'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var PropTypes$2 = require('prop-types');
var Select = require('react-select');
var ReactDOM = require('react-dom');
var Grid2 = require('@mui/material/Unstable_Grid2');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : { default: e };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(
          n,
          k,
          d.get
            ? d
            : {
                enumerable: true,
                get: function () {
                  return e[k];
                },
              },
        );
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
var PropTypes__default = /*#__PURE__*/ _interopDefaultLegacy(PropTypes$2);
var Select__default = /*#__PURE__*/ _interopDefaultLegacy(Select);
var ReactDOM__namespace = /*#__PURE__*/ _interopNamespace(ReactDOM);
var ReactDOM__default = /*#__PURE__*/ _interopDefaultLegacy(ReactDOM);
var Grid2__default = /*#__PURE__*/ _interopDefaultLegacy(Grid2);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
  __assign =
    Object.assign ||
    function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
  return __assign.apply(this, arguments);
};

function __rest$1(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === 'function')
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P
      ? value
      : new P(function (resolve) {
          resolve(value);
        });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator['throw'](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: [],
    },
    f,
    y,
    t,
    g;
  return (
    (g = { next: verb(0), throw: verb(1), return: verb(2) }),
    typeof Symbol === 'function' &&
      (g[Symbol.iterator] = function () {
        return this;
      }),
    g
  );
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError('Generator is already executing.');
    while ((g && ((g = 0), op[0] && (_ = 0)), _))
      try {
        if (
          ((f = 1),
          y &&
            (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) &&
            !(t = t.call(y, op[1])).done)
        )
          return t;
        if (((y = 0), t)) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!((t = _.trys), (t = t.length > 0 && t[t.length - 1])) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

function __read(o, n) {
  var m = typeof Symbol === 'function' && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error: error };
  } finally {
    try {
      if (r && !r.done && (m = i['return'])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, 'raw', { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}

/** Checks if value is string */
function isString$1(str) {
  return typeof str === 'string' || str instanceof String;
}

/** Checks if value is object */
function isObject$c(obj) {
  var _obj$constructor;
  return (
    typeof obj === 'object' &&
    obj != null &&
    (obj == null || (_obj$constructor = obj.constructor) == null ? void 0 : _obj$constructor.name) === 'Object'
  );
}
function pick(obj, keys) {
  if (Array.isArray(keys)) return pick(obj, (_, k) => keys.includes(k));
  return Object.entries(obj).reduce((acc, _ref) => {
    let [k, v] = _ref;
    if (keys(v, k)) acc[k] = v;
    return acc;
  }, {});
}

/** Direction */
const DIRECTION = {
  NONE: 'NONE',
  LEFT: 'LEFT',
  FORCE_LEFT: 'FORCE_LEFT',
  RIGHT: 'RIGHT',
  FORCE_RIGHT: 'FORCE_RIGHT',
};

/** Direction */

function forceDirection(direction) {
  switch (direction) {
    case DIRECTION.LEFT:
      return DIRECTION.FORCE_LEFT;
    case DIRECTION.RIGHT:
      return DIRECTION.FORCE_RIGHT;
    default:
      return direction;
  }
}

/** Escapes regular expression control chars */
function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
}

// cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
function objectIncludes(b, a) {
  if (a === b) return true;
  const arrA = Array.isArray(a),
    arrB = Array.isArray(b);
  let i;
  if (arrA && arrB) {
    if (a.length != b.length) return false;
    for (i = 0; i < a.length; i++) if (!objectIncludes(a[i], b[i])) return false;
    return true;
  }
  if (arrA != arrB) return false;
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    const dateA = a instanceof Date,
      dateB = b instanceof Date;
    if (dateA && dateB) return a.getTime() == b.getTime();
    if (dateA != dateB) return false;
    const regexpA = a instanceof RegExp,
      regexpB = b instanceof RegExp;
    if (regexpA && regexpB) return a.toString() == b.toString();
    if (regexpA != regexpB) return false;
    const keys = Object.keys(a);
    // if (keys.length !== Object.keys(b).length) return false;

    for (i = 0; i < keys.length; i++) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    for (i = 0; i < keys.length; i++) if (!objectIncludes(b[keys[i]], a[keys[i]])) return false;
    return true;
  } else if (a && b && typeof a === 'function' && typeof b === 'function') {
    return a.toString() === b.toString();
  }
  return false;
}

/** Provides details of changing input */
class ActionDetails {
  /** Current input value */

  /** Current cursor position */

  /** Old input value */

  /** Old selection */

  constructor(opts) {
    Object.assign(this, opts);

    // double check if left part was changed (autofilling, other non-standard input triggers)
    while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
      --this.oldSelection.start;
    }
    if (this.insertedCount) {
      // double check right part
      while (this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end)) {
        if (this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end) ++this.oldSelection.end;
        else ++this.cursorPos;
      }
    }
  }

  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }

  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }

  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }

  /** Removed symbols count */
  get removedCount() {
    // Math.max for opposite operation
    return Math.max(
      this.oldSelection.end - this.startChangePos ||
        // for Delete
        this.oldValue.length - this.value.length,
      0,
    );
  }

  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }

  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }

  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }

  /** Remove direction */
  get removeDirection() {
    if (!this.removedCount || this.insertedCount) return DIRECTION.NONE;

    // align right if delete at right
    return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) &&
      // if not range removed (event with backspace)
      this.oldSelection.end === this.oldSelection.start
      ? DIRECTION.RIGHT
      : DIRECTION.LEFT;
  }
}

/** Applies mask on element */
function IMask(el, opts) {
  // currently available only for input-like elements
  return new IMask.InputMask(el, opts);
}

// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// export function maskedClass(mask: string): typeof MaskedPattern;
// export function maskedClass(mask: DateConstructor): typeof MaskedDate;
// export function maskedClass(mask: NumberConstructor): typeof MaskedNumber;
// export function maskedClass(mask: Array<any> | ArrayConstructor): typeof MaskedDynamic;
// export function maskedClass(mask: MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass(mask: Masked): typeof Masked;
// export function maskedClass(mask: typeof Masked): typeof Masked;
// export function maskedClass(mask: typeof MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: typeof MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: typeof MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: typeof MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: typeof MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: typeof MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: typeof MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: typeof MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass<Mask extends typeof Masked> (mask: Mask): Mask;
// export function maskedClass(mask: RegExp): typeof MaskedRegExp;
// export function maskedClass(mask: (value: string, ...args: any[]) => boolean): typeof MaskedFunction;

/** Get Masked class by mask type */
function maskedClass(mask) /* TODO */ {
  if (mask == null) throw new Error('mask property should be defined');
  if (mask instanceof RegExp) return IMask.MaskedRegExp;
  if (isString$1(mask)) return IMask.MaskedPattern;
  if (mask === Date) return IMask.MaskedDate;
  if (mask === Number) return IMask.MaskedNumber;
  if (Array.isArray(mask) || mask === Array) return IMask.MaskedDynamic;
  if (IMask.Masked && mask.prototype instanceof IMask.Masked) return mask;
  if (IMask.Masked && mask instanceof IMask.Masked) return mask.constructor;
  if (mask instanceof Function) return IMask.MaskedFunction;
  console.warn('Mask not found for mask', mask); // eslint-disable-line no-console
  return IMask.Masked;
}
function normalizeOpts(opts) {
  if (!opts) throw new Error('Options in not defined');
  if (IMask.Masked) {
    if (opts.prototype instanceof IMask.Masked)
      return {
        mask: opts,
      };

    /*
      handle cases like:
      1) opts = Masked
      2) opts = { mask: Masked, ...instanceOpts }
    */
    const { mask = undefined, ...instanceOpts } =
      opts instanceof IMask.Masked
        ? {
            mask: opts,
          }
        : isObject$c(opts) && opts.mask instanceof IMask.Masked
        ? opts
        : {};
    if (mask) {
      const _mask = mask.mask;
      return {
        ...pick(mask, (_, k) => !k.startsWith('_')),
        mask: mask.constructor,
        _mask,
        ...instanceOpts,
      };
    }
  }
  if (!isObject$c(opts))
    return {
      mask: opts,
    };
  return {
    ...opts,
  };
}

// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754

// From masked
// export default function createMask<Opts extends Masked, ReturnMasked=Opts> (opts: Opts): ReturnMasked;
// // From masked class
// export default function createMask<Opts extends MaskedOptions<typeof Masked>, ReturnMasked extends Masked=InstanceType<Opts['mask']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDate>, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedNumber>, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedEnum>, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRange>, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedFunction>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedPattern>, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDynamic>, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// // From mask opts
// export default function createMask<Opts extends MaskedOptions<Masked>, ReturnMasked=Opts extends MaskedOptions<infer M> ? M : never> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedNumberOptions, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDateFactoryOptions, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedEnumOptions, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedRangeOptions, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedPatternOptions, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDynamicOptions, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<RegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<Function>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;

/** Creates new {@link Masked} depending on mask type */
function createMask(opts) {
  if (IMask.Masked && opts instanceof IMask.Masked) return opts;
  const nOpts = normalizeOpts(opts);
  const MaskedClass = maskedClass(nOpts.mask);
  if (!MaskedClass)
    throw new Error(
      'Masked class is not found for provided mask ' +
        nOpts.mask +
        ', appropriate module needs to be imported manually before creating mask.',
    );
  if (nOpts.mask === MaskedClass) delete nOpts.mask;
  if (nOpts._mask) {
    nOpts.mask = nOpts._mask;
    delete nOpts._mask;
  }
  return new MaskedClass(nOpts);
}
IMask.createMask = createMask;

/**  Generic element API to use with mask */
class MaskElement {
  /** */

  /** */

  /** */

  /** Safely returns selection start */
  get selectionStart() {
    let start;
    try {
      start = this._unsafeSelectionStart;
    } catch {}
    return start != null ? start : this.value.length;
  }

  /** Safely returns selection end */
  get selectionEnd() {
    let end;
    try {
      end = this._unsafeSelectionEnd;
    } catch {}
    return end != null ? end : this.value.length;
  }

  /** Safely sets element selection */
  select(start, end) {
    if (start == null || end == null || (start === this.selectionStart && end === this.selectionEnd)) return;
    try {
      this._unsafeSelect(start, end);
    } catch {}
  }

  /** */
  get isActive() {
    return false;
  }
  /** */

  /** */

  /** */
}
IMask.MaskElement = MaskElement;

const KEY_Z = 90;
const KEY_Y = 89;

/** Bridge between HTMLElement and {@link Masked} */
class HTMLMaskElement extends MaskElement {
  /** HTMLElement to use mask on */

  constructor(input) {
    super();
    this.input = input;
    this._onKeydown = this._onKeydown.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onBeforeinput = this._onBeforeinput.bind(this);
    this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
    return (_this$input$getRootNo =
      (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) == null
        ? void 0
        : _this$input$getRootNo2.call(_this$input)) != null
      ? _this$input$getRootNo
      : document;
  }

  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }

  /** Binds HTMLElement events to mask internal events */
  bindEvents(handlers) {
    this.input.addEventListener('keydown', this._onKeydown);
    this.input.addEventListener('input', this._onInput);
    this.input.addEventListener('beforeinput', this._onBeforeinput);
    this.input.addEventListener('compositionend', this._onCompositionEnd);
    this.input.addEventListener('drop', handlers.drop);
    this.input.addEventListener('click', handlers.click);
    this.input.addEventListener('focus', handlers.focus);
    this.input.addEventListener('blur', handlers.commit);
    this._handlers = handlers;
  }
  _onKeydown(e) {
    if (
      this._handlers.redo &&
      ((e.keyCode === KEY_Z && e.shiftKey && (e.metaKey || e.ctrlKey)) || (e.keyCode === KEY_Y && e.ctrlKey))
    ) {
      e.preventDefault();
      return this._handlers.redo(e);
    }
    if (this._handlers.undo && e.keyCode === KEY_Z && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      return this._handlers.undo(e);
    }
    if (!e.isComposing) this._handlers.selectionChange(e);
  }
  _onBeforeinput(e) {
    if (e.inputType === 'historyUndo' && this._handlers.undo) {
      e.preventDefault();
      return this._handlers.undo(e);
    }
    if (e.inputType === 'historyRedo' && this._handlers.redo) {
      e.preventDefault();
      return this._handlers.redo(e);
    }
  }
  _onCompositionEnd(e) {
    this._handlers.input(e);
  }
  _onInput(e) {
    if (!e.isComposing) this._handlers.input(e);
  }

  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener('keydown', this._onKeydown);
    this.input.removeEventListener('input', this._onInput);
    this.input.removeEventListener('beforeinput', this._onBeforeinput);
    this.input.removeEventListener('compositionend', this._onCompositionEnd);
    this.input.removeEventListener('drop', this._handlers.drop);
    this.input.removeEventListener('click', this._handlers.click);
    this.input.removeEventListener('focus', this._handlers.focus);
    this.input.removeEventListener('blur', this._handlers.commit);
    this._handlers = {};
  }
}
IMask.HTMLMaskElement = HTMLMaskElement;

/** Bridge between InputElement and {@link Masked} */
class HTMLInputMaskElement extends HTMLMaskElement {
  /** InputElement to use mask on */

  constructor(input) {
    super(input);
    this.input = input;
  }

  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }

  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }

  /** Sets InputElement selection */
  _unsafeSelect(start, end) {
    this.input.setSelectionRange(start, end);
  }
  get value() {
    return this.input.value;
  }
  set value(value) {
    this.input.value = value;
  }
}
IMask.HTMLMaskElement = HTMLMaskElement;

class HTMLContenteditableMaskElement extends HTMLMaskElement {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    const anchorOffset = selection && selection.anchorOffset;
    const focusOffset = selection && selection.focusOffset;
    if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) {
      return anchorOffset;
    }
    return focusOffset;
  }

  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    const anchorOffset = selection && selection.anchorOffset;
    const focusOffset = selection && selection.focusOffset;
    if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) {
      return anchorOffset;
    }
    return focusOffset;
  }

  /** Sets HTMLElement selection */
  _unsafeSelect(start, end) {
    if (!this.rootElement.createRange) return;
    const range = this.rootElement.createRange();
    range.setStart(this.input.firstChild || this.input, start);
    range.setEnd(this.input.lastChild || this.input, end);
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  /** HTMLElement value */
  get value() {
    return this.input.textContent || '';
  }
  set value(value) {
    this.input.textContent = value;
  }
}
IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;

class InputHistory {
  constructor() {
    this.states = [];
    this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(state) {
    // if current index points before the last element then remove the future
    if (this.currentIndex < this.states.length - 1) this.states.length = this.currentIndex + 1;
    this.states.push(state);
    if (this.states.length > InputHistory.MAX_LENGTH) this.states.shift();
    this.currentIndex = this.states.length - 1;
  }
  go(steps) {
    this.currentIndex = Math.min(Math.max(this.currentIndex + steps, 0), this.states.length - 1);
    return this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(+1);
  }
  clear() {
    this.states.length = 0;
    this.currentIndex = 0;
  }
}
InputHistory.MAX_LENGTH = 100;

/** Listens to element events and controls changes between element and {@link Masked} */
class InputMask$1 {
  /**
    View element
  */

  /** Internal {@link Masked} model */

  constructor(el, opts) {
    this.el =
      el instanceof MaskElement
        ? el
        : el.isContentEditable && el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA'
        ? new HTMLContenteditableMaskElement(el)
        : new HTMLInputMaskElement(el);
    this.masked = createMask(opts);
    this._listeners = {};
    this._value = '';
    this._unmaskedValue = '';
    this._rawInputValue = '';
    this.history = new InputHistory();
    this._saveSelection = this._saveSelection.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onDrop = this._onDrop.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onUndo = this._onUndo.bind(this);
    this._onRedo = this._onRedo.bind(this);
    this.alignCursor = this.alignCursor.bind(this);
    this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
    this._bindEvents();

    // refresh
    this.updateValue();
    this._onChange();
  }
  maskEquals(mask) {
    var _this$masked;
    return mask == null || ((_this$masked = this.masked) == null ? void 0 : _this$masked.maskEquals(mask));
  }

  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(mask) {
    if (this.maskEquals(mask)) return;
    if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
      // TODO "any" no idea
      this.masked.updateOptions({
        mask,
      });
      return;
    }
    const masked =
      mask instanceof IMask.Masked
        ? mask
        : createMask({
            mask,
          });
    masked.unmaskedValue = this.masked.unmaskedValue;
    this.masked = masked;
  }

  /** Raw value */
  get value() {
    return this._value;
  }
  set value(str) {
    if (this.value === str) return;
    this.masked.value = str;
    this.updateControl('auto');
  }

  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(str) {
    if (this.unmaskedValue === str) return;
    this.masked.unmaskedValue = str;
    this.updateControl('auto');
  }

  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(str) {
    if (this.rawInputValue === str) return;
    this.masked.rawInputValue = str;
    this.updateControl();
    this.alignCursor();
  }

  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(val) {
    if (this.masked.typedValueEquals(val)) return;
    this.masked.typedValue = val;
    this.updateControl('auto');
  }

  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }

  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo,
    });
  }

  /** Stops listening to element events */
  _unbindEvents() {
    if (this.el) this.el.unbindEvents();
  }

  /** Fires custom event */
  _fireEvent(ev, e) {
    const listeners = this._listeners[ev];
    if (!listeners) return;
    listeners.forEach((l) => l(e));
  }

  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }

  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(pos) {
    if (!this.el || !this.el.isActive) return;
    this.el.select(pos, pos);
    this._saveSelection();
  }

  /** Stores current selection */
  _saveSelection /* ev */() {
    if (this.displayValue !== this.el.value) {
      console.warn(
        'Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.',
      ); // eslint-disable-line no-console
    }
    this._selection = {
      start: this.selectionStart,
      end: this.cursorPos,
    };
  }

  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value;
    this._value = this.masked.value;
    this._unmaskedValue = this.masked.unmaskedValue;
    this._rawInputValue = this.masked.rawInputValue;
  }

  /** Syncronizes view from model value, fires change events */
  updateControl(cursorPos) {
    const newUnmaskedValue = this.masked.unmaskedValue;
    const newValue = this.masked.value;
    const newRawInputValue = this.masked.rawInputValue;
    const newDisplayValue = this.displayValue;
    const isChanged =
      this.unmaskedValue !== newUnmaskedValue || this.value !== newValue || this._rawInputValue !== newRawInputValue;
    this._unmaskedValue = newUnmaskedValue;
    this._value = newValue;
    this._rawInputValue = newRawInputValue;
    if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
    if (cursorPos === 'auto') this.alignCursor();
    else if (cursorPos != null) this.cursorPos = cursorPos;
    if (isChanged) this._fireChangeEvents();
    if (!this._historyChanging && (isChanged || this.history.isEmpty))
      this.history.push({
        unmaskedValue: newUnmaskedValue,
        selection: {
          start: this.selectionStart,
          end: this.cursorPos,
        },
      });
  }

  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(opts) {
    const { mask, ...restOpts } = opts; // TODO types, yes, mask is optional

    const updateMask = !this.maskEquals(mask);
    const updateOpts = this.masked.optionsIsChanged(restOpts);
    if (updateMask) this.mask = mask;
    if (updateOpts) this.masked.updateOptions(restOpts); // TODO

    if (updateMask || updateOpts) this.updateControl();
  }

  /** Updates cursor */
  updateCursor(cursorPos) {
    if (cursorPos == null) return;
    this.cursorPos = cursorPos;

    // also queue change cursor for mobile browsers
    this._delayUpdateCursor(cursorPos);
  }

  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(cursorPos) {
    this._abortUpdateCursor();
    this._changingCursorPos = cursorPos;
    this._cursorChanging = setTimeout(() => {
      if (!this.el) return; // if was destroyed
      this.cursorPos = this._changingCursorPos;
      this._abortUpdateCursor();
    }, 10);
  }

  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent('accept', this._inputEvent);
    if (this.masked.isComplete) this._fireEvent('complete', this._inputEvent);
  }

  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    if (this._cursorChanging) {
      clearTimeout(this._cursorChanging);
      delete this._cursorChanging;
    }
  }

  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
  }

  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
    this.alignCursor();
  }

  /** Adds listener on custom event */
  on(ev, handler) {
    if (!this._listeners[ev]) this._listeners[ev] = [];
    this._listeners[ev].push(handler);
    return this;
  }

  /** Removes custom event listener */
  off(ev, handler) {
    if (!this._listeners[ev]) return this;
    if (!handler) {
      delete this._listeners[ev];
      return this;
    }
    const hIndex = this._listeners[ev].indexOf(handler);
    if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
    return this;
  }

  /** Handles view input event */
  _onInput(e) {
    this._inputEvent = e;
    this._abortUpdateCursor();
    const details = new ActionDetails({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection,
    });
    const oldRawValue = this.masked.rawInputValue;
    const offset = this.masked.splice(
      details.startChangePos,
      details.removed.length,
      details.inserted,
      details.removeDirection,
      {
        input: true,
        raw: true,
      },
    ).offset;

    // force align in remove direction only if no input chars were removed
    // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
    const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
    let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
    if (removeDirection !== DIRECTION.NONE) cursorPos = this.masked.nearestInputPos(cursorPos, DIRECTION.NONE);
    this.updateControl(cursorPos);
    delete this._inputEvent;
  }

  /** Handles view change event and commits model value */
  _onChange() {
    if (this.displayValue !== this.el.value) this.updateValue();
    this.masked.doCommit();
    this.updateControl();
    this._saveSelection();
  }

  /** Handles view drop event, prevents by default */
  _onDrop(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }

  /** Restore last selection on focus */
  _onFocus(ev) {
    this.alignCursorFriendly();
  }

  /** Restore last selection on focus */
  _onClick(ev) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(state) {
    if (!state) return;
    this._historyChanging = true;
    this.unmaskedValue = state.unmaskedValue;
    this.el.select(state.selection.start, state.selection.end);
    this._saveSelection();
    this._historyChanging = false;
  }

  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents();
    this._listeners.length = 0;
    delete this.el;
  }
}
IMask.InputMask = InputMask$1;

/** Provides details of changing model value */
class ChangeDetails {
  /** Inserted symbols */

  /** Additional offset if any changes occurred before tail */

  /** Raw inserted is used by dynamic mask */

  /** Can skip chars */

  static normalize(prep) {
    return Array.isArray(prep) ? prep : [prep, new ChangeDetails()];
  }
  constructor(details) {
    Object.assign(
      this,
      {
        inserted: '',
        rawInserted: '',
        tailShift: 0,
        skip: false,
      },
      details,
    );
  }

  /** Aggregate changes */
  aggregate(details) {
    this.inserted += details.inserted;
    this.rawInserted += details.rawInserted;
    this.tailShift += details.tailShift;
    this.skip = this.skip || details.skip;
    return this;
  }

  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return Boolean(this.rawInserted) || this.skip;
  }
  equals(details) {
    return (
      this.inserted === details.inserted &&
      this.tailShift === details.tailShift &&
      this.rawInserted === details.rawInserted &&
      this.skip === details.skip
    );
  }
}
IMask.ChangeDetails = ChangeDetails;

/** Provides details of continuous extracted tail */
class ContinuousTailDetails {
  /** Tail value as string */

  /** Tail start position */

  /** Start position */

  constructor(value, from, stop) {
    if (value === void 0) {
      value = '';
    }
    if (from === void 0) {
      from = 0;
    }
    this.value = value;
    this.from = from;
    this.stop = stop;
  }
  toString() {
    return this.value;
  }
  extend(tail) {
    this.value += String(tail);
  }
  appendTo(masked) {
    return masked
      .append(this.toString(), {
        tail: true,
      })
      .aggregate(masked._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop,
    };
  }
  set state(state) {
    Object.assign(this, state);
  }
  unshift(beforePos) {
    if (!this.value.length || (beforePos != null && this.from >= beforePos)) return '';
    const shiftChar = this.value[0];
    this.value = this.value.slice(1);
    return shiftChar;
  }
  shift() {
    if (!this.value.length) return '';
    const shiftChar = this.value[this.value.length - 1];
    this.value = this.value.slice(0, -1);
    return shiftChar;
  }
}

/** Append flags */

/** Extract flags */

// see https://github.com/microsoft/TypeScript/issues/6223

/** Provides common masking stuff */
class Masked {
  /** */

  /** */

  /** Transforms value before mask processing */

  /** Transforms each char before mask processing */

  /** Validates if value is acceptable */

  /** Does additional processing at the end of editing */

  /** Format typed value to string */

  /** Parse string to get typed value */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  /** */

  constructor(opts) {
    this._value = '';
    this._update({
      ...Masked.DEFAULTS,
      ...opts,
    });
    this._initialized = true;
  }

  /** Sets and applies new options */
  updateOptions(opts) {
    if (!this.optionsIsChanged(opts)) return;
    this.withValueRefresh(this._update.bind(this, opts));
  }

  /** Sets new options */
  _update(opts) {
    Object.assign(this, opts);
  }

  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
    };
  }
  set state(state) {
    this._value = state._value;
  }

  /** Resets value */
  reset() {
    this._value = '';
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this.resolve(value, {
      input: true,
    });
  }

  /** Resolve new value */
  resolve(value, flags) {
    if (flags === void 0) {
      flags = {
        input: true,
      };
    }
    this.reset();
    this.append(value, flags, '');
    this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(value) {
    this.resolve(value, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(value) {
    if (this.format) {
      this.value = this.format(value, this);
    } else {
      this.unmaskedValue = String(value);
    }
  }

  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: true,
    });
  }
  set rawInputValue(value) {
    this.resolve(value, {
      raw: true,
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return true;
  }
  get isFilled() {
    return this.isComplete;
  }

  /** Finds nearest input position in direction */
  nearestInputPos(cursorPos, direction) {
    return cursorPos;
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    return Math.min(this.displayValue.length, toPos - fromPos);
  }

  /** Extracts value in range considering flags */
  extractInput(fromPos, toPos, flags) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    return this.displayValue.slice(fromPos, toPos);
  }

  /** Extracts tail in range */
  extractTail(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
  }

  /** Appends tail */
  appendTail(tail) {
    if (isString$1(tail)) tail = new ContinuousTailDetails(String(tail));
    return tail.appendTo(this);
  }

  /** Appends char */
  _appendCharRaw(ch, flags) {
    if (!ch) return new ChangeDetails();
    this._value += ch;
    return new ChangeDetails({
      inserted: ch,
      rawInserted: ch,
    });
  }

  /** Appends char */
  _appendChar(ch, flags, checkTail) {
    if (flags === void 0) {
      flags = {};
    }
    const consistentState = this.state;
    let details;
    [ch, details] = this.doPrepareChar(ch, flags);
    if (ch) {
      details = details.aggregate(this._appendCharRaw(ch, flags));

      // TODO handle `skip`?

      // try `autofix` lookahead
      if (!details.rawInserted && this.autofix === 'pad') {
        const noFixState = this.state;
        this.state = consistentState;
        let fixDetails = this.pad(flags);
        const chDetails = this._appendCharRaw(ch, flags);
        fixDetails = fixDetails.aggregate(chDetails);

        // if fix was applied or
        // if details are equal use skip restoring state optimization
        if (chDetails.rawInserted || fixDetails.equals(details)) {
          details = fixDetails;
        } else {
          this.state = noFixState;
        }
      }
    }
    if (details.inserted) {
      let consistentTail;
      let appended = this.doValidate(flags) !== false;
      if (appended && checkTail != null) {
        // validation ok, check tail
        const beforeTailState = this.state;
        if (this.overwrite === true) {
          consistentTail = checkTail.state;
          for (let i = 0; i < details.rawInserted.length; ++i) {
            checkTail.unshift(this.displayValue.length - details.tailShift);
          }
        }
        let tailDetails = this.appendTail(checkTail);
        appended = tailDetails.rawInserted.length === checkTail.toString().length;

        // not ok, try shift
        if (!(appended && tailDetails.inserted) && this.overwrite === 'shift') {
          this.state = beforeTailState;
          consistentTail = checkTail.state;
          for (let i = 0; i < details.rawInserted.length; ++i) {
            checkTail.shift();
          }
          tailDetails = this.appendTail(checkTail);
          appended = tailDetails.rawInserted.length === checkTail.toString().length;
        }

        // if ok, rollback state after tail
        if (appended && tailDetails.inserted) this.state = beforeTailState;
      }

      // revert all if something went wrong
      if (!appended) {
        details = new ChangeDetails();
        this.state = consistentState;
        if (checkTail && consistentTail) checkTail.state = consistentTail;
      }
    }
    return details;
  }

  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new ChangeDetails();
  }

  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new ChangeDetails();
  }

  /** Appends symbols considering flags */
  append(str, flags, tail) {
    if (!isString$1(str)) throw new Error('value should be string');
    const checkTail = isString$1(tail) ? new ContinuousTailDetails(String(tail)) : tail;
    if (flags != null && flags.tail) flags._beforeTailState = this.state;
    let details;
    [str, details] = this.doPrepare(str, flags);
    for (let ci = 0; ci < str.length; ++ci) {
      const d = this._appendChar(str[ci], flags, checkTail);
      if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
      details.aggregate(d);
    }
    if ((this.eager === true || this.eager === 'append') && flags != null && flags.input && str) {
      details.aggregate(this._appendEager());
    }

    // append tail but aggregate only tailShift
    if (checkTail != null) {
      details.tailShift += this.appendTail(checkTail).tailShift;
      // TODO it's a good idea to clear state after appending ends
      // but it causes bugs when one append calls another (when dynamic dispatch set rawInputValue)
      // this._resetBeforeTailState();
    }
    return details;
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    this._value = this.displayValue.slice(0, fromPos) + this.displayValue.slice(toPos);
    return new ChangeDetails();
  }

  /** Calls function and reapplies current value */
  withValueRefresh(fn) {
    if (this._refreshing || !this._initialized) return fn();
    this._refreshing = true;
    const rawInput = this.rawInputValue;
    const value = this.value;
    const ret = fn();
    this.rawInputValue = rawInput;
    // append lost trailing chars at the end
    if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
      this.append(value.slice(this.displayValue.length), {}, '');
      this.doCommit();
    }
    delete this._refreshing;
    return ret;
  }
  runIsolated(fn) {
    if (this._isolated || !this._initialized) return fn(this);
    this._isolated = true;
    const state = this.state;
    const ret = fn(this);
    this.state = state;
    delete this._isolated;
    return ret;
  }
  doSkipInvalid(ch, flags, checkTail) {
    return Boolean(this.skipInvalid);
  }

  /** Prepares string before mask processing */
  doPrepare(str, flags) {
    if (flags === void 0) {
      flags = {};
    }
    return ChangeDetails.normalize(this.prepare ? this.prepare(str, this, flags) : str);
  }

  /** Prepares each char before mask processing */
  doPrepareChar(str, flags) {
    if (flags === void 0) {
      flags = {};
    }
    return ChangeDetails.normalize(this.prepareChar ? this.prepareChar(str, this, flags) : str);
  }

  /** Validates if value is acceptable */
  doValidate(flags) {
    return (
      (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags))
    );
  }

  /** Does additional processing at the end of editing */
  doCommit() {
    if (this.commit) this.commit(this.value, this);
  }
  splice(start, deleteCount, inserted, removeDirection, flags) {
    if (inserted === void 0) {
      inserted = '';
    }
    if (removeDirection === void 0) {
      removeDirection = DIRECTION.NONE;
    }
    if (flags === void 0) {
      flags = {
        input: true,
      };
    }
    const tailPos = start + deleteCount;
    const tail = this.extractTail(tailPos);
    const eagerRemove = this.eager === true || this.eager === 'remove';
    let oldRawValue;
    if (eagerRemove) {
      removeDirection = forceDirection(removeDirection);
      oldRawValue = this.extractInput(0, tailPos, {
        raw: true,
      });
    }
    let startChangePos = start;
    const details = new ChangeDetails();

    // if it is just deletion without insertion
    if (removeDirection !== DIRECTION.NONE) {
      startChangePos = this.nearestInputPos(
        start,
        deleteCount > 1 && start !== 0 && !eagerRemove ? DIRECTION.NONE : removeDirection,
      );

      // adjust tailShift if start was aligned
      details.tailShift = startChangePos - start;
    }
    details.aggregate(this.remove(startChangePos));
    if (eagerRemove && removeDirection !== DIRECTION.NONE && oldRawValue === this.rawInputValue) {
      if (removeDirection === DIRECTION.FORCE_LEFT) {
        let valLength;
        while (oldRawValue === this.rawInputValue && (valLength = this.displayValue.length)) {
          details
            .aggregate(
              new ChangeDetails({
                tailShift: -1,
              }),
            )
            .aggregate(this.remove(valLength - 1));
        }
      } else if (removeDirection === DIRECTION.FORCE_RIGHT) {
        tail.unshift();
      }
    }
    return details.aggregate(this.append(inserted, flags, tail));
  }
  maskEquals(mask) {
    return this.mask === mask;
  }
  optionsIsChanged(opts) {
    return !objectIncludes(this, opts);
  }
  typedValueEquals(value) {
    const tval = this.typedValue;
    return (
      value === tval ||
      (Masked.EMPTY_VALUES.includes(value) && Masked.EMPTY_VALUES.includes(tval)) ||
      (this.format ? this.format(value, this) === this.format(this.typedValue, this) : false)
    );
  }
  pad(flags) {
    return new ChangeDetails();
  }
}
Masked.DEFAULTS = {
  skipInvalid: true,
};
Masked.EMPTY_VALUES = [undefined, null, ''];
IMask.Masked = Masked;

class ChunksTailDetails {
  /** */

  constructor(chunks, from) {
    if (chunks === void 0) {
      chunks = [];
    }
    if (from === void 0) {
      from = 0;
    }
    this.chunks = chunks;
    this.from = from;
  }
  toString() {
    return this.chunks.map(String).join('');
  }
  extend(tailChunk) {
    if (!String(tailChunk)) return;
    tailChunk = isString$1(tailChunk) ? new ContinuousTailDetails(String(tailChunk)) : tailChunk;
    const lastChunk = this.chunks[this.chunks.length - 1];
    const extendLast =
      lastChunk &&
      // if stops are same or tail has no stop
      (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) &&
      // if tail chunk goes just after last chunk
      tailChunk.from === lastChunk.from + lastChunk.toString().length;
    if (tailChunk instanceof ContinuousTailDetails) {
      // check the ability to extend previous chunk
      if (extendLast) {
        // extend previous chunk
        lastChunk.extend(tailChunk.toString());
      } else {
        // append new chunk
        this.chunks.push(tailChunk);
      }
    } else if (tailChunk instanceof ChunksTailDetails) {
      if (tailChunk.stop == null) {
        // unwrap floating chunks to parent, keeping `from` pos
        let firstTailChunk;
        while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
          firstTailChunk = tailChunk.chunks.shift(); // not possible to be `undefined` because length was checked above
          firstTailChunk.from += tailChunk.from;
          this.extend(firstTailChunk);
        }
      }

      // if tail chunk still has value
      if (tailChunk.toString()) {
        // if chunks contains stops, then popup stop to container
        tailChunk.stop = tailChunk.blockIndex;
        this.chunks.push(tailChunk);
      }
    }
  }
  appendTo(masked) {
    if (!(masked instanceof IMask.MaskedPattern)) {
      const tail = new ContinuousTailDetails(this.toString());
      return tail.appendTo(masked);
    }
    const details = new ChangeDetails();
    for (let ci = 0; ci < this.chunks.length; ++ci) {
      const chunk = this.chunks[ci];
      const lastBlockIter = masked._mapPosToBlock(masked.displayValue.length);
      const stop = chunk.stop;
      let chunkBlock;
      if (
        stop != null &&
        // if block not found or stop is behind lastBlock
        (!lastBlockIter || lastBlockIter.index <= stop)
      ) {
        if (
          chunk instanceof ChunksTailDetails ||
          // for continuous block also check if stop is exist
          masked._stops.indexOf(stop) >= 0
        ) {
          details.aggregate(masked._appendPlaceholder(stop));
        }
        chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
      }
      if (chunkBlock) {
        const tailDetails = chunkBlock.appendTail(chunk);
        details.aggregate(tailDetails);

        // get not inserted chars
        const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
        if (remainChars)
          details.aggregate(
            masked.append(remainChars, {
              tail: true,
            }),
          );
      } else {
        details.aggregate(
          masked.append(chunk.toString(), {
            tail: true,
          }),
        );
      }
    }
    return details;
  }
  get state() {
    return {
      chunks: this.chunks.map((c) => c.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex,
    };
  }
  set state(state) {
    const { chunks, ...props } = state;
    Object.assign(this, props);
    this.chunks = chunks.map((cstate) => {
      const chunk = 'chunks' in cstate ? new ChunksTailDetails() : new ContinuousTailDetails();
      chunk.state = cstate;
      return chunk;
    });
  }
  unshift(beforePos) {
    if (!this.chunks.length || (beforePos != null && this.from >= beforePos)) return '';
    const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
    let ci = 0;
    while (ci < this.chunks.length) {
      const chunk = this.chunks[ci];
      const shiftChar = chunk.unshift(chunkShiftPos);
      if (chunk.toString()) {
        // chunk still contains value
        // but not shifted - means no more available chars to shift
        if (!shiftChar) break;
        ++ci;
      } else {
        // clean if chunk has no value
        this.chunks.splice(ci, 1);
      }
      if (shiftChar) return shiftChar;
    }
    return '';
  }
  shift() {
    if (!this.chunks.length) return '';
    let ci = this.chunks.length - 1;
    while (0 <= ci) {
      const chunk = this.chunks[ci];
      const shiftChar = chunk.shift();
      if (chunk.toString()) {
        // chunk still contains value
        // but not shifted - means no more available chars to shift
        if (!shiftChar) break;
        --ci;
      } else {
        // clean if chunk has no value
        this.chunks.splice(ci, 1);
      }
      if (shiftChar) return shiftChar;
    }
    return '';
  }
}

class PatternCursor {
  constructor(masked, pos) {
    this.masked = masked;
    this._log = [];
    const { offset, index } =
      masked._mapPosToBlock(pos) ||
      (pos < 0
        ? // first
          {
            index: 0,
            offset: 0,
          }
        : // last
          {
            index: this.masked._blocks.length,
            offset: 0,
          });
    this.offset = offset;
    this.index = index;
    this.ok = false;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok,
    };
  }
  set state(s) {
    Object.assign(this, s);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const s = this._log.pop();
    if (s) this.state = s;
    return s;
  }
  bindBlock() {
    if (this.block) return;
    if (this.index < 0) {
      this.index = 0;
      this.offset = 0;
    }
    if (this.index >= this.masked._blocks.length) {
      this.index = this.masked._blocks.length - 1;
      this.offset = this.block.displayValue.length; // TODO this is stupid type error, `block` depends on index that was changed above
    }
  }
  _pushLeft(fn) {
    this.pushState();
    for (
      this.bindBlock();
      0 <= this.index;
      --this.index, this.offset = ((_this$block = this.block) == null ? void 0 : _this$block.displayValue.length) || 0
    ) {
      var _this$block;
      if (fn()) return (this.ok = true);
    }
    return (this.ok = false);
  }
  _pushRight(fn) {
    this.pushState();
    for (this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) {
      if (fn()) return (this.ok = true);
    }
    return (this.ok = false);
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (this.block.isFixed || !this.block.value) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_LEFT);
      if (this.offset !== 0) return true;
    });
  }
  pushLeftBeforeInput() {
    // cases:
    // filled input: 00|
    // optional empty input: 00[]|
    // nested block: XX<[]>|
    return this._pushLeft(() => {
      if (this.block.isFixed) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
      return true;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (this.block.isFixed || (this.block.isOptional && !this.block.value)) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
      return true;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (this.block.isFixed || !this.block.value) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_RIGHT);
      if (this.offset !== this.block.value.length) return true;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (this.block.isFixed) return;

      // const o = this.offset;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
      // HACK cases like (STILL DOES NOT WORK FOR NESTED)
      // aa|X
      // aa<X|[]>X_    - this will not work
      // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
      return true;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (this.block.isFixed || (this.block.isOptional && !this.block.value)) return;

      // TODO check |[*]XX_
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
      return true;
    });
  }
}

class PatternFixedDefinition {
  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  constructor(opts) {
    Object.assign(this, opts);
    this._value = '';
    this.isFixed = true;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : '';
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : '';
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = false;
    this._value = '';
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this._value.length;
    }
    this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
    if (!this._value) this._isRawInput = false;
    return new ChangeDetails();
  }
  nearestInputPos(cursorPos, direction) {
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    const minPos = 0;
    const maxPos = this._value.length;
    switch (direction) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return minPos;
      case DIRECTION.NONE:
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
      default:
        return maxPos;
    }
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this._value.length;
    }
    return this._isRawInput ? toPos - fromPos : 0;
  }
  extractInput(fromPos, toPos, flags) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this._value.length;
    }
    if (flags === void 0) {
      flags = {};
    }
    return (flags.raw && this._isRawInput && this._value.slice(fromPos, toPos)) || '';
  }
  get isComplete() {
    return true;
  }
  get isFilled() {
    return Boolean(this._value);
  }
  _appendChar(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    if (this.isFilled) return new ChangeDetails();
    const appendEager = this.eager === true || this.eager === 'append';
    const appended = this.char === ch;
    const isResolved =
      appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
    const details = new ChangeDetails({
      inserted: this.char,
      rawInserted: isResolved ? this.char : '',
    });
    this._value = this.char;
    this._isRawInput = isResolved && (flags.raw || flags.input);
    return details;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: true,
    });
  }
  _appendPlaceholder() {
    const details = new ChangeDetails();
    if (this.isFilled) return details;
    this._value = details.inserted = this.char;
    return details;
  }
  extractTail() {
    return new ContinuousTailDetails('');
  }
  appendTail(tail) {
    if (isString$1(tail)) tail = new ContinuousTailDetails(String(tail));
    return tail.appendTo(this);
  }
  append(str, flags, tail) {
    const details = this._appendChar(str[0], flags);
    if (tail != null) {
      details.tailShift += this.appendTail(tail).tailShift;
    }
    return details;
  }
  doCommit() {}
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue,
    };
  }
  set state(state) {
    this._value = state._value;
    this._isRawInput = Boolean(state._rawInputValue);
  }
  pad(flags) {
    return this._appendPlaceholder();
  }
}

class PatternInputDefinition {
  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  constructor(opts) {
    const { parent, isOptional, placeholderChar, displayChar, lazy, eager, ...maskOpts } = opts;
    this.masked = createMask(maskOpts);
    Object.assign(this, {
      parent,
      isOptional,
      placeholderChar,
      displayChar,
      lazy,
      eager,
    });
  }
  reset() {
    this.isFilled = false;
    this.masked.reset();
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.value.length;
    }
    if (fromPos === 0 && toPos >= 1) {
      this.isFilled = false;
      return this.masked.remove(fromPos, toPos);
    }
    return new ChangeDetails();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : '');
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return (this.masked.value && this.displayChar) || this.value;
  }
  get isComplete() {
    return Boolean(this.masked.value) || this.isOptional;
  }
  _appendChar(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    if (this.isFilled) return new ChangeDetails();
    const state = this.masked.state;
    // simulate input
    let details = this.masked._appendChar(ch, this.currentMaskFlags(flags));
    if (details.inserted && this.doValidate(flags) === false) {
      details = new ChangeDetails();
      this.masked.state = state;
    }
    if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) {
      details.inserted = this.placeholderChar;
    }
    details.skip = !details.inserted && !this.isOptional;
    this.isFilled = Boolean(details.inserted);
    return details;
  }
  append(str, flags, tail) {
    // TODO probably should be done via _appendChar
    return this.masked.append(str, this.currentMaskFlags(flags), tail);
  }
  _appendPlaceholder() {
    if (this.isFilled || this.isOptional) return new ChangeDetails();
    this.isFilled = true;
    return new ChangeDetails({
      inserted: this.placeholderChar,
    });
  }
  _appendEager() {
    return new ChangeDetails();
  }
  extractTail(fromPos, toPos) {
    return this.masked.extractTail(fromPos, toPos);
  }
  appendTail(tail) {
    return this.masked.appendTail(tail);
  }
  extractInput(fromPos, toPos, flags) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.value.length;
    }
    return this.masked.extractInput(fromPos, toPos, flags);
  }
  nearestInputPos(cursorPos, direction) {
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    const minPos = 0;
    const maxPos = this.value.length;
    const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
    switch (direction) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return this.isComplete ? boundPos : minPos;
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
        return this.isComplete ? boundPos : maxPos;
      case DIRECTION.NONE:
      default:
        return boundPos;
    }
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.value.length;
    }
    return this.value.slice(fromPos, toPos).length;
  }
  doValidate(flags) {
    return (
      this.masked.doValidate(this.currentMaskFlags(flags)) &&
      (!this.parent || this.parent.doValidate(this.currentMaskFlags(flags)))
    );
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled,
    };
  }
  set state(state) {
    this.masked.state = state.masked;
    this.isFilled = state.isFilled;
  }
  currentMaskFlags(flags) {
    var _flags$_beforeTailSta;
    return {
      ...flags,
      _beforeTailState:
        (flags == null || (_flags$_beforeTailSta = flags._beforeTailState) == null
          ? void 0
          : _flags$_beforeTailSta.masked) || (flags == null ? void 0 : flags._beforeTailState),
    };
  }
  pad(flags) {
    return new ChangeDetails();
  }
}
PatternInputDefinition.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  '*': /./,
};

/** Masking by RegExp */
class MaskedRegExp extends Masked {
  /** */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const mask = opts.mask;
    if (mask) opts.validate = (value) => value.search(mask) >= 0;
    super._update(opts);
  }
}
IMask.MaskedRegExp = MaskedRegExp;

/** Pattern mask */
class MaskedPattern extends Masked {
  /** */

  /** */

  /** Single char for empty input */

  /** Single char for filled input */

  /** Show placeholder only when needed */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  constructor(opts) {
    super({
      ...MaskedPattern.DEFAULTS,
      ...opts,
      definitions: Object.assign(
        {},
        PatternInputDefinition.DEFAULT_DEFINITIONS,
        opts == null ? void 0 : opts.definitions,
      ),
    });
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    opts.definitions = Object.assign({}, this.definitions, opts.definitions);
    super._update(opts);
    this._rebuildMask();
  }
  _rebuildMask() {
    const defs = this.definitions;
    this._blocks = [];
    this.exposeBlock = undefined;
    this._stops = [];
    this._maskedBlocks = {};
    const pattern = this.mask;
    if (!pattern || !defs) return;
    let unmaskingBlock = false;
    let optionalBlock = false;
    for (let i = 0; i < pattern.length; ++i) {
      if (this.blocks) {
        const p = pattern.slice(i);
        const bNames = Object.keys(this.blocks).filter((bName) => p.indexOf(bName) === 0);
        // order by key length
        bNames.sort((a, b) => b.length - a.length);
        // use block name with max length
        const bName = bNames[0];
        if (bName) {
          const { expose, repeat, ...bOpts } = normalizeOpts(this.blocks[bName]); // TODO type Opts<Arg & Extra>
          const blockOpts = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...bOpts,
            repeat,
            parent: this,
          };
          const maskedBlock = repeat != null ? new IMask.RepeatBlock(blockOpts /* TODO */) : createMask(blockOpts);
          if (maskedBlock) {
            this._blocks.push(maskedBlock);
            if (expose) this.exposeBlock = maskedBlock;

            // store block index
            if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
            this._maskedBlocks[bName].push(this._blocks.length - 1);
          }
          i += bName.length - 1;
          continue;
        }
      }
      let char = pattern[i];
      let isInput = char in defs;
      if (char === MaskedPattern.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (char === '{' || char === '}') {
        unmaskingBlock = !unmaskingBlock;
        continue;
      }
      if (char === '[' || char === ']') {
        optionalBlock = !optionalBlock;
        continue;
      }
      if (char === MaskedPattern.ESCAPE_CHAR) {
        ++i;
        char = pattern[i];
        if (!char) break;
        isInput = false;
      }
      const def = isInput
        ? new PatternInputDefinition({
            isOptional: optionalBlock,
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            ...normalizeOpts(defs[char]),
            parent: this,
          })
        : new PatternFixedDefinition({
            char,
            eager: this.eager,
            isUnmasking: unmaskingBlock,
          });
      this._blocks.push(def);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((b) => b.state),
    };
  }
  set state(state) {
    if (!state) {
      this.reset();
      return;
    }
    const { _blocks, ...maskedState } = state;
    this._blocks.forEach((b, bi) => (b.state = _blocks[bi]));
    super.state = maskedState;
  }
  reset() {
    super.reset();
    this._blocks.forEach((b) => b.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((b) => b.isComplete);
  }
  get isFilled() {
    return this._blocks.every((b) => b.isFilled);
  }
  get isFixed() {
    return this._blocks.every((b) => b.isFixed);
  }
  get isOptional() {
    return this._blocks.every((b) => b.isOptional);
  }
  doCommit() {
    this._blocks.forEach((b) => b.doCommit());
    super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock
      ? this.exposeBlock.unmaskedValue
      : this._blocks.reduce((str, b) => (str += b.unmaskedValue), '');
  }
  set unmaskedValue(unmaskedValue) {
    if (this.exposeBlock) {
      const tail = this.extractTail(
        this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length,
      );
      this.exposeBlock.unmaskedValue = unmaskedValue;
      this.appendTail(tail);
      this.doCommit();
    } else super.unmaskedValue = unmaskedValue;
  }
  get value() {
    return this.exposeBlock
      ? this.exposeBlock.value
      : // TODO return _value when not in change?
        this._blocks.reduce((str, b) => (str += b.value), '');
  }
  set value(value) {
    if (this.exposeBlock) {
      const tail = this.extractTail(
        this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length,
      );
      this.exposeBlock.value = value;
      this.appendTail(tail);
      this.doCommit();
    } else super.value = value;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(value) {
    if (this.exposeBlock) {
      const tail = this.extractTail(
        this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length,
      );
      this.exposeBlock.typedValue = value;
      this.appendTail(tail);
      this.doCommit();
    } else super.typedValue = value;
  }
  get displayValue() {
    return this._blocks.reduce((str, b) => (str += b.displayValue), '');
  }
  appendTail(tail) {
    return super.appendTail(tail).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var _this$_mapPosToBlock;
    const details = new ChangeDetails();
    let startBlockIndex =
      (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null
        ? void 0
        : _this$_mapPosToBlock.index;
    if (startBlockIndex == null) return details;

    // TODO test if it works for nested pattern masks
    if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
    for (let bi = startBlockIndex; bi < this._blocks.length; ++bi) {
      const d = this._blocks[bi]._appendEager();
      if (!d.inserted) break;
      details.aggregate(d);
    }
    return details;
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const blockIter = this._mapPosToBlock(this.displayValue.length);
    const details = new ChangeDetails();
    if (!blockIter) return details;
    for (let bi = blockIter.index, block; (block = this._blocks[bi]); ++bi) {
      var _flags$_beforeTailSta;
      const blockDetails = block._appendChar(ch, {
        ...flags,
        _beforeTailState:
          (_flags$_beforeTailSta = flags._beforeTailState) == null ||
          (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null
            ? void 0
            : _flags$_beforeTailSta[bi],
      });
      details.aggregate(blockDetails);
      if (blockDetails.consumed) break; // go next char
    }
    return details;
  }
  extractTail(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const chunkTail = new ChunksTailDetails();
    if (fromPos === toPos) return chunkTail;
    this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos) => {
      const blockChunk = b.extractTail(bFromPos, bToPos);
      blockChunk.stop = this._findStopBefore(bi);
      blockChunk.from = this._blockStartPos(bi);
      if (blockChunk instanceof ChunksTailDetails) blockChunk.blockIndex = bi;
      chunkTail.extend(blockChunk);
    });
    return chunkTail;
  }
  extractInput(fromPos, toPos, flags) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    if (flags === void 0) {
      flags = {};
    }
    if (fromPos === toPos) return '';
    let input = '';
    this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos) => {
      input += b.extractInput(fromPos, toPos, flags);
    });
    return input;
  }
  _findStopBefore(blockIndex) {
    let stopBefore;
    for (let si = 0; si < this._stops.length; ++si) {
      const stop = this._stops[si];
      if (stop <= blockIndex) stopBefore = stop;
      else break;
    }
    return stopBefore;
  }

  /** Appends placeholder depending on laziness */
  _appendPlaceholder(toBlockIndex) {
    const details = new ChangeDetails();
    if (this.lazy && toBlockIndex == null) return details;
    const startBlockIter = this._mapPosToBlock(this.displayValue.length);
    if (!startBlockIter) return details;
    const startBlockIndex = startBlockIter.index;
    const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
    this._blocks.slice(startBlockIndex, endBlockIndex).forEach((b) => {
      if (!b.lazy || toBlockIndex != null) {
        var _blocks2;
        details.aggregate(b._appendPlaceholder((_blocks2 = b._blocks) == null ? void 0 : _blocks2.length));
      }
    });
    return details;
  }

  /** Finds block in pos */
  _mapPosToBlock(pos) {
    let accVal = '';
    for (let bi = 0; bi < this._blocks.length; ++bi) {
      const block = this._blocks[bi];
      const blockStartPos = accVal.length;
      accVal += block.displayValue;
      if (pos <= accVal.length) {
        return {
          index: bi,
          offset: pos - blockStartPos,
        };
      }
    }
  }
  _blockStartPos(blockIndex) {
    return this._blocks.slice(0, blockIndex).reduce((pos, b) => (pos += b.displayValue.length), 0);
  }
  _forEachBlocksInRange(fromPos, toPos, fn) {
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const fromBlockIter = this._mapPosToBlock(fromPos);
    if (fromBlockIter) {
      const toBlockIter = this._mapPosToBlock(toPos);
      // process first block
      const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
      const fromBlockStartPos = fromBlockIter.offset;
      const fromBlockEndPos =
        toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].displayValue.length;
      fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
      if (toBlockIter && !isSameBlock) {
        // process intermediate blocks
        for (let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
          fn(this._blocks[bi], bi, 0, this._blocks[bi].displayValue.length);
        }

        // process last block
        fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
      }
    }
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const removeDetails = super.remove(fromPos, toPos);
    this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
      removeDetails.aggregate(b.remove(bFromPos, bToPos));
    });
    return removeDetails;
  }
  nearestInputPos(cursorPos, direction) {
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    if (!this._blocks.length) return 0;
    const cursor = new PatternCursor(this, cursorPos);
    if (direction === DIRECTION.NONE) {
      // -------------------------------------------------
      // NONE should only go out from fixed to the right!
      // -------------------------------------------------
      if (cursor.pushRightBeforeInput()) return cursor.pos;
      cursor.popState();
      if (cursor.pushLeftBeforeInput()) return cursor.pos;
      return this.displayValue.length;
    }

    // FORCE is only about a|* otherwise is 0
    if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
      // try to break fast when *|a
      if (direction === DIRECTION.LEFT) {
        cursor.pushRightBeforeFilled();
        if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
        cursor.popState();
      }

      // forward flow
      cursor.pushLeftBeforeInput();
      cursor.pushLeftBeforeRequired();
      cursor.pushLeftBeforeFilled();

      // backward flow
      if (direction === DIRECTION.LEFT) {
        cursor.pushRightBeforeInput();
        cursor.pushRightBeforeRequired();
        if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
        cursor.popState();
        if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
        cursor.popState();
      }
      if (cursor.ok) return cursor.pos;
      if (direction === DIRECTION.FORCE_LEFT) return 0;
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      return 0;
    }
    if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
      // forward flow
      cursor.pushRightBeforeInput();
      cursor.pushRightBeforeRequired();
      if (cursor.pushRightBeforeFilled()) return cursor.pos;
      if (direction === DIRECTION.FORCE_RIGHT) return this.displayValue.length;

      // backward flow
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      return this.nearestInputPos(cursorPos, DIRECTION.LEFT);
    }
    return cursorPos;
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    let total = 0;
    this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
      total += b.totalInputPositions(bFromPos, bToPos);
    });
    return total;
  }

  /** Get block by name */
  maskedBlock(name) {
    return this.maskedBlocks(name)[0];
  }

  /** Get all blocks by name */
  maskedBlocks(name) {
    const indices = this._maskedBlocks[name];
    if (!indices) return [];
    return indices.map((gi) => this._blocks[gi]);
  }
  pad(flags) {
    const details = new ChangeDetails();
    this._forEachBlocksInRange(0, this.displayValue.length, (b) => details.aggregate(b.pad(flags)));
    return details;
  }
}
MaskedPattern.DEFAULTS = {
  ...Masked.DEFAULTS,
  lazy: true,
  placeholderChar: '_',
};
MaskedPattern.STOP_CHAR = '`';
MaskedPattern.ESCAPE_CHAR = '\\';
MaskedPattern.InputDefinition = PatternInputDefinition;
MaskedPattern.FixedDefinition = PatternFixedDefinition;
IMask.MaskedPattern = MaskedPattern;

/** Pattern which accepts ranges */
class MaskedRange extends MaskedPattern {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */

  /** Min bound */

  /** Max bound */

  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(opts) {
    super(opts); // mask will be created in _update
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const {
      to = this.to || 0,
      from = this.from || 0,
      maxLength = this.maxLength || 0,
      autofix = this.autofix,
      ...patternOpts
    } = opts;
    this.to = to;
    this.from = from;
    this.maxLength = Math.max(String(to).length, maxLength);
    this.autofix = autofix;
    const fromStr = String(this.from).padStart(this.maxLength, '0');
    const toStr = String(this.to).padStart(this.maxLength, '0');
    let sameCharsCount = 0;
    while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) ++sameCharsCount;
    patternOpts.mask =
      toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(this.maxLength - sameCharsCount);
    super._update(patternOpts);
  }
  get isComplete() {
    return super.isComplete && Boolean(this.value);
  }
  boundaries(str) {
    let minstr = '';
    let maxstr = '';
    const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
    if (num) {
      minstr = '0'.repeat(placeholder.length) + num;
      maxstr = '9'.repeat(placeholder.length) + num;
    }
    minstr = minstr.padEnd(this.maxLength, '0');
    maxstr = maxstr.padEnd(this.maxLength, '9');
    return [minstr, maxstr];
  }
  doPrepareChar(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    let details;
    [ch, details] = super.doPrepareChar(ch.replace(/\D/g, ''), flags);
    if (!ch) details.skip = !this.isComplete;
    return [ch, details];
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    if (!this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(ch, flags);
    const fromStr = String(this.from).padStart(this.maxLength, '0');
    const toStr = String(this.to).padStart(this.maxLength, '0');
    const [minstr, maxstr] = this.boundaries(this.value + ch);
    if (Number(maxstr) < this.from) return super._appendCharRaw(fromStr[this.value.length], flags);
    if (Number(minstr) > this.to) {
      if (!flags.tail && this.autofix === 'pad' && this.value.length + 1 < this.maxLength) {
        return super._appendCharRaw(fromStr[this.value.length], flags).aggregate(this._appendCharRaw(ch, flags));
      }
      return super._appendCharRaw(toStr[this.value.length], flags);
    }
    return super._appendCharRaw(ch, flags);
  }
  doValidate(flags) {
    const str = this.value;
    const firstNonZero = str.search(/[^0]/);
    if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
    const [minstr, maxstr] = this.boundaries(str);
    return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(flags);
  }
  pad(flags) {
    const details = new ChangeDetails();
    if (this.value.length === this.maxLength) return details;
    const value = this.value;
    const padLength = this.maxLength - this.value.length;
    if (padLength) {
      this.reset();
      for (let i = 0; i < padLength; ++i) {
        details.aggregate(super._appendCharRaw('0', flags));
      }

      // append tail
      value.split('').forEach((ch) => this._appendCharRaw(ch));
    }
    return details;
  }
}
IMask.MaskedRange = MaskedRange;

const DefaultPattern = 'd{.}`m{.}`Y';

// Make format and parse required when pattern is provided

/** Date mask */
class MaskedDate extends MaskedPattern {
  static extractPatternOptions(opts) {
    const { mask, pattern, ...patternOpts } = opts;
    return {
      ...patternOpts,
      mask: isString$1(mask) ? mask : pattern,
    };
  }

  /** Pattern mask for date according to {@link MaskedDate#format} */

  /** Start date */

  /** End date */

  /** Format typed value to string */

  /** Parse string to get typed value */

  constructor(opts) {
    super(
      MaskedDate.extractPatternOptions({
        ...MaskedDate.DEFAULTS,
        ...opts,
      }),
    );
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const { mask, pattern, blocks, ...patternOpts } = {
      ...MaskedDate.DEFAULTS,
      ...opts,
    };
    const patternBlocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS());
    // adjust year block
    if (opts.min) patternBlocks.Y.from = opts.min.getFullYear();
    if (opts.max) patternBlocks.Y.to = opts.max.getFullYear();
    if (opts.min && opts.max && patternBlocks.Y.from === patternBlocks.Y.to) {
      patternBlocks.m.from = opts.min.getMonth() + 1;
      patternBlocks.m.to = opts.max.getMonth() + 1;
      if (patternBlocks.m.from === patternBlocks.m.to) {
        patternBlocks.d.from = opts.min.getDate();
        patternBlocks.d.to = opts.max.getDate();
      }
    }
    Object.assign(patternBlocks, this.blocks, blocks);
    super._update({
      ...patternOpts,
      mask: isString$1(mask) ? mask : pattern,
      blocks: patternBlocks,
    });
  }
  doValidate(flags) {
    const date = this.date;
    return (
      super.doValidate(flags) &&
      (!this.isComplete ||
        (this.isDateExist(this.value) &&
          date != null &&
          (this.min == null || this.min <= date) &&
          (this.max == null || date <= this.max)))
    );
  }

  /** Checks if date is exists */
  isDateExist(str) {
    return this.format(this.parse(str, this), this).indexOf(str) >= 0;
  }

  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(date) {
    this.typedValue = date;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(value) {
    super.typedValue = value;
  }
  maskEquals(mask) {
    return mask === Date || super.maskEquals(mask);
  }
  optionsIsChanged(opts) {
    return super.optionsIsChanged(MaskedDate.extractPatternOptions(opts));
  }
}
MaskedDate.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: MaskedRange,
    from: 1,
    to: 31,
    maxLength: 2,
  },
  m: {
    mask: MaskedRange,
    from: 1,
    to: 12,
    maxLength: 2,
  },
  Y: {
    mask: MaskedRange,
    from: 1900,
    to: 9999,
  },
});
MaskedDate.DEFAULTS = {
  ...MaskedPattern.DEFAULTS,
  mask: Date,
  pattern: DefaultPattern,
  format: (date, masked) => {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return [day, month, year].join('.');
  },
  parse: (str, masked) => {
    const [day, month, year] = str.split('.').map(Number);
    return new Date(year, month - 1, day);
  },
};
IMask.MaskedDate = MaskedDate;

/** Dynamic mask for choosing appropriate mask in run-time */
class MaskedDynamic extends Masked {
  constructor(opts) {
    super({
      ...MaskedDynamic.DEFAULTS,
      ...opts,
    });
    this.currentMask = undefined;
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    super._update(opts);
    if ('mask' in opts) {
      this.exposeMask = undefined;
      // mask could be totally dynamic with only `dispatch` option
      this.compiledMasks = Array.isArray(opts.mask)
        ? opts.mask.map((m) => {
            const { expose, ...maskOpts } = normalizeOpts(m);
            const masked = createMask({
              overwrite: this._overwrite,
              eager: this._eager,
              skipInvalid: this._skipInvalid,
              ...maskOpts,
            });
            if (expose) this.exposeMask = masked;
            return masked;
          })
        : [];

      // this.currentMask = this.doDispatch(''); // probably not needed but lets see
    }
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const details = this._applyDispatch(ch, flags);
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
    }
    return details;
  }
  _applyDispatch(appended, flags, tail) {
    if (appended === void 0) {
      appended = '';
    }
    if (flags === void 0) {
      flags = {};
    }
    if (tail === void 0) {
      tail = '';
    }
    const prevValueBeforeTail =
      flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
    const inputValue = this.rawInputValue;
    const insertValue =
      flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
    const tailValue = inputValue.slice(insertValue.length);
    const prevMask = this.currentMask;
    const details = new ChangeDetails();
    const prevMaskState = prevMask == null ? void 0 : prevMask.state;

    // clone flags to prevent overwriting `_beforeTailState`
    this.currentMask = this.doDispatch(
      appended,
      {
        ...flags,
      },
      tail,
    );

    // restore state after dispatch
    if (this.currentMask) {
      if (this.currentMask !== prevMask) {
        // if mask changed reapply input
        this.currentMask.reset();
        if (insertValue) {
          this.currentMask.append(insertValue, {
            raw: true,
          });
          details.tailShift = this.currentMask.value.length - prevValueBeforeTail.length;
        }
        if (tailValue) {
          details.tailShift += this.currentMask.append(tailValue, {
            raw: true,
            tail: true,
          }).tailShift;
        }
      } else if (prevMaskState) {
        // Dispatch can do something bad with state, so
        // restore prev mask state
        this.currentMask.state = prevMaskState;
      }
    }
    return details;
  }
  _appendPlaceholder() {
    const details = this._applyDispatch();
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendPlaceholder());
    }
    return details;
  }
  _appendEager() {
    const details = this._applyDispatch();
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendEager());
    }
    return details;
  }
  appendTail(tail) {
    const details = new ChangeDetails();
    if (tail) details.aggregate(this._applyDispatch('', {}, tail));
    return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
  }
  currentMaskFlags(flags) {
    var _flags$_beforeTailSta, _flags$_beforeTailSta2;
    return {
      ...flags,
      _beforeTailState:
        (((_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.currentMaskRef) ===
          this.currentMask &&
          ((_flags$_beforeTailSta2 = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta2.currentMask)) ||
        flags._beforeTailState,
    };
  }
  doDispatch(appended, flags, tail) {
    if (flags === void 0) {
      flags = {};
    }
    if (tail === void 0) {
      tail = '';
    }
    return this.dispatch(appended, this, flags, tail);
  }
  doValidate(flags) {
    return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
  }
  doPrepare(str, flags) {
    if (flags === void 0) {
      flags = {};
    }
    let [s, details] = super.doPrepare(str, flags);
    if (this.currentMask) {
      let currentDetails;
      [s, currentDetails] = super.doPrepare(s, this.currentMaskFlags(flags));
      details = details.aggregate(currentDetails);
    }
    return [s, details];
  }
  doPrepareChar(str, flags) {
    if (flags === void 0) {
      flags = {};
    }
    let [s, details] = super.doPrepareChar(str, flags);
    if (this.currentMask) {
      let currentDetails;
      [s, currentDetails] = super.doPrepareChar(s, this.currentMaskFlags(flags));
      details = details.aggregate(currentDetails);
    }
    return [s, details];
  }
  reset() {
    var _this$currentMask;
    (_this$currentMask = this.currentMask) == null || _this$currentMask.reset();
    this.compiledMasks.forEach((m) => m.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : '';
  }
  set value(value) {
    if (this.exposeMask) {
      this.exposeMask.value = value;
      this.currentMask = this.exposeMask;
      this._applyDispatch();
    } else super.value = value;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : '';
  }
  set unmaskedValue(unmaskedValue) {
    if (this.exposeMask) {
      this.exposeMask.unmaskedValue = unmaskedValue;
      this.currentMask = this.exposeMask;
      this._applyDispatch();
    } else super.unmaskedValue = unmaskedValue;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : '';
  }
  set typedValue(typedValue) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = typedValue;
      this.currentMask = this.exposeMask;
      this._applyDispatch();
      return;
    }
    let unmaskedValue = String(typedValue);

    // double check it
    if (this.currentMask) {
      this.currentMask.typedValue = typedValue;
      unmaskedValue = this.currentMask.unmaskedValue;
    }
    this.unmaskedValue = unmaskedValue;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : '';
  }
  get isComplete() {
    var _this$currentMask2;
    return Boolean((_this$currentMask2 = this.currentMask) == null ? void 0 : _this$currentMask2.isComplete);
  }
  get isFilled() {
    var _this$currentMask3;
    return Boolean((_this$currentMask3 = this.currentMask) == null ? void 0 : _this$currentMask3.isFilled);
  }
  remove(fromPos, toPos) {
    const details = new ChangeDetails();
    if (this.currentMask) {
      details
        .aggregate(this.currentMask.remove(fromPos, toPos))
        // update with dispatch
        .aggregate(this._applyDispatch());
    }
    return details;
  }
  get state() {
    var _this$currentMask4;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((m) => m.state),
      currentMaskRef: this.currentMask,
      currentMask: (_this$currentMask4 = this.currentMask) == null ? void 0 : _this$currentMask4.state,
    };
  }
  set state(state) {
    const { compiledMasks, currentMaskRef, currentMask, ...maskedState } = state;
    if (compiledMasks) this.compiledMasks.forEach((m, mi) => (m.state = compiledMasks[mi]));
    if (currentMaskRef != null) {
      this.currentMask = currentMaskRef;
      this.currentMask.state = currentMask;
    }
    super.state = maskedState;
  }
  extractInput(fromPos, toPos, flags) {
    return this.currentMask ? this.currentMask.extractInput(fromPos, toPos, flags) : '';
  }
  extractTail(fromPos, toPos) {
    return this.currentMask ? this.currentMask.extractTail(fromPos, toPos) : super.extractTail(fromPos, toPos);
  }
  doCommit() {
    if (this.currentMask) this.currentMask.doCommit();
    super.doCommit();
  }
  nearestInputPos(cursorPos, direction) {
    return this.currentMask
      ? this.currentMask.nearestInputPos(cursorPos, direction)
      : super.nearestInputPos(cursorPos, direction);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(overwrite) {
    this._overwrite = overwrite;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(eager) {
    this._eager = eager;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(skipInvalid) {
    this._skipInvalid = skipInvalid;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(autofix) {
    this._autofix = autofix;
  }
  maskEquals(mask) {
    return Array.isArray(mask)
      ? this.compiledMasks.every((m, mi) => {
          if (!mask[mi]) return;
          const { mask: oldMask, ...restOpts } = mask[mi];
          return objectIncludes(m, restOpts) && m.maskEquals(oldMask);
        })
      : super.maskEquals(mask);
  }
  typedValueEquals(value) {
    var _this$currentMask5;
    return Boolean(
      (_this$currentMask5 = this.currentMask) == null ? void 0 : _this$currentMask5.typedValueEquals(value),
    );
  }
}
/** Currently chosen mask */
/** Currently chosen mask */
/** Compliled {@link Masked} options */
/** Chooses {@link Masked} depending on input value */
MaskedDynamic.DEFAULTS = {
  ...Masked.DEFAULTS,
  dispatch: (appended, masked, flags, tail) => {
    if (!masked.compiledMasks.length) return;
    const inputValue = masked.rawInputValue;

    // simulate input
    const inputs = masked.compiledMasks.map((m, index) => {
      const isCurrent = masked.currentMask === m;
      const startInputPos = isCurrent
        ? m.displayValue.length
        : m.nearestInputPos(m.displayValue.length, DIRECTION.FORCE_LEFT);
      if (m.rawInputValue !== inputValue) {
        m.reset();
        m.append(inputValue, {
          raw: true,
        });
      } else if (!isCurrent) {
        m.remove(startInputPos);
      }
      m.append(appended, masked.currentMaskFlags(flags));
      m.appendTail(tail);
      return {
        index,
        weight: m.rawInputValue.length,
        totalInputPositions: m.totalInputPositions(
          0,
          Math.max(startInputPos, m.nearestInputPos(m.displayValue.length, DIRECTION.FORCE_LEFT)),
        ),
      };
    });

    // pop masks with longer values first
    inputs.sort((i1, i2) => i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
    return masked.compiledMasks[inputs[0].index];
  },
};
IMask.MaskedDynamic = MaskedDynamic;

/** Pattern which validates enum values */
class MaskedEnum extends MaskedPattern {
  constructor(opts) {
    super({
      ...MaskedEnum.DEFAULTS,
      ...opts,
    }); // mask will be created in _update
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const { enum: enum_, ...eopts } = opts;
    if (enum_) {
      const lengths = enum_.map((e) => e.length);
      const requiredLength = Math.min(...lengths);
      const optionalLength = Math.max(...lengths) - requiredLength;
      eopts.mask = '*'.repeat(requiredLength);
      if (optionalLength) eopts.mask += '[' + '*'.repeat(optionalLength) + ']';
      this.enum = enum_;
    }
    super._update(eopts);
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const matchFrom = Math.min(this.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
    const matches = this.enum.filter((e) => this.matchValue(e, this.unmaskedValue + ch, matchFrom));
    if (matches.length) {
      if (matches.length === 1) {
        this._forEachBlocksInRange(0, this.value.length, (b, bi) => {
          const mch = matches[0][bi];
          if (bi >= this.value.length || mch === b.value) return;
          b.reset();
          b._appendChar(mch, flags);
        });
      }
      const d = super._appendCharRaw(matches[0][this.value.length], flags);
      if (matches.length === 1) {
        matches[0]
          .slice(this.unmaskedValue.length)
          .split('')
          .forEach((mch) => d.aggregate(super._appendCharRaw(mch)));
      }
      return d;
    }
    return new ChangeDetails({
      skip: !this.isComplete,
    });
  }
  extractTail(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    // just drop tail
    return new ContinuousTailDetails('', fromPos);
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    if (fromPos === toPos) return new ChangeDetails();
    const matchFrom = Math.min(super.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
    let pos;
    for (pos = fromPos; pos >= 0; --pos) {
      const matches = this.enum.filter((e) => this.matchValue(e, this.value.slice(matchFrom, pos), matchFrom));
      if (matches.length > 1) break;
    }
    const details = super.remove(pos, toPos);
    details.tailShift += pos - fromPos;
    return details;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
/** Match enum value */
MaskedEnum.DEFAULTS = {
  ...MaskedPattern.DEFAULTS,
  matchValue: (estr, istr, matchFrom) => estr.indexOf(istr, matchFrom) === matchFrom,
};
IMask.MaskedEnum = MaskedEnum;

/** Masking by custom Function */
class MaskedFunction extends Masked {
  /** */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    super._update({
      ...opts,
      validate: opts.mask,
    });
  }
}
IMask.MaskedFunction = MaskedFunction;

var _MaskedNumber;
/** Number mask */
class MaskedNumber extends Masked {
  /** Single char */

  /** Single char */

  /** Array of single chars */

  /** */

  /** */

  /** Digits after point */

  /** Flag to remove leading and trailing zeros in the end of editing */

  /** Flag to pad trailing zeros after point in the end of editing */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  /** Format typed value to string */

  /** Parse string to get typed value */

  constructor(opts) {
    super({
      ...MaskedNumber.DEFAULTS,
      ...opts,
    });
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    super._update(opts);
    this._updateRegExps();
  }
  _updateRegExps() {
    const start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
    const mid = '\\d*';
    const end = (this.scale ? '(' + escapeRegExp(this.radix) + '\\d{0,' + this.scale + '})?' : '') + '$';
    this._numberRegExp = new RegExp(start + mid + end);
    this._mapToRadixRegExp = new RegExp('[' + this.mapToRadix.map(escapeRegExp).join('') + ']', 'g');
    this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), 'g');
  }
  _removeThousandsSeparators(value) {
    return value.replace(this._thousandsSeparatorRegExp, '');
  }
  _insertThousandsSeparators(value) {
    // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
    const parts = value.split(this.radix);
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
    return parts.join(this.radix);
  }
  doPrepareChar(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const [prepCh, details] = super.doPrepareChar(
      this._removeThousandsSeparators(
        this.scale &&
          this.mapToRadix.length &&
          /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
          ((flags.input && flags.raw) || (!flags.input && !flags.raw))
          ? ch.replace(this._mapToRadixRegExp, this.radix)
          : ch,
      ),
      flags,
    );
    if (ch && !prepCh) details.skip = true;
    if (prepCh && !this.allowPositive && !this.value && prepCh !== '-') details.aggregate(this._appendChar('-'));
    return [prepCh, details];
  }
  _separatorsCount(to, extendOnSeparators) {
    if (extendOnSeparators === void 0) {
      extendOnSeparators = false;
    }
    let count = 0;
    for (let pos = 0; pos < to; ++pos) {
      if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
        ++count;
        if (extendOnSeparators) to += this.thousandsSeparator.length;
      }
    }
    return count;
  }
  _separatorsCountFromSlice(slice) {
    if (slice === void 0) {
      slice = this._value;
    }
    return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
  }
  extractInput(fromPos, toPos, flags) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
    return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
    const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
    this._value = this._removeThousandsSeparators(this.value);
    const oldValue = this._value;
    this._value += ch;
    const num = this.number;
    let accepted = !isNaN(num);
    let skip = false;
    if (accepted) {
      let fixedNum;
      if (this.min != null && this.min < 0 && this.number < this.min) fixedNum = this.min;
      if (this.max != null && this.max > 0 && this.number > this.max) fixedNum = this.max;
      if (fixedNum != null) {
        if (this.autofix) {
          this._value = this.format(fixedNum, this).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
          skip || (skip = oldValue === this._value && !flags.tail); // if not changed on tail it's still ok to proceed
        } else {
          accepted = false;
        }
      }
      accepted && (accepted = Boolean(this._value.match(this._numberRegExp)));
    }
    let appendDetails;
    if (!accepted) {
      this._value = oldValue;
      appendDetails = new ChangeDetails();
    } else {
      appendDetails = new ChangeDetails({
        inserted: this._value.slice(oldValue.length),
        rawInserted: skip ? '' : ch,
        skip,
      });
    }
    this._value = this._insertThousandsSeparators(this._value);
    const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
    const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
    appendDetails.tailShift +=
      (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
    return appendDetails;
  }
  _findSeparatorAround(pos) {
    if (this.thousandsSeparator) {
      const searchFrom = pos - this.thousandsSeparator.length + 1;
      const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
      if (separatorPos <= pos) return separatorPos;
    }
    return -1;
  }
  _adjustRangeWithSeparators(from, to) {
    const separatorAroundFromPos = this._findSeparatorAround(from);
    if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
    const separatorAroundToPos = this._findSeparatorAround(to);
    if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
    return [from, to];
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
    const valueBeforePos = this.value.slice(0, fromPos);
    const valueAfterPos = this.value.slice(toPos);
    const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
    const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
    return new ChangeDetails({
      tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length,
    });
  }
  nearestInputPos(cursorPos, direction) {
    if (!this.thousandsSeparator) return cursorPos;
    switch (direction) {
      case DIRECTION.NONE:
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT: {
        const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
        if (separatorAtLeftPos >= 0) {
          const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
          if (
            cursorPos < separatorAtLeftEndPos ||
            this.value.length <= separatorAtLeftEndPos ||
            direction === DIRECTION.FORCE_LEFT
          ) {
            return separatorAtLeftPos;
          }
        }
        break;
      }
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT: {
        const separatorAtRightPos = this._findSeparatorAround(cursorPos);
        if (separatorAtRightPos >= 0) {
          return separatorAtRightPos + this.thousandsSeparator.length;
        }
      }
    }
    return cursorPos;
  }
  doCommit() {
    if (this.value) {
      const number = this.number;
      let validnum = number;

      // check bounds
      if (this.min != null) validnum = Math.max(validnum, this.min);
      if (this.max != null) validnum = Math.min(validnum, this.max);
      if (validnum !== number) this.unmaskedValue = this.format(validnum, this);
      let formatted = this.value;
      if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
      if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
      this._value = formatted;
    }
    super.doCommit();
  }
  _normalizeZeros(value) {
    const parts = this._removeThousandsSeparators(value).split(this.radix);

    // remove leading zeros
    parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num) => sign + num);
    // add leading zero
    if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';
    if (parts.length > 1) {
      parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros
      if (!parts[1].length) parts.length = 1; // remove fractional
    }
    return this._insertThousandsSeparators(parts.join(this.radix));
  }
  _padFractionalZeros(value) {
    if (!value) return value;
    const parts = value.split(this.radix);
    if (parts.length < 2) parts.push('');
    parts[1] = parts[1].padEnd(this.scale, '0');
    return parts.join(this.radix);
  }
  doSkipInvalid(ch, flags, checkTail) {
    if (flags === void 0) {
      flags = {};
    }
    const dropFractional =
      this.scale === 0 &&
      ch !== this.thousandsSeparator &&
      (ch === this.radix || ch === MaskedNumber.UNMASKED_RADIX || this.mapToRadix.includes(ch));
    return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(
      this.radix,
      MaskedNumber.UNMASKED_RADIX,
    );
  }
  set unmaskedValue(unmaskedValue) {
    super.unmaskedValue = unmaskedValue;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(n) {
    this.rawInputValue = this.format(n, this).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
  }

  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(number) {
    this.typedValue = number;
  }
  get allowNegative() {
    return (this.min != null && this.min < 0) || (this.max != null && this.max < 0);
  }
  get allowPositive() {
    return (this.min != null && this.min > 0) || (this.max != null && this.max > 0);
  }
  typedValueEquals(value) {
    // handle  0 -> '' case (typed = 0 even if value = '')
    // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
    return (
      (super.typedValueEquals(value) ||
        (MaskedNumber.EMPTY_VALUES.includes(value) && MaskedNumber.EMPTY_VALUES.includes(this.typedValue))) &&
      !(value === 0 && this.value === '')
    );
  }
}
_MaskedNumber = MaskedNumber;
MaskedNumber.UNMASKED_RADIX = '.';
MaskedNumber.EMPTY_VALUES = [...Masked.EMPTY_VALUES, 0];
MaskedNumber.DEFAULTS = {
  ...Masked.DEFAULTS,
  mask: Number,
  radix: ',',
  thousandsSeparator: '',
  mapToRadix: [_MaskedNumber.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: true,
  padFractionalZeros: false,
  parse: Number,
  format: (n) =>
    n.toLocaleString('en-US', {
      useGrouping: false,
      maximumFractionDigits: 20,
    }),
};
IMask.MaskedNumber = MaskedNumber;

/** Mask pipe source and destination types */
const PIPE_TYPE = {
  MASKED: 'value',
  UNMASKED: 'unmaskedValue',
  TYPED: 'typedValue',
};
/** Creates new pipe function depending on mask type, source and destination options */
function createPipe(arg, from, to) {
  if (from === void 0) {
    from = PIPE_TYPE.MASKED;
  }
  if (to === void 0) {
    to = PIPE_TYPE.MASKED;
  }
  const masked = createMask(arg);
  return (value) =>
    masked.runIsolated((m) => {
      m[from] = value;
      return m[to];
    });
}

/** Pipes value through mask depending on mask type, source and destination options */
function pipe(value, mask, from, to) {
  return createPipe(mask, from, to)(value);
}
IMask.PIPE_TYPE = PIPE_TYPE;
IMask.createPipe = createPipe;
IMask.pipe = pipe;

/** Pattern mask */
class RepeatBlock extends MaskedPattern {
  get repeatFrom() {
    var _ref;
    return (_ref = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === Infinity ? 0 : this.repeat) != null
      ? _ref
      : 0;
  }
  get repeatTo() {
    var _ref2;
    return (_ref2 = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? _ref2 : Infinity;
  }
  constructor(opts) {
    super(opts);
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    var _ref3, _ref4, _this$_blocks;
    const { repeat, ...blockOpts } = normalizeOpts(opts); // TODO type
    this._blockOpts = Object.assign({}, this._blockOpts, blockOpts);
    const block = createMask(this._blockOpts);
    this.repeat =
      (_ref3 = (_ref4 = repeat != null ? repeat : block.repeat) != null ? _ref4 : this.repeat) != null
        ? _ref3
        : Infinity; // TODO type

    super._update({
      mask: 'm'.repeat(
        Math.max(
          (this.repeatTo === Infinity && ((_this$_blocks = this._blocks) == null ? void 0 : _this$_blocks.length)) || 0,
          this.repeatFrom,
        ),
      ),
      blocks: {
        m: block,
      },
      eager: block.eager,
      overwrite: block.overwrite,
      skipInvalid: block.skipInvalid,
      lazy: block.lazy,
      placeholderChar: block.placeholderChar,
      displayChar: block.displayChar,
    });
  }
  _allocateBlock(bi) {
    if (bi < this._blocks.length) return this._blocks[bi];
    if (this.repeatTo === Infinity || this._blocks.length < this.repeatTo) {
      this._blocks.push(createMask(this._blockOpts));
      this.mask += 'm';
      return this._blocks[this._blocks.length - 1];
    }
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const details = new ChangeDetails();
    for (
      let bi =
          (_this$_mapPosToBlock$ =
            (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null
              ? void 0
              : _this$_mapPosToBlock.index) != null
            ? _this$_mapPosToBlock$
            : Math.max(this._blocks.length - 1, 0),
        block,
        allocated;
      // try to get a block or
      // try to allocate a new block if not allocated already
      (block =
        (_this$_blocks$bi = this._blocks[bi]) != null
          ? _this$_blocks$bi
          : (allocated = !allocated && this._allocateBlock(bi)));
      ++bi
    ) {
      var _this$_mapPosToBlock$, _this$_mapPosToBlock, _this$_blocks$bi, _flags$_beforeTailSta;
      const blockDetails = block._appendChar(ch, {
        ...flags,
        _beforeTailState:
          (_flags$_beforeTailSta = flags._beforeTailState) == null ||
          (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null
            ? void 0
            : _flags$_beforeTailSta[bi],
      });
      if (blockDetails.skip && allocated) {
        // remove the last allocated block and break
        this._blocks.pop();
        this.mask = this.mask.slice(1);
        break;
      }
      details.aggregate(blockDetails);
      if (blockDetails.consumed) break; // go next char
    }
    return details;
  }
  _trimEmptyTail(fromPos, toPos) {
    var _this$_mapPosToBlock2, _this$_mapPosToBlock3;
    if (fromPos === void 0) {
      fromPos = 0;
    }
    const firstBlockIndex = Math.max(
      ((_this$_mapPosToBlock2 = this._mapPosToBlock(fromPos)) == null ? void 0 : _this$_mapPosToBlock2.index) || 0,
      this.repeatFrom,
      0,
    );
    let lastBlockIndex;
    if (toPos != null)
      lastBlockIndex =
        (_this$_mapPosToBlock3 = this._mapPosToBlock(toPos)) == null ? void 0 : _this$_mapPosToBlock3.index;
    if (lastBlockIndex == null) lastBlockIndex = this._blocks.length - 1;
    let removeCount = 0;
    for (let blockIndex = lastBlockIndex; firstBlockIndex <= blockIndex; --blockIndex, ++removeCount) {
      if (this._blocks[blockIndex].unmaskedValue) break;
    }
    if (removeCount) {
      this._blocks.splice(lastBlockIndex - removeCount + 1, removeCount);
      this.mask = this.mask.slice(removeCount);
    }
  }
  reset() {
    super.reset();
    this._trimEmptyTail();
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const removeDetails = super.remove(fromPos, toPos);
    this._trimEmptyTail(fromPos, toPos);
    return removeDetails;
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos == null && this.repeatTo === Infinity) return Infinity;
    return super.totalInputPositions(fromPos, toPos);
  }
  get state() {
    return super.state;
  }
  set state(state) {
    this._blocks.length = state._blocks.length;
    this.mask = this.mask.slice(0, this._blocks.length);
    super.state = state;
  }
}
IMask.RepeatBlock = RepeatBlock;

try {
  globalThis.IMask = IMask;
} catch {}

const MASK_PROPS = {
  // common
  mask: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].array,
    PropTypes__default['default'].func,
    PropTypes__default['default'].string,
    PropTypes__default['default'].instanceOf(RegExp),
    PropTypes__default['default'].oneOf([Date, Number, IMask.Masked]),
    PropTypes__default['default'].instanceOf(IMask.Masked),
  ]),
  value: PropTypes__default['default'].any,
  unmask: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].bool,
    PropTypes__default['default'].oneOf(['typed']),
  ]),
  prepare: PropTypes__default['default'].func,
  prepareChar: PropTypes__default['default'].func,
  validate: PropTypes__default['default'].func,
  commit: PropTypes__default['default'].func,
  overwrite: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].bool,
    PropTypes__default['default'].oneOf(['shift']),
  ]),
  eager: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].bool,
    PropTypes__default['default'].oneOf(['append', 'remove']),
  ]),
  skipInvalid: PropTypes__default['default'].bool,
  // events
  onAccept: PropTypes__default['default'].func,
  onComplete: PropTypes__default['default'].func,
  // pattern
  placeholderChar: PropTypes__default['default'].string,
  displayChar: PropTypes__default['default'].string,
  lazy: PropTypes__default['default'].bool,
  definitions: PropTypes__default['default'].object,
  blocks: PropTypes__default['default'].object,
  // enum
  enum: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  // range
  maxLength: PropTypes__default['default'].number,
  from: PropTypes__default['default'].number,
  to: PropTypes__default['default'].number,
  // date
  pattern: PropTypes__default['default'].string,
  format: PropTypes__default['default'].func,
  parse: PropTypes__default['default'].func,
  autofix: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].bool,
    PropTypes__default['default'].oneOf(['pad']),
  ]),
  // number
  radix: PropTypes__default['default'].string,
  thousandsSeparator: PropTypes__default['default'].string,
  mapToRadix: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  scale: PropTypes__default['default'].number,
  normalizeZeros: PropTypes__default['default'].bool,
  padFractionalZeros: PropTypes__default['default'].bool,
  min: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].number,
    PropTypes__default['default'].instanceOf(Date),
  ]),
  max: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].number,
    PropTypes__default['default'].instanceOf(Date),
  ]),
  // dynamic
  dispatch: PropTypes__default['default'].func,
  // ref
  inputRef: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].func,
    PropTypes__default['default'].shape({
      current: PropTypes__default['default'].object,
    }),
  ]),
};
const MASK_PROPS_NAMES = Object.keys(MASK_PROPS).filter((p) => p !== 'value');
const NON_MASK_OPTIONS_NAMES = ['value', 'unmask', 'onAccept', 'onComplete', 'inputRef'];
const MASK_OPTIONS_NAMES = MASK_PROPS_NAMES.filter((pName) => NON_MASK_OPTIONS_NAMES.indexOf(pName) < 0);
function IMaskMixin(ComposedComponent) {
  var _Class;
  const MaskedComponent =
    ((_Class = class MaskedComponent extends React__default['default'].Component {
      constructor(props) {
        super(props);
        this._inputRef = this._inputRef.bind(this);
      }
      componentDidMount() {
        if (!this.props.mask) return;
        this.initMask();
      }
      componentDidUpdate() {
        const props = this.props;
        const maskOptions = this._extractMaskOptionsFromProps(props);
        if (maskOptions.mask) {
          if (this.maskRef) {
            this.maskRef.updateOptions(maskOptions); // TODO fix
            if ('value' in props && props.value !== undefined) this.maskValue = props.value;
          } else {
            this.initMask(maskOptions);
          }
        } else {
          this.destroyMask();
          if ('value' in props && props.value !== undefined) {
            var _this$element;
            if (
              (_this$element = this.element) != null &&
              _this$element.isContentEditable &&
              this.element.tagName !== 'INPUT' &&
              this.element.tagName !== 'TEXTAREA'
            )
              this.element.textContent = props.value;
            else this.element.value = props.value;
          }
        }
      }
      componentWillUnmount() {
        this.destroyMask();
      }
      _inputRef(el) {
        this.element = el;
        if (this.props.inputRef) {
          if (Object.prototype.hasOwnProperty.call(this.props.inputRef, 'current')) this.props.inputRef.current = el;
          else this.props.inputRef(el);
        }
      }
      initMask(maskOptions) {
        if (maskOptions === void 0) {
          maskOptions = this._extractMaskOptionsFromProps(this.props);
        }
        this.maskRef = IMask(this.element, maskOptions)
          .on('accept', this._onAccept.bind(this))
          .on('complete', this._onComplete.bind(this));
        if ('value' in this.props && this.props.value !== undefined) this.maskValue = this.props.value;
      }
      destroyMask() {
        if (this.maskRef) {
          this.maskRef.destroy();
          delete this.maskRef;
        }
      }
      _extractMaskOptionsFromProps(props) {
        const { ...cloneProps } = props;

        // keep only mask options
        Object.keys(cloneProps)
          .filter((prop) => MASK_OPTIONS_NAMES.indexOf(prop) < 0)
          .forEach((nonMaskProp) => {
            delete cloneProps[nonMaskProp];
          });
        return cloneProps;
      }
      _extractNonMaskProps(props) {
        const { ...cloneProps } = props;
        MASK_PROPS_NAMES.forEach((maskProp) => {
          if (maskProp !== 'maxLength') delete cloneProps[maskProp];
        });
        if (!('defaultValue' in cloneProps)) cloneProps.defaultValue = props.mask ? '' : cloneProps.value;
        delete cloneProps.value;
        return cloneProps;
      }
      get maskValue() {
        if (!this.maskRef) return '';
        if (this.props.unmask === 'typed') return this.maskRef.typedValue;
        if (this.props.unmask) return this.maskRef.unmaskedValue;
        return this.maskRef.value;
      }
      set maskValue(value) {
        if (!this.maskRef) return;
        value = value == null && this.props.unmask !== 'typed' ? '' : value;
        if (this.props.unmask === 'typed') this.maskRef.typedValue = value;
        else if (this.props.unmask) this.maskRef.unmaskedValue = value;
        else this.maskRef.value = value;
      }
      _onAccept(e) {
        if (this.props.onAccept && this.maskRef) this.props.onAccept(this.maskValue, this.maskRef, e);
      }
      _onComplete(e) {
        if (this.props.onComplete && this.maskRef) this.props.onComplete(this.maskValue, this.maskRef, e);
      }
      render() {
        return React__default['default'].createElement(ComposedComponent, {
          ...this._extractNonMaskProps(this.props),
          inputRef: this._inputRef,
        });
      }
    }),
    (_Class.displayName = void 0),
    (_Class.propTypes = void 0),
    _Class);
  const nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || 'Component';
  MaskedComponent.displayName = 'IMask(' + nestedComponentName + ')';
  MaskedComponent.propTypes = MASK_PROPS;
  return React__default['default'].forwardRef((props, ref) =>
    React__default['default'].createElement(MaskedComponent, {
      ...props,
      ref,
    }),
  );
}

const IMaskInputClass = IMaskMixin((_ref) => {
  let { inputRef, ...props } = _ref;
  return React__default['default'].createElement('input', {
    ...props,
    ref: inputRef,
  });
});
const IMaskInputFn = (props, ref) =>
  React__default['default'].createElement(IMaskInputClass, {
    ...props,
    ref,
  }); // TODO fix no idea
const IMaskInput = React__default['default'].forwardRef(IMaskInputFn);

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == 'function') {
    var a = function a() {
      if (this instanceof a) {
        var args = [null];
        args.push.apply(args, arguments);
        var Ctor = Function.bind.apply(f, args);
        return new Ctor();
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', { value: true });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(
      a,
      k,
      d.get
        ? d
        : {
            enumerable: true,
            get: function () {
              return n[k];
            },
          },
    );
  });
  return a;
}

var classnames = { exports: {} };

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
classnames.exports;

(function (module) {
  /* global define */

  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
            classes.push(arg.toString());
            continue;
          }

          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);

var classnamesExports = classnames.exports;
var cx = /*@__PURE__*/ getDefaultExportFromCjs(classnamesExports);

var Icon = function (_a) {
  var name = _a.name,
    className = _a.className,
    _b = _a.size,
    size = _b === void 0 ? 'lg' : _b,
    fixed = _a.fixed,
    pullLeft = _a.pullLeft,
    pullRight = _a.pullRight,
    spin = _a.spin,
    rotate = _a.rotate,
    color = _a.color,
    style = _a.style;
  return jsxRuntime.jsx('i', {
    style: __assign(__assign({}, style), { color: color }),
    className: cx(
      'icon',
      'htco-Icon',
      className,
      /^icon/.exec(name) ? name : 'icon-'.concat(name),
      rotate && 'icon-rotate-'.concat(rotate),
      size === 'sm' ? null : 'icon-'.concat(size),
      {
        'icon-fw': !!fixed,
        'icon-spin': !!spin,
        'pull-right': !!pullRight,
        'pull-left': !!pullLeft,
      },
    ),
  });
};

var style$R = { FormError: 'htco-FormError', isStandalone: 'htco-isStandalone' };

var FormError = function (_a) {
  var error = _a.error,
    standalone = _a.standalone,
    className = _a.className,
    props = __rest$1(_a, ['error', 'standalone', 'className']);
  if (error) {
    return jsxRuntime.jsxs(
      'span',
      __assign({ className: cx(style$R.FormError, className, standalone && style$R.isStandalone) }, props, {
        children: [standalone && jsxRuntime.jsx(Icon, { name: 'error', pullLeft: true }), error],
      }),
    );
  }
  return null;
};
FormError.propTypes = {
  error: PropTypes__default['default'].node,
  standalone: PropTypes__default['default'].bool,
};

var style$Q = {
  Label: 'htco-Label',
  LabelText: 'htco-LabelText',
  LabelError: 'htco-LabelError',
  LabelWithAsterisk: 'htco-LabelWithAsterisk',
  LabelWithAsteriskAndHelp: 'htco-LabelWithAsteriskAndHelp',
};

var Label$1 = function (_a) {
  var children = _a.children,
    error = _a.error,
    props = __rest$1(_a, ['children', 'error']);
  if (children || error) {
    return jsxRuntime.jsxs(
      'label',
      __assign({}, props, {
        className: cx(style$Q.Label, props.className),
        children: [
          children && jsxRuntime.jsx('span', { className: style$Q.LabelText, children: children }),
          jsxRuntime.jsx(FormError, { className: style$Q.LabelError, error: error }),
        ],
      }),
    );
  }
  return null;
};
Label$1.propTypes = {
  children: PropTypes__default['default'].node,
};

var _deleteField = function (obj, field) {
  var newObject = __assign({}, obj);
  delete newObject[field];
  return newObject;
};
var useForm = function (defaultValues, options) {
  if (defaultValues === void 0) {
    defaultValues = {};
  }
  var _a = React.useState(defaultValues),
    formData = _a[0],
    setFormData = _a[1];
  var _b = React.useState({}),
    errors = _b[0],
    setErrors = _b[1];
  var _c = React.useState([]),
    requiredFields = _c[0],
    setRequiredFields = _c[1];
  var _d = React.useState((options === null || options === void 0 ? void 0 : options.showInitialErrors) || false),
    showSubmitErrors = _d[0],
    setShowSubmitErrors = _d[1];
  var handleValidation = React.useCallback(function (field, message, show) {
    if (message) {
      setErrors(function (errors) {
        var _a;
        return __assign(__assign({}, errors), ((_a = {}), (_a[field] = { message: message, show: show }), _a));
      });
    } else {
      setErrors(function (errors) {
        return _deleteField(errors, field);
      });
    }
  }, []);
  // This allows for dynamic updating of the form's initial state if shouldUpdateDefaultValues is true
  React.useEffect(
    function () {
      if (options === null || options === void 0 ? void 0 : options.shouldUpdateDefaultValues) {
        setFormData(defaultValues);
      }
    },
    [options === null || options === void 0 ? void 0 : options.shouldUpdateDefaultValues, defaultValues],
  );
  // This allows for dynamic updating of the form's showInitialErrors if shouldUpdateInitialErrors is true
  React.useEffect(
    function () {
      if (
        (options === null || options === void 0 ? void 0 : options.shouldUpdateInitialErrors) &&
        (options === null || options === void 0 ? void 0 : options.showInitialErrors) !== showSubmitErrors
      ) {
        setShowSubmitErrors(options === null || options === void 0 ? void 0 : options.showInitialErrors);
      }
    },
    [
      options === null || options === void 0 ? void 0 : options.showInitialErrors,
      options === null || options === void 0 ? void 0 : options.shouldUpdateInitialErrors,
      showSubmitErrors,
    ],
  );
  var handleFieldChange = React.useCallback(
    function (value, field, fieldError) {
      // Handling '' values to prevent fields from retaining these upon reset
      if (value || value === 0 || value === '') {
        setFormData(function (formData) {
          var _a;
          return __assign(__assign({}, formData), ((_a = {}), (_a[field] = value), _a));
        });
      } else {
        setFormData(function (formData) {
          return _deleteField(formData, field);
        });
      }
      // Resolve Errors on change, but doesn't show errors on change
      handleValidation(field, fieldError, false);
    },
    [handleValidation],
  );
  var updateFormData = React.useCallback(function (updatedFormFields) {
    if (updatedFormFields === void 0) {
      updatedFormFields = {};
    }
    setFormData(function (formData) {
      return __assign(__assign({}, formData), updatedFormFields);
    });
  }, []);
  // Manages errors on blur
  var handleFieldBlur = React.useCallback(
    function (value, field, fieldError) {
      handleValidation(field, fieldError, true);
    },
    [handleValidation],
  );
  var handleRequire = function (field) {
    // @ts-expect-error TS(2345): Argument of type '(prev: never[]) => any[]' is not... Remove this comment to see the full error message
    setRequiredFields(function (prev) {
      // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
      if (prev.includes(field)) return prev;
      return __spreadArray(__spreadArray([], prev, true), [field], false);
    });
  };
  var handleUnsetRequire = function (field) {
    setRequiredFields(function (prev) {
      // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
      if (!prev.includes(field)) return prev;
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (requiredErrors[field]) {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        delete errors[field];
      }
      return prev.filter(function (item) {
        return item !== field;
      });
    });
  };
  var requiredErrors = {};
  requiredFields.forEach(function (field) {
    var val = formData[field];
    if (
      (!val && val !== 0) ||
      (Array.isArray(val) && val.length === 0) ||
      (typeof val === 'string' && val.trim().length === 0)
    ) {
      // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'never'.
      requiredErrors[field] = { message: 'This is a required field.', show: showSubmitErrors };
    }
  });
  var hasNoErrors = Object.keys(errors).length === 0;
  var hasNoEmptyRequiredFields = Object.keys(requiredErrors).length === 0;
  var isFormValid = hasNoErrors && hasNoEmptyRequiredFields;
  var allErrors = __assign(__assign({}, requiredErrors), errors);
  var formSubmitMessage = null;
  if (showSubmitErrors && !isFormValid) {
    if (hasNoEmptyRequiredFields) {
      formSubmitMessage = 'Please correct highlighted errors and try again';
    } else {
      formSubmitMessage = 'Please complete all required fields';
    }
  }
  return {
    formData: formData,
    formSubmitError: formSubmitMessage,
    errors: allErrors,
    isFormValid: isFormValid,
    setErrors: handleValidation,
    handleFieldChange: handleFieldChange,
    updateFormData: updateFormData,
    showSubmitErrors: showSubmitErrors,
    handleSubmit: function (submitFn) {
      return function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (isFormValid) {
          if (submitFn) {
            submitFn(formData);
          } else {
            console.error('No callback function was passed to handleSubmit');
          }
        } else {
          setShowSubmitErrors(true);
        }
      };
    },
    registerField: function (name, valueProp) {
      var _a;
      if (valueProp === void 0) {
        valueProp = 'value';
      }
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      var error = allErrors[name];
      return (
        (_a = {
          name: name,
        }),
        (_a[valueProp] = formData[name]),
        (_a.error = ((error === null || error === void 0 ? void 0 : error.show) && error.message) || null),
        (_a.onBlur = handleFieldBlur),
        (_a.onChange = handleFieldChange),
        (_a.registerRequiredField = handleRequire),
        (_a.unregisterRequiredField = handleUnsetRequire),
        _a
      );
    },
  };
};
// Utility Hook for components to use required fields with useForm
var useRequiredValidation = function (_a) {
  var name = _a.name,
    required = _a.required,
    registerRequiredField = _a.registerRequiredField,
    unregisterRequiredField = _a.unregisterRequiredField;
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  var nameRef = React.useRef();
  React.useEffect(
    function () {
      if (required) {
        registerRequiredField === null || registerRequiredField === void 0 ? void 0 : registerRequiredField(name);
      } else {
        unregisterRequiredField === null || unregisterRequiredField === void 0 ? void 0 : unregisterRequiredField(name);
      }
      if (nameRef.current !== name) {
        unregisterRequiredField === null || unregisterRequiredField === void 0
          ? void 0
          : unregisterRequiredField(nameRef.current);
        nameRef.current = name;
      }
      return function () {
        return unregisterRequiredField === null || unregisterRequiredField === void 0
          ? void 0
          : unregisterRequiredField(name);
      };
    },
    [name, required],
  );
};
var useErrorScroll = function (formError, element) {
  React.useEffect(
    function () {
      if (formError) {
        if (element) {
          element.scrollTop = 0;
        } else {
          window.scrollTo({ top: 0 });
        }
      }
    },
    [formError],
  );
};

var style$P = { TextInput: 'htco-TextInput', hasError: 'htco-hasError' };

var TextInput = React.forwardRef(function (_a, ref) {
  var _b;
  var _c = _a.type,
    type = _c === void 0 ? 'text' : _c,
    _d = _a.value,
    value = _d === void 0 ? '' : _d,
    className = _a.className,
    label = _a.label,
    error = _a.error,
    validator = _a.validator,
    mask = _a.mask,
    onBlur = _a.onBlur,
    onChange = _a.onChange,
    required = _a.required,
    registerRequiredField = _a.registerRequiredField,
    unregisterRequiredField = _a.unregisterRequiredField,
    props = __rest$1(_a, [
      'type',
      'value',
      'className',
      'label',
      'error',
      'validator',
      'mask',
      'onBlur',
      'onChange',
      'required',
      'registerRequiredField',
      'unregisterRequiredField',
    ]);
  useRequiredValidation(
    __assign(
      {
        registerRequiredField: registerRequiredField,
        unregisterRequiredField: unregisterRequiredField,
        required: required,
      },
      props,
    ),
  );
  React.useEffect(function () {
    if (value && value !== '') {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(value, props.name, handleValidation(value));
    }
  }, []);
  var handleChange = function (e) {
    var val = e.currentTarget.value;
    onChange(val, props.name, handleValidation(val));
  };
  var handleBlur = function (e) {
    var val = e.currentTarget.value;
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(val, props.name, handleValidation(val));
  };
  var handleValidation = function (val) {
    if (val || props.required) {
      if (validator) {
        return validator(val);
      }
    }
  };
  var Input = type === 'textarea' ? 'textarea' : 'input';
  var labelObject =
    (_b = label === null || label === void 0 ? void 0 : label.props) === null || _b === void 0 ? void 0 : _b.label;
  var ariaLabel = typeof label === 'string' ? label : labelObject;
  if (mask) {
    return jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        jsxRuntime.jsx(Label$1, { error: error, children: label }),
        jsxRuntime.jsx(
          IMaskInput,
          __assign(
            {
              mask: mask,
              value: value,
              unmask: false,
              'aria-label': ariaLabel,
              className: cx(style$P.TextInput, className, error && style$P.hasError),
              onBlur: handleBlur,
              onAccept: function (value) {
                onChange(value, props.name, handleValidation(value));
              },
              ref: ref,
            },
            props,
          ),
        ),
      ],
    });
  }
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      jsxRuntime.jsx(Label$1, { error: error, children: label }),
      jsxRuntime.jsx(
        Input,
        __assign(
          {
            ref: ref,
            value: value,
            type: type,
            'aria-label': ariaLabel,
            className: cx(style$P.TextInput, className, error && style$P.hasError),
            onBlur: handleBlur,
            onChange: handleChange,
            rows: type === 'textarea' ? props.rows || 5 : undefined,
          },
          props,
        ),
      ),
    ],
  });
});
TextInput.displayName = 'TextInput';
TextInput.propTypes = {
  type: PropTypes__default['default'].string,
  name: PropTypes__default['default'].string,
  label: PropTypes__default['default'].node,
  error: PropTypes__default['default'].node,
  required: PropTypes__default['default'].bool,
  validator: PropTypes__default['default'].func,
  value: PropTypes__default['default'].string,
  onChange: PropTypes__default['default'].func.isRequired,
  /** This is used with useForm hook to manage required fields */
  registerRequiredField: PropTypes__default['default'].func,
  unregisterRequiredField: PropTypes__default['default'].func,
};

var validateEmail = function (email) {
  var re =
    // eslint-disable-next-line no-control-regex
    /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
  return re.test(String(email).toLowerCase());
};
var EmailInput = function (_a) {
  var props = __rest$1(_a, []);
  var _b = React.useState(),
    internalError = _b[0],
    setInternalError = _b[1];
  var validator = function (val) {
    if (val || props.required) {
      if (!validateEmail(val)) {
        return 'Please enter a valid email. (example@hometap.com)';
      } else if (props.validator) {
        return props.validator();
      }
    }
  };
  var handleBlur = function (val, name, err) {
    var _a;
    setInternalError(validator(val));
    (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, val, name, err);
  };
  var handleChange = function (val, name, err) {
    var _a;
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, val, name, err);
    if (internalError && !validator(val)) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      setInternalError();
    }
  };
  return jsxRuntime.jsx(
    TextInput,
    __assign({}, props, {
      inputMode: 'email',
      error: props.error || internalError,
      validator: validator,
      onBlur: handleBlur,
      onChange: handleChange,
    }),
  );
};
EmailInput.propTypes = {
  name: PropTypes__default['default'].string,
  label: PropTypes__default['default'].node,
  error: PropTypes__default['default'].node,
  value: PropTypes__default['default'].string,
  required: PropTypes__default['default'].bool,
  validator: PropTypes__default['default'].func,
  onChange: PropTypes__default['default'].func,
  registerRequiredField: PropTypes__default['default'].func,
};

var validatePhone = function (phone) {
  var re = /^([+]?)?(1[\s\\-]?)?((\([0-9]{3}\))|[0-9]{3})[\s\\-]?[\0-9]{3}[\s\\-]?[0-9]{4}$/g;
  return re.test(phone);
};
var PhoneInput = function (_a) {
  var props = __rest$1(_a, []);
  var _b = React.useState(),
    internalError = _b[0],
    setInternalError = _b[1];
  var validator = function (val) {
    if (val || props.required) {
      if (!validatePhone(val)) {
        return 'Please enter a valid phone number. (123)-456-7890';
      } else if (props.validator) {
        return props.validator();
      }
    }
  };
  var handleBlur = function (val, name, err) {
    var _a, _b;
    setInternalError(validator(val));
    (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, val, name, err);
    if (!err) {
      (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, val, name, err);
    }
  };
  var handleChange = function (val, name, err) {
    var _a;
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, val, name, err);
    if (internalError && !validator(val)) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      setInternalError();
    }
  };
  return jsxRuntime.jsx(
    TextInput,
    __assign({ mask: '{1 }(000) 000-0000' }, props, {
      type: 'phone',
      inputMode: 'tel',
      error: props.error || internalError,
      validator: validator,
      onBlur: handleBlur,
      onChange: handleChange,
    }),
  );
};
PhoneInput.propTypes = {
  name: PropTypes__default['default'].string,
  label: PropTypes__default['default'].node,
  error: PropTypes__default['default'].node,
  value: PropTypes__default['default'].string,
  required: PropTypes__default['default'].bool,
  validator: PropTypes__default['default'].func,
  onChange: PropTypes__default['default'].func,
  registerRequiredField: PropTypes__default['default'].func,
};

var style$O = {
  SelectionSet: 'htco-SelectionSet',
  SelectionSetWrapper: 'htco-SelectionSetWrapper',
  SelectionSetItem: 'htco-SelectionSetItem',
  inverseTheme: 'htco-inverseTheme',
  isSelected: 'htco-isSelected',
  hasIcon: 'htco-hasIcon',
  hasDescription: 'htco-hasDescription',
  isStacked: 'htco-isStacked',
  isDisabled: 'htco-isDisabled',
};

var SelectionSetBase = React.forwardRef(function (_a, ref) {
  var label = _a.label,
    className = _a.className,
    name = _a.name,
    options = _a.options,
    error = _a.error,
    _b = _a.value,
    value = _b === void 0 ? undefined : _b,
    _c = _a.stacked,
    stacked = _c === void 0 ? false : _c,
    _d = _a.labelGrow,
    labelGrow = _d === void 0 ? true : _d,
    labelWidth = _a.labelWidth,
    _e = _a.align,
    align = _e === void 0 ? 'left' : _e,
    _f = _a.theme,
    theme = _f === void 0 ? 'normal' : _f,
    onChange = _a.onChange,
    props = __rest$1(_a, [
      'label',
      'className',
      'name',
      'options',
      'error',
      'value',
      'stacked',
      'labelGrow',
      'labelWidth',
      'align',
      'theme',
      'onChange',
    ]);
  var isMultiple = props.multiple === true;
  var initialValue = value !== null && value !== void 0 ? value : isMultiple ? [] : undefined;
  var _g = React.useState(initialValue),
    selectedValues = _g[0],
    setSelectedValues = _g[1];
  React.useEffect(
    function handleDefaultValue() {
      if (value !== selectedValues) {
        setSelectedValues(value);
      }
    },
    [value],
  );
  var createLabelStyle = function () {
    var inlineLabelStyle = { flexGrow: labelGrow ? 1 : 0 };
    if (labelWidth) {
      inlineLabelStyle.width = /%/.exec(labelWidth) ? 'calc('.concat(labelWidth, ' - 16px)') : labelWidth;
    }
    return inlineLabelStyle;
  };
  var alignMap = { left: 'flex-start', right: 'flex-end', center: 'center' };
  var handleInputChange = function (e, optionValue) {
    var updatedValues;
    if (isMultiple) {
      updatedValues = Array.isArray(selectedValues) ? __spreadArray([], selectedValues, true) : [];
      var index = updatedValues.indexOf(optionValue);
      if (index === -1) {
        updatedValues.push(optionValue);
      } else {
        updatedValues.splice(index, 1);
      }
    } else {
      updatedValues = optionValue;
    }
    setSelectedValues(updatedValues);
    // Create a synthetic event to mimic the native onChange
    var syntheticEvent = __assign(__assign({}, e), {
      target: __assign(__assign({}, e.target), { name: name, value: updatedValues }),
    });
    if (onChange) {
      onChange(syntheticEvent);
    }
  };
  return jsxRuntime.jsxs('div', {
    className: cx(style$O.SelectionSet, className),
    children: [
      jsxRuntime.jsx('input', { hidden: true, name: name, value: selectedValues, ref: ref, readOnly: true }),
      jsxRuntime.jsx(Label$1, { error: error, style: { textAlign: align }, children: label }),
      jsxRuntime.jsx('div', {
        className: style$O.SelectionSetWrapper,
        style: { justifyContent: alignMap[align] },
        children: options.map(function (option) {
          var _a, _b, _c, _d;
          var checked = isMultiple
            ? Array.isArray(selectedValues) && selectedValues.includes(option.value)
            : option.value === selectedValues;
          var type = isMultiple ? 'checkbox' : 'radio';
          return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            jsxRuntime.jsxs(
              'label',
              {
                className: cx(
                  style$O.SelectionSetItem,
                  ((_a = {}),
                  (_a[style$O.isSelected] = checked),
                  (_a[style$O.isStacked] = stacked),
                  (_a[style$O.hasIcon] = !!option.icon),
                  (_a[style$O.inverseTheme] = theme === 'inverse'),
                  (_a[style$O.hasDescription] = option.description),
                  (_a[style$O.isDisabled] = option.disabled),
                  _a),
                ),
                style: createLabelStyle(),
                role: isMultiple ? 'checkbox' : 'radio',
                'aria-checked': checked,
                'data-value': option.value,
                tabIndex: 0,
                onKeyDown: function (e) {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleInputChange(e, option.value);
                  }
                },
                children: [
                  jsxRuntime.jsx(
                    'input',
                    __assign(
                      {
                        type: type,
                        value: option.value,
                        checked: checked,
                        name: name,
                        onChange: function (e) {
                          return handleInputChange(e, option.value);
                        },
                      },
                      props,
                    ),
                  ),
                  option.icon &&
                    jsxRuntime.jsx(Icon, {
                      className: cx(((_b = {}), (_b[style$O.isDisabled] = option.disabled), _b)),
                      name: option.icon,
                    }),
                  jsxRuntime.jsxs('span', {
                    className: cx(((_c = {}), (_c[style$O.isDisabled] = option.disabled), _c)),
                    children: [
                      option.label,
                      option.description &&
                        jsxRuntime.jsx('p', {
                          className: cx(((_d = {}), (_d[style$O.isDisabled] = option.disabled), _d)),
                          children: option.description,
                        }),
                    ],
                  }),
                ],
              },
              option.value,
            )
          );
        }),
      }),
    ],
  });
});
SelectionSetBase.displayName = 'SelectionSetBase';

var isMultiple = function (p) {
  return !!(p === null || p === void 0 ? void 0 : p.multiple);
};
var SelectionSet = function (_a) {
  var _b = _a.required,
    required = _b === void 0 ? false : _b,
    name = _a.name,
    options = _a.options,
    registerRequiredField = _a.registerRequiredField,
    unregisterRequiredField = _a.unregisterRequiredField,
    props = __rest$1(_a, ['required', 'name', 'options', 'registerRequiredField', 'unregisterRequiredField']);
  useRequiredValidation(
    __assign(
      {
        name: name,
        required: required,
        registerRequiredField: registerRequiredField,
        unregisterRequiredField: unregisterRequiredField,
      },
      props,
    ),
  );
  var multiple = isMultiple(props);
  var handleChange = function (e) {
    var _a, _b;
    var selectedValue;
    if (multiple) {
      if ('key' in e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        selectedValue = (_a = e.currentTarget.dataset.value) !== null && _a !== void 0 ? _a : '';
      } else {
        selectedValue = e.currentTarget.value;
      }
      var newValue = [].concat((_b = props.value) !== null && _b !== void 0 ? _b : []);
      var selectedValueIndex = newValue.indexOf(selectedValue);
      if (selectedValueIndex === -1) {
        newValue.push(selectedValue);
      } else {
        newValue.splice(selectedValueIndex, 1);
      }
      props.onChange(newValue, name);
    } else {
      selectedValue = e.target.value;
      props.onChange(selectedValue, name);
    }
  };
  return jsxRuntime.jsx(
    SelectionSetBase,
    __assign({ options: options, name: name }, props, { onChange: handleChange }),
  );
};

var handleKeyboardEnter = function (callback) {
  return function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      callback(e);
    }
  };
};
var handleKeyboardClick = function (e) {
  handleKeyboardEnter(function (evnt) {
    evnt.preventDefault();
    if (evnt.currentTarget) {
      evnt.currentTarget.click();
    }
  })(e);
};

var style$N = {
  Toggle: 'htco-Toggle',
  ToggleItem: 'htco-ToggleItem',
  disabled: 'htco-disabled',
  isSelected: 'htco-isSelected',
  ToggleItemLabel: 'htco-ToggleItemLabel',
  ToggleItemLabelText: 'htco-ToggleItemLabelText',
  ToggleItemLabelSpacer: 'htco-ToggleItemLabelSpacer',
};

var Toggle = function (_a) {
  var label = _a.label,
    className = _a.className,
    name = _a.name,
    value = _a.value,
    defaultValue = _a.defaultValue,
    disabled = _a.disabled,
    _b = _a.options,
    options = _b === void 0 ? [] : _b,
    _c = _a.labelGrow,
    labelGrow = _c === void 0 ? true : _c,
    labelWidth = _a.labelWidth,
    onChange = _a.onChange;
  React.useEffect(function () {
    if (!value) {
      var initialVal = defaultValue || options[0].value;
      onChange(initialVal, name);
    }
  }, []);
  var handleClick = function (option) {
    if (disabled) return;
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    document.activeElement.blur();
    var value = option.value;
    onChange(value, name);
  };
  var labelStyle = { flexGrow: labelGrow ? 1 : 'unset' };
  if (labelWidth) {
    // @ts-expect-error TS(2339): Property 'width' does not exist on type '{ flexGro... Remove this comment to see the full error message
    labelStyle.width = labelWidth;
  }
  return jsxRuntime.jsxs('div', {
    className: cx(style$N.Toggle, className),
    children: [
      jsxRuntime.jsx(Label$1, { children: label }),
      jsxRuntime.jsx('div', {
        className: 'ToggleWrapper',
        children: options.map(function (option) {
          var _a;
          return jsxRuntime.jsx(
            'label',
            {
              className: cx(
                style$N.ToggleItem,
                ((_a = {}), (_a[style$N.isSelected] = value === option.value), (_a[style$N.disabled] = disabled), _a),
              ),
              htmlFor: name,
              id: option.value,
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
              role: 'radio',
              tabIndex: disabled ? -1 : 0,
              onKeyDown: handleKeyboardClick,
              'aria-checked': value === option.value,
              style: labelStyle,
              onClick: function () {
                handleClick(option);
              },
              'aria-label': option.label,
              children: jsxRuntime.jsxs('span', {
                className: cx(style$N.ToggleItemLabel),
                children: [
                  jsxRuntime.jsx('span', { className: cx(style$N.ToggleItemLabelText), children: option.label }),
                  jsxRuntime.jsx('span', { className: cx(style$N.ToggleItemLabelSpacer), children: option.label }),
                ],
              }),
            },
            option.value,
          );
        }),
      }),
    ],
  });
};
Toggle.propTypes = {
  label: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  value: PropTypes__default['default'].string,
  defaultValue: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  options: PropTypes__default['default'].array,
  labelWidth: PropTypes__default['default'].string,
  labelGrow: PropTypes__default['default'].bool,
  onChange: PropTypes__default['default'].func.isRequired,
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$b(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$b;

var _isObject = /*@__PURE__*/ getDefaultExportFromCjs(isObject_1);

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof global == 'object' && global && global.Object === Object && global;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$9 = freeGlobal || freeSelf || Function('return this')();

var _root = root$9;

var root$8 = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function () {
  return root$8.Date.now();
};

var now_1 = now$1;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

var _baseTrim = baseTrim$1;

var root$7 = _root;

/** Built-in value references. */
var Symbol$8 = root$7.Symbol;

var _Symbol = Symbol$8;

var Symbol$7 = _Symbol;

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$g.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$g.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$7 ? Symbol$7.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$f.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$f = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$f.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$6 = _Symbol,
  getRawTag = _getRawTag,
  objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$9(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

var _baseGetTag = baseGetTag$9;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$b(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$b;

var baseGetTag$8 = _baseGetTag,
  isObjectLike$a = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$6(value) {
  return typeof value == 'symbol' || (isObjectLike$a(value) && baseGetTag$8(value) == symbolTag$3);
}

var isSymbol_1 = isSymbol$6;

var baseTrim = _baseTrim,
  isObject$a = isObject_1,
  isSymbol$5 = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$2(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$5(value)) {
    return NAN;
  }
  if (isObject$a(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$a(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value)
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : reIsBadHex.test(value)
    ? NAN
    : +value;
}

var toNumber_1 = toNumber$2;

var isObject$9 = isObject_1,
  now = now_1,
  toNumber$1 = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max,
  nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$4(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$9(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$3(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;

    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (
      lastCallTime === undefined ||
      timeSinceLastCall >= wait ||
      timeSinceLastCall < 0 ||
      (maxing && timeSinceLastInvoke >= maxWait)
    );
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
      isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce$4;

var debounce$5 = /*@__PURE__*/ getDefaultExportFromCjs(debounce_1);

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$b(value) {
  return value;
}

var identity_1 = identity$b;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$1;

var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$2(func, start, transform) {
  start = nativeMax$2(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax$2(args.length - start, 0),
      array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$2;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$3(value) {
  return function () {
    return value;
  };
}

var constant_1 = constant$3;

var baseGetTag$7 = _baseGetTag,
  isObject$8 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$5(value) {
  if (!isObject$8(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$7(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$5;

var _isFunction = /*@__PURE__*/ getDefaultExportFromCjs(isFunction_1);

var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function () {
  var uid = /[^.]+$/.exec((coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO) || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
})();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$4 = isFunction_1,
  isMasked = _isMasked,
  isObject$7 = isObject_1,
  toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
  objectProto$e = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$e.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp(
  '^' +
    funcToString$1
      .call(hasOwnProperty$e)
      .replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
    '$',
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$7(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$4(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$2(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$2;

var baseIsNative = _baseIsNative,
  getValue$1 = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative;

var defineProperty$6 = (function () {
  try {
    var func = getNative$6(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
})();

var _defineProperty$1e = defineProperty$6;

var constant$2 = constant_1,
  defineProperty$5 = _defineProperty$1e,
  identity$a = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty$5
  ? identity$a
  : function (func, string) {
      return defineProperty$5(func, 'toString', {
        configurable: true,
        enumerable: false,
        value: constant$2(string),
        writable: true,
      });
    };

var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
  HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
    lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
      remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
  shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut(baseSetToString);

var _setToString = setToString$2;

var identity$9 = identity_1,
  overRest$1 = _overRest,
  setToString$1 = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$2(func, start) {
  return setToString$1(overRest$1(func, start, identity$9), func + '');
}

var _baseRest = baseRest$2;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$5(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$5;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$2 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

var isLength_1 = isLength$3;

var isFunction$3 = isFunction_1,
  isLength$2 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$6(value) {
  return value != null && isLength$2(value.length) && !isFunction$3(value);
}

var isArrayLike_1 = isArrayLike$6;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return (
    !!length &&
    (type == 'number' || (type != 'symbol' && reIsUint.test(value))) &&
    value > -1 &&
    value % 1 == 0 &&
    value < length
  );
}

var _isIndex = isIndex$3;

var eq$4 = eq_1,
  isArrayLike$5 = isArrayLike_1,
  isIndex$2 = _isIndex,
  isObject$6 = isObject_1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$5(value, index, object) {
  if (!isObject$6(object)) {
    return false;
  }
  var type = typeof index;
  if (
    type == 'number' ? isArrayLike$5(object) && isIndex$2(index, object.length) : type == 'string' && index in object
  ) {
    return eq$4(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall$5;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
    result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

var baseGetTag$6 = _baseGetTag,
  isObjectLike$9 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$9(value) && baseGetTag$6(value) == argsTag$3;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
  isObjectLike$8 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$d.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$d.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$6 = baseIsArguments(
  (function () {
    return arguments;
  })(),
)
  ? baseIsArguments
  : function (value) {
      return (
        isObjectLike$8(value) && hasOwnProperty$d.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee')
      );
    };

var isArguments_1 = isArguments$6;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$f = Array.isArray;

var isArray_1 = isArray$f;

var _isArray = /*@__PURE__*/ getDefaultExportFromCjs(isArray_1);

var isBuffer$4 = { exports: {} };

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

isBuffer$4.exports;

(function (module, exports) {
  var root = _root,
    stubFalse = stubFalse_1;

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? root.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse;

  module.exports = isBuffer;
})(isBuffer$4, isBuffer$4.exports);

var isBufferExports = isBuffer$4.exports;

var baseGetTag$5 = _baseGetTag,
  isLength$1 = isLength_1,
  isObjectLike$7 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
  arrayTag$2 = '[object Array]',
  boolTag$4 = '[object Boolean]',
  dateTag$3 = '[object Date]',
  errorTag$2 = '[object Error]',
  funcTag$1 = '[object Function]',
  mapTag$5 = '[object Map]',
  numberTag$4 = '[object Number]',
  objectTag$4 = '[object Object]',
  regexpTag$3 = '[object RegExp]',
  setTag$5 = '[object Set]',
  stringTag$4 = '[object String]',
  weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
  dataViewTag$4 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] =
  typedArrayTags[float64Tag$2] =
  typedArrayTags[int8Tag$2] =
  typedArrayTags[int16Tag$2] =
  typedArrayTags[int32Tag$2] =
  typedArrayTags[uint8Tag$2] =
  typedArrayTags[uint8ClampedTag$2] =
  typedArrayTags[uint16Tag$2] =
  typedArrayTags[uint32Tag$2] =
    true;
typedArrayTags[argsTag$2] =
  typedArrayTags[arrayTag$2] =
  typedArrayTags[arrayBufferTag$3] =
  typedArrayTags[boolTag$4] =
  typedArrayTags[dataViewTag$4] =
  typedArrayTags[dateTag$3] =
  typedArrayTags[errorTag$2] =
  typedArrayTags[funcTag$1] =
  typedArrayTags[mapTag$5] =
  typedArrayTags[numberTag$4] =
  typedArrayTags[objectTag$4] =
  typedArrayTags[regexpTag$3] =
  typedArrayTags[setTag$5] =
  typedArrayTags[stringTag$4] =
  typedArrayTags[weakMapTag$2] =
    false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$7(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$5(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$4(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$4;

var _nodeUtil = { exports: {} };

_nodeUtil.exports;

(function (module, exports) {
  var freeGlobal = _freeGlobal;

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  })();

  module.exports = nodeUtil;
})(_nodeUtil, _nodeUtil.exports);

var _nodeUtilExports = _nodeUtil.exports;

var baseIsTypedArray = _baseIsTypedArray,
  baseUnary$3 = _baseUnary,
  nodeUtil$2 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray ? baseUnary$3(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$2;

var baseTimes = _baseTimes,
  isArguments$5 = isArguments_1,
  isArray$e = isArray_1,
  isBuffer$3 = isBufferExports,
  isIndex$1 = _isIndex,
  isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$c.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$e(value),
    isArg = !isArr && isArguments$5(value),
    isBuff = !isArr && !isArg && isBuffer$3(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;

  for (var key in value) {
    if (
      (inherited || hasOwnProperty$c.call(value, key)) &&
      !(
        skipIndexes &&
        // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == 'length' ||
          // Node.js 0.10 has enumerable non-index properties on buffers.
          (isBuff && (key == 'offset' || key == 'parent')) ||
          // PhantomJS 2 has enumerable non-index properties on typed arrays.
          (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
          // Skip index properties.
          isIndex$1(key, length))
      )
    ) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */

var objectProto$b = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$3(value) {
  var Ctor = value && value.constructor,
    proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$b;

  return value === proto;
}

var _isPrototype = isPrototype$3;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$5 = isObject_1,
  isPrototype$2 = _isPrototype,
  nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$5(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$2(object),
    result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$b.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys$1 = _arrayLikeKeys,
  baseKeysIn = _baseKeysIn,
  isArrayLike$4 = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$4(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$1(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$4;

var baseRest$1 = _baseRest,
  eq$3 = eq_1,
  isIterateeCall$4 = _isIterateeCall,
  keysIn$3 = keysIn_1;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$9.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults$1 = baseRest$1(function (object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall$4(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn$3(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined || (eq$3(value, objectProto$9[key]) && !hasOwnProperty$a.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

var defaults_1 = defaults$1;

var defaults$2 = /*@__PURE__*/ getDefaultExportFromCjs(defaults_1);

// These match the breakpoints in _breakpoints.scss
// lg = Container grid width
var breakpoints = {
  // legacy
  xs_old: 414,
  sm_old: 767,
  md_old: 1024,
  lg_old: 1200,
  xl_old: 1366,
  // redesign
  mobile: 375,
  mobileLg: 600,
  tablet: 834,
  tabletLg: 900,
  smallDesktop: 1280,
  largeDesktop: 1728,
  // newest
  xs: 600,
  sm: 900,
  md: 1280,
  lg: 1728,
};
var generateKey = function (prefix) {
  return (
    prefix +
    Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '')
      .substr(0, 5)
  );
};
var defaultOptions$2 = {
  breakpoints: breakpoints,
  delay: 0,
};
var useWindowSize = function (options) {
  var _a, _b;
  if (options === void 0) {
    options = {};
  }
  var _c = defaults$2(options, defaultOptions$2),
    breakpoints = _c.breakpoints,
    delay = _c.delay;
  var isClient = typeof window === 'object';
  var isServerRendered = process.env.IS_SERVER_RENDERED === 'true';
  var getSize = function () {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  };
  var _d = React.useState(isServerRendered ? generateKey('server') : null),
    key = _d[0],
    setKey = _d[1];
  var _e = React.useState(getSize),
    windowSize = _e[0],
    setWindowSize = _e[1];
  var screenWidth = (_a = windowSize.width) !== null && _a !== void 0 ? _a : 0;
  var screenHeight = (_b = windowSize.height) !== null && _b !== void 0 ? _b : 0;
  React.useEffect(function () {
    if (isClient) {
      if (isServerRendered) {
        setKey(generateKey('client'));
      }
      var _handleResize = function () {
        setWindowSize(getSize());
      };
      var handleResize_1 = delay ? debounce$5(_handleResize, delay) : _handleResize;
      window.addEventListener('resize', handleResize_1);
      return function () {
        return window.removeEventListener('resize', handleResize_1);
      };
    }
  }, []); // Dependency array left empty to mimic componentDidMount and componentWillUnmount
  var respond = function (max) {
    var maxSize = breakpoints[max];
    var screenWidthIsNum = typeof maxSize === 'number';
    var screenWidthDefined = screenWidth && screenWidthIsNum;
    return screenWidthDefined ? screenWidth <= maxSize : undefined;
  };
  return {
    isScreenSize: respond,
    screenHydrateKey: isServerRendered ? key : null,
    screenWidth: screenWidth,
    screenHeight: screenHeight,
  };
};

var style$M = {
  DropdownSelector: 'htco-DropdownSelector',
  DropdownSelectorIndicatorMulti: 'htco-DropdownSelectorIndicatorMulti',
  isDisabled: 'htco-isDisabled',
};

var findOption = function (options, value) {
  if (!options) return;
  return options.find(function (item) {
    return item.value === value;
  });
};
var DropdownSelector = function (_a) {
  var _b;
  var disabled = _a.disabled,
    _c = _a.label,
    label = _c === void 0 ? '' : _c,
    multiple = _a.multiple,
    _d = _a.isMuiSelect,
    isMuiSelect = _d === void 0 ? false : _d,
    required = _a.required,
    onChange = _a.onChange,
    error = _a.error,
    registerRequiredField = _a.registerRequiredField,
    unregisterRequiredField = _a.unregisterRequiredField,
    isSearchable = _a.isSearchable,
    onKeyDown = _a.onKeyDown,
    props = __rest$1(_a, [
      'disabled',
      'label',
      'multiple',
      'isMuiSelect',
      'required',
      'onChange',
      'error',
      'registerRequiredField',
      'unregisterRequiredField',
      'isSearchable',
      'onKeyDown',
    ]);
  useRequiredValidation({
    name: props.name,
    required: required,
    registerRequiredField: registerRequiredField,
    unregisterRequiredField: unregisterRequiredField,
  });
  var isScreenSize = useWindowSize().isScreenSize;
  var isMulti = !!multiple;
  var selectRef = React.useRef(null);
  var handleKeyDown = React.useCallback(function (event) {
    var _a, _b, _c, _d;
    if (onKeyDown) {
      onKeyDown(event);
      if (event.defaultPrevented) return;
    }
    if (event.key === 'Enter' && !((_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.props.menuIsOpen)) {
      (_b = selectRef.current) === null || _b === void 0 ? void 0 : _b.openMenu('first');
      // we need this for example to prevent submission of a form if the select is inside the form element
      event.preventDefault();
    }
    if (event.key === 'Tab' && ((_c = selectRef.current) === null || _c === void 0 ? void 0 : _c.props.menuIsOpen)) {
      (_d = selectRef.current) === null || _d === void 0 ? void 0 : _d.onMenuClose();
      // event.preventDefault() does not prevent focusing on next element, so we need to get focus back
      setTimeout(function () {
        var _a;
        return (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      }, 0);
      event.preventDefault();
    }
  }, []);
  // Find full option object from value key so that the parent forms can store simple values
  var selectedOptions = null;
  if (isMulti && Array.isArray(props.value)) {
    var values = props.value.map(function (val) {
      return findOption(props.options, val);
    });
    selectedOptions = values;
  } else if (props.value) {
    selectedOptions = findOption(props.options, props.value);
  }
  var handleChange = function (selected) {
    if (selectRef.current === null || !selected) return;
    if (Array.isArray(selected) && isMulti) {
      var values = selected.map(function (item) {
        return selectRef.current.getOptionValue(item);
      });
      return onChange === null || onChange === void 0 ? void 0 : onChange(values, props.name);
    }
    var value = selectRef.current.getOptionValue(selected);
    return onChange === null || onChange === void 0 ? void 0 : onChange(value, props.name);
  };
  var DropdownIndicator = function (props) {
    var _a, _b;
    return jsxRuntime.jsx(
      Select.components.DropdownIndicator,
      __assign({}, props, {
        children: isMuiSelect
          ? jsxRuntime.jsx(Icon, {
              name: props.selectProps.menuIsOpen ? 'icon-chevron2-up' : 'icon-chevron2-down',
              className: cx(
                style$M.DropdownSelectorIndicatorMulti,
                ((_a = {}), (_a[style$M.isDisabled] = disabled), _a),
                ((_b = {}), (_b[style$M.onError] = error), _b),
              ),
            })
          : jsxRuntime.jsx(Icon, {
              name: props.selectProps.menuIsOpen ? 'caret-up' : 'caret-down',
              style: { color: '#366CED', fontSize: '8px', padding: '0 4px' },
            }),
      }),
    );
  };
  var MultiValueRemove = function (props) {
    return jsxRuntime.jsx(
      Select.components.MultiValueRemove,
      __assign({}, props, { children: jsxRuntime.jsx(Icon, { name: 'cancel' }) }),
    );
  };
  var isDropdownSearchable = function () {
    // If the prop is provided, override screen logic
    if (isSearchable !== undefined) {
      return isSearchable;
    }
    // Disable keyboard by default if screen size is mobile
    var isMobile = isScreenSize('sm');
    return !isMobile;
  };
  var customComponents = isMuiSelect
    ? __assign({ DropdownIndicator: DropdownIndicator, MultiValueRemove: MultiValueRemove }, props.components)
    : __assign({ DropdownIndicator: DropdownIndicator }, props.components);
  var ariaLabel = (_b = props['aria-label']) !== null && _b !== void 0 ? _b : typeof label === 'string' ? label : '';
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      jsxRuntime.jsx(Label$1, { error: !isMuiSelect ? error : null, children: label }),
      jsxRuntime.jsx(
        Select__default['default'],
        __assign(
          {
            ref: selectRef,
            menuPlacement: 'auto',
            className: cx(props.className, style$M.DropdownSelector),
            'aria-label': ariaLabel,
          },
          props,
          {
            value: selectedOptions,
            theme: function (theme) {
              return __assign(__assign({}, theme), {
                borderRadius: 4,
                marginTop: '.35em',
                borderColor: error && '#B41A1A',
                colors: __assign(__assign({}, theme.colors), {
                  primary: isMuiSelect ? '#E1E9FC' : '#366CED',
                  primary75: '#6992F2',
                  primary50: isMuiSelect ? '#F6F6F6' : '#9AB6F6',
                  primary25: isMuiSelect ? '#F6F6F6' : '#E2EAFD',
                  danger: '#B41A1A',
                  dangerLight: '#DA8D8C',
                  neutral20: error ? '#B41A1A' : '#DDDDDD',
                }),
              });
            },
            components: customComponents,
            hideSelectedOptions: !isMuiSelect,
            isMulti: multiple,
            onChange: handleChange,
            onKeyDown: handleKeyDown,
            isDisabled: disabled,
            blurInputOnSelect: isMuiSelect,
            isSearchable: isDropdownSearchable(),
            onBlur: function (e) {
              if (props.onBlur) {
                props.onBlur(e.target.value, props.name);
              }
            },
          },
        ),
      ),
    ],
  });
};

var style$L = {
  ProgressIndicator: 'htco-ProgressIndicator',
  hasAnimation: 'htco-hasAnimation',
  ProgressIndicatorItem: 'htco-ProgressIndicatorItem',
  isActive: 'htco-isActive',
  isSaturated: 'htco-isSaturated',
  saturate: 'htco-saturate',
};

var ProgressIndicator = function (_a) {
  var steps = _a.steps,
    _b = _a.current,
    current = _b === void 0 ? 0 : _b;
  return jsxRuntime.jsx(jsxRuntime.Fragment, {
    children:
      steps &&
      jsxRuntime.jsx('div', {
        className: style$L.ProgressIndicator,
        children: steps.map(function (step, index) {
          return jsxRuntime.jsx(
            'span',
            {
              className: cx(style$L.hasAnimation, steps.indexOf(step) <= current ? style$L.isActive : ''),
              children: jsxRuntime.jsx('div', {
                className: cx(style$L.ProgressIndicatorItem),
                children: jsxRuntime.jsx('span', { children: step }),
              }),
            },
            step + index,
          );
        }),
      }),
  });
};
ProgressIndicator.propTypes = {
  steps: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,
  current: PropTypes__default['default'].number,
};

var style$K = { ProgressBar: 'htco-ProgressBar', ProgressBarFill: 'htco-ProgressBarFill' };

var ProgressBar = function (_a) {
  var steps = _a.steps,
    curStep = _a.curStep,
    _b = _a.height,
    height = _b === void 0 ? '4px' : _b;
  var widthCalc = (curStep / steps) * 100;
  var widthFill;
  if (widthCalc >= 100) {
    widthFill = '100%';
  } else if (widthCalc < 0 || !widthCalc) {
    widthFill = '0';
  } else {
    widthFill = ''.concat(widthCalc, '%');
  }
  return jsxRuntime.jsx('div', {
    className: style$K.ProgressBar,
    style: { height: height },
    children: jsxRuntime.jsx('div', { className: style$K.ProgressBarFill, style: { width: widthFill } }),
  });
};
ProgressBar.propTypes = {
  steps: PropTypes__default['default'].number.isRequired,
  curStep: PropTypes__default['default'].number.isRequired,
  height: PropTypes__default['default'].string,
};

React__namespace.createContext();
React__namespace.createContext();

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
      value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect =
  typeof window !== 'undefined' && window.document && window.document.createElement
    ? React__namespace.useLayoutEffect
    : React__namespace.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + '-' + start, placement + '-' + end]);
}, []);
var placements$1 = /*#__PURE__*/ [].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + '-' + start, placement + '-' + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow$1(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow$1(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow$1(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow$1(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0',
    },
    arrow: {
      position: 'absolute',
    },
    reference: {},
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules

var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles'],
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max$4 = Math.max;
var min$3 = Math.min;
var round$1 = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands
      .map(function (item) {
        return item.brand + '/' + item.version;
      })
      .join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect$1(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow$1(element) : window,
    visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y,
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect$1(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height,
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;

    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...

      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false

  return false;
}

function getComputedStyle$1(element) {
  return getWindow$1(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return (
    (isElement(element)
      ? element.ownerDocument // $FlowFixMe[prop-missing]
      : element.document) || window.document
  ).documentElement;
}

function getParentNode$1(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    (isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback
  );
}

function getTrueOffsetParent(element) {
  if (
    !isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle$1(element).position === 'fixed'
  ) {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block

function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode$1(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (
      css.transform !== 'none' ||
      css.perspective !== 'none' ||
      css.contain === 'paint' ||
      ['transform', 'perspective'].indexOf(css.willChange) !== -1 ||
      (isFirefox && css.willChange === 'filter') ||
      (isFirefox && css.filter && css.filter !== 'none')
    ) {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.

function getOffsetParent$1(element) {
  var window = getWindow$1(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (
    offsetParent &&
    (getNodeName(offsetParent) === 'html' ||
      (getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static'))
  ) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min, value, max) {
  return max$4(min, min$3(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding =
    typeof padding === 'function'
      ? padding(
          Object.assign({}, state.rects, {
            placement: state.placement,
          }),
        )
      : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow$1(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
    name = _ref.name,
    options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff =
    state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent$1(arrowElement);
  var clientSize = arrowOffsetParent
    ? axis === 'y'
      ? arrowOffsetParent.clientHeight || 0
      : arrowOffsetParent.clientWidth || 0
    : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] =
    ((_state$modifiersData$ = {}),
    (_state$modifiersData$[axisProp] = offset),
    (_state$modifiersData$.centerOffset = offset - center),
    _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
    options = _ref2.options;
  var _options$element = options.element,
    arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (!isHTMLElement(arrowElement)) {
      console.error(
        [
          'Popper: "arrow" element must be an HTMLElement (not an SVGElement).',
          'To use an SVG arrow, wrap it in an HTMLElement that will be used as',
          'the arrow.',
        ].join(' '),
      );
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules

var arrow$2 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow$1,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow'],
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto',
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
    y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$1(x * dpr) / dpr || 0,
    y: round$1(y * dpr) / dpr || 0,
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
    popperRect = _ref2.popperRect,
    placement = _ref2.placement,
    variation = _ref2.variation,
    offsets = _ref2.offsets,
    position = _ref2.position,
    gpuAcceleration = _ref2.gpuAcceleration,
    adaptive = _ref2.adaptive,
    roundOffsets = _ref2.roundOffsets,
    isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
    x = _offsets$x === void 0 ? 0 : _offsets$x,
    _offsets$y = offsets.y,
    y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 =
    typeof roundOffsets === 'function'
      ? roundOffsets({
          x: x,
          y: y,
        })
      : {
          x: x,
          y: y,
        };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent$1(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow$1(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    offsetParent = offsetParent;

    if (placement === top || ((placement === left || placement === right) && variation === end)) {
      sideY = bottom;
      var offsetY =
        isFixed && offsetParent === win && win.visualViewport
          ? win.visualViewport.height // $FlowFixMe[prop-missing]
          : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || ((placement === top || placement === bottom) && variation === end)) {
      sideX = right;
      var offsetX =
        isFixed && offsetParent === win && win.visualViewport
          ? win.visualViewport.width // $FlowFixMe[prop-missing]
          : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign(
    {
      position: position,
    },
    adaptive && unsetSides,
  );

  var _ref4 =
    roundOffsets === true
      ? roundOffsetsByDPR(
          {
            x: x,
            y: y,
          },
          getWindow$1(popper),
        )
      : {
          x: x,
          y: y,
        };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign(
      {},
      commonStyles,
      ((_Object$assign = {}),
      (_Object$assign[sideY] = hasY ? '0' : ''),
      (_Object$assign[sideX] = hasX ? '0' : ''),
      (_Object$assign.transform =
        (win.devicePixelRatio || 1) <= 1
          ? 'translate(' + x + 'px, ' + y + 'px)'
          : 'translate3d(' + x + 'px, ' + y + 'px, 0)'),
      _Object$assign),
    );
  }

  return Object.assign(
    {},
    commonStyles,
    ((_Object$assign2 = {}),
    (_Object$assign2[sideY] = hasY ? y + 'px' : ''),
    (_Object$assign2[sideX] = hasX ? x + 'px' : ''),
    (_Object$assign2.transform = ''),
    _Object$assign2),
  );
}

function computeStyles(_ref5) {
  var state = _ref5.state,
    options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
    gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
    _options$adaptive = options.adaptive,
    adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
    _options$roundOffsets = options.roundOffsets,
    roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== 'production') {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

    if (
      adaptive &&
      ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
        return transitionProperty.indexOf(property) >= 0;
      })
    ) {
      console.warn(
        [
          'Popper: Detected CSS transitions on at least one of the following',
          'CSS properties: "transform", "top", "right", "bottom", "left".',
          '\n\n',
          'Disable the "computeStyles" modifier\'s `adaptive` option to allow',
          'for smooth transitions, or remove these properties from the CSS',
          'transition declaration on the popper element if only transitioning',
          'opacity or background-color for example.',
          '\n\n',
          'We recommend using the popper element as a wrapper around an inner',
          'element that can have any CSS property transitioned for animations.',
        ].join(' '),
      );
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed',
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign(
      {},
      state.styles.popper,
      mapToStyles(
        Object.assign({}, commonStyles, {
          offsets: state.modifiersData.popperOffsets,
          position: state.options.strategy,
          adaptive: adaptive,
          roundOffsets: roundOffsets,
        }),
      ),
    );
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign(
      {},
      state.styles.arrow,
      mapToStyles(
        Object.assign({}, commonStyles, {
          offsets: state.modifiersData.arrow,
          position: 'absolute',
          adaptive: false,
          roundOffsets: roundOffsets,
        }),
      ),
    );
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement,
  });
} // eslint-disable-next-line import/no-unused-modules

var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {},
};

var passive = {
  passive: true,
};

function effect(_ref) {
  var state = _ref.state,
    instance = _ref.instance,
    options = _ref.options;
  var _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    _options$resize = options.resize,
    resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow$1(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules

var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {},
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom',
};
function getOppositePlacement$1(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start',
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow$1(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop,
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect$1(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow$1(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || (!layoutViewport && strategy === 'fixed')) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y,
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max$4(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max$4(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max$4(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y,
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
    overflow = _getComputedStyle.overflow,
    overflowX = _getComputedStyle.overflowX,
    overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent$1(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent$1(getParentNode$1(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent$1(element);
  var isBody =
    scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow$1(scrollParent);
  var target = isBody
    ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : [])
    : scrollParent;
  var updatedList = list.concat(target);
  return isBody
    ? updatedList // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    : updatedList.concat(listScrollParents(getParentNode$1(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height,
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect$1(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport
    ? rectToClientRect(getViewportRect(element, strategy))
    : isElement(clippingParent)
    ? getInnerBoundingClientRect(clippingParent, strategy)
    : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`

function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent$1(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

  return clippingParents.filter(function (clippingParent) {
    return (
      isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body'
    );
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents

function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(
    function (accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent, strategy);
      accRect.top = max$4(rect.top, accRect.top);
      accRect.right = min$3(rect.right, accRect.right);
      accRect.bottom = min$3(rect.bottom, accRect.bottom);
      accRect.left = max$4(rect.left, accRect.left);
      return accRect;
    },
    getClientRectFromMixedType(element, firstClippingParent, strategy),
  );
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
    element = _ref.element,
    placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height,
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height,
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY,
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY,
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y,
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
    _options$placement = _options.placement,
    placement = _options$placement === void 0 ? state.placement : _options$placement,
    _options$strategy = _options.strategy,
    strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
    _options$boundary = _options.boundary,
    boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
    _options$rootBoundary = _options.rootBoundary,
    rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
    _options$elementConte = _options.elementContext,
    elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
    _options$altBoundary = _options.altBoundary,
    altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
    _options$padding = _options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(
    typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements),
  );
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(
    isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper),
    boundary,
    rootBoundary,
    strategy,
  );
  var referenceClientRect = getBoundingClientRect$1(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement,
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right,
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement$1(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
    placement = _options.placement,
    boundary = _options.boundary,
    rootBoundary = _options.rootBoundary,
    padding = _options.padding,
    flipVariations = _options.flipVariations,
    _options$allowedAutoP = _options.allowedAutoPlacements,
    allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements$1 : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation
    ? flipVariations
      ? variationPlacements
      : variationPlacements.filter(function (placement) {
          return getVariation(placement) === variation;
        })
    : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (process.env.NODE_ENV !== 'production') {
      console.error(
        [
          'Popper: The `allowedAutoPlacements` option did not allow any',
          'placements. Ensure the `placement` option matches the variation',
          'of the allowed placements.',
          'For example, "auto" cannot be used to allow "bottom-start".',
          'Use "auto-start" instead.',
        ].join(' '),
      );
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement$1(placement);
  return [
    getOppositeVariationPlacement(placement),
    oppositePlacement,
    getOppositeVariationPlacement(oppositePlacement),
  ];
}

function flip$2(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
    specifiedFallbackPlacements = options.fallbackPlacements,
    padding = options.padding,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    _options$flipVariatio = options.flipVariations,
    flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
    allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements =
    specifiedFallbackPlacements ||
    (isBasePlacement || !flipVariations
      ? [getOppositePlacement$1(preferredPlacement)]
      : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(
      getBasePlacement(placement) === auto
        ? computeAutoPlacement$1(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements,
          })
        : placement,
    );
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding,
    });
    var mainVariationSide = isVertical ? (isStartVariation ? right : left) : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement$1(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement$1(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (
      checks.every(function (check) {
        return check;
      })
    ) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return 'break';
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === 'break') break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules

var flip$3 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip$2,
  requiresIfExists: ['offset'],
  data: {
    _skip: false,
  },
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0,
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x,
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide$1(_ref) {
  var state = _ref.state,
    name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference',
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true,
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped,
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped,
  });
} // eslint-disable-next-line import/no-unused-modules

var hide$2 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide$1,
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref =
      typeof offset === 'function'
        ? offset(
            Object.assign({}, rects, {
              placement: placement,
            }),
          )
        : offset,
    skidding = _ref[0],
    distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0
    ? {
        x: distance,
        y: skidding,
      }
    : {
        x: skidding,
        y: distance,
      };
}

function offset$1(_ref2) {
  var state = _ref2.state,
    options = _ref2.options,
    name = _ref2.name;
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements$1.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
    x = _data$state$placement.x,
    y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var offset$2 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset$1,
};

function popperOffsets(_ref) {
  var state = _ref.state,
    name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement,
  });
} // eslint-disable-next-line import/no-unused-modules

var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {},
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow$1(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    padding = options.padding,
    _options$tether = options.tether,
    tether = _options$tether === void 0 ? true : _options$tether,
    _options$tetherOffset = options.tetherOffset,
    tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary,
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue =
    typeof tetherOffset === 'function'
      ? tetherOffset(
          Object.assign({}, state.rects, {
            placement: state.placement,
          }),
        )
      : tetherOffset;
  var normalizedTetherOffsetValue =
    typeof tetherOffsetValue === 'number'
      ? {
          mainAxis: tetherOffsetValue,
          altAxis: tetherOffsetValue,
        }
      : Object.assign(
          {
            mainAxis: 0,
            altAxis: 0,
          },
          tetherOffsetValue,
        );
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0,
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect =
      tether && arrowElement
        ? getLayoutRect(arrowElement)
        : {
            width: 0,
            height: 0,
          };
    var arrowPaddingObject = state.modifiersData['arrow#persistent']
      ? state.modifiersData['arrow#persistent'].padding
      : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement
      ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis
      : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement
      ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis
      : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent$1(state.elements.arrow);
    var clientOffset = arrowOffsetParent
      ? mainAxis === 'y'
        ? arrowOffsetParent.clientTop || 0
        : arrowOffsetParent.clientLeft || 0
      : 0;
    var offsetModifierValue =
      (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null
        ? _offsetModifierState$
        : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$3(min, tetherMin) : min, offset, tether ? max$4(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue =
      (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null
        ? _offsetModifierState$2
        : 0;

    var _tetherMin = isOriginSide
      ? _min
      : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide
      ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis
      : _max;

    var _preventedOffset =
      tether && isOriginSide
        ? withinMaxClamp(_tetherMin, _offset, _tetherMax)
        : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var preventOverflow$2 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow$1,
  requiresIfExists: ['offset'],
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop,
  };
}

function getNodeScroll(node) {
  if (node === getWindow$1(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$1(rect.width) / element.offsetWidth || 1;
  var scaleY = round$1(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect$1(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0,
  };
  var offsets = {
    x: 0,
    y: 0,
  };

  if (isOffsetParentAnElement || (!isOffsetParentAnElement && !isFixed)) {
    if (
      getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
      isScrollParent(documentElement)
    ) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect$1(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height,
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(
      orderedModifiers.filter(function (modifier) {
        return modifier.phase === phase;
      }),
    );
  }, []);
}

function debounce$3(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format$2(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    []
      .concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
      .filter(function (value, index, self) {
        return self.indexOf(value) === index;
      })
      .forEach(function (key) {
        switch (key) {
          case 'name':
            if (typeof modifier.name !== 'string') {
              console.error(
                format$2(
                  INVALID_MODIFIER_ERROR,
                  String(modifier.name),
                  '"name"',
                  '"string"',
                  '"' + String(modifier.name) + '"',
                ),
              );
            }

            break;

          case 'enabled':
            if (typeof modifier.enabled !== 'boolean') {
              console.error(
                format$2(
                  INVALID_MODIFIER_ERROR,
                  modifier.name,
                  '"enabled"',
                  '"boolean"',
                  '"' + String(modifier.enabled) + '"',
                ),
              );
            }

            break;

          case 'phase':
            if (modifierPhases.indexOf(modifier.phase) < 0) {
              console.error(
                format$2(
                  INVALID_MODIFIER_ERROR,
                  modifier.name,
                  '"phase"',
                  'either ' + modifierPhases.join(', '),
                  '"' + String(modifier.phase) + '"',
                ),
              );
            }

            break;

          case 'fn':
            if (typeof modifier.fn !== 'function') {
              console.error(
                format$2(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'),
              );
            }

            break;

          case 'effect':
            if (modifier.effect != null && typeof modifier.effect !== 'function') {
              console.error(
                format$2(
                  INVALID_MODIFIER_ERROR,
                  modifier.name,
                  '"effect"',
                  '"function"',
                  '"' + String(modifier.fn) + '"',
                ),
              );
            }

            break;

          case 'requires':
            if (modifier.requires != null && !Array.isArray(modifier.requires)) {
              console.error(
                format$2(
                  INVALID_MODIFIER_ERROR,
                  modifier.name,
                  '"requires"',
                  '"array"',
                  '"' + String(modifier.requires) + '"',
                ),
              );
            }

            break;

          case 'requiresIfExists':
            if (!Array.isArray(modifier.requiresIfExists)) {
              console.error(
                format$2(
                  INVALID_MODIFIER_ERROR,
                  modifier.name,
                  '"requiresIfExists"',
                  '"array"',
                  '"' + String(modifier.requiresIfExists) + '"',
                ),
              );
            }

            break;

          case 'options':
          case 'data':
            break;

          default:
            console.error(
              'PopperJS: an invalid property has been provided to the "' +
                modifier.name +
                '" modifier, valid properties are ' +
                VALID_PROPERTIES.map(function (s) {
                  return '"' + s + '"';
                }).join(', ') +
                '; but "' +
                key +
                '" was provided.',
            );
        }

        modifier.requires &&
          modifier.requires.forEach(function (requirement) {
            if (
              modifiers.find(function (mod) {
                return mod.name === requirement;
              }) == null
            ) {
              console.error(format$2(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
            }
          });
      });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing
      ? Object.assign({}, existing, current, {
          options: Object.assign({}, existing.options, current.options),
          data: Object.assign({}, existing.data, current.data),
        })
      : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR =
  'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR =
  'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute',
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
    _generatorOptions$def = _generatorOptions.defaultModifiers,
    defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
    _generatorOptions$def2 = _generatorOptions.defaultOptions,
    defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper,
      },
      attributes: {},
      styles: {},
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference)
            ? listScrollParents(reference)
            : reference.contextElement
            ? listScrollParents(reference.contextElement)
            : [],
          popper: listScrollParents(popper),
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== 'production') {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(
                ['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '),
              );
            }
          }

          var _getComputedStyle = getComputedStyle$1(popper),
            marginTop = _getComputedStyle.marginTop,
            marginRight = _getComputedStyle.marginRight,
            marginBottom = _getComputedStyle.marginBottom,
            marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer

          if (
            [marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
              return parseFloat(margin);
            })
          ) {
            console.warn(
              [
                'Popper: CSS "margin" styles cannot be used to apply padding',
                'between the popper and its reference element or boundary.',
                'To replicate margin, use the `offset` modifier, as well as',
                'the `padding` option in the `preventOverflow` and `flip`',
                'modifiers.',
              ].join(' '),
            );
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers

        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent$1(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper),
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return (state.modifiersData[modifier.name] = Object.assign({}, modifier.data));
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== 'production') {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
            fn = _state$orderedModifie.fn,
            _state$orderedModifie2 = _state$orderedModifie.options,
            _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
            name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state =
              fn({
                state: state,
                options: _options,
                name: name,
                instance: instance,
              }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$3(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      },
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
          _ref3$options = _ref3.options,
          options = _ref3$options === void 0 ? {} : _ref3$options,
          effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options,
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [
  eventListeners,
  popperOffsets$1,
  computeStyles$1,
  applyStyles$1,
  offset$2,
  flip$3,
  preventOverflow$2,
  arrow$2,
  hide$2,
];
var createPopper = /*#__PURE__*/ popperGenerator({
  defaultModifiers: defaultModifiers,
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0; ) if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0; ) if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function')
      return a.valueOf() === b.valueOf();
    if (
      a.toString !== Object.prototype.toString &&
      typeof a.toString === 'function' &&
      typeof b.toString === 'function'
    )
      return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0; ) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var isEqual$3 = /*@__PURE__*/ getDefaultExportFromCjs(reactFastCompare);

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React__namespace.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS,
  };

  var _React$useState = React__namespace.useState({
      styles: {
        popper: {
          position: optionsWithDefaults.strategy,
          left: '0',
          top: '0',
        },
        arrow: {
          position: 'absolute',
        },
      },
      attributes: {},
    }),
    state = _React$useState[0],
    setState = _React$useState[1];

  var updateStateModifier = React__namespace.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM__namespace.flushSync(function () {
          setState({
            styles: fromEntries(
              elements.map(function (element) {
                return [element, state.styles[element] || {}];
              }),
            ),
            attributes: fromEntries(
              elements.map(function (element) {
                return [element, state.attributes[element]];
              }),
            ),
          });
        });
      },
      requires: ['computeStyles'],
    };
  }, []);
  var popperOptions = React__namespace.useMemo(
    function () {
      var newOptions = {
        onFirstUpdate: optionsWithDefaults.onFirstUpdate,
        placement: optionsWithDefaults.placement,
        strategy: optionsWithDefaults.strategy,
        modifiers: [].concat(optionsWithDefaults.modifiers, [
          updateStateModifier,
          {
            name: 'applyStyles',
            enabled: false,
          },
        ]),
      };

      if (isEqual$3(prevOptions.current, newOptions)) {
        return prevOptions.current || newOptions;
      } else {
        prevOptions.current = newOptions;
        return newOptions;
      }
    },
    [
      optionsWithDefaults.onFirstUpdate,
      optionsWithDefaults.placement,
      optionsWithDefaults.strategy,
      optionsWithDefaults.modifiers,
      updateStateModifier,
    ],
  );
  var popperInstanceRef = React__namespace.useRef();
  useIsomorphicLayoutEffect(
    function () {
      if (popperInstanceRef.current) {
        popperInstanceRef.current.setOptions(popperOptions);
      }
    },
    [popperOptions],
  );
  useIsomorphicLayoutEffect(
    function () {
      if (referenceElement == null || popperElement == null) {
        return;
      }

      var createPopper$1 = options.createPopper || createPopper;
      var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
      popperInstanceRef.current = popperInstance;
      return function () {
        popperInstance.destroy();
        popperInstanceRef.current = null;
      };
    },
    [referenceElement, popperElement, options.createPopper],
  );
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null,
  };
};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function () {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message =
      'Warning: ' +
      format.replace(/%s/g, function () {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function (condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

var warning$1 = /*@__PURE__*/ getDefaultExportFromCjs(warning_1);

// Referenced from https://usehooks.com/useOnClickOutside/
var useOutsideClick = function (ref, handler) {
  React.useEffect(
    function () {
      if (typeof window !== 'undefined') {
        var listener_1 = function (e) {
          // Do nothing if clicking ref's element or descendent elements
          if (!ref || ref.contains(e.target)) {
            return;
          }
          handler(e);
        };
        var keyboardListener_1 = function (e) {
          if (e.key === 'Escape') {
            handler(e);
          }
        };
        document.addEventListener('click', listener_1);
        document.addEventListener('touchstart', listener_1);
        document.addEventListener('keydown', keyboardListener_1);
        return function () {
          document.removeEventListener('click', listener_1);
          document.removeEventListener('touchstart', listener_1);
          document.removeEventListener('keydown', keyboardListener_1);
        };
      }
    },
    [ref, handler],
  );
};

var style$J = { Tooltip: 'htco-Tooltip', TooltipArrow: 'htco-TooltipArrow' };

var HOVER_IN = 'hover-in-click-out';
var HOVER = 'hover';
var CLICK = 'click';
var CONTROLLED = 'controlled';
var NONE = 'none';
var TooltipPositionValues = [
  'bottom-end',
  'bottom-start',
  'bottom',
  'left-end',
  'left-start',
  'left',
  'right-end',
  'right-start',
  'right',
  'top-end',
  'top-start',
  'top',
];
var TooltipActionValues = [HOVER_IN, HOVER, CLICK, CONTROLLED, NONE];
var Tooltip$1 = function (_a) {
  var className = _a.className,
    tooltipContentClassName = _a.tooltipContentClassName,
    content = _a.content,
    width = _a.width,
    _b = _a.action,
    action = _b === void 0 ? 'hover' : _b,
    visible = _a.visible,
    children = _a.children,
    _c = _a.position,
    position = _c === void 0 ? 'bottom' : _c,
    target = _a.target,
    isClickableLink = _a.isClickableLink;
  // These are refs, but react-popper wants them set as state functions
  var _d = React.useState(null),
    trigger = _d[0],
    setTrigger = _d[1];
  var _e = React.useState(null),
    tooltip = _e[0],
    setTooltip = _e[1];
  var _f = React.useState(null),
    arrow = _f[0],
    setArrow = _f[1];
  var _g = React.useState(false),
    show = _g[0],
    setShow = _g[1];
  var _h = React.useState(false),
    touched = _h[0],
    setTouched = _h[1]; // For mobile support
  var wrapper = React.useRef(null);
  useOutsideClick(wrapper.current, function () {
    if (action !== CONTROLLED) {
      setShow(false);
    }
  });
  React.useEffect(
    function () {
      if (visible !== undefined && action === CONTROLLED) {
        setShow(visible);
      }
    },
    [visible],
  );
  var _j = usePopper(trigger, tooltip, {
      placement: position,
      modifiers: [
        { name: 'arrow', options: { element: arrow } },
        {
          name: 'offset',
          options: {
            offset: [0, 14],
          },
        },
      ],
    }),
    styles = _j.styles,
    attributes = _j.attributes;
  var tooltipContent = jsxRuntime.jsxs(
    'div',
    __assign(
      {
        className: cx(style$J.Tooltip, tooltipContentClassName),
        ref: setTooltip,
        role: 'tooltip',
        style: __assign(__assign({}, styles.popper), { maxWidth: width }),
      },
      attributes.popper,
      {
        children: [
          jsxRuntime.jsx('div', { className: style$J.TooltipArrow, ref: setArrow, style: styles.arrow }),
          content,
        ],
      },
    ),
  );
  var renderTooltip = function () {
    if (target) {
      if (typeof window !== 'undefined') {
        var targetEl = window.document.querySelector(target);
        if (targetEl) {
          return ReactDOM.createPortal(tooltipContent, targetEl);
        }
      }
    } else {
      return tooltipContent;
    }
  };
  return jsxRuntime.jsxs('span', {
    ref: wrapper,
    className: className,
    children: [
      jsxRuntime.jsx('span', {
        ref: setTrigger,
        tabIndex: 0,
        role: 'button',
        'aria-label': typeof content === 'string' ? content : '',
        onTouchStart: function () {
          if (action !== CONTROLLED) {
            setTouched(true);
            setShow(!show);
          }
        },
        onFocus: function () {
          return null;
        },
        onBlur: function () {
          if (action !== CONTROLLED) {
            setShow(false);
          }
        },
        onMouseOver: function () {
          if (!touched) {
            if (action === HOVER || action === HOVER_IN) {
              setShow(true);
            }
          }
        },
        onMouseLeave: function () {
          if (action === HOVER) {
            setShow(false);
          }
        },
        onClick: function (e) {
          if (!isClickableLink) {
            e.preventDefault();
          }
          if (!touched) {
            if (action === CLICK && !isClickableLink) {
              setShow(!show);
            } else if (action === HOVER_IN && show) {
              setShow(false);
            }
          }
        },
        onKeyDown: function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            setShow(!show);
          }
        },
        children: children,
      }),
      show && renderTooltip(),
    ],
  });
};

var Helptip = function (_a) {
  var title = _a.title,
    text = _a.text,
    iconSize = _a.iconSize,
    _b = _a.iconColor,
    iconColor = _b === void 0 ? '#697891' : _b,
    props = __rest$1(_a, ['title', 'text', 'iconSize', 'iconColor']);
  var helptipContent = jsxRuntime.jsxs('div', {
    children: [title && jsxRuntime.jsx('b', { children: title }), jsxRuntime.jsx('div', { children: text })],
  });
  return jsxRuntime.jsx(
    Tooltip$1,
    __assign({ content: helptipContent, position: 'bottom-start' }, props, {
      children: jsxRuntime.jsx(Icon, {
        name: 'question-circle',
        size: iconSize,
        color: iconColor,
        style: {
          width: 35,
          display: 'inline-block',
          textAlign: 'center',
          cursor: 'pointer',
          fontSize: !iconSize ? 20 : undefined,
        },
      }),
    }),
  );
};
Helptip.propTypes = {
  title: PropTypes__default['default'].node,
  text: PropTypes__default['default'].node,
  iconSize: PropTypes__default['default'].string,
  iconColor: PropTypes__default['default'].string,
};

var LabelWithHelp = function (_a) {
  var className = _a.className,
    label = _a.label,
    helpTitle = _a.helpTitle,
    helpText = _a.helpText,
    _b = _a.helpPosition,
    helpPosition = _b === void 0 ? 'bottom-start' : _b;
  return jsxRuntime.jsxs('span', {
    className: className,
    children: [label, jsxRuntime.jsx(Helptip, { title: helpTitle, text: helpText, position: helpPosition })],
  });
};
LabelWithHelp.propTypes = {
  label: PropTypes__default['default'].node,
  helpTitle: PropTypes__default['default'].node,
  helpText: PropTypes__default['default'].node,
};

var LabelWithAsterisk = function (_a) {
  var label = _a.label,
    className = _a.className;
  return jsxRuntime.jsx('span', { className: cx(style$Q.LabelWithAsterisk, className), children: label });
};

var LabelWithAsteriskAndHelp = function (_a) {
  var className = _a.className,
    label = _a.label,
    helpTitle = _a.helpTitle,
    helpText = _a.helpText,
    _b = _a.helpPosition,
    helpPosition = _b === void 0 ? 'bottom-start' : _b;
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      jsxRuntime.jsx('span', { className: cx(style$Q.LabelWithAsteriskAndHelp, className), children: label }),
      jsxRuntime.jsx(Helptip, { title: helpTitle, text: helpText, position: helpPosition }),
    ],
  });
};
LabelWithAsteriskAndHelp.propTypes = {
  label: PropTypes__default['default'].node,
  helpTitle: PropTypes__default['default'].node,
  helpText: PropTypes__default['default'].node,
};

var style$I = {
  Checkbox: 'htco-Checkbox',
  isDisabled: 'htco-isDisabled',
  CheckboxInput: 'htco-CheckboxInput',
  CheckboxCustom: 'htco-CheckboxCustom',
  CheckboxDisplayLabel: 'htco-CheckboxDisplayLabel',
  CheckboxSet: 'htco-CheckboxSet',
  isInline: 'htco-isInline',
  withHelp: 'htco-withHelp',
  CheckboxSetLabel: 'htco-CheckboxSetLabel',
  CheckboxSetItem: 'htco-CheckboxSetItem',
  isChecked: 'htco-isChecked',
  CheckboxSetLabelText: 'htco-CheckboxSetLabelText',
};

var Checkbox = function (_a) {
  var _b;
  var _c;
  var label = _a.label,
    name = _a.name,
    value = _a.value,
    _d = _a.checked,
    checked = _d === void 0 ? false : _d,
    _e = _a.disabled,
    disabled = _e === void 0 ? false : _e,
    _f = _a.required,
    required = _f === void 0 ? false : _f,
    error = _a.error,
    className = _a.className,
    onChange = _a.onChange,
    props = __rest$1(_a, [
      'label',
      'name',
      'value',
      'checked',
      'disabled',
      'required',
      'error',
      'className',
      'onChange',
    ]);
  useRequiredValidation(__assign({ name: name, required: required }, props));
  var id = ''.concat(name, '-').concat(value);
  var handleChange = function () {
    onChange(!checked, name, value);
  };
  var ariaLabel =
    (_c = props['aria-label']) !== null && _c !== void 0 ? _c : typeof label === 'string' ? label : undefined;
  return jsxRuntime.jsxs('label', {
    className: cx(
      style$I.Checkbox,
      className,
      ((_b = {}), (_b[style$I.isDisabled] = disabled), (_b[style$I.isChecked] = checked), _b),
    ),
    style: props.style,
    htmlFor: id,
    children: [
      jsxRuntime.jsx('input', {
        className: style$I.CheckboxInput,
        type: 'checkbox',
        name: name,
        id: id,
        value: value,
        checked: checked,
        disabled: disabled,
        onChange: handleChange,
      }),
      jsxRuntime.jsx('span', {
        tabIndex: 0,
        role: 'checkbox',
        'aria-checked': checked,
        'aria-label': ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : value,
        className: style$I.CheckboxCustom,
        onKeyDown: function (e) {
          if (!disabled) {
            handleKeyboardEnter(handleChange)(e);
          }
        },
      }),
      jsxRuntime.jsxs('span', {
        className: style$I.CheckboxDisplayLabel,
        children: [
          label !== null && label !== void 0 ? label : value,
          jsxRuntime.jsx('div', { children: jsxRuntime.jsx(FormError, { error: error }) }),
        ],
      }),
    ],
  });
};

var CheckboxSet = function (_a) {
  var _b = _a.value,
    value = _b === void 0 ? [] : _b,
    label = _a.label,
    _c = _a.inline,
    inline = _c === void 0 ? false : _c,
    _d = _a.required,
    required = _d === void 0 ? false : _d,
    _e = _a.disabled,
    disabled = _e === void 0 ? false : _e,
    name = _a.name,
    error = _a.error,
    _f = _a.options,
    options = _f === void 0 ? [] : _f,
    onChange = _a.onChange,
    className = _a.className,
    props = __rest$1(_a, [
      'value',
      'label',
      'inline',
      'required',
      'disabled',
      'name',
      'error',
      'options',
      'onChange',
      'className',
    ]);
  useRequiredValidation(__assign({ name: name, required: required }, props));
  // @ts-expect-error TS(7006): Parameter 'opt' implicitly has an 'any' type.
  var withHelp = !!options.find(function (opt) {
    return opt.helptip;
  });
  return jsxRuntime.jsxs('span', {
    className: cx(style$I.CheckboxSet, inline && style$I.isInline, className),
    children: [
      jsxRuntime.jsx(Label$1, { error: error, className: style$I.CheckboxSetLabel, children: label }),
      options.map(function (option) {
        var _a;
        var isChecked = value.indexOf(option.value) !== -1;
        return React.createElement(
          Checkbox,
          __assign({}, option, {
            key: option.value,
            name: name,
            className: cx(style$I.CheckboxSetItem, ((_a = {}), (_a[style$I.withHelp] = withHelp), _a)),
            checked: isChecked,
            disabled: option.disabled || disabled,
            label: jsxRuntime.jsxs(jsxRuntime.Fragment, {
              children: [
                jsxRuntime.jsx('span', {
                  className: style$I.CheckboxSetLabelText,
                  children: option.label || option.value,
                }),
                option.helptip &&
                  jsxRuntime.jsx('span', {
                    className: style$I.CheckboxSetIcon,
                    children: jsxRuntime.jsx(Helptip, __assign({}, option.helptip)),
                  }),
              ],
            }),
            onChange: function (checkedState) {
              var newValue;
              if (checkedState) {
                newValue = value.concat([option.value]);
              } else {
                // @ts-expect-error TS(7006): Parameter 'val' implicitly has an 'any' type.
                newValue = value.filter(function (val) {
                  return val !== option.value;
                });
              }
              onChange(newValue, name);
            },
          }),
        );
      }),
    ],
  });
};
CheckboxSet.propTypes = {
  label: PropTypes__default['default'].node,
  name: PropTypes__default['default'].string,
  value: PropTypes__default['default'].array,
  options: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      label: PropTypes__default['default'].node.isRequired,
      value: PropTypes__default['default'].string.isRequired,
      helptip: PropTypes__default['default'].object,
    }),
  ).isRequired,
  disabled: PropTypes__default['default'].bool,
  required: PropTypes__default['default'].bool,
  onChange: PropTypes__default['default'].func.isRequired,
  registerRequiredField: PropTypes__default['default'].func,
  unregisterRequiredField: PropTypes__default['default'].func,
};

var style$H = {
  DetailBox: 'htco-DetailBox',
  isMedium: 'htco-isMedium',
  isBright: 'htco-isBright',
  DetailBoxIcon: 'htco-DetailBoxIcon',
  DetailBoxContent: 'htco-DetailBoxContent',
};

var DetailBox = function (_a) {
  var _b;
  var icon = _a.icon,
    emphasis = _a.emphasis,
    text = _a.text,
    className = _a.className,
    _c = _a.theme,
    theme = _c === void 0 ? 'medium' : _c;
  return jsxRuntime.jsxs('div', {
    className: cx(
      style$H.DetailBox,
      className,
      ((_b = {}), (_b[style$H.isMedium] = theme === 'medium'), (_b[style$H.isBright] = theme === 'bright'), _b),
    ),
    children: [
      icon && jsxRuntime.jsx(Icon, { className: cx(style$H.DetailBoxIcon), name: icon, pullLeft: true }),
      jsxRuntime.jsxs('div', {
        className: style$H.DetailBoxContent,
        children: [emphasis && jsxRuntime.jsx('b', { children: ''.concat(emphasis, ' ') }), text],
      }),
    ],
  });
};
DetailBox.propTypes = {
  icon: PropTypes__default['default'].string,
  emphasis: PropTypes__default['default'].node,
  text: PropTypes__default['default'].node,
  theme: PropTypes__default['default'].oneOf(['bright', 'medium']),
};

var style$G = {
  Loader: 'htco-Loader',
  isLoaderPulse: 'htco-isLoaderPulse',
  isSmall: 'htco-isSmall',
  isLarge: 'htco-isLarge',
  LoaderOverlay: 'htco-LoaderOverlay',
  LoaderSpinner: 'htco-LoaderSpinner',
  loader: 'htco-loader',
  isXs: 'htco-isXs',
  isSecondary: 'htco-isSecondary',
  isInverse: 'htco-isInverse',
  LoaderPulse: 'htco-LoaderPulse',
  'dot-pulse-primary': 'htco-dot-pulse-primary',
  'dot-pulse-secondary': 'htco-dot-pulse-secondary',
  'dot-pulse-inverse': 'htco-dot-pulse-inverse',
  'dot-pulse-small-primary': 'htco-dot-pulse-small-primary',
  'dot-pulse-small-secondary': 'htco-dot-pulse-small-secondary',
  'dot-pulse-small-inverse': 'htco-dot-pulse-small-inverse',
  'dot-pulse-large-primary': 'htco-dot-pulse-large-primary',
  'dot-pulse-large-secondary': 'htco-dot-pulse-large-secondary',
  'dot-pulse-large-inverse': 'htco-dot-pulse-large-inverse',
};

var Loader = function (_a) {
  var _b, _c;
  var className = _a.className,
    _d = _a.size,
    size = _d === void 0 ? 'normal' : _d,
    _e = _a.theme,
    theme = _e === void 0 ? 'primary' : _e,
    _f = _a.type,
    type = _f === void 0 ? 'spinner' : _f,
    _g = _a.overlay,
    overlay = _g === void 0 ? false : _g;
  var variants =
    ((_b = {}),
    (_b[style$G.isXs] = size === 'xs'),
    (_b[style$G.isSmall] = size === 'small'),
    (_b[style$G.isLarge] = size === 'large'),
    (_b[style$G.isSecondary] = theme === 'secondary'),
    (_b[style$G.isInverse] = theme === 'inverse'),
    _b);
  var containerStyles = cx(
    style$G.Loader,
    className,
    variants,
    ((_c = {}), (_c[style$G.isLoaderPulse] = type === 'dot-pulse'), _c),
  );
  var themeClass = type === 'spinner' ? style$G.LoaderSpinner : style$G.LoaderPulse;
  var themeStyles = cx(themeClass, variants);
  return jsxRuntime.jsx('span', {
    className: overlay ? style$G.LoaderOverlay : '',
    children: jsxRuntime.jsx('span', {
      className: containerStyles,
      children: jsxRuntime.jsx('span', { className: themeStyles }),
    }),
  });
};
Loader.propTypes = {
  size: PropTypes__default['default'].oneOf(['normal', 'small', 'large', 'xs']),
  type: PropTypes__default['default'].oneOf(['spinner', 'dot-pulse']),
  theme: PropTypes__default['default'].oneOf(['primary', 'secondary', 'inverse']),
  overlay: PropTypes__default['default'].bool,
};

var style$F = {
  Button: 'htco-Button',
  noFocusRing: 'htco-noFocusRing',
  isDisabled: 'htco-isDisabled',
  isPrimary: 'htco-isPrimary',
  isSecondary: 'htco-isSecondary',
  isLoading: 'htco-isLoading',
  isTextButton: 'htco-isTextButton',
  isLink: 'htco-isLink',
  isLinkAlt: 'htco-isLinkAlt',
  isAlternative: 'htco-isAlternative',
  isDanger: 'htco-isDanger',
  isSecondaryDanger: 'htco-isSecondaryDanger',
  isLarge: 'htco-isLarge',
  hasIcon: 'htco-hasIcon',
  isSmall: 'htco-isSmall',
  ButtonLoader: 'htco-ButtonLoader',
};

var Button = function (_a) {
  var _b;
  var _c = _a.type,
    type = _c === void 0 ? 'button' : _c,
    _d = _a.theme,
    theme = _d === void 0 ? 'primary' : _d,
    _e = _a.size,
    size = _e === void 0 ? 'normal' : _e,
    _f = _a.width,
    width = _f === void 0 ? undefined : _f,
    _g = _a.disabled,
    disabled = _g === void 0 ? false : _g,
    _h = _a.loading,
    loading = _h === void 0 ? false : _h,
    _j = _a.reverseLinkIcon,
    reverseLinkIcon = _j === void 0 ? false : _j,
    href = _a.href,
    icon = _a.icon,
    label = _a.label,
    onClick = _a.onClick,
    className = _a.className,
    children = _a.children,
    props = __rest$1(_a, [
      'type',
      'theme',
      'size',
      'width',
      'disabled',
      'loading',
      'reverseLinkIcon',
      'href',
      'icon',
      'label',
      'onClick',
      'className',
      'children',
    ]);
  var _k = React.useState(false),
    mouseFocused = _k[0],
    setMouseFocused = _k[1];
  var classes = cx(
    style$F.Button,
    className,
    ((_b = {}),
    (_b[style$F.isPrimary] = theme === 'primary'),
    (_b[style$F.isSecondary] = theme === 'secondary'),
    (_b[style$F.isAlternative] = theme === 'alternative'),
    (_b[style$F.isLink] = theme === 'link'),
    (_b[style$F.isLinkAlt] = theme === 'link-alt'),
    (_b[style$F.isTextButton] = theme === 'text'),
    (_b[style$F.isDanger] = theme === 'danger'),
    (_b[style$F.isSecondaryDanger] = theme === 'secondary-danger'),
    (_b[style$F.isSmall] = size === 'small'),
    (_b[style$F.isLarge] = size === 'large'),
    (_b[style$F.isLoading] = !!loading),
    (_b[style$F.hasIcon] = icon),
    (_b[style$F.noFocusRing] = mouseFocused),
    (_b[style$F.isDisabled] = disabled || loading),
    _b),
  );
  var loader = jsxRuntime.jsx(Loader, {
    className: style$F.ButtonLoader,
    theme: ['link', 'text'].includes(theme) ? 'primary' : 'inverse',
    size: size === 'small' ? 'xs' : 'small',
  });
  var isDisabled = disabled || loading;
  var getIconSize = function () {
    switch (theme) {
      case 'link':
      case 'link-alt':
      case 'text':
        return 'sm';
      default:
        return 'lg';
    }
  };
  return href
    ? jsxRuntime.jsxs(
        'a',
        __assign({}, props, {
          href: href,
          className: classes,
          onClick: onClick,
          style: { width: width },
          children: [
            loading && loader,
            reverseLinkIcon
              ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
                  children: [
                    label !== null && label !== void 0 ? label : children,
                    '\u00A0',
                    icon && jsxRuntime.jsx(Icon, { name: icon }),
                  ],
                })
              : jsxRuntime.jsxs(jsxRuntime.Fragment, {
                  children: [
                    icon && jsxRuntime.jsx(Icon, { name: icon }),
                    label !== null && label !== void 0 ? label : children,
                  ],
                }),
          ],
        }),
      )
    : jsxRuntime.jsxs(
        'button',
        __assign({}, props, {
          type: type,
          className: classes,
          style: { width: width },
          disabled: isDisabled,
          onClick: onClick,
          onMouseDown: function () {
            return setMouseFocused(true);
          },
          onBlur: function () {
            return setMouseFocused(false);
          },
          children: [
            loading && loader,
            label !== null && label !== void 0 ? label : children,
            icon && jsxRuntime.jsx('span', { children: jsxRuntime.jsx(Icon, { name: icon, size: getIconSize() }) }),
          ],
        }),
      );
};

var style$E = {
  ContentHero: 'htco-ContentHero',
  imgLeft: 'htco-imgLeft',
  ContentHeroTitle: 'htco-ContentHeroTitle',
  ContentHeroCopyBlock: 'htco-ContentHeroCopyBlock',
  ContentHeroImgBlock: 'htco-ContentHeroImgBlock',
  isGatsbyImage: 'htco-isGatsbyImage',
  ContentHeroPrimaryImg: 'htco-ContentHeroPrimaryImg',
  CTAButton: 'htco-CTAButton',
  CTALink: 'htco-CTALink',
};

var ContentHero = function (_a) {
  var _b;
  var title = _a.title,
    image = _a.image,
    buttonLabel = _a.buttonLabel,
    buttonLink = _a.buttonLink,
    buttonOnClick = _a.buttonOnClick,
    _c = _a.imagePosition,
    imagePosition = _c === void 0 ? 'right' : _c,
    linkLabel = _a.linkLabel,
    linkDestination = _a.linkDestination,
    gatsbyImage = _a.gatsbyImage,
    props = __rest$1(_a, [
      'title',
      'image',
      'buttonLabel',
      'buttonLink',
      'buttonOnClick',
      'imagePosition',
      'linkLabel',
      'linkDestination',
      'gatsbyImage',
    ]);
  return jsxRuntime.jsxs('div', {
    className: cx(style$E.ContentHero, ((_b = {}), (_b[style$E.imgLeft] = imagePosition === 'left'), _b)),
    children: [
      jsxRuntime.jsxs('div', {
        className: style$E.ContentHeroCopyBlock,
        children: [
          jsxRuntime.jsxs('h1', { className: style$E.ContentHeroTitle, children: [' ', title] }),
          jsxRuntime.jsx('div', { className: style$E.ContentHeroText, children: props.children }),
          buttonLabel &&
            jsxRuntime.jsx(Button, {
              className: cx(style$E.CTAButton),
              label: buttonLabel,
              theme: 'primary',
              disabled: false,
              href: buttonLink,
              onClick: buttonOnClick,
            }),
          linkLabel &&
            jsxRuntime.jsx(Button, {
              className: cx(style$E.CTAButton, style$E.CTALink),
              theme: 'link',
              href: linkDestination,
              title: 'CTA link.',
              children: linkLabel,
            }),
        ],
      }),
      jsxRuntime.jsx('div', {
        className: cx(gatsbyImage && style$E.isGatsbyImage, style$E.ContentHeroImgBlock),
        children: gatsbyImage
          ? gatsbyImage
          : jsxRuntime.jsx('img', { src: image, alt: '', className: style$E.ContentHeroPrimaryImg }),
      }),
    ],
  });
};
ContentHero.propTypes = {
  title: PropTypes__default['default'].node.isRequired,
  image: PropTypes__default['default'].string,
  buttonLabel: PropTypes__default['default'].string,
  linkLabel: PropTypes__default['default'].string,
  buttonLink: PropTypes__default['default'].node,
  linkDestination: PropTypes__default['default'].node,
  imagePosition: PropTypes__default['default'].oneOf(['right', 'left']),
  gatsbyImage: PropTypes__default['default'].node,
};

var style$D = {
  IconButton: 'htco-IconButton',
  isPrimary: 'htco-isPrimary',
  isSolid: 'htco-isSolid',
  hasTitle: 'htco-hasTitle',
  noFocusRing: 'htco-noFocusRing',
};

var IconButton = function (_a) {
  var _b;
  var _c = _a.theme,
    theme = _c === void 0 ? 'plain' : _c,
    _d = _a.disabled,
    disabled = _d === void 0 ? false : _d,
    label = _a.label,
    icon = _a.icon,
    size = _a.size,
    onClick = _a.onClick,
    className = _a.className,
    props = __rest$1(_a, ['theme', 'disabled', 'label', 'icon', 'size', 'onClick', 'className']);
  var _e = React.useState(false),
    mouseFocused = _e[0],
    setMouseFocused = _e[1];
  var classes = cx(
    style$D.IconButton,
    className,
    ((_b = {}),
    (_b[style$D.isPrimary] = theme === 'primary'),
    (_b[style$D.isSolid] = theme === 'solid'),
    (_b[style$D.noFocusRing] = mouseFocused),
    (_b[style$D.hasTitle] = !!label),
    _b),
  );
  return jsxRuntime.jsx(
    'button',
    __assign(
      {
        className: classes,
        disabled: disabled,
        title: label,
        onClick: onClick,
        onMouseDown: function () {
          return setMouseFocused(true);
        },
        onBlur: function () {
          return setMouseFocused(false);
        },
      },
      props,
      { children: jsxRuntime.jsx(Icon, { name: icon, size: size }) },
    ),
  );
};
IconButton.propTypes = {
  theme: PropTypes__default['default'].oneOf(['plain', 'primary', 'solid']),
  label: PropTypes__default['default'].string,
  icon: PropTypes__default['default'].string,
  size: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  onClick: PropTypes__default['default'].func,
};

var hasWindow = function () {
  return typeof window !== 'undefined';
};
var getDocument = function () {
  return hasWindow() ? document : null;
};
var getBody = function () {
  return hasWindow() ? document.body : null;
};
var getBodyClasses = function () {
  return hasWindow() ? document.body.classList : null;
};
var windowUtils = {
  hasWindow: hasWindow,
  getDocument: getDocument,
  getBody: getBody,
  getBodyClasses: getBodyClasses,
};

var utils = __assign(__assign({}, windowUtils), { handleKeyboardClick: handleKeyboardClick });

var getScrollPosition = function (element) {
  if (element && element.current instanceof HTMLElement) {
    var target = element ? element.current : document.body;
    var position = target.getBoundingClientRect();
    return { x: position.left, y: position.top };
  }
  return utils.hasWindow() ? { x: window.scrollX, y: window.scrollY } : null;
};
var useScroll = function (effect, deps, wait, element) {
  if (deps === void 0) {
    deps = [];
  }
  var position = React.useRef(getScrollPosition());
  var throttleTimeout = null;
  var callBack = function () {
    var current = getScrollPosition(element);
    effect({ previous: position.current, current: current });
    position.current = current;
    throttleTimeout = null;
  };
  React.useLayoutEffect(function () {
    var handleScroll = function () {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = setTimeout(callBack, wait);
        }
      } else {
        callBack();
      }
    };
    if (utils.hasWindow()) {
      window.addEventListener('scroll', handleScroll);
    }
    return function () {
      if (utils.hasWindow()) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, deps);
};

/*
  useWin hook: effect will be called only from browser (never server), and only when window is ready.
  This was created to alleviate a known issue where Gatsby doesn't know to re-hydrate components with dependencies on window or document.
*/
var useWin = function (effect, deps) {
  if (effect === void 0) {
    effect = function () {
      return function () {
        return null;
      };
    };
  }
  if (deps === void 0) {
    deps = [];
  }
  var _a = React.useState(null),
    win = _a[0],
    setWin = _a[1];
  React.useEffect(
    function () {
      if (utils.hasWindow() && win === null) {
        // @ts-expect-error TS(2345): Argument of type 'Window & typeof globalThis' is n... Remove this comment to see the full error message
        setWin(window);
      }
      return function () {
        if (win !== null) setWin(null);
      };
    },
    [win, setWin],
  );
  React.useEffect(
    function () {
      if (win !== null) effect();
    },
    __spreadArray([win], deps, true),
  );
  return win;
};

var style$C = {
  Banner: 'htco-Banner',
  BannerContent: 'htco-BannerContent',
  FixedBanner: 'htco-FixedBanner',
  isFixed: 'htco-isFixed',
  shouldHide: 'htco-shouldHide',
  hasScrolled: 'htco-hasScrolled',
  FixedBannerSpacer: 'htco-FixedBannerSpacer',
  FixedBannerBody: 'htco-FixedBannerBody',
};

/**
 * A simple banner that just goes in an element and doesn't do much.
 * Eventually we may want to add some props to handle icons, a couple of style options, etc.!
 */
var Banner = React.forwardRef(function (_a, ref) {
  var className = _a.className,
    style = _a.style,
    children = _a.children;
  return (
    // @ts-expect-error TS(2322): Type 'ForwardedRef<unknown>' is not assignable to ... Remove this comment to see the full error message
    jsxRuntime.jsx('section', {
      ref: ref,
      style: style,
      className: cx(style$C.Banner, className),
      children: jsxRuntime.jsx('div', { className: style$C.BannerContent, children: children }),
    })
  );
});
Banner.displayName = 'Banner';

/**
 * A banner that's fixed to the top of the browser window. Can close on scroll, be set to reappear when scrolled back up, and includes optional spacing options.
 * If you place the component in an element that needs extra space to leave room for the banner, use the `localSpacer` prop to create an element with the same height as the banner to compensate.
 * `hideOnScroll` will hide the banner when scrollY isn't zero (once the user has scrolled down). It'll come back if the user scrolls back up to the top, but you can use `removeOnScroll` instead to only show it once.
 */
var FixedBanner = function (_a) {
  var _b;
  var _c = _a.fixed,
    fixed = _c === void 0 ? true : _c,
    _d = _a.localSpacer,
    localSpacer = _d === void 0 ? true : _d,
    _e = _a.hideOnScroll,
    hideOnScroll = _e === void 0 ? false : _e,
    _f = _a.removeOnScroll,
    removeOnScroll = _f === void 0 ? false : _f,
    _g = _a.hideBanner,
    hideBanner = _g === void 0 ? false : _g,
    className = _a.className,
    children = _a.children;
  var bannerRef = React.useRef(null);
  var _h = React.useState(),
    bannerHeight = _h[0],
    setBannerHeight = _h[1];
  var _j = React.useState(false),
    scrolled = _j[0],
    setScrolled = _j[1];
  var bodyClasses = utils.getBodyClasses();
  // @ts-expect-error TS(2339): Property 'getBoundingClientRect' does not exist on... Remove this comment to see the full error message
  var getRefHeight = function () {
    return bannerRef.current ? bannerRef.current.getBoundingClientRect().height : null;
  };
  var setBodyStyle = function (height) {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    bodyClasses.add(style$C.FixedBannerBody);
    if (removeOnScroll || hideOnScroll) {
      if (height) {
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        utils.getBody().style.marginTop = ''.concat(height, 'px');
      } else {
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        utils.getBody().style.marginTop = null;
      }
    }
    return null;
  };
  var handleScroll = function (scroll) {
    if (scroll.current.y === 0) {
      if (scrolled) {
        if (removeOnScroll) {
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
          setBodyStyle();
        } else {
          setScrolled(false);
          setBodyStyle(bannerHeight);
        }
      }
    } else if (!scrolled) {
      setScrolled(true);
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      setBodyStyle();
    }
  };
  var isClient = useWin(
    function () {
      setBannerHeight(getRefHeight());
      setBodyStyle(bannerHeight);
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      return function () {
        return setBodyStyle();
      };
      // @ts-expect-error TS(2322): Type 'undefined' is not assignable to type 'never'... Remove this comment to see the full error message
    },
    [bannerHeight],
  );
  useScroll(handleScroll, [scrolled], 10);
  // @ts-expect-error TS(2345): Argument of type '() => () => null' is not assigna... Remove this comment to see the full error message
  React.useLayoutEffect(
    function () {
      setBannerHeight(getRefHeight());
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      return function () {
        return (utils.getBody().style.marginTop = null);
      };
    },
    [bannerRef.current],
  );
  var spacerHeight = { height: bannerHeight };
  if (scrolled) {
    // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'undefined... Remove this comment to see the full error message
    spacerHeight = { height: 0 };
  }
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      fixed &&
        localSpacer &&
        jsxRuntime.jsx(
          'div',
          { className: style$C.FixedBannerSpacer, style: spacerHeight.height === undefined ? {} : spacerHeight },
          isClient !== null && 'ready',
        ),
      jsxRuntime.jsx(Banner, {
        ref: bannerRef,
        style: bannerHeight ? { height: bannerHeight } : {},
        className: cx(
          style$C.FixedBanner,
          className,
          ((_b = {}),
          (_b[style$C.isFixed] = fixed),
          (_b[style$C.shouldHide] = hideOnScroll || removeOnScroll || hideBanner),
          (_b[style$C.hasScrolled] = !!(scrolled || hideBanner)),
          _b),
        ),
        children: children,
      }),
    ],
  });
};
FixedBanner.propTypes = {
  fixed: PropTypes__default['default'].bool,
  localSpacer: PropTypes__default['default'].bool,
  hideOnScroll: PropTypes__default['default'].bool,
  removeOnScroll: PropTypes__default['default'].bool,
  hideBanner: PropTypes__default['default'].bool,
};

var fortAwesome = 'https://use.fortawesome.com/e881caa9.js';

var style$B = {
  Container: 'htco-Container',
  isRow: 'htco-isRow',
  isGrid: 'htco-isGrid',
  ContainerGrid1: 'htco-ContainerGrid1',
  respondXS_OLD: 'htco-respondXS_OLD',
  respondSM_OLD: 'htco-respondSM_OLD',
  respondMD_OLD: 'htco-respondMD_OLD',
  respondLG_OLD: 'htco-respondLG_OLD',
  respondXL_OLD: 'htco-respondXL_OLD',
  respondMOBILE: 'htco-respondMOBILE',
  respondTABLET: 'htco-respondTABLET',
  respondSMALLDESKTOP: 'htco-respondSMALLDESKTOP',
  respondLARGEDESKTOP: 'htco-respondLARGEDESKTOP',
  respondXS: 'htco-respondXS',
  respondSM: 'htco-respondSM',
  respondMD: 'htco-respondMD',
  respondLG: 'htco-respondLG',
  ContainerFixedGrid1: 'htco-ContainerFixedGrid1',
  ContainerGrid2: 'htco-ContainerGrid2',
  ContainerFixedGrid2: 'htco-ContainerFixedGrid2',
  ContainerGrid3: 'htco-ContainerGrid3',
  ContainerFixedGrid3: 'htco-ContainerFixedGrid3',
  ContainerGrid4: 'htco-ContainerGrid4',
  ContainerFixedGrid4: 'htco-ContainerFixedGrid4',
  ContainerGrid5: 'htco-ContainerGrid5',
  ContainerFixedGrid5: 'htco-ContainerFixedGrid5',
  ContainerGrid6: 'htco-ContainerGrid6',
  ContainerFixedGrid6: 'htco-ContainerFixedGrid6',
  ContainerGrid7: 'htco-ContainerGrid7',
  ContainerFixedGrid7: 'htco-ContainerFixedGrid7',
  ContainerGrid8: 'htco-ContainerGrid8',
  ContainerFixedGrid8: 'htco-ContainerFixedGrid8',
  ContainerGrid9: 'htco-ContainerGrid9',
  ContainerFixedGrid9: 'htco-ContainerFixedGrid9',
  ContainerGrid10: 'htco-ContainerGrid10',
  ContainerFixedGrid10: 'htco-ContainerFixedGrid10',
  ContainerGrid11: 'htco-ContainerGrid11',
  ContainerFixedGrid11: 'htco-ContainerFixedGrid11',
  ContainerGrid12: 'htco-ContainerGrid12',
  ContainerFixedGrid12: 'htco-ContainerFixedGrid12',
};

var gridPadding$1 = 10;
var Container = function (_a) {
  var _b;
  var grid = _a.grid,
    fixed = _a.fixed,
    row = _a.row,
    justify = _a.justify,
    align = _a.align,
    _c = _a.space,
    space = _c === void 0 ? 0 : _c,
    _d = _a.respondAt,
    respondAt = _d === void 0 ? 'sm' : _d,
    props = __rest$1(_a, ['grid', 'fixed', 'row', 'justify', 'align', 'space', 'respondAt']);
  var screenHydrateKey = useWindowSize().screenHydrateKey;
  var calcStyles = {
    justifyContent: justify,
    alignItems: align,
    marginTop: space * gridPadding$1,
    marginBottom: space * gridPadding$1,
  };
  var classes = cx(
    props.className,
    style$B.Container,
    ((_b = {}),
    (_b[style$B['ContainerGrid'.concat(grid)]] = grid && !fixed),
    (_b[style$B['ContainerFixedGrid'.concat(grid)]] = grid && fixed),
    (_b[style$B['respond'.concat(respondAt.toUpperCase())]] = !!respondAt),
    (_b[style$B.isRow] = !!row),
    (_b[style$B.isGrid] = !!grid),
    _b),
  );
  return jsxRuntime.jsx(
    'div',
    __assign({}, props, {
      className: classes,
      style: __assign(__assign({}, calcStyles), props.style),
      children: props.children,
    }),
    screenHydrateKey,
  );
};

var style$A = {
  CTABlockRow: 'htco-CTABlockRow',
  CTABlockExtraPadding: 'htco-CTABlockExtraPadding',
  isMedium: 'htco-isMedium',
  isDark: 'htco-isDark',
  CTABlockContent: 'htco-CTABlockContent',
  CTABlockButton: 'htco-CTABlockButton',
  hasNoMargin: 'htco-hasNoMargin',
  CTABlockTitle: 'htco-CTABlockTitle',
  CTABlockText: 'htco-CTABlockText',
};

var CTABlock = function (_a) {
  var _b, _c;
  var _d = _a.theme,
    theme = _d === void 0 ? 'plain' : _d,
    title = _a.title,
    text = _a.text,
    buttonLabel = _a.buttonLabel,
    buttonLink = _a.buttonLink,
    buttonTheme = _a.buttonTheme,
    className = _a.className;
  var CTABlockTheme = cx(
    ((_b = {}), (_b[style$A.isMedium] = theme === 'medium'), (_b[style$A.isDark] = theme === 'dark'), _b),
  );
  return jsxRuntime.jsx('section', {
    className: cx(style$A.CTABlockRow, !text && style$A.CTABlockExtraPadding, className, CTABlockTheme),
    children: jsxRuntime.jsx(Container, {
      children: jsxRuntime.jsxs('div', {
        className: cx(style$A.CTABlockContent),
        children: [
          jsxRuntime.jsx('h3', { className: cx(style$A.CTABlockTitle, CTABlockTheme), children: title }),
          text && jsxRuntime.jsx('p', { className: style$A.CTABlockText, children: text }),
          jsxRuntime.jsx(Button, {
            className: cx(style$A.CTABlockButton, ((_c = {}), (_c[style$A.hasNoMargin] = !text), _c)),
            href: buttonLink,
            label: buttonLabel,
            theme: buttonTheme,
            disabled: false,
          }),
        ],
      }),
    }),
  });
};
CTABlock.propTypes = {
  theme: PropTypes__default['default'].oneOf(['plain', 'medium', 'dark']),
  title: PropTypes__default['default'].node.isRequired,
  text: PropTypes__default['default'].node,
  buttonLabel: PropTypes__default['default'].node.isRequired,
  buttonLink: PropTypes__default['default'].node.isRequired,
  buttonTheme: PropTypes__default['default'].string,
};

var style$z = {
  CardGroup: 'htco-CardGroup',
  CardGroupHeader: 'htco-CardGroupHeader',
  CardGroupText: 'htco-CardGroupText',
  CardGroupContentWrap: 'htco-CardGroupContentWrap',
};

var CardGroup = function (_a) {
  var title = _a.title,
    text = _a.text,
    // matches original $maxContentWidth - design currently expanding max-widths
    _b = _a.maxWidth,
    // matches original $maxContentWidth - design currently expanding max-widths
    maxWidth = _b === void 0 ? '1200px' : _b,
    _c = _a.titleAlignment,
    titleAlignment = _c === void 0 ? 'center' : _c,
    _d = _a.textAlignment,
    textAlignment = _d === void 0 ? 'center' : _d,
    _e = _a.cardAlignment,
    cardAlignment = _e === void 0 ? 'left' : _e,
    cardSize = _a.cardSize,
    cardFit = _a.cardFit,
    _f = _a.spacing,
    spacing = _f === void 0 ? 12 : _f,
    preventOrphans = _a.preventOrphans,
    props = __rest$1(_a, [
      'title',
      'text',
      'maxWidth',
      'titleAlignment',
      'textAlignment',
      'cardAlignment',
      'cardSize',
      'cardFit',
      'spacing',
      'preventOrphans',
    ]);
  // @ts-expect-error expected one argument but got 0
  var cardGroup = React.useRef();
  var screenWidth = useWindowSize().screenWidth;
  var _g = React.useState(),
    cardGroupWidth = _g[0],
    setCardGroupWidth = _g[1];
  React.useEffect(
    function () {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      var groupWidth = cardGroup.current.offsetWidth;
      if (groupWidth) {
        setCardGroupWidth(groupWidth);
      }
    },
    [screenWidth],
  );
  var titleAlign = titleAlignment;
  var txtAlign = textAlignment;
  var justify = 'center';
  if (cardAlignment === 'left') {
    justify = 'flex-start';
  } else if (cardAlignment === 'right') {
    justify = 'flex-end';
  }
  var wrapperStyles = {};
  var cardHasDefinedSize = typeof cardSize === 'object';
  if (cardHasDefinedSize && cardGroupWidth) {
    var childCount = React.Children.count(props.children);
    var cardWidth =
      ((cardSize === null || cardSize === void 0 ? void 0 : cardSize.width) ||
        (cardSize === null || cardSize === void 0 ? void 0 : cardSize.minWidth)) +
      spacing * 2;
    var maxCardCountPerRow = Math.max(Math.floor(cardGroupWidth / cardWidth), 1);
    var numOfRows = Math.ceil(childCount / maxCardCountPerRow);
    var cardsPerRow = Math.ceil(childCount / numOfRows);
    if (preventOrphans) {
      if (childCount % maxCardCountPerRow === 1) {
        cardsPerRow = Math.floor(childCount / numOfRows);
      }
    }
    // @ts-expect-error TS(2339): Property 'margin' does not exist on type '{}'.
    wrapperStyles.margin = '0 auto';
    if (cardWidth > screenWidth) {
      // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
      wrapperStyles.width = '100%';
    } else {
      var centeredWidth = Math.min(cardsPerRow, childCount) * cardWidth;
      if (!cardSize.width) {
        var fitCount = Math.floor(100 / parseFloat(cardFit));
        if (fitCount * cardWidth > cardGroupWidth) {
          // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
          wrapperStyles.width = centeredWidth;
        }
      } else {
        // @ts-expect-error TS(2339): Property 'width' does not exist on type '{}'.
        wrapperStyles.width = centeredWidth;
      }
    }
    if (cardsPerRow === 1) {
      titleAlign = 'center';
      txtAlign = 'center';
    }
  }
  return (
    // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
    jsxRuntime.jsx('div', {
      className: cx(style$z.CardGroup, props.className),
      ref: cardGroup,
      style: { maxWidth: maxWidth },
      children: jsxRuntime.jsxs('div', {
        style: wrapperStyles,
        children: [
          title &&
            jsxRuntime.jsx('h2', {
              className: style$z.CardGroupHeader,
              style: { textAlign: titleAlign, paddingLeft: spacing, paddingRight: spacing },
              children: title,
            }),
          text &&
            jsxRuntime.jsx('p', {
              className: style$z.CardGroupText,
              style: { textAlign: txtAlign, paddingLeft: spacing, paddingRight: spacing },
              children: text,
            }),
          jsxRuntime.jsx('div', {
            className: style$z.CardGroupContentWrap,
            style: { justifyContent: justify },
            children:
              cardGroupWidth &&
              React.Children.map(props.children, function (child) {
                if (React.isValidElement(child)) {
                  return jsxRuntime.jsx('div', {
                    style: {
                      padding: spacing,
                      boxSizing: 'border-box',
                      display: 'flex',
                      width: cardFit,
                      minWidth:
                        (cardSize === null || cardSize === void 0 ? void 0 : cardSize.minWidth) &&
                        cardSize.minWidth + spacing * 2,
                    },
                    children: child,
                  });
                }
              }),
          }),
        ],
      }),
    })
  );
};
CardGroup.propTypes = {
  title: PropTypes__default['default'].node,
  text: PropTypes__default['default'].string,
  maxWidth: PropTypes__default['default'].string,
  titleAlignment: PropTypes__default['default'].oneOf(['center', 'left', 'right']),
  textAlignment: PropTypes__default['default'].oneOf(['center', 'left', 'right']),
  cardAlignment: PropTypes__default['default'].oneOf(['center', 'left', 'right']),
  cardFit: PropTypes__default['default'].string,
  cardSize: PropTypes__default['default'].shape({
    width: PropTypes__default['default'].number,
    minWidth: PropTypes__default['default'].number,
  }),
};

var style$y = {
  InfoCardHeader: 'htco-InfoCardHeader',
  InfoCard: 'htco-InfoCard',
  isMedium: 'htco-isMedium',
  InfoCardLink: 'htco-InfoCardLink',
  hasBottomLink: 'htco-hasBottomLink',
  ThumbnailRounded: 'htco-ThumbnailRounded',
  InfoCardContent: 'htco-InfoCardContent',
};

var size$3 = {
  width: 320,
};
var InfoCard = function (_a) {
  var _b, _c;
  var _d = _a.theme,
    theme = _d === void 0 ? 'plain' : _d,
    title = _a.title,
    description = _a.description,
    image = _a.image,
    link = _a.link,
    linkLabel = _a.linkLabel,
    gatsbyImage = _a.gatsbyImage;
  return jsxRuntime.jsx('div', {
    className: cx(style$y.InfoCard, ((_b = {}), (_b[style$y.isMedium] = theme === 'medium'), _b)),
    style: size$3,
    children: jsxRuntime.jsxs('a', {
      href: link,
      title: title,
      className: cx(style$y.InfoCardLink, ((_c = {}), (_c[style$y.hasBottomLink] = !!linkLabel), _c)),
      children: [
        gatsbyImage
          ? jsxRuntime.jsx('div', { className: style$y.ThumbnailRounded, children: gatsbyImage })
          : jsxRuntime.jsx('img', { className: style$y.ThumbnailRounded, src: image, alt: '' }),
        title && jsxRuntime.jsx('h4', { className: style$y.InfoCardHeader, children: title }),
        jsxRuntime.jsx('p', { className: style$y.InfoCardContent, children: description }),
        linkLabel &&
          jsxRuntime.jsxs('h4', {
            className: style$y.InfoCardHeader,
            children: [linkLabel, '\u00A0', jsxRuntime.jsx(Icon, { name: 'arrow-right' })],
          }),
      ],
    }),
  });
};
InfoCard.propTypes = {
  theme: PropTypes__default['default'].oneOf(['plain', 'medium']),
  linkLabel: PropTypes__default['default'].node,
  title: PropTypes__default['default'].node,
  description: PropTypes__default['default'].node,
  image: PropTypes__default['default'].string,
  link: PropTypes__default['default'].string.isRequired,
  gatsbyImage: PropTypes__default['default'].node,
};
InfoCard.size = size$3;

var style$x = {
  UseCaseCard: 'htco-UseCaseCard',
  UseCaseCardWrapper: 'htco-UseCaseCardWrapper',
  ThumbnailRounded: 'htco-ThumbnailRounded',
  UseCaseCardContent: 'htco-UseCaseCardContent',
  UseCaseCardLinkWrapper: 'htco-UseCaseCardLinkWrapper',
  UseCaseCardHeader: 'htco-UseCaseCardHeader',
  UseCaseCardLink: 'htco-UseCaseCardLink',
};

var UseCaseCard = function (_a) {
  var title = _a.title,
    description = _a.description,
    image = _a.image,
    link = _a.link,
    _b = _a.linkLabel,
    linkLabel = _b === void 0 ? 'Learn More' : _b;
  return jsxRuntime.jsx('div', {
    className: style$x.UseCaseCard,
    children: jsxRuntime.jsxs('div', {
      className: style$x.UseCaseCardWrapper,
      children: [
        jsxRuntime.jsxs('div', {
          children: [
            jsxRuntime.jsx('img', { className: style$x.ThumbnailRounded, src: image, alt: '' }),
            title && jsxRuntime.jsx('h4', { className: style$x.UseCaseCardHeader, children: title }),
            jsxRuntime.jsx('p', { className: style$x.UseCaseCardContent, children: description }),
          ],
        }),
        jsxRuntime.jsx('div', {
          className: style$x.UseCaseCardLinkWrapper,
          children: jsxRuntime.jsx(Button, {
            className: style$x.UseCaseCardLink,
            icon: 'arrow-forward',
            theme: 'link',
            href: link,
            reverseLinkIcon: true,
            children: linkLabel,
          }),
        }),
      ],
    }),
  });
};
UseCaseCard.propTypes = {
  linkLabel: PropTypes__default['default'].node,
  title: PropTypes__default['default'].node,
  description: PropTypes__default['default'].node,
  image: PropTypes__default['default'].string,
  link: PropTypes__default['default'].string.isRequired,
};

var style$w = {
  PointCard: 'htco-PointCard',
  PointCardParagraph: 'htco-PointCardParagraph',
  PointCardProfile: 'htco-PointCardProfile',
  PointCardIcon: 'htco-PointCardIcon',
  hasCheck: 'htco-hasCheck',
  PointCardHeading: 'htco-PointCardHeading',
};

var getIconColor = function (icon) {
  return icon === 'check-filled' ? '#29c08d' : null;
};
var size$2 = {
  width: 490,
};
var PointCard = function (_a) {
  var icon = _a.icon,
    title = _a.title,
    props = __rest$1(_a, ['icon', 'title']);
  return jsxRuntime.jsxs('div', {
    className: cx(style$w.PointCard),
    style: size$2,
    children: [
      jsxRuntime.jsxs('div', {
        className: style$w.PointCardProfile,
        children: [
          jsxRuntime.jsx('div', {
            className: cx(style$w.PointCardIcon),
            children: jsxRuntime.jsx(Icon, { name: icon, size: '2x', color: getIconColor(icon) }),
          }),
          jsxRuntime.jsx('h4', { className: style$w.PointCardHeading, children: title }),
        ],
      }),
      jsxRuntime.jsx('p', { className: style$w.PointCardParagraph, children: props.children }),
    ],
  });
};
PointCard.propTypes = {
  icon: PropTypes__default['default'].node.isRequired,
  title: PropTypes__default['default'].node.isRequired,
};
PointCard.size = size$2;

var img$b =
  'data:image/gif;base64,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';

var style$v = {
  NotFoundBlock: 'htco-NotFoundBlock',
  NotFoundBlockImage: 'htco-NotFoundBlockImage',
  NotFoundBlockButton: 'htco-NotFoundBlockButton',
};

var NotFoundBlock = function (_a) {
  var _b;
  var _c = _a.error,
    error = _c === void 0 ? '404 Error' : _c,
    _d = _a.title,
    title = _d === void 0 ? 'Looks like we’re having some trouble fetching this page' : _d,
    _e = _a.image,
    image = _e === void 0 ? img$b : _e,
    _f = _a.buttonLabel,
    buttonLabel = _f === void 0 ? 'Head on home' : _f,
    buttonLink = _a.buttonLink,
    props = __rest$1(_a, ['error', 'title', 'image', 'buttonLabel', 'buttonLink']);
  return jsxRuntime.jsxs('div', {
    className: cx(style$v.NotFoundBlock, props.className),
    children: [
      jsxRuntime.jsxs('div', {
        children: [
          jsxRuntime.jsx('h2', { children: error }),
          jsxRuntime.jsx('h1', { children: title }),
          (_b = props.children) !== null && _b !== void 0
            ? _b
            : 'You may be here because this page has moved—or no longer exists.',
          buttonLink &&
            jsxRuntime.jsx('div', {
              className: style$v.NotFoundBlockButton,
              children: jsxRuntime.jsx(Button, { href: buttonLink, children: buttonLabel }),
            }),
        ],
      }),
      jsxRuntime.jsx('div', {
        children: jsxRuntime.jsx('img', {
          className: style$v.NotFoundBlockImage,
          src: image,
          alt: 'Dog fetching ball and rolling over',
        }),
      }),
    ],
  });
};

function _extends$C() {
  return (
    (_extends$C = Object.assign
      ? Object.assign.bind()
      : function (n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = arguments[e];
            for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }
          return n;
        }),
    _extends$C.apply(null, arguments)
  );
}

function _objectWithoutPropertiesLoose$o(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
  return t;
}

function _setPrototypeOf$12(t, e) {
  return (
    (_setPrototypeOf$12 = Object.setPrototypeOf
      ? Object.setPrototypeOf.bind()
      : function (t, e) {
          return (t.__proto__ = e), t;
        }),
    _setPrototypeOf$12(t, e)
  );
}

function _inheritsLoose$3(t, o) {
  (t.prototype = Object.create(o.prototype)), (t.prototype.constructor = t), _setPrototypeOf$12(t, o);
}

/**
 * Checks if a given element has a CSS class.
 *
 * @param element the element
 * @param className the CSS class name
 */
function hasClass$1(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (' ' + (element.className.baseVal || element.className) + ' ').indexOf(' ' + className + ' ') !== -1;
}

/**
 * Adds a CSS class to a given element.
 *
 * @param element the element
 * @param className the CSS class name
 */

function addClass$1(element, className) {
  if (element.classList) element.classList.add(className);
  else if (!hasClass$1(element, className))
    if (typeof element.className === 'string') element.className = element.className + ' ' + className;
    else element.setAttribute('class', ((element.className && element.className.baseVal) || '') + ' ' + className);
}

function replaceClassName$1(origClass, classToRemove) {
  return origClass
    .replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1')
    .replace(/\s+/g, ' ')
    .replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 *
 * @param element the element
 * @param className the CSS class name
 */

function removeClass$2(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName$1(element.className, className);
  } else {
    element.setAttribute(
      'class',
      replaceClassName$1((element.className && element.className.baseVal) || '', className),
    );
  }
}

var config$1 = {
  disabled: false,
};

var timeoutsShape$1 =
  process.env.NODE_ENV !== 'production'
    ? PropTypes__default['default'].oneOfType([
        PropTypes__default['default'].number,
        PropTypes__default['default'].shape({
          enter: PropTypes__default['default'].number,
          exit: PropTypes__default['default'].number,
          appear: PropTypes__default['default'].number,
        }).isRequired,
      ])
    : null;
var classNamesShape$1 =
  process.env.NODE_ENV !== 'production'
    ? PropTypes__default['default'].oneOfType([
        PropTypes__default['default'].string,
        PropTypes__default['default'].shape({
          enter: PropTypes__default['default'].string,
          exit: PropTypes__default['default'].string,
          active: PropTypes__default['default'].string,
        }),
        PropTypes__default['default'].shape({
          enter: PropTypes__default['default'].string,
          enterDone: PropTypes__default['default'].string,
          enterActive: PropTypes__default['default'].string,
          exit: PropTypes__default['default'].string,
          exitDone: PropTypes__default['default'].string,
          exitActive: PropTypes__default['default'].string,
        }),
      ])
    : null;

var TransitionGroupContext = React__default['default'].createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED$1 = 'unmounted';
var EXITED$1 = 'exited';
var ENTERING$1 = 'entering';
var ENTERED$1 = 'entered';
var EXITING$1 = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition$2 = /*#__PURE__*/ (function (_React$Component) {
  _inheritsLoose$3(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED$1;
        _this.appearStatus = ENTERING$1;
      } else {
        initialStatus = ENTERED$1;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED$1;
      } else {
        initialStatus = EXITED$1;
      }
    }

    _this.state = {
      status: initialStatus,
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED$1) {
      return {
        status: EXITED$1,
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING$1 && status !== ENTERED$1) {
          nextStatus = ENTERING$1;
        }
      } else {
        if (status === ENTERING$1 || status === ENTERED$1) {
          nextStatus = EXITING$1;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear,
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING$1) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default['default'].findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED$1) {
      this.setState({
        status: UNMOUNTED$1,
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default['default'].findDOMNode(this), appearing],
      maybeNode = _ref2[0],
      maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if ((!mounting && !enter) || config$1.disabled) {
      this.safeSetState(
        {
          status: ENTERED$1,
        },
        function () {
          _this2.props.onEntered(maybeNode);
        },
      );
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState(
      {
        status: ENTERING$1,
      },
      function () {
        _this2.props.onEntering(maybeNode, maybeAppearing);

        _this2.onTransitionEnd(enterTimeout, function () {
          _this2.safeSetState(
            {
              status: ENTERED$1,
            },
            function () {
              _this2.props.onEntered(maybeNode, maybeAppearing);
            },
          );
        });
      },
    );
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default['default'].findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config$1.disabled) {
      this.safeSetState(
        {
          status: EXITED$1,
        },
        function () {
          _this3.props.onExited(maybeNode);
        },
      );
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState(
      {
        status: EXITING$1,
      },
      function () {
        _this3.props.onExiting(maybeNode);

        _this3.onTransitionEnd(timeouts.exit, function () {
          _this3.safeSetState(
            {
              status: EXITED$1,
            },
            function () {
              _this3.props.onExited(maybeNode);
            },
          );
        });
      },
    );
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default['default'].findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
        maybeNode = _ref3[0],
        maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED$1) {
      return null;
    }

    var _this$props = this.props,
      children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose$o(_this$props, [
      'children',
      'in',
      'mountOnEnter',
      'unmountOnExit',
      'appear',
      'enter',
      'exit',
      'timeout',
      'addEndListener',
      'onEnter',
      'onEntering',
      'onEntered',
      'onExit',
      'onExiting',
      'onExited',
      'nodeRef',
    ]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default['default'].createElement(
        TransitionGroupContext.Provider,
        {
          value: null,
        },
        typeof children === 'function'
          ? children(status, childProps)
          : React__default['default'].cloneElement(React__default['default'].Children.only(children), childProps),
      )
    );
  };

  return Transition;
})(React__default['default'].Component);

Transition$2.contextType = TransitionGroupContext;
Transition$2.propTypes =
  process.env.NODE_ENV !== 'production'
    ? {
        /**
         * A React reference to DOM element that need to transition:
         * https://stackoverflow.com/a/51127130/4671932
         *
         *   - When `nodeRef` prop is used, `node` is not passed to callback functions
         *      (e.g. `onEnter`) because user already has direct access to the node.
         *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
         *     `nodeRef` need to be provided to `Transition` with changed `key` prop
         *     (see
         *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
         */
        nodeRef: PropTypes__default['default'].shape({
          current:
            typeof Element === 'undefined'
              ? PropTypes__default['default'].any
              : function (propValue, key, componentName, location, propFullName, secret) {
                  var value = propValue[key];
                  return PropTypes__default['default'].instanceOf(
                    value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element,
                  )(propValue, key, componentName, location, propFullName, secret);
                },
        }),

        /**
         * A `function` child can be used instead of a React element. This function is
         * called with the current transition status (`'entering'`, `'entered'`,
         * `'exiting'`, `'exited'`), which can be used to apply context
         * specific props to a component.
         *
         * ```jsx
         * <Transition in={this.state.in} timeout={150}>
         *   {state => (
         *     <MyComponent className={`fade fade-${state}`} />
         *   )}
         * </Transition>
         * ```
         */
        children: PropTypes__default['default'].oneOfType([
          PropTypes__default['default'].func.isRequired,
          PropTypes__default['default'].element.isRequired,
        ]).isRequired,

        /**
         * Show the component; triggers the enter or exit states
         */
        in: PropTypes__default['default'].bool,

        /**
         * By default the child component is mounted immediately along with
         * the parent `Transition` component. If you want to "lazy mount" the component on the
         * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
         * mounted, even on "exited", unless you also specify `unmountOnExit`.
         */
        mountOnEnter: PropTypes__default['default'].bool,

        /**
         * By default the child component stays mounted after it reaches the `'exited'` state.
         * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
         */
        unmountOnExit: PropTypes__default['default'].bool,

        /**
         * By default the child component does not perform the enter transition when
         * it first mounts, regardless of the value of `in`. If you want this
         * behavior, set both `appear` and `in` to `true`.
         *
         * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
         * > only adds an additional enter transition. However, in the
         * > `<CSSTransition>` component that first enter transition does result in
         * > additional `.appear-*` classes, that way you can choose to style it
         * > differently.
         */
        appear: PropTypes__default['default'].bool,

        /**
         * Enable or disable enter transitions.
         */
        enter: PropTypes__default['default'].bool,

        /**
         * Enable or disable exit transitions.
         */
        exit: PropTypes__default['default'].bool,

        /**
         * The duration of the transition, in milliseconds.
         * Required unless `addEndListener` is provided.
         *
         * You may specify a single timeout for all transitions:
         *
         * ```jsx
         * timeout={500}
         * ```
         *
         * or individually:
         *
         * ```jsx
         * timeout={{
         *  appear: 500,
         *  enter: 300,
         *  exit: 500,
         * }}
         * ```
         *
         * - `appear` defaults to the value of `enter`
         * - `enter` defaults to `0`
         * - `exit` defaults to `0`
         *
         * @type {number | { enter?: number, exit?: number, appear?: number }}
         */
        timeout: function timeout(props) {
          var pt = timeoutsShape$1;
          if (!props.addEndListener) pt = pt.isRequired;

          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          return pt.apply(void 0, [props].concat(args));
        },

        /**
         * Add a custom transition end trigger. Called with the transitioning
         * DOM node and a `done` callback. Allows for more fine grained transition end
         * logic. Timeouts are still used as a fallback if provided.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * ```jsx
         * addEndListener={(node, done) => {
         *   // use the css transitionend event to mark the finish of a transition
         *   node.addEventListener('transitionend', done, false);
         * }}
         * ```
         */
        addEndListener: PropTypes__default['default'].func,

        /**
         * Callback fired before the "entering" status is applied. An extra parameter
         * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement, isAppearing: bool) -> void
         */
        onEnter: PropTypes__default['default'].func,

        /**
         * Callback fired after the "entering" status is applied. An extra parameter
         * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement, isAppearing: bool)
         */
        onEntering: PropTypes__default['default'].func,

        /**
         * Callback fired after the "entered" status is applied. An extra parameter
         * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement, isAppearing: bool) -> void
         */
        onEntered: PropTypes__default['default'].func,

        /**
         * Callback fired before the "exiting" status is applied.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement) -> void
         */
        onExit: PropTypes__default['default'].func,

        /**
         * Callback fired after the "exiting" status is applied.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement) -> void
         */
        onExiting: PropTypes__default['default'].func,

        /**
         * Callback fired after the "exited" status is applied.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed
         *
         * @type Function(node: HtmlElement) -> void
         */
        onExited: PropTypes__default['default'].func,
      }
    : {}; // Name the function so it is clearer in the documentation

function noop$5() {}

Transition$2.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$5,
  onEntering: noop$5,
  onEntered: noop$5,
  onExit: noop$5,
  onExiting: noop$5,
  onExited: noop$5,
};
Transition$2.UNMOUNTED = UNMOUNTED$1;
Transition$2.EXITED = EXITED$1;
Transition$2.ENTERING = ENTERING$1;
Transition$2.ENTERED = ENTERED$1;
Transition$2.EXITING = EXITING$1;

var _addClass = function addClass(node, classes) {
  return (
    node &&
    classes &&
    classes.split(' ').forEach(function (c) {
      return addClass$1(node, c);
    })
  );
};

var removeClass$1 = function removeClass(node, classes) {
  return (
    node &&
    classes &&
    classes.split(' ').forEach(function (c) {
      return removeClass$2(node, c);
    })
  );
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */

var CSSTransition$1 = /*#__PURE__*/ (function (_React$Component) {
  _inheritsLoose$3(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {},
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument[0],
        appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument2[0],
        appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument3[0],
        appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef
        ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
        : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var baseClassName = isStringClassNames ? '' + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? baseClassName + '-done' : classNames[type + 'Done'];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName,
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + 'ClassName'];

    var _this$getClassNames = this.getClassNames('enter'),
      doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += ' ' + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.

    if (phase === 'active') {
      if (node) forceReflow(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
      baseClassName = _this$appliedClasses$.base,
      activeClassName = _this$appliedClasses$.active,
      doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
    _this$props.classNames;
    var props = _objectWithoutPropertiesLoose$o(_this$props, ['classNames']);

    return /*#__PURE__*/ React__default['default'].createElement(
      Transition$2,
      _extends$C({}, props, {
        onEnter: this.onEnter,
        onEntered: this.onEntered,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited,
      }),
    );
  };

  return CSSTransition;
})(React__default['default'].Component);

CSSTransition$1.defaultProps = {
  classNames: '',
};
CSSTransition$1.propTypes =
  process.env.NODE_ENV !== 'production'
    ? _extends$C({}, Transition$2.propTypes, {
        /**
         * The animation classNames applied to the component as it appears, enters,
         * exits or has finished the transition. A single name can be provided, which
         * will be suffixed for each stage, e.g. `classNames="fade"` applies:
         *
         * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
         * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
         * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
         *
         * A few details to note about how these classes are applied:
         *
         * 1. They are _joined_ with the ones that are already defined on the child
         *    component, so if you want to add some base styles, you can use
         *    `className` without worrying that it will be overridden.
         *
         * 2. If the transition component mounts with `in={false}`, no classes are
         *    applied yet. You might be expecting `*-exit-done`, but if you think
         *    about it, a component cannot finish exiting if it hasn't entered yet.
         *
         * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
         *    allows you to define different behavior for when appearing is done and
         *    when regular entering is done, using selectors like
         *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
         *    an epic entrance animation when element first appears in the DOM using
         *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
         *    simply use `fade-enter-done` for defining both cases.
         *
         * Each individual classNames can also be specified independently like:
         *
         * ```js
         * classNames={{
         *  appear: 'my-appear',
         *  appearActive: 'my-active-appear',
         *  appearDone: 'my-done-appear',
         *  enter: 'my-enter',
         *  enterActive: 'my-active-enter',
         *  enterDone: 'my-done-enter',
         *  exit: 'my-exit',
         *  exitActive: 'my-active-exit',
         *  exitDone: 'my-done-exit',
         * }}
         * ```
         *
         * If you want to set these classes using CSS Modules:
         *
         * ```js
         * import styles from './styles.css';
         * ```
         *
         * you might want to use camelCase in your CSS file, that way could simply
         * spread them instead of listing them one by one:
         *
         * ```js
         * classNames={{ ...styles }}
         * ```
         *
         * @type {string | {
         *  appear?: string,
         *  appearActive?: string,
         *  appearDone?: string,
         *  enter?: string,
         *  enterActive?: string,
         *  enterDone?: string,
         *  exit?: string,
         *  exitActive?: string,
         *  exitDone?: string,
         * }}
         */
        classNames: classNamesShape$1,

        /**
         * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
         * applied.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement, isAppearing: bool)
         */
        onEnter: PropTypes__default['default'].func,

        /**
         * A `<Transition>` callback fired immediately after the 'enter-active' or
         * 'appear-active' class is applied.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement, isAppearing: bool)
         */
        onEntering: PropTypes__default['default'].func,

        /**
         * A `<Transition>` callback fired immediately after the 'enter' or
         * 'appear' classes are **removed** and the `done` class is added to the DOM node.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement, isAppearing: bool)
         */
        onEntered: PropTypes__default['default'].func,

        /**
         * A `<Transition>` callback fired immediately after the 'exit' class is
         * applied.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed
         *
         * @type Function(node: HtmlElement)
         */
        onExit: PropTypes__default['default'].func,

        /**
         * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed
         *
         * @type Function(node: HtmlElement)
         */
        onExiting: PropTypes__default['default'].func,

        /**
         * A `<Transition>` callback fired immediately after the 'exit' classes
         * are **removed** and the `exit-done` class is added to the DOM node.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed
         *
         * @type Function(node: HtmlElement)
         */
        onExited: PropTypes__default['default'].func,
      })
    : {};

function _assertThisInitialized$12(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping$1(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && React.isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children)
    React.Children.map(children, function (c) {
      return c;
    }).forEach(function (child) {
      // run the map function here instead so that the key is the computed one
      result[child.key] = mapper(child);
    });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings$1(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list

  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`

  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp$1(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping$1(props, onExited) {
  return getChildMapping$1(props.children, function (child) {
    return React.cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp$1(child, 'appear', props),
      enter: getProp$1(child, 'enter', props),
      exit: getProp$1(child, 'exit', props),
    });
  });
}
function getNextChildMapping$1(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping$1(nextProps.children);
  var children = mergeChildMappings$1(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!React.isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = React.isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = React.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp$1(child, 'exit', nextProps),
        enter: getProp$1(child, 'enter', nextProps),
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = React.cloneElement(child, {
        in: false,
      });
    } else if (hasNext && hasPrev && React.isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = React.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp$1(child, 'exit', nextProps),
        enter: getProp$1(child, 'enter', nextProps),
      });
    }
  });
  return children;
}

var values =
  Object.values ||
  function (obj) {
    return Object.keys(obj).map(function (k) {
      return obj[k];
    });
  };

var defaultProps$2 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  },
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup$1 = /*#__PURE__*/ (function (_React$Component) {
  _inheritsLoose$3(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized$12(_this)); // Initial children should all be entering, dependent on appear

    _this.state = {
      contextValue: {
        isMounting: true,
      },
      handleExited: handleExited,
      firstRender: true,
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false,
      },
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
      handleExited = _ref.handleExited,
      firstRender = _ref.firstRender;
    return {
      children: firstRender
        ? getInitialChildMapping$1(nextProps, handleExited)
        : getNextChildMapping$1(nextProps, prevChildMapping, handleExited),
      firstRender: false,
    };
  }; // node is `undefined` when user provided `nodeRef` prop

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping$1(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$C({}, state.children);

        delete children[child.key];
        return {
          children: children,
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
      Component = _this$props.component,
      childFactory = _this$props.childFactory,
      props = _objectWithoutPropertiesLoose$o(_this$props, ['component', 'childFactory']);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/ React__default['default'].createElement(
        TransitionGroupContext.Provider,
        {
          value: contextValue,
        },
        children,
      );
    }

    return /*#__PURE__*/ React__default['default'].createElement(
      TransitionGroupContext.Provider,
      {
        value: contextValue,
      },
      /*#__PURE__*/ React__default['default'].createElement(Component, props, children),
    );
  };

  return TransitionGroup;
})(React__default['default'].Component);

TransitionGroup$1.propTypes =
  process.env.NODE_ENV !== 'production'
    ? {
        /**
         * `<TransitionGroup>` renders a `<div>` by default. You can change this
         * behavior by providing a `component` prop.
         * If you use React v16+ and would like to avoid a wrapping `<div>` element
         * you can pass in `component={null}`. This is useful if the wrapping div
         * borks your css styles.
         */
        component: PropTypes__default['default'].any,

        /**
         * A set of `<Transition>` components, that are toggled `in` and out as they
         * leave. the `<TransitionGroup>` will inject specific transition props, so
         * remember to spread them through if you are wrapping the `<Transition>` as
         * with our `<Fade>` example.
         *
         * While this component is meant for multiple `Transition` or `CSSTransition`
         * children, sometimes you may want to have a single transition child with
         * content that you want to be transitioned out and in when you change it
         * (e.g. routes, images etc.) In that case you can change the `key` prop of
         * the transition child as you change its content, this will cause
         * `TransitionGroup` to transition the child out and back in.
         */
        children: PropTypes__default['default'].node,

        /**
         * A convenience prop that enables or disables appear animations
         * for all children. Note that specifying this will override any defaults set
         * on individual children Transitions.
         */
        appear: PropTypes__default['default'].bool,

        /**
         * A convenience prop that enables or disables enter animations
         * for all children. Note that specifying this will override any defaults set
         * on individual children Transitions.
         */
        enter: PropTypes__default['default'].bool,

        /**
         * A convenience prop that enables or disables exit animations
         * for all children. Note that specifying this will override any defaults set
         * on individual children Transitions.
         */
        exit: PropTypes__default['default'].bool,

        /**
         * You may need to apply reactive updates to a child as it is exiting.
         * This is generally done by using `cloneElement` however in the case of an exiting
         * child the element has already been removed and not accessible to the consumer.
         *
         * If you do need to update a child as it leaves you can provide a `childFactory`
         * to wrap every child, even the ones that are leaving.
         *
         * @type Function(child: ReactElement) -> ReactElement
         */
        childFactory: PropTypes__default['default'].func,
      }
    : {};
TransitionGroup$1.defaultProps = defaultProps$2;

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition$1 = /*#__PURE__*/ (function (_React$Component) {
  _inheritsLoose$3(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = React__default['default'].Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : ReactDOM__default['default'].findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      inProp = _this$props.in,
      props = _objectWithoutPropertiesLoose$o(_this$props, ['children', 'in']);

    var _React$Children$toArr = React__default['default'].Children.toArray(children),
      first = _React$Children$toArr[0],
      second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/ React__default['default'].createElement(
      TransitionGroup$1,
      props,
      inProp
        ? React__default['default'].cloneElement(first, {
            key: 'first',
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered,
          })
        : React__default['default'].cloneElement(second, {
            key: 'second',
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited,
          }),
    );
  };

  return ReplaceTransition;
})(React__default['default'].Component);

ReplaceTransition$1.propTypes =
  process.env.NODE_ENV !== 'production'
    ? {
        in: PropTypes__default['default'].bool.isRequired,
        children: function children(props, propName) {
          if (React__default['default'].Children.count(props[propName]) !== 2)
            return new Error('"' + propName + '" must be exactly two transition components.');
          return null;
        },
      }
    : {};

var _leaveRenders, _enterRenders;

function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (
    React__default['default'].isValidElement(oldChildren) &&
    React__default['default'].isValidElement(newChildren) &&
    oldChildren.key != null &&
    oldChildren.key === newChildren.key
  ) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */

var modes = {
  out: 'out-in',
  in: 'in-out',
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders =
  ((_leaveRenders = {}),
  (_leaveRenders[modes.out] = function (_ref) {
    var current = _ref.current,
      changeState = _ref.changeState;
    return React__default['default'].cloneElement(current, {
      in: false,
      onExited: callHook(current, 'onExited', function () {
        changeState(ENTERING$1, null);
      }),
    });
  }),
  (_leaveRenders[modes.in] = function (_ref2) {
    var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
    return [
      current,
      React__default['default'].cloneElement(children, {
        in: true,
        onEntered: callHook(children, 'onEntered', function () {
          changeState(ENTERING$1);
        }),
      }),
    ];
  }),
  _leaveRenders);
var enterRenders =
  ((_enterRenders = {}),
  (_enterRenders[modes.out] = function (_ref3) {
    var children = _ref3.children,
      changeState = _ref3.changeState;
    return React__default['default'].cloneElement(children, {
      in: true,
      onEntered: callHook(children, 'onEntered', function () {
        changeState(
          ENTERED$1,
          React__default['default'].cloneElement(children, {
            in: true,
          }),
        );
      }),
    });
  }),
  (_enterRenders[modes.in] = function (_ref4) {
    var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
    return [
      React__default['default'].cloneElement(current, {
        in: false,
        onExited: callHook(current, 'onExited', function () {
          changeState(
            ENTERED$1,
            React__default['default'].cloneElement(children, {
              in: true,
            }),
          );
        }),
      }),
      React__default['default'].cloneElement(children, {
        in: true,
      }),
    ];
  }),
  _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/ (function (_React$Component) {
  _inheritsLoose$3(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED$1,
      current: null,
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current,
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null,
      };
    }

    if (state.status === ENTERING$1 && props.mode === modes.in) {
      return {
        status: ENTERING$1,
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING$1,
      };
    }

    return {
      current: React__default['default'].cloneElement(props.children, {
        in: true,
      }),
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      mode = _this$props.mode,
      _this$state = this.state,
      status = _this$state.status,
      current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status,
    };
    var component;

    switch (status) {
      case ENTERING$1:
        component = enterRenders[mode](data);
        break;

      case EXITING$1:
        component = leaveRenders[mode](data);
        break;

      case ENTERED$1:
        component = current;
    }

    return /*#__PURE__*/ React__default['default'].createElement(
      TransitionGroupContext.Provider,
      {
        value: {
          isMounting: !this.appeared,
        },
      },
      component,
    );
  };

  return SwitchTransition;
})(React__default['default'].Component);

SwitchTransition.propTypes =
  process.env.NODE_ENV !== 'production'
    ? {
        /**
         * Transition modes.
         * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
         * `in-out`: New element transitions in first, then when complete, the current element transitions out.
         *
         * @type {'out-in'|'in-out'}
         */
        mode: PropTypes__default['default'].oneOf([modes.in, modes.out]),

        /**
         * Any `Transition` or `CSSTransition` component.
         */
        children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].element.isRequired]),
      }
    : {};
SwitchTransition.defaultProps = {
  mode: modes.out,
};

var SlideDown = function (_a) {
  var className = _a.className,
    _b = _a.visible,
    visible = _b === void 0 ? false : _b,
    _c = _a.duration,
    duration = _c === void 0 ? 500 : _c,
    maxHeight = _a.maxHeight,
    children = _a.children;
  var _d = React.useState(),
    calcHeight = _d[0],
    setCalcHeight = _d[1];
  var childRef = React.useRef(null);
  var transitionRef = React.useRef(null);
  React.useLayoutEffect(
    function () {
      var content = childRef.current;
      var updateHeight = function () {
        if (content) {
          setCalcHeight(content.getBoundingClientRect().height);
        }
      };
      updateHeight();
      var observer = new MutationObserver(updateHeight);
      if (content) {
        observer.observe(content, { childList: true, subtree: true, characterData: true });
      }
      return function () {
        observer.disconnect();
      };
    },
    [childRef.current, visible],
  );
  React.useEffect(
    function () {
      var handleResize = function () {
        var content = childRef.current;
        if (content) {
          var height = content === null || content === void 0 ? void 0 : content.getBoundingClientRect().height;
          setCalcHeight(height);
        }
      };
      window.addEventListener('resize', handleResize);
      return function () {
        window.removeEventListener('resize', handleResize);
      };
    },
    [childRef.current],
  );
  var transitionStates = {
    entering: { maxHeight: maxHeight !== null && maxHeight !== void 0 ? maxHeight : calcHeight },
    entered: { maxHeight: maxHeight !== null && maxHeight !== void 0 ? maxHeight : calcHeight },
    exiting: { maxHeight: 0 },
    exited: { maxHeight: 0 },
    unmounted: { maxHeight: 0 },
  };
  return (
    // @ts-expect-error TS(2786): 'Transition' cannot be used as a JSX component.
    jsxRuntime.jsx(Transition$2, {
      className: className,
      in: visible,
      timeout: duration,
      appear: visible,
      nodeRef: transitionRef,
      mountOnEnter: true,
      unmountOnExit: true,
      children: function (state) {
        return jsxRuntime.jsx('div', {
          ref: transitionRef,
          style: __assign(
            {
              transition: 'max-height '.concat(duration / 1000, 's ease-in-out 0s'),
              overflow: 'hidden',
              boxSizing: 'border-box',
            },
            transitionStates[state],
          ),
          children: jsxRuntime.jsx('div', {
            ref: childRef,
            style: { boxSizing: 'border-box', padding: 1 },
            children: children,
          }),
        });
      },
    })
  );
};

var style$u = {
  Paper: 'htco-Paper',
  isElevated: 'htco-isElevated',
  isMedium: 'htco-isMedium',
  isDark: 'htco-isDark',
  withDivider: 'htco-withDivider',
};

var gridPadding = 10;
var Paper = function (_a) {
  var _b;
  var _c = _a.theme,
    theme = _c === void 0 ? 'elevated' : _c,
    _d = _a.divider,
    divider = _d === void 0 ? false : _d,
    pad = _a.pad,
    children = _a.children,
    className = _a.className,
    props = __rest$1(_a, ['theme', 'divider', 'pad', 'children', 'className']);
  var screenHydrateKey = useWindowSize().screenHydrateKey;
  var paperThemes = cx(
    style$u.Paper,
    className,
    ((_b = {}),
    (_b[style$u.isElevated] = theme === 'elevated'),
    (_b[style$u.isMedium] = theme === 'medium'),
    (_b[style$u.isDark] = theme === 'dark'),
    (_b[style$u.withDivider] = divider),
    _b),
  );
  var padStyles = {};
  var toPx = function (size) {
    return ''.concat(size * gridPadding, 'px');
  };
  if (typeof pad === 'object') {
    padStyles = {
      paddingTop: toPx(pad.top),
      paddingBottom: toPx(pad.bottom),
      paddingRight: toPx(pad.right),
      paddingLeft: toPx(pad.left),
    };
  } else if (pad) {
    padStyles = { padding: toPx(pad) };
  }
  return jsxRuntime.jsx(
    'div',
    __assign({}, props, {
      className: paperThemes,
      style: __assign(__assign({}, padStyles), props.style),
      children: children,
    }),
    screenHydrateKey,
  );
};
Paper.propTypes = {
  theme: PropTypes__default['default'].oneOf(['plain', 'elevated', 'medium', 'dark']),
  divider: PropTypes__default['default'].bool,
  pad: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].number,
    PropTypes__default['default'].shape({
      top: PropTypes__default['default'].number,
      bottom: PropTypes__default['default'].number,
      left: PropTypes__default['default'].number,
      right: PropTypes__default['default'].number,
    }),
  ]),
};

var style$t = {
  KPICard: 'htco-KPICard',
  KPICardIcon: 'htco-KPICardIcon',
  KPICardTextWrap: 'htco-KPICardTextWrap',
  KPICardValue: 'htco-KPICardValue',
  KPICardBeforeText: 'htco-KPICardBeforeText',
};

var size$1 = {
  minWidth: 300,
};
var KPICard = function (_a) {
  var icon = _a.icon,
    value = _a.value,
    beforeText = _a.beforeText,
    afterText = _a.afterText,
    _b = _a.lineBreaks,
    lineBreaks = _b === void 0 ? 0 : _b,
    props = __rest$1(_a, ['icon', 'value', 'beforeText', 'afterText', 'lineBreaks']);
  return jsxRuntime.jsxs('div', {
    className: cx(style$t.KPICard, props.className),
    style: size$1,
    children: [
      icon && jsxRuntime.jsx(Icon, { size: '2x', name: icon, className: style$t.KPICardIcon }),
      jsxRuntime.jsxs('div', {
        className: style$t.KPICardTextWrap,
        children: [
          beforeText && jsxRuntime.jsx('span', { className: style$t.KPICardBeforeText, children: beforeText }),
          jsxRuntime.jsx('div', { className: style$t.KPICardValue, children: value }),
          afterText && jsxRuntime.jsx('span', { className: style$t.KPICardAfterText, children: afterText }),
          __spreadArray([], Array(lineBreaks), true).map(function (n) {
            return jsxRuntime.jsx('br', {}, n + 1);
          }),
        ],
      }),
    ],
  });
};
KPICard.propTypes = {
  icon: PropTypes__default['default'].string,
  value: PropTypes__default['default'].node.isRequired,
  beforeText: PropTypes__default['default'].node,
  afterText: PropTypes__default['default'].node,
  lineBreaks: PropTypes__default['default'].number,
};
KPICard.size = size$1;

var style$s = {
  ContentCard: 'htco-ContentCard',
  ContentCardImage: 'htco-ContentCardImage',
  ContentCardImageAlt: 'htco-ContentCardImageAlt',
  ContentCardLink: 'htco-ContentCardLink',
  ContentCardBody: 'htco-ContentCardBody',
  ContentCardInnerWrap: 'htco-ContentCardInnerWrap',
  ContentCardResourcesTitle: 'htco-ContentCardResourcesTitle',
  ContentCardMeta: 'htco-ContentCardMeta',
  ContentCardCategory: 'htco-ContentCardCategory',
  ContentCardCornerButton: 'htco-ContentCardCornerButton',
  ContentCardCornerButtonMod: 'htco-ContentCardCornerButtonMod',
  ContentCardCornerButtonLink: 'htco-ContentCardCornerButtonLink',
};

var size = {
  width: 307,
};
var ContentCard = function (_a) {
  var link = _a.link,
    target = _a.target,
    image = _a.image,
    alt = _a.alt,
    category = _a.category,
    categoryURL = _a.categoryURL,
    title = _a.title,
    description = _a.description,
    arrowLabel = _a.arrowLabel;
  return jsxRuntime.jsxs('div', {
    className: style$s.ContentCard,
    style: size,
    children: [
      jsxRuntime.jsx('figure', {
        className: style$s.ContentCardImage,
        style: {
          backgroundImage: 'url('.concat(image, ')'),
        },
        children: jsxRuntime.jsx('figcaption', { className: style$s.ContentCardImageAlt, children: alt }),
      }),
      jsxRuntime.jsxs('div', {
        className: style$s.ContentCardBody,
        children: [
          jsxRuntime.jsxs('div', {
            className: style$s.ContentCardInnerWrap,
            children: [
              jsxRuntime.jsx('div', {
                className: style$s.ContentCardMeta,
                children: categoryURL
                  ? jsxRuntime.jsx('a', { href: categoryURL, title: title, children: category })
                  : jsxRuntime.jsx('div', { className: style$s.ContentCardCategory, children: category }),
              }),
              jsxRuntime.jsx('a', {
                href: link,
                target: target,
                className: style$s.ContentCardLink,
                children: jsxRuntime.jsxs('h3', {
                  className: description && style$s.ContentCardResourcesTitle,
                  children: [
                    title,
                    !arrowLabel &&
                      jsxRuntime.jsx('div', {
                        className: style$s.ContentCardCornerButton,
                        children: jsxRuntime.jsx(Icon, { name: 'icon-arrow-forward' }),
                      }),
                  ],
                }),
              }),
              description && jsxRuntime.jsx('p', { children: description }),
            ],
          }),
          arrowLabel &&
            jsxRuntime.jsx('div', {
              className: style$s.ContentCardCornerButtonMod,
              children: jsxRuntime.jsxs('a', {
                className: style$s.ContentCardCornerButtonLink,
                href: link,
                children: [arrowLabel, jsxRuntime.jsx(Icon, { name: 'arrow-right' })],
              }),
            }),
        ],
      }),
    ],
  });
};
ContentCard.propTypes = {
  link: PropTypes__default['default'].string.isRequired,
  target: PropTypes__default['default'].oneOf(['_blank', '_self', '_parent', '_top']),
  image: PropTypes__default['default'].node.isRequired,
  alt: PropTypes__default['default'].string,
  category: PropTypes__default['default'].string.isRequired,
  title: PropTypes__default['default'].string.isRequired,
  description: PropTypes__default['default'].string,
  arrowLabel: PropTypes__default['default'].string,
  size: PropTypes__default['default'].node,
};
ContentCard.defaultProps = {
  target: '_self',
};
ContentCard.size = size;

var Grid = function (_a) {
  var children = _a.children,
    props = __rest$1(_a, ['children']);
  // @ts-expect-error Grid2 cannot be used as a JSX component.
  return jsxRuntime.jsx(Grid2__default['default'], __assign({}, props, { children: children }));
};

var withinRange = function (n, min, max) {
  return Math.min(Math.max(n, min), max);
};
var getValuesFromRange = function (min, max, step) {
  if (step === void 0) {
    step = 1;
  }
  var range = [];
  for (var i = min; i <= max; i += step) {
    range.push(i);
  }
  return range;
};
var convertToMoneyString = function (number, options) {
  return number.toLocaleString(
    'en-US',
    __assign(
      { style: 'currency', currency: 'USD' },
      (options === null || options === void 0 ? void 0 : options.stripDecimal) && {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      },
    ),
  );
};
var formatting = {
  convertToMoneyString: convertToMoneyString,
  getValuesFromRange: getValuesFromRange,
  withinRange: withinRange,
};

var style$r = {
  Slider: 'htco-Slider',
  SliderControl: 'htco-SliderControl',
  isDisabled: 'htco-isDisabled',
  SliderTrack: 'htco-SliderTrack',
  SliderProgress: 'htco-SliderProgress',
  SliderInput: 'htco-SliderInput',
};

// This component uses the browser "range" input as it's control
// but styles the track and progress bar independently to get the right UX behavior
var Slider = function (_a) {
  var _b, _c;
  var label = _a.label,
    name = _a.name,
    value = _a.value,
    _d = _a.min,
    min = _d === void 0 ? 0 : _d,
    _e = _a.max,
    max = _e === void 0 ? 100 : _e,
    _f = _a.step,
    step = _f === void 0 ? 1 : _f,
    formatter = _a.formatter,
    disabled = _a.disabled,
    error = _a.error,
    onChange = _a.onChange;
  var selectedValue = parseInt(typeof value === 'number' || typeof value === 'string' ? value : min);
  var progressWidth = ((selectedValue - min) / (max - min)) * 100;
  var handleFormat = function (num) {
    return formatter ? formatter(num) : num;
  };
  var handleChange = function (e) {
    var newValue = withinRange(e.currentTarget.value, min, max);
    onChange(newValue, name, error);
  };
  return jsxRuntime.jsxs('div', {
    children: [
      jsxRuntime.jsx(Label$1, { error: error, children: label }),
      jsxRuntime.jsxs('div', {
        className: style$r.Slider,
        children: [
          jsxRuntime.jsx('div', { className: style$r.SliderMin, children: handleFormat(min) }),
          jsxRuntime.jsx('div', {
            className: cx(style$r.SliderControl, ((_b = {}), (_b[style$r.isDisabled] = !!disabled), _b)),
            children: jsxRuntime.jsxs('div', {
              className: style$r.SliderTrack,
              children: [
                jsxRuntime.jsx('div', {
                  className: style$r.SliderProgress,
                  style: { width: ''.concat(Math.min(progressWidth, 100), '%') },
                }),
                jsxRuntime.jsx('input', {
                  className: cx(style$r.SliderInput, ((_c = {}), (_c[style$r.isDisabled] = !!disabled), _c)),
                  value: selectedValue,
                  type: 'range',
                  name: name,
                  min: min,
                  max: max,
                  step: step,
                  disabled: disabled,
                  'aria-label': label,
                  onChange: handleChange,
                }),
              ],
            }),
          }),
          jsxRuntime.jsx('div', { className: style$r.SliderMax, children: handleFormat(max) }),
        ],
      }),
    ],
  });
};
Slider.propTypes = {
  label: PropTypes__default['default'].node,
  name: PropTypes__default['default'].string,
  value: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].number,
    PropTypes__default['default'].string,
  ]),
  min: PropTypes__default['default'].number,
  max: PropTypes__default['default'].number,
  step: PropTypes__default['default'].number,
  formatter: PropTypes__default['default'].func,
  disabled: PropTypes__default['default'].bool,
  error: PropTypes__default['default'].string,
  onChange: PropTypes__default['default'].func,
};

var replaceForbiddenChars = function (val) {
  return val.replace(/[^\d.$,%-]/g, '');
};
var formatter = function (n, options) {
  var formatter = new Intl.NumberFormat('en-US', options);
  return formatter.format(n);
};
var NumberInput = function (_a) {
  var className = _a.className,
    _b = _a.type,
    type = _b === void 0 ? 'integer' : _b,
    value = _a.value,
    _c = _a.precision,
    precision = _c === void 0 ? 2 : _c,
    _d = _a.min,
    min = _d === void 0 ? 0 : _d,
    _e = _a.max,
    max = _e === void 0 ? 100000000 : _e,
    _f = _a.align,
    align = _f === void 0 ? 'left' : _f,
    props = __rest$1(_a, ['className', 'type', 'value', 'precision', 'min', 'max', 'align']);
  useRequiredValidation(__assign({ value: value }, props));
  // Maintain the display string version of the value in state
  // so that this component can assume value is a number
  // This logic keeps value and displayValue in sync
  var _g = React.useState(''.concat(value)),
    displayValue = _g[0],
    setDisplayValue = _g[1];
  React.useEffect(
    function () {
      if (getNumberValue(displayValue) !== value) {
        setDisplayValue(getFormattedValue(value));
      }
    },
    [value],
  );
  var FORMATS = {
    currency: function (n) {
      return formatter(n, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      });
    },
    integer: function (n) {
      return formatter(n, {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    decimal: function (n) {
      return formatter(n, {
        style: 'decimal',
        maximumFractionDigits: precision,
      });
    },
    percent: function (n) {
      return formatter(n / 100, {
        style: 'percent',
        maximumFractionDigits: precision,
      });
    },
  };
  var getFormattedValue = function (val) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    var format = FORMATS[type];
    return val === '' || value === undefined ? '' : format(getNumberValue(''.concat(val)));
  };
  var getNumberValue = function (val) {
    if (val === '') {
      return undefined;
    }
    var cleanNumber = val.replace(/[^\d.]/g, '');
    return withinRange(cleanNumber, min, max);
  };
  var handleBlur = function (val, name, err) {
    var _a;
    (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, getNumberValue(val), name, err);
    // @ts-expect-error TS(2554): Expected 3 arguments, but got 1.
    handleChange(getFormattedValue(val));
  };
  var handleChange = function (val, name, err) {
    var _a;
    setDisplayValue(replaceForbiddenChars(val));
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, getNumberValue(val), name, err);
  };
  return jsxRuntime.jsx(
    TextInput,
    __assign({}, props, {
      className: className,
      value: displayValue,
      inputMode: type === 'integer' || precision === 0 ? 'numeric' : 'decimal',
      onBlur: handleBlur,
      onChange: handleChange,
      style: __assign({ textAlign: align }, props.style),
    }),
  );
};
NumberInput.propTypes = {
  name: PropTypes__default['default'].string,
  label: PropTypes__default['default'].node,
  value: PropTypes__default['default'].number,
  type: PropTypes__default['default'].oneOf(['integer', 'decimal', 'currency', 'percent']),
  precision: PropTypes__default['default'].number,
  min: PropTypes__default['default'].number,
  max: PropTypes__default['default'].number,
  align: PropTypes__default['default'].oneOf(['left', 'right', 'center']),
  error: PropTypes__default['default'].node,
  required: PropTypes__default['default'].bool,
  onChange: PropTypes__default['default'].func,
  registerRequiredField: PropTypes__default['default'].func,
  unregisterRequiredField: PropTypes__default['default'].func,
};

var useKeyboardOnlyFocus = function () {
  var _a = React.useState(false),
    mouseFocused = _a[0],
    setMouseFocused = _a[1];
  return {
    showFocus: !mouseFocused,
    focusListeners: {
      onMouseDown: function () {
        return setMouseFocused(true);
      },
      onBlur: function () {
        return setMouseFocused(false);
      },
    },
  };
};

var style$q = {
  Accordion: 'htco-Accordion',
  isHeavy: 'htco-isHeavy',
  isOpen: 'htco-isOpen',
  AccordionHeader: 'htco-AccordionHeader',
  AccordionExpandIcon: 'htco-AccordionExpandIcon',
  AccordionContent: 'htco-AccordionContent',
  isWithArrowContent: 'htco-isWithArrowContent',
  withFocus: 'htco-withFocus',
  isWithArrow: 'htco-isWithArrow',
  AccordionHeaderContent: 'htco-AccordionHeaderContent',
};

var Accordion = function (_a) {
  var _b, _c, _d, _e;
  var _f = _a.theme,
    theme = _f === void 0 ? 'with-plus' : _f,
    header = _a.header,
    className = _a.className,
    children = _a.children,
    onChange = _a.onChange,
    props = __rest$1(_a, ['theme', 'header', 'className', 'children', 'onChange']);
  var _g = React.useState(props.isOpen || false),
    isOpen = _g[0],
    setIsOpen = _g[1];
  var _h = useKeyboardOnlyFocus(),
    showFocus = _h.showFocus,
    focusListeners = _h.focusListeners;
  React.useEffect(
    function () {
      if (props.isOpen !== null) {
        setIsOpen(props.isOpen);
      }
    },
    [props.isOpen],
  );
  return jsxRuntime.jsxs('div', {
    className: cx(
      style$q.Accordion,
      className,
      ((_b = {}), (_b[style$q.isHeavy] = theme.endsWith('heavy')), (_b[style$q.isOpen] = !!isOpen), _b),
    ),
    children: [
      jsxRuntime.jsxs(
        'div',
        __assign(
          {
            className: cx(
              style$q.AccordionHeader,
              ((_c = {}),
              (_c[style$q.withFocus] = showFocus),
              (_c[style$q.isWithArrow] = theme.startsWith('with-arrow')),
              _c),
            ),
            role: 'button',
            tabIndex: 0,
            onKeyDown: handleKeyboardClick,
            onClick: function () {
              setIsOpen(!isOpen);
              onChange === null || onChange === void 0 ? void 0 : onChange(!isOpen);
            },
          },
          focusListeners,
          {
            children: [
              jsxRuntime.jsx('span', { className: style$q.AccordionHeaderContent, children: header }),
              jsxRuntime.jsx('span', {
                className: cx(style$q.AccordionExpandIcon, ((_d = {}), (_d[style$q.isOpen] = !!isOpen), _d)),
              }),
            ],
          },
        ),
      ),
      jsxRuntime.jsx(SlideDown, {
        visible: isOpen,
        children: jsxRuntime.jsx('div', {
          className: cx(
            style$q.AccordionContent,
            ((_e = {}), (_e[style$q.isWithArrowContent] = theme.startsWith('with-arrow')), _e),
          ),
          children: children,
        }),
      }),
    ],
  });
};
Accordion.propTypes = {
  header: PropTypes__default['default'].node.isRequired,
  children: PropTypes__default['default'].any.isRequired,
  theme: PropTypes__default['default'].oneOf(['with-plus', 'with-arrow', 'with-arrow-heavy']),
  isOpen: PropTypes__default['default'].bool,
  onChange: PropTypes__default['default'].func,
};

var style$p = {
  Table: 'htco-Table',
  isCompact: 'htco-isCompact',
  hasRowHover: 'htco-hasRowHover',
  MobileTable: 'htco-MobileTable',
  MobileTableInner: 'htco-MobileTableInner',
  MobileTableMore: 'htco-MobileTableMore',
  MobileTableColumnLabel: 'htco-MobileTableColumnLabel',
};

var MobileTable = function (_a) {
  var columns = _a.columns,
    data = _a.data,
    onRowClick = _a.onRowClick,
    className = _a.className,
    groupBy = _a.groupBy,
    getMobileRowAction = _a.getMobileRowAction,
    defaultRowsOpen = _a.defaultRowsOpen;
  var getCellDisplay = function (col, item) {
    return col.cellDisplay ? col.cellDisplay(item) : item[col.key] || '';
  };
  return jsxRuntime.jsx('div', {
    children: data.map(function (item) {
      var headerCol =
        (groupBy &&
          columns.find(function (col) {
            return col.key === groupBy;
          })) ||
        columns[0];
      var mobileAction =
        getMobileRowAction === null || getMobileRowAction === void 0 ? void 0 : getMobileRowAction(item);
      var handleIsRowOpen = typeof defaultRowsOpen === 'function' ? defaultRowsOpen(item) : !!defaultRowsOpen;
      return jsxRuntime.jsx(
        Accordion,
        {
          isOpen: handleIsRowOpen,
          className: cx(style$p.MobileTable, className),
          header: getCellDisplay(headerCol, item),
          children: jsxRuntime.jsx('table', {
            className: style$p.MobileTableInner,
            children: jsxRuntime.jsxs('tbody', {
              children: [
                columns.map(function (col, index) {
                  var showCell = !groupBy ? index !== 0 : col.key !== groupBy;
                  if (showCell) {
                    return jsxRuntime.jsxs(
                      'tr',
                      {
                        children: [
                          jsxRuntime.jsx('td', { className: style$p.MobileTableColumnLabel, children: col.label }),
                          jsxRuntime.jsx('td', { children: getCellDisplay(col, item) }),
                        ],
                      },
                      col.key,
                    );
                  }
                  return null;
                }),
                (onRowClick || mobileAction) &&
                  jsxRuntime.jsx('tr', {
                    className: style$p.MobileTableMore,
                    children: jsxRuntime.jsx('td', {
                      colSpan: 2,
                      children:
                        mobileAction ||
                        jsxRuntime.jsx(Button, {
                          theme: 'link',
                          onClick: function () {
                            onRowClick(item);
                          },
                          children: 'View More',
                        }),
                    }),
                  }),
              ],
            }),
          }),
        },
        item.id || item.key,
      );
    }),
  });
};
MobileTable.propTypes = {
  columns: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      label: PropTypes__default['default'].node,
      key: PropTypes__default['default'].string.isRequired,
      cellDisplay: PropTypes__default['default'].func,
      align: PropTypes__default['default'].oneOf(['left', 'right', 'center']),
      width: PropTypes__default['default'].string,
    }),
  ),
  data: PropTypes__default['default'].arrayOf(PropTypes__default['default'].object),
  groupBy: PropTypes__default['default'].string,
  getMobileRowAction: PropTypes__default['default'].func,
  onRowClick: PropTypes__default['default'].func,
};

var Table = function (_a) {
  var _b;
  var columns = _a.columns,
    data = _a.data,
    _c = _a.showHeader,
    showHeader = _c === void 0 ? true : _c,
    _d = _a.compact,
    compact = _d === void 0 ? false : _d,
    mobileProps = _a.mobileProps,
    onRowClick = _a.onRowClick,
    className = _a.className,
    _e = _a.mobileBreakpoint,
    mobileBreakpoint = _e === void 0 ? 'sm' : _e,
    props = __rest$1(_a, [
      'columns',
      'data',
      'showHeader',
      'compact',
      'mobileProps',
      'onRowClick',
      'className',
      'mobileBreakpoint',
    ]);
  var tableStyles = cx(
    style$p.Table,
    className,
    ((_b = {}), (_b[style$p.isCompact] = compact), (_b[style$p.hasRowHover] = !!onRowClick), _b),
  );
  var getColumnStyles = function (col) {
    return {
      textAlign: col.align,
      width: col.width,
    };
  };
  var isScreenSize = useWindowSize().isScreenSize;
  if (isScreenSize(mobileBreakpoint)) {
    return jsxRuntime.jsx(
      MobileTable,
      __assign({ columns: columns, data: data, className: className, onRowClick: onRowClick }, mobileProps),
    );
  }
  return jsxRuntime.jsxs(
    'table',
    __assign({}, props, {
      className: tableStyles,
      children: [
        showHeader &&
          jsxRuntime.jsx('thead', {
            children: jsxRuntime.jsx('tr', {
              children: columns.map(function (col) {
                return jsxRuntime.jsx(
                  'th',
                  { className: col.className, style: getColumnStyles(col), children: col.label || '' },
                  col.key,
                );
              }),
            }),
          }),
        jsxRuntime.jsx('tbody', {
          children: data.map(function (item) {
            var key = item.id || item.key;
            return jsxRuntime.jsx(
              'tr',
              {
                onClick:
                  onRowClick &&
                  function () {
                    return onRowClick(item);
                  },
                children: columns.map(function (col) {
                  return jsxRuntime.jsx(
                    'td',
                    {
                      className: col.className,
                      style: getColumnStyles(col),
                      children: col.cellDisplay ? col.cellDisplay(item) : item[col.key] || '',
                    },
                    ''.concat(key, '-').concat(col.key),
                  );
                }),
              },
              key,
            );
          }),
        }),
      ],
    }),
  );
};
Table.propTypes = {
  columns: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      label: PropTypes__default['default'].node,
      key: PropTypes__default['default'].string.isRequired,
      cellDisplay: PropTypes__default['default'].func,
      align: PropTypes__default['default'].oneOf(['left', 'right', 'center']),
      width: PropTypes__default['default'].string,
    }),
  ),
  data: PropTypes__default['default'].arrayOf(PropTypes__default['default'].object),
  compact: PropTypes__default['default'].bool,
  showHeader: PropTypes__default['default'].bool,
  mobileProps: PropTypes__default['default'].object,
  onRowClick: PropTypes__default['default'].func,
  mobileBreakpoint: PropTypes__default['default'].oneOf(['xs', 'sm', 'md', 'lg']),
};

var useEscape = function (enabled, handler) {
  React.useEffect(
    function () {
      if (typeof window !== 'undefined') {
        var keyboardListener_1 = function (e) {
          if (e.key === 'Escape' && enabled) {
            handler(e);
          }
        };
        document.addEventListener('keydown', keyboardListener_1);
        return function () {
          document.removeEventListener('keydown', keyboardListener_1);
        };
      }
    },
    [handler],
  );
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

var eq$2 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
    index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
    index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
  listCacheDelete = _listCacheDelete,
  listCacheGet = _listCacheGet,
  listCacheHas = _listCacheHas,
  listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
    result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var getNative$5 = _getNative,
  root$5 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$5(root$5, 'Map');

var _Map = Map$4;

var getNative$4 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$4(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$8.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$9.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$7.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$8.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
  hashDelete = _hashDelete,
  hashGet = _hashGet,
  hashHas = _hashHas,
  hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
  ListCache$2 = _ListCache,
  Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    hash: new Hash(),
    map: new (Map$3 || ListCache$2)(),
    string: new Hash(),
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean'
    ? value !== '__proto__'
    : value === null;
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
    size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
  mapCacheDelete = _mapCacheDelete,
  mapCacheGet = _mapCacheGet,
  mapCacheHas = _mapCacheHas,
  mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
  Map$2 = _Map,
  MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
  stackClear = _stackClear,
  stackDelete = _stackDelete,
  stackGet = _stackGet,
  stackHas = _stackHas,
  stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$3(entries) {
  var data = (this.__data__ = new ListCache(entries));
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$3.prototype.clear = stackClear;
Stack$3.prototype['delete'] = stackDelete;
Stack$3.prototype.get = stackGet;
Stack$3.prototype.has = stackHas;
Stack$3.prototype.set = stackSet;

var _Stack = Stack$3;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
  setCacheAdd = _setCacheAdd,
  setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$2(values) {
  var index = -1,
    length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$1();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;

var _SetCache = SetCache$2;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$2(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$2;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$2(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$2;

var SetCache$1 = _SetCache,
  arraySome$1 = _arraySome,
  cacheHas$1 = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
    arrLength = array.length,
    othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (
        !arraySome$1(other, function (othValue, othIndex) {
          if (
            !cacheHas$1(seen, othIndex) &&
            (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))
          ) {
            return seen.push(othIndex);
          }
        })
      ) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$4 = _root;

/** Built-in value references. */
var Uint8Array$3 = root$4.Uint8Array;

var _Uint8Array = Uint8Array$3;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
    result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$3(set) {
  var index = -1,
    result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$3;

var Symbol$5 = _Symbol,
  Uint8Array$2 = _Uint8Array,
  eq$1 = eq_1,
  equalArrays$1 = _equalArrays,
  mapToArray = _mapToArray,
  setToArray$2 = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$1 = '[object Error]',
  mapTag$4 = '[object Map]',
  numberTag$3 = '[object Number]',
  regexpTag$2 = '[object RegExp]',
  setTag$4 = '[object Set]',
  stringTag$3 = '[object String]',
  symbolTag$2 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$3 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$5 ? Symbol$5.prototype : undefined,
  symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$3:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$2:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;

    case boolTag$3:
    case dateTag$2:
    case numberTag$3:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$2:
    case stringTag$3:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag$4:
      var convert = mapToArray;

    case setTag$4:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray$2);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$2:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$3;

var arrayPush$2 = _arrayPush,
  isArray$d = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$d(object) ? result : arrayPush$2(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter = _arrayFilter,
  stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$1
  ? stubArray$1
  : function (object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

var _getSymbols = getSymbols$3;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$1 = _isPrototype,
  nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$5.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$1(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

var arrayLikeKeys = _arrayLikeKeys,
  baseKeys = _baseKeys,
  isArrayLike$3 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$7(object) {
  return isArrayLike$3(object) ? arrayLikeKeys(object) : baseKeys(object);
}

var keys_1 = keys$7;

var baseGetAllKeys$1 = _baseGetAllKeys,
  getSymbols$2 = _getSymbols,
  keys$6 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$6, getSymbols$2);
}

var _getAllKeys = getAllKeys$2;

var getAllKeys$1 = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$4.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
    objProps = getAllKeys$1(object),
    objLength = objProps.length,
    othProps = getAllKeys$1(other),
    othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$6.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (
      !(compared === undefined
        ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack)
        : compared)
    ) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (
      objCtor != othCtor &&
      'constructor' in object &&
      'constructor' in other &&
      !(
        typeof objCtor == 'function' &&
        objCtor instanceof objCtor &&
        typeof othCtor == 'function' &&
        othCtor instanceof othCtor
      )
    ) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$3 = _getNative,
  root$3 = _root;

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$3(root$3, 'DataView');

var _DataView = DataView$2;

var getNative$2 = _getNative,
  root$2 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$2(root$2, 'Promise');

var _Promise = Promise$2;

var getNative$1 = _getNative,
  root$1 = _root;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$1(root$1, 'Set');

var _Set = Set$3;

var getNative = _getNative,
  root = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative(root, 'WeakMap');

var _WeakMap = WeakMap$2;

var DataView$1 = _DataView,
  Map$1 = _Map,
  Promise$1 = _Promise,
  Set$2 = _Set,
  WeakMap$1 = _WeakMap,
  baseGetTag$4 = _baseGetTag,
  toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
  objectTag$3 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$3 = '[object Set]',
  weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
  mapCtorString = toSource(Map$1),
  promiseCtorString = toSource(Promise$1),
  setCtorString = toSource(Set$2),
  weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$4 = baseGetTag$4;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (
  (DataView$1 && getTag$4(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
  (Map$1 && getTag$4(new Map$1()) != mapTag$3) ||
  (Promise$1 && getTag$4(Promise$1.resolve()) != promiseTag) ||
  (Set$2 && getTag$4(new Set$2()) != setTag$3) ||
  (WeakMap$1 && getTag$4(new WeakMap$1()) != weakMapTag$1)
) {
  getTag$4 = function (value) {
    var result = baseGetTag$4(value),
      Ctor = result == objectTag$3 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$3;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$3;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$4;

var Stack$2 = _Stack,
  equalArrays = _equalArrays,
  equalByTag = _equalByTag,
  equalObjects = _equalObjects,
  getTag$3 = _getTag,
  isArray$c = isArray_1,
  isBuffer$2 = isBufferExports,
  isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$3.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$c(object),
    othIsArr = isArray$c(other),
    objTag = objIsArr ? arrayTag$1 : getTag$3(object),
    othTag = othIsArr ? arrayTag$1 : getTag$3(other);

  objTag = objTag == argsTag$1 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$2 : othTag;

  var objIsObj = objTag == objectTag$2,
    othIsObj = othTag == objectTag$2,
    isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$2(object)) {
    if (!isBuffer$2(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$2());
    return objIsArr || isTypedArray(object)
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$5.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty$5.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$2());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$2());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
  isObjectLike$6 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$6(value) && !isObjectLike$6(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

var _baseIsEqual = baseIsEqual$3;

var baseIsEqual$2 = _baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual$2(value, other) {
  return baseIsEqual$2(value, other);
}

var isEqual_1 = isEqual$2;

var _isEqual = /*@__PURE__*/ getDefaultExportFromCjs(isEqual_1);

var useAsync = function (asyncFunction, options) {
  var _a = options !== null && options !== void 0 ? options : {},
    _b = _a.immediate,
    immediate = _b === void 0 ? false : _b,
    _c = _a.params,
    params = _c === void 0 ? [] : _c,
    defaultResults = _a.defaultResults,
    defaultLoading = _a.defaultLoading,
    executeThrow = _a.executeThrow,
    onError = _a.onError,
    onSuccess = _a.onSuccess;
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  var _d = React.useState(defaultLoading || false),
    loading = _d[0],
    setLoading = _d[1];
  var _e = React.useState(defaultResults),
    results = _e[0],
    setResults = _e[1];
  var _f = React.useState(null),
    error = _f[0],
    setError = _f[1];
  var mountedRef = React.useRef(true);
  // Helper to handle success responses
  var handleSuccess = function (response) {
    if (!mountedRef.current) return response;
    setResults(response);
    if (typeof onSuccess === 'function') {
      onSuccess(response);
    } else if (onSuccess !== undefined) {
      throw new TypeError('Expected typeof onSuccess to be "function". Found: "'.concat(typeof onSuccess, '"'));
    }
    return response;
  };
  // Helper to handle errors
  var handleError = function (error) {
    if (!mountedRef.current) return null;
    setError(error);
    setResults(defaultResults);
    if (typeof onError === 'function') {
      onError(error);
    }
    if (executeThrow) {
      throw error;
    }
  };
  // The execute function wraps asyncFunction and handles setting state for loading, results, and error.
  var execute = React.useCallback(
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setLoading(true);
              setError(null);
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3, 4, 5]);
              return [4 /*yield*/, asyncFunction.apply(void 0, args)];
            case 2:
              response = _a.sent();
              return [2 /*return*/, handleSuccess(response)];
            case 3:
              error_1 = _a.sent();
              handleError(error_1);
              return [3 /*break*/, 5];
            case 4:
              if (mountedRef.current) {
                setLoading(false);
              }
              return [7 /*endfinally*/];
            case 5:
              return [2 /*return*/];
          }
        });
      });
    },
    [asyncFunction, onError, onSuccess, defaultResults, executeThrow],
  );
  var prevParams = React.useRef([]);
  var immediateFuncParams = React.useMemo(
    function () {
      if (_isEqual(prevParams.current, params)) {
        return prevParams.current;
      }
      prevParams.current = params;
      return params;
    },
    [params],
  );
  // Call execute if we want to fire it right away
  React.useEffect(
    function () {
      if (immediate) {
        execute.apply(void 0, immediateFuncParams);
      }
    },
    [execute, immediate, immediateFuncParams],
  );
  React.useEffect(function () {
    mountedRef.current = true;
    return function () {
      mountedRef.current = false;
    };
  }, []);
  return {
    execute: execute,
    loading: loading,
    results: results,
    error: error,
    setResults: setResults,
    setError: setError,
  };
};

var useBoolState = function (defaultState) {
  if (defaultState === void 0) {
    defaultState = false;
  }
  var _a = React.useState(defaultState),
    bool = _a[0],
    setBool = _a[1];
  return {
    value: bool,
    toggle: function () {
      setBool(!bool);
    },
    setTrue: function () {
      setBool(true);
    },
    setFalse: function () {
      setBool(false);
    },
  };
};

var useFocusTrap = function () {
  var element = React.useRef(null);
  var handleFocus = function (e) {
    var _a;
    var focusable =
      (_a = element.current) === null || _a === void 0
        ? void 0
        : _a.querySelectorAll(
            'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select',
          );
    if (!focusable) return;
    var firstElement = Array.from(focusable)[0];
    var lastElement = focusable[focusable.length - 1];
    if (e.keyCode === 9 || e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  };
  React.useEffect(
    function () {
      var refInstance = element.current;
      if (refInstance) {
        refInstance.addEventListener('keydown', handleFocus);
        return function () {
          refInstance.removeEventListener('keydown', handleFocus);
        };
      }
    },
    [element.current],
  );
  return element;
};

var debounce$2 = debounce_1,
  isObject$4 = isObject_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
    trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject$4(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$2(func, wait, {
    leading: leading,
    maxWait: wait,
    trailing: trailing,
  });
}

var throttle_1 = throttle;

var _throttle = /*@__PURE__*/ getDefaultExportFromCjs(throttle_1);

// hard-coded defaults are derived from SESSION_SECURITY_WARN_AFTER and SESSION_SECURITY_EXPIRE_AFTER
// from base.py in eng_portals
var DEFAULT_WARNING_DELAY = 1000 * 9 * 60;
var DEFAULT_LOGOUT_DELAY = 1000 * 10 * 60;
var LOGOUT_RESPONSE = 'logout';
var DEFAULT_EVENTS = ['mousemove', 'scroll', 'keyup', 'click', 'touchstart', 'touchend', 'touchmove'];
var getTimeInSeconds = function (time) {
  return Math.floor(time / 1000);
};
var getTimeDifferentialInSeconds = function (before, after) {
  return getTimeInSeconds((after || new Date()) - before);
};
var useSessionSecurityTimer = function (request, _a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.idleWarnTime,
    idleWarnTime = _c === void 0 ? DEFAULT_WARNING_DELAY : _c,
    _d = _b.idleLogoutTime,
    idleLogoutTime = _d === void 0 ? DEFAULT_LOGOUT_DELAY : _d,
    _e = _b.customEvents,
    customEvents = _e === void 0 ? [] : _e;
  var execute = useAsync(request, { immediate: false }).execute;
  var lastActivity = React.useRef(new Date());
  var _f = React.useState(false),
    shouldLogOut = _f[0],
    setShouldLogOut = _f[1];
  var _g = React.useState(false),
    shouldWarn = _g[0],
    setShouldWarn = _g[1];
  var nextPingTimer = React.useRef(null);
  var calculateIsWarningTime = function (idleTimeInSeconds) {
    return idleTimeInSeconds >= getTimeInSeconds(idleWarnTime);
  };
  var refreshTimerAndUpdateState = function () {
    if (nextPingTimer.current) clearTimeout(nextPingTimer.current);
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    var idleTime = getTimeDifferentialInSeconds(lastActivity.current);
    var isTimeToWarn = calculateIsWarningTime(idleTime);
    var followUpPing;
    if (isTimeToWarn) {
      setShouldWarn(true);
      followUpPing = getTimeInSeconds(idleLogoutTime) - idleTime;
    } else {
      setShouldWarn(false);
      followUpPing = getTimeInSeconds(idleWarnTime) - idleTime;
    }
    // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
    nextPingTimer.current = setTimeout(checkWithServer, followUpPing * 1000);
  };
  var checkWithServer = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var getIdleTime, results, userActiveInAnotherApp, lastActivityInSeconds;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            getIdleTime = function () {
              return getTimeDifferentialInSeconds(lastActivity.current);
            };
            return [4 /*yield*/, execute(getIdleTime())];
          case 1:
            results = _a.sent();
            if (results === LOGOUT_RESPONSE) {
              return [2 /*return*/, setShouldLogOut(true)];
            }
            userActiveInAnotherApp = Number.isInteger(results) && results < getIdleTime();
            if (userActiveInAnotherApp) {
              lastActivityInSeconds = lastActivity.current.getSeconds();
              lastActivity.current.setSeconds(
                // move forward last activity timestamp by the difference in client/server idle time
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                lastActivityInSeconds + (getIdleTime() - results),
              );
            }
            refreshTimerAndUpdateState();
            return [2 /*return*/];
        }
      });
    });
  };
  // alert server and cease warning state, throttled to every second
  var onActivityDetected = _throttle(function () {
    var oldActivity = lastActivity.current;
    lastActivity.current = new Date();
    // determines warning state using ref, react state inaccessible due to eventListener in react hook
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    var isWarning = calculateIsWarningTime(getTimeDifferentialInSeconds(oldActivity));
    if (isWarning) {
      checkWithServer();
    }
  }, 1000);
  // set up timers and add event listeners on mount
  React.useEffect(function () {
    // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
    nextPingTimer.current = setTimeout(checkWithServer, idleWarnTime);
    var userEvents = __spreadArray(__spreadArray([], DEFAULT_EVENTS, true), customEvents, true);
    userEvents.forEach(function (event) {
      document.body.addEventListener(event, onActivityDetected);
    });
    return function () {
      // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      clearTimeout(nextPingTimer.current);
      userEvents.forEach(function (event) {
        document.body.removeEventListener(event, onActivityDetected);
      });
    };
  }, []);
  return { shouldWarn: shouldWarn, shouldLogOut: shouldLogOut };
};

var FadeIn = React.forwardRef(function (_a, ref) {
  var _b = _a.unmountOnExit,
    unmountOnExit = _b === void 0 ? false : _b,
    visible = _a.visible,
    children = _a.children,
    _c = _a.duration,
    duration = _c === void 0 ? 250 : _c,
    transitionProps = _a.transitionProps,
    style = _a.style,
    props = __rest$1(_a, ['unmountOnExit', 'visible', 'children', 'duration', 'transitionProps', 'style']);
  // @ts-expect-error expected 0 arguments, but got 1
  var nodeRef = React.useRef();
  var defaultStyle = {
    transition: 'opacity '.concat(duration, 'ms ease-in-out'),
    opacity: 0,
    pointerEvents: 'none',
  };
  var transitionStyles = {
    entering: { opacity: 1 },
    entered: { opacity: 1, pointerEvents: 'auto' },
    exiting: { opacity: 0 },
    exited: { opacity: 0 },
  };
  return (
    // @ts-expect-error TS(2786): 'Transition' cannot be used as a JSX component.
    jsxRuntime.jsx(
      Transition$2,
      __assign(
        {
          in: visible,
          timeout: duration,
          appear: visible,
          nodeRef: ref !== null && ref !== void 0 ? ref : nodeRef,
          mountOnEnter: !!unmountOnExit,
          unmountOnExit: unmountOnExit,
        },
        transitionProps,
        {
          children: function (state) {
            return jsxRuntime.jsx(
              'div',
              __assign(
                { style: __assign(__assign(__assign({}, defaultStyle), style), transitionStyles[state]) },
                props,
                { ref: ref !== null && ref !== void 0 ? ref : nodeRef, children: children },
              ),
            );
          },
        },
      ),
    )
  );
});
FadeIn.displayName = 'FadeIn';
FadeIn.propTypes = {
  visible: PropTypes__default['default'].bool.isRequired,
  children: PropTypes__default['default'].any.isRequired,
  unmountOnExit: PropTypes__default['default'].bool,
  duration: PropTypes__default['default'].number,
  transitionProps: PropTypes__default['default'].object,
};

var style$o = {
  Modal: 'htco-Modal',
  isOverflowing: 'htco-isOverflowing',
  ModalWrapper: 'htco-ModalWrapper',
  ModalContainer: 'htco-ModalContainer',
  ModalClose: 'htco-ModalClose',
  ModalConfirmHeader: 'htco-ModalConfirmHeader',
  ModalConfirmBody: 'htco-ModalConfirmBody',
  ModalConfirmFooter: 'htco-ModalConfirmFooter',
  ModalConfirmCancel: 'htco-ModalConfirmCancel',
  'theme-small': 'htco-theme-small',
  ModalCloseBtn: 'htco-ModalCloseBtn',
};

// this function validates the max modal width for the current screensize
// if the parameter passed as prop is bigger than the viewport
// then it returns the modal size - the margins to fit it in the screen
function getMaxModalWidth(width, screen) {
  var modalMarginValueInPx = 12;
  var modalMargins = modalMarginValueInPx * 2;
  return width >= screen ? screen - modalMargins : width;
}
function validateModalWidth(screenWidth, modalPropsWidth, defaultWidth) {
  var nonMobileSize = screenWidth >= breakpoints.tablet;
  // if the screen size is larger than tablet the size can be determined by the props
  // except if it exceeds the viewport size, in that case the max size is the viewport size minus the margins
  return getMaxModalWidth(nonMobileSize ? modalPropsWidth : defaultWidth, screenWidth);
}
// This component exists because it renders with unmountOnExit correctly.
var InnerComponent = function (_a) {
  var _b;
  var ariaProps = _a.ariaProps,
    children = _a.children;
  if (typeof children === 'function') {
    return (_b = children({ ariaProps: ariaProps })) !== null && _b !== void 0 ? _b : null;
  }
  return children !== null && children !== void 0 ? children : null;
};
var ModalTheme = {
  REGULAR: 'regular',
  SMALL: 'small',
};
var Modal = function (_a) {
  var _b;
  var _c;
  var _d = _a.open,
    open = _d === void 0 ? false : _d,
    onClose = _a.onClose,
    _e = _a.allowClose,
    allowClose = _e === void 0 ? true : _e,
    _f = _a.theme,
    theme = _f === void 0 ? ModalTheme.REGULAR : _f,
    _g = _a.target,
    target = _g === void 0 ? utils.getBody() : _g,
    children = _a.children,
    className = _a.className,
    props = __rest$1(_a, ['open', 'onClose', 'allowClose', 'theme', 'target', 'children', 'className']);
  var duration = 100;
  var defaultModalWidth = 600;
  var containerRef = useFocusTrap();
  var previousFocus = React.useRef(null);
  var _h = useWindowSize(),
    screenHeight = _h.screenHeight,
    screenWidth = _h.screenWidth;
  var smallModalWidth = props.width ? Math.min(props.width, defaultModalWidth) : 'auto';
  var resolvedDefaultWidth = theme === ModalTheme.SMALL ? smallModalWidth : defaultModalWidth;
  var width =
    resolvedDefaultWidth === 'auto'
      ? 'auto'
      : validateModalWidth(
          screenWidth,
          (_c = props.width) !== null && _c !== void 0 ? _c : resolvedDefaultWidth,
          resolvedDefaultWidth,
        ) || resolvedDefaultWidth;
  var _j = React.useState(false),
    isOverflowing = _j[0],
    setIsOverflowing = _j[1];
  useEscape(allowClose, onClose);
  useOutsideClick(containerRef.current, function (e) {
    var _a;
    if (allowClose && open) {
      if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.className.match(style$o.Modal)) {
        onClose();
      }
    }
  });
  React.useEffect(
    function () {
      var _a;
      // Manage changing focus to inner modal components and
      // return focus to trigger when modal is closed
      var container = containerRef.current;
      if (open) {
        previousFocus.current = document.activeElement;
        var focusable =
          container === null || container === void 0
            ? void 0
            : container.querySelectorAll('input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!focusable) return;
        if (focusable[0]) {
          focusable[0].focus();
        } else {
          container === null || container === void 0 ? void 0 : container.focus();
        }
      } else if (previousFocus.current) {
        (_a = previousFocus.current) === null || _a === void 0 ? void 0 : _a.focus();
      }
      var containerHeight = container ? container.offsetHeight : 150;
      setIsOverflowing(screenHeight < containerHeight);
      document.body.style.overflow = open ? 'hidden' : 'auto';
      return function () {
        document.body.style.overflow = 'auto';
      };
    },
    [open, containerRef.current, screenHeight],
  );
  // Get up a random key to identify the aria-prop components
  var randomKey = React.useRef(Math.random().toString(36).substring(2, 11));
  var ariaProps = {
    label: 'label_'.concat(randomKey.current),
    description: 'desc_'.concat(randomKey.current),
  };
  var component = jsxRuntime.jsx(FadeIn, {
    visible: open,
    duration: duration,
    className: style$o.ModalWrapper,
    children: jsxRuntime.jsx(
      'div',
      __assign(
        {
          // the overflow class should be added assuming the margin is 0 or negative
          className: cx(
            style$o.Modal,
            style$o['theme-'.concat(theme)],
            className,
            ((_b = {}), (_b[style$o.isOverflowing] = isOverflowing), _b),
          ),
          role: 'dialog',
          'aria-modal': true,
          'aria-labelledby': ariaProps.label,
          'aria-describedby': ariaProps.description,
        },
        props,
        {
          children: jsxRuntime.jsx('div', {
            ref: containerRef,
            children: jsxRuntime.jsxs(FadeIn, {
              visible: open,
              duration: duration + 50,
              tabIndex: 0,
              unmountOnExit: true,
              className: cx(style$o.ModalContainer, allowClose && style$o.hasClose),
              style: { width: width },
              'data-testid': 'modal-container',
              children: [
                allowClose &&
                  jsxRuntime.jsx('span', {
                    className: style$o.ModalClose,
                    children: jsxRuntime.jsx(IconButton, {
                      icon: theme === ModalTheme.SMALL ? 'close' : 'cancel',
                      size: theme === ModalTheme.SMALL ? '2x' : 'lg',
                      className: style$o.ModalCloseBtn,
                      onClick: onClose,
                      'aria-label': 'close',
                    }),
                  }),
                jsxRuntime.jsx(InnerComponent, { ariaProps: ariaProps, children: children }),
              ],
            }),
          }),
        },
      ),
    ),
  });
  return target ? ReactDOM.createPortal(component, target) : component;
};

var ModalButton = function (_a) {
  var buttonLabel = _a.buttonLabel,
    _b = _a.buttonTheme,
    buttonTheme = _b === void 0 ? 'solid' : _b,
    className = _a.className,
    children = _a.children,
    props = __rest$1(_a, ['buttonLabel', 'buttonTheme', 'className', 'children']);
  var _c = React.useState(false),
    open = _c[0],
    setOpen = _c[1];
  var handleOpen = function () {
    return setOpen(true);
  };
  var handleClose = function () {
    return setOpen(false);
  };
  return jsxRuntime.jsxs('div', {
    className: className,
    children: [
      jsxRuntime.jsx(Button, { theme: buttonTheme, onClick: handleOpen, children: buttonLabel }),
      jsxRuntime.jsx(
        Modal,
        __assign({ open: open, onClose: handleClose }, props, {
          children: function (_a) {
            var ariaProps = _a.ariaProps;
            if (typeof children === 'function') {
              return children({ ariaProps: ariaProps, handleClose: handleClose });
            }
            return children || null;
          },
        }),
      ),
    ],
  });
};
ModalButton.propTypes = {
  buttonLabel: PropTypes__default['default'].node.isRequired,
  buttonTheme: PropTypes__default['default'].node,
};

var ModalConfirm = function (_a) {
  var open = _a.open,
    header = _a.header,
    _b = _a.cancelText,
    cancelText = _b === void 0 ? 'Cancel' : _b,
    _c = _a.confirmText,
    confirmText = _c === void 0 ? 'Submit' : _c,
    _d = _a.theme,
    theme = _d === void 0 ? 'primary' : _d,
    _e = _a.width,
    width = _e === void 0 ? 500 : _e,
    onConfirm = _a.onConfirm,
    onCancel = _a.onCancel,
    onClose = _a.onClose,
    _f = _a.isDisabledConfirmButton,
    isDisabledConfirmButton = _f === void 0 ? false : _f,
    children = _a.children,
    props = __rest$1(_a, [
      'open',
      'header',
      'cancelText',
      'confirmText',
      'theme',
      'width',
      'onConfirm',
      'onCancel',
      'onClose',
      'isDisabledConfirmButton',
      'children',
    ]);
  var handleCancel = function () {
    if (onCancel) {
      onCancel();
    } else {
      onClose();
    }
  };
  return jsxRuntime.jsx(
    Modal,
    __assign({ open: open, onClose: onClose, width: width }, props, {
      children: function (_a) {
        var ariaProps = _a.ariaProps;
        return jsxRuntime.jsxs('div', {
          children: [
            header &&
              jsxRuntime.jsx('div', { className: style$o.ModalConfirmHeader, id: ariaProps.label, children: header }),
            jsxRuntime.jsx('div', {
              className: style$o.ModalConfirmBody,
              id: ariaProps.description,
              children: children,
            }),
            jsxRuntime.jsxs('div', {
              className: style$o.ModalConfirmFooter,
              children: [
                jsxRuntime.jsx(Button, {
                  theme: 'link',
                  className: style$o.ModalConfirmCancel,
                  onClick: handleCancel,
                  children: cancelText,
                }),
                jsxRuntime.jsx(Button, {
                  theme: theme,
                  onClick: onConfirm,
                  disabled: isDisabledConfirmButton,
                  children: confirmText,
                }),
              ],
            }),
          ],
        });
      },
    }),
  );
};

var style$n = {
  LoadingPlaceholder: 'htco-LoadingPlaceholder',
  isLoading: 'htco-isLoading',
  loadingPlaceholderAnimation: 'htco-loadingPlaceholderAnimation',
};

var LoadingPlaceholder = function (_a) {
  var className = _a.className,
    _b = _a.isLoading,
    isLoading = _b === void 0 ? false : _b,
    _c = _a.isInline,
    isInline = _c === void 0 ? false : _c,
    children = _a.children,
    props = __rest$1(_a, ['className', 'isLoading', 'isInline', 'children']);
  var inlineStyle = isInline ? { display: 'inline-block' } : {};
  var loadingClass = isLoading ? style$n.isLoading : '';
  var withLoadingClass = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return cx.apply(void 0, __spreadArray([loadingClass], args, false));
  };
  return jsxRuntime.jsx(
    'div',
    __assign({ className: cx(style$n.LoadingPlaceholder, className), style: inlineStyle }, props, {
      children: children({ loadingClass: loadingClass, withLoadingClass: withLoadingClass }),
    }),
  );
};
LoadingPlaceholder.propTypes = {
  isLoading: PropTypes__default['default'].bool,
  isInline: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].func.isRequired,
};

var baseGetTag$3 = _baseGetTag,
  isArray$b = isArray_1,
  isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag$2 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || (!isArray$b(value) && isObjectLike$5(value) && baseGetTag$3(value) == stringTag$2);
}

var isString_1 = isString;

var _isString = /*@__PURE__*/ getDefaultExportFromCjs(isString_1);

var isArray$a = isArray_1,
  isSymbol$4 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$a(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$4(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || (object != null && value in Object(object));
}

var _isKey = isKey$3;

var MapCache = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$3(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function () {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$3.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize$3.Cache = MapCache;

var memoize_1 = memoize$3;

var memoize$2 = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize$2(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : number || match);
  });
  return result;
});

var _stringToPath = stringToPath$2;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$4(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$4;

var Symbol$4 = _Symbol,
  arrayMap$3 = _arrayMap,
  isArray$9 = isArray_1,
  isSymbol$3 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$4 ? Symbol$4.prototype : undefined,
  symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$9(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$3(value, baseToString$1) + '';
  }
  if (isSymbol$3(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$3 ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$4(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$4;

var isArray$8 = isArray_1,
  isKey$2 = _isKey,
  stringToPath$1 = _stringToPath,
  toString$3 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$4(value, object) {
  if (isArray$8(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath$1(toString$3(value));
}

var _castPath = castPath$4;

var isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$2(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}

var _toKey = toKey$5;

var castPath$3 = _castPath,
  toKey$4 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$4(object, path) {
  path = castPath$3(path, object);

  var index = 0,
    length = path.length;

  while (object != null && index < length) {
    object = object[toKey$4(path[index++])];
  }
  return index && index == length ? object : undefined;
}

var _baseGet = baseGet$4;

var baseGet$3 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$3(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

var _get = /*@__PURE__*/ getDefaultExportFromCjs(get_1);

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */

function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

var _isNil = /*@__PURE__*/ getDefaultExportFromCjs(isNil_1);

var reactIs$3 = { exports: {} };

var reactIs_production_min$2 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$2;

function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2) return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var b = 'function' === typeof Symbol && Symbol.for,
    c = b ? Symbol.for('react.element') : 60103,
    d = b ? Symbol.for('react.portal') : 60106,
    e = b ? Symbol.for('react.fragment') : 60107,
    f = b ? Symbol.for('react.strict_mode') : 60108,
    g = b ? Symbol.for('react.profiler') : 60114,
    h = b ? Symbol.for('react.provider') : 60109,
    k = b ? Symbol.for('react.context') : 60110,
    l = b ? Symbol.for('react.async_mode') : 60111,
    m = b ? Symbol.for('react.concurrent_mode') : 60111,
    n = b ? Symbol.for('react.forward_ref') : 60112,
    p = b ? Symbol.for('react.suspense') : 60113,
    q = b ? Symbol.for('react.suspense_list') : 60120,
    r = b ? Symbol.for('react.memo') : 60115,
    t = b ? Symbol.for('react.lazy') : 60116,
    v = b ? Symbol.for('react.block') : 60121,
    w = b ? Symbol.for('react.fundamental') : 60117,
    x = b ? Symbol.for('react.responder') : 60118,
    y = b ? Symbol.for('react.scope') : 60119;
  function z(a) {
    if ('object' === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (((a = a.type), a)) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (((a = a && a.$$typeof), a)) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min$2.AsyncMode = l;
  reactIs_production_min$2.ConcurrentMode = m;
  reactIs_production_min$2.ContextConsumer = k;
  reactIs_production_min$2.ContextProvider = h;
  reactIs_production_min$2.Element = c;
  reactIs_production_min$2.ForwardRef = n;
  reactIs_production_min$2.Fragment = e;
  reactIs_production_min$2.Lazy = t;
  reactIs_production_min$2.Memo = r;
  reactIs_production_min$2.Portal = d;
  reactIs_production_min$2.Profiler = g;
  reactIs_production_min$2.StrictMode = f;
  reactIs_production_min$2.Suspense = p;
  reactIs_production_min$2.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min$2.isConcurrentMode = A;
  reactIs_production_min$2.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min$2.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min$2.isElement = function (a) {
    return 'object' === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min$2.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min$2.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min$2.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min$2.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min$2.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min$2.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min$2.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min$2.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min$2.isValidElementType = function (a) {
    return (
      'string' === typeof a ||
      'function' === typeof a ||
      a === e ||
      a === m ||
      a === g ||
      a === f ||
      a === p ||
      a === q ||
      ('object' === typeof a &&
        null !== a &&
        (a.$$typeof === t ||
          a.$$typeof === r ||
          a.$$typeof === h ||
          a.$$typeof === k ||
          a.$$typeof === n ||
          a.$$typeof === w ||
          a.$$typeof === x ||
          a.$$typeof === y ||
          a.$$typeof === v))
    );
  };
  reactIs_production_min$2.typeOf = z;
  return reactIs_production_min$2;
}

var reactIs_development$2 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$2;

function requireReactIs_development$2() {
  if (hasRequiredReactIs_development$2) return reactIs_development$2;
  hasRequiredReactIs_development$2 = 1;

  if (process.env.NODE_ENV !== 'production') {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return (
          typeof type === 'string' ||
          typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE ||
          type === REACT_CONCURRENT_MODE_TYPE ||
          type === REACT_PROFILER_TYPE ||
          type === REACT_STRICT_MODE_TYPE ||
          type === REACT_SUSPENSE_TYPE ||
          type === REACT_SUSPENSE_LIST_TYPE ||
          (typeof type === 'object' &&
            type !== null &&
            (type.$$typeof === REACT_LAZY_TYPE ||
              type.$$typeof === REACT_MEMO_TYPE ||
              type.$$typeof === REACT_PROVIDER_TYPE ||
              type.$$typeof === REACT_CONTEXT_TYPE ||
              type.$$typeof === REACT_FORWARD_REF_TYPE ||
              type.$$typeof === REACT_FUNDAMENTAL_TYPE ||
              type.$$typeof === REACT_RESPONDER_TYPE ||
              type.$$typeof === REACT_SCOPE_TYPE ||
              type.$$typeof === REACT_BLOCK_TYPE))
        );
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }
              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn'](
              'The ReactIs.isAsyncMode() alias has been deprecated, ' +
                'and will be removed in React 17+. Update your code to use ' +
                'ReactIs.isConcurrentMode() instead. It has the exact same API.',
            );
          }
        }

        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      reactIs_development$2.AsyncMode = AsyncMode;
      reactIs_development$2.ConcurrentMode = ConcurrentMode;
      reactIs_development$2.ContextConsumer = ContextConsumer;
      reactIs_development$2.ContextProvider = ContextProvider;
      reactIs_development$2.Element = Element;
      reactIs_development$2.ForwardRef = ForwardRef;
      reactIs_development$2.Fragment = Fragment;
      reactIs_development$2.Lazy = Lazy;
      reactIs_development$2.Memo = Memo;
      reactIs_development$2.Portal = Portal;
      reactIs_development$2.Profiler = Profiler;
      reactIs_development$2.StrictMode = StrictMode;
      reactIs_development$2.Suspense = Suspense;
      reactIs_development$2.isAsyncMode = isAsyncMode;
      reactIs_development$2.isConcurrentMode = isConcurrentMode;
      reactIs_development$2.isContextConsumer = isContextConsumer;
      reactIs_development$2.isContextProvider = isContextProvider;
      reactIs_development$2.isElement = isElement;
      reactIs_development$2.isForwardRef = isForwardRef;
      reactIs_development$2.isFragment = isFragment;
      reactIs_development$2.isLazy = isLazy;
      reactIs_development$2.isMemo = isMemo;
      reactIs_development$2.isPortal = isPortal;
      reactIs_development$2.isProfiler = isProfiler;
      reactIs_development$2.isStrictMode = isStrictMode;
      reactIs_development$2.isSuspense = isSuspense;
      reactIs_development$2.isValidElementType = isValidElementType;
      reactIs_development$2.typeOf = typeOf;
    })();
  }
  return reactIs_development$2;
}

if (process.env.NODE_ENV === 'production') {
  reactIs$3.exports = requireReactIs_production_min$2();
} else {
  reactIs$3.exports = requireReactIs_development$2();
}

var reactIsExports$2 = reactIs$3.exports;

var baseGetTag$2 = _baseGetTag,
  isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var numberTag$2 = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber$2(value) {
  return typeof value == 'number' || (isObjectLike$4(value) && baseGetTag$2(value) == numberTag$2);
}

var isNumber_1 = isNumber$2;

var _isNumber = /*@__PURE__*/ getDefaultExportFromCjs(isNumber_1);

var isNumber$1 = isNumber_1;

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN$1(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber$1(value) && value != +value;
}

var _isNaN = isNaN$1;

var _isNaN$1 = /*@__PURE__*/ getDefaultExportFromCjs(_isNaN);

var mathSign$1 = function mathSign(value) {
  if (value === 0) {
    return 0;
  }
  if (value > 0) {
    return 1;
  }
  return -1;
};
var isPercent = function isPercent(value) {
  return _isString(value) && value.indexOf('%') === value.length - 1;
};
var isNumber = function isNumber(value) {
  return _isNumber(value) && !_isNaN$1(value);
};
var isNumOrStr = function isNumOrStr(value) {
  return isNumber(value) || _isString(value);
};
var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
  var id = ++idCounter;
  return ''.concat(prefix || '').concat(id);
};

/**
 * Get percent value of a total value
 * @param {number|string} percent A percent
 * @param {number} totalValue     Total value
 * @param {number} defaultValue   The value returned when percent is undefined or invalid
 * @param {boolean} validate      If set to be true, the result will be validated
 * @return {number} value
 */
var getPercentValue = function getPercentValue(percent, totalValue) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!isNumber(percent) && !_isString(percent)) {
    return defaultValue;
  }
  var value;
  if (isPercent(percent)) {
    var index = percent.indexOf('%');
    value = (totalValue * parseFloat(percent.slice(0, index))) / 100;
  } else {
    value = +percent;
  }
  if (_isNaN$1(value)) {
    value = defaultValue;
  }
  if (validate && value > totalValue) {
    value = totalValue;
  }
  return value;
};
var getAnyElementOfObject = function getAnyElementOfObject(obj) {
  if (!obj) {
    return null;
  }
  var keys = Object.keys(obj);
  if (keys && keys.length) {
    return obj[keys[0]];
  }
  return null;
};
var hasDuplicate = function hasDuplicate(ary) {
  if (!_isArray(ary)) {
    return false;
  }
  var len = ary.length;
  var cache = {};
  for (var i = 0; i < len; i++) {
    if (!cache[ary[i]]) {
      cache[ary[i]] = true;
    } else {
      return true;
    }
  }
  return false;
};

/* @todo consider to rename this function into `getInterpolator` */
var interpolateNumber$2 = function interpolateNumber(numberA, numberB) {
  if (isNumber(numberA) && isNumber(numberB)) {
    return function (t) {
      return numberA + t * (numberB - numberA);
    };
  }
  return function () {
    return numberB;
  };
};
function findEntryInArray(ary, specifiedKey, specifiedValue) {
  if (!ary || !ary.length) {
    return null;
  }
  return ary.find(function (entry) {
    return (
      entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : _get(entry, specifiedKey)) === specifiedValue
    );
  });
}

/**
 * The least square linear regression
 * @param {Array} data The array of points
 * @returns {Object} The domain of x, and the parameter of linear function
 */
var getLinearRegression = function getLinearRegression(data) {
  if (!data || !data.length) {
    return null;
  }
  var len = data.length;
  var xsum = 0;
  var ysum = 0;
  var xysum = 0;
  var xxsum = 0;
  var xmin = Infinity;
  var xmax = -Infinity;
  var xcurrent = 0;
  var ycurrent = 0;
  for (var i = 0; i < len; i++) {
    xcurrent = data[i].cx || 0;
    ycurrent = data[i].cy || 0;
    xsum += xcurrent;
    ysum += ycurrent;
    xysum += xcurrent * ycurrent;
    xxsum += xcurrent * xcurrent;
    xmin = Math.min(xmin, xcurrent);
    xmax = Math.max(xmax, xcurrent);
  }
  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
  return {
    xmin: xmin,
    xmax: xmax,
    a: a,
    b: (ysum - a * xsum) / len,
  };
};

function shallowEqual$1(a, b) {
  /* eslint-disable no-restricted-syntax */
  for (var key in a) {
    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
      return false;
    }
  }
  for (var _key in b) {
    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
      return false;
    }
  }
  return true;
}

function _typeof$1k(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1k =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1k(obj)
  );
}
var SVGContainerPropKeys = ['viewBox', 'children'];
var SVGElementPropKeys = [
  'aria-activedescendant',
  'aria-atomic',
  'aria-autocomplete',
  'aria-busy',
  'aria-checked',
  'aria-colcount',
  'aria-colindex',
  'aria-colspan',
  'aria-controls',
  'aria-current',
  'aria-describedby',
  'aria-details',
  'aria-disabled',
  'aria-errormessage',
  'aria-expanded',
  'aria-flowto',
  'aria-haspopup',
  'aria-hidden',
  'aria-invalid',
  'aria-keyshortcuts',
  'aria-label',
  'aria-labelledby',
  'aria-level',
  'aria-live',
  'aria-modal',
  'aria-multiline',
  'aria-multiselectable',
  'aria-orientation',
  'aria-owns',
  'aria-placeholder',
  'aria-posinset',
  'aria-pressed',
  'aria-readonly',
  'aria-relevant',
  'aria-required',
  'aria-roledescription',
  'aria-rowcount',
  'aria-rowindex',
  'aria-rowspan',
  'aria-selected',
  'aria-setsize',
  'aria-sort',
  'aria-valuemax',
  'aria-valuemin',
  'aria-valuenow',
  'aria-valuetext',
  'className',
  'color',
  'height',
  'id',
  'lang',
  'max',
  'media',
  'method',
  'min',
  'name',
  'style',
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  'target',
  'width',
  'role',
  'tabIndex',
  'accentHeight',
  'accumulate',
  'additive',
  'alignmentBaseline',
  'allowReorder',
  'alphabetic',
  'amplitude',
  'arabicForm',
  'ascent',
  'attributeName',
  'attributeType',
  'autoReverse',
  'azimuth',
  'baseFrequency',
  'baselineShift',
  'baseProfile',
  'bbox',
  'begin',
  'bias',
  'by',
  'calcMode',
  'capHeight',
  'clip',
  'clipPath',
  'clipPathUnits',
  'clipRule',
  'colorInterpolation',
  'colorInterpolationFilters',
  'colorProfile',
  'colorRendering',
  'contentScriptType',
  'contentStyleType',
  'cursor',
  'cx',
  'cy',
  'd',
  'decelerate',
  'descent',
  'diffuseConstant',
  'direction',
  'display',
  'divisor',
  'dominantBaseline',
  'dur',
  'dx',
  'dy',
  'edgeMode',
  'elevation',
  'enableBackground',
  'end',
  'exponent',
  'externalResourcesRequired',
  'fill',
  'fillOpacity',
  'fillRule',
  'filter',
  'filterRes',
  'filterUnits',
  'floodColor',
  'floodOpacity',
  'focusable',
  'fontFamily',
  'fontSize',
  'fontSizeAdjust',
  'fontStretch',
  'fontStyle',
  'fontVariant',
  'fontWeight',
  'format',
  'from',
  'fx',
  'fy',
  'g1',
  'g2',
  'glyphName',
  'glyphOrientationHorizontal',
  'glyphOrientationVertical',
  'glyphRef',
  'gradientTransform',
  'gradientUnits',
  'hanging',
  'horizAdvX',
  'horizOriginX',
  'href',
  'ideographic',
  'imageRendering',
  'in2',
  'in',
  'intercept',
  'k1',
  'k2',
  'k3',
  'k4',
  'k',
  'kernelMatrix',
  'kernelUnitLength',
  'kerning',
  'keyPoints',
  'keySplines',
  'keyTimes',
  'lengthAdjust',
  'letterSpacing',
  'lightingColor',
  'limitingConeAngle',
  'local',
  'markerEnd',
  'markerHeight',
  'markerMid',
  'markerStart',
  'markerUnits',
  'markerWidth',
  'mask',
  'maskContentUnits',
  'maskUnits',
  'mathematical',
  'mode',
  'numOctaves',
  'offset',
  'opacity',
  'operator',
  'order',
  'orient',
  'orientation',
  'origin',
  'overflow',
  'overlinePosition',
  'overlineThickness',
  'paintOrder',
  'panose1',
  'pathLength',
  'patternContentUnits',
  'patternTransform',
  'patternUnits',
  'pointerEvents',
  'pointsAtX',
  'pointsAtY',
  'pointsAtZ',
  'preserveAlpha',
  'preserveAspectRatio',
  'primitiveUnits',
  'r',
  'radius',
  'refX',
  'refY',
  'renderingIntent',
  'repeatCount',
  'repeatDur',
  'requiredExtensions',
  'requiredFeatures',
  'restart',
  'result',
  'rotate',
  'rx',
  'ry',
  'seed',
  'shapeRendering',
  'slope',
  'spacing',
  'specularConstant',
  'specularExponent',
  'speed',
  'spreadMethod',
  'startOffset',
  'stdDeviation',
  'stemh',
  'stemv',
  'stitchTiles',
  'stopColor',
  'stopOpacity',
  'strikethroughPosition',
  'strikethroughThickness',
  'string',
  'stroke',
  'strokeDasharray',
  'strokeDashoffset',
  'strokeLinecap',
  'strokeLinejoin',
  'strokeMiterlimit',
  'strokeOpacity',
  'strokeWidth',
  'surfaceScale',
  'systemLanguage',
  'tableValues',
  'targetX',
  'targetY',
  'textAnchor',
  'textDecoration',
  'textLength',
  'textRendering',
  'to',
  'transform',
  'u1',
  'u2',
  'underlinePosition',
  'underlineThickness',
  'unicode',
  'unicodeBidi',
  'unicodeRange',
  'unitsPerEm',
  'vAlphabetic',
  'values',
  'vectorEffect',
  'version',
  'vertAdvY',
  'vertOriginX',
  'vertOriginY',
  'vHanging',
  'vIdeographic',
  'viewTarget',
  'visibility',
  'vMathematical',
  'widths',
  'wordSpacing',
  'writingMode',
  'x1',
  'x2',
  'x',
  'xChannelSelector',
  'xHeight',
  'xlinkActuate',
  'xlinkArcrole',
  'xlinkHref',
  'xlinkRole',
  'xlinkShow',
  'xlinkTitle',
  'xlinkType',
  'xmlBase',
  'xmlLang',
  'xmlns',
  'xmlnsXlink',
  'xmlSpace',
  'y1',
  'y2',
  'y',
  'yChannelSelector',
  'z',
  'zoomAndPan',
  'ref',
  'key',
  'angle',
];
var PolyElementKeys = ['points', 'pathLength'];

/** svg element types that have specific attribute filtration requirements */

/** map of svg element types to unique svg attributes that belong to that element */
var FilteredElementKeyMap = {
  svg: SVGContainerPropKeys,
  polygon: PolyElementKeys,
  polyline: PolyElementKeys,
};
var EventKeys = [
  'dangerouslySetInnerHTML',
  'onCopy',
  'onCopyCapture',
  'onCut',
  'onCutCapture',
  'onPaste',
  'onPasteCapture',
  'onCompositionEnd',
  'onCompositionEndCapture',
  'onCompositionStart',
  'onCompositionStartCapture',
  'onCompositionUpdate',
  'onCompositionUpdateCapture',
  'onFocus',
  'onFocusCapture',
  'onBlur',
  'onBlurCapture',
  'onChange',
  'onChangeCapture',
  'onBeforeInput',
  'onBeforeInputCapture',
  'onInput',
  'onInputCapture',
  'onReset',
  'onResetCapture',
  'onSubmit',
  'onSubmitCapture',
  'onInvalid',
  'onInvalidCapture',
  'onLoad',
  'onLoadCapture',
  'onError',
  'onErrorCapture',
  'onKeyDown',
  'onKeyDownCapture',
  'onKeyPress',
  'onKeyPressCapture',
  'onKeyUp',
  'onKeyUpCapture',
  'onAbort',
  'onAbortCapture',
  'onCanPlay',
  'onCanPlayCapture',
  'onCanPlayThrough',
  'onCanPlayThroughCapture',
  'onDurationChange',
  'onDurationChangeCapture',
  'onEmptied',
  'onEmptiedCapture',
  'onEncrypted',
  'onEncryptedCapture',
  'onEnded',
  'onEndedCapture',
  'onLoadedData',
  'onLoadedDataCapture',
  'onLoadedMetadata',
  'onLoadedMetadataCapture',
  'onLoadStart',
  'onLoadStartCapture',
  'onPause',
  'onPauseCapture',
  'onPlay',
  'onPlayCapture',
  'onPlaying',
  'onPlayingCapture',
  'onProgress',
  'onProgressCapture',
  'onRateChange',
  'onRateChangeCapture',
  'onSeeked',
  'onSeekedCapture',
  'onSeeking',
  'onSeekingCapture',
  'onStalled',
  'onStalledCapture',
  'onSuspend',
  'onSuspendCapture',
  'onTimeUpdate',
  'onTimeUpdateCapture',
  'onVolumeChange',
  'onVolumeChangeCapture',
  'onWaiting',
  'onWaitingCapture',
  'onAuxClick',
  'onAuxClickCapture',
  'onClick',
  'onClickCapture',
  'onContextMenu',
  'onContextMenuCapture',
  'onDoubleClick',
  'onDoubleClickCapture',
  'onDrag',
  'onDragCapture',
  'onDragEnd',
  'onDragEndCapture',
  'onDragEnter',
  'onDragEnterCapture',
  'onDragExit',
  'onDragExitCapture',
  'onDragLeave',
  'onDragLeaveCapture',
  'onDragOver',
  'onDragOverCapture',
  'onDragStart',
  'onDragStartCapture',
  'onDrop',
  'onDropCapture',
  'onMouseDown',
  'onMouseDownCapture',
  'onMouseEnter',
  'onMouseLeave',
  'onMouseMove',
  'onMouseMoveCapture',
  'onMouseOut',
  'onMouseOutCapture',
  'onMouseOver',
  'onMouseOverCapture',
  'onMouseUp',
  'onMouseUpCapture',
  'onSelect',
  'onSelectCapture',
  'onTouchCancel',
  'onTouchCancelCapture',
  'onTouchEnd',
  'onTouchEndCapture',
  'onTouchMove',
  'onTouchMoveCapture',
  'onTouchStart',
  'onTouchStartCapture',
  'onPointerDown',
  'onPointerDownCapture',
  'onPointerMove',
  'onPointerMoveCapture',
  'onPointerUp',
  'onPointerUpCapture',
  'onPointerCancel',
  'onPointerCancelCapture',
  'onPointerEnter',
  'onPointerEnterCapture',
  'onPointerLeave',
  'onPointerLeaveCapture',
  'onPointerOver',
  'onPointerOverCapture',
  'onPointerOut',
  'onPointerOutCapture',
  'onGotPointerCapture',
  'onGotPointerCaptureCapture',
  'onLostPointerCapture',
  'onLostPointerCaptureCapture',
  'onScroll',
  'onScrollCapture',
  'onWheel',
  'onWheelCapture',
  'onAnimationStart',
  'onAnimationStartCapture',
  'onAnimationEnd',
  'onAnimationEndCapture',
  'onAnimationIteration',
  'onAnimationIterationCapture',
  'onTransitionEnd',
  'onTransitionEndCapture',
];

// Animation Types => TODO: Should be moved when react-smooth is typescriptified.

var adaptEventHandlers = function adaptEventHandlers(props, newHandler) {
  if (!props || typeof props === 'function' || typeof props === 'boolean') {
    return null;
  }
  var inputProps = props;
  if (/*#__PURE__*/ React.isValidElement(props)) {
    inputProps = props.props;
  }
  if (!_isObject(inputProps)) {
    return null;
  }
  var out = {};
  Object.keys(inputProps).forEach(function (key) {
    if (EventKeys.includes(key)) {
      out[key] =
        newHandler ||
        function (e) {
          return inputProps[key](inputProps, e);
        };
    }
  });
  return out;
};
var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
  return function (e) {
    originalHandler(data, index, e);
    return null;
  };
};
var adaptEventsOfChild = function adaptEventsOfChild(props, data, index) {
  if (!_isObject(props) || _typeof$1k(props) !== 'object') {
    return null;
  }
  var out = null;
  Object.keys(props).forEach(function (key) {
    var item = props[key];
    if (EventKeys.includes(key) && typeof item === 'function') {
      if (!out) out = {};
      out[key] = getEventHandlerOfChild(item, data, index);
    }
  });
  return out;
};

var _excluded$k = ['children'],
  _excluded2$6 = ['children'];
function _objectWithoutProperties$k(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$n(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$n(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var REACT_BROWSER_EVENT_MAP = {
  click: 'onClick',
  mousedown: 'onMouseDown',
  mouseup: 'onMouseUp',
  mouseover: 'onMouseOver',
  mousemove: 'onMouseMove',
  mouseout: 'onMouseOut',
  mouseenter: 'onMouseEnter',
  mouseleave: 'onMouseLeave',
  touchcancel: 'onTouchCancel',
  touchend: 'onTouchEnd',
  touchmove: 'onTouchMove',
  touchstart: 'onTouchStart',
};

/**
 * Get the display name of a component
 * @param  {Object} Comp Specified Component
 * @return {String}      Display name of Component
 */
var getDisplayName = function getDisplayName(Comp) {
  if (typeof Comp === 'string') {
    return Comp;
  }
  if (!Comp) {
    return '';
  }
  return Comp.displayName || Comp.name || 'Component';
};

// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var lastChildren = null;
var lastResult = null;
var toArray = function toArray(children) {
  if (children === lastChildren && _isArray(lastResult)) {
    return lastResult;
  }
  var result = [];
  React.Children.forEach(children, function (child) {
    if (_isNil(child)) return;
    if (reactIsExports$2.isFragment(child)) {
      result = result.concat(toArray(child.props.children));
    } else {
      result.push(child);
    }
  });
  lastResult = result;
  lastChildren = children;
  return result;
};

/*
 * Find and return all matched children by type.
 * `type` must be a React.ComponentType
 */
function findAllByType(children, type) {
  var result = [];
  var types = [];
  if (_isArray(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }
  toArray(children).forEach(function (child) {
    var childType = _get(child, 'type.displayName') || _get(child, 'type.name');
    if (types.indexOf(childType) !== -1) {
      result.push(child);
    }
  });
  return result;
}

/*
 * Return the first matched child by type, return null otherwise.
 * `type` must be a React.ComponentType
 */
function findChildByType(children, type) {
  var result = findAllByType(children, type);
  return result && result[0];
}

/**
 * validate the width and height props of a chart element
 * @param  {Object} el A chart element
 * @return {Boolean}   true If the props width and height are number, and greater than 0
 */
var validateWidthHeight = function validateWidthHeight(el) {
  if (!el || !el.props) {
    return false;
  }
  var _el$props = el.props,
    width = _el$props.width,
    height = _el$props.height;
  if (!isNumber(width) || width <= 0 || !isNumber(height) || height <= 0) {
    return false;
  }
  return true;
};
var SVG_TAGS = [
  'a',
  'altGlyph',
  'altGlyphDef',
  'altGlyphItem',
  'animate',
  'animateColor',
  'animateMotion',
  'animateTransform',
  'circle',
  'clipPath',
  'color-profile',
  'cursor',
  'defs',
  'desc',
  'ellipse',
  'feBlend',
  'feColormatrix',
  'feComponentTransfer',
  'feComposite',
  'feConvolveMatrix',
  'feDiffuseLighting',
  'feDisplacementMap',
  'feDistantLight',
  'feFlood',
  'feFuncA',
  'feFuncB',
  'feFuncG',
  'feFuncR',
  'feGaussianBlur',
  'feImage',
  'feMerge',
  'feMergeNode',
  'feMorphology',
  'feOffset',
  'fePointLight',
  'feSpecularLighting',
  'feSpotLight',
  'feTile',
  'feTurbulence',
  'filter',
  'font',
  'font-face',
  'font-face-format',
  'font-face-name',
  'font-face-url',
  'foreignObject',
  'g',
  'glyph',
  'glyphRef',
  'hkern',
  'image',
  'line',
  'lineGradient',
  'marker',
  'mask',
  'metadata',
  'missing-glyph',
  'mpath',
  'path',
  'pattern',
  'polygon',
  'polyline',
  'radialGradient',
  'rect',
  'script',
  'set',
  'stop',
  'style',
  'svg',
  'switch',
  'symbol',
  'text',
  'textPath',
  'title',
  'tref',
  'tspan',
  'use',
  'view',
  'vkern',
];
var isSvgElement = function isSvgElement(child) {
  return child && child.type && _isString(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};

/**
 * Checks if the property is valid to spread onto an SVG element or onto a specific component
 * @param {unknown} property property value currently being compared
 * @param {string} key property key currently being compared
 * @param {boolean} includeEvents if events are included in spreadable props
 * @param {boolean} svgElementType checks against map of SVG element types to attributes
 * @returns {boolean} is prop valid
 */
var isValidSpreadableProp = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
  var _FilteredElementKeyMa;
  /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */
  var matchingElementTypeKeys =
    (_FilteredElementKeyMa =
      FilteredElementKeyMap === null || FilteredElementKeyMap === void 0
        ? void 0
        : FilteredElementKeyMap[svgElementType]) !== null && _FilteredElementKeyMa !== void 0
      ? _FilteredElementKeyMa
      : [];
  return (
    (!_isFunction(property) &&
      ((svgElementType && matchingElementTypeKeys.includes(key)) || SVGElementPropKeys.includes(key))) ||
    (includeEvents && EventKeys.includes(key))
  );
};

/**
 * Filter all the svg elements of children
 * @param  {Array} children The children of a react element
 * @return {Array}          All the svg elements
 */
var filterSvgElements = function filterSvgElements(children) {
  var svgElements = [];
  toArray(children).forEach(function (entry) {
    if (isSvgElement(entry)) {
      svgElements.push(entry);
    }
  });
  return svgElements;
};
var filterProps = function filterProps(props, includeEvents, svgElementType) {
  if (!props || typeof props === 'function' || typeof props === 'boolean') {
    return null;
  }
  var inputProps = props;
  if (/*#__PURE__*/ React.isValidElement(props)) {
    inputProps = props.props;
  }
  if (!_isObject(inputProps)) {
    return null;
  }
  var out = {};

  /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */
  Object.keys(inputProps).forEach(function (key) {
    var _inputProps;
    if (
      isValidSpreadableProp(
        (_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key],
        key,
        includeEvents,
        svgElementType,
      )
    ) {
      out[key] = inputProps[key];
    }
  });
  return out;
};

/**
 * Wether props of children changed
 * @param  {Object} nextChildren The latest children
 * @param  {Object} prevChildren The prev children
 * @return {Boolean}             equal or not
 */
var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
  if (nextChildren === prevChildren) {
    return true;
  }
  var count = React.Children.count(nextChildren);
  if (count !== React.Children.count(prevChildren)) {
    return false;
  }
  if (count === 0) {
    return true;
  }
  if (count === 1) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return isSingleChildEqual(
      _isArray(nextChildren) ? nextChildren[0] : nextChildren,
      _isArray(prevChildren) ? prevChildren[0] : prevChildren,
    );
  }
  for (var i = 0; i < count; i++) {
    var nextChild = nextChildren[i];
    var prevChild = prevChildren[i];
    if (_isArray(nextChild) || _isArray(prevChild)) {
      if (!isChildrenEqual(nextChild, prevChild)) {
        return false;
      }
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
    } else if (!isSingleChildEqual(nextChild, prevChild)) {
      return false;
    }
  }
  return true;
};
var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
  if (_isNil(nextChild) && _isNil(prevChild)) {
    return true;
  }
  if (!_isNil(nextChild) && !_isNil(prevChild)) {
    var _ref = nextChild.props || {},
      nextChildren = _ref.children,
      nextProps = _objectWithoutProperties$k(_ref, _excluded$k);
    var _ref2 = prevChild.props || {},
      prevChildren = _ref2.children,
      prevProps = _objectWithoutProperties$k(_ref2, _excluded2$6);
    if (nextChildren && prevChildren) {
      return shallowEqual$1(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
    }
    if (!nextChildren && !prevChildren) {
      return shallowEqual$1(nextProps, prevProps);
    }
    return false;
  }
  return false;
};
var renderByOrder = function renderByOrder(children, renderMap) {
  var elements = [];
  var record = {};
  toArray(children).forEach(function (child, index) {
    if (isSvgElement(child)) {
      elements.push(child);
    } else if (child) {
      var displayName = getDisplayName(child.type);
      var _ref3 = renderMap[displayName] || {},
        handler = _ref3.handler,
        once = _ref3.once;
      if (handler && (!once || !record[displayName])) {
        var results = handler(child, displayName, index);
        elements.push(results);
        record[displayName] = true;
      }
    }
  });
  return elements;
};
var getReactEventByType = function getReactEventByType(e) {
  var type = e && e.type;
  if (type && REACT_BROWSER_EVENT_MAP[type]) {
    return REACT_BROWSER_EVENT_MAP[type];
  }
  return null;
};
var parseChildIndex = function parseChildIndex(child, children) {
  return toArray(children).indexOf(child);
};

var _excluded$j = ['children', 'width', 'height', 'viewBox', 'className', 'style'];
function _extends$B() {
  _extends$B = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$B.apply(this, arguments);
}
function _objectWithoutProperties$j(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$m(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$m(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function Surface(props) {
  var children = props.children,
    width = props.width,
    height = props.height,
    viewBox = props.viewBox,
    className = props.className,
    style = props.style,
    others = _objectWithoutProperties$j(props, _excluded$j);
  var svgView = viewBox || {
    width: width,
    height: height,
    x: 0,
    y: 0,
  };
  var layerClass = cx('recharts-surface', className);
  return /*#__PURE__*/ React__default['default'].createElement(
    'svg',
    _extends$B({}, filterProps(others, true, 'svg'), {
      className: layerClass,
      width: width,
      height: height,
      style: style,
      viewBox: ''.concat(svgView.x, ' ').concat(svgView.y, ' ').concat(svgView.width, ' ').concat(svgView.height),
    }),
    /*#__PURE__*/ React__default['default'].createElement('title', null, props.title),
    /*#__PURE__*/ React__default['default'].createElement('desc', null, props.desc),
    children,
  );
}

var _excluded$i = ['children', 'className'];
function _extends$A() {
  _extends$A = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$A.apply(this, arguments);
}
function _objectWithoutProperties$i(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$l(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$l(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Layer = /*#__PURE__*/ React__default['default'].forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    others = _objectWithoutProperties$i(props, _excluded$i);
  var layerClass = cx('recharts-layer', className);
  return /*#__PURE__*/ React__default['default'].createElement(
    'g',
    _extends$A(
      {
        className: layerClass,
      },
      filterProps(others, true),
      {
        ref: ref,
      },
    ),
    children,
  );
});

var Stack$1 = _Stack,
  baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
    length = index,
    noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
      objValue = object[key],
      srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$1();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (
        !(result === undefined
          ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
          : result)
      ) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$3 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$3(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
  keys$5 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$5(object),
    length = result.length;

  while (length--) {
    var key = result[length],
      value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
  getMatchData = _getMatchData,
  matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var castPath$2 = _castPath,
  isArguments$4 = isArguments_1,
  isArray$7 = isArray_1,
  isIndex = _isIndex,
  isLength = isLength_1,
  toKey$3 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$2(path, object);

  var index = -1,
    length = path.length,
    result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$7(object) || isArguments$4(object));
}

var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
  hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual = _baseIsEqual,
  get = get_1,
  hasIn = hasIn_1,
  isKey$1 = _isKey,
  isStrictComparable = _isStrictComparable,
  matchesStrictComparable = _matchesStrictComparable,
  toKey$2 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet$2 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function (object) {
    return baseGet$2(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
  basePropertyDeep = _basePropertyDeep,
  isKey = _isKey,
  toKey$1 = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
  baseMatchesProperty = _baseMatchesProperty,
  identity$8 = identity_1,
  isArray$6 = isArray_1,
  property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$b(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$8;
  }
  if (typeof value == 'object') {
    return isArray$6(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$b;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$2(array, predicate, fromIndex, fromRight) {
  var length = array.length,
    index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$2;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
    length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex$1 = _baseFindIndex,
  baseIsNaN = _baseIsNaN,
  strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$1(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex$1(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$1;

var baseIndexOf = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes$1;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludesWith$1(array, value, comparator) {
  var index = -1,
    length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith$1;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */

function noop$4() {
  // No operation performed.
}

var noop_1 = noop$4;

var Set$1 = _Set,
  noop$3 = noop_1,
  setToArray$1 = _setToArray;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet$1 = !(Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY$1)
  ? noop$3
  : function (values) {
      return new Set$1(values);
    };

var _createSet = createSet$1;

var SetCache = _SetCache,
  arrayIncludes = _arrayIncludes,
  arrayIncludesWith = _arrayIncludesWith,
  cacheHas = _cacheHas,
  createSet = _createSet,
  setToArray = _setToArray;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq$1(array, iteratee, comparator) {
  var index = -1,
    includes = arrayIncludes,
    length = array.length,
    isCommon = true,
    result = [],
    seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer: while (++index < length) {
    var value = array[index],
      computed = iteratee ? iteratee(value) : value;

    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseUniq = baseUniq$1;

var baseIteratee$a = _baseIteratee,
  baseUniq = _baseUniq;

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return array && array.length ? baseUniq(array, baseIteratee$a(iteratee)) : [];
}

var uniqBy_1 = uniqBy;

var _uniqBy = /*@__PURE__*/ getDefaultExportFromCjs(uniqBy_1);

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$2(array, start, end) {
  var index = -1,
    length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : (end - start) >>> 0;
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$2;

var baseSlice$1 = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice$1(array, start, end);
}

var _castSlice = castSlice$1;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
  rsComboMarksRange$1 = '\\u0300-\\u036f',
  reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
  rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
  rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
  rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$1 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1 + rsComboRange$1 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
  rsComboMarksRange = '\\u0300-\\u036f',
  reComboHalfMarksRange = '\\ufe20-\\ufe2f',
  rsComboSymbolsRange = '\\u20d0-\\u20ff',
  rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
  rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
  rsCombo = '[' + rsComboRange + ']',
  rsFitz = '\\ud83c[\\udffb-\\udfff]',
  rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
  rsNonAstral = '[^' + rsAstralRange + ']',
  rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
  rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
  rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
  rsOptVar = '[' + rsVarRange + ']?',
  rsOptJoin =
    '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
  rsSeq = rsOptVar + reOptMod + rsOptJoin,
  rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
  hasUnicode$1 = _hasUnicode,
  unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string) ? unicodeToArray(string) : asciiToArray(string);
}

var _stringToArray = stringToArray$1;

var castSlice = _castSlice,
  hasUnicode = _hasUnicode,
  stringToArray = _stringToArray,
  toString$2 = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function (string) {
    string = toString$2(string);

    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;

    var chr = strSymbols ? strSymbols[0] : string.charAt(0);

    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst;

var _upperFirst = /*@__PURE__*/ getDefaultExportFromCjs(upperFirst_1);

function constant$1(x) {
  return function constant() {
    return x;
  };
}

const cos = Math.cos;
const sin = Math.sin;
const sqrt$1 = Math.sqrt;

const epsilon$1 = 1e-12;
const pi$1 = Math.PI;
const tau$1 = 2 * pi$1;

const pi = Math.PI,
  tau = 2 * pi,
  epsilon = 1e-6,
  tauEpsilon = tau - epsilon;

function append(strings) {
  this._ += strings[0];
  for (let i = 1, n = strings.length; i < n; ++i) {
    this._ += arguments[i] + strings[i];
  }
}

function appendRound(digits) {
  let d = Math.floor(digits);
  if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
  if (d > 15) return append;
  const k = 10 ** d;
  return function (strings) {
    this._ += strings[0];
    for (let i = 1, n = strings.length; i < n; ++i) {
      this._ += Math.round(arguments[i] * k) / k + strings[i];
    }
  };
}

class Path {
  constructor(digits) {
    this._x0 =
      this._y0 = // start of current subpath
      this._x1 =
      this._y1 =
        null; // end of current subpath
    this._ = '';
    this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x, y) {
    this._append`M${(this._x0 = this._x1 = +x)},${(this._y0 = this._y1 = +y)}`;
  }
  closePath() {
    if (this._x1 !== null) {
      (this._x1 = this._x0), (this._y1 = this._y0);
      this._append`Z`;
    }
  }
  lineTo(x, y) {
    this._append`L${(this._x1 = +x)},${(this._y1 = +y)}`;
  }
  quadraticCurveTo(x1, y1, x, y) {
    this._append`Q${+x1},${+y1},${(this._x1 = +x)},${(this._y1 = +y)}`;
  }
  bezierCurveTo(x1, y1, x2, y2, x, y) {
    this._append`C${+x1},${+y1},${+x2},${+y2},${(this._x1 = +x)},${(this._y1 = +y)}`;
  }
  arcTo(x1, y1, x2, y2, r) {
    (x1 = +x1), (y1 = +y1), (x2 = +x2), (y2 = +y2), (r = +r);

    // Is the radius negative? Error.
    if (r < 0) throw new Error(`negative radius: ${r}`);

    let x0 = this._x1,
      y0 = this._y1,
      x21 = x2 - x1,
      y21 = y2 - y1,
      x01 = x0 - x1,
      y01 = y0 - y1,
      l01_2 = x01 * x01 + y01 * y01;

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._append`M${(this._x1 = x1)},${(this._y1 = y1)}`;
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
      // Equivalently, is (x1,y1) coincident with (x2,y2)?
      // Or, is the radius zero? Line to (x1,y1).
      this._append`L${(this._x1 = x1)},${(this._y1 = y1)}`;
    }

    // Otherwise, draw an arc!
    else {
      let x20 = x2 - x0,
        y20 = y2 - y0,
        l21_2 = x21 * x21 + y21 * y21,
        l20_2 = x20 * x20 + y20 * y20,
        l21 = Math.sqrt(l21_2),
        l01 = Math.sqrt(l01_2),
        l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
        t01 = l / l01,
        t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }

      this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${(this._x1 = x1 + t21 * x21)},${(this._y1 =
        y1 + t21 * y21)}`;
    }
  }
  arc(x, y, r, a0, a1, ccw) {
    (x = +x), (y = +y), (r = +r), (ccw = !!ccw);

    // Is the radius negative? Error.
    if (r < 0) throw new Error(`negative radius: ${r}`);

    let dx = r * Math.cos(a0),
      dy = r * Math.sin(a0),
      x0 = x + dx,
      y0 = y + dy,
      cw = 1 ^ ccw,
      da = ccw ? a0 - a1 : a1 - a0;

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._append`L${x0},${y0}`;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = (da % tau) + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${(this._x1 = x0)},${(this._y1 = y0)}`;
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._append`A${r},${r},0,${+(da >= pi)},${cw},${(this._x1 = x + r * Math.cos(a1))},${(this._y1 =
        y + r * Math.sin(a1))}`;
    }
  }
  rect(x, y, w, h) {
    this._append`M${(this._x0 = this._x1 = +x)},${(this._y0 = this._y1 = +y)}h${(w = +w)}v${+h}h${-w}Z`;
  }
  toString() {
    return this._;
  }
}

function withPath(shape) {
  let digits = 3;

  shape.digits = function (_) {
    if (!arguments.length) return digits;
    if (_ == null) {
      digits = null;
    } else {
      const d = Math.floor(_);
      if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
      digits = d;
    }
    return shape;
  };

  return () => new Path(digits);
}

function array(x) {
  return typeof x === 'object' && 'length' in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._point = 0;
  },
  lineEnd: function () {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    (x = +x), (y = +y);
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2; // falls through
      default:
        this._context.lineTo(x, y);
        break;
    }
  },
};

function curveLinear(context) {
  return new Linear(context);
}

function x$2(p) {
  return p[0];
}

function y$2(p) {
  return p[1];
}

function shapeLine(x, y) {
  var defined = constant$1(true),
    context = null,
    curve = curveLinear,
    output = null,
    path = withPath(line);

  x = typeof x === 'function' ? x : x === undefined ? x$2 : constant$1(x);
  y = typeof y === 'function' ? y : y === undefined ? y$2 : constant$1(y);

  function line(data) {
    var i,
      n = (data = array(data)).length,
      d,
      defined0 = false,
      buffer;

    if (context == null) output = curve((buffer = path()));

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined((d = data[i]), i, data)) === defined0) {
        if ((defined0 = !defined0)) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return (output = null), buffer + '' || null;
  }

  line.x = function (_) {
    return arguments.length ? ((x = typeof _ === 'function' ? _ : constant$1(+_)), line) : x;
  };

  line.y = function (_) {
    return arguments.length ? ((y = typeof _ === 'function' ? _ : constant$1(+_)), line) : y;
  };

  line.defined = function (_) {
    return arguments.length ? ((defined = typeof _ === 'function' ? _ : constant$1(!!_)), line) : defined;
  };

  line.curve = function (_) {
    return arguments.length ? ((curve = _), context != null && (output = curve(context)), line) : curve;
  };

  line.context = function (_) {
    return arguments.length ? (_ == null ? (context = output = null) : (output = curve((context = _))), line) : context;
  };

  return line;
}

function shapeArea(x0, y0, y1) {
  var x1 = null,
    defined = constant$1(true),
    context = null,
    curve = curveLinear,
    output = null,
    path = withPath(area);

  x0 = typeof x0 === 'function' ? x0 : x0 === undefined ? x$2 : constant$1(+x0);
  y0 = typeof y0 === 'function' ? y0 : y0 === undefined ? constant$1(0) : constant$1(+y0);
  y1 = typeof y1 === 'function' ? y1 : y1 === undefined ? y$2 : constant$1(+y1);

  function area(data) {
    var i,
      j,
      k,
      n = (data = array(data)).length,
      d,
      defined0 = false,
      buffer,
      x0z = new Array(n),
      y0z = new Array(n);

    if (context == null) output = curve((buffer = path()));

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined((d = data[i]), i, data)) === defined0) {
        if ((defined0 = !defined0)) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        (x0z[i] = +x0(d, i, data)), (y0z[i] = +y0(d, i, data));
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return (output = null), buffer + '' || null;
  }

  function arealine() {
    return shapeLine().defined(defined).curve(curve).context(context);
  }

  area.x = function (_) {
    return arguments.length ? ((x0 = typeof _ === 'function' ? _ : constant$1(+_)), (x1 = null), area) : x0;
  };

  area.x0 = function (_) {
    return arguments.length ? ((x0 = typeof _ === 'function' ? _ : constant$1(+_)), area) : x0;
  };

  area.x1 = function (_) {
    return arguments.length ? ((x1 = _ == null ? null : typeof _ === 'function' ? _ : constant$1(+_)), area) : x1;
  };

  area.y = function (_) {
    return arguments.length ? ((y0 = typeof _ === 'function' ? _ : constant$1(+_)), (y1 = null), area) : y0;
  };

  area.y0 = function (_) {
    return arguments.length ? ((y0 = typeof _ === 'function' ? _ : constant$1(+_)), area) : y0;
  };

  area.y1 = function (_) {
    return arguments.length ? ((y1 = _ == null ? null : typeof _ === 'function' ? _ : constant$1(+_)), area) : y1;
  };

  area.lineX0 = area.lineY0 = function () {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function () {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function () {
    return arealine().x(x1).y(y0);
  };

  area.defined = function (_) {
    return arguments.length ? ((defined = typeof _ === 'function' ? _ : constant$1(!!_)), area) : defined;
  };

  area.curve = function (_) {
    return arguments.length ? ((curve = _), context != null && (output = curve(context)), area) : curve;
  };

  area.context = function (_) {
    return arguments.length ? (_ == null ? (context = output = null) : (output = curve((context = _))), area) : context;
  };

  return area;
}

var symbolCircle = {
  draw(context, size) {
    const r = sqrt$1(size / pi$1);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau$1);
  },
};

var symbolCross = {
  draw(context, size) {
    const r = sqrt$1(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  },
};

const tan30 = sqrt$1(1 / 3);
const tan30_2 = tan30 * 2;

var symbolDiamond = {
  draw(context, size) {
    const y = sqrt$1(size / tan30_2);
    const x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  },
};

var symbolSquare = {
  draw(context, size) {
    const w = sqrt$1(size);
    const x = -w / 2;
    context.rect(x, x, w, w);
  },
};

const ka = 0.8908130915292852281;
const kr = sin(pi$1 / 10) / sin((7 * pi$1) / 10);
const kx = sin(tau$1 / 10) * kr;
const ky = -cos(tau$1 / 10) * kr;

var symbolStar = {
  draw(context, size) {
    const r = sqrt$1(size * ka);
    const x = kx * r;
    const y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (let i = 1; i < 5; ++i) {
      const a = (tau$1 * i) / 5;
      const c = cos(a);
      const s = sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  },
};

const sqrt3 = sqrt$1(3);

var symbolTriangle = {
  draw(context, size) {
    const y = -sqrt$1(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  },
};

const c$1 = -0.5;
const s$1 = sqrt$1(3) / 2;
const k$2 = 1 / sqrt$1(12);
const a = (k$2 / 2 + 1) * 3;

var symbolWye = {
  draw(context, size) {
    const r = sqrt$1(size / a);
    const x0 = r / 2,
      y0 = r * k$2;
    const x1 = x0,
      y1 = r * k$2 + r;
    const x2 = -x1,
      y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c$1 * x0 - s$1 * y0, s$1 * x0 + c$1 * y0);
    context.lineTo(c$1 * x1 - s$1 * y1, s$1 * x1 + c$1 * y1);
    context.lineTo(c$1 * x2 - s$1 * y2, s$1 * x2 + c$1 * y2);
    context.lineTo(c$1 * x0 + s$1 * y0, c$1 * y0 - s$1 * x0);
    context.lineTo(c$1 * x1 + s$1 * y1, c$1 * y1 - s$1 * x1);
    context.lineTo(c$1 * x2 + s$1 * y2, c$1 * y2 - s$1 * x2);
    context.closePath();
  },
};

function Symbol$3(type, size) {
  let context = null,
    path = withPath(symbol);

  type = typeof type === 'function' ? type : constant$1(type || symbolCircle);
  size = typeof size === 'function' ? size : constant$1(size === undefined ? 64 : +size);

  function symbol() {
    let buffer;
    if (!context) context = buffer = path();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return (context = null), buffer + '' || null;
  }

  symbol.type = function (_) {
    return arguments.length ? ((type = typeof _ === 'function' ? _ : constant$1(_)), symbol) : type;
  };

  symbol.size = function (_) {
    return arguments.length ? ((size = typeof _ === 'function' ? _ : constant$1(+_)), symbol) : size;
  };

  symbol.context = function (_) {
    return arguments.length ? ((context = _ == null ? null : _), symbol) : context;
  };

  return symbol;
}

function noop$2() {}

function point$4(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6,
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 3:
        point$4(this, this._x1, this._y1); // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    (x = +x), (y = +y);
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
      default:
        point$4(this, x, y);
        break;
    }
    (this._x0 = this._x1), (this._x1 = x);
    (this._y0 = this._y1), (this._y1 = y);
  },
};

function curveBasis(context) {
  return new Basis(context);
}

function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function (x, y) {
    (x = +x), (y = +y);
    switch (this._point) {
      case 0:
        this._point = 1;
        (this._x2 = x), (this._y2 = y);
        break;
      case 1:
        this._point = 2;
        (this._x3 = x), (this._y3 = y);
        break;
      case 2:
        this._point = 3;
        (this._x4 = x), (this._y4 = y);
        this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
        break;
      default:
        point$4(this, x, y);
        break;
    }
    (this._x0 = this._x1), (this._x1 = x);
    (this._y0 = this._y1), (this._y1 = y);
  },
};

function curveBasisClosed(context) {
  return new BasisClosed(context);
}

function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    (x = +x), (y = +y);
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var x0 = (this._x0 + 4 * this._x1 + x) / 6,
          y0 = (this._y0 + 4 * this._y1 + y) / 6;
        this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
        break;
      case 3:
        this._point = 4; // falls through
      default:
        point$4(this, x, y);
        break;
    }
    (this._x0 = this._x1), (this._x1 = x);
    (this._y0 = this._y1), (this._y1 = y);
  },
};

function curveBasisOpen(context) {
  return new BasisOpen(context);
}

function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function () {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function () {
    var x = this._x,
      y = this._y,
      j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
        y0 = y[0],
        dx = x[j] - x0,
        dy = y[j] - y0,
        i = -1,
        t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy),
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function (x, y) {
    this._x.push(+x);
    this._y.push(+y);
  },
};

(function custom(beta) {
  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function (beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85);

function point$3(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2,
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        point$3(this, this._x1, this._y1);
        break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    (x = +x), (y = +y);
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        (this._x1 = x), (this._y1 = y);
        break;
      case 2:
        this._point = 3; // falls through
      default:
        point$3(this, x, y);
        break;
    }
    (this._x0 = this._x1), (this._x1 = this._x2), (this._x2 = x);
    (this._y0 = this._y1), (this._y1 = this._y2), (this._y2 = y);
  },
};

(function custom(tension) {
  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function (tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function () {
    this._x0 =
      this._x1 =
      this._x2 =
      this._x3 =
      this._x4 =
      this._x5 =
      this._y0 =
      this._y1 =
      this._y2 =
      this._y3 =
      this._y4 =
      this._y5 =
        NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function (x, y) {
    (x = +x), (y = +y);
    switch (this._point) {
      case 0:
        this._point = 1;
        (this._x3 = x), (this._y3 = y);
        break;
      case 1:
        this._point = 2;
        this._context.moveTo((this._x4 = x), (this._y4 = y));
        break;
      case 2:
        this._point = 3;
        (this._x5 = x), (this._y5 = y);
        break;
      default:
        point$3(this, x, y);
        break;
    }
    (this._x0 = this._x1), (this._x1 = this._x2), (this._x2 = x);
    (this._y0 = this._y1), (this._y1 = this._y2), (this._y2 = y);
  },
};

(function custom(tension) {
  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function (tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    (x = +x), (y = +y);
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4; // falls through
      default:
        point$3(this, x, y);
        break;
    }
    (this._x0 = this._x1), (this._x1 = this._x2), (this._x2 = x);
    (this._y0 = this._y1), (this._y1 = this._y2), (this._y2 = y);
  },
};

(function custom(tension) {
  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function (tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function point$2(that, x, y) {
  var x1 = that._x1,
    y1 = that._y1,
    x2 = that._x2,
    y2 = that._y2;

  if (that._l01_a > epsilon$1) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
      n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > epsilon$1) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
      m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    (x = +x), (y = +y);

    if (this._point) {
      var x23 = this._x2 - x,
        y23 = this._y2 - y;
      this._l23_a = Math.sqrt((this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha)));
    }

    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3; // falls through
      default:
        point$2(this, x, y);
        break;
    }

    (this._l01_a = this._l12_a), (this._l12_a = this._l23_a);
    (this._l01_2a = this._l12_2a), (this._l12_2a = this._l23_2a);
    (this._x0 = this._x1), (this._x1 = this._x2), (this._x2 = x);
    (this._y0 = this._y1), (this._y1 = this._y2), (this._y2 = y);
  },
};

(function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function () {
    this._x0 =
      this._x1 =
      this._x2 =
      this._x3 =
      this._x4 =
      this._x5 =
      this._y0 =
      this._y1 =
      this._y2 =
      this._y3 =
      this._y4 =
      this._y5 =
        NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function (x, y) {
    (x = +x), (y = +y);

    if (this._point) {
      var x23 = this._x2 - x,
        y23 = this._y2 - y;
      this._l23_a = Math.sqrt((this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha)));
    }

    switch (this._point) {
      case 0:
        this._point = 1;
        (this._x3 = x), (this._y3 = y);
        break;
      case 1:
        this._point = 2;
        this._context.moveTo((this._x4 = x), (this._y4 = y));
        break;
      case 2:
        this._point = 3;
        (this._x5 = x), (this._y5 = y);
        break;
      default:
        point$2(this, x, y);
        break;
    }

    (this._l01_a = this._l12_a), (this._l12_a = this._l23_a);
    (this._l01_2a = this._l12_2a), (this._l12_2a = this._l23_2a);
    (this._x0 = this._x1), (this._x1 = this._x2), (this._x2 = x);
    (this._y0 = this._y1), (this._y1 = this._y2), (this._y2 = y);
  },
};

(function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }

  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function () {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    (x = +x), (y = +y);

    if (this._point) {
      var x23 = this._x2 - x,
        y23 = this._y2 - y;
      this._l23_a = Math.sqrt((this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha)));
    }

    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4; // falls through
      default:
        point$2(this, x, y);
        break;
    }

    (this._l01_a = this._l12_a), (this._l12_a = this._l23_a);
    (this._l01_2a = this._l12_2a), (this._l12_2a = this._l23_2a);
    (this._x0 = this._x1), (this._x1 = this._x2), (this._x2 = x);
    (this._y0 = this._y1), (this._y1 = this._y2), (this._y2 = y);
  },
};

(function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }

  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function () {
    this._point = 0;
  },
  lineEnd: function () {
    if (this._point) this._context.closePath();
  },
  point: function (x, y) {
    (x = +x), (y = +y);
    if (this._point) this._context.lineTo(x, y);
    else (this._point = 1), this._context.moveTo(x, y);
  },
};

function curveLinearClosed(context) {
  return new LinearClosed(context);
}

function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
    h1 = x2 - that._x1,
    s0 = (that._y1 - that._y0) / (h0 || (h1 < 0 && -0)),
    s1 = (y2 - that._y1) / (h1 || (h0 < 0 && -0)),
    p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? ((3 * (that._y1 - that._y0)) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point$1(that, t0, t1) {
  var x0 = that._x0,
    y0 = that._y0,
    x1 = that._x1,
    y1 = that._y1,
    dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point$1(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    var t1 = NaN;

    (x = +x), (y = +y);
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point$1(this, slope2(this, (t1 = slope3(this, x, y))), t1);
        break;
      default:
        point$1(this, this._t0, (t1 = slope3(this, x, y)));
        break;
    }

    (this._x0 = this._x1), (this._x1 = x);
    (this._y0 = this._y1), (this._y1 = y);
    this._t0 = t1;
  },
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function (x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function (x, y) {
    this._context.moveTo(y, x);
  },
  closePath: function () {
    this._context.closePath();
  },
  lineTo: function (x, y) {
    this._context.lineTo(y, x);
  },
  bezierCurveTo: function (x1, y1, x2, y2, x, y) {
    this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
  },
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x = [];
    this._y = [];
  },
  lineEnd: function () {
    var x = this._x,
      y = this._y,
      n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
          py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function (x, y) {
    this._x.push(+x);
    this._y.push(+y);
  },
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
    n = x.length - 1,
    m,
    a = new Array(n),
    b = new Array(n),
    r = new Array(n);
  (a[0] = 0), (b[0] = 2), (r[0] = x[0] + 2 * x[1]);
  for (i = 1; i < n - 1; ++i) (a[i] = 1), (b[i] = 4), (r[i] = 4 * x[i] + 2 * x[i + 1]);
  (a[n - 1] = 2), (b[n - 1] = 7), (r[n - 1] = 8 * x[n - 1] + x[n]);
  for (i = 1; i < n; ++i) (m = a[i] / b[i - 1]), (b[i] -= m), (r[i] -= m * r[i - 1]);
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

function curveNatural(context) {
  return new Natural(context);
}

function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) (this._t = 1 - this._t), (this._line = 1 - this._line);
  },
  point: function (x, y) {
    (x = +x), (y = +y);
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;
      case 1:
        this._point = 2; // falls through
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    (this._x = x), (this._y = y);
  },
};

function curveStep(context) {
  return new Step(context, 0.5);
}

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

function stackOffsetNone(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    (s0 = s1), (s1 = series[order[i]]);
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

function stackOrderNone(series) {
  var n = series.length,
    o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}

function stackValue(d, key) {
  return d[key];
}

function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}

function shapeStack() {
  var keys = constant$1([]),
    order = stackOrderNone,
    offset = stackOffsetNone,
    value = stackValue;

  function stack(data) {
    var sz = Array.from(keys.apply(this, arguments), stackSeries),
      i,
      n = sz.length,
      j = -1,
      oz;

    for (const d of data) {
      for (i = 0, ++j; i < n; ++i) {
        (sz[i][j] = [0, +value(d, sz[i].key, j, data)]).data = d;
      }
    }

    for (i = 0, oz = array(order(sz)); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function (_) {
    return arguments.length ? ((keys = typeof _ === 'function' ? _ : constant$1(Array.from(_))), stack) : keys;
  };

  stack.value = function (_) {
    return arguments.length ? ((value = typeof _ === 'function' ? _ : constant$1(+_)), stack) : value;
  };

  stack.order = function (_) {
    return arguments.length
      ? ((order = _ == null ? stackOrderNone : typeof _ === 'function' ? _ : constant$1(Array.from(_))), stack)
      : order;
  };

  stack.offset = function (_) {
    return arguments.length ? ((offset = _ == null ? stackOffsetNone : _), stack) : offset;
  };

  return stack;
}

function stackOffsetExpand(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  stackOffsetNone(series, order);
}

function stackOffsetSilhouette(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  stackOffsetNone(series, order);
}

function stackOffsetWiggle(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
        sij0 = si[j][1] || 0,
        sij1 = si[j - 1][1] || 0,
        s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
          skj0 = sk[j][1] || 0,
          skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      (s1 += sij0), (s2 += s3 * sij0);
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  stackOffsetNone(series, order);
}

function _typeof$1j(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1j =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1j(obj)
  );
}
function _extends$z() {
  _extends$z = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$z.apply(this, arguments);
}
function _classCallCheck$11(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$11(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$J(descriptor.key), descriptor);
  }
}
function _createClass$11(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$11(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$11(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$$(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$11(subClass, superClass);
}
function _setPrototypeOf$11(o, p) {
  _setPrototypeOf$11 = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$11(o, p);
}
function _createSuper$$(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$$();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$$(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$$(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$$(this, result);
  };
}
function _possibleConstructorReturn$$(self, call) {
  if (call && (_typeof$1j(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$11(self);
}
function _assertThisInitialized$11(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$$() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$$(o) {
  _getPrototypeOf$$ = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$$(o);
}
function _defineProperty$1d(obj, key, value) {
  key = _toPropertyKey$J(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$J(arg) {
  var key = _toPrimitive$J(arg, 'string');
  return _typeof$1j(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$J(input, hint) {
  if (_typeof$1j(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$1j(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var symbolFactories = {
  symbolCircle: symbolCircle,
  symbolCross: symbolCross,
  symbolDiamond: symbolDiamond,
  symbolSquare: symbolSquare,
  symbolStar: symbolStar,
  symbolTriangle: symbolTriangle,
  symbolWye: symbolWye,
};
var RADIAN$2 = Math.PI / 180;
var getSymbolFactory = function getSymbolFactory(type) {
  var name = 'symbol'.concat(_upperFirst(type));
  return symbolFactories[name] || symbolCircle;
};
var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
  if (sizeType === 'area') {
    return size;
  }
  switch (type) {
    case 'cross':
      return (5 * size * size) / 9;
    case 'diamond':
      return (0.5 * size * size) / Math.sqrt(3);
    case 'square':
      return size * size;
    case 'star': {
      var angle = 18 * RADIAN$2;
      return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
    }
    case 'triangle':
      return (Math.sqrt(3) * size * size) / 4;
    case 'wye':
      return ((21 - 10 * Math.sqrt(3)) * size * size) / 8;
    default:
      return (Math.PI * size * size) / 4;
  }
};
var Symbols = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$$(Symbols, _PureComponent);
  var _super = _createSuper$$(Symbols);
  function Symbols() {
    _classCallCheck$11(this, Symbols);
    return _super.apply(this, arguments);
  }
  _createClass$11(Symbols, [
    {
      key: 'getPath',
      value:
        /**
         * Calculate the path of curve
         * @return {String} path
         */
        function getPath() {
          var _this$props = this.props,
            size = _this$props.size,
            sizeType = _this$props.sizeType,
            type = _this$props.type;
          var symbolFactory = getSymbolFactory(type);
          var symbol = Symbol$3()
            .type(symbolFactory)
            .size(calculateAreaSize(size, sizeType, type));
          return symbol();
        },
    },
    {
      key: 'render',
      value: function render() {
        var _this$props2 = this.props,
          className = _this$props2.className,
          cx$1 = _this$props2.cx,
          cy = _this$props2.cy,
          size = _this$props2.size;
        var filteredProps = filterProps(this.props, true);
        if (cx$1 === +cx$1 && cy === +cy && size === +size) {
          return /*#__PURE__*/ React__default['default'].createElement(
            'path',
            _extends$z({}, filteredProps, {
              className: cx('recharts-symbols', className),
              transform: 'translate('.concat(cx$1, ', ').concat(cy, ')'),
              d: this.getPath(),
            }),
          );
        }
        return null;
      },
    },
  ]);
  return Symbols;
})(React.PureComponent);
_defineProperty$1d(Symbols, 'defaultProps', {
  type: 'circle',
  size: 64,
  sizeType: 'area',
});
_defineProperty$1d(Symbols, 'registerSymbol', function (key, factory) {
  symbolFactories['symbol'.concat(_upperFirst(key))] = factory;
});

function _typeof$1i(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1i =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1i(obj)
  );
}
function _extends$y() {
  _extends$y = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$y.apply(this, arguments);
}
function ownKeys$D(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$D(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$D(Object(source), !0).forEach(function (key) {
          _defineProperty$1c(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$D(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$10(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$10(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$I(descriptor.key), descriptor);
  }
}
function _createClass$10(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$10(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$10(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$_(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$10(subClass, superClass);
}
function _setPrototypeOf$10(o, p) {
  _setPrototypeOf$10 = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$10(o, p);
}
function _createSuper$_(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$_();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$_(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$_(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$_(this, result);
  };
}
function _possibleConstructorReturn$_(self, call) {
  if (call && (_typeof$1i(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$10(self);
}
function _assertThisInitialized$10(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$_() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$_(o) {
  _getPrototypeOf$_ = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$_(o);
}
function _defineProperty$1c(obj, key, value) {
  key = _toPropertyKey$I(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$I(arg) {
  var key = _toPrimitive$I(arg, 'string');
  return _typeof$1i(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$I(input, hint) {
  if (_typeof$1i(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$1i(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var SIZE = 32;
var DefaultLegendContent = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$_(DefaultLegendContent, _PureComponent);
  var _super = _createSuper$_(DefaultLegendContent);
  function DefaultLegendContent() {
    _classCallCheck$10(this, DefaultLegendContent);
    return _super.apply(this, arguments);
  }
  _createClass$10(DefaultLegendContent, [
    {
      key: 'renderIcon',
      value:
        /**
         * Render the path of icon
         * @param {Object} data Data of each legend item
         * @return {String} Path element
         */
        function renderIcon(data) {
          var inactiveColor = this.props.inactiveColor;
          var halfSize = SIZE / 2;
          var sixthSize = SIZE / 6;
          var thirdSize = SIZE / 3;
          var color = data.inactive ? inactiveColor : data.color;
          if (data.type === 'plainline') {
            return /*#__PURE__*/ React__default['default'].createElement('line', {
              strokeWidth: 4,
              fill: 'none',
              stroke: color,
              strokeDasharray: data.payload.strokeDasharray,
              x1: 0,
              y1: halfSize,
              x2: SIZE,
              y2: halfSize,
              className: 'recharts-legend-icon',
            });
          }
          if (data.type === 'line') {
            return /*#__PURE__*/ React__default['default'].createElement('path', {
              strokeWidth: 4,
              fill: 'none',
              stroke: color,
              d: 'M0,'
                .concat(halfSize, 'h')
                .concat(thirdSize, '\n            A')
                .concat(sixthSize, ',')
                .concat(sixthSize, ',0,1,1,')
                .concat(2 * thirdSize, ',')
                .concat(halfSize, '\n            H')
                .concat(SIZE, 'M')
                .concat(2 * thirdSize, ',')
                .concat(halfSize, '\n            A')
                .concat(sixthSize, ',')
                .concat(sixthSize, ',0,1,1,')
                .concat(thirdSize, ',')
                .concat(halfSize),
              className: 'recharts-legend-icon',
            });
          }
          if (data.type === 'rect') {
            return /*#__PURE__*/ React__default['default'].createElement('path', {
              stroke: 'none',
              fill: color,
              d: 'M0,'
                .concat(SIZE / 8, 'h')
                .concat(SIZE, 'v')
                .concat((SIZE * 3) / 4, 'h')
                .concat(-SIZE, 'z'),
              className: 'recharts-legend-icon',
            });
          }
          if (/*#__PURE__*/ React__default['default'].isValidElement(data.legendIcon)) {
            var iconProps = _objectSpread$D({}, data);
            delete iconProps.legendIcon;
            return /*#__PURE__*/ React__default['default'].cloneElement(data.legendIcon, iconProps);
          }
          return /*#__PURE__*/ React__default['default'].createElement(Symbols, {
            fill: color,
            cx: halfSize,
            cy: halfSize,
            size: SIZE,
            sizeType: 'diameter',
            type: data.type,
          });
        },

      /**
       * Draw items of legend
       * @return {ReactElement} Items
       */
    },
    {
      key: 'renderItems',
      value: function renderItems() {
        var _this = this;
        var _this$props = this.props,
          payload = _this$props.payload,
          iconSize = _this$props.iconSize,
          layout = _this$props.layout,
          formatter = _this$props.formatter,
          inactiveColor = _this$props.inactiveColor;
        var viewBox = {
          x: 0,
          y: 0,
          width: SIZE,
          height: SIZE,
        };
        var itemStyle = {
          display: layout === 'horizontal' ? 'inline-block' : 'block',
          marginRight: 10,
        };
        var svgStyle = {
          display: 'inline-block',
          verticalAlign: 'middle',
          marginRight: 4,
        };
        return payload.map(function (entry, i) {
          var _classNames;
          var finalFormatter = entry.formatter || formatter;
          var className = cx(
            ((_classNames = {
              'recharts-legend-item': true,
            }),
            _defineProperty$1c(_classNames, 'legend-item-'.concat(i), true),
            _defineProperty$1c(_classNames, 'inactive', entry.inactive),
            _classNames),
          );
          if (entry.type === 'none') {
            return null;
          }
          var color = entry.inactive ? inactiveColor : entry.color;
          return /*#__PURE__*/ React__default['default'].createElement(
            'li',
            _extends$y(
              {
                className: className,
                style: itemStyle,
                key: 'legend-item-'.concat(i), // eslint-disable-line react/no-array-index-key
              },
              adaptEventsOfChild(_this.props, entry, i),
            ),
            /*#__PURE__*/ React__default['default'].createElement(
              Surface,
              {
                width: iconSize,
                height: iconSize,
                viewBox: viewBox,
                style: svgStyle,
              },
              _this.renderIcon(entry),
            ),
            /*#__PURE__*/ React__default['default'].createElement(
              'span',
              {
                className: 'recharts-legend-item-text',
                style: {
                  color: color,
                },
              },
              finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value,
            ),
          );
        });
      },
    },
    {
      key: 'render',
      value: function render() {
        var _this$props2 = this.props,
          payload = _this$props2.payload,
          layout = _this$props2.layout,
          align = _this$props2.align;
        if (!payload || !payload.length) {
          return null;
        }
        var finalStyle = {
          padding: 0,
          margin: 0,
          textAlign: layout === 'horizontal' ? align : 'left',
        };
        return /*#__PURE__*/ React__default['default'].createElement(
          'ul',
          {
            className: 'recharts-default-legend',
            style: finalStyle,
          },
          this.renderItems(),
        );
      },
    },
  ]);
  return DefaultLegendContent;
})(React.PureComponent);
_defineProperty$1c(DefaultLegendContent, 'displayName', 'Legend');
_defineProperty$1c(DefaultLegendContent, 'defaultProps', {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'middle',
  inactiveColor: '#ccc',
});

function _typeof$1h(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1h =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1h(obj)
  );
}
var _excluded$h = ['ref'];
function ownKeys$C(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$C(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$C(Object(source), !0).forEach(function (key) {
          _defineProperty$1b(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$C(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$$(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$$(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$H(descriptor.key), descriptor);
  }
}
function _createClass$$(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$$(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$$(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$Z(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$$(subClass, superClass);
}
function _setPrototypeOf$$(o, p) {
  _setPrototypeOf$$ = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$$(o, p);
}
function _createSuper$Z(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$Z();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$Z(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$Z(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$Z(this, result);
  };
}
function _possibleConstructorReturn$Z(self, call) {
  if (call && (_typeof$1h(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$$(self);
}
function _assertThisInitialized$$(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$Z() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$Z(o) {
  _getPrototypeOf$Z = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$Z(o);
}
function _defineProperty$1b(obj, key, value) {
  key = _toPropertyKey$H(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$H(arg) {
  var key = _toPrimitive$H(arg, 'string');
  return _typeof$1h(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$H(input, hint) {
  if (_typeof$1h(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$1h(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _objectWithoutProperties$h(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$k(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$k(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function defaultUniqBy$1(entry) {
  return entry.value;
}
function getUniqPayload$1(option, payload) {
  if (option === true) {
    return _uniqBy(payload, defaultUniqBy$1);
  }
  if (_isFunction(option)) {
    return _uniqBy(payload, option);
  }
  return payload;
}
function renderContent$1(content, props) {
  if (/*#__PURE__*/ React__default['default'].isValidElement(content)) {
    return /*#__PURE__*/ React__default['default'].cloneElement(content, props);
  }
  if (_isFunction(content)) {
    return /*#__PURE__*/ React__default['default'].createElement(content, props);
  }
  props.ref;
  var otherProps = _objectWithoutProperties$h(props, _excluded$h);
  return /*#__PURE__*/ React__default['default'].createElement(DefaultLegendContent, otherProps);
}
var EPS$2 = 1;
var Legend = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$Z(Legend, _PureComponent);
  var _super = _createSuper$Z(Legend);
  function Legend() {
    var _this;
    _classCallCheck$$(this, Legend);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1b(_assertThisInitialized$$(_this), 'state', {
      boxWidth: -1,
      boxHeight: -1,
    });
    return _this;
  }
  _createClass$$(
    Legend,
    [
      {
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.updateBBox();
        },
      },
      {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.updateBBox();
        },
      },
      {
        key: 'getBBox',
        value: function getBBox() {
          if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
            return this.wrapperNode.getBoundingClientRect();
          }
          return null;
        },
      },
      {
        key: 'getBBoxSnapshot',
        value: function getBBoxSnapshot() {
          var _this$state = this.state,
            boxWidth = _this$state.boxWidth,
            boxHeight = _this$state.boxHeight;
          if (boxWidth >= 0 && boxHeight >= 0) {
            return {
              width: boxWidth,
              height: boxHeight,
            };
          }
          return null;
        },
      },
      {
        key: 'getDefaultPosition',
        value: function getDefaultPosition(style) {
          var _this$props = this.props,
            layout = _this$props.layout,
            align = _this$props.align,
            verticalAlign = _this$props.verticalAlign,
            margin = _this$props.margin,
            chartWidth = _this$props.chartWidth,
            chartHeight = _this$props.chartHeight;
          var hPos, vPos;
          if (
            !style ||
            ((style.left === undefined || style.left === null) && (style.right === undefined || style.right === null))
          ) {
            if (align === 'center' && layout === 'vertical') {
              var _box = this.getBBoxSnapshot() || {
                width: 0,
              };
              hPos = {
                left: ((chartWidth || 0) - _box.width) / 2,
              };
            } else {
              hPos =
                align === 'right'
                  ? {
                      right: (margin && margin.right) || 0,
                    }
                  : {
                      left: (margin && margin.left) || 0,
                    };
            }
          }
          if (
            !style ||
            ((style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null))
          ) {
            if (verticalAlign === 'middle') {
              var _box2 = this.getBBoxSnapshot() || {
                height: 0,
              };
              vPos = {
                top: ((chartHeight || 0) - _box2.height) / 2,
              };
            } else {
              vPos =
                verticalAlign === 'bottom'
                  ? {
                      bottom: (margin && margin.bottom) || 0,
                    }
                  : {
                      top: (margin && margin.top) || 0,
                    };
            }
          }
          return _objectSpread$C(_objectSpread$C({}, hPos), vPos);
        },
      },
      {
        key: 'updateBBox',
        value: function updateBBox() {
          var _this$state2 = this.state,
            boxWidth = _this$state2.boxWidth,
            boxHeight = _this$state2.boxHeight;
          var onBBoxUpdate = this.props.onBBoxUpdate;
          if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
            var _box3 = this.wrapperNode.getBoundingClientRect();
            if (Math.abs(_box3.width - boxWidth) > EPS$2 || Math.abs(_box3.height - boxHeight) > EPS$2) {
              this.setState(
                {
                  boxWidth: _box3.width,
                  boxHeight: _box3.height,
                },
                function () {
                  if (onBBoxUpdate) {
                    onBBoxUpdate(_box3);
                  }
                },
              );
            }
          } else if (boxWidth !== -1 || boxHeight !== -1) {
            this.setState(
              {
                boxWidth: -1,
                boxHeight: -1,
              },
              function () {
                if (onBBoxUpdate) {
                  onBBoxUpdate(null);
                }
              },
            );
          }
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this2 = this;
          var _this$props2 = this.props,
            content = _this$props2.content,
            width = _this$props2.width,
            height = _this$props2.height,
            wrapperStyle = _this$props2.wrapperStyle,
            payloadUniqBy = _this$props2.payloadUniqBy,
            payload = _this$props2.payload;
          var outerStyle = _objectSpread$C(
            _objectSpread$C(
              {
                position: 'absolute',
                width: width || 'auto',
                height: height || 'auto',
              },
              this.getDefaultPosition(wrapperStyle),
            ),
            wrapperStyle,
          );
          return /*#__PURE__*/ React__default['default'].createElement(
            'div',
            {
              className: 'recharts-legend-wrapper',
              style: outerStyle,
              ref: function ref(node) {
                _this2.wrapperNode = node;
              },
            },
            renderContent$1(
              content,
              _objectSpread$C(
                _objectSpread$C({}, this.props),
                {},
                {
                  payload: getUniqPayload$1(payloadUniqBy, payload),
                },
              ),
            ),
          );
        },
      },
    ],
    [
      {
        key: 'getWithHeight',
        value: function getWithHeight(item, chartWidth) {
          var layout = item.props.layout;
          if (layout === 'vertical' && isNumber(item.props.height)) {
            return {
              height: item.props.height,
            };
          }
          if (layout === 'horizontal') {
            return {
              width: item.props.width || chartWidth,
            };
          }
          return null;
        },
      },
    ],
  );
  return Legend;
})(React.PureComponent);
_defineProperty$1b(Legend, 'displayName', 'Legend');
_defineProperty$1b(Legend, 'defaultProps', {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
});

/**
 * Default equality comparator pass-through, used as the standard `isEqual` creator for
 * use inside the built comparator.
 */
function createDefaultIsNestedEqual(comparator) {
  return function isEqual(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, meta) {
    return comparator(a, b, meta);
  };
}
/**
 * Wrap the provided `areItemsEqual` method to manage the circular cache, allowing
 * for circular references to be safely included in the comparison without creating
 * stack overflows.
 */
function createIsCircular(areItemsEqual) {
  return function isCircular(a, b, isEqual, cache) {
    if (!a || !b || typeof a !== 'object' || typeof b !== 'object') {
      return areItemsEqual(a, b, isEqual, cache);
    }
    var cachedA = cache.get(a);
    var cachedB = cache.get(b);
    if (cachedA && cachedB) {
      return cachedA === b && cachedB === a;
    }
    cache.set(a, b);
    cache.set(b, a);
    var result = areItemsEqual(a, b, isEqual, cache);
    cache.delete(a);
    cache.delete(b);
    return result;
  };
}
/**
 * Targeted shallow merge of two objects.
 *
 * @NOTE
 * This exists as a tinier compiled version of the `__assign` helper that
 * `tsc` injects in case of `Object.assign` not being present.
 */
function merge(a, b) {
  var merged = {};
  for (var key in a) {
    merged[key] = a[key];
  }
  for (var key in b) {
    merged[key] = b[key];
  }
  return merged;
}
/**
 * Whether the value is a plain object.
 *
 * @NOTE
 * This is a same-realm compariosn only.
 */
function isPlainObject$2(value) {
  return value.constructor === Object || value.constructor == null;
}
/**
 * When the value is `Promise`-like, aka "then-able".
 */
function isPromiseLike(value) {
  return typeof value.then === 'function';
}
/**
 * Whether the values passed are strictly equal or both NaN.
 */
function sameValueZeroEqual(a, b) {
  return a === b || (a !== a && b !== b);
}

var ARGUMENTS_TAG = '[object Arguments]';
var BOOLEAN_TAG = '[object Boolean]';
var DATE_TAG = '[object Date]';
var REG_EXP_TAG = '[object RegExp]';
var MAP_TAG = '[object Map]';
var NUMBER_TAG = '[object Number]';
var OBJECT_TAG = '[object Object]';
var SET_TAG = '[object Set]';
var STRING_TAG = '[object String]';
var toString$1 = Object.prototype.toString;
function createComparator(_a) {
  var areArraysEqual = _a.areArraysEqual,
    areDatesEqual = _a.areDatesEqual,
    areMapsEqual = _a.areMapsEqual,
    areObjectsEqual = _a.areObjectsEqual,
    areRegExpsEqual = _a.areRegExpsEqual,
    areSetsEqual = _a.areSetsEqual,
    createIsNestedEqual = _a.createIsNestedEqual;
  var isEqual = createIsNestedEqual(comparator);
  /**
   * compare the value of the two objects and return true if they are equivalent in values
   */
  function comparator(a, b, meta) {
    // If the items are strictly equal, no need to do a value comparison.
    if (a === b) {
      return true;
    }
    // If the items are not non-nullish objects, then the only possibility
    // of them being equal but not strictly is if they are both `NaN`. Since
    // `NaN` is uniquely not equal to itself, we can use self-comparison of
    // both objects, which is faster than `isNaN()`.
    if (!a || !b || typeof a !== 'object' || typeof b !== 'object') {
      return a !== a && b !== b;
    }
    // Checks are listed in order of commonality of use-case:
    //   1. Common complex object types (plain object, array)
    //   2. Common data values (date, regexp)
    //   3. Less-common complex object types (map, set)
    //   4. Less-common data values (promise, primitive wrappers)
    // Inherently this is both subjective and assumptive, however
    // when reviewing comparable libraries in the wild this order
    // appears to be generally consistent.
    // `isPlainObject` only checks against the object's own realm. Cross-realm
    // comparisons are rare, and will be handled in the ultimate fallback, so
    // we can avoid the `toString.call()` cost unless necessary.
    if (isPlainObject$2(a) && isPlainObject$2(b)) {
      return areObjectsEqual(a, b, isEqual, meta);
    }
    // `isArray()` works on subclasses and is cross-realm, so we can again avoid
    // the `toString.call()` cost unless necessary by just checking if either
    // and then both are arrays.
    var aArray = Array.isArray(a);
    var bArray = Array.isArray(b);
    if (aArray || bArray) {
      return aArray === bArray && areArraysEqual(a, b, isEqual, meta);
    }
    // Since this is a custom object, use the classic `toString.call()` to get its
    // type. This is reasonably performant in modern environments like v8 and
    // SpiderMonkey, and allows for cross-realm comparison when other checks like
    // `instanceof` do not.
    var aTag = toString$1.call(a);
    if (aTag !== toString$1.call(b)) {
      return false;
    }
    if (aTag === DATE_TAG) {
      // `getTime()` showed better results compared to alternatives like `valueOf()`
      // or the unary `+` operator.
      return areDatesEqual(a, b, isEqual, meta);
    }
    if (aTag === REG_EXP_TAG) {
      return areRegExpsEqual(a, b, isEqual, meta);
    }
    if (aTag === MAP_TAG) {
      return areMapsEqual(a, b, isEqual, meta);
    }
    if (aTag === SET_TAG) {
      return areSetsEqual(a, b, isEqual, meta);
    }
    // If a simple object tag, then we can prioritize a simple object comparison because
    // it is likely a custom class. If an arguments tag, it should be treated as a standard
    // object.
    if (aTag === OBJECT_TAG || aTag === ARGUMENTS_TAG) {
      // The exception for value comparison is `Promise`-like contracts. These should be
      // treated the same as standard `Promise` objects, which means strict equality.
      return isPromiseLike(a) || isPromiseLike(b) ? false : areObjectsEqual(a, b, isEqual, meta);
    }
    // As the penultimate fallback, check if the values passed are primitive wrappers. This
    // is very rare in modern JS, which is why it is deprioritized compared to all other object
    // types.
    if (aTag === BOOLEAN_TAG || aTag === NUMBER_TAG || aTag === STRING_TAG) {
      return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    // If not matching any tags that require a specific type of comparison, then we hard-code false because
    // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
    //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
    //     comparison that can be made.
    //   - For types that can be introspected, but rarely have requirements to be compared
    //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
    //     use-cases (may be included in a future release, if requested enough).
    //   - For types that can be introspected but do not have an objective definition of what
    //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
    // In all cases, these decisions should be reevaluated based on changes to the language and
    // common development practices.
    return false;
  }
  return comparator;
}

/**
 * Whether the arrays are equal in value.
 */
function areArraysEqual(a, b, isEqual, meta) {
  var index = a.length;
  if (b.length !== index) {
    return false;
  }
  // Decrementing `while` showed faster results than either incrementing or
  // decrementing `for` loop and than an incrementing `while` loop. Declarative
  // methods like `some` / `every` were not used to avoid incurring the garbage
  // cost of anonymous callbacks.
  while (index-- > 0) {
    if (!isEqual(a[index], b[index], index, index, a, b, meta)) {
      return false;
    }
  }
  return true;
}
/**
 * Whether the arrays are equal in value, including circular references.
 */
var areArraysEqualCircular = createIsCircular(areArraysEqual);

/**
 * Whether the dates passed are equal in value.
 *
 * @NOTE
 * This is a standalone function instead of done inline in the comparator
 * to allow for overrides.
 */
function areDatesEqual(a, b) {
  return sameValueZeroEqual(a.valueOf(), b.valueOf());
}

/**
 * Whether the `Map`s are equal in value.
 */
function areMapsEqual(a, b, isEqual, meta) {
  var isValueEqual = a.size === b.size;
  if (!isValueEqual) {
    return false;
  }
  if (!a.size) {
    return true;
  }
  // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
  // the inability to control the performance of the resulting code. It also avoids excessive
  // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
  // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
  // equality checks themselves.
  var matchedIndices = {};
  var indexA = 0;
  a.forEach(function (aValue, aKey) {
    if (!isValueEqual) {
      return;
    }
    var hasMatch = false;
    var matchIndexB = 0;
    b.forEach(function (bValue, bKey) {
      if (
        !hasMatch &&
        !matchedIndices[matchIndexB] &&
        (hasMatch =
          isEqual(aKey, bKey, indexA, matchIndexB, a, b, meta) && isEqual(aValue, bValue, aKey, bKey, a, b, meta))
      ) {
        matchedIndices[matchIndexB] = true;
      }
      matchIndexB++;
    });
    indexA++;
    isValueEqual = hasMatch;
  });
  return isValueEqual;
}
/**
 * Whether the `Map`s are equal in value, including circular references.
 */
var areMapsEqualCircular = createIsCircular(areMapsEqual);

var OWNER = '_owner';
var hasOwnProperty$4 = Object.prototype.hasOwnProperty;
/**
 * Whether the objects are equal in value.
 */
function areObjectsEqual(a, b, isEqual, meta) {
  var keysA = Object.keys(a);
  var index = keysA.length;
  if (Object.keys(b).length !== index) {
    return false;
  }
  var key;
  // Decrementing `while` showed faster results than either incrementing or
  // decrementing `for` loop and than an incrementing `while` loop. Declarative
  // methods like `some` / `every` were not used to avoid incurring the garbage
  // cost of anonymous callbacks.
  while (index-- > 0) {
    key = keysA[index];
    if (key === OWNER) {
      var reactElementA = !!a.$$typeof;
      var reactElementB = !!b.$$typeof;
      if ((reactElementA || reactElementB) && reactElementA !== reactElementB) {
        return false;
      }
    }
    if (!hasOwnProperty$4.call(b, key) || !isEqual(a[key], b[key], key, key, a, b, meta)) {
      return false;
    }
  }
  return true;
}
/**
 * Whether the objects are equal in value, including circular references.
 */
var areObjectsEqualCircular = createIsCircular(areObjectsEqual);

/**
 * Whether the regexps passed are equal in value.
 *
 * @NOTE
 * This is a standalone function instead of done inline in the comparator
 * to allow for overrides. An example of this would be supporting a
 * pre-ES2015 environment where the `flags` property is not available.
 */
function areRegExpsEqual(a, b) {
  return a.source === b.source && a.flags === b.flags;
}

/**
 * Whether the `Set`s are equal in value.
 */
function areSetsEqual(a, b, isEqual, meta) {
  var isValueEqual = a.size === b.size;
  if (!isValueEqual) {
    return false;
  }
  if (!a.size) {
    return true;
  }
  // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
  // the inability to control the performance of the resulting code. It also avoids excessive
  // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
  // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
  // equality checks themselves.
  var matchedIndices = {};
  a.forEach(function (aValue, aKey) {
    if (!isValueEqual) {
      return;
    }
    var hasMatch = false;
    var matchIndex = 0;
    b.forEach(function (bValue, bKey) {
      if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = isEqual(aValue, bValue, aKey, bKey, a, b, meta))) {
        matchedIndices[matchIndex] = true;
      }
      matchIndex++;
    });
    isValueEqual = hasMatch;
  });
  return isValueEqual;
}
/**
 * Whether the `Set`s are equal in value, including circular references.
 */
var areSetsEqualCircular = createIsCircular(areSetsEqual);

var DEFAULT_CONFIG = Object.freeze({
  areArraysEqual: areArraysEqual,
  areDatesEqual: areDatesEqual,
  areMapsEqual: areMapsEqual,
  areObjectsEqual: areObjectsEqual,
  areRegExpsEqual: areRegExpsEqual,
  areSetsEqual: areSetsEqual,
  createIsNestedEqual: createDefaultIsNestedEqual,
});
var DEFAULT_CIRCULAR_CONFIG = Object.freeze({
  areArraysEqual: areArraysEqualCircular,
  areDatesEqual: areDatesEqual,
  areMapsEqual: areMapsEqualCircular,
  areObjectsEqual: areObjectsEqualCircular,
  areRegExpsEqual: areRegExpsEqual,
  areSetsEqual: areSetsEqualCircular,
  createIsNestedEqual: createDefaultIsNestedEqual,
});
var isDeepEqual = createComparator(DEFAULT_CONFIG);
/**
 * Whether the items passed are deeply-equal in value.
 */
function deepEqual$2(a, b) {
  return isDeepEqual(a, b, undefined);
}
createComparator(
  merge(DEFAULT_CONFIG, {
    createIsNestedEqual: function () {
      return sameValueZeroEqual;
    },
  }),
);
createComparator(DEFAULT_CIRCULAR_CONFIG);
createComparator(
  merge(DEFAULT_CIRCULAR_CONFIG, {
    createIsNestedEqual: function () {
      return sameValueZeroEqual;
    },
  }),
);

function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currTime = -1;
  var shouldUpdate = function shouldUpdate(now) {
    if (currTime < 0) {
      currTime = now;
    }
    if (now - currTime > timeout) {
      callback(now);
      currTime = -1;
    } else {
      requestAnimationFrame(shouldUpdate);
    }
  };
  requestAnimationFrame(shouldUpdate);
}

function _typeof$1g(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1g =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1g(obj)
  );
}
function _toArray(arr) {
  return (
    _arrayWithHoles$d(arr) || _iterableToArray$f(arr) || _unsupportedIterableToArray$n(arr) || _nonIterableRest$d()
  );
}
function _nonIterableRest$d() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$n(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$n(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$n(o, minLen);
}
function _arrayLikeToArray$n(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArray$f(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithHoles$d(arr) {
  if (Array.isArray(arr)) return arr;
}
function createAnimateManager() {
  var currStyle = {};
  var handleChange = function handleChange() {
    return null;
  };
  var shouldStop = false;
  var setStyle = function setStyle(_style) {
    if (shouldStop) {
      return;
    }
    if (Array.isArray(_style)) {
      if (!_style.length) {
        return;
      }
      var styles = _style;
      var _styles = _toArray(styles),
        curr = _styles[0],
        restStyles = _styles.slice(1);
      if (typeof curr === 'number') {
        setRafTimeout(setStyle.bind(null, restStyles), curr);
        return;
      }
      setStyle(curr);
      setRafTimeout(setStyle.bind(null, restStyles));
      return;
    }
    if (_typeof$1g(_style) === 'object') {
      currStyle = _style;
      handleChange(currStyle);
    }
    if (typeof _style === 'function') {
      _style();
    }
  };
  return {
    stop: function stop() {
      shouldStop = true;
    },
    start: function start(style) {
      shouldStop = false;
      setStyle(style);
    },
    subscribe: function subscribe(_handleChange) {
      handleChange = _handleChange;
      return function () {
        handleChange = function handleChange() {
          return null;
        };
      };
    },
  };
}

function _typeof$1f(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1f =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1f(obj)
  );
}
function ownKeys$B(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$B(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$B(Object(source), !0).forEach(function (key) {
          _defineProperty$1a(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$B(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$1a(obj, key, value) {
  key = _toPropertyKey$G(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$G(arg) {
  var key = _toPrimitive$G(arg, 'string');
  return _typeof$1f(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$G(input, hint) {
  if (_typeof$1f(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$1f(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
/* eslint no-console: 0 */
var PREFIX_LIST$1 = ['Webkit', 'Moz', 'O', 'ms'];
var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
  return [Object.keys(preObj), Object.keys(nextObj)].reduce(function (a, b) {
    return a.filter(function (c) {
      return b.includes(c);
    });
  });
};
var identity$7 = function identity(param) {
  return param;
};

/*
 * @description: convert camel case to dash case
 * string => string
 */
var getDashCase = function getDashCase(name) {
  return name.replace(/([A-Z])/g, function (v) {
    return '-'.concat(v.toLowerCase());
  });
};

/*
 * @description: add compatible style prefix
 * (string, string) => object
 */
var generatePrefixStyle$1 = function generatePrefixStyle(name, value) {
  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
    return _defineProperty$1a({}, name, value);
  }
  var isTransition = name === 'transition';
  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var styleVal = value;
  return PREFIX_LIST$1.reduce(function (result, property, i) {
    if (isTransition) {
      styleVal = value.replace(/(transform|transform-origin)/gim, ''.concat(IN_LINE_PREFIX_LIST[i], '$1'));
    }
    return _objectSpread$B(_objectSpread$B({}, result), {}, _defineProperty$1a({}, property + camelName, styleVal));
  }, {});
};

/*
 * @description: map object on every element in this object.
 * (function, object) => object
 */
var mapObject = function mapObject(fn, obj) {
  return Object.keys(obj).reduce(function (res, key) {
    return _objectSpread$B(_objectSpread$B({}, res), {}, _defineProperty$1a({}, key, fn(key, obj[key])));
  }, {});
};

/*
 * @description: add compatible prefix to style
 * object => object
 */
var translateStyle = function translateStyle(style) {
  return Object.keys(style).reduce(function (res, key) {
    return _objectSpread$B(_objectSpread$B({}, res), generatePrefixStyle$1(key, res[key]));
  }, style);
};
var getTransitionVal = function getTransitionVal(props, duration, easing) {
  return props
    .map(function (prop) {
      return ''.concat(getDashCase(prop), ' ').concat(duration, 'ms ').concat(easing);
    })
    .join(',');
};
var isDev$1 = process.env.NODE_ENV !== 'production';
var warn$1 = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev$1 && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }
    if (!condition) {
      if (format === undefined) {
        console.warn(
          'Minified exception occurred; use the non-minified dev environment ' +
            'for the full error message and additional helpful warnings.',
        );
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        console.warn(
          format.replace(/%s/g, function () {
            return args[argIndex++];
          }),
        );
      }
    }
  }
};

function _slicedToArray$c(arr, i) {
  return (
    _arrayWithHoles$c(arr) ||
    _iterableToArrayLimit$c(arr, i) ||
    _unsupportedIterableToArray$m(arr, i) ||
    _nonIterableRest$c()
  );
}
function _nonIterableRest$c() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _iterableToArrayLimit$c(arr, i) {
  var _i = null == arr ? null : ('undefined' != typeof Symbol && arr[Symbol.iterator]) || arr['@@iterator'];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      (_d = !0), (_e = err);
    } finally {
      try {
        if (!_n && null != _i.return && ((_r = _i.return()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$c(arr) {
  if (Array.isArray(arr)) return arr;
}
function _toConsumableArray$e(arr) {
  return (
    _arrayWithoutHoles$e(arr) || _iterableToArray$e(arr) || _unsupportedIterableToArray$m(arr) || _nonIterableSpread$e()
  );
}
function _nonIterableSpread$e() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$m(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$m(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$m(o, minLen);
}
function _iterableToArray$e(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$e(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$m(arr);
}
function _arrayLikeToArray$m(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var ACCURACY = 1e-4;
var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
};
var multyTime = function multyTime(params, t) {
  return params
    .map(function (param, i) {
      return param * Math.pow(t, i);
    })
    .reduce(function (pre, curr) {
      return pre + curr;
    });
};
var cubicBezier = function cubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    return multyTime(params, t);
  };
};
var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    var newParams = [].concat(
      _toConsumableArray$e(
        params
          .map(function (param, i) {
            return param * i;
          })
          .slice(1),
      ),
      [0],
    );
    return multyTime(newParams, t);
  };
};

// calculate cubic-bezier using Newton's method
var configBezier = function configBezier() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var x1 = args[0],
    y1 = args[1],
    x2 = args[2],
    y2 = args[3];
  if (args.length === 1) {
    switch (args[0]) {
      case 'linear':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;
        break;
      case 'ease':
        x1 = 0.25;
        y1 = 0.1;
        x2 = 0.25;
        y2 = 1.0;
        break;
      case 'ease-in':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;
        break;
      case 'ease-out':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;
        break;
      case 'ease-in-out':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;
        break;
      default: {
        var easing = args[0].split('(');
        if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
          var _easing$1$split$0$spl = easing[1]
            .split(')')[0]
            .split(',')
            .map(function (x) {
              return parseFloat(x);
            });
          var _easing$1$split$0$spl2 = _slicedToArray$c(_easing$1$split$0$spl, 4);
          x1 = _easing$1$split$0$spl2[0];
          y1 = _easing$1$split$0$spl2[1];
          x2 = _easing$1$split$0$spl2[2];
          y2 = _easing$1$split$0$spl2[3];
        } else {
          warn$1(
            false,
            '[configBezier]: arguments should be one of ' +
              "oneOf 'linear', 'ease', 'ease-in', 'ease-out', " +
              "'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s",
            args,
          );
        }
      }
    }
  }
  warn$1(
    [x1, x2, y1, y2].every(function (num) {
      return typeof num === 'number' && num >= 0 && num <= 1;
    }),
    '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s',
    args,
  );
  var curveX = cubicBezier(x1, x2);
  var curveY = cubicBezier(y1, y2);
  var derCurveX = derivativeCubicBezier(x1, x2);
  var rangeValue = function rangeValue(value) {
    if (value > 1) {
      return 1;
    } else if (value < 0) {
      return 0;
    }
    return value;
  };
  var bezier = function bezier(_t) {
    var t = _t > 1 ? 1 : _t;
    var x = t;
    for (var i = 0; i < 8; ++i) {
      var evalT = curveX(x) - t;
      var derVal = derCurveX(x);
      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
        return curveY(x);
      }
      x = rangeValue(x - evalT / derVal);
    }
    return curveY(x);
  };
  bezier.isStepper = false;
  return bezier;
};
var configSpring = function configSpring() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$stiff = config.stiff,
    stiff = _config$stiff === void 0 ? 100 : _config$stiff,
    _config$damping = config.damping,
    damping = _config$damping === void 0 ? 8 : _config$damping,
    _config$dt = config.dt,
    dt = _config$dt === void 0 ? 17 : _config$dt;
  var stepper = function stepper(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff;
    var FDamping = currV * damping;
    var newV = currV + ((FSpring - FDamping) * dt) / 1000;
    var newX = (currV * dt) / 1000 + currX;
    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
      return [destX, 0];
    }
    return [newX, newV];
  };
  stepper.isStepper = true;
  stepper.dt = dt;
  return stepper;
};
var configEasing = function configEasing() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var easing = args[0];
  if (typeof easing === 'string') {
    switch (easing) {
      case 'ease':
      case 'ease-in-out':
      case 'ease-out':
      case 'ease-in':
      case 'linear':
        return configBezier(easing);
      case 'spring':
        return configSpring();
      default:
        if (easing.split('(')[0] === 'cubic-bezier') {
          return configBezier(easing);
        }
        warn$1(
          false,
          "[configEasing]: first argument should be one of 'ease', 'ease-in', " +
            "'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s",
          args,
        );
    }
  }
  if (typeof easing === 'function') {
    return easing;
  }
  warn$1(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
  return null;
};

function _typeof$1e(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1e =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1e(obj)
  );
}
function _toConsumableArray$d(arr) {
  return (
    _arrayWithoutHoles$d(arr) || _iterableToArray$d(arr) || _unsupportedIterableToArray$l(arr) || _nonIterableSpread$d()
  );
}
function _nonIterableSpread$d() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _iterableToArray$d(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$d(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$l(arr);
}
function ownKeys$A(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$A(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$A(Object(source), !0).forEach(function (key) {
          _defineProperty$19(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$A(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$19(obj, key, value) {
  key = _toPropertyKey$F(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$F(arg) {
  var key = _toPrimitive$F(arg, 'string');
  return _typeof$1e(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$F(input, hint) {
  if (_typeof$1e(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$1e(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _slicedToArray$b(arr, i) {
  return (
    _arrayWithHoles$b(arr) ||
    _iterableToArrayLimit$b(arr, i) ||
    _unsupportedIterableToArray$l(arr, i) ||
    _nonIterableRest$b()
  );
}
function _nonIterableRest$b() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$l(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$l(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$l(o, minLen);
}
function _arrayLikeToArray$l(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit$b(arr, i) {
  var _i = null == arr ? null : ('undefined' != typeof Symbol && arr[Symbol.iterator]) || arr['@@iterator'];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      (_d = !0), (_e = err);
    } finally {
      try {
        if (!_n && null != _i.return && ((_r = _i.return()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$b(arr) {
  if (Array.isArray(arr)) return arr;
}
var alpha = function alpha(begin, end, k) {
  return begin + (end - begin) * k;
};
var needContinue = function needContinue(_ref) {
  var from = _ref.from,
    to = _ref.to;
  return from !== to;
};

/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */
var calStepperVals = function calStepperVals(easing, preVals, steps) {
  var nextStepVals = mapObject(function (key, val) {
    if (needContinue(val)) {
      var _easing = easing(val.from, val.to, val.velocity),
        _easing2 = _slicedToArray$b(_easing, 2),
        newX = _easing2[0],
        newV = _easing2[1];
      return _objectSpread$A(
        _objectSpread$A({}, val),
        {},
        {
          from: newX,
          velocity: newV,
        },
      );
    }
    return val;
  }, preVals);
  if (steps < 1) {
    return mapObject(function (key, val) {
      if (needContinue(val)) {
        return _objectSpread$A(
          _objectSpread$A({}, val),
          {},
          {
            velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: alpha(val.from, nextStepVals[key].from, steps),
          },
        );
      }
      return val;
    }, preVals);
  }
  return calStepperVals(easing, nextStepVals, steps - 1);
};

// configure update function
var configUpdate = function (from, to, easing, duration, render) {
  var interKeys = getIntersectionKeys(from, to);
  var timingStyle = interKeys.reduce(function (res, key) {
    return _objectSpread$A(_objectSpread$A({}, res), {}, _defineProperty$19({}, key, [from[key], to[key]]));
  }, {});
  var stepperStyle = interKeys.reduce(function (res, key) {
    return _objectSpread$A(
      _objectSpread$A({}, res),
      {},
      _defineProperty$19({}, key, {
        from: from[key],
        velocity: 0,
        to: to[key],
      }),
    );
  }, {});
  var cafId = -1;
  var preTime;
  var beginTime;
  var update = function update() {
    return null;
  };
  var getCurrStyle = function getCurrStyle() {
    return mapObject(function (key, val) {
      return val.from;
    }, stepperStyle);
  };
  var shouldStopAnimation = function shouldStopAnimation() {
    return !Object.values(stepperStyle).filter(needContinue).length;
  };

  // stepper timing function like spring
  var stepperUpdate = function stepperUpdate(now) {
    if (!preTime) {
      preTime = now;
    }
    var deltaTime = now - preTime;
    var steps = deltaTime / easing.dt;
    stepperStyle = calStepperVals(easing, stepperStyle, steps);
    // get union set and add compatible prefix
    render(_objectSpread$A(_objectSpread$A(_objectSpread$A({}, from), to), getCurrStyle()));
    preTime = now;
    if (!shouldStopAnimation()) {
      cafId = requestAnimationFrame(update);
    }
  };

  // t => val timing function like cubic-bezier
  var timingUpdate = function timingUpdate(now) {
    if (!beginTime) {
      beginTime = now;
    }
    var t = (now - beginTime) / duration;
    var currStyle = mapObject(function (key, val) {
      return alpha.apply(void 0, _toConsumableArray$d(val).concat([easing(t)]));
    }, timingStyle);

    // get union set and add compatible prefix
    render(_objectSpread$A(_objectSpread$A(_objectSpread$A({}, from), to), currStyle));
    if (t < 1) {
      cafId = requestAnimationFrame(update);
    } else {
      var finalStyle = mapObject(function (key, val) {
        return alpha.apply(void 0, _toConsumableArray$d(val).concat([easing(1)]));
      }, timingStyle);
      render(_objectSpread$A(_objectSpread$A(_objectSpread$A({}, from), to), finalStyle));
    }
  };
  update = easing.isStepper ? stepperUpdate : timingUpdate;

  // return start animation method
  return function () {
    requestAnimationFrame(update);

    // return stop animation method
    return function () {
      cancelAnimationFrame(cafId);
    };
  };
};

var _excluded$g = [
  'children',
  'begin',
  'duration',
  'attributeName',
  'easing',
  'isActive',
  'steps',
  'from',
  'to',
  'canBegin',
  'onAnimationEnd',
  'shouldReAnimate',
  'onAnimationReStart',
];
function _typeof$1d(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1d =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1d(obj)
  );
}
function _objectWithoutProperties$g(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$j(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$j(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _toConsumableArray$c(arr) {
  return (
    _arrayWithoutHoles$c(arr) || _iterableToArray$c(arr) || _unsupportedIterableToArray$k(arr) || _nonIterableSpread$c()
  );
}
function _nonIterableSpread$c() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$k(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$k(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$k(o, minLen);
}
function _iterableToArray$c(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$c(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$k(arr);
}
function _arrayLikeToArray$k(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function ownKeys$z(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$z(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$z(Object(source), !0).forEach(function (key) {
          _defineProperty$18(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$z(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$_(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$_(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$E(descriptor.key), descriptor);
  }
}
function _createClass$_(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$_(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$_(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$Y(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$_(subClass, superClass);
}
function _setPrototypeOf$_(o, p) {
  _setPrototypeOf$_ = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$_(o, p);
}
function _createSuper$Y(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$Y();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$Y(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$Y(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$Y(this, result);
  };
}
function _possibleConstructorReturn$Y(self, call) {
  if (call && (_typeof$1d(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$_(self);
}
function _assertThisInitialized$_(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$Y() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$Y(o) {
  _getPrototypeOf$Y = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$Y(o);
}
function _defineProperty$18(obj, key, value) {
  key = _toPropertyKey$E(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$E(arg) {
  var key = _toPrimitive$E(arg, 'string');
  return _typeof$1d(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$E(input, hint) {
  if (_typeof$1d(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$1d(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var Animate = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$Y(Animate, _PureComponent);
  var _super = _createSuper$Y(Animate);
  function Animate(props, context) {
    var _this;
    _classCallCheck$_(this, Animate);
    _this = _super.call(this, props, context);
    var _this$props = _this.props,
      isActive = _this$props.isActive,
      attributeName = _this$props.attributeName,
      from = _this$props.from,
      to = _this$props.to,
      steps = _this$props.steps,
      children = _this$props.children;
    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized$_(_this));
    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized$_(_this));
    if (!isActive) {
      _this.state = {
        style: {},
      };

      // if children is a function and animation is not active, set style to 'to'
      if (typeof children === 'function') {
        _this.state = {
          style: to,
        };
      }
      return _possibleConstructorReturn$Y(_this);
    }
    if (steps && steps.length) {
      _this.state = {
        style: steps[0].style,
      };
    } else if (from) {
      if (typeof children === 'function') {
        _this.state = {
          style: from,
        };
        return _possibleConstructorReturn$Y(_this);
      }
      _this.state = {
        style: attributeName ? _defineProperty$18({}, attributeName, from) : from,
      };
    } else {
      _this.state = {
        style: {},
      };
    }
    return _this;
  }
  _createClass$_(Animate, [
    {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this$props2 = this.props,
          isActive = _this$props2.isActive,
          canBegin = _this$props2.canBegin;
        this.mounted = true;
        if (!isActive || !canBegin) {
          return;
        }
        this.runAnimation(this.props);
      },
    },
    {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _this$props3 = this.props,
          isActive = _this$props3.isActive,
          canBegin = _this$props3.canBegin,
          attributeName = _this$props3.attributeName,
          shouldReAnimate = _this$props3.shouldReAnimate;
        if (!canBegin) {
          return;
        }
        if (!isActive) {
          var newState = {
            style: attributeName ? _defineProperty$18({}, attributeName, this.props.to) : this.props.to,
          };
          if (this.state && this.state.style) {
            if (
              (attributeName && this.state.style[attributeName] !== this.props.to) ||
              (!attributeName && this.state.style !== this.props.to)
            ) {
              // eslint-disable-next-line react/no-did-update-set-state
              this.setState(newState);
            }
          }
          return;
        }
        if (deepEqual$2(prevProps.to, this.props.to) && prevProps.canBegin && prevProps.isActive) {
          return;
        }
        var isTriggered = !prevProps.canBegin || !prevProps.isActive;
        if (this.manager) {
          this.manager.stop();
        }
        if (this.stopJSAnimation) {
          this.stopJSAnimation();
        }
        var from = isTriggered || shouldReAnimate ? this.props.from : prevProps.to;
        if (this.state && this.state.style) {
          var _newState = {
            style: attributeName ? _defineProperty$18({}, attributeName, from) : from,
          };
          if (
            (attributeName && this.state.style[attributeName] !== from) ||
            (!attributeName && this.state.style !== from)
          ) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(_newState);
          }
        }
        this.runAnimation(
          _objectSpread$z(
            _objectSpread$z({}, this.props),
            {},
            {
              from: from,
              begin: 0,
            },
          ),
        );
      },
    },
    {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.mounted = false;
        if (this.unSubscribe) {
          this.unSubscribe();
        }
        if (this.manager) {
          this.manager.stop();
          this.manager = null;
        }
        if (this.stopJSAnimation) {
          this.stopJSAnimation();
        }
      },
    },
    {
      key: 'runJSAnimation',
      value: function runJSAnimation(props) {
        var _this2 = this;
        var from = props.from,
          to = props.to,
          duration = props.duration,
          easing = props.easing,
          begin = props.begin,
          onAnimationEnd = props.onAnimationEnd,
          onAnimationStart = props.onAnimationStart;
        var startAnimation = configUpdate(from, to, configEasing(easing), duration, this.changeStyle);
        var finalStartAnimation = function finalStartAnimation() {
          _this2.stopJSAnimation = startAnimation();
        };
        this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
      },
    },
    {
      key: 'runStepAnimation',
      value: function runStepAnimation(props) {
        var _this3 = this;
        var steps = props.steps,
          begin = props.begin,
          onAnimationStart = props.onAnimationStart;
        var _steps$ = steps[0],
          initialStyle = _steps$.style,
          _steps$$duration = _steps$.duration,
          initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
        var addStyle = function addStyle(sequence, nextItem, index) {
          if (index === 0) {
            return sequence;
          }
          var duration = nextItem.duration,
            _nextItem$easing = nextItem.easing,
            easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing,
            style = nextItem.style,
            nextProperties = nextItem.properties,
            onAnimationEnd = nextItem.onAnimationEnd;
          var preItem = index > 0 ? steps[index - 1] : nextItem;
          var properties = nextProperties || Object.keys(style);
          if (typeof easing === 'function' || easing === 'spring') {
            return [].concat(_toConsumableArray$c(sequence), [
              _this3.runJSAnimation.bind(_this3, {
                from: preItem.style,
                to: style,
                duration: duration,
                easing: easing,
              }),
              duration,
            ]);
          }
          var transition = getTransitionVal(properties, duration, easing);
          var newStyle = _objectSpread$z(
            _objectSpread$z(_objectSpread$z({}, preItem.style), style),
            {},
            {
              transition: transition,
            },
          );
          return [].concat(_toConsumableArray$c(sequence), [newStyle, duration, onAnimationEnd]).filter(identity$7);
        };
        return this.manager.start(
          [onAnimationStart].concat(
            _toConsumableArray$c(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])),
            [props.onAnimationEnd],
          ),
        );
      },
    },
    {
      key: 'runAnimation',
      value: function runAnimation(props) {
        if (!this.manager) {
          this.manager = createAnimateManager();
        }
        var begin = props.begin,
          duration = props.duration,
          attributeName = props.attributeName,
          propsTo = props.to,
          easing = props.easing,
          onAnimationStart = props.onAnimationStart,
          onAnimationEnd = props.onAnimationEnd,
          steps = props.steps,
          children = props.children;
        var manager = this.manager;
        this.unSubscribe = manager.subscribe(this.handleStyleChange);
        if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
          this.runJSAnimation(props);
          return;
        }
        if (steps.length > 1) {
          this.runStepAnimation(props);
          return;
        }
        var to = attributeName ? _defineProperty$18({}, attributeName, propsTo) : propsTo;
        var transition = getTransitionVal(Object.keys(to), duration, easing);
        manager.start([
          onAnimationStart,
          begin,
          _objectSpread$z(
            _objectSpread$z({}, to),
            {},
            {
              transition: transition,
            },
          ),
          duration,
          onAnimationEnd,
        ]);
      },
    },
    {
      key: 'handleStyleChange',
      value: function handleStyleChange(style) {
        this.changeStyle(style);
      },
    },
    {
      key: 'changeStyle',
      value: function changeStyle(style) {
        if (this.mounted) {
          this.setState({
            style: style,
          });
        }
      },
    },
    {
      key: 'render',
      value: function render() {
        var _this$props4 = this.props,
          children = _this$props4.children;
        _this$props4.begin;
        _this$props4.duration;
        _this$props4.attributeName;
        _this$props4.easing;
        var isActive = _this$props4.isActive;
        _this$props4.steps;
        _this$props4.from;
        _this$props4.to;
        _this$props4.canBegin;
        _this$props4.onAnimationEnd;
        _this$props4.shouldReAnimate;
        _this$props4.onAnimationReStart;
        var others = _objectWithoutProperties$g(_this$props4, _excluded$g);
        var count = React.Children.count(children);
        var stateStyle = translateStyle(this.state.style);
        if (typeof children === 'function') {
          return children(stateStyle);
        }
        if (!isActive || count === 0) {
          return children;
        }
        var cloneContainer = function cloneContainer(container) {
          var _container$props = container.props,
            _container$props$styl = _container$props.style,
            style = _container$props$styl === void 0 ? {} : _container$props$styl,
            className = _container$props.className;
          var res = /*#__PURE__*/ React.cloneElement(
            container,
            _objectSpread$z(
              _objectSpread$z({}, others),
              {},
              {
                style: _objectSpread$z(_objectSpread$z({}, style), stateStyle),
                className: className,
              },
            ),
          );
          return res;
        };
        if (count === 1) {
          return cloneContainer(React.Children.only(children));
        }
        return /*#__PURE__*/ React__default['default'].createElement(
          'div',
          null,
          React.Children.map(children, function (child) {
            return cloneContainer(child);
          }),
        );
      },
    },
  ]);
  return Animate;
})(React.PureComponent);
_defineProperty$18(Animate, 'displayName', 'Animate');
_defineProperty$18(Animate, 'propTypes', {
  from: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].object,
    PropTypes__default['default'].string,
  ]),
  to: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].object,
    PropTypes__default['default'].string,
  ]),
  attributeName: PropTypes__default['default'].string,
  // animation duration
  duration: PropTypes__default['default'].number,
  begin: PropTypes__default['default'].number,
  easing: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].func,
  ]),
  steps: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      duration: PropTypes__default['default'].number.isRequired,
      style: PropTypes__default['default'].object.isRequired,
      easing: PropTypes__default['default'].oneOfType([
        PropTypes__default['default'].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
        PropTypes__default['default'].func,
      ]),
      // transition css properties(dash case), optional
      properties: PropTypes__default['default'].arrayOf('string'),
      onAnimationEnd: PropTypes__default['default'].func,
    }),
  ),
  children: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].node,
    PropTypes__default['default'].func,
  ]),
  isActive: PropTypes__default['default'].bool,
  canBegin: PropTypes__default['default'].bool,
  onAnimationEnd: PropTypes__default['default'].func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: PropTypes__default['default'].bool,
  onAnimationStart: PropTypes__default['default'].func,
  onAnimationReStart: PropTypes__default['default'].func,
});
_defineProperty$18(Animate, 'defaultProps', {
  begin: 0,
  duration: 1000,
  from: '',
  to: '',
  attributeName: '',
  easing: 'ease',
  isActive: true,
  canBegin: true,
  steps: [],
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationStart: function onAnimationStart() {},
});

var CSSTransition = { exports: {} };

var addClass = { exports: {} };

var interopRequireDefault = { exports: {} };

interopRequireDefault.exports;

(function (module) {
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule
      ? obj
      : {
          default: obj,
        };
  }
  (module.exports = _interopRequireDefault),
    (module.exports.__esModule = true),
    (module.exports['default'] = module.exports);
})(interopRequireDefault);

var interopRequireDefaultExports = interopRequireDefault.exports;

var hasClass = { exports: {} };

hasClass.exports;

var hasRequiredHasClass;

function requireHasClass() {
  if (hasRequiredHasClass) return hasClass.exports;
  hasRequiredHasClass = 1;
  (function (module, exports) {
    exports.__esModule = true;
    exports.default = hasClass;

    function hasClass(element, className) {
      if (element.classList) return !!className && element.classList.contains(className);
      else return (' ' + (element.className.baseVal || element.className) + ' ').indexOf(' ' + className + ' ') !== -1;
    }

    module.exports = exports['default'];
  })(hasClass, hasClass.exports);
  return hasClass.exports;
}

addClass.exports;

(function (module, exports) {
  var _interopRequireDefault = interopRequireDefaultExports;

  exports.__esModule = true;
  exports.default = addClass;

  var _hasClass = _interopRequireDefault(requireHasClass());

  function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClass.default)(element, className))
      if (typeof element.className === 'string') element.className = element.className + ' ' + className;
      else element.setAttribute('class', ((element.className && element.className.baseVal) || '') + ' ' + className);
  }

  module.exports = exports['default'];
})(addClass, addClass.exports);

var addClassExports = addClass.exports;

function replaceClassName(origClass, classToRemove) {
  return origClass
    .replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1')
    .replace(/\s+/g, ' ')
    .replace(/^\s*|\s*$/g, '');
}

var removeClass = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);
  else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
  else
    element.setAttribute('class', replaceClassName((element.className && element.className.baseVal) || '', className));
};

var Transition$1 = {};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill$3(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks',
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype',
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  polyfill: polyfill$3,
});

var require$$2 = /*@__PURE__*/ getAugmentedNamespace(reactLifecyclesCompat_es);

var PropTypes$1 = {};

PropTypes$1.__esModule = true;
PropTypes$1.classNamesShape = PropTypes$1.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault$3(PropTypes__default['default']);

function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var timeoutsShape =
  process.env.NODE_ENV !== 'production'
    ? _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.shape({
          enter: _propTypes.default.number,
          exit: _propTypes.default.number,
          appear: _propTypes.default.number,
        }).isRequired,
      ])
    : null;
PropTypes$1.timeoutsShape = timeoutsShape;
var classNamesShape =
  process.env.NODE_ENV !== 'production'
    ? _propTypes.default.oneOfType([
        _propTypes.default.string,
        _propTypes.default.shape({
          enter: _propTypes.default.string,
          exit: _propTypes.default.string,
          active: _propTypes.default.string,
        }),
        _propTypes.default.shape({
          enter: _propTypes.default.string,
          enterDone: _propTypes.default.string,
          enterActive: _propTypes.default.string,
          exit: _propTypes.default.string,
          exitDone: _propTypes.default.string,
          exitActive: _propTypes.default.string,
        }),
      ])
    : null;
PropTypes$1.classNamesShape = classNamesShape;

Transition$1.__esModule = true;
Transition$1.default =
  Transition$1.EXITING =
  Transition$1.ENTERED =
  Transition$1.ENTERING =
  Transition$1.EXITED =
  Transition$1.UNMOUNTED =
    void 0;

var PropTypes = _interopRequireWildcard(PropTypes__default['default']);

var _react$1 = _interopRequireDefault$2(React__default['default']);

var _reactDom = _interopRequireDefault$2(ReactDOM__default['default']);

var _reactLifecyclesCompat = require$$2;

var _PropTypes = PropTypes$1;

function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc =
            Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutPropertiesLoose$i(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var UNMOUNTED = 'unmounted';
Transition$1.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
Transition$1.EXITED = EXITED;
var ENTERING = 'entering';
Transition$1.ENTERING = ENTERING;
var ENTERED = 'entered';
Transition$1.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

Transition$1.EXITING = EXITING;

var Transition =
  /*#__PURE__*/
  (function (_React$Component) {
    _inheritsLoose$2(Transition, _React$Component);

    function Transition(props, context) {
      var _this;

      _this = _React$Component.call(this, props, context) || this;
      var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
      var initialStatus;
      _this.appearStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.appearStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = {
        status: initialStatus,
      };
      _this.nextCallback = null;
      return _this;
    }

    var _proto = Transition.prototype;

    _proto.getChildContext = function getChildContext() {
      return {
        transitionGroup: null, // allows for nested Transitions
      };
    };

    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
      var nextIn = _ref.in;

      if (nextIn && prevState.status === UNMOUNTED) {
        return {
          status: EXITED,
        };
      }

      return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }

    _proto.componentDidMount = function componentDidMount() {
      this.updateStatus(true, this.appearStatus);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      var nextStatus = null;

      if (prevProps !== this.props) {
        var status = this.state.status;

        if (this.props.in) {
          if (status !== ENTERING && status !== ENTERED) {
            nextStatus = ENTERING;
          }
        } else {
          if (status === ENTERING || status === ENTERED) {
            nextStatus = EXITING;
          }
        }
      }

      this.updateStatus(false, nextStatus);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    _proto.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;
      var exit, enter, appear;
      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter; // TODO: remove fallback for next major

        appear = timeout.appear !== undefined ? timeout.appear : enter;
      }

      return {
        exit: exit,
        enter: enter,
        appear: appear,
      };
    };

    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
      if (mounting === void 0) {
        mounting = false;
      }

      if (nextStatus !== null) {
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();

        var node = _reactDom.default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({
          status: UNMOUNTED,
        });
      }
    };

    _proto.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;
      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
      var timeouts = this.getTimeouts();
      var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set

      if (!mounting && !enter) {
        this.safeSetState(
          {
            status: ENTERED,
          },
          function () {
            _this2.props.onEntered(node);
          },
        );
        return;
      }

      this.props.onEnter(node, appearing);
      this.safeSetState(
        {
          status: ENTERING,
        },
        function () {
          _this2.props.onEntering(node, appearing);

          _this2.onTransitionEnd(node, enterTimeout, function () {
            _this2.safeSetState(
              {
                status: ENTERED,
              },
              function () {
                _this2.props.onEntered(node, appearing);
              },
            );
          });
        },
      );
    };

    _proto.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;
      var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

      if (!exit) {
        this.safeSetState(
          {
            status: EXITED,
          },
          function () {
            _this3.props.onExited(node);
          },
        );
        return;
      }

      this.props.onExit(node);
      this.safeSetState(
        {
          status: EXITING,
        },
        function () {
          _this3.props.onExiting(node);

          _this3.onTransitionEnd(node, timeouts.exit, function () {
            _this3.safeSetState(
              {
                status: EXITED,
              },
              function () {
                _this3.props.onExited(node);
              },
            );
          });
        },
      );
    };

    _proto.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    _proto.safeSetState = function safeSetState(nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, callback);
    };

    _proto.setNextCallback = function setNextCallback(callback) {
      var _this4 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this4.nextCallback = null;
          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);
      var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

      if (!node || doesNotHaveTimeoutOrListener) {
        setTimeout(this.nextCallback, 0);
        return;
      }

      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    };

    _proto.render = function render() {
      var status = this.state.status;

      if (status === UNMOUNTED) {
        return null;
      }

      var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose$i(_this$props, ['children']); // filter props for Transtition

      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        return children(status, childProps);
      }

      var child = _react$1.default.Children.only(children);

      return _react$1.default.cloneElement(child, childProps);
    };

    return Transition;
  })(_react$1.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object,
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {},
};
Transition.propTypes =
  process.env.NODE_ENV !== 'production'
    ? {
        /**
         * A `function` child can be used instead of a React element. This function is
         * called with the current transition status (`'entering'`, `'entered'`,
         * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
         * specific props to a component.
         *
         * ```jsx
         * <Transition in={this.state.in} timeout={150}>
         *   {state => (
         *     <MyComponent className={`fade fade-${state}`} />
         *   )}
         * </Transition>
         * ```
         */
        children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

        /**
         * Show the component; triggers the enter or exit states
         */
        in: PropTypes.bool,

        /**
         * By default the child component is mounted immediately along with
         * the parent `Transition` component. If you want to "lazy mount" the component on the
         * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
         * mounted, even on "exited", unless you also specify `unmountOnExit`.
         */
        mountOnEnter: PropTypes.bool,

        /**
         * By default the child component stays mounted after it reaches the `'exited'` state.
         * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
         */
        unmountOnExit: PropTypes.bool,

        /**
         * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
         * If you want to transition on the first mount set `appear` to `true`, and the
         * component will transition in as soon as the `<Transition>` mounts.
         *
         * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
         */
        appear: PropTypes.bool,

        /**
         * Enable or disable enter transitions.
         */
        enter: PropTypes.bool,

        /**
         * Enable or disable exit transitions.
         */
        exit: PropTypes.bool,

        /**
         * The duration of the transition, in milliseconds.
         * Required unless `addEndListener` is provided.
         *
         * You may specify a single timeout for all transitions:
         *
         * ```jsx
         * timeout={500}
         * ```
         *
         * or individually:
         *
         * ```jsx
         * timeout={{
         *  appear: 500,
         *  enter: 300,
         *  exit: 500,
         * }}
         * ```
         *
         * - `appear` defaults to the value of `enter`
         * - `enter` defaults to `0`
         * - `exit` defaults to `0`
         *
         * @type {number | { enter?: number, exit?: number, appear?: number }}
         */
        timeout: function timeout(props) {
          var pt = _PropTypes.timeoutsShape;
          if (!props.addEndListener) pt = pt.isRequired;

          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          return pt.apply(void 0, [props].concat(args));
        },

        /**
         * Add a custom transition end trigger. Called with the transitioning
         * DOM node and a `done` callback. Allows for more fine grained transition end
         * logic. **Note:** Timeouts are still used as a fallback if provided.
         *
         * ```jsx
         * addEndListener={(node, done) => {
         *   // use the css transitionend event to mark the finish of a transition
         *   node.addEventListener('transitionend', done, false);
         * }}
         * ```
         */
        addEndListener: PropTypes.func,

        /**
         * Callback fired before the "entering" status is applied. An extra parameter
         * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
         *
         * @type Function(node: HtmlElement, isAppearing: bool) -> void
         */
        onEnter: PropTypes.func,

        /**
         * Callback fired after the "entering" status is applied. An extra parameter
         * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
         *
         * @type Function(node: HtmlElement, isAppearing: bool)
         */
        onEntering: PropTypes.func,

        /**
         * Callback fired after the "entered" status is applied. An extra parameter
         * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
         *
         * @type Function(node: HtmlElement, isAppearing: bool) -> void
         */
        onEntered: PropTypes.func,

        /**
         * Callback fired before the "exiting" status is applied.
         *
         * @type Function(node: HtmlElement) -> void
         */
        onExit: PropTypes.func,

        /**
         * Callback fired after the "exiting" status is applied.
         *
         * @type Function(node: HtmlElement) -> void
         */
        onExiting: PropTypes.func,

        /**
         * Callback fired after the "exited" status is applied.
         *
         * @type Function(node: HtmlElement) -> void
         */
        onExited: PropTypes.func, // Name the function so it is clearer in the documentation
      }
    : {};

function noop$1() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$1,
  onEntering: noop$1,
  onEntered: noop$1,
  onExit: noop$1,
  onExiting: noop$1,
  onExited: noop$1,
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default$1 = (0, _reactLifecyclesCompat.polyfill)(Transition);

Transition$1.default = _default$1;

CSSTransition.exports;

(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;

  var PropTypes = _interopRequireWildcard(PropTypes__default['default']);

  var _addClass = _interopRequireDefault(addClassExports);

  var _removeClass = _interopRequireDefault(removeClass);

  var _react = _interopRequireDefault(React__default['default']);

  var _Transition = _interopRequireDefault(Transition$1);

  var _PropTypes = PropTypes$1;

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc =
              Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }

  function _extends() {
    _extends =
      Object.assign ||
      function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
    return _extends.apply(this, arguments);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  var addClass = function addClass(node, classes) {
    return (
      node &&
      classes &&
      classes.split(' ').forEach(function (c) {
        return (0, _addClass.default)(node, c);
      })
    );
  };

  var removeClass$1 = function removeClass(node, classes) {
    return (
      node &&
      classes &&
      classes.split(' ').forEach(function (c) {
        return (0, _removeClass.default)(node, c);
      })
    );
  };
  /**
   * A transition component inspired by the excellent
   * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
   * using CSS transitions or animations. It's built upon the
   * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
   * component, so it inherits all of its props.
   *
   * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
   * and `exit` states of the transition. The first class is applied and then a
   * second `*-active` class in order to activate the CSSS transition. After the
   * transition, matching `*-done` class names are applied to persist the
   * transition state.
   *
   * ```jsx
   * function App() {
   *   const [inProp, setInProp] = useState(false);
   *   return (
   *     <div>
   *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
   *         <div>
   *           {"I'll receive my-node-* classes"}
   *         </div>
   *       </CSSTransition>
   *       <button type="button" onClick={() => setInProp(true)}>
   *         Click to Enter
   *       </button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the `in` prop is set to `true`, the child component will first receive
   * the class `example-enter`, then the `example-enter-active` will be added in
   * the next tick. `CSSTransition` [forces a
   * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
   * between before adding the `example-enter-active`. This is an important trick
   * because it allows us to transition between `example-enter` and
   * `example-enter-active` even though they were added immediately one after
   * another. Most notably, this is what makes it possible for us to animate
   * _appearance_.
   *
   * ```css
   * .my-node-enter {
   *   opacity: 0;
   * }
   * .my-node-enter-active {
   *   opacity: 1;
   *   transition: opacity 200ms;
   * }
   * .my-node-exit {
   *   opacity: 1;
   * }
   * .my-node-exit-active {
   *   opacity: 0;
   *   transition: opacity: 200ms;
   * }
   * ```
   *
   * `*-active` classes represent which styles you want to animate **to**.
   */

  var CSSTransition =
    /*#__PURE__*/
    (function (_React$Component) {
      _inheritsLoose(CSSTransition, _React$Component);

      function CSSTransition() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

        _this.onEnter = function (node, appearing) {
          var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
            className = _this$getClassNames.className;

          _this.removeClasses(node, 'exit');

          addClass(node, className);

          if (_this.props.onEnter) {
            _this.props.onEnter(node, appearing);
          }
        };

        _this.onEntering = function (node, appearing) {
          var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
            activeClassName = _this$getClassNames2.activeClassName;

          _this.reflowAndAddClass(node, activeClassName);

          if (_this.props.onEntering) {
            _this.props.onEntering(node, appearing);
          }
        };

        _this.onEntered = function (node, appearing) {
          var appearClassName = _this.getClassNames('appear').doneClassName;

          var enterClassName = _this.getClassNames('enter').doneClassName;

          var doneClassName = appearing ? appearClassName + ' ' + enterClassName : enterClassName;

          _this.removeClasses(node, appearing ? 'appear' : 'enter');

          addClass(node, doneClassName);

          if (_this.props.onEntered) {
            _this.props.onEntered(node, appearing);
          }
        };

        _this.onExit = function (node) {
          var _this$getClassNames3 = _this.getClassNames('exit'),
            className = _this$getClassNames3.className;

          _this.removeClasses(node, 'appear');

          _this.removeClasses(node, 'enter');

          addClass(node, className);

          if (_this.props.onExit) {
            _this.props.onExit(node);
          }
        };

        _this.onExiting = function (node) {
          var _this$getClassNames4 = _this.getClassNames('exit'),
            activeClassName = _this$getClassNames4.activeClassName;

          _this.reflowAndAddClass(node, activeClassName);

          if (_this.props.onExiting) {
            _this.props.onExiting(node);
          }
        };

        _this.onExited = function (node) {
          var _this$getClassNames5 = _this.getClassNames('exit'),
            doneClassName = _this$getClassNames5.doneClassName;

          _this.removeClasses(node, 'exit');

          addClass(node, doneClassName);

          if (_this.props.onExited) {
            _this.props.onExited(node);
          }
        };

        _this.getClassNames = function (type) {
          var classNames = _this.props.classNames;
          var isStringClassNames = typeof classNames === 'string';
          var prefix = isStringClassNames && classNames ? classNames + '-' : '';
          var className = isStringClassNames ? prefix + type : classNames[type];
          var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
          var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
          return {
            className: className,
            activeClassName: activeClassName,
            doneClassName: doneClassName,
          };
        };

        return _this;
      }

      var _proto = CSSTransition.prototype;

      _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type),
          className = _this$getClassNames6.className,
          activeClassName = _this$getClassNames6.activeClassName,
          doneClassName = _this$getClassNames6.doneClassName;

        className && removeClass$1(node, className);
        activeClassName && removeClass$1(node, activeClassName);
        doneClassName && removeClass$1(node, doneClassName);
      };

      _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
          /* eslint-disable no-unused-expressions */
          node && node.scrollTop;
          /* eslint-enable no-unused-expressions */

          addClass(node, className);
        }
      };

      _proto.render = function render() {
        var props = _extends({}, this.props);

        delete props.classNames;
        return _react.default.createElement(
          _Transition.default,
          _extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited,
          }),
        );
      };

      return CSSTransition;
    })(_react.default.Component);

  CSSTransition.defaultProps = {
    classNames: '',
  };
  CSSTransition.propTypes =
    process.env.NODE_ENV !== 'production'
      ? _extends({}, _Transition.default.propTypes, {
          /**
           * The animation classNames applied to the component as it enters, exits or
           * has finished the transition. A single name can be provided and it will be
           * suffixed for each stage: e.g.
           *
           * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
           * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
           * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
           *
           * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
           * This allows you to define different behavior for when appearing is done and
           * when regular entering is done, using selectors like
           * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
           * epic entrance animation when element first appears in the DOM using
           * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
           * simply use `fade-enter-done` for defining both cases.
           *
           * Each individual classNames can also be specified independently like:
           *
           * ```js
           * classNames={{
           *  appear: 'my-appear',
           *  appearActive: 'my-active-appear',
           *  appearDone: 'my-done-appear',
           *  enter: 'my-enter',
           *  enterActive: 'my-active-enter',
           *  enterDone: 'my-done-enter',
           *  exit: 'my-exit',
           *  exitActive: 'my-active-exit',
           *  exitDone: 'my-done-exit',
           * }}
           * ```
           *
           * If you want to set these classes using CSS Modules:
           *
           * ```js
           * import styles from './styles.css';
           * ```
           *
           * you might want to use camelCase in your CSS file, that way could simply
           * spread them instead of listing them one by one:
           *
           * ```js
           * classNames={{ ...styles }}
           * ```
           *
           * @type {string | {
           *  appear?: string,
           *  appearActive?: string,
           *  appearDone?: string,
           *  enter?: string,
           *  enterActive?: string,
           *  enterDone?: string,
           *  exit?: string,
           *  exitActive?: string,
           *  exitDone?: string,
           * }}
           */
          classNames: _PropTypes.classNamesShape,

          /**
           * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
           * applied.
           *
           * @type Function(node: HtmlElement, isAppearing: bool)
           */
          onEnter: PropTypes.func,

          /**
           * A `<Transition>` callback fired immediately after the 'enter-active' or
           * 'appear-active' class is applied.
           *
           * @type Function(node: HtmlElement, isAppearing: bool)
           */
          onEntering: PropTypes.func,

          /**
           * A `<Transition>` callback fired immediately after the 'enter' or
           * 'appear' classes are **removed** and the `done` class is added to the DOM node.
           *
           * @type Function(node: HtmlElement, isAppearing: bool)
           */
          onEntered: PropTypes.func,

          /**
           * A `<Transition>` callback fired immediately after the 'exit' class is
           * applied.
           *
           * @type Function(node: HtmlElement)
           */
          onExit: PropTypes.func,

          /**
           * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
           *
           * @type Function(node: HtmlElement)
           */
          onExiting: PropTypes.func,

          /**
           * A `<Transition>` callback fired immediately after the 'exit' classes
           * are **removed** and the `exit-done` class is added to the DOM node.
           *
           * @type Function(node: HtmlElement)
           */
          onExited: PropTypes.func,
        })
      : {};
  var _default = CSSTransition;
  exports.default = _default;
  module.exports = exports['default'];
})(CSSTransition, CSSTransition.exports);

var CSSTransitionExports = CSSTransition.exports;

var ReplaceTransition = { exports: {} };

var TransitionGroup = { exports: {} };

var ChildMapping = {};

ChildMapping.__esModule = true;
ChildMapping.getChildMapping = getChildMapping;
ChildMapping.mergeChildMappings = mergeChildMappings;
ChildMapping.getInitialChildMapping = getInitialChildMapping;
ChildMapping.getNextChildMapping = getNextChildMapping;

var _react = React__default['default'];

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children)
    _react.Children.map(children, function (c) {
      return c;
    }).forEach(function (child) {
      // run the map function here instead so that the key is the computed one
      result[child.key] = mapper(child);
    });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list

  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`

  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props),
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps),
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false,
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps),
      });
    }
  });
  return children;
}

TransitionGroup.exports;

(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;

  var _propTypes = _interopRequireDefault(PropTypes__default['default']);

  var _react = _interopRequireDefault(React__default['default']);

  var _reactLifecyclesCompat = require$$2;

  var _ChildMapping = ChildMapping;

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }

  function _extends() {
    _extends =
      Object.assign ||
      function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
    return _extends.apply(this, arguments);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }

  var values =
    Object.values ||
    function (obj) {
      return Object.keys(obj).map(function (k) {
        return obj[k];
      });
    };

  var defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
      return child;
    },
    /**
     * The `<TransitionGroup>` component manages a set of transition components
     * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
     * components, `<TransitionGroup>` is a state machine for managing the mounting
     * and unmounting of components over time.
     *
     * Consider the example below. As items are removed or added to the TodoList the
     * `in` prop is toggled automatically by the `<TransitionGroup>`.
     *
     * Note that `<TransitionGroup>`  does not define any animation behavior!
     * Exactly _how_ a list item animates is up to the individual transition
     * component. This means you can mix and match animations across different list
     * items.
     */
  };

  var TransitionGroup =
    /*#__PURE__*/
    (function (_React$Component) {
      _inheritsLoose(TransitionGroup, _React$Component);

      function TransitionGroup(props, context) {
        var _this;

        _this = _React$Component.call(this, props, context) || this;

        var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear

        _this.state = {
          handleExited: handleExited,
          firstRender: true,
        };
        return _this;
      }

      var _proto = TransitionGroup.prototype;

      _proto.getChildContext = function getChildContext() {
        return {
          transitionGroup: {
            isMounting: !this.appeared,
          },
        };
      };

      _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
      };

      TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children,
          handleExited = _ref.handleExited,
          firstRender = _ref.firstRender;
        return {
          children: firstRender
            ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited)
            : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
          firstRender: false,
        };
      };

      _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;

        if (child.props.onExited) {
          child.props.onExited(node);
        }

        if (this.mounted) {
          this.setState(function (state) {
            var children = _extends({}, state.children);

            delete children[child.key];
            return {
              children: children,
            };
          });
        }
      };

      _proto.render = function render() {
        var _this$props = this.props,
          Component = _this$props.component,
          childFactory = _this$props.childFactory,
          props = _objectWithoutPropertiesLoose(_this$props, ['component', 'childFactory']);

        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;

        if (Component === null) {
          return children;
        }

        return _react.default.createElement(Component, props, children);
      };

      return TransitionGroup;
    })(_react.default.Component);

  TransitionGroup.childContextTypes = {
    transitionGroup: _propTypes.default.object.isRequired,
  };
  TransitionGroup.propTypes =
    process.env.NODE_ENV !== 'production'
      ? {
          /**
           * `<TransitionGroup>` renders a `<div>` by default. You can change this
           * behavior by providing a `component` prop.
           * If you use React v16+ and would like to avoid a wrapping `<div>` element
           * you can pass in `component={null}`. This is useful if the wrapping div
           * borks your css styles.
           */
          component: _propTypes.default.any,

          /**
           * A set of `<Transition>` components, that are toggled `in` and out as they
           * leave. the `<TransitionGroup>` will inject specific transition props, so
           * remember to spread them through if you are wrapping the `<Transition>` as
           * with our `<Fade>` example.
           *
           * While this component is meant for multiple `Transition` or `CSSTransition`
           * children, sometimes you may want to have a single transition child with
           * content that you want to be transitioned out and in when you change it
           * (e.g. routes, images etc.) In that case you can change the `key` prop of
           * the transition child as you change its content, this will cause
           * `TransitionGroup` to transition the child out and back in.
           */
          children: _propTypes.default.node,

          /**
           * A convenience prop that enables or disables appear animations
           * for all children. Note that specifying this will override any defaults set
           * on individual children Transitions.
           */
          appear: _propTypes.default.bool,

          /**
           * A convenience prop that enables or disables enter animations
           * for all children. Note that specifying this will override any defaults set
           * on individual children Transitions.
           */
          enter: _propTypes.default.bool,

          /**
           * A convenience prop that enables or disables exit animations
           * for all children. Note that specifying this will override any defaults set
           * on individual children Transitions.
           */
          exit: _propTypes.default.bool,

          /**
           * You may need to apply reactive updates to a child as it is exiting.
           * This is generally done by using `cloneElement` however in the case of an exiting
           * child the element has already been removed and not accessible to the consumer.
           *
           * If you do need to update a child as it leaves you can provide a `childFactory`
           * to wrap every child, even the ones that are leaving.
           *
           * @type Function(child: ReactElement) -> ReactElement
           */
          childFactory: _propTypes.default.func,
        }
      : {};
  TransitionGroup.defaultProps = defaultProps;

  var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

  exports.default = _default;
  module.exports = exports['default'];
})(TransitionGroup, TransitionGroup.exports);

var TransitionGroupExports = TransitionGroup.exports;

ReplaceTransition.exports;

(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;

  var _propTypes = _interopRequireDefault(PropTypes__default['default']);

  var _react = _interopRequireDefault(React__default['default']);

  var _reactDom = ReactDOM__default['default'];

  var _TransitionGroup = _interopRequireDefault(TransitionGroupExports);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  /**
   * The `<ReplaceTransition>` component is a specialized `Transition` component
   * that animates between two children.
   *
   * ```jsx
   * <ReplaceTransition in>
   *   <Fade><div>I appear first</div></Fade>
   *   <Fade><div>I replace the above</div></Fade>
   * </ReplaceTransition>
   * ```
   */
  var ReplaceTransition =
    /*#__PURE__*/
    (function (_React$Component) {
      _inheritsLoose(ReplaceTransition, _React$Component);

      function ReplaceTransition() {
        var _this;

        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
          _args[_key] = arguments[_key];
        }

        _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

        _this.handleEnter = function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return _this.handleLifecycle('onEnter', 0, args);
        };

        _this.handleEntering = function () {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          return _this.handleLifecycle('onEntering', 0, args);
        };

        _this.handleEntered = function () {
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }

          return _this.handleLifecycle('onEntered', 0, args);
        };

        _this.handleExit = function () {
          for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
          }

          return _this.handleLifecycle('onExit', 1, args);
        };

        _this.handleExiting = function () {
          for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
          }

          return _this.handleLifecycle('onExiting', 1, args);
        };

        _this.handleExited = function () {
          for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
          }

          return _this.handleLifecycle('onExited', 1, args);
        };

        return _this;
      }

      var _proto = ReplaceTransition.prototype;

      _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;

        var children = this.props.children;

        var child = _react.default.Children.toArray(children)[idx];

        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
      };

      _proto.render = function render() {
        var _this$props = this.props,
          children = _this$props.children,
          inProp = _this$props.in,
          props = _objectWithoutPropertiesLoose(_this$props, ['children', 'in']);

        var _React$Children$toArr = _react.default.Children.toArray(children),
          first = _React$Children$toArr[0],
          second = _React$Children$toArr[1];

        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return _react.default.createElement(
          _TransitionGroup.default,
          props,
          inProp
            ? _react.default.cloneElement(first, {
                key: 'first',
                onEnter: this.handleEnter,
                onEntering: this.handleEntering,
                onEntered: this.handleEntered,
              })
            : _react.default.cloneElement(second, {
                key: 'second',
                onEnter: this.handleExit,
                onEntering: this.handleExiting,
                onEntered: this.handleExited,
              }),
        );
      };

      return ReplaceTransition;
    })(_react.default.Component);

  ReplaceTransition.propTypes =
    process.env.NODE_ENV !== 'production'
      ? {
          in: _propTypes.default.bool.isRequired,
          children: function children(props, propName) {
            if (_react.default.Children.count(props[propName]) !== 2)
              return new Error('"' + propName + '" must be exactly two transition components.');
            return null;
          },
        }
      : {};
  var _default = ReplaceTransition;
  exports.default = _default;
  module.exports = exports['default'];
})(ReplaceTransition, ReplaceTransition.exports);

var ReplaceTransitionExports = ReplaceTransition.exports;

var _CSSTransition = _interopRequireDefault$1(CSSTransitionExports);

var _ReplaceTransition = _interopRequireDefault$1(ReplaceTransitionExports);

var _TransitionGroup = _interopRequireDefault$1(TransitionGroupExports);

var _Transition = _interopRequireDefault$1(Transition$1);

function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var reactTransitionGroup = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default,
};

var _excluded$f = ['children', 'appearOptions', 'enterOptions', 'leaveOptions'];
function _typeof$1c(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1c =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1c(obj)
  );
}
function _extends$x() {
  _extends$x = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$x.apply(this, arguments);
}
function _objectWithoutProperties$f(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$h(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$h(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys$y(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$y(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$y(Object(source), !0).forEach(function (key) {
          _defineProperty$17(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$y(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$Z(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$Z(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$D(descriptor.key), descriptor);
  }
}
function _createClass$Z(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$Z(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$Z(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$X(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$Z(subClass, superClass);
}
function _setPrototypeOf$Z(o, p) {
  _setPrototypeOf$Z = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$Z(o, p);
}
function _createSuper$X(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$X();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$X(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$X(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$X(this, result);
  };
}
function _possibleConstructorReturn$X(self, call) {
  if (call && (_typeof$1c(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$Z(self);
}
function _assertThisInitialized$Z(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$X() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$X(o) {
  _getPrototypeOf$X = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$X(o);
}
function _defineProperty$17(obj, key, value) {
  key = _toPropertyKey$D(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$D(arg) {
  var key = _toPrimitive$D(arg, 'string');
  return _typeof$1c(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$D(input, hint) {
  if (_typeof$1c(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$1c(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
if (Number.isFinite === undefined) {
  Number.isFinite = function (value) {
    return typeof value === 'number' && isFinite(value);
  };
}
var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var steps = options.steps,
    duration = options.duration;
  if (steps && steps.length) {
    return steps.reduce(function (result, entry) {
      return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
  }
  if (Number.isFinite(duration)) {
    return duration;
  }
  return 0;
};
var AnimateGroupChild = /*#__PURE__*/ (function (_Component) {
  _inherits$X(AnimateGroupChild, _Component);
  var _super = _createSuper$X(AnimateGroupChild);
  function AnimateGroupChild() {
    var _this;
    _classCallCheck$Z(this, AnimateGroupChild);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$17(_assertThisInitialized$Z(_this), 'state', {
      isActive: false,
    });
    _defineProperty$17(_assertThisInitialized$Z(_this), 'handleEnter', function (node, isAppearing) {
      var _this$props = _this.props,
        appearOptions = _this$props.appearOptions,
        enterOptions = _this$props.enterOptions;
      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
    });
    _defineProperty$17(_assertThisInitialized$Z(_this), 'handleExit', function () {
      _this.handleStyleActive(_this.props.leaveOptions);
    });
    return _this;
  }
  _createClass$Z(AnimateGroupChild, [
    {
      key: 'handleStyleActive',
      value: function handleStyleActive(style) {
        if (style) {
          var onAnimationEnd = style.onAnimationEnd
            ? function () {
                style.onAnimationEnd();
              }
            : null;
          this.setState(
            _objectSpread$y(
              _objectSpread$y({}, style),
              {},
              {
                onAnimationEnd: onAnimationEnd,
                isActive: true,
              },
            ),
          );
        }
      },
    },
    {
      key: 'parseTimeout',
      value: function parseTimeout() {
        var _this$props2 = this.props,
          appearOptions = _this$props2.appearOptions,
          enterOptions = _this$props2.enterOptions,
          leaveOptions = _this$props2.leaveOptions;
        return (
          parseDurationOfSingleTransition(appearOptions) +
          parseDurationOfSingleTransition(enterOptions) +
          parseDurationOfSingleTransition(leaveOptions)
        );
      },
    },
    {
      key: 'render',
      value: function render() {
        var _this2 = this;
        var _this$props3 = this.props,
          children = _this$props3.children;
        _this$props3.appearOptions;
        _this$props3.enterOptions;
        _this$props3.leaveOptions;
        var props = _objectWithoutProperties$f(_this$props3, _excluded$f);
        return /*#__PURE__*/ React__default['default'].createElement(
          reactTransitionGroup.Transition,
          _extends$x({}, props, {
            onEnter: this.handleEnter,
            onExit: this.handleExit,
            timeout: this.parseTimeout(),
          }),
          function () {
            return /*#__PURE__*/ React__default['default'].createElement(
              Animate,
              _this2.state,
              React.Children.only(children),
            );
          },
        );
      },
    },
  ]);
  return AnimateGroupChild;
})(React.Component);
_defineProperty$17(AnimateGroupChild, 'propTypes', {
  appearOptions: PropTypes__default['default'].object,
  enterOptions: PropTypes__default['default'].object,
  leaveOptions: PropTypes__default['default'].object,
  children: PropTypes__default['default'].element,
});

({
  appear: PropTypes__default['default'].object,
  enter: PropTypes__default['default'].object,
  leave: PropTypes__default['default'].object,
  children: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].array,
    PropTypes__default['default'].element,
  ]),
  component: PropTypes__default['default'].any,
});

var Symbol$2 = _Symbol,
  isArguments$3 = isArguments_1,
  isArray$5 = isArray_1;

/** Built-in value references. */
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$5(value) || isArguments$3(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush$1 = _arrayPush,
  isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$3(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$3(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$3;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$1 = createBaseFor();

var _baseFor = baseFor$1;

var baseFor = _baseFor,
  keys$4 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$2(object, iteratee) {
  return object && baseFor(object, iteratee, keys$4);
}

var _baseForOwn = baseForOwn$2;

var isArrayLike$2 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$2(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
      index = fromRight ? length : -1,
      iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$1;

var baseForOwn$1 = _baseForOwn,
  createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$3 = createBaseEach(baseForOwn$1);

var _baseEach = baseEach$3;

var baseEach$2 = _baseEach,
  isArrayLike$1 = isArrayLike_1;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap$2(collection, iteratee) {
  var index = -1,
    result = isArrayLike$1(collection) ? Array(collection.length) : [];

  baseEach$2(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$2;

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */

function baseSortBy$1(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

var _baseSortBy = baseSortBy$1;

var isSymbol$1 = isSymbol_1;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
      valIsNull = value === null,
      valIsReflexive = value === value,
      valIsSymbol = isSymbol$1(value);

    var othIsDefined = other !== undefined,
      othIsNull = other === null,
      othIsReflexive = other === other,
      othIsSymbol = isSymbol$1(other);

    if (
      (!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
      (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
      (valIsNull && othIsDefined && othIsReflexive) ||
      (!valIsDefined && othIsReflexive) ||
      !valIsReflexive
    ) {
      return 1;
    }
    if (
      (!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
      (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
      (othIsNull && valIsDefined && valIsReflexive) ||
      (!othIsDefined && valIsReflexive) ||
      !othIsReflexive
    ) {
      return -1;
    }
  }
  return 0;
}

var _compareAscending = compareAscending$1;

var compareAscending = _compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple$1(object, other, orders) {
  var index = -1,
    objCriteria = object.criteria,
    othCriteria = other.criteria,
    length = objCriteria.length,
    ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

var _compareMultiple = compareMultiple$1;

var arrayMap$2 = _arrayMap,
  baseGet$1 = _baseGet,
  baseIteratee$9 = _baseIteratee,
  baseMap$1 = _baseMap,
  baseSortBy = _baseSortBy,
  baseUnary$2 = _baseUnary,
  compareMultiple = _compareMultiple,
  identity$6 = identity_1,
  isArray$4 = isArray_1;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap$2(iteratees, function (iteratee) {
      if (isArray$4(iteratee)) {
        return function (value) {
          return baseGet$1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity$6];
  }

  var index = -1;
  iteratees = arrayMap$2(iteratees, baseUnary$2(baseIteratee$9));

  var result = baseMap$1(collection, function (value, key, collection) {
    var criteria = arrayMap$2(iteratees, function (iteratee) {
      return iteratee(value);
    });
    return { criteria: criteria, index: ++index, value: value };
  });

  return baseSortBy(result, function (object, other) {
    return compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy$1;

var baseFlatten$2 = _baseFlatten,
  baseOrderBy = _baseOrderBy,
  baseRest = _baseRest,
  isIterateeCall$3 = _isIterateeCall;

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function (collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall$3(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall$3(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten$2(iteratees, 1), []);
});

var sortBy_1 = sortBy;

var _sortBy = /*@__PURE__*/ getDefaultExportFromCjs(sortBy_1);

function _typeof$1b(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1b =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1b(obj)
  );
}
function _slicedToArray$a(arr, i) {
  return (
    _arrayWithHoles$a(arr) ||
    _iterableToArrayLimit$a(arr, i) ||
    _unsupportedIterableToArray$j(arr, i) ||
    _nonIterableRest$a()
  );
}
function _nonIterableRest$a() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$j(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$j(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$j(o, minLen);
}
function _arrayLikeToArray$j(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit$a(arr, i) {
  var _i = null == arr ? null : ('undefined' != typeof Symbol && arr[Symbol.iterator]) || arr['@@iterator'];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      (_d = !0), (_e = err);
    } finally {
      try {
        if (!_n && null != _i['return'] && ((_r = _i['return']()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$a(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys$x(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$x(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$x(Object(source), !0).forEach(function (key) {
          _defineProperty$16(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$x(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$Y(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$Y(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$C(descriptor.key), descriptor);
  }
}
function _createClass$Y(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$Y(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$Y(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$W(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$Y(subClass, superClass);
}
function _setPrototypeOf$Y(o, p) {
  _setPrototypeOf$Y = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$Y(o, p);
}
function _createSuper$W(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$W();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$W(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$W(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$W(this, result);
  };
}
function _possibleConstructorReturn$W(self, call) {
  if (call && (_typeof$1b(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$Y(self);
}
function _assertThisInitialized$Y(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$W() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$W(o) {
  _getPrototypeOf$W = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$W(o);
}
function _defineProperty$16(obj, key, value) {
  key = _toPropertyKey$C(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$C(arg) {
  var key = _toPrimitive$C(arg, 'string');
  return _typeof$1b(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$C(input, hint) {
  if (_typeof$1b(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$1b(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function defaultFormatter(value) {
  return _isArray(value) && isNumOrStr(value[0]) && isNumOrStr(value[1]) ? value.join(' ~ ') : value;
}
var DefaultTooltipContent = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$W(DefaultTooltipContent, _PureComponent);
  var _super = _createSuper$W(DefaultTooltipContent);
  function DefaultTooltipContent() {
    _classCallCheck$Y(this, DefaultTooltipContent);
    return _super.apply(this, arguments);
  }
  _createClass$Y(DefaultTooltipContent, [
    {
      key: 'renderContent',
      value: function renderContent() {
        var _this$props = this.props,
          payload = _this$props.payload,
          separator = _this$props.separator,
          formatter = _this$props.formatter,
          itemStyle = _this$props.itemStyle,
          itemSorter = _this$props.itemSorter;
        if (payload && payload.length) {
          var listStyle = {
            padding: 0,
            margin: 0,
          };
          var items = (itemSorter ? _sortBy(payload, itemSorter) : payload).map(function (entry, i) {
            if (entry.type === 'none') {
              return null;
            }
            var finalItemStyle = _objectSpread$x(
              {
                display: 'block',
                paddingTop: 4,
                paddingBottom: 4,
                color: entry.color || '#000',
              },
              itemStyle,
            );
            var finalFormatter = entry.formatter || formatter || defaultFormatter;
            var value = entry.value,
              name = entry.name;
            if (finalFormatter && value != null && name != null) {
              var formatted = finalFormatter(value, name, entry, i, payload);
              if (Array.isArray(formatted)) {
                var _ref = formatted;
                var _ref2 = _slicedToArray$a(_ref, 2);
                value = _ref2[0];
                name = _ref2[1];
              } else {
                value = formatted;
              }
            }
            return (
              /*#__PURE__*/
              // eslint-disable-next-line react/no-array-index-key
              React__default['default'].createElement(
                'li',
                {
                  className: 'recharts-tooltip-item',
                  key: 'tooltip-item-'.concat(i),
                  style: finalItemStyle,
                },
                isNumOrStr(name)
                  ? /*#__PURE__*/ React__default['default'].createElement(
                      'span',
                      {
                        className: 'recharts-tooltip-item-name',
                      },
                      name,
                    )
                  : null,
                isNumOrStr(name)
                  ? /*#__PURE__*/ React__default['default'].createElement(
                      'span',
                      {
                        className: 'recharts-tooltip-item-separator',
                      },
                      separator,
                    )
                  : null,
                /*#__PURE__*/ React__default['default'].createElement(
                  'span',
                  {
                    className: 'recharts-tooltip-item-value',
                  },
                  value,
                ),
                /*#__PURE__*/ React__default['default'].createElement(
                  'span',
                  {
                    className: 'recharts-tooltip-item-unit',
                  },
                  entry.unit || '',
                ),
              )
            );
          });
          return /*#__PURE__*/ React__default['default'].createElement(
            'ul',
            {
              className: 'recharts-tooltip-item-list',
              style: listStyle,
            },
            items,
          );
        }
        return null;
      },
    },
    {
      key: 'render',
      value: function render() {
        var _this$props2 = this.props,
          wrapperClassName = _this$props2.wrapperClassName,
          contentStyle = _this$props2.contentStyle,
          labelClassName = _this$props2.labelClassName,
          labelStyle = _this$props2.labelStyle,
          label = _this$props2.label,
          labelFormatter = _this$props2.labelFormatter,
          payload = _this$props2.payload;
        var finalStyle = _objectSpread$x(
          {
            margin: 0,
            padding: 10,
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            whiteSpace: 'nowrap',
          },
          contentStyle,
        );
        var finalLabelStyle = _objectSpread$x(
          {
            margin: 0,
          },
          labelStyle,
        );
        var hasLabel = !_isNil(label);
        var finalLabel = hasLabel ? label : '';
        var wrapperCN = cx('recharts-default-tooltip', wrapperClassName);
        var labelCN = cx('recharts-tooltip-label', labelClassName);
        if (hasLabel && labelFormatter && payload !== undefined && payload !== null) {
          finalLabel = labelFormatter(label, payload);
        }
        return /*#__PURE__*/ React__default['default'].createElement(
          'div',
          {
            className: wrapperCN,
            style: finalStyle,
          },
          /*#__PURE__*/ React__default['default'].createElement(
            'p',
            {
              className: labelCN,
              style: finalLabelStyle,
            },
            /*#__PURE__*/ React__default['default'].isValidElement(finalLabel) ? finalLabel : ''.concat(finalLabel),
          ),
          this.renderContent(),
        );
      },
    },
  ]);
  return DefaultTooltipContent;
})(React.PureComponent);
_defineProperty$16(DefaultTooltipContent, 'displayName', 'DefaultTooltipContent');
_defineProperty$16(DefaultTooltipContent, 'defaultProps', {
  separator: ' : ',
  contentStyle: {},
  itemStyle: {},
  labelStyle: {},
});

var parseIsSsrByDefault = function parseIsSsrByDefault() {
  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var Global = {
  isSsr: parseIsSsrByDefault(),
  get: function get(key) {
    return Global[key];
  },
  set: function set(key, value) {
    if (typeof key === 'string') {
      Global[key] = value;
    } else {
      var keys = Object.keys(key);
      if (keys && keys.length) {
        keys.forEach(function (k) {
          Global[k] = key[k];
        });
      }
    }
  },
};

function _typeof$1a(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$1a =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$1a(obj)
  );
}
function ownKeys$w(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$w(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$w(Object(source), !0).forEach(function (key) {
          _defineProperty$15(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$w(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$X(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$X(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$B(descriptor.key), descriptor);
  }
}
function _createClass$X(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$X(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$X(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$V(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$X(subClass, superClass);
}
function _setPrototypeOf$X(o, p) {
  _setPrototypeOf$X = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$X(o, p);
}
function _createSuper$V(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$V();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$V(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$V(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$V(this, result);
  };
}
function _possibleConstructorReturn$V(self, call) {
  if (call && (_typeof$1a(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$X(self);
}
function _assertThisInitialized$X(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$V() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$V(o) {
  _getPrototypeOf$V = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$V(o);
}
function _defineProperty$15(obj, key, value) {
  key = _toPropertyKey$B(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$B(arg) {
  var key = _toPrimitive$B(arg, 'string');
  return _typeof$1a(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$B(input, hint) {
  if (_typeof$1a(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$1a(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var CLS_PREFIX = 'recharts-tooltip-wrapper';
var EPS$1 = 1;
function defaultUniqBy(entry) {
  return entry.dataKey;
}
function getUniqPayload(option, payload) {
  if (option === true) {
    return _uniqBy(payload, defaultUniqBy);
  }
  if (_isFunction(option)) {
    return _uniqBy(payload, option);
  }
  return payload;
}
function renderContent(content, props) {
  if (/*#__PURE__*/ React__default['default'].isValidElement(content)) {
    return /*#__PURE__*/ React__default['default'].cloneElement(content, props);
  }
  if (_isFunction(content)) {
    return /*#__PURE__*/ React__default['default'].createElement(content, props);
  }
  return /*#__PURE__*/ React__default['default'].createElement(DefaultTooltipContent, props);
}
var Tooltip = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$V(Tooltip, _PureComponent);
  var _super = _createSuper$V(Tooltip);
  function Tooltip() {
    var _this;
    _classCallCheck$X(this, Tooltip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$15(_assertThisInitialized$X(_this), 'state', {
      boxWidth: -1,
      boxHeight: -1,
      dismissed: false,
      dismissedAtCoordinate: {
        x: 0,
        y: 0,
      },
    });
    _defineProperty$15(_assertThisInitialized$X(_this), 'getTranslate', function (_ref) {
      var key = _ref.key,
        tooltipDimension = _ref.tooltipDimension,
        viewBoxDimension = _ref.viewBoxDimension;
      var _this$props = _this.props,
        allowEscapeViewBox = _this$props.allowEscapeViewBox,
        reverseDirection = _this$props.reverseDirection,
        coordinate = _this$props.coordinate,
        offset = _this$props.offset,
        position = _this$props.position,
        viewBox = _this$props.viewBox;
      if (position && isNumber(position[key])) {
        return position[key];
      }
      var negative = coordinate[key] - tooltipDimension - offset;
      var positive = coordinate[key] + offset;
      if (allowEscapeViewBox[key]) {
        return reverseDirection[key] ? negative : positive;
      }
      if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) {
          return Math.max(positive, viewBox[key]);
        }
        return Math.max(negative, viewBox[key]);
      }
      var tooltipBoundary = positive + tooltipDimension;
      var viewBoxBoundary = viewBox[key] + viewBoxDimension;
      if (tooltipBoundary > viewBoxBoundary) {
        return Math.max(negative, viewBox[key]);
      }
      return Math.max(positive, viewBox[key]);
    });
    return _this;
  }
  _createClass$X(Tooltip, [
    {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.updateBBox();
      },
    },
    {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.updateBBox();
      },
    },
    {
      key: 'updateBBox',
      value: function updateBBox() {
        var _this$state = this.state,
          boxWidth = _this$state.boxWidth,
          boxHeight = _this$state.boxHeight,
          dismissed = _this$state.dismissed;
        if (dismissed) {
          this.wrapperNode.blur();
          if (
            this.props.coordinate.x !== this.state.dismissedAtCoordinate.x ||
            this.props.coordinate.y !== this.state.dismissedAtCoordinate.y
          ) {
            this.setState({
              dismissed: false,
            });
          }
        } else {
          this.wrapperNode.focus({
            preventScroll: true,
          });
        }
        if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
          var box = this.wrapperNode.getBoundingClientRect();
          if (Math.abs(box.width - boxWidth) > EPS$1 || Math.abs(box.height - boxHeight) > EPS$1) {
            this.setState({
              boxWidth: box.width,
              boxHeight: box.height,
            });
          }
        } else if (boxWidth !== -1 || boxHeight !== -1) {
          this.setState({
            boxWidth: -1,
            boxHeight: -1,
          });
        }
      },
    },
    {
      key: 'render',
      value: function render() {
        var _classNames,
          _this2 = this;
        var _this$props2 = this.props,
          payload = _this$props2.payload,
          isAnimationActive = _this$props2.isAnimationActive,
          animationDuration = _this$props2.animationDuration,
          animationEasing = _this$props2.animationEasing,
          filterNull = _this$props2.filterNull,
          payloadUniqBy = _this$props2.payloadUniqBy;
        var finalPayload = getUniqPayload(
          payloadUniqBy,
          filterNull && payload && payload.length
            ? payload.filter(function (entry) {
                return !_isNil(entry.value);
              })
            : payload,
        );
        var hasPayload = finalPayload && finalPayload.length;
        var _this$props3 = this.props,
          content = _this$props3.content,
          viewBox = _this$props3.viewBox,
          coordinate = _this$props3.coordinate,
          position = _this$props3.position,
          active = _this$props3.active,
          wrapperStyle = _this$props3.wrapperStyle;
        var outerStyle = _objectSpread$w(
          {
            pointerEvents: 'none',
            visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
            position: 'absolute',
            top: 0,
            left: 0,
          },
          wrapperStyle,
        );
        var translateX, translateY;
        if (position && isNumber(position.x) && isNumber(position.y)) {
          translateX = position.x;
          translateY = position.y;
        } else {
          var _this$state2 = this.state,
            boxWidth = _this$state2.boxWidth,
            boxHeight = _this$state2.boxHeight;
          if (boxWidth > 0 && boxHeight > 0 && coordinate) {
            translateX = this.getTranslate({
              key: 'x',
              tooltipDimension: boxWidth,
              viewBoxDimension: viewBox.width,
            });
            translateY = this.getTranslate({
              key: 'y',
              tooltipDimension: boxHeight,
              viewBoxDimension: viewBox.height,
            });
          } else {
            outerStyle.visibility = 'hidden';
          }
        }
        outerStyle = _objectSpread$w(
          _objectSpread$w(
            {},
            translateStyle({
              transform: this.props.useTranslate3d
                ? 'translate3d('.concat(translateX, 'px, ').concat(translateY, 'px, 0)')
                : 'translate('.concat(translateX, 'px, ').concat(translateY, 'px)'),
            }),
          ),
          outerStyle,
        );
        if (isAnimationActive && active) {
          outerStyle = _objectSpread$w(
            _objectSpread$w(
              {},
              translateStyle({
                transition: 'transform '.concat(animationDuration, 'ms ').concat(animationEasing),
              }),
            ),
            outerStyle,
          );
        }
        var cls = cx(
          CLS_PREFIX,
          ((_classNames = {}),
          _defineProperty$15(
            _classNames,
            ''.concat(CLS_PREFIX, '-right'),
            isNumber(translateX) && coordinate && isNumber(coordinate.x) && translateX >= coordinate.x,
          ),
          _defineProperty$15(
            _classNames,
            ''.concat(CLS_PREFIX, '-left'),
            isNumber(translateX) && coordinate && isNumber(coordinate.x) && translateX < coordinate.x,
          ),
          _defineProperty$15(
            _classNames,
            ''.concat(CLS_PREFIX, '-bottom'),
            isNumber(translateY) && coordinate && isNumber(coordinate.y) && translateY >= coordinate.y,
          ),
          _defineProperty$15(
            _classNames,
            ''.concat(CLS_PREFIX, '-top'),
            isNumber(translateY) && coordinate && isNumber(coordinate.y) && translateY < coordinate.y,
          ),
          _classNames),
        );
        return (
          /*#__PURE__*/
          // ESLint is disabled to allow listening to the `Escape` key. Refer to
          // https://github.com/recharts/recharts/pull/2925
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          React__default['default'].createElement(
            'div',
            {
              tabIndex: -1,
              role: 'dialog',
              onKeyDown: function onKeyDown(event) {
                if (event.key === 'Escape') {
                  _this2.setState({
                    dismissed: true,
                    dismissedAtCoordinate: _objectSpread$w(
                      _objectSpread$w({}, _this2.state.dismissedAtCoordinate),
                      {},
                      {
                        x: _this2.props.coordinate.x,
                        y: _this2.props.coordinate.y,
                      },
                    ),
                  });
                }
              },
              className: cls,
              style: outerStyle,
              ref: function ref(node) {
                _this2.wrapperNode = node;
              },
            },
            renderContent(
              content,
              _objectSpread$w(
                _objectSpread$w({}, this.props),
                {},
                {
                  payload: finalPayload,
                },
              ),
            ),
          )
        );
      },
    },
  ]);
  return Tooltip;
})(React.PureComponent);
_defineProperty$15(Tooltip, 'displayName', 'Tooltip');
_defineProperty$15(Tooltip, 'defaultProps', {
  active: false,
  allowEscapeViewBox: {
    x: false,
    y: false,
  },
  reverseDirection: {
    x: false,
    y: false,
  },
  offset: 10,
  viewBox: {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0,
  },
  coordinate: {
    x: 0,
    y: 0,
  },
  cursorStyle: {},
  separator: ' : ',
  wrapperStyle: {},
  contentStyle: {},
  itemStyle: {},
  labelStyle: {},
  cursor: true,
  trigger: 'hover',
  isAnimationActive: !Global.isSsr,
  animationEasing: 'ease',
  animationDuration: 400,
  filterNull: true,
  useTranslate3d: false,
});

/* global Reflect, Promise */

var extendStatics = function (d, b) {
  extendStatics =
    Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array &&
      function (d, b) {
        d.__proto__ = b;
      }) ||
    function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
  return extendStatics(d, b);
};

function __extends(d, b) {
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === 'function')
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
  return t;
}
var patchResizeHandler = function (resizeCallback, refreshMode, refreshRate, refreshOptions) {
  switch (refreshMode) {
    case 'debounce':
      return debounce$5(resizeCallback, refreshRate, refreshOptions);
    case 'throttle':
      return _throttle(resizeCallback, refreshRate, refreshOptions);
    default:
      return resizeCallback;
  }
};
var isFunction$2 = function (fn) {
  return typeof fn === 'function';
};
var isSSR = function () {
  return typeof window === 'undefined';
};
var isDOMElement = function (element) {
  return element instanceof Element || element instanceof HTMLDocument;
};
var createNotifier = function (setSize, handleWidth, handleHeight) {
  return function (_a) {
    var width = _a.width,
      height = _a.height;
    setSize(function (prev) {
      if (prev.width === width && prev.height === height) {
        // skip if dimensions haven't changed
        return prev;
      }
      if ((prev.width === width && !handleHeight) || (prev.height === height && !handleWidth)) {
        // process `handleHeight/handleWidth` props
        return prev;
      }
      return { width: width, height: height };
    });
  };
};
var ResizeDetector = /** @class */ (function (_super) {
  __extends(ResizeDetector, _super);
  function ResizeDetector(props) {
    var _this = _super.call(this, props) || this;
    _this.cancelHandler = function () {
      if (_this.resizeHandler && _this.resizeHandler.cancel) {
        // cancel debounced handler
        _this.resizeHandler.cancel();
        _this.resizeHandler = null;
      }
    };
    _this.attachObserver = function () {
      var _a = _this.props,
        targetRef = _a.targetRef,
        observerOptions = _a.observerOptions;
      if (isSSR()) {
        return;
      }
      if (targetRef && targetRef.current) {
        _this.targetRef.current = targetRef.current;
      }
      var element = _this.getElement();
      if (!element) {
        // can't find element to observe
        return;
      }
      if (_this.observableElement && _this.observableElement === element) {
        // element is already observed
        return;
      }
      _this.observableElement = element;
      _this.resizeObserver.observe(element, observerOptions);
    };
    _this.getElement = function () {
      var _a = _this.props,
        querySelector = _a.querySelector,
        targetDomEl = _a.targetDomEl;
      if (isSSR()) return null;
      // in case we pass a querySelector
      if (querySelector) return document.querySelector(querySelector);
      // in case we pass a DOM element
      if (targetDomEl && isDOMElement(targetDomEl)) return targetDomEl;
      // in case we pass a React ref using React.createRef()
      if (_this.targetRef && isDOMElement(_this.targetRef.current)) return _this.targetRef.current;
      // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
      // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
      var currentElement = ReactDOM.findDOMNode(_this);
      if (!currentElement) return null;
      var renderType = _this.getRenderType();
      switch (renderType) {
        case 'renderProp':
          return currentElement;
        case 'childFunction':
          return currentElement;
        case 'child':
          return currentElement;
        case 'childArray':
          return currentElement;
        default:
          return currentElement.parentElement;
      }
    };
    _this.createResizeHandler = function (entries) {
      var _a = _this.props,
        _b = _a.handleWidth,
        handleWidth = _b === void 0 ? true : _b,
        _c = _a.handleHeight,
        handleHeight = _c === void 0 ? true : _c,
        onResize = _a.onResize;
      if (!handleWidth && !handleHeight) return;
      var notifyResize = createNotifier(
        function (setStateFunc) {
          return _this.setState(setStateFunc, function () {
            return onResize === null || onResize === void 0 ? void 0 : onResize(_this.state.width, _this.state.height);
          });
        },
        handleWidth,
        handleHeight,
      );
      entries.forEach(function (entry) {
        var _a = (entry && entry.contentRect) || {},
          width = _a.width,
          height = _a.height;
        var shouldSetSize = !_this.skipOnMount && !isSSR();
        if (shouldSetSize) {
          notifyResize({ width: width, height: height });
        }
        _this.skipOnMount = false;
      });
    };
    _this.getRenderType = function () {
      var _a = _this.props,
        render = _a.render,
        children = _a.children;
      if (isFunction$2(render)) {
        // DEPRECATED. Use `Child Function Pattern` instead
        return 'renderProp';
      }
      if (isFunction$2(children)) {
        return 'childFunction';
      }
      if (React.isValidElement(children)) {
        return 'child';
      }
      if (Array.isArray(children)) {
        // DEPRECATED. Wrap children with a single parent
        return 'childArray';
      }
      // DEPRECATED. Use `Child Function Pattern` instead
      return 'parent';
    };
    var skipOnMount = props.skipOnMount,
      refreshMode = props.refreshMode,
      _a = props.refreshRate,
      refreshRate = _a === void 0 ? 1000 : _a,
      refreshOptions = props.refreshOptions;
    _this.state = {
      width: undefined,
      height: undefined,
    };
    _this.skipOnMount = skipOnMount;
    _this.targetRef = React.createRef();
    _this.observableElement = null;
    if (isSSR()) {
      return _this;
    }
    _this.resizeHandler = patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
    _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
    return _this;
  }
  ResizeDetector.prototype.componentDidMount = function () {
    this.attachObserver();
  };
  ResizeDetector.prototype.componentDidUpdate = function () {
    this.attachObserver();
  };
  ResizeDetector.prototype.componentWillUnmount = function () {
    if (isSSR()) {
      return;
    }
    this.observableElement = null;
    this.resizeObserver.disconnect();
    this.cancelHandler();
  };
  ResizeDetector.prototype.render = function () {
    var _a = this.props,
      render = _a.render,
      children = _a.children,
      _b = _a.nodeType,
      WrapperTag = _b === void 0 ? 'div' : _b;
    var _c = this.state,
      width = _c.width,
      height = _c.height;
    var childProps = { width: width, height: height, targetRef: this.targetRef };
    var renderType = this.getRenderType();
    switch (renderType) {
      case 'renderProp':
        return render === null || render === void 0 ? void 0 : render(childProps);
      case 'childFunction': {
        var childFunction = children;
        return childFunction === null || childFunction === void 0 ? void 0 : childFunction(childProps);
      }
      case 'child': {
        // @TODO bug prone logic
        var child = children;
        if (child.type && typeof child.type === 'string') {
          // child is a native DOM elements such as div, span etc
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          childProps.targetRef;
          var nativeProps = __rest(childProps, ['targetRef']);
          return React.cloneElement(child, nativeProps);
        }
        // class or functional component otherwise
        return React.cloneElement(child, childProps);
      }
      case 'childArray': {
        var childArray = children;
        return childArray.map(function (el) {
          return !!el && React.cloneElement(el, childProps);
        });
      }
      default:
        return React__default['default'].createElement(WrapperTag, null);
    }
  };
  return ResizeDetector;
})(React.PureComponent);

/* eslint no-console: 0 */
var isDev = process.env.NODE_ENV !== 'production';
var warn = function warn(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }
    if (!condition) {
      if (format === undefined) {
        console.warn(
          'Minified exception occurred; use the non-minified dev environment ' +
            'for the full error message and additional helpful warnings.',
        );
      } else {
        var argIndex = 0;
        console.warn(
          format.replace(/%s/g, function () {
            return args[argIndex++];
          }),
        );
      }
    }
  }
};

function _extends$w() {
  _extends$w = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$w.apply(this, arguments);
}
function _slicedToArray$9(arr, i) {
  return (
    _arrayWithHoles$9(arr) ||
    _iterableToArrayLimit$9(arr, i) ||
    _unsupportedIterableToArray$i(arr, i) ||
    _nonIterableRest$9()
  );
}
function _nonIterableRest$9() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$i(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$i(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$i(o, minLen);
}
function _arrayLikeToArray$i(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit$9(arr, i) {
  var _i = null == arr ? null : ('undefined' != typeof Symbol && arr[Symbol.iterator]) || arr['@@iterator'];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      (_d = !0), (_e = err);
    } finally {
      try {
        if (!_n && null != _i['return'] && ((_r = _i['return']()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$9(arr) {
  if (Array.isArray(arr)) return arr;
}
var ResponsiveContainer = /*#__PURE__*/ React.forwardRef(function (_ref, ref) {
  var aspect = _ref.aspect,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$minWidth = _ref.minWidth,
    minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth,
    minHeight = _ref.minHeight,
    maxHeight = _ref.maxHeight,
    children = _ref.children,
    _ref$debounce = _ref.debounce,
    debounce = _ref$debounce === void 0 ? 0 : _ref$debounce,
    id = _ref.id,
    className = _ref.className,
    onResize = _ref.onResize;
  var _useState = React.useState({
      containerWidth: -1,
      containerHeight: -1,
    }),
    _useState2 = _slicedToArray$9(_useState, 2),
    sizes = _useState2[0],
    setSizes = _useState2[1];
  var containerRef = React.useRef(null);
  React.useImperativeHandle(
    ref,
    function () {
      return containerRef;
    },
    [containerRef],
  );
  var getContainerSize = React.useCallback(function () {
    if (!containerRef.current) {
      return null;
    }
    return {
      containerWidth: containerRef.current.clientWidth,
      containerHeight: containerRef.current.clientHeight,
    };
  }, []);
  var updateDimensionsImmediate = React.useCallback(
    function () {
      var newSize = getContainerSize();
      if (newSize) {
        var containerWidth = newSize.containerWidth,
          containerHeight = newSize.containerHeight;
        if (onResize) onResize(containerWidth, containerHeight);
        setSizes(function (currentSizes) {
          var oldWidth = currentSizes.containerWidth,
            oldHeight = currentSizes.containerHeight;
          if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
            return {
              containerWidth: containerWidth,
              containerHeight: containerHeight,
            };
          }
          return currentSizes;
        });
      }
    },
    [getContainerSize],
  );
  var chartContent = React.useMemo(
    function () {
      var containerWidth = sizes.containerWidth,
        containerHeight = sizes.containerHeight;
      if (containerWidth < 0 || containerHeight < 0) {
        return null;
      }
      warn(
        isPercent(width) || isPercent(height),
        "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.",
        width,
        height,
      );
      warn(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
      var calculatedWidth = isPercent(width) ? containerWidth : width;
      var calculatedHeight = isPercent(height) ? containerHeight : height;
      if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        if (calculatedWidth) {
          // Will default to using width for aspect ratio
          calculatedHeight = calculatedWidth / aspect;
        } else if (calculatedHeight) {
          // But we should also take height into consideration
          calculatedWidth = calculatedHeight * aspect;
        }

        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
        if (maxHeight && calculatedHeight > maxHeight) {
          calculatedHeight = maxHeight;
        }
      }
      warn(
        calculatedWidth > 0 || calculatedHeight > 0,
        'The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.',
        calculatedWidth,
        calculatedHeight,
        width,
        height,
        minWidth,
        minHeight,
        aspect,
      );
      return /*#__PURE__*/ React.cloneElement(children, {
        width: calculatedWidth,
        height: calculatedHeight,
      });
    },
    [aspect, children, height, maxHeight, minHeight, minWidth, sizes, width],
  );
  React.useEffect(
    function () {
      var size = getContainerSize();
      if (size) {
        setSizes(size);
      }
    },
    [getContainerSize],
  );
  var style = {
    width: width,
    height: height,
    minWidth: minWidth,
    minHeight: minHeight,
    maxHeight: maxHeight,
  };
  return /*#__PURE__*/ React__default['default'].createElement(
    ResizeDetector,
    {
      handleWidth: true,
      handleHeight: true,
      onResize: updateDimensionsImmediate,
      targetRef: containerRef,
      refreshMode: debounce > 0 ? 'debounce' : undefined,
      refreshRate: debounce,
    },
    /*#__PURE__*/ React__default['default'].createElement(
      'div',
      _extends$w(
        {},
        id != null
          ? {
              id: ''.concat(id),
            }
          : {},
        {
          className: cx('recharts-responsive-container', className),
          style: style,
          ref: containerRef,
        },
      ),
      chartContent,
    ),
  );
});

/**
 * @fileOverview Cross
 */

var Cell = function Cell(_props) {
  return null;
};
Cell.displayName = 'Cell';

var dist = { exports: {} };

var openParentheses = '('.charCodeAt(0);
var closeParentheses = ')'.charCodeAt(0);
var singleQuote = "'".charCodeAt(0);
var doubleQuote = '"'.charCodeAt(0);
var backslash = '\\'.charCodeAt(0);
var slash = '/'.charCodeAt(0);
var comma = ','.charCodeAt(0);
var colon = ':'.charCodeAt(0);
var star = '*'.charCodeAt(0);

var parse$2 = function (input) {
  var tokens = [];
  var value = input;

  var next, quote, prev, token, escape, escapePos, whitespacePos;
  var pos = 0;
  var code = value.charCodeAt(pos);
  var max = value.length;
  var stack = [{ nodes: tokens }];
  var balanced = 0;
  var parent;

  var name = '';
  var before = '';
  var after = '';

  while (pos < max) {
    // Whitespaces
    if (code <= 32) {
      next = pos;
      do {
        next += 1;
        code = value.charCodeAt(next);
      } while (code <= 32);
      token = value.slice(pos, next);

      prev = tokens[tokens.length - 1];
      if (code === closeParentheses && balanced) {
        after = token;
      } else if (prev && prev.type === 'div') {
        prev.after = token;
      } else if (code === comma || code === colon || (code === slash && value.charCodeAt(next + 1) !== star)) {
        before = token;
      } else {
        tokens.push({
          type: 'space',
          sourceIndex: pos,
          value: token,
        });
      }

      pos = next;

      // Quotes
    } else if (code === singleQuote || code === doubleQuote) {
      next = pos;
      quote = code === singleQuote ? "'" : '"';
      token = {
        type: 'string',
        sourceIndex: pos,
        quote: quote,
      };
      do {
        escape = false;
        next = value.indexOf(quote, next + 1);
        if (~next) {
          escapePos = next;
          while (value.charCodeAt(escapePos - 1) === backslash) {
            escapePos -= 1;
            escape = !escape;
          }
        } else {
          value += quote;
          next = value.length - 1;
          token.unclosed = true;
        }
      } while (escape);
      token.value = value.slice(pos + 1, next);

      tokens.push(token);
      pos = next + 1;
      code = value.charCodeAt(pos);

      // Comments
    } else if (code === slash && value.charCodeAt(pos + 1) === star) {
      token = {
        type: 'comment',
        sourceIndex: pos,
      };

      next = value.indexOf('*/', pos);
      if (next === -1) {
        token.unclosed = true;
        next = value.length;
      }

      token.value = value.slice(pos + 2, next);
      tokens.push(token);

      pos = next + 2;
      code = value.charCodeAt(pos);

      // Dividers
    } else if (code === slash || code === comma || code === colon) {
      token = value[pos];

      tokens.push({
        type: 'div',
        sourceIndex: pos - before.length,
        value: token,
        before: before,
        after: '',
      });
      before = '';

      pos += 1;
      code = value.charCodeAt(pos);

      // Open parentheses
    } else if (openParentheses === code) {
      // Whitespaces after open parentheses
      next = pos;
      do {
        next += 1;
        code = value.charCodeAt(next);
      } while (code <= 32);
      token = {
        type: 'function',
        sourceIndex: pos - name.length,
        value: name,
        before: value.slice(pos + 1, next),
      };
      pos = next;

      if (name === 'url' && code !== singleQuote && code !== doubleQuote) {
        next -= 1;
        do {
          escape = false;
          next = value.indexOf(')', next + 1);
          if (~next) {
            escapePos = next;
            while (value.charCodeAt(escapePos - 1) === backslash) {
              escapePos -= 1;
              escape = !escape;
            }
          } else {
            value += ')';
            next = value.length - 1;
            token.unclosed = true;
          }
        } while (escape);
        // Whitespaces before closed
        whitespacePos = next;
        do {
          whitespacePos -= 1;
          code = value.charCodeAt(whitespacePos);
        } while (code <= 32);
        if (pos !== whitespacePos + 1) {
          token.nodes = [
            {
              type: 'word',
              sourceIndex: pos,
              value: value.slice(pos, whitespacePos + 1),
            },
          ];
        } else {
          token.nodes = [];
        }
        if (token.unclosed && whitespacePos + 1 !== next) {
          token.after = '';
          token.nodes.push({
            type: 'space',
            sourceIndex: whitespacePos + 1,
            value: value.slice(whitespacePos + 1, next),
          });
        } else {
          token.after = value.slice(whitespacePos + 1, next);
        }
        pos = next + 1;
        code = value.charCodeAt(pos);
        tokens.push(token);
      } else {
        balanced += 1;
        token.after = '';
        tokens.push(token);
        stack.push(token);
        tokens = token.nodes = [];
        parent = token;
      }
      name = '';

      // Close parentheses
    } else if (closeParentheses === code && balanced) {
      pos += 1;
      code = value.charCodeAt(pos);

      parent.after = after;
      after = '';
      balanced -= 1;
      stack.pop();
      parent = stack[balanced];
      tokens = parent.nodes;

      // Words
    } else {
      next = pos;
      do {
        if (code === backslash) {
          next += 1;
        }
        next += 1;
        code = value.charCodeAt(next);
      } while (
        next < max &&
        !(
          code <= 32 ||
          code === singleQuote ||
          code === doubleQuote ||
          code === comma ||
          code === colon ||
          code === slash ||
          code === openParentheses ||
          (code === closeParentheses && balanced)
        )
      );
      token = value.slice(pos, next);

      if (openParentheses === code) {
        name = token;
      } else {
        tokens.push({
          type: 'word',
          sourceIndex: pos,
          value: token,
        });
      }

      pos = next;
    }
  }

  for (pos = stack.length - 1; pos; pos -= 1) {
    stack[pos].unclosed = true;
  }

  return stack[0].nodes;
};

var walk$1 = function walk(nodes, cb, bubble) {
  var i, max, node, result;

  for (i = 0, max = nodes.length; i < max; i += 1) {
    node = nodes[i];
    if (!bubble) {
      result = cb(node, i, nodes);
    }

    if (result !== false && node.type === 'function' && Array.isArray(node.nodes)) {
      walk(node.nodes, cb, bubble);
    }

    if (bubble) {
      cb(node, i, nodes);
    }
  }
};

function stringifyNode(node, custom) {
  var type = node.type;
  var value = node.value;
  var buf;
  var customResult;

  if (custom && (customResult = custom(node)) !== undefined) {
    return customResult;
  } else if (type === 'word' || type === 'space') {
    return value;
  } else if (type === 'string') {
    buf = node.quote || '';
    return buf + value + (node.unclosed ? '' : buf);
  } else if (type === 'comment') {
    return '/*' + value + (node.unclosed ? '' : '*/');
  } else if (type === 'div') {
    return (node.before || '') + value + (node.after || '');
  } else if (Array.isArray(node.nodes)) {
    buf = stringify$1(node.nodes);
    if (type !== 'function') {
      return buf;
    }
    return value + '(' + (node.before || '') + buf + (node.after || '') + (node.unclosed ? '' : ')');
  }
  return value;
}

function stringify$1(nodes, custom) {
  var result, i;

  if (Array.isArray(nodes)) {
    result = '';
    for (i = nodes.length - 1; ~i; i -= 1) {
      result = stringifyNode(nodes[i], custom) + result;
    }
    return result;
  }
  return stringifyNode(nodes, custom);
}

var stringify_1 = stringify$1;

var unit$1;
var hasRequiredUnit;

function requireUnit() {
  if (hasRequiredUnit) return unit$1;
  hasRequiredUnit = 1;
  var minus = '-'.charCodeAt(0);
  var plus = '+'.charCodeAt(0);
  var dot = '.'.charCodeAt(0);
  var exp = 'e'.charCodeAt(0);
  var EXP = 'E'.charCodeAt(0);

  unit$1 = function (value) {
    var pos = 0;
    var length = value.length;
    var dotted = false;
    var sciPos = -1;
    var containsNumber = false;
    var code;

    while (pos < length) {
      code = value.charCodeAt(pos);

      if (code >= 48 && code <= 57) {
        containsNumber = true;
      } else if (code === exp || code === EXP) {
        if (sciPos > -1) {
          break;
        }
        sciPos = pos;
      } else if (code === dot) {
        if (dotted) {
          break;
        }
        dotted = true;
      } else if (code === plus || code === minus) {
        if (pos !== 0) {
          break;
        }
      } else {
        break;
      }

      pos += 1;
    }

    if (sciPos + 1 === pos) pos--;

    return containsNumber
      ? {
          number: value.slice(0, pos),
          unit: value.slice(pos),
        }
      : false;
  };
  return unit$1;
}

var parse$1 = parse$2;
var walk = walk$1;
var stringify = stringify_1;

function ValueParser(value) {
  if (this instanceof ValueParser) {
    this.nodes = parse$1(value);
    return this;
  }
  return new ValueParser(value);
}

ValueParser.prototype.toString = function () {
  return Array.isArray(this.nodes) ? stringify(this.nodes) : '';
};

ValueParser.prototype.walk = function (cb, bubble) {
  walk(this.nodes, cb, bubble);
  return this;
};

ValueParser.unit = requireUnit();

ValueParser.walk = walk;

ValueParser.stringify = stringify;

var lib$1 = ValueParser;

function commonjsRequire(path) {
  throw new Error(
    'Could not dynamically require "' +
      path +
      '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.',
  );
}

var parser = {};

(function (exports) {
  /* parser generated by jison 0.6.1-215 */

  /*
   * Returns a Parser object of the following structure:
   *
   *  Parser: {
   *    yy: {}     The so-called "shared state" or rather the *source* of it;
   *               the real "shared state" `yy` passed around to
   *               the rule actions, etc. is a derivative/copy of this one,
   *               not a direct reference!
   *  }
   *
   *  Parser.prototype: {
   *    yy: {},
   *    EOF: 1,
   *    TERROR: 2,
   *
   *    trace: function(errorMessage, ...),
   *
   *    JisonParserError: function(msg, hash),
   *
   *    quoteName: function(name),
   *               Helper function which can be overridden by user code later on: put suitable
   *               quotes around literal IDs in a description string.
   *
   *    originalQuoteName: function(name),
   *               The basic quoteName handler provided by JISON.
   *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
   *               at the end of the `parse()`.
   *
   *    describeSymbol: function(symbol),
   *               Return a more-or-less human-readable description of the given symbol, when
   *               available, or the symbol itself, serving as its own 'description' for lack
   *               of something better to serve up.
   *
   *               Return NULL when the symbol is unknown to the parser.
   *
   *    symbols_: {associative list: name ==> number},
   *    terminals_: {associative list: number ==> name},
   *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
   *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
   *    productions_: [...],
   *
   *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
   *
   *               The function parameters and `this` have the following value/meaning:
   *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
   *                             to store/reference the rule value `$$` and location info `@$`.
   *
   *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
   *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
   *                 data from one reduce action through to the next within a single parse run, then you
   *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
   *
   *                 `this.yy` is a direct reference to the `yy` shared state object.
   *
   *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
   *                 object at `parse()` start and are therefore available to the action code via the
   *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
   *                 the %parse-param` list.
   *
   *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
   *                             to match this rule. This is *not* the look-ahead token, but the last token
   *                             that's actually part of this rule.
   *
   *                 Formulated another way, `yytext` is the value of the token immediately preceeding
   *                 the current look-ahead token.
   *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
   *
   *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
   *
   *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
   *
   *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
   *
   *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
   *                               of an empty object when no suitable location info can be provided.
   *
   *               - `yystate` : the current parser state number, used internally for dispatching and
   *                               executing the action code chunk matching the rule currently being reduced.
   *
   *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
   *
   *                 This one comes in handy when you are going to do advanced things to the parser
   *                 stacks, all of which are accessible from your action code (see the next entries below).
   *
   *                 Also note that you can access this and other stack index values using the new double-hash
   *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
   *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
   *                 This is made available to write very advanced grammar action rules, e.g. when you want
   *                 to investigate the parse state stack in your action code, which would, for example,
   *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
   *                 to the work described here:
   *
   *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
   *                   In Journées Francophones des Languages Applicatifs.
   *
   *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
   *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
   *
   *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
   *
   *                 This one comes in handy when you are going to do advanced things to the parser
   *                 stacks, all of which are accessible from your action code (see the next entries below).
   *
   *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
   *                             constructs.
   *
   *               - `yylstack`: reference to the parser token location stack. Also accessed via
   *                             the `@1` etc. constructs.
   *
   *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
   *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
   *                             action code did not provide a suitable location info object when such a
   *                             slot was filled!
   *
   *               - `yystack` : reference to the parser token id stack. Also accessed via the
   *                             `#1` etc. constructs.
   *
   *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
   *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
   *                 want access this array for your own purposes, such as error analysis as mentioned above!
   *
   *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
   *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
   *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
   *                 *reduced*.
   *
   *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
   *                             *states* such as the one in `yystate`, which are used to represent
   *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
   *                             what can I say? If you access this one, you're clearly doing wicked things
   *
   *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
   *                             grammar definition file.
   *
   *    table: [...],
   *               State transition table
   *               ----------------------
   *
   *               index levels are:
   *               - `state`  --> hash table
   *               - `symbol` --> action (number or array)
   *
   *                 If the `action` is an array, these are the elements' meaning:
   *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
   *                 - index [1]: GOTO `state`
   *
   *                 If the `action` is a number, it is the GOTO `state`
   *
   *    defaultActions: {...},
   *
   *    parseError: function(str, hash, ExceptionClass),
   *    yyError: function(str, ...),
   *    yyRecovering: function(),
   *    yyErrOk: function(),
   *    yyClearIn: function(),
   *
   *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
   *               Helper function **which will be set up during the first invocation of the `parse()` method**.
   *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
   *               See it's use in this parser kernel in many places; example usage:
   *
   *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
   *                                     parser.collect_expected_token_set(state), true);
   *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
   *
   *    originalParseError: function(str, hash, ExceptionClass),
   *               The basic `parseError` handler provided by JISON.
   *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
   *               at the end of the `parse()`.
   *
   *    options: { ... parser %options ... },
   *
   *    parse: function(input[, args...]),
   *               Parse the given `input` and return the parsed value (or `true` when none was provided by
   *               the root action, in which case the parser is acting as a *matcher*).
   *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
   *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
   *
   *               WARNING:
   *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
   *               any attributes already added to `yy` by the jison run-time;
   *               when such a collision is detected an exception is thrown to prevent the generated run-time
   *               from silently accepting this confusing and potentially hazardous situation!
   *
   *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
   *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
   *               object and any collision with those will be reported by the lexer via a thrown exception.
   *
   *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
   *               Helper function **which will be set up during the first invocation of the `parse()` method**.
   *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
   *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
   *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
   *               the internal parser gets properly garbage collected under these particular circumstances.
   *
   *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
   *               Helper function **which will be set up during the first invocation of the `parse()` method**.
   *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
   *
   *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
   *               this function will attempt to obtain a suitable location marker by inspecting the location stack
   *               backwards.
   *
   *               For more info see the documentation comment further below, immediately above this function's
   *               implementation.
   *
   *    lexer: {
   *        yy: {...},           A reference to the so-called "shared state" `yy` once
   *                             received via a call to the `.setInput(input, yy)` lexer API.
   *        EOF: 1,
   *        ERROR: 2,
   *        JisonLexerError: function(msg, hash),
   *        parseError: function(str, hash, ExceptionClass),
   *        setInput: function(input, [yy]),
   *        input: function(),
   *        unput: function(str),
   *        more: function(),
   *        reject: function(),
   *        less: function(n),
   *        pastInput: function(n),
   *        upcomingInput: function(n),
   *        showPosition: function(),
   *        test_match: function(regex_match_array, rule_index, ...),
   *        next: function(...),
   *        lex: function(...),
   *        begin: function(condition),
   *        pushState: function(condition),
   *        popState: function(),
   *        topState: function(),
   *        _currentRules: function(),
   *        stateStackSize: function(),
   *        cleanupAfterLex: function()
   *
   *        options: { ... lexer %options ... },
   *
   *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
   *        rules: [...],
   *        conditions: {associative list: name ==> set},
   *    }
   *  }
   *
   *
   *  token location info (@$, _$, etc.): {
   *    first_line: n,
   *    last_line: n,
   *    first_column: n,
   *    last_column: n,
   *    range: [start_number, end_number]
   *               (where the numbers are indexes into the input string, zero-based)
   *  }
   *
   * ---
   *
   * The `parseError` function receives a 'hash' object with these members for lexer and
   * parser errors:
   *
   *  {
   *    text:        (matched text)
   *    token:       (the produced terminal token, if any)
   *    token_id:    (the produced terminal token numeric ID, if any)
   *    line:        (yylineno)
   *    loc:         (yylloc)
   *  }
   *
   * parser (grammar) errors will also provide these additional members:
   *
   *  {
   *    expected:    (array describing the set of expected tokens;
   *                  may be UNDEFINED when we cannot easily produce such a set)
   *    state:       (integer (or array when the table includes grammar collisions);
   *                  represents the current internal state of the parser kernel.
   *                  can, for example, be used to pass to the `collect_expected_token_set()`
   *                  API to obtain the expected token set)
   *    action:      (integer; represents the current internal action which will be executed)
   *    new_state:   (integer; represents the next/planned internal state, once the current
   *                  action has executed)
   *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
   *                  available for this particular error)
   *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
   *                  for instance, for advanced error analysis and reporting)
   *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
   *                  for instance, for advanced error analysis and reporting)
   *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
   *                  for instance, for advanced error analysis and reporting)
   *    yy:          (object: the current parser internal "shared state" `yy`
   *                  as is also available in the rule actions; this can be used,
   *                  for instance, for advanced error analysis and reporting)
   *    lexer:       (reference to the current lexer instance used by the parser)
   *    parser:      (reference to the current parser instance)
   *  }
   *
   * while `this` will reference the current parser instance.
   *
   * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
   * instance, while these additional `hash` fields will also be provided:
   *
   *  {
   *    lexer:       (reference to the current lexer instance which reported the error)
   *  }
   *
   * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
   * from either the parser or lexer, `this` will still reference the related *parser*
   * instance, while these additional `hash` fields will also be provided:
   *
   *  {
   *    exception:   (reference to the exception thrown)
   *  }
   *
   * Please do note that in the latter situation, the `expected` field will be omitted as
   * this type of failure is assumed not to be due to *parse errors* but rather due to user
   * action code in either parser or lexer failing unexpectedly.
   *
   * ---
   *
   * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
   * These options are available:
   *
   * ### options which are global for all parser instances
   *
   *  Parser.pre_parse: function(yy)
   *                 optional: you can specify a pre_parse() function in the chunk following
   *                 the grammar, i.e. after the last `%%`.
   *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
   *                 optional: you can specify a post_parse() function in the chunk following
   *                 the grammar, i.e. after the last `%%`. When it does not return any value,
   *                 the parser will return the original `retval`.
   *
   * ### options which can be set up per parser instance
   *
   *  yy: {
   *      pre_parse:  function(yy)
   *                 optional: is invoked before the parse cycle starts (and before the first
   *                 invocation of `lex()`) but immediately after the invocation of
   *                 `parser.pre_parse()`).
   *      post_parse: function(yy, retval, parseInfo) { return retval; }
   *                 optional: is invoked when the parse terminates due to success ('accept')
   *                 or failure (even when exceptions are thrown).
   *                 `retval` contains the return value to be produced by `Parser.parse()`;
   *                 this function can override the return value by returning another.
   *                 When it does not return any value, the parser will return the original
   *                 `retval`.
   *                 This function is invoked immediately before `parser.post_parse()`.
   *
   *      parseError: function(str, hash, ExceptionClass)
   *                 optional: overrides the default `parseError` function.
   *      quoteName: function(name),
   *                 optional: overrides the default `quoteName` function.
   *  }
   *
   *  parser.lexer.options: {
   *      pre_lex:  function()
   *                 optional: is invoked before the lexer is invoked to produce another token.
   *                 `this` refers to the Lexer object.
   *      post_lex: function(token) { return token; }
   *                 optional: is invoked when the lexer has produced a token `token`;
   *                 this function can override the returned token value by returning another.
   *                 When it does not return any (truthy) value, the lexer will return
   *                 the original `token`.
   *                 `this` refers to the Lexer object.
   *
   *      ranges: boolean
   *                 optional: `true` ==> token location info will include a .range[] member.
   *      flex: boolean
   *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
   *                 exhaustively to find the longest match.
   *      backtrack_lexer: boolean
   *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
   *                 the lexer terminates the scan when a token is returned by the action code.
   *      xregexp: boolean
   *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
   *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
   *                 rule regexes have been written as standard JavaScript RegExp expressions.
   *  }
   */

  var parser = (function () {
    // See also:
    // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
    // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
    // with userland code which might access the derived class in a 'classic' way.
    function JisonParserError(msg, hash) {
      Object.defineProperty(this, 'name', {
        enumerable: false,
        writable: false,
        value: 'JisonParserError',
      });

      if (msg == null) msg = '???';

      Object.defineProperty(this, 'message', {
        enumerable: false,
        writable: true,
        value: msg,
      });

      this.hash = hash;

      var stacktrace;
      if (hash && hash.exception instanceof Error) {
        var ex2 = hash.exception;
        this.message = ex2.message || msg;
        stacktrace = ex2.stack;
      }
      if (!stacktrace) {
        if (Error.hasOwnProperty('captureStackTrace')) {
          // V8/Chrome engine
          Error.captureStackTrace(this, this.constructor);
        } else {
          stacktrace = new Error(msg).stack;
        }
      }
      if (stacktrace) {
        Object.defineProperty(this, 'stack', {
          enumerable: false,
          writable: false,
          value: stacktrace,
        });
      }
    }

    if (typeof Object.setPrototypeOf === 'function') {
      Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
    } else {
      JisonParserError.prototype = Object.create(Error.prototype);
    }
    JisonParserError.prototype.constructor = JisonParserError;
    JisonParserError.prototype.name = 'JisonParserError';

    // helper: reconstruct the productions[] table
    function bp(s) {
      var rv = [];
      var p = s.pop;
      var r = s.rule;
      for (var i = 0, l = p.length; i < l; i++) {
        rv.push([p[i], r[i]]);
      }
      return rv;
    }

    // helper: reconstruct the defaultActions[] table
    function bda(s) {
      var rv = {};
      var d = s.idx;
      var g = s.goto;
      for (var i = 0, l = d.length; i < l; i++) {
        var j = d[i];
        rv[j] = g[i];
      }
      return rv;
    }

    // helper: reconstruct the 'goto' table
    function bt(s) {
      var rv = [];
      var d = s.len;
      var y = s.symbol;
      var t = s.type;
      var a = s.state;
      var m = s.mode;
      var g = s.goto;
      for (var i = 0, l = d.length; i < l; i++) {
        var n = d[i];
        var q = {};
        for (var j = 0; j < n; j++) {
          var z = y.shift();
          switch (t.shift()) {
            case 2:
              q[z] = [m.shift(), g.shift()];
              break;

            case 0:
              q[z] = a.shift();
              break;

            default:
              // type === 1: accept
              q[z] = [3];
          }
        }
        rv.push(q);
      }
      return rv;
    }

    // helper: runlength encoding with increment step: code, length: step (default step = 0)
    // `this` references an array
    function s(c, l, a) {
      a = a || 0;
      for (var i = 0; i < l; i++) {
        this.push(c);
        c += a;
      }
    }

    // helper: duplicate sequence from *relative* offset and length.
    // `this` references an array
    function c(i, l) {
      i = this.length - i;
      for (l += i; i < l; i++) {
        this.push(this[i]);
      }
    }

    // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
    function u(a) {
      var rv = [];
      for (var i = 0, l = a.length; i < l; i++) {
        var e = a[i];
        // Is this entry a helper function?
        if (typeof e === 'function') {
          i++;
          e.apply(rv, a[i]);
        } else {
          rv.push(e);
        }
      }
      return rv;
    }

    var parser = {
      // Code Generator Information Report
      // ---------------------------------
      //
      // Options:
      //
      //   default action mode: ............. ["classic","merge"]
      //   test-compile action mode: ........ "parser:*,lexer:*"
      //   try..catch: ...................... true
      //   default resolve on conflict: ..... true
      //   on-demand look-ahead: ............ false
      //   error recovery token skip maximum: 3
      //   yyerror in parse actions is: ..... NOT recoverable,
      //   yyerror in lexer actions and other non-fatal lexer are:
      //   .................................. NOT recoverable,
      //   debug grammar/output: ............ false
      //   has partial LR conflict upgrade:   true
      //   rudimentary token-stack support:   false
      //   parser table compression mode: ... 2
      //   export debug tables: ............. false
      //   export *all* tables: ............. false
      //   module type: ..................... commonjs
      //   parser engine type: .............. lalr
      //   output main() in the module: ..... true
      //   has user-specified main(): ....... false
      //   has user-specified require()/import modules for main():
      //   .................................. false
      //   number of expected conflicts: .... 0
      //
      //
      // Parser Analysis flags:
      //
      //   no significant actions (parser is a language matcher only):
      //   .................................. false
      //   uses yyleng: ..................... false
      //   uses yylineno: ................... false
      //   uses yytext: ..................... false
      //   uses yylloc: ..................... false
      //   uses ParseError API: ............. false
      //   uses YYERROR: .................... false
      //   uses YYRECOVERING: ............... false
      //   uses YYERROK: .................... false
      //   uses YYCLEARIN: .................. false
      //   tracks rule values: .............. true
      //   assigns rule values: ............. true
      //   uses location tracking: .......... false
      //   assigns location: ................ false
      //   uses yystack: .................... false
      //   uses yysstack: ................... false
      //   uses yysp: ....................... true
      //   uses yyrulelength: ............... false
      //   uses yyMergeLocationInfo API: .... false
      //   has error recovery: .............. false
      //   has error reporting: ............. false
      //
      // --------- END OF REPORT -----------

      trace: function no_op_trace() {},
      JisonParserError: JisonParserError,
      yy: {},
      options: {
        type: 'lalr',
        hasPartialLrUpgradeOnConflict: true,
        errorRecoveryTokenDiscardCount: 3,
      },
      symbols_: {
        $accept: 0,
        $end: 1,
        ADD: 3,
        ANGLE: 16,
        CHS: 22,
        COMMA: 14,
        CSS_CPROP: 13,
        CSS_VAR: 12,
        DIV: 6,
        EMS: 20,
        EOF: 1,
        EXS: 21,
        FREQ: 18,
        LENGTH: 15,
        LPAREN: 7,
        MUL: 5,
        NESTED_CALC: 9,
        NUMBER: 11,
        PERCENTAGE: 28,
        PREFIX: 10,
        REMS: 23,
        RES: 19,
        RPAREN: 8,
        SUB: 4,
        TIME: 17,
        VHS: 24,
        VMAXS: 27,
        VMINS: 26,
        VWS: 25,
        css_value: 33,
        css_variable: 32,
        error: 2,
        expression: 29,
        math_expression: 30,
        value: 31,
      },
      terminals_: {
        1: 'EOF',
        2: 'error',
        3: 'ADD',
        4: 'SUB',
        5: 'MUL',
        6: 'DIV',
        7: 'LPAREN',
        8: 'RPAREN',
        9: 'NESTED_CALC',
        10: 'PREFIX',
        11: 'NUMBER',
        12: 'CSS_VAR',
        13: 'CSS_CPROP',
        14: 'COMMA',
        15: 'LENGTH',
        16: 'ANGLE',
        17: 'TIME',
        18: 'FREQ',
        19: 'RES',
        20: 'EMS',
        21: 'EXS',
        22: 'CHS',
        23: 'REMS',
        24: 'VHS',
        25: 'VWS',
        26: 'VMINS',
        27: 'VMAXS',
        28: 'PERCENTAGE',
      },
      TERROR: 2,
      EOF: 1,

      // internals: defined here so the object *structure* doesn't get modified by parse() et al,
      // thus helping JIT compilers like Chrome V8.
      originalQuoteName: null,
      originalParseError: null,
      cleanupAfterParse: null,
      constructParseErrorInfo: null,
      yyMergeLocationInfo: null,

      __reentrant_call_depth: 0, // INTERNAL USE ONLY
      __error_infos: [], // INTERNAL USE ONLY: the set of parseErrorInfo objects created since the last cleanup
      __error_recovery_infos: [], // INTERNAL USE ONLY: the set of parseErrorInfo objects created since the last cleanup

      // APIs which will be set up depending on user action code analysis:
      //yyRecovering: 0,
      //yyErrOk: 0,
      //yyClearIn: 0,

      // Helper APIs
      // -----------

      // Helper function which can be overridden by user code later on: put suitable quotes around
      // literal IDs in a description string.
      quoteName: function parser_quoteName(id_str) {
        return '"' + id_str + '"';
      },

      // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
      //
      // Return NULL when the symbol is unknown to the parser.
      getSymbolName: function parser_getSymbolName(symbol) {
        if (this.terminals_[symbol]) {
          return this.terminals_[symbol];
        }

        // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
        //
        // An example of this may be where a rule's action code contains a call like this:
        //
        //      parser.getSymbolName(#$)
        //
        // to obtain a human-readable name of the current grammar rule.
        var s = this.symbols_;
        for (var key in s) {
          if (s[key] === symbol) {
            return key;
          }
        }
        return null;
      },

      // Return a more-or-less human-readable description of the given symbol, when available,
      // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
      //
      // Return NULL when the symbol is unknown to the parser.
      describeSymbol: function parser_describeSymbol(symbol) {
        if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) {
          return this.terminal_descriptions_[symbol];
        } else if (symbol === this.EOF) {
          return 'end of input';
        }
        var id = this.getSymbolName(symbol);
        if (id) {
          return this.quoteName(id);
        }
        return null;
      },

      // Produce a (more or less) human-readable list of expected tokens at the point of failure.
      //
      // The produced list may contain token or token set descriptions instead of the tokens
      // themselves to help turning this output into something that easier to read by humans
      // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
      // expected terminals and nonterminals is produced.
      //
      // The returned list (array) will not contain any duplicate entries.
      collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
        var TERROR = this.TERROR;
        var tokenset = [];
        var check = {};
        // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
        // If so, use that one instead of the less palatable token set.
        if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) {
          return [this.state_descriptions_[state]];
        }
        for (var p in this.table[state]) {
          p = +p;
          if (p !== TERROR) {
            var d = do_not_describe ? p : this.describeSymbol(p);
            if (d && !check[d]) {
              tokenset.push(d);
              check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
            }
          }
        }
        return tokenset;
      },
      productions_: bp({
        pop: u([29, s, [30, 10], 31, 31, 32, 32, s, [33, 15]]),
        rule: u([2, s, [3, 5], 4, 7, s, [1, 4], 2, 4, 6, s, [1, 14], 2]),
      }),
      performAction: function parser__PerformAction(yystate /* action[1] */, yysp, yyvstack) {
        /* this == yyval */

        // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
        var yy = this.yy;
        yy.parser;
        yy.lexer;

        switch (yystate) {
          case 0:
            /*! Production::    $accept : expression $end */

            // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
            this.$ = yyvstack[yysp - 1];
            // END of default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-)
            break;

          case 1:
            /*! Production::    expression : math_expression EOF */

            // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
            this.$ = yyvstack[yysp - 1];
            // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)

            return yyvstack[yysp - 1];

          case 2:
          /*! Production::    math_expression : math_expression ADD math_expression */
          case 3:
          /*! Production::    math_expression : math_expression SUB math_expression */
          case 4:
          /*! Production::    math_expression : math_expression MUL math_expression */
          case 5:
            /*! Production::    math_expression : math_expression DIV math_expression */

            this.$ = {
              type: 'MathExpression',
              operator: yyvstack[yysp - 1],
              left: yyvstack[yysp - 2],
              right: yyvstack[yysp],
            };
            break;

          case 6:
            /*! Production::    math_expression : LPAREN math_expression RPAREN */

            this.$ = yyvstack[yysp - 1];
            break;

          case 7:
            /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */

            this.$ = { type: 'Calc', value: yyvstack[yysp - 1] };
            break;

          case 8:
            /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */

            this.$ = { type: 'Calc', value: yyvstack[yysp - 1], prefix: yyvstack[yysp - 5] };
            break;

          case 9:
          /*! Production::    math_expression : css_variable */
          case 10:
          /*! Production::    math_expression : css_value */
          case 11:
            /*! Production::    math_expression : value */

            this.$ = yyvstack[yysp];
            break;

          case 12:
            /*! Production::    value : NUMBER */

            this.$ = { type: 'Value', value: parseFloat(yyvstack[yysp]) };
            break;

          case 13:
            /*! Production::    value : SUB NUMBER */

            this.$ = { type: 'Value', value: parseFloat(yyvstack[yysp]) * -1 };
            break;

          case 14:
            /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */

            this.$ = { type: 'CssVariable', value: yyvstack[yysp - 1] };
            break;

          case 15:
            /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */

            this.$ = { type: 'CssVariable', value: yyvstack[yysp - 3], fallback: yyvstack[yysp - 1] };
            break;

          case 16:
            /*! Production::    css_value : LENGTH */

            this.$ = { type: 'LengthValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
            break;

          case 17:
            /*! Production::    css_value : ANGLE */

            this.$ = { type: 'AngleValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
            break;

          case 18:
            /*! Production::    css_value : TIME */

            this.$ = { type: 'TimeValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
            break;

          case 19:
            /*! Production::    css_value : FREQ */

            this.$ = {
              type: 'FrequencyValue',
              value: parseFloat(yyvstack[yysp]),
              unit: /[a-z]+/.exec(yyvstack[yysp])[0],
            };
            break;

          case 20:
            /*! Production::    css_value : RES */

            this.$ = {
              type: 'ResolutionValue',
              value: parseFloat(yyvstack[yysp]),
              unit: /[a-z]+/.exec(yyvstack[yysp])[0],
            };
            break;

          case 21:
            /*! Production::    css_value : EMS */

            this.$ = { type: 'EmValue', value: parseFloat(yyvstack[yysp]), unit: 'em' };
            break;

          case 22:
            /*! Production::    css_value : EXS */

            this.$ = { type: 'ExValue', value: parseFloat(yyvstack[yysp]), unit: 'ex' };
            break;

          case 23:
            /*! Production::    css_value : CHS */

            this.$ = { type: 'ChValue', value: parseFloat(yyvstack[yysp]), unit: 'ch' };
            break;

          case 24:
            /*! Production::    css_value : REMS */

            this.$ = { type: 'RemValue', value: parseFloat(yyvstack[yysp]), unit: 'rem' };
            break;

          case 25:
            /*! Production::    css_value : VHS */

            this.$ = { type: 'VhValue', value: parseFloat(yyvstack[yysp]), unit: 'vh' };
            break;

          case 26:
            /*! Production::    css_value : VWS */

            this.$ = { type: 'VwValue', value: parseFloat(yyvstack[yysp]), unit: 'vw' };
            break;

          case 27:
            /*! Production::    css_value : VMINS */

            this.$ = { type: 'VminValue', value: parseFloat(yyvstack[yysp]), unit: 'vmin' };
            break;

          case 28:
            /*! Production::    css_value : VMAXS */

            this.$ = { type: 'VmaxValue', value: parseFloat(yyvstack[yysp]), unit: 'vmax' };
            break;

          case 29:
            /*! Production::    css_value : PERCENTAGE */

            this.$ = { type: 'PercentageValue', value: parseFloat(yyvstack[yysp]), unit: '%' };
            break;

          case 30:
            /*! Production::    css_value : SUB css_value */

            var prev = yyvstack[yysp];
            prev.value *= -1;
            this.$ = prev;
            break;
        }
      },
      table: bt({
        len: u([
          24,
          1,
          5,
          23,
          1,
          18,
          s,
          [0, 3],
          1,
          s,
          [0, 16],
          s,
          [23, 4],
          c,
          [28, 3],
          0,
          0,
          16,
          1,
          6,
          6,
          s,
          [0, 3],
          5,
          1,
          2,
          c,
          [37, 3],
          c,
          [20, 3],
          5,
          0,
          0,
        ]),
        symbol: u([
          4,
          7,
          9,
          11,
          12,
          s,
          [15, 19, 1],
          1,
          1,
          s,
          [3, 4, 1],
          c,
          [30, 19],
          c,
          [29, 4],
          7,
          4,
          10,
          11,
          c,
          [22, 14],
          c,
          [19, 3],
          c,
          [43, 22],
          c,
          [23, 69],
          c,
          [139, 4],
          8,
          c,
          [51, 24],
          4,
          c,
          [138, 15],
          13,
          c,
          [186, 5],
          8,
          c,
          [6, 6],
          c,
          [5, 5],
          9,
          8,
          14,
          c,
          [159, 47],
          c,
          [60, 10],
        ]),
        type: u([
          s,
          [2, 19],
          s,
          [0, 5],
          1,
          s,
          [2, 24],
          s,
          [0, 4],
          c,
          [22, 19],
          c,
          [43, 42],
          c,
          [23, 70],
          c,
          [28, 25],
          c,
          [45, 25],
          c,
          [113, 54],
        ]),
        state: u([
          1,
          2,
          8,
          6,
          7,
          30,
          c,
          [4, 3],
          33,
          37,
          c,
          [5, 3],
          38,
          c,
          [4, 3],
          39,
          c,
          [4, 3],
          40,
          c,
          [4, 3],
          42,
          c,
          [21, 4],
          50,
          c,
          [5, 3],
          51,
          c,
          [4, 3],
        ]),
        mode: u([s, [1, 179], s, [2, 3], c, [5, 5], c, [6, 4], s, [1, 57]]),
        goto: u([
          5,
          3,
          4,
          24,
          s,
          [9, 15, 1],
          s,
          [25, 5, 1],
          c,
          [24, 19],
          31,
          35,
          32,
          34,
          c,
          [18, 14],
          36,
          c,
          [38, 19],
          c,
          [19, 57],
          c,
          [118, 4],
          41,
          c,
          [24, 19],
          43,
          35,
          c,
          [16, 14],
          44,
          s,
          [2, 3],
          28,
          29,
          2,
          s,
          [3, 3],
          28,
          29,
          3,
          c,
          [53, 4],
          s,
          [45, 5, 1],
          c,
          [100, 42],
          52,
          c,
          [5, 4],
          53,
        ]),
      }),
      defaultActions: bda({
        idx: u([6, 7, 8, s, [10, 16, 1], 33, 34, 39, 40, 41, 45, 47, 52, 53]),
        goto: u([9, 10, 11, s, [16, 14, 1], 12, 1, 30, 13, s, [4, 4, 1], 14, 15, 8]),
      }),
      parseError: function parseError(str, hash, ExceptionClass) {
        if (hash.recoverable) {
          if (typeof this.trace === 'function') {
            this.trace(str);
          }
          hash.destroy(); // destroy... well, *almost*!
        } else {
          if (typeof this.trace === 'function') {
            this.trace(str);
          }
          if (!ExceptionClass) {
            ExceptionClass = this.JisonParserError;
          }
          throw new ExceptionClass(str, hash);
        }
      },
      parse: function parse(input) {
        var self = this;
        var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)
        var sstack = new Array(128); // state stack: stores states (column storage)

        var vstack = new Array(128); // semantic value stack

        var table = this.table;
        var sp = 0; // 'stack pointer': index into the stacks

        var symbol = 0;

        this.TERROR;
        var EOF = this.EOF;
        this.options.errorRecoveryTokenDiscardCount | 0 || 3;
        var NO_ACTION = [
          0, 54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */,
        ];

        var lexer;
        if (this.__lexer__) {
          lexer = this.__lexer__;
        } else {
          lexer = this.__lexer__ = Object.create(this.lexer);
        }

        var sharedState_yy = {
          parseError: undefined,
          quoteName: undefined,
          lexer: undefined,
          parser: undefined,
          pre_parse: undefined,
          post_parse: undefined,
          pre_lex: undefined,
          post_lex: undefined, // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
        };
        if (typeof assert !== 'function');
        else {
          assert;
        }

        this.yyGetSharedState = function yyGetSharedState() {
          return sharedState_yy;
        };

        function shallow_copy_noclobber(dst, src) {
          for (var k in src) {
            if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) {
              dst[k] = src[k];
            }
          }
        }

        // copy state
        shallow_copy_noclobber(sharedState_yy, this.yy);

        sharedState_yy.lexer = lexer;
        sharedState_yy.parser = this;

        // Does the shared state override the default `parseError` that already comes with this instance?
        if (typeof sharedState_yy.parseError === 'function') {
          this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
            if (!ExceptionClass) {
              ExceptionClass = this.JisonParserError;
            }
            return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
          };
        } else {
          this.parseError = this.originalParseError;
        }

        // Does the shared state override the default `quoteName` that already comes with this instance?
        if (typeof sharedState_yy.quoteName === 'function') {
          this.quoteName = function quoteNameAlt(id_str) {
            return sharedState_yy.quoteName.call(this, id_str);
          };
        } else {
          this.quoteName = this.originalQuoteName;
        }

        // set up the cleanup function; make it an API so that external code can re-use this one in case of
        // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
        // case this parse() API method doesn't come with a `finally { ... }` block any more!
        //
        // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
        //       or else your `sharedState`, etc. references will be *wrong*!
        this.cleanupAfterParse = function parser_cleanupAfterParse(
          resultValue,
          invoke_post_methods,
          do_not_nuke_errorinfos,
        ) {
          var rv;

          if (invoke_post_methods) {
            var hash;

            if (sharedState_yy.post_parse || this.post_parse) {
              // create an error hash info instance: we re-use this API in a **non-error situation**
              // as this one delivers all parser internals ready for access by userland code.
              hash = this.constructParseErrorInfo(null /* no error! */, null /* no exception! */, null, false);
            }

            if (sharedState_yy.post_parse) {
              rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
              if (typeof rv !== 'undefined') resultValue = rv;
            }
            if (this.post_parse) {
              rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
              if (typeof rv !== 'undefined') resultValue = rv;
            }

            // cleanup:
            if (hash && hash.destroy) {
              hash.destroy();
            }
          }

          if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.

          // clean up the lingering lexer structures as well:
          if (lexer.cleanupAfterLex) {
            lexer.cleanupAfterLex(do_not_nuke_errorinfos);
          }

          // prevent lingering circular references from causing memory leaks:
          if (sharedState_yy) {
            sharedState_yy.lexer = undefined;
            sharedState_yy.parser = undefined;
            if (lexer.yy === sharedState_yy) {
              lexer.yy = undefined;
            }
          }
          sharedState_yy = undefined;
          this.parseError = this.originalParseError;
          this.quoteName = this.originalQuoteName;

          // nuke the vstack[] array at least as that one will still reference obsoleted user values.
          // To be safe, we nuke the other internal stack columns as well...
          stack.length = 0; // fastest way to nuke an array without overly bothering the GC
          sstack.length = 0;

          vstack.length = 0;
          sp = 0;

          // nuke the error hash info instances created during this run.
          // Userland code must COPY any data/references
          // in the error hash instance(s) it is more permanently interested in.
          if (!do_not_nuke_errorinfos) {
            for (var i = this.__error_infos.length - 1; i >= 0; i--) {
              var el = this.__error_infos[i];
              if (el && typeof el.destroy === 'function') {
                el.destroy();
              }
            }
            this.__error_infos.length = 0;
          }

          return resultValue;
        };

        // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
        //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
        this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
          var pei = {
            errStr: msg,
            exception: ex,
            text: lexer.match,
            value: lexer.yytext,
            token: this.describeSymbol(symbol) || symbol,
            token_id: symbol,
            line: lexer.yylineno,

            expected: expected,
            recoverable: recoverable,
            state: state,
            action: action,
            new_state: newState,
            symbol_stack: stack,
            state_stack: sstack,
            value_stack: vstack,

            stack_pointer: sp,
            yy: sharedState_yy,
            lexer: lexer,
            parser: this,

            // and make sure the error info doesn't stay due to potential
            // ref cycle via userland code manipulations.
            // These would otherwise all be memory leak opportunities!
            //
            // Note that only array and object references are nuked as those
            // constitute the set of elements which can produce a cyclic ref.
            // The rest of the members is kept intact as they are harmless.
            destroy: function destructParseErrorInfo() {
              // remove cyclic references added to error info:
              // info.yy = null;
              // info.lexer = null;
              // info.value = null;
              // info.value_stack = null;
              // ...
              var rec = !!this.recoverable;
              for (var key in this) {
                if (this.hasOwnProperty(key) && typeof key === 'object') {
                  this[key] = undefined;
                }
              }
              this.recoverable = rec;
            },
          };
          // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
          this.__error_infos.push(pei);
          return pei;
        };

        function stdLex() {
          var token = lexer.lex();
          // if token isn't its numeric value, convert
          if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
          }

          return token || EOF;
        }

        function fastLex() {
          var token = lexer.fastLex();
          // if token isn't its numeric value, convert
          if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
          }

          return token || EOF;
        }

        var lex = stdLex;

        var state, action, r, t;
        var yyval = {
          $: true,
          _$: undefined,
          yy: sharedState_yy,
        };
        var p;
        var yyrulelen;
        var this_production;
        var newState;
        var retval = false;

        try {
          this.__reentrant_call_depth++;

          lexer.setInput(input, sharedState_yy);

          // NOTE: we *assume* no lexer pre/post handlers are set up *after*
          // this initial `setInput()` call: hence we can now check and decide
          // whether we'll go with the standard, slower, lex() API or the
          // `fast_lex()` one:
          if (typeof lexer.canIUse === 'function') {
            var lexerInfo = lexer.canIUse();
            if (lexerInfo.fastLex && typeof fastLex === 'function') {
              lex = fastLex;
            }
          }

          vstack[sp] = null;
          sstack[sp] = 0;
          stack[sp] = 0;
          ++sp;

          if (this.pre_parse) {
            this.pre_parse.call(this, sharedState_yy);
          }
          if (sharedState_yy.pre_parse) {
            sharedState_yy.pre_parse.call(this, sharedState_yy);
          }

          newState = sstack[sp - 1];
          for (;;) {
            // retrieve state number from top of stack
            state = newState; // sstack[sp - 1];

            // use default actions if available
            if (this.defaultActions[state]) {
              action = 2;
              newState = this.defaultActions[state];
            } else {
              // The single `==` condition below covers both these `===` comparisons in a single
              // operation:
              //
              //     if (symbol === null || typeof symbol === 'undefined') ...
              if (!symbol) {
                symbol = lex();
              }
              // read action for current state and first input
              t = (table[state] && table[state][symbol]) || NO_ACTION;
              newState = t[1];
              action = t[0];

              // handle parse error
              if (!action) {
                var errStr;
                var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                var expected = this.collect_expected_token_set(state);

                // Report error
                if (typeof lexer.yylineno === 'number') {
                  errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
                } else {
                  errStr = 'Parse error: ';
                }
                if (typeof lexer.showPosition === 'function') {
                  errStr += '\n' + lexer.showPosition(79 - 10, 10) + '\n';
                }
                if (expected.length) {
                  errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
                } else {
                  errStr += 'Unexpected ' + errSymbolDescr;
                }
                // we cannot recover from the error!
                p = this.constructParseErrorInfo(errStr, null, expected, false);
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== 'undefined') {
                  retval = r;
                }
                break;
              }
            }

            switch (action) {
              // catch misc. parse failures:
              default:
                // this shouldn't happen, unless resolve defaults are off
                if (action instanceof Array) {
                  p = this.constructParseErrorInfo(
                    'Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol,
                    null,
                    null,
                    false,
                  );
                  r = this.parseError(p.errStr, p, this.JisonParserError);
                  if (typeof r !== 'undefined') {
                    retval = r;
                  }
                  break;
                }
                // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                // or a buggy LUT (LookUp Table):
                p = this.constructParseErrorInfo(
                  'Parsing halted. No viable error recovery approach available due to internal system failure.',
                  null,
                  null,
                  false,
                );
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== 'undefined') {
                  retval = r;
                }
                break;

              // shift:
              case 1:
                stack[sp] = symbol;
                vstack[sp] = lexer.yytext;

                sstack[sp] = newState; // push state

                ++sp;
                symbol = 0;

                // Pick up the lexer details for the current symbol as that one is not 'look-ahead' any more:

                continue;

              // reduce:
              case 2:
                this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                yyrulelen = this_production[1];

                r = this.performAction.call(yyval, newState, sp - 1, vstack);

                if (typeof r !== 'undefined') {
                  retval = r;
                  break;
                }

                // pop off stack
                sp -= yyrulelen;

                // don't overwrite the `symbol` variable: use a local var to speed things up:
                var ntsymbol = this_production[0]; // push nonterminal (reduce)
                stack[sp] = ntsymbol;
                vstack[sp] = yyval.$;

                // goto new state = table[STATE][NONTERMINAL]
                newState = table[sstack[sp - 1]][ntsymbol];
                sstack[sp] = newState;
                ++sp;

                continue;

              // accept:
              case 3:
                if (sp !== -2) {
                  retval = true;
                  // Return the `$accept` rule's `$$` result, if available.
                  //
                  // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                  // default, action):
                  //
                  //     $accept: <startSymbol> $end
                  //                  %{ $$ = $1; @$ = @1; %}
                  //
                  // which, combined with the parse kernel's `$accept` state behaviour coded below,
                  // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                  // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                  //
                  // In code:
                  //
                  //                  %{
                  //                      @$ = @1;            // if location tracking support is included
                  //                      if (typeof $1 !== 'undefined')
                  //                          return $1;
                  //                      else
                  //                          return true;           // the default parse result if the rule actions don't produce anything
                  //                  %}
                  sp--;
                  if (typeof vstack[sp] !== 'undefined') {
                    retval = vstack[sp];
                  }
                }
                break;
            }

            // break out of loop: we accept or fail with error
            break;
          }
        } catch (ex) {
          // report exceptions through the parseError callback too, but keep the exception intact
          // if it is a known parser or lexer error which has been thrown by parseError() already:
          if (ex instanceof this.JisonParserError) {
            throw ex;
          } else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) {
            throw ex;
          }

          p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
          retval = false;
          r = this.parseError(p.errStr, p, this.JisonParserError);
          if (typeof r !== 'undefined') {
            retval = r;
          }
        } finally {
          retval = this.cleanupAfterParse(retval, true, true);
          this.__reentrant_call_depth--;
        } // /finally

        return retval;
      },
    };
    parser.originalParseError = parser.parseError;
    parser.originalQuoteName = parser.quoteName;
    /* lexer generated by jison-lex 0.6.1-215 */

    /*
     * Returns a Lexer object of the following structure:
     *
     *  Lexer: {
     *    yy: {}     The so-called "shared state" or rather the *source* of it;
     *               the real "shared state" `yy` passed around to
     *               the rule actions, etc. is a direct reference!
     *
     *               This "shared context" object was passed to the lexer by way of
     *               the `lexer.setInput(str, yy)` API before you may use it.
     *
     *               This "shared context" object is passed to the lexer action code in `performAction()`
     *               so userland code in the lexer actions may communicate with the outside world
     *               and/or other lexer rules' actions in more or less complex ways.
     *
     *  }
     *
     *  Lexer.prototype: {
     *    EOF: 1,
     *    ERROR: 2,
     *
     *    yy:        The overall "shared context" object reference.
     *
     *    JisonLexerError: function(msg, hash),
     *
     *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
     *
     *               The function parameters and `this` have the following value/meaning:
     *               - `this`    : reference to the `lexer` instance.
     *                               `yy_` is an alias for `this` lexer instance reference used internally.
     *
     *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
     *                             by way of the `lexer.setInput(str, yy)` API before.
     *
     *                             Note:
     *                             The extra arguments you specified in the `%parse-param` statement in your
     *                             **parser** grammar definition file are passed to the lexer via this object
     *                             reference as member variables.
     *
     *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
     *
     *               - `YY_START`: the current lexer "start condition" state.
     *
     *    parseError: function(str, hash, ExceptionClass),
     *
     *    constructLexErrorInfo: function(error_message, is_recoverable),
     *               Helper function.
     *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
     *               See it's use in this lexer kernel in many places; example usage:
     *
     *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
     *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
     *
     *    options: { ... lexer %options ... },
     *
     *    lex: function(),
     *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
     *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
     *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
     *
     *               WARNING:
     *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
     *               any attributes already added to `yy` by the **parser** or the jison run-time;
     *               when such a collision is detected an exception is thrown to prevent the generated run-time
     *               from silently accepting this confusing and potentially hazardous situation!
     *
     *    cleanupAfterLex: function(do_not_nuke_errorinfos),
     *               Helper function.
     *
     *               This helper API is invoked when the **parse process** has completed: it is the responsibility
     *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired.
     *
     *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
     *
     *    setInput: function(input, [yy]),
     *
     *
     *    input: function(),
     *
     *
     *    unput: function(str),
     *
     *
     *    more: function(),
     *
     *
     *    reject: function(),
     *
     *
     *    less: function(n),
     *
     *
     *    pastInput: function(n),
     *
     *
     *    upcomingInput: function(n),
     *
     *
     *    showPosition: function(),
     *
     *
     *    test_match: function(regex_match_array, rule_index),
     *
     *
     *    next: function(),
     *
     *
     *    begin: function(condition),
     *
     *
     *    pushState: function(condition),
     *
     *
     *    popState: function(),
     *
     *
     *    topState: function(),
     *
     *
     *    _currentRules: function(),
     *
     *
     *    stateStackSize: function(),
     *
     *
     *    performAction: function(yy, yy_, yyrulenumber, YY_START),
     *
     *
     *    rules: [...],
     *
     *
     *    conditions: {associative list: name ==> set},
     *  }
     *
     *
     *  token location info (`yylloc`): {
     *    first_line: n,
     *    last_line: n,
     *    first_column: n,
     *    last_column: n,
     *    range: [start_number, end_number]
     *               (where the numbers are indexes into the input string, zero-based)
     *  }
     *
     * ---
     *
     * The `parseError` function receives a 'hash' object with these members for lexer errors:
     *
     *  {
     *    text:        (matched text)
     *    token:       (the produced terminal token, if any)
     *    token_id:    (the produced terminal token numeric ID, if any)
     *    line:        (yylineno)
     *    loc:         (yylloc)
     *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
     *                  available for this particular error)
     *    yy:          (object: the current parser internal "shared state" `yy`
     *                  as is also available in the rule actions; this can be used,
     *                  for instance, for advanced error analysis and reporting)
     *    lexer:       (reference to the current lexer instance used by the parser)
     *  }
     *
     * while `this` will reference the current lexer instance.
     *
     * When `parseError` is invoked by the lexer, the default implementation will
     * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
     * it will try to invoke `yy.parseError()` instead. When that callback is also not
     * provided, a `JisonLexerError` exception will be thrown containing the error
     * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
     *
     * Note that the lexer's `JisonLexerError` error class is passed via the
     * `ExceptionClass` argument, which is invoked to construct the exception
     * instance to be thrown, so technically `parseError` will throw the object
     * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
     *
     * ---
     *
     * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
     * These options are available:
     *
     * (Options are permanent.)
     *
     *  yy: {
     *      parseError: function(str, hash, ExceptionClass)
     *                 optional: overrides the default `parseError` function.
     *  }
     *
     *  lexer.options: {
     *      pre_lex:  function()
     *                 optional: is invoked before the lexer is invoked to produce another token.
     *                 `this` refers to the Lexer object.
     *      post_lex: function(token) { return token; }
     *                 optional: is invoked when the lexer has produced a token `token`;
     *                 this function can override the returned token value by returning another.
     *                 When it does not return any (truthy) value, the lexer will return
     *                 the original `token`.
     *                 `this` refers to the Lexer object.
     *
     * WARNING: the next set of options are not meant to be changed. They echo the abilities of
     * the lexer as per when it was compiled!
     *
     *      ranges: boolean
     *                 optional: `true` ==> token location info will include a .range[] member.
     *      flex: boolean
     *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
     *                 exhaustively to find the longest match.
     *      backtrack_lexer: boolean
     *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
     *                 the lexer terminates the scan when a token is returned by the action code.
     *      xregexp: boolean
     *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
     *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
     *                 rule regexes have been written as standard JavaScript RegExp expressions.
     *  }
     */

    var lexer = (function () {
      /**
       * See also:
       * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
       * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
       * with userland code which might access the derived class in a 'classic' way.
       *
       * @public
       * @constructor
       * @nocollapse
       */
      function JisonLexerError(msg, hash) {
        Object.defineProperty(this, 'name', {
          enumerable: false,
          writable: false,
          value: 'JisonLexerError',
        });

        if (msg == null) msg = '???';

        Object.defineProperty(this, 'message', {
          enumerable: false,
          writable: true,
          value: msg,
        });

        this.hash = hash;
        var stacktrace;

        if (hash && hash.exception instanceof Error) {
          var ex2 = hash.exception;
          this.message = ex2.message || msg;
          stacktrace = ex2.stack;
        }

        if (!stacktrace) {
          if (Error.hasOwnProperty('captureStackTrace')) {
            // V8
            Error.captureStackTrace(this, this.constructor);
          } else {
            stacktrace = new Error(msg).stack;
          }
        }

        if (stacktrace) {
          Object.defineProperty(this, 'stack', {
            enumerable: false,
            writable: false,
            value: stacktrace,
          });
        }
      }

      if (typeof Object.setPrototypeOf === 'function') {
        Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
      } else {
        JisonLexerError.prototype = Object.create(Error.prototype);
      }

      JisonLexerError.prototype.constructor = JisonLexerError;
      JisonLexerError.prototype.name = 'JisonLexerError';

      var lexer = {
        // Code Generator Information Report
        // ---------------------------------
        //
        // Options:
        //
        //   backtracking: .................... false
        //   location.ranges: ................. false
        //   location line+column tracking: ... true
        //
        //
        // Forwarded Parser Analysis flags:
        //
        //   uses yyleng: ..................... false
        //   uses yylineno: ................... false
        //   uses yytext: ..................... false
        //   uses yylloc: ..................... false
        //   uses lexer values: ............... true / true
        //   location tracking: ............... false
        //   location assignment: ............. false
        //
        //
        // Lexer Analysis flags:
        //
        //   uses yyleng: ..................... ???
        //   uses yylineno: ................... ???
        //   uses yytext: ..................... ???
        //   uses yylloc: ..................... ???
        //   uses ParseError API: ............. ???
        //   uses yyerror: .................... ???
        //   uses location tracking & editing:  ???
        //   uses more() API: ................. ???
        //   uses unput() API: ................ ???
        //   uses reject() API: ............... ???
        //   uses less() API: ................. ???
        //   uses display APIs pastInput(), upcomingInput(), showPosition():
        //        ............................. ???
        //   uses describeYYLLOC() API: ....... ???
        //
        // --------- END OF REPORT -----------

        EOF: 1,
        ERROR: 2,

        // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator

        // options: {},                             /// <-- injected by the code generator

        // yy: ...,                                 /// <-- injected by setInput()

        __currentRuleSet__: null, /// INTERNAL USE ONLY: internal rule set cache for the current lexer state

        __error_infos: [], /// INTERNAL USE ONLY: the set of lexErrorInfo objects created since the last cleanup
        __decompressed: false, /// INTERNAL USE ONLY: mark whether the lexer instance has been 'unfolded' completely and is now ready for use
        done: false, /// INTERNAL USE ONLY
        _backtrack: false, /// INTERNAL USE ONLY
        _input: '', /// INTERNAL USE ONLY
        _more: false, /// INTERNAL USE ONLY
        _signaled_error_token: false, /// INTERNAL USE ONLY
        conditionStack: [], /// INTERNAL USE ONLY; managed via `pushState()`, `popState()`, `topState()` and `stateStackSize()`
        match: '', /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks input which has been matched so far for the lexer token under construction. `match` is identical to `yytext` except that this one still contains the matched input string after `lexer.performAction()` has been invoked, where userland code MAY have changed/replaced the `yytext` value entirely!
        matched: '', /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks entire input which has been matched so far
        matches: false, /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks RE match result for last (successful) match attempt
        yytext: '', /// ADVANCED USE ONLY: tracks input which has been matched so far for the lexer token under construction; this value is transferred to the parser as the 'token value' when the parser consumes the lexer token produced through a call to the `lex()` API.
        offset: 0, /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks the 'cursor position' in the input string, i.e. the number of characters matched so far
        yyleng: 0, /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: length of matched input for the token under construction (`yytext`)
        yylineno: 0, /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: 'line number' at which the token under construction is located
        yylloc: null, /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks location info (lines + columns) for the token under construction

        /**
         * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
         *
         * @public
         * @this {RegExpLexer}
         */
        constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
          msg = '' + msg;

          // heuristic to determine if the error message already contains a (partial) source code dump
          // as produced by either `showPosition()` or `prettyPrintRange()`:
          if (show_input_position == undefined) {
            show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
          }

          if (this.yylloc && show_input_position) {
            if (typeof this.prettyPrintRange === 'function') {
              this.prettyPrintRange(this.yylloc);

              if (!/\n\s*$/.test(msg)) {
                msg += '\n';
              }

              msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
            } else if (typeof this.showPosition === 'function') {
              var pos_str = this.showPosition();

              if (pos_str) {
                if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') {
                  msg += '\n' + pos_str;
                } else {
                  msg += pos_str;
                }
              }
            }
          }

          /** @constructor */
          var pei = {
            errStr: msg,
            recoverable: !!recoverable,
            text: this.match, // This one MAY be empty; userland code should use the `upcomingInput` API to obtain more text which follows the 'lexer cursor position'...
            token: null,
            line: this.yylineno,
            loc: this.yylloc,
            yy: this.yy,
            lexer: this,

            /**
             * and make sure the error info doesn't stay due to potential
             * ref cycle via userland code manipulations.
             * These would otherwise all be memory leak opportunities!
             *
             * Note that only array and object references are nuked as those
             * constitute the set of elements which can produce a cyclic ref.
             * The rest of the members is kept intact as they are harmless.
             *
             * @public
             * @this {LexErrorInfo}
             */
            destroy: function destructLexErrorInfo() {
              // remove cyclic references added to error info:
              // info.yy = null;
              // info.lexer = null;
              // ...
              var rec = !!this.recoverable;

              for (var key in this) {
                if (this.hasOwnProperty(key) && typeof key === 'object') {
                  this[key] = undefined;
                }
              }

              this.recoverable = rec;
            },
          };

          // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
          this.__error_infos.push(pei);

          return pei;
        },

        /**
         * handler which is invoked when a lexer error occurs.
         *
         * @public
         * @this {RegExpLexer}
         */
        parseError: function lexer_parseError(str, hash, ExceptionClass) {
          if (!ExceptionClass) {
            ExceptionClass = this.JisonLexerError;
          }

          if (this.yy) {
            if (this.yy.parser && typeof this.yy.parser.parseError === 'function') {
              return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
            } else if (typeof this.yy.parseError === 'function') {
              return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
            }
          }

          throw new ExceptionClass(str, hash);
        },

        /**
         * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
         *
         * @public
         * @this {RegExpLexer}
         */
        yyerror: function yyError(str /*, ...args */) {
          var lineno_msg = '';

          if (this.yylloc) {
            lineno_msg = ' on line ' + (this.yylineno + 1);
          }

          var p = this.constructLexErrorInfo(
            'Lexical error' + lineno_msg + ': ' + str,
            this.options.lexerErrorsAreRecoverable,
          );

          // Add any extra args to the hash under the name `extra_error_attributes`:
          var args = Array.prototype.slice.call(arguments, 1);

          if (args.length) {
            p.extra_error_attributes = args;
          }

          return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
        },

        /**
         * final cleanup function for when we have completed lexing the input;
         * make it an API so that external code can use this one once userland
         * code has decided it's time to destroy any lingering lexer error
         * hash object instances and the like: this function helps to clean
         * up these constructs, which *may* carry cyclic references which would
         * otherwise prevent the instances from being properly and timely
         * garbage-collected, i.e. this function helps prevent memory leaks!
         *
         * @public
         * @this {RegExpLexer}
         */
        cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
          // prevent lingering circular references from causing memory leaks:
          this.setInput('', {});

          // nuke the error hash info instances created during this run.
          // Userland code must COPY any data/references
          // in the error hash instance(s) it is more permanently interested in.
          if (!do_not_nuke_errorinfos) {
            for (var i = this.__error_infos.length - 1; i >= 0; i--) {
              var el = this.__error_infos[i];

              if (el && typeof el.destroy === 'function') {
                el.destroy();
              }
            }

            this.__error_infos.length = 0;
          }

          return this;
        },

        /**
         * clear the lexer token context; intended for internal use only
         *
         * @public
         * @this {RegExpLexer}
         */
        clear: function lexer_clear() {
          this.yytext = '';
          this.yyleng = 0;
          this.match = '';

          // - DO NOT reset `this.matched`
          this.matches = false;

          this._more = false;
          this._backtrack = false;
          var col = this.yylloc ? this.yylloc.last_column : 0;

          this.yylloc = {
            first_line: this.yylineno + 1,
            first_column: col,
            last_line: this.yylineno + 1,
            last_column: col,
            range: [this.offset, this.offset],
          };
        },

        /**
         * resets the lexer, sets new input
         *
         * @public
         * @this {RegExpLexer}
         */
        setInput: function lexer_setInput(input, yy) {
          this.yy = yy || this.yy || {};

          // also check if we've fully initialized the lexer instance,
          // including expansion work to be done to go from a loaded
          // lexer to a usable lexer:
          if (!this.__decompressed) {
            // step 1: decompress the regex list:
            var rules = this.rules;

            for (var i = 0, len = rules.length; i < len; i++) {
              var rule_re = rules[i];

              // compression: is the RE an xref to another RE slot in the rules[] table?
              if (typeof rule_re === 'number') {
                rules[i] = rules[rule_re];
              }
            }

            // step 2: unfold the conditions[] set to make these ready for use:
            var conditions = this.conditions;

            for (var k in conditions) {
              var spec = conditions[k];
              var rule_ids = spec.rules;
              var len = rule_ids.length;
              var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple!
              var rule_new_ids = new Array(len + 1);

              for (var i = 0; i < len; i++) {
                var idx = rule_ids[i];
                var rule_re = rules[idx];
                rule_regexes[i + 1] = rule_re;
                rule_new_ids[i + 1] = idx;
              }

              spec.rules = rule_new_ids;
              spec.__rule_regexes = rule_regexes;
              spec.__rule_count = len;
            }

            this.__decompressed = true;
          }

          this._input = input || '';
          this.clear();
          this._signaled_error_token = false;
          this.done = false;
          this.yylineno = 0;
          this.matched = '';
          this.conditionStack = ['INITIAL'];
          this.__currentRuleSet__ = null;

          this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0,
            range: [0, 0],
          };

          this.offset = 0;
          return this;
        },

        /**
         * edit the remaining input via user-specified callback.
         * This can be used to forward-adjust the input-to-parse,
         * e.g. inserting macro expansions and alike in the
         * input which has yet to be lexed.
         * The behaviour of this API contrasts the `unput()` et al
         * APIs as those act on the *consumed* input, while this
         * one allows one to manipulate the future, without impacting
         * the current `yyloc` cursor location or any history.
         *
         * Use this API to help implement C-preprocessor-like
         * `#include` statements, etc.
         *
         * The provided callback must be synchronous and is
         * expected to return the edited input (string).
         *
         * The `cpsArg` argument value is passed to the callback
         * as-is.
         *
         * `callback` interface:
         * `function callback(input, cpsArg)`
         *
         * - `input` will carry the remaining-input-to-lex string
         *   from the lexer.
         * - `cpsArg` is `cpsArg` passed into this API.
         *
         * The `this` reference for the callback will be set to
         * reference this lexer instance so that userland code
         * in the callback can easily and quickly access any lexer
         * API.
         *
         * When the callback returns a non-string-type falsey value,
         * we assume the callback did not edit the input and we
         * will using the input as-is.
         *
         * When the callback returns a non-string-type value, it
         * is converted to a string for lexing via the `"" + retval`
         * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html
         * -- that way any returned object's `toValue()` and `toString()`
         * methods will be invoked in a proper/desirable order.)
         *
         * @public
         * @this {RegExpLexer}
         */
        editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
          var rv = callback.call(this, this._input, cpsArg);

          if (typeof rv !== 'string') {
            if (rv) {
              this._input = '' + rv;
            }
            // else: keep `this._input` as is.
          } else {
            this._input = rv;
          }

          return this;
        },

        /**
         * consumes and returns one char from the input
         *
         * @public
         * @this {RegExpLexer}
         */
        input: function lexer_input() {
          if (!this._input) {
            //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
            return null;
          }

          var ch = this._input[0];
          this.yytext += ch;
          this.yyleng++;
          this.offset++;
          this.match += ch;
          this.matched += ch;

          // Count the linenumber up when we hit the LF (or a stand-alone CR).
          // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
          // and we advance immediately past the LF as well, returning both together as if
          // it was all a single 'character' only.
          var slice_len = 1;

          var lines = false;

          if (ch === '\n') {
            lines = true;
          } else if (ch === '\r') {
            lines = true;
            var ch2 = this._input[1];

            if (ch2 === '\n') {
              slice_len++;
              ch += ch2;
              this.yytext += ch2;
              this.yyleng++;
              this.offset++;
              this.match += ch2;
              this.matched += ch2;
              this.yylloc.range[1]++;
            }
          }

          if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
            this.yylloc.last_column = 0;
          } else {
            this.yylloc.last_column++;
          }

          this.yylloc.range[1]++;
          this._input = this._input.slice(slice_len);
          return ch;
        },

        /**
         * unshifts one char (or an entire string) into the input
         *
         * @public
         * @this {RegExpLexer}
         */
        unput: function lexer_unput(ch) {
          var len = ch.length;
          var lines = ch.split(/(?:\r\n?|\n)/g);
          this._input = ch + this._input;
          this.yytext = this.yytext.substr(0, this.yytext.length - len);
          this.yyleng = this.yytext.length;
          this.offset -= len;
          this.match = this.match.substr(0, this.match.length - len);
          this.matched = this.matched.substr(0, this.matched.length - len);

          if (lines.length > 1) {
            this.yylineno -= lines.length - 1;
            this.yylloc.last_line = this.yylineno + 1;

            // Get last entirely matched line into the `pre_lines[]` array's
            // last index slot; we don't mind when other previously
            // matched lines end up in the array too.
            var pre = this.match;

            var pre_lines = pre.split(/(?:\r\n?|\n)/g);

            if (pre_lines.length === 1) {
              pre = this.matched;
              pre_lines = pre.split(/(?:\r\n?|\n)/g);
            }

            this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
          } else {
            this.yylloc.last_column -= len;
          }

          this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
          this.done = false;
          return this;
        },

        /**
         * cache matched text and append it on next action
         *
         * @public
         * @this {RegExpLexer}
         */
        more: function lexer_more() {
          this._more = true;
          return this;
        },

        /**
         * signal the lexer that this rule fails to match the input, so the
         * next matching rule (regex) should be tested instead.
         *
         * @public
         * @this {RegExpLexer}
         */
        reject: function lexer_reject() {
          if (this.options.backtrack_lexer) {
            this._backtrack = true;
          } else {
            // when the `parseError()` call returns, we MUST ensure that the error is registered.
            // We accomplish this by signaling an 'error' token to be produced for the current
            // `.lex()` run.
            var lineno_msg = '';

            if (this.yylloc) {
              lineno_msg = ' on line ' + (this.yylineno + 1);
            }

            var p = this.constructLexErrorInfo(
              'Lexical error' +
                lineno_msg +
                ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).',
              false,
            );

            this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
          }

          return this;
        },

        /**
         * retain first n characters of the match
         *
         * @public
         * @this {RegExpLexer}
         */
        less: function lexer_less(n) {
          return this.unput(this.match.slice(n));
        },

        /**
         * return (part of the) already matched input, i.e. for error
         * messages.
         *
         * Limit the returned string length to `maxSize` (default: 20).
         *
         * Limit the returned string to the `maxLines` number of lines of
         * input (default: 1).
         *
         * Negative limit values equal *unlimited*.
         *
         * @public
         * @this {RegExpLexer}
         */
        pastInput: function lexer_pastInput(maxSize, maxLines) {
          var past = this.matched.substring(0, this.matched.length - this.match.length);

          if (maxSize < 0) maxSize = past.length;
          else if (!maxSize) maxSize = 20;

          if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this!
          else if (!maxLines) maxLines = 1;

          // `substr` anticipation: treat \r\n as a single character and take a little
          // more than necessary so that we can still properly check against maxSize
          // after we've transformed and limited the newLines in here:
          past = past.substr(-maxSize * 2 - 2);

          // now that we have a significantly reduced string to process, transform the newlines
          // and chop them, then limit them:
          var a = past.replace(/\r\n|\r/g, '\n').split('\n');

          a = a.slice(-maxLines);
          past = a.join('\n');

          // When, after limiting to maxLines, we still have too much to return,
          // do add an ellipsis prefix...
          if (past.length > maxSize) {
            past = '...' + past.substr(-maxSize);
          }

          return past;
        },

        /**
         * return (part of the) upcoming input, i.e. for error messages.
         *
         * Limit the returned string length to `maxSize` (default: 20).
         *
         * Limit the returned string to the `maxLines` number of lines of input (default: 1).
         *
         * Negative limit values equal *unlimited*.
         *
         * > ### NOTE ###
         * >
         * > *"upcoming input"* is defined as the whole of the both
         * > the *currently lexed* input, together with any remaining input
         * > following that. *"currently lexed"* input is the input
         * > already recognized by the lexer but not yet returned with
         * > the lexer token. This happens when you are invoking this API
         * > from inside any lexer rule action code block.
         * >
         *
         * @public
         * @this {RegExpLexer}
         */
        upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
          var next = this.match;

          if (maxSize < 0) maxSize = next.length + this._input.length;
          else if (!maxSize) maxSize = 20;

          if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this!
          else if (!maxLines) maxLines = 1;

          // `substring` anticipation: treat \r\n as a single character and take a little
          // more than necessary so that we can still properly check against maxSize
          // after we've transformed and limited the newLines in here:
          if (next.length < maxSize * 2 + 2) {
            next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8
          }

          // now that we have a significantly reduced string to process, transform the newlines
          // and chop them, then limit them:
          var a = next.replace(/\r\n|\r/g, '\n').split('\n');

          a = a.slice(0, maxLines);
          next = a.join('\n');

          // When, after limiting to maxLines, we still have too much to return,
          // do add an ellipsis postfix...
          if (next.length > maxSize) {
            next = next.substring(0, maxSize) + '...';
          }

          return next;
        },

        /**
         * return a string which displays the character position where the
         * lexing error occurred, i.e. for error messages
         *
         * @public
         * @this {RegExpLexer}
         */
        showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
          var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
          var c = new Array(pre.length + 1).join('-');
          return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
        },

        /**
         * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
         * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
         * it MAY be NULL) and you MUST have a valid location info object anyway:
         * then we take the given context of the `preceding` and `following` locations, IFF those are available,
         * and reconstruct the `actual` location info from those.
         * If this fails, the heuristic is to take the `current` location, IFF available.
         * If this fails as well, we assume the sought location is at/around the current lexer position
         * and then produce that one as a response. DO NOTE that these heuristic/derived location info
         * values MAY be inaccurate!
         *
         * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
         * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
         *
         * @public
         * @this {RegExpLexer}
         */
        deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
          var loc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0,
            range: [0, 0],
          };

          if (actual) {
            loc.first_line = actual.first_line | 0;
            loc.last_line = actual.last_line | 0;
            loc.first_column = actual.first_column | 0;
            loc.last_column = actual.last_column | 0;

            if (actual.range) {
              loc.range[0] = actual.range[0] | 0;
              loc.range[1] = actual.range[1] | 0;
            }
          }

          if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
            // plan B: heuristic using preceding and following:
            if (loc.first_line <= 0 && preceding) {
              loc.first_line = preceding.last_line | 0;
              loc.first_column = preceding.last_column | 0;

              if (preceding.range) {
                loc.range[0] = actual.range[1] | 0;
              }
            }

            if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
              loc.last_line = following.first_line | 0;
              loc.last_column = following.first_column | 0;

              if (following.range) {
                loc.range[1] = actual.range[0] | 0;
              }
            }

            // plan C?: see if the 'current' location is useful/sane too:
            if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
              loc.first_line = current.first_line | 0;
              loc.first_column = current.first_column | 0;

              if (current.range) {
                loc.range[0] = current.range[0] | 0;
              }
            }

            if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
              loc.last_line = current.last_line | 0;
              loc.last_column = current.last_column | 0;

              if (current.range) {
                loc.range[1] = current.range[1] | 0;
              }
            }
          }

          // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
          // or plan D heuristics to produce a 'sensible' last_line value:
          if (loc.last_line <= 0) {
            if (loc.first_line <= 0) {
              loc.first_line = this.yylloc.first_line;
              loc.last_line = this.yylloc.last_line;
              loc.first_column = this.yylloc.first_column;
              loc.last_column = this.yylloc.last_column;
              loc.range[0] = this.yylloc.range[0];
              loc.range[1] = this.yylloc.range[1];
            } else {
              loc.last_line = this.yylloc.last_line;
              loc.last_column = this.yylloc.last_column;
              loc.range[1] = this.yylloc.range[1];
            }
          }

          if (loc.first_line <= 0) {
            loc.first_line = loc.last_line;
            loc.first_column = 0; // loc.last_column;
            loc.range[1] = loc.range[0];
          }

          if (loc.first_column < 0) {
            loc.first_column = 0;
          }

          if (loc.last_column < 0) {
            loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
          }

          return loc;
        },

        /**
         * return a string which displays the lines & columns of input which are referenced
         * by the given location info range, plus a few lines of context.
         *
         * This function pretty-prints the indicated section of the input, with line numbers
         * and everything!
         *
         * This function is very useful to provide highly readable error reports, while
         * the location range may be specified in various flexible ways:
         *
         * - `loc` is the location info object which references the area which should be
         *   displayed and 'marked up': these lines & columns of text are marked up by `^`
         *   characters below each character in the entire input range.
         *
         * - `context_loc` is the *optional* location info object which instructs this
         *   pretty-printer how much *leading* context should be displayed alongside
         *   the area referenced by `loc`. This can help provide context for the displayed
         *   error, etc.
         *
         *   When this location info is not provided, a default context of 3 lines is
         *   used.
         *
         * - `context_loc2` is another *optional* location info object, which serves
         *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
         *   context lines to display in the pretty-print output.
         *
         *   When this location info is not provided, a default context of 1 line only is
         *   used.
         *
         * Special Notes:
         *
         * - when the `loc`-indicated range is very large (about 5 lines or more), then
         *   only the first and last few lines of this block are printed while a
         *   `...continued...` message will be printed between them.
         *
         *   This serves the purpose of not printing a huge amount of text when the `loc`
         *   range happens to be huge: this way a manageable & readable output results
         *   for arbitrary large ranges.
         *
         * - this function can display lines of input which whave not yet been lexed.
         *   `prettyPrintRange()` can access the entire input!
         *
         * @public
         * @this {RegExpLexer}
         */
        prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
          loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
          const CONTEXT = 3;
          const CONTEXT_TAIL = 1;
          const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
          var input = this.matched + this._input;
          var lines = input.split('\n');
          var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
          var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
          var lineno_display_width = (1 + Math.log10(l1 | 1)) | 0;
          var ws_prefix = new Array(lineno_display_width).join(' ');
          var nonempty_line_indexes = [];

          var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
            var lno = index + l0;
            var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
            var rv = lno_pfx + ': ' + line;
            var errpfx = new Array(lineno_display_width + 1).join('^');
            var offset = 2 + 1;
            var len = 0;

            if (lno === loc.first_line) {
              offset += loc.first_column;

              len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
            } else if (lno === loc.last_line) {
              len = Math.max(2, loc.last_column + 1);
            } else if (lno > loc.first_line && lno < loc.last_line) {
              len = Math.max(2, line.length + 1);
            }

            if (len) {
              var lead = new Array(offset).join('.');
              var mark = new Array(len).join('^');
              rv += '\n' + errpfx + lead + mark;

              if (line.trim().length > 0) {
                nonempty_line_indexes.push(index);
              }
            }

            rv = rv.replace(/\t/g, ' ');
            return rv;
          });

          // now make sure we don't print an overly large amount of error area: limit it
          // to the top and bottom line count:
          if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
            var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
            var clip_end =
              nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
            var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
            intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
            rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
          }

          return rv.join('\n');
        },

        /**
         * helper function, used to produce a human readable description as a string, given
         * the input `yylloc` location object.
         *
         * Set `display_range_too` to TRUE to include the string character index position(s)
         * in the description if the `yylloc.range` is available.
         *
         * @public
         * @this {RegExpLexer}
         */
        describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
          var l1 = yylloc.first_line;
          var l2 = yylloc.last_line;
          var c1 = yylloc.first_column;
          var c2 = yylloc.last_column;
          var dl = l2 - l1;
          var dc = c2 - c1;
          var rv;

          if (dl === 0) {
            rv = 'line ' + l1 + ', ';

            if (dc <= 1) {
              rv += 'column ' + c1;
            } else {
              rv += 'columns ' + c1 + ' .. ' + c2;
            }
          } else {
            rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
          }

          if (yylloc.range && display_range_too) {
            var r1 = yylloc.range[0];
            var r2 = yylloc.range[1] - 1;

            if (r2 <= r1) {
              rv += ' {String Offset: ' + r1 + '}';
            } else {
              rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
            }
          }

          return rv;
        },

        /**
         * test the lexed token: return FALSE when not a match, otherwise return token.
         *
         * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
         * contains the actually matched text string.
         *
         * Also move the input cursor forward and update the match collectors:
         *
         * - `yytext`
         * - `yyleng`
         * - `match`
         * - `matches`
         * - `yylloc`
         * - `offset`
         *
         * @public
         * @this {RegExpLexer}
         */
        test_match: function lexer_test_match(match, indexed_rule) {
          var token, lines, backup, match_str, match_str_len;

          if (this.options.backtrack_lexer) {
            // save context
            backup = {
              yylineno: this.yylineno,

              yylloc: {
                first_line: this.yylloc.first_line,
                last_line: this.yylloc.last_line,
                first_column: this.yylloc.first_column,
                last_column: this.yylloc.last_column,
                range: this.yylloc.range.slice(0),
              },

              yytext: this.yytext,
              match: this.match,
              matches: this.matches,
              matched: this.matched,
              yyleng: this.yyleng,
              offset: this.offset,
              _more: this._more,
              _input: this._input,

              //_signaled_error_token: this._signaled_error_token,
              yy: this.yy,

              conditionStack: this.conditionStack.slice(0),
              done: this.done,
            };
          }

          match_str = match[0];
          match_str_len = match_str.length;

          // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
          lines = match_str.split(/(?:\r\n?|\n)/g);

          if (lines.length > 1) {
            this.yylineno += lines.length - 1;
            this.yylloc.last_line = this.yylineno + 1;
            this.yylloc.last_column = lines[lines.length - 1].length;
          } else {
            this.yylloc.last_column += match_str_len;
          }

          // }
          this.yytext += match_str;

          this.match += match_str;
          this.matched += match_str;
          this.matches = match;
          this.yyleng = this.yytext.length;
          this.yylloc.range[1] += match_str_len;

          // previous lex rules MAY have invoked the `more()` API rather than producing a token:
          // those rules will already have moved this `offset` forward matching their match lengths,
          // hence we must only add our own match length now:
          this.offset += match_str_len;

          this._more = false;
          this._backtrack = false;
          this._input = this._input.slice(match_str_len);

          // calling this method:
          //
          //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
          token = this.performAction.call(
            this,
            this.yy,
            indexed_rule,
            this.conditionStack[this.conditionStack.length - 1] /* = YY_START */,
          );

          // otherwise, when the action codes are all simple return token statements:
          //token = this.simpleCaseActionClusters[indexed_rule];

          if (this.done && this._input) {
            this.done = false;
          }

          if (token) {
            return token;
          } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
              this[k] = backup[k];
            }

            this.__currentRuleSet__ = null;
            return false; // rule action called reject() implying the next rule should be tested instead.
          } else if (this._signaled_error_token) {
            // produce one 'error' token as `.parseError()` in `reject()`
            // did not guarantee a failure signal by throwing an exception!
            token = this._signaled_error_token;

            this._signaled_error_token = false;
            return token;
          }

          return false;
        },

        /**
         * return next match in input
         *
         * @public
         * @this {RegExpLexer}
         */
        next: function lexer_next() {
          if (this.done) {
            this.clear();
            return this.EOF;
          }

          if (!this._input) {
            this.done = true;
          }

          var token, match, tempMatch, index;

          if (!this._more) {
            this.clear();
          }

          var spec = this.__currentRuleSet__;

          if (!spec) {
            // Update the ruleset cache as we apparently encountered a state change or just started lexing.
            // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
            // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
            // speed up those activities a tiny bit.
            spec = this.__currentRuleSet__ = this._currentRules();

            // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
            // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
            if (!spec || !spec.rules) {
              var lineno_msg = '';

              if (this.options.trackPosition) {
                lineno_msg = ' on line ' + (this.yylineno + 1);
              }

              var p = this.constructLexErrorInfo(
                'Internal lexer engine error' +
                  lineno_msg +
                  ': The lex grammar programmer pushed a non-existing condition name "' +
                  this.topState() +
                  '"; this is a fatal error and should be reported to the application programmer team!',
                false,
              );

              // produce one 'error' token until this situation has been resolved, most probably by parse termination!
              return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
            }
          }

          var rule_ids = spec.rules;
          var regexes = spec.__rule_regexes;
          var len = spec.__rule_count;

          // Note: the arrays are 1-based, while `len` itself is a valid index,
          // hence the non-standard less-or-equal check in the next loop condition!
          for (var i = 1; i <= len; i++) {
            tempMatch = this._input.match(regexes[i]);

            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
              match = tempMatch;
              index = i;

              if (this.options.backtrack_lexer) {
                token = this.test_match(tempMatch, rule_ids[i]);

                if (token !== false) {
                  return token;
                } else if (this._backtrack) {
                  match = undefined;
                  continue; // rule action called reject() implying a rule MISmatch.
                } else {
                  // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                  return false;
                }
              } else if (!this.options.flex) {
                break;
              }
            }
          }

          if (match) {
            token = this.test_match(match, rule_ids[index]);

            if (token !== false) {
              return token;
            }

            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
          }

          if (!this._input) {
            this.done = true;
            this.clear();
            return this.EOF;
          } else {
            var lineno_msg = '';

            if (this.options.trackPosition) {
              lineno_msg = ' on line ' + (this.yylineno + 1);
            }

            var p = this.constructLexErrorInfo(
              'Lexical error' + lineno_msg + ': Unrecognized text.',
              this.options.lexerErrorsAreRecoverable,
            );

            var pendingInput = this._input;
            var activeCondition = this.topState();
            var conditionStackDepth = this.conditionStack.length;
            token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;

            if (token === this.ERROR) {
              // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
              // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
              // has not consumed/modified any pending input or changed state in the error handler:
              if (
                !this.matches && // and make sure the input has been modified/consumed ...
                pendingInput === this._input && // ...or the lexer state has been modified significantly enough
                // to merit a non-consuming error handling action right now.
                activeCondition === this.topState() &&
                conditionStackDepth === this.conditionStack.length
              ) {
                this.input();
              }
            }

            return token;
          }
        },

        /**
         * return next match that has a token
         *
         * @public
         * @this {RegExpLexer}
         */
        lex: function lexer_lex() {
          var r;

          // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
          if (typeof this.pre_lex === 'function') {
            r = this.pre_lex.call(this, 0);
          }

          if (typeof this.options.pre_lex === 'function') {
            // (also account for a userdef function which does not return any value: keep the token as is)
            r = this.options.pre_lex.call(this, r) || r;
          }

          if (this.yy && typeof this.yy.pre_lex === 'function') {
            // (also account for a userdef function which does not return any value: keep the token as is)
            r = this.yy.pre_lex.call(this, r) || r;
          }

          while (!r) {
            r = this.next();
          }

          if (this.yy && typeof this.yy.post_lex === 'function') {
            // (also account for a userdef function which does not return any value: keep the token as is)
            r = this.yy.post_lex.call(this, r) || r;
          }

          if (typeof this.options.post_lex === 'function') {
            // (also account for a userdef function which does not return any value: keep the token as is)
            r = this.options.post_lex.call(this, r) || r;
          }

          if (typeof this.post_lex === 'function') {
            // (also account for a userdef function which does not return any value: keep the token as is)
            r = this.post_lex.call(this, r) || r;
          }

          return r;
        },

        /**
         * return next match that has a token. Identical to the `lex()` API but does not invoke any of the
         * `pre_lex()` nor any of the `post_lex()` callbacks.
         *
         * @public
         * @this {RegExpLexer}
         */
        fastLex: function lexer_fastLex() {
          var r;

          while (!r) {
            r = this.next();
          }

          return r;
        },

        /**
         * return info about the lexer state that can help a parser or other lexer API user to use the
         * most efficient means available. This API is provided to aid run-time performance for larger
         * systems which employ this lexer.
         *
         * @public
         * @this {RegExpLexer}
         */
        canIUse: function lexer_canIUse() {
          var rv = {
            fastLex:
              !(
                typeof this.pre_lex === 'function' ||
                typeof this.options.pre_lex === 'function' ||
                (this.yy && typeof this.yy.pre_lex === 'function') ||
                (this.yy && typeof this.yy.post_lex === 'function') ||
                typeof this.options.post_lex === 'function' ||
                typeof this.post_lex === 'function'
              ) && typeof this.fastLex === 'function',
          };

          return rv;
        },

        /**
         * backwards compatible alias for `pushState()`;
         * the latter is symmetrical with `popState()` and we advise to use
         * those APIs in any modern lexer code, rather than `begin()`.
         *
         * @public
         * @this {RegExpLexer}
         */
        begin: function lexer_begin(condition) {
          return this.pushState(condition);
        },

        /**
         * activates a new lexer condition state (pushes the new lexer
         * condition state onto the condition stack)
         *
         * @public
         * @this {RegExpLexer}
         */
        pushState: function lexer_pushState(condition) {
          this.conditionStack.push(condition);
          this.__currentRuleSet__ = null;
          return this;
        },

        /**
         * pop the previously active lexer condition state off the condition
         * stack
         *
         * @public
         * @this {RegExpLexer}
         */
        popState: function lexer_popState() {
          var n = this.conditionStack.length - 1;

          if (n > 0) {
            this.__currentRuleSet__ = null;
            return this.conditionStack.pop();
          } else {
            return this.conditionStack[0];
          }
        },

        /**
         * return the currently active lexer condition state; when an index
         * argument is provided it produces the N-th previous condition state,
         * if available
         *
         * @public
         * @this {RegExpLexer}
         */
        topState: function lexer_topState(n) {
          n = this.conditionStack.length - 1 - Math.abs(n || 0);

          if (n >= 0) {
            return this.conditionStack[n];
          } else {
            return 'INITIAL';
          }
        },

        /**
         * (internal) determine the lexer rule set which is active for the
         * currently active lexer condition state
         *
         * @public
         * @this {RegExpLexer}
         */
        _currentRules: function lexer__currentRules() {
          if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
          } else {
            return this.conditions['INITIAL'];
          }
        },

        /**
         * return the number of states currently on the stack
         *
         * @public
         * @this {RegExpLexer}
         */
        stateStackSize: function lexer_stateStackSize() {
          return this.conditionStack.length;
        },

        options: {
          trackPosition: true,
        },

        JisonLexerError: JisonLexerError,

        performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
          switch (yyrulenumber) {
            case 1:
              /*! Conditions:: INITIAL */
              /*! Rule::       \s+ */
              /* skip whitespace */
              break;

            default:
              return this.simpleCaseActionClusters[yyrulenumber];
          }
        },

        simpleCaseActionClusters: {
          /*! Conditions:: INITIAL */
          /*! Rule::       (--[0-9a-z-A-Z-]*) */
          0: 13,

          /*! Conditions:: INITIAL */
          /*! Rule::       \* */
          2: 5,

          /*! Conditions:: INITIAL */
          /*! Rule::       \/ */
          3: 6,

          /*! Conditions:: INITIAL */
          /*! Rule::       \+ */
          4: 3,

          /*! Conditions:: INITIAL */
          /*! Rule::       - */
          5: 4,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */
          6: 15,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */
          7: 15,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */
          8: 15,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */
          9: 15,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */
          10: 15,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */
          11: 15,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */
          12: 16,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */
          13: 16,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */
          14: 16,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */
          15: 16,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */
          16: 17,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */
          17: 17,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */
          18: 18,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */
          19: 18,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */
          20: 19,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */
          21: 19,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */
          22: 19,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */
          23: 20,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */
          24: 21,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */
          25: 22,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */
          26: 23,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */
          27: 25,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */
          28: 24,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */
          29: 26,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */
          30: 27,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */
          31: 28,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */
          32: 11,

          /*! Conditions:: INITIAL */
          /*! Rule::       (calc) */
          33: 9,

          /*! Conditions:: INITIAL */
          /*! Rule::       (var) */
          34: 12,

          /*! Conditions:: INITIAL */
          /*! Rule::       ([a-z]+) */
          35: 10,

          /*! Conditions:: INITIAL */
          /*! Rule::       \( */
          36: 7,

          /*! Conditions:: INITIAL */
          /*! Rule::       \) */
          37: 8,

          /*! Conditions:: INITIAL */
          /*! Rule::       , */
          38: 14,

          /*! Conditions:: INITIAL */
          /*! Rule::       $ */
          39: 1,
        },

        rules: [
          /*  0: */ /^(?:(--[\d\-A-Za-z]*))/,
          /*  1: */ /^(?:\s+)/,
          /*  2: */ /^(?:\*)/,
          /*  3: */ /^(?:\/)/,
          /*  4: */ /^(?:\+)/,
          /*  5: */ /^(?:-)/,
          /*  6: */ /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
          /*  7: */ /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
          /*  8: */ /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
          /*  9: */ /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
          /* 10: */ /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
          /* 11: */ /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
          /* 12: */ /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
          /* 13: */ /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
          /* 14: */ /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
          /* 15: */ /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
          /* 16: */ /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
          /* 17: */ /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
          /* 18: */ /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
          /* 19: */ /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
          /* 20: */ /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
          /* 21: */ /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
          /* 22: */ /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
          /* 23: */ /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
          /* 24: */ /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
          /* 25: */ /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
          /* 26: */ /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
          /* 27: */ /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
          /* 28: */ /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
          /* 29: */ /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
          /* 30: */ /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
          /* 31: */ /^(?:(\d+(\.\d*)?|\.\d+)%)/,
          /* 32: */ /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
          /* 33: */ /^(?:(calc))/,
          /* 34: */ /^(?:(var))/,
          /* 35: */ /^(?:([a-z]+))/,
          /* 36: */ /^(?:\()/,
          /* 37: */ /^(?:\))/,
          /* 38: */ /^(?:,)/,
          /* 39: */ /^(?:$)/,
        ],

        conditions: {
          INITIAL: {
            rules: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28,
              29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
            ],

            inclusive: true,
          },
        },
      };

      return lexer;
    })();
    parser.lexer = lexer;

    function Parser() {
      this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;

    return new Parser();
  })();

  if (typeof commonjsRequire !== 'undefined' && 'object' !== 'undefined') {
    exports.parser = parser;
    exports.Parser = parser.Parser;
    exports.parse = function () {
      return parser.parse.apply(parser, arguments);
    };
  }
})(parser);

var reducer$1 = {};

var convert = { exports: {} };

var conversions = {
  // length
  px: {
    px: 1,
    cm: 96.0 / 2.54,
    mm: 96.0 / 25.4,
    in: 96,
    pt: 96.0 / 72.0,
    pc: 16,
  },
  cm: {
    px: 2.54 / 96.0,
    cm: 1,
    mm: 0.1,
    in: 2.54,
    pt: 2.54 / 72.0,
    pc: 2.54 / 6.0,
  },
  mm: {
    px: 25.4 / 96.0,
    cm: 10,
    mm: 1,
    in: 25.4,
    pt: 25.4 / 72.0,
    pc: 25.4 / 6.0,
  },
  in: {
    px: 1.0 / 96.0,
    cm: 1.0 / 2.54,
    mm: 1.0 / 25.4,
    in: 1,
    pt: 1.0 / 72.0,
    pc: 1.0 / 6.0,
  },
  pt: {
    px: 0.75,
    cm: 72.0 / 2.54,
    mm: 72.0 / 25.4,
    in: 72,
    pt: 1,
    pc: 12,
  },
  pc: {
    px: 6.0 / 96.0,
    cm: 6.0 / 2.54,
    mm: 6.0 / 25.4,
    in: 6,
    pt: 6.0 / 72.0,
    pc: 1,
  },
  // angle
  deg: {
    deg: 1,
    grad: 0.9,
    rad: 180 / Math.PI,
    turn: 360,
  },
  grad: {
    deg: 400 / 360,
    grad: 1,
    rad: 200 / Math.PI,
    turn: 400,
  },
  rad: {
    deg: Math.PI / 180,
    grad: Math.PI / 200,
    rad: 1,
    turn: Math.PI * 2,
  },
  turn: {
    deg: 1 / 360,
    grad: 1 / 400,
    rad: 0.5 / Math.PI,
    turn: 1,
  },
  // time
  s: {
    s: 1,
    ms: 1 / 1000,
  },
  ms: {
    s: 1000,
    ms: 1,
  },
  // frequency
  Hz: {
    Hz: 1,
    kHz: 1000,
  },
  kHz: {
    Hz: 1 / 1000,
    kHz: 1,
  },
  // resolution
  dpi: {
    dpi: 1,
    dpcm: 1.0 / 2.54,
    dppx: 1 / 96,
  },
  dpcm: {
    dpi: 2.54,
    dpcm: 1,
    dppx: 2.54 / 96.0,
  },
  dppx: {
    dpi: 96,
    dpcm: 96.0 / 2.54,
    dppx: 1,
  },
};

var cssUnitConverter = function (value, sourceUnit, targetUnit, precision) {
  if (!conversions.hasOwnProperty(targetUnit)) throw new Error('Cannot convert to ' + targetUnit);

  if (!conversions[targetUnit].hasOwnProperty(sourceUnit))
    throw new Error('Cannot convert from ' + sourceUnit + ' to ' + targetUnit);

  var converted = conversions[targetUnit][sourceUnit] * value;

  if (precision !== false) {
    precision = Math.pow(10, parseInt(precision) || 5);
    return Math.round(converted * precision) / precision;
  }

  return converted;
};

convert.exports;

(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true,
  });

  var _cssUnitConverter = cssUnitConverter;

  var _cssUnitConverter2 = _interopRequireDefault(_cssUnitConverter);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function convertNodes(left, right, precision) {
    switch (left.type) {
      case 'LengthValue':
      case 'AngleValue':
      case 'TimeValue':
      case 'FrequencyValue':
      case 'ResolutionValue':
        return convertAbsoluteLength(left, right, precision);
      default:
        return { left: left, right: right };
    }
  }

  function convertAbsoluteLength(left, right, precision) {
    if (right.type === left.type) {
      right = {
        type: left.type,
        value: (0, _cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
        unit: left.unit,
      };
    }
    return { left: left, right: right };
  }

  exports.default = convertNodes;
  module.exports = exports['default'];
})(convert, convert.exports);

var convertExports = convert.exports;

Object.defineProperty(reducer$1, '__esModule', {
  value: true,
});
reducer$1.flip = flip$1;

var _convert = convertExports;

var _convert2 = _interopRequireDefault(_convert);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function reduce(node, precision) {
  if (node.type === 'MathExpression') return reduceMathExpression(node, precision);
  if (node.type === 'Calc') return reduce(node.value, precision);

  return node;
}

function isEqual$1(left, right) {
  return left.type === right.type && left.value === right.value;
}

function isValueType(type) {
  switch (type) {
    case 'LengthValue':
    case 'AngleValue':
    case 'TimeValue':
    case 'FrequencyValue':
    case 'ResolutionValue':
    case 'EmValue':
    case 'ExValue':
    case 'ChValue':
    case 'RemValue':
    case 'VhValue':
    case 'VwValue':
    case 'VminValue':
    case 'VmaxValue':
    case 'PercentageValue':
    case 'Value':
      return true;
  }
  return false;
}

function convertMathExpression(node, precision) {
  var nodes = (0, _convert2.default)(node.left, node.right, precision);
  var left = reduce(nodes.left, precision);
  var right = reduce(nodes.right, precision);

  if (left.type === 'MathExpression' && right.type === 'MathExpression') {
    if (
      (left.operator === '/' && right.operator === '*') ||
      (left.operator === '-' && right.operator === '+') ||
      (left.operator === '*' && right.operator === '/') ||
      (left.operator === '+' && right.operator === '-')
    ) {
      if (isEqual$1(left.right, right.right)) nodes = (0, _convert2.default)(left.left, right.left, precision);
      else if (isEqual$1(left.right, right.left)) nodes = (0, _convert2.default)(left.left, right.right, precision);

      left = reduce(nodes.left, precision);
      right = reduce(nodes.right, precision);
    }
  }

  node.left = left;
  node.right = right;
  return node;
}

function flip$1(operator) {
  return operator === '+' ? '-' : '+';
}

function flipValue(node) {
  if (isValueType(node.type)) node.value = -node.value;
  else if (node.type == 'MathExpression') {
    node.left = flipValue(node.left);
    node.right = flipValue(node.right);
  }
  return node;
}

function reduceAddSubExpression(node, precision) {
  var _node = node,
    left = _node.left,
    right = _node.right,
    op = _node.operator;

  if (left.type === 'CssVariable' || right.type === 'CssVariable') return node;

  // something + 0 => something
  // something - 0 => something
  if (right.value === 0) return left;

  // 0 + something => something
  if (left.value === 0 && op === '+') return right;

  // 0 - something => -something
  if (left.value === 0 && op === '-') return flipValue(right);

  // value + value
  // value - value
  if (left.type === right.type && isValueType(left.type)) {
    node = Object.assign({}, left);
    if (op === '+') node.value = left.value + right.value;
    else node.value = left.value - right.value;
  }

  // value <op> (expr)
  if (isValueType(left.type) && (right.operator === '+' || right.operator === '-') && right.type === 'MathExpression') {
    // value + (value + something) => (value + value) + something
    // value + (value - something) => (value + value) - something
    // value - (value + something) => (value - value) - something
    // value - (value - something) => (value - value) + something
    if (left.type === right.left.type) {
      node = Object.assign({}, node);
      node.left = reduce(
        {
          type: 'MathExpression',
          operator: op,
          left: left,
          right: right.left,
        },
        precision,
      );
      node.right = right.right;
      node.operator = op === '-' ? flip$1(right.operator) : right.operator;
      return reduce(node, precision);
    }
    // value + (something + value) => (value + value) + something
    // value + (something - value) => (value - value) + something
    // value - (something + value) => (value - value) - something
    // value - (something - value) => (value + value) - something
    else if (left.type === right.right.type) {
      node = Object.assign({}, node);
      node.left = reduce(
        {
          type: 'MathExpression',
          operator: op === '-' ? flip$1(right.operator) : right.operator,
          left: left,
          right: right.right,
        },
        precision,
      );
      node.right = right.left;
      return reduce(node, precision);
    }
  }

  // (expr) <op> value
  if (left.type === 'MathExpression' && (left.operator === '+' || left.operator === '-') && isValueType(right.type)) {
    // (value + something) + value => (value + value) + something
    // (value - something) + value => (value + value) - something
    // (value + something) - value => (value - value) + something
    // (value - something) - value => (value - value) - something
    if (right.type === left.left.type) {
      node = Object.assign({}, left);
      node.left = reduce(
        {
          type: 'MathExpression',
          operator: op,
          left: left.left,
          right: right,
        },
        precision,
      );
      return reduce(node, precision);
    }
    // (something + value) + value => something + (value + value)
    // (something - value1) + value2 => something - (value2 - value1)
    // (something + value) - value => something + (value - value)
    // (something - value) - value => something - (value + value)
    else if (right.type === left.right.type) {
      node = Object.assign({}, left);
      if (left.operator === '-') {
        node.right = reduce(
          {
            type: 'MathExpression',
            operator: op === '-' ? '+' : '-',
            left: right,
            right: left.right,
          },
          precision,
        );
        node.operator = op === '-' ? '-' : '+';
      } else {
        node.right = reduce(
          {
            type: 'MathExpression',
            operator: op,
            left: left.right,
            right: right,
          },
          precision,
        );
      }
      if (node.right.value < 0) {
        node.right.value *= -1;
        node.operator = node.operator === '-' ? '+' : '-';
      }
      return reduce(node, precision);
    }
  }
  return node;
}

function reduceDivisionExpression(node, precision) {
  if (!isValueType(node.right.type)) return node;

  if (node.right.type !== 'Value') throw new Error('Cannot divide by "' + node.right.unit + '", number expected');

  if (node.right.value === 0) throw new Error('Cannot divide by zero');

  // (expr) / value
  if (node.left.type === 'MathExpression') {
    if (isValueType(node.left.left.type) && isValueType(node.left.right.type)) {
      node.left.left.value /= node.right.value;
      node.left.right.value /= node.right.value;
      return reduce(node.left, precision);
    }
    return node;
  }
  // something / value
  else if (isValueType(node.left.type)) {
    node.left.value /= node.right.value;
    return node.left;
  }
  return node;
}

function reduceMultiplicationExpression(node) {
  // (expr) * value
  if (node.left.type === 'MathExpression' && node.right.type === 'Value') {
    if (isValueType(node.left.left.type) && isValueType(node.left.right.type)) {
      node.left.left.value *= node.right.value;
      node.left.right.value *= node.right.value;
      return node.left;
    }
  }
  // something * value
  else if (isValueType(node.left.type) && node.right.type === 'Value') {
    node.left.value *= node.right.value;
    return node.left;
  }
  // value * (expr)
  else if (node.left.type === 'Value' && node.right.type === 'MathExpression') {
    if (isValueType(node.right.left.type) && isValueType(node.right.right.type)) {
      node.right.left.value *= node.left.value;
      node.right.right.value *= node.left.value;
      return node.right;
    }
  }
  // value * something
  else if (node.left.type === 'Value' && isValueType(node.right.type)) {
    node.right.value *= node.left.value;
    return node.right;
  }
  return node;
}

function reduceMathExpression(node, precision) {
  node = convertMathExpression(node, precision);

  switch (node.operator) {
    case '+':
    case '-':
      return reduceAddSubExpression(node, precision);
    case '/':
      return reduceDivisionExpression(node, precision);
    case '*':
      return reduceMultiplicationExpression(node);
  }
  return node;
}

reducer$1.default = reduce;

var stringifier = { exports: {} };

stringifier.exports;

(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true,
  });

  exports.default = function (calc, node, precision) {
    var str = stringify(node, precision);

    if (node.type === 'MathExpression') {
      // if calc expression couldn't be resolved to a single value, re-wrap it as
      // a calc()
      str = calc + '(' + str + ')';
    }
    return str;
  };

  var _reducer = reducer$1;

  var order = {
    '*': 0,
    '/': 0,
    '+': 1,
    '-': 1,
  };

  function round(value, prec) {
    if (prec !== false) {
      var precision = Math.pow(10, prec);
      return Math.round(value * precision) / precision;
    }
    return value;
  }

  function stringify(node, prec) {
    switch (node.type) {
      case 'MathExpression': {
        var left = node.left,
          right = node.right,
          op = node.operator;

        var str = '';

        if (left.type === 'MathExpression' && order[op] < order[left.operator])
          str += '(' + stringify(left, prec) + ')';
        else str += stringify(left, prec);

        str += ' ' + node.operator + ' ';

        if (right.type === 'MathExpression' && order[op] < order[right.operator]) {
          str += '(' + stringify(right, prec) + ')';
        } else if (right.type === 'MathExpression' && op === '-' && ['+', '-'].includes(right.operator)) {
          // fix #52 : a-(b+c) = a-b-c
          right.operator = (0, _reducer.flip)(right.operator);
          str += stringify(right, prec);
        } else {
          str += stringify(right, prec);
        }

        return str;
      }
      case 'Value':
        return round(node.value, prec);
      case 'CssVariable':
        if (node.fallback) {
          return 'var(' + node.value + ', ' + stringify(node.fallback, prec) + ')';
        }
        return 'var(' + node.value + ')';
      case 'Calc':
        if (node.prefix) {
          return '-' + node.prefix + '-calc(' + stringify(node.value, prec) + ')';
        }
        return 'calc(' + stringify(node.value, prec) + ')';
      default:
        return round(node.value, prec) + node.unit;
    }
  }

  module.exports = exports['default'];
})(stringifier, stringifier.exports);

var stringifierExports = stringifier.exports;

dist.exports;

(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true,
  });

  var _postcssValueParser = lib$1;

  var _postcssValueParser2 = _interopRequireDefault(_postcssValueParser);

  var _parser = parser;

  var _reducer = reducer$1;

  var _reducer2 = _interopRequireDefault(_reducer);

  var _stringifier = stringifierExports;

  var _stringifier2 = _interopRequireDefault(_stringifier);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  // eslint-disable-line
  var MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;

  exports.default = function (value) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

    return (0, _postcssValueParser2.default)(value)
      .walk(function (node) {
        // skip anything which isn't a calc() function
        if (node.type !== 'function' || !MATCH_CALC.test(node.value)) return;

        // stringify calc expression and produce an AST
        var contents = _postcssValueParser2.default.stringify(node.nodes);

        // skip constant() and env()
        if (contents.indexOf('constant') >= 0 || contents.indexOf('env') >= 0) return;

        var ast = _parser.parser.parse(contents);

        // reduce AST to its simplest form, that is, either to a single value
        // or a simplified calc expression
        var reducedAst = (0, _reducer2.default)(ast, precision);

        // stringify AST and write it back
        node.type = 'word';
        node.value = (0, _stringifier2.default)(node.value, reducedAst, precision);
      }, true)
      .toString();
  };

  module.exports = exports['default'];
})(dist, dist.exports);

var distExports = dist.exports;
var reduceCSSCalc = /*@__PURE__*/ getDefaultExportFromCjs(distExports);

function _typeof$19(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$19 =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$19(obj)
  );
}
function ownKeys$v(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$v(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$v(Object(source), !0).forEach(function (key) {
          _defineProperty$14(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$v(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$14(obj, key, value) {
  key = _toPropertyKey$A(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$A(arg) {
  var key = _toPrimitive$A(arg, 'string');
  return _typeof$19(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$A(input, hint) {
  if (_typeof$19(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$19(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _toConsumableArray$b(arr) {
  return (
    _arrayWithoutHoles$b(arr) || _iterableToArray$b(arr) || _unsupportedIterableToArray$h(arr) || _nonIterableSpread$b()
  );
}
function _nonIterableSpread$b() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$h(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$h(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$h(o, minLen);
}
function _iterableToArray$b(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$b(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$h(arr);
}
function _arrayLikeToArray$h(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var stringCache = {
  widthCache: {},
  cacheCount: 0,
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
  position: 'absolute',
  top: '-20000px',
  left: 0,
  padding: 0,
  margin: 0,
  border: 'none',
  whiteSpace: 'pre',
};
var STYLE_LIST = [
  'minWidth',
  'maxWidth',
  'width',
  'minHeight',
  'maxHeight',
  'height',
  'top',
  'left',
  'fontSize',
  'lineHeight',
  'padding',
  'margin',
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function autoCompleteStyle(name, value) {
  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
    return ''.concat(value, 'px');
  }
  return value;
}
function camelToMiddleLine(text) {
  var strs = text.split('');
  var formatStrs = strs.reduce(function (result, entry) {
    if (entry === entry.toUpperCase()) {
      return [].concat(_toConsumableArray$b(result), ['-', entry.toLowerCase()]);
    }
    return [].concat(_toConsumableArray$b(result), [entry]);
  }, []);
  return formatStrs.join('');
}
var getStyleString = function getStyleString(style) {
  return Object.keys(style).reduce(function (result, s) {
    return ''.concat(result).concat(camelToMiddleLine(s), ':').concat(autoCompleteStyle(s, style[s]), ';');
  }, '');
};
var getStringSize = function getStringSize(text) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (text === undefined || text === null || Global.isSsr) {
    return {
      width: 0,
      height: 0,
    };
  }
  var str = ''.concat(text);
  var styleString = getStyleString(style);
  var cacheKey = ''.concat(str, '-').concat(styleString);
  if (stringCache.widthCache[cacheKey]) {
    return stringCache.widthCache[cacheKey];
  }
  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
    if (!measurementSpan) {
      measurementSpan = document.createElement('span');
      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
      measurementSpan.setAttribute('aria-hidden', 'true');
      document.body.appendChild(measurementSpan);
    }
    // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
    // https://en.wikipedia.org/wiki/Content_Security_Policy
    var measurementSpanStyle = _objectSpread$v(_objectSpread$v({}, SPAN_STYLE), style);
    Object.keys(measurementSpanStyle).map(function (styleKey) {
      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
      return styleKey;
    });
    measurementSpan.textContent = str;
    var rect = measurementSpan.getBoundingClientRect();
    var result = {
      width: rect.width,
      height: rect.height,
    };
    stringCache.widthCache[cacheKey] = result;
    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
      stringCache.cacheCount = 0;
      stringCache.widthCache = {};
    }
    return result;
  } catch (e) {
    return {
      width: 0,
      height: 0,
    };
  }
};
var getOffset = function getOffset(el) {
  var html = el.ownerDocument.documentElement;
  var box = {
    top: 0,
    left: 0,
  };

  // If we don't have gBCR, just use 0,0 rather than error
  // BlackBerry 5, iOS 3 (original iPhone)
  if (typeof el.getBoundingClientRect !== 'undefined') {
    box = el.getBoundingClientRect();
  }
  return {
    top: box.top + window.pageYOffset - html.clientTop,
    left: box.left + window.pageXOffset - html.clientLeft,
  };
};

/**
 * Calculate coordinate of cursor in chart
 * @param  {Object} event  Event object
 * @param  {Object} offset The offset of main part in the svg element
 * @return {Object}        {chartX, chartY}
 */
var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
  return {
    chartX: Math.round(event.pageX - offset.left),
    chartY: Math.round(event.pageY - offset.top),
  };
};

var _excluded$e = [
  'dx',
  'dy',
  'textAnchor',
  'verticalAnchor',
  'scaleToFit',
  'angle',
  'lineHeight',
  'capHeight',
  'className',
  'breakAll',
];
function _typeof$18(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$18 =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$18(obj)
  );
}
function _extends$v() {
  _extends$v = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$v.apply(this, arguments);
}
function _objectWithoutProperties$e(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$g(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$g(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck$W(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$W(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$z(descriptor.key), descriptor);
  }
}
function _createClass$W(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$W(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$W(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$U(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$W(subClass, superClass);
}
function _setPrototypeOf$W(o, p) {
  _setPrototypeOf$W = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$W(o, p);
}
function _createSuper$U(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$U();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$U(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$U(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$U(this, result);
  };
}
function _possibleConstructorReturn$U(self, call) {
  if (call && (_typeof$18(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$W(self);
}
function _assertThisInitialized$W(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$U() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$U(o) {
  _getPrototypeOf$U = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$U(o);
}
function _slicedToArray$8(arr, i) {
  return (
    _arrayWithHoles$8(arr) ||
    _iterableToArrayLimit$8(arr, i) ||
    _unsupportedIterableToArray$g(arr, i) ||
    _nonIterableRest$8()
  );
}
function _nonIterableRest$8() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$g(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$g(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$g(o, minLen);
}
function _arrayLikeToArray$g(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit$8(arr, i) {
  var _i = null == arr ? null : ('undefined' != typeof Symbol && arr[Symbol.iterator]) || arr['@@iterator'];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      (_d = !0), (_e = err);
    } finally {
      try {
        if (!_n && null != _i['return'] && ((_r = _i['return']()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$8(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys$u(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$u(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$u(Object(source), !0).forEach(function (key) {
          _defineProperty$13(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$u(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$13(obj, key, value) {
  key = _toPropertyKey$z(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$z(arg) {
  var key = _toPrimitive$z(arg, 'string');
  return _typeof$18(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$z(input, hint) {
  if (_typeof$18(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$18(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var calculateWordWidths = function calculateWordWidths(props) {
  try {
    var words = [];
    if (!_isNil(props.children)) {
      if (props.breakAll) {
        words = props.children.toString().split('');
      } else {
        words = props.children.toString().split(BREAKING_SPACES);
      }
    }
    var wordsWithComputedWidth = words.map(function (word) {
      return {
        word: word,
        width: getStringSize(word, props.style).width,
      };
    });
    var spaceWidth = props.breakAll ? 0 : getStringSize('\xA0', props.style).width;
    return {
      wordsWithComputedWidth: wordsWithComputedWidth,
      spaceWidth: spaceWidth,
    };
  } catch (e) {
    return null;
  }
};
var calculateWordsByLines = function calculateWordsByLines(
  props,
  initialWordsWithComputedWith,
  spaceWidth,
  lineWidth,
  scaleToFit,
) {
  var shouldLimitLines = isNumber(props.maxLines);
  var text = props.children;
  var calculate = function calculate() {
    var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return words.reduce(function (result, _ref) {
      var word = _ref.word,
        width = _ref.width;
      var currentLine = result[result.length - 1];
      if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
        // Word can be added to an existing line
        currentLine.words.push(word);
        currentLine.width += width + spaceWidth;
      } else {
        // Add first word to line or word is too long to scaleToFit on existing line
        var newLine = {
          words: [word],
          width: width,
        };
        result.push(newLine);
      }
      return result;
    }, []);
  };
  var originalResult = calculate(initialWordsWithComputedWith);
  var findLongestLine = function findLongestLine(words) {
    return words.reduce(function (a, b) {
      return a.width > b.width ? a : b;
    });
  };
  if (!shouldLimitLines) {
    return originalResult;
  }
  var suffix = '…';
  var checkOverflow = function checkOverflow(index) {
    var tempText = text.slice(0, index);
    var words = calculateWordWidths(
      _objectSpread$u(
        _objectSpread$u({}, props),
        {},
        {
          children: tempText + suffix,
        },
      ),
    ).wordsWithComputedWidth;
    var result = calculate(words);
    var doesOverflow = result.length > props.maxLines || findLongestLine(result).width > lineWidth;
    return [doesOverflow, result];
  };
  var start = 0;
  var end = text.length - 1;
  var iterations = 0;
  var trimmedResult;
  while (start <= end && iterations <= text.length - 1) {
    var middle = Math.floor((start + end) / 2);
    var prev = middle - 1;
    var _checkOverflow = checkOverflow(prev),
      _checkOverflow2 = _slicedToArray$8(_checkOverflow, 2),
      doesPrevOverflow = _checkOverflow2[0],
      result = _checkOverflow2[1];
    var _checkOverflow3 = checkOverflow(middle),
      _checkOverflow4 = _slicedToArray$8(_checkOverflow3, 1),
      doesMiddleOverflow = _checkOverflow4[0];
    if (!doesPrevOverflow && !doesMiddleOverflow) {
      start = middle + 1;
    }
    if (doesPrevOverflow && doesMiddleOverflow) {
      end = middle - 1;
    }
    if (!doesPrevOverflow && doesMiddleOverflow) {
      trimmedResult = result;
      break;
    }
    iterations++;
  }

  // Fallback to originalResult (result without trimming) if we cannot find the
  // where to trim.  This should not happen :tm:
  return trimmedResult || originalResult;
};
var getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
  var words = !_isNil(children) ? children.toString().split(BREAKING_SPACES) : [];
  return [
    {
      words: words,
    },
  ];
};
var getWordsByLines = function getWordsByLines(props, needCalculate) {
  // Only perform calculations if using features that require them (multiline, scaleToFit)
  if ((props.width || props.scaleToFit) && !Global.isSsr) {
    var wordsWithComputedWidth, spaceWidth;
    if (needCalculate) {
      var wordWidths = calculateWordWidths(props);
      if (wordWidths) {
        var wcw = wordWidths.wordsWithComputedWidth,
          sw = wordWidths.spaceWidth;
        wordsWithComputedWidth = wcw;
        spaceWidth = sw;
      } else {
        return getWordsWithoutCalculate(props.children);
      }
      return calculateWordsByLines(props, wordsWithComputedWidth, spaceWidth, props.width, props.scaleToFit);
    }
  }
  return getWordsWithoutCalculate(props.children);
};
var Text = /*#__PURE__*/ (function (_Component) {
  _inherits$U(Text, _Component);
  var _super = _createSuper$U(Text);
  function Text() {
    var _this;
    _classCallCheck$W(this, Text);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$13(_assertThisInitialized$W(_this), 'state', {});
    return _this;
  }
  _createClass$W(
    Text,
    [
      {
        key: 'render',
        value: function render() {
          var _this$props = this.props,
            dx = _this$props.dx,
            dy = _this$props.dy,
            textAnchor = _this$props.textAnchor,
            verticalAnchor = _this$props.verticalAnchor,
            scaleToFit = _this$props.scaleToFit,
            angle = _this$props.angle,
            lineHeight = _this$props.lineHeight,
            capHeight = _this$props.capHeight,
            className = _this$props.className,
            breakAll = _this$props.breakAll,
            textProps = _objectWithoutProperties$e(_this$props, _excluded$e);
          var wordsByLines = this.state.wordsByLines;
          if (!isNumOrStr(textProps.x) || !isNumOrStr(textProps.y)) {
            return null;
          }
          var x = textProps.x + (isNumber(dx) ? dx : 0);
          var y = textProps.y + (isNumber(dy) ? dy : 0);
          var startDy;
          switch (verticalAnchor) {
            case 'start':
              startDy = reduceCSSCalc('calc('.concat(capHeight, ')'));
              break;
            case 'middle':
              startDy = reduceCSSCalc(
                'calc('
                  .concat((wordsByLines.length - 1) / 2, ' * -')
                  .concat(lineHeight, ' + (')
                  .concat(capHeight, ' / 2))'),
              );
              break;
            default:
              startDy = reduceCSSCalc('calc('.concat(wordsByLines.length - 1, ' * -').concat(lineHeight, ')'));
              break;
          }
          var transforms = [];
          if (scaleToFit) {
            var lineWidth = wordsByLines[0].width;
            var width = this.props.width;
            transforms.push('scale('.concat((isNumber(width) ? width / lineWidth : 1) / lineWidth, ')'));
          }
          if (angle) {
            transforms.push('rotate('.concat(angle, ', ').concat(x, ', ').concat(y, ')'));
          }
          if (transforms.length) {
            textProps.transform = transforms.join(' ');
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            'text',
            _extends$v({}, filterProps(textProps, true), {
              x: x,
              y: y,
              className: cx('recharts-text', className),
              textAnchor: textAnchor,
              fill: textProps.fill.includes('url') ? Text.defaultProps.fill : textProps.fill,
            }),
            wordsByLines.map(function (line, index) {
              return (
                /*#__PURE__*/
                // eslint-disable-next-line react/no-array-index-key
                React__default['default'].createElement(
                  'tspan',
                  {
                    x: x,
                    dy: index === 0 ? startDy : lineHeight,
                    key: index,
                  },
                  line.words.join(breakAll ? '' : ' '),
                )
              );
            }),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (
            nextProps.width !== prevState.prevWidth ||
            nextProps.scaleToFit !== prevState.prevScaleToFit ||
            nextProps.children !== prevState.prevChildren ||
            nextProps.style !== prevState.prevStyle ||
            nextProps.breakAll !== prevState.prevBreakAll
          ) {
            var needCalculate =
              nextProps.children !== prevState.prevChildren ||
              nextProps.style !== prevState.prevStyle ||
              nextProps.breakAll !== prevState.prevBreakAll;
            return {
              prevWidth: nextProps.width,
              prevScaleToFit: nextProps.scaleToFit,
              prevChildren: nextProps.children,
              prevStyle: nextProps.style,
              wordsByLines: getWordsByLines(nextProps, needCalculate),
            };
          }
          return null;
        },
      },
    ],
  );
  return Text;
})(React.Component);
_defineProperty$13(Text, 'defaultProps', {
  x: 0,
  y: 0,
  lineHeight: '1em',
  capHeight: '0.71em',
  // Magic number from d3
  scaleToFit: false,
  textAnchor: 'start',
  verticalAnchor: 'end',
  // Maintain compat with existing charts / default SVG behavior
  fill: '#808080',
});

var isSymbol = isSymbol_1;

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum$4(array, iteratee, comparator) {
  var index = -1,
    length = array.length;

  while (++index < length) {
    var value = array[index],
      current = iteratee(value);

    if (
      current != null &&
      (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))
    ) {
      var computed = current,
        result = value;
    }
  }
  return result;
}

var _baseExtremum = baseExtremum$4;

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */

function baseGt$2(value, other) {
  return value > other;
}

var _baseGt = baseGt$2;

var baseExtremum$3 = _baseExtremum,
  baseGt$1 = _baseGt,
  identity$5 = identity_1;

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max$3(array) {
  return array && array.length ? baseExtremum$3(array, identity$5, baseGt$1) : undefined;
}

var max_1 = max$3;

var _max = /*@__PURE__*/ getDefaultExportFromCjs(max_1);

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */

function baseLt$2(value, other) {
  return value < other;
}

var _baseLt = baseLt$2;

var baseExtremum$2 = _baseExtremum,
  baseLt$1 = _baseLt,
  identity$4 = identity_1;

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min$2(array) {
  return array && array.length ? baseExtremum$2(array, identity$4, baseLt$1) : undefined;
}

var min_1 = min$2;

var _min = /*@__PURE__*/ getDefaultExportFromCjs(min_1);

var arrayMap$1 = _arrayMap,
  baseIteratee$8 = _baseIteratee,
  baseMap = _baseMap,
  isArray$3 = isArray_1;

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map$4(collection, iteratee) {
  var func = isArray$3(collection) ? arrayMap$1 : baseMap;
  return func(collection, baseIteratee$8(iteratee));
}

var map_1 = map$4;

var baseFlatten$1 = _baseFlatten,
  map$3 = map_1;

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten$1(map$3(collection, iteratee), 1);
}

var flatMap_1 = flatMap;

var _flatMap = /*@__PURE__*/ getDefaultExportFromCjs(flatMap_1);

function ascending(a, b) {
  return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function descending(a, b) {
  return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

function bisector(f) {
  let compare1, compare2, delta;

  // If an accessor is specified, promote it to a comparator. In this case we
  // can test whether the search value is (self-) comparable. We can’t do this
  // for a comparator (except for specific, known comparators) because we can’t
  // tell if the comparator is symmetric, and an asymmetric comparator can’t be
  // used to test whether a single value is comparable.
  if (f.length !== 2) {
    compare1 = ascending;
    compare2 = (d, x) => ascending(f(d), x);
    delta = (d, x) => f(d) - x;
  } else {
    compare1 = f === ascending || f === descending ? f : zero$1;
    compare2 = f;
    delta = f;
  }

  function left(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = (lo + hi) >>> 1;
        if (compare2(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }

  function right(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = (lo + hi) >>> 1;
        if (compare2(a[mid], x) <= 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }

  function center(a, x, lo = 0, hi = a.length) {
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return { left, center, right };
}

function zero$1() {
  return 0;
}

function number$2(x) {
  return x === null ? NaN : +x;
}

function* numbers(values, valueof) {
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}

const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$2).center;

class InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, { _intern: { value: new Map() }, _key: { value: key } });
    if (entries != null) for (const [key, value] of entries) this.set(key, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}

function intern_get({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}

function intern_set({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}

function intern_delete({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}

function keyof(value) {
  return value !== null && typeof value === 'object' ? value.valueOf() : value;
}

function compareDefined(compare = ascending) {
  if (compare === ascending) return ascendingDefined;
  if (typeof compare !== 'function') throw new TypeError('compare is not a function');
  return (a, b) => {
    const x = compare(a, b);
    if (x || x === 0) return x;
    return (compare(b, b) === 0) - (compare(a, a) === 0);
  };
}

function ascendingDefined(a, b) {
  return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

const e10 = Math.sqrt(50),
  e5 = Math.sqrt(10),
  e2 = Math.sqrt(2);

function tickSpec(start, stop, count) {
  const step = (stop - start) / Math.max(0, count),
    power = Math.floor(Math.log10(step)),
    error = step / Math.pow(10, power),
    factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start * inc);
    i2 = Math.round(stop * inc);
    if (i1 / inc < start) ++i1;
    if (i2 / inc > stop) --i2;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start / inc);
    i2 = Math.round(stop / inc);
    if (i1 * inc < start) ++i1;
    if (i2 * inc > stop) --i2;
  }
  if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
  return [i1, i2, inc];
}

function ticks(start, stop, count) {
  (stop = +stop), (start = +start), (count = +count);
  if (!(count > 0)) return [];
  if (start === stop) return [start];
  const reverse = stop < start,
    [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
  if (!(i2 >= i1)) return [];
  const n = i2 - i1 + 1,
    ticks = new Array(n);
  if (reverse) {
    if (inc < 0) for (let i = 0; i < n; ++i) ticks[i] = (i2 - i) / -inc;
    else for (let i = 0; i < n; ++i) ticks[i] = (i2 - i) * inc;
  } else {
    if (inc < 0) for (let i = 0; i < n; ++i) ticks[i] = (i1 + i) / -inc;
    else for (let i = 0; i < n; ++i) ticks[i] = (i1 + i) * inc;
  }
  return ticks;
}

function tickIncrement(start, stop, count) {
  (stop = +stop), (start = +start), (count = +count);
  return tickSpec(start, stop, count)[2];
}

function tickStep(start, stop, count) {
  (stop = +stop), (start = +start), (count = +count);
  const reverse = stop < start,
    inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
  return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

function max$2(values, valueof) {
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  }
  return max;
}

function min$1(values, valueof) {
  let min;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null && (min > value || (min === undefined && value >= value))) {
        min = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (min > value || (min === undefined && value >= value))) {
        min = value;
      }
    }
  }
  return min;
}

// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k, left = 0, right = Infinity, compare) {
  k = Math.floor(k);
  left = Math.floor(Math.max(0, left));
  right = Math.floor(Math.min(array.length - 1, right));

  if (!(left <= k && k <= right)) return array;

  compare = compare === undefined ? ascendingDefined : compareDefined(compare);

  while (right > left) {
    if (right - left > 600) {
      const n = right - left + 1;
      const m = k - left + 1;
      const z = Math.log(n);
      const s = 0.5 * Math.exp((2 * z) / 3);
      const sd = 0.5 * Math.sqrt((z * s * (n - s)) / n) * (m - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left, Math.floor(k - (m * s) / n + sd));
      const newRight = Math.min(right, Math.floor(k + ((n - m) * s) / n + sd));
      quickselect(array, k, newLeft, newRight, compare);
    }

    const t = array[k];
    let i = left;
    let j = right;

    swap(array, left, k);
    if (compare(array[right], t) > 0) swap(array, left, right);

    while (i < j) {
      swap(array, i, j), ++i, --j;
      while (compare(array[i], t) < 0) ++i;
      while (compare(array[j], t) > 0) --j;
    }

    if (compare(array[left], t) === 0) swap(array, left, j);
    else ++j, swap(array, j, right);

    if (j <= k) left = j + 1;
    if (k <= j) right = j - 1;
  }

  return array;
}

function swap(array, i, j) {
  const t = array[i];
  array[i] = array[j];
  array[j] = t;
}

function quantile$1(values, p, valueof) {
  values = Float64Array.from(numbers(values, valueof));
  if (!(n = values.length) || isNaN((p = +p))) return;
  if (p <= 0 || n < 2) return min$1(values);
  if (p >= 1) return max$2(values);
  var n,
    i = (n - 1) * p,
    i0 = Math.floor(i),
    value0 = max$2(quickselect(values, i0).subarray(0, i0 + 1)),
    value1 = min$1(values.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}

function quantileSorted(values, p, valueof = number$2) {
  if (!(n = values.length) || isNaN((p = +p))) return;
  if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
    i = (n - 1) * p,
    i0 = Math.floor(i),
    value0 = +valueof(values[i0], i0, values),
    value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}

function range$2(start, stop, step) {
  (start = +start),
    (stop = +stop),
    (step = (n = arguments.length) < 2 ? ((stop = start), (start = 0), 1) : n < 3 ? 1 : +step);

  var i = -1,
    n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
    range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);
      break;
    default:
      this.range(range).domain(domain);
      break;
  }
  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain === 'function') this.interpolator(domain);
      else this.range(domain);
      break;
    }
    default: {
      this.domain(domain);
      if (typeof interpolator === 'function') this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}

const implicit = Symbol('implicit');

function ordinal() {
  var index = new InternMap(),
    domain = [],
    range = [],
    unknown = implicit;

  function scale(d) {
    let i = index.get(d);
    if (i === undefined) {
      if (unknown !== implicit) return unknown;
      index.set(d, (i = domain.push(d) - 1));
    }
    return range[i % range.length];
  }

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    (domain = []), (index = new InternMap());
    for (const value of _) {
      if (index.has(value)) continue;
      index.set(value, domain.push(value) - 1);
    }
    return scale;
  };

  scale.range = function (_) {
    return arguments.length ? ((range = Array.from(_)), scale) : range.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? ((unknown = _), scale) : unknown;
  };

  scale.copy = function () {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
    domain = scale.domain,
    ordinalRange = scale.range,
    r0 = 0,
    r1 = 1,
    step,
    bandwidth,
    round = false,
    paddingInner = 0,
    paddingOuter = 0,
    align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
      reverse = r1 < r0,
      start = reverse ? r1 : r0,
      stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) (start = Math.round(start)), (bandwidth = Math.round(bandwidth));
    var values = range$2(n).map(function (i) {
      return start + step * i;
    });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function (_) {
    return arguments.length ? (([r0, r1] = _), (r0 = +r0), (r1 = +r1), rescale()) : [r0, r1];
  };

  scale.rangeRound = function (_) {
    return ([r0, r1] = _), (r0 = +r0), (r1 = +r1), (round = true), rescale();
  };

  scale.bandwidth = function () {
    return bandwidth;
  };

  scale.step = function () {
    return step;
  };

  scale.round = function (_) {
    return arguments.length ? ((round = !!_), rescale()) : round;
  };

  scale.padding = function (_) {
    return arguments.length ? ((paddingInner = Math.min(1, (paddingOuter = +_))), rescale()) : paddingInner;
  };

  scale.paddingInner = function (_) {
    return arguments.length ? ((paddingInner = Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function (_) {
    return arguments.length ? ((paddingOuter = +_), rescale()) : paddingOuter;
  };

  scale.align = function (_) {
    return arguments.length ? ((align = Math.max(0, Math.min(1, _))), rescale()) : align;
  };

  scale.copy = function () {
    return band(domain(), [r0, r1]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function () {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

function define$3(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend$1(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = '\\s*([+-]?\\d+)\\s*',
  reN = '\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*',
  reP = '\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*',
  reHex = /^#([0-9a-f]{3,8})$/,
  reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`),
  reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`),
  reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`),
  reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`),
  reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`),
  reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32,
};

define$3(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb,
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHex8() {
  return this.rgb().formatHex8();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + '').trim().toLowerCase();
  return (m = reHex.exec(format))
    ? ((l = m[1].length),
      (m = parseInt(m[1], 16)),
      l === 6
        ? rgbn(m) // #ff0000
        : l === 3
        ? new Rgb(((m >> 8) & 0xf) | ((m >> 4) & 0xf0), ((m >> 4) & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
        : l === 8
        ? rgba((m >> 24) & 0xff, (m >> 16) & 0xff, (m >> 8) & 0xff, (m & 0xff) / 0xff) // #ff000000
        : l === 4
        ? rgba(
            ((m >> 12) & 0xf) | ((m >> 8) & 0xf0),
            ((m >> 8) & 0xf) | ((m >> 4) & 0xf0),
            ((m >> 4) & 0xf) | (m & 0xf0),
            (((m & 0xf) << 4) | (m & 0xf)) / 0xff,
          ) // #f000
        : null) // invalid hex
    : (m = reRgbInteger.exec(format))
    ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
    : (m = reRgbPercent.exec(format))
    ? new Rgb((m[1] * 255) / 100, (m[2] * 255) / 100, (m[3] * 255) / 100, 1) // rgb(100%, 0%, 0%)
    : (m = reRgbaInteger.exec(format))
    ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
    : (m = reRgbaPercent.exec(format))
    ? rgba((m[1] * 255) / 100, (m[2] * 255) / 100, (m[3] * 255) / 100, m[4]) // rgb(100%, 0%, 0%, 1)
    : (m = reHslPercent.exec(format))
    ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
    : (m = reHslaPercent.exec(format))
    ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
    : named.hasOwnProperty(format)
    ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
    : format === 'transparent'
    ? new Rgb(NaN, NaN, NaN, 0)
    : null;
}

function rgbn(n) {
  return new Rgb((n >> 16) & 0xff, (n >> 8) & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb$1(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define$3(
  Rgb,
  rgb$1,
  extend$1(Color, {
    brighter(k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker(k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb() {
      return this;
    },
    clamp() {
      return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable() {
      return (
        -0.5 <= this.r &&
        this.r < 255.5 &&
        -0.5 <= this.g &&
        this.g < 255.5 &&
        -0.5 <= this.b &&
        this.b < 255.5 &&
        0 <= this.opacity &&
        this.opacity <= 1
      );
    },
    hex: rgb_formatHex, // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb,
  }),
);

function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}

function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}

function rgb_formatRgb() {
  const a = clampa(this.opacity);
  return `${a === 1 ? 'rgb(' : 'rgba('}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${
    a === 1 ? ')' : `, ${a})`
  }`;
}

function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}

function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}

function hex(value) {
  value = clampi(value);
  return (value < 16 ? '0' : '') + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    min = Math.min(r, g, b),
    max = Math.max(r, g, b),
    h = NaN,
    s = max - min,
    l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define$3(
  Hsl,
  hsl,
  extend$1(Color, {
    brighter(k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker(k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb() {
      var h = (this.h % 360) + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
      return new Rgb(
        hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
        hsl2rgb(h, m1, m2),
        hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
        this.opacity,
      );
    },
    clamp() {
      return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable() {
      return (
        ((0 <= this.s && this.s <= 1) || isNaN(this.s)) &&
        0 <= this.l &&
        this.l <= 1 &&
        0 <= this.opacity &&
        this.opacity <= 1
      );
    },
    formatHsl() {
      const a = clampa(this.opacity);
      return `${a === 1 ? 'hsl(' : 'hsla('}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${
        a === 1 ? ')' : `, ${a})`
      }`;
    },
  }),
);

function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}

function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + ((m2 - m1) * h) / 60 : h < 180 ? m2 : h < 240 ? m1 + ((m2 - m1) * (240 - h)) / 60 : m1) * 255;
}

const radians = Math.PI / 180;
const degrees = 180 / Math.PI;

// https://observablehq.com/@mbostock/lab-and-rgb
const K$2 = 18,
  Xn = 0.96422,
  Yn = 1,
  Zn = 0.82521,
  t0$1 = 4 / 29,
  t1$1 = 6 / 29,
  t2 = 3 * t1$1 * t1$1,
  t3 = t1$1 * t1$1 * t1$1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = rgb2lrgb(o.r),
    g = rgb2lrgb(o.g),
    b = rgb2lrgb(o.b),
    y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn),
    x,
    z;
  if (r === g && g === b) x = z = y;
  else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

define$3(
  Lab,
  lab,
  extend$1(Color, {
    brighter(k) {
      return new Lab(this.l + K$2 * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker(k) {
      return new Lab(this.l - K$2 * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb() {
      var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
      x = Xn * lab2xyz(x);
      y = Yn * lab2xyz(y);
      z = Zn * lab2xyz(z);
      return new Rgb(
        lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
        lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.033454 * z),
        lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
        this.opacity,
      );
    },
  }),
);

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0$1;
}

function lab2xyz(t) {
  return t > t1$1 ? t * t * t : t2 * (t - t0$1);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * degrees;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * radians;
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

define$3(
  Hcl,
  hcl,
  extend$1(Color, {
    brighter(k) {
      return new Hcl(this.h, this.c, this.l + K$2 * (k == null ? 1 : k), this.opacity);
    },
    darker(k) {
      return new Hcl(this.h, this.c, this.l - K$2 * (k == null ? 1 : k), this.opacity);
    },
    rgb() {
      return hcl2lab(this).rgb();
    },
  }),
);

var A$1 = -0.14861,
  B$2 = +1.78277,
  C$2 = -0.29227,
  D$2 = -0.90649,
  E$2 = +1.97294,
  ED = E$2 * D$2,
  EB = E$2 * B$2,
  BC_DA = B$2 * C$2 - D$2 * A$1;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
    g = o.g / 255,
    b = o.b / 255,
    l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
    bl = b - l,
    k = (E$2 * (g - l) - C$2 * bl) / D$2,
    s = Math.sqrt(k * k + bl * bl) / (E$2 * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * degrees - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix$1(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define$3(
  Cubehelix,
  cubehelix$1,
  extend$1(Color, {
    brighter(k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker(k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb() {
      var h = isNaN(this.h) ? 0 : (this.h + 120) * radians,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
      return new Rgb(
        255 * (l + a * (A$1 * cosh + B$2 * sinh)),
        255 * (l + a * (C$2 * cosh + D$2 * sinh)),
        255 * (l + a * (E$2 * cosh)),
        this.opacity,
      );
    },
  }),
);

var constant = (x) => () => x;

function linear$1(a, d) {
  return function (t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return (
    (a = Math.pow(a, y)),
    (b = Math.pow(b, y) - a),
    (y = 1 / y),
    function (t) {
      return Math.pow(a + t * b, y);
    }
  );
}

function hue(a, b) {
  var d = b - a;
  return d ? linear$1(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1
    ? nogamma
    : function (a, b) {
        return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
      };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant(isNaN(a) ? b : a);
}

var rgb = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb(start, end) {
    var r = color((start = rgb$1(start)).r, (end = rgb$1(end)).r),
      g = color(start.g, end.g),
      b = color(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
    return function (t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + '';
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
    c = b.slice(),
    i;
  return function (t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
    na = a ? Math.min(nb, a.length) : 0,
    x = new Array(na),
    c = new Array(nb),
    i;

  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function (t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date$1(a, b) {
  var d = new Date();
  return (
    (a = +a),
    (b = +b),
    function (t) {
      return d.setTime(a * (1 - t) + b * t), d;
    }
  );
}

function interpolateNumber$1(a, b) {
  return (
    (a = +a),
    (b = +b),
    function (t) {
      return a * (1 - t) + b * t;
    }
  );
}

function object(a, b) {
  var i = {},
    c = {},
    k;

  if (a === null || typeof a !== 'object') a = {};
  if (b === null || typeof b !== 'object') b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolate(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function (t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
  reB = new RegExp(reA.source, 'g');

function zero(b) {
  return function () {
    return b;
  };
}

function one(b) {
  return function (t) {
    return b(t) + '';
  };
}

function string(a, b) {
  var bi = (reA.lastIndex = reB.lastIndex = 0), // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators

  // Coerce inputs to strings.
  (a = a + ''), (b = b + '');

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else {
      // interpolate non-matching numbers
      s[++i] = null;
      q.push({ i: i, x: interpolateNumber$1(am, bm) });
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2
    ? q[0]
      ? one(q[0].x)
      : zero(b)
    : ((b = q.length),
      function (t) {
        for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
        return s.join('');
      });
}

function interpolate(a, b) {
  var t = typeof b,
    c;
  return b == null || t === 'boolean'
    ? constant(b)
    : (t === 'number'
        ? interpolateNumber$1
        : t === 'string'
        ? (c = color(b))
          ? ((b = c), rgb)
          : string
        : b instanceof color
        ? rgb
        : b instanceof Date
        ? date$1
        : isNumberArray(b)
        ? numberArray
        : Array.isArray(b)
        ? genericArray
        : (typeof b.valueOf !== 'function' && typeof b.toString !== 'function') || isNaN(b)
        ? object
        : interpolateNumber$1)(a, b);
}

function interpolateRound(a, b) {
  return (
    (a = +a),
    (b = +b),
    function (t) {
      return Math.round(a * (1 - t) + b * t);
    }
  );
}

var epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

(function zoomRho(rho, rho2, rho4) {
  // p0 = [ux0, uy0, w0]
  // p1 = [ux1, uy1, w1]
  function zoom(p0, p1) {
    var ux0 = p0[0],
      uy0 = p0[1],
      w0 = p0[2],
      ux1 = p1[0],
      uy1 = p1[1],
      w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

    // Special case for u0 ≅ u1.
    if (d2 < epsilon2) {
      S = Math.log(w1 / w0) / rho;
      i = function (t) {
        return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
      };
    }

    // General case.
    else {
      var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho;
      i = function (t) {
        var s = t * S,
          coshr0 = cosh(r0),
          u = (w0 / (rho2 * d1)) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
        return [ux0 + u * dx, uy0 + u * dy, (w0 * coshr0) / cosh(rho * s + r0)];
      };
    }

    i.duration = (S * 1000 * rho) / Math.SQRT2;

    return i;
  }

  zoom.rho = function (_) {
    var _1 = Math.max(1e-3, +_),
      _2 = _1 * _1,
      _4 = _2 * _2;
    return zoomRho(_1, _2, _4);
  };

  return zoom;
})(Math.SQRT2, 2, 4);

function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = cubehelix$1(start)).h, (end = cubehelix$1(end)).h),
        s = nogamma(start.s, end.s),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + '';
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

cubehelix(hue);
cubehelix(nogamma);

function piecewise(interpolate$1, values) {
  if (values === undefined) (values = interpolate$1), (interpolate$1 = interpolate);
  var i = 0,
    n = values.length - 1,
    v = values[0],
    I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate$1(v, (v = values[++i]));
  return function (t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor((t *= n))));
    return I[i](t - i);
  };
}

function constants(x) {
  return function () {
    return x;
  };
}

function number$1(x) {
  return +x;
}

var unit = [0, 1];

function identity$3(x) {
  return x;
}

function normalize(a, b) {
  return (b -= a = +a)
    ? function (x) {
        return (x - a) / b;
      }
    : constants(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) (t = a), (a = b), (b = t);
  return function (x) {
    return Math.max(a, Math.min(b, x));
  };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0],
    d1 = domain[1],
    r0 = range[0],
    r1 = range[1];
  if (d1 < d0) (d0 = normalize(d1, d0)), (r0 = interpolate(r1, r0));
  else (d0 = normalize(d0, d1)), (r0 = interpolate(r0, r1));
  return function (x) {
    return r0(d0(x));
  };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
    d = new Array(j),
    r = new Array(j),
    i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function (x) {
    var i = bisectRight(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy$1(source, target) {
  return target
    .domain(source.domain())
    .range(source.range())
    .interpolate(source.interpolate())
    .clamp(source.clamp())
    .unknown(source.unknown());
}

function transformer$2() {
  var domain = unit,
    range = unit,
    interpolate$1 = interpolate,
    transform,
    untransform,
    unknown,
    clamp = identity$3,
    piecewise,
    output,
    input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$3) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN((x = +x))
      ? unknown
      : (output || (output = piecewise(domain.map(transform), range, interpolate$1)))(transform(clamp(x)));
  }

  scale.invert = function (y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber$1)))(y)));
  };

  scale.domain = function (_) {
    return arguments.length ? ((domain = Array.from(_, number$1)), rescale()) : domain.slice();
  };

  scale.range = function (_) {
    return arguments.length ? ((range = Array.from(_)), rescale()) : range.slice();
  };

  scale.rangeRound = function (_) {
    return (range = Array.from(_)), (interpolate$1 = interpolateRound), rescale();
  };

  scale.clamp = function (_) {
    return arguments.length ? ((clamp = _ ? true : identity$3), rescale()) : clamp !== identity$3;
  };

  scale.interpolate = function (_) {
    return arguments.length ? ((interpolate$1 = _), rescale()) : interpolate$1;
  };

  scale.unknown = function (_) {
    return arguments.length ? ((unknown = _), scale) : unknown;
  };

  return function (t, u) {
    (transform = t), (untransform = u);
    return rescale();
  };
}

function continuous() {
  return transformer$2()(identity$3, identity$3);
}

function formatDecimal(x) {
  return Math.abs((x = Math.round(x))) >= 1e21 ? x.toLocaleString('en').replace(/,/g, '') : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf('e')) < 0) return null; // NaN, ±Infinity
  var i,
    coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}

function exponent(x) {
  return (x = formatDecimalParts(Math.abs(x))), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function (value, width) {
    var i = value.length,
      t = [],
      j = 0,
      g = grouping[0],
      length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring((i -= g), i + g));
      if ((length += g + 1) > width) break;
      g = grouping[(j = (j + 1) % grouping.length)];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re$2 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re$2.exec(specifier))) throw new Error('invalid format: ' + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10],
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? ' ' : specifier.fill + '';
  this.align = specifier.align === undefined ? '>' : specifier.align + '';
  this.sign = specifier.sign === undefined ? '-' : specifier.sign + '';
  this.symbol = specifier.symbol === undefined ? '' : specifier.symbol + '';
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? '' : specifier.type + '';
}

FormatSpecifier.prototype.toString = function () {
  return (
    this.fill +
    this.align +
    this.sign +
    this.symbol +
    (this.zero ? '0' : '') +
    (this.width === undefined ? '' : Math.max(1, this.width | 0)) +
    (this.comma ? ',' : '') +
    (this.precision === undefined ? '' : '.' + Math.max(0, this.precision | 0)) +
    (this.trim ? '~' : '') +
    this.type
  );
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case '.':
        i0 = i1 = i;
        break;
      case '0':
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      default:
        if (!+s[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + '';
  var coefficient = d[0],
    exponent = d[1],
    i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
    n = coefficient.length;
  return i === n
    ? coefficient
    : i > n
    ? coefficient + new Array(i - n + 1).join('0')
    : i > 0
    ? coefficient.slice(0, i) + '.' + coefficient.slice(i)
    : '0.' + new Array(1 - i).join('0') + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + '';
  var coefficient = d[0],
    exponent = d[1];
  return exponent < 0
    ? '0.' + new Array(-exponent).join('0') + coefficient
    : coefficient.length > exponent + 1
    ? coefficient.slice(0, exponent + 1) + '.' + coefficient.slice(exponent + 1)
    : coefficient + new Array(exponent - coefficient.length + 2).join('0');
}

var formatTypes = {
  '%': (x, p) => (x * 100).toFixed(p),
  b: (x) => Math.round(x).toString(2),
  c: (x) => x + '',
  d: formatDecimal,
  e: (x, p) => x.toExponential(p),
  f: (x, p) => x.toFixed(p),
  g: (x, p) => x.toPrecision(p),
  o: (x) => Math.round(x).toString(8),
  p: (x, p) => formatRounded(x * 100, p),
  r: formatRounded,
  s: formatPrefixAuto,
  X: (x) => Math.round(x).toString(16).toUpperCase(),
  x: (x) => Math.round(x).toString(16),
};

function identity$2(x) {
  return x;
}

var map$2 = Array.prototype.map,
  prefixes = ['y', 'z', 'a', 'f', 'p', 'n', 'µ', 'm', '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];

function formatLocale$1(locale) {
  var group =
      locale.grouping === undefined || locale.thousands === undefined
        ? identity$2
        : formatGroup(map$2.call(locale.grouping, Number), locale.thousands + ''),
    currencyPrefix = locale.currency === undefined ? '' : locale.currency[0] + '',
    currencySuffix = locale.currency === undefined ? '' : locale.currency[1] + '',
    decimal = locale.decimal === undefined ? '.' : locale.decimal + '',
    numerals = locale.numerals === undefined ? identity$2 : formatNumerals(map$2.call(locale.numerals, String)),
    percent = locale.percent === undefined ? '%' : locale.percent + '',
    minus = locale.minus === undefined ? '−' : locale.minus + '',
    nan = locale.nan === undefined ? 'NaN' : locale.nan + '';

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
      align = specifier.align,
      sign = specifier.sign,
      symbol = specifier.symbol,
      zero = specifier.zero,
      width = specifier.width,
      comma = specifier.comma,
      precision = specifier.precision,
      trim = specifier.trim,
      type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === 'n') (comma = true), (type = 'g');
    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), (trim = true), (type = 'g');

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === '0' && align === '=')) (zero = true), (fill = '0'), (align = '=');

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix =
        symbol === '$' ? currencyPrefix : symbol === '#' && /[boxX]/.test(type) ? '0' + type.toLowerCase() : '',
      suffix = symbol === '$' ? currencySuffix : /[%p]/.test(type) ? percent : '';

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
      maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision =
      precision === undefined
        ? 6
        : /[gprs]/.test(type)
        ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
        valueSuffix = suffix,
        i,
        n,
        c;

      if (type === 'c') {
        valueSuffix = formatType(value) + valueSuffix;
        value = '';
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== '+') valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix =
          (valueNegative ? (sign === '(' ? sign : minus) : sign === '-' || sign === '(' ? '' : sign) + valuePrefix;
        valueSuffix =
          (type === 's' ? prefixes[8 + prefixExponent / 3] : '') +
          valueSuffix +
          (valueNegative && sign === '(' ? ')' : '');

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          (i = -1), (n = value.length);
          while (++i < n) {
            if (((c = value.charCodeAt(i)), 48 > c || c > 57)) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
        padding = length < width ? new Array(width - length + 1).join(fill) : '';

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero)
        (value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity)), (padding = '');

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case '<':
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case '=':
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case '^':
          value =
            padding.slice(0, (length = padding.length >> 1)) +
            valuePrefix +
            value +
            valueSuffix +
            padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }

      return numerals(value);
    }

    format.toString = function () {
      return specifier + '';
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat(((specifier = formatSpecifier(specifier)), (specifier.type = 'f'), specifier)),
      e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
      k = Math.pow(10, -e),
      prefix = prefixes[8 + e / 3];
    return function (value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix,
  };
}

var locale$2;
var format$1;
var formatPrefix;

defaultLocale$1({
  thousands: ',',
  grouping: [3],
  currency: ['$', ''],
});

function defaultLocale$1(definition) {
  locale$2 = formatLocale$1(definition);
  format$1 = locale$2.format;
  formatPrefix = locale$2.formatPrefix;
  return locale$2;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  (step = Math.abs(step)), (max = Math.abs(max) - step);
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
    precision;
  specifier = formatSpecifier(specifier == null ? ',f' : specifier);
  switch (specifier.type) {
    case 's': {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN((precision = precisionPrefix(step, value))))
        specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case '':
    case 'e':
    case 'g':
    case 'p':
    case 'r': {
      if (
        specifier.precision == null &&
        !isNaN((precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop)))))
      )
        specifier.precision = precision - (specifier.type === 'e');
      break;
    }
    case 'f':
    case '%': {
      if (specifier.precision == null && !isNaN((precision = precisionFixed(step))))
        specifier.precision = precision - (specifier.type === '%') * 2;
      break;
    }
  }
  return format$1(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function (count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function (count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function (count) {
    if (count == null) count = 10;

    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      (step = start), (start = stop), (stop = step);
      (step = i0), (i0 = i1), (i1 = step);
    }

    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = continuous();

  scale.copy = function () {
    return copy$1(scale, linear());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function identity$1(domain) {
  var unknown;

  function scale(x) {
    return x == null || isNaN((x = +x)) ? unknown : x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function (_) {
    return arguments.length ? ((domain = Array.from(_, number$1)), scale) : domain.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? ((unknown = _), scale) : unknown;
  };

  scale.copy = function () {
    return identity$1(domain).unknown(unknown);
  };

  domain = arguments.length ? Array.from(domain, number$1) : [0, 1];

  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
    i1 = domain.length - 1,
    x0 = domain[i0],
    x1 = domain[i1],
    t;

  if (x1 < x0) {
    (t = i0), (i0 = i1), (i1 = t);
    (t = x0), (x0 = x1), (x1 = t);
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

function transformLog(x) {
  return Math.log(x);
}

function transformExp(x) {
  return Math.exp(x);
}

function transformLogn(x) {
  return -Math.log(-x);
}

function transformExpn(x) {
  return -Math.exp(-x);
}

function pow10(x) {
  return isFinite(x) ? +('1e' + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : (x) => Math.pow(base, x);
}

function logp(base) {
  return base === Math.E
    ? Math.log
    : (base === 10 && Math.log10) || (base === 2 && Math.log2) || ((base = Math.log(base)), (x) => Math.log(x) / base);
}

function reflect(f) {
  return (x, k) => -f(-x, k);
}

function loggish(transform) {
  const scale = transform(transformLog, transformExp);
  const domain = scale.domain;
  let base = 10;
  let logs;
  let pows;

  function rescale() {
    (logs = logp(base)), (pows = powp(base));
    if (domain()[0] < 0) {
      (logs = reflect(logs)), (pows = reflect(pows));
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }

  scale.base = function (_) {
    return arguments.length ? ((base = +_), rescale()) : base;
  };

  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = (count) => {
    const d = domain();
    let u = d[0];
    let v = d[d.length - 1];
    const r = v < u;

    if (r) [u, v] = [v, u];

    let i = logs(u);
    let j = logs(v);
    let k;
    let t;
    const n = count == null ? 10 : +count;
    let z = [];

    if (!(base % 1) && j - i < n) {
      (i = Math.floor(i)), (j = Math.ceil(j));
      if (u > 0)
        for (; i <= j; ++i) {
          for (k = 1; k < base; ++k) {
            t = i < 0 ? k / pows(-i) : k * pows(i);
            if (t < u) continue;
            if (t > v) break;
            z.push(t);
          }
        }
      else
        for (; i <= j; ++i) {
          for (k = base - 1; k >= 1; --k) {
            t = i > 0 ? k / pows(-i) : k * pows(i);
            if (t < u) continue;
            if (t > v) break;
            z.push(t);
          }
        }
      if (z.length * 2 < n) z = ticks(u, v, n);
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }
    return r ? z.reverse() : z;
  };

  scale.tickFormat = (count, specifier) => {
    if (count == null) count = 10;
    if (specifier == null) specifier = base === 10 ? 's' : ',';
    if (typeof specifier !== 'function') {
      if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null) specifier.trim = true;
      specifier = format$1(specifier);
    }
    if (count === Infinity) return specifier;
    const k = Math.max(1, (base * count) / scale.ticks().length); // TODO fast estimate?
    return (d) => {
      let i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : '';
    };
  };

  scale.nice = () => {
    return domain(
      nice(domain(), {
        floor: (x) => pows(Math.floor(logs(x))),
        ceil: (x) => pows(Math.ceil(logs(x))),
      }),
    );
  };

  return scale;
}

function log() {
  const scale = loggish(transformer$2()).domain([1, 10]);
  scale.copy = () => copy$1(scale, log()).base(scale.base());
  initRange.apply(scale, arguments);
  return scale;
}

function transformSymlog(c) {
  return function (x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}

function transformSymexp(c) {
  return function (x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}

function symlogish(transform) {
  var c = 1,
    scale = transform(transformSymlog(c), transformSymexp(c));

  scale.constant = function (_) {
    return arguments.length ? transform(transformSymlog((c = +_)), transformSymexp(c)) : c;
  };

  return linearish(scale);
}

function symlog() {
  var scale = symlogish(transformer$2());

  scale.copy = function () {
    return copy$1(scale, symlog()).constant(scale.constant());
  };

  return initRange.apply(scale, arguments);
}

function transformPow(exponent) {
  return function (x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
}

function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}

function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}

function powish(transform) {
  var scale = transform(identity$3, identity$3),
    exponent = 1;

  function rescale() {
    return exponent === 1
      ? transform(identity$3, identity$3)
      : exponent === 0.5
      ? transform(transformSqrt, transformSquare)
      : transform(transformPow(exponent), transformPow(1 / exponent));
  }

  scale.exponent = function (_) {
    return arguments.length ? ((exponent = +_), rescale()) : exponent;
  };

  return linearish(scale);
}

function pow() {
  var scale = powish(transformer$2());

  scale.copy = function () {
    return copy$1(scale, pow()).exponent(scale.exponent());
  };

  initRange.apply(scale, arguments);

  return scale;
}

function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}

function square(x) {
  return Math.sign(x) * x * x;
}

function unsquare(x) {
  return Math.sign(x) * Math.sqrt(Math.abs(x));
}

function radial() {
  var squared = continuous(),
    range = [0, 1],
    round = false,
    unknown;

  function scale(x) {
    var y = unsquare(squared(x));
    return isNaN(y) ? unknown : round ? Math.round(y) : y;
  }

  scale.invert = function (y) {
    return squared.invert(square(y));
  };

  scale.domain = function (_) {
    return arguments.length ? (squared.domain(_), scale) : squared.domain();
  };

  scale.range = function (_) {
    return arguments.length ? (squared.range((range = Array.from(_, number$1)).map(square)), scale) : range.slice();
  };

  scale.rangeRound = function (_) {
    return scale.range(_).round(true);
  };

  scale.round = function (_) {
    return arguments.length ? ((round = !!_), scale) : round;
  };

  scale.clamp = function (_) {
    return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
  };

  scale.unknown = function (_) {
    return arguments.length ? ((unknown = _), scale) : unknown;
  };

  scale.copy = function () {
    return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function quantile() {
  var domain = [],
    range = [],
    thresholds = [],
    unknown;

  function rescale() {
    var i = 0,
      n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = quantileSorted(domain, i / n);
    return scale;
  }

  function scale(x) {
    return x == null || isNaN((x = +x)) ? unknown : range[bisectRight(thresholds, x)];
  }

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0
      ? [NaN, NaN]
      : [i > 0 ? thresholds[i - 1] : domain[0], i < thresholds.length ? thresholds[i] : domain[domain.length - 1]];
  };

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN((d = +d))) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };

  scale.range = function (_) {
    return arguments.length ? ((range = Array.from(_)), rescale()) : range.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? ((unknown = _), scale) : unknown;
  };

  scale.quantiles = function () {
    return thresholds.slice();
  };

  scale.copy = function () {
    return quantile().domain(domain).range(range).unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

function quantize() {
  var x0 = 0,
    x1 = 1,
    n = 1,
    domain = [0.5],
    range = [0, 1],
    unknown;

  function scale(x) {
    return x != null && x <= x ? range[bisectRight(domain, x, 0, n)] : unknown;
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function (_) {
    return arguments.length ? (([x0, x1] = _), (x0 = +x0), (x1 = +x1), rescale()) : [x0, x1];
  };

  scale.range = function (_) {
    return arguments.length ? ((n = (range = Array.from(_)).length - 1), rescale()) : range.slice();
  };

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : i >= n ? [domain[n - 1], x1] : [domain[i - 1], domain[i]];
  };

  scale.unknown = function (_) {
    return arguments.length ? ((unknown = _), scale) : scale;
  };

  scale.thresholds = function () {
    return domain.slice();
  };

  scale.copy = function () {
    return quantize().domain([x0, x1]).range(range).unknown(unknown);
  };

  return initRange.apply(linearish(scale), arguments);
}

function threshold() {
  var domain = [0.5],
    range = [0, 1],
    unknown,
    n = 1;

  function scale(x) {
    return x != null && x <= x ? range[bisectRight(domain, x, 0, n)] : unknown;
  }

  scale.domain = function (_) {
    return arguments.length
      ? ((domain = Array.from(_)), (n = Math.min(domain.length, range.length - 1)), scale)
      : domain.slice();
  };

  scale.range = function (_) {
    return arguments.length
      ? ((range = Array.from(_)), (n = Math.min(domain.length, range.length - 1)), scale)
      : range.slice();
  };

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function (_) {
    return arguments.length ? ((unknown = _), scale) : unknown;
  };

  scale.copy = function () {
    return threshold().domain(domain).range(range).unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

const t0 = new Date(),
  t1 = new Date();

function timeInterval(floori, offseti, count, field) {
  function interval(date) {
    return floori((date = arguments.length === 0 ? new Date() : new Date(+date))), date;
  }

  interval.floor = (date) => {
    return floori((date = new Date(+date))), date;
  };

  interval.ceil = (date) => {
    return floori((date = new Date(date - 1))), offseti(date, 1), floori(date), date;
  };

  interval.round = (date) => {
    const d0 = interval(date),
      d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = (date, step) => {
    return offseti((date = new Date(+date)), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = (start, stop, step) => {
    const range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    let previous;
    do range.push((previous = new Date(+start))), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = (test) => {
    return timeInterval(
      (date) => {
        if (date >= date) while ((floori(date), !test(date))) date.setTime(date - 1);
      },
      (date, step) => {
        if (date >= date) {
          if (step < 0)
            while (++step <= 0) {
              while ((offseti(date, -1), !test(date))) {} // eslint-disable-line no-empty
            }
          else
            while (--step >= 0) {
              while ((offseti(date, +1), !test(date))) {} // eslint-disable-line no-empty
            }
        }
      },
    );
  };

  if (count) {
    interval.count = (start, end) => {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = (step) => {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0)
        ? null
        : !(step > 1)
        ? interval
        : interval.filter(field ? (d) => field(d) % step === 0 : (d) => interval.count(0, d) % step === 0);
    };
  }

  return interval;
}

const millisecond = timeInterval(
  () => {
    // noop
  },
  (date, step) => {
    date.setTime(+date + step);
  },
  (start, end) => {
    return end - start;
  },
);

// An optimized implementation for this simple case.
millisecond.every = (k) => {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return timeInterval(
    (date) => {
      date.setTime(Math.floor(date / k) * k);
    },
    (date, step) => {
      date.setTime(+date + step * k);
    },
    (start, end) => {
      return (end - start) / k;
    },
  );
};

millisecond.range;

const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

const second = timeInterval(
  (date) => {
    date.setTime(date - date.getMilliseconds());
  },
  (date, step) => {
    date.setTime(+date + step * durationSecond);
  },
  (start, end) => {
    return (end - start) / durationSecond;
  },
  (date) => {
    return date.getUTCSeconds();
  },
);

second.range;

const timeMinute = timeInterval(
  (date) => {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
  },
  (date, step) => {
    date.setTime(+date + step * durationMinute);
  },
  (start, end) => {
    return (end - start) / durationMinute;
  },
  (date) => {
    return date.getMinutes();
  },
);

timeMinute.range;

const utcMinute = timeInterval(
  (date) => {
    date.setUTCSeconds(0, 0);
  },
  (date, step) => {
    date.setTime(+date + step * durationMinute);
  },
  (start, end) => {
    return (end - start) / durationMinute;
  },
  (date) => {
    return date.getUTCMinutes();
  },
);

utcMinute.range;

const timeHour = timeInterval(
  (date) => {
    date.setTime(
      date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute,
    );
  },
  (date, step) => {
    date.setTime(+date + step * durationHour);
  },
  (start, end) => {
    return (end - start) / durationHour;
  },
  (date) => {
    return date.getHours();
  },
);

timeHour.range;

const utcHour = timeInterval(
  (date) => {
    date.setUTCMinutes(0, 0, 0);
  },
  (date, step) => {
    date.setTime(+date + step * durationHour);
  },
  (start, end) => {
    return (end - start) / durationHour;
  },
  (date) => {
    return date.getUTCHours();
  },
);

utcHour.range;

const timeDay = timeInterval(
  (date) => date.setHours(0, 0, 0, 0),
  (date, step) => date.setDate(date.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay,
  (date) => date.getDate() - 1,
);

timeDay.range;

const utcDay = timeInterval(
  (date) => {
    date.setUTCHours(0, 0, 0, 0);
  },
  (date, step) => {
    date.setUTCDate(date.getUTCDate() + step);
  },
  (start, end) => {
    return (end - start) / durationDay;
  },
  (date) => {
    return date.getUTCDate() - 1;
  },
);

utcDay.range;

const unixDay = timeInterval(
  (date) => {
    date.setUTCHours(0, 0, 0, 0);
  },
  (date, step) => {
    date.setUTCDate(date.getUTCDate() + step);
  },
  (start, end) => {
    return (end - start) / durationDay;
  },
  (date) => {
    return Math.floor(date / durationDay);
  },
);

unixDay.range;

function timeWeekday(i) {
  return timeInterval(
    (date) => {
      date.setDate(date.getDate() - ((date.getDay() + 7 - i) % 7));
      date.setHours(0, 0, 0, 0);
    },
    (date, step) => {
      date.setDate(date.getDate() + step * 7);
    },
    (start, end) => {
      return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
    },
  );
}

const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);

timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;

function utcWeekday(i) {
  return timeInterval(
    (date) => {
      date.setUTCDate(date.getUTCDate() - ((date.getUTCDay() + 7 - i) % 7));
      date.setUTCHours(0, 0, 0, 0);
    },
    (date, step) => {
      date.setUTCDate(date.getUTCDate() + step * 7);
    },
    (start, end) => {
      return (end - start) / durationWeek;
    },
  );
}

const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);

utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;

const timeMonth = timeInterval(
  (date) => {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
  },
  (date, step) => {
    date.setMonth(date.getMonth() + step);
  },
  (start, end) => {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
  },
  (date) => {
    return date.getMonth();
  },
);

timeMonth.range;

const utcMonth = timeInterval(
  (date) => {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
  },
  (date, step) => {
    date.setUTCMonth(date.getUTCMonth() + step);
  },
  (start, end) => {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
  },
  (date) => {
    return date.getUTCMonth();
  },
);

utcMonth.range;

const timeYear = timeInterval(
  (date) => {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  },
  (date, step) => {
    date.setFullYear(date.getFullYear() + step);
  },
  (start, end) => {
    return end.getFullYear() - start.getFullYear();
  },
  (date) => {
    return date.getFullYear();
  },
);

// An optimized implementation for this simple case.
timeYear.every = (k) => {
  return !isFinite((k = Math.floor(k))) || !(k > 0)
    ? null
    : timeInterval(
        (date) => {
          date.setFullYear(Math.floor(date.getFullYear() / k) * k);
          date.setMonth(0, 1);
          date.setHours(0, 0, 0, 0);
        },
        (date, step) => {
          date.setFullYear(date.getFullYear() + step * k);
        },
      );
};

timeYear.range;

const utcYear = timeInterval(
  (date) => {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  },
  (date, step) => {
    date.setUTCFullYear(date.getUTCFullYear() + step);
  },
  (start, end) => {
    return end.getUTCFullYear() - start.getUTCFullYear();
  },
  (date) => {
    return date.getUTCFullYear();
  },
);

// An optimized implementation for this simple case.
utcYear.every = (k) => {
  return !isFinite((k = Math.floor(k))) || !(k > 0)
    ? null
    : timeInterval(
        (date) => {
          date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
          date.setUTCMonth(0, 1);
          date.setUTCHours(0, 0, 0, 0);
        },
        (date, step) => {
          date.setUTCFullYear(date.getUTCFullYear() + step * k);
        },
      );
};

utcYear.range;

function ticker(year, month, week, day, hour, minute) {
  const tickIntervals = [
    [second, 1, durationSecond],
    [second, 5, 5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute, 1, durationMinute],
    [minute, 5, 5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [hour, 1, durationHour],
    [hour, 3, 3 * durationHour],
    [hour, 6, 6 * durationHour],
    [hour, 12, 12 * durationHour],
    [day, 1, durationDay],
    [day, 2, 2 * durationDay],
    [week, 1, durationWeek],
    [month, 1, durationMonth],
    [month, 3, 3 * durationMonth],
    [year, 1, durationYear],
  ];

  function ticks(start, stop, count) {
    const reverse = stop < start;
    if (reverse) [start, stop] = [stop, start];
    const interval = count && typeof count.range === 'function' ? count : tickInterval(start, stop, count);
    const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
    return reverse ? ticks.reverse() : ticks;
  }

  function tickInterval(start, stop, count) {
    const target = Math.abs(stop - start) / count;
    const i = bisector(([, , step]) => step).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
    if (i === 0) return millisecond.every(Math.max(tickStep(start, stop, count), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }

  return [ticks, tickInterval];
}

const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return { y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0 };
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
    locale_date = locale.date,
    locale_time = locale.time,
    locale_periods = locale.periods,
    locale_weekdays = locale.days,
    locale_shortWeekdays = locale.shortDays,
    locale_months = locale.months,
    locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
    periodLookup = formatLookup(locale_periods),
    weekdayRe = formatRe(locale_weekdays),
    weekdayLookup = formatLookup(locale_weekdays),
    shortWeekdayRe = formatRe(locale_shortWeekdays),
    shortWeekdayLookup = formatLookup(locale_shortWeekdays),
    monthRe = formatRe(locale_months),
    monthLookup = formatLookup(locale_months),
    shortMonthRe = formatRe(locale_shortMonths),
    shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    a: formatShortWeekday,
    A: formatWeekday,
    b: formatShortMonth,
    B: formatMonth,
    c: null,
    d: formatDayOfMonth,
    e: formatDayOfMonth,
    f: formatMicroseconds,
    g: formatYearISO,
    G: formatFullYearISO,
    H: formatHour24,
    I: formatHour12,
    j: formatDayOfYear,
    L: formatMilliseconds,
    m: formatMonthNumber,
    M: formatMinutes,
    p: formatPeriod,
    q: formatQuarter,
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatSeconds,
    u: formatWeekdayNumberMonday,
    U: formatWeekNumberSunday,
    V: formatWeekNumberISO,
    w: formatWeekdayNumberSunday,
    W: formatWeekNumberMonday,
    x: null,
    X: null,
    y: formatYear,
    Y: formatFullYear,
    Z: formatZone,
    '%': formatLiteralPercent,
  };

  var utcFormats = {
    a: formatUTCShortWeekday,
    A: formatUTCWeekday,
    b: formatUTCShortMonth,
    B: formatUTCMonth,
    c: null,
    d: formatUTCDayOfMonth,
    e: formatUTCDayOfMonth,
    f: formatUTCMicroseconds,
    g: formatUTCYearISO,
    G: formatUTCFullYearISO,
    H: formatUTCHour24,
    I: formatUTCHour12,
    j: formatUTCDayOfYear,
    L: formatUTCMilliseconds,
    m: formatUTCMonthNumber,
    M: formatUTCMinutes,
    p: formatUTCPeriod,
    q: formatUTCQuarter,
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatUTCSeconds,
    u: formatUTCWeekdayNumberMonday,
    U: formatUTCWeekNumberSunday,
    V: formatUTCWeekNumberISO,
    w: formatUTCWeekdayNumberSunday,
    W: formatUTCWeekNumberMonday,
    x: null,
    X: null,
    y: formatUTCYear,
    Y: formatUTCFullYear,
    Z: formatUTCZone,
    '%': formatLiteralPercent,
  };

  var parses = {
    a: parseShortWeekday,
    A: parseWeekday,
    b: parseShortMonth,
    B: parseMonth,
    c: parseLocaleDateTime,
    d: parseDayOfMonth,
    e: parseDayOfMonth,
    f: parseMicroseconds,
    g: parseYear$1,
    G: parseFullYear,
    H: parseHour24,
    I: parseHour24,
    j: parseDayOfYear,
    L: parseMilliseconds,
    m: parseMonthNumber,
    M: parseMinutes,
    p: parsePeriod,
    q: parseQuarter,
    Q: parseUnixTimestamp,
    s: parseUnixTimestampSeconds,
    S: parseSeconds,
    u: parseWeekdayNumberMonday,
    U: parseWeekNumberSunday,
    V: parseWeekNumberISO,
    w: parseWeekdayNumberSunday,
    W: parseWeekNumberMonday,
    x: parseLocaleDate,
    X: parseLocaleTime,
    y: parseYear$1,
    Y: parseFullYear,
    Z: parseZone,
    '%': parseLiteralPercent,
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function (date) {
      var string = [],
        i = -1,
        j = 0,
        n = specifier.length,
        c,
        pad,
        format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[(c = specifier.charAt(++i))]) != null) c = specifier.charAt(++i);
          else pad = c === 'e' ? ' ' : '0';
          if ((format = formats[c])) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join('');
    };
  }

  function newParse(specifier, Z) {
    return function (string) {
      var d = newDate(1900, undefined, 1),
        i = parseSpecifier(d, specifier, (string += ''), 0),
        week,
        day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ('Q' in d) return new Date(d.Q);
      if ('s' in d) return new Date(d.s * 1000 + ('L' in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !('Z' in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ('p' in d) d.H = (d.H % 12) + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = 'q' in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ('V' in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!('w' in d)) d.w = 1;
        if ('Z' in d) {
          (week = utcDate(newDate(d.y, 0, 1))), (day = week.getUTCDay());
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + ((d.w + 6) % 7);
        } else {
          (week = localDate(newDate(d.y, 0, 1))), (day = week.getDay());
          week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + ((d.w + 6) % 7);
        }
      } else if ('W' in d || 'U' in d) {
        if (!('w' in d)) d.w = 'u' in d ? d.u % 7 : 'W' in d ? 1 : 0;
        day = 'Z' in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = 'W' in d ? ((d.w + 6) % 7) + d.W * 7 - ((day + 5) % 7) : d.w + d.U * 7 - ((day + 6) % 7);
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ('Z' in d) {
        d.H += (d.Z / 100) | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
      n = specifier.length,
      m = string.length,
      c,
      parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || (j = parse(d, string, j)) < 0) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? ((d.p = periodLookup.get(n[0].toLowerCase())), i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? ((d.w = shortWeekdayLookup.get(n[0].toLowerCase())), i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? ((d.w = weekdayLookup.get(n[0].toLowerCase())), i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? ((d.m = shortMonthLookup.get(n[0].toLowerCase())), i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? ((d.m = monthLookup.get(n[0].toLowerCase())), i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function (specifier) {
      var f = newFormat((specifier += ''), formats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    parse: function (specifier) {
      var p = newParse((specifier += ''), false);
      p.toString = function () {
        return specifier;
      };
      return p;
    },
    utcFormat: function (specifier) {
      var f = newFormat((specifier += ''), utcFormats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    utcParse: function (specifier) {
      var p = newParse((specifier += ''), true);
      p.toString = function () {
        return specifier;
      };
      return p;
    },
  };
}

var pads = { '-': '', _: ' ', 0: '0' },
  numberRe = /^\s*\d+/, // note: ignores next directive
  percentRe = /^%/,
  requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? '-' : '',
    string = (sign ? -value : value) + '',
    length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, '\\$&');
}

function formatRe(names) {
  return new RegExp('^(?:' + names.map(requote).join('|') + ')', 'i');
}

function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? ((d.w = +n[0]), i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? ((d.u = +n[0]), i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? ((d.U = +n[0]), i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? ((d.V = +n[0]), i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? ((d.W = +n[0]), i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? ((d.y = +n[0]), i + n[0].length) : -1;
}

function parseYear$1(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? ((d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000)), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? ((d.Z = n[1] ? 0 : -(n[2] + (n[3] || '00'))), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? ((d.q = n[0] * 3 - 3), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? ((d.m = n[0] - 1), i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? ((d.d = +n[0]), i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? ((d.m = 0), (d.d = +n[0]), i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? ((d.H = +n[0]), i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? ((d.M = +n[0]), i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? ((d.S = +n[0]), i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? ((d.L = +n[0]), i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? ((d.L = Math.floor(n[0] / 1000)), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? ((d.Q = +n[0]), i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? ((d.s = +n[0]), i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + timeDay.count(timeYear(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + '000';
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(timeSunday.count(timeYear(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(timeMonday.count(timeYear(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? '-' : ((z *= -1), '+')) + pad((z / 60) | 0, '0', 2) + pad(z % 60, '0', 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + '000';
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return '+0000';
}

function formatLiteralPercent() {
  return '%';
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

var locale$1;
var timeFormat;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: '%x, %X',
  date: '%-m/%-d/%Y',
  time: '%-I:%M:%S %p',
  periods: ['AM', 'PM'],
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
});

function defaultLocale(definition) {
  locale$1 = formatLocale(definition);
  timeFormat = locale$1.format;
  locale$1.parse;
  utcFormat = locale$1.utcFormat;
  utcParse = locale$1.utcParse;
  return locale$1;
}

var isoSpecifier = '%Y-%m-%dT%H:%M:%S.%LZ';

function formatIsoNative(date) {
  return date.toISOString();
}

Date.prototype.toISOString ? formatIsoNative : utcFormat(isoSpecifier);

function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

+new Date('2000-01-01T00:00:00.000Z') ? parseIsoNative : utcParse(isoSpecifier);

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
  var scale = continuous(),
    invert = scale.invert,
    domain = scale.domain;

  var formatMillisecond = format('.%L'),
    formatSecond = format(':%S'),
    formatMinute = format('%I:%M'),
    formatHour = format('%I %p'),
    formatDay = format('%a %d'),
    formatWeek = format('%b %d'),
    formatMonth = format('%B'),
    formatYear = format('%Y');

  function tickFormat(date) {
    return (
      second(date) < date
        ? formatMillisecond
        : minute(date) < date
        ? formatSecond
        : hour(date) < date
        ? formatMinute
        : day(date) < date
        ? formatHour
        : month(date) < date
        ? week(date) < date
          ? formatDay
          : formatWeek
        : year(date) < date
        ? formatMonth
        : formatYear
    )(date);
  }

  scale.invert = function (y) {
    return new Date(invert(y));
  };

  scale.domain = function (_) {
    return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
  };

  scale.ticks = function (interval) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
  };

  scale.tickFormat = function (count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function (interval) {
    var d = domain();
    if (!interval || typeof interval.range !== 'function')
      interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
    return interval ? domain(nice(d, interval)) : scale;
  };

  scale.copy = function () {
    return copy$1(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
  };

  return scale;
}

function time() {
  return initRange.apply(
    calendar(
      timeTicks,
      timeTickInterval,
      timeYear,
      timeMonth,
      timeSunday,
      timeDay,
      timeHour,
      timeMinute,
      second,
      timeFormat,
    ).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]),
    arguments,
  );
}

function utcTime() {
  return initRange.apply(
    calendar(
      utcTicks,
      utcTickInterval,
      utcYear,
      utcMonth,
      utcSunday,
      utcDay,
      utcHour,
      utcMinute,
      second,
      utcFormat,
    ).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]),
    arguments,
  );
}

function transformer$1() {
  var x0 = 0,
    x1 = 1,
    t0,
    t1,
    k10,
    transform,
    interpolator = identity$3,
    clamp = false,
    unknown;

  function scale(x) {
    return x == null || isNaN((x = +x))
      ? unknown
      : interpolator(k10 === 0 ? 0.5 : ((x = (transform(x) - t0) * k10), clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function (_) {
    return arguments.length
      ? (([x0, x1] = _),
        (t0 = transform((x0 = +x0))),
        (t1 = transform((x1 = +x1))),
        (k10 = t0 === t1 ? 0 : 1 / (t1 - t0)),
        scale)
      : [x0, x1];
  };

  scale.clamp = function (_) {
    return arguments.length ? ((clamp = !!_), scale) : clamp;
  };

  scale.interpolator = function (_) {
    return arguments.length ? ((interpolator = _), scale) : interpolator;
  };

  function range(interpolate) {
    return function (_) {
      var r0, r1;
      return arguments.length
        ? (([r0, r1] = _), (interpolator = interpolate(r0, r1)), scale)
        : [interpolator(0), interpolator(1)];
    };
  }

  scale.range = range(interpolate);

  scale.rangeRound = range(interpolateRound);

  scale.unknown = function (_) {
    return arguments.length ? ((unknown = _), scale) : unknown;
  };

  return function (t) {
    (transform = t), (t0 = t(x0)), (t1 = t(x1)), (k10 = t0 === t1 ? 0 : 1 / (t1 - t0));
    return scale;
  };
}

function copy(source, target) {
  return target
    .domain(source.domain())
    .interpolator(source.interpolator())
    .clamp(source.clamp())
    .unknown(source.unknown());
}

function sequential() {
  var scale = linearish(transformer$1()(identity$3));

  scale.copy = function () {
    return copy(scale, sequential());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialLog() {
  var scale = loggish(transformer$1()).domain([1, 10]);

  scale.copy = function () {
    return copy(scale, sequentialLog()).base(scale.base());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialSymlog() {
  var scale = symlogish(transformer$1());

  scale.copy = function () {
    return copy(scale, sequentialSymlog()).constant(scale.constant());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialPow() {
  var scale = powish(transformer$1());

  scale.copy = function () {
    return copy(scale, sequentialPow()).exponent(scale.exponent());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}

function sequentialQuantile() {
  var domain = [],
    interpolator = identity$3;

  function scale(x) {
    if (x != null && !isNaN((x = +x))) return interpolator((bisectRight(domain, x, 1) - 1) / (domain.length - 1));
  }

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN((d = +d))) domain.push(d);
    domain.sort(ascending);
    return scale;
  };

  scale.interpolator = function (_) {
    return arguments.length ? ((interpolator = _), scale) : interpolator;
  };

  scale.range = function () {
    return domain.map((d, i) => interpolator(i / (domain.length - 1)));
  };

  scale.quantiles = function (n) {
    return Array.from({ length: n + 1 }, (_, i) => quantile$1(domain, i / n));
  };

  scale.copy = function () {
    return sequentialQuantile(interpolator).domain(domain);
  };

  return initInterpolator.apply(scale, arguments);
}

function transformer() {
  var x0 = 0,
    x1 = 0.5,
    x2 = 1,
    s = 1,
    t0,
    t1,
    t2,
    k10,
    k21,
    interpolator = identity$3,
    transform,
    clamp = false,
    unknown;

  function scale(x) {
    return isNaN((x = +x))
      ? unknown
      : ((x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21)),
        interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function (_) {
    return arguments.length
      ? (([x0, x1, x2] = _),
        (t0 = transform((x0 = +x0))),
        (t1 = transform((x1 = +x1))),
        (t2 = transform((x2 = +x2))),
        (k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0)),
        (k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1)),
        (s = t1 < t0 ? -1 : 1),
        scale)
      : [x0, x1, x2];
  };

  scale.clamp = function (_) {
    return arguments.length ? ((clamp = !!_), scale) : clamp;
  };

  scale.interpolator = function (_) {
    return arguments.length ? ((interpolator = _), scale) : interpolator;
  };

  function range(interpolate) {
    return function (_) {
      var r0, r1, r2;
      return arguments.length
        ? (([r0, r1, r2] = _), (interpolator = piecewise(interpolate, [r0, r1, r2])), scale)
        : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }

  scale.range = range(interpolate);

  scale.rangeRound = range(interpolateRound);

  scale.unknown = function (_) {
    return arguments.length ? ((unknown = _), scale) : unknown;
  };

  return function (t) {
    (transform = t),
      (t0 = t(x0)),
      (t1 = t(x1)),
      (t2 = t(x2)),
      (k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0)),
      (k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1)),
      (s = t1 < t0 ? -1 : 1);
    return scale;
  };
}

function diverging() {
  var scale = linearish(transformer()(identity$3));

  scale.copy = function () {
    return copy(scale, diverging());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingLog() {
  var scale = loggish(transformer()).domain([0.1, 1, 10]);

  scale.copy = function () {
    return copy(scale, divergingLog()).base(scale.base());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingSymlog() {
  var scale = symlogish(transformer());

  scale.copy = function () {
    return copy(scale, divergingSymlog()).constant(scale.constant());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingPow() {
  var scale = powish(transformer());

  scale.copy = function () {
    return copy(scale, divergingPow()).exponent(scale.exponent());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}

var d3Scales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  scaleBand: band,
  scalePoint: point,
  scaleIdentity: identity$1,
  scaleLinear: linear,
  scaleLog: log,
  scaleSymlog: symlog,
  scaleOrdinal: ordinal,
  scaleImplicit: implicit,
  scalePow: pow,
  scaleSqrt: sqrt,
  scaleRadial: radial,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleThreshold: threshold,
  scaleTime: time,
  scaleUtc: utcTime,
  scaleSequential: sequential,
  scaleSequentialLog: sequentialLog,
  scaleSequentialPow: sequentialPow,
  scaleSequentialSqrt: sequentialSqrt,
  scaleSequentialSymlog: sequentialSymlog,
  scaleSequentialQuantile: sequentialQuantile,
  scaleDiverging: diverging,
  scaleDivergingLog: divergingLog,
  scaleDivergingPow: divergingPow,
  scaleDivergingSqrt: divergingSqrt,
  scaleDivergingSymlog: divergingSymlog,
  tickFormat: tickFormat,
});

/*
 *  decimal.js-light v2.5.1
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js-light
 *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Expat Licence
 */

// ------------------------------------  EDITABLE DEFAULTS  ------------------------------------- //

// The limit on the value of `precision`, and on the value of the first argument to
// `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
var MAX_DIGITS = 1e9, // 0 to 1e9
  // The initial configuration properties of the Decimal constructor.
  defaults = {
    // These values must be integers within the stated ranges (inclusive).
    // Most of these values can be changed during run-time using `Decimal.config`.

    // The maximum number of significant digits of the result of a calculation or base conversion.
    // E.g. `Decimal.config({ precision: 20 });`
    precision: 20, // 1 to MAX_DIGITS

    // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
    // `toFixed`, `toPrecision` and `toSignificantDigits`.
    //
    // ROUND_UP         0 Away from zero.
    // ROUND_DOWN       1 Towards zero.
    // ROUND_CEIL       2 Towards +Infinity.
    // ROUND_FLOOR      3 Towards -Infinity.
    // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    //
    // E.g.
    // `Decimal.rounding = 4;`
    // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
    rounding: 4, // 0 to 8

    // The exponent value at and beneath which `toString` returns exponential notation.
    // JavaScript numbers: -7
    toExpNeg: -7, // 0 to -MAX_E

    // The exponent value at and above which `toString` returns exponential notation.
    // JavaScript numbers: 21
    toExpPos: 21, // 0 to MAX_E

    // The natural logarithm of 10.
    // 115 digits
    LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286',
  },
  // ------------------------------------ END OF EDITABLE DEFAULTS -------------------------------- //

  Decimal,
  external = true,
  decimalError = '[DecimalError] ',
  invalidArgument = decimalError + 'Invalid argument: ',
  exponentOutOfRange = decimalError + 'Exponent out of range: ',
  mathfloor = Math.floor,
  mathpow = Math.pow,
  isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
  ONE,
  BASE = 1e7,
  LOG_BASE = 7,
  MAX_SAFE_INTEGER = 9007199254740991,
  MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // 1286742750677284
  // Decimal.prototype object
  P$1 = {};

// Decimal prototype methods

/*
 *  absoluteValue                       abs
 *  comparedTo                          cmp
 *  decimalPlaces                       dp
 *  dividedBy                           div
 *  dividedToIntegerBy                  idiv
 *  equals                              eq
 *  exponent
 *  greaterThan                         gt
 *  greaterThanOrEqualTo                gte
 *  isInteger                           isint
 *  isNegative                          isneg
 *  isPositive                          ispos
 *  isZero
 *  lessThan                            lt
 *  lessThanOrEqualTo                   lte
 *  logarithm                           log
 *  minus                               sub
 *  modulo                              mod
 *  naturalExponential                  exp
 *  naturalLogarithm                    ln
 *  negated                             neg
 *  plus                                add
 *  precision                           sd
 *  squareRoot                          sqrt
 *  times                               mul
 *  toDecimalPlaces                     todp
 *  toExponential
 *  toFixed
 *  toInteger                           toint
 *  toNumber
 *  toPower                             pow
 *  toPrecision
 *  toSignificantDigits                 tosd
 *  toString
 *  valueOf                             val
 */

/*
 * Return a new Decimal whose value is the absolute value of this Decimal.
 *
 */
P$1.absoluteValue = P$1.abs = function () {
  var x = new this.constructor(this);
  if (x.s) x.s = 1;
  return x;
};

/*
 * Return
 *   1    if the value of this Decimal is greater than the value of `y`,
 *  -1    if the value of this Decimal is less than the value of `y`,
 *   0    if they have the same value
 *
 */
P$1.comparedTo = P$1.cmp = function (y) {
  var i,
    j,
    xdL,
    ydL,
    x = this;

  y = new x.constructor(y);

  // Signs differ?
  if (x.s !== y.s) return x.s || -y.s;

  // Compare exponents.
  if (x.e !== y.e) return (x.e > y.e) ^ (x.s < 0) ? 1 : -1;

  xdL = x.d.length;
  ydL = y.d.length;

  // Compare digit by digit.
  for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
    if (x.d[i] !== y.d[i]) return (x.d[i] > y.d[i]) ^ (x.s < 0) ? 1 : -1;
  }

  // Compare lengths.
  return xdL === ydL ? 0 : (xdL > ydL) ^ (x.s < 0) ? 1 : -1;
};

/*
 * Return the number of decimal places of the value of this Decimal.
 *
 */
P$1.decimalPlaces = P$1.dp = function () {
  var x = this,
    w = x.d.length - 1,
    dp = (w - x.e) * LOG_BASE;

  // Subtract the number of trailing zeros of the last word.
  w = x.d[w];
  if (w) for (; w % 10 == 0; w /= 10) dp--;

  return dp < 0 ? 0 : dp;
};

/*
 * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
 * `precision` significant digits.
 *
 */
P$1.dividedBy = P$1.div = function (y) {
  return divide(this, new this.constructor(y));
};

/*
 * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
 * by the value of `y`, truncated to `precision` significant digits.
 *
 */
P$1.dividedToIntegerBy = P$1.idiv = function (y) {
  var x = this,
    Ctor = x.constructor;
  return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
};

/*
 * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
 *
 */
P$1.equals = P$1.eq = function (y) {
  return !this.cmp(y);
};

/*
 * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
 *
 */
P$1.exponent = function () {
  return getBase10Exponent(this);
};

/*
 * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
 * false.
 *
 */
P$1.greaterThan = P$1.gt = function (y) {
  return this.cmp(y) > 0;
};

/*
 * Return true if the value of this Decimal is greater than or equal to the value of `y`,
 * otherwise return false.
 *
 */
P$1.greaterThanOrEqualTo = P$1.gte = function (y) {
  return this.cmp(y) >= 0;
};

/*
 * Return true if the value of this Decimal is an integer, otherwise return false.
 *
 */
P$1.isInteger = P$1.isint = function () {
  return this.e > this.d.length - 2;
};

/*
 * Return true if the value of this Decimal is negative, otherwise return false.
 *
 */
P$1.isNegative = P$1.isneg = function () {
  return this.s < 0;
};

/*
 * Return true if the value of this Decimal is positive, otherwise return false.
 *
 */
P$1.isPositive = P$1.ispos = function () {
  return this.s > 0;
};

/*
 * Return true if the value of this Decimal is 0, otherwise return false.
 *
 */
P$1.isZero = function () {
  return this.s === 0;
};

/*
 * Return true if the value of this Decimal is less than `y`, otherwise return false.
 *
 */
P$1.lessThan = P$1.lt = function (y) {
  return this.cmp(y) < 0;
};

/*
 * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
 *
 */
P$1.lessThanOrEqualTo = P$1.lte = function (y) {
  return this.cmp(y) < 1;
};

/*
 * Return the logarithm of the value of this Decimal to the specified base, truncated to
 * `precision` significant digits.
 *
 * If no base is specified, return log[10](x).
 *
 * log[base](x) = ln(x) / ln(base)
 *
 * The maximum error of the result is 1 ulp (unit in the last place).
 *
 * [base] {number|string|Decimal} The base of the logarithm.
 *
 */
P$1.logarithm = P$1.log = function (base) {
  var r,
    x = this,
    Ctor = x.constructor,
    pr = Ctor.precision,
    wpr = pr + 5;

  // Default base is 10.
  if (base === void 0) {
    base = new Ctor(10);
  } else {
    base = new Ctor(base);

    // log[-b](x) = NaN
    // log[0](x)  = NaN
    // log[1](x)  = NaN
    if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
  }

  // log[b](-x) = NaN
  // log[b](0) = -Infinity
  if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

  // log[b](1) = 0
  if (x.eq(ONE)) return new Ctor(0);

  external = false;
  r = divide(ln(x, wpr), ln(base, wpr), wpr);
  external = true;

  return round(r, pr);
};

/*
 * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
 * `precision` significant digits.
 *
 */
P$1.minus = P$1.sub = function (y) {
  var x = this;
  y = new x.constructor(y);
  return x.s == y.s ? subtract(x, y) : add(x, ((y.s = -y.s), y));
};

/*
 * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
 * `precision` significant digits.
 *
 */
P$1.modulo = P$1.mod = function (y) {
  var q,
    x = this,
    Ctor = x.constructor,
    pr = Ctor.precision;

  y = new Ctor(y);

  // x % 0 = NaN
  if (!y.s) throw Error(decimalError + 'NaN');

  // Return x if x is 0.
  if (!x.s) return round(new Ctor(x), pr);

  // Prevent rounding of intermediate calculations.
  external = false;
  q = divide(x, y, 0, 1).times(y);
  external = true;

  return x.minus(q);
};

/*
 * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
 * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
 * significant digits.
 *
 */
P$1.naturalExponential = P$1.exp = function () {
  return exp(this);
};

/*
 * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
 * truncated to `precision` significant digits.
 *
 */
P$1.naturalLogarithm = P$1.ln = function () {
  return ln(this);
};

/*
 * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
 * -1.
 *
 */
P$1.negated = P$1.neg = function () {
  var x = new this.constructor(this);
  x.s = -x.s || 0;
  return x;
};

/*
 * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
 * `precision` significant digits.
 *
 */
P$1.plus = P$1.add = function (y) {
  var x = this;
  y = new x.constructor(y);
  return x.s == y.s ? add(x, y) : subtract(x, ((y.s = -y.s), y));
};

/*
 * Return the number of significant digits of the value of this Decimal.
 *
 * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
 *
 */
P$1.precision = P$1.sd = function (z) {
  var e,
    sd,
    w,
    x = this;

  if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);

  e = getBase10Exponent(x) + 1;
  w = x.d.length - 1;
  sd = w * LOG_BASE + 1;
  w = x.d[w];

  // If non-zero...
  if (w) {
    // Subtract the number of trailing zeros of the last word.
    for (; w % 10 == 0; w /= 10) sd--;

    // Add the number of digits of the first word.
    for (w = x.d[0]; w >= 10; w /= 10) sd++;
  }

  return z && e > sd ? e : sd;
};

/*
 * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
 * significant digits.
 *
 */
P$1.squareRoot = P$1.sqrt = function () {
  var e,
    n,
    pr,
    r,
    s,
    t,
    wpr,
    x = this,
    Ctor = x.constructor;

  // Negative or zero?
  if (x.s < 1) {
    if (!x.s) return new Ctor(0);

    // sqrt(-x) = NaN
    throw Error(decimalError + 'NaN');
  }

  e = getBase10Exponent(x);
  external = false;

  // Initial estimate.
  s = Math.sqrt(+x);

  // Math.sqrt underflow/overflow?
  // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
  if (s == 0 || s == 1 / 0) {
    n = digitsToString(x.d);
    if ((n.length + e) % 2 == 0) n += '0';
    s = Math.sqrt(n);
    e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);

    if (s == 1 / 0) {
      n = '5e' + e;
    } else {
      n = s.toExponential();
      n = n.slice(0, n.indexOf('e') + 1) + e;
    }

    r = new Ctor(n);
  } else {
    r = new Ctor(s.toString());
  }

  pr = Ctor.precision;
  s = wpr = pr + 3;

  // Newton-Raphson iteration.
  for (;;) {
    t = r;
    r = t.plus(divide(x, t, wpr + 2)).times(0.5);

    if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
      n = n.slice(wpr - 3, wpr + 1);

      // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
      // 4999, i.e. approaching a rounding boundary, continue the iteration.
      if (s == wpr && n == '4999') {
        // On the first iteration only, check to see if rounding up gives the exact result as the
        // nines may infinitely repeat.
        round(t, pr + 1, 0);

        if (t.times(t).eq(x)) {
          r = t;
          break;
        }
      } else if (n != '9999') {
        break;
      }

      wpr += 4;
    }
  }

  external = true;

  return round(r, pr);
};

/*
 * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
 * `precision` significant digits.
 *
 */
P$1.times = P$1.mul = function (y) {
  var carry,
    e,
    i,
    k,
    r,
    rL,
    t,
    xdL,
    ydL,
    x = this,
    Ctor = x.constructor,
    xd = x.d,
    yd = (y = new Ctor(y)).d;

  // Return 0 if either is 0.
  if (!x.s || !y.s) return new Ctor(0);

  y.s *= x.s;
  e = x.e + y.e;
  xdL = xd.length;
  ydL = yd.length;

  // Ensure xd points to the longer array.
  if (xdL < ydL) {
    r = xd;
    xd = yd;
    yd = r;
    rL = xdL;
    xdL = ydL;
    ydL = rL;
  }

  // Initialise the result array with zeros.
  r = [];
  rL = xdL + ydL;
  for (i = rL; i--; ) r.push(0);

  // Multiply!
  for (i = ydL; --i >= 0; ) {
    carry = 0;
    for (k = xdL + i; k > i; ) {
      t = r[k] + yd[i] * xd[k - i - 1] + carry;
      r[k--] = t % BASE | 0;
      carry = (t / BASE) | 0;
    }

    r[k] = (r[k] + carry) % BASE | 0;
  }

  // Remove trailing zeros.
  for (; !r[--rL]; ) r.pop();

  if (carry) ++e;
  else r.shift();

  y.d = r;
  y.e = e;

  return external ? round(y, Ctor.precision) : y;
};

/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
 * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
 *
 * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P$1.toDecimalPlaces = P$1.todp = function (dp, rm) {
  var x = this,
    Ctor = x.constructor;

  x = new Ctor(x);
  if (dp === void 0) return x;

  checkInt32(dp, 0, MAX_DIGITS);

  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);

  return round(x, dp + getBase10Exponent(x) + 1, rm);
};

/*
 * Return a string representing the value of this Decimal in exponential notation rounded to
 * `dp` fixed decimal places using rounding mode `rounding`.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P$1.toExponential = function (dp, rm) {
  var str,
    x = this,
    Ctor = x.constructor;

  if (dp === void 0) {
    str = toString(x, true);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    x = round(new Ctor(x), dp + 1, rm);
    str = toString(x, true, dp + 1);
  }

  return str;
};

/*
 * Return a string representing the value of this Decimal in normal (fixed-point) notation to
 * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
 * omitted.
 *
 * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 * (-0).toFixed(3) is '0.000'.
 * (-0.5).toFixed(0) is '-0'.
 *
 */
P$1.toFixed = function (dp, rm) {
  var str,
    y,
    x = this,
    Ctor = x.constructor;

  if (dp === void 0) return toString(x);

  checkInt32(dp, 0, MAX_DIGITS);

  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);

  y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
  str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);

  // To determine whether to add the minus sign look at the value before it was rounded,
  // i.e. look at `x` rather than `y`.
  return x.isneg() && !x.isZero() ? '-' + str : str;
};

/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
 * rounding mode `rounding`.
 *
 */
P$1.toInteger = P$1.toint = function () {
  var x = this,
    Ctor = x.constructor;
  return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
};

/*
 * Return the value of this Decimal converted to a number primitive.
 *
 */
P$1.toNumber = function () {
  return +this;
};

/*
 * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
 * truncated to `precision` significant digits.
 *
 * For non-integer or very large exponents pow(x, y) is calculated using
 *
 *   x^y = exp(y*ln(x))
 *
 * The maximum error is 1 ulp (unit in last place).
 *
 * y {number|string|Decimal} The power to which to raise this Decimal.
 *
 */
P$1.toPower = P$1.pow = function (y) {
  var e,
    k,
    pr,
    r,
    sign,
    yIsInt,
    x = this,
    Ctor = x.constructor,
    guard = 12,
    yn = +(y = new Ctor(y));

  // pow(x, 0) = 1
  if (!y.s) return new Ctor(ONE);

  x = new Ctor(x);

  // pow(0, y > 0) = 0
  // pow(0, y < 0) = Infinity
  if (!x.s) {
    if (y.s < 1) throw Error(decimalError + 'Infinity');
    return x;
  }

  // pow(1, y) = 1
  if (x.eq(ONE)) return x;

  pr = Ctor.precision;

  // pow(x, 1) = x
  if (y.eq(ONE)) return round(x, pr);

  e = y.e;
  k = y.d.length - 1;
  yIsInt = e >= k;
  sign = x.s;

  if (!yIsInt) {
    // pow(x < 0, y non-integer) = NaN
    if (sign < 0) throw Error(decimalError + 'NaN');

    // If y is a small integer use the 'exponentiation by squaring' algorithm.
  } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
    r = new Ctor(ONE);

    // Max k of 9007199254740991 takes 53 loop iterations.
    // Maximum digits array length; leaves [28, 34] guard digits.
    e = Math.ceil(pr / LOG_BASE + 4);

    external = false;

    for (;;) {
      if (k % 2) {
        r = r.times(x);
        truncate(r.d, e);
      }

      k = mathfloor(k / 2);
      if (k === 0) break;

      x = x.times(x);
      truncate(x.d, e);
    }

    external = true;

    return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
  }

  // Result is negative if x is negative and the last digit of integer y is odd.
  sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;

  x.s = 1;
  external = false;
  r = y.times(ln(x, pr + guard));
  external = true;
  r = exp(r);
  r.s = sign;

  return r;
};

/*
 * Return a string representing the value of this Decimal rounded to `sd` significant digits
 * using rounding mode `rounding`.
 *
 * Return exponential notation if `sd` is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P$1.toPrecision = function (sd, rm) {
  var e,
    str,
    x = this,
    Ctor = x.constructor;

  if (sd === void 0) {
    e = getBase10Exponent(x);
    str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
  } else {
    checkInt32(sd, 1, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    x = round(new Ctor(x), sd, rm);
    e = getBase10Exponent(x);
    str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
  }

  return str;
};

/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
 * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
 * omitted.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P$1.toSignificantDigits = P$1.tosd = function (sd, rm) {
  var x = this,
    Ctor = x.constructor;

  if (sd === void 0) {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  } else {
    checkInt32(sd, 1, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  }

  return round(new Ctor(x), sd, rm);
};

/*
 * Return a string representing the value of this Decimal.
 *
 * Return exponential notation if this Decimal has a positive exponent equal to or greater than
 * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
 *
 */
P$1.toString =
  P$1.valueOf =
  P$1.val =
  P$1.toJSON =
  P$1[Symbol.for('nodejs.util.inspect.custom')] =
    function () {
      var x = this,
        e = getBase10Exponent(x),
        Ctor = x.constructor;

      return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };

// Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.

/*
 *  add                 P.minus, P.plus
 *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
 *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
 *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
 *  exp                 P.exp, P.pow
 *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
 *                      P.toString, divide, round, toString, exp, ln
 *  getLn10             P.log, ln
 *  getZeroString       digitsToString, toString
 *  ln                  P.log, P.ln, P.pow, exp
 *  parseDecimal        Decimal
 *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
 *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
 *                      divide, getLn10, exp, ln
 *  subtract            P.minus, P.plus
 *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
 *  truncate            P.pow
 *
 *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
 *                      getLn10, exp, ln, parseDecimal, Decimal, config
 */

function add(x, y) {
  var carry,
    d,
    e,
    i,
    k,
    len,
    xd,
    yd,
    Ctor = x.constructor,
    pr = Ctor.precision;

  // If either is zero...
  if (!x.s || !y.s) {
    // Return x if y is zero.
    // Return y if y is non-zero.
    if (!y.s) y = new Ctor(x);
    return external ? round(y, pr) : y;
  }

  xd = x.d;
  yd = y.d;

  // x and y are finite, non-zero numbers with the same sign.

  k = x.e;
  e = y.e;
  xd = xd.slice();
  i = k - e;

  // If base 1e7 exponents differ...
  if (i) {
    if (i < 0) {
      d = xd;
      i = -i;
      len = yd.length;
    } else {
      d = yd;
      e = k;
      len = xd.length;
    }

    // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
    k = Math.ceil(pr / LOG_BASE);
    len = k > len ? k + 1 : len + 1;

    if (i > len) {
      i = len;
      d.length = 1;
    }

    // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
    d.reverse();
    for (; i--; ) d.push(0);
    d.reverse();
  }

  len = xd.length;
  i = yd.length;

  // If yd is longer than xd, swap xd and yd so xd points to the longer array.
  if (len - i < 0) {
    i = len;
    d = yd;
    yd = xd;
    xd = d;
  }

  // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
  for (carry = 0; i; ) {
    carry = ((xd[--i] = xd[i] + yd[i] + carry) / BASE) | 0;
    xd[i] %= BASE;
  }

  if (carry) {
    xd.unshift(carry);
    ++e;
  }

  // Remove trailing zeros.
  // No need to check for zero, as +x + +y != 0 && -x + -y != 0
  for (len = xd.length; xd[--len] == 0; ) xd.pop();

  y.d = xd;
  y.e = e;

  return external ? round(y, pr) : y;
}

function checkInt32(i, min, max) {
  if (i !== ~~i || i < min || i > max) {
    throw Error(invalidArgument + i);
  }
}

function digitsToString(d) {
  var i,
    k,
    ws,
    indexOfLastWord = d.length - 1,
    str = '',
    w = d[0];

  if (indexOfLastWord > 0) {
    str += w;
    for (i = 1; i < indexOfLastWord; i++) {
      ws = d[i] + '';
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
      str += ws;
    }

    w = d[i];
    ws = w + '';
    k = LOG_BASE - ws.length;
    if (k) str += getZeroString(k);
  } else if (w === 0) {
    return '0';
  }

  // Remove trailing zeros of last w.
  for (; w % 10 === 0; ) w /= 10;

  return str + w;
}

var divide = (function () {
  // Assumes non-zero x and k, and hence non-zero result.
  function multiplyInteger(x, k) {
    var temp,
      carry = 0,
      i = x.length;

    for (x = x.slice(); i--; ) {
      temp = x[i] * k + carry;
      x[i] = temp % BASE | 0;
      carry = (temp / BASE) | 0;
    }

    if (carry) x.unshift(carry);

    return x;
  }

  function compare(a, b, aL, bL) {
    var i, r;

    if (aL != bL) {
      r = aL > bL ? 1 : -1;
    } else {
      for (i = r = 0; i < aL; i++) {
        if (a[i] != b[i]) {
          r = a[i] > b[i] ? 1 : -1;
          break;
        }
      }
    }

    return r;
  }

  function subtract(a, b, aL) {
    var i = 0;

    // Subtract b from a.
    for (; aL--; ) {
      a[aL] -= i;
      i = a[aL] < b[aL] ? 1 : 0;
      a[aL] = i * BASE + a[aL] - b[aL];
    }

    // Remove leading zeros.
    for (; !a[0] && a.length > 1; ) a.shift();
  }

  return function (x, y, pr, dp) {
    var cmp,
      e,
      i,
      k,
      prod,
      prodL,
      q,
      qd,
      rem,
      remL,
      rem0,
      sd,
      t,
      xi,
      xL,
      yd0,
      yL,
      yz,
      Ctor = x.constructor,
      sign = x.s == y.s ? 1 : -1,
      xd = x.d,
      yd = y.d;

    // Either 0?
    if (!x.s) return new Ctor(x);
    if (!y.s) throw Error(decimalError + 'Division by zero');

    e = x.e - y.e;
    yL = yd.length;
    xL = xd.length;
    q = new Ctor(sign);
    qd = q.d = [];

    // Result exponent may be one less than e.
    for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
    if (yd[i] > (xd[i] || 0)) --e;

    if (pr == null) {
      sd = pr = Ctor.precision;
    } else if (dp) {
      sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
    } else {
      sd = pr;
    }

    if (sd < 0) return new Ctor(0);

    // Convert precision in number of base 10 digits to base 1e7 digits.
    sd = (sd / LOG_BASE + 2) | 0;
    i = 0;

    // divisor < 1e7
    if (yL == 1) {
      k = 0;
      yd = yd[0];
      sd++;

      // k is the carry.
      for (; (i < xL || k) && sd--; i++) {
        t = k * BASE + (xd[i] || 0);
        qd[i] = (t / yd) | 0;
        k = t % yd | 0;
      }

      // divisor >= 1e7
    } else {
      // Normalise xd and yd so highest order digit of yd is >= BASE/2
      k = (BASE / (yd[0] + 1)) | 0;

      if (k > 1) {
        yd = multiplyInteger(yd, k);
        xd = multiplyInteger(xd, k);
        yL = yd.length;
        xL = xd.length;
      }

      xi = yL;
      rem = xd.slice(0, yL);
      remL = rem.length;

      // Add zeros to make remainder as long as divisor.
      for (; remL < yL; ) rem[remL++] = 0;

      yz = yd.slice();
      yz.unshift(0);
      yd0 = yd[0];

      if (yd[1] >= BASE / 2) ++yd0;

      do {
        k = 0;

        // Compare divisor and remainder.
        cmp = compare(yd, rem, yL, remL);

        // If divisor < remainder.
        if (cmp < 0) {
          // Calculate trial digit, k.
          rem0 = rem[0];
          if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);

          // k will be how many times the divisor goes into the current remainder.
          k = (rem0 / yd0) | 0;

          //  Algorithm:
          //  1. product = divisor * trial digit (k)
          //  2. if product > remainder: product -= divisor, k--
          //  3. remainder -= product
          //  4. if product was < remainder at 2:
          //    5. compare new remainder and divisor
          //    6. If remainder > divisor: remainder -= divisor, k++

          if (k > 1) {
            if (k >= BASE) k = BASE - 1;

            // product = divisor * trial digit.
            prod = multiplyInteger(yd, k);
            prodL = prod.length;
            remL = rem.length;

            // Compare product and remainder.
            cmp = compare(prod, rem, prodL, remL);

            // product > remainder.
            if (cmp == 1) {
              k--;

              // Subtract divisor from product.
              subtract(prod, yL < prodL ? yz : yd, prodL);
            }
          } else {
            // cmp is -1.
            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
            if (k == 0) cmp = k = 1;
            prod = yd.slice();
          }

          prodL = prod.length;
          if (prodL < remL) prod.unshift(0);

          // Subtract product from remainder.
          subtract(rem, prod, remL);

          // If product was < previous remainder.
          if (cmp == -1) {
            remL = rem.length;

            // Compare divisor and new remainder.
            cmp = compare(yd, rem, yL, remL);

            // If divisor < new remainder, subtract divisor from remainder.
            if (cmp < 1) {
              k++;

              // Subtract divisor from remainder.
              subtract(rem, yL < remL ? yz : yd, remL);
            }
          }

          remL = rem.length;
        } else if (cmp === 0) {
          k++;
          rem = [0];
        } // if cmp === 1, k will be 0

        // Add the next digit, k, to the result array.
        qd[i++] = k;

        // Update the remainder.
        if (cmp && rem[0]) {
          rem[remL++] = xd[xi] || 0;
        } else {
          rem = [xd[xi]];
          remL = 1;
        }
      } while ((xi++ < xL || rem[0] !== void 0) && sd--);
    }

    // Leading zero?
    if (!qd[0]) qd.shift();

    q.e = e;

    return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
  };
})();

/*
 * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
 * significant digits.
 *
 * Taylor/Maclaurin series.
 *
 * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
 *
 * Argument reduction:
 *   Repeat x = x / 32, k += 5, until |x| < 0.1
 *   exp(x) = exp(x / 2^k)^(2^k)
 *
 * Previously, the argument was initially reduced by
 * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
 * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
 * found to be slower than just dividing repeatedly by 32 as above.
 *
 * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
 *
 *  exp(x) is non-terminating for any finite, non-zero x.
 *
 */
function exp(x, sd) {
  var denominator,
    guard,
    pow,
    sum,
    t,
    wpr,
    i = 0,
    k = 0,
    Ctor = x.constructor,
    pr = Ctor.precision;

  if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));

  // exp(0) = 1
  if (!x.s) return new Ctor(ONE);

  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }

  t = new Ctor(0.03125);

  while (x.abs().gte(0.1)) {
    x = x.times(t); // x = x / 2^5
    k += 5;
  }

  // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
  guard = ((Math.log(mathpow(2, k)) / Math.LN10) * 2 + 5) | 0;
  wpr += guard;
  denominator = pow = sum = new Ctor(ONE);
  Ctor.precision = wpr;

  for (;;) {
    pow = round(pow.times(x), wpr);
    denominator = denominator.times(++i);
    t = sum.plus(divide(pow, denominator, wpr));

    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
      while (k--) sum = round(sum.times(sum), wpr);
      Ctor.precision = pr;
      return sd == null ? ((external = true), round(sum, pr)) : sum;
    }

    sum = t;
  }
}

// Calculate the base 10 exponent from the base 1e7 exponent.
function getBase10Exponent(x) {
  var e = x.e * LOG_BASE,
    w = x.d[0];

  // Add the number of digits of the first word of the digits array.
  for (; w >= 10; w /= 10) e++;
  return e;
}

function getLn10(Ctor, sd, pr) {
  if (sd > Ctor.LN10.sd()) {
    // Reset global state in case the exception is caught.
    external = true;
    if (pr) Ctor.precision = pr;
    throw Error(decimalError + 'LN10 precision limit exceeded');
  }

  return round(new Ctor(Ctor.LN10), sd);
}

function getZeroString(k) {
  var zs = '';
  for (; k--; ) zs += '0';
  return zs;
}

/*
 * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
 * digits.
 *
 *  ln(n) is non-terminating (n != 1)
 *
 */
function ln(y, sd) {
  var c,
    c0,
    denominator,
    e,
    numerator,
    sum,
    t,
    wpr,
    x2,
    n = 1,
    guard = 10,
    x = y,
    xd = x.d,
    Ctor = x.constructor,
    pr = Ctor.precision;

  // ln(-x) = NaN
  // ln(0) = -Infinity
  if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

  // ln(1) = 0
  if (x.eq(ONE)) return new Ctor(0);

  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }

  if (x.eq(10)) {
    if (sd == null) external = true;
    return getLn10(Ctor, wpr);
  }

  wpr += guard;
  Ctor.precision = wpr;
  c = digitsToString(xd);
  c0 = c.charAt(0);
  e = getBase10Exponent(x);

  if (Math.abs(e) < 1.5e15) {
    // Argument reduction.
    // The series converges faster the closer the argument is to 1, so using
    // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
    // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
    // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
    // later be divided by this number, then separate out the power of 10 using
    // ln(a*10^b) = ln(a) + b*ln(10).

    // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
    //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
    // max n is 6 (gives 0.7 - 1.3)
    while ((c0 < 7 && c0 != 1) || (c0 == 1 && c.charAt(1) > 3)) {
      x = x.times(y);
      c = digitsToString(x.d);
      c0 = c.charAt(0);
      n++;
    }

    e = getBase10Exponent(x);

    if (c0 > 1) {
      x = new Ctor('0.' + c);
      e++;
    } else {
      x = new Ctor(c0 + '.' + c.slice(1));
    }
  } else {
    // The argument reduction method above may result in overflow if the argument y is a massive
    // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
    // function using ln(x*10^e) = ln(x) + e*ln(10).
    t = getLn10(Ctor, wpr + 2, pr).times(e + '');
    x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);

    Ctor.precision = pr;
    return sd == null ? ((external = true), round(x, pr)) : x;
  }

  // x is reduced to a value near 1.

  // Taylor series.
  // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
  // where x = (y - 1)/(y + 1)    (|x| < 1)
  sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
  x2 = round(x.times(x), wpr);
  denominator = 3;

  for (;;) {
    numerator = round(numerator.times(x2), wpr);
    t = sum.plus(divide(numerator, new Ctor(denominator), wpr));

    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
      sum = sum.times(2);

      // Reverse the argument reduction.
      if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
      sum = divide(sum, new Ctor(n), wpr);

      Ctor.precision = pr;
      return sd == null ? ((external = true), round(sum, pr)) : sum;
    }

    sum = t;
    denominator += 2;
  }
}

/*
 * Parse the value of a new Decimal `x` from string `str`.
 */
function parseDecimal(x, str) {
  var e, i, len;

  // Decimal point?
  if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

  // Exponential form?
  if ((i = str.search(/e/i)) > 0) {
    // Determine exponent.
    if (e < 0) e = i;
    e += +str.slice(i + 1);
    str = str.substring(0, i);
  } else if (e < 0) {
    // Integer.
    e = str.length;
  }

  // Determine leading zeros.
  for (i = 0; str.charCodeAt(i) === 48; ) ++i;

  // Determine trailing zeros.
  for (len = str.length; str.charCodeAt(len - 1) === 48; ) --len;
  str = str.slice(i, len);

  if (str) {
    len -= i;
    e = e - i - 1;
    x.e = mathfloor(e / LOG_BASE);
    x.d = [];

    // Transform base

    // e is the base 10 exponent.
    // i is where to slice str to get the first word of the digits array.
    i = (e + 1) % LOG_BASE;
    if (e < 0) i += LOG_BASE;

    if (i < len) {
      if (i) x.d.push(+str.slice(0, i));
      for (len -= LOG_BASE; i < len; ) x.d.push(+str.slice(i, (i += LOG_BASE)));
      str = str.slice(i);
      i = LOG_BASE - str.length;
    } else {
      i -= len;
    }

    for (; i--; ) str += '0';
    x.d.push(+str);

    if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
  } else {
    // Zero.
    x.s = 0;
    x.e = 0;
    x.d = [0];
  }

  return x;
}

/*
 * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
 */
function round(x, sd, rm) {
  var i,
    j,
    k,
    n,
    rd,
    doRound,
    w,
    xdi,
    xd = x.d;

  // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
  // w: the word of xd which contains the rounding digit, a base 1e7 number.
  // xdi: the index of w within xd.
  // n: the number of digits of w.
  // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
  // they had leading zeros)
  // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).

  // Get the length of the first word of the digits array xd.
  for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
  i = sd - n;

  // Is the rounding digit in the first word of xd?
  if (i < 0) {
    i += LOG_BASE;
    j = sd;
    w = xd[(xdi = 0)];
  } else {
    xdi = Math.ceil((i + 1) / LOG_BASE);
    k = xd.length;
    if (xdi >= k) return x;
    w = k = xd[xdi];

    // Get the number of digits of w.
    for (n = 1; k >= 10; k /= 10) n++;

    // Get the index of rd within w.
    i %= LOG_BASE;

    // Get the index of rd within w, adjusted for leading zeros.
    // The number of leading zeros of w is given by LOG_BASE - n.
    j = i - LOG_BASE + n;
  }

  if (rm !== void 0) {
    k = mathpow(10, n - j - 1);

    // Get the rounding digit at index j of w.
    rd = (w / k) % 10 | 0;

    // Are there any non-zero digits after the rounding digit?
    doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;

    // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
    // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
    // 714.

    doRound =
      rm < 4
        ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
        : rd > 5 ||
          (rd == 5 &&
            (rm == 4 ||
              doRound ||
              (rm == 6 &&
                // Check whether the digit to the left of the rounding digit is odd.
                (i > 0 ? (j > 0 ? w / mathpow(10, n - j) : 0) : xd[xdi - 1]) % 10 & 1) ||
              rm == (x.s < 0 ? 8 : 7)));
  }

  if (sd < 1 || !xd[0]) {
    if (doRound) {
      k = getBase10Exponent(x);
      xd.length = 1;

      // Convert sd to decimal places.
      sd = sd - k - 1;

      // 1, 0.1, 0.01, 0.001, 0.0001 etc.
      xd[0] = mathpow(10, (LOG_BASE - (sd % LOG_BASE)) % LOG_BASE);
      x.e = mathfloor(-sd / LOG_BASE) || 0;
    } else {
      xd.length = 1;

      // Zero.
      xd[0] = x.e = x.s = 0;
    }

    return x;
  }

  // Remove excess digits.
  if (i == 0) {
    xd.length = xdi;
    k = 1;
    xdi--;
  } else {
    xd.length = xdi + 1;
    k = mathpow(10, LOG_BASE - i);

    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
    // j > 0 means i > number of leading zeros of w.
    xd[xdi] = j > 0 ? ((w / mathpow(10, n - j)) % mathpow(10, j) | 0) * k : 0;
  }

  if (doRound) {
    for (;;) {
      // Is the digit to be rounded up in the first word of xd?
      if (xdi == 0) {
        if ((xd[0] += k) == BASE) {
          xd[0] = 1;
          ++x.e;
        }

        break;
      } else {
        xd[xdi] += k;
        if (xd[xdi] != BASE) break;
        xd[xdi--] = 0;
        k = 1;
      }
    }
  }

  // Remove trailing zeros.
  for (i = xd.length; xd[--i] === 0; ) xd.pop();

  if (external && (x.e > MAX_E || x.e < -MAX_E)) {
    throw Error(exponentOutOfRange + getBase10Exponent(x));
  }

  return x;
}

function subtract(x, y) {
  var d,
    e,
    i,
    j,
    k,
    len,
    xd,
    xe,
    xLTy,
    yd,
    Ctor = x.constructor,
    pr = Ctor.precision;

  // Return y negated if x is zero.
  // Return x if y is zero and x is non-zero.
  if (!x.s || !y.s) {
    if (y.s) y.s = -y.s;
    else y = new Ctor(x);
    return external ? round(y, pr) : y;
  }

  xd = x.d;
  yd = y.d;

  // x and y are non-zero numbers with the same sign.

  e = y.e;
  xe = x.e;
  xd = xd.slice();
  k = xe - e;

  // If exponents differ...
  if (k) {
    xLTy = k < 0;

    if (xLTy) {
      d = xd;
      k = -k;
      len = yd.length;
    } else {
      d = yd;
      e = xe;
      len = xd.length;
    }

    // Numbers with massively different exponents would result in a very high number of zeros
    // needing to be prepended, but this can be avoided while still ensuring correct rounding by
    // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
    i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;

    if (k > i) {
      k = i;
      d.length = 1;
    }

    // Prepend zeros to equalise exponents.
    d.reverse();
    for (i = k; i--; ) d.push(0);
    d.reverse();

    // Base 1e7 exponents equal.
  } else {
    // Check digits to determine which is the bigger number.

    i = xd.length;
    len = yd.length;
    xLTy = i < len;
    if (xLTy) len = i;

    for (i = 0; i < len; i++) {
      if (xd[i] != yd[i]) {
        xLTy = xd[i] < yd[i];
        break;
      }
    }

    k = 0;
  }

  if (xLTy) {
    d = xd;
    xd = yd;
    yd = d;
    y.s = -y.s;
  }

  len = xd.length;

  // Append zeros to xd if shorter.
  // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
  for (i = yd.length - len; i > 0; --i) xd[len++] = 0;

  // Subtract yd from xd.
  for (i = yd.length; i > k; ) {
    if (xd[--i] < yd[i]) {
      for (j = i; j && xd[--j] === 0; ) xd[j] = BASE - 1;
      --xd[j];
      xd[i] += BASE;
    }

    xd[i] -= yd[i];
  }

  // Remove trailing zeros.
  for (; xd[--len] === 0; ) xd.pop();

  // Remove leading zeros and adjust exponent accordingly.
  for (; xd[0] === 0; xd.shift()) --e;

  // Zero?
  if (!xd[0]) return new Ctor(0);

  y.d = xd;
  y.e = e;

  //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
  return external ? round(y, pr) : y;
}

function toString(x, isExp, sd) {
  var k,
    e = getBase10Exponent(x),
    str = digitsToString(x.d),
    len = str.length;

  if (isExp) {
    if (sd && (k = sd - len) > 0) {
      str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
    } else if (len > 1) {
      str = str.charAt(0) + '.' + str.slice(1);
    }

    str = str + (e < 0 ? 'e' : 'e+') + e;
  } else if (e < 0) {
    str = '0.' + getZeroString(-e - 1) + str;
    if (sd && (k = sd - len) > 0) str += getZeroString(k);
  } else if (e >= len) {
    str += getZeroString(e + 1 - len);
    if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
  } else {
    if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
    if (sd && (k = sd - len) > 0) {
      if (e + 1 === len) str += '.';
      str += getZeroString(k);
    }
  }

  return x.s < 0 ? '-' + str : str;
}

// Does not strip trailing zeros.
function truncate(arr, len) {
  if (arr.length > len) {
    arr.length = len;
    return true;
  }
}

// Decimal methods

/*
 *  clone
 *  config/set
 */

/*
 * Create and return a Decimal constructor with the same configuration properties as this Decimal
 * constructor.
 *
 */
function clone(obj) {
  var i, p, ps;

  /*
   * The Decimal constructor and exported function.
   * Return a new Decimal instance.
   *
   * value {number|string|Decimal} A numeric value.
   *
   */
  function Decimal(value) {
    var x = this;

    // Decimal called without new.
    if (!(x instanceof Decimal)) return new Decimal(value);

    // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
    // which points to Object.
    x.constructor = Decimal;

    // Duplicate.
    if (value instanceof Decimal) {
      x.s = value.s;
      x.e = value.e;
      x.d = (value = value.d) ? value.slice() : value;
      return;
    }

    if (typeof value === 'number') {
      // Reject Infinity/NaN.
      if (value * 0 !== 0) {
        throw Error(invalidArgument + value);
      }

      if (value > 0) {
        x.s = 1;
      } else if (value < 0) {
        value = -value;
        x.s = -1;
      } else {
        x.s = 0;
        x.e = 0;
        x.d = [0];
        return;
      }

      // Fast path for small integers.
      if (value === ~~value && value < 1e7) {
        x.e = 0;
        x.d = [value];
        return;
      }

      return parseDecimal(x, value.toString());
    } else if (typeof value !== 'string') {
      throw Error(invalidArgument + value);
    }

    // Minus sign?
    if (value.charCodeAt(0) === 45) {
      value = value.slice(1);
      x.s = -1;
    } else {
      x.s = 1;
    }

    if (isDecimal.test(value)) parseDecimal(x, value);
    else throw Error(invalidArgument + value);
  }

  Decimal.prototype = P$1;

  Decimal.ROUND_UP = 0;
  Decimal.ROUND_DOWN = 1;
  Decimal.ROUND_CEIL = 2;
  Decimal.ROUND_FLOOR = 3;
  Decimal.ROUND_HALF_UP = 4;
  Decimal.ROUND_HALF_DOWN = 5;
  Decimal.ROUND_HALF_EVEN = 6;
  Decimal.ROUND_HALF_CEIL = 7;
  Decimal.ROUND_HALF_FLOOR = 8;

  Decimal.clone = clone;
  Decimal.config = Decimal.set = config;

  if (obj === void 0) obj = {};
  if (obj) {
    ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
    for (i = 0; i < ps.length; ) if (!obj.hasOwnProperty((p = ps[i++]))) obj[p] = this[p];
  }

  Decimal.config(obj);

  return Decimal;
}

/*
 * Configure global settings for a Decimal constructor.
 *
 * `obj` is an object with one or more of the following properties,
 *
 *   precision  {number}
 *   rounding   {number}
 *   toExpNeg   {number}
 *   toExpPos   {number}
 *
 * E.g. Decimal.config({ precision: 20, rounding: 4 })
 *
 */
function config(obj) {
  if (!obj || typeof obj !== 'object') {
    throw Error(decimalError + 'Object expected');
  }
  var i,
    p,
    v,
    ps = ['precision', 1, MAX_DIGITS, 'rounding', 0, 8, 'toExpNeg', -1 / 0, 0, 'toExpPos', 0, 1 / 0];

  for (i = 0; i < ps.length; i += 3) {
    if ((v = obj[(p = ps[i])]) !== void 0) {
      if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
      else throw Error(invalidArgument + p + ': ' + v);
    }
  }

  if ((v = obj[(p = 'LN10')]) !== void 0) {
    if (v == Math.LN10) this[p] = new this(v);
    else throw Error(invalidArgument + p + ': ' + v);
  }

  return this;
}

// Create and configure initial Decimal constructor.
var Decimal = clone(defaults);

// Internal constant.
ONE = new Decimal(1);

var Decimal$1 = Decimal;

function _toConsumableArray$a(arr) {
  return (
    _arrayWithoutHoles$a(arr) || _iterableToArray$a(arr) || _unsupportedIterableToArray$f(arr) || _nonIterableSpread$a()
  );
}

function _nonIterableSpread$a() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}

function _unsupportedIterableToArray$f(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$f(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$f(o, minLen);
}

function _iterableToArray$a(iter) {
  if (typeof Symbol !== 'undefined' && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles$a(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$f(arr);
}

function _arrayLikeToArray$f(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

var identity = function identity(i) {
  return i;
};

var PLACE_HOLDER = {
  '@@functional/placeholder': true,
};

var isPlaceHolder = function isPlaceHolder(val) {
  return val === PLACE_HOLDER;
};

var curry0 = function curry0(fn) {
  return function _curried() {
    if (
      arguments.length === 0 ||
      (arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0]))
    ) {
      return _curried;
    }

    return fn.apply(void 0, arguments);
  };
};

var curryN = function curryN(n, fn) {
  if (n === 1) {
    return fn;
  }

  return curry0(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsLength = args.filter(function (arg) {
      return arg !== PLACE_HOLDER;
    }).length;

    if (argsLength >= n) {
      return fn.apply(void 0, args);
    }

    return curryN(
      n - argsLength,
      curry0(function () {
        for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          restArgs[_key2] = arguments[_key2];
        }

        var newArgs = args.map(function (arg) {
          return isPlaceHolder(arg) ? restArgs.shift() : arg;
        });
        return fn.apply(void 0, _toConsumableArray$a(newArgs).concat(restArgs));
      }),
    );
  });
};

var curry = function curry(fn) {
  return curryN(fn.length, fn);
};
var range$1 = function range(begin, end) {
  var arr = [];

  for (var i = begin; i < end; ++i) {
    arr[i - begin] = i;
  }

  return arr;
};
var map$1 = curry(function (fn, arr) {
  if (Array.isArray(arr)) {
    return arr.map(fn);
  }

  return Object.keys(arr)
    .map(function (key) {
      return arr[key];
    })
    .map(fn);
});
var compose = function compose() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (!args.length) {
    return identity;
  }

  var fns = args.reverse(); // first function can receive multiply arguments

  var firstFn = fns[0];
  var tailsFn = fns.slice(1);
  return function () {
    return tailsFn.reduce(
      function (res, fn) {
        return fn(res);
      },
      firstFn.apply(void 0, arguments),
    );
  };
};
var reverse = function reverse(arr) {
  if (Array.isArray(arr)) {
    return arr.reverse();
  } // can be string

  return arr.split('').reverse.join('');
};
var memoize$1 = function memoize(fn) {
  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    if (
      lastArgs &&
      args.every(function (val, i) {
        return val === lastArgs[i];
      })
    ) {
      return lastResult;
    }

    lastArgs = args;
    lastResult = fn.apply(void 0, args);
    return lastResult;
  };
};

/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */
/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */

function getDigitCount(value) {
  var result;

  if (value === 0) {
    result = 1;
  } else {
    result = Math.floor(new Decimal$1(value).abs().log(10).toNumber()) + 1;
  }

  return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */

function rangeStep(start, end, step) {
  var num = new Decimal$1(start);
  var i = 0;
  var result = []; // magic number to prevent infinite loop

  while (num.lt(end) && i < 100000) {
    result.push(num.toNumber());
    num = num.add(step);
    i++;
  }

  return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */

var interpolateNumber = curry(function (a, b, t) {
  var newA = +a;
  var newB = +b;
  return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */

var uninterpolateNumber = curry(function (a, b, x) {
  var diff = b - +a;
  diff = diff || Infinity;
  return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */

var uninterpolateTruncation = curry(function (a, b, x) {
  var diff = b - +a;
  diff = diff || Infinity;
  return Math.max(0, Math.min(1, (x - a) / diff));
});
var Arithmetic = {
  rangeStep: rangeStep,
  getDigitCount: getDigitCount,
  interpolateNumber: interpolateNumber,
  uninterpolateNumber: uninterpolateNumber,
  uninterpolateTruncation: uninterpolateTruncation,
};

function _toConsumableArray$9(arr) {
  return (
    _arrayWithoutHoles$9(arr) || _iterableToArray$9(arr) || _unsupportedIterableToArray$e(arr) || _nonIterableSpread$9()
  );
}

function _nonIterableSpread$9() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}

function _iterableToArray$9(iter) {
  if (typeof Symbol !== 'undefined' && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles$9(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$e(arr);
}

function _slicedToArray$7(arr, i) {
  return (
    _arrayWithHoles$7(arr) ||
    _iterableToArrayLimit$7(arr, i) ||
    _unsupportedIterableToArray$e(arr, i) ||
    _nonIterableRest$7()
  );
}

function _nonIterableRest$7() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}

function _unsupportedIterableToArray$e(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$e(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$e(o, minLen);
}

function _arrayLikeToArray$e(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _iterableToArrayLimit$7(arr, i) {
  if (typeof Symbol === 'undefined' || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayWithHoles$7(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */

function getValidInterval(_ref) {
  var _ref2 = _slicedToArray$7(_ref, 2),
    min = _ref2[0],
    max = _ref2[1];

  var validMin = min,
    validMax = max; // exchange

  if (min > max) {
    validMin = max;
    validMax = min;
  }

  return [validMin, validMax];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */

function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep.lte(0)) {
    return new Decimal$1(0);
  }

  var digitCount = Arithmetic.getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
  // order of magnitudes than the rough step

  var digitCountValue = new Decimal$1(10).pow(digitCount);
  var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong

  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
  var amendStepRatio = new Decimal$1(Math.ceil(stepRatio.div(stepRatioScale).toNumber()))
    .add(correctionFactor)
    .mul(stepRatioScale);
  var formatStep = amendStepRatio.mul(digitCountValue);
  return allowDecimals ? formatStep : new Decimal$1(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */

function getTickOfSingleValue(value, tickCount, allowDecimals) {
  var step = 1; // calculate the middle value of ticks

  var middle = new Decimal$1(value);

  if (!middle.isint() && allowDecimals) {
    var absVal = Math.abs(value);

    if (absVal < 1) {
      // The step should be a float number when the difference is smaller than 1
      step = new Decimal$1(10).pow(Arithmetic.getDigitCount(value) - 1);
      middle = new Decimal$1(Math.floor(middle.div(step).toNumber())).mul(step);
    } else if (absVal > 1) {
      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
      middle = new Decimal$1(Math.floor(value));
    }
  } else if (value === 0) {
    middle = new Decimal$1(Math.floor((tickCount - 1) / 2));
  } else if (!allowDecimals) {
    middle = new Decimal$1(Math.floor(value));
  }

  var middleIndex = Math.floor((tickCount - 1) / 2);
  var fn = compose(
    map$1(function (n) {
      return middle.add(new Decimal$1(n - middleIndex).mul(step)).toNumber();
    }),
    range$1,
  );
  return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */

function calculateStep(min, max, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  // dirty hack (for recharts' test)
  if (!Number.isFinite((max - min) / (tickCount - 1))) {
    return {
      step: new Decimal$1(0),
      tickMin: new Decimal$1(0),
      tickMax: new Decimal$1(0),
    };
  } // The step which is easy to understand between two ticks

  var step = getFormatStep(new Decimal$1(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks

  var middle; // When 0 is inside the interval, 0 should be a tick

  if (min <= 0 && max >= 0) {
    middle = new Decimal$1(0);
  } else {
    // calculate the middle value
    middle = new Decimal$1(min).add(max).div(2); // minus modulo value

    middle = middle.sub(new Decimal$1(middle).mod(step));
  }

  var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
  var upCount = Math.ceil(new Decimal$1(max).sub(middle).div(step).toNumber());
  var scaleCount = belowCount + upCount + 1;

  if (scaleCount > tickCount) {
    // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
  }

  if (scaleCount < tickCount) {
    // When less ticks can cover the interval, we should add some additional ticks
    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
  }

  return {
    step: step,
    tickMin: middle.sub(new Decimal$1(belowCount).mul(step)),
    tickMax: middle.add(new Decimal$1(upCount).mul(step)),
  };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */

function getNiceTickValuesFn(_ref3) {
  var _ref4 = _slicedToArray$7(_ref3, 2),
    min = _ref4[0],
    max = _ref4[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval = getValidInterval([min, max]),
    _getValidInterval2 = _slicedToArray$7(_getValidInterval, 2),
    cormin = _getValidInterval2[0],
    cormax = _getValidInterval2[1];

  if (cormin === -Infinity || cormax === Infinity) {
    var _values =
      cormax === Infinity
        ? [cormin].concat(
            _toConsumableArray$9(
              range$1(0, tickCount - 1).map(function () {
                return Infinity;
              }),
            ),
          )
        : [].concat(
            _toConsumableArray$9(
              range$1(0, tickCount - 1).map(function () {
                return -Infinity;
              }),
            ),
            [cormax],
          );

    return min > max ? reverse(_values) : _values;
  }

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  } // Get the step between two ticks

  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
    step = _calculateStep.step,
    tickMin = _calculateStep.tickMin,
    tickMax = _calculateStep.tickMax;

  var values = Arithmetic.rangeStep(tickMin, tickMax.add(new Decimal$1(0.1).mul(step)), step);
  return min > max ? reverse(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */

function getTickValuesFixedDomainFn(_ref7, tickCount) {
  var _ref8 = _slicedToArray$7(_ref7, 2),
    min = _ref8[0],
    max = _ref8[1];

  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var _getValidInterval5 = getValidInterval([min, max]),
    _getValidInterval6 = _slicedToArray$7(_getValidInterval5, 2),
    cormin = _getValidInterval6[0],
    cormax = _getValidInterval6[1];

  if (cormin === -Infinity || cormax === Infinity) {
    return [min, max];
  }

  if (cormin === cormax) {
    return [cormin];
  }

  var count = Math.max(tickCount, 2);
  var step = getFormatStep(new Decimal$1(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
  var values = [].concat(
    _toConsumableArray$9(
      Arithmetic.rangeStep(new Decimal$1(cormin), new Decimal$1(cormax).sub(new Decimal$1(0.99).mul(step)), step),
    ),
    [cormax],
  );
  return min > max ? reverse(values) : values;
}

var getNiceTickValues = memoize$1(getNiceTickValuesFn);
var getTickValuesFixedDomain = memoize$1(getTickValuesFixedDomainFn);

var _excluded$d = ['offset', 'layout', 'width', 'dataKey', 'data', 'dataPointFormatter', 'xAxis', 'yAxis'];
function _extends$u() {
  _extends$u = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$u.apply(this, arguments);
}
function _slicedToArray$6(arr, i) {
  return (
    _arrayWithHoles$6(arr) ||
    _iterableToArrayLimit$6(arr, i) ||
    _unsupportedIterableToArray$d(arr, i) ||
    _nonIterableRest$6()
  );
}
function _nonIterableRest$6() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$d(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$d(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$d(o, minLen);
}
function _arrayLikeToArray$d(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit$6(arr, i) {
  var _i = null == arr ? null : ('undefined' != typeof Symbol && arr[Symbol.iterator]) || arr['@@iterator'];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      (_d = !0), (_e = err);
    } finally {
      try {
        if (!_n && null != _i['return'] && ((_r = _i['return']()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$6(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties$d(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$f(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$f(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ErrorBar(props) {
  var offset = props.offset,
    layout = props.layout,
    width = props.width,
    dataKey = props.dataKey,
    data = props.data,
    dataPointFormatter = props.dataPointFormatter,
    xAxis = props.xAxis,
    yAxis = props.yAxis,
    others = _objectWithoutProperties$d(props, _excluded$d);
  var svgProps = filterProps(others);
  var errorBars = data.map(function (entry, i) {
    var _dataPointFormatter = dataPointFormatter(entry, dataKey),
      x = _dataPointFormatter.x,
      y = _dataPointFormatter.y,
      value = _dataPointFormatter.value,
      errorVal = _dataPointFormatter.errorVal;
    if (!errorVal) {
      return null;
    }
    var lineCoordinates = [];
    var lowBound, highBound;
    if (Array.isArray(errorVal)) {
      var _errorVal = _slicedToArray$6(errorVal, 2);
      lowBound = _errorVal[0];
      highBound = _errorVal[1];
    } else {
      lowBound = highBound = errorVal;
    }
    if (layout === 'vertical') {
      // error bar for horizontal charts, the y is fixed, x is a range value
      var scale = xAxis.scale;
      var yMid = y + offset;
      var yMin = yMid + width;
      var yMax = yMid - width;
      var xMin = scale(value - lowBound);
      var xMax = scale(value + highBound);

      // the right line of |--|
      lineCoordinates.push({
        x1: xMax,
        y1: yMin,
        x2: xMax,
        y2: yMax,
      });
      // the middle line of |--|
      lineCoordinates.push({
        x1: xMin,
        y1: yMid,
        x2: xMax,
        y2: yMid,
      });
      // the left line of |--|
      lineCoordinates.push({
        x1: xMin,
        y1: yMin,
        x2: xMin,
        y2: yMax,
      });
    } else if (layout === 'horizontal') {
      // error bar for horizontal charts, the x is fixed, y is a range value
      var _scale = yAxis.scale;
      var xMid = x + offset;
      var _xMin = xMid - width;
      var _xMax = xMid + width;
      var _yMin = _scale(value - lowBound);
      var _yMax = _scale(value + highBound);

      // the top line
      lineCoordinates.push({
        x1: _xMin,
        y1: _yMax,
        x2: _xMax,
        y2: _yMax,
      });
      // the middle line
      lineCoordinates.push({
        x1: xMid,
        y1: _yMin,
        x2: xMid,
        y2: _yMax,
      });
      // the bottom line
      lineCoordinates.push({
        x1: _xMin,
        y1: _yMin,
        x2: _xMax,
        y2: _yMin,
      });
    }
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React__default['default'].createElement(
        Layer,
        _extends$u(
          {
            className: 'recharts-errorBar',
            key: 'bar-'.concat(i),
          },
          svgProps,
        ),
        lineCoordinates.map(function (coordinates, index) {
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            React__default['default'].createElement(
              'line',
              _extends$u({}, coordinates, {
                key: 'line-'.concat(index),
              }),
            )
          );
        }),
      )
    );
  });
  return /*#__PURE__*/ React__default['default'].createElement(
    Layer,
    {
      className: 'recharts-errorBars',
    },
    errorBars,
  );
}
ErrorBar.defaultProps = {
  stroke: 'black',
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: 'horizontal',
};
ErrorBar.displayName = 'ErrorBar';

function _typeof$17(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$17 =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$17(obj)
  );
}
function _toConsumableArray$8(arr) {
  return (
    _arrayWithoutHoles$8(arr) || _iterableToArray$8(arr) || _unsupportedIterableToArray$c(arr) || _nonIterableSpread$8()
  );
}
function _nonIterableSpread$8() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$c(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$c(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$c(o, minLen);
}
function _iterableToArray$8(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$8(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$c(arr);
}
function _arrayLikeToArray$c(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function ownKeys$t(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$t(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$t(Object(source), !0).forEach(function (key) {
          _defineProperty$12(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$t(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$12(obj, key, value) {
  key = _toPropertyKey$y(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$y(arg) {
  var key = _toPrimitive$y(arg, 'string');
  return _typeof$17(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$y(input, hint) {
  if (_typeof$17(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$17(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
// TODO: Cause of circular dependency. Needs refactor.
// import { RadiusAxisProps, AngleAxisProps } from '../polar/types';

function getValueByDataKey(obj, dataKey, defaultValue) {
  if (_isNil(obj) || _isNil(dataKey)) {
    return defaultValue;
  }
  if (isNumOrStr(dataKey)) {
    return _get(obj, dataKey, defaultValue);
  }
  if (_isFunction(dataKey)) {
    return dataKey(obj);
  }
  return defaultValue;
}
/**
 * Get domain of data by key
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */
function getDomainOfDataByKey(data, key, type, filterNil) {
  var flattenData = _flatMap(data, function (entry) {
    return getValueByDataKey(entry, key);
  });
  if (type === 'number') {
    var domain = flattenData.filter(function (entry) {
      return isNumber(entry) || parseFloat(entry);
    });
    return domain.length ? [_min(domain), _max(domain)] : [Infinity, -Infinity];
  }
  var validateData = filterNil
    ? flattenData.filter(function (entry) {
        return !_isNil(entry);
      })
    : flattenData;

  // 支持Date类型的x轴
  return validateData.map(function (entry) {
    return isNumOrStr(entry) || entry instanceof Date ? entry : '';
  });
}
var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate) {
  var _ticks$length;
  var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
  var axis = arguments.length > 3 ? arguments[3] : undefined;
  var index = -1;
  var len =
    (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0
      ? _ticks$length
      : 0;

  // if there are 1 or less ticks ticks then the active tick is at index 0
  if (len <= 1) {
    return 0;
  }
  if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
    var range = axis.range;
    // ticks are distributed in a circle
    for (var i = 0; i < len; i++) {
      var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
      var cur = unsortedTicks[i].coordinate;
      var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
      var sameDirectionCoord = void 0;
      if (mathSign$1(cur - before) !== mathSign$1(after - cur)) {
        var diffInterval = [];
        if (mathSign$1(after - cur) === mathSign$1(range[1] - range[0])) {
          sameDirectionCoord = after;
          var curInRange = cur + range[1] - range[0];
          diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
          diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
        } else {
          sameDirectionCoord = before;
          var afterInRange = after + range[1] - range[0];
          diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
          diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
        }
        var sameInterval = [
          Math.min(cur, (sameDirectionCoord + cur) / 2),
          Math.max(cur, (sameDirectionCoord + cur) / 2),
        ];
        if (
          (coordinate > sameInterval[0] && coordinate <= sameInterval[1]) ||
          (coordinate >= diffInterval[0] && coordinate <= diffInterval[1])
        ) {
          index = unsortedTicks[i].index;
          break;
        }
      } else {
        var min = Math.min(before, after);
        var max = Math.max(before, after);
        if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
          index = unsortedTicks[i].index;
          break;
        }
      }
    }
  } else {
    // ticks are distributed in a single direction
    for (var _i = 0; _i < len; _i++) {
      if (
        (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2) ||
        (_i > 0 &&
          _i < len - 1 &&
          coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 &&
          coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2) ||
        (_i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2)
      ) {
        index = ticks[_i].index;
        break;
      }
    }
  }
  return index;
};

/**
 * Get the main color of each graphic item
 * @param  {ReactElement} item A graphic item
 * @return {String}            Color
 */
var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
  var _ref = item,
    displayName = _ref.type.displayName; // TODO: check if displayName is valid.
  var _item$props = item.props,
    stroke = _item$props.stroke,
    fill = _item$props.fill;
  var result;
  switch (displayName) {
    case 'Line':
      result = stroke;
      break;
    case 'Area':
    case 'Radar':
      result = stroke && stroke !== 'none' ? stroke : fill;
      break;
    default:
      result = fill;
      break;
  }
  return result;
};
var getLegendProps = function getLegendProps(_ref2) {
  var children = _ref2.children,
    formattedGraphicalItems = _ref2.formattedGraphicalItems,
    legendWidth = _ref2.legendWidth,
    legendContent = _ref2.legendContent;
  var legendItem = findChildByType(children, Legend);
  if (!legendItem) {
    return null;
  }
  var legendData;
  if (legendItem.props && legendItem.props.payload) {
    legendData = legendItem.props && legendItem.props.payload;
  } else if (legendContent === 'children') {
    legendData = (formattedGraphicalItems || []).reduce(function (result, _ref3) {
      var item = _ref3.item,
        props = _ref3.props;
      var data = props.sectors || props.data || [];
      return result.concat(
        data.map(function (entry) {
          return {
            type: legendItem.props.iconType || item.props.legendType,
            value: entry.name,
            color: entry.fill,
            payload: entry,
          };
        }),
      );
    }, []);
  } else {
    legendData = (formattedGraphicalItems || []).map(function (_ref4) {
      var item = _ref4.item;
      var _item$props2 = item.props,
        dataKey = _item$props2.dataKey,
        name = _item$props2.name,
        legendType = _item$props2.legendType,
        hide = _item$props2.hide;
      return {
        inactive: hide,
        dataKey: dataKey,
        type: legendItem.props.iconType || legendType || 'square',
        color: getMainColorOfGraphicItem(item),
        value: name || dataKey,
        payload: item.props,
      };
    });
  }
  return _objectSpread$t(
    _objectSpread$t(_objectSpread$t({}, legendItem.props), Legend.getWithHeight(legendItem, legendWidth)),
    {},
    {
      payload: legendData,
      item: legendItem,
    },
  );
};
/**
 * Calculate the size of all groups for stacked bar graph
 * @param  {Object} stackGroups The items grouped by axisId and stackId
 * @return {Object} The size of all groups
 */
var getBarSizeList = function getBarSizeList(_ref5) {
  var globalSize = _ref5.barSize,
    _ref5$stackGroups = _ref5.stackGroups,
    stackGroups = _ref5$stackGroups === void 0 ? {} : _ref5$stackGroups;
  if (!stackGroups) {
    return {};
  }
  var result = {};
  var numericAxisIds = Object.keys(stackGroups);
  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
    var stackIds = Object.keys(sgs);
    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]],
        items = _sgs$stackIds$j.items,
        cateAxisId = _sgs$stackIds$j.cateAxisId;
      var barItems = items.filter(function (item) {
        return getDisplayName(item.type).indexOf('Bar') >= 0;
      });
      if (barItems && barItems.length) {
        var selfSize = barItems[0].props.barSize;
        var cateId = barItems[0].props[cateAxisId];
        if (!result[cateId]) {
          result[cateId] = [];
        }
        result[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: _isNil(selfSize) ? globalSize : selfSize,
        });
      }
    }
  }
  return result;
};

/**
 * Calculate the size of each bar and the gap between two bars
 * @param  {Number} bandSize  The size of each category
 * @param  {sizeList} sizeList  The size of all groups
 * @param  {maxBarSize} maxBarSize The maximum size of bar
 * @return {Number} The size of each bar and the gap between two bars
 */
var getBarPosition = function getBarPosition(_ref6) {
  var barGap = _ref6.barGap,
    barCategoryGap = _ref6.barCategoryGap,
    bandSize = _ref6.bandSize,
    _ref6$sizeList = _ref6.sizeList,
    sizeList = _ref6$sizeList === void 0 ? [] : _ref6$sizeList,
    maxBarSize = _ref6.maxBarSize;
  var len = sizeList.length;
  if (len < 1) return null;
  var realBarGap = getPercentValue(barGap, bandSize, 0, true);
  var result;

  // whether or not is barSize setted by user
  if (sizeList[0].barSize === +sizeList[0].barSize) {
    var useFull = false;
    var fullBarSize = bandSize / len;
    var sum = sizeList.reduce(function (res, entry) {
      return res + entry.barSize || 0;
    }, 0);
    sum += (len - 1) * realBarGap;
    if (sum >= bandSize) {
      sum -= (len - 1) * realBarGap;
      realBarGap = 0;
    }
    if (sum >= bandSize && fullBarSize > 0) {
      useFull = true;
      fullBarSize *= 0.9;
      sum = len * fullBarSize;
    }
    var offset = ((bandSize - sum) / 2) >> 0;
    var prev = {
      offset: offset - realBarGap,
      size: 0,
    };
    result = sizeList.reduce(function (res, entry) {
      var newRes = [].concat(_toConsumableArray$8(res), [
        {
          item: entry.item,
          position: {
            offset: prev.offset + prev.size + realBarGap,
            size: useFull ? fullBarSize : entry.barSize,
          },
        },
      ]);
      prev = newRes[newRes.length - 1].position;
      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({
            item: item,
            position: prev,
          });
        });
      }
      return newRes;
    }, []);
  } else {
    var _offset = getPercentValue(barCategoryGap, bandSize, 0, true);
    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
      realBarGap = 0;
    }
    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
    if (originalSize > 1) {
      originalSize >>= 0;
    }
    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
    result = sizeList.reduce(function (res, entry, i) {
      var newRes = [].concat(_toConsumableArray$8(res), [
        {
          item: entry.item,
          position: {
            offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
            size: size,
          },
        },
      ]);
      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({
            item: item,
            position: newRes[newRes.length - 1].position,
          });
        });
      }
      return newRes;
    }, []);
  }
  return result;
};
var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
  var children = props.children,
    width = props.width,
    margin = props.margin;
  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
  // const legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
  var legendProps = getLegendProps({
    children: children,
    legendWidth: legendWidth,
  });
  var newOffset = offset;
  if (legendProps) {
    var box = legendBox || {};
    var align = legendProps.align,
      verticalAlign = legendProps.verticalAlign,
      layout = legendProps.layout;
    if ((layout === 'vertical' || (layout === 'horizontal' && verticalAlign === 'middle')) && isNumber(offset[align])) {
      newOffset = _objectSpread$t(
        _objectSpread$t({}, offset),
        {},
        _defineProperty$12({}, align, newOffset[align] + (box.width || 0)),
      );
    }
    if ((layout === 'horizontal' || (layout === 'vertical' && align === 'center')) && isNumber(offset[verticalAlign])) {
      newOffset = _objectSpread$t(
        _objectSpread$t({}, offset),
        {},
        _defineProperty$12({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)),
      );
    }
  }
  return newOffset;
};
var isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
  if (_isNil(axisType)) {
    return true;
  }
  if (layout === 'horizontal') {
    return axisType === 'yAxis';
  }
  if (layout === 'vertical') {
    return axisType === 'xAxis';
  }
  if (direction === 'x') {
    return axisType === 'xAxis';
  }
  if (direction === 'y') {
    return axisType === 'yAxis';
  }
  return true;
};
var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
  var children = item.props.children;
  var errorBars = findAllByType(children, ErrorBar).filter(function (errorBarChild) {
    return isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
  });
  if (errorBars && errorBars.length) {
    var keys = errorBars.map(function (errorBarChild) {
      return errorBarChild.props.dataKey;
    });
    return data.reduce(
      function (result, entry) {
        var entryValue = getValueByDataKey(entry, dataKey, 0);
        var mainValue = _isArray(entryValue) ? [_min(entryValue), _max(entryValue)] : [entryValue, entryValue];
        var errorDomain = keys.reduce(
          function (prevErrorArr, k) {
            var errorValue = getValueByDataKey(entry, k, 0);
            var lowerValue = mainValue[0] - Math.abs(_isArray(errorValue) ? errorValue[0] : errorValue);
            var upperValue = mainValue[1] + Math.abs(_isArray(errorValue) ? errorValue[1] : errorValue);
            return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
          },
          [Infinity, -Infinity],
        );
        return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
      },
      [Infinity, -Infinity],
    );
  }
  return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
  var domains = items
    .map(function (item) {
      return getDomainOfErrorBars(data, item, dataKey, layout, axisType);
    })
    .filter(function (entry) {
      return !_isNil(entry);
    });
  if (domains && domains.length) {
    return domains.reduce(
      function (result, entry) {
        return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
      },
      [Infinity, -Infinity],
    );
  }
  return null;
};

/**
 * Get domain of data by the configuration of item element
 * @param  {Array}   data      The data displayed in the chart
 * @param  {Array}   items     The instances of item
 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
 * @param  {LayoutType} layout The type of layout
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array}        Domain
 */
var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
  var domains = items.map(function (item) {
    var dataKey = item.props.dataKey;
    if (type === 'number' && dataKey) {
      return getDomainOfErrorBars(data, item, dataKey, layout) || getDomainOfDataByKey(data, dataKey, type, filterNil);
    }
    return getDomainOfDataByKey(data, dataKey, type, filterNil);
  });
  if (type === 'number') {
    // Calculate the domain of number axis
    return domains.reduce(
      function (result, entry) {
        return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
      },
      [Infinity, -Infinity],
    );
  }
  var tag = {};
  // Get the union set of category axis
  return domains.reduce(function (result, entry) {
    for (var i = 0, len = entry.length; i < len; i++) {
      if (!tag[entry[i]]) {
        tag[entry[i]] = true;
        result.push(entry[i]);
      }
    }
    return result;
  }, []);
};
var isCategoricalAxis = function isCategoricalAxis(layout, axisType) {
  return (
    (layout === 'horizontal' && axisType === 'xAxis') ||
    (layout === 'vertical' && axisType === 'yAxis') ||
    (layout === 'centric' && axisType === 'angleAxis') ||
    (layout === 'radial' && axisType === 'radiusAxis')
  );
};

/**
 * Calculate the Coordinates of grid
 * @param  {Array} ticks The ticks in axis
 * @param {Number} min   The minimun value of axis
 * @param {Number} max   The maximun value of axis
 * @return {Array}       Coordinates
 */
var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
  var hasMin, hasMax;
  var values = ticks.map(function (entry) {
    if (entry.coordinate === min) {
      hasMin = true;
    }
    if (entry.coordinate === max) {
      hasMax = true;
    }
    return entry.coordinate;
  });
  if (!hasMin) {
    values.push(min);
  }
  if (!hasMax) {
    values.push(max);
  }
  return values;
};

/**
 * Get the ticks of an axis
 * @param  {Object}  axis The configuration of an axis
 * @param {Boolean} isGrid Whether or not are the ticks in grid
 * @param {Boolean} isAll Return the ticks of all the points or not
 * @return {Array}  Ticks
 */
var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
  if (!axis) return null;
  var scale = axis.scale;
  var duplicateDomain = axis.duplicateDomain,
    type = axis.type,
    range = axis.range;
  var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
  offset =
    axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2
      ? mathSign$1(range[0] - range[1]) * 2 * offset
      : offset;

  // The ticks set by user should only affect the ticks adjacent to axis line
  if (isGrid && (axis.ticks || axis.niceTicks)) {
    var result = (axis.ticks || axis.niceTicks).map(function (entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: scale(scaleContent) + offset,
        value: entry,
        offset: offset,
      };
    });
    return result.filter(function (row) {
      return !_isNaN$1(row.coordinate);
    });
  }

  // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
  if (axis.isCategorical && axis.categoricalDomain) {
    return axis.categoricalDomain.map(function (entry, index) {
      return {
        coordinate: scale(entry) + offset,
        value: entry,
        index: index,
        offset: offset,
      };
    });
  }
  if (scale.ticks && !isAll) {
    return scale.ticks(axis.tickCount).map(function (entry) {
      return {
        coordinate: scale(entry) + offset,
        value: entry,
        offset: offset,
      };
    });
  }

  // When axis has duplicated text, serial numbers are used to generate scale
  return scale.domain().map(function (entry, index) {
    return {
      coordinate: scale(entry) + offset,
      value: duplicateDomain ? duplicateDomain[entry] : entry,
      index: index,
      offset: offset,
    };
  });
};

/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} parentHandler  Handler function specified in parent component
 * @param  {Function} childHandler   Handler function specified in child component
 * @return {Function}                The combined handler
 */
var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
  var customizedHandler;
  if (_isFunction(childHandler)) {
    customizedHandler = childHandler;
  } else if (_isFunction(parentHandler)) {
    customizedHandler = parentHandler;
  }
  if (_isFunction(defaultHandler) || customizedHandler) {
    return function (arg1, arg2, arg3, arg4) {
      if (_isFunction(defaultHandler)) {
        defaultHandler(arg1, arg2, arg3, arg4);
      }
      if (_isFunction(customizedHandler)) {
        customizedHandler(arg1, arg2, arg3, arg4);
      }
    };
  }
  return null;
};
/**
 * Parse the scale function of axis
 * @param  {Object}   axis          The option of axis
 * @param  {String}   chartType     The displayName of chart
 * @param  {Boolean}  hasBar        if it has a bar
 * @return {Function}               The scale function
 */
var parseScale = function parseScale(axis, chartType, hasBar) {
  var scale = axis.scale,
    type = axis.type,
    layout = axis.layout,
    axisType = axis.axisType;
  if (scale === 'auto') {
    if (layout === 'radial' && axisType === 'radiusAxis') {
      return {
        scale: band(),
        realScaleType: 'band',
      };
    }
    if (layout === 'radial' && axisType === 'angleAxis') {
      return {
        scale: linear(),
        realScaleType: 'linear',
      };
    }
    if (
      type === 'category' &&
      chartType &&
      (chartType.indexOf('LineChart') >= 0 ||
        chartType.indexOf('AreaChart') >= 0 ||
        (chartType.indexOf('ComposedChart') >= 0 && !hasBar))
    ) {
      return {
        scale: point(),
        realScaleType: 'point',
      };
    }
    if (type === 'category') {
      return {
        scale: band(),
        realScaleType: 'band',
      };
    }
    return {
      scale: linear(),
      realScaleType: 'linear',
    };
  }
  if (_isString(scale)) {
    var name = 'scale'.concat(_upperFirst(scale));
    return {
      scale: (d3Scales[name] || point)(),
      realScaleType: d3Scales[name] ? name : 'point',
    };
  }
  return _isFunction(scale)
    ? {
        scale: scale,
      }
    : {
        scale: point(),
        realScaleType: 'point',
      };
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale(scale) {
  var domain = scale.domain();
  if (!domain || domain.length <= 2) {
    return;
  }
  var len = domain.length;
  var range = scale.range();
  var min = Math.min(range[0], range[1]) - EPS;
  var max = Math.max(range[0], range[1]) + EPS;
  var first = scale(domain[0]);
  var last = scale(domain[len - 1]);
  if (first < min || first > max || last < min || last > max) {
    scale.domain([domain[0], domain[len - 1]]);
  }
};
var findPositionOfBar = function findPositionOfBar(barPosition, child) {
  if (!barPosition) {
    return null;
  }
  for (var i = 0, len = barPosition.length; i < len; i++) {
    if (barPosition[i].item === child) {
      return barPosition[i].position;
    }
  }
  return null;
};
var truncateByDomain = function truncateByDomain(value, domain) {
  if (!domain || domain.length !== 2 || !isNumber(domain[0]) || !isNumber(domain[1])) {
    return value;
  }
  var min = Math.min(domain[0], domain[1]);
  var max = Math.max(domain[0], domain[1]);
  var result = [value[0], value[1]];
  if (!isNumber(value[0]) || value[0] < min) {
    result[0] = min;
  }
  if (!isNumber(value[1]) || value[1] > max) {
    result[1] = max;
  }
  if (result[0] > max) {
    result[0] = max;
  }
  if (result[1] < min) {
    result[1] = min;
  }
  return result;
};

/* eslint no-param-reassign: 0 */
var offsetSign = function offsetSign(series) {
  var n = series.length;
  if (n <= 0) {
    return;
  }
  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    var negative = 0;
    for (var i = 0; i < n; ++i) {
      var value = _isNaN$1(series[i][j][1]) ? series[i][j][0] : series[i][j][1];

      /* eslint-disable prefer-destructuring */
      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = negative;
        series[i][j][1] = negative + value;
        negative = series[i][j][1];
      }
      /* eslint-enable prefer-destructuring */
    }
  }
};

var offsetPositive = function offsetPositive(series) {
  var n = series.length;
  if (n <= 0) {
    return;
  }
  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    for (var i = 0; i < n; ++i) {
      var value = _isNaN$1(series[i][j][1]) ? series[i][j][0] : series[i][j][1];

      /* eslint-disable prefer-destructuring */
      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = 0;
        series[i][j][1] = 0;
      }
      /* eslint-enable prefer-destructuring */
    }
  }
};

var STACK_OFFSET_MAP = {
  sign: offsetSign,
  expand: stackOffsetExpand,
  none: stackOffsetNone,
  silhouette: stackOffsetSilhouette,
  wiggle: stackOffsetWiggle,
  positive: offsetPositive,
};
var getStackedData = function getStackedData(data, stackItems, offsetType) {
  var dataKeys = stackItems.map(function (item) {
    return item.props.dataKey;
  });
  var stack = shapeStack()
    .keys(dataKeys)
    .value(function (d, key) {
      return +getValueByDataKey(d, key, 0);
    })
    .order(stackOrderNone)
    .offset(STACK_OFFSET_MAP[offsetType]);
  return stack(data);
};
var getStackGroupsByAxisId = function getStackGroupsByAxisId(
  data,
  _items,
  numericAxisId,
  cateAxisId,
  offsetType,
  reverseStackOrder,
) {
  if (!data) {
    return null;
  }

  // reversing items to affect render order (for layering)
  var items = reverseStackOrder ? _items.reverse() : _items;
  var stackGroups = items.reduce(function (result, item) {
    var _item$props3 = item.props,
      stackId = _item$props3.stackId,
      hide = _item$props3.hide;
    if (hide) {
      return result;
    }
    var axisId = item.props[numericAxisId];
    var parentGroup = result[axisId] || {
      hasStack: false,
      stackGroups: {},
    };
    if (isNumOrStr(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId: numericAxisId,
        cateAxisId: cateAxisId,
        items: [],
      };
      childGroup.items.push(item);
      parentGroup.hasStack = true;
      parentGroup.stackGroups[stackId] = childGroup;
    } else {
      parentGroup.stackGroups[uniqueId('_stackId_')] = {
        numericAxisId: numericAxisId,
        cateAxisId: cateAxisId,
        items: [item],
      };
    }
    return _objectSpread$t(_objectSpread$t({}, result), {}, _defineProperty$12({}, axisId, parentGroup));
  }, {});
  return Object.keys(stackGroups).reduce(function (result, axisId) {
    var group = stackGroups[axisId];
    if (group.hasStack) {
      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
        var g = group.stackGroups[stackId];
        return _objectSpread$t(
          _objectSpread$t({}, res),
          {},
          _defineProperty$12({}, stackId, {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: g.items,
            stackedData: getStackedData(data, g.items, offsetType),
          }),
        );
      }, {});
    }
    return _objectSpread$t(_objectSpread$t({}, result), {}, _defineProperty$12({}, axisId, group));
  }, {});
};

/**
 * Configure the scale function of axis
 * @param {Object} scale The scale function
 * @param {Object} opts  The configuration of axis
 * @return {Object}      null
 */
var getTicksOfScale = function getTicksOfScale(scale, opts) {
  var realScaleType = opts.realScaleType,
    type = opts.type,
    tickCount = opts.tickCount,
    originalDomain = opts.originalDomain,
    allowDecimals = opts.allowDecimals;
  var scaleType = realScaleType || opts.scale;
  if (scaleType !== 'auto' && scaleType !== 'linear') {
    return null;
  }
  if (
    tickCount &&
    type === 'number' &&
    originalDomain &&
    (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')
  ) {
    // Calculate the ticks by the number of grid when the axis is a number axis
    var domain = scale.domain();
    if (!domain.length) {
      return null;
    }
    var tickValues = getNiceTickValues(domain, tickCount, allowDecimals);
    scale.domain([_min(tickValues), _max(tickValues)]);
    return {
      niceTicks: tickValues,
    };
  }
  if (tickCount && type === 'number') {
    var _domain = scale.domain();
    var _tickValues = getTickValuesFixedDomain(_domain, tickCount, allowDecimals);
    return {
      niceTicks: _tickValues,
    };
  }
  return null;
};
var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref7) {
  var axis = _ref7.axis,
    ticks = _ref7.ticks,
    bandSize = _ref7.bandSize,
    entry = _ref7.entry,
    index = _ref7.index,
    dataKey = _ref7.dataKey;
  if (axis.type === 'category') {
    // find coordinate of category axis by the value of category
    if (!axis.allowDuplicatedCategory && axis.dataKey && !_isNil(entry[axis.dataKey])) {
      var matchedTick = findEntryInArray(ticks, 'value', entry[axis.dataKey]);
      if (matchedTick) {
        return matchedTick.coordinate + bandSize / 2;
      }
    }
    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
  }
  var value = getValueByDataKey(entry, !_isNil(dataKey) ? dataKey : axis.dataKey);
  return !_isNil(value) ? axis.scale(value) : null;
};
var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref8) {
  var axis = _ref8.axis,
    ticks = _ref8.ticks,
    offset = _ref8.offset,
    bandSize = _ref8.bandSize,
    entry = _ref8.entry,
    index = _ref8.index;
  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + offset : null;
  }
  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
  return !_isNil(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var getBaseValueOfBar = function getBaseValueOfBar(_ref9) {
  var numericAxis = _ref9.numericAxis;
  var domain = numericAxis.scale.domain();
  if (numericAxis.type === 'number') {
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);
    if (min <= 0 && max >= 0) {
      return 0;
    }
    if (max < 0) {
      return max;
    }
    return min;
  }
  return domain[0];
};
var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
  var stackId = item.props.stackId;
  if (isNumOrStr(stackId)) {
    var group = stackGroups[stackId];
    if (group && group.items.length) {
      var itemIndex = -1;
      for (var i = 0, len = group.items.length; i < len; i++) {
        if (group.items[i] === item) {
          itemIndex = i;
          break;
        }
      }
      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }
  return null;
};
var getDomainOfSingle = function getDomainOfSingle(data) {
  return data.reduce(
    function (result, entry) {
      return [_min(entry.concat([result[0]]).filter(isNumber)), _max(entry.concat([result[1]]).filter(isNumber))];
    },
    [Infinity, -Infinity],
  );
};
var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups)
    .reduce(
      function (result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(
          function (res, entry) {
            var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
          },
          [Infinity, -Infinity],
        );
        return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
      },
      [Infinity, -Infinity],
    )
    .map(function (result) {
      return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
  if (_isFunction(specifiedDomain)) {
    return specifiedDomain(dataDomain, allowDataOverflow);
  }
  if (!_isArray(specifiedDomain)) {
    return dataDomain;
  }
  var domain = [];

  /* eslint-disable prefer-destructuring */
  if (isNumber(specifiedDomain[0])) {
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
    domain[0] = dataDomain[0] - value;
  } else if (_isFunction(specifiedDomain[0])) {
    domain[0] = specifiedDomain[0](dataDomain[0]);
  } else {
    domain[0] = dataDomain[0];
  }
  if (isNumber(specifiedDomain[1])) {
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
    domain[1] = dataDomain[1] + _value;
  } else if (_isFunction(specifiedDomain[1])) {
    domain[1] = specifiedDomain[1](dataDomain[1]);
  } else {
    domain[1] = dataDomain[1];
  }
  /* eslint-enable prefer-destructuring */

  return domain;
};

/**
 * Calculate the size between two category
 * @param  {Object} axis  The options of axis
 * @param  {Array}  ticks The ticks of axis
 * @param  {Boolean} isBar if items in axis are bars
 * @return {Number} Size
 */
var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks, isBar) {
  if (axis && axis.scale && axis.scale.bandwidth) {
    var bandWidth = axis.scale.bandwidth();
    if (!isBar || bandWidth > 0) {
      return bandWidth;
    }
  }
  if (axis && ticks && ticks.length >= 2) {
    var orderedTicks = _sortBy(ticks, function (o) {
      return o.coordinate;
    });
    var bandSize = Infinity;
    for (var i = 1, len = orderedTicks.length; i < len; i++) {
      var cur = orderedTicks[i];
      var prev = orderedTicks[i - 1];
      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }
    return bandSize === Infinity ? 0 : bandSize;
  }
  return isBar ? undefined : 0;
};
/**
 * parse the domain of a category axis when a domain is specified
 * @param   {Array}        specifiedDomain  The domain specified by users
 * @param   {Array}        calculatedDomain The domain calculated by dateKey
 * @param   {ReactElement} axisChild        The axis element
 * @returns {Array}        domains
 */
var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
  if (!specifiedDomain || !specifiedDomain.length) {
    return calculatedDomain;
  }
  if (_isEqual(specifiedDomain, _get(axisChild, 'type.defaultProps.domain'))) {
    return calculatedDomain;
  }
  return specifiedDomain;
};
var getTooltipItem = function getTooltipItem(graphicalItem, payload) {
  var _graphicalItem$props = graphicalItem.props,
    dataKey = _graphicalItem$props.dataKey,
    name = _graphicalItem$props.name,
    unit = _graphicalItem$props.unit,
    formatter = _graphicalItem$props.formatter,
    tooltipType = _graphicalItem$props.tooltipType,
    chartType = _graphicalItem$props.chartType;
  return _objectSpread$t(
    _objectSpread$t({}, filterProps(graphicalItem)),
    {},
    {
      dataKey: dataKey,
      unit: unit,
      formatter: formatter,
      name: name || dataKey,
      color: getMainColorOfGraphicItem(graphicalItem),
      value: getValueByDataKey(payload, dataKey),
      type: tooltipType,
      payload: payload,
      chartType: chartType,
    },
  );
};

function _typeof$16(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$16 =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$16(obj)
  );
}
function ownKeys$s(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$s(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$s(Object(source), !0).forEach(function (key) {
          _defineProperty$11(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$s(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$11(obj, key, value) {
  key = _toPropertyKey$x(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$x(arg) {
  var key = _toPrimitive$x(arg, 'string');
  return _typeof$16(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$x(input, hint) {
  if (_typeof$16(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$16(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _slicedToArray$5(arr, i) {
  return (
    _arrayWithHoles$5(arr) ||
    _iterableToArrayLimit$5(arr, i) ||
    _unsupportedIterableToArray$b(arr, i) ||
    _nonIterableRest$5()
  );
}
function _nonIterableRest$5() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$b(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$b(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$b(o, minLen);
}
function _arrayLikeToArray$b(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit$5(arr, i) {
  var _i = null == arr ? null : ('undefined' != typeof Symbol && arr[Symbol.iterator]) || arr['@@iterator'];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      (_d = !0), (_e = err);
    } finally {
      try {
        if (!_n && null != _i['return'] && ((_r = _i['return']()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$5(arr) {
  if (Array.isArray(arr)) return arr;
}
var RADIAN$1 = Math.PI / 180;
var radianToDegree = function radianToDegree(angleInRadian) {
  return (angleInRadian * 180) / Math.PI;
};
var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN$1 * angle) * radius,
    y: cy + Math.sin(-RADIAN$1 * angle) * radius,
  };
};
var getMaxRadius = function getMaxRadius(width, height) {
  var offset =
    arguments.length > 2 && arguments[2] !== undefined
      ? arguments[2]
      : {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        };
  return (
    Math.min(
      Math.abs(width - (offset.left || 0) - (offset.right || 0)),
      Math.abs(height - (offset.top || 0) - (offset.bottom || 0)),
    ) / 2
  );
};

/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */
var formatAxisMap$1 = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
    height = props.height;
  var startAngle = props.startAngle,
    endAngle = props.endAngle;
  var cx = getPercentValue(props.cx, width, width / 2);
  var cy = getPercentValue(props.cy, height, height / 2);
  var maxRadius = getMaxRadius(width, height, offset);
  var innerRadius = getPercentValue(props.innerRadius, maxRadius, 0);
  var outerRadius = getPercentValue(props.outerRadius, maxRadius, maxRadius * 0.8);
  var ids = Object.keys(axisMap);
  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var domain = axis.domain,
      reversed = axis.reversed;
    var range;
    if (_isNil(axis.range)) {
      if (axisType === 'angleAxis') {
        range = [startAngle, endAngle];
      } else if (axisType === 'radiusAxis') {
        range = [innerRadius, outerRadius];
      }
      if (reversed) {
        range = [range[1], range[0]];
      }
    } else {
      range = axis.range;
      var _range = range;
      var _range2 = _slicedToArray$5(_range, 2);
      startAngle = _range2[0];
      endAngle = _range2[1];
    }
    var _parseScale = parseScale(axis, chartName),
      realScaleType = _parseScale.realScaleType,
      scale = _parseScale.scale;
    scale.domain(domain).range(range);
    checkDomainOfScale(scale);
    var ticks = getTicksOfScale(
      scale,
      _objectSpread$s(
        _objectSpread$s({}, axis),
        {},
        {
          realScaleType: realScaleType,
        },
      ),
    );
    var finalAxis = _objectSpread$s(
      _objectSpread$s(_objectSpread$s({}, axis), ticks),
      {},
      {
        range: range,
        radius: outerRadius,
        realScaleType: realScaleType,
        scale: scale,
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
      },
    );
    return _objectSpread$s(_objectSpread$s({}, result), {}, _defineProperty$11({}, id, finalAxis));
  }, {});
};
var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
  var x1 = point.x,
    y1 = point.y;
  var x2 = anotherPoint.x,
    y2 = anotherPoint.y;
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
  var x = _ref.x,
    y = _ref.y;
  var cx = _ref2.cx,
    cy = _ref2.cy;
  var radius = distanceBetweenPoints(
    {
      x: x,
      y: y,
    },
    {
      x: cx,
      y: cy,
    },
  );
  if (radius <= 0) {
    return {
      radius: radius,
    };
  }
  var cos = (x - cx) / radius;
  var angleInRadian = Math.acos(cos);
  if (y > cy) {
    angleInRadian = 2 * Math.PI - angleInRadian;
  }
  return {
    radius: radius,
    angle: radianToDegree(angleInRadian),
    angleInRadian: angleInRadian,
  };
};
var formatAngleOfSector = function formatAngleOfSector(_ref3) {
  var startAngle = _ref3.startAngle,
    endAngle = _ref3.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);
  return {
    startAngle: startAngle - min * 360,
    endAngle: endAngle - min * 360,
  };
};
var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
  var startAngle = _ref4.startAngle,
    endAngle = _ref4.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);
  return angle + min * 360;
};
var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
  var x = _ref5.x,
    y = _ref5.y;
  var _getAngleOfPoint = getAngleOfPoint(
      {
        x: x,
        y: y,
      },
      sector,
    ),
    radius = _getAngleOfPoint.radius,
    angle = _getAngleOfPoint.angle;
  var innerRadius = sector.innerRadius,
    outerRadius = sector.outerRadius;
  if (radius < innerRadius || radius > outerRadius) {
    return false;
  }
  if (radius === 0) {
    return true;
  }
  var _formatAngleOfSector = formatAngleOfSector(sector),
    startAngle = _formatAngleOfSector.startAngle,
    endAngle = _formatAngleOfSector.endAngle;
  var formatAngle = angle;
  var inRange;
  if (startAngle <= endAngle) {
    while (formatAngle > endAngle) {
      formatAngle -= 360;
    }
    while (formatAngle < startAngle) {
      formatAngle += 360;
    }
    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
  } else {
    while (formatAngle > startAngle) {
      formatAngle -= 360;
    }
    while (formatAngle < endAngle) {
      formatAngle += 360;
    }
    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
  }
  if (inRange) {
    return _objectSpread$s(
      _objectSpread$s({}, sector),
      {},
      {
        radius: radius,
        angle: reverseFormatAngleOfSetor(formatAngle, sector),
      },
    );
  }
  return null;
};

function _typeof$15(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$15 =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$15(obj)
  );
}
function _toConsumableArray$7(arr) {
  return (
    _arrayWithoutHoles$7(arr) || _iterableToArray$7(arr) || _unsupportedIterableToArray$a(arr) || _nonIterableSpread$7()
  );
}
function _nonIterableSpread$7() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$a(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$a(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen);
}
function _iterableToArray$7(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$7(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$a(arr);
}
function _arrayLikeToArray$a(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function ownKeys$r(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$r(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$r(Object(source), !0).forEach(function (key) {
          _defineProperty$10(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$r(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$10(obj, key, value) {
  key = _toPropertyKey$w(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$w(arg) {
  var key = _toPrimitive$w(arg, 'string');
  return _typeof$15(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$w(input, hint) {
  if (_typeof$15(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$15(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _extends$t() {
  _extends$t = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$t.apply(this, arguments);
}
var getLabel = function getLabel(props) {
  var value = props.value,
    formatter = props.formatter;
  var label = _isNil(props.children) ? value : props.children;
  if (_isFunction(formatter)) {
    return formatter(label);
  }
  return label;
};
var getDeltaAngle$1 = function getDeltaAngle(startAngle, endAngle) {
  var sign = mathSign$1(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign * deltaAngle;
};
var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
  var position = labelProps.position,
    viewBox = labelProps.viewBox,
    offset = labelProps.offset,
    className = labelProps.className;
  var _ref = viewBox,
    cx$1 = _ref.cx,
    cy = _ref.cy,
    innerRadius = _ref.innerRadius,
    outerRadius = _ref.outerRadius,
    startAngle = _ref.startAngle,
    endAngle = _ref.endAngle,
    clockWise = _ref.clockWise;
  var radius = (innerRadius + outerRadius) / 2;
  var deltaAngle = getDeltaAngle$1(startAngle, endAngle);
  var sign = deltaAngle >= 0 ? 1 : -1;
  var labelAngle, direction;
  if (position === 'insideStart') {
    labelAngle = startAngle + sign * offset;
    direction = clockWise;
  } else if (position === 'insideEnd') {
    labelAngle = endAngle - sign * offset;
    direction = !clockWise;
  } else if (position === 'end') {
    labelAngle = endAngle + sign * offset;
    direction = clockWise;
  }
  direction = deltaAngle <= 0 ? direction : !direction;
  var startPoint = polarToCartesian(cx$1, cy, radius, labelAngle);
  var endPoint = polarToCartesian(cx$1, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
  var path = 'M'
    .concat(startPoint.x, ',')
    .concat(startPoint.y, '\n    A')
    .concat(radius, ',')
    .concat(radius, ',0,1,')
    .concat(direction ? 0 : 1, ',\n    ')
    .concat(endPoint.x, ',')
    .concat(endPoint.y);
  var id = _isNil(labelProps.id) ? uniqueId('recharts-radial-line-') : labelProps.id;
  return /*#__PURE__*/ React__default['default'].createElement(
    'text',
    _extends$t({}, attrs, {
      dominantBaseline: 'central',
      className: cx('recharts-radial-bar-label', className),
    }),
    /*#__PURE__*/ React__default['default'].createElement(
      'defs',
      null,
      /*#__PURE__*/ React__default['default'].createElement('path', {
        id: id,
        d: path,
      }),
    ),
    /*#__PURE__*/ React__default['default'].createElement(
      'textPath',
      {
        xlinkHref: '#'.concat(id),
      },
      label,
    ),
  );
};
var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
  var viewBox = props.viewBox,
    offset = props.offset,
    position = props.position;
  var _ref2 = viewBox,
    cx = _ref2.cx,
    cy = _ref2.cy,
    innerRadius = _ref2.innerRadius,
    outerRadius = _ref2.outerRadius,
    startAngle = _ref2.startAngle,
    endAngle = _ref2.endAngle;
  var midAngle = (startAngle + endAngle) / 2;
  if (position === 'outside') {
    var _polarToCartesian = polarToCartesian(cx, cy, outerRadius + offset, midAngle),
      _x = _polarToCartesian.x,
      _y = _polarToCartesian.y;
    return {
      x: _x,
      y: _y,
      textAnchor: _x >= cx ? 'start' : 'end',
      verticalAnchor: 'middle',
    };
  }
  if (position === 'center') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'middle',
    };
  }
  if (position === 'centerTop') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'start',
    };
  }
  if (position === 'centerBottom') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'end',
    };
  }
  var r = (innerRadius + outerRadius) / 2;
  var _polarToCartesian2 = polarToCartesian(cx, cy, r, midAngle),
    x = _polarToCartesian2.x,
    y = _polarToCartesian2.y;
  return {
    x: x,
    y: y,
    textAnchor: 'middle',
    verticalAnchor: 'middle',
  };
};
var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
  var viewBox = props.viewBox,
    parentViewBox = props.parentViewBox,
    offset = props.offset,
    position = props.position;
  var _ref3 = viewBox,
    x = _ref3.x,
    y = _ref3.y,
    width = _ref3.width,
    height = _ref3.height;

  // Define vertical offsets and position inverts based on the value being positive or negative
  var verticalSign = height >= 0 ? 1 : -1;
  var verticalOffset = verticalSign * offset;
  var verticalEnd = verticalSign > 0 ? 'end' : 'start';
  var verticalStart = verticalSign > 0 ? 'start' : 'end';

  // Define horizontal offsets and position inverts based on the value being positive or negative
  var horizontalSign = width >= 0 ? 1 : -1;
  var horizontalOffset = horizontalSign * offset;
  var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
  var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
  if (position === 'top') {
    var attrs = {
      x: x + width / 2,
      y: y - verticalSign * offset,
      textAnchor: 'middle',
      verticalAnchor: verticalEnd,
    };
    return _objectSpread$r(
      _objectSpread$r({}, attrs),
      parentViewBox
        ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width,
          }
        : {},
    );
  }
  if (position === 'bottom') {
    var _attrs = {
      x: x + width / 2,
      y: y + height + verticalOffset,
      textAnchor: 'middle',
      verticalAnchor: verticalStart,
    };
    return _objectSpread$r(
      _objectSpread$r({}, _attrs),
      parentViewBox
        ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width,
          }
        : {},
    );
  }
  if (position === 'left') {
    var _attrs2 = {
      x: x - horizontalOffset,
      y: y + height / 2,
      textAnchor: horizontalEnd,
      verticalAnchor: 'middle',
    };
    return _objectSpread$r(
      _objectSpread$r({}, _attrs2),
      parentViewBox
        ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height,
          }
        : {},
    );
  }
  if (position === 'right') {
    var _attrs3 = {
      x: x + width + horizontalOffset,
      y: y + height / 2,
      textAnchor: horizontalStart,
      verticalAnchor: 'middle',
    };
    return _objectSpread$r(
      _objectSpread$r({}, _attrs3),
      parentViewBox
        ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height,
          }
        : {},
    );
  }
  var sizeAttrs = parentViewBox
    ? {
        width: width,
        height: height,
      }
    : {};
  if (position === 'insideLeft') {
    return _objectSpread$r(
      {
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle',
      },
      sizeAttrs,
    );
  }
  if (position === 'insideRight') {
    return _objectSpread$r(
      {
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle',
      },
      sizeAttrs,
    );
  }
  if (position === 'insideTop') {
    return _objectSpread$r(
      {
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart,
      },
      sizeAttrs,
    );
  }
  if (position === 'insideBottom') {
    return _objectSpread$r(
      {
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd,
      },
      sizeAttrs,
    );
  }
  if (position === 'insideTopLeft') {
    return _objectSpread$r(
      {
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart,
      },
      sizeAttrs,
    );
  }
  if (position === 'insideTopRight') {
    return _objectSpread$r(
      {
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart,
      },
      sizeAttrs,
    );
  }
  if (position === 'insideBottomLeft') {
    return _objectSpread$r(
      {
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd,
      },
      sizeAttrs,
    );
  }
  if (position === 'insideBottomRight') {
    return _objectSpread$r(
      {
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd,
      },
      sizeAttrs,
    );
  }
  if (
    _isObject(position) &&
    (isNumber(position.x) || isPercent(position.x)) &&
    (isNumber(position.y) || isPercent(position.y))
  ) {
    return _objectSpread$r(
      {
        x: x + getPercentValue(position.x, width),
        y: y + getPercentValue(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end',
      },
      sizeAttrs,
    );
  }
  return _objectSpread$r(
    {
      x: x + width / 2,
      y: y + height / 2,
      textAnchor: 'middle',
      verticalAnchor: 'middle',
    },
    sizeAttrs,
  );
};
var isPolar = function isPolar(viewBox) {
  return 'cx' in viewBox && isNumber(viewBox.cx);
};
function Label(props) {
  var viewBox = props.viewBox,
    position = props.position,
    value = props.value,
    children = props.children,
    content = props.content,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    textBreakAll = props.textBreakAll;
  if (
    !viewBox ||
    (_isNil(value) && _isNil(children) && !(/*#__PURE__*/ React.isValidElement(content)) && !_isFunction(content))
  ) {
    return null;
  }
  if (/*#__PURE__*/ React.isValidElement(content)) {
    return /*#__PURE__*/ React.cloneElement(content, props);
  }
  var label;
  if (_isFunction(content)) {
    label = /*#__PURE__*/ React.createElement(content, props);
    if (/*#__PURE__*/ React.isValidElement(label)) {
      return label;
    }
  } else {
    label = getLabel(props);
  }
  var isPolarLabel = isPolar(viewBox);
  var attrs = filterProps(props, true);
  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
    return renderRadialLabel(props, label, attrs);
  }
  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
  return /*#__PURE__*/ React__default['default'].createElement(
    Text,
    _extends$t(
      {
        className: cx('recharts-label', className),
      },
      attrs,
      positionAttrs,
      {
        breakAll: textBreakAll,
      },
    ),
    label,
  );
}
Label.displayName = 'Label';
Label.defaultProps = {
  offset: 5,
};
var parseViewBox = function parseViewBox(props) {
  var cx = props.cx,
    cy = props.cy,
    angle = props.angle,
    startAngle = props.startAngle,
    endAngle = props.endAngle,
    r = props.r,
    radius = props.radius,
    innerRadius = props.innerRadius,
    outerRadius = props.outerRadius,
    x = props.x,
    y = props.y,
    top = props.top,
    left = props.left,
    width = props.width,
    height = props.height,
    clockWise = props.clockWise,
    labelViewBox = props.labelViewBox;
  if (labelViewBox) {
    return labelViewBox;
  }
  if (isNumber(width) && isNumber(height)) {
    if (isNumber(x) && isNumber(y)) {
      return {
        x: x,
        y: y,
        width: width,
        height: height,
      };
    }
    if (isNumber(top) && isNumber(left)) {
      return {
        x: top,
        y: left,
        width: width,
        height: height,
      };
    }
  }
  if (isNumber(x) && isNumber(y)) {
    return {
      x: x,
      y: y,
      width: 0,
      height: 0,
    };
  }
  if (isNumber(cx) && isNumber(cy)) {
    return {
      cx: cx,
      cy: cy,
      startAngle: startAngle || angle || 0,
      endAngle: endAngle || angle || 0,
      innerRadius: innerRadius || 0,
      outerRadius: outerRadius || radius || r || 0,
      clockWise: clockWise,
    };
  }
  if (props.viewBox) {
    return props.viewBox;
  }
  return {};
};
var parseLabel = function parseLabel(label, viewBox) {
  if (!label) {
    return null;
  }
  if (label === true) {
    return /*#__PURE__*/ React__default['default'].createElement(Label, {
      key: 'label-implicit',
      viewBox: viewBox,
    });
  }
  if (isNumOrStr(label)) {
    return /*#__PURE__*/ React__default['default'].createElement(Label, {
      key: 'label-implicit',
      viewBox: viewBox,
      value: label,
    });
  }
  if (/*#__PURE__*/ React.isValidElement(label)) {
    if (label.type === Label) {
      return /*#__PURE__*/ React.cloneElement(label, {
        key: 'label-implicit',
        viewBox: viewBox,
      });
    }
    return /*#__PURE__*/ React__default['default'].createElement(Label, {
      key: 'label-implicit',
      content: label,
      viewBox: viewBox,
    });
  }
  if (_isFunction(label)) {
    return /*#__PURE__*/ React__default['default'].createElement(Label, {
      key: 'label-implicit',
      content: label,
      viewBox: viewBox,
    });
  }
  if (_isObject(label)) {
    return /*#__PURE__*/ React__default['default'].createElement(
      Label,
      _extends$t(
        {
          viewBox: viewBox,
        },
        label,
        {
          key: 'label-implicit',
        },
      ),
    );
  }
  return null;
};
var renderCallByParent$1 = function renderCallByParent(parentProps, viewBox) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!parentProps || (!parentProps.children && checkPropsLabel && !parentProps.label)) {
    return null;
  }
  var children = parentProps.children;
  var parentViewBox = parseViewBox(parentProps);
  var explicitChildren = findAllByType(children, Label).map(function (child, index) {
    return /*#__PURE__*/ React.cloneElement(child, {
      viewBox: viewBox || parentViewBox,
      // eslint-disable-next-line react/no-array-index-key
      key: 'label-'.concat(index),
    });
  });
  if (!checkPropsLabel) {
    return explicitChildren;
  }
  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
  return [implicitLabel].concat(_toConsumableArray$7(explicitChildren));
};
Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent$1;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last$1;

var _last = /*@__PURE__*/ getDefaultExportFromCjs(last_1);

function _typeof$14(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$14 =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$14(obj)
  );
}
var _excluded$c = ['data', 'valueAccessor', 'dataKey', 'clockWise', 'id', 'textBreakAll'];
function _toConsumableArray$6(arr) {
  return (
    _arrayWithoutHoles$6(arr) || _iterableToArray$6(arr) || _unsupportedIterableToArray$9(arr) || _nonIterableSpread$6()
  );
}
function _nonIterableSpread$6() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$9(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$9(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen);
}
function _iterableToArray$6(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$6(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$9(arr);
}
function _arrayLikeToArray$9(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _extends$s() {
  _extends$s = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$s.apply(this, arguments);
}
function ownKeys$q(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$q(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$q(Object(source), !0).forEach(function (key) {
          _defineProperty$$(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$q(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$$(obj, key, value) {
  key = _toPropertyKey$v(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$v(arg) {
  var key = _toPrimitive$v(arg, 'string');
  return _typeof$14(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$v(input, hint) {
  if (_typeof$14(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$14(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _objectWithoutProperties$c(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$e(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$e(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var defaultProps$1 = {
  valueAccessor: function valueAccessor(entry) {
    return _isArray(entry.value) ? _last(entry.value) : entry.value;
  },
};
function LabelList(props) {
  var data = props.data,
    valueAccessor = props.valueAccessor,
    dataKey = props.dataKey,
    clockWise = props.clockWise,
    id = props.id,
    textBreakAll = props.textBreakAll,
    others = _objectWithoutProperties$c(props, _excluded$c);
  if (!data || !data.length) {
    return null;
  }
  return /*#__PURE__*/ React__default['default'].createElement(
    Layer,
    {
      className: 'recharts-label-list',
    },
    data.map(function (entry, index) {
      var value = _isNil(dataKey) ? valueAccessor(entry, index) : getValueByDataKey(entry && entry.payload, dataKey);
      var idProps = _isNil(id)
        ? {}
        : {
            id: ''.concat(id, '-').concat(index),
          };
      return /*#__PURE__*/ React__default['default'].createElement(
        Label,
        _extends$s({}, filterProps(entry, true), others, idProps, {
          parentViewBox: entry.parentViewBox,
          index: index,
          value: value,
          textBreakAll: textBreakAll,
          viewBox: Label.parseViewBox(
            _isNil(clockWise)
              ? entry
              : _objectSpread$q(
                  _objectSpread$q({}, entry),
                  {},
                  {
                    clockWise: clockWise,
                  },
                ),
          ),
          key: 'label-'.concat(index), // eslint-disable-line react/no-array-index-key
        }),
      );
    }),
  );
}

LabelList.displayName = 'LabelList';
function parseLabelList(label, data) {
  if (!label) {
    return null;
  }
  if (label === true) {
    return /*#__PURE__*/ React__default['default'].createElement(LabelList, {
      key: 'labelList-implicit',
      data: data,
    });
  }
  if (/*#__PURE__*/ React__default['default'].isValidElement(label) || _isFunction(label)) {
    return /*#__PURE__*/ React__default['default'].createElement(LabelList, {
      key: 'labelList-implicit',
      data: data,
      content: label,
    });
  }
  if (_isObject(label)) {
    return /*#__PURE__*/ React__default['default'].createElement(
      LabelList,
      _extends$s(
        {
          data: data,
        },
        label,
        {
          key: 'labelList-implicit',
        },
      ),
    );
  }
  return null;
}
function renderCallByParent(parentProps, data) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!parentProps || (!parentProps.children && checkPropsLabel && !parentProps.label)) {
    return null;
  }
  var children = parentProps.children;
  var explicitChildren = findAllByType(children, LabelList).map(function (child, index) {
    return /*#__PURE__*/ React.cloneElement(child, {
      data: data,
      // eslint-disable-next-line react/no-array-index-key
      key: 'labelList-'.concat(index),
    });
  });
  if (!checkPropsLabel) {
    return explicitChildren;
  }
  var implicitLabelList = parseLabelList(parentProps.label, data);
  return [implicitLabelList].concat(_toConsumableArray$6(explicitChildren));
}
LabelList.renderCallByParent = renderCallByParent;
LabelList.defaultProps = defaultProps$1;

function _typeof$13(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$13 =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$13(obj)
  );
}
function _extends$r() {
  _extends$r = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$r.apply(this, arguments);
}
function _classCallCheck$V(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$V(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$u(descriptor.key), descriptor);
  }
}
function _createClass$V(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$V(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$V(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$T(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$V(subClass, superClass);
}
function _setPrototypeOf$V(o, p) {
  _setPrototypeOf$V = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$V(o, p);
}
function _createSuper$T(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$T();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$T(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$T(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$T(this, result);
  };
}
function _possibleConstructorReturn$T(self, call) {
  if (call && (_typeof$13(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$V(self);
}
function _assertThisInitialized$V(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$T() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$T(o) {
  _getPrototypeOf$T = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$T(o);
}
function _defineProperty$_(obj, key, value) {
  key = _toPropertyKey$u(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$u(arg) {
  var key = _toPrimitive$u(arg, 'string');
  return _typeof$13(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$u(input, hint) {
  if (_typeof$13(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$13(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = mathSign$1(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
  return sign * deltaAngle;
};
var getTangentCircle = function getTangentCircle(_ref) {
  var cx = _ref.cx,
    cy = _ref.cy,
    radius = _ref.radius,
    angle = _ref.angle,
    sign = _ref.sign,
    isExternal = _ref.isExternal,
    cornerRadius = _ref.cornerRadius,
    cornerIsExternal = _ref.cornerIsExternal;
  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
  var theta = Math.asin(cornerRadius / centerRadius) / RADIAN$1;
  var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
  var center = polarToCartesian(cx, cy, centerRadius, centerAngle);
  // The coordinate of point which is tangent to the circle
  var circleTangency = polarToCartesian(cx, cy, radius, centerAngle);
  // The coordinate of point which is tangent to the radius line
  var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
  var lineTangency = polarToCartesian(cx, cy, centerRadius * Math.cos(theta * RADIAN$1), lineTangencyAngle);
  return {
    center: center,
    circleTangency: circleTangency,
    lineTangency: lineTangency,
    theta: theta,
  };
};
var getSectorPath = function getSectorPath(_ref2) {
  var cx = _ref2.cx,
    cy = _ref2.cy,
    innerRadius = _ref2.innerRadius,
    outerRadius = _ref2.outerRadius,
    startAngle = _ref2.startAngle,
    endAngle = _ref2.endAngle;
  var angle = getDeltaAngle(startAngle, endAngle);

  // When the angle of sector equals to 360, star point and end point coincide
  var tempEndAngle = startAngle + angle;
  var outerStartPoint = polarToCartesian(cx, cy, outerRadius, startAngle);
  var outerEndPoint = polarToCartesian(cx, cy, outerRadius, tempEndAngle);
  var path = 'M '
    .concat(outerStartPoint.x, ',')
    .concat(outerStartPoint.y, '\n    A ')
    .concat(outerRadius, ',')
    .concat(outerRadius, ',0,\n    ')
    .concat(+(Math.abs(angle) > 180), ',')
    .concat(+(startAngle > tempEndAngle), ',\n    ')
    .concat(outerEndPoint.x, ',')
    .concat(outerEndPoint.y, '\n  ');
  if (innerRadius > 0) {
    var innerStartPoint = polarToCartesian(cx, cy, innerRadius, startAngle);
    var innerEndPoint = polarToCartesian(cx, cy, innerRadius, tempEndAngle);
    path += 'L '
      .concat(innerEndPoint.x, ',')
      .concat(innerEndPoint.y, '\n            A ')
      .concat(innerRadius, ',')
      .concat(innerRadius, ',0,\n            ')
      .concat(+(Math.abs(angle) > 180), ',')
      .concat(+(startAngle <= tempEndAngle), ',\n            ')
      .concat(innerStartPoint.x, ',')
      .concat(innerStartPoint.y, ' Z');
  } else {
    path += 'L '.concat(cx, ',').concat(cy, ' Z');
  }
  return path;
};
var getSectorWithCorner = function getSectorWithCorner(_ref3) {
  var cx = _ref3.cx,
    cy = _ref3.cy,
    innerRadius = _ref3.innerRadius,
    outerRadius = _ref3.outerRadius,
    cornerRadius = _ref3.cornerRadius,
    forceCornerRadius = _ref3.forceCornerRadius,
    cornerIsExternal = _ref3.cornerIsExternal,
    startAngle = _ref3.startAngle,
    endAngle = _ref3.endAngle;
  var sign = mathSign$1(endAngle - startAngle);
  var _getTangentCircle = getTangentCircle({
      cx: cx,
      cy: cy,
      radius: outerRadius,
      angle: startAngle,
      sign: sign,
      cornerRadius: cornerRadius,
      cornerIsExternal: cornerIsExternal,
    }),
    soct = _getTangentCircle.circleTangency,
    solt = _getTangentCircle.lineTangency,
    sot = _getTangentCircle.theta;
  var _getTangentCircle2 = getTangentCircle({
      cx: cx,
      cy: cy,
      radius: outerRadius,
      angle: endAngle,
      sign: -sign,
      cornerRadius: cornerRadius,
      cornerIsExternal: cornerIsExternal,
    }),
    eoct = _getTangentCircle2.circleTangency,
    eolt = _getTangentCircle2.lineTangency,
    eot = _getTangentCircle2.theta;
  var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
  if (outerArcAngle < 0) {
    if (forceCornerRadius) {
      return 'M '
        .concat(solt.x, ',')
        .concat(solt.y, '\n        a')
        .concat(cornerRadius, ',')
        .concat(cornerRadius, ',0,0,1,')
        .concat(cornerRadius * 2, ',0\n        a')
        .concat(cornerRadius, ',')
        .concat(cornerRadius, ',0,0,1,')
        .concat(-cornerRadius * 2, ',0\n      ');
    }
    return getSectorPath({
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle,
    });
  }
  var path = 'M '
    .concat(solt.x, ',')
    .concat(solt.y, '\n    A')
    .concat(cornerRadius, ',')
    .concat(cornerRadius, ',0,0,')
    .concat(+(sign < 0), ',')
    .concat(soct.x, ',')
    .concat(soct.y, '\n    A')
    .concat(outerRadius, ',')
    .concat(outerRadius, ',0,')
    .concat(+(outerArcAngle > 180), ',')
    .concat(+(sign < 0), ',')
    .concat(eoct.x, ',')
    .concat(eoct.y, '\n    A')
    .concat(cornerRadius, ',')
    .concat(cornerRadius, ',0,0,')
    .concat(+(sign < 0), ',')
    .concat(eolt.x, ',')
    .concat(eolt.y, '\n  ');
  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: innerRadius,
        angle: startAngle,
        sign: sign,
        isExternal: true,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal,
      }),
      sict = _getTangentCircle3.circleTangency,
      silt = _getTangentCircle3.lineTangency,
      sit = _getTangentCircle3.theta;
    var _getTangentCircle4 = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: innerRadius,
        angle: endAngle,
        sign: -sign,
        isExternal: true,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal,
      }),
      eict = _getTangentCircle4.circleTangency,
      eilt = _getTangentCircle4.lineTangency,
      eit = _getTangentCircle4.theta;
    var innerArcAngle = cornerIsExternal
      ? Math.abs(startAngle - endAngle)
      : Math.abs(startAngle - endAngle) - sit - eit;
    if (innerArcAngle < 0 && cornerRadius === 0) {
      return ''.concat(path, 'L').concat(cx, ',').concat(cy, 'Z');
    }
    path += 'L'
      .concat(eilt.x, ',')
      .concat(eilt.y, '\n      A')
      .concat(cornerRadius, ',')
      .concat(cornerRadius, ',0,0,')
      .concat(+(sign < 0), ',')
      .concat(eict.x, ',')
      .concat(eict.y, '\n      A')
      .concat(innerRadius, ',')
      .concat(innerRadius, ',0,')
      .concat(+(innerArcAngle > 180), ',')
      .concat(+(sign > 0), ',')
      .concat(sict.x, ',')
      .concat(sict.y, '\n      A')
      .concat(cornerRadius, ',')
      .concat(cornerRadius, ',0,0,')
      .concat(+(sign < 0), ',')
      .concat(silt.x, ',')
      .concat(silt.y, 'Z');
  } else {
    path += 'L'.concat(cx, ',').concat(cy, 'Z');
  }
  return path;
};
var Sector = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$T(Sector, _PureComponent);
  var _super = _createSuper$T(Sector);
  function Sector() {
    _classCallCheck$V(this, Sector);
    return _super.apply(this, arguments);
  }
  _createClass$V(Sector, [
    {
      key: 'render',
      value: function render() {
        var _this$props = this.props,
          cx$1 = _this$props.cx,
          cy = _this$props.cy,
          innerRadius = _this$props.innerRadius,
          outerRadius = _this$props.outerRadius,
          cornerRadius = _this$props.cornerRadius,
          forceCornerRadius = _this$props.forceCornerRadius,
          cornerIsExternal = _this$props.cornerIsExternal,
          startAngle = _this$props.startAngle,
          endAngle = _this$props.endAngle,
          className = _this$props.className;
        if (outerRadius < innerRadius || startAngle === endAngle) {
          return null;
        }
        var layerClass = cx('recharts-sector', className);
        var deltaRadius = outerRadius - innerRadius;
        var cr = getPercentValue(cornerRadius, deltaRadius, 0, true);
        var path;
        if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
          path = getSectorWithCorner({
            cx: cx$1,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            cornerRadius: Math.min(cr, deltaRadius / 2),
            forceCornerRadius: forceCornerRadius,
            cornerIsExternal: cornerIsExternal,
            startAngle: startAngle,
            endAngle: endAngle,
          });
        } else {
          path = getSectorPath({
            cx: cx$1,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle,
          });
        }
        return /*#__PURE__*/ React__default['default'].createElement(
          'path',
          _extends$r({}, filterProps(this.props, true), {
            className: layerClass,
            d: path,
            role: 'img',
          }),
        );
      },
    },
  ]);
  return Sector;
})(React.PureComponent);
_defineProperty$_(Sector, 'defaultProps', {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: false,
  cornerIsExternal: false,
});

function _typeof$12(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$12 =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$12(obj)
  );
}
function _extends$q() {
  _extends$q = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$q.apply(this, arguments);
}
function ownKeys$p(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$p(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$p(Object(source), !0).forEach(function (key) {
          _defineProperty$Z(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$p(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$U(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$U(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$t(descriptor.key), descriptor);
  }
}
function _createClass$U(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$U(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$U(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$S(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$U(subClass, superClass);
}
function _setPrototypeOf$U(o, p) {
  _setPrototypeOf$U = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$U(o, p);
}
function _createSuper$S(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$S();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$S(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$S(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$S(this, result);
  };
}
function _possibleConstructorReturn$S(self, call) {
  if (call && (_typeof$12(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$U(self);
}
function _assertThisInitialized$U(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$S() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$S(o) {
  _getPrototypeOf$S = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$S(o);
}
function _defineProperty$Z(obj, key, value) {
  key = _toPropertyKey$t(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$t(arg) {
  var key = _toPrimitive$t(arg, 'string');
  return _typeof$12(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$t(input, hint) {
  if (_typeof$12(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$12(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var CURVE_FACTORIES = {
  curveBasisClosed: curveBasisClosed,
  curveBasisOpen: curveBasisOpen,
  curveBasis: curveBasis,
  curveLinearClosed: curveLinearClosed,
  curveLinear: curveLinear,
  curveMonotoneX: monotoneX,
  curveMonotoneY: monotoneY,
  curveNatural: curveNatural,
  curveStep: curveStep,
  curveStepAfter: stepAfter,
  curveStepBefore: stepBefore,
};
var defined = function defined(p) {
  return p.x === +p.x && p.y === +p.y;
};
var getX = function getX(p) {
  return p.x;
};
var getY = function getY(p) {
  return p.y;
};
var getCurveFactory = function getCurveFactory(type, layout) {
  if (_isFunction(type)) {
    return type;
  }
  var name = 'curve'.concat(_upperFirst(type));
  if (name === 'curveMonotone' && layout) {
    return CURVE_FACTORIES[''.concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
  }
  return CURVE_FACTORIES[name] || curveLinear;
};
var Curve = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$S(Curve, _PureComponent);
  var _super = _createSuper$S(Curve);
  function Curve() {
    _classCallCheck$U(this, Curve);
    return _super.apply(this, arguments);
  }
  _createClass$U(Curve, [
    {
      key: 'getPath',
      value:
        /**
         * Calculate the path of curve
         * @return {String} path
         */
        function getPath() {
          var _this$props = this.props,
            type = _this$props.type,
            points = _this$props.points,
            baseLine = _this$props.baseLine,
            layout = _this$props.layout,
            connectNulls = _this$props.connectNulls;
          var curveFactory = getCurveFactory(type, layout);
          var formatPoints = connectNulls
            ? points.filter(function (entry) {
                return defined(entry);
              })
            : points;
          var lineFunction;
          if (_isArray(baseLine)) {
            var formatBaseLine = connectNulls
              ? baseLine.filter(function (base) {
                  return defined(base);
                })
              : baseLine;
            var areaPoints = formatPoints.map(function (entry, index) {
              return _objectSpread$p(
                _objectSpread$p({}, entry),
                {},
                {
                  base: formatBaseLine[index],
                },
              );
            });
            if (layout === 'vertical') {
              lineFunction = shapeArea()
                .y(getY)
                .x1(getX)
                .x0(function (d) {
                  return d.base.x;
                });
            } else {
              lineFunction = shapeArea()
                .x(getX)
                .y1(getY)
                .y0(function (d) {
                  return d.base.y;
                });
            }
            lineFunction.defined(defined).curve(curveFactory);
            return lineFunction(areaPoints);
          }
          if (layout === 'vertical' && isNumber(baseLine)) {
            lineFunction = shapeArea().y(getY).x1(getX).x0(baseLine);
          } else if (isNumber(baseLine)) {
            lineFunction = shapeArea().x(getX).y1(getY).y0(baseLine);
          } else {
            lineFunction = shapeLine().x(getX).y(getY);
          }
          lineFunction.defined(defined).curve(curveFactory);
          return lineFunction(formatPoints);
        },
    },
    {
      key: 'render',
      value: function render() {
        var _this$props2 = this.props,
          className = _this$props2.className,
          points = _this$props2.points,
          path = _this$props2.path,
          pathRef = _this$props2.pathRef;
        if ((!points || !points.length) && !path) {
          return null;
        }
        var realPath = points && points.length ? this.getPath() : path;
        return /*#__PURE__*/ React__default['default'].createElement(
          'path',
          _extends$q({}, filterProps(this.props), adaptEventHandlers(this.props), {
            className: cx('recharts-curve', className),
            d: realPath,
            ref: pathRef,
          }),
        );
      },
    },
  ]);
  return Curve;
})(React.PureComponent);
_defineProperty$Z(Curve, 'defaultProps', {
  type: 'linear',
  points: [],
  connectNulls: false,
});

function _typeof$11(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$11 =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$11(obj)
  );
}
function _extends$p() {
  _extends$p = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$p.apply(this, arguments);
}
function _classCallCheck$T(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$T(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$s(descriptor.key), descriptor);
  }
}
function _createClass$T(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$T(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$T(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$R(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$T(subClass, superClass);
}
function _setPrototypeOf$T(o, p) {
  _setPrototypeOf$T = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$T(o, p);
}
function _createSuper$R(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$R();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$R(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$R(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$R(this, result);
  };
}
function _possibleConstructorReturn$R(self, call) {
  if (call && (_typeof$11(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$T(self);
}
function _assertThisInitialized$T(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$R() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$R(o) {
  _getPrototypeOf$R = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$R(o);
}
function _defineProperty$Y(obj, key, value) {
  key = _toPropertyKey$s(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$s(arg) {
  var key = _toPrimitive$s(arg, 'string');
  return _typeof$11(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$s(input, hint) {
  if (_typeof$11(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$11(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
  var ySign = height >= 0 ? 1 : -1;
  var xSign = width >= 0 ? 1 : -1;
  var clockWise = (height >= 0 && width >= 0) || (height < 0 && width < 0) ? 1 : 0;
  var path;
  if (maxRadius > 0 && radius instanceof Array) {
    var newRadius = [0, 0, 0, 0];
    for (var i = 0, len = 4; i < len; i++) {
      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
    }
    path = 'M'.concat(x, ',').concat(y + ySign * newRadius[0]);
    if (newRadius[0] > 0) {
      path += 'A '
        .concat(newRadius[0], ',')
        .concat(newRadius[0], ',0,0,')
        .concat(clockWise, ',')
        .concat(x + xSign * newRadius[0], ',')
        .concat(y);
    }
    path += 'L '.concat(x + width - xSign * newRadius[1], ',').concat(y);
    if (newRadius[1] > 0) {
      path += 'A '
        .concat(newRadius[1], ',')
        .concat(newRadius[1], ',0,0,')
        .concat(clockWise, ',\n        ')
        .concat(x + width, ',')
        .concat(y + ySign * newRadius[1]);
    }
    path += 'L '.concat(x + width, ',').concat(y + height - ySign * newRadius[2]);
    if (newRadius[2] > 0) {
      path += 'A '
        .concat(newRadius[2], ',')
        .concat(newRadius[2], ',0,0,')
        .concat(clockWise, ',\n        ')
        .concat(x + width - xSign * newRadius[2], ',')
        .concat(y + height);
    }
    path += 'L '.concat(x + xSign * newRadius[3], ',').concat(y + height);
    if (newRadius[3] > 0) {
      path += 'A '
        .concat(newRadius[3], ',')
        .concat(newRadius[3], ',0,0,')
        .concat(clockWise, ',\n        ')
        .concat(x, ',')
        .concat(y + height - ySign * newRadius[3]);
    }
    path += 'Z';
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);
    path = 'M '
      .concat(x, ',')
      .concat(y + ySign * _newRadius, '\n            A ')
      .concat(_newRadius, ',')
      .concat(_newRadius, ',0,0,')
      .concat(clockWise, ',')
      .concat(x + xSign * _newRadius, ',')
      .concat(y, '\n            L ')
      .concat(x + width - xSign * _newRadius, ',')
      .concat(y, '\n            A ')
      .concat(_newRadius, ',')
      .concat(_newRadius, ',0,0,')
      .concat(clockWise, ',')
      .concat(x + width, ',')
      .concat(y + ySign * _newRadius, '\n            L ')
      .concat(x + width, ',')
      .concat(y + height - ySign * _newRadius, '\n            A ')
      .concat(_newRadius, ',')
      .concat(_newRadius, ',0,0,')
      .concat(clockWise, ',')
      .concat(x + width - xSign * _newRadius, ',')
      .concat(y + height, '\n            L ')
      .concat(x + xSign * _newRadius, ',')
      .concat(y + height, '\n            A ')
      .concat(_newRadius, ',')
      .concat(_newRadius, ',0,0,')
      .concat(clockWise, ',')
      .concat(x, ',')
      .concat(y + height - ySign * _newRadius, ' Z');
  } else {
    path = 'M '.concat(x, ',').concat(y, ' h ').concat(width, ' v ').concat(height, ' h ').concat(-width, ' Z');
  }
  return path;
};
var isInRectangle = function isInRectangle(point, rect) {
  if (!point || !rect) {
    return false;
  }
  var px = point.x,
    py = point.y;
  var x = rect.x,
    y = rect.y,
    width = rect.width,
    height = rect.height;
  if (Math.abs(width) > 0 && Math.abs(height) > 0) {
    var minX = Math.min(x, x + width);
    var maxX = Math.max(x, x + width);
    var minY = Math.min(y, y + height);
    var maxY = Math.max(y, y + height);
    return px >= minX && px <= maxX && py >= minY && py <= maxY;
  }
  return false;
};
var Rectangle = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$R(Rectangle, _PureComponent);
  var _super = _createSuper$R(Rectangle);
  function Rectangle() {
    var _this;
    _classCallCheck$T(this, Rectangle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$Y(_assertThisInitialized$T(_this), 'state', {
      totalLength: -1,
    });
    return _this;
  }
  _createClass$T(Rectangle, [
    {
      key: 'componentDidMount',
      /* eslint-disable  react/no-did-mount-set-state */
      value: function componentDidMount() {
        if (this.node && this.node.getTotalLength) {
          try {
            var totalLength = this.node.getTotalLength();
            if (totalLength) {
              this.setState({
                totalLength: totalLength,
              });
            }
          } catch (err) {
            // calculate total length error
          }
        }
      },
    },
    {
      key: 'render',
      value: function render() {
        var _this2 = this;
        var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          width = _this$props.width,
          height = _this$props.height,
          radius = _this$props.radius,
          className = _this$props.className;
        var totalLength = this.state.totalLength;
        var _this$props2 = this.props,
          animationEasing = _this$props2.animationEasing,
          animationDuration = _this$props2.animationDuration,
          animationBegin = _this$props2.animationBegin,
          isAnimationActive = _this$props2.isAnimationActive,
          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
        if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
          return null;
        }
        var layerClass = cx('recharts-rectangle', className);
        if (!isUpdateAnimationActive) {
          return /*#__PURE__*/ React__default['default'].createElement(
            'path',
            _extends$p({}, filterProps(this.props, true), {
              className: layerClass,
              d: getRectanglePath(x, y, width, height, radius),
            }),
          );
        }
        return /*#__PURE__*/ React__default['default'].createElement(
          Animate,
          {
            canBegin: totalLength > 0,
            from: {
              width: width,
              height: height,
              x: x,
              y: y,
            },
            to: {
              width: width,
              height: height,
              x: x,
              y: y,
            },
            duration: animationDuration,
            animationEasing: animationEasing,
            isActive: isUpdateAnimationActive,
          },
          function (_ref) {
            var currWidth = _ref.width,
              currHeight = _ref.height,
              currX = _ref.x,
              currY = _ref.y;
            return /*#__PURE__*/ React__default['default'].createElement(
              Animate,
              {
                canBegin: totalLength > 0,
                from: '0px '.concat(totalLength === -1 ? 1 : totalLength, 'px'),
                to: ''.concat(totalLength, 'px 0px'),
                attributeName: 'strokeDasharray',
                begin: animationBegin,
                duration: animationDuration,
                isActive: isAnimationActive,
                easing: animationEasing,
              },
              /*#__PURE__*/ React__default['default'].createElement(
                'path',
                _extends$p({}, filterProps(_this2.props, true), {
                  className: layerClass,
                  d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
                  ref: function ref(node) {
                    _this2.node = node;
                  },
                }),
              ),
            );
          },
        );
      },
    },
  ]);
  return Rectangle;
})(React.PureComponent);
_defineProperty$Y(Rectangle, 'defaultProps', {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: false,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
});

function _typeof$10(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$10 =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$10(obj)
  );
}
var _excluded$b = ['points', 'className', 'baseLinePoints', 'connectNulls'];
function _extends$o() {
  _extends$o = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$o.apply(this, arguments);
}
function _objectWithoutProperties$b(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$d(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$d(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck$S(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$S(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$r(descriptor.key), descriptor);
  }
}
function _createClass$S(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$S(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$S(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _toPropertyKey$r(arg) {
  var key = _toPrimitive$r(arg, 'string');
  return _typeof$10(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$r(input, hint) {
  if (_typeof$10(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$10(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _inherits$Q(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$S(subClass, superClass);
}
function _setPrototypeOf$S(o, p) {
  _setPrototypeOf$S = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$S(o, p);
}
function _createSuper$Q(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$Q();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$Q(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$Q(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$Q(this, result);
  };
}
function _possibleConstructorReturn$Q(self, call) {
  if (call && (_typeof$10(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$S(self);
}
function _assertThisInitialized$S(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$Q() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$Q(o) {
  _getPrototypeOf$Q = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$Q(o);
}
function _toConsumableArray$5(arr) {
  return (
    _arrayWithoutHoles$5(arr) || _iterableToArray$5(arr) || _unsupportedIterableToArray$8(arr) || _nonIterableSpread$5()
  );
}
function _nonIterableSpread$5() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$8(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$8(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen);
}
function _iterableToArray$5(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$5(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$8(arr);
}
function _arrayLikeToArray$8(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var isValidatePoint = function isValidatePoint(point) {
  return point && point.x === +point.x && point.y === +point.y;
};
var getParsedPoints = function getParsedPoints() {
  var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var segmentPoints = [[]];
  points.forEach(function (entry) {
    if (isValidatePoint(entry)) {
      segmentPoints[segmentPoints.length - 1].push(entry);
    } else if (segmentPoints[segmentPoints.length - 1].length > 0) {
      // add another path
      segmentPoints.push([]);
    }
  });
  if (isValidatePoint(points[0])) {
    segmentPoints[segmentPoints.length - 1].push(points[0]);
  }
  if (segmentPoints[segmentPoints.length - 1].length <= 0) {
    segmentPoints = segmentPoints.slice(0, -1);
  }
  return segmentPoints;
};
var getSinglePolygonPath = function getSinglePolygonPath(points, connectNulls) {
  var segmentPoints = getParsedPoints(points);
  if (connectNulls) {
    segmentPoints = [
      segmentPoints.reduce(function (res, segPoints) {
        return [].concat(_toConsumableArray$5(res), _toConsumableArray$5(segPoints));
      }, []),
    ];
  }
  var polygonPath = segmentPoints
    .map(function (segPoints) {
      return segPoints.reduce(function (path, point, index) {
        return ''
          .concat(path)
          .concat(index === 0 ? 'M' : 'L')
          .concat(point.x, ',')
          .concat(point.y);
      }, '');
    })
    .join('');
  return segmentPoints.length === 1 ? ''.concat(polygonPath, 'Z') : polygonPath;
};
var getRanglePath = function getRanglePath(points, baseLinePoints, connectNulls) {
  var outerPath = getSinglePolygonPath(points, connectNulls);
  return ''
    .concat(outerPath.slice(-1) === 'Z' ? outerPath.slice(0, -1) : outerPath, 'L')
    .concat(getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var Polygon = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$Q(Polygon, _PureComponent);
  var _super = _createSuper$Q(Polygon);
  function Polygon() {
    _classCallCheck$S(this, Polygon);
    return _super.apply(this, arguments);
  }
  _createClass$S(Polygon, [
    {
      key: 'render',
      value: function render() {
        var _this$props = this.props,
          points = _this$props.points,
          className = _this$props.className,
          baseLinePoints = _this$props.baseLinePoints,
          connectNulls = _this$props.connectNulls,
          others = _objectWithoutProperties$b(_this$props, _excluded$b);
        if (!points || !points.length) {
          return null;
        }
        var layerClass = cx('recharts-polygon', className);
        if (baseLinePoints && baseLinePoints.length) {
          var hasStroke = others.stroke && others.stroke !== 'none';
          var rangePath = getRanglePath(points, baseLinePoints, connectNulls);
          return /*#__PURE__*/ React__default['default'].createElement(
            'g',
            {
              className: layerClass,
            },
            /*#__PURE__*/ React__default['default'].createElement(
              'path',
              _extends$o({}, filterProps(others, true), {
                fill: rangePath.slice(-1) === 'Z' ? others.fill : 'none',
                stroke: 'none',
                d: rangePath,
              }),
            ),
            hasStroke
              ? /*#__PURE__*/ React__default['default'].createElement(
                  'path',
                  _extends$o({}, filterProps(others, true), {
                    fill: 'none',
                    d: getSinglePolygonPath(points, connectNulls),
                  }),
                )
              : null,
            hasStroke
              ? /*#__PURE__*/ React__default['default'].createElement(
                  'path',
                  _extends$o({}, filterProps(others, true), {
                    fill: 'none',
                    d: getSinglePolygonPath(baseLinePoints, connectNulls),
                  }),
                )
              : null,
          );
        }
        var singlePath = getSinglePolygonPath(points, connectNulls);
        return /*#__PURE__*/ React__default['default'].createElement(
          'path',
          _extends$o({}, filterProps(others, true), {
            fill: singlePath.slice(-1) === 'Z' ? others.fill : 'none',
            className: layerClass,
            d: singlePath,
          }),
        );
      },
    },
  ]);
  return Polygon;
})(React.PureComponent);

function _typeof$$(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$$ =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$$(obj)
  );
}
function _extends$n() {
  _extends$n = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$n.apply(this, arguments);
}
function _classCallCheck$R(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$R(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$q(descriptor.key), descriptor);
  }
}
function _createClass$R(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$R(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$R(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _toPropertyKey$q(arg) {
  var key = _toPrimitive$q(arg, 'string');
  return _typeof$$(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$q(input, hint) {
  if (_typeof$$(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$$(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _inherits$P(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$R(subClass, superClass);
}
function _setPrototypeOf$R(o, p) {
  _setPrototypeOf$R = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$R(o, p);
}
function _createSuper$P(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$P();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$P(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$P(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$P(this, result);
  };
}
function _possibleConstructorReturn$P(self, call) {
  if (call && (_typeof$$(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$R(self);
}
function _assertThisInitialized$R(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$P() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$P(o) {
  _getPrototypeOf$P = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$P(o);
}
var Dot = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$P(Dot, _PureComponent);
  var _super = _createSuper$P(Dot);
  function Dot() {
    _classCallCheck$R(this, Dot);
    return _super.apply(this, arguments);
  }
  _createClass$R(Dot, [
    {
      key: 'render',
      value: function render() {
        var _this$props = this.props,
          cx$1 = _this$props.cx,
          cy = _this$props.cy,
          r = _this$props.r,
          className = _this$props.className;
        var layerClass = cx('recharts-dot', className);
        if (cx$1 === +cx$1 && cy === +cy && r === +r) {
          return /*#__PURE__*/ React__default['default'].createElement(
            'circle',
            _extends$n({}, filterProps(this.props), adaptEventHandlers(this.props), {
              className: layerClass,
              cx: cx$1,
              cy: cy,
              r: r,
            }),
          );
        }
        return null;
      },
    },
  ]);
  return Dot;
})(React.PureComponent);

function _typeof$_(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$_ =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$_(obj)
  );
}
function _extends$m() {
  _extends$m = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$m.apply(this, arguments);
}
function _classCallCheck$Q(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$Q(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$p(descriptor.key), descriptor);
  }
}
function _createClass$Q(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$Q(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$Q(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$O(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$Q(subClass, superClass);
}
function _setPrototypeOf$Q(o, p) {
  _setPrototypeOf$Q = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$Q(o, p);
}
function _createSuper$O(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$O();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$O(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$O(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$O(this, result);
  };
}
function _possibleConstructorReturn$O(self, call) {
  if (call && (_typeof$_(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$Q(self);
}
function _assertThisInitialized$Q(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$O() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$O(o) {
  _getPrototypeOf$O = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$O(o);
}
function _defineProperty$X(obj, key, value) {
  key = _toPropertyKey$p(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$p(arg) {
  var key = _toPrimitive$p(arg, 'string');
  return _typeof$_(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$p(input, hint) {
  if (_typeof$_(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$_(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var Cross = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$O(Cross, _PureComponent);
  var _super = _createSuper$O(Cross);
  function Cross() {
    _classCallCheck$Q(this, Cross);
    return _super.apply(this, arguments);
  }
  _createClass$Q(
    Cross,
    [
      {
        key: 'render',
        value: function render() {
          var _this$props = this.props,
            x = _this$props.x,
            y = _this$props.y,
            width = _this$props.width,
            height = _this$props.height,
            top = _this$props.top,
            left = _this$props.left,
            className = _this$props.className;
          if (
            !isNumber(x) ||
            !isNumber(y) ||
            !isNumber(width) ||
            !isNumber(height) ||
            !isNumber(top) ||
            !isNumber(left)
          ) {
            return null;
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            'path',
            _extends$m({}, filterProps(this.props, true), {
              className: cx('recharts-cross', className),
              d: Cross.getPath(x, y, width, height, top, left),
            }),
          );
        },
      },
    ],
    [
      {
        key: 'getPath',
        value: function getPath(x, y, width, height, top, left) {
          return 'M'.concat(x, ',').concat(top, 'v').concat(height, 'M').concat(left, ',').concat(y, 'h').concat(width);
        },
      },
    ],
  );
  return Cross;
})(React.PureComponent);
_defineProperty$X(Cross, 'defaultProps', {
  x: 0,
  y: 0,
  top: 0,
  left: 0,
  width: 0,
  height: 0,
});

function _typeof$Z(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$Z =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$Z(obj)
  );
}
function _extends$l() {
  _extends$l = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$l.apply(this, arguments);
}
function ownKeys$o(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$o(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$o(Object(source), !0).forEach(function (key) {
          _defineProperty$W(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$o(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$P(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$P(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$o(descriptor.key), descriptor);
  }
}
function _createClass$P(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$P(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$P(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$N(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$P(subClass, superClass);
}
function _setPrototypeOf$P(o, p) {
  _setPrototypeOf$P = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$P(o, p);
}
function _createSuper$N(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$N();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$N(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$N(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$N(this, result);
  };
}
function _possibleConstructorReturn$N(self, call) {
  if (call && (_typeof$Z(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$P(self);
}
function _assertThisInitialized$P(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$N() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$N(o) {
  _getPrototypeOf$N = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$N(o);
}
function _defineProperty$W(obj, key, value) {
  key = _toPropertyKey$o(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$o(arg) {
  var key = _toPrimitive$o(arg, 'string');
  return _typeof$Z(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$o(input, hint) {
  if (_typeof$Z(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$Z(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var PolarGrid = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$N(PolarGrid, _PureComponent);
  var _super = _createSuper$N(PolarGrid);
  function PolarGrid() {
    _classCallCheck$P(this, PolarGrid);
    return _super.apply(this, arguments);
  }
  _createClass$P(PolarGrid, [
    {
      key: 'getPolygonPath',
      value: function getPolygonPath(radius) {
        var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          polarAngles = _this$props.polarAngles;
        var path = '';
        polarAngles.forEach(function (angle, i) {
          var point = polarToCartesian(cx, cy, radius, angle);
          if (i) {
            path += 'L '.concat(point.x, ',').concat(point.y);
          } else {
            path += 'M '.concat(point.x, ',').concat(point.y);
          }
        });
        path += 'Z';
        return path;
      },

      /**
       * Draw axis of radial line
       * @return {[type]} The lines
       */
    },
    {
      key: 'renderPolarAngles',
      value: function renderPolarAngles() {
        var _this$props2 = this.props,
          cx = _this$props2.cx,
          cy = _this$props2.cy,
          innerRadius = _this$props2.innerRadius,
          outerRadius = _this$props2.outerRadius,
          polarAngles = _this$props2.polarAngles,
          radialLines = _this$props2.radialLines;
        if (!polarAngles || !polarAngles.length || !radialLines) {
          return null;
        }
        var props = _objectSpread$o(
          {
            stroke: '#ccc',
          },
          filterProps(this.props),
        );
        return /*#__PURE__*/ React__default['default'].createElement(
          'g',
          {
            className: 'recharts-polar-grid-angle',
          },
          polarAngles.map(function (entry, i) {
            var start = polarToCartesian(cx, cy, innerRadius, entry);
            var end = polarToCartesian(cx, cy, outerRadius, entry);
            return /*#__PURE__*/ React__default['default'].createElement(
              'line',
              _extends$l({}, props, {
                key: 'line-'.concat(i), // eslint-disable-line react/no-array-index-key
                x1: start.x,
                y1: start.y,
                x2: end.x,
                y2: end.y,
              }),
            );
          }),
        );
      },

      /**
       * Draw concentric circles
       * @param {Number} radius The radius of circle
       * @param {Number} index  The index of circle
       * @param {Object} extraProps Extra props
       * @return {ReactElement} circle
       */
    },
    {
      key: 'renderConcentricCircle',
      value: function renderConcentricCircle(radius, index, extraProps) {
        var _this$props3 = this.props,
          cx = _this$props3.cx,
          cy = _this$props3.cy;
        var props = _objectSpread$o(
          _objectSpread$o(
            {
              stroke: '#ccc',
            },
            filterProps(this.props),
          ),
          {},
          {
            fill: 'none',
          },
          extraProps,
        );
        return /*#__PURE__*/ React__default['default'].createElement(
          'circle',
          _extends$l({}, props, {
            className: 'recharts-polar-grid-concentric-circle',
            key: 'circle-'.concat(index),
            cx: cx,
            cy: cy,
            r: radius,
          }),
        );
      },

      /**
       * Draw concentric polygons
       * @param {Number} radius     The radius of polygon
       * @param {Number} index      The index of polygon
       * @param {Object} extraProps Extra props
       * @return {ReactElement} polygon
       */
    },
    {
      key: 'renderConcentricPolygon',
      value: function renderConcentricPolygon(radius, index, extraProps) {
        var props = _objectSpread$o(
          _objectSpread$o(
            {
              stroke: '#ccc',
            },
            filterProps(this.props),
          ),
          {},
          {
            fill: 'none',
          },
          extraProps,
        );
        return /*#__PURE__*/ React__default['default'].createElement(
          'path',
          _extends$l({}, props, {
            className: 'recharts-polar-grid-concentric-polygon',
            key: 'path-'.concat(index),
            d: this.getPolygonPath(radius),
          }),
        );
      },

      /**
       * Draw concentric axis
       * @return {ReactElement} Concentric axis
       * @todo Optimize the name
       */
    },
    {
      key: 'renderConcentricPath',
      value: function renderConcentricPath() {
        var _this = this;
        var _this$props4 = this.props,
          polarRadius = _this$props4.polarRadius,
          gridType = _this$props4.gridType;
        if (!polarRadius || !polarRadius.length) {
          return null;
        }
        return /*#__PURE__*/ React__default['default'].createElement(
          'g',
          {
            className: 'recharts-polar-grid-concentric',
          },
          polarRadius.map(function (entry, i) {
            return gridType === 'circle'
              ? _this.renderConcentricCircle(entry, i)
              : _this.renderConcentricPolygon(entry, i);
          }),
        );
      },
    },
    {
      key: 'render',
      value: function render() {
        var outerRadius = this.props.outerRadius;
        if (outerRadius <= 0) {
          return null;
        }
        return /*#__PURE__*/ React__default['default'].createElement(
          'g',
          {
            className: 'recharts-polar-grid',
          },
          this.renderPolarAngles(),
          this.renderConcentricPath(),
        );
      },
    },
  ]);
  return PolarGrid;
})(React.PureComponent);
_defineProperty$W(PolarGrid, 'displayName', 'PolarGrid');
_defineProperty$W(PolarGrid, 'defaultProps', {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  gridType: 'polygon',
  radialLines: true,
});

var baseExtremum$1 = _baseExtremum,
  baseIteratee$7 = _baseIteratee,
  baseLt = _baseLt;

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return array && array.length ? baseExtremum$1(array, baseIteratee$7(iteratee), baseLt) : undefined;
}

var minBy_1 = minBy;

var _minBy = /*@__PURE__*/ getDefaultExportFromCjs(minBy_1);

var baseExtremum = _baseExtremum,
  baseGt = _baseGt,
  baseIteratee$6 = _baseIteratee;

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return array && array.length ? baseExtremum(array, baseIteratee$6(iteratee), baseGt) : undefined;
}

var maxBy_1 = maxBy;

var _maxBy = /*@__PURE__*/ getDefaultExportFromCjs(maxBy_1);

var _excluded$a = ['cx', 'cy', 'angle', 'ticks', 'axisLine'],
  _excluded2$5 = ['ticks', 'tick', 'angle', 'tickFormatter', 'stroke'];
function _typeof$Y(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$Y =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$Y(obj)
  );
}
function _extends$k() {
  _extends$k = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$k.apply(this, arguments);
}
function ownKeys$n(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$n(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$n(Object(source), !0).forEach(function (key) {
          _defineProperty$V(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$n(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _objectWithoutProperties$a(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$c(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$c(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck$O(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$O(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$n(descriptor.key), descriptor);
  }
}
function _createClass$O(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$O(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$O(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$M(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$O(subClass, superClass);
}
function _setPrototypeOf$O(o, p) {
  _setPrototypeOf$O = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$O(o, p);
}
function _createSuper$M(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$M();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$M(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$M(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$M(this, result);
  };
}
function _possibleConstructorReturn$M(self, call) {
  if (call && (_typeof$Y(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$O(self);
}
function _assertThisInitialized$O(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$M() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$M(o) {
  _getPrototypeOf$M = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$M(o);
}
function _defineProperty$V(obj, key, value) {
  key = _toPropertyKey$n(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$n(arg) {
  var key = _toPrimitive$n(arg, 'string');
  return _typeof$Y(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$n(input, hint) {
  if (_typeof$Y(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$Y(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var PolarRadiusAxis = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$M(PolarRadiusAxis, _PureComponent);
  var _super = _createSuper$M(PolarRadiusAxis);
  function PolarRadiusAxis() {
    _classCallCheck$O(this, PolarRadiusAxis);
    return _super.apply(this, arguments);
  }
  _createClass$O(
    PolarRadiusAxis,
    [
      {
        key: 'getTickValueCoord',
        value:
          /**
           * Calculate the coordinate of tick
           * @param  {Number} coordinate The radius of tick
           * @return {Object} (x, y)
           */
          function getTickValueCoord(_ref) {
            var coordinate = _ref.coordinate;
            var _this$props = this.props,
              angle = _this$props.angle,
              cx = _this$props.cx,
              cy = _this$props.cy;
            return polarToCartesian(cx, cy, coordinate, angle);
          },
      },
      {
        key: 'getTickTextAnchor',
        value: function getTickTextAnchor() {
          var orientation = this.props.orientation;
          var textAnchor;
          switch (orientation) {
            case 'left':
              textAnchor = 'end';
              break;
            case 'right':
              textAnchor = 'start';
              break;
            default:
              textAnchor = 'middle';
              break;
          }
          return textAnchor;
        },
      },
      {
        key: 'getViewBox',
        value: function getViewBox() {
          var _this$props2 = this.props,
            cx = _this$props2.cx,
            cy = _this$props2.cy,
            angle = _this$props2.angle,
            ticks = _this$props2.ticks;
          var maxRadiusTick = _maxBy(ticks, function (entry) {
            return entry.coordinate || 0;
          });
          var minRadiusTick = _minBy(ticks, function (entry) {
            return entry.coordinate || 0;
          });
          return {
            cx: cx,
            cy: cy,
            startAngle: angle,
            endAngle: angle,
            innerRadius: minRadiusTick.coordinate || 0,
            outerRadius: maxRadiusTick.coordinate || 0,
          };
        },
      },
      {
        key: 'renderAxisLine',
        value: function renderAxisLine() {
          var _this$props3 = this.props,
            cx = _this$props3.cx,
            cy = _this$props3.cy,
            angle = _this$props3.angle,
            ticks = _this$props3.ticks,
            axisLine = _this$props3.axisLine,
            others = _objectWithoutProperties$a(_this$props3, _excluded$a);
          var extent = ticks.reduce(
            function (result, entry) {
              return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
            },
            [Infinity, -Infinity],
          );
          var point0 = polarToCartesian(cx, cy, extent[0], angle);
          var point1 = polarToCartesian(cx, cy, extent[1], angle);
          var props = _objectSpread$n(
            _objectSpread$n(
              _objectSpread$n({}, filterProps(others)),
              {},
              {
                fill: 'none',
              },
              filterProps(axisLine),
            ),
            {},
            {
              x1: point0.x,
              y1: point0.y,
              x2: point1.x,
              y2: point1.y,
            },
          );
          return /*#__PURE__*/ React__default['default'].createElement(
            'line',
            _extends$k(
              {
                className: 'recharts-polar-radius-axis-line',
              },
              props,
            ),
          );
        },
      },
      {
        key: 'renderTicks',
        value: function renderTicks() {
          var _this = this;
          var _this$props4 = this.props,
            ticks = _this$props4.ticks,
            tick = _this$props4.tick,
            angle = _this$props4.angle,
            tickFormatter = _this$props4.tickFormatter,
            stroke = _this$props4.stroke,
            others = _objectWithoutProperties$a(_this$props4, _excluded2$5);
          var textAnchor = this.getTickTextAnchor();
          var axisProps = filterProps(others);
          var customTickProps = filterProps(tick);
          var items = ticks.map(function (entry, i) {
            var coord = _this.getTickValueCoord(entry);
            var tickProps = _objectSpread$n(
              _objectSpread$n(
                _objectSpread$n(
                  _objectSpread$n(
                    {
                      textAnchor: textAnchor,
                      transform: 'rotate('
                        .concat(90 - angle, ', ')
                        .concat(coord.x, ', ')
                        .concat(coord.y, ')'),
                    },
                    axisProps,
                  ),
                  {},
                  {
                    stroke: 'none',
                    fill: stroke,
                  },
                  customTickProps,
                ),
                {},
                {
                  index: i,
                },
                coord,
              ),
              {},
              {
                payload: entry,
              },
            );
            return /*#__PURE__*/ React__default['default'].createElement(
              Layer,
              _extends$k(
                {
                  className: 'recharts-polar-radius-axis-tick',
                  key: 'tick-'.concat(i), // eslint-disable-line react/no-array-index-key
                },
                adaptEventsOfChild(_this.props, entry, i),
              ),
              PolarRadiusAxis.renderTickItem(
                tick,
                tickProps,
                tickFormatter ? tickFormatter(entry.value, i) : entry.value,
              ),
            );
          });
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-polar-radius-axis-ticks',
            },
            items,
          );
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props5 = this.props,
            ticks = _this$props5.ticks,
            axisLine = _this$props5.axisLine,
            tick = _this$props5.tick;
          if (!ticks || !ticks.length) {
            return null;
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-polar-radius-axis',
            },
            axisLine && this.renderAxisLine(),
            tick && this.renderTicks(),
            Label.renderCallByParent(this.props, this.getViewBox()),
          );
        },
      },
    ],
    [
      {
        key: 'renderTickItem',
        value: function renderTickItem(option, props, value) {
          var tickItem;
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            tickItem = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          } else if (_isFunction(option)) {
            tickItem = option(props);
          } else {
            tickItem = /*#__PURE__*/ React__default['default'].createElement(
              Text,
              _extends$k({}, props, {
                className: 'recharts-polar-radius-axis-tick-value',
              }),
              value,
            );
          }
          return tickItem;
        },
      },
    ],
  );
  return PolarRadiusAxis;
})(React.PureComponent);
_defineProperty$V(PolarRadiusAxis, 'displayName', 'PolarRadiusAxis');
_defineProperty$V(PolarRadiusAxis, 'axisType', 'radiusAxis');
_defineProperty$V(PolarRadiusAxis, 'defaultProps', {
  type: 'number',
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: 'right',
  stroke: '#ccc',
  axisLine: true,
  tick: true,
  tickCount: 5,
  allowDataOverflow: false,
  scale: 'auto',
  allowDuplicatedCategory: true,
});

function _typeof$X(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$X =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$X(obj)
  );
}
function _extends$j() {
  _extends$j = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$j.apply(this, arguments);
}
function ownKeys$m(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$m(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$m(Object(source), !0).forEach(function (key) {
          _defineProperty$U(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$m(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$N(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$N(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$m(descriptor.key), descriptor);
  }
}
function _createClass$N(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$N(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$N(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$L(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$N(subClass, superClass);
}
function _setPrototypeOf$N(o, p) {
  _setPrototypeOf$N = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$N(o, p);
}
function _createSuper$L(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$L();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$L(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$L(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$L(this, result);
  };
}
function _possibleConstructorReturn$L(self, call) {
  if (call && (_typeof$X(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$N(self);
}
function _assertThisInitialized$N(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$L() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$L(o) {
  _getPrototypeOf$L = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$L(o);
}
function _defineProperty$U(obj, key, value) {
  key = _toPropertyKey$m(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$m(arg) {
  var key = _toPrimitive$m(arg, 'string');
  return _typeof$X(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$m(input, hint) {
  if (_typeof$X(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$X(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var RADIAN = Math.PI / 180;
var eps = 1e-5;
var PolarAngleAxis = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$L(PolarAngleAxis, _PureComponent);
  var _super = _createSuper$L(PolarAngleAxis);
  function PolarAngleAxis() {
    _classCallCheck$N(this, PolarAngleAxis);
    return _super.apply(this, arguments);
  }
  _createClass$N(
    PolarAngleAxis,
    [
      {
        key: 'getTickLineCoord',
        value:
          /**
           * Calculate the coordinate of line endpoint
           * @param  {Object} data The Data if ticks
           * @return {Object} (x0, y0): The start point of text,
           *                  (x1, y1): The end point close to text,
           *                  (x2, y2): The end point close to axis
           */
          function getTickLineCoord(data) {
            var _this$props = this.props,
              cx = _this$props.cx,
              cy = _this$props.cy,
              radius = _this$props.radius,
              orientation = _this$props.orientation,
              tickSize = _this$props.tickSize;
            var tickLineSize = tickSize || 8;
            var p1 = polarToCartesian(cx, cy, radius, data.coordinate);
            var p2 = polarToCartesian(
              cx,
              cy,
              radius + (orientation === 'inner' ? -1 : 1) * tickLineSize,
              data.coordinate,
            );
            return {
              x1: p1.x,
              y1: p1.y,
              x2: p2.x,
              y2: p2.y,
            };
          },

        /**
         * Get the text-anchor of each tick
         * @param  {Object} data Data of ticks
         * @return {String} text-anchor
         */
      },
      {
        key: 'getTickTextAnchor',
        value: function getTickTextAnchor(data) {
          var orientation = this.props.orientation;
          var cos = Math.cos(-data.coordinate * RADIAN);
          var textAnchor;
          if (cos > eps) {
            textAnchor = orientation === 'outer' ? 'start' : 'end';
          } else if (cos < -eps) {
            textAnchor = orientation === 'outer' ? 'end' : 'start';
          } else {
            textAnchor = 'middle';
          }
          return textAnchor;
        },
      },
      {
        key: 'renderAxisLine',
        value: function renderAxisLine() {
          var _this$props2 = this.props,
            cx = _this$props2.cx,
            cy = _this$props2.cy,
            radius = _this$props2.radius,
            axisLine = _this$props2.axisLine,
            axisLineType = _this$props2.axisLineType;
          var props = _objectSpread$m(
            _objectSpread$m({}, filterProps(this.props)),
            {},
            {
              fill: 'none',
            },
            filterProps(axisLine),
          );
          if (axisLineType === 'circle') {
            return /*#__PURE__*/ React__default['default'].createElement(
              Dot,
              _extends$j(
                {
                  className: 'recharts-polar-angle-axis-line',
                },
                props,
                {
                  cx: cx,
                  cy: cy,
                  r: radius,
                },
              ),
            );
          }
          var ticks = this.props.ticks;
          var points = ticks.map(function (entry) {
            return polarToCartesian(cx, cy, radius, entry.coordinate);
          });
          return /*#__PURE__*/ React__default['default'].createElement(
            Polygon,
            _extends$j(
              {
                className: 'recharts-polar-angle-axis-line',
              },
              props,
              {
                points: points,
              },
            ),
          );
        },
      },
      {
        key: 'renderTicks',
        value: function renderTicks() {
          var _this = this;
          var _this$props3 = this.props,
            ticks = _this$props3.ticks,
            tick = _this$props3.tick,
            tickLine = _this$props3.tickLine,
            tickFormatter = _this$props3.tickFormatter,
            stroke = _this$props3.stroke;
          var axisProps = filterProps(this.props);
          var customTickProps = filterProps(tick);
          var tickLineProps = _objectSpread$m(
            _objectSpread$m({}, axisProps),
            {},
            {
              fill: 'none',
            },
            filterProps(tickLine),
          );
          var items = ticks.map(function (entry, i) {
            var lineCoord = _this.getTickLineCoord(entry);
            var textAnchor = _this.getTickTextAnchor(entry);
            var tickProps = _objectSpread$m(
              _objectSpread$m(
                _objectSpread$m(
                  {
                    textAnchor: textAnchor,
                  },
                  axisProps,
                ),
                {},
                {
                  stroke: 'none',
                  fill: stroke,
                },
                customTickProps,
              ),
              {},
              {
                index: i,
                payload: entry,
                x: lineCoord.x2,
                y: lineCoord.y2,
              },
            );
            return /*#__PURE__*/ React__default['default'].createElement(
              Layer,
              _extends$j(
                {
                  className: 'recharts-polar-angle-axis-tick',
                  key: 'tick-'.concat(i), // eslint-disable-line react/no-array-index-key
                },
                adaptEventsOfChild(_this.props, entry, i),
              ),
              tickLine &&
                /*#__PURE__*/ React__default['default'].createElement(
                  'line',
                  _extends$j(
                    {
                      className: 'recharts-polar-angle-axis-tick-line',
                    },
                    tickLineProps,
                    lineCoord,
                  ),
                ),
              tick &&
                PolarAngleAxis.renderTickItem(
                  tick,
                  tickProps,
                  tickFormatter ? tickFormatter(entry.value, i) : entry.value,
                ),
            );
          });
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-polar-angle-axis-ticks',
            },
            items,
          );
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props4 = this.props,
            ticks = _this$props4.ticks,
            radius = _this$props4.radius,
            axisLine = _this$props4.axisLine;
          if (radius <= 0 || !ticks || !ticks.length) {
            return null;
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-polar-angle-axis',
            },
            axisLine && this.renderAxisLine(),
            this.renderTicks(),
          );
        },
      },
    ],
    [
      {
        key: 'renderTickItem',
        value: function renderTickItem(option, props, value) {
          var tickItem;
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            tickItem = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          } else if (_isFunction(option)) {
            tickItem = option(props);
          } else {
            tickItem = /*#__PURE__*/ React__default['default'].createElement(
              Text,
              _extends$j({}, props, {
                className: 'recharts-polar-angle-axis-tick-value',
              }),
              value,
            );
          }
          return tickItem;
        },
      },
    ],
  );
  return PolarAngleAxis;
})(React.PureComponent);
_defineProperty$U(PolarAngleAxis, 'displayName', 'PolarAngleAxis');
_defineProperty$U(PolarAngleAxis, 'axisType', 'angleAxis');
_defineProperty$U(PolarAngleAxis, 'defaultProps', {
  type: 'category',
  angleAxisId: 0,
  scale: 'auto',
  cx: 0,
  cy: 0,
  orientation: 'outer',
  axisLine: true,
  tickLine: true,
  tickSize: 8,
  tick: true,
  hide: false,
  allowDuplicatedCategory: true,
});

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$3 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$3;

var baseGetTag$1 = _baseGetTag,
  getPrototype$2 = _getPrototype,
  isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var objectTag$1 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$2.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$1(value) {
  if (!isObjectLike$3(value) || baseGetTag$1(value) != objectTag$1) {
    return false;
  }
  var proto = getPrototype$2(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$3.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$1;

var _isPlainObject = /*@__PURE__*/ getDefaultExportFromCjs(isPlainObject_1);

function _typeof$W(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$W =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$W(obj)
  );
}
function _extends$i() {
  _extends$i = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$i.apply(this, arguments);
}
function ownKeys$l(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$l(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$l(Object(source), !0).forEach(function (key) {
          _defineProperty$T(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$l(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$M(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$M(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$l(descriptor.key), descriptor);
  }
}
function _createClass$M(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$M(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$M(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$K(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$M(subClass, superClass);
}
function _setPrototypeOf$M(o, p) {
  _setPrototypeOf$M = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$M(o, p);
}
function _createSuper$K(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$K();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$K(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$K(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$K(this, result);
  };
}
function _possibleConstructorReturn$K(self, call) {
  if (call && (_typeof$W(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$M(self);
}
function _assertThisInitialized$M(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$K() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$K(o) {
  _getPrototypeOf$K = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$K(o);
}
function _defineProperty$T(obj, key, value) {
  key = _toPropertyKey$l(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$l(arg) {
  var key = _toPrimitive$l(arg, 'string');
  return _typeof$W(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$l(input, hint) {
  if (_typeof$W(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$W(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var Pie = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$K(Pie, _PureComponent);
  var _super = _createSuper$K(Pie);
  function Pie(props) {
    var _this;
    _classCallCheck$M(this, Pie);
    _this = _super.call(this, props);
    _defineProperty$T(_assertThisInitialized$M(_this), 'pieRef', null);
    _defineProperty$T(_assertThisInitialized$M(_this), 'sectorRefs', []);
    _defineProperty$T(_assertThisInitialized$M(_this), 'id', uniqueId('recharts-pie-'));
    _defineProperty$T(_assertThisInitialized$M(_this), 'handleAnimationEnd', function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true,
      });
      if (_isFunction(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$T(_assertThisInitialized$M(_this), 'handleAnimationStart', function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false,
      });
      if (_isFunction(onAnimationStart)) {
        onAnimationStart();
      }
    });
    _this.state = {
      isAnimationFinished: !props.isAnimationActive,
      prevIsAnimationActive: props.isAnimationActive,
      prevAnimationId: props.animationId,
      sectorToFocus: 0,
    };
    return _this;
  }
  _createClass$M(
    Pie,
    [
      {
        key: 'isActiveIndex',
        value: function isActiveIndex(i) {
          var activeIndex = this.props.activeIndex;
          if (Array.isArray(activeIndex)) {
            return activeIndex.indexOf(i) !== -1;
          }
          return i === activeIndex;
        },
      },
      {
        key: 'hasActiveIndex',
        value: function hasActiveIndex() {
          var activeIndex = this.props.activeIndex;
          return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
        },
      },
      {
        key: 'renderLabels',
        value: function renderLabels(sectors) {
          var isAnimationActive = this.props.isAnimationActive;
          if (isAnimationActive && !this.state.isAnimationFinished) {
            return null;
          }
          var _this$props = this.props,
            label = _this$props.label,
            labelLine = _this$props.labelLine,
            dataKey = _this$props.dataKey,
            valueKey = _this$props.valueKey;
          var pieProps = filterProps(this.props);
          var customLabelProps = filterProps(label);
          var customLabelLineProps = filterProps(labelLine);
          var offsetRadius = (label && label.offsetRadius) || 20;
          var labels = sectors.map(function (entry, i) {
            var midAngle = (entry.startAngle + entry.endAngle) / 2;
            var endPoint = polarToCartesian(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
            var labelProps = _objectSpread$l(
              _objectSpread$l(
                _objectSpread$l(_objectSpread$l({}, pieProps), entry),
                {},
                {
                  stroke: 'none',
                },
                customLabelProps,
              ),
              {},
              {
                index: i,
                textAnchor: Pie.getTextAnchor(endPoint.x, entry.cx),
              },
              endPoint,
            );
            var lineProps = _objectSpread$l(
              _objectSpread$l(
                _objectSpread$l(_objectSpread$l({}, pieProps), entry),
                {},
                {
                  fill: 'none',
                  stroke: entry.fill,
                },
                customLabelLineProps,
              ),
              {},
              {
                index: i,
                points: [polarToCartesian(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint],
                key: 'line',
              },
            );
            var realDataKey = dataKey;
            // TODO: compatible to lower versions
            if (_isNil(dataKey) && _isNil(valueKey)) {
              realDataKey = 'value';
            } else if (_isNil(dataKey)) {
              realDataKey = valueKey;
            }
            return (
              /*#__PURE__*/
              // eslint-disable-next-line react/no-array-index-key
              React__default['default'].createElement(
                Layer,
                {
                  key: 'label-'.concat(i),
                },
                labelLine && Pie.renderLabelLineItem(labelLine, lineProps),
                Pie.renderLabelItem(label, labelProps, getValueByDataKey(entry, realDataKey)),
              )
            );
          });
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-pie-labels',
            },
            labels,
          );
        },
      },
      {
        key: 'renderSectorsStatically',
        value: function renderSectorsStatically(sectors) {
          var _this2 = this;
          var _this$props2 = this.props,
            activeShape = _this$props2.activeShape,
            blendStroke = _this$props2.blendStroke,
            inactiveShapeProp = _this$props2.inactiveShape;
          return sectors.map(function (entry, i) {
            var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
            var sectorOptions = _this2.isActiveIndex(i) ? activeShape : inactiveShape;
            var sectorProps = _objectSpread$l(
              _objectSpread$l({}, entry),
              {},
              {
                stroke: blendStroke ? entry.fill : entry.stroke,
              },
            );
            return /*#__PURE__*/ React__default['default'].createElement(
              Layer,
              _extends$i(
                {
                  ref: function ref(_ref) {
                    if (_ref && !_this2.sectorRefs.includes(_ref)) {
                      _this2.sectorRefs.push(_ref);
                    }
                  },
                  tabIndex: -1,
                  className: 'recharts-pie-sector',
                },
                adaptEventsOfChild(_this2.props, entry, i),
                {
                  key: 'sector-'.concat(i), // eslint-disable-line react/no-array-index-key
                },
              ),
              Pie.renderSectorItem(sectorOptions, sectorProps),
            );
          });
        },
      },
      {
        key: 'renderSectorsWithAnimation',
        value: function renderSectorsWithAnimation() {
          var _this3 = this;
          var _this$props3 = this.props,
            sectors = _this$props3.sectors,
            isAnimationActive = _this$props3.isAnimationActive,
            animationBegin = _this$props3.animationBegin,
            animationDuration = _this$props3.animationDuration,
            animationEasing = _this$props3.animationEasing,
            animationId = _this$props3.animationId;
          var _this$state = this.state,
            prevSectors = _this$state.prevSectors,
            prevIsAnimationActive = _this$state.prevIsAnimationActive;
          return /*#__PURE__*/ React__default['default'].createElement(
            Animate,
            {
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing,
              from: {
                t: 0,
              },
              to: {
                t: 1,
              },
              key: 'pie-'.concat(animationId, '-').concat(prevIsAnimationActive),
              onAnimationStart: this.handleAnimationStart,
              onAnimationEnd: this.handleAnimationEnd,
            },
            function (_ref2) {
              var t = _ref2.t;
              var stepData = [];
              var first = sectors && sectors[0];
              var curAngle = first.startAngle;
              sectors.forEach(function (entry, index) {
                var prev = prevSectors && prevSectors[index];
                var paddingAngle = index > 0 ? _get(entry, 'paddingAngle', 0) : 0;
                if (prev) {
                  var angleIp = interpolateNumber$2(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
                  var latest = _objectSpread$l(
                    _objectSpread$l({}, entry),
                    {},
                    {
                      startAngle: curAngle + paddingAngle,
                      endAngle: curAngle + angleIp(t) + paddingAngle,
                    },
                  );
                  stepData.push(latest);
                  curAngle = latest.endAngle;
                } else {
                  var endAngle = entry.endAngle,
                    startAngle = entry.startAngle;
                  var interpolatorAngle = interpolateNumber$2(0, endAngle - startAngle);
                  var deltaAngle = interpolatorAngle(t);
                  var _latest = _objectSpread$l(
                    _objectSpread$l({}, entry),
                    {},
                    {
                      startAngle: curAngle + paddingAngle,
                      endAngle: curAngle + deltaAngle + paddingAngle,
                    },
                  );
                  stepData.push(_latest);
                  curAngle = _latest.endAngle;
                }
              });
              return /*#__PURE__*/ React__default['default'].createElement(
                Layer,
                null,
                _this3.renderSectorsStatically(stepData),
              );
            },
          );
        },
      },
      {
        key: 'attachKeyboardHandlers',
        value: function attachKeyboardHandlers(pieRef) {
          var _this4 = this;
          // eslint-disable-next-line no-param-reassign
          pieRef.onkeydown = function (e) {
            if (!e.altKey) {
              switch (e.key) {
                case 'ArrowLeft': {
                  var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
                  _this4.sectorRefs[next].focus();
                  _this4.setState({
                    sectorToFocus: next,
                  });
                  break;
                }
                case 'ArrowRight': {
                  var _next =
                    --_this4.state.sectorToFocus < 0
                      ? _this4.sectorRefs.length - 1
                      : _this4.state.sectorToFocus % _this4.sectorRefs.length;
                  _this4.sectorRefs[_next].focus();
                  _this4.setState({
                    sectorToFocus: _next,
                  });
                  break;
                }
                case 'Escape': {
                  _this4.sectorRefs[_this4.state.sectorToFocus].blur();
                  _this4.setState({
                    sectorToFocus: 0,
                  });
                  break;
                }
              }
            }
          };
        },
      },
      {
        key: 'renderSectors',
        value: function renderSectors() {
          var _this$props4 = this.props,
            sectors = _this$props4.sectors,
            isAnimationActive = _this$props4.isAnimationActive;
          var prevSectors = this.state.prevSectors;
          if (isAnimationActive && sectors && sectors.length && (!prevSectors || !_isEqual(prevSectors, sectors))) {
            return this.renderSectorsWithAnimation();
          }
          return this.renderSectorsStatically(sectors);
        },
      },
      {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.pieRef) {
            this.attachKeyboardHandlers(this.pieRef);
          }
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this5 = this;
          var _this$props5 = this.props,
            hide = _this$props5.hide,
            sectors = _this$props5.sectors,
            className = _this$props5.className,
            label = _this$props5.label,
            cx$1 = _this$props5.cx,
            cy = _this$props5.cy,
            innerRadius = _this$props5.innerRadius,
            outerRadius = _this$props5.outerRadius,
            isAnimationActive = _this$props5.isAnimationActive;
          var isAnimationFinished = this.state.isAnimationFinished;
          if (
            hide ||
            !sectors ||
            !sectors.length ||
            !isNumber(cx$1) ||
            !isNumber(cy) ||
            !isNumber(innerRadius) ||
            !isNumber(outerRadius)
          ) {
            return null;
          }
          var layerClass = cx('recharts-pie', className);
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              tabIndex: 0,
              className: layerClass,
              ref: function ref(_ref3) {
                _this5.pieRef = _ref3;
              },
            },
            this.renderSectors(),
            label && this.renderLabels(sectors),
            Label.renderCallByParent(this.props, null, false),
            (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, sectors, false),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) {
            return {
              prevIsAnimationActive: nextProps.isAnimationActive,
              prevAnimationId: nextProps.animationId,
              curSectors: nextProps.sectors,
              prevSectors: [],
              isAnimationFinished: true,
            };
          }
          if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) {
            return {
              prevAnimationId: nextProps.animationId,
              curSectors: nextProps.sectors,
              prevSectors: prevState.curSectors,
              isAnimationFinished: true,
            };
          }
          if (nextProps.sectors !== prevState.curSectors) {
            return {
              curSectors: nextProps.sectors,
              isAnimationFinished: true,
            };
          }
          return null;
        },
      },
      {
        key: 'getTextAnchor',
        value: function getTextAnchor(x, cx) {
          if (x > cx) {
            return 'start';
          }
          if (x < cx) {
            return 'end';
          }
          return 'middle';
        },
      },
      {
        key: 'renderLabelLineItem',
        value: function renderLabelLineItem(option, props) {
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            return /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          }
          if (_isFunction(option)) {
            return option(props);
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            Curve,
            _extends$i({}, props, {
              type: 'linear',
              className: 'recharts-pie-label-line',
            }),
          );
        },
      },
      {
        key: 'renderLabelItem',
        value: function renderLabelItem(option, props, value) {
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            return /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          }
          var label = value;
          if (_isFunction(option)) {
            label = option(props);
            if (/*#__PURE__*/ React__default['default'].isValidElement(label)) {
              return label;
            }
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            Text,
            _extends$i({}, props, {
              alignmentBaseline: 'middle',
              className: 'recharts-pie-label-text',
            }),
            label,
          );
        },
      },
      {
        key: 'renderSectorItem',
        value: function renderSectorItem(option, props) {
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            return /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          }
          if (_isFunction(option)) {
            return option(props);
          }
          if (_isPlainObject(option)) {
            return /*#__PURE__*/ React__default['default'].createElement(
              Sector,
              _extends$i(
                {
                  tabIndex: -1,
                },
                props,
                option,
              ),
            );
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            Sector,
            _extends$i(
              {
                tabIndex: -1,
              },
              props,
            ),
          );
        },
      },
    ],
  );
  return Pie;
})(React.PureComponent);
_defineProperty$T(Pie, 'displayName', 'Pie');
_defineProperty$T(Pie, 'defaultProps', {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  cx: '50%',
  cy: '50%',
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: '80%',
  paddingAngle: 0,
  labelLine: true,
  hide: false,
  minAngle: 0,
  isAnimationActive: !Global.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease',
  nameKey: 'name',
  blendStroke: false,
});
_defineProperty$T(Pie, 'parseDeltaAngle', function (startAngle, endAngle) {
  var sign = mathSign$1(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign * deltaAngle;
});
_defineProperty$T(Pie, 'getRealPieData', function (item) {
  var _item$props = item.props,
    data = _item$props.data,
    children = _item$props.children;
  var presentationProps = filterProps(item.props);
  var cells = findAllByType(children, Cell);
  if (data && data.length) {
    return data.map(function (entry, index) {
      return _objectSpread$l(
        _objectSpread$l(
          _objectSpread$l(
            {
              payload: entry,
            },
            presentationProps,
          ),
          entry,
        ),
        cells && cells[index] && cells[index].props,
      );
    });
  }
  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _objectSpread$l(_objectSpread$l({}, presentationProps), cell.props);
    });
  }
  return [];
});
_defineProperty$T(Pie, 'parseCoordinateOfPie', function (item, offset) {
  var top = offset.top,
    left = offset.left,
    width = offset.width,
    height = offset.height;
  var maxPieRadius = getMaxRadius(width, height);
  var cx = left + getPercentValue(item.props.cx, width, width / 2);
  var cy = top + getPercentValue(item.props.cy, height, height / 2);
  var innerRadius = getPercentValue(item.props.innerRadius, maxPieRadius, 0);
  var outerRadius = getPercentValue(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
  return {
    cx: cx,
    cy: cy,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    maxRadius: maxRadius,
  };
});
_defineProperty$T(Pie, 'getComposedData', function (_ref4) {
  var item = _ref4.item,
    offset = _ref4.offset;
  var pieData = Pie.getRealPieData(item);
  if (!pieData || !pieData.length) {
    return null;
  }
  var _item$props2 = item.props,
    cornerRadius = _item$props2.cornerRadius,
    startAngle = _item$props2.startAngle,
    endAngle = _item$props2.endAngle,
    paddingAngle = _item$props2.paddingAngle,
    dataKey = _item$props2.dataKey,
    nameKey = _item$props2.nameKey,
    valueKey = _item$props2.valueKey,
    tooltipType = _item$props2.tooltipType;
  var minAngle = Math.abs(item.props.minAngle);
  var coordinate = Pie.parseCoordinateOfPie(item, offset);
  var deltaAngle = Pie.parseDeltaAngle(startAngle, endAngle);
  var absDeltaAngle = Math.abs(deltaAngle);
  var realDataKey = dataKey;
  if (_isNil(dataKey) && _isNil(valueKey)) {
    warn(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
    realDataKey = 'value';
  } else if (_isNil(dataKey)) {
    warn(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
    realDataKey = valueKey;
  }
  var notZeroItemCount = pieData.filter(function (entry) {
    return getValueByDataKey(entry, realDataKey, 0) !== 0;
  }).length;
  var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
  var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
  var sum = pieData.reduce(function (result, entry) {
    var val = getValueByDataKey(entry, realDataKey, 0);
    return result + (isNumber(val) ? val : 0);
  }, 0);
  var sectors;
  if (sum > 0) {
    var prev;
    sectors = pieData.map(function (entry, i) {
      var val = getValueByDataKey(entry, realDataKey, 0);
      var name = getValueByDataKey(entry, nameKey, i);
      var percent = (isNumber(val) ? val : 0) / sum;
      var tempStartAngle;
      if (i) {
        tempStartAngle = prev.endAngle + mathSign$1(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
      } else {
        tempStartAngle = startAngle;
      }
      var tempEndAngle =
        tempStartAngle + mathSign$1(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
      var midAngle = (tempStartAngle + tempEndAngle) / 2;
      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
      var tooltipPayload = [
        {
          name: name,
          value: val,
          payload: entry,
          dataKey: realDataKey,
          type: tooltipType,
        },
      ];
      var tooltipPosition = polarToCartesian(coordinate.cx, coordinate.cy, middleRadius, midAngle);
      prev = _objectSpread$l(
        _objectSpread$l(
          _objectSpread$l(
            {
              percent: percent,
              cornerRadius: cornerRadius,
              name: name,
              tooltipPayload: tooltipPayload,
              midAngle: midAngle,
              middleRadius: middleRadius,
              tooltipPosition: tooltipPosition,
            },
            entry,
          ),
          coordinate,
        ),
        {},
        {
          value: getValueByDataKey(entry, realDataKey),
          startAngle: tempStartAngle,
          endAngle: tempEndAngle,
          payload: entry,
          paddingAngle: mathSign$1(deltaAngle) * paddingAngle,
        },
      );
      return prev;
    });
  }
  return _objectSpread$l(
    _objectSpread$l({}, coordinate),
    {},
    {
      sectors: sectors,
      data: pieData,
    },
  );
});

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */

function head(array) {
  return array && array.length ? array[0] : undefined;
}

var head_1 = head;

var first = head_1;

var _first = /*@__PURE__*/ getDefaultExportFromCjs(first);

function _typeof$V(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$V =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$V(obj)
  );
}
function _extends$h() {
  _extends$h = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$h.apply(this, arguments);
}
function ownKeys$k(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$k(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$k(Object(source), !0).forEach(function (key) {
          _defineProperty$S(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$k(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$L(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$L(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$k(descriptor.key), descriptor);
  }
}
function _createClass$L(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$L(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$L(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$J(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$L(subClass, superClass);
}
function _setPrototypeOf$L(o, p) {
  _setPrototypeOf$L = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$L(o, p);
}
function _createSuper$J(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$J();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$J(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$J(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$J(this, result);
  };
}
function _possibleConstructorReturn$J(self, call) {
  if (call && (_typeof$V(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$L(self);
}
function _assertThisInitialized$L(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$J() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$J(o) {
  _getPrototypeOf$J = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$J(o);
}
function _defineProperty$S(obj, key, value) {
  key = _toPropertyKey$k(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$k(arg) {
  var key = _toPrimitive$k(arg, 'string');
  return _typeof$V(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$k(input, hint) {
  if (_typeof$V(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$V(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var Radar = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$J(Radar, _PureComponent);
  var _super = _createSuper$J(Radar);
  function Radar() {
    var _this;
    _classCallCheck$L(this, Radar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$S(_assertThisInitialized$L(_this), 'state', {
      isAnimationFinished: false,
    });
    _defineProperty$S(_assertThisInitialized$L(_this), 'handleAnimationEnd', function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true,
      });
      if (_isFunction(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$S(_assertThisInitialized$L(_this), 'handleAnimationStart', function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false,
      });
      if (_isFunction(onAnimationStart)) {
        onAnimationStart();
      }
    });
    _defineProperty$S(_assertThisInitialized$L(_this), 'handleMouseEnter', function (e) {
      var onMouseEnter = _this.props.onMouseEnter;
      if (onMouseEnter) {
        onMouseEnter(_this.props, e);
      }
    });
    _defineProperty$S(_assertThisInitialized$L(_this), 'handleMouseLeave', function (e) {
      var onMouseLeave = _this.props.onMouseLeave;
      if (onMouseLeave) {
        onMouseLeave(_this.props, e);
      }
    });
    return _this;
  }
  _createClass$L(
    Radar,
    [
      {
        key: 'renderDots',
        value: function renderDots(points) {
          var _this$props = this.props,
            dot = _this$props.dot,
            dataKey = _this$props.dataKey;
          var baseProps = filterProps(this.props);
          var customDotProps = filterProps(dot);
          var dots = points.map(function (entry, i) {
            var dotProps = _objectSpread$k(
              _objectSpread$k(
                _objectSpread$k(
                  {
                    key: 'dot-'.concat(i),
                    r: 3,
                  },
                  baseProps,
                ),
                customDotProps,
              ),
              {},
              {
                dataKey: dataKey,
                cx: entry.x,
                cy: entry.y,
                index: i,
                payload: entry,
              },
            );
            return Radar.renderDotItem(dot, dotProps);
          });
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-radar-dots',
            },
            dots,
          );
        },
      },
      {
        key: 'renderPolygonStatically',
        value: function renderPolygonStatically(points) {
          var _this$props2 = this.props,
            shape = _this$props2.shape,
            dot = _this$props2.dot,
            isRange = _this$props2.isRange,
            baseLinePoints = _this$props2.baseLinePoints,
            connectNulls = _this$props2.connectNulls;
          var radar;
          if (/*#__PURE__*/ React__default['default'].isValidElement(shape)) {
            radar = /*#__PURE__*/ React__default['default'].cloneElement(
              shape,
              _objectSpread$k(
                _objectSpread$k({}, this.props),
                {},
                {
                  points: points,
                },
              ),
            );
          } else if (_isFunction(shape)) {
            radar = shape(
              _objectSpread$k(
                _objectSpread$k({}, this.props),
                {},
                {
                  points: points,
                },
              ),
            );
          } else {
            radar = /*#__PURE__*/ React__default['default'].createElement(
              Polygon,
              _extends$h({}, filterProps(this.props, true), {
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave,
                points: points,
                baseLinePoints: isRange ? baseLinePoints : null,
                connectNulls: connectNulls,
              }),
            );
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-radar-polygon',
            },
            radar,
            dot ? this.renderDots(points) : null,
          );
        },
      },
      {
        key: 'renderPolygonWithAnimation',
        value: function renderPolygonWithAnimation() {
          var _this2 = this;
          var _this$props3 = this.props,
            points = _this$props3.points,
            isAnimationActive = _this$props3.isAnimationActive,
            animationBegin = _this$props3.animationBegin,
            animationDuration = _this$props3.animationDuration,
            animationEasing = _this$props3.animationEasing,
            animationId = _this$props3.animationId;
          var prevPoints = this.state.prevPoints;
          return /*#__PURE__*/ React__default['default'].createElement(
            Animate,
            {
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing,
              from: {
                t: 0,
              },
              to: {
                t: 1,
              },
              key: 'radar-'.concat(animationId),
              onAnimationEnd: this.handleAnimationEnd,
              onAnimationStart: this.handleAnimationStart,
            },
            function (_ref) {
              var t = _ref.t;
              var prevPointsDiffFactor = prevPoints && prevPoints.length / points.length;
              var stepData = points.map(function (entry, index) {
                var prev = prevPoints && prevPoints[Math.floor(index * prevPointsDiffFactor)];
                if (prev) {
                  var _interpolatorX = interpolateNumber$2(prev.x, entry.x);
                  var _interpolatorY = interpolateNumber$2(prev.y, entry.y);
                  return _objectSpread$k(
                    _objectSpread$k({}, entry),
                    {},
                    {
                      x: _interpolatorX(t),
                      y: _interpolatorY(t),
                    },
                  );
                }
                var interpolatorX = interpolateNumber$2(entry.cx, entry.x);
                var interpolatorY = interpolateNumber$2(entry.cy, entry.y);
                return _objectSpread$k(
                  _objectSpread$k({}, entry),
                  {},
                  {
                    x: interpolatorX(t),
                    y: interpolatorY(t),
                  },
                );
              });
              return _this2.renderPolygonStatically(stepData);
            },
          );
        },
      },
      {
        key: 'renderPolygon',
        value: function renderPolygon() {
          var _this$props4 = this.props,
            points = _this$props4.points,
            isAnimationActive = _this$props4.isAnimationActive,
            isRange = _this$props4.isRange;
          var prevPoints = this.state.prevPoints;
          if (
            isAnimationActive &&
            points &&
            points.length &&
            !isRange &&
            (!prevPoints || !_isEqual(prevPoints, points))
          ) {
            return this.renderPolygonWithAnimation();
          }
          return this.renderPolygonStatically(points);
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props5 = this.props,
            hide = _this$props5.hide,
            className = _this$props5.className,
            points = _this$props5.points,
            isAnimationActive = _this$props5.isAnimationActive;
          if (hide || !points || !points.length) {
            return null;
          }
          var isAnimationFinished = this.state.isAnimationFinished;
          var layerClass = cx('recharts-radar', className);
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: layerClass,
            },
            this.renderPolygon(),
            (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, points),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (nextProps.animationId !== prevState.prevAnimationId) {
            return {
              prevAnimationId: nextProps.animationId,
              curPoints: nextProps.points,
              prevPoints: prevState.curPoints,
            };
          }
          if (nextProps.points !== prevState.curPoints) {
            return {
              curPoints: nextProps.points,
            };
          }
          return null;
        },
      },
      {
        key: 'renderDotItem',
        value: function renderDotItem(option, props) {
          var dotItem;
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            dotItem = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          } else if (_isFunction(option)) {
            dotItem = option(props);
          } else {
            dotItem = /*#__PURE__*/ React__default['default'].createElement(
              Dot,
              _extends$h({}, props, {
                className: 'recharts-radar-dot',
              }),
            );
          }
          return dotItem;
        },
      },
    ],
  );
  return Radar;
})(React.PureComponent);
_defineProperty$S(Radar, 'displayName', 'Radar');
_defineProperty$S(Radar, 'defaultProps', {
  angleAxisId: 0,
  radiusAxisId: 0,
  hide: false,
  activeDot: true,
  dot: false,
  legendType: 'rect',
  isAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
});
_defineProperty$S(Radar, 'getComposedData', function (_ref2) {
  var radiusAxis = _ref2.radiusAxis,
    angleAxis = _ref2.angleAxis,
    displayedData = _ref2.displayedData,
    dataKey = _ref2.dataKey,
    bandSize = _ref2.bandSize;
  var cx = angleAxis.cx,
    cy = angleAxis.cy;
  var isRange = false;
  var points = [];
  displayedData.forEach(function (entry, i) {
    var name = getValueByDataKey(entry, angleAxis.dataKey, i);
    var value = getValueByDataKey(entry, dataKey);
    var angle = angleAxis.scale(name) + (bandSize || 0);
    var pointValue = _isArray(value) ? _last(value) : value;
    var radius = _isNil(pointValue) ? undefined : radiusAxis.scale(pointValue);
    if (_isArray(value) && value.length >= 2) {
      isRange = true;
    }
    points.push(
      _objectSpread$k(
        _objectSpread$k({}, polarToCartesian(cx, cy, radius, angle)),
        {},
        {
          name: name,
          value: value,
          cx: cx,
          cy: cy,
          radius: radius,
          angle: angle,
          payload: entry,
        },
      ),
    );
  });
  var baseLinePoints = [];
  if (isRange) {
    points.forEach(function (point) {
      if (_isArray(point.value)) {
        var baseValue = _first(point.value);
        var radius = _isNil(baseValue) ? undefined : radiusAxis.scale(baseValue);
        baseLinePoints.push(
          _objectSpread$k(
            _objectSpread$k({}, point),
            {},
            {
              radius: radius,
            },
            polarToCartesian(cx, cy, radius, point.angle),
          ),
        );
      } else {
        baseLinePoints.push(point);
      }
    });
  }
  return {
    points: points,
    isRange: isRange,
    baseLinePoints: baseLinePoints,
  };
});

var _excluded$9 = ['shape', 'activeShape', 'activeIndex', 'cornerRadius'],
  _excluded2$4 = ['value', 'background'];
function _typeof$U(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$U =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$U(obj)
  );
}
function ownKeys$j(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$j(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$j(Object(source), !0).forEach(function (key) {
          _defineProperty$R(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$j(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _objectWithoutProperties$9(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$b(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$b(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck$K(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$K(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$j(descriptor.key), descriptor);
  }
}
function _createClass$K(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$K(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$K(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$I(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$K(subClass, superClass);
}
function _setPrototypeOf$K(o, p) {
  _setPrototypeOf$K = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$K(o, p);
}
function _createSuper$I(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$I();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$I(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$I(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$I(this, result);
  };
}
function _possibleConstructorReturn$I(self, call) {
  if (call && (_typeof$U(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$K(self);
}
function _assertThisInitialized$K(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$I() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$I(o) {
  _getPrototypeOf$I = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$I(o);
}
function _defineProperty$R(obj, key, value) {
  key = _toPropertyKey$j(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$j(arg) {
  var key = _toPrimitive$j(arg, 'string');
  return _typeof$U(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$j(input, hint) {
  if (_typeof$U(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$U(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
// TODO: Cause of circular dependency. Needs refactoring of functions that need them.
// import { AngleAxisProps, RadiusAxisProps } from './types';

var RadialBar = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$I(RadialBar, _PureComponent);
  var _super = _createSuper$I(RadialBar);
  function RadialBar() {
    var _this;
    _classCallCheck$K(this, RadialBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$R(_assertThisInitialized$K(_this), 'state', {
      isAnimationFinished: false,
    });
    _defineProperty$R(_assertThisInitialized$K(_this), 'handleAnimationEnd', function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true,
      });
      if (_isFunction(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$R(_assertThisInitialized$K(_this), 'handleAnimationStart', function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false,
      });
      if (_isFunction(onAnimationStart)) {
        onAnimationStart();
      }
    });
    return _this;
  }
  _createClass$K(
    RadialBar,
    [
      {
        key: 'getDeltaAngle',
        value: function getDeltaAngle() {
          var _this$props = this.props,
            startAngle = _this$props.startAngle,
            endAngle = _this$props.endAngle;
          var sign = mathSign$1(endAngle - startAngle);
          var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
          return sign * deltaAngle;
        },
      },
      {
        key: 'renderSectorsStatically',
        value: function renderSectorsStatically(sectors) {
          var _this2 = this;
          var _this$props2 = this.props,
            shape = _this$props2.shape,
            activeShape = _this$props2.activeShape,
            activeIndex = _this$props2.activeIndex,
            cornerRadius = _this$props2.cornerRadius,
            others = _objectWithoutProperties$9(_this$props2, _excluded$9);
          var baseProps = filterProps(others);
          return sectors.map(function (entry, i) {
            var props = _objectSpread$j(
              _objectSpread$j(
                _objectSpread$j(
                  _objectSpread$j({}, baseProps),
                  {},
                  {
                    cornerRadius: cornerRadius,
                  },
                  entry,
                ),
                adaptEventsOfChild(_this2.props, entry, i),
              ),
              {},
              {
                key: 'sector-'.concat(i),
                className: 'recharts-radial-bar-sector',
                forceCornerRadius: others.forceCornerRadius,
                cornerIsExternal: others.cornerIsExternal,
              },
            );
            return RadialBar.renderSectorShape(i === activeIndex ? activeShape : shape, props);
          });
        },
      },
      {
        key: 'renderSectorsWithAnimation',
        value: function renderSectorsWithAnimation() {
          var _this3 = this;
          var _this$props3 = this.props,
            data = _this$props3.data,
            isAnimationActive = _this$props3.isAnimationActive,
            animationBegin = _this$props3.animationBegin,
            animationDuration = _this$props3.animationDuration,
            animationEasing = _this$props3.animationEasing,
            animationId = _this$props3.animationId;
          var prevData = this.state.prevData;
          return /*#__PURE__*/ React__default['default'].createElement(
            Animate,
            {
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing,
              from: {
                t: 0,
              },
              to: {
                t: 1,
              },
              key: 'radialBar-'.concat(animationId),
              onAnimationStart: this.handleAnimationStart,
              onAnimationEnd: this.handleAnimationEnd,
            },
            function (_ref) {
              var t = _ref.t;
              var stepData = data.map(function (entry, index) {
                var prev = prevData && prevData[index];
                if (prev) {
                  var interpolatorStartAngle = interpolateNumber$2(prev.startAngle, entry.startAngle);
                  var interpolatorEndAngle = interpolateNumber$2(prev.endAngle, entry.endAngle);
                  return _objectSpread$j(
                    _objectSpread$j({}, entry),
                    {},
                    {
                      startAngle: interpolatorStartAngle(t),
                      endAngle: interpolatorEndAngle(t),
                    },
                  );
                }
                var endAngle = entry.endAngle,
                  startAngle = entry.startAngle;
                var interpolator = interpolateNumber$2(startAngle, endAngle);
                return _objectSpread$j(
                  _objectSpread$j({}, entry),
                  {},
                  {
                    endAngle: interpolator(t),
                  },
                );
              });
              return /*#__PURE__*/ React__default['default'].createElement(
                Layer,
                null,
                _this3.renderSectorsStatically(stepData),
              );
            },
          );
        },
      },
      {
        key: 'renderSectors',
        value: function renderSectors() {
          var _this$props4 = this.props,
            data = _this$props4.data,
            isAnimationActive = _this$props4.isAnimationActive;
          var prevData = this.state.prevData;
          if (isAnimationActive && data && data.length && (!prevData || !_isEqual(prevData, data))) {
            return this.renderSectorsWithAnimation();
          }
          return this.renderSectorsStatically(data);
        },
      },
      {
        key: 'renderBackground',
        value: function renderBackground(sectors) {
          var _this4 = this;
          var cornerRadius = this.props.cornerRadius;
          var backgroundProps = filterProps(this.props.background);
          return sectors.map(function (entry, i) {
            entry.value;
            var background = entry.background,
              rest = _objectWithoutProperties$9(entry, _excluded2$4);
            if (!background) {
              return null;
            }
            var props = _objectSpread$j(
              _objectSpread$j(
                _objectSpread$j(
                  _objectSpread$j(
                    _objectSpread$j(
                      {
                        cornerRadius: cornerRadius,
                      },
                      rest,
                    ),
                    {},
                    {
                      fill: '#eee',
                    },
                    background,
                  ),
                  backgroundProps,
                ),
                adaptEventsOfChild(_this4.props, entry, i),
              ),
              {},
              {
                index: i,
                key: 'sector-'.concat(i),
                className: 'recharts-radial-bar-background-sector',
              },
            );
            return RadialBar.renderSectorShape(background, props);
          });
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props5 = this.props,
            hide = _this$props5.hide,
            data = _this$props5.data,
            className = _this$props5.className,
            background = _this$props5.background,
            isAnimationActive = _this$props5.isAnimationActive;
          if (hide || !data || !data.length) {
            return null;
          }
          var isAnimationFinished = this.state.isAnimationFinished;
          var layerClass = cx('recharts-area', className);
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: layerClass,
            },
            background &&
              /*#__PURE__*/ React__default['default'].createElement(
                Layer,
                {
                  className: 'recharts-radial-bar-background',
                },
                this.renderBackground(data),
              ),
            /*#__PURE__*/ React__default['default'].createElement(
              Layer,
              {
                className: 'recharts-radial-bar-sectors',
              },
              this.renderSectors(),
            ),
            (!isAnimationActive || isAnimationFinished) &&
              LabelList.renderCallByParent(_objectSpread$j({}, this.props), data),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (nextProps.animationId !== prevState.prevAnimationId) {
            return {
              prevAnimationId: nextProps.animationId,
              curData: nextProps.data,
              prevData: prevState.curData,
            };
          }
          if (nextProps.data !== prevState.curData) {
            return {
              curData: nextProps.data,
            };
          }
          return null;
        },
      },
      {
        key: 'renderSectorShape',
        value: function renderSectorShape(shape, props) {
          var sectorShape;
          if (/*#__PURE__*/ React__default['default'].isValidElement(shape)) {
            sectorShape = /*#__PURE__*/ React__default['default'].cloneElement(shape, props);
          } else if (_isFunction(shape)) {
            sectorShape = shape(props);
          } else {
            sectorShape = /*#__PURE__*/ React__default['default'].createElement(Sector, props);
          }
          return sectorShape;
        },
      },
    ],
  );
  return RadialBar;
})(React.PureComponent);
_defineProperty$R(RadialBar, 'displayName', 'RadialBar');
_defineProperty$R(RadialBar, 'defaultProps', {
  angleAxisId: 0,
  radiusAxisId: 0,
  minPointSize: 0,
  hide: false,
  legendType: 'rect',
  data: [],
  isAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  forceCornerRadius: false,
  cornerIsExternal: false,
});
_defineProperty$R(RadialBar, 'getComposedData', function (_ref2) {
  var item = _ref2.item,
    props = _ref2.props,
    radiusAxis = _ref2.radiusAxis,
    radiusAxisTicks = _ref2.radiusAxisTicks,
    angleAxis = _ref2.angleAxis,
    angleAxisTicks = _ref2.angleAxisTicks,
    displayedData = _ref2.displayedData,
    dataKey = _ref2.dataKey,
    stackedData = _ref2.stackedData,
    barPosition = _ref2.barPosition,
    bandSize = _ref2.bandSize,
    dataStartIndex = _ref2.dataStartIndex;
  var pos = findPositionOfBar(barPosition, item);
  if (!pos) {
    return null;
  }
  var cx = angleAxis.cx,
    cy = angleAxis.cy;
  var layout = props.layout;
  var _item$props = item.props,
    children = _item$props.children,
    minPointSize = _item$props.minPointSize;
  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = getBaseValueOfBar({
    numericAxis: numericAxis,
  });
  var cells = findAllByType(children, Cell);
  var sectors = displayedData.map(function (entry, index) {
    var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;
    if (stackedData) {
      value = truncateByDomain(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = getValueByDataKey(entry, dataKey);
      if (!_isArray(value)) {
        value = [baseValue, value];
      }
    }
    if (layout === 'radial') {
      innerRadius = getCateCoordinateOfBar({
        axis: radiusAxis,
        ticks: radiusAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index,
      });
      endAngle = angleAxis.scale(value[1]);
      startAngle = angleAxis.scale(value[0]);
      outerRadius = innerRadius + pos.size;
      var deltaAngle = endAngle - startAngle;
      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
        var delta = mathSign$1(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
        endAngle += delta;
      }
      backgroundSector = {
        background: {
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          startAngle: props.startAngle,
          endAngle: props.endAngle,
        },
      };
    } else {
      innerRadius = radiusAxis.scale(value[0]);
      outerRadius = radiusAxis.scale(value[1]);
      startAngle = getCateCoordinateOfBar({
        axis: angleAxis,
        ticks: angleAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index,
      });
      endAngle = startAngle + pos.size;
      var deltaRadius = outerRadius - innerRadius;
      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
        var _delta = mathSign$1(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
        outerRadius += _delta;
      }
    }
    return _objectSpread$j(
      _objectSpread$j(
        _objectSpread$j(_objectSpread$j({}, entry), backgroundSector),
        {},
        {
          payload: entry,
          value: stackedData ? value : value[1],
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          startAngle: startAngle,
          endAngle: endAngle,
        },
        cells && cells[index] && cells[index].props,
      ),
      {},
      {
        tooltipPayload: [getTooltipItem(item, entry)],
        tooltipPosition: polarToCartesian(cx, cy, (innerRadius + outerRadius) / 2, (startAngle + endAngle) / 2),
      },
    );
  });
  return {
    data: sectors,
    layout: layout,
  };
});

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeCeil = Math.ceil,
  nativeMax$1 = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange$1(start, end, step, fromRight) {
  var index = -1,
    length = nativeMax$1(nativeCeil((end - start) / (step || 1)), 0),
    result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

var _baseRange = baseRange$1;

var toNumber = toNumber_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
  MAX_INTEGER = 1.7976931348623157e308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$2(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite$2;

var baseRange = _baseRange,
  isIterateeCall$2 = _isIterateeCall,
  toFinite$1 = toFinite_1;

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange$1(fromRight) {
  return function (start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall$2(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite$1(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite$1(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite$1(step);
    return baseRange(start, end, step, fromRight);
  };
}

var _createRange = createRange$1;

var createRange = _createRange;

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

var range_1 = range;

var _range = /*@__PURE__*/ getDefaultExportFromCjs(range_1);

function _typeof$T(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$T =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$T(obj)
  );
}
function ownKeys$i(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$i(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$i(Object(source), !0).forEach(function (key) {
          _defineProperty$Q(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$i(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$Q(obj, key, value) {
  key = _toPropertyKey$i(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$i(arg) {
  var key = _toPrimitive$i(arg, 'string');
  return _typeof$T(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$i(input, hint) {
  if (_typeof$T(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$T(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
var generatePrefixStyle = function generatePrefixStyle(name, value) {
  if (!name) {
    return null;
  }
  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var result = PREFIX_LIST.reduce(function (res, entry) {
    return _objectSpread$i(_objectSpread$i({}, res), {}, _defineProperty$Q({}, entry + camelName, value));
  }, {});
  result[name] = value;
  return result;
};

function _typeof$S(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$S =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$S(obj)
  );
}
function _extends$g() {
  _extends$g = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$g.apply(this, arguments);
}
function ownKeys$h(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$h(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$h(Object(source), !0).forEach(function (key) {
          _defineProperty$P(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$h(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$J(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$J(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$h(descriptor.key), descriptor);
  }
}
function _createClass$J(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$J(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$J(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$H(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$J(subClass, superClass);
}
function _setPrototypeOf$J(o, p) {
  _setPrototypeOf$J = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$J(o, p);
}
function _createSuper$H(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$H();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$H(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$H(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$H(this, result);
  };
}
function _possibleConstructorReturn$H(self, call) {
  if (call && (_typeof$S(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$J(self);
}
function _assertThisInitialized$J(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$H() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$H(o) {
  _getPrototypeOf$H = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$H(o);
}
function _defineProperty$P(obj, key, value) {
  key = _toPropertyKey$h(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$h(arg) {
  var key = _toPrimitive$h(arg, 'string');
  return _typeof$S(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$h(input, hint) {
  if (_typeof$S(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$S(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var createScale = function createScale(_ref) {
  var data = _ref.data,
    startIndex = _ref.startIndex,
    endIndex = _ref.endIndex,
    x = _ref.x,
    width = _ref.width,
    travellerWidth = _ref.travellerWidth;
  if (!data || !data.length) {
    return {};
  }
  var len = data.length;
  var scale = point()
    .domain(_range(0, len))
    .range([x, x + width - travellerWidth]);
  var scaleValues = scale.domain().map(function (entry) {
    return scale(entry);
  });
  return {
    isTextActive: false,
    isSlideMoving: false,
    isTravellerMoving: false,
    startX: scale(startIndex),
    endX: scale(endIndex),
    scale: scale,
    scaleValues: scaleValues,
  };
};
var isTouch = function isTouch(e) {
  return e.changedTouches && !!e.changedTouches.length;
};
var Brush = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$H(Brush, _PureComponent);
  var _super = _createSuper$H(Brush);
  function Brush(props) {
    var _this;
    _classCallCheck$J(this, Brush);
    _this = _super.call(this, props);
    _defineProperty$P(_assertThisInitialized$J(_this), 'handleDrag', function (e) {
      if (_this.leaveTimer) {
        clearTimeout(_this.leaveTimer);
        _this.leaveTimer = null;
      }
      if (_this.state.isTravellerMoving) {
        _this.handleTravellerMove(e);
      } else if (_this.state.isSlideMoving) {
        _this.handleSlideDrag(e);
      }
    });
    _defineProperty$P(_assertThisInitialized$J(_this), 'handleTouchMove', function (e) {
      if (e.changedTouches != null && e.changedTouches.length > 0) {
        _this.handleDrag(e.changedTouches[0]);
      }
    });
    _defineProperty$P(_assertThisInitialized$J(_this), 'handleDragEnd', function () {
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: false,
      });
      _this.detachDragEndListener();
    });
    _defineProperty$P(_assertThisInitialized$J(_this), 'handleLeaveWrapper', function () {
      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
        _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
      }
    });
    _defineProperty$P(_assertThisInitialized$J(_this), 'handleEnterSlideOrTraveller', function () {
      _this.setState({
        isTextActive: true,
      });
    });
    _defineProperty$P(_assertThisInitialized$J(_this), 'handleLeaveSlideOrTraveller', function () {
      _this.setState({
        isTextActive: false,
      });
    });
    _defineProperty$P(_assertThisInitialized$J(_this), 'handleSlideDragStart', function (e) {
      var event = isTouch(e) ? e.changedTouches[0] : e;
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: true,
        slideMoveStartX: event.pageX,
      });
      _this.attachDragEndListener();
    });
    _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_assertThisInitialized$J(_this), 'startX'),
      endX: _this.handleTravellerDragStart.bind(_assertThisInitialized$J(_this), 'endX'),
    };
    _this.state = {};
    return _this;
  }
  _createClass$J(
    Brush,
    [
      {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.leaveTimer) {
            clearTimeout(this.leaveTimer);
            this.leaveTimer = null;
          }
          this.detachDragEndListener();
        },
      },
      {
        key: 'getIndex',
        value: function getIndex(_ref2) {
          var startX = _ref2.startX,
            endX = _ref2.endX;
          var scaleValues = this.state.scaleValues;
          var _this$props = this.props,
            gap = _this$props.gap,
            data = _this$props.data;
          var lastIndex = data.length - 1;
          var min = Math.min(startX, endX);
          var max = Math.max(startX, endX);
          var minIndex = Brush.getIndexInRange(scaleValues, min);
          var maxIndex = Brush.getIndexInRange(scaleValues, max);
          return {
            startIndex: minIndex - (minIndex % gap),
            endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - (maxIndex % gap),
          };
        },
      },
      {
        key: 'getTextOfTick',
        value: function getTextOfTick(index) {
          var _this$props2 = this.props,
            data = _this$props2.data,
            tickFormatter = _this$props2.tickFormatter,
            dataKey = _this$props2.dataKey;
          var text = getValueByDataKey(data[index], dataKey, index);
          return _isFunction(tickFormatter) ? tickFormatter(text, index) : text;
        },
      },
      {
        key: 'attachDragEndListener',
        value: function attachDragEndListener() {
          window.addEventListener('mouseup', this.handleDragEnd, true);
          window.addEventListener('touchend', this.handleDragEnd, true);
          window.addEventListener('mousemove', this.handleDrag, true);
        },
      },
      {
        key: 'detachDragEndListener',
        value: function detachDragEndListener() {
          window.removeEventListener('mouseup', this.handleDragEnd, true);
          window.removeEventListener('touchend', this.handleDragEnd, true);
          window.removeEventListener('mousemove', this.handleDrag, true);
        },
      },
      {
        key: 'handleSlideDrag',
        value: function handleSlideDrag(e) {
          var _this$state = this.state,
            slideMoveStartX = _this$state.slideMoveStartX,
            startX = _this$state.startX,
            endX = _this$state.endX;
          var _this$props3 = this.props,
            x = _this$props3.x,
            width = _this$props3.width,
            travellerWidth = _this$props3.travellerWidth,
            startIndex = _this$props3.startIndex,
            endIndex = _this$props3.endIndex,
            onChange = _this$props3.onChange;
          var delta = e.pageX - slideMoveStartX;
          if (delta > 0) {
            delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
          } else if (delta < 0) {
            delta = Math.max(delta, x - startX, x - endX);
          }
          var newIndex = this.getIndex({
            startX: startX + delta,
            endX: endX + delta,
          });
          if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
            onChange(newIndex);
          }
          this.setState({
            startX: startX + delta,
            endX: endX + delta,
            slideMoveStartX: e.pageX,
          });
        },
      },
      {
        key: 'handleTravellerDragStart',
        value: function handleTravellerDragStart(id, e) {
          var event = isTouch(e) ? e.changedTouches[0] : e;
          this.setState({
            isSlideMoving: false,
            isTravellerMoving: true,
            movingTravellerId: id,
            brushMoveStartX: event.pageX,
          });
          this.attachDragEndListener();
        },
      },
      {
        key: 'handleTravellerMove',
        value: function handleTravellerMove(e) {
          var _this$setState;
          var _this$state2 = this.state,
            brushMoveStartX = _this$state2.brushMoveStartX,
            movingTravellerId = _this$state2.movingTravellerId,
            endX = _this$state2.endX,
            startX = _this$state2.startX;
          var prevValue = this.state[movingTravellerId];
          var _this$props4 = this.props,
            x = _this$props4.x,
            width = _this$props4.width,
            travellerWidth = _this$props4.travellerWidth,
            onChange = _this$props4.onChange,
            gap = _this$props4.gap,
            data = _this$props4.data;
          var params = {
            startX: this.state.startX,
            endX: this.state.endX,
          };
          var delta = e.pageX - brushMoveStartX;
          if (delta > 0) {
            delta = Math.min(delta, x + width - travellerWidth - prevValue);
          } else if (delta < 0) {
            delta = Math.max(delta, x - prevValue);
          }
          params[movingTravellerId] = prevValue + delta;
          var newIndex = this.getIndex(params);
          var startIndex = newIndex.startIndex,
            endIndex = newIndex.endIndex;
          var isFullGap = function isFullGap() {
            var lastIndex = data.length - 1;
            if (
              (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0)) ||
              (endX < startX && endIndex === lastIndex) ||
              (movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0)) ||
              (endX > startX && endIndex === lastIndex)
            ) {
              return true;
            }
            return false;
          };
          this.setState(
            ((_this$setState = {}),
            _defineProperty$P(_this$setState, movingTravellerId, prevValue + delta),
            _defineProperty$P(_this$setState, 'brushMoveStartX', e.pageX),
            _this$setState),
            function () {
              if (onChange) {
                if (isFullGap()) {
                  onChange(newIndex);
                }
              }
            },
          );
        },
      },
      {
        key: 'renderBackground',
        value: function renderBackground() {
          var _this$props5 = this.props,
            x = _this$props5.x,
            y = _this$props5.y,
            width = _this$props5.width,
            height = _this$props5.height,
            fill = _this$props5.fill,
            stroke = _this$props5.stroke;
          return /*#__PURE__*/ React__default['default'].createElement('rect', {
            stroke: stroke,
            fill: fill,
            x: x,
            y: y,
            width: width,
            height: height,
          });
        },
      },
      {
        key: 'renderPanorama',
        value: function renderPanorama() {
          var _this$props6 = this.props,
            x = _this$props6.x,
            y = _this$props6.y,
            width = _this$props6.width,
            height = _this$props6.height,
            data = _this$props6.data,
            children = _this$props6.children,
            padding = _this$props6.padding;
          var chartElement = React.Children.only(children);
          if (!chartElement) {
            return null;
          }
          return /*#__PURE__*/ React__default['default'].cloneElement(chartElement, {
            x: x,
            y: y,
            width: width,
            height: height,
            margin: padding,
            compact: true,
            data: data,
          });
        },
      },
      {
        key: 'renderTravellerLayer',
        value: function renderTravellerLayer(travellerX, id) {
          var _this$props7 = this.props,
            y = _this$props7.y,
            travellerWidth = _this$props7.travellerWidth,
            height = _this$props7.height,
            traveller = _this$props7.traveller;
          var x = Math.max(travellerX, this.props.x);
          var travellerProps = _objectSpread$h(
            _objectSpread$h({}, filterProps(this.props)),
            {},
            {
              x: x,
              y: y,
              width: travellerWidth,
              height: height,
            },
          );
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-brush-traveller',
              onMouseEnter: this.handleEnterSlideOrTraveller,
              onMouseLeave: this.handleLeaveSlideOrTraveller,
              onMouseDown: this.travellerDragStartHandlers[id],
              onTouchStart: this.travellerDragStartHandlers[id],
              style: {
                cursor: 'col-resize',
              },
            },
            Brush.renderTraveller(traveller, travellerProps),
          );
        },
      },
      {
        key: 'renderSlide',
        value: function renderSlide(startX, endX) {
          var _this$props8 = this.props,
            y = _this$props8.y,
            height = _this$props8.height,
            stroke = _this$props8.stroke,
            travellerWidth = _this$props8.travellerWidth;
          var x = Math.min(startX, endX) + travellerWidth;
          var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
          return /*#__PURE__*/ React__default['default'].createElement('rect', {
            className: 'recharts-brush-slide',
            onMouseEnter: this.handleEnterSlideOrTraveller,
            onMouseLeave: this.handleLeaveSlideOrTraveller,
            onMouseDown: this.handleSlideDragStart,
            onTouchStart: this.handleSlideDragStart,
            style: {
              cursor: 'move',
            },
            stroke: 'none',
            fill: stroke,
            fillOpacity: 0.2,
            x: x,
            y: y,
            width: width,
            height: height,
          });
        },
      },
      {
        key: 'renderText',
        value: function renderText() {
          var _this$props9 = this.props,
            startIndex = _this$props9.startIndex,
            endIndex = _this$props9.endIndex,
            y = _this$props9.y,
            height = _this$props9.height,
            travellerWidth = _this$props9.travellerWidth,
            stroke = _this$props9.stroke;
          var _this$state3 = this.state,
            startX = _this$state3.startX,
            endX = _this$state3.endX;
          var offset = 5;
          var attrs = {
            pointerEvents: 'none',
            fill: stroke,
          };
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-brush-texts',
            },
            /*#__PURE__*/ React__default['default'].createElement(
              Text,
              _extends$g(
                {
                  textAnchor: 'end',
                  verticalAnchor: 'middle',
                  x: Math.min(startX, endX) - offset,
                  y: y + height / 2,
                },
                attrs,
              ),
              this.getTextOfTick(startIndex),
            ),
            /*#__PURE__*/ React__default['default'].createElement(
              Text,
              _extends$g(
                {
                  textAnchor: 'start',
                  verticalAnchor: 'middle',
                  x: Math.max(startX, endX) + travellerWidth + offset,
                  y: y + height / 2,
                },
                attrs,
              ),
              this.getTextOfTick(endIndex),
            ),
          );
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props10 = this.props,
            data = _this$props10.data,
            className = _this$props10.className,
            children = _this$props10.children,
            x = _this$props10.x,
            y = _this$props10.y,
            width = _this$props10.width,
            height = _this$props10.height,
            alwaysShowText = _this$props10.alwaysShowText;
          var _this$state4 = this.state,
            startX = _this$state4.startX,
            endX = _this$state4.endX,
            isTextActive = _this$state4.isTextActive,
            isSlideMoving = _this$state4.isSlideMoving,
            isTravellerMoving = _this$state4.isTravellerMoving;
          if (
            !data ||
            !data.length ||
            !isNumber(x) ||
            !isNumber(y) ||
            !isNumber(width) ||
            !isNumber(height) ||
            width <= 0 ||
            height <= 0
          ) {
            return null;
          }
          var layerClass = cx('recharts-brush', className);
          var isPanoramic = React__default['default'].Children.count(children) === 1;
          var style = generatePrefixStyle('userSelect', 'none');
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: layerClass,
              onMouseLeave: this.handleLeaveWrapper,
              onTouchMove: this.handleTouchMove,
              style: style,
            },
            this.renderBackground(),
            isPanoramic && this.renderPanorama(),
            this.renderSlide(startX, endX),
            this.renderTravellerLayer(startX, 'startX'),
            this.renderTravellerLayer(endX, 'endX'),
            (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText(),
          );
        },
      },
    ],
    [
      {
        key: 'renderDefaultTraveller',
        value: function renderDefaultTraveller(props) {
          var x = props.x,
            y = props.y,
            width = props.width,
            height = props.height,
            stroke = props.stroke;
          var lineY = Math.floor(y + height / 2) - 1;
          return /*#__PURE__*/ React__default['default'].createElement(
            React__default['default'].Fragment,
            null,
            /*#__PURE__*/ React__default['default'].createElement('rect', {
              x: x,
              y: y,
              width: width,
              height: height,
              fill: stroke,
              stroke: 'none',
            }),
            /*#__PURE__*/ React__default['default'].createElement('line', {
              x1: x + 1,
              y1: lineY,
              x2: x + width - 1,
              y2: lineY,
              fill: 'none',
              stroke: '#fff',
            }),
            /*#__PURE__*/ React__default['default'].createElement('line', {
              x1: x + 1,
              y1: lineY + 2,
              x2: x + width - 1,
              y2: lineY + 2,
              fill: 'none',
              stroke: '#fff',
            }),
          );
        },
      },
      {
        key: 'renderTraveller',
        value: function renderTraveller(option, props) {
          var rectangle;
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            rectangle = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          } else if (_isFunction(option)) {
            rectangle = option(props);
          } else {
            rectangle = Brush.renderDefaultTraveller(props);
          }
          return rectangle;
        },
      },
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          var data = nextProps.data,
            width = nextProps.width,
            x = nextProps.x,
            travellerWidth = nextProps.travellerWidth,
            updateId = nextProps.updateId,
            startIndex = nextProps.startIndex,
            endIndex = nextProps.endIndex;
          if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) {
            return _objectSpread$h(
              {
                prevData: data,
                prevTravellerWidth: travellerWidth,
                prevUpdateId: updateId,
                prevX: x,
                prevWidth: width,
              },
              data && data.length
                ? createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex,
                  })
                : {
                    scale: null,
                    scaleValues: null,
                  },
            );
          }
          if (
            prevState.scale &&
            (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)
          ) {
            prevState.scale.range([x, x + width - travellerWidth]);
            var scaleValues = prevState.scale.domain().map(function (entry) {
              return prevState.scale(entry);
            });
            return {
              prevData: data,
              prevTravellerWidth: travellerWidth,
              prevUpdateId: updateId,
              prevX: x,
              prevWidth: width,
              startX: prevState.scale(nextProps.startIndex),
              endX: prevState.scale(nextProps.endIndex),
              scaleValues: scaleValues,
            };
          }
          return null;
        },
      },
      {
        key: 'getIndexInRange',
        value: function getIndexInRange(range, x) {
          var len = range.length;
          var start = 0;
          var end = len - 1;
          while (end - start > 1) {
            var middle = Math.floor((start + end) / 2);
            if (range[middle] > x) {
              end = middle;
            } else {
              start = middle;
            }
          }
          return x >= range[end] ? end : start;
        },
      },
    ],
  );
  return Brush;
})(React.PureComponent);
_defineProperty$P(Brush, 'displayName', 'Brush');
_defineProperty$P(Brush, 'defaultProps', {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: '#fff',
  stroke: '#666',
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1,
  },
  leaveTimeOut: 1000,
  alwaysShowText: false,
});

var baseEach$1 = _baseEach;

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome$1(collection, predicate) {
  var result;

  baseEach$1(collection, function (value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

var _baseSome = baseSome$1;

var arraySome = _arraySome,
  baseIteratee$5 = _baseIteratee,
  baseSome = _baseSome,
  isArray$2 = isArray_1,
  isIterateeCall$1 = _isIterateeCall;

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray$2(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall$1(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee$5(predicate));
}

var some_1 = some;

var _some = /*@__PURE__*/ getDefaultExportFromCjs(some_1);

var ifOverflowMatches = function ifOverflowMatches(props, value) {
  var alwaysShow = props.alwaysShow;
  var ifOverflow = props.ifOverflow;
  if (alwaysShow) {
    ifOverflow = 'extendDomain';
  }
  return ifOverflow === value;
};

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */

function arrayEvery$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

var _arrayEvery = arrayEvery$1;

var baseEach = _baseEach;

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery$1(collection, predicate) {
  var result = true;
  baseEach(collection, function (value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

var _baseEvery = baseEvery$1;

var arrayEvery = _arrayEvery,
  baseEvery = _baseEvery,
  baseIteratee$4 = _baseIteratee,
  isArray$1 = isArray_1,
  isIterateeCall = _isIterateeCall;

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray$1(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee$4(predicate));
}

var every_1 = every;

var _every = /*@__PURE__*/ getDefaultExportFromCjs(every_1);

var defineProperty$4 = _defineProperty$1e;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$4) {
    defineProperty$4(object, key, {
      configurable: true,
      enumerable: true,
      value: value,
      writable: true,
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$3;

var baseAssignValue$2 = _baseAssignValue,
  baseForOwn = _baseForOwn,
  baseIteratee$3 = _baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee$3(iteratee);

  baseForOwn(object, function (value, key, object) {
    baseAssignValue$2(result, key, iteratee(value, key, object));
  });
  return result;
}

var mapValues_1 = mapValues;

var _mapValues = /*@__PURE__*/ getDefaultExportFromCjs(mapValues_1);

var _excluded$8 = ['value', 'background'];
function _typeof$R(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$R =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$R(obj)
  );
}
function _objectWithoutProperties$8(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$a(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$a(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _extends$f() {
  _extends$f = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$f.apply(this, arguments);
}
function ownKeys$g(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$g(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$g(Object(source), !0).forEach(function (key) {
          _defineProperty$O(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$g(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$I(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$I(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$g(descriptor.key), descriptor);
  }
}
function _createClass$I(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$I(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$I(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$G(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$I(subClass, superClass);
}
function _setPrototypeOf$I(o, p) {
  _setPrototypeOf$I = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$I(o, p);
}
function _createSuper$G(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$G();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$G(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$G(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$G(this, result);
  };
}
function _possibleConstructorReturn$G(self, call) {
  if (call && (_typeof$R(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$I(self);
}
function _assertThisInitialized$I(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$G() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$G(o) {
  _getPrototypeOf$G = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$G(o);
}
function _defineProperty$O(obj, key, value) {
  key = _toPropertyKey$g(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$g(arg) {
  var key = _toPrimitive$g(arg, 'string');
  return _typeof$R(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$g(input, hint) {
  if (_typeof$R(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$R(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var Bar = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$G(Bar, _PureComponent);
  var _super = _createSuper$G(Bar);
  function Bar() {
    var _this;
    _classCallCheck$I(this, Bar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$O(_assertThisInitialized$I(_this), 'state', {
      isAnimationFinished: false,
    });
    _defineProperty$O(_assertThisInitialized$I(_this), 'id', uniqueId('recharts-bar-'));
    _defineProperty$O(_assertThisInitialized$I(_this), 'handleAnimationEnd', function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true,
      });
      if (onAnimationEnd) {
        onAnimationEnd();
      }
    });
    _defineProperty$O(_assertThisInitialized$I(_this), 'handleAnimationStart', function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false,
      });
      if (onAnimationStart) {
        onAnimationStart();
      }
    });
    return _this;
  }
  _createClass$I(
    Bar,
    [
      {
        key: 'renderRectanglesStatically',
        value: function renderRectanglesStatically(data) {
          var _this2 = this;
          var shape = this.props.shape;
          var baseProps = filterProps(this.props);
          return (
            data &&
            data.map(function (entry, i) {
              var props = _objectSpread$g(
                _objectSpread$g(_objectSpread$g({}, baseProps), entry),
                {},
                {
                  index: i,
                },
              );
              return /*#__PURE__*/ React__default['default'].createElement(
                Layer,
                _extends$f(
                  {
                    className: 'recharts-bar-rectangle',
                  },
                  adaptEventsOfChild(_this2.props, entry, i),
                  {
                    key: 'rectangle-'.concat(i), // eslint-disable-line react/no-array-index-key
                    role: 'img',
                  },
                ),
                Bar.renderRectangle(shape, props),
              );
            })
          );
        },
      },
      {
        key: 'renderRectanglesWithAnimation',
        value: function renderRectanglesWithAnimation() {
          var _this3 = this;
          var _this$props = this.props,
            data = _this$props.data,
            layout = _this$props.layout,
            isAnimationActive = _this$props.isAnimationActive,
            animationBegin = _this$props.animationBegin,
            animationDuration = _this$props.animationDuration,
            animationEasing = _this$props.animationEasing,
            animationId = _this$props.animationId;
          var prevData = this.state.prevData;
          return /*#__PURE__*/ React__default['default'].createElement(
            Animate,
            {
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing,
              from: {
                t: 0,
              },
              to: {
                t: 1,
              },
              key: 'bar-'.concat(animationId),
              onAnimationEnd: this.handleAnimationEnd,
              onAnimationStart: this.handleAnimationStart,
            },
            function (_ref) {
              var t = _ref.t;
              var stepData = data.map(function (entry, index) {
                var prev = prevData && prevData[index];
                if (prev) {
                  var interpolatorX = interpolateNumber$2(prev.x, entry.x);
                  var interpolatorY = interpolateNumber$2(prev.y, entry.y);
                  var interpolatorWidth = interpolateNumber$2(prev.width, entry.width);
                  var interpolatorHeight = interpolateNumber$2(prev.height, entry.height);
                  return _objectSpread$g(
                    _objectSpread$g({}, entry),
                    {},
                    {
                      x: interpolatorX(t),
                      y: interpolatorY(t),
                      width: interpolatorWidth(t),
                      height: interpolatorHeight(t),
                    },
                  );
                }
                if (layout === 'horizontal') {
                  var _interpolatorHeight = interpolateNumber$2(0, entry.height);
                  var h = _interpolatorHeight(t);
                  return _objectSpread$g(
                    _objectSpread$g({}, entry),
                    {},
                    {
                      y: entry.y + entry.height - h,
                      height: h,
                    },
                  );
                }
                var interpolator = interpolateNumber$2(0, entry.width);
                var w = interpolator(t);
                return _objectSpread$g(
                  _objectSpread$g({}, entry),
                  {},
                  {
                    width: w,
                  },
                );
              });
              return /*#__PURE__*/ React__default['default'].createElement(
                Layer,
                null,
                _this3.renderRectanglesStatically(stepData),
              );
            },
          );
        },
      },
      {
        key: 'renderRectangles',
        value: function renderRectangles() {
          var _this$props2 = this.props,
            data = _this$props2.data,
            isAnimationActive = _this$props2.isAnimationActive;
          var prevData = this.state.prevData;
          if (isAnimationActive && data && data.length && (!prevData || !_isEqual(prevData, data))) {
            return this.renderRectanglesWithAnimation();
          }
          return this.renderRectanglesStatically(data);
        },
      },
      {
        key: 'renderBackground',
        value: function renderBackground() {
          var _this4 = this;
          var data = this.props.data;
          var backgroundProps = filterProps(this.props.background);
          return data.map(function (entry, i) {
            entry.value;
            var background = entry.background,
              rest = _objectWithoutProperties$8(entry, _excluded$8);
            if (!background) {
              return null;
            }
            var props = _objectSpread$g(
              _objectSpread$g(
                _objectSpread$g(
                  _objectSpread$g(
                    _objectSpread$g({}, rest),
                    {},
                    {
                      fill: '#eee',
                    },
                    background,
                  ),
                  backgroundProps,
                ),
                adaptEventsOfChild(_this4.props, entry, i),
              ),
              {},
              {
                index: i,
                key: 'background-bar-'.concat(i),
                className: 'recharts-bar-background-rectangle',
              },
            );
            return Bar.renderRectangle(_this4.props.background, props);
          });
        },
      },
      {
        key: 'renderErrorBar',
        value: function renderErrorBar(needClip, clipPathId) {
          if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
            return null;
          }
          var _this$props3 = this.props,
            data = _this$props3.data,
            xAxis = _this$props3.xAxis,
            yAxis = _this$props3.yAxis,
            layout = _this$props3.layout,
            children = _this$props3.children;
          var errorBarItems = findAllByType(children, ErrorBar);
          if (!errorBarItems) {
            return null;
          }
          var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
          function dataPointFormatter(dataPoint, dataKey) {
            return {
              x: dataPoint.x,
              y: dataPoint.y,
              value: dataPoint.value,
              errorVal: getValueByDataKey(dataPoint, dataKey),
            };
          }
          var errorBarProps = {
            clipPath: needClip ? 'url(#clipPath-'.concat(clipPathId, ')') : null,
          };
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            errorBarProps,
            errorBarItems.map(function (item, i) {
              return /*#__PURE__*/ React__default['default'].cloneElement(item, {
                key: 'error-bar-'.concat(i),
                // eslint-disable-line react/no-array-index-key
                data: data,
                xAxis: xAxis,
                yAxis: yAxis,
                layout: layout,
                offset: offset,
                dataPointFormatter: dataPointFormatter,
              });
            }),
          );
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props4 = this.props,
            hide = _this$props4.hide,
            data = _this$props4.data,
            className = _this$props4.className,
            xAxis = _this$props4.xAxis,
            yAxis = _this$props4.yAxis,
            left = _this$props4.left,
            top = _this$props4.top,
            width = _this$props4.width,
            height = _this$props4.height,
            isAnimationActive = _this$props4.isAnimationActive,
            background = _this$props4.background,
            id = _this$props4.id;
          if (hide || !data || !data.length) {
            return null;
          }
          var isAnimationFinished = this.state.isAnimationFinished;
          var layerClass = cx('recharts-bar', className);
          var needClip = (xAxis && xAxis.allowDataOverflow) || (yAxis && yAxis.allowDataOverflow);
          var clipPathId = _isNil(id) ? this.id : id;
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: layerClass,
            },
            needClip
              ? /*#__PURE__*/ React__default['default'].createElement(
                  'defs',
                  null,
                  /*#__PURE__*/ React__default['default'].createElement(
                    'clipPath',
                    {
                      id: 'clipPath-'.concat(clipPathId),
                    },
                    /*#__PURE__*/ React__default['default'].createElement('rect', {
                      x: left,
                      y: top,
                      width: width,
                      height: height,
                    }),
                  ),
                )
              : null,
            /*#__PURE__*/ React__default['default'].createElement(
              Layer,
              {
                className: 'recharts-bar-rectangles',
                clipPath: needClip ? 'url(#clipPath-'.concat(clipPathId, ')') : null,
              },
              background ? this.renderBackground() : null,
              this.renderRectangles(),
            ),
            this.renderErrorBar(needClip, clipPathId),
            (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, data),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (nextProps.animationId !== prevState.prevAnimationId) {
            return {
              prevAnimationId: nextProps.animationId,
              curData: nextProps.data,
              prevData: prevState.curData,
            };
          }
          if (nextProps.data !== prevState.curData) {
            return {
              curData: nextProps.data,
            };
          }
          return null;
        },
      },
      {
        key: 'renderRectangle',
        value: function renderRectangle(option, props) {
          var rectangle;
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            rectangle = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          } else if (_isFunction(option)) {
            rectangle = option(props);
          } else {
            rectangle = /*#__PURE__*/ React__default['default'].createElement(Rectangle, props);
          }
          return rectangle;
        },
      },
    ],
  );
  return Bar;
})(React.PureComponent);
_defineProperty$O(Bar, 'displayName', 'Bar');
_defineProperty$O(Bar, 'defaultProps', {
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'rect',
  minPointSize: 0,
  hide: false,
  // data of bar
  data: [],
  layout: 'vertical',
  isAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'ease',
});
_defineProperty$O(Bar, 'getComposedData', function (_ref2) {
  var props = _ref2.props,
    item = _ref2.item,
    barPosition = _ref2.barPosition,
    bandSize = _ref2.bandSize,
    xAxis = _ref2.xAxis,
    yAxis = _ref2.yAxis,
    xAxisTicks = _ref2.xAxisTicks,
    yAxisTicks = _ref2.yAxisTicks,
    stackedData = _ref2.stackedData,
    dataStartIndex = _ref2.dataStartIndex,
    displayedData = _ref2.displayedData,
    offset = _ref2.offset;
  var pos = findPositionOfBar(barPosition, item);
  if (!pos) {
    return null;
  }
  var layout = props.layout;
  var _item$props = item.props,
    dataKey = _item$props.dataKey,
    children = _item$props.children,
    minPointSize = _item$props.minPointSize;
  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = getBaseValueOfBar({
    numericAxis: numericAxis,
  });
  var cells = findAllByType(children, Cell);
  var rects = displayedData.map(function (entry, index) {
    var value, x, y, width, height, background;
    if (stackedData) {
      value = truncateByDomain(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = getValueByDataKey(entry, dataKey);
      if (!_isArray(value)) {
        value = [baseValue, value];
      }
    }
    if (layout === 'horizontal') {
      var _ref4;
      var _ref3 = [yAxis.scale(value[0]), yAxis.scale(value[1])],
        baseValueScale = _ref3[0],
        currentValueScale = _ref3[1];
      x = getCateCoordinateOfBar({
        axis: xAxis,
        ticks: xAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index,
      });
      y =
        (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !==
          null && _ref4 !== void 0
          ? _ref4
          : undefined;
      width = pos.size;
      var computedHeight = baseValueScale - currentValueScale;
      height = Number.isNaN(computedHeight) ? 0 : computedHeight;
      background = {
        x: x,
        y: yAxis.y,
        width: width,
        height: yAxis.height,
      };
      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
        var delta = mathSign$1(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
        y -= delta;
        height += delta;
      }
    } else {
      var _ref5 = [xAxis.scale(value[0]), xAxis.scale(value[1])],
        _baseValueScale = _ref5[0],
        _currentValueScale = _ref5[1];
      x = _baseValueScale;
      y = getCateCoordinateOfBar({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index,
      });
      width = _currentValueScale - _baseValueScale;
      height = pos.size;
      background = {
        x: xAxis.x,
        y: y,
        width: xAxis.width,
        height: height,
      };
      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
        var _delta = mathSign$1(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
        width += _delta;
      }
    }
    return _objectSpread$g(
      _objectSpread$g(
        _objectSpread$g({}, entry),
        {},
        {
          x: x,
          y: y,
          width: width,
          height: height,
          value: stackedData ? value : value[1],
          payload: entry,
          background: background,
        },
        cells && cells[index] && cells[index].props,
      ),
      {},
      {
        tooltipPayload: [getTooltipItem(item, entry)],
        tooltipPosition: {
          x: x + width / 2,
          y: y + height / 2,
        },
      },
    );
  });
  return _objectSpread$g(
    {
      data: rects,
      layout: layout,
    },
    offset,
  );
});

function _typeof$Q(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$Q =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$Q(obj)
  );
}
function _classCallCheck$H(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$H(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$f(descriptor.key), descriptor);
  }
}
function _createClass$H(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$H(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$H(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function ownKeys$f(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$f(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$f(Object(source), !0).forEach(function (key) {
          _defineProperty$N(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$f(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$N(obj, key, value) {
  key = _toPropertyKey$f(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$f(arg) {
  var key = _toPrimitive$f(arg, 'string');
  return _typeof$Q(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$f(input, hint) {
  if (_typeof$Q(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$Q(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}

/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {String} axisType  The type of axes, x-axis or y-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
    height = props.height,
    layout = props.layout,
    children = props.children;
  var ids = Object.keys(axisMap);
  var steps = {
    left: offset.left,
    leftMirror: offset.left,
    right: width - offset.right,
    rightMirror: width - offset.right,
    top: offset.top,
    topMirror: offset.top,
    bottom: height - offset.bottom,
    bottomMirror: height - offset.bottom,
  };
  var hasBar = !!findChildByType(children, Bar);
  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var orientation = axis.orientation,
      domain = axis.domain,
      _axis$padding = axis.padding,
      padding = _axis$padding === void 0 ? {} : _axis$padding,
      mirror = axis.mirror,
      reversed = axis.reversed;
    var offsetKey = ''.concat(orientation).concat(mirror ? 'Mirror' : '');
    var calculatedPadding, range, x, y, needSpace;
    if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
      var diff = domain[1] - domain[0];
      var smallestDistanceBetweenValues = Infinity;
      var sortedValues = axis.categoricalDomain.sort();
      sortedValues.forEach(function (value, index) {
        if (index > 0) {
          smallestDistanceBetweenValues = Math.min(
            (value || 0) - (sortedValues[index - 1] || 0),
            smallestDistanceBetweenValues,
          );
        }
      });
      var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
      var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
      if (axis.padding === 'gap') {
        calculatedPadding = (smallestDistanceInPercent * rangeWidth) / 2;
      }
      if (axis.padding === 'no-gap') {
        var gap = getPercentValue(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
        var halfBand = (smallestDistanceInPercent * rangeWidth) / 2;
        calculatedPadding = halfBand - gap - ((halfBand - gap) / rangeWidth) * gap;
      }
    }
    if (axisType === 'xAxis') {
      range = [
        offset.left + (padding.left || 0) + (calculatedPadding || 0),
        offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0),
      ];
    } else if (axisType === 'yAxis') {
      range =
        layout === 'horizontal'
          ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)]
          : [
              offset.top + (padding.top || 0) + (calculatedPadding || 0),
              offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0),
            ];
    } else {
      range = axis.range;
    }
    if (reversed) {
      range = [range[1], range[0]];
    }
    var _parseScale = parseScale(axis, chartName, hasBar),
      scale = _parseScale.scale,
      realScaleType = _parseScale.realScaleType;
    scale.domain(domain).range(range);
    checkDomainOfScale(scale);
    var ticks = getTicksOfScale(
      scale,
      _objectSpread$f(
        _objectSpread$f({}, axis),
        {},
        {
          realScaleType: realScaleType,
        },
      ),
    );
    if (axisType === 'xAxis') {
      needSpace = (orientation === 'top' && !mirror) || (orientation === 'bottom' && mirror);
      x = offset.left;
      y = steps[offsetKey] - needSpace * axis.height;
    } else if (axisType === 'yAxis') {
      needSpace = (orientation === 'left' && !mirror) || (orientation === 'right' && mirror);
      x = steps[offsetKey] - needSpace * axis.width;
      y = offset.top;
    }
    var finalAxis = _objectSpread$f(
      _objectSpread$f(_objectSpread$f({}, axis), ticks),
      {},
      {
        realScaleType: realScaleType,
        x: x,
        y: y,
        scale: scale,
        width: axisType === 'xAxis' ? offset.width : axis.width,
        height: axisType === 'yAxis' ? offset.height : axis.height,
      },
    );
    finalAxis.bandSize = getBandSizeOfAxis(finalAxis, ticks);
    if (!axis.hide && axisType === 'xAxis') {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
    } else if (!axis.hide) {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
    }
    return _objectSpread$f(_objectSpread$f({}, result), {}, _defineProperty$N({}, id, finalAxis));
  }, {});
};
var rectWithPoints = function rectWithPoints(_ref, _ref2) {
  var x1 = _ref.x,
    y1 = _ref.y;
  var x2 = _ref2.x,
    y2 = _ref2.y;
  return {
    x: Math.min(x1, x2),
    y: Math.min(y1, y2),
    width: Math.abs(x2 - x1),
    height: Math.abs(y2 - y1),
  };
};

/**
 * Compute the x, y, width, and height of a box from two reference points.
 * @param  {Object} coords     x1, x2, y1, and y2
 * @return {Object} object
 */
var rectWithCoords = function rectWithCoords(_ref3) {
  var x1 = _ref3.x1,
    y1 = _ref3.y1,
    x2 = _ref3.x2,
    y2 = _ref3.y2;
  return rectWithPoints(
    {
      x: x1,
      y: y1,
    },
    {
      x: x2,
      y: y2,
    },
  );
};
var ScaleHelper = /*#__PURE__*/ (function () {
  function ScaleHelper(scale) {
    _classCallCheck$H(this, ScaleHelper);
    this.scale = scale;
  }
  _createClass$H(
    ScaleHelper,
    [
      {
        key: 'domain',
        get: function get() {
          return this.scale.domain;
        },
      },
      {
        key: 'range',
        get: function get() {
          return this.scale.range;
        },
      },
      {
        key: 'rangeMin',
        get: function get() {
          return this.range()[0];
        },
      },
      {
        key: 'rangeMax',
        get: function get() {
          return this.range()[1];
        },
      },
      {
        key: 'bandwidth',
        get: function get() {
          return this.scale.bandwidth;
        },
      },
      {
        key: 'apply',
        value: function apply(value) {
          var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            bandAware = _ref4.bandAware,
            position = _ref4.position;
          if (value === undefined) {
            return undefined;
          }
          if (position) {
            switch (position) {
              case 'start': {
                return this.scale(value);
              }
              case 'middle': {
                var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                return this.scale(value) + offset;
              }
              case 'end': {
                var _offset = this.bandwidth ? this.bandwidth() : 0;
                return this.scale(value) + _offset;
              }
              default: {
                return this.scale(value);
              }
            }
          }
          if (bandAware) {
            var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
            return this.scale(value) + _offset2;
          }
          return this.scale(value);
        },
      },
      {
        key: 'isInRange',
        value: function isInRange(value) {
          var range = this.range();
          var first = range[0];
          var last = range[range.length - 1];
          return first <= last ? value >= first && value <= last : value >= last && value <= first;
        },
      },
    ],
    [
      {
        key: 'create',
        value: function create(obj) {
          return new ScaleHelper(obj);
        },
      },
    ],
  );
  return ScaleHelper;
})();
_defineProperty$N(ScaleHelper, 'EPS', 1e-4);
var createLabeledScales = function createLabeledScales(options) {
  var scales = Object.keys(options).reduce(function (res, key) {
    return _objectSpread$f(_objectSpread$f({}, res), {}, _defineProperty$N({}, key, ScaleHelper.create(options[key])));
  }, {});
  return _objectSpread$f(
    _objectSpread$f({}, scales),
    {},
    {
      apply: function apply(coord) {
        var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          bandAware = _ref5.bandAware,
          position = _ref5.position;
        return _mapValues(coord, function (value, label) {
          return scales[label].apply(value, {
            bandAware: bandAware,
            position: position,
          });
        });
      },
      isInRange: function isInRange(coord) {
        return _every(coord, function (value, label) {
          return scales[label].isInRange(value);
        });
      },
    },
  );
};

function _typeof$P(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$P =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$P(obj)
  );
}
function ownKeys$e(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$e(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$e(Object(source), !0).forEach(function (key) {
          _defineProperty$M(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$e(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$M(obj, key, value) {
  key = _toPropertyKey$e(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$e(arg) {
  var key = _toPrimitive$e(arg, 'string');
  return _typeof$P(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$e(input, hint) {
  if (_typeof$P(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$P(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _slicedToArray$4(arr, i) {
  return (
    _arrayWithHoles$4(arr) ||
    _iterableToArrayLimit$4(arr, i) ||
    _unsupportedIterableToArray$7(arr, i) ||
    _nonIterableRest$4()
  );
}
function _nonIterableRest$4() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$7(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$7(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen);
}
function _arrayLikeToArray$7(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit$4(arr, i) {
  var _i = null == arr ? null : ('undefined' != typeof Symbol && arr[Symbol.iterator]) || arr['@@iterator'];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      (_d = !0), (_e = err);
    } finally {
      try {
        if (!_n && null != _i['return'] && ((_r = _i['return']()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$4(arr) {
  if (Array.isArray(arr)) return arr;
}
function _extends$e() {
  _extends$e = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$e.apply(this, arguments);
}
var renderLine = function renderLine(option, props) {
  var line;
  if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
    line = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
  } else if (_isFunction(option)) {
    line = option(props);
  } else {
    line = /*#__PURE__*/ React__default['default'].createElement(
      'line',
      _extends$e({}, props, {
        className: 'recharts-reference-line-line',
      }),
    );
  }
  return line;
};

// TODO: ScaleHelper
var getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
  var _props$viewBox = props.viewBox,
    x = _props$viewBox.x,
    y = _props$viewBox.y,
    width = _props$viewBox.width,
    height = _props$viewBox.height,
    position = props.position;
  if (isFixedY) {
    var yCoord = props.y,
      orientation = props.yAxis.orientation;
    var coord = scales.y.apply(yCoord, {
      position: position,
    });
    if (ifOverflowMatches(props, 'discard') && !scales.y.isInRange(coord)) {
      return null;
    }
    var points = [
      {
        x: x + width,
        y: coord,
      },
      {
        x: x,
        y: coord,
      },
    ];
    return orientation === 'left' ? points.reverse() : points;
  }
  if (isFixedX) {
    var xCoord = props.x,
      _orientation = props.xAxis.orientation;
    var _coord = scales.x.apply(xCoord, {
      position: position,
    });
    if (ifOverflowMatches(props, 'discard') && !scales.x.isInRange(_coord)) {
      return null;
    }
    var _points = [
      {
        x: _coord,
        y: y + height,
      },
      {
        x: _coord,
        y: y,
      },
    ];
    return _orientation === 'top' ? _points.reverse() : _points;
  }
  if (isSegment) {
    var segment = props.segment;
    var _points2 = segment.map(function (p) {
      return scales.apply(p, {
        position: position,
      });
    });
    if (
      ifOverflowMatches(props, 'discard') &&
      _some(_points2, function (p) {
        return !scales.isInRange(p);
      })
    ) {
      return null;
    }
    return _points2;
  }
  return null;
};
function ReferenceLine(props) {
  var fixedX = props.x,
    fixedY = props.y,
    segment = props.segment,
    xAxis = props.xAxis,
    yAxis = props.yAxis,
    shape = props.shape,
    className = props.className,
    alwaysShow = props.alwaysShow,
    clipPathId = props.clipPathId;
  warn(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale,
  });
  var isX = isNumOrStr(fixedX);
  var isY = isNumOrStr(fixedY);
  var isSegment = segment && segment.length === 2;
  var endPoints = getEndPoints(scales, isX, isY, isSegment, props);
  if (!endPoints) {
    return null;
  }
  var _endPoints = _slicedToArray$4(endPoints, 2),
    _endPoints$ = _endPoints[0],
    x1 = _endPoints$.x,
    y1 = _endPoints$.y,
    _endPoints$2 = _endPoints[1],
    x2 = _endPoints$2.x,
    y2 = _endPoints$2.y;
  var clipPath = ifOverflowMatches(props, 'hidden') ? 'url(#'.concat(clipPathId, ')') : undefined;
  var lineProps = _objectSpread$e(
    _objectSpread$e(
      {
        clipPath: clipPath,
      },
      filterProps(props, true),
    ),
    {},
    {
      x1: x1,
      y1: y1,
      x2: x2,
      y2: y2,
    },
  );
  return /*#__PURE__*/ React__default['default'].createElement(
    Layer,
    {
      className: cx('recharts-reference-line', className),
    },
    renderLine(shape, lineProps),
    Label.renderCallByParent(
      props,
      rectWithCoords({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
      }),
    ),
  );
}
ReferenceLine.displayName = 'ReferenceLine';
ReferenceLine.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  fill: 'none',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1,
  position: 'middle',
};

function _typeof$O(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$O =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$O(obj)
  );
}
function _extends$d() {
  _extends$d = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$d.apply(this, arguments);
}
function ownKeys$d(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$d(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$d(Object(source), !0).forEach(function (key) {
          _defineProperty$L(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$d(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$L(obj, key, value) {
  key = _toPropertyKey$d(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$d(arg) {
  var key = _toPrimitive$d(arg, 'string');
  return _typeof$O(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$d(input, hint) {
  if (_typeof$O(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$O(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var getCoordinate = function getCoordinate(props) {
  var x = props.x,
    y = props.y,
    xAxis = props.xAxis,
    yAxis = props.yAxis;
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale,
  });
  var result = scales.apply(
    {
      x: x,
      y: y,
    },
    {
      bandAware: true,
    },
  );
  if (ifOverflowMatches(props, 'discard') && !scales.isInRange(result)) {
    return null;
  }
  return result;
};
function ReferenceDot(props) {
  var x = props.x,
    y = props.y,
    r = props.r,
    alwaysShow = props.alwaysShow,
    clipPathId = props.clipPathId;
  var isX = isNumOrStr(x);
  var isY = isNumOrStr(y);
  warn(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  if (!isX || !isY) {
    return null;
  }
  var coordinate = getCoordinate(props);
  if (!coordinate) {
    return null;
  }
  var cx$1 = coordinate.x,
    cy = coordinate.y;
  var shape = props.shape,
    className = props.className;
  var clipPath = ifOverflowMatches(props, 'hidden') ? 'url(#'.concat(clipPathId, ')') : undefined;
  var dotProps = _objectSpread$d(
    _objectSpread$d(
      {
        clipPath: clipPath,
      },
      filterProps(props, true),
    ),
    {},
    {
      cx: cx$1,
      cy: cy,
    },
  );
  return /*#__PURE__*/ React__default['default'].createElement(
    Layer,
    {
      className: cx('recharts-reference-dot', className),
    },
    ReferenceDot.renderDot(shape, dotProps),
    Label.renderCallByParent(props, {
      x: cx$1 - r,
      y: cy - r,
      width: 2 * r,
      height: 2 * r,
    }),
  );
}
ReferenceDot.displayName = 'ReferenceDot';
ReferenceDot.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#fff',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1,
};
ReferenceDot.renderDot = function (option, props) {
  var dot;
  if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
    dot = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
  } else if (_isFunction(option)) {
    dot = option(props);
  } else {
    dot = /*#__PURE__*/ React__default['default'].createElement(
      Dot,
      _extends$d({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: 'recharts-reference-dot-dot',
      }),
    );
  }
  return dot;
};

function _typeof$N(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$N =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$N(obj)
  );
}
function _extends$c() {
  _extends$c = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$c.apply(this, arguments);
}
function ownKeys$c(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$c(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$c(Object(source), !0).forEach(function (key) {
          _defineProperty$K(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$c(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$K(obj, key, value) {
  key = _toPropertyKey$c(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$c(arg) {
  var key = _toPrimitive$c(arg, 'string');
  return _typeof$N(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$c(input, hint) {
  if (_typeof$N(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$N(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
  var xValue1 = props.x1,
    xValue2 = props.x2,
    yValue1 = props.y1,
    yValue2 = props.y2,
    xAxis = props.xAxis,
    yAxis = props.yAxis;
  if (!xAxis || !yAxis) return null;
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale,
  });
  var p1 = {
    x: hasX1
      ? scales.x.apply(xValue1, {
          position: 'start',
        })
      : scales.x.rangeMin,
    y: hasY1
      ? scales.y.apply(yValue1, {
          position: 'start',
        })
      : scales.y.rangeMin,
  };
  var p2 = {
    x: hasX2
      ? scales.x.apply(xValue2, {
          position: 'end',
        })
      : scales.x.rangeMax,
    y: hasY2
      ? scales.y.apply(yValue2, {
          position: 'end',
        })
      : scales.y.rangeMax,
  };
  if (ifOverflowMatches(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) {
    return null;
  }
  return rectWithPoints(p1, p2);
};
function ReferenceArea(props) {
  var x1 = props.x1,
    x2 = props.x2,
    y1 = props.y1,
    y2 = props.y2,
    className = props.className,
    alwaysShow = props.alwaysShow,
    clipPathId = props.clipPathId;
  warn(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var hasX1 = isNumOrStr(x1);
  var hasX2 = isNumOrStr(x2);
  var hasY1 = isNumOrStr(y1);
  var hasY2 = isNumOrStr(y2);
  var shape = props.shape;
  if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
    return null;
  }
  var rect = getRect(hasX1, hasX2, hasY1, hasY2, props);
  if (!rect && !shape) {
    return null;
  }
  var clipPath = ifOverflowMatches(props, 'hidden') ? 'url(#'.concat(clipPathId, ')') : undefined;
  return /*#__PURE__*/ React__default['default'].createElement(
    Layer,
    {
      className: cx('recharts-reference-area', className),
    },
    ReferenceArea.renderRect(
      shape,
      _objectSpread$c(
        _objectSpread$c(
          {
            clipPath: clipPath,
          },
          filterProps(props, true),
        ),
        rect,
      ),
    ),
    Label.renderCallByParent(props, rect),
  );
}
ReferenceArea.displayName = 'ReferenceArea';
ReferenceArea.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#ccc',
  fillOpacity: 0.5,
  stroke: 'none',
  strokeWidth: 1,
};
ReferenceArea.renderRect = function (option, props) {
  var rect;
  if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
    rect = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
  } else if (_isFunction(option)) {
    rect = option(props);
  } else {
    rect = /*#__PURE__*/ React__default['default'].createElement(
      Rectangle,
      _extends$c({}, props, {
        className: 'recharts-reference-area-rect',
      }),
    );
  }
  return rect;
};

/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */
function getEveryNthWithCondition(array, n, isValid) {
  if (n < 1) {
    return [];
  }
  if (n === 1 && isValid === undefined) {
    return array;
  }
  var result = [];
  for (var i = 0; i < array.length; i += n) {
    if (isValid === undefined || isValid(array[i]) === true) {
      result.push(array[i]);
    } else {
      return undefined;
    }
  }
  return result;
}

function _typeof$M(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$M =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$M(obj)
  );
}
function ownKeys$b(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$b(Object(source), !0).forEach(function (key) {
          _defineProperty$J(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$b(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$J(obj, key, value) {
  key = _toPropertyKey$b(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$b(arg) {
  var key = _toPrimitive$b(arg, 'string');
  return _typeof$M(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$b(input, hint) {
  if (_typeof$M(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$M(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}

/**
 * Given an array of ticks, find N, the lowest possible number for which every
 * nTH tick in the ticks array isShow == true and return the array of every nTh tick.
 * @param {CartesianTickItem[]} ticks An array of CartesianTickItem with the
 * information whether they can be shown without overlapping with their neighbour isShow.
 * @returns {CartesianTickItem[]} Every nTh tick in an array.
 */
function getEveryNThTick(ticks) {
  var N = 1;
  var previous = getEveryNthWithCondition(ticks, N, function (tickItem) {
    return tickItem.isShow;
  });
  while (N <= ticks.length) {
    if (previous !== undefined) {
      return previous;
    }
    N++;
    previous = getEveryNthWithCondition(ticks, N, function (tickItem) {
      return tickItem.isShow;
    });
  }
  return ticks.slice(0, 1);
}
function getNumberIntervalTicks(ticks, interval) {
  return getEveryNthWithCondition(ticks, interval + 1);
}
function getTicksEnd(_ref) {
  var ticks = _ref.ticks,
    tickFormatter = _ref.tickFormatter,
    viewBox = _ref.viewBox,
    orientation = _ref.orientation,
    minTickGap = _ref.minTickGap,
    unit = _ref.unit,
    fontSize = _ref.fontSize,
    letterSpacing = _ref.letterSpacing;
  var x = viewBox.x,
    y = viewBox.y,
    width = viewBox.width,
    height = viewBox.height;
  var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
  // we need add the width of 'unit' only when sizeKey === 'width'
  var unitSize =
    unit && sizeKey === 'width'
      ? getStringSize(unit, {
          fontSize: fontSize,
          letterSpacing: letterSpacing,
        })[sizeKey]
      : 0;
  var result = (ticks || []).slice();
  var len = result.length;
  var sign = len >= 2 ? mathSign$1(result[1].coordinate - result[0].coordinate) : 1;
  var start, end;
  if (sign === 1) {
    start = sizeKey === 'width' ? x : y;
    end = sizeKey === 'width' ? x + width : y + height;
  } else {
    start = sizeKey === 'width' ? x + width : y + height;
    end = sizeKey === 'width' ? x : y;
  }
  for (var i = len - 1; i >= 0; i--) {
    var entry = result[i];
    var content = _isFunction(tickFormatter) ? tickFormatter(entry.value, len - i - 1) : entry.value;
    var size =
      getStringSize(content, {
        fontSize: fontSize,
        letterSpacing: letterSpacing,
      })[sizeKey] + unitSize;
    if (i === len - 1) {
      var gap = sign * (entry.coordinate + (sign * size) / 2 - end);
      result[i] = entry = _objectSpread$b(
        _objectSpread$b({}, entry),
        {},
        {
          tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate,
        },
      );
    } else {
      result[i] = entry = _objectSpread$b(
        _objectSpread$b({}, entry),
        {},
        {
          tickCoord: entry.coordinate,
        },
      );
    }
    var isShow =
      sign * (entry.tickCoord - (sign * size) / 2 - start) >= 0 &&
      sign * (entry.tickCoord + (sign * size) / 2 - end) <= 0;
    if (isShow) {
      end = entry.tickCoord - sign * (size / 2 + minTickGap);
      result[i] = _objectSpread$b(
        _objectSpread$b({}, entry),
        {},
        {
          isShow: true,
        },
      );
    }
  }
  return result;
}
function getTicksStart(_ref2, preserveEnd) {
  var ticks = _ref2.ticks,
    tickFormatter = _ref2.tickFormatter,
    viewBox = _ref2.viewBox,
    orientation = _ref2.orientation,
    minTickGap = _ref2.minTickGap,
    unit = _ref2.unit,
    fontSize = _ref2.fontSize,
    letterSpacing = _ref2.letterSpacing;
  var x = viewBox.x,
    y = viewBox.y,
    width = viewBox.width,
    height = viewBox.height;
  var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
  var result = (ticks || []).slice();
  // we need add the width of 'unit' only when sizeKey === 'width'
  var unitSize =
    unit && sizeKey === 'width'
      ? getStringSize(unit, {
          fontSize: fontSize,
          letterSpacing: letterSpacing,
        })[sizeKey]
      : 0;
  var len = result.length;
  var sign = len >= 2 ? mathSign$1(result[1].coordinate - result[0].coordinate) : 1;
  var start, end;
  if (sign === 1) {
    start = sizeKey === 'width' ? x : y;
    end = sizeKey === 'width' ? x + width : y + height;
  } else {
    start = sizeKey === 'width' ? x + width : y + height;
    end = sizeKey === 'width' ? x : y;
  }
  if (preserveEnd) {
    // Try to guarantee the tail to be displayed
    var tail = ticks[len - 1];
    var tailContent = _isFunction(tickFormatter) ? tickFormatter(tail.value, len - 1) : tail.value;
    var tailSize =
      getStringSize(tailContent, {
        fontSize: fontSize,
        letterSpacing: letterSpacing,
      })[sizeKey] + unitSize;
    var tailGap = sign * (tail.coordinate + (sign * tailSize) / 2 - end);
    result[len - 1] = tail = _objectSpread$b(
      _objectSpread$b({}, tail),
      {},
      {
        tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate,
      },
    );
    var isTailShow =
      sign * (tail.tickCoord - (sign * tailSize) / 2 - start) >= 0 &&
      sign * (tail.tickCoord + (sign * tailSize) / 2 - end) <= 0;
    if (isTailShow) {
      end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
      result[len - 1] = _objectSpread$b(
        _objectSpread$b({}, tail),
        {},
        {
          isShow: true,
        },
      );
    }
  }
  var count = preserveEnd ? len - 1 : len;
  for (var i = 0; i < count; i++) {
    var entry = result[i];
    var content = _isFunction(tickFormatter) ? tickFormatter(entry.value, i) : entry.value;
    var size =
      getStringSize(content, {
        fontSize: fontSize,
        letterSpacing: letterSpacing,
      })[sizeKey] + unitSize;
    if (i === 0) {
      var gap = sign * (entry.coordinate - (sign * size) / 2 - start);
      result[i] = entry = _objectSpread$b(
        _objectSpread$b({}, entry),
        {},
        {
          tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate,
        },
      );
    } else {
      result[i] = entry = _objectSpread$b(
        _objectSpread$b({}, entry),
        {},
        {
          tickCoord: entry.coordinate,
        },
      );
    }
    var isShow =
      sign * (entry.tickCoord - (sign * size) / 2 - start) >= 0 &&
      sign * (entry.tickCoord + (sign * size) / 2 - end) <= 0;
    if (isShow) {
      start = entry.tickCoord + sign * (size / 2 + minTickGap);
      result[i] = _objectSpread$b(
        _objectSpread$b({}, entry),
        {},
        {
          isShow: true,
        },
      );
    }
  }
  return result;
}
function getTicks(props, fontSize, letterSpacing) {
  var tick = props.tick,
    ticks = props.ticks,
    viewBox = props.viewBox,
    minTickGap = props.minTickGap,
    orientation = props.orientation,
    interval = props.interval,
    tickFormatter = props.tickFormatter,
    unit = props.unit;
  if (!ticks || !ticks.length || !tick) {
    return [];
  }
  if (isNumber(interval) || Global.isSsr) {
    return getNumberIntervalTicks(ticks, typeof interval === 'number' && isNumber(interval) ? interval : 0);
  }
  var candidates = [];
  if (interval === 'equidistantPreserveStart') {
    candidates = getTicksStart({
      ticks: ticks,
      tickFormatter: tickFormatter,
      viewBox: viewBox,
      orientation: orientation,
      minTickGap: minTickGap,
      unit: unit,
      fontSize: fontSize,
      letterSpacing: letterSpacing,
    });
    return getEveryNThTick(candidates);
  }
  if (interval === 'preserveStart' || interval === 'preserveStartEnd') {
    candidates = getTicksStart(
      {
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit,
        fontSize: fontSize,
        letterSpacing: letterSpacing,
      },
      interval === 'preserveStartEnd',
    );
  } else {
    candidates = getTicksEnd({
      ticks: ticks,
      tickFormatter: tickFormatter,
      viewBox: viewBox,
      orientation: orientation,
      minTickGap: minTickGap,
      unit: unit,
      fontSize: fontSize,
      letterSpacing: letterSpacing,
    });
  }
  return candidates.filter(function (entry) {
    return entry.isShow;
  });
}

var _excluded$7 = ['viewBox'],
  _excluded2$3 = ['viewBox'],
  _excluded3$1 = ['ticks'];
function _typeof$L(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$L =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$L(obj)
  );
}
function _extends$b() {
  _extends$b = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$b.apply(this, arguments);
}
function ownKeys$a(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$a(Object(source), !0).forEach(function (key) {
          _defineProperty$I(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$a(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _objectWithoutProperties$7(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$9(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$9(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck$G(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$G(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$a(descriptor.key), descriptor);
  }
}
function _createClass$G(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$G(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$G(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$F(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$H(subClass, superClass);
}
function _setPrototypeOf$H(o, p) {
  _setPrototypeOf$H = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$H(o, p);
}
function _createSuper$F(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$F();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$F(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$F(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$F(this, result);
  };
}
function _possibleConstructorReturn$F(self, call) {
  if (call && (_typeof$L(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$H(self);
}
function _assertThisInitialized$H(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$F() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$F(o) {
  _getPrototypeOf$F = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$F(o);
}
function _defineProperty$I(obj, key, value) {
  key = _toPropertyKey$a(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$a(arg) {
  var key = _toPrimitive$a(arg, 'string');
  return _typeof$L(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$a(input, hint) {
  if (_typeof$L(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$L(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var CartesianAxis = /*#__PURE__*/ (function (_Component) {
  _inherits$F(CartesianAxis, _Component);
  var _super = _createSuper$F(CartesianAxis);
  function CartesianAxis(props) {
    var _this;
    _classCallCheck$G(this, CartesianAxis);
    _this = _super.call(this, props);
    _this.state = {
      fontSize: '',
      letterSpacing: '',
    };
    return _this;
  }
  _createClass$G(
    CartesianAxis,
    [
      {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(_ref, nextState) {
          var viewBox = _ref.viewBox,
            restProps = _objectWithoutProperties$7(_ref, _excluded$7);
          // props.viewBox is sometimes generated every time -
          // check that specially as object equality is likely to fail
          var _this$props = this.props,
            viewBoxOld = _this$props.viewBox,
            restPropsOld = _objectWithoutProperties$7(_this$props, _excluded2$3);
          return (
            !shallowEqual$1(viewBox, viewBoxOld) ||
            !shallowEqual$1(restProps, restPropsOld) ||
            !shallowEqual$1(nextState, this.state)
          );
        },
      },
      {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var htmlLayer = this.layerReference;
          if (!htmlLayer) return;
          var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
          if (tick) {
            this.setState({
              fontSize: window.getComputedStyle(tick).fontSize,
              letterSpacing: window.getComputedStyle(tick).letterSpacing,
            });
          }
        },

        /**
         * Calculate the coordinates of endpoints in ticks
         * @param  {Object} data The data of a simple tick
         * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
         *  (x2, y2): The coordinate of endpoint close to axis
         */
      },
      {
        key: 'getTickLineCoord',
        value: function getTickLineCoord(data) {
          var _this$props2 = this.props,
            x = _this$props2.x,
            y = _this$props2.y,
            width = _this$props2.width,
            height = _this$props2.height,
            orientation = _this$props2.orientation,
            tickSize = _this$props2.tickSize,
            mirror = _this$props2.mirror,
            tickMargin = _this$props2.tickMargin;
          var x1, x2, y1, y2, tx, ty;
          var sign = mirror ? -1 : 1;
          var finalTickSize = data.tickSize || tickSize;
          var tickCoord = isNumber(data.tickCoord) ? data.tickCoord : data.coordinate;
          switch (orientation) {
            case 'top':
              x1 = x2 = data.coordinate;
              y2 = y + +!mirror * height;
              y1 = y2 - sign * finalTickSize;
              ty = y1 - sign * tickMargin;
              tx = tickCoord;
              break;
            case 'left':
              y1 = y2 = data.coordinate;
              x2 = x + +!mirror * width;
              x1 = x2 - sign * finalTickSize;
              tx = x1 - sign * tickMargin;
              ty = tickCoord;
              break;
            case 'right':
              y1 = y2 = data.coordinate;
              x2 = x + +mirror * width;
              x1 = x2 + sign * finalTickSize;
              tx = x1 + sign * tickMargin;
              ty = tickCoord;
              break;
            default:
              x1 = x2 = data.coordinate;
              y2 = y + +mirror * height;
              y1 = y2 + sign * finalTickSize;
              ty = y1 + sign * tickMargin;
              tx = tickCoord;
              break;
          }
          return {
            line: {
              x1: x1,
              y1: y1,
              x2: x2,
              y2: y2,
            },
            tick: {
              x: tx,
              y: ty,
            },
          };
        },
      },
      {
        key: 'getTickTextAnchor',
        value: function getTickTextAnchor() {
          var _this$props3 = this.props,
            orientation = _this$props3.orientation,
            mirror = _this$props3.mirror;
          var textAnchor;
          switch (orientation) {
            case 'left':
              textAnchor = mirror ? 'start' : 'end';
              break;
            case 'right':
              textAnchor = mirror ? 'end' : 'start';
              break;
            default:
              textAnchor = 'middle';
              break;
          }
          return textAnchor;
        },
      },
      {
        key: 'getTickVerticalAnchor',
        value: function getTickVerticalAnchor() {
          var _this$props4 = this.props,
            orientation = _this$props4.orientation,
            mirror = _this$props4.mirror;
          var verticalAnchor = 'end';
          switch (orientation) {
            case 'left':
            case 'right':
              verticalAnchor = 'middle';
              break;
            case 'top':
              verticalAnchor = mirror ? 'start' : 'end';
              break;
            default:
              verticalAnchor = mirror ? 'end' : 'start';
              break;
          }
          return verticalAnchor;
        },
      },
      {
        key: 'renderAxisLine',
        value: function renderAxisLine() {
          var _this$props5 = this.props,
            x = _this$props5.x,
            y = _this$props5.y,
            width = _this$props5.width,
            height = _this$props5.height,
            orientation = _this$props5.orientation,
            mirror = _this$props5.mirror,
            axisLine = _this$props5.axisLine;
          var props = _objectSpread$a(
            _objectSpread$a(_objectSpread$a({}, filterProps(this.props)), filterProps(axisLine)),
            {},
            {
              fill: 'none',
            },
          );
          if (orientation === 'top' || orientation === 'bottom') {
            var needHeight = +((orientation === 'top' && !mirror) || (orientation === 'bottom' && mirror));
            props = _objectSpread$a(
              _objectSpread$a({}, props),
              {},
              {
                x1: x,
                y1: y + needHeight * height,
                x2: x + width,
                y2: y + needHeight * height,
              },
            );
          } else {
            var needWidth = +((orientation === 'left' && !mirror) || (orientation === 'right' && mirror));
            props = _objectSpread$a(
              _objectSpread$a({}, props),
              {},
              {
                x1: x + needWidth * width,
                y1: y,
                x2: x + needWidth * width,
                y2: y + height,
              },
            );
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            'line',
            _extends$b({}, props, {
              className: cx('recharts-cartesian-axis-line', _get(axisLine, 'className')),
            }),
          );
        },
      },
      {
        key: 'renderTicks',
        value:
          /**
           * render the ticks
           * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
           * @param {string} fontSize Fontsize to consider for tick spacing
           * @param {string} letterSpacing Letterspacing to consider for tick spacing
           * @return {ReactComponent} renderedTicks
           */
          function renderTicks(ticks, fontSize, letterSpacing) {
            var _this2 = this;
            var _this$props6 = this.props,
              tickLine = _this$props6.tickLine,
              stroke = _this$props6.stroke,
              tick = _this$props6.tick,
              tickFormatter = _this$props6.tickFormatter,
              unit = _this$props6.unit;
            var finalTicks = getTicks(
              _objectSpread$a(
                _objectSpread$a({}, this.props),
                {},
                {
                  ticks: ticks,
                },
              ),
              fontSize,
              letterSpacing,
            );
            var textAnchor = this.getTickTextAnchor();
            var verticalAnchor = this.getTickVerticalAnchor();
            var axisProps = filterProps(this.props);
            var customTickProps = filterProps(tick);
            var tickLineProps = _objectSpread$a(
              _objectSpread$a({}, axisProps),
              {},
              {
                fill: 'none',
              },
              filterProps(tickLine),
            );
            var items = finalTicks.map(function (entry, i) {
              var _this2$getTickLineCoo = _this2.getTickLineCoord(entry),
                lineCoord = _this2$getTickLineCoo.line,
                tickCoord = _this2$getTickLineCoo.tick;
              var tickProps = _objectSpread$a(
                _objectSpread$a(
                  _objectSpread$a(
                    _objectSpread$a(
                      {
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor,
                      },
                      axisProps,
                    ),
                    {},
                    {
                      stroke: 'none',
                      fill: stroke,
                    },
                    customTickProps,
                  ),
                  tickCoord,
                ),
                {},
                {
                  index: i,
                  payload: entry,
                  visibleTicksCount: finalTicks.length,
                  tickFormatter: tickFormatter,
                },
              );
              return /*#__PURE__*/ React__default['default'].createElement(
                Layer,
                _extends$b(
                  {
                    className: 'recharts-cartesian-axis-tick',
                    key: 'tick-'.concat(i), // eslint-disable-line react/no-array-index-key
                  },
                  adaptEventsOfChild(_this2.props, entry, i),
                ),
                tickLine &&
                  /*#__PURE__*/ React__default['default'].createElement(
                    'line',
                    _extends$b({}, tickLineProps, lineCoord, {
                      className: cx('recharts-cartesian-axis-tick-line', _get(tickLine, 'className')),
                    }),
                  ),
                tick &&
                  CartesianAxis.renderTickItem(
                    tick,
                    tickProps,
                    ''
                      .concat(_isFunction(tickFormatter) ? tickFormatter(entry.value, i) : entry.value)
                      .concat(unit || ''),
                  ),
              );
            });
            return /*#__PURE__*/ React__default['default'].createElement(
              'g',
              {
                className: 'recharts-cartesian-axis-ticks',
              },
              items,
            );
          },
      },
      {
        key: 'render',
        value: function render() {
          var _this3 = this;
          var _this$props7 = this.props,
            axisLine = _this$props7.axisLine,
            width = _this$props7.width,
            height = _this$props7.height,
            ticksGenerator = _this$props7.ticksGenerator,
            className = _this$props7.className,
            hide = _this$props7.hide;
          if (hide) {
            return null;
          }
          var _this$props8 = this.props,
            ticks = _this$props8.ticks,
            noTicksProps = _objectWithoutProperties$7(_this$props8, _excluded3$1);
          var finalTicks = ticks;
          if (_isFunction(ticksGenerator)) {
            finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
          }
          if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
            return null;
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: cx('recharts-cartesian-axis', className),
              ref: function ref(_ref2) {
                _this3.layerReference = _ref2;
              },
            },
            axisLine && this.renderAxisLine(),
            this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing),
            Label.renderCallByParent(this.props),
          );
        },
      },
    ],
    [
      {
        key: 'renderTickItem',
        value: function renderTickItem(option, props, value) {
          var tickItem;
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            tickItem = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          } else if (_isFunction(option)) {
            tickItem = option(props);
          } else {
            tickItem = /*#__PURE__*/ React__default['default'].createElement(
              Text,
              _extends$b({}, props, {
                className: 'recharts-cartesian-axis-tick-value',
              }),
              value,
            );
          }
          return tickItem;
        },
      },
    ],
  );
  return CartesianAxis;
})(React.Component);
_defineProperty$I(CartesianAxis, 'displayName', 'CartesianAxis');
_defineProperty$I(CartesianAxis, 'defaultProps', {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  },
  // The orientation of axis
  orientation: 'bottom',
  // The ticks
  ticks: [],
  stroke: '#666',
  tickLine: true,
  axisLine: true,
  tick: true,
  mirror: false,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: 'preserveEnd',
});

var _excluded$6 = ['x1', 'y1', 'x2', 'y2', 'key'];
function _typeof$K(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$K =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$K(obj)
  );
}
function _extends$a() {
  _extends$a = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$a.apply(this, arguments);
}
function _objectWithoutProperties$6(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$8(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$8(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys$9(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$9(Object(source), !0).forEach(function (key) {
          _defineProperty$H(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$9(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$F(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$F(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$9(descriptor.key), descriptor);
  }
}
function _createClass$F(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$F(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$F(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$E(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$G(subClass, superClass);
}
function _setPrototypeOf$G(o, p) {
  _setPrototypeOf$G = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$G(o, p);
}
function _createSuper$E(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$E();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$E(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$E(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$E(this, result);
  };
}
function _possibleConstructorReturn$E(self, call) {
  if (call && (_typeof$K(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$G(self);
}
function _assertThisInitialized$G(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$E() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$E(o) {
  _getPrototypeOf$E = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$E(o);
}
function _defineProperty$H(obj, key, value) {
  key = _toPropertyKey$9(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$9(arg) {
  var key = _toPrimitive$9(arg, 'string');
  return _typeof$K(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$9(input, hint) {
  if (_typeof$K(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$K(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var CartesianGrid = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$E(CartesianGrid, _PureComponent);
  var _super = _createSuper$E(CartesianGrid);
  function CartesianGrid() {
    _classCallCheck$F(this, CartesianGrid);
    return _super.apply(this, arguments);
  }
  _createClass$F(
    CartesianGrid,
    [
      {
        key: 'renderHorizontal',
        value:
          /**
           * Draw the horizontal grid lines
           * @param {Array} horizontalPoints either passed in as props or generated from function
           * @return {Group} Horizontal lines
           */
          function renderHorizontal(horizontalPoints) {
            var _this = this;
            var _this$props = this.props,
              x = _this$props.x,
              width = _this$props.width,
              horizontal = _this$props.horizontal;
            if (!horizontalPoints || !horizontalPoints.length) {
              return null;
            }
            var items = horizontalPoints.map(function (entry, i) {
              var props = _objectSpread$9(
                _objectSpread$9({}, _this.props),
                {},
                {
                  x1: x,
                  y1: entry,
                  x2: x + width,
                  y2: entry,
                  key: 'line-'.concat(i),
                  index: i,
                },
              );
              return CartesianGrid.renderLineItem(horizontal, props);
            });
            return /*#__PURE__*/ React__default['default'].createElement(
              'g',
              {
                className: 'recharts-cartesian-grid-horizontal',
              },
              items,
            );
          },

        /**
         * Draw vertical grid lines
         * @param {Array} verticalPoints either passed in as props or generated from function
         * @return {Group} Vertical lines
         */
      },
      {
        key: 'renderVertical',
        value: function renderVertical(verticalPoints) {
          var _this2 = this;
          var _this$props2 = this.props,
            y = _this$props2.y,
            height = _this$props2.height,
            vertical = _this$props2.vertical;
          if (!verticalPoints || !verticalPoints.length) {
            return null;
          }
          var items = verticalPoints.map(function (entry, i) {
            var props = _objectSpread$9(
              _objectSpread$9({}, _this2.props),
              {},
              {
                x1: entry,
                y1: y,
                x2: entry,
                y2: y + height,
                key: 'line-'.concat(i),
                index: i,
              },
            );
            return CartesianGrid.renderLineItem(vertical, props);
          });
          return /*#__PURE__*/ React__default['default'].createElement(
            'g',
            {
              className: 'recharts-cartesian-grid-vertical',
            },
            items,
          );
        },

        /**
         * Draw vertical grid stripes filled by colors
         * @param {Array} verticalPoints either passed in as props or generated from function
         * @return {Group} Vertical stripes
         */
      },
      {
        key: 'renderVerticalStripes',
        value: function renderVerticalStripes(verticalPoints) {
          var verticalFill = this.props.verticalFill;
          if (!verticalFill || !verticalFill.length) {
            return null;
          }
          var _this$props3 = this.props,
            fillOpacity = _this$props3.fillOpacity,
            x = _this$props3.x,
            y = _this$props3.y,
            width = _this$props3.width,
            height = _this$props3.height;
          var roundedSortedVerticalPoints = verticalPoints
            .map(function (e) {
              return Math.round(e + x - x);
            })
            .sort(function (a, b) {
              return a - b;
            });
          if (x !== roundedSortedVerticalPoints[0]) {
            roundedSortedVerticalPoints.unshift(0);
          }
          var items = roundedSortedVerticalPoints.map(function (entry, i) {
            var lastStripe = !roundedSortedVerticalPoints[i + 1];
            var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
            if (lineWidth <= 0) {
              return null;
            }
            var colorIndex = i % verticalFill.length;
            return /*#__PURE__*/ React__default['default'].createElement('rect', {
              key: 'react-'.concat(i), // eslint-disable-line react/no-array-index-key
              x: entry,
              y: y,
              width: lineWidth,
              height: height,
              stroke: 'none',
              fill: verticalFill[colorIndex],
              fillOpacity: fillOpacity,
              className: 'recharts-cartesian-grid-bg',
            });
          });
          return /*#__PURE__*/ React__default['default'].createElement(
            'g',
            {
              className: 'recharts-cartesian-gridstripes-vertical',
            },
            items,
          );
        },

        /**
         * Draw horizontal grid stripes filled by colors
         * @param {Array} horizontalPoints either passed in as props or generated from function
         * @return {Group} Horizontal stripes
         */
      },
      {
        key: 'renderHorizontalStripes',
        value: function renderHorizontalStripes(horizontalPoints) {
          var horizontalFill = this.props.horizontalFill;
          if (!horizontalFill || !horizontalFill.length) {
            return null;
          }
          var _this$props4 = this.props,
            fillOpacity = _this$props4.fillOpacity,
            x = _this$props4.x,
            y = _this$props4.y,
            width = _this$props4.width,
            height = _this$props4.height;
          var roundedSortedHorizontalPoints = horizontalPoints
            .map(function (e) {
              return Math.round(e + y - y);
            })
            .sort(function (a, b) {
              return a - b;
            });
          if (y !== roundedSortedHorizontalPoints[0]) {
            roundedSortedHorizontalPoints.unshift(0);
          }
          var items = roundedSortedHorizontalPoints.map(function (entry, i) {
            var lastStripe = !roundedSortedHorizontalPoints[i + 1];
            var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
            if (lineHeight <= 0) {
              return null;
            }
            var colorIndex = i % horizontalFill.length;
            return /*#__PURE__*/ React__default['default'].createElement('rect', {
              key: 'react-'.concat(i), // eslint-disable-line react/no-array-index-key
              y: entry,
              x: x,
              height: lineHeight,
              width: width,
              stroke: 'none',
              fill: horizontalFill[colorIndex],
              fillOpacity: fillOpacity,
              className: 'recharts-cartesian-grid-bg',
            });
          });
          return /*#__PURE__*/ React__default['default'].createElement(
            'g',
            {
              className: 'recharts-cartesian-gridstripes-horizontal',
            },
            items,
          );
        },
      },
      {
        key: 'renderBackground',
        value: function renderBackground() {
          var fill = this.props.fill;
          if (!fill || fill === 'none') {
            return null;
          }
          var _this$props5 = this.props,
            fillOpacity = _this$props5.fillOpacity,
            x = _this$props5.x,
            y = _this$props5.y,
            width = _this$props5.width,
            height = _this$props5.height;
          return /*#__PURE__*/ React__default['default'].createElement('rect', {
            x: x,
            y: y,
            width: width,
            height: height,
            stroke: 'none',
            fill: fill,
            fillOpacity: fillOpacity,
            className: 'recharts-cartesian-grid-bg',
          });
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props6 = this.props,
            x = _this$props6.x,
            y = _this$props6.y,
            width = _this$props6.width,
            height = _this$props6.height,
            horizontal = _this$props6.horizontal,
            vertical = _this$props6.vertical,
            horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator,
            verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator,
            xAxis = _this$props6.xAxis,
            yAxis = _this$props6.yAxis,
            offset = _this$props6.offset,
            chartWidth = _this$props6.chartWidth,
            chartHeight = _this$props6.chartHeight;
          if (
            !isNumber(width) ||
            width <= 0 ||
            !isNumber(height) ||
            height <= 0 ||
            !isNumber(x) ||
            x !== +x ||
            !isNumber(y) ||
            y !== +y
          ) {
            return null;
          }
          var _this$props7 = this.props,
            horizontalPoints = _this$props7.horizontalPoints,
            verticalPoints = _this$props7.verticalPoints;

          // No horizontal points are specified
          if ((!horizontalPoints || !horizontalPoints.length) && _isFunction(horizontalCoordinatesGenerator)) {
            horizontalPoints = horizontalCoordinatesGenerator({
              yAxis: yAxis,
              width: chartWidth,
              height: chartHeight,
              offset: offset,
            });
          }

          // No vertical points are specified
          if ((!verticalPoints || !verticalPoints.length) && _isFunction(verticalCoordinatesGenerator)) {
            verticalPoints = verticalCoordinatesGenerator({
              xAxis: xAxis,
              width: chartWidth,
              height: chartHeight,
              offset: offset,
            });
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            'g',
            {
              className: 'recharts-cartesian-grid',
            },
            this.renderBackground(),
            horizontal && this.renderHorizontal(horizontalPoints),
            vertical && this.renderVertical(verticalPoints),
            horizontal && this.renderHorizontalStripes(horizontalPoints),
            vertical && this.renderVerticalStripes(verticalPoints),
          );
        },
      },
    ],
    [
      {
        key: 'renderLineItem',
        value: function renderLineItem(option, props) {
          var lineItem;
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            lineItem = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          } else if (_isFunction(option)) {
            lineItem = option(props);
          } else {
            var x1 = props.x1,
              y1 = props.y1,
              x2 = props.x2,
              y2 = props.y2,
              key = props.key,
              others = _objectWithoutProperties$6(props, _excluded$6);
            lineItem = /*#__PURE__*/ React__default['default'].createElement(
              'line',
              _extends$a({}, filterProps(others), {
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                fill: 'none',
                key: key,
              }),
            );
          }
          return lineItem;
        },
      },
    ],
  );
  return CartesianGrid;
})(React.PureComponent);
_defineProperty$H(CartesianGrid, 'displayName', 'CartesianGrid');
_defineProperty$H(CartesianGrid, 'defaultProps', {
  horizontal: true,
  vertical: true,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: '#ccc',
  fill: 'none',
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: [],
});

var _excluded$5 = ['type', 'layout', 'connectNulls', 'ref'];
function _typeof$J(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$J =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$J(obj)
  );
}
function _objectWithoutProperties$5(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$7(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$7(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _extends$9() {
  _extends$9 = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$9.apply(this, arguments);
}
function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$8(Object(source), !0).forEach(function (key) {
          _defineProperty$G(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$8(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _toConsumableArray$4(arr) {
  return (
    _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$6(arr) || _nonIterableSpread$4()
  );
}
function _nonIterableSpread$4() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$6(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
}
function _iterableToArray$4(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$4(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$6(arr);
}
function _arrayLikeToArray$6(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _classCallCheck$E(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$E(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$8(descriptor.key), descriptor);
  }
}
function _createClass$E(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$E(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$E(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$D(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$F(subClass, superClass);
}
function _setPrototypeOf$F(o, p) {
  _setPrototypeOf$F = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$F(o, p);
}
function _createSuper$D(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$D();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$D(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$D(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$D(this, result);
  };
}
function _possibleConstructorReturn$D(self, call) {
  if (call && (_typeof$J(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$F(self);
}
function _assertThisInitialized$F(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$D() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$D(o) {
  _getPrototypeOf$D = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$D(o);
}
function _defineProperty$G(obj, key, value) {
  key = _toPropertyKey$8(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$8(arg) {
  var key = _toPrimitive$8(arg, 'string');
  return _typeof$J(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$8(input, hint) {
  if (_typeof$J(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$J(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var Line = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$D(Line, _PureComponent);
  var _super = _createSuper$D(Line);
  function Line() {
    var _this;
    _classCallCheck$E(this, Line);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$G(_assertThisInitialized$F(_this), 'state', {
      isAnimationFinished: true,
      totalLength: 0,
    });
    _defineProperty$G(_assertThisInitialized$F(_this), 'getStrokeDasharray', function (length, totalLength, lines) {
      var lineLength = lines.reduce(function (pre, next) {
        return pre + next;
      });
      var count = Math.floor(length / lineLength);
      var remainLength = length % lineLength;
      var restLength = totalLength - length;
      var remainLines = [];
      for (var i = 0, sum = 0; ; sum += lines[i], ++i) {
        if (sum + lines[i] > remainLength) {
          remainLines = [].concat(_toConsumableArray$4(lines.slice(0, i)), [remainLength - sum]);
          break;
        }
      }
      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
      return []
        .concat(_toConsumableArray$4(Line.repeat(lines, count)), _toConsumableArray$4(remainLines), emptyLines)
        .map(function (line) {
          return ''.concat(line, 'px');
        })
        .join(', ');
    });
    _defineProperty$G(_assertThisInitialized$F(_this), 'id', uniqueId('recharts-line-'));
    _defineProperty$G(_assertThisInitialized$F(_this), 'pathRef', function (node) {
      _this.mainCurve = node;
    });
    _defineProperty$G(_assertThisInitialized$F(_this), 'handleAnimationEnd', function () {
      _this.setState({
        isAnimationFinished: true,
      });
      if (_this.props.onAnimationEnd) {
        _this.props.onAnimationEnd();
      }
    });
    _defineProperty$G(_assertThisInitialized$F(_this), 'handleAnimationStart', function () {
      _this.setState({
        isAnimationFinished: false,
      });
      if (_this.props.onAnimationStart) {
        _this.props.onAnimationStart();
      }
    });
    return _this;
  }
  _createClass$E(
    Line,
    [
      {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (!this.props.isAnimationActive) {
            return;
          }
          var totalLength = this.getTotalLength();
          this.setState({
            totalLength: totalLength,
          });
        },
      },
      {
        key: 'getTotalLength',
        value: function getTotalLength() {
          var curveDom = this.mainCurve;
          try {
            return (curveDom && curveDom.getTotalLength && curveDom.getTotalLength()) || 0;
          } catch (err) {
            return 0;
          }
        },
      },
      {
        key: 'renderErrorBar',
        value: function renderErrorBar(needClip, clipPathId) {
          if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
            return null;
          }
          var _this$props = this.props,
            points = _this$props.points,
            xAxis = _this$props.xAxis,
            yAxis = _this$props.yAxis,
            layout = _this$props.layout,
            children = _this$props.children;
          var errorBarItems = findAllByType(children, ErrorBar);
          if (!errorBarItems) {
            return null;
          }
          function dataPointFormatter(dataPoint, dataKey) {
            return {
              x: dataPoint.x,
              y: dataPoint.y,
              value: dataPoint.value,
              errorVal: getValueByDataKey(dataPoint.payload, dataKey),
            };
          }
          var errorBarProps = {
            clipPath: needClip ? 'url(#clipPath-'.concat(clipPathId, ')') : null,
          };
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            errorBarProps,
            errorBarItems.map(function (item, i) {
              return /*#__PURE__*/ React__default['default'].cloneElement(item, {
                // eslint-disable-next-line react/no-array-index-key
                key: 'bar-'.concat(i),
                data: points,
                xAxis: xAxis,
                yAxis: yAxis,
                layout: layout,
                dataPointFormatter: dataPointFormatter,
              });
            }),
          );
        },
      },
      {
        key: 'renderDots',
        value: function renderDots(needClip, clipPathId) {
          var isAnimationActive = this.props.isAnimationActive;
          if (isAnimationActive && !this.state.isAnimationFinished) {
            return null;
          }
          var _this$props2 = this.props,
            dot = _this$props2.dot,
            points = _this$props2.points,
            dataKey = _this$props2.dataKey;
          var lineProps = filterProps(this.props);
          var customDotProps = filterProps(dot, true);
          var dots = points.map(function (entry, i) {
            var dotProps = _objectSpread$8(
              _objectSpread$8(
                _objectSpread$8(
                  {
                    key: 'dot-'.concat(i),
                    r: 3,
                  },
                  lineProps,
                ),
                customDotProps,
              ),
              {},
              {
                value: entry.value,
                dataKey: dataKey,
                cx: entry.x,
                cy: entry.y,
                index: i,
                payload: entry.payload,
              },
            );
            return Line.renderDotItem(dot, dotProps);
          });
          var dotsProps = {
            clipPath: needClip ? 'url(#clipPath-'.concat(clipPathId, ')') : null,
          };
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            _extends$9(
              {
                className: 'recharts-line-dots',
                key: 'dots',
              },
              dotsProps,
              {
                role: 'img',
              },
            ),
            dots,
          );
        },
      },
      {
        key: 'renderCurveStatically',
        value: function renderCurveStatically(points, needClip, clipPathId, props) {
          var _this$props3 = this.props,
            type = _this$props3.type,
            layout = _this$props3.layout,
            connectNulls = _this$props3.connectNulls;
          _this$props3.ref;
          var others = _objectWithoutProperties$5(_this$props3, _excluded$5);
          var curveProps = _objectSpread$8(
            _objectSpread$8(
              _objectSpread$8({}, filterProps(others, true)),
              {},
              {
                fill: 'none',
                className: 'recharts-line-curve',
                clipPath: needClip ? 'url(#clipPath-'.concat(clipPathId, ')') : null,
                points: points,
              },
              props,
            ),
            {},
            {
              type: type,
              layout: layout,
              connectNulls: connectNulls,
            },
          );
          return /*#__PURE__*/ React__default['default'].createElement(
            Curve,
            _extends$9({}, curveProps, {
              pathRef: this.pathRef,
            }),
          );
        },
      },
      {
        key: 'renderCurveWithAnimation',
        value: function renderCurveWithAnimation(needClip, clipPathId) {
          var _this2 = this;
          var _this$props4 = this.props,
            points = _this$props4.points,
            strokeDasharray = _this$props4.strokeDasharray,
            isAnimationActive = _this$props4.isAnimationActive,
            animationBegin = _this$props4.animationBegin,
            animationDuration = _this$props4.animationDuration,
            animationEasing = _this$props4.animationEasing,
            animationId = _this$props4.animationId,
            animateNewValues = _this$props4.animateNewValues,
            width = _this$props4.width,
            height = _this$props4.height;
          var _this$state = this.state,
            prevPoints = _this$state.prevPoints,
            totalLength = _this$state.totalLength;
          return /*#__PURE__*/ React__default['default'].createElement(
            Animate,
            {
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing,
              from: {
                t: 0,
              },
              to: {
                t: 1,
              },
              key: 'line-'.concat(animationId),
              onAnimationEnd: this.handleAnimationEnd,
              onAnimationStart: this.handleAnimationStart,
            },
            function (_ref) {
              var t = _ref.t;
              if (prevPoints) {
                var prevPointsDiffFactor = prevPoints.length / points.length;
                var stepData = points.map(function (entry, index) {
                  var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                  if (prevPoints[prevPointIndex]) {
                    var prev = prevPoints[prevPointIndex];
                    var interpolatorX = interpolateNumber$2(prev.x, entry.x);
                    var interpolatorY = interpolateNumber$2(prev.y, entry.y);
                    return _objectSpread$8(
                      _objectSpread$8({}, entry),
                      {},
                      {
                        x: interpolatorX(t),
                        y: interpolatorY(t),
                      },
                    );
                  }

                  // magic number of faking previous x and y location
                  if (animateNewValues) {
                    var _interpolatorX = interpolateNumber$2(width * 2, entry.x);
                    var _interpolatorY = interpolateNumber$2(height / 2, entry.y);
                    return _objectSpread$8(
                      _objectSpread$8({}, entry),
                      {},
                      {
                        x: _interpolatorX(t),
                        y: _interpolatorY(t),
                      },
                    );
                  }
                  return _objectSpread$8(
                    _objectSpread$8({}, entry),
                    {},
                    {
                      x: entry.x,
                      y: entry.y,
                    },
                  );
                });
                return _this2.renderCurveStatically(stepData, needClip, clipPathId);
              }
              var interpolator = interpolateNumber$2(0, totalLength);
              var curLength = interpolator(t);
              var currentStrokeDasharray;
              if (strokeDasharray) {
                var lines = ''
                  .concat(strokeDasharray)
                  .split(/[,\s]+/gim)
                  .map(function (num) {
                    return parseFloat(num);
                  });
                currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
              } else {
                currentStrokeDasharray = ''.concat(curLength, 'px ').concat(totalLength - curLength, 'px');
              }
              return _this2.renderCurveStatically(points, needClip, clipPathId, {
                strokeDasharray: currentStrokeDasharray,
              });
            },
          );
        },
      },
      {
        key: 'renderCurve',
        value: function renderCurve(needClip, clipPathId) {
          var _this$props5 = this.props,
            points = _this$props5.points,
            isAnimationActive = _this$props5.isAnimationActive;
          var _this$state2 = this.state,
            prevPoints = _this$state2.prevPoints,
            totalLength = _this$state2.totalLength;
          if (
            isAnimationActive &&
            points &&
            points.length &&
            ((!prevPoints && totalLength > 0) || !_isEqual(prevPoints, points))
          ) {
            return this.renderCurveWithAnimation(needClip, clipPathId);
          }
          return this.renderCurveStatically(points, needClip, clipPathId);
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props6 = this.props,
            hide = _this$props6.hide,
            dot = _this$props6.dot,
            points = _this$props6.points,
            className = _this$props6.className,
            xAxis = _this$props6.xAxis,
            yAxis = _this$props6.yAxis,
            top = _this$props6.top,
            left = _this$props6.left,
            width = _this$props6.width,
            height = _this$props6.height,
            isAnimationActive = _this$props6.isAnimationActive,
            id = _this$props6.id;
          if (hide || !points || !points.length) {
            return null;
          }
          var isAnimationFinished = this.state.isAnimationFinished;
          var hasSinglePoint = points.length === 1;
          var layerClass = cx('recharts-line', className);
          var needClip = (xAxis && xAxis.allowDataOverflow) || (yAxis && yAxis.allowDataOverflow);
          var clipPathId = _isNil(id) ? this.id : id;
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: layerClass,
            },
            needClip
              ? /*#__PURE__*/ React__default['default'].createElement(
                  'defs',
                  null,
                  /*#__PURE__*/ React__default['default'].createElement(
                    'clipPath',
                    {
                      id: 'clipPath-'.concat(clipPathId),
                    },
                    /*#__PURE__*/ React__default['default'].createElement('rect', {
                      x: left,
                      y: top,
                      width: width,
                      height: height,
                    }),
                  ),
                )
              : null,
            !hasSinglePoint && this.renderCurve(needClip, clipPathId),
            this.renderErrorBar(needClip, clipPathId),
            (hasSinglePoint || dot) && this.renderDots(needClip, clipPathId),
            (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, points),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (nextProps.animationId !== prevState.prevAnimationId) {
            return {
              prevAnimationId: nextProps.animationId,
              curPoints: nextProps.points,
              prevPoints: prevState.curPoints,
            };
          }
          if (nextProps.points !== prevState.curPoints) {
            return {
              curPoints: nextProps.points,
            };
          }
          return null;
        },
      },
      {
        key: 'repeat',
        value: function repeat(lines, count) {
          var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray$4(lines), [0]) : lines;
          var result = [];
          for (var i = 0; i < count; ++i) {
            result = [].concat(_toConsumableArray$4(result), _toConsumableArray$4(linesUnit));
          }
          return result;
        },
      },
      {
        key: 'renderDotItem',
        value: function renderDotItem(option, props) {
          var dotItem;
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            dotItem = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          } else if (_isFunction(option)) {
            dotItem = option(props);
          } else {
            var className = cx('recharts-line-dot', option ? option.className : '');
            dotItem = /*#__PURE__*/ React__default['default'].createElement(
              Dot,
              _extends$9({}, props, {
                className: className,
              }),
            );
          }
          return dotItem;
        },
      },
    ],
  );
  return Line;
})(React.PureComponent);
_defineProperty$G(Line, 'displayName', 'Line');
_defineProperty$G(Line, 'defaultProps', {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: false,
  activeDot: true,
  dot: true,
  legendType: 'line',
  stroke: '#3182bd',
  strokeWidth: 1,
  fill: '#fff',
  points: [],
  isAnimationActive: !Global.isSsr,
  animateNewValues: true,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  hide: false,
  label: false,
});
_defineProperty$G(Line, 'getComposedData', function (_ref2) {
  var props = _ref2.props,
    xAxis = _ref2.xAxis,
    yAxis = _ref2.yAxis,
    xAxisTicks = _ref2.xAxisTicks,
    yAxisTicks = _ref2.yAxisTicks,
    dataKey = _ref2.dataKey,
    bandSize = _ref2.bandSize,
    displayedData = _ref2.displayedData,
    offset = _ref2.offset;
  var layout = props.layout;
  var points = displayedData.map(function (entry, index) {
    var value = getValueByDataKey(entry, dataKey);
    if (layout === 'horizontal') {
      return {
        x: getCateCoordinateOfLine({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize: bandSize,
          entry: entry,
          index: index,
        }),
        y: _isNil(value) ? null : yAxis.scale(value),
        value: value,
        payload: entry,
      };
    }
    return {
      x: _isNil(value) ? null : xAxis.scale(value),
      y: getCateCoordinateOfLine({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        entry: entry,
        index: index,
      }),
      value: value,
      payload: entry,
    };
  });
  return _objectSpread$8(
    {
      points: points,
      layout: layout,
    },
    offset,
  );
});

var _excluded$4 = ['layout', 'type', 'stroke', 'connectNulls', 'isRange', 'ref'];
function _typeof$I(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$I =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$I(obj)
  );
}
function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$6(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _extends$8() {
  _extends$8 = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$8.apply(this, arguments);
}
function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$7(Object(source), !0).forEach(function (key) {
          _defineProperty$F(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$7(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$D(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$D(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$7(descriptor.key), descriptor);
  }
}
function _createClass$D(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$D(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$D(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$C(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$E(subClass, superClass);
}
function _setPrototypeOf$E(o, p) {
  _setPrototypeOf$E = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$E(o, p);
}
function _createSuper$C(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$C();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$C(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$C(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$C(this, result);
  };
}
function _possibleConstructorReturn$C(self, call) {
  if (call && (_typeof$I(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$E(self);
}
function _assertThisInitialized$E(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$C() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$C(o) {
  _getPrototypeOf$C = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$C(o);
}
function _defineProperty$F(obj, key, value) {
  key = _toPropertyKey$7(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$7(arg) {
  var key = _toPrimitive$7(arg, 'string');
  return _typeof$I(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$7(input, hint) {
  if (_typeof$I(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$I(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var Area = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$C(Area, _PureComponent);
  var _super = _createSuper$C(Area);
  function Area() {
    var _this;
    _classCallCheck$D(this, Area);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$F(_assertThisInitialized$E(_this), 'state', {
      isAnimationFinished: true,
    });
    _defineProperty$F(_assertThisInitialized$E(_this), 'id', uniqueId('recharts-area-'));
    _defineProperty$F(_assertThisInitialized$E(_this), 'handleAnimationEnd', function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true,
      });
      if (_isFunction(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$F(_assertThisInitialized$E(_this), 'handleAnimationStart', function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false,
      });
      if (_isFunction(onAnimationStart)) {
        onAnimationStart();
      }
    });
    return _this;
  }
  _createClass$D(
    Area,
    [
      {
        key: 'renderDots',
        value: function renderDots(needClip, clipPathId) {
          var isAnimationActive = this.props.isAnimationActive;
          var isAnimationFinished = this.state.isAnimationFinished;
          if (isAnimationActive && !isAnimationFinished) {
            return null;
          }
          var _this$props = this.props,
            dot = _this$props.dot,
            points = _this$props.points,
            dataKey = _this$props.dataKey;
          var areaProps = filterProps(this.props);
          var customDotProps = filterProps(dot, true);
          var dots = points.map(function (entry, i) {
            var dotProps = _objectSpread$7(
              _objectSpread$7(
                _objectSpread$7(
                  {
                    key: 'dot-'.concat(i),
                    r: 3,
                  },
                  areaProps,
                ),
                customDotProps,
              ),
              {},
              {
                dataKey: dataKey,
                cx: entry.x,
                cy: entry.y,
                index: i,
                value: entry.value,
                payload: entry.payload,
              },
            );
            return Area.renderDotItem(dot, dotProps);
          });
          var dotsProps = {
            clipPath: needClip ? 'url(#clipPath-'.concat(clipPathId, ')') : null,
          };
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            _extends$8(
              {
                className: 'recharts-area-dots',
              },
              dotsProps,
            ),
            dots,
          );
        },
      },
      {
        key: 'renderHorizontalRect',
        value: function renderHorizontalRect(alpha) {
          var _this$props2 = this.props,
            baseLine = _this$props2.baseLine,
            points = _this$props2.points,
            strokeWidth = _this$props2.strokeWidth;
          var startX = points[0].x;
          var endX = points[points.length - 1].x;
          var width = alpha * Math.abs(startX - endX);
          var maxY = _max(
            points.map(function (entry) {
              return entry.y || 0;
            }),
          );
          if (isNumber(baseLine) && typeof baseLine === 'number') {
            maxY = Math.max(baseLine, maxY);
          } else if (baseLine && _isArray(baseLine) && baseLine.length) {
            maxY = Math.max(
              _max(
                baseLine.map(function (entry) {
                  return entry.y || 0;
                }),
              ),
              maxY,
            );
          }
          if (isNumber(maxY)) {
            return /*#__PURE__*/ React__default['default'].createElement('rect', {
              x: startX < endX ? startX : startX - width,
              y: 0,
              width: width,
              height: Math.floor(maxY + (strokeWidth ? parseInt(''.concat(strokeWidth), 10) : 1)),
            });
          }
          return null;
        },
      },
      {
        key: 'renderVerticalRect',
        value: function renderVerticalRect(alpha) {
          var _this$props3 = this.props,
            baseLine = _this$props3.baseLine,
            points = _this$props3.points,
            strokeWidth = _this$props3.strokeWidth;
          var startY = points[0].y;
          var endY = points[points.length - 1].y;
          var height = alpha * Math.abs(startY - endY);
          var maxX = _max(
            points.map(function (entry) {
              return entry.x || 0;
            }),
          );
          if (isNumber(baseLine) && typeof baseLine === 'number') {
            maxX = Math.max(baseLine, maxX);
          } else if (baseLine && _isArray(baseLine) && baseLine.length) {
            maxX = Math.max(
              _max(
                baseLine.map(function (entry) {
                  return entry.x || 0;
                }),
              ),
              maxX,
            );
          }
          if (isNumber(maxX)) {
            return /*#__PURE__*/ React__default['default'].createElement('rect', {
              x: 0,
              y: startY < endY ? startY : startY - height,
              width: maxX + (strokeWidth ? parseInt(''.concat(strokeWidth), 10) : 1),
              height: Math.floor(height),
            });
          }
          return null;
        },
      },
      {
        key: 'renderClipRect',
        value: function renderClipRect(alpha) {
          var layout = this.props.layout;
          if (layout === 'vertical') {
            return this.renderVerticalRect(alpha);
          }
          return this.renderHorizontalRect(alpha);
        },
      },
      {
        key: 'renderAreaStatically',
        value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
          var _this$props4 = this.props,
            layout = _this$props4.layout,
            type = _this$props4.type,
            stroke = _this$props4.stroke,
            connectNulls = _this$props4.connectNulls,
            isRange = _this$props4.isRange;
          _this$props4.ref;
          var others = _objectWithoutProperties$4(_this$props4, _excluded$4);
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              clipPath: needClip ? 'url(#clipPath-'.concat(clipPathId, ')') : null,
            },
            /*#__PURE__*/ React__default['default'].createElement(
              Curve,
              _extends$8({}, filterProps(others, true), {
                points: points,
                connectNulls: connectNulls,
                type: type,
                baseLine: baseLine,
                layout: layout,
                stroke: 'none',
                className: 'recharts-area-area',
              }),
            ),
            stroke !== 'none' &&
              /*#__PURE__*/ React__default['default'].createElement(
                Curve,
                _extends$8({}, filterProps(this.props), {
                  className: 'recharts-area-curve',
                  layout: layout,
                  type: type,
                  connectNulls: connectNulls,
                  fill: 'none',
                  points: points,
                }),
              ),
            stroke !== 'none' &&
              isRange &&
              /*#__PURE__*/ React__default['default'].createElement(
                Curve,
                _extends$8({}, filterProps(this.props), {
                  className: 'recharts-area-curve',
                  layout: layout,
                  type: type,
                  connectNulls: connectNulls,
                  fill: 'none',
                  points: baseLine,
                }),
              ),
          );
        },
      },
      {
        key: 'renderAreaWithAnimation',
        value: function renderAreaWithAnimation(needClip, clipPathId) {
          var _this2 = this;
          var _this$props5 = this.props,
            points = _this$props5.points,
            baseLine = _this$props5.baseLine,
            isAnimationActive = _this$props5.isAnimationActive,
            animationBegin = _this$props5.animationBegin,
            animationDuration = _this$props5.animationDuration,
            animationEasing = _this$props5.animationEasing,
            animationId = _this$props5.animationId;
          var _this$state = this.state,
            prevPoints = _this$state.prevPoints,
            prevBaseLine = _this$state.prevBaseLine;
          // const clipPathId = _.isNil(id) ? this.id : id;

          return /*#__PURE__*/ React__default['default'].createElement(
            Animate,
            {
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing,
              from: {
                t: 0,
              },
              to: {
                t: 1,
              },
              key: 'area-'.concat(animationId),
              onAnimationEnd: this.handleAnimationEnd,
              onAnimationStart: this.handleAnimationStart,
            },
            function (_ref) {
              var t = _ref.t;
              if (prevPoints) {
                var prevPointsDiffFactor = prevPoints.length / points.length;
                // update animtaion
                var stepPoints = points.map(function (entry, index) {
                  var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                  if (prevPoints[prevPointIndex]) {
                    var prev = prevPoints[prevPointIndex];
                    var interpolatorX = interpolateNumber$2(prev.x, entry.x);
                    var interpolatorY = interpolateNumber$2(prev.y, entry.y);
                    return _objectSpread$7(
                      _objectSpread$7({}, entry),
                      {},
                      {
                        x: interpolatorX(t),
                        y: interpolatorY(t),
                      },
                    );
                  }
                  return entry;
                });
                var stepBaseLine;
                if (isNumber(baseLine) && typeof baseLine === 'number') {
                  var interpolator = interpolateNumber$2(prevBaseLine, baseLine);
                  stepBaseLine = interpolator(t);
                } else if (_isNil(baseLine) || _isNaN$1(baseLine)) {
                  var _interpolator = interpolateNumber$2(prevBaseLine, 0);
                  stepBaseLine = _interpolator(t);
                } else {
                  stepBaseLine = baseLine.map(function (entry, index) {
                    var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                    if (prevBaseLine[prevPointIndex]) {
                      var prev = prevBaseLine[prevPointIndex];
                      var interpolatorX = interpolateNumber$2(prev.x, entry.x);
                      var interpolatorY = interpolateNumber$2(prev.y, entry.y);
                      return _objectSpread$7(
                        _objectSpread$7({}, entry),
                        {},
                        {
                          x: interpolatorX(t),
                          y: interpolatorY(t),
                        },
                      );
                    }
                    return entry;
                  });
                }
                return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
              }
              return /*#__PURE__*/ React__default['default'].createElement(
                Layer,
                null,
                /*#__PURE__*/ React__default['default'].createElement(
                  'defs',
                  null,
                  /*#__PURE__*/ React__default['default'].createElement(
                    'clipPath',
                    {
                      id: 'animationClipPath-'.concat(clipPathId),
                    },
                    _this2.renderClipRect(t),
                  ),
                ),
                /*#__PURE__*/ React__default['default'].createElement(
                  Layer,
                  {
                    clipPath: 'url(#animationClipPath-'.concat(clipPathId, ')'),
                  },
                  _this2.renderAreaStatically(points, baseLine, needClip, clipPathId),
                ),
              );
            },
          );
        },
      },
      {
        key: 'renderArea',
        value: function renderArea(needClip, clipPathId) {
          var _this$props6 = this.props,
            points = _this$props6.points,
            baseLine = _this$props6.baseLine,
            isAnimationActive = _this$props6.isAnimationActive;
          var _this$state2 = this.state,
            prevPoints = _this$state2.prevPoints,
            prevBaseLine = _this$state2.prevBaseLine,
            totalLength = _this$state2.totalLength;
          if (
            isAnimationActive &&
            points &&
            points.length &&
            ((!prevPoints && totalLength > 0) || !_isEqual(prevPoints, points) || !_isEqual(prevBaseLine, baseLine))
          ) {
            return this.renderAreaWithAnimation(needClip, clipPathId);
          }
          return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props7 = this.props,
            hide = _this$props7.hide,
            dot = _this$props7.dot,
            points = _this$props7.points,
            className = _this$props7.className,
            top = _this$props7.top,
            left = _this$props7.left,
            xAxis = _this$props7.xAxis,
            yAxis = _this$props7.yAxis,
            width = _this$props7.width,
            height = _this$props7.height,
            isAnimationActive = _this$props7.isAnimationActive,
            id = _this$props7.id;
          if (hide || !points || !points.length) {
            return null;
          }
          var isAnimationFinished = this.state.isAnimationFinished;
          var hasSinglePoint = points.length === 1;
          var layerClass = cx('recharts-area', className);
          var needClip = (xAxis && xAxis.allowDataOverflow) || (yAxis && yAxis.allowDataOverflow);
          var clipPathId = _isNil(id) ? this.id : id;
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: layerClass,
            },
            needClip
              ? /*#__PURE__*/ React__default['default'].createElement(
                  'defs',
                  null,
                  /*#__PURE__*/ React__default['default'].createElement(
                    'clipPath',
                    {
                      id: 'clipPath-'.concat(clipPathId),
                    },
                    /*#__PURE__*/ React__default['default'].createElement('rect', {
                      x: left,
                      y: top,
                      width: width,
                      height: Math.floor(height),
                    }),
                  ),
                )
              : null,
            !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null,
            (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId),
            (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, points),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (nextProps.animationId !== prevState.prevAnimationId) {
            return {
              prevAnimationId: nextProps.animationId,
              curPoints: nextProps.points,
              curBaseLine: nextProps.baseLine,
              prevPoints: prevState.curPoints,
              prevBaseLine: prevState.curBaseLine,
            };
          }
          if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) {
            return {
              curPoints: nextProps.points,
              curBaseLine: nextProps.baseLine,
            };
          }
          return null;
        },
      },
    ],
  );
  return Area;
})(React.PureComponent);
_defineProperty$F(Area, 'displayName', 'Area');
_defineProperty$F(Area, 'defaultProps', {
  stroke: '#3182bd',
  fill: '#3182bd',
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'line',
  connectNulls: false,
  // points of area
  points: [],
  dot: false,
  activeDot: true,
  hide: false,
  isAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
});
_defineProperty$F(Area, 'getBaseValue', function (props, item, xAxis, yAxis) {
  var layout = props.layout,
    chartBaseValue = props.baseValue;
  var itemBaseValue = item.props.baseValue;

  // The baseValue can be defined both on the AreaChart as well as on the Area.
  // The value for the item takes precedence.
  var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
  if (isNumber(baseValue) && typeof baseValue === 'number') {
    return baseValue;
  }
  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var domain = numericAxis.scale.domain();
  if (numericAxis.type === 'number') {
    var max = Math.max(domain[0], domain[1]);
    var min = Math.min(domain[0], domain[1]);
    if (baseValue === 'dataMin') {
      return min;
    }
    if (baseValue === 'dataMax') {
      return max;
    }
    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
  }
  if (baseValue === 'dataMin') {
    return domain[0];
  }
  if (baseValue === 'dataMax') {
    return domain[1];
  }
  return domain[0];
});
_defineProperty$F(Area, 'getComposedData', function (_ref2) {
  var props = _ref2.props,
    item = _ref2.item,
    xAxis = _ref2.xAxis,
    yAxis = _ref2.yAxis,
    xAxisTicks = _ref2.xAxisTicks,
    yAxisTicks = _ref2.yAxisTicks,
    bandSize = _ref2.bandSize,
    dataKey = _ref2.dataKey,
    stackedData = _ref2.stackedData,
    dataStartIndex = _ref2.dataStartIndex,
    displayedData = _ref2.displayedData,
    offset = _ref2.offset;
  var layout = props.layout;
  var hasStack = stackedData && stackedData.length;
  var baseValue = Area.getBaseValue(props, item, xAxis, yAxis);
  var isRange = false;
  var points = displayedData.map(function (entry, index) {
    var originalValue = getValueByDataKey(entry, dataKey);
    var value;
    if (hasStack) {
      value = stackedData[dataStartIndex + index];
    } else {
      value = originalValue;
      if (!_isArray(value)) {
        value = [baseValue, value];
      } else {
        isRange = true;
      }
    }
    var isBreakPoint = _isNil(value[1]) || (hasStack && _isNil(originalValue));
    if (layout === 'horizontal') {
      return {
        x: getCateCoordinateOfLine({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize: bandSize,
          entry: entry,
          index: index,
        }),
        y: isBreakPoint ? null : yAxis.scale(value[1]),
        value: value,
        payload: entry,
      };
    }
    return {
      x: isBreakPoint ? null : xAxis.scale(value[1]),
      y: getCateCoordinateOfLine({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        entry: entry,
        index: index,
      }),
      value: value,
      payload: entry,
    };
  });
  var baseLine;
  if (hasStack || isRange) {
    baseLine = points.map(function (entry) {
      if (layout === 'horizontal') {
        return {
          x: entry.x,
          y:
            !_isNil(_get(entry, 'value[0]')) && !_isNil(_get(entry, 'y')) ? yAxis.scale(_get(entry, 'value[0]')) : null,
        };
      }
      return {
        x: !_isNil(_get(entry, 'value[0]')) ? xAxis.scale(_get(entry, 'value[0]')) : null,
        y: entry.y,
      };
    });
  } else if (layout === 'horizontal') {
    baseLine = yAxis.scale(baseValue);
  } else {
    baseLine = xAxis.scale(baseValue);
  }
  return _objectSpread$7(
    {
      points: points,
      baseLine: baseLine,
      layout: layout,
      isRange: isRange,
    },
    offset,
  );
});
_defineProperty$F(Area, 'renderDotItem', function (option, props) {
  var dotItem;
  if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
    dotItem = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
  } else if (_isFunction(option)) {
    dotItem = option(props);
  } else {
    dotItem = /*#__PURE__*/ React__default['default'].createElement(
      Dot,
      _extends$8({}, props, {
        className: 'recharts-area-dot',
      }),
    );
  }
  return dotItem;
});

/**
 * @fileOverview Z Axis
 */

var ZAxis = function ZAxis() {
  return null;
};
ZAxis.displayName = 'ZAxis';
ZAxis.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto',
  type: 'number',
};

function _typeof$H(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$H =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$H(obj)
  );
}
function _extends$7() {
  _extends$7 = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$7.apply(this, arguments);
}
function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$6(Object(source), !0).forEach(function (key) {
          _defineProperty$E(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$6(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$C(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$C(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$6(descriptor.key), descriptor);
  }
}
function _createClass$C(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$C(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$C(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$B(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$D(subClass, superClass);
}
function _setPrototypeOf$D(o, p) {
  _setPrototypeOf$D = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$D(o, p);
}
function _createSuper$B(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$B();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$B(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$B(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$B(this, result);
  };
}
function _possibleConstructorReturn$B(self, call) {
  if (call && (_typeof$H(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$D(self);
}
function _assertThisInitialized$D(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$B() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$B(o) {
  _getPrototypeOf$B = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$B(o);
}
function _defineProperty$E(obj, key, value) {
  key = _toPropertyKey$6(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$6(arg) {
  var key = _toPrimitive$6(arg, 'string');
  return _typeof$H(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$6(input, hint) {
  if (_typeof$H(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$H(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var Scatter = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$B(Scatter, _PureComponent);
  var _super = _createSuper$B(Scatter);
  function Scatter() {
    var _this;
    _classCallCheck$C(this, Scatter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$E(_assertThisInitialized$D(_this), 'state', {
      isAnimationFinished: false,
    });
    _defineProperty$E(_assertThisInitialized$D(_this), 'handleAnimationEnd', function () {
      _this.setState({
        isAnimationFinished: true,
      });
    });
    _defineProperty$E(_assertThisInitialized$D(_this), 'handleAnimationStart', function () {
      _this.setState({
        isAnimationFinished: false,
      });
    });
    _defineProperty$E(_assertThisInitialized$D(_this), 'id', uniqueId('recharts-scatter-'));
    return _this;
  }
  _createClass$C(
    Scatter,
    [
      {
        key: 'renderSymbolsStatically',
        value: function renderSymbolsStatically(points) {
          var _this2 = this;
          var _this$props = this.props,
            shape = _this$props.shape,
            activeShape = _this$props.activeShape,
            activeIndex = _this$props.activeIndex;
          var baseProps = filterProps(this.props);
          return points.map(function (entry, i) {
            var props = _objectSpread$6(
              _objectSpread$6(
                {
                  key: 'symbol-'.concat(i),
                },
                baseProps,
              ),
              entry,
            );
            return /*#__PURE__*/ React__default['default'].createElement(
              Layer,
              _extends$7(
                {
                  className: 'recharts-scatter-symbol',
                },
                adaptEventsOfChild(_this2.props, entry, i),
                {
                  key: 'symbol-'.concat(i), // eslint-disable-line react/no-array-index-key
                  role: 'img',
                },
              ),
              Scatter.renderSymbolItem(activeIndex === i ? activeShape : shape, props),
            );
          });
        },
      },
      {
        key: 'renderSymbolsWithAnimation',
        value: function renderSymbolsWithAnimation() {
          var _this3 = this;
          var _this$props2 = this.props,
            points = _this$props2.points,
            isAnimationActive = _this$props2.isAnimationActive,
            animationBegin = _this$props2.animationBegin,
            animationDuration = _this$props2.animationDuration,
            animationEasing = _this$props2.animationEasing,
            animationId = _this$props2.animationId;
          var prevPoints = this.state.prevPoints;
          return /*#__PURE__*/ React__default['default'].createElement(
            Animate,
            {
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing,
              from: {
                t: 0,
              },
              to: {
                t: 1,
              },
              key: 'pie-'.concat(animationId),
              onAnimationEnd: this.handleAnimationEnd,
              onAnimationStart: this.handleAnimationStart,
            },
            function (_ref) {
              var t = _ref.t;
              var stepData = points.map(function (entry, index) {
                var prev = prevPoints && prevPoints[index];
                if (prev) {
                  var interpolatorCx = interpolateNumber$2(prev.cx, entry.cx);
                  var interpolatorCy = interpolateNumber$2(prev.cy, entry.cy);
                  var interpolatorSize = interpolateNumber$2(prev.size, entry.size);
                  return _objectSpread$6(
                    _objectSpread$6({}, entry),
                    {},
                    {
                      cx: interpolatorCx(t),
                      cy: interpolatorCy(t),
                      size: interpolatorSize(t),
                    },
                  );
                }
                var interpolator = interpolateNumber$2(0, entry.size);
                return _objectSpread$6(
                  _objectSpread$6({}, entry),
                  {},
                  {
                    size: interpolator(t),
                  },
                );
              });
              return /*#__PURE__*/ React__default['default'].createElement(
                Layer,
                null,
                _this3.renderSymbolsStatically(stepData),
              );
            },
          );
        },
      },
      {
        key: 'renderSymbols',
        value: function renderSymbols() {
          var _this$props3 = this.props,
            points = _this$props3.points,
            isAnimationActive = _this$props3.isAnimationActive;
          var prevPoints = this.state.prevPoints;
          if (isAnimationActive && points && points.length && (!prevPoints || !_isEqual(prevPoints, points))) {
            return this.renderSymbolsWithAnimation();
          }
          return this.renderSymbolsStatically(points);
        },
      },
      {
        key: 'renderErrorBar',
        value: function renderErrorBar() {
          var isAnimationActive = this.props.isAnimationActive;
          if (isAnimationActive && !this.state.isAnimationFinished) {
            return null;
          }
          var _this$props4 = this.props,
            points = _this$props4.points,
            xAxis = _this$props4.xAxis,
            yAxis = _this$props4.yAxis,
            children = _this$props4.children;
          var errorBarItems = findAllByType(children, ErrorBar);
          if (!errorBarItems) {
            return null;
          }
          function dataPointFormatterY(dataPoint, dataKey) {
            return {
              x: dataPoint.cx,
              y: dataPoint.cy,
              value: +dataPoint.node.y,
              errorVal: getValueByDataKey(dataPoint, dataKey),
            };
          }
          function dataPointFormatterX(dataPoint, dataKey) {
            return {
              x: dataPoint.cx,
              y: dataPoint.cy,
              value: +dataPoint.node.x,
              errorVal: getValueByDataKey(dataPoint, dataKey),
            };
          }
          return errorBarItems.map(function (item, i) {
            var direction = item.props.direction;
            return /*#__PURE__*/ React__default['default'].cloneElement(item, {
              key: i,
              // eslint-disable-line react/no-array-index-key
              data: points,
              xAxis: xAxis,
              yAxis: yAxis,
              layout: direction === 'x' ? 'vertical' : 'horizontal',
              dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY,
            });
          });
        },
      },
      {
        key: 'renderLine',
        value: function renderLine() {
          var _this$props5 = this.props,
            points = _this$props5.points,
            line = _this$props5.line,
            lineType = _this$props5.lineType,
            lineJointType = _this$props5.lineJointType;
          var scatterProps = filterProps(this.props);
          var customLineProps = filterProps(line);
          var linePoints, lineItem;
          if (lineType === 'joint') {
            linePoints = points.map(function (entry) {
              return {
                x: entry.cx,
                y: entry.cy,
              };
            });
          } else if (lineType === 'fitting') {
            var _getLinearRegression = getLinearRegression(points),
              xmin = _getLinearRegression.xmin,
              xmax = _getLinearRegression.xmax,
              a = _getLinearRegression.a,
              b = _getLinearRegression.b;
            var linearExp = function linearExp(x) {
              return a * x + b;
            };
            linePoints = [
              {
                x: xmin,
                y: linearExp(xmin),
              },
              {
                x: xmax,
                y: linearExp(xmax),
              },
            ];
          }
          var lineProps = _objectSpread$6(
            _objectSpread$6(
              _objectSpread$6({}, scatterProps),
              {},
              {
                fill: 'none',
                stroke: scatterProps && scatterProps.fill,
              },
              customLineProps,
            ),
            {},
            {
              points: linePoints,
            },
          );
          if (/*#__PURE__*/ React__default['default'].isValidElement(line)) {
            lineItem = /*#__PURE__*/ React__default['default'].cloneElement(line, lineProps);
          } else if (_isFunction(line)) {
            lineItem = line(lineProps);
          } else {
            lineItem = /*#__PURE__*/ React__default['default'].createElement(
              Curve,
              _extends$7({}, lineProps, {
                type: lineJointType,
              }),
            );
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-scatter-line',
              key: 'recharts-scatter-line',
            },
            lineItem,
          );
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props6 = this.props,
            hide = _this$props6.hide,
            points = _this$props6.points,
            line = _this$props6.line,
            className = _this$props6.className,
            xAxis = _this$props6.xAxis,
            yAxis = _this$props6.yAxis,
            left = _this$props6.left,
            top = _this$props6.top,
            width = _this$props6.width,
            height = _this$props6.height,
            id = _this$props6.id,
            isAnimationActive = _this$props6.isAnimationActive;
          if (hide || !points || !points.length) {
            return null;
          }
          var isAnimationFinished = this.state.isAnimationFinished;
          var layerClass = cx('recharts-scatter', className);
          var needClip = (xAxis && xAxis.allowDataOverflow) || (yAxis && yAxis.allowDataOverflow);
          var clipPathId = _isNil(id) ? this.id : id;
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: layerClass,
              clipPath: needClip ? 'url(#clipPath-'.concat(clipPathId, ')') : null,
            },
            needClip
              ? /*#__PURE__*/ React__default['default'].createElement(
                  'defs',
                  null,
                  /*#__PURE__*/ React__default['default'].createElement(
                    'clipPath',
                    {
                      id: 'clipPath-'.concat(clipPathId),
                    },
                    /*#__PURE__*/ React__default['default'].createElement('rect', {
                      x: left,
                      y: top,
                      width: width,
                      height: height,
                    }),
                  ),
                )
              : null,
            line && this.renderLine(),
            this.renderErrorBar(),
            /*#__PURE__*/ React__default['default'].createElement(
              Layer,
              {
                key: 'recharts-scatter-symbols',
              },
              this.renderSymbols(),
            ),
            (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, points),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (nextProps.animationId !== prevState.prevAnimationId) {
            return {
              prevAnimationId: nextProps.animationId,
              curPoints: nextProps.points,
              prevPoints: prevState.curPoints,
            };
          }
          if (nextProps.points !== prevState.curPoints) {
            return {
              curPoints: nextProps.points,
            };
          }
          return null;
        },
      },
      {
        key: 'renderSymbolItem',
        value: function renderSymbolItem(option, props) {
          var symbol;
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            symbol = /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          } else if (_isFunction(option)) {
            symbol = option(props);
          } else if (typeof option === 'string') {
            symbol = /*#__PURE__*/ React__default['default'].createElement(
              Symbols,
              _extends$7({}, props, {
                type: option,
              }),
            );
          }
          return symbol;
        },
      },
    ],
  );
  return Scatter;
})(React.PureComponent);
_defineProperty$E(Scatter, 'displayName', 'Scatter');
_defineProperty$E(Scatter, 'defaultProps', {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: 'circle',
  lineType: 'joint',
  lineJointType: 'linear',
  data: [],
  shape: 'circle',
  hide: false,
  isAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'linear',
});
_defineProperty$E(Scatter, 'getComposedData', function (_ref2) {
  var xAxis = _ref2.xAxis,
    yAxis = _ref2.yAxis,
    zAxis = _ref2.zAxis,
    item = _ref2.item,
    displayedData = _ref2.displayedData,
    xAxisTicks = _ref2.xAxisTicks,
    yAxisTicks = _ref2.yAxisTicks,
    offset = _ref2.offset;
  var tooltipType = item.props.tooltipType;
  var cells = findAllByType(item.props.children, Cell);
  var xAxisDataKey = _isNil(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
  var yAxisDataKey = _isNil(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
  var zAxisDataKey = zAxis && zAxis.dataKey;
  var defaultRangeZ = zAxis ? zAxis.range : ZAxis.defaultProps.range;
  var defaultZ = defaultRangeZ && defaultRangeZ[0];
  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
  var points = displayedData.map(function (entry, index) {
    var x = getValueByDataKey(entry, xAxisDataKey);
    var y = getValueByDataKey(entry, yAxisDataKey);
    var z = (!_isNil(zAxisDataKey) && getValueByDataKey(entry, zAxisDataKey)) || '-';
    var tooltipPayload = [
      {
        name: _isNil(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
        unit: xAxis.unit || '',
        value: x,
        payload: entry,
        dataKey: xAxisDataKey,
        type: tooltipType,
      },
      {
        name: _isNil(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
        unit: yAxis.unit || '',
        value: y,
        payload: entry,
        dataKey: yAxisDataKey,
        type: tooltipType,
      },
    ];
    if (z !== '-') {
      tooltipPayload.push({
        name: zAxis.name || zAxis.dataKey,
        unit: zAxis.unit || '',
        value: z,
        payload: entry,
        dataKey: zAxisDataKey,
        type: tooltipType,
      });
    }
    var cx = getCateCoordinateOfLine({
      axis: xAxis,
      ticks: xAxisTicks,
      bandSize: xBandSize,
      entry: entry,
      index: index,
      dataKey: xAxisDataKey,
    });
    var cy = getCateCoordinateOfLine({
      axis: yAxis,
      ticks: yAxisTicks,
      bandSize: yBandSize,
      entry: entry,
      index: index,
      dataKey: yAxisDataKey,
    });
    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
    return _objectSpread$6(
      _objectSpread$6({}, entry),
      {},
      {
        cx: cx,
        cy: cy,
        x: cx - radius,
        y: cy - radius,
        xAxis: xAxis,
        yAxis: yAxis,
        zAxis: zAxis,
        width: 2 * radius,
        height: 2 * radius,
        size: size,
        node: {
          x: x,
          y: y,
          z: z,
        },
        tooltipPayload: tooltipPayload,
        tooltipPosition: {
          x: cx,
          y: cy,
        },
        payload: entry,
      },
      cells && cells[index] && cells[index].props,
    );
  });
  return _objectSpread$6(
    {
      points: points,
    },
    offset,
  );
});

/**
 * @fileOverview X Axis
 */

/** Define of XAxis props */

var XAxis = function XAxis() {
  return null;
};
XAxis.displayName = 'XAxis';
XAxis.defaultProps = {
  allowDecimals: true,
  hide: false,
  orientation: 'bottom',
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: 'category',
  padding: {
    left: 0,
    right: 0,
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false,
  allowDuplicatedCategory: true,
};

/**
 * @fileOverview Y Axis
 */

var YAxis = function YAxis() {
  return null;
};
YAxis.displayName = 'YAxis';
YAxis.defaultProps = {
  allowDuplicatedCategory: true,
  allowDecimals: true,
  hide: false,
  orientation: 'left',
  width: 60,
  height: 0,
  mirror: false,
  yAxisId: 0,
  tickCount: 5,
  type: 'number',
  padding: {
    top: 0,
    bottom: 0,
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false,
};

var baseIteratee$2 = _baseIteratee,
  isArrayLike = isArrayLike_1,
  keys$3 = keys_1;

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind$1(findIndexFunc) {
  return function (collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee$2(predicate);
      collection = keys$3(collection);
      predicate = function (key) {
        return iteratee(iterable[key], key, iterable);
      };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

var _createFind = createFind$1;

var toFinite = toFinite_1;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$2(value) {
  var result = toFinite(value),
    remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger$2;

var baseFindIndex = _baseFindIndex,
  baseIteratee$1 = _baseIteratee,
  toInteger$1 = toInteger_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex$3(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger$1(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee$1(predicate), index);
}

var findIndex_1 = findIndex$3;

var createFind = _createFind,
  findIndex$2 = findIndex_1;

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find$1 = createFind(findIndex$2);

var find_1 = find$1;

var _find = /*@__PURE__*/ getDefaultExportFromCjs(find_1);

var baseGetTag = _baseGetTag,
  isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false || (isObjectLike$2(value) && baseGetTag(value) == boolTag$2);
}

var isBoolean_1 = isBoolean;

var _isBoolean = /*@__PURE__*/ getDefaultExportFromCjs(isBoolean_1);

function _toConsumableArray$3(arr) {
  return (
    _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$5(arr) || _nonIterableSpread$3()
  );
}
function _nonIterableSpread$3() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$5(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
}
function _iterableToArray$3(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$3(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$5(arr);
}
function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var detectReferenceElementsDomain = function detectReferenceElementsDomain(
  children,
  domain,
  axisId,
  axisType,
  specifiedTicks,
) {
  var lines = findAllByType(children, ReferenceLine);
  var dots = findAllByType(children, ReferenceDot);
  var elements = [].concat(_toConsumableArray$3(lines), _toConsumableArray$3(dots));
  var areas = findAllByType(children, ReferenceArea);
  var idKey = ''.concat(axisType, 'Id');
  var valueKey = axisType[0];
  var finalDomain = domain;
  if (elements.length) {
    finalDomain = elements.reduce(function (result, el) {
      if (el.props[idKey] === axisId && ifOverflowMatches(el.props, 'extendDomain') && isNumber(el.props[valueKey])) {
        var value = el.props[valueKey];
        return [Math.min(result[0], value), Math.max(result[1], value)];
      }
      return result;
    }, finalDomain);
  }
  if (areas.length) {
    var key1 = ''.concat(valueKey, '1');
    var key2 = ''.concat(valueKey, '2');
    finalDomain = areas.reduce(function (result, el) {
      if (
        el.props[idKey] === axisId &&
        ifOverflowMatches(el.props, 'extendDomain') &&
        isNumber(el.props[key1]) &&
        isNumber(el.props[key2])
      ) {
        var value1 = el.props[key1];
        var value2 = el.props[key2];
        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
      }
      return result;
    }, finalDomain);
  }
  if (specifiedTicks && specifiedTicks.length) {
    finalDomain = specifiedTicks.reduce(function (result, tick) {
      if (isNumber(tick)) {
        return [Math.min(result[0], tick), Math.max(result[1], tick)];
      }
      return result;
    }, finalDomain);
  }
  return finalDomain;
};

var eventemitter3 = { exports: {} };

eventemitter3.exports;

(function (module) {
  var has = Object.prototype.hasOwnProperty,
    prefix = '~';

  /**
   * Constructor to create a storage for our `EE` objects.
   * An `Events` instance is a plain object whose properties are event names.
   *
   * @constructor
   * @private
   */
  function Events() {}

  //
  // We try to not inherit from `Object.prototype`. In some engines creating an
  // instance in this way is faster than calling `Object.create(null)` directly.
  // If `Object.create(null)` is not supported we prefix the event names with a
  // character to make sure that the built-in object properties are not
  // overridden or used as an attack vector.
  //
  if (Object.create) {
    Events.prototype = Object.create(null);

    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
  }

  /**
   * Representation of a single event listener.
   *
   * @param {Function} fn The listener function.
   * @param {*} context The context to invoke the listener with.
   * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
   * @constructor
   * @private
   */
  function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
  }

  /**
   * Add a listener for a given event.
   *
   * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} context The context to invoke the listener with.
   * @param {Boolean} once Specify if the listener is a one-time listener.
   * @returns {EventEmitter}
   * @private
   */
  function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') {
      throw new TypeError('The listener must be a function');
    }

    var listener = new EE(fn, context || emitter, once),
      evt = prefix ? prefix + event : event;

    if (!emitter._events[evt]) (emitter._events[evt] = listener), emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [emitter._events[evt], listener];

    return emitter;
  }

  /**
   * Clear event by name.
   *
   * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
   * @param {(String|Symbol)} evt The Event name.
   * @private
   */
  function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
  }

  /**
   * Minimal `EventEmitter` interface that is molded against the Node.js
   * `EventEmitter` interface.
   *
   * @constructor
   * @public
   */
  function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
  }

  /**
   * Return an array listing the events for which the emitter has registered
   * listeners.
   *
   * @returns {Array}
   * @public
   */
  EventEmitter.prototype.eventNames = function eventNames() {
    var names = [],
      events,
      name;

    if (this._eventsCount === 0) return names;

    for (name in (events = this._events)) {
      if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    }

    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }

    return names;
  };

  /**
   * Return the listeners registered for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Array} The registered listeners.
   * @public
   */
  EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event,
      handlers = this._events[evt];

    if (!handlers) return [];
    if (handlers.fn) return [handlers.fn];

    for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
      ee[i] = handlers[i].fn;
    }

    return ee;
  };

  /**
   * Return the number of listeners listening to a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Number} The number of listeners.
   * @public
   */
  EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event,
      listeners = this._events[evt];

    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
  };

  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Boolean} `true` if the event had listeners, else `false`.
   * @public
   */
  EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;

    if (!this._events[evt]) return false;

    var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;

    if (listeners.fn) {
      if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

      switch (len) {
        case 1:
          return listeners.fn.call(listeners.context), true;
        case 2:
          return listeners.fn.call(listeners.context, a1), true;
        case 3:
          return listeners.fn.call(listeners.context, a1, a2), true;
        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), true;
        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }

      for (i = 1, args = new Array(len - 1); i < len; i++) {
        args[i - 1] = arguments[i];
      }

      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length,
        j;

      for (i = 0; i < length; i++) {
        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

        switch (len) {
          case 1:
            listeners[i].fn.call(listeners[i].context);
            break;
          case 2:
            listeners[i].fn.call(listeners[i].context, a1);
            break;
          case 3:
            listeners[i].fn.call(listeners[i].context, a1, a2);
            break;
          case 4:
            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
            break;
          default:
            if (!args)
              for (j = 1, args = new Array(len - 1); j < len; j++) {
                args[j - 1] = arguments[j];
              }

            listeners[i].fn.apply(listeners[i].context, args);
        }
      }
    }

    return true;
  };

  /**
   * Add a listener for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
  };

  /**
   * Add a one-time listener for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
  };

  /**
   * Remove the listeners of a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn Only remove the listeners that match this function.
   * @param {*} context Only remove the listeners that have this context.
   * @param {Boolean} once Only remove one-time listeners.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;

    if (!this._events[evt]) return this;
    if (!fn) {
      clearEvent(this, evt);
      return this;
    }

    var listeners = this._events[evt];

    if (listeners.fn) {
      if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
        clearEvent(this, evt);
      }
    } else {
      for (var i = 0, events = [], length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || (once && !listeners[i].once) || (context && listeners[i].context !== context)) {
          events.push(listeners[i]);
        }
      }

      //
      // Reset the array, or remove it completely if we have no more listeners.
      //
      if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
      else clearEvent(this, evt);
    }

    return this;
  };

  /**
   * Remove all listeners, or those of the specified event.
   *
   * @param {(String|Symbol)} [event] The event name.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;

    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt]) clearEvent(this, evt);
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }

    return this;
  };

  //
  // Alias methods names because people roll like that.
  //
  EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

  //
  // Expose the prefix.
  //
  EventEmitter.prefixed = prefix;

  //
  // Allow `EventEmitter` to be imported as module namespace.
  //
  EventEmitter.EventEmitter = EventEmitter;

  //
  // Expose the module.
  //
  {
    module.exports = EventEmitter;
  }
})(eventemitter3);

var eventemitter3Exports = eventemitter3.exports;
var EventEmitter$1 = /*@__PURE__*/ getDefaultExportFromCjs(eventemitter3Exports);

var eventCenter = new EventEmitter$1();
if (eventCenter.setMaxListeners) {
  eventCenter.setMaxListeners(10);
}
var SYNC_EVENT = 'recharts.syncMouseEvents';

var _excluded$3 = ['item'],
  _excluded2$2 = ['children', 'className', 'width', 'height', 'style', 'compact', 'title', 'desc'];
function _typeof$G(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$G =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$G(obj)
  );
}
function _slicedToArray$3(arr, i) {
  return (
    _arrayWithHoles$3(arr) ||
    _iterableToArrayLimit$3(arr, i) ||
    _unsupportedIterableToArray$4(arr, i) ||
    _nonIterableRest$3()
  );
}
function _nonIterableRest$3() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _iterableToArrayLimit$3(arr, i) {
  var _i = null == arr ? null : ('undefined' != typeof Symbol && arr[Symbol.iterator]) || arr['@@iterator'];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      (_d = !0), (_e = err);
    } finally {
      try {
        if (!_n && null != _i['return'] && ((_r = _i['return']()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr)) return arr;
}
function _extends$6() {
  _extends$6 = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$6.apply(this, arguments);
}
function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$5(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck$B(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$B(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$5(descriptor.key), descriptor);
  }
}
function _createClass$B(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$B(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$B(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$A(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$C(subClass, superClass);
}
function _setPrototypeOf$C(o, p) {
  _setPrototypeOf$C = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$C(o, p);
}
function _createSuper$A(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$A();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$A(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$A(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$A(this, result);
  };
}
function _possibleConstructorReturn$A(self, call) {
  if (call && (_typeof$G(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$C(self);
}
function _assertThisInitialized$C(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$A() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$A(o) {
  _getPrototypeOf$A = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$A(o);
}
function _toConsumableArray$2(arr) {
  return (
    _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread$2()
  );
}
function _nonIterableSpread$2() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$4(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen);
}
function _iterableToArray$2(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$4(arr);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$5(Object(source), !0).forEach(function (key) {
          _defineProperty$D(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$5(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$D(obj, key, value) {
  key = _toPropertyKey$5(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$5(arg) {
  var key = _toPrimitive$5(arg, 'string');
  return _typeof$G(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$5(input, hint) {
  if (_typeof$G(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$G(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var ORIENT_MAP = {
  xAxis: ['bottom', 'top'],
  yAxis: ['left', 'right'],
};
var originCoordinate = {
  x: 0,
  y: 0,
};

// use legacy isFinite only if there is a problem (aka IE)
// eslint-disable-next-line no-restricted-globals
var isFinit = Number.isFinite ? Number.isFinite : isFinite;
var defer =
  // eslint-disable-next-line no-nested-ternary
  typeof requestAnimationFrame === 'function'
    ? requestAnimationFrame
    : typeof setImmediate === 'function'
    ? setImmediate
    : setTimeout;
var deferClear =
  // eslint-disable-next-line no-nested-ternary
  typeof cancelAnimationFrame === 'function'
    ? cancelAnimationFrame
    : typeof clearImmediate === 'function'
    ? clearImmediate
    : clearTimeout;
var calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
  if (layout === 'horizontal') {
    return rangeObj.x;
  }
  if (layout === 'vertical') {
    return rangeObj.y;
  }
  if (layout === 'centric') {
    return rangeObj.angle;
  }
  return rangeObj.radius;
};
var getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
  var entry = tooltipTicks.find(function (tick) {
    return tick && tick.index === activeIndex;
  });
  if (entry) {
    if (layout === 'horizontal') {
      return {
        x: entry.coordinate,
        y: rangeObj.y,
      };
    }
    if (layout === 'vertical') {
      return {
        x: rangeObj.x,
        y: entry.coordinate,
      };
    }
    if (layout === 'centric') {
      var _angle = entry.coordinate;
      var _radius = rangeObj.radius;
      return _objectSpread$5(
        _objectSpread$5(_objectSpread$5({}, rangeObj), polarToCartesian(rangeObj.cx, rangeObj.cy, _radius, _angle)),
        {},
        {
          angle: _angle,
          radius: _radius,
        },
      );
    }
    var radius = entry.coordinate;
    var angle = rangeObj.angle;
    return _objectSpread$5(
      _objectSpread$5(_objectSpread$5({}, rangeObj), polarToCartesian(rangeObj.cx, rangeObj.cy, radius, angle)),
      {},
      {
        angle: angle,
        radius: radius,
      },
    );
  }
  return originCoordinate;
};
var getDisplayedData = function getDisplayedData(data, _ref, item) {
  var graphicalItems = _ref.graphicalItems,
    dataStartIndex = _ref.dataStartIndex,
    dataEndIndex = _ref.dataEndIndex;
  var itemsData = (graphicalItems || []).reduce(function (result, child) {
    var itemData = child.props.data;
    if (itemData && itemData.length) {
      return [].concat(_toConsumableArray$2(result), _toConsumableArray$2(itemData));
    }
    return result;
  }, []);
  if (itemsData && itemsData.length > 0) {
    return itemsData;
  }
  if (item && item.props && item.props.data && item.props.data.length > 0) {
    return item.props.data;
  }
  if (data && data.length && isNumber(dataStartIndex) && isNumber(dataEndIndex)) {
    return data.slice(dataStartIndex, dataEndIndex + 1);
  }
  return [];
};

/**
 * Takes a domain and user props to determine whether he provided the domain via props or if we need to calculate it.
 * @param   {AxisDomain}  domain              The potential domain from props
 * @param   {Boolean}     allowDataOverflow   from props
 * @param   {String}      axisType            from props
 * @returns {Boolean}                         `true` if domain is specified by user
 */
function isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
  if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
    var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
    var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];

    /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */
    if (!!domainStart && !!domainEnd && isNumber(domainStart) && isNumber(domainEnd)) {
      return true;
    }
  }
  return false;
}
function getDefaultDomainByAxisType(axisType) {
  return axisType === 'number' ? [0, 'auto'] : undefined;
}

/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */
var getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
  var graphicalItems = state.graphicalItems,
    tooltipAxis = state.tooltipAxis;
  var displayedData = getDisplayedData(chartData, state);
  if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
    return null;
  }
  // get data by activeIndex when the axis don't allow duplicated category
  return graphicalItems.reduce(function (result, child) {
    var hide = child.props.hide;
    if (hide) {
      return result;
    }
    var data = child.props.data;
    var payload;
    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
      // graphic child has data props
      var entries = data === undefined ? displayedData : data;
      payload = findEntryInArray(entries, tooltipAxis.dataKey, activeLabel);
    } else {
      payload = (data && data[activeIndex]) || displayedData[activeIndex];
    }
    if (!payload) {
      return result;
    }
    return [].concat(_toConsumableArray$2(result), [getTooltipItem(child, payload)]);
  }, []);
};

/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */
var getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
  var rangeData = rangeObj || {
    x: state.chartX,
    y: state.chartY,
  };
  var pos = calculateTooltipPos(rangeData, layout);
  var ticks = state.orderedTooltipTicks,
    axis = state.tooltipAxis,
    tooltipTicks = state.tooltipTicks;
  var activeIndex = calculateActiveTickIndex(pos, ticks, tooltipTicks, axis);
  if (activeIndex >= 0 && tooltipTicks) {
    var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
    var activePayload = getTooltipContent(state, chartData, activeIndex, activeLabel);
    var activeCoordinate = getActiveCoordinate(layout, ticks, activeIndex, rangeData);
    return {
      activeTooltipIndex: activeIndex,
      activeLabel: activeLabel,
      activePayload: activePayload,
      activeCoordinate: activeCoordinate,
    };
  }
  return null;
};

/**
 * Get the configuration of axis by the options of axis instance
 * @param  {Object} props         Latest props
 * @param {Array}  axes           The instance of axes
 * @param  {Array} graphicalItems The instances of item
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}      Configuration
 */
var getAxisMapByAxes = function getAxisMapByAxes(props, _ref2) {
  var axes = _ref2.axes,
    graphicalItems = _ref2.graphicalItems,
    axisType = _ref2.axisType,
    axisIdKey = _ref2.axisIdKey,
    stackGroups = _ref2.stackGroups,
    dataStartIndex = _ref2.dataStartIndex,
    dataEndIndex = _ref2.dataEndIndex;
  var layout = props.layout,
    children = props.children,
    stackOffset = props.stackOffset;
  var isCategorical = isCategoricalAxis(layout, axisType);

  // Eliminate duplicated axes
  var axisMap = axes.reduce(function (result, child) {
    var _child$props$domain2;
    var _child$props = child.props,
      type = _child$props.type,
      dataKey = _child$props.dataKey,
      allowDataOverflow = _child$props.allowDataOverflow,
      allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
      scale = _child$props.scale,
      ticks = _child$props.ticks,
      includeHidden = _child$props.includeHidden;
    var axisId = child.props[axisIdKey];
    if (result[axisId]) {
      return result;
    }
    var displayedData = getDisplayedData(props.data, {
      graphicalItems: graphicalItems.filter(function (item) {
        return item.props[axisIdKey] === axisId;
      }),
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex,
    });
    var len = displayedData.length;
    var domain, duplicateDomain, categoricalDomain;

    /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */
    if (isDomainSpecifiedByUser(child.props.domain, allowDataOverflow, type)) {
      domain = parseSpecifiedDomain(child.props.domain, null, allowDataOverflow);
      /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */
      if (isCategorical && (type === 'number' || scale !== 'auto')) {
        categoricalDomain = getDomainOfDataByKey(displayedData, dataKey, 'category');
      }
    }

    // if the domain is defaulted we need this for `originalDomain` as well
    var defaultDomain = getDefaultDomainByAxisType(type);

    // we didn't create the domain from user's props above, so we need to calculate it
    if (!domain || domain.length === 0) {
      var _child$props$domain;
      var childDomain =
        (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0
          ? _child$props$domain
          : defaultDomain;
      if (dataKey) {
        // has dataKey in <Axis />
        domain = getDomainOfDataByKey(displayedData, dataKey, type);
        if (type === 'category' && isCategorical) {
          // the field type is category data and this axis is categorical axis
          var duplicate = hasDuplicate(domain);
          if (allowDuplicatedCategory && duplicate) {
            duplicateDomain = domain;
            // When category axis has duplicated text, serial numbers are used to generate scale
            domain = _range(0, len);
          } else if (!allowDuplicatedCategory) {
            // remove duplicated category
            domain = parseDomainOfCategoryAxis(childDomain, domain, child).reduce(function (finalDomain, entry) {
              return finalDomain.indexOf(entry) >= 0
                ? finalDomain
                : [].concat(_toConsumableArray$2(finalDomain), [entry]);
            }, []);
          }
        } else if (type === 'category') {
          // the field type is category data and this axis is numerical axis
          if (!allowDuplicatedCategory) {
            domain = parseDomainOfCategoryAxis(childDomain, domain, child).reduce(function (finalDomain, entry) {
              return finalDomain.indexOf(entry) >= 0 || entry === '' || _isNil(entry)
                ? finalDomain
                : [].concat(_toConsumableArray$2(finalDomain), [entry]);
            }, []);
          } else {
            // eliminate undefined or null or empty string
            domain = domain.filter(function (entry) {
              return entry !== '' && !_isNil(entry);
            });
          }
        } else if (type === 'number') {
          // the field type is numerical
          var errorBarsDomain = parseErrorBarsOfAxis(
            displayedData,
            graphicalItems.filter(function (item) {
              return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }),
            dataKey,
            axisType,
            layout,
          );
          if (errorBarsDomain) {
            domain = errorBarsDomain;
          }
        }
        if (isCategorical && (type === 'number' || scale !== 'auto')) {
          categoricalDomain = getDomainOfDataByKey(displayedData, dataKey, 'category');
        }
      } else if (isCategorical) {
        // the axis is a categorical axis
        domain = _range(0, len);
      } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
        // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
        domain =
          stackOffset === 'expand'
            ? [0, 1]
            : getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
      } else {
        domain = getDomainOfItemsWithSameAxis(
          displayedData,
          graphicalItems.filter(function (item) {
            return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
          }),
          type,
          layout,
          true,
        );
      }
      if (type === 'number') {
        // To detect wether there is any reference lines whose props alwaysShow is true
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType, ticks);
        if (childDomain) {
          domain = parseSpecifiedDomain(childDomain, domain, allowDataOverflow);
        }
      } else if (type === 'category' && childDomain) {
        var axisDomain = childDomain;
        var isDomainValid = domain.every(function (entry) {
          return axisDomain.indexOf(entry) >= 0;
        });
        if (isDomainValid) {
          domain = axisDomain;
        }
      }
    }
    return _objectSpread$5(
      _objectSpread$5({}, result),
      {},
      _defineProperty$D(
        {},
        axisId,
        _objectSpread$5(
          _objectSpread$5({}, child.props),
          {},
          {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain:
              (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0
                ? _child$props$domain2
                : defaultDomain,
            isCategorical: isCategorical,
            layout: layout,
          },
        ),
      ),
    );
  }, {});
  return axisMap;
};

/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */
var getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
  var graphicalItems = _ref3.graphicalItems,
    Axis = _ref3.Axis,
    axisType = _ref3.axisType,
    axisIdKey = _ref3.axisIdKey,
    stackGroups = _ref3.stackGroups,
    dataStartIndex = _ref3.dataStartIndex,
    dataEndIndex = _ref3.dataEndIndex;
  var layout = props.layout,
    children = props.children;
  var displayedData = getDisplayedData(props.data, {
    graphicalItems: graphicalItems,
    dataStartIndex: dataStartIndex,
    dataEndIndex: dataEndIndex,
  });
  var len = displayedData.length;
  var isCategorical = isCategoricalAxis(layout, axisType);
  var index = -1;

  // The default type of x-axis is category axis,
  // The default contents of x-axis is the serial numbers of data
  // The default type of y-axis is number axis
  // The default contents of y-axis is the domain of data
  var axisMap = graphicalItems.reduce(function (result, child) {
    var axisId = child.props[axisIdKey];
    var originalDomain = getDefaultDomainByAxisType('number');
    if (!result[axisId]) {
      index++;
      var domain;
      if (isCategorical) {
        domain = _range(0, len);
      } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
        domain = getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType);
      } else {
        domain = parseSpecifiedDomain(
          originalDomain,
          getDomainOfItemsWithSameAxis(
            displayedData,
            graphicalItems.filter(function (item) {
              return item.props[axisIdKey] === axisId && !item.props.hide;
            }),
            'number',
            layout,
          ),
          Axis.defaultProps.allowDataOverflow,
        );
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType);
      }
      return _objectSpread$5(
        _objectSpread$5({}, result),
        {},
        _defineProperty$D(
          {},
          axisId,
          _objectSpread$5(
            _objectSpread$5(
              {
                axisType: axisType,
              },
              Axis.defaultProps,
            ),
            {},
            {
              hide: true,
              orientation: _get(ORIENT_MAP, ''.concat(axisType, '.').concat(index % 2), null),
              domain: domain,
              originalDomain: originalDomain,
              isCategorical: isCategorical,
              layout: layout,
              // specify scale when no Axis
              // scale: isCategorical ? 'band' : 'linear',
            },
          ),
        ),
      );
    }

    return result;
  }, {});
  return axisMap;
};

/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */
var getAxisMap = function getAxisMap(props, _ref4) {
  var _ref4$axisType = _ref4.axisType,
    axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType,
    AxisComp = _ref4.AxisComp,
    graphicalItems = _ref4.graphicalItems,
    stackGroups = _ref4.stackGroups,
    dataStartIndex = _ref4.dataStartIndex,
    dataEndIndex = _ref4.dataEndIndex;
  var children = props.children;
  var axisIdKey = ''.concat(axisType, 'Id');
  // Get all the instance of Axis
  var axes = findAllByType(children, AxisComp);
  var axisMap = {};
  if (axes && axes.length) {
    axisMap = getAxisMapByAxes(props, {
      axes: axes,
      graphicalItems: graphicalItems,
      axisType: axisType,
      axisIdKey: axisIdKey,
      stackGroups: stackGroups,
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex,
    });
  } else if (graphicalItems && graphicalItems.length) {
    axisMap = getAxisMapByItems(props, {
      Axis: AxisComp,
      graphicalItems: graphicalItems,
      axisType: axisType,
      axisIdKey: axisIdKey,
      stackGroups: stackGroups,
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex,
    });
  }
  return axisMap;
};
var tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
  var axis = getAnyElementOfObject(axisMap);
  var tooltipTicks = getTicksOfAxis(axis, false, true);
  return {
    tooltipTicks: tooltipTicks,
    orderedTooltipTicks: _sortBy(tooltipTicks, function (o) {
      return o.coordinate;
    }),
    tooltipAxis: axis,
    tooltipAxisBandSize: getBandSizeOfAxis(axis, tooltipTicks),
  };
};

/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */
var createDefaultState = function createDefaultState(props) {
  var _brushItem$props, _brushItem$props2;
  var children = props.children,
    defaultShowTooltip = props.defaultShowTooltip;
  var brushItem = findChildByType(children, Brush);
  var startIndex = (brushItem && brushItem.props && brushItem.props.startIndex) || 0;
  var endIndex =
    (brushItem === null || brushItem === void 0
      ? void 0
      : (_brushItem$props = brushItem.props) === null || _brushItem$props === void 0
      ? void 0
      : _brushItem$props.endIndex) !== undefined
      ? brushItem === null || brushItem === void 0
        ? void 0
        : (_brushItem$props2 = brushItem.props) === null || _brushItem$props2 === void 0
        ? void 0
        : _brushItem$props2.endIndex
      : (props.data && props.data.length - 1) || 0;
  return {
    chartX: 0,
    chartY: 0,
    dataStartIndex: startIndex,
    dataEndIndex: endIndex,
    activeTooltipIndex: -1,
    isTooltipActive: !_isNil(defaultShowTooltip) ? defaultShowTooltip : false,
  };
};
var hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
  if (!graphicalItems || !graphicalItems.length) {
    return false;
  }
  return graphicalItems.some(function (item) {
    var name = getDisplayName(item && item.type);
    return name && name.indexOf('Bar') >= 0;
  });
};
var getAxisNameByLayout = function getAxisNameByLayout(layout) {
  if (layout === 'horizontal') {
    return {
      numericAxisName: 'yAxis',
      cateAxisName: 'xAxis',
    };
  }
  if (layout === 'vertical') {
    return {
      numericAxisName: 'xAxis',
      cateAxisName: 'yAxis',
    };
  }
  if (layout === 'centric') {
    return {
      numericAxisName: 'radiusAxis',
      cateAxisName: 'angleAxis',
    };
  }
  return {
    numericAxisName: 'angleAxis',
    cateAxisName: 'radiusAxis',
  };
};

/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} props          Latest props
 * graphicalItems The instances of item
 * xAxisMap       The configuration of x-axis
 * yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox          the boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */
var calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
  var props = _ref5.props,
    graphicalItems = _ref5.graphicalItems,
    _ref5$xAxisMap = _ref5.xAxisMap,
    xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap,
    _ref5$yAxisMap = _ref5.yAxisMap,
    yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
  var width = props.width,
    height = props.height,
    children = props.children;
  var margin = props.margin || {};
  var brushItem = findChildByType(children, Brush);
  var legendItem = findChildByType(children, Legend);
  var offsetH = Object.keys(yAxisMap).reduce(
    function (result, id) {
      var entry = yAxisMap[id];
      var orientation = entry.orientation;
      if (!entry.mirror && !entry.hide) {
        return _objectSpread$5(
          _objectSpread$5({}, result),
          {},
          _defineProperty$D({}, orientation, result[orientation] + entry.width),
        );
      }
      return result;
    },
    {
      left: margin.left || 0,
      right: margin.right || 0,
    },
  );
  var offsetV = Object.keys(xAxisMap).reduce(
    function (result, id) {
      var entry = xAxisMap[id];
      var orientation = entry.orientation;
      if (!entry.mirror && !entry.hide) {
        return _objectSpread$5(
          _objectSpread$5({}, result),
          {},
          _defineProperty$D({}, orientation, _get(result, ''.concat(orientation)) + entry.height),
        );
      }
      return result;
    },
    {
      top: margin.top || 0,
      bottom: margin.bottom || 0,
    },
  );
  var offset = _objectSpread$5(_objectSpread$5({}, offsetV), offsetH);
  var brushBottom = offset.bottom;
  if (brushItem) {
    offset.bottom += brushItem.props.height || Brush.defaultProps.height;
  }
  if (legendItem && prevLegendBBox) {
    offset = appendOffsetOfLegend(offset, graphicalItems, props, prevLegendBBox);
  }
  return _objectSpread$5(
    _objectSpread$5(
      {
        brushBottom: brushBottom,
      },
      offset,
    ),
    {},
    {
      width: width - offset.left - offset.right,
      height: height - offset.top - offset.bottom,
    },
  );
};
var generateCategoricalChart = function generateCategoricalChart(_ref6) {
  var _class;
  var chartName = _ref6.chartName,
    GraphicalChild = _ref6.GraphicalChild,
    _ref6$defaultTooltipE = _ref6.defaultTooltipEventType,
    defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE,
    _ref6$validateTooltip = _ref6.validateTooltipEventTypes,
    validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? ['axis'] : _ref6$validateTooltip,
    axisComponents = _ref6.axisComponents,
    legendContent = _ref6.legendContent,
    formatAxisMap = _ref6.formatAxisMap,
    defaultProps = _ref6.defaultProps;
  var getFormatItems = function getFormatItems(props, currentState) {
    var graphicalItems = currentState.graphicalItems,
      stackGroups = currentState.stackGroups,
      offset = currentState.offset,
      updateId = currentState.updateId,
      dataStartIndex = currentState.dataStartIndex,
      dataEndIndex = currentState.dataEndIndex;
    var barSize = props.barSize,
      layout = props.layout,
      barGap = props.barGap,
      barCategoryGap = props.barCategoryGap,
      globalMaxBarSize = props.maxBarSize;
    var _getAxisNameByLayout = getAxisNameByLayout(layout),
      numericAxisName = _getAxisNameByLayout.numericAxisName,
      cateAxisName = _getAxisNameByLayout.cateAxisName;
    var hasBar = hasGraphicalBarItem(graphicalItems);
    var sizeList =
      hasBar &&
      getBarSizeList({
        barSize: barSize,
        stackGroups: stackGroups,
      });
    var formattedItems = [];
    graphicalItems.forEach(function (item, index) {
      var displayedData = getDisplayedData(
        props.data,
        {
          dataStartIndex: dataStartIndex,
          dataEndIndex: dataEndIndex,
        },
        item,
      );
      var _item$props = item.props,
        dataKey = _item$props.dataKey,
        childMaxBarSize = _item$props.maxBarSize;
      var numericAxisId = item.props[''.concat(numericAxisName, 'Id')];
      var cateAxisId = item.props[''.concat(cateAxisName, 'Id')];
      var axisObj = axisComponents.reduce(function (result, entry) {
        var _objectSpread6;
        var axisMap = currentState[''.concat(entry.axisType, 'Map')];
        var id = item.props[''.concat(entry.axisType, 'Id')];
        var axis = axisMap && axisMap[id];
        return _objectSpread$5(
          _objectSpread$5({}, result),
          {},
          ((_objectSpread6 = {}),
          _defineProperty$D(_objectSpread6, entry.axisType, axis),
          _defineProperty$D(_objectSpread6, ''.concat(entry.axisType, 'Ticks'), getTicksOfAxis(axis)),
          _objectSpread6),
        );
      }, {});
      var cateAxis = axisObj[cateAxisName];
      var cateTicks = axisObj[''.concat(cateAxisName, 'Ticks')];
      var stackedData =
        stackGroups &&
        stackGroups[numericAxisId] &&
        stackGroups[numericAxisId].hasStack &&
        getStackedDataOfItem(item, stackGroups[numericAxisId].stackGroups);
      var itemIsBar = getDisplayName(item.type).indexOf('Bar') >= 0;
      var bandSize = getBandSizeOfAxis(cateAxis, cateTicks);
      var barPosition = [];
      if (itemIsBar) {
        var _ref7, _getBandSizeOfAxis;
        // 如果是bar，计算bar的位置
        var maxBarSize = _isNil(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
        var barBandSize =
          (_ref7 =
            (_getBandSizeOfAxis = getBandSizeOfAxis(cateAxis, cateTicks, true)) !== null &&
            _getBandSizeOfAxis !== void 0
              ? _getBandSizeOfAxis
              : maxBarSize) !== null && _ref7 !== void 0
            ? _ref7
            : 0;
        barPosition = getBarPosition({
          barGap: barGap,
          barCategoryGap: barCategoryGap,
          bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
          sizeList: sizeList[cateAxisId],
          maxBarSize: maxBarSize,
        });
        if (barBandSize !== bandSize) {
          barPosition = barPosition.map(function (pos) {
            return _objectSpread$5(
              _objectSpread$5({}, pos),
              {},
              {
                position: _objectSpread$5(
                  _objectSpread$5({}, pos.position),
                  {},
                  {
                    offset: pos.position.offset - barBandSize / 2,
                  },
                ),
              },
            );
          });
        }
      }
      var composedFn = item && item.type && item.type.getComposedData;
      if (composedFn) {
        var _objectSpread7;
        formattedItems.push({
          props: _objectSpread$5(
            _objectSpread$5(
              {},
              composedFn(
                _objectSpread$5(
                  _objectSpread$5({}, axisObj),
                  {},
                  {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                  },
                ),
              ),
            ),
            {},
            ((_objectSpread7 = {
              key: item.key || 'item-'.concat(index),
            }),
            _defineProperty$D(_objectSpread7, numericAxisName, axisObj[numericAxisName]),
            _defineProperty$D(_objectSpread7, cateAxisName, axisObj[cateAxisName]),
            _defineProperty$D(_objectSpread7, 'animationId', updateId),
            _objectSpread7),
          ),
          childIndex: parseChildIndex(item, props.children),
          item: item,
        });
      }
    });
    return formattedItems;
  };

  /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */
  var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
    var props = _ref8.props,
      dataStartIndex = _ref8.dataStartIndex,
      dataEndIndex = _ref8.dataEndIndex,
      updateId = _ref8.updateId;
    if (
      !validateWidthHeight({
        props: props,
      })
    ) {
      return null;
    }
    var children = props.children,
      layout = props.layout,
      stackOffset = props.stackOffset,
      data = props.data,
      reverseStackOrder = props.reverseStackOrder;
    var _getAxisNameByLayout2 = getAxisNameByLayout(layout),
      numericAxisName = _getAxisNameByLayout2.numericAxisName,
      cateAxisName = _getAxisNameByLayout2.cateAxisName;
    var graphicalItems = findAllByType(children, GraphicalChild);
    var stackGroups = getStackGroupsByAxisId(
      data,
      graphicalItems,
      ''.concat(numericAxisName, 'Id'),
      ''.concat(cateAxisName, 'Id'),
      stackOffset,
      reverseStackOrder,
    );
    var axisObj = axisComponents.reduce(function (result, entry) {
      var name = ''.concat(entry.axisType, 'Map');
      return _objectSpread$5(
        _objectSpread$5({}, result),
        {},
        _defineProperty$D(
          {},
          name,
          getAxisMap(
            props,
            _objectSpread$5(
              _objectSpread$5({}, entry),
              {},
              {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex,
              },
            ),
          ),
        ),
      );
    }, {});
    var offset = calculateOffset(
      _objectSpread$5(
        _objectSpread$5({}, axisObj),
        {},
        {
          props: props,
          graphicalItems: graphicalItems,
        },
      ),
      prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox,
    );
    Object.keys(axisObj).forEach(function (key) {
      axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
    });
    var cateAxisMap = axisObj[''.concat(cateAxisName, 'Map')];
    var ticksObj = tooltipTicksGenerator(cateAxisMap);
    var formattedGraphicalItems = getFormatItems(
      props,
      _objectSpread$5(
        _objectSpread$5({}, axisObj),
        {},
        {
          dataStartIndex: dataStartIndex,
          dataEndIndex: dataEndIndex,
          updateId: updateId,
          graphicalItems: graphicalItems,
          stackGroups: stackGroups,
          offset: offset,
        },
      ),
    );
    return _objectSpread$5(
      _objectSpread$5(
        {
          formattedGraphicalItems: formattedGraphicalItems,
          graphicalItems: graphicalItems,
          offset: offset,
          stackGroups: stackGroups,
        },
        ticksObj,
      ),
      axisObj,
    );
  };
  return (
    (_class = /*#__PURE__*/ (function (_Component) {
      _inherits$A(CategoricalChartWrapper, _Component);
      var _super = _createSuper$A(CategoricalChartWrapper);
      // todo join specific chart propTypes

      function CategoricalChartWrapper(_props) {
        var _this;
        _classCallCheck$B(this, CategoricalChartWrapper);
        _this = _super.call(this, _props);
        _defineProperty$D(_assertThisInitialized$C(_this), 'clearDeferId', function () {
          if (!_isNil(_this.deferId) && deferClear) {
            deferClear(_this.deferId);
          }
          _this.deferId = null;
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleLegendBBoxUpdate', function (box) {
          if (box) {
            var _this$state = _this.state,
              dataStartIndex = _this$state.dataStartIndex,
              dataEndIndex = _this$state.dataEndIndex,
              updateId = _this$state.updateId;
            _this.setState(
              _objectSpread$5(
                {
                  legendBBox: box,
                },
                updateStateOfAxisMapsOffsetAndStackGroups(
                  {
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId,
                  },
                  _objectSpread$5(
                    _objectSpread$5({}, _this.state),
                    {},
                    {
                      legendBBox: box,
                    },
                  ),
                ),
              ),
            );
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleReceiveSyncEvent', function (cId, chartId, data) {
          var syncId = _this.props.syncId;
          if (syncId === cId && chartId !== _this.uniqueChartId) {
            _this.clearDeferId();
            _this.deferId = defer && defer(_this.applySyncEvent.bind(_assertThisInitialized$C(_this), data));
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleBrushChange', function (_ref9) {
          var startIndex = _ref9.startIndex,
            endIndex = _ref9.endIndex;
          // Only trigger changes if the extents of the brush have actually changed
          if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
            var updateId = _this.state.updateId;
            _this.setState(function () {
              return _objectSpread$5(
                {
                  dataStartIndex: startIndex,
                  dataEndIndex: endIndex,
                },
                updateStateOfAxisMapsOffsetAndStackGroups(
                  {
                    props: _this.props,
                    dataStartIndex: startIndex,
                    dataEndIndex: endIndex,
                    updateId: updateId,
                  },
                  _this.state,
                ),
              );
            });
            _this.triggerSyncEvent({
              dataStartIndex: startIndex,
              dataEndIndex: endIndex,
            });
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleMouseEnter', function (e) {
          var onMouseEnter = _this.props.onMouseEnter;
          var mouse = _this.getMouseInfo(e);
          if (mouse) {
            var _nextState = _objectSpread$5(
              _objectSpread$5({}, mouse),
              {},
              {
                isTooltipActive: true,
              },
            );
            _this.setState(_nextState);
            _this.triggerSyncEvent(_nextState);
            if (_isFunction(onMouseEnter)) {
              onMouseEnter(_nextState, e);
            }
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'triggeredAfterMouseMove', function (e) {
          var onMouseMove = _this.props.onMouseMove;
          var mouse = _this.getMouseInfo(e);
          var nextState = mouse
            ? _objectSpread$5(
                _objectSpread$5({}, mouse),
                {},
                {
                  isTooltipActive: true,
                },
              )
            : {
                isTooltipActive: false,
              };
          _this.setState(nextState);
          _this.triggerSyncEvent(nextState);
          if (_isFunction(onMouseMove)) {
            onMouseMove(nextState, e);
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleItemMouseEnter', function (el) {
          _this.setState(function () {
            return {
              isTooltipActive: true,
              activeItem: el,
              activePayload: el.tooltipPayload,
              activeCoordinate: el.tooltipPosition || {
                x: el.cx,
                y: el.cy,
              },
            };
          });
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleItemMouseLeave', function () {
          _this.setState(function () {
            return {
              isTooltipActive: false,
            };
          });
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleMouseMove', function (e) {
          if (e && _isFunction(e.persist)) {
            e.persist();
          }
          _this.triggeredAfterMouseMove(e);
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleMouseLeave', function (e) {
          var onMouseLeave = _this.props.onMouseLeave;
          var nextState = {
            isTooltipActive: false,
          };
          _this.setState(nextState);
          _this.triggerSyncEvent(nextState);
          if (_isFunction(onMouseLeave)) {
            onMouseLeave(nextState, e);
          }
          _this.cancelThrottledTriggerAfterMouseMove();
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleOuterEvent', function (e) {
          var eventName = getReactEventByType(e);
          var event = _get(_this.props, ''.concat(eventName));
          if (eventName && _isFunction(event)) {
            var mouse;
            if (/.*touch.*/i.test(eventName)) {
              mouse = _this.getMouseInfo(e.changedTouches[0]);
            } else {
              mouse = _this.getMouseInfo(e);
            }
            var handler = event;

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            handler(mouse, e);
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleClick', function (e) {
          var onClick = _this.props.onClick;
          var mouse = _this.getMouseInfo(e);
          if (mouse) {
            var _nextState2 = _objectSpread$5(
              _objectSpread$5({}, mouse),
              {},
              {
                isTooltipActive: true,
              },
            );
            _this.setState(_nextState2);
            _this.triggerSyncEvent(_nextState2);
            if (_isFunction(onClick)) {
              onClick(_nextState2, e);
            }
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleMouseDown', function (e) {
          var onMouseDown = _this.props.onMouseDown;
          if (_isFunction(onMouseDown)) {
            var _nextState3 = _this.getMouseInfo(e);
            onMouseDown(_nextState3, e);
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleMouseUp', function (e) {
          var onMouseUp = _this.props.onMouseUp;
          if (_isFunction(onMouseUp)) {
            var _nextState4 = _this.getMouseInfo(e);
            onMouseUp(_nextState4, e);
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleTouchMove', function (e) {
          if (e.changedTouches != null && e.changedTouches.length > 0) {
            _this.handleMouseMove(e.changedTouches[0]);
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleTouchStart', function (e) {
          if (e.changedTouches != null && e.changedTouches.length > 0) {
            _this.handleMouseDown(e.changedTouches[0]);
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'handleTouchEnd', function (e) {
          if (e.changedTouches != null && e.changedTouches.length > 0) {
            _this.handleMouseUp(e.changedTouches[0]);
          }
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'verticalCoordinatesGenerator', function (_ref10) {
          var xAxis = _ref10.xAxis,
            width = _ref10.width,
            height = _ref10.height,
            offset = _ref10.offset;
          return getCoordinatesOfGrid(
            getTicks(
              _objectSpread$5(
                _objectSpread$5(_objectSpread$5({}, CartesianAxis.defaultProps), xAxis),
                {},
                {
                  ticks: getTicksOfAxis(xAxis, true),
                  viewBox: {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height,
                  },
                },
              ),
            ),
            offset.left,
            offset.left + offset.width,
          );
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'horizontalCoordinatesGenerator', function (_ref11) {
          var yAxis = _ref11.yAxis,
            width = _ref11.width,
            height = _ref11.height,
            offset = _ref11.offset;
          return getCoordinatesOfGrid(
            getTicks(
              _objectSpread$5(
                _objectSpread$5(_objectSpread$5({}, CartesianAxis.defaultProps), yAxis),
                {},
                {
                  ticks: getTicksOfAxis(yAxis, true),
                  viewBox: {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height,
                  },
                },
              ),
            ),
            offset.top,
            offset.top + offset.height,
          );
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'axesTicksGenerator', function (axis) {
          return getTicksOfAxis(axis, true);
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderCursor', function (element) {
          var _this$state2 = _this.state,
            isTooltipActive = _this$state2.isTooltipActive,
            activeCoordinate = _this$state2.activeCoordinate,
            activePayload = _this$state2.activePayload,
            offset = _this$state2.offset,
            activeTooltipIndex = _this$state2.activeTooltipIndex;
          var tooltipEventType = _this.getTooltipEventType();
          if (
            !element ||
            !element.props.cursor ||
            !isTooltipActive ||
            !activeCoordinate ||
            (chartName !== 'ScatterChart' && tooltipEventType !== 'axis')
          ) {
            return null;
          }
          var layout = _this.props.layout;
          var restProps;
          var cursorComp = Curve;
          if (chartName === 'ScatterChart') {
            restProps = activeCoordinate;
            cursorComp = Cross;
          } else if (chartName === 'BarChart') {
            restProps = _this.getCursorRectangle();
            cursorComp = Rectangle;
          } else if (layout === 'radial') {
            var _this$getCursorPoints = _this.getCursorPoints(),
              cx = _this$getCursorPoints.cx,
              cy = _this$getCursorPoints.cy,
              radius = _this$getCursorPoints.radius,
              startAngle = _this$getCursorPoints.startAngle,
              endAngle = _this$getCursorPoints.endAngle;
            restProps = {
              cx: cx,
              cy: cy,
              startAngle: startAngle,
              endAngle: endAngle,
              innerRadius: radius,
              outerRadius: radius,
            };
            cursorComp = Sector;
          } else {
            restProps = {
              points: _this.getCursorPoints(),
            };
            cursorComp = Curve;
          }
          var key = element.key || '_recharts-cursor';
          var cursorProps = _objectSpread$5(
            _objectSpread$5(
              _objectSpread$5(
                _objectSpread$5(
                  {
                    stroke: '#ccc',
                    pointerEvents: 'none',
                  },
                  offset,
                ),
                restProps,
              ),
              filterProps(element.props.cursor),
            ),
            {},
            {
              payload: activePayload,
              payloadIndex: activeTooltipIndex,
              key: key,
              className: 'recharts-tooltip-cursor',
            },
          );
          return /*#__PURE__*/ React.isValidElement(element.props.cursor)
            ? /*#__PURE__*/ React.cloneElement(element.props.cursor, cursorProps)
            : /*#__PURE__*/ React.createElement(cursorComp, cursorProps);
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderPolarAxis', function (element, displayName, index) {
          var axisType = _get(element, 'type.axisType');
          var axisMap = _get(_this.state, ''.concat(axisType, 'Map'));
          var axisOption = axisMap && axisMap[element.props[''.concat(axisType, 'Id')]];
          return /*#__PURE__*/ React.cloneElement(
            element,
            _objectSpread$5(
              _objectSpread$5({}, axisOption),
              {},
              {
                className: axisType,
                key: element.key || ''.concat(displayName, '-').concat(index),
                ticks: getTicksOfAxis(axisOption, true),
              },
            ),
          );
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderXAxis', function (element, displayName, index) {
          var xAxisMap = _this.state.xAxisMap;
          var axisObj = xAxisMap[element.props.xAxisId];
          return _this.renderAxis(axisObj, element, displayName, index);
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderYAxis', function (element, displayName, index) {
          var yAxisMap = _this.state.yAxisMap;
          var axisObj = yAxisMap[element.props.yAxisId];
          return _this.renderAxis(axisObj, element, displayName, index);
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderGrid', function (element) {
          var _this$state3 = _this.state,
            xAxisMap = _this$state3.xAxisMap,
            yAxisMap = _this$state3.yAxisMap,
            offset = _this$state3.offset;
          var _this$props = _this.props,
            width = _this$props.width,
            height = _this$props.height;
          var xAxis = getAnyElementOfObject(xAxisMap);
          var yAxisWithFiniteDomain = _find(yAxisMap, function (axis) {
            return _every(axis.domain, isFinit);
          });
          var yAxis = yAxisWithFiniteDomain || getAnyElementOfObject(yAxisMap);
          var props = element.props || {};
          return /*#__PURE__*/ React.cloneElement(element, {
            key: element.key || 'grid',
            x: isNumber(props.x) ? props.x : offset.left,
            y: isNumber(props.y) ? props.y : offset.top,
            width: isNumber(props.width) ? props.width : offset.width,
            height: isNumber(props.height) ? props.height : offset.height,
            xAxis: xAxis,
            yAxis: yAxis,
            offset: offset,
            chartWidth: width,
            chartHeight: height,
            verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
            horizontalCoordinatesGenerator:
              props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator,
          });
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderPolarGrid', function (element) {
          var _element$props = element.props,
            radialLines = _element$props.radialLines,
            polarAngles = _element$props.polarAngles,
            polarRadius = _element$props.polarRadius;
          var _this$state4 = _this.state,
            radiusAxisMap = _this$state4.radiusAxisMap,
            angleAxisMap = _this$state4.angleAxisMap;
          var radiusAxis = getAnyElementOfObject(radiusAxisMap);
          var angleAxis = getAnyElementOfObject(angleAxisMap);
          var cx = angleAxis.cx,
            cy = angleAxis.cy,
            innerRadius = angleAxis.innerRadius,
            outerRadius = angleAxis.outerRadius;
          return /*#__PURE__*/ React.cloneElement(element, {
            polarAngles: _isArray(polarAngles)
              ? polarAngles
              : getTicksOfAxis(angleAxis, true).map(function (entry) {
                  return entry.coordinate;
                }),
            polarRadius: _isArray(polarRadius)
              ? polarRadius
              : getTicksOfAxis(radiusAxis, true).map(function (entry) {
                  return entry.coordinate;
                }),
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            key: element.key || 'polar-grid',
            radialLines: radialLines,
          });
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderLegend', function () {
          var formattedGraphicalItems = _this.state.formattedGraphicalItems;
          var _this$props2 = _this.props,
            children = _this$props2.children,
            width = _this$props2.width,
            height = _this$props2.height;
          var margin = _this.props.margin || {};
          var legendWidth = width - (margin.left || 0) - (margin.right || 0);
          var props = getLegendProps({
            children: children,
            formattedGraphicalItems: formattedGraphicalItems,
            legendWidth: legendWidth,
            legendContent: legendContent,
          });
          if (!props) {
            return null;
          }
          var item = props.item,
            otherProps = _objectWithoutProperties$3(props, _excluded$3);
          return /*#__PURE__*/ React.cloneElement(
            item,
            _objectSpread$5(
              _objectSpread$5({}, otherProps),
              {},
              {
                chartWidth: width,
                chartHeight: height,
                margin: margin,
                ref: function ref(legend) {
                  _this.legendInstance = legend;
                },
                onBBoxUpdate: _this.handleLegendBBoxUpdate,
              },
            ),
          );
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderTooltip', function () {
          var children = _this.props.children;
          var tooltipItem = findChildByType(children, Tooltip);
          if (!tooltipItem) {
            return null;
          }
          var _this$state5 = _this.state,
            isTooltipActive = _this$state5.isTooltipActive,
            activeCoordinate = _this$state5.activeCoordinate,
            activePayload = _this$state5.activePayload,
            activeLabel = _this$state5.activeLabel,
            offset = _this$state5.offset;
          return /*#__PURE__*/ React.cloneElement(tooltipItem, {
            viewBox: _objectSpread$5(
              _objectSpread$5({}, offset),
              {},
              {
                x: offset.left,
                y: offset.top,
              },
            ),
            active: isTooltipActive,
            label: activeLabel,
            payload: isTooltipActive ? activePayload : [],
            coordinate: activeCoordinate,
          });
        });
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderBrush', function (element) {
          var _this$props3 = _this.props,
            margin = _this$props3.margin,
            data = _this$props3.data;
          var _this$state6 = _this.state,
            offset = _this$state6.offset,
            dataStartIndex = _this$state6.dataStartIndex,
            dataEndIndex = _this$state6.dataEndIndex,
            updateId = _this$state6.updateId;

          // TODO: update brush when children update
          return /*#__PURE__*/ React.cloneElement(element, {
            key: element.key || '_recharts-brush',
            onChange: combineEventHandlers(_this.handleBrushChange, null, element.props.onChange),
            data: data,
            x: isNumber(element.props.x) ? element.props.x : offset.left,
            y: isNumber(element.props.y)
              ? element.props.y
              : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
            width: isNumber(element.props.width) ? element.props.width : offset.width,
            startIndex: dataStartIndex,
            endIndex: dataEndIndex,
            updateId: 'brush-'.concat(updateId),
          });
        });
        _defineProperty$D(
          _assertThisInitialized$C(_this),
          'renderReferenceElement',
          function (element, displayName, index) {
            if (!element) {
              return null;
            }
            var _assertThisInitialize = _assertThisInitialized$C(_this),
              clipPathId = _assertThisInitialize.clipPathId;
            var _this$state7 = _this.state,
              xAxisMap = _this$state7.xAxisMap,
              yAxisMap = _this$state7.yAxisMap,
              offset = _this$state7.offset;
            var _element$props2 = element.props,
              xAxisId = _element$props2.xAxisId,
              yAxisId = _element$props2.yAxisId;
            return /*#__PURE__*/ React.cloneElement(element, {
              key: element.key || ''.concat(displayName, '-').concat(index),
              xAxis: xAxisMap[xAxisId],
              yAxis: yAxisMap[yAxisId],
              viewBox: {
                x: offset.left,
                y: offset.top,
                width: offset.width,
                height: offset.height,
              },
              clipPathId: clipPathId,
            });
          },
        );
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderActivePoints', function (_ref12) {
          var item = _ref12.item,
            activePoint = _ref12.activePoint,
            basePoint = _ref12.basePoint,
            childIndex = _ref12.childIndex,
            isRange = _ref12.isRange;
          var result = [];
          var key = item.props.key;
          var _item$item$props = item.item.props,
            activeDot = _item$item$props.activeDot,
            dataKey = _item$item$props.dataKey;
          var dotProps = _objectSpread$5(
            _objectSpread$5(
              {
                index: childIndex,
                dataKey: dataKey,
                cx: activePoint.x,
                cy: activePoint.y,
                r: 4,
                fill: getMainColorOfGraphicItem(item.item),
                strokeWidth: 2,
                stroke: '#fff',
                payload: activePoint.payload,
                value: activePoint.value,
                key: ''.concat(key, '-activePoint-').concat(childIndex),
              },
              filterProps(activeDot),
            ),
            adaptEventHandlers(activeDot),
          );
          result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
          if (basePoint) {
            result.push(
              CategoricalChartWrapper.renderActiveDot(
                activeDot,
                _objectSpread$5(
                  _objectSpread$5({}, dotProps),
                  {},
                  {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: ''.concat(key, '-basePoint-').concat(childIndex),
                  },
                ),
              ),
            );
          } else if (isRange) {
            result.push(null);
          }
          return result;
        });
        _defineProperty$D(
          _assertThisInitialized$C(_this),
          'renderGraphicChild',
          function (element, displayName, index) {
            var item = _this.filterFormatItem(element, displayName, index);
            if (!item) {
              return null;
            }
            var tooltipEventType = _this.getTooltipEventType();
            var _this$state8 = _this.state,
              isTooltipActive = _this$state8.isTooltipActive,
              tooltipAxis = _this$state8.tooltipAxis,
              activeTooltipIndex = _this$state8.activeTooltipIndex,
              activeLabel = _this$state8.activeLabel;
            var children = _this.props.children;
            var tooltipItem = findChildByType(children, Tooltip);
            var _item$props2 = item.props,
              points = _item$props2.points,
              isRange = _item$props2.isRange,
              baseLine = _item$props2.baseLine;
            var _item$item$props2 = item.item.props,
              activeDot = _item$item$props2.activeDot,
              hide = _item$item$props2.hide;
            var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
            var itemEvents = {};
            if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') {
              itemEvents = {
                onClick: combineEventHandlers(_this.handleItemMouseEnter, null, element.props.onCLick),
              };
            } else if (tooltipEventType !== 'axis') {
              itemEvents = {
                onMouseLeave: combineEventHandlers(_this.handleItemMouseLeave, null, element.props.onMouseLeave),
                onMouseEnter: combineEventHandlers(_this.handleItemMouseEnter, null, element.props.onMouseEnter),
              };
            }
            var graphicalItem = /*#__PURE__*/ React.cloneElement(
              element,
              _objectSpread$5(_objectSpread$5({}, item.props), itemEvents),
            );
            function findWithPayload(entry) {
              // TODO needs to verify dataKey is Function
              return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
            }
            if (hasActive) {
              var activePoint, basePoint;
              if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                // number transform to string
                var specifiedKey =
                  typeof tooltipAxis.dataKey === 'function'
                    ? findWithPayload
                    : 'payload.'.concat(tooltipAxis.dataKey.toString());
                activePoint = findEntryInArray(points, specifiedKey, activeLabel);
                basePoint = isRange && baseLine && findEntryInArray(baseLine, specifiedKey, activeLabel);
              } else {
                activePoint = points[activeTooltipIndex];
                basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
              }
              if (!_isNil(activePoint)) {
                return [graphicalItem].concat(
                  _toConsumableArray$2(
                    _this.renderActivePoints({
                      item: item,
                      activePoint: activePoint,
                      basePoint: basePoint,
                      childIndex: activeTooltipIndex,
                      isRange: isRange,
                    }),
                  ),
                );
              }
            }
            if (isRange) {
              return [graphicalItem, null, null];
            }
            return [graphicalItem, null];
          },
        );
        _defineProperty$D(_assertThisInitialized$C(_this), 'renderCustomized', function (element, displayName, index) {
          return /*#__PURE__*/ React.cloneElement(
            element,
            _objectSpread$5(
              _objectSpread$5(
                {
                  key: 'recharts-customized-'.concat(index),
                },
                _this.props,
              ),
              _this.state,
            ),
          );
        });
        _this.uniqueChartId = _isNil(_props.id) ? uniqueId('recharts') : _props.id;
        _this.clipPathId = ''.concat(_this.uniqueChartId, '-clip');
        if (_props.throttleDelay) {
          _this.triggeredAfterMouseMove = _throttle(_this.triggeredAfterMouseMove, _props.throttleDelay);
        }
        _this.state = {};
        return _this;
      }
      _createClass$B(CategoricalChartWrapper, [
        {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!_isNil(this.props.syncId)) {
              this.addListener();
            }
          },
        },
        {
          key: 'componentDidUpdate',
          value: function componentDidUpdate(prevProps) {
            // add syncId
            if (_isNil(prevProps.syncId) && !_isNil(this.props.syncId)) {
              this.addListener();
            }
            // remove syncId
            if (!_isNil(prevProps.syncId) && _isNil(this.props.syncId)) {
              this.removeListener();
            }
          },
        },
        {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this.clearDeferId();
            if (!_isNil(this.props.syncId)) {
              this.removeListener();
            }
            this.cancelThrottledTriggerAfterMouseMove();
          },
        },
        {
          key: 'cancelThrottledTriggerAfterMouseMove',
          value: function cancelThrottledTriggerAfterMouseMove() {
            if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
              this.triggeredAfterMouseMove.cancel();
            }
          },
        },
        {
          key: 'getTooltipEventType',
          value: function getTooltipEventType() {
            var tooltipItem = findChildByType(this.props.children, Tooltip);
            if (tooltipItem && _isBoolean(tooltipItem.props.shared)) {
              var eventType = tooltipItem.props.shared ? 'axis' : 'item';
              return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
            }
            return defaultTooltipEventType;
          },

          /**
           * Get the information of mouse in chart, return null when the mouse is not in the chart
           * @param  {Object} event    The event object
           * @return {Object}          Mouse data
           */
        },
        {
          key: 'getMouseInfo',
          value: function getMouseInfo(event) {
            if (!this.container) {
              return null;
            }
            var containerOffset = getOffset(this.container);
            var e = calculateChartCoordinate(event, containerOffset);
            var rangeObj = this.inRange(e.chartX, e.chartY);
            if (!rangeObj) {
              return null;
            }
            var _this$state9 = this.state,
              xAxisMap = _this$state9.xAxisMap,
              yAxisMap = _this$state9.yAxisMap;
            var tooltipEventType = this.getTooltipEventType();
            if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
              var xScale = getAnyElementOfObject(xAxisMap).scale;
              var yScale = getAnyElementOfObject(yAxisMap).scale;
              var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
              var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
              return _objectSpread$5(
                _objectSpread$5({}, e),
                {},
                {
                  xValue: xValue,
                  yValue: yValue,
                },
              );
            }
            var toolTipData = getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
            if (toolTipData) {
              return _objectSpread$5(_objectSpread$5({}, e), toolTipData);
            }
            return null;
          },
        },
        {
          key: 'getCursorRectangle',
          value: function getCursorRectangle() {
            var layout = this.props.layout;
            var _this$state10 = this.state,
              activeCoordinate = _this$state10.activeCoordinate,
              offset = _this$state10.offset,
              tooltipAxisBandSize = _this$state10.tooltipAxisBandSize;
            var halfSize = tooltipAxisBandSize / 2;
            return {
              stroke: 'none',
              fill: '#ccc',
              x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
              y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
              width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
              height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize,
            };
          },
        },
        {
          key: 'getCursorPoints',
          value: function getCursorPoints() {
            var layout = this.props.layout;
            var _this$state11 = this.state,
              activeCoordinate = _this$state11.activeCoordinate,
              offset = _this$state11.offset;
            var x1, y1, x2, y2;
            if (layout === 'horizontal') {
              x1 = activeCoordinate.x;
              x2 = x1;
              y1 = offset.top;
              y2 = offset.top + offset.height;
            } else if (layout === 'vertical') {
              y1 = activeCoordinate.y;
              y2 = y1;
              x1 = offset.left;
              x2 = offset.left + offset.width;
            } else if (!_isNil(activeCoordinate.cx) || !_isNil(activeCoordinate.cy)) {
              if (layout === 'centric') {
                var cx = activeCoordinate.cx,
                  cy = activeCoordinate.cy,
                  innerRadius = activeCoordinate.innerRadius,
                  outerRadius = activeCoordinate.outerRadius,
                  angle = activeCoordinate.angle;
                var innerPoint = polarToCartesian(cx, cy, innerRadius, angle);
                var outerPoint = polarToCartesian(cx, cy, outerRadius, angle);
                x1 = innerPoint.x;
                y1 = innerPoint.y;
                x2 = outerPoint.x;
                y2 = outerPoint.y;
              } else {
                var _cx = activeCoordinate.cx,
                  _cy = activeCoordinate.cy,
                  radius = activeCoordinate.radius,
                  startAngle = activeCoordinate.startAngle,
                  endAngle = activeCoordinate.endAngle;
                var startPoint = polarToCartesian(_cx, _cy, radius, startAngle);
                var endPoint = polarToCartesian(_cx, _cy, radius, endAngle);
                return {
                  points: [startPoint, endPoint],
                  cx: _cx,
                  cy: _cy,
                  radius: radius,
                  startAngle: startAngle,
                  endAngle: endAngle,
                };
              }
            }
            return [
              {
                x: x1,
                y: y1,
              },
              {
                x: x2,
                y: y2,
              },
            ];
          },
        },
        {
          key: 'inRange',
          value: function inRange(x, y) {
            var layout = this.props.layout;
            if (layout === 'horizontal' || layout === 'vertical') {
              var offset = this.state.offset;
              var isInRange =
                x >= offset.left &&
                x <= offset.left + offset.width &&
                y >= offset.top &&
                y <= offset.top + offset.height;
              return isInRange
                ? {
                    x: x,
                    y: y,
                  }
                : null;
            }
            var _this$state12 = this.state,
              angleAxisMap = _this$state12.angleAxisMap,
              radiusAxisMap = _this$state12.radiusAxisMap;
            if (angleAxisMap && radiusAxisMap) {
              var angleAxis = getAnyElementOfObject(angleAxisMap);
              return inRangeOfSector(
                {
                  x: x,
                  y: y,
                },
                angleAxis,
              );
            }
            return null;
          },
        },
        {
          key: 'parseEventsOfWrapper',
          value: function parseEventsOfWrapper() {
            var children = this.props.children;
            var tooltipEventType = this.getTooltipEventType();
            var tooltipItem = findChildByType(children, Tooltip);
            var tooltipEvents = {};
            if (tooltipItem && tooltipEventType === 'axis') {
              if (tooltipItem.props.trigger === 'click') {
                tooltipEvents = {
                  onClick: this.handleClick,
                };
              } else {
                tooltipEvents = {
                  onMouseEnter: this.handleMouseEnter,
                  onMouseMove: this.handleMouseMove,
                  onMouseLeave: this.handleMouseLeave,
                  onTouchMove: this.handleTouchMove,
                  onTouchStart: this.handleTouchStart,
                  onTouchEnd: this.handleTouchEnd,
                };
              }
            }
            var outerEvents = adaptEventHandlers(this.props, this.handleOuterEvent);
            return _objectSpread$5(_objectSpread$5({}, outerEvents), tooltipEvents);
          },

          /* eslint-disable  no-underscore-dangle */
        },
        {
          key: 'addListener',
          value: function addListener() {
            eventCenter.on(SYNC_EVENT, this.handleReceiveSyncEvent);
            if (eventCenter.setMaxListeners && eventCenter._maxListeners) {
              eventCenter.setMaxListeners(eventCenter._maxListeners + 1);
            }
          },
        },
        {
          key: 'removeListener',
          value: function removeListener() {
            eventCenter.removeListener(SYNC_EVENT, this.handleReceiveSyncEvent);
            if (eventCenter.setMaxListeners && eventCenter._maxListeners) {
              eventCenter.setMaxListeners(eventCenter._maxListeners - 1);
            }
          },
        },
        {
          key: 'triggerSyncEvent',
          value: function triggerSyncEvent(data) {
            var syncId = this.props.syncId;
            if (!_isNil(syncId)) {
              eventCenter.emit(SYNC_EVENT, syncId, this.uniqueChartId, data);
            }
          },
        },
        {
          key: 'applySyncEvent',
          value: function applySyncEvent(data) {
            var _this$props4 = this.props,
              layout = _this$props4.layout,
              syncMethod = _this$props4.syncMethod;
            var updateId = this.state.updateId;
            var dataStartIndex = data.dataStartIndex,
              dataEndIndex = data.dataEndIndex;
            if (!_isNil(data.dataStartIndex) || !_isNil(data.dataEndIndex)) {
              this.setState(
                _objectSpread$5(
                  {
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                  },
                  updateStateOfAxisMapsOffsetAndStackGroups(
                    {
                      props: this.props,
                      dataStartIndex: dataStartIndex,
                      dataEndIndex: dataEndIndex,
                      updateId: updateId,
                    },
                    this.state,
                  ),
                ),
              );
            } else if (!_isNil(data.activeTooltipIndex)) {
              var chartX = data.chartX,
                chartY = data.chartY;
              var activeTooltipIndex = data.activeTooltipIndex;
              var _this$state13 = this.state,
                offset = _this$state13.offset,
                tooltipTicks = _this$state13.tooltipTicks;
              if (!offset) {
                return;
              }
              if (typeof syncMethod === 'function') {
                // Call a callback function. If there is an application specific algorithm
                activeTooltipIndex = syncMethod(tooltipTicks, data);
              } else if (syncMethod === 'value') {
                // Set activeTooltipIndex to the index with the same value as data.activeLabel
                // For loop instead of findIndex because the latter is very slow in some browsers
                activeTooltipIndex = -1; // in case we cannot find the element
                for (var i = 0; i < tooltipTicks.length; i++) {
                  if (tooltipTicks[i].value === data.activeLabel) {
                    activeTooltipIndex = i;
                    break;
                  }
                }
              }
              var viewBox = _objectSpread$5(
                _objectSpread$5({}, offset),
                {},
                {
                  x: offset.left,
                  y: offset.top,
                },
              );
              // When a categorical chart is combined with another chart, the value of chartX
              // and chartY may beyond the boundaries.
              var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
              var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
              var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
              var activePayload = getTooltipContent(this.state, this.props.data, activeTooltipIndex);
              var activeCoordinate = tooltipTicks[activeTooltipIndex]
                ? {
                    x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                    y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate,
                  }
                : originCoordinate;
              this.setState(
                _objectSpread$5(
                  _objectSpread$5({}, data),
                  {},
                  {
                    activeLabel: activeLabel,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                  },
                ),
              );
            } else {
              this.setState(data);
            }
          },
        },
        {
          key: 'filterFormatItem',
          value: function filterFormatItem(item, displayName, childIndex) {
            var formattedGraphicalItems = this.state.formattedGraphicalItems;
            for (var i = 0, len = formattedGraphicalItems.length; i < len; i++) {
              var entry = formattedGraphicalItems[i];
              if (
                entry.item === item ||
                entry.props.key === item.key ||
                (displayName === getDisplayName(entry.item.type) && childIndex === entry.childIndex)
              ) {
                return entry;
              }
            }
            return null;
          },
        },
        {
          key: 'renderAxis',
          value:
            /**
             * Draw axis
             * @param {Object} axisOptions The options of axis
             * @param {Object} element      The axis element
             * @param {String} displayName  The display name of axis
             * @param {Number} index        The index of element
             * @return {ReactElement}       The instance of x-axes
             */
            function renderAxis(axisOptions, element, displayName, index) {
              var _this$props5 = this.props,
                width = _this$props5.width,
                height = _this$props5.height;
              return /*#__PURE__*/ React__default['default'].createElement(
                CartesianAxis,
                _extends$6({}, axisOptions, {
                  className: 'recharts-'.concat(axisOptions.axisType, ' ').concat(axisOptions.axisType),
                  key: element.key || ''.concat(displayName, '-').concat(index),
                  viewBox: {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height,
                  },
                  ticksGenerator: this.axesTicksGenerator,
                }),
              );
            },

          /**
           * Draw grid
           * @param  {ReactElement} element the grid item
           * @return {ReactElement} The instance of grid
           */
        },
        {
          key: 'renderClipPath',
          value: function renderClipPath() {
            var clipPathId = this.clipPathId;
            var _this$state$offset = this.state.offset,
              left = _this$state$offset.left,
              top = _this$state$offset.top,
              height = _this$state$offset.height,
              width = _this$state$offset.width;
            return /*#__PURE__*/ React__default['default'].createElement(
              'defs',
              null,
              /*#__PURE__*/ React__default['default'].createElement(
                'clipPath',
                {
                  id: clipPathId,
                },
                /*#__PURE__*/ React__default['default'].createElement('rect', {
                  x: left,
                  y: top,
                  height: height,
                  width: width,
                }),
              ),
            );
          },
        },
        {
          key: 'getXScales',
          value: function getXScales() {
            var xAxisMap = this.state.xAxisMap;
            return xAxisMap
              ? Object.entries(xAxisMap).reduce(function (res, _ref13) {
                  var _ref14 = _slicedToArray$3(_ref13, 2),
                    axisId = _ref14[0],
                    axisProps = _ref14[1];
                  return _objectSpread$5(_objectSpread$5({}, res), {}, _defineProperty$D({}, axisId, axisProps.scale));
                }, {})
              : null;
          },
        },
        {
          key: 'getYScales',
          value: function getYScales() {
            var yAxisMap = this.state.yAxisMap;
            return yAxisMap
              ? Object.entries(yAxisMap).reduce(function (res, _ref15) {
                  var _ref16 = _slicedToArray$3(_ref15, 2),
                    axisId = _ref16[0],
                    axisProps = _ref16[1];
                  return _objectSpread$5(_objectSpread$5({}, res), {}, _defineProperty$D({}, axisId, axisProps.scale));
                }, {})
              : null;
          },
        },
        {
          key: 'getXScaleByAxisId',
          value: function getXScaleByAxisId(axisId) {
            var _this$state$xAxisMap, _this$state$xAxisMap$;
            return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0
              ? void 0
              : (_this$state$xAxisMap$ = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap$ === void 0
              ? void 0
              : _this$state$xAxisMap$.scale;
          },
        },
        {
          key: 'getYScaleByAxisId',
          value: function getYScaleByAxisId(axisId) {
            var _this$state$yAxisMap, _this$state$yAxisMap$;
            return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0
              ? void 0
              : (_this$state$yAxisMap$ = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap$ === void 0
              ? void 0
              : _this$state$yAxisMap$.scale;
          },
        },
        {
          key: 'getItemByXY',
          value: function getItemByXY(chartXY) {
            var formattedGraphicalItems = this.state.formattedGraphicalItems;
            if (formattedGraphicalItems && formattedGraphicalItems.length) {
              for (var i = 0, len = formattedGraphicalItems.length; i < len; i++) {
                var graphicalItem = formattedGraphicalItems[i];
                var props = graphicalItem.props,
                  item = graphicalItem.item;
                var itemDisplayName = getDisplayName(item.type);
                if (itemDisplayName === 'Bar') {
                  var activeBarItem = (props.data || []).find(function (entry) {
                    return isInRectangle(chartXY, entry);
                  });
                  if (activeBarItem) {
                    return {
                      graphicalItem: graphicalItem,
                      payload: activeBarItem,
                    };
                  }
                } else if (itemDisplayName === 'RadialBar') {
                  var _activeBarItem = (props.data || []).find(function (entry) {
                    return inRangeOfSector(chartXY, entry);
                  });
                  if (_activeBarItem) {
                    return {
                      graphicalItem: graphicalItem,
                      payload: _activeBarItem,
                    };
                  }
                }
              }
            }
            return null;
          },
        },
        {
          key: 'render',
          value: function render() {
            var _this2 = this;
            if (!validateWidthHeight(this)) {
              return null;
            }
            var _this$props6 = this.props,
              children = _this$props6.children,
              className = _this$props6.className,
              width = _this$props6.width,
              height = _this$props6.height,
              style = _this$props6.style,
              compact = _this$props6.compact,
              title = _this$props6.title,
              desc = _this$props6.desc,
              others = _objectWithoutProperties$3(_this$props6, _excluded2$2);
            var attrs = filterProps(others);
            var map = {
              CartesianGrid: {
                handler: this.renderGrid,
                once: true,
              },
              ReferenceArea: {
                handler: this.renderReferenceElement,
              },
              ReferenceLine: {
                handler: this.renderReferenceElement,
              },
              ReferenceDot: {
                handler: this.renderReferenceElement,
              },
              XAxis: {
                handler: this.renderXAxis,
              },
              YAxis: {
                handler: this.renderYAxis,
              },
              Brush: {
                handler: this.renderBrush,
                once: true,
              },
              Bar: {
                handler: this.renderGraphicChild,
              },
              Line: {
                handler: this.renderGraphicChild,
              },
              Area: {
                handler: this.renderGraphicChild,
              },
              Radar: {
                handler: this.renderGraphicChild,
              },
              RadialBar: {
                handler: this.renderGraphicChild,
              },
              Scatter: {
                handler: this.renderGraphicChild,
              },
              Pie: {
                handler: this.renderGraphicChild,
              },
              Funnel: {
                handler: this.renderGraphicChild,
              },
              Tooltip: {
                handler: this.renderCursor,
                once: true,
              },
              PolarGrid: {
                handler: this.renderPolarGrid,
                once: true,
              },
              PolarAngleAxis: {
                handler: this.renderPolarAxis,
              },
              PolarRadiusAxis: {
                handler: this.renderPolarAxis,
              },
              Customized: {
                handler: this.renderCustomized,
              },
            };

            // The "compact" mode is mainly used as the panorama within Brush
            if (compact) {
              return /*#__PURE__*/ React__default['default'].createElement(
                Surface,
                _extends$6({}, attrs, {
                  width: width,
                  height: height,
                  title: title,
                  desc: desc,
                }),
                this.renderClipPath(),
                renderByOrder(children, map),
              );
            }
            var events = this.parseEventsOfWrapper();
            return /*#__PURE__*/ React__default['default'].createElement(
              'div',
              _extends$6(
                {
                  className: cx('recharts-wrapper', className),
                  style: _objectSpread$5(
                    {
                      position: 'relative',
                      cursor: 'default',
                      width: width,
                      height: height,
                    },
                    style,
                  ),
                },
                events,
                {
                  ref: function ref(node) {
                    _this2.container = node;
                  },
                  role: 'region',
                },
              ),
              /*#__PURE__*/ React__default['default'].createElement(
                Surface,
                _extends$6({}, attrs, {
                  width: width,
                  height: height,
                  title: title,
                  desc: desc,
                }),
                this.renderClipPath(),
                renderByOrder(children, map),
              ),
              this.renderLegend(),
              this.renderTooltip(),
            );
          },
        },
      ]);
      return CategoricalChartWrapper;
    })(React.Component)),
    _defineProperty$D(_class, 'displayName', chartName),
    _defineProperty$D(
      _class,
      'defaultProps',
      _objectSpread$5(
        {
          layout: 'horizontal',
          stackOffset: 'none',
          barCategoryGap: '10%',
          barGap: 4,
          margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5,
          },
          reverseStackOrder: false,
          syncMethod: 'index',
        },
        defaultProps,
      ),
    ),
    _defineProperty$D(_class, 'getDerivedStateFromProps', function (nextProps, prevState) {
      var data = nextProps.data,
        children = nextProps.children,
        width = nextProps.width,
        height = nextProps.height,
        layout = nextProps.layout,
        stackOffset = nextProps.stackOffset,
        margin = nextProps.margin;
      if (_isNil(prevState.updateId)) {
        var defaultState = createDefaultState(nextProps);
        return _objectSpread$5(
          _objectSpread$5(
            _objectSpread$5({}, defaultState),
            {},
            {
              updateId: 0,
            },
            updateStateOfAxisMapsOffsetAndStackGroups(
              _objectSpread$5(
                _objectSpread$5(
                  {
                    props: nextProps,
                  },
                  defaultState,
                ),
                {},
                {
                  updateId: 0,
                },
              ),
              prevState,
            ),
          ),
          {},
          {
            prevData: data,
            prevWidth: width,
            prevHeight: height,
            prevLayout: layout,
            prevStackOffset: stackOffset,
            prevMargin: margin,
            prevChildren: children,
          },
        );
      }
      if (
        data !== prevState.prevData ||
        width !== prevState.prevWidth ||
        height !== prevState.prevHeight ||
        layout !== prevState.prevLayout ||
        stackOffset !== prevState.prevStackOffset ||
        !shallowEqual$1(margin, prevState.prevMargin)
      ) {
        var _defaultState = createDefaultState(nextProps);

        // Fixes https://github.com/recharts/recharts/issues/2143
        var keepFromPrevState = {
          // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
          // any flickering
          chartX: prevState.chartX,
          chartY: prevState.chartY,
          // The tooltip should stay active when it was active in the previous render. If this is not
          // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
          isTooltipActive: prevState.isTooltipActive,
        };
        var updatesToState = _objectSpread$5(
          _objectSpread$5({}, getTooltipData(prevState, data, layout)),
          {},
          {
            updateId: prevState.updateId + 1,
          },
        );
        var newState = _objectSpread$5(
          _objectSpread$5(_objectSpread$5({}, _defaultState), keepFromPrevState),
          updatesToState,
        );
        return _objectSpread$5(
          _objectSpread$5(
            _objectSpread$5({}, newState),
            updateStateOfAxisMapsOffsetAndStackGroups(
              _objectSpread$5(
                {
                  props: nextProps,
                },
                newState,
              ),
              prevState,
            ),
          ),
          {},
          {
            prevData: data,
            prevWidth: width,
            prevHeight: height,
            prevLayout: layout,
            prevStackOffset: stackOffset,
            prevMargin: margin,
            prevChildren: children,
          },
        );
      }
      if (!isChildrenEqual(children, prevState.prevChildren)) {
        // update configuration in children
        var hasGlobalData = !_isNil(data);
        var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
        return _objectSpread$5(
          _objectSpread$5(
            {
              updateId: newUpdateId,
            },
            updateStateOfAxisMapsOffsetAndStackGroups(
              _objectSpread$5(
                _objectSpread$5(
                  {
                    props: nextProps,
                  },
                  prevState,
                ),
                {},
                {
                  updateId: newUpdateId,
                },
              ),
              prevState,
            ),
          ),
          {},
          {
            prevChildren: children,
          },
        );
      }
      return null;
    }),
    _defineProperty$D(_class, 'renderActiveDot', function (option, props) {
      var dot;
      if (/*#__PURE__*/ React.isValidElement(option)) {
        dot = /*#__PURE__*/ React.cloneElement(option, props);
      } else if (_isFunction(option)) {
        dot = option(props);
      } else {
        dot = /*#__PURE__*/ React__default['default'].createElement(Dot, props);
      }
      return /*#__PURE__*/ React__default['default'].createElement(
        Layer,
        {
          className: 'recharts-active-dot',
          key: props.key,
        },
        dot,
      );
    }),
    _class
  );
};

/**
 * @fileOverview Line Chart
 */
generateCategoricalChart({
  chartName: 'LineChart',
  GraphicalChild: Line,
  axisComponents: [
    {
      axisType: 'xAxis',
      AxisComp: XAxis,
    },
    {
      axisType: 'yAxis',
      AxisComp: YAxis,
    },
  ],
  formatAxisMap: formatAxisMap,
});

/**
 * @fileOverview Bar Chart
 */
var BarChart$1 = generateCategoricalChart({
  chartName: 'BarChart',
  GraphicalChild: Bar,
  defaultTooltipEventType: 'axis',
  validateTooltipEventTypes: ['axis', 'item'],
  axisComponents: [
    {
      axisType: 'xAxis',
      AxisComp: XAxis,
    },
    {
      axisType: 'yAxis',
      AxisComp: YAxis,
    },
  ],
  formatAxisMap: formatAxisMap,
});

/**
 * @fileOverview Pie Chart
 */
generateCategoricalChart({
  chartName: 'PieChart',
  GraphicalChild: Pie,
  validateTooltipEventTypes: ['item'],
  defaultTooltipEventType: 'item',
  legendContent: 'children',
  axisComponents: [
    {
      axisType: 'angleAxis',
      AxisComp: PolarAngleAxis,
    },
    {
      axisType: 'radiusAxis',
      AxisComp: PolarRadiusAxis,
    },
  ],
  formatAxisMap: formatAxisMap$1,
  defaultProps: {
    layout: 'centric',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%',
  },
});

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$1(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$1;

var baseAssignValue$1 = _baseAssignValue,
  eq = eq_1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$2.call(object, key) && eq(objValue, value)) || (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$2;

var assignValue$1 = _assignValue,
  baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$5(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
    length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$5;

var copyObject$4 = _copyObject,
  keys$2 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$4(source, keys$2(source), object);
}

var _baseAssign = baseAssign$1;

var copyObject$3 = _copyObject,
  keysIn$2 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$3(source, keysIn$2(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = { exports: {} };

_cloneBuffer.exports;

(function (module, exports) {
  var root = _root;

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

    buffer.copy(result);
    return result;
  }

  module.exports = cloneBuffer;
})(_cloneBuffer, _cloneBuffer.exports);

var _cloneBufferExports = _cloneBuffer.exports;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$1(source, array) {
  var index = -1,
    length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$1;

var copyObject$2 = _copyObject,
  getSymbols$1 = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$2(source, getSymbols$1(source), object);
}

var _copySymbols = copySymbols$1;

var arrayPush = _arrayPush,
  getPrototype$1 = _getPrototype,
  getSymbols = _getSymbols,
  stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols
  ? stubArray
  : function (object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype$1(object);
      }
      return result;
    };

var _getSymbolsIn = getSymbolsIn$2;

var copyObject$1 = _copyObject,
  getSymbolsIn$1 = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject$1(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var baseGetAllKeys = _baseGetAllKeys,
  getSymbolsIn = _getSymbolsIn,
  keysIn$1 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$2(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$2;

/** Used for built-in method references. */

var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$1.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var Uint8Array$1 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$1 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

var cloneArrayBuffer = _cloneArrayBuffer,
  cloneDataView = _cloneDataView,
  cloneRegExp = _cloneRegExp,
  cloneSymbol = _cloneSymbol,
  cloneTypedArray = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  mapTag$2 = '[object Map]',
  numberTag$1 = '[object Number]',
  regexpTag$1 = '[object RegExp]',
  setTag$2 = '[object Set]',
  stringTag$1 = '[object String]',
  symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$1 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor();

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor();

    case symbolTag$1:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$2 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function () {
  function object() {}
  return function (proto) {
    if (!isObject$2(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
})();

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
  getPrototype = _getPrototype,
  isPrototype = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$1(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

var _initCloneObject = initCloneObject$1;

var getTag$2 = _getTag,
  isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$1(value) && getTag$2(value) == mapTag$1;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
  baseUnary$1 = _baseUnary,
  nodeUtil$1 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$1 = _getTag,
  isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
  baseUnary = _baseUnary,
  nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack = _Stack,
  arrayEach = _arrayEach,
  assignValue = _assignValue,
  baseAssign = _baseAssign,
  baseAssignIn = _baseAssignIn,
  cloneBuffer = _cloneBufferExports,
  copyArray = _copyArray,
  copySymbols = _copySymbols,
  copySymbolsIn = _copySymbolsIn,
  getAllKeys = _getAllKeys,
  getAllKeysIn$1 = _getAllKeysIn,
  getTag = _getTag,
  initCloneArray = _initCloneArray,
  initCloneByTag = _initCloneByTag,
  initCloneObject = _initCloneObject,
  isArray = isArray_1,
  isBuffer$1 = isBufferExports,
  isMap = isMap_1,
  isObject$1 = isObject_1,
  isSet = isSet_1,
  keys$1 = keys_1,
  keysIn = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
  CLONE_FLAT_FLAG$1 = 2,
  CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  objectTag = '[object Object]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]',
  weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] =
  cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] =
  cloneableTags[dataViewTag] =
  cloneableTags[boolTag] =
  cloneableTags[dateTag] =
  cloneableTags[float32Tag] =
  cloneableTags[float64Tag] =
  cloneableTags[int8Tag] =
  cloneableTags[int16Tag] =
  cloneableTags[int32Tag] =
  cloneableTags[mapTag] =
  cloneableTags[numberTag] =
  cloneableTags[objectTag] =
  cloneableTags[regexpTag] =
  cloneableTags[setTag] =
  cloneableTags[stringTag] =
  cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] =
  cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] =
  cloneableTags[uint32Tag] =
    true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG$1,
    isFlat = bitmask & CLONE_FLAT_FLAG$1,
    isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
      isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? (isFlat ? getAllKeysIn$1 : getAllKeys) : isFlat ? keysIn : keys$1;

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

var baseGet = _baseGet,
  baseSlice = _baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent$1(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

var _parent = parent$1;

var castPath$1 = _castPath,
  last = last_1,
  parent = _parent,
  toKey = _toKey;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset$1(object, path) {
  path = castPath$1(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

var _baseUnset = baseUnset$1;

var isPlainObject = isPlainObject_1;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone$1(value) {
  return isPlainObject(value) ? undefined : value;
}

var _customOmitClone = customOmitClone$1;

var baseFlatten = _baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$2(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

var flatten_1 = flatten$2;

var flatten$1 = flatten_1,
  overRest = _overRest,
  setToString = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$1(func) {
  return setToString(overRest(func, undefined, flatten$1), func + '');
}

var _flatRest = flatRest$1;

var arrayMap = _arrayMap,
  baseClone = _baseClone,
  baseUnset = _baseUnset,
  castPath = _castPath,
  copyObject = _copyObject,
  customOmitClone = _customOmitClone,
  flatRest = _flatRest,
  getAllKeysIn = _getAllKeysIn;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function (object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function (path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

var omit_1 = omit;

var _omit = /*@__PURE__*/ getDefaultExportFromCjs(omit_1);

var COLOR_PANEL = [
  '#1890FF',
  '#66B5FF',
  '#41D9C7',
  '#2FC25B',
  '#6EDB8F',
  '#9AE65C',
  '#FACC14',
  '#E6965C',
  '#57AD71',
  '#223273',
  '#738AE6',
  '#7564CC',
  '#8543E0',
  '#A877ED',
  '#5C8EE6',
  '#13C2C2',
  '#70E0E0',
  '#5CA3E6',
  '#3436C7',
  '#8082FF',
  '#DD81E6',
  '#F04864',
  '#FA7D92',
  '#D598D9',
];

var _excluded$2 = ['width', 'height', 'className', 'style', 'children', 'type'];
function _typeof$F(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$F =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$F(obj)
  );
}
function _extends$5() {
  _extends$5 = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$5.apply(this, arguments);
}
function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$4(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck$A(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$A(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$4(descriptor.key), descriptor);
  }
}
function _createClass$A(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$A(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$A(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$z(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$B(subClass, superClass);
}
function _setPrototypeOf$B(o, p) {
  _setPrototypeOf$B = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$B(o, p);
}
function _createSuper$z(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$z();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$z(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$z(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$z(this, result);
  };
}
function _possibleConstructorReturn$z(self, call) {
  if (call && (_typeof$F(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$B(self);
}
function _assertThisInitialized$B(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$z() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$z(o) {
  _getPrototypeOf$z = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$z(o);
}
function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$4(Object(source), !0).forEach(function (key) {
          _defineProperty$C(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$4(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$C(obj, key, value) {
  key = _toPropertyKey$4(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$4(arg) {
  var key = _toPrimitive$4(arg, 'string');
  return _typeof$F(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$4(input, hint) {
  if (_typeof$F(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$F(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var NODE_VALUE_KEY = 'value';
var computeNode = function computeNode(_ref) {
  var _objectSpread2;
  var depth = _ref.depth,
    node = _ref.node,
    index = _ref.index,
    valueKey = _ref.valueKey;
  var children = node.children;
  var childDepth = depth + 1;
  var computedChildren =
    children && children.length
      ? children.map(function (child, i) {
          return computeNode({
            depth: childDepth,
            node: child,
            index: i,
            valueKey: valueKey,
          });
        })
      : null;
  var nodeValue;
  if (children && children.length) {
    nodeValue = computedChildren.reduce(function (result, child) {
      return result + child[NODE_VALUE_KEY];
    }, 0);
  } else {
    // TODO need to verify valueKey
    nodeValue = _isNaN$1(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
  }
  return _objectSpread$4(
    _objectSpread$4({}, node),
    {},
    ((_objectSpread2 = {
      children: computedChildren,
    }),
    _defineProperty$C(_objectSpread2, NODE_VALUE_KEY, nodeValue),
    _defineProperty$C(_objectSpread2, 'depth', depth),
    _defineProperty$C(_objectSpread2, 'index', index),
    _objectSpread2),
  );
};
var filterRect = function filterRect(node) {
  return {
    x: node.x,
    y: node.y,
    width: node.width,
    height: node.height,
  };
};

// Compute the area for each child based on value & scale.
var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
  return children.map(function (child) {
    var area = child[NODE_VALUE_KEY] * ratio;
    return _objectSpread$4(
      _objectSpread$4({}, child),
      {},
      {
        area: _isNaN$1(area) || area <= 0 ? 0 : area,
      },
    );
  });
};

// Computes the score for the specified row, as the worst aspect ratio.
var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
  var parentArea = parentSize * parentSize;
  var rowArea = row.area * row.area;
  var _row$reduce = row.reduce(
      function (result, child) {
        return {
          min: Math.min(result.min, child.area),
          max: Math.max(result.max, child.area),
        };
      },
      {
        min: Infinity,
        max: 0,
      },
    ),
    min = _row$reduce.min,
    max = _row$reduce.max;
  return rowArea
    ? Math.max((parentArea * max * aspectRatio) / rowArea, rowArea / (parentArea * min * aspectRatio))
    : Infinity;
};
var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
  if (isFlush || rowHeight > parentRect.height) {
    rowHeight = parentRect.height;
  }
  var curX = parentRect.x;
  var child;
  for (var _i = 0, len = row.length; _i < len; _i++) {
    child = row[_i];
    child.x = curX;
    child.y = parentRect.y;
    child.height = rowHeight;
    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
    curX += child.width;
  }
  // add the remain x to the last one of row
  child.width += parentRect.x + parentRect.width - curX;
  return _objectSpread$4(
    _objectSpread$4({}, parentRect),
    {},
    {
      y: parentRect.y + rowHeight,
      height: parentRect.height - rowHeight,
    },
  );
};
var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
  if (isFlush || rowWidth > parentRect.width) {
    rowWidth = parentRect.width;
  }
  var curY = parentRect.y;
  var child;
  for (var _i2 = 0, len = row.length; _i2 < len; _i2++) {
    child = row[_i2];
    child.x = parentRect.x;
    child.y = curY;
    child.width = rowWidth;
    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
    curY += child.height;
  }
  if (child) {
    child.height += parentRect.y + parentRect.height - curY;
  }
  return _objectSpread$4(
    _objectSpread$4({}, parentRect),
    {},
    {
      x: parentRect.x + rowWidth,
      width: parentRect.width - rowWidth,
    },
  );
};
var position = function position(row, parentSize, parentRect, isFlush) {
  if (parentSize === parentRect.width) {
    return horizontalPosition(row, parentSize, parentRect, isFlush);
  }
  return verticalPosition(row, parentSize, parentRect, isFlush);
};

// Recursively arranges the specified node's children into squarified rows.
var squarify = function squarify(node, aspectRatio) {
  var children = node.children;
  if (children && children.length) {
    var rect = filterRect(node);
    // maybe a bug
    var row = [];
    var best = Infinity; // the best row score so far
    var child, score; // the current row score
    var size = Math.min(rect.width, rect.height); // initial orientation
    var scaleChildren = getAreaOfChildren(children, (rect.width * rect.height) / node[NODE_VALUE_KEY]);
    var tempChildren = scaleChildren.slice();
    row.area = 0;
    while (tempChildren.length > 0) {
      // row first
      // eslint-disable-next-line prefer-destructuring
      row.push((child = tempChildren[0]));
      row.area += child.area;
      score = getWorstScore(row, size, aspectRatio);
      if (score <= best) {
        // continue with this orientation
        tempChildren.shift();
        best = score;
      } else {
        // abort, and try a different orientation
        row.area -= row.pop().area;
        rect = position(row, size, rect, false);
        size = Math.min(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
    }
    if (row.length) {
      rect = position(row, size, rect, true);
      row.length = row.area = 0;
    }
    return _objectSpread$4(
      _objectSpread$4({}, node),
      {},
      {
        children: scaleChildren.map(function (c) {
          return squarify(c, aspectRatio);
        }),
      },
    );
  }
  return node;
};
var defaultState = {
  isTooltipActive: false,
  isAnimationFinished: false,
  activeNode: null,
  formatRoot: null,
  currentRoot: null,
  nestIndex: [],
};
var Treemap = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$z(Treemap, _PureComponent);
  var _super = _createSuper$z(Treemap);
  function Treemap() {
    var _this;
    _classCallCheck$A(this, Treemap);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$C(_assertThisInitialized$B(_this), 'state', _objectSpread$4({}, defaultState));
    _defineProperty$C(_assertThisInitialized$B(_this), 'handleAnimationEnd', function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true,
      });
      if (_isFunction(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$C(_assertThisInitialized$B(_this), 'handleAnimationStart', function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false,
      });
      if (_isFunction(onAnimationStart)) {
        onAnimationStart();
      }
    });
    return _this;
  }
  _createClass$A(
    Treemap,
    [
      {
        key: 'handleMouseEnter',
        value: function handleMouseEnter(node, e) {
          var _this$props = this.props,
            onMouseEnter = _this$props.onMouseEnter,
            children = _this$props.children;
          var tooltipItem = findChildByType(children, Tooltip);
          if (tooltipItem) {
            this.setState(
              {
                isTooltipActive: true,
                activeNode: node,
              },
              function () {
                if (onMouseEnter) {
                  onMouseEnter(node, e);
                }
              },
            );
          } else if (onMouseEnter) {
            onMouseEnter(node, e);
          }
        },
      },
      {
        key: 'handleMouseLeave',
        value: function handleMouseLeave(node, e) {
          var _this$props2 = this.props,
            onMouseLeave = _this$props2.onMouseLeave,
            children = _this$props2.children;
          var tooltipItem = findChildByType(children, Tooltip);
          if (tooltipItem) {
            this.setState(
              {
                isTooltipActive: false,
                activeNode: null,
              },
              function () {
                if (onMouseLeave) {
                  onMouseLeave(node, e);
                }
              },
            );
          } else if (onMouseLeave) {
            onMouseLeave(node, e);
          }
        },
      },
      {
        key: 'handleClick',
        value: function handleClick(node) {
          var _this$props3 = this.props,
            onClick = _this$props3.onClick,
            type = _this$props3.type;
          if (type === 'nest' && node.children) {
            var _this$props4 = this.props,
              width = _this$props4.width,
              height = _this$props4.height,
              dataKey = _this$props4.dataKey,
              aspectRatio = _this$props4.aspectRatio;
            var root = computeNode({
              depth: 0,
              node: _objectSpread$4(
                _objectSpread$4({}, node),
                {},
                {
                  x: 0,
                  y: 0,
                  width: width,
                  height: height,
                },
              ),
              index: 0,
              valueKey: dataKey,
            });
            var formatRoot = squarify(root, aspectRatio);
            var nestIndex = this.state.nestIndex;
            nestIndex.push(node);
            this.setState({
              formatRoot: formatRoot,
              currentRoot: root,
              nestIndex: nestIndex,
            });
          }
          if (onClick) {
            onClick(node);
          }
        },
      },
      {
        key: 'handleNestIndex',
        value: function handleNestIndex(node, i) {
          var nestIndex = this.state.nestIndex;
          var _this$props5 = this.props,
            width = _this$props5.width,
            height = _this$props5.height,
            dataKey = _this$props5.dataKey,
            aspectRatio = _this$props5.aspectRatio;
          var root = computeNode({
            depth: 0,
            node: _objectSpread$4(
              _objectSpread$4({}, node),
              {},
              {
                x: 0,
                y: 0,
                width: width,
                height: height,
              },
            ),
            index: 0,
            valueKey: dataKey,
          });
          var formatRoot = squarify(root, aspectRatio);
          nestIndex = nestIndex.slice(0, i + 1);
          this.setState({
            formatRoot: formatRoot,
            currentRoot: node,
            nestIndex: nestIndex,
          });
        },
      },
      {
        key: 'renderItem',
        value: function renderItem(content, nodeProps, isLeaf) {
          var _this2 = this;
          var _this$props6 = this.props,
            isAnimationActive = _this$props6.isAnimationActive,
            animationBegin = _this$props6.animationBegin,
            animationDuration = _this$props6.animationDuration,
            animationEasing = _this$props6.animationEasing,
            isUpdateAnimationActive = _this$props6.isUpdateAnimationActive,
            type = _this$props6.type,
            animationId = _this$props6.animationId,
            colorPanel = _this$props6.colorPanel;
          var isAnimationFinished = this.state.isAnimationFinished;
          var width = nodeProps.width,
            height = nodeProps.height,
            x = nodeProps.x,
            y = nodeProps.y,
            depth = nodeProps.depth;
          var translateX = parseInt(''.concat((Math.random() * 2 - 1) * width), 10);
          var event = {};
          if (isLeaf || type === 'nest') {
            event = {
              onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
              onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
              onClick: this.handleClick.bind(this, nodeProps),
            };
          }
          if (!isAnimationActive) {
            return /*#__PURE__*/ React__default['default'].createElement(
              Layer,
              event,
              this.constructor.renderContentItem(
                content,
                _objectSpread$4(
                  _objectSpread$4({}, nodeProps),
                  {},
                  {
                    isAnimationActive: false,
                    isUpdateAnimationActive: false,
                    width: width,
                    height: height,
                    x: x,
                    y: y,
                  },
                ),
                type,
                colorPanel,
              ),
            );
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            Animate,
            {
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing,
              key: 'treemap-'.concat(animationId),
              from: {
                x: x,
                y: y,
                width: width,
                height: height,
              },
              to: {
                x: x,
                y: y,
                width: width,
                height: height,
              },
              onAnimationStart: this.handleAnimationStart,
              onAnimationEnd: this.handleAnimationEnd,
            },
            function (_ref2) {
              var currX = _ref2.x,
                currY = _ref2.y,
                currWidth = _ref2.width,
                currHeight = _ref2.height;
              return /*#__PURE__*/ React__default['default'].createElement(
                Animate,
                {
                  from: 'translate('.concat(translateX, 'px, ').concat(translateX, 'px)'),
                  to: 'translate(0, 0)',
                  attributeName: 'transform',
                  begin: animationBegin,
                  easing: animationEasing,
                  isActive: isAnimationActive,
                  duration: animationDuration,
                },
                /*#__PURE__*/ React__default['default'].createElement(
                  Layer,
                  event,
                  (function () {
                    // when animation Duration , only render depth=1 nodes
                    if (depth > 2 && !isAnimationFinished) {
                      return null;
                    }
                    return _this2.constructor.renderContentItem(
                      content,
                      _objectSpread$4(
                        _objectSpread$4({}, nodeProps),
                        {},
                        {
                          isAnimationActive: isAnimationActive,
                          isUpdateAnimationActive: !isUpdateAnimationActive,
                          width: currWidth,
                          height: currHeight,
                          x: currX,
                          y: currY,
                        },
                      ),
                      type,
                      colorPanel,
                    );
                  })(),
                ),
              );
            },
          );
        },
      },
      {
        key: 'renderNode',
        value: function renderNode(root, node, i) {
          var _this3 = this;
          var _this$props7 = this.props,
            content = _this$props7.content,
            type = _this$props7.type;
          var nodeProps = _objectSpread$4(
            _objectSpread$4(_objectSpread$4({}, filterProps(this.props)), node),
            {},
            {
              root: root,
            },
          );
          var isLeaf = !node.children || !node.children.length;
          var currentRoot = this.state.currentRoot;
          var isCurrentRootChild = (currentRoot.children || []).filter(function (item) {
            return item.depth === node.depth && item.name === node.name;
          });
          if (!isCurrentRootChild.length && root.depth && type === 'nest') {
            return null;
          }
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            React__default['default'].createElement(
              Layer,
              {
                key: 'recharts-treemap-node-'.concat(i),
                className: 'recharts-treemap-depth-'.concat(node.depth),
              },
              this.renderItem(content, nodeProps, isLeaf),
              node.children && node.children.length
                ? node.children.map(function (child, index) {
                    return _this3.renderNode(node, child, index);
                  })
                : null,
            )
          );
        },
      },
      {
        key: 'renderAllNodes',
        value: function renderAllNodes() {
          var formatRoot = this.state.formatRoot;
          if (!formatRoot) {
            return null;
          }
          return this.renderNode(formatRoot, formatRoot, 0);
        },
      },
      {
        key: 'renderTooltip',
        value: function renderTooltip() {
          var _this$props8 = this.props,
            children = _this$props8.children,
            nameKey = _this$props8.nameKey;
          var tooltipItem = findChildByType(children, Tooltip);
          if (!tooltipItem) {
            return null;
          }
          var _this$props9 = this.props,
            width = _this$props9.width,
            height = _this$props9.height;
          var _this$state = this.state,
            isTooltipActive = _this$state.isTooltipActive,
            activeNode = _this$state.activeNode;
          var viewBox = {
            x: 0,
            y: 0,
            width: width,
            height: height,
          };
          var coordinate = activeNode
            ? {
                x: activeNode.x + activeNode.width / 2,
                y: activeNode.y + activeNode.height / 2,
              }
            : null;
          var payload =
            isTooltipActive && activeNode
              ? [
                  {
                    payload: activeNode,
                    name: getValueByDataKey(activeNode, nameKey, ''),
                    value: getValueByDataKey(activeNode, NODE_VALUE_KEY),
                  },
                ]
              : [];
          return /*#__PURE__*/ React__default['default'].cloneElement(tooltipItem, {
            viewBox: viewBox,
            active: isTooltipActive,
            coordinate: coordinate,
            label: '',
            payload: payload,
          });
        },

        // render nest treemap
      },
      {
        key: 'renderNestIndex',
        value: function renderNestIndex() {
          var _this4 = this;
          var _this$props10 = this.props,
            nameKey = _this$props10.nameKey,
            nestIndexContent = _this$props10.nestIndexContent;
          var nestIndex = this.state.nestIndex;
          return /*#__PURE__*/ React__default['default'].createElement(
            'div',
            {
              className: 'recharts-treemap-nest-index-wrapper',
              style: {
                marginTop: '8px',
                textAlign: 'center',
              },
            },
            nestIndex.map(function (item, i) {
              // TODO need to verify nameKey type
              var name = _get(item, nameKey, 'root');
              var content = null;
              if (/*#__PURE__*/ React__default['default'].isValidElement(nestIndexContent)) {
                content = /*#__PURE__*/ React__default['default'].cloneElement(nestIndexContent, item, i);
              }
              if (_isFunction(nestIndexContent)) {
                content = nestIndexContent(item, i);
              } else {
                content = name;
              }
              return (
                /*#__PURE__*/
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                React__default['default'].createElement(
                  'div',
                  {
                    onClick: _this4.handleNestIndex.bind(_this4, item, i),
                    key: 'nest-index-'.concat(uniqueId()),
                    className: 'recharts-treemap-nest-index-box',
                    style: {
                      cursor: 'pointer',
                      display: 'inline-block',
                      padding: '0 7px',
                      background: '#000',
                      color: '#fff',
                      marginRight: '3px',
                    },
                  },
                  content,
                )
              );
            }),
          );
        },
      },
      {
        key: 'render',
        value: function render() {
          if (!validateWidthHeight(this)) {
            return null;
          }
          var _this$props11 = this.props,
            width = _this$props11.width,
            height = _this$props11.height,
            className = _this$props11.className,
            style = _this$props11.style,
            children = _this$props11.children,
            type = _this$props11.type,
            others = _objectWithoutProperties$2(_this$props11, _excluded$2);
          var attrs = filterProps(others);
          return /*#__PURE__*/ React__default['default'].createElement(
            'div',
            {
              className: cx('recharts-wrapper', className),
              style: _objectSpread$4(
                _objectSpread$4({}, style),
                {},
                {
                  position: 'relative',
                  cursor: 'default',
                  width: width,
                  height: height,
                },
              ),
              role: 'region',
            },
            /*#__PURE__*/ React__default['default'].createElement(
              Surface,
              _extends$5({}, attrs, {
                width: width,
                height: type === 'nest' ? height - 30 : height,
              }),
              this.renderAllNodes(),
              filterSvgElements(children),
            ),
            this.renderTooltip(),
            type === 'nest' && this.renderNestIndex(),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (
            nextProps.data !== prevState.prevData ||
            nextProps.type !== prevState.prevType ||
            nextProps.width !== prevState.prevWidth ||
            nextProps.height !== prevState.prevHeight ||
            nextProps.dataKey !== prevState.prevDataKey ||
            nextProps.aspectRatio !== prevState.prevAspectRatio
          ) {
            var root = computeNode({
              depth: 0,
              node: {
                children: nextProps.data,
                x: 0,
                y: 0,
                width: nextProps.width,
                height: nextProps.height,
              },
              index: 0,
              valueKey: nextProps.dataKey,
            });
            var formatRoot = squarify(root, nextProps.aspectRatio);
            return _objectSpread$4(
              _objectSpread$4({}, prevState),
              {},
              {
                formatRoot: formatRoot,
                currentRoot: root,
                nestIndex: [root],
                prevAspectRatio: nextProps.aspectRatio,
                prevData: nextProps.data,
                prevWidth: nextProps.width,
                prevHeight: nextProps.height,
                prevDataKey: nextProps.dataKey,
                prevType: nextProps.type,
              },
            );
          }
          return null;
        },
      },
      {
        key: 'renderContentItem',
        value: function renderContentItem(content, nodeProps, type, colorPanel) {
          if (/*#__PURE__*/ React__default['default'].isValidElement(content)) {
            return /*#__PURE__*/ React__default['default'].cloneElement(content, nodeProps);
          }
          if (_isFunction(content)) {
            return content(nodeProps);
          }
          // optimize default shape
          var x = nodeProps.x,
            y = nodeProps.y,
            width = nodeProps.width,
            height = nodeProps.height,
            index = nodeProps.index;
          var arrow = null;
          if (width > 10 && height > 10 && nodeProps.children && type === 'nest') {
            arrow = /*#__PURE__*/ React__default['default'].createElement(Polygon, {
              points: [
                {
                  x: x + 2,
                  y: y + height / 2,
                },
                {
                  x: x + 6,
                  y: y + height / 2 + 3,
                },
                {
                  x: x + 2,
                  y: y + height / 2 + 6,
                },
              ],
            });
          }
          var text = null;
          var nameSize = getStringSize(nodeProps.name);
          if (width > 20 && height > 20 && nameSize.width < width && nameSize.height < height) {
            text = /*#__PURE__*/ React__default['default'].createElement(
              'text',
              {
                x: x + 8,
                y: y + height / 2 + 7,
                fontSize: 14,
              },
              nodeProps.name,
            );
          }
          var colors = colorPanel || COLOR_PANEL;
          return /*#__PURE__*/ React__default['default'].createElement(
            'g',
            null,
            /*#__PURE__*/ React__default['default'].createElement(
              Rectangle,
              _extends$5(
                {
                  fill: nodeProps.depth < 2 ? colors[index % colors.length] : 'rgba(255,255,255,0)',
                  stroke: '#fff',
                },
                _omit(nodeProps, 'children'),
                {
                  role: 'img',
                },
              ),
            ),
            arrow,
            text,
          );
        },
      },
    ],
  );
  return Treemap;
})(React.PureComponent);
_defineProperty$C(Treemap, 'displayName', 'Treemap');
_defineProperty$C(Treemap, 'defaultProps', {
  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
  dataKey: 'value',
  type: 'flat',
  isAnimationActive: !Global.isSsr,
  isUpdateAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'linear',
});

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */

function baseSum$1(array, iteratee) {
  var result,
    index = -1,
    length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : result + current;
    }
  }
  return result;
}

var _baseSum = baseSum$1;

var baseIteratee = _baseIteratee,
  baseSum = _baseSum;

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return array && array.length ? baseSum(array, baseIteratee(iteratee)) : 0;
}

var sumBy_1 = sumBy;

var _sumBy = /*@__PURE__*/ getDefaultExportFromCjs(sumBy_1);

var _excluded$1 = ['width', 'height', 'className', 'style', 'children'],
  _excluded2$1 = ['sourceX', 'sourceY', 'sourceControlX', 'targetX', 'targetY', 'targetControlX', 'linkWidth'];
function _typeof$E(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$E =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$E(obj)
  );
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _extends$4() {
  _extends$4 = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$4.apply(this, arguments);
}
function _classCallCheck$z(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$z(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$3(descriptor.key), descriptor);
  }
}
function _createClass$z(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$z(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$z(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$y(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$A(subClass, superClass);
}
function _setPrototypeOf$A(o, p) {
  _setPrototypeOf$A = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$A(o, p);
}
function _createSuper$y(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$y();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$y(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$y(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$y(this, result);
  };
}
function _possibleConstructorReturn$y(self, call) {
  if (call && (_typeof$E(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$A(self);
}
function _assertThisInitialized$A(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$y() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$y(o) {
  _getPrototypeOf$y = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$y(o);
}
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$3(Object(source), !0).forEach(function (key) {
          _defineProperty$B(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$3(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _defineProperty$B(obj, key, value) {
  key = _toPropertyKey$3(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$3(arg) {
  var key = _toPrimitive$3(arg, 'string');
  return _typeof$E(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$3(input, hint) {
  if (_typeof$E(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$E(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var defaultCoordinateOfTooltip = {
  x: 0,
  y: 0,
};
var interpolationGenerator = function interpolationGenerator(a, b) {
  var ka = +a;
  var kb = b - ka;
  return function (t) {
    return ka + kb * t;
  };
};
var centerY = function centerY(node) {
  return node.y + node.dy / 2;
};
var getValue = function getValue(entry) {
  return (entry && entry.value) || 0;
};
var getSumOfIds = function getSumOfIds(links, ids) {
  return ids.reduce(function (result, id) {
    return result + getValue(links[id]);
  }, 0);
};
var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var sourceNode = tree[link.source];
    return result + centerY(sourceNode) * getValue(links[id]);
  }, 0);
};
var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var targetNode = tree[link.target];
    return result + centerY(targetNode) * getValue(links[id]);
  }, 0);
};
var ascendingY = function ascendingY(a, b) {
  return a.y - b.y;
};
var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
  var sourceNodes = [];
  var sourceLinks = [];
  var targetNodes = [];
  var targetLinks = [];
  for (var i = 0, len = links.length; i < len; i++) {
    var link = links[i];
    if (link.source === id) {
      targetNodes.push(link.target);
      targetLinks.push(i);
    }
    if (link.target === id) {
      sourceNodes.push(link.source);
      sourceLinks.push(i);
    }
  }
  return {
    sourceNodes: sourceNodes,
    sourceLinks: sourceLinks,
    targetLinks: targetLinks,
    targetNodes: targetNodes,
  };
};
var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
  var targetNodes = curNode.targetNodes;
  for (var i = 0, len = targetNodes.length; i < len; i++) {
    var target = tree[targetNodes[i]];
    if (target) {
      target.depth = Math.max(curNode.depth + 1, target.depth);
      updateDepthOfTargets(tree, target);
    }
  }
};
var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
  var nodes = _ref.nodes,
    links = _ref.links;
  var tree = nodes.map(function (entry, index) {
    var result = searchTargetsAndSources(links, index);
    return _objectSpread$3(
      _objectSpread$3(_objectSpread$3({}, entry), result),
      {},
      {
        value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
        depth: 0,
      },
    );
  });
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    if (!node.sourceNodes.length) {
      updateDepthOfTargets(tree, node);
    }
  }
  var maxDepth = _maxBy(tree, function (entry) {
    return entry.depth;
  }).depth;
  if (maxDepth >= 1) {
    var childWidth = (width - nodeWidth) / maxDepth;
    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
      var _node = tree[_i];
      if (!_node.targetNodes.length) {
        _node.depth = maxDepth;
      }
      _node.x = _node.depth * childWidth;
      _node.dx = nodeWidth;
    }
  }
  return {
    tree: tree,
    maxDepth: maxDepth,
  };
};
var getDepthTree = function getDepthTree(tree) {
  var result = [];
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    if (!result[node.depth]) {
      result[node.depth] = [];
    }
    result[node.depth].push(node);
  }
  return result;
};
var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
  var yRatio = _min(
    depthTree.map(function (nodes) {
      return (height - (nodes.length - 1) * nodePadding) / _sumBy(nodes, getValue);
    }),
  );
  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
    for (var i = 0, len = depthTree[d].length; i < len; i++) {
      var node = depthTree[d][i];
      node.y = i;
      node.dy = node.value * yRatio;
    }
  }
  return links.map(function (link) {
    return _objectSpread$3(
      _objectSpread$3({}, link),
      {},
      {
        dy: getValue(link) * yRatio,
      },
    );
  });
};
var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
  for (var i = 0, len = depthTree.length; i < len; i++) {
    var nodes = depthTree[i];
    var n = nodes.length;

    // Sort by the value of y
    nodes.sort(ascendingY);
    var y0 = 0;
    for (var j = 0; j < n; j++) {
      var node = nodes[j];
      var dy = y0 - node.y;
      if (dy > 0) {
        node.y += dy;
      }
      y0 = node.y + node.dy + nodePadding;
    }
    y0 = height + nodePadding;
    for (var _j = n - 1; _j >= 0; _j--) {
      var _node2 = nodes[_j];
      var _dy = _node2.y + _node2.dy + nodePadding - y0;
      if (_dy > 0) {
        _node2.y -= _dy;
        y0 = _node2.y;
      } else {
        break;
      }
    }
  }
};
var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
    var nodes = depthTree[i];
    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];
      if (node.sourceLinks.length) {
        var sourceSum = getSumOfIds(links, node.sourceLinks);
        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
        var y = weightedSum / sourceSum;
        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};
var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
  for (var i = depthTree.length - 1; i >= 0; i--) {
    var nodes = depthTree[i];
    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];
      if (node.targetLinks.length) {
        var targetSum = getSumOfIds(links, node.targetLinks);
        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
        var y = weightedSum / targetSum;
        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};
var updateYOfLinks = function updateYOfLinks(tree, links) {
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    var sy = 0;
    var ty = 0;
    node.targetLinks.sort(function (a, b) {
      return tree[links[a].target].y - tree[links[b].target].y;
    });
    node.sourceLinks.sort(function (a, b) {
      return tree[links[a].source].y - tree[links[b].source].y;
    });
    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
      var link = links[node.targetLinks[j]];
      if (link) {
        link.sy = sy;
        sy += link.dy;
      }
    }
    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
      var _link = links[node.sourceLinks[_j2]];
      if (_link) {
        _link.ty = ty;
        ty += _link.dy;
      }
    }
  }
};
var computeData = function computeData(_ref2) {
  var data = _ref2.data,
    width = _ref2.width,
    height = _ref2.height,
    iterations = _ref2.iterations,
    nodeWidth = _ref2.nodeWidth,
    nodePadding = _ref2.nodePadding;
  var links = data.links;
  var _getNodesTree = getNodesTree(data, width, nodeWidth),
    tree = _getNodesTree.tree;
  var depthTree = getDepthTree(tree);
  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
  resolveCollisions(depthTree, height, nodePadding);
  var alpha = 1;
  for (var i = 1; i <= iterations; i++) {
    relaxRightToLeft(tree, depthTree, newLinks, (alpha *= 0.99));
    resolveCollisions(depthTree, height, nodePadding);
    relaxLeftToRight(tree, depthTree, newLinks, alpha);
    resolveCollisions(depthTree, height, nodePadding);
  }
  updateYOfLinks(tree, newLinks);
  return {
    nodes: tree,
    links: newLinks,
  };
};
var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
  if (type === 'node') {
    return {
      x: el.x + el.width / 2,
      y: el.y + el.height / 2,
    };
  }
  return {
    x: (el.sourceX + el.targetX) / 2,
    y: (el.sourceY + el.targetY) / 2,
  };
};
var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
  var payload = el.payload;
  if (type === 'node') {
    return [
      {
        payload: el,
        name: getValueByDataKey(payload, nameKey, ''),
        value: getValueByDataKey(payload, 'value'),
      },
    ];
  }
  if (payload.source && payload.target) {
    var sourceName = getValueByDataKey(payload.source, nameKey, '');
    var targetName = getValueByDataKey(payload.target, nameKey, '');
    return [
      {
        payload: el,
        name: ''.concat(sourceName, ' - ').concat(targetName),
        value: getValueByDataKey(payload, 'value'),
      },
    ];
  }
  return [];
};
var Sankey = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$y(Sankey, _PureComponent);
  var _super = _createSuper$y(Sankey);
  function Sankey() {
    var _this;
    _classCallCheck$z(this, Sankey);
    for (var _len2 = arguments.length, args = new Array(_len2), _key = 0; _key < _len2; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$B(_assertThisInitialized$A(_this), 'state', {
      activeElement: null,
      activeElementType: null,
      isTooltipActive: false,
      nodes: [],
      links: [],
    });
    return _this;
  }
  _createClass$z(
    Sankey,
    [
      {
        key: 'handleMouseEnter',
        value: function handleMouseEnter(el, type, e) {
          var _this$props = this.props,
            onMouseEnter = _this$props.onMouseEnter,
            children = _this$props.children;
          var tooltipItem = findChildByType(children, Tooltip);
          if (tooltipItem) {
            this.setState(
              function (prev) {
                if (tooltipItem.props.trigger === 'hover') {
                  return _objectSpread$3(
                    _objectSpread$3({}, prev),
                    {},
                    {
                      activeElement: el,
                      activeElementType: type,
                      isTooltipActive: true,
                    },
                  );
                }
                return prev;
              },
              function () {
                if (onMouseEnter) {
                  onMouseEnter(el, type, e);
                }
              },
            );
          } else if (onMouseEnter) {
            onMouseEnter(el, type, e);
          }
        },
      },
      {
        key: 'handleMouseLeave',
        value: function handleMouseLeave(el, type, e) {
          var _this$props2 = this.props,
            onMouseLeave = _this$props2.onMouseLeave,
            children = _this$props2.children;
          var tooltipItem = findChildByType(children, Tooltip);
          if (tooltipItem) {
            this.setState(
              function (prev) {
                if (tooltipItem.props.trigger === 'hover') {
                  return _objectSpread$3(
                    _objectSpread$3({}, prev),
                    {},
                    {
                      activeElement: undefined,
                      activeElementType: undefined,
                      isTooltipActive: false,
                    },
                  );
                }
                return prev;
              },
              function () {
                if (onMouseLeave) {
                  onMouseLeave(el, type, e);
                }
              },
            );
          } else if (onMouseLeave) {
            onMouseLeave(el, type, e);
          }
        },
      },
      {
        key: 'handleClick',
        value: function handleClick(el, type, e) {
          var _this$props3 = this.props,
            onClick = _this$props3.onClick,
            children = _this$props3.children;
          var tooltipItem = findChildByType(children, Tooltip);
          if (tooltipItem && tooltipItem.props.trigger === 'click') {
            if (this.state.isTooltipActive) {
              this.setState(function (prev) {
                return _objectSpread$3(
                  _objectSpread$3({}, prev),
                  {},
                  {
                    activeElement: undefined,
                    activeElementType: undefined,
                    isTooltipActive: false,
                  },
                );
              });
            } else {
              this.setState(function (prev) {
                return _objectSpread$3(
                  _objectSpread$3({}, prev),
                  {},
                  {
                    activeElement: el,
                    activeElementType: type,
                    isTooltipActive: true,
                  },
                );
              });
            }
          }
          if (onClick) onClick(el, type, e);
        },
      },
      {
        key: 'renderLinks',
        value: function renderLinks(links, nodes) {
          var _this2 = this;
          var _this$props4 = this.props,
            linkCurvature = _this$props4.linkCurvature,
            linkContent = _this$props4.link,
            margin = _this$props4.margin;
          var top = _get(margin, 'top') || 0;
          var left = _get(margin, 'left') || 0;
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-sankey-links',
              key: 'recharts-sankey-links',
            },
            links.map(function (link, i) {
              var sourceRelativeY = link.sy,
                targetRelativeY = link.ty,
                linkWidth = link.dy;
              var source = nodes[link.source];
              var target = nodes[link.target];
              var sourceX = source.x + source.dx + left;
              var targetX = target.x + left;
              var interpolationFunc = interpolationGenerator(sourceX, targetX);
              var sourceControlX = interpolationFunc(linkCurvature);
              var targetControlX = interpolationFunc(1 - linkCurvature);
              var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
              var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
              var linkProps = _objectSpread$3(
                {
                  sourceX: sourceX,
                  targetX: targetX,
                  sourceY: sourceY,
                  targetY: targetY,
                  sourceControlX: sourceControlX,
                  targetControlX: targetControlX,
                  sourceRelativeY: sourceRelativeY,
                  targetRelativeY: targetRelativeY,
                  linkWidth: linkWidth,
                  index: i,
                  payload: _objectSpread$3(
                    _objectSpread$3({}, link),
                    {},
                    {
                      source: source,
                      target: target,
                    },
                  ),
                },
                filterProps(linkContent),
              );
              var events = {
                onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
                onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link'),
                onClick: _this2.handleClick.bind(_this2, linkProps, 'link'),
              };
              return (
                /*#__PURE__*/
                // eslint-disable-next-line react/no-array-index-key
                React__default['default'].createElement(
                  Layer,
                  _extends$4(
                    {
                      key: 'link'.concat(i),
                    },
                    events,
                  ),
                  _this2.constructor.renderLinkItem(linkContent, linkProps),
                )
              );
            }),
          );
        },
      },
      {
        key: 'renderNodes',
        value: function renderNodes(nodes) {
          var _this3 = this;
          var _this$props5 = this.props,
            nodeContent = _this$props5.node,
            margin = _this$props5.margin;
          var top = _get(margin, 'top') || 0;
          var left = _get(margin, 'left') || 0;
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: 'recharts-sankey-nodes',
              key: 'recharts-sankey-nodes',
            },
            nodes.map(function (node, i) {
              var x = node.x,
                y = node.y,
                dx = node.dx,
                dy = node.dy;
              var nodeProps = _objectSpread$3(
                _objectSpread$3({}, filterProps(nodeContent)),
                {},
                {
                  x: x + left,
                  y: y + top,
                  width: dx,
                  height: dy,
                  index: i,
                  payload: node,
                },
              );
              var events = {
                onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
                onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node'),
                onClick: _this3.handleClick.bind(_this3, nodeProps, 'node'),
              };
              return (
                /*#__PURE__*/
                // eslint-disable-next-line react/no-array-index-key
                React__default['default'].createElement(
                  Layer,
                  _extends$4(
                    {
                      key: 'node'.concat(i),
                    },
                    events,
                  ),
                  _this3.constructor.renderNodeItem(nodeContent, nodeProps),
                )
              );
            }),
          );
        },
      },
      {
        key: 'renderTooltip',
        value: function renderTooltip() {
          var _this$props6 = this.props,
            children = _this$props6.children,
            width = _this$props6.width,
            height = _this$props6.height,
            nameKey = _this$props6.nameKey;
          var tooltipItem = findChildByType(children, Tooltip);
          if (!tooltipItem) {
            return null;
          }
          var _this$state = this.state,
            isTooltipActive = _this$state.isTooltipActive,
            activeElement = _this$state.activeElement,
            activeElementType = _this$state.activeElementType;
          var viewBox = {
            x: 0,
            y: 0,
            width: width,
            height: height,
          };
          var coordinate = activeElement
            ? getCoordinateOfTooltip(activeElement, activeElementType)
            : defaultCoordinateOfTooltip;
          var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
          return /*#__PURE__*/ React__default['default'].cloneElement(tooltipItem, {
            viewBox: viewBox,
            active: isTooltipActive,
            coordinate: coordinate,
            label: '',
            payload: payload,
          });
        },
      },
      {
        key: 'render',
        value: function render() {
          if (!validateWidthHeight(this)) {
            return null;
          }
          var _this$props7 = this.props,
            width = _this$props7.width,
            height = _this$props7.height,
            className = _this$props7.className,
            style = _this$props7.style,
            children = _this$props7.children,
            others = _objectWithoutProperties$1(_this$props7, _excluded$1);
          var _this$state2 = this.state,
            links = _this$state2.links,
            nodes = _this$state2.nodes;
          var attrs = filterProps(others);
          return /*#__PURE__*/ React__default['default'].createElement(
            'div',
            {
              className: cx('recharts-wrapper', className),
              style: _objectSpread$3(
                _objectSpread$3({}, style),
                {},
                {
                  position: 'relative',
                  cursor: 'default',
                  width: width,
                  height: height,
                },
              ),
              role: 'region',
            },
            /*#__PURE__*/ React__default['default'].createElement(
              Surface,
              _extends$4({}, attrs, {
                width: width,
                height: height,
              }),
              filterSvgElements(children),
              this.renderLinks(links, nodes),
              this.renderNodes(nodes),
            ),
            this.renderTooltip(),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          var data = nextProps.data,
            width = nextProps.width,
            height = nextProps.height,
            margin = nextProps.margin,
            iterations = nextProps.iterations,
            nodeWidth = nextProps.nodeWidth,
            nodePadding = nextProps.nodePadding;
          if (
            data !== prevState.prevData ||
            width !== prevState.prevWidth ||
            height !== prevState.prevHeight ||
            !shallowEqual$1(margin, prevState.prevMargin) ||
            iterations !== prevState.prevIterations ||
            nodeWidth !== prevState.prevNodeWidth ||
            nodePadding !== prevState.prevNodePadding
          ) {
            var contentWidth = width - ((margin && margin.left) || 0) - ((margin && margin.right) || 0);
            var contentHeight = height - ((margin && margin.top) || 0) - ((margin && margin.bottom) || 0);
            var _computeData = computeData({
                data: data,
                width: contentWidth,
                height: contentHeight,
                iterations: iterations,
                nodeWidth: nodeWidth,
                nodePadding: nodePadding,
              }),
              links = _computeData.links,
              nodes = _computeData.nodes;
            return _objectSpread$3(
              _objectSpread$3({}, prevState),
              {},
              {
                nodes: nodes,
                links: links,
                prevData: data,
                prevWidth: iterations,
                prevHeight: height,
                prevMargin: margin,
                prevNodePadding: nodePadding,
                prevNodeWidth: nodeWidth,
                prevIterations: iterations,
              },
            );
          }
          return null;
        },
      },
      {
        key: 'renderLinkItem',
        value: function renderLinkItem(option, props) {
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            return /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          }
          if (_isFunction(option)) {
            return option(props);
          }
          var sourceX = props.sourceX,
            sourceY = props.sourceY,
            sourceControlX = props.sourceControlX,
            targetX = props.targetX,
            targetY = props.targetY,
            targetControlX = props.targetControlX,
            linkWidth = props.linkWidth,
            others = _objectWithoutProperties$1(props, _excluded2$1);
          return /*#__PURE__*/ React__default['default'].createElement(
            'path',
            _extends$4(
              {
                className: 'recharts-sankey-link',
                d: '\n          M'
                  .concat(sourceX, ',')
                  .concat(sourceY, '\n          C')
                  .concat(sourceControlX, ',')
                  .concat(sourceY, ' ')
                  .concat(targetControlX, ',')
                  .concat(targetY, ' ')
                  .concat(targetX, ',')
                  .concat(targetY, '\n        '),
                fill: 'none',
                stroke: '#333',
                strokeWidth: linkWidth,
                strokeOpacity: '0.2',
              },
              filterProps(others),
            ),
          );
        },
      },
      {
        key: 'renderNodeItem',
        value: function renderNodeItem(option, props) {
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            return /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          }
          if (_isFunction(option)) {
            return option(props);
          }
          return /*#__PURE__*/ React__default['default'].createElement(
            Rectangle,
            _extends$4(
              {
                className: 'recharts-sankey-node',
                fill: '#0088fe',
                fillOpacity: '0.8',
              },
              filterProps(props),
              {
                role: 'img',
              },
            ),
          );
        },
      },
    ],
  );
  return Sankey;
})(React.PureComponent);
_defineProperty$B(Sankey, 'displayName', 'Sankey');
_defineProperty$B(Sankey, 'defaultProps', {
  nameKey: 'name',
  dataKey: 'value',
  nodePadding: 10,
  nodeWidth: 10,
  linkCurvature: 0.5,
  iterations: 32,
  margin: {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5,
  },
});

/**
 * @fileOverview Radar Chart
 */
generateCategoricalChart({
  chartName: 'RadarChart',
  GraphicalChild: Radar,
  axisComponents: [
    {
      axisType: 'angleAxis',
      AxisComp: PolarAngleAxis,
    },
    {
      axisType: 'radiusAxis',
      AxisComp: PolarRadiusAxis,
    },
  ],
  formatAxisMap: formatAxisMap$1,
  defaultProps: {
    layout: 'centric',
    startAngle: 90,
    endAngle: -270,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%',
  },
});

/**
 * @fileOverview Scatter Chart
 */
generateCategoricalChart({
  chartName: 'ScatterChart',
  GraphicalChild: Scatter,
  defaultTooltipEventType: 'item',
  validateTooltipEventTypes: ['item'],
  axisComponents: [
    {
      axisType: 'xAxis',
      AxisComp: XAxis,
    },
    {
      axisType: 'yAxis',
      AxisComp: YAxis,
    },
    {
      axisType: 'zAxis',
      AxisComp: ZAxis,
    },
  ],
  formatAxisMap: formatAxisMap,
});

/**
 * @fileOverview Area Chart
 */
generateCategoricalChart({
  chartName: 'AreaChart',
  GraphicalChild: Area,
  axisComponents: [
    {
      axisType: 'xAxis',
      AxisComp: XAxis,
    },
    {
      axisType: 'yAxis',
      AxisComp: YAxis,
    },
  ],
  formatAxisMap: formatAxisMap,
});

/**
 * @fileOverview Radar Bar Chart
 */
generateCategoricalChart({
  chartName: 'RadialBarChart',
  GraphicalChild: RadialBar,
  legendContent: 'children',
  defaultTooltipEventType: 'axis',
  validateTooltipEventTypes: ['axis', 'item'],
  axisComponents: [
    {
      axisType: 'angleAxis',
      AxisComp: PolarAngleAxis,
    },
    {
      axisType: 'radiusAxis',
      AxisComp: PolarRadiusAxis,
    },
  ],
  formatAxisMap: formatAxisMap$1,
  defaultProps: {
    layout: 'radial',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%',
  },
});

/**
 * @fileOverview Composed Chart
 */
generateCategoricalChart({
  chartName: 'ComposedChart',
  GraphicalChild: [Line, Area, Bar, Scatter],
  axisComponents: [
    {
      axisType: 'xAxis',
      AxisComp: XAxis,
    },
    {
      axisType: 'yAxis',
      AxisComp: YAxis,
    },
    {
      axisType: 'zAxis',
      AxisComp: ZAxis,
    },
  ],
  formatAxisMap: formatAxisMap,
});

function _typeof$D(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$D =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$D(obj)
  );
}
function _extends$3() {
  _extends$3 = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$3.apply(this, arguments);
}
function _classCallCheck$y(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$y(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor);
  }
}
function _createClass$y(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$y(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$y(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$x(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$z(subClass, superClass);
}
function _setPrototypeOf$z(o, p) {
  _setPrototypeOf$z = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$z(o, p);
}
function _createSuper$x(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$x();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$x(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$x(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$x(this, result);
  };
}
function _possibleConstructorReturn$x(self, call) {
  if (call && (_typeof$D(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$z(self);
}
function _assertThisInitialized$z(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$x() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$x(o) {
  _getPrototypeOf$x = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$x(o);
}
function _defineProperty$A(obj, key, value) {
  key = _toPropertyKey$2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$2(arg) {
  var key = _toPrimitive$2(arg, 'string');
  return _typeof$D(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$2(input, hint) {
  if (_typeof$D(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$D(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
  var widthGap = upperWidth - lowerWidth;
  var path;
  path = 'M '.concat(x, ',').concat(y);
  path += 'L '.concat(x + upperWidth, ',').concat(y);
  path += 'L '.concat(x + upperWidth - widthGap / 2, ',').concat(y + height);
  path += 'L '.concat(x + upperWidth - widthGap / 2 - lowerWidth, ',').concat(y + height);
  path += 'L '.concat(x, ',').concat(y, ' Z');
  return path;
};
var Trapezoid = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$x(Trapezoid, _PureComponent);
  var _super = _createSuper$x(Trapezoid);
  function Trapezoid() {
    var _this;
    _classCallCheck$y(this, Trapezoid);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$A(_assertThisInitialized$z(_this), 'state', {
      totalLength: -1,
    });
    return _this;
  }
  _createClass$y(Trapezoid, [
    {
      key: 'componentDidMount',
      /* eslint-disable  react/no-did-mount-set-state */
      value: function componentDidMount() {
        if (this.node && this.node.getTotalLength) {
          try {
            var totalLength = this.node.getTotalLength();
            if (totalLength) {
              this.setState({
                totalLength: totalLength,
              });
            }
          } catch (err) {
            // calculate total length error
          }
        }
      },
    },
    {
      key: 'render',
      value: function render() {
        var _this2 = this;
        var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          upperWidth = _this$props.upperWidth,
          lowerWidth = _this$props.lowerWidth,
          height = _this$props.height,
          className = _this$props.className;
        var totalLength = this.state.totalLength;
        var _this$props2 = this.props,
          animationEasing = _this$props2.animationEasing,
          animationDuration = _this$props2.animationDuration,
          animationBegin = _this$props2.animationBegin,
          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
        if (
          x !== +x ||
          y !== +y ||
          upperWidth !== +upperWidth ||
          lowerWidth !== +lowerWidth ||
          height !== +height ||
          (upperWidth === 0 && lowerWidth === 0) ||
          height === 0
        ) {
          return null;
        }
        var layerClass = cx('recharts-trapezoid', className);
        if (!isUpdateAnimationActive) {
          return /*#__PURE__*/ React__default['default'].createElement(
            'g',
            null,
            /*#__PURE__*/ React__default['default'].createElement(
              'path',
              _extends$3({}, filterProps(this.props, true), {
                className: layerClass,
                d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height),
              }),
            ),
          );
        }
        return /*#__PURE__*/ React__default['default'].createElement(
          Animate,
          {
            canBegin: totalLength > 0,
            from: {
              upperWidth: 0,
              lowerWidth: 0,
              height: height,
              x: x,
              y: y,
            },
            to: {
              upperWidth: upperWidth,
              lowerWidth: lowerWidth,
              height: height,
              x: x,
              y: y,
            },
            duration: animationDuration,
            animationEasing: animationEasing,
            isActive: isUpdateAnimationActive,
          },
          function (_ref) {
            var currUpperWidth = _ref.upperWidth,
              currLowerWidth = _ref.lowerWidth,
              currHeight = _ref.height,
              currX = _ref.x,
              currY = _ref.y;
            return /*#__PURE__*/ React__default['default'].createElement(
              Animate,
              {
                canBegin: totalLength > 0,
                from: '0px '.concat(totalLength === -1 ? 1 : totalLength, 'px'),
                to: ''.concat(totalLength, 'px 0px'),
                attributeName: 'strokeDasharray',
                begin: animationBegin,
                duration: animationDuration,
                easing: animationEasing,
              },
              /*#__PURE__*/ React__default['default'].createElement(
                'path',
                _extends$3({}, filterProps(_this2.props, true), {
                  className: layerClass,
                  d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
                  ref: function ref(node) {
                    _this2.node = node;
                  },
                }),
              ),
            );
          },
        );
      },
    },
  ]);
  return Trapezoid;
})(React.PureComponent);
_defineProperty$A(Trapezoid, 'defaultProps', {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
});

function _slicedToArray$2(arr, i) {
  return (
    _arrayWithHoles$2(arr) ||
    _iterableToArrayLimit$2(arr, i) ||
    _unsupportedIterableToArray$3(arr, i) ||
    _nonIterableRest$2()
  );
}
function _nonIterableRest$2() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray$3(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit$2(arr, i) {
  var _i = null == arr ? null : ('undefined' != typeof Symbol && arr[Symbol.iterator]) || arr['@@iterator'];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      (_d = !0), (_e = err);
    } finally {
      try {
        if (!_n && null != _i['return'] && ((_r = _i['return']()), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}
function _typeof$C(obj) {
  '@babel/helpers - typeof';
  return (
    (_typeof$C =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof$C(obj)
  );
}
function _extends$2() {
  _extends$2 = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$2.apply(this, arguments);
}
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$2(Object(source), !0).forEach(function (key) {
          _defineProperty$z(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$2(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}
function _classCallCheck$x(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _defineProperties$x(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass$x(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$x(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$x(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
function _inherits$w(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  Object.defineProperty(subClass, 'prototype', { writable: false });
  if (superClass) _setPrototypeOf$y(subClass, superClass);
}
function _setPrototypeOf$y(o, p) {
  _setPrototypeOf$y = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf$y(o, p);
}
function _createSuper$w(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$w();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$w(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$w(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$w(this, result);
  };
}
function _possibleConstructorReturn$w(self, call) {
  if (call && (_typeof$C(call) === 'object' || typeof call === 'function')) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }
  return _assertThisInitialized$y(self);
}
function _assertThisInitialized$y(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$w() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$w(o) {
  _getPrototypeOf$w = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$w(o);
}
function _defineProperty$z(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, 'string');
  return _typeof$C(key) === 'symbol' ? key : String(key);
}
function _toPrimitive$1(input, hint) {
  if (_typeof$C(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof$C(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
var Funnel = /*#__PURE__*/ (function (_PureComponent) {
  _inherits$w(Funnel, _PureComponent);
  var _super = _createSuper$w(Funnel);
  function Funnel() {
    var _this;
    _classCallCheck$x(this, Funnel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$z(_assertThisInitialized$y(_this), 'state', {
      isAnimationFinished: false,
    });
    _defineProperty$z(_assertThisInitialized$y(_this), 'handleAnimationEnd', function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true,
      });
      if (_isFunction(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$z(_assertThisInitialized$y(_this), 'handleAnimationStart', function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false,
      });
      if (_isFunction(onAnimationStart)) {
        onAnimationStart();
      }
    });
    return _this;
  }
  _createClass$x(
    Funnel,
    [
      {
        key: 'isActiveIndex',
        value: function isActiveIndex(i) {
          var activeIndex = this.props.activeIndex;
          if (Array.isArray(activeIndex)) {
            return activeIndex.indexOf(i) !== -1;
          }
          return i === activeIndex;
        },
      },
      {
        key: 'renderTrapezoidsStatically',
        value: function renderTrapezoidsStatically(trapezoids) {
          var _this2 = this;
          var activeShape = this.props.activeShape;
          return trapezoids.map(function (entry, i) {
            var trapezoidOptions = _this2.isActiveIndex(i) ? activeShape : null;
            var trapezoidProps = _objectSpread$2(
              _objectSpread$2({}, entry),
              {},
              {
                stroke: entry.stroke,
              },
            );
            return /*#__PURE__*/ React__default['default'].createElement(
              Layer,
              _extends$2(
                {
                  className: 'recharts-funnel-trapezoid',
                },
                adaptEventsOfChild(_this2.props, entry, i),
                {
                  key: 'trapezoid-'.concat(i), // eslint-disable-line react/no-array-index-key
                  role: 'img',
                },
              ),
              Funnel.renderTrapezoidItem(trapezoidOptions, trapezoidProps),
            );
          });
        },
      },
      {
        key: 'renderTrapezoidsWithAnimation',
        value: function renderTrapezoidsWithAnimation() {
          var _this3 = this;
          var _this$props = this.props,
            trapezoids = _this$props.trapezoids,
            isAnimationActive = _this$props.isAnimationActive,
            animationBegin = _this$props.animationBegin,
            animationDuration = _this$props.animationDuration,
            animationEasing = _this$props.animationEasing,
            animationId = _this$props.animationId;
          var prevTrapezoids = this.state.prevTrapezoids;
          return /*#__PURE__*/ React__default['default'].createElement(
            Animate,
            {
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing,
              from: {
                t: 0,
              },
              to: {
                t: 1,
              },
              key: 'funnel-'.concat(animationId),
              onAnimationStart: this.handleAnimationStart,
              onAnimationEnd: this.handleAnimationEnd,
            },
            function (_ref) {
              var t = _ref.t;
              var stepData = trapezoids.map(function (entry, index) {
                var prev = prevTrapezoids && prevTrapezoids[index];
                if (prev) {
                  var _interpolatorX = interpolateNumber$2(prev.x, entry.x);
                  var _interpolatorY = interpolateNumber$2(prev.y, entry.y);
                  var _interpolatorUpperWidth = interpolateNumber$2(prev.upperWidth, entry.upperWidth);
                  var _interpolatorLowerWidth = interpolateNumber$2(prev.lowerWidth, entry.lowerWidth);
                  var _interpolatorHeight = interpolateNumber$2(prev.height, entry.height);
                  return _objectSpread$2(
                    _objectSpread$2({}, entry),
                    {},
                    {
                      x: _interpolatorX(t),
                      y: _interpolatorY(t),
                      upperWidth: _interpolatorUpperWidth(t),
                      lowerWidth: _interpolatorLowerWidth(t),
                      height: _interpolatorHeight(t),
                    },
                  );
                }
                var interpolatorX = interpolateNumber$2(entry.x + entry.upperWidth / 2, entry.x);
                var interpolatorY = interpolateNumber$2(entry.y + entry.height / 2, entry.y);
                var interpolatorUpperWidth = interpolateNumber$2(0, entry.upperWidth);
                var interpolatorLowerWidth = interpolateNumber$2(0, entry.lowerWidth);
                var interpolatorHeight = interpolateNumber$2(0, entry.height);
                return _objectSpread$2(
                  _objectSpread$2({}, entry),
                  {},
                  {
                    x: interpolatorX(t),
                    y: interpolatorY(t),
                    upperWidth: interpolatorUpperWidth(t),
                    lowerWidth: interpolatorLowerWidth(t),
                    height: interpolatorHeight(t),
                  },
                );
              });
              return /*#__PURE__*/ React__default['default'].createElement(
                Layer,
                null,
                _this3.renderTrapezoidsStatically(stepData),
              );
            },
          );
        },
      },
      {
        key: 'renderTrapezoids',
        value: function renderTrapezoids() {
          var _this$props2 = this.props,
            trapezoids = _this$props2.trapezoids,
            isAnimationActive = _this$props2.isAnimationActive;
          var prevTrapezoids = this.state.prevTrapezoids;
          if (
            isAnimationActive &&
            trapezoids &&
            trapezoids.length &&
            (!prevTrapezoids || !_isEqual(prevTrapezoids, trapezoids))
          ) {
            return this.renderTrapezoidsWithAnimation();
          }
          return this.renderTrapezoidsStatically(trapezoids);
        },
      },
      {
        key: 'render',
        value: function render() {
          var _this$props3 = this.props,
            hide = _this$props3.hide,
            trapezoids = _this$props3.trapezoids,
            className = _this$props3.className,
            isAnimationActive = _this$props3.isAnimationActive;
          var isAnimationFinished = this.state.isAnimationFinished;
          if (hide || !trapezoids || !trapezoids.length) {
            return null;
          }
          var layerClass = cx('recharts-trapezoids', className);
          return /*#__PURE__*/ React__default['default'].createElement(
            Layer,
            {
              className: layerClass,
            },
            this.renderTrapezoids(),
            (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, trapezoids),
          );
        },
      },
    ],
    [
      {
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (nextProps.animationId !== prevState.prevAnimationId) {
            return {
              prevAnimationId: nextProps.animationId,
              curTrapezoids: nextProps.trapezoids,
              prevTrapezoids: prevState.curTrapezoids,
            };
          }
          if (nextProps.trapezoids !== prevState.curTrapezoids) {
            return {
              curTrapezoids: nextProps.trapezoids,
            };
          }
          return null;
        },
      },
      {
        key: 'renderTrapezoidItem',
        value: function renderTrapezoidItem(option, props) {
          if (/*#__PURE__*/ React__default['default'].isValidElement(option)) {
            return /*#__PURE__*/ React__default['default'].cloneElement(option, props);
          }
          if (_isFunction(option)) {
            return option(props);
          }
          if (_isPlainObject(option)) {
            return /*#__PURE__*/ React__default['default'].createElement(Trapezoid, _extends$2({}, props, option));
          }
          return /*#__PURE__*/ React__default['default'].createElement(Trapezoid, props);
        },
      },
    ],
  );
  return Funnel;
})(React.PureComponent);
_defineProperty$z(Funnel, 'displayName', 'Funnel');
_defineProperty$z(Funnel, 'defaultProps', {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  labelLine: true,
  hide: false,
  isAnimationActive: !Global.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease',
  nameKey: 'name',
  lastShapeType: 'triangle',
});
_defineProperty$z(Funnel, 'getRealFunnelData', function (item) {
  var _item$props = item.props,
    data = _item$props.data,
    children = _item$props.children;
  var presentationProps = filterProps(item.props);
  var cells = findAllByType(children, Cell);
  if (data && data.length) {
    return data.map(function (entry, index) {
      return _objectSpread$2(
        _objectSpread$2(
          _objectSpread$2(
            {
              payload: entry,
            },
            presentationProps,
          ),
          entry,
        ),
        cells && cells[index] && cells[index].props,
      );
    });
  }
  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _objectSpread$2(_objectSpread$2({}, presentationProps), cell.props);
    });
  }
  return [];
});
_defineProperty$z(Funnel, 'getRealWidthHeight', function (item, offset) {
  var customWidth = item.props.width;
  var width = offset.width,
    height = offset.height,
    left = offset.left,
    right = offset.right,
    top = offset.top,
    bottom = offset.bottom;
  var realHeight = height;
  var realWidth = width;
  if (_isNumber(customWidth)) {
    realWidth = customWidth;
  } else if (_isString(customWidth)) {
    realWidth = (realWidth * parseFloat(customWidth)) / 100;
  }
  return {
    realWidth: realWidth - left - right - 50,
    realHeight: realHeight - bottom - top,
    offsetX: (width - realWidth) / 2,
    offsetY: (height - realHeight) / 2,
  };
});
_defineProperty$z(Funnel, 'getComposedData', function (_ref2) {
  var item = _ref2.item,
    offset = _ref2.offset;
  var funnelData = Funnel.getRealFunnelData(item);
  var _item$props2 = item.props,
    dataKey = _item$props2.dataKey,
    nameKey = _item$props2.nameKey,
    tooltipType = _item$props2.tooltipType,
    lastShapeType = _item$props2.lastShapeType,
    reversed = _item$props2.reversed;
  var left = offset.left,
    top = offset.top;
  var _Funnel$getRealWidthH = Funnel.getRealWidthHeight(item, offset),
    realHeight = _Funnel$getRealWidthH.realHeight,
    realWidth = _Funnel$getRealWidthH.realWidth,
    offsetX = _Funnel$getRealWidthH.offsetX,
    offsetY = _Funnel$getRealWidthH.offsetY;
  var maxValue = Math.max.apply(
    null,
    funnelData.map(function (entry) {
      return getValueByDataKey(entry, dataKey, 0);
    }),
  );
  var len = funnelData.length;
  var rowHeight = realHeight / len;
  var parentViewBox = {
    x: offset.left,
    y: offset.top,
    width: offset.width,
    height: offset.height,
  };
  var trapezoids = funnelData.map(function (entry, i) {
    var rawVal = getValueByDataKey(entry, dataKey, 0);
    var name = getValueByDataKey(entry, nameKey, i);
    var val = rawVal;
    var nextVal;
    if (i !== len - 1) {
      nextVal = getValueByDataKey(funnelData[i + 1], dataKey, 0);
      if (nextVal instanceof Array) {
        var _nextVal = nextVal;
        var _nextVal2 = _slicedToArray$2(_nextVal, 1);
        nextVal = _nextVal2[0];
      }
    } else if (rawVal instanceof Array && rawVal.length === 2) {
      var _rawVal = _slicedToArray$2(rawVal, 2);
      val = _rawVal[0];
      nextVal = _rawVal[1];
    } else if (lastShapeType === 'rectangle') {
      nextVal = val;
    } else {
      nextVal = 0;
    }
    var x = ((maxValue - val) * realWidth) / (2 * maxValue) + top + 25 + offsetX;
    var y = rowHeight * i + left + offsetY;
    var upperWidth = (val / maxValue) * realWidth;
    var lowerWidth = (nextVal / maxValue) * realWidth;
    var tooltipPayload = [
      {
        name: name,
        value: val,
        payload: entry,
        dataKey: dataKey,
        type: tooltipType,
      },
    ];
    var tooltipPosition = {
      x: x + upperWidth / 2,
      y: y + rowHeight / 2,
    };
    return _objectSpread$2(
      _objectSpread$2(
        {
          x: x,
          y: y,
          width: Math.max(upperWidth, lowerWidth),
          upperWidth: upperWidth,
          lowerWidth: lowerWidth,
          height: rowHeight,
          name: name,
          val: val,
          tooltipPayload: tooltipPayload,
          tooltipPosition: tooltipPosition,
        },
        _omit(entry, 'width'),
      ),
      {},
      {
        payload: entry,
        parentViewBox: parentViewBox,
        labelViewBox: {
          x: x + (upperWidth - lowerWidth) / 4,
          y: y,
          width: Math.abs(upperWidth - lowerWidth) / 2 + Math.min(upperWidth, lowerWidth),
          height: rowHeight,
        },
      },
    );
  });
  if (reversed) {
    trapezoids = trapezoids.map(function (entry, index) {
      var newY = entry.y - index * rowHeight + (len - 1 - index) * rowHeight;
      return _objectSpread$2(
        _objectSpread$2({}, entry),
        {},
        {
          upperWidth: entry.lowerWidth,
          lowerWidth: entry.upperWidth,
          x: entry.x - (entry.lowerWidth - entry.upperWidth) / 2,
          y: entry.y - index * rowHeight + (len - 1 - index) * rowHeight,
          tooltipPosition: _objectSpread$2(
            _objectSpread$2({}, entry.tooltipPosition),
            {},
            {
              y: newY + rowHeight / 2,
            },
          ),
          labelViewBox: _objectSpread$2(
            _objectSpread$2({}, entry.labelViewBox),
            {},
            {
              y: newY,
            },
          ),
        },
      );
    });
  }
  return {
    trapezoids: trapezoids,
    data: funnelData,
  };
});

/**
 * @fileOverview Funnel Chart
 */
generateCategoricalChart({
  chartName: 'FunnelChart',
  GraphicalChild: Funnel,
  validateTooltipEventTypes: ['item'],
  defaultTooltipEventType: 'item',
  axisComponents: [],
  defaultProps: {
    layout: 'centric',
  },
});

var XAxisDisplayController = function (_a) {
  var data = _a.data,
    styles = _a.styles,
    series = _a.series,
    selectedIcon = _a.selectedIcon,
    xTickFormatter = _a.xTickFormatter,
    setSelectedIcon = _a.setSelectedIcon,
    xAxisMobileTicks = _a.xAxisMobileTicks,
    showSeriesLabelsOnXAxis = _a.showSeriesLabelsOnXAxis,
    breaksOn = _a.breaksOn,
    rechartsProps = __rest$1(_a, [
      'data',
      'styles',
      'series',
      'selectedIcon',
      'xTickFormatter',
      'setSelectedIcon',
      'xAxisMobileTicks',
      'showSeriesLabelsOnXAxis',
      'breaksOn',
    ]);
  var x = rechartsProps.x,
    y = rechartsProps.y,
    index = rechartsProps.index,
    height = rechartsProps.height,
    payload = rechartsProps.payload;
  var isSelected = index === selectedIcon;
  var mobileTick =
    typeof xAxisMobileTicks === 'function' ? xAxisMobileTicks(data[index], isSelected) : xAxisMobileTicks[index];
  var isScreenSize = useWindowSize().isScreenSize;
  var tickDisplay;
  if (isScreenSize(breaksOn) && mobileTick) {
    tickDisplay = jsxRuntime.jsx('g', {
      transform: 'translate('.concat(x, ',').concat(y, ')'),
      height: height + 100,
      onClick: function () {
        return mobileTick && setSelectedIcon(index);
      },
      children:
        mobileTick &&
        jsxRuntime.jsx('foreignObject', {
          x: -15,
          y: 0,
          width: '100',
          height: '100',
          children: jsxRuntime.jsx('span', {
            className: styles.BarChartXAxisTick,
            // @ts-expect-error TS(2322): Type '{ children: $TSFixMe; className: $TSFixMe; xmlns: stri... Remove this comment to see the full error message
            xmlns: 'http://www.w3.org/1999/xhtml',
            style: { fontWeight: '600' },
            children: mobileTick,
          }),
        }),
    });
  } else if (!isScreenSize(breaksOn)) {
    tickDisplay = jsxRuntime.jsxs('g', {
      transform: 'translate('.concat(x, ',').concat(y + 17, ')'),
      height: height + 100,
      className: styles.BarChartKeyValue,
      textAnchor: 'middle',
      children: [
        jsxRuntime.jsx('text', {
          style: { fontWeight: '600', fontSize: '16px' },
          textAnchor: 'middle',
          y: -5,
          children: payload.value,
        }),
        showSeriesLabelsOnXAxis &&
          jsxRuntime.jsx('text', {
            textAnchor: 'start',
            children: __spreadArray([], series, true)
              .reverse()
              .map(function (_a, seriesIndex) {
                var key = _a.key,
                  label = _a.label;
                var formattedValue = xTickFormatter(data[index][key]);
                return jsxRuntime.jsxs(
                  'tspan',
                  {
                    textAnchor: 'middle',
                    dy: seriesIndex === 0 ? 20 : 17,
                    x: 0,
                    style: { fontSize: '12px' },
                    children: [
                      jsxRuntime.jsx('tspan', { children: label }),
                      jsxRuntime.jsx('tspan', { letterSpacing: -0.75, children: ' - ' }),
                      jsxRuntime.jsx('tspan', { className: styles.BarChartDataValue, children: formattedValue }),
                    ],
                  },
                  'tspan-'.concat(index, '-').concat(key),
                );
              }),
          }),
      ],
    });
  } else {
    tickDisplay = null;
  }
  return tickDisplay;
};

var MobileDataDisplay = function (_a) {
  var xTickFormatter = _a.xTickFormatter,
    selectedMobileIconIndex = _a.selectedMobileIconIndex,
    xAxisKey = _a.xAxisKey,
    chartData = _a.chartData,
    styles = _a.styles,
    series = _a.series,
    handleColors = _a.handleColors;
  var data = chartData[selectedMobileIconIndex];
  return jsxRuntime.jsx('div', {
    className: styles.BarChartMobileDataContainer,
    children: jsxRuntime.jsxs('div', {
      className: styles.BarChartMobileData,
      children: [
        jsxRuntime.jsx('strong', { className: styles.BarChartMobileDataHeading, children: data[xAxisKey] }),
        __spreadArray([], series, true)
          .reverse()
          .map(function (_a, keyIndex) {
            var key = _a.key,
              label = _a.label,
              color = _a.color;
            var formattedValue = xTickFormatter(chartData[selectedMobileIconIndex][key]);
            return jsxRuntime.jsxs(
              'div',
              {
                className: styles.BarChartKeyValue,
                children: [
                  jsxRuntime.jsx('figure', {
                    className: styles.BarChartKeyValueColor,
                    style: {
                      background: handleColors(
                        { key: key, label: label, color: color },
                        chartData[selectedMobileIconIndex],
                        selectedMobileIconIndex,
                        keyIndex,
                      ),
                    },
                  }),
                  jsxRuntime.jsxs('span', { children: [label, ' - '] }),
                  jsxRuntime.jsx('span', { className: styles.BarChartDataValue, children: formattedValue }),
                ],
              },
              'mobile-tick-'.concat(keyIndex),
            );
          }),
      ],
    }),
  });
};

var style$m = {
  BarChartContainer: 'htco-BarChartContainer',
  BarChart: 'htco-BarChart',
  BarChartMobileDataContainer: 'htco-BarChartMobileDataContainer',
  BarChartMobileData: 'htco-BarChartMobileData',
  BarChartKeyValue: 'htco-BarChartKeyValue',
  BarChartMobileDataHeading: 'htco-BarChartMobileDataHeading',
  BarChartKeyValueColor: 'htco-BarChartKeyValueColor',
  BarChartDataValue: 'htco-BarChartDataValue',
};

var getDefaultColor = function (index) {
  var defaultFillData = [
    '#746BFF',
    '#00B5AF',
    '#6991F2',
    '#23BE8A',
    '#70DAFF',
    '#5342F7',
    '#009490',
    '#1045C1',
    '#18936A',
    '#2AB4E4',
  ];
  return defaultFillData[index] || defaultFillData[0];
};
var BarChart = function (_a) {
  var isStacked = _a.isStacked,
    tooltipFormatter = _a.tooltipFormatter,
    _b = _a.tooltipSortBy,
    tooltipSortBy =
      _b === void 0
        ? function (payload) {
            return payload.value;
          }
        : _b,
    _c = _a.tooltipHoverHighlightColor,
    tooltipHoverHighlightColor = _c === void 0 ? '#F1F5FE' : _c,
    _d = _a.height,
    height = _d === void 0 ? 350 : _d,
    _e = _a.series,
    series = _e === void 0 ? [] : _e,
    _f = _a.chartData,
    chartData = _f === void 0 ? [] : _f,
    _g = _a.xAxisKey,
    xAxisKey = _g === void 0 ? 'xAxisLabel' : _g,
    _h = _a.xAxisMobileTicks,
    xAxisMobileTicks =
      _h === void 0
        ? function () {
            return null;
          }
        : _h,
    _j = _a.xTickFormatter,
    xTickFormatter =
      _j === void 0
        ? function (xTick) {
            return xTick;
          }
        : _j,
    _k = _a.yTickFormatter,
    yTickFormatter =
      _k === void 0
        ? function (yTick) {
            if (yTick > 1000000) {
              return ''.concat(yTick / 1000000, 'm');
            }
            return yTick > 10000 ? ''.concat(yTick / 1000, 'k') : yTick;
          }
        : _k,
    _l = _a.showSeriesLabelsOnXAxis,
    showSeriesLabelsOnXAxis = _l === void 0 ? true : _l,
    _m = _a.breaksOn,
    breaksOn = _m === void 0 ? 'sm' : _m;
  var isScreenSize = useWindowSize().isScreenSize;
  var _o = React.useState(0),
    selectedMobileIconIndex = _o[0],
    setSelectedMobileIconIndex = _o[1];
  var handleColors = function (seriesConfig, data, index, fillDataIndex) {
    if (seriesConfig) {
      return typeof seriesConfig.color === 'function'
        ? seriesConfig.color(data)
        : seriesConfig.color || getDefaultColor(fillDataIndex);
    }
  };
  var formatTooltip = function (value, name, props) {
    // @ts-expect-error TS(7006): Parameter 'config' implicitly has an 'any' type.
    var seriesData = series.find(function (config) {
      return config.key === name;
    });
    var label = (seriesData === null || seriesData === void 0 ? void 0 : seriesData.label) || name;
    if (tooltipFormatter) {
      return tooltipFormatter(value, label, props);
    }
    return [value, label];
  };
  // @ts-expect-error TS(7006): Parameter 'seriesConfig' implicitly has an 'any' t... Remove this comment to see the full error message
  var bars = series.map(function (seriesConfig, index) {
    // @ts-expect-error TS(7006): Parameter 'key' implicitly has an 'any' type.
    var seriesData = chartData.filter(function (key) {
      return key !== seriesConfig[xAxisKey];
    });
    return (
      // @ts-expect-error TS(2769): No overload matches this call.
      jsxRuntime.jsx(
        Bar,
        {
          dataKey: seriesConfig.key,
          stackId: isStacked ? 'stack' : null,
          barSize: 90,
          children: seriesData.map(function (datum, keyIndex) {
            var color = handleColors(seriesConfig, datum, keyIndex, index);
            var stackedBarRadius = index % 2 === 0 ? 0 : [2, 2, 0, 0];
            return jsxRuntime.jsx(
              Cell,
              {
                fill: color,
                // @ts-expect-error TS(2322): Type 'number | number[]' is not assignable to type... Remove this comment to see the full error message
                radius: stackedBarRadius,
                onClick: function () {
                  return setSelectedMobileIconIndex(keyIndex);
                },
              },
              keyIndex,
            );
          }),
        },
        seriesConfig.key,
      )
    );
  });
  return jsxRuntime.jsxs(Container, {
    className: style$m.BarChartContainer,
    style: { minHeight: ''.concat(height + 50, 'px') },
    children: [
      jsxRuntime.jsx(ResponsiveContainer, {
        height: height,
        width: '90%',
        className: style$m.BarChart,
        children: jsxRuntime.jsxs(BarChart$1, {
          data: chartData,
          barCategoryGap: 10,
          children: [
            jsxRuntime.jsx(XAxis, {
              minTickGap: -100,
              dataKey: xAxisKey,
              tickMargin: 10,
              tickLine: false,
              axisLine: {
                strokeWidth: '0.5px',
              },
              tick: jsxRuntime.jsx(XAxisDisplayController, {
                setSelectedIcon: setSelectedMobileIconIndex,
                data: chartData,
                xAxisMobileTicks: xAxisMobileTicks,
                selectedIcon: selectedMobileIconIndex,
                styles: style$m,
                xTickFormatter: xTickFormatter,
                series: series,
                showSeriesLabelsOnXAxis: showSeriesLabelsOnXAxis,
                breaksOn: breaksOn,
              }),
            }),
            jsxRuntime.jsx(YAxis, {
              interval: 'preserveStartEnd',
              tickLine: false,
              axisLine: false,
              width: 30,
              tick: { fill: '#bbbbbb' },
              tickFormatter: yTickFormatter,
            }),
            !isScreenSize(breaksOn) &&
              // @ts-expect-error Tooltip caannot be used as a JSX component
              jsxRuntime.jsx(Tooltip, {
                formatter: formatTooltip,
                itemSorter: tooltipSortBy,
                cursor: { fill: tooltipHoverHighlightColor },
              }),
            bars,
          ],
        }),
      }),
      isScreenSize(breaksOn)
        ? jsxRuntime.jsx(MobileDataDisplay, {
            styles: style$m,
            chartData: chartData,
            xAxisKey: xAxisKey,
            selectedMobileIconIndex: selectedMobileIconIndex,
            series: series,
            xTickFormatter: xTickFormatter,
            handleColors: handleColors,
          })
        : null,
    ],
  });
};
BarChart.propTypes = {
  chartData: PropTypes__default['default'].array.isRequired,
  xAxisKey: PropTypes__default['default'].string,
  isStacked: PropTypes__default['default'].bool,
  series: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      key: PropTypes__default['default'].string.isRequired,
      label: PropTypes__default['default'].string.isRequired,
      color: PropTypes__default['default'].oneOfType([
        PropTypes__default['default'].string,
        PropTypes__default['default'].func,
      ]),
    }),
  ).isRequired,
  xAxisMobileTicks: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].func,
    PropTypes__default['default'].arrayOf(PropTypes__default['default'].node),
  ]),
  xTickFormatter: PropTypes__default['default'].func,
  yTickFormatter: PropTypes__default['default'].func,
  showSeriesLabelsOnXAxis: PropTypes__default['default'].bool,
  tooltipSortBy: PropTypes__default['default'].func,
  tooltipHoverHighlightColor: PropTypes__default['default'].string,
  breaksOn: PropTypes__default['default'].string,
};

var style$l = {
  KPIBar: 'htco-KPIBar',
  KPIBarCell: 'htco-KPIBarCell',
  KPIBarLabel: 'htco-KPIBarLabel',
  KPIBarValue: 'htco-KPIBarValue',
};

var KPIBar = function (_a) {
  var kpis = _a.kpis,
    className = _a.className;
  return jsxRuntime.jsx('section', {
    className: cx(style$l.KPIBar, className),
    children: kpis.map(function (_a) {
      var label = _a.label,
        value = _a.value;
      return jsxRuntime.jsxs(
        'div',
        {
          className: style$l.KPIBarCell,
          children: [
            jsxRuntime.jsx('div', { className: style$l.KPIBarLabel, children: label }),
            jsxRuntime.jsx('div', { className: style$l.KPIBarValue, children: value }),
          ],
        },
        value,
      );
    }),
  });
};
KPIBar.propTypes = {
  kpis: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      label: PropTypes__default['default'].node.isRequired,
      value: PropTypes__default['default'].node.isRequired,
    }).isRequired,
  ).isRequired,
  className: PropTypes__default['default'].string,
};

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(
      required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present',
    );
  }
}

function _typeof$B(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$B = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$B = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$B(obj);
}
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate$1(value) {
  requiredArgs(1, arguments);
  return (
    value instanceof Date ||
    (_typeof$B(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]')
  );
}

function _typeof$A(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$A = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$A = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$A(obj);
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || (_typeof$A(argument) === 'object' && argStr === '[object Date]')) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn(
        "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments",
      ); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate$1(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY$1 = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$2 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
}

var defaultOptions$1 = {};
function getDefaultOptions() {
  return defaultOptions$1;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref,
    _ref2,
    _ref3,
    _options$weekStartsOn,
    _options$locale,
    _options$locale$optio,
    _defaultOptions$local,
    _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger(
    (_ref =
      (_ref2 =
        (_ref3 =
          (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null &&
          _options$weekStartsOn !== void 0
            ? _options$weekStartsOn
            : options === null || options === void 0
            ? void 0
            : (_options$locale = options.locale) === null || _options$locale === void 0
            ? void 0
            : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0
            ? void 0
            : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0
          ? _ref3
          : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0
        ? _ref2
        : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0
        ? void 0
        : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0
        ? void 0
        : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0
      ? _ref
      : 0,
  ); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref,
    _ref2,
    _ref3,
    _options$firstWeekCon,
    _options$locale,
    _options$locale$optio,
    _defaultOptions$local,
    _defaultOptions$local2;

  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger(
    (_ref =
      (_ref2 =
        (_ref3 =
          (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !==
            null && _options$firstWeekCon !== void 0
            ? _options$firstWeekCon
            : options === null || options === void 0
            ? void 0
            : (_options$locale = options.locale) === null || _options$locale === void 0
            ? void 0
            : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0
            ? void 0
            : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0
          ? _ref3
          : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0
        ? _ref2
        : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0
        ? void 0
        : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0
        ? void 0
        : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0
      ? _ref
      : 1,
  ); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref,
    _ref2,
    _ref3,
    _options$firstWeekCon,
    _options$locale,
    _options$locale$optio,
    _defaultOptions$local,
    _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger(
    (_ref =
      (_ref2 =
        (_ref3 =
          (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !==
            null && _options$firstWeekCon !== void 0
            ? _options$firstWeekCon
            : options === null || options === void 0
            ? void 0
            : (_options$locale = options.locale) === null || _options$locale === void 0
            ? void 0
            : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0
            ? void 0
            : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0
          ? _ref3
          : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0
        ? _ref2
        : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0
        ? void 0
        : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0
        ? void 0
        : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0
      ? _ref
      : 1,
  );
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$1 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  },
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night',
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */
var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated',
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow',
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide',
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year',
      });
    }

    return formatters$1.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number

    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year',
      });
    } // Padding

    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter',
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting',
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting',
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting',
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter',
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone',
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone',
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone',
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$1.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month',
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting',
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting',
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting',
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month',
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone',
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone',
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone',
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week',
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week',
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date',
      });
    }

    return formatters$1.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear',
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting',
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting',
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting',
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting',
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day',
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting',
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting',
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting',
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting',
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day',
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone',
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone',
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone',
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone',
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day',
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting',
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting',
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting',
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting',
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting',
        });

      case 'aaa':
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting',
          })
          .toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting',
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting',
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting',
        });

      case 'bbb':
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting',
          })
          .toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting',
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting',
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting',
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting',
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting',
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour',
      });
    }

    return formatters$1.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour',
      });
    }

    return formatters$1.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour',
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour',
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute',
      });
    }

    return formatters$1.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second',
      });
    }

    return formatters$1.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$1.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  },
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short',
      });

    case 'PP':
      return formatLong.date({
        width: 'medium',
      });

    case 'PPP':
      return formatLong.date({
        width: 'long',
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full',
      });
  }
};

var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short',
      });

    case 'pp':
      return formatLong.time({
        width: 'medium',
      });

    case 'ppp':
      return formatLong.time({
        width: 'long',
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full',
      });
  }
};

var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short',
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium',
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long',
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full',
      });
      break;
  }

  return dateTimeFormat
    .replace('{{date}}', dateLongFormatter(datePattern, formatLong))
    .replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
};

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError(
      'Use `yyyy` instead of `YYYY` (in `'
        .concat(format, '`) for formatting years to the input `')
        .concat(input, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md'),
    );
  } else if (token === 'YY') {
    throw new RangeError(
      'Use `yy` instead of `YY` (in `'
        .concat(format, '`) for formatting years to the input `')
        .concat(input, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md'),
    );
  } else if (token === 'D') {
    throw new RangeError(
      'Use `d` instead of `D` (in `'
        .concat(format, '`) for formatting days of the month to the input `')
        .concat(input, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md'),
    );
  } else if (token === 'DD') {
    throw new RangeError(
      'Use `dd` instead of `DD` (in `'
        .concat(format, '`) for formatting days of the month to the input `')
        .concat(input, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md'),
    );
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds',
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds',
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes',
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes',
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours',
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours',
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days',
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks',
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks',
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months',
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months',
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years',
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years',
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years',
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years',
  },
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy',
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a',
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}',
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full',
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full',
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full',
  }),
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P',
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini'],
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'],
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night',
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night',
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night',
  },
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night',
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night',
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night',
  },
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    },
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide',
  }),
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = (width && args.matchPatterns[width]) || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = (width && args.parsePatterns[width]) || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns)
      ? findIndex$1(parsePatterns, function (pattern) {
          return pattern.test(matchedString);
        })
      : findKey(parsePatterns, function (pattern) {
          return pattern.test(matchedString);
        });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest,
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex$1(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest,
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i],
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i],
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    },
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any',
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    },
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any',
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any',
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any',
  }),
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0,
    /* Sunday */
    firstWeekContainsDate: 1,
  },
};

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref,
    _options$locale,
    _ref2,
    _ref3,
    _ref4,
    _options$firstWeekCon,
    _options$locale2,
    _options$locale2$opti,
    _defaultOptions$local,
    _defaultOptions$local2,
    _ref5,
    _ref6,
    _ref7,
    _options$weekStartsOn,
    _options$locale3,
    _options$locale3$opti,
    _defaultOptions$local3,
    _defaultOptions$local4;

  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale$1 =
    (_ref =
      (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null &&
      _options$locale !== void 0
        ? _options$locale
        : defaultOptions.locale) !== null && _ref !== void 0
      ? _ref
      : locale;
  var firstWeekContainsDate = toInteger(
    (_ref2 =
      (_ref3 =
        (_ref4 =
          (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !==
            null && _options$firstWeekCon !== void 0
            ? _options$firstWeekCon
            : options === null || options === void 0
            ? void 0
            : (_options$locale2 = options.locale) === null || _options$locale2 === void 0
            ? void 0
            : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0
            ? void 0
            : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0
          ? _ref4
          : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0
        ? _ref3
        : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0
        ? void 0
        : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0
        ? void 0
        : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0
      ? _ref2
      : 1,
  ); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = toInteger(
    (_ref5 =
      (_ref6 =
        (_ref7 =
          (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null &&
          _options$weekStartsOn !== void 0
            ? _options$weekStartsOn
            : options === null || options === void 0
            ? void 0
            : (_options$locale3 = options.locale) === null || _options$locale3 === void 0
            ? void 0
            : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0
            ? void 0
            : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0
          ? _ref7
          : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0
        ? _ref6
        : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0
        ? void 0
        : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0
        ? void 0
        : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0
      ? _ref5
      : 0,
  ); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376

  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate,
  };
  var result = formatStr
    .match(longFormattingTokensRegExp$1)
    .map(function (substring) {
      var firstCharacter = substring[0];

      if (firstCharacter === 'p' || firstCharacter === 'P') {
        var longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale$1.formatLong);
      }

      return substring;
    })
    .join('')
    .match(formattingTokensRegExp$1)
    .map(function (substring) {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return "'";
      }

      var firstCharacter = substring[0];

      if (firstCharacter === "'") {
        return cleanEscapedString$1(substring);
      }

      var formatter = formatters[firstCharacter];

      if (formatter) {
        if (
          !(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) &&
          isProtectedWeekYearToken(substring)
        ) {
          throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
        }

        if (
          !(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) &&
          isProtectedDayOfYearToken(substring)
        ) {
          throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
        }

        return formatter(utcDate, substring, locale$1.localize, formatterOptions);
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      }

      return substring;
    })
    .join('');
  return result;
}

function cleanEscapedString$1(input) {
  var matched = input.match(escapedStringRegExp$1);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp$1, "'");
}

var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay$1(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, options) {
  var _ref,
    _ref2,
    _ref3,
    _options$weekStartsOn,
    _options$locale,
    _options$locale$optio,
    _defaultOptions$local,
    _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger(
    (_ref =
      (_ref2 =
        (_ref3 =
          (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null &&
          _options$weekStartsOn !== void 0
            ? _options$weekStartsOn
            : options === null || options === void 0
            ? void 0
            : (_options$locale = options.locale) === null || _options$locale === void 0
            ? void 0
            : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0
            ? void 0
            : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0
          ? _ref3
          : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0
        ? _ref2
        : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0
        ? void 0
        : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0
        ? void 0
        : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0
      ? _ref
      : 0,
  ); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1,
  });
}

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */

function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  return month;
}

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */

function getQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime$1(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */

function setQuarter(dirtyDate, dirtyQuarter) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var quarter = toInteger(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return setMonth(date, date.getMonth() + diff * 3);
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

function _typeof$z(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$z = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$z = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$z(obj);
}
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */

function min(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof$z(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = toDate(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

function _typeof$y(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$y = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$y = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$y(obj);
}
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */

function max$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof$y(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = toDate(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */

function startOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - (currentMonth % 3);
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

function assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target[property] = object[property];
    }
  }

  return target;
}

function _typeof$x(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$x = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$x = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$x(obj);
}

function _inherits$v(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$x(subClass, superClass);
}

function _setPrototypeOf$x(o, p) {
  _setPrototypeOf$x =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$x(o, p);
}

function _createSuper$v(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$v();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$v(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$v(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$v(this, result);
  };
}

function _possibleConstructorReturn$v(self, call) {
  if (call && (_typeof$x(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$x(self);
}

function _assertThisInitialized$x(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$v() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$v(o) {
  _getPrototypeOf$v = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$v(o);
}

function _classCallCheck$w(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$w(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$w(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$w(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$w(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$y(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ (function () {
  function Setter() {
    _classCallCheck$w(this, Setter);

    _defineProperty$y(this, 'subPriority', 0);
  }

  _createClass$w(Setter, [
    {
      key: 'validate',
      value: function validate(_utcDate, _options) {
        return true;
      },
    },
  ]);

  return Setter;
})();
var ValueSetter = /*#__PURE__*/ (function (_Setter) {
  _inherits$v(ValueSetter, _Setter);

  var _super = _createSuper$v(ValueSetter);

  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;

    _classCallCheck$w(this, ValueSetter);

    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;

    if (subPriority) {
      _this.subPriority = subPriority;
    }

    return _this;
  }

  _createClass$w(ValueSetter, [
    {
      key: 'validate',
      value: function validate(utcDate, options) {
        return this.validateValue(utcDate, this.value, options);
      },
    },
    {
      key: 'set',
      value: function set(utcDate, flags, options) {
        return this.setValue(utcDate, flags, this.value, options);
      },
    },
  ]);

  return ValueSetter;
})(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ (function (_Setter2) {
  _inherits$v(DateToSystemTimezoneSetter, _Setter2);

  var _super2 = _createSuper$v(DateToSystemTimezoneSetter);

  function DateToSystemTimezoneSetter() {
    var _this2;

    _classCallCheck$w(this, DateToSystemTimezoneSetter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty$y(_assertThisInitialized$x(_this2), 'priority', TIMEZONE_UNIT_PRIORITY);

    _defineProperty$y(_assertThisInitialized$x(_this2), 'subPriority', -1);

    return _this2;
  }

  _createClass$w(DateToSystemTimezoneSetter, [
    {
      key: 'set',
      value: function set(date, flags) {
        if (flags.timestampIsSet) {
          return date;
        }

        var convertedDate = new Date(0);
        convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        convertedDate.setHours(
          date.getUTCHours(),
          date.getUTCMinutes(),
          date.getUTCSeconds(),
          date.getUTCMilliseconds(),
        );
        return convertedDate;
      },
    },
  ]);

  return DateToSystemTimezoneSetter;
})(Setter);

function _classCallCheck$v(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$v(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$v(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$v(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$v(Constructor, staticProps);
  return Constructor;
}
var Parser = /*#__PURE__*/ (function () {
  function Parser() {
    _classCallCheck$v(this, Parser);
  }

  _createClass$v(Parser, [
    {
      key: 'run',
      value: function run(dateString, token, match, options) {
        var result = this.parse(dateString, token, match, options);

        if (!result) {
          return null;
        }

        return {
          setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
          rest: result.rest,
        };
      },
    },
    {
      key: 'validate',
      value: function validate(_utcDate, _value, _options) {
        return true;
      },
    },
  ]);

  return Parser;
})();

function _typeof$w(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$w = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$w = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$w(obj);
}

function _classCallCheck$u(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$u(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$u(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$u(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$u(Constructor, staticProps);
  return Constructor;
}

function _inherits$u(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$w(subClass, superClass);
}

function _setPrototypeOf$w(o, p) {
  _setPrototypeOf$w =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$w(o, p);
}

function _createSuper$u(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$u();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$u(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$u(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$u(this, result);
  };
}

function _possibleConstructorReturn$u(self, call) {
  if (call && (_typeof$w(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$w(self);
}

function _assertThisInitialized$w(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$u() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$u(o) {
  _getPrototypeOf$u = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$u(o);
}

function _defineProperty$x(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var EraParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$u(EraParser, _Parser);

  var _super = _createSuper$u(EraParser);

  function EraParser() {
    var _this;

    _classCallCheck$u(this, EraParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$x(_assertThisInitialized$w(_this), 'priority', 140);

    _defineProperty$x(_assertThisInitialized$w(_this), 'incompatibleTokens', ['R', 'u', 't', 'T']);

    return _this;
  }

  _createClass$u(EraParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          // AD, BC
          case 'G':
          case 'GG':
          case 'GGG':
            return (
              match.era(dateString, {
                width: 'abbreviated',
              }) ||
              match.era(dateString, {
                width: 'narrow',
              })
            );
          // A, B

          case 'GGGGG':
            return match.era(dateString, {
              width: 'narrow',
            });
          // Anno Domini, Before Christ

          case 'GGGG':
          default:
            return (
              match.era(dateString, {
                width: 'wide',
              }) ||
              match.era(dateString, {
                width: 'abbreviated',
              }) ||
              match.era(dateString, {
                width: 'narrow',
              })
            );
        }
      },
    },
    {
      key: 'set',
      value: function set(date, flags, value) {
        flags.era = value;
        date.setUTCFullYear(value, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return EraParser;
})(Parser);

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;

var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/, // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/,
};

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest,
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length),
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'

  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1),
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length),
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

function _typeof$v(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$v = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$v = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$v(obj);
}

function _classCallCheck$t(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$t(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$t(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$t(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$t(Constructor, staticProps);
  return Constructor;
}

function _inherits$t(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$v(subClass, superClass);
}

function _setPrototypeOf$v(o, p) {
  _setPrototypeOf$v =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$v(o, p);
}

function _createSuper$t(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$t();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$t(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$t(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$t(this, result);
  };
}

function _possibleConstructorReturn$t(self, call) {
  if (call && (_typeof$v(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$v(self);
}

function _assertThisInitialized$v(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$t() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$t(o) {
  _getPrototypeOf$t = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$t(o);
}

function _defineProperty$w(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$t(YearParser, _Parser);

  var _super = _createSuper$t(YearParser);

  function YearParser() {
    var _this;

    _classCallCheck$t(this, YearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$w(_assertThisInitialized$v(_this), 'priority', 130);

    _defineProperty$w(_assertThisInitialized$v(_this), 'incompatibleTokens', [
      'Y',
      'R',
      'u',
      'w',
      'I',
      'i',
      'e',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$t(YearParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        var valueCallback = function valueCallback(year) {
          return {
            year: year,
            isTwoDigitYear: token === 'yy',
          };
        };

        switch (token) {
          case 'y':
            return mapValue(parseNDigits(4, dateString), valueCallback);

          case 'yo':
            return mapValue(
              match.ordinalNumber(dateString, {
                unit: 'year',
              }),
              valueCallback,
            );

          default:
            return mapValue(parseNDigits(token.length, dateString), valueCallback);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
      },
    },
    {
      key: 'set',
      value: function set(date, flags, value) {
        var currentYear = date.getUTCFullYear();

        if (value.isTwoDigitYear) {
          var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
          date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }

        var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setUTCFullYear(year, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return YearParser;
})(Parser);

function _typeof$u(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$u = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$u = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$u(obj);
}

function _classCallCheck$s(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$s(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$s(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$s(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$s(Constructor, staticProps);
  return Constructor;
}

function _inherits$s(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$u(subClass, superClass);
}

function _setPrototypeOf$u(o, p) {
  _setPrototypeOf$u =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$u(o, p);
}

function _createSuper$s(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$s();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$s(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$s(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$s(this, result);
  };
}

function _possibleConstructorReturn$s(self, call) {
  if (call && (_typeof$u(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$u(self);
}

function _assertThisInitialized$u(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$s() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$s(o) {
  _getPrototypeOf$s = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$s(o);
}

function _defineProperty$v(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$s(LocalWeekYearParser, _Parser);

  var _super = _createSuper$s(LocalWeekYearParser);

  function LocalWeekYearParser() {
    var _this;

    _classCallCheck$s(this, LocalWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$v(_assertThisInitialized$u(_this), 'priority', 130);

    _defineProperty$v(_assertThisInitialized$u(_this), 'incompatibleTokens', [
      'y',
      'R',
      'u',
      'Q',
      'q',
      'M',
      'L',
      'I',
      'd',
      'D',
      'i',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$s(LocalWeekYearParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        var valueCallback = function valueCallback(year) {
          return {
            year: year,
            isTwoDigitYear: token === 'YY',
          };
        };

        switch (token) {
          case 'Y':
            return mapValue(parseNDigits(4, dateString), valueCallback);

          case 'Yo':
            return mapValue(
              match.ordinalNumber(dateString, {
                unit: 'year',
              }),
              valueCallback,
            );

          default:
            return mapValue(parseNDigits(token.length, dateString), valueCallback);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
      },
    },
    {
      key: 'set',
      value: function set(date, flags, value, options) {
        var currentYear = getUTCWeekYear(date, options);

        if (value.isTwoDigitYear) {
          var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
          date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
          date.setUTCHours(0, 0, 0, 0);
          return startOfUTCWeek(date, options);
        }

        var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      },
    },
  ]);

  return LocalWeekYearParser;
})(Parser);

function _typeof$t(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$t = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$t = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$t(obj);
}

function _classCallCheck$r(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$r(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$r(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$r(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$r(Constructor, staticProps);
  return Constructor;
}

function _inherits$r(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$t(subClass, superClass);
}

function _setPrototypeOf$t(o, p) {
  _setPrototypeOf$t =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$t(o, p);
}

function _createSuper$r(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$r();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$r(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$r(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$r(this, result);
  };
}

function _possibleConstructorReturn$r(self, call) {
  if (call && (_typeof$t(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$t(self);
}

function _assertThisInitialized$t(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$r() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$r(o) {
  _getPrototypeOf$r = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$r(o);
}

function _defineProperty$u(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var ISOWeekYearParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$r(ISOWeekYearParser, _Parser);

  var _super = _createSuper$r(ISOWeekYearParser);

  function ISOWeekYearParser() {
    var _this;

    _classCallCheck$r(this, ISOWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$u(_assertThisInitialized$t(_this), 'priority', 130);

    _defineProperty$u(_assertThisInitialized$t(_this), 'incompatibleTokens', [
      'G',
      'y',
      'Y',
      'u',
      'Q',
      'q',
      'M',
      'L',
      'w',
      'd',
      'D',
      'e',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$r(ISOWeekYearParser, [
    {
      key: 'parse',
      value: function parse(dateString, token) {
        if (token === 'R') {
          return parseNDigitsSigned(4, dateString);
        }

        return parseNDigitsSigned(token.length, dateString);
      },
    },
    {
      key: 'set',
      value: function set(_date, _flags, value) {
        var firstWeekOfYear = new Date(0);
        firstWeekOfYear.setUTCFullYear(value, 0, 4);
        firstWeekOfYear.setUTCHours(0, 0, 0, 0);
        return startOfUTCISOWeek(firstWeekOfYear);
      },
    },
  ]);

  return ISOWeekYearParser;
})(Parser);

function _typeof$s(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$s = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$s = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$s(obj);
}

function _classCallCheck$q(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$q(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$q(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$q(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$q(Constructor, staticProps);
  return Constructor;
}

function _inherits$q(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$s(subClass, superClass);
}

function _setPrototypeOf$s(o, p) {
  _setPrototypeOf$s =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$s(o, p);
}

function _createSuper$q(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$q();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$q(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$q(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$q(this, result);
  };
}

function _possibleConstructorReturn$q(self, call) {
  if (call && (_typeof$s(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$s(self);
}

function _assertThisInitialized$s(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$q() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$q(o) {
  _getPrototypeOf$q = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$q(o);
}

function _defineProperty$t(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ExtendedYearParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$q(ExtendedYearParser, _Parser);

  var _super = _createSuper$q(ExtendedYearParser);

  function ExtendedYearParser() {
    var _this;

    _classCallCheck$q(this, ExtendedYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$t(_assertThisInitialized$s(_this), 'priority', 130);

    _defineProperty$t(_assertThisInitialized$s(_this), 'incompatibleTokens', [
      'G',
      'y',
      'Y',
      'R',
      'w',
      'I',
      'i',
      'e',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$q(ExtendedYearParser, [
    {
      key: 'parse',
      value: function parse(dateString, token) {
        if (token === 'u') {
          return parseNDigitsSigned(4, dateString);
        }

        return parseNDigitsSigned(token.length, dateString);
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCFullYear(value, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return ExtendedYearParser;
})(Parser);

function _typeof$r(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$r = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$r = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$r(obj);
}

function _classCallCheck$p(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$p(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$p(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$p(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$p(Constructor, staticProps);
  return Constructor;
}

function _inherits$p(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$r(subClass, superClass);
}

function _setPrototypeOf$r(o, p) {
  _setPrototypeOf$r =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$r(o, p);
}

function _createSuper$p(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$p();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$p(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$p(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$p(this, result);
  };
}

function _possibleConstructorReturn$p(self, call) {
  if (call && (_typeof$r(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$r(self);
}

function _assertThisInitialized$r(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$p() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$p(o) {
  _getPrototypeOf$p = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$p(o);
}

function _defineProperty$s(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var QuarterParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$p(QuarterParser, _Parser);

  var _super = _createSuper$p(QuarterParser);

  function QuarterParser() {
    var _this;

    _classCallCheck$p(this, QuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$s(_assertThisInitialized$r(_this), 'priority', 120);

    _defineProperty$s(_assertThisInitialized$r(_this), 'incompatibleTokens', [
      'Y',
      'R',
      'q',
      'M',
      'L',
      'w',
      'I',
      'd',
      'D',
      'i',
      'e',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$p(QuarterParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          // 1, 2, 3, 4
          case 'Q':
          case 'QQ':
            // 01, 02, 03, 04
            return parseNDigits(token.length, dateString);
          // 1st, 2nd, 3rd, 4th

          case 'Qo':
            return match.ordinalNumber(dateString, {
              unit: 'quarter',
            });
          // Q1, Q2, Q3, Q4

          case 'QQQ':
            return (
              match.quarter(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.quarter(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)

          case 'QQQQQ':
            return match.quarter(dateString, {
              width: 'narrow',
              context: 'formatting',
            });
          // 1st quarter, 2nd quarter, ...

          case 'QQQQ':
          default:
            return (
              match.quarter(dateString, {
                width: 'wide',
                context: 'formatting',
              }) ||
              match.quarter(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.quarter(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 1 && value <= 4;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCMonth((value - 1) * 3, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return QuarterParser;
})(Parser);

function _typeof$q(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$q = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$q = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$q(obj);
}

function _classCallCheck$o(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$o(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$o(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$o(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$o(Constructor, staticProps);
  return Constructor;
}

function _inherits$o(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$q(subClass, superClass);
}

function _setPrototypeOf$q(o, p) {
  _setPrototypeOf$q =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$q(o, p);
}

function _createSuper$o(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$o();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$o(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$o(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$o(this, result);
  };
}

function _possibleConstructorReturn$o(self, call) {
  if (call && (_typeof$q(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$q(self);
}

function _assertThisInitialized$q(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$o() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$o(o) {
  _getPrototypeOf$o = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$o(o);
}

function _defineProperty$r(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var StandAloneQuarterParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$o(StandAloneQuarterParser, _Parser);

  var _super = _createSuper$o(StandAloneQuarterParser);

  function StandAloneQuarterParser() {
    var _this;

    _classCallCheck$o(this, StandAloneQuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$r(_assertThisInitialized$q(_this), 'priority', 120);

    _defineProperty$r(_assertThisInitialized$q(_this), 'incompatibleTokens', [
      'Y',
      'R',
      'Q',
      'M',
      'L',
      'w',
      'I',
      'd',
      'D',
      'i',
      'e',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$o(StandAloneQuarterParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          // 1, 2, 3, 4
          case 'q':
          case 'qq':
            // 01, 02, 03, 04
            return parseNDigits(token.length, dateString);
          // 1st, 2nd, 3rd, 4th

          case 'qo':
            return match.ordinalNumber(dateString, {
              unit: 'quarter',
            });
          // Q1, Q2, Q3, Q4

          case 'qqq':
            return (
              match.quarter(dateString, {
                width: 'abbreviated',
                context: 'standalone',
              }) ||
              match.quarter(dateString, {
                width: 'narrow',
                context: 'standalone',
              })
            );
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)

          case 'qqqqq':
            return match.quarter(dateString, {
              width: 'narrow',
              context: 'standalone',
            });
          // 1st quarter, 2nd quarter, ...

          case 'qqqq':
          default:
            return (
              match.quarter(dateString, {
                width: 'wide',
                context: 'standalone',
              }) ||
              match.quarter(dateString, {
                width: 'abbreviated',
                context: 'standalone',
              }) ||
              match.quarter(dateString, {
                width: 'narrow',
                context: 'standalone',
              })
            );
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 1 && value <= 4;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCMonth((value - 1) * 3, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return StandAloneQuarterParser;
})(Parser);

function _typeof$p(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$p = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$p = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$p(obj);
}

function _classCallCheck$n(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$n(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$n(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$n(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$n(Constructor, staticProps);
  return Constructor;
}

function _inherits$n(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$p(subClass, superClass);
}

function _setPrototypeOf$p(o, p) {
  _setPrototypeOf$p =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$p(o, p);
}

function _createSuper$n(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$n();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$n(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$n(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$n(this, result);
  };
}

function _possibleConstructorReturn$n(self, call) {
  if (call && (_typeof$p(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$p(self);
}

function _assertThisInitialized$p(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$n() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$n(o) {
  _getPrototypeOf$n = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$n(o);
}

function _defineProperty$q(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var MonthParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$n(MonthParser, _Parser);

  var _super = _createSuper$n(MonthParser);

  function MonthParser() {
    var _this;

    _classCallCheck$n(this, MonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$q(_assertThisInitialized$p(_this), 'incompatibleTokens', [
      'Y',
      'R',
      'q',
      'Q',
      'L',
      'w',
      'I',
      'D',
      'i',
      'e',
      'c',
      't',
      'T',
    ]);

    _defineProperty$q(_assertThisInitialized$p(_this), 'priority', 110);

    return _this;
  }

  _createClass$n(MonthParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        var valueCallback = function valueCallback(value) {
          return value - 1;
        };

        switch (token) {
          // 1, 2, ..., 12
          case 'M':
            return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
          // 01, 02, ..., 12

          case 'MM':
            return mapValue(parseNDigits(2, dateString), valueCallback);
          // 1st, 2nd, ..., 12th

          case 'Mo':
            return mapValue(
              match.ordinalNumber(dateString, {
                unit: 'month',
              }),
              valueCallback,
            );
          // Jan, Feb, ..., Dec

          case 'MMM':
            return (
              match.month(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.month(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
          // J, F, ..., D

          case 'MMMMM':
            return match.month(dateString, {
              width: 'narrow',
              context: 'formatting',
            });
          // January, February, ..., December

          case 'MMMM':
          default:
            return (
              match.month(dateString, {
                width: 'wide',
                context: 'formatting',
              }) ||
              match.month(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.month(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 0 && value <= 11;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCMonth(value, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return MonthParser;
})(Parser);

function _typeof$o(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$o = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$o = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$o(obj);
}

function _classCallCheck$m(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$m(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$m(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$m(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$m(Constructor, staticProps);
  return Constructor;
}

function _inherits$m(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$o(subClass, superClass);
}

function _setPrototypeOf$o(o, p) {
  _setPrototypeOf$o =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$o(o, p);
}

function _createSuper$m(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$m();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$m(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$m(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$m(this, result);
  };
}

function _possibleConstructorReturn$m(self, call) {
  if (call && (_typeof$o(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$o(self);
}

function _assertThisInitialized$o(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$m() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$m(o) {
  _getPrototypeOf$m = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$m(o);
}

function _defineProperty$p(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var StandAloneMonthParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$m(StandAloneMonthParser, _Parser);

  var _super = _createSuper$m(StandAloneMonthParser);

  function StandAloneMonthParser() {
    var _this;

    _classCallCheck$m(this, StandAloneMonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$p(_assertThisInitialized$o(_this), 'priority', 110);

    _defineProperty$p(_assertThisInitialized$o(_this), 'incompatibleTokens', [
      'Y',
      'R',
      'q',
      'Q',
      'M',
      'w',
      'I',
      'D',
      'i',
      'e',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$m(StandAloneMonthParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        var valueCallback = function valueCallback(value) {
          return value - 1;
        };

        switch (token) {
          // 1, 2, ..., 12
          case 'L':
            return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
          // 01, 02, ..., 12

          case 'LL':
            return mapValue(parseNDigits(2, dateString), valueCallback);
          // 1st, 2nd, ..., 12th

          case 'Lo':
            return mapValue(
              match.ordinalNumber(dateString, {
                unit: 'month',
              }),
              valueCallback,
            );
          // Jan, Feb, ..., Dec

          case 'LLL':
            return (
              match.month(dateString, {
                width: 'abbreviated',
                context: 'standalone',
              }) ||
              match.month(dateString, {
                width: 'narrow',
                context: 'standalone',
              })
            );
          // J, F, ..., D

          case 'LLLLL':
            return match.month(dateString, {
              width: 'narrow',
              context: 'standalone',
            });
          // January, February, ..., December

          case 'LLLL':
          default:
            return (
              match.month(dateString, {
                width: 'wide',
                context: 'standalone',
              }) ||
              match.month(dateString, {
                width: 'abbreviated',
                context: 'standalone',
              }) ||
              match.month(dateString, {
                width: 'narrow',
                context: 'standalone',
              })
            );
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 0 && value <= 11;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCMonth(value, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return StandAloneMonthParser;
})(Parser);

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

function _typeof$n(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$n = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$n = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$n(obj);
}

function _classCallCheck$l(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$l(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$l(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$l(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$l(Constructor, staticProps);
  return Constructor;
}

function _inherits$l(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$n(subClass, superClass);
}

function _setPrototypeOf$n(o, p) {
  _setPrototypeOf$n =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$n(o, p);
}

function _createSuper$l(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$l();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$l(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$l(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$l(this, result);
  };
}

function _possibleConstructorReturn$l(self, call) {
  if (call && (_typeof$n(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$n(self);
}

function _assertThisInitialized$n(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$l() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$l(o) {
  _getPrototypeOf$l = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$l(o);
}

function _defineProperty$o(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var LocalWeekParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$l(LocalWeekParser, _Parser);

  var _super = _createSuper$l(LocalWeekParser);

  function LocalWeekParser() {
    var _this;

    _classCallCheck$l(this, LocalWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$o(_assertThisInitialized$n(_this), 'priority', 100);

    _defineProperty$o(_assertThisInitialized$n(_this), 'incompatibleTokens', [
      'y',
      'R',
      'u',
      'q',
      'Q',
      'M',
      'L',
      'I',
      'd',
      'D',
      'i',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$l(LocalWeekParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'w':
            return parseNumericPattern(numericPatterns.week, dateString);

          case 'wo':
            return match.ordinalNumber(dateString, {
              unit: 'week',
            });

          default:
            return parseNDigits(token.length, dateString);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 1 && value <= 53;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value, options) {
        return startOfUTCWeek(setUTCWeek(date, value, options), options);
      },
    },
  ]);

  return LocalWeekParser;
})(Parser);

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

function _typeof$m(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$m = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$m = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$m(obj);
}

function _classCallCheck$k(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$k(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$k(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$k(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$k(Constructor, staticProps);
  return Constructor;
}

function _inherits$k(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$m(subClass, superClass);
}

function _setPrototypeOf$m(o, p) {
  _setPrototypeOf$m =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$m(o, p);
}

function _createSuper$k(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$k();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$k(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$k(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$k(this, result);
  };
}

function _possibleConstructorReturn$k(self, call) {
  if (call && (_typeof$m(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$m(self);
}

function _assertThisInitialized$m(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$k() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$k(o) {
  _getPrototypeOf$k = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$k(o);
}

function _defineProperty$n(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var ISOWeekParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$k(ISOWeekParser, _Parser);

  var _super = _createSuper$k(ISOWeekParser);

  function ISOWeekParser() {
    var _this;

    _classCallCheck$k(this, ISOWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$n(_assertThisInitialized$m(_this), 'priority', 100);

    _defineProperty$n(_assertThisInitialized$m(_this), 'incompatibleTokens', [
      'y',
      'Y',
      'u',
      'q',
      'Q',
      'M',
      'L',
      'w',
      'd',
      'D',
      'e',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$k(ISOWeekParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'I':
            return parseNumericPattern(numericPatterns.week, dateString);

          case 'Io':
            return match.ordinalNumber(dateString, {
              unit: 'week',
            });

          default:
            return parseNDigits(token.length, dateString);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 1 && value <= 53;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        return startOfUTCISOWeek(setUTCISOWeek(date, value));
      },
    },
  ]);

  return ISOWeekParser;
})(Parser);

function _typeof$l(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$l = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$l = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$l(obj);
}

function _classCallCheck$j(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$j(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$j(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$j(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$j(Constructor, staticProps);
  return Constructor;
}

function _inherits$j(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$l(subClass, superClass);
}

function _setPrototypeOf$l(o, p) {
  _setPrototypeOf$l =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$l(o, p);
}

function _createSuper$j(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$j();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$j(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$j(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$j(this, result);
  };
}

function _possibleConstructorReturn$j(self, call) {
  if (call && (_typeof$l(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$l(self);
}

function _assertThisInitialized$l(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$j() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$j(o) {
  _getPrototypeOf$j = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$j(o);
}

function _defineProperty$m(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Day of the month

var DateParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$j(DateParser, _Parser);

  var _super = _createSuper$j(DateParser);

  function DateParser() {
    var _this;

    _classCallCheck$j(this, DateParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$m(_assertThisInitialized$l(_this), 'priority', 90);

    _defineProperty$m(_assertThisInitialized$l(_this), 'subPriority', 1);

    _defineProperty$m(_assertThisInitialized$l(_this), 'incompatibleTokens', [
      'Y',
      'R',
      'q',
      'Q',
      'w',
      'I',
      'D',
      'i',
      'e',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$j(DateParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'd':
            return parseNumericPattern(numericPatterns.date, dateString);

          case 'do':
            return match.ordinalNumber(dateString, {
              unit: 'date',
            });

          default:
            return parseNDigits(token.length, dateString);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(date, value) {
        var year = date.getUTCFullYear();
        var isLeapYear = isLeapYearIndex$1(year);
        var month = date.getUTCMonth();

        if (isLeapYear) {
          return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
        } else {
          return value >= 1 && value <= DAYS_IN_MONTH[month];
        }
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCDate(value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return DateParser;
})(Parser);

function _typeof$k(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$k = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$k = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$k(obj);
}

function _classCallCheck$i(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$i(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$i(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$i(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$i(Constructor, staticProps);
  return Constructor;
}

function _inherits$i(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$k(subClass, superClass);
}

function _setPrototypeOf$k(o, p) {
  _setPrototypeOf$k =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$k(o, p);
}

function _createSuper$i(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$i();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$i(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$i(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$i(this, result);
  };
}

function _possibleConstructorReturn$i(self, call) {
  if (call && (_typeof$k(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$k(self);
}

function _assertThisInitialized$k(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$i() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$i(o) {
  _getPrototypeOf$i = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$i(o);
}

function _defineProperty$l(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DayOfYearParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$i(DayOfYearParser, _Parser);

  var _super = _createSuper$i(DayOfYearParser);

  function DayOfYearParser() {
    var _this;

    _classCallCheck$i(this, DayOfYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$l(_assertThisInitialized$k(_this), 'priority', 90);

    _defineProperty$l(_assertThisInitialized$k(_this), 'subpriority', 1);

    _defineProperty$l(_assertThisInitialized$k(_this), 'incompatibleTokens', [
      'Y',
      'R',
      'q',
      'Q',
      'M',
      'L',
      'w',
      'I',
      'd',
      'E',
      'i',
      'e',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$i(DayOfYearParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'D':
          case 'DD':
            return parseNumericPattern(numericPatterns.dayOfYear, dateString);

          case 'Do':
            return match.ordinalNumber(dateString, {
              unit: 'date',
            });

          default:
            return parseNDigits(token.length, dateString);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(date, value) {
        var year = date.getUTCFullYear();
        var isLeapYear = isLeapYearIndex$1(year);

        if (isLeapYear) {
          return value >= 1 && value <= 366;
        } else {
          return value >= 1 && value <= 365;
        }
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCMonth(0, value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return DayOfYearParser;
})(Parser);

function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref,
    _ref2,
    _ref3,
    _options$weekStartsOn,
    _options$locale,
    _options$locale$optio,
    _defaultOptions$local,
    _defaultOptions$local2;

  requiredArgs(2, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger(
    (_ref =
      (_ref2 =
        (_ref3 =
          (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null &&
          _options$weekStartsOn !== void 0
            ? _options$weekStartsOn
            : options === null || options === void 0
            ? void 0
            : (_options$locale = options.locale) === null || _options$locale === void 0
            ? void 0
            : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0
            ? void 0
            : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0
          ? _ref3
          : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0
        ? _ref2
        : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0
        ? void 0
        : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0
        ? void 0
        : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0
      ? _ref
      : 0,
  ); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

function _typeof$j(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$j = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$j = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$j(obj);
}

function _classCallCheck$h(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$h(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$h(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$h(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$h(Constructor, staticProps);
  return Constructor;
}

function _inherits$h(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$j(subClass, superClass);
}

function _setPrototypeOf$j(o, p) {
  _setPrototypeOf$j =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$j(o, p);
}

function _createSuper$h(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$h();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$h(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$h(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$h(this, result);
  };
}

function _possibleConstructorReturn$h(self, call) {
  if (call && (_typeof$j(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$j(self);
}

function _assertThisInitialized$j(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$h() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$h(o) {
  _getPrototypeOf$h = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$h(o);
}

function _defineProperty$k(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var DayParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$h(DayParser, _Parser);

  var _super = _createSuper$h(DayParser);

  function DayParser() {
    var _this;

    _classCallCheck$h(this, DayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$k(_assertThisInitialized$j(_this), 'priority', 90);

    _defineProperty$k(_assertThisInitialized$j(_this), 'incompatibleTokens', ['D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$h(DayParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          // Tue
          case 'E':
          case 'EE':
          case 'EEE':
            return (
              match.day(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'short',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
          // T

          case 'EEEEE':
            return match.day(dateString, {
              width: 'narrow',
              context: 'formatting',
            });
          // Tu

          case 'EEEEEE':
            return (
              match.day(dateString, {
                width: 'short',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
          // Tuesday

          case 'EEEE':
          default:
            return (
              match.day(dateString, {
                width: 'wide',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'short',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 0 && value <= 6;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return DayParser;
})(Parser);

function _typeof$i(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$i = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$i = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$i(obj);
}

function _classCallCheck$g(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$g(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$g(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$g(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$g(Constructor, staticProps);
  return Constructor;
}

function _inherits$g(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$i(subClass, superClass);
}

function _setPrototypeOf$i(o, p) {
  _setPrototypeOf$i =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$i(o, p);
}

function _createSuper$g(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$g();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$g(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$g(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$g(this, result);
  };
}

function _possibleConstructorReturn$g(self, call) {
  if (call && (_typeof$i(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$i(self);
}

function _assertThisInitialized$i(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$g() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$g(o) {
  _getPrototypeOf$g = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$g(o);
}

function _defineProperty$j(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var LocalDayParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$g(LocalDayParser, _Parser);

  var _super = _createSuper$g(LocalDayParser);

  function LocalDayParser() {
    var _this;

    _classCallCheck$g(this, LocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$j(_assertThisInitialized$i(_this), 'priority', 90);

    _defineProperty$j(_assertThisInitialized$i(_this), 'incompatibleTokens', [
      'y',
      'R',
      'u',
      'q',
      'Q',
      'M',
      'L',
      'I',
      'd',
      'D',
      'E',
      'i',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$g(LocalDayParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match, options) {
        var valueCallback = function valueCallback(value) {
          var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
          return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
        };

        switch (token) {
          // 3
          case 'e':
          case 'ee':
            // 03
            return mapValue(parseNDigits(token.length, dateString), valueCallback);
          // 3rd

          case 'eo':
            return mapValue(
              match.ordinalNumber(dateString, {
                unit: 'day',
              }),
              valueCallback,
            );
          // Tue

          case 'eee':
            return (
              match.day(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'short',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
          // T

          case 'eeeee':
            return match.day(dateString, {
              width: 'narrow',
              context: 'formatting',
            });
          // Tu

          case 'eeeeee':
            return (
              match.day(dateString, {
                width: 'short',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
          // Tuesday

          case 'eeee':
          default:
            return (
              match.day(dateString, {
                width: 'wide',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'short',
                context: 'formatting',
              }) ||
              match.day(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 0 && value <= 6;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return LocalDayParser;
})(Parser);

function _typeof$h(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$h = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$h = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$h(obj);
}

function _classCallCheck$f(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$f(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$f(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$f(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$f(Constructor, staticProps);
  return Constructor;
}

function _inherits$f(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$h(subClass, superClass);
}

function _setPrototypeOf$h(o, p) {
  _setPrototypeOf$h =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$h(o, p);
}

function _createSuper$f(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$f();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$f(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$f(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$f(this, result);
  };
}

function _possibleConstructorReturn$f(self, call) {
  if (call && (_typeof$h(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$h(self);
}

function _assertThisInitialized$h(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$f() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$f(o) {
  _getPrototypeOf$f = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$f(o);
}

function _defineProperty$i(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var StandAloneLocalDayParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$f(StandAloneLocalDayParser, _Parser);

  var _super = _createSuper$f(StandAloneLocalDayParser);

  function StandAloneLocalDayParser() {
    var _this;

    _classCallCheck$f(this, StandAloneLocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$i(_assertThisInitialized$h(_this), 'priority', 90);

    _defineProperty$i(_assertThisInitialized$h(_this), 'incompatibleTokens', [
      'y',
      'R',
      'u',
      'q',
      'Q',
      'M',
      'L',
      'I',
      'd',
      'D',
      'E',
      'i',
      'e',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$f(StandAloneLocalDayParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match, options) {
        var valueCallback = function valueCallback(value) {
          var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
          return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
        };

        switch (token) {
          // 3
          case 'c':
          case 'cc':
            // 03
            return mapValue(parseNDigits(token.length, dateString), valueCallback);
          // 3rd

          case 'co':
            return mapValue(
              match.ordinalNumber(dateString, {
                unit: 'day',
              }),
              valueCallback,
            );
          // Tue

          case 'ccc':
            return (
              match.day(dateString, {
                width: 'abbreviated',
                context: 'standalone',
              }) ||
              match.day(dateString, {
                width: 'short',
                context: 'standalone',
              }) ||
              match.day(dateString, {
                width: 'narrow',
                context: 'standalone',
              })
            );
          // T

          case 'ccccc':
            return match.day(dateString, {
              width: 'narrow',
              context: 'standalone',
            });
          // Tu

          case 'cccccc':
            return (
              match.day(dateString, {
                width: 'short',
                context: 'standalone',
              }) ||
              match.day(dateString, {
                width: 'narrow',
                context: 'standalone',
              })
            );
          // Tuesday

          case 'cccc':
          default:
            return (
              match.day(dateString, {
                width: 'wide',
                context: 'standalone',
              }) ||
              match.day(dateString, {
                width: 'abbreviated',
                context: 'standalone',
              }) ||
              match.day(dateString, {
                width: 'short',
                context: 'standalone',
              }) ||
              match.day(dateString, {
                width: 'narrow',
                context: 'standalone',
              })
            );
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 0 && value <= 6;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return StandAloneLocalDayParser;
})(Parser);

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

function _typeof$g(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$g = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$g = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$g(obj);
}

function _classCallCheck$e(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$e(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$e(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$e(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$e(Constructor, staticProps);
  return Constructor;
}

function _inherits$e(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$g(subClass, superClass);
}

function _setPrototypeOf$g(o, p) {
  _setPrototypeOf$g =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$g(o, p);
}

function _createSuper$e(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$e();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$e(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$e(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$e(this, result);
  };
}

function _possibleConstructorReturn$e(self, call) {
  if (call && (_typeof$g(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$g(self);
}

function _assertThisInitialized$g(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$e() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$e(o) {
  _getPrototypeOf$e = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$e(o);
}

function _defineProperty$h(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var ISODayParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$e(ISODayParser, _Parser);

  var _super = _createSuper$e(ISODayParser);

  function ISODayParser() {
    var _this;

    _classCallCheck$e(this, ISODayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$h(_assertThisInitialized$g(_this), 'priority', 90);

    _defineProperty$h(_assertThisInitialized$g(_this), 'incompatibleTokens', [
      'y',
      'Y',
      'u',
      'q',
      'Q',
      'M',
      'L',
      'w',
      'd',
      'D',
      'E',
      'e',
      'c',
      't',
      'T',
    ]);

    return _this;
  }

  _createClass$e(ISODayParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        var valueCallback = function valueCallback(value) {
          if (value === 0) {
            return 7;
          }

          return value;
        };

        switch (token) {
          // 2
          case 'i':
          case 'ii':
            // 02
            return parseNDigits(token.length, dateString);
          // 2nd

          case 'io':
            return match.ordinalNumber(dateString, {
              unit: 'day',
            });
          // Tue

          case 'iii':
            return mapValue(
              match.day(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
                match.day(dateString, {
                  width: 'short',
                  context: 'formatting',
                }) ||
                match.day(dateString, {
                  width: 'narrow',
                  context: 'formatting',
                }),
              valueCallback,
            );
          // T

          case 'iiiii':
            return mapValue(
              match.day(dateString, {
                width: 'narrow',
                context: 'formatting',
              }),
              valueCallback,
            );
          // Tu

          case 'iiiiii':
            return mapValue(
              match.day(dateString, {
                width: 'short',
                context: 'formatting',
              }) ||
                match.day(dateString, {
                  width: 'narrow',
                  context: 'formatting',
                }),
              valueCallback,
            );
          // Tuesday

          case 'iiii':
          default:
            return mapValue(
              match.day(dateString, {
                width: 'wide',
                context: 'formatting',
              }) ||
                match.day(dateString, {
                  width: 'abbreviated',
                  context: 'formatting',
                }) ||
                match.day(dateString, {
                  width: 'short',
                  context: 'formatting',
                }) ||
                match.day(dateString, {
                  width: 'narrow',
                  context: 'formatting',
                }),
              valueCallback,
            );
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 1 && value <= 7;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date = setUTCISODay(date, value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      },
    },
  ]);

  return ISODayParser;
})(Parser);

function _typeof$f(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$f = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$f = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$f(obj);
}

function _classCallCheck$d(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$d(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$d(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$d(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$d(Constructor, staticProps);
  return Constructor;
}

function _inherits$d(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$f(subClass, superClass);
}

function _setPrototypeOf$f(o, p) {
  _setPrototypeOf$f =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$f(o, p);
}

function _createSuper$d(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$d();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$d(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$d(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$d(this, result);
  };
}

function _possibleConstructorReturn$d(self, call) {
  if (call && (_typeof$f(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$f(self);
}

function _assertThisInitialized$f(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$d() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$d(o) {
  _getPrototypeOf$d = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$d(o);
}

function _defineProperty$g(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var AMPMParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$d(AMPMParser, _Parser);

  var _super = _createSuper$d(AMPMParser);

  function AMPMParser() {
    var _this;

    _classCallCheck$d(this, AMPMParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$g(_assertThisInitialized$f(_this), 'priority', 80);

    _defineProperty$g(_assertThisInitialized$f(_this), 'incompatibleTokens', ['b', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  _createClass$d(AMPMParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'a':
          case 'aa':
          case 'aaa':
            return (
              match.dayPeriod(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.dayPeriod(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );

          case 'aaaaa':
            return match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting',
            });

          case 'aaaa':
          default:
            return (
              match.dayPeriod(dateString, {
                width: 'wide',
                context: 'formatting',
              }) ||
              match.dayPeriod(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.dayPeriod(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
        }
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      },
    },
  ]);

  return AMPMParser;
})(Parser);

function _typeof$e(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$e = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$e = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$e(obj);
}

function _classCallCheck$c(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$c(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$c(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$c(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$c(Constructor, staticProps);
  return Constructor;
}

function _inherits$c(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$e(subClass, superClass);
}

function _setPrototypeOf$e(o, p) {
  _setPrototypeOf$e =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$e(o, p);
}

function _createSuper$c(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$c();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$c(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$c(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$c(this, result);
  };
}

function _possibleConstructorReturn$c(self, call) {
  if (call && (_typeof$e(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$e(self);
}

function _assertThisInitialized$e(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$c() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$c(o) {
  _getPrototypeOf$c = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$c(o);
}

function _defineProperty$f(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var AMPMMidnightParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$c(AMPMMidnightParser, _Parser);

  var _super = _createSuper$c(AMPMMidnightParser);

  function AMPMMidnightParser() {
    var _this;

    _classCallCheck$c(this, AMPMMidnightParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$f(_assertThisInitialized$e(_this), 'priority', 80);

    _defineProperty$f(_assertThisInitialized$e(_this), 'incompatibleTokens', ['a', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  _createClass$c(AMPMMidnightParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'b':
          case 'bb':
          case 'bbb':
            return (
              match.dayPeriod(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.dayPeriod(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );

          case 'bbbbb':
            return match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting',
            });

          case 'bbbb':
          default:
            return (
              match.dayPeriod(dateString, {
                width: 'wide',
                context: 'formatting',
              }) ||
              match.dayPeriod(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.dayPeriod(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
        }
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      },
    },
  ]);

  return AMPMMidnightParser;
})(Parser);

function _typeof$d(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$d = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$d = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$d(obj);
}

function _classCallCheck$b(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$b(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$b(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$b(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$b(Constructor, staticProps);
  return Constructor;
}

function _inherits$b(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$d(subClass, superClass);
}

function _setPrototypeOf$d(o, p) {
  _setPrototypeOf$d =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$d(o, p);
}

function _createSuper$b(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$b();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$b(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$b(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$b(this, result);
  };
}

function _possibleConstructorReturn$b(self, call) {
  if (call && (_typeof$d(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$d(self);
}

function _assertThisInitialized$d(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$b() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$b(o) {
  _getPrototypeOf$b = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$b(o);
}

function _defineProperty$e(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var DayPeriodParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$b(DayPeriodParser, _Parser);

  var _super = _createSuper$b(DayPeriodParser);

  function DayPeriodParser() {
    var _this;

    _classCallCheck$b(this, DayPeriodParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$e(_assertThisInitialized$d(_this), 'priority', 80);

    _defineProperty$e(_assertThisInitialized$d(_this), 'incompatibleTokens', ['a', 'b', 't', 'T']);

    return _this;
  }

  _createClass$b(DayPeriodParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'B':
          case 'BB':
          case 'BBB':
            return (
              match.dayPeriod(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.dayPeriod(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );

          case 'BBBBB':
            return match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting',
            });

          case 'BBBB':
          default:
            return (
              match.dayPeriod(dateString, {
                width: 'wide',
                context: 'formatting',
              }) ||
              match.dayPeriod(dateString, {
                width: 'abbreviated',
                context: 'formatting',
              }) ||
              match.dayPeriod(dateString, {
                width: 'narrow',
                context: 'formatting',
              })
            );
        }
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      },
    },
  ]);

  return DayPeriodParser;
})(Parser);

function _typeof$c(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$c = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$c = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$c(obj);
}

function _classCallCheck$a(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$a(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$a(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$a(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$a(Constructor, staticProps);
  return Constructor;
}

function _inherits$a(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$c(subClass, superClass);
}

function _setPrototypeOf$c(o, p) {
  _setPrototypeOf$c =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$c(o, p);
}

function _createSuper$a(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$a();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$a(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$a(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$a(this, result);
  };
}

function _possibleConstructorReturn$a(self, call) {
  if (call && (_typeof$c(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$c(self);
}

function _assertThisInitialized$c(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$a() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$a(o) {
  _getPrototypeOf$a = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$a(o);
}

function _defineProperty$d(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var Hour1to12Parser = /*#__PURE__*/ (function (_Parser) {
  _inherits$a(Hour1to12Parser, _Parser);

  var _super = _createSuper$a(Hour1to12Parser);

  function Hour1to12Parser() {
    var _this;

    _classCallCheck$a(this, Hour1to12Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$d(_assertThisInitialized$c(_this), 'priority', 70);

    _defineProperty$d(_assertThisInitialized$c(_this), 'incompatibleTokens', ['H', 'K', 'k', 't', 'T']);

    return _this;
  }

  _createClass$a(Hour1to12Parser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'h':
            return parseNumericPattern(numericPatterns.hour12h, dateString);

          case 'ho':
            return match.ordinalNumber(dateString, {
              unit: 'hour',
            });

          default:
            return parseNDigits(token.length, dateString);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 1 && value <= 12;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        var isPM = date.getUTCHours() >= 12;

        if (isPM && value < 12) {
          date.setUTCHours(value + 12, 0, 0, 0);
        } else if (!isPM && value === 12) {
          date.setUTCHours(0, 0, 0, 0);
        } else {
          date.setUTCHours(value, 0, 0, 0);
        }

        return date;
      },
    },
  ]);

  return Hour1to12Parser;
})(Parser);

function _typeof$b(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$b = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$b = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$b(obj);
}

function _classCallCheck$9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$9(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$9(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$9(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$9(Constructor, staticProps);
  return Constructor;
}

function _inherits$9(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$b(subClass, superClass);
}

function _setPrototypeOf$b(o, p) {
  _setPrototypeOf$b =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$b(o, p);
}

function _createSuper$9(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$9();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$9(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$9(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$9(this, result);
  };
}

function _possibleConstructorReturn$9(self, call) {
  if (call && (_typeof$b(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$b(self);
}

function _assertThisInitialized$b(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$9() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$9(o) {
  _getPrototypeOf$9 = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$9(o);
}

function _defineProperty$c(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var Hour0to23Parser = /*#__PURE__*/ (function (_Parser) {
  _inherits$9(Hour0to23Parser, _Parser);

  var _super = _createSuper$9(Hour0to23Parser);

  function Hour0to23Parser() {
    var _this;

    _classCallCheck$9(this, Hour0to23Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$c(_assertThisInitialized$b(_this), 'priority', 70);

    _defineProperty$c(_assertThisInitialized$b(_this), 'incompatibleTokens', ['a', 'b', 'h', 'K', 'k', 't', 'T']);

    return _this;
  }

  _createClass$9(Hour0to23Parser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'H':
            return parseNumericPattern(numericPatterns.hour23h, dateString);

          case 'Ho':
            return match.ordinalNumber(dateString, {
              unit: 'hour',
            });

          default:
            return parseNDigits(token.length, dateString);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 0 && value <= 23;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCHours(value, 0, 0, 0);
        return date;
      },
    },
  ]);

  return Hour0to23Parser;
})(Parser);

function _typeof$a(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$a = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$a = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$a(obj);
}

function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$8(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$8(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$8(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$8(Constructor, staticProps);
  return Constructor;
}

function _inherits$8(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$a(subClass, superClass);
}

function _setPrototypeOf$a(o, p) {
  _setPrototypeOf$a =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$a(o, p);
}

function _createSuper$8(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$8();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$8(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$8(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$8(this, result);
  };
}

function _possibleConstructorReturn$8(self, call) {
  if (call && (_typeof$a(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$a(self);
}

function _assertThisInitialized$a(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$8() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$8(o) {
  _getPrototypeOf$8 = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$8(o);
}

function _defineProperty$b(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var Hour0To11Parser = /*#__PURE__*/ (function (_Parser) {
  _inherits$8(Hour0To11Parser, _Parser);

  var _super = _createSuper$8(Hour0To11Parser);

  function Hour0To11Parser() {
    var _this;

    _classCallCheck$8(this, Hour0To11Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$b(_assertThisInitialized$a(_this), 'priority', 70);

    _defineProperty$b(_assertThisInitialized$a(_this), 'incompatibleTokens', ['h', 'H', 'k', 't', 'T']);

    return _this;
  }

  _createClass$8(Hour0To11Parser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'K':
            return parseNumericPattern(numericPatterns.hour11h, dateString);

          case 'Ko':
            return match.ordinalNumber(dateString, {
              unit: 'hour',
            });

          default:
            return parseNDigits(token.length, dateString);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 0 && value <= 11;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        var isPM = date.getUTCHours() >= 12;

        if (isPM && value < 12) {
          date.setUTCHours(value + 12, 0, 0, 0);
        } else {
          date.setUTCHours(value, 0, 0, 0);
        }

        return date;
      },
    },
  ]);

  return Hour0To11Parser;
})(Parser);

function _typeof$9(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$9 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$9 = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$9(obj);
}

function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$7(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$7(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$7(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$7(Constructor, staticProps);
  return Constructor;
}

function _inherits$7(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$9(subClass, superClass);
}

function _setPrototypeOf$9(o, p) {
  _setPrototypeOf$9 =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$9(o, p);
}

function _createSuper$7(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$7();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$7(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$7(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$7(this, result);
  };
}

function _possibleConstructorReturn$7(self, call) {
  if (call && (_typeof$9(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$9(self);
}

function _assertThisInitialized$9(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$7() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$7(o) {
  _getPrototypeOf$7 = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$7(o);
}

function _defineProperty$a(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var Hour1To24Parser = /*#__PURE__*/ (function (_Parser) {
  _inherits$7(Hour1To24Parser, _Parser);

  var _super = _createSuper$7(Hour1To24Parser);

  function Hour1To24Parser() {
    var _this;

    _classCallCheck$7(this, Hour1To24Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$a(_assertThisInitialized$9(_this), 'priority', 70);

    _defineProperty$a(_assertThisInitialized$9(_this), 'incompatibleTokens', ['a', 'b', 'h', 'H', 'K', 't', 'T']);

    return _this;
  }

  _createClass$7(Hour1To24Parser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'k':
            return parseNumericPattern(numericPatterns.hour24h, dateString);

          case 'ko':
            return match.ordinalNumber(dateString, {
              unit: 'hour',
            });

          default:
            return parseNDigits(token.length, dateString);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 1 && value <= 24;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        var hours = value <= 24 ? value % 24 : value;
        date.setUTCHours(hours, 0, 0, 0);
        return date;
      },
    },
  ]);

  return Hour1To24Parser;
})(Parser);

function _typeof$8(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$8 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$8 = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$8(obj);
}

function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$6(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$6(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$6(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$6(Constructor, staticProps);
  return Constructor;
}

function _inherits$6(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$8(subClass, superClass);
}

function _setPrototypeOf$8(o, p) {
  _setPrototypeOf$8 =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$8(o, p);
}

function _createSuper$6(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$6();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$6(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$6(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$6(this, result);
  };
}

function _possibleConstructorReturn$6(self, call) {
  if (call && (_typeof$8(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$8(self);
}

function _assertThisInitialized$8(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$6() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$6(o) {
  _getPrototypeOf$6 = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$6(o);
}

function _defineProperty$9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var MinuteParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$6(MinuteParser, _Parser);

  var _super = _createSuper$6(MinuteParser);

  function MinuteParser() {
    var _this;

    _classCallCheck$6(this, MinuteParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$9(_assertThisInitialized$8(_this), 'priority', 60);

    _defineProperty$9(_assertThisInitialized$8(_this), 'incompatibleTokens', ['t', 'T']);

    return _this;
  }

  _createClass$6(MinuteParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'm':
            return parseNumericPattern(numericPatterns.minute, dateString);

          case 'mo':
            return match.ordinalNumber(dateString, {
              unit: 'minute',
            });

          default:
            return parseNDigits(token.length, dateString);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 0 && value <= 59;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCMinutes(value, 0, 0);
        return date;
      },
    },
  ]);

  return MinuteParser;
})(Parser);

function _typeof$7(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$7 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$7 = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$7(obj);
}

function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$5(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$5(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$5(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$5(Constructor, staticProps);
  return Constructor;
}

function _inherits$5(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$7(subClass, superClass);
}

function _setPrototypeOf$7(o, p) {
  _setPrototypeOf$7 =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$7(o, p);
}

function _createSuper$5(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$5(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$5(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$5(this, result);
  };
}

function _possibleConstructorReturn$5(self, call) {
  if (call && (_typeof$7(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$7(self);
}

function _assertThisInitialized$7(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$5() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$5(o) {
  _getPrototypeOf$5 = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$5(o);
}

function _defineProperty$8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var SecondParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$5(SecondParser, _Parser);

  var _super = _createSuper$5(SecondParser);

  function SecondParser() {
    var _this;

    _classCallCheck$5(this, SecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$7(_this), 'priority', 50);

    _defineProperty$8(_assertThisInitialized$7(_this), 'incompatibleTokens', ['t', 'T']);

    return _this;
  }

  _createClass$5(SecondParser, [
    {
      key: 'parse',
      value: function parse(dateString, token, match) {
        switch (token) {
          case 's':
            return parseNumericPattern(numericPatterns.second, dateString);

          case 'so':
            return match.ordinalNumber(dateString, {
              unit: 'second',
            });

          default:
            return parseNDigits(token.length, dateString);
        }
      },
    },
    {
      key: 'validate',
      value: function validate(_date, value) {
        return value >= 0 && value <= 59;
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCSeconds(value, 0);
        return date;
      },
    },
  ]);

  return SecondParser;
})(Parser);

function _typeof$6(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$6 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$6 = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$6(obj);
}

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$4(Constructor, staticProps);
  return Constructor;
}

function _inherits$4(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$6(subClass, superClass);
}

function _setPrototypeOf$6(o, p) {
  _setPrototypeOf$6 =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$6(o, p);
}

function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$4(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$4(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$4(this, result);
  };
}

function _possibleConstructorReturn$4(self, call) {
  if (call && (_typeof$6(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$6(self);
}

function _assertThisInitialized$6(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$4() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$4(o) {
  _getPrototypeOf$4 = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$4(o);
}

function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var FractionOfSecondParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$4(FractionOfSecondParser, _Parser);

  var _super = _createSuper$4(FractionOfSecondParser);

  function FractionOfSecondParser() {
    var _this;

    _classCallCheck$4(this, FractionOfSecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$7(_assertThisInitialized$6(_this), 'priority', 30);

    _defineProperty$7(_assertThisInitialized$6(_this), 'incompatibleTokens', ['t', 'T']);

    return _this;
  }

  _createClass$4(FractionOfSecondParser, [
    {
      key: 'parse',
      value: function parse(dateString, token) {
        var valueCallback = function valueCallback(value) {
          return Math.floor(value * Math.pow(10, -token.length + 3));
        };

        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      },
    },
    {
      key: 'set',
      value: function set(date, _flags, value) {
        date.setUTCMilliseconds(value);
        return date;
      },
    },
  ]);

  return FractionOfSecondParser;
})(Parser);

function _typeof$5(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$5 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$5 = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$5(obj);
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$3(Constructor, staticProps);
  return Constructor;
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$5(subClass, superClass);
}

function _setPrototypeOf$5(o, p) {
  _setPrototypeOf$5 =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$5(o, p);
}

function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$3(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$3(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$3(this, result);
  };
}

function _possibleConstructorReturn$3(self, call) {
  if (call && (_typeof$5(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$5(self);
}

function _assertThisInitialized$5(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$3() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$3(o) {
  _getPrototypeOf$3 = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$3(o);
}

function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var ISOTimezoneWithZParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$3(ISOTimezoneWithZParser, _Parser);

  var _super = _createSuper$3(ISOTimezoneWithZParser);

  function ISOTimezoneWithZParser() {
    var _this;

    _classCallCheck$3(this, ISOTimezoneWithZParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$6(_assertThisInitialized$5(_this), 'priority', 10);

    _defineProperty$6(_assertThisInitialized$5(_this), 'incompatibleTokens', ['t', 'T', 'x']);

    return _this;
  }

  _createClass$3(ISOTimezoneWithZParser, [
    {
      key: 'parse',
      value: function parse(dateString, token) {
        switch (token) {
          case 'X':
            return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

          case 'XX':
            return parseTimezonePattern(timezonePatterns.basic, dateString);

          case 'XXXX':
            return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

          case 'XXXXX':
            return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

          case 'XXX':
          default:
            return parseTimezonePattern(timezonePatterns.extended, dateString);
        }
      },
    },
    {
      key: 'set',
      value: function set(date, flags, value) {
        if (flags.timestampIsSet) {
          return date;
        }

        return new Date(date.getTime() - value);
      },
    },
  ]);

  return ISOTimezoneWithZParser;
})(Parser);

function _typeof$4(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$4 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$4 = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$4(obj);
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  return Constructor;
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$4(subClass, superClass);
}

function _setPrototypeOf$4(o, p) {
  _setPrototypeOf$4 =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$4(o, p);
}

function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$2(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$2(this, result);
  };
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (_typeof$4(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$4(self);
}

function _assertThisInitialized$4(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$2() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$2(o);
}

function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var ISOTimezoneParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$2(ISOTimezoneParser, _Parser);

  var _super = _createSuper$2(ISOTimezoneParser);

  function ISOTimezoneParser() {
    var _this;

    _classCallCheck$2(this, ISOTimezoneParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$5(_assertThisInitialized$4(_this), 'priority', 10);

    _defineProperty$5(_assertThisInitialized$4(_this), 'incompatibleTokens', ['t', 'T', 'X']);

    return _this;
  }

  _createClass$2(ISOTimezoneParser, [
    {
      key: 'parse',
      value: function parse(dateString, token) {
        switch (token) {
          case 'x':
            return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

          case 'xx':
            return parseTimezonePattern(timezonePatterns.basic, dateString);

          case 'xxxx':
            return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

          case 'xxxxx':
            return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

          case 'xxx':
          default:
            return parseTimezonePattern(timezonePatterns.extended, dateString);
        }
      },
    },
    {
      key: 'set',
      value: function set(date, flags, value) {
        if (flags.timestampIsSet) {
          return date;
        }

        return new Date(date.getTime() - value);
      },
    },
  ]);

  return ISOTimezoneParser;
})(Parser);

function _typeof$3(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$3 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$3 = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$3(obj);
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$3(subClass, superClass);
}

function _setPrototypeOf$3(o, p) {
  _setPrototypeOf$3 =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$3(o, p);
}

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$3(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$3(self);
}

function _assertThisInitialized$3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf$1(o);
}

function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var TimestampSecondsParser = /*#__PURE__*/ (function (_Parser) {
  _inherits$1(TimestampSecondsParser, _Parser);

  var _super = _createSuper$1(TimestampSecondsParser);

  function TimestampSecondsParser() {
    var _this;

    _classCallCheck$1(this, TimestampSecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$4(_assertThisInitialized$3(_this), 'priority', 40);

    _defineProperty$4(_assertThisInitialized$3(_this), 'incompatibleTokens', '*');

    return _this;
  }

  _createClass$1(TimestampSecondsParser, [
    {
      key: 'parse',
      value: function parse(dateString) {
        return parseAnyDigitsSigned(dateString);
      },
    },
    {
      key: 'set',
      value: function set(_date, _flags, value) {
        return [
          new Date(value * 1000),
          {
            timestampIsSet: true,
          },
        ];
      },
    },
  ]);

  return TimestampSecondsParser;
})(Parser);

function _typeof$2(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$2(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf$2(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$2(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized$2(self);
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var TimestampMillisecondsParser = /*#__PURE__*/ (function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);

  var _super = _createSuper(TimestampMillisecondsParser);

  function TimestampMillisecondsParser() {
    var _this;

    _classCallCheck(this, TimestampMillisecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$3(_assertThisInitialized$2(_this), 'priority', 20);

    _defineProperty$3(_assertThisInitialized$2(_this), 'incompatibleTokens', '*');

    return _this;
  }

  _createClass(TimestampMillisecondsParser, [
    {
      key: 'parse',
      value: function parse(dateString) {
        return parseAnyDigitsSigned(dateString);
      },
    },
    {
      key: 'set',
      value: function set(_date, _flags, value) {
        return [
          new Date(value),
          {
            timestampIsSet: true,
          },
        ];
      },
    },
  ]);

  return TimestampMillisecondsParser;
})(Parser);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */

var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser(),
};

function _typeof$1(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof$1(obj);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;
  if (typeof Symbol === 'undefined' || o[Symbol.iterator] == null) {
    if (
      Array.isArray(o) ||
      (it = _unsupportedIterableToArray$2(o)) ||
      (allowArrayLike && o && typeof o.length === 'number')
    ) {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return { done: true };
          return { done: false, value: o[i++] };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F,
      };
    }
    throw new TypeError(
      'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
    );
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    },
  };
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref,
    _options$locale,
    _ref2,
    _ref3,
    _ref4,
    _options$firstWeekCon,
    _options$locale2,
    _options$locale2$opti,
    _defaultOptions$local,
    _defaultOptions$local2,
    _ref5,
    _ref6,
    _ref7,
    _options$weekStartsOn,
    _options$locale3,
    _options$locale3$opti,
    _defaultOptions$local3,
    _defaultOptions$local4;

  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = getDefaultOptions();
  var locale$1 =
    (_ref =
      (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null &&
      _options$locale !== void 0
        ? _options$locale
        : defaultOptions.locale) !== null && _ref !== void 0
      ? _ref
      : locale;

  if (!locale$1.match) {
    throw new RangeError('locale must contain match property');
  }

  var firstWeekContainsDate = toInteger(
    (_ref2 =
      (_ref3 =
        (_ref4 =
          (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !==
            null && _options$firstWeekCon !== void 0
            ? _options$firstWeekCon
            : options === null || options === void 0
            ? void 0
            : (_options$locale2 = options.locale) === null || _options$locale2 === void 0
            ? void 0
            : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0
            ? void 0
            : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0
          ? _ref4
          : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0
        ? _ref3
        : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0
        ? void 0
        : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0
        ? void 0
        : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0
      ? _ref2
      : 1,
  ); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = toInteger(
    (_ref5 =
      (_ref6 =
        (_ref7 =
          (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null &&
          _options$weekStartsOn !== void 0
            ? _options$weekStartsOn
            : options === null || options === void 0
            ? void 0
            : (_options$locale3 = options.locale) === null || _options$locale3 === void 0
            ? void 0
            : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0
            ? void 0
            : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0
          ? _ref7
          : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0
        ? _ref6
        : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0
        ? void 0
        : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0
        ? void 0
        : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0
      ? _ref5
      : 0,
  ); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString
    .match(longFormattingTokensRegExp)
    .map(function (substring) {
      var firstCharacter = substring[0];

      if (firstCharacter in longFormatters) {
        var longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale$1.formatLong);
      }

      return substring;
    })
    .join('')
    .match(formattingTokensRegExp);
  var usedTokens = [];

  var _iterator = _createForOfIteratorHelper(tokens),
    _step;

  try {
    var _loop = function _loop() {
      var token = _step.value;

      if (
        !(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) &&
        isProtectedWeekYearToken(token)
      ) {
        throwProtectedError(token, formatString, dirtyDateString);
      }

      if (
        !(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) &&
        isProtectedDayOfYearToken(token)
      ) {
        throwProtectedError(token, formatString, dirtyDateString);
      }

      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];

      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;

        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });

          if (incompatibleToken) {
            throw new RangeError(
              "The format string mustn't contain `"
                .concat(incompatibleToken.fullToken, '` and `')
                .concat(token, '` at the same time'),
            );
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError(
            "The format string mustn't contain `".concat(token, '` and any other token at the same time'),
          );
        }

        usedTokens.push({
          token: firstCharacter,
          fullToken: token,
        });
        var parseResult = parser.run(dateString, token, locale$1.match, subFnOptions);

        if (!parseResult) {
          return {
            v: new Date(NaN),
          };
        }

        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        } // Replace two single quote characters with one single quote character

        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        } // Cut token from string, or, if string doesn't match the token, return Invalid Date

        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN),
          };
        }
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var _ret = _loop();

      if (_typeof$1(_ret) === 'object') return _ret.v;
    } // Check if the remaining input contains something other than whitespace
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters
    .map(function (setter) {
      return setter.priority;
    })
    .sort(function (a, b) {
      return b - a;
    })
    .filter(function (priority, index, array) {
      return array.indexOf(priority) === index;
    })
    .map(function (priority) {
      return setters
        .filter(function (setter) {
          return setter.priority === priority;
        })
        .sort(function (a, b) {
          return b.subPriority - a.subPriority;
        });
    })
    .map(function (setterArray) {
      return setterArray[0];
    });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.

  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
    _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var setter = _step2.value;

      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }

      var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)

      if (Array.isArray(result)) {
        utcDate = result[0];
        assign(flags, result[1]); // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return utcDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, options) {
  var _options$additionalDi;

  requiredArgs(1, arguments);
  var additionalDigits = toInteger(
    (_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null &&
      _options$additionalDi !== void 0
      ? _options$additionalDi
      : 2,
  );

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(
      dirtyDate.getUTCHours(),
      dirtyDate.getUTCMinutes(),
      dirtyDate.getUTCSeconds(),
      dirtyDate.getUTCMilliseconds(),
    );
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/,
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp(
    '^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)',
  );
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures)
    return {
      year: NaN,
      restDateString: '',
    };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length),
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}

function parseTimeUnit(value) {
  return (value && parseFloat(value.replace(',', '.'))) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = (captures[3] && parseInt(captures[3])) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)

var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf$1(subClass, superClass);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

  return _setPrototypeOf$1(o, p);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
} /**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17

  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host

  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    },
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};
function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */

function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return (
    (_temp = _class =
      /*#__PURE__*/ (function (_Component) {
        _inheritsLoose$1(onClickOutside, _Component);

        function onClickOutside(props) {
          var _this;

          _this = _Component.call(this, props) || this;

          _this.__outsideClickHandler = function (event) {
            if (typeof _this.__clickOutsideHandlerProp === 'function') {
              _this.__clickOutsideHandlerProp(event);

              return;
            }

            var instance = _this.getInstance();

            if (typeof instance.props.handleClickOutside === 'function') {
              instance.props.handleClickOutside(event);
              return;
            }

            if (typeof instance.handleClickOutside === 'function') {
              instance.handleClickOutside(event);
              return;
            }

            throw new Error(
              'WrappedComponent: ' +
                componentName +
                ' lacks a handleClickOutside(event) function for processing outside click events.',
            );
          };

          _this.__getComponentNode = function () {
            var instance = _this.getInstance();

            if (config && typeof config.setClickOutsideRef === 'function') {
              return config.setClickOutsideRef()(instance);
            }

            if (typeof instance.setClickOutsideRef === 'function') {
              return instance.setClickOutsideRef();
            }

            return ReactDOM.findDOMNode(instance);
          };

          _this.enableOnClickOutside = function () {
            if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
              return;
            }

            if (typeof passiveEventSupport === 'undefined') {
              passiveEventSupport = testPassiveEventSupport();
            }

            enabledInstances[_this._uid] = true;
            var events = _this.props.eventTypes;

            if (!events.forEach) {
              events = [events];
            }

            handlersMap[_this._uid] = function (event) {
              if (_this.componentNode === null) return;

              if (_this.props.preventDefault) {
                event.preventDefault();
              }

              if (_this.props.stopPropagation) {
                event.stopPropagation();
              }

              if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
              var current = (event.composed && event.composedPath && event.composedPath().shift()) || event.target;

              if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
                return;
              }

              _this.__outsideClickHandler(event);
            };

            events.forEach(function (eventName) {
              document.addEventListener(
                eventName,
                handlersMap[_this._uid],
                getEventHandlerOptions(_assertThisInitialized$1(_this), eventName),
              );
            });
          };

          _this.disableOnClickOutside = function () {
            delete enabledInstances[_this._uid];
            var fn = handlersMap[_this._uid];

            if (fn && typeof document !== 'undefined') {
              var events = _this.props.eventTypes;

              if (!events.forEach) {
                events = [events];
              }

              events.forEach(function (eventName) {
                return document.removeEventListener(
                  eventName,
                  fn,
                  getEventHandlerOptions(_assertThisInitialized$1(_this), eventName),
                );
              });
              delete handlersMap[_this._uid];
            }
          };

          _this.getRef = function (ref) {
            return (_this.instanceRef = ref);
          };

          _this._uid = uid();
          return _this;
        }
        /**
         * Access the WrappedComponent's instance.
         */

        var _proto = onClickOutside.prototype;

        _proto.getInstance = function getInstance() {
          if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
            return this;
          }

          var ref = this.instanceRef;
          return ref.getInstance ? ref.getInstance() : ref;
        };

        /**
         * Add click listeners to the current document,
         * linked to this component's state.
         */
        _proto.componentDidMount = function componentDidMount() {
          // If we are in an environment without a DOM such
          // as shallow rendering or snapshots then we exit
          // early to prevent any unhandled errors being thrown.
          if (typeof document === 'undefined' || !document.createElement) {
            return;
          }

          var instance = this.getInstance();

          if (config && typeof config.handleClickOutside === 'function') {
            this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

            if (typeof this.__clickOutsideHandlerProp !== 'function') {
              throw new Error(
                'WrappedComponent: ' +
                  componentName +
                  ' lacks a function for processing outside click events specified by the handleClickOutside config option.',
              );
            }
          }

          this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

          if (this.props.disableOnClickOutside) return;
          this.enableOnClickOutside();
        };

        _proto.componentDidUpdate = function componentDidUpdate() {
          this.componentNode = this.__getComponentNode();
        };
        /**
         * Remove all document's event listeners for this component
         */

        _proto.componentWillUnmount = function componentWillUnmount() {
          this.disableOnClickOutside();
        };
        /**
         * Can be called to explicitly enable event listening
         * for clicks and touches outside of this element.
         */

        /**
         * Pass-through render
         */
        _proto.render = function render() {
          // eslint-disable-next-line no-unused-vars
          var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose$2(_this$props, ['excludeScrollbar']);

          if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
            props.ref = this.getRef;
          } else {
            props.wrappedRef = this.getRef;
          }

          props.disableOnClickOutside = this.disableOnClickOutside;
          props.enableOnClickOutside = this.enableOnClickOutside;
          return React.createElement(WrappedComponent, props);
        };

        return onClickOutside;
      })(React.Component)),
    (_class.displayName = 'OnClickOutside(' + componentName + ')'),
    (_class.defaultProps = {
      eventTypes: ['mousedown', 'touchstart'],
      excludeScrollbar: (config && config.excludeScrollbar) || false,
      outsideClickIgnoreClass: IGNORE_CLASS_NAME,
      preventDefault: false,
      stopPropagation: false,
    }),
    (_class.getClass = function () {
      return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }),
    _temp
  );
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _extends$1() {
  _extends$1 = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends$1.apply(this, arguments);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _typeof(obj) {
  '@babel/helpers - typeof';

  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof(obj)
  );
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}

function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var toStr$3 = Object.prototype.toString;

var isArguments$2 = function isArguments(value) {
  var str = toStr$3.call(value);
  var isArgs = str === '[object Arguments]';
  if (!isArgs) {
    isArgs =
      str !== '[object Array]' &&
      value !== null &&
      typeof value === 'object' &&
      typeof value.length === 'number' &&
      value.length >= 0 &&
      toStr$3.call(value.callee) === '[object Function]';
  }
  return isArgs;
};

var implementation$9;
var hasRequiredImplementation;

function requireImplementation() {
  if (hasRequiredImplementation) return implementation$9;
  hasRequiredImplementation = 1;

  var keysShim;
  if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = isArguments$2; // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
    var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
    var dontEnums = [
      'toString',
      'toLocaleString',
      'valueOf',
      'hasOwnProperty',
      'isPrototypeOf',
      'propertyIsEnumerable',
      'constructor',
    ];
    var equalsConstructorPrototype = function (o) {
      var ctor = o.constructor;
      return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true,
    };
    var hasAutomationEqualityBug = (function () {
      /* global window */
      if (typeof window === 'undefined') {
        return false;
      }
      for (var k in window) {
        try {
          if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
            try {
              equalsConstructorPrototype(window[k]);
            } catch (e) {
              return true;
            }
          }
        } catch (e) {
          return true;
        }
      }
      return false;
    })();
    var equalsConstructorPrototypeIfNotBuggy = function (o) {
      /* global window */
      if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
        return equalsConstructorPrototype(o);
      }
      try {
        return equalsConstructorPrototype(o);
      } catch (e) {
        return false;
      }
    };

    keysShim = function keys(object) {
      var isObject = object !== null && typeof object === 'object';
      var isFunction = toStr.call(object) === '[object Function]';
      var isArguments = isArgs(object);
      var isString = isObject && toStr.call(object) === '[object String]';
      var theKeys = [];

      if (!isObject && !isFunction && !isArguments) {
        throw new TypeError('Object.keys called on a non-object');
      }

      var skipProto = hasProtoEnumBug && isFunction;
      if (isString && object.length > 0 && !has.call(object, 0)) {
        for (var i = 0; i < object.length; ++i) {
          theKeys.push(String(i));
        }
      }

      if (isArguments && object.length > 0) {
        for (var j = 0; j < object.length; ++j) {
          theKeys.push(String(j));
        }
      } else {
        for (var name in object) {
          if (!(skipProto && name === 'prototype') && has.call(object, name)) {
            theKeys.push(String(name));
          }
        }
      }

      if (hasDontEnumBug) {
        var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

        for (var k = 0; k < dontEnums.length; ++k) {
          if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
            theKeys.push(dontEnums[k]);
          }
        }
      }
      return theKeys;
    };
  }
  implementation$9 = keysShim;
  return implementation$9;
}

var slice = Array.prototype.slice;
var isArgs = isArguments$2;

var origKeys = Object.keys;
var keysShim = origKeys
  ? function keys(o) {
      return origKeys(o);
    }
  : requireImplementation();

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
  if (Object.keys) {
    var keysWorksWithArguments = (function () {
      // Safari 5.0 bug
      var args = Object.keys(arguments);
      return args && args.length === arguments.length;
    })(1, 2);
    if (!keysWorksWithArguments) {
      Object.keys = function keys(object) {
        // eslint-disable-line func-name-matching
        if (isArgs(object)) {
          return originalKeys(slice.call(object));
        }
        return originalKeys(object);
      };
    }
  } else {
    Object.keys = keysShim;
  }
  return Object.keys || keysShim;
};

var objectKeys$1 = keysShim;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams$1 = function hasSymbols() {
  if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
    return false;
  }
  if (typeof Symbol.iterator === 'symbol') {
    return true;
  }

  var obj = {};
  var sym = Symbol('test');
  var symObj = Object(sym);
  if (typeof sym === 'string') {
    return false;
  }

  if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
    return false;
  }

  // temp disabled per https://github.com/ljharb/object.assign/issues/17
  // if (sym instanceof Symbol) { return false; }
  // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
  // if (!(symObj instanceof Symbol)) { return false; }

  // if (typeof Symbol.prototype.toString !== 'function') { return false; }
  // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
  if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
    return false;
  }

  if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }

  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }

  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }

  if (typeof Object.getOwnPropertyDescriptor === 'function') {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }

  return true;
};

var hasSymbols$3 = shams$1;

var shams = function hasToStringTagShams() {
  return hasSymbols$3() && !!Symbol.toStringTag;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = shams$1;

var hasSymbols$2 = function hasNativeSymbols() {
  if (typeof origSymbol !== 'function') {
    return false;
  }
  if (typeof Symbol !== 'function') {
    return false;
  }
  if (typeof origSymbol('foo') !== 'symbol') {
    return false;
  }
  if (typeof Symbol('bar') !== 'symbol') {
    return false;
  }

  return hasSymbolSham();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr$2 = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
  var arr = [];

  for (var i = 0; i < a.length; i += 1) {
    arr[i] = a[i];
  }
  for (var j = 0; j < b.length; j += 1) {
    arr[j + a.length] = b[j];
  }

  return arr;
};

var slicy = function slicy(arrLike, offset) {
  var arr = [];
  for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
    arr[j] = arrLike[i];
  }
  return arr;
};

var joiny = function (arr, joiner) {
  var str = '';
  for (var i = 0; i < arr.length; i += 1) {
    str += arr[i];
    if (i + 1 < arr.length) {
      str += joiner;
    }
  }
  return str;
};

var implementation$8 = function bind(that) {
  var target = this;
  if (typeof target !== 'function' || toStr$2.apply(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slicy(arguments, 1);

  var bound;
  var binder = function () {
    if (this instanceof bound) {
      var result = target.apply(this, concatty(args, arguments));
      if (Object(result) === result) {
        return result;
      }
      return this;
    }
    return target.apply(that, concatty(args, arguments));
  };

  var boundLength = max(0, target.length - args.length);
  var boundArgs = [];
  for (var i = 0; i < boundLength; i++) {
    boundArgs[i] = '$' + i;
  }

  bound = Function(
    'binder',
    'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }',
  )(binder);

  if (target.prototype) {
    var Empty = function Empty() {};
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }

  return bound;
};

var implementation$7 = implementation$8;

var functionBind = Function.prototype.bind || implementation$7;

var hasOwnProperty = {}.hasOwnProperty;
var call = Function.prototype.call;

var src = call.bind
  ? call.bind(hasOwnProperty)
  : function (O, P) {
      return call.call(hasOwnProperty, O, P);
    };

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
  } catch (e) {}
};

var $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1) {
  try {
    $gOPD$1({}, '');
  } catch (e) {
    $gOPD$1 = null; // this is IE 8, which has a broken gOPD
  }
}

var throwTypeError = function () {
  throw new $TypeError();
};
var ThrowTypeError = $gOPD$1
  ? (function () {
      try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
      } catch (calleeThrows) {
        try {
          // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
          return $gOPD$1(arguments, 'callee').get;
        } catch (gOPDthrows) {
          return throwTypeError;
        }
      }
    })()
  : throwTypeError;

var hasSymbols$1 = hasSymbols$2();

var getProto$1 =
  Object.getPrototypeOf ||
  function (x) {
    return x.__proto__;
  }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto$1(Uint8Array);

var INTRINSICS = {
  '%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
  '%Array%': Array,
  '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
  '%ArrayIteratorPrototype%': hasSymbols$1 ? getProto$1([][Symbol.iterator]()) : undefined$1,
  '%AsyncFromSyncIteratorPrototype%': undefined$1,
  '%AsyncFunction%': needsEval,
  '%AsyncGenerator%': needsEval,
  '%AsyncGeneratorFunction%': needsEval,
  '%AsyncIteratorPrototype%': needsEval,
  '%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
  '%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
  '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined$1 : BigInt64Array,
  '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined$1 : BigUint64Array,
  '%Boolean%': Boolean,
  '%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
  '%Date%': Date,
  '%decodeURI%': decodeURI,
  '%decodeURIComponent%': decodeURIComponent,
  '%encodeURI%': encodeURI,
  '%encodeURIComponent%': encodeURIComponent,
  '%Error%': Error,
  '%eval%': eval, // eslint-disable-line no-eval
  '%EvalError%': EvalError,
  '%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
  '%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
  '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
  '%Function%': $Function,
  '%GeneratorFunction%': needsEval,
  '%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
  '%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
  '%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
  '%isFinite%': isFinite,
  '%isNaN%': isNaN,
  '%IteratorPrototype%': hasSymbols$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
  '%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
  '%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
  '%MapIteratorPrototype%':
    typeof Map === 'undefined' || !hasSymbols$1 ? undefined$1 : getProto$1(new Map()[Symbol.iterator]()),
  '%Math%': Math,
  '%Number%': Number,
  '%Object%': Object,
  '%parseFloat%': parseFloat,
  '%parseInt%': parseInt,
  '%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
  '%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
  '%RangeError%': RangeError,
  '%ReferenceError%': ReferenceError,
  '%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
  '%RegExp%': RegExp,
  '%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
  '%SetIteratorPrototype%':
    typeof Set === 'undefined' || !hasSymbols$1 ? undefined$1 : getProto$1(new Set()[Symbol.iterator]()),
  '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
  '%String%': String,
  '%StringIteratorPrototype%': hasSymbols$1 ? getProto$1(''[Symbol.iterator]()) : undefined$1,
  '%Symbol%': hasSymbols$1 ? Symbol : undefined$1,
  '%SyntaxError%': $SyntaxError,
  '%ThrowTypeError%': ThrowTypeError,
  '%TypedArray%': TypedArray,
  '%TypeError%': $TypeError,
  '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
  '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
  '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
  '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
  '%URIError%': URIError,
  '%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
  '%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
  '%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet,
};

try {
  null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
  // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
  var errorProto = getProto$1(getProto$1(e));
  INTRINSICS['%Error.prototype%'] = errorProto;
}

var doEval = function doEval(name) {
  var value;
  if (name === '%AsyncFunction%') {
    value = getEvalledConstructor('async function () {}');
  } else if (name === '%GeneratorFunction%') {
    value = getEvalledConstructor('function* () {}');
  } else if (name === '%AsyncGeneratorFunction%') {
    value = getEvalledConstructor('async function* () {}');
  } else if (name === '%AsyncGenerator%') {
    var fn = doEval('%AsyncGeneratorFunction%');
    if (fn) {
      value = fn.prototype;
    }
  } else if (name === '%AsyncIteratorPrototype%') {
    var gen = doEval('%AsyncGenerator%');
    if (gen) {
      value = getProto$1(gen.prototype);
    }
  }

  INTRINSICS[name] = value;

  return value;
};

var LEGACY_ALIASES = {
  '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
  '%ArrayPrototype%': ['Array', 'prototype'],
  '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
  '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
  '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
  '%ArrayProto_values%': ['Array', 'prototype', 'values'],
  '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
  '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
  '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
  '%BooleanPrototype%': ['Boolean', 'prototype'],
  '%DataViewPrototype%': ['DataView', 'prototype'],
  '%DatePrototype%': ['Date', 'prototype'],
  '%ErrorPrototype%': ['Error', 'prototype'],
  '%EvalErrorPrototype%': ['EvalError', 'prototype'],
  '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
  '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
  '%FunctionPrototype%': ['Function', 'prototype'],
  '%Generator%': ['GeneratorFunction', 'prototype'],
  '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
  '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
  '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
  '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
  '%JSONParse%': ['JSON', 'parse'],
  '%JSONStringify%': ['JSON', 'stringify'],
  '%MapPrototype%': ['Map', 'prototype'],
  '%NumberPrototype%': ['Number', 'prototype'],
  '%ObjectPrototype%': ['Object', 'prototype'],
  '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
  '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
  '%PromisePrototype%': ['Promise', 'prototype'],
  '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
  '%Promise_all%': ['Promise', 'all'],
  '%Promise_reject%': ['Promise', 'reject'],
  '%Promise_resolve%': ['Promise', 'resolve'],
  '%RangeErrorPrototype%': ['RangeError', 'prototype'],
  '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
  '%RegExpPrototype%': ['RegExp', 'prototype'],
  '%SetPrototype%': ['Set', 'prototype'],
  '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
  '%StringPrototype%': ['String', 'prototype'],
  '%SymbolPrototype%': ['Symbol', 'prototype'],
  '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
  '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
  '%TypeErrorPrototype%': ['TypeError', 'prototype'],
  '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
  '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
  '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
  '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
  '%URIErrorPrototype%': ['URIError', 'prototype'],
  '%WeakMapPrototype%': ['WeakMap', 'prototype'],
  '%WeakSetPrototype%': ['WeakSet', 'prototype'],
};

var bind = functionBind;
var hasOwn = src;
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec$1 = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);
  if (first === '%' && last !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
  } else if (last === '%' && first !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
  }
  var result = [];
  $replace(string, rePropName, function (match, number, quote, subString) {
    result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
  });
  return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = '%' + alias[0] + '%';
  }

  if (hasOwn(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === 'undefined' && !allowMissing) {
      throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
    }

    return {
      alias: alias,
      name: intrinsicName,
      value: value,
    };
  }

  throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== 'string' || name.length === 0) {
    throw new $TypeError('intrinsic name must be a non-empty string');
  }
  if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
    throw new $TypeError('"allowMissing" argument must be a boolean');
  }

  if ($exec$1(/^%?[^%]*%?$/, name) === null) {
    throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
  }
  var parts = stringToPath(name);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

  var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;

  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat([0, 1], alias));
  }

  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
    var part = parts[i];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);
    if (
      (first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') &&
      first !== last
    ) {
      throw new $SyntaxError('property names with quotes must have matching quotes');
    }
    if (part === 'constructor' || !isOwn) {
      skipFurtherCaching = true;
    }

    intrinsicBaseName += '.' + part;
    intrinsicRealName = '%' + intrinsicBaseName + '%';

    if (hasOwn(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
        }
        return void undefined$1;
      }
      if ($gOPD$1 && i + 1 >= parts.length) {
        var desc = $gOPD$1(value, part);
        isOwn = !!desc;

        // By convention, when a data property is converted to an accessor
        // property to emulate a data property that does not suffer from
        // the override mistake, that accessor's getter is marked with
        // an `originalValue` property. Here, when we detect this, we
        // uphold the illusion by pretending to see that original data
        // property, i.e., returning the value rather than the getter
        // itself.
        if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn(value, part);
        value = value[part];
      }

      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};

var callBind$3 = { exports: {} };

callBind$3.exports;

(function (module) {
  var bind = functionBind;
  var GetIntrinsic = getIntrinsic;

  var $apply = GetIntrinsic('%Function.prototype.apply%');
  var $call = GetIntrinsic('%Function.prototype.call%');
  var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

  var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
  var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
  var $max = GetIntrinsic('%Math.max%');

  if ($defineProperty) {
    try {
      $defineProperty({}, 'a', { value: 1 });
    } catch (e) {
      // IE 8 has a broken defineProperty
      $defineProperty = null;
    }
  }

  module.exports = function callBind(originalFunction) {
    var func = $reflectApply(bind, $call, arguments);
    if ($gOPD && $defineProperty) {
      var desc = $gOPD(func, 'length');
      if (desc.configurable) {
        // original length, plus the receiver, minus any additional arguments (after the receiver)
        $defineProperty(func, 'length', { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) });
      }
    }
    return func;
  };

  var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
  };

  if ($defineProperty) {
    $defineProperty(module.exports, 'apply', { value: applyBind });
  } else {
    module.exports.apply = applyBind;
  }
})(callBind$3);

var callBindExports = callBind$3.exports;

var GetIntrinsic$1 = getIntrinsic;

var callBind$2 = callBindExports;

var $indexOf = callBind$2(GetIntrinsic$1('String.prototype.indexOf'));

var callBound$2 = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = GetIntrinsic$1(name, !!allowMissing);
  if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
    return callBind$2(intrinsic);
  }
  return intrinsic;
};

var hasToStringTag$2 = shams();
var callBound$1 = callBound$2;

var $toString$1 = callBound$1('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
  if (hasToStringTag$2 && value && typeof value === 'object' && Symbol.toStringTag in value) {
    return false;
  }
  return $toString$1(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
  if (isStandardArguments(value)) {
    return true;
  }
  return (
    value !== null &&
    typeof value === 'object' &&
    typeof value.length === 'number' &&
    value.length >= 0 &&
    $toString$1(value) !== '[object Array]' &&
    $toString$1(value.callee) === '[object Function]'
  );
};

var supportsStandardArguments = (function () {
  return isStandardArguments(arguments);
})();

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

var GetIntrinsic = getIntrinsic;

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors$1 = function hasPropertyDescriptors() {
  if ($defineProperty) {
    try {
      $defineProperty({}, 'a', { value: 1 });
      return true;
    } catch (e) {
      // IE 8 has a broken defineProperty
      return false;
    }
  }
  return false;
};

hasPropertyDescriptors$1.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
  // node v0.6 has a bug where array lengths can be Set but not Defined
  if (!hasPropertyDescriptors$1()) {
    return null;
  }
  try {
    return $defineProperty([], 'length', { value: 1 }).length !== 1;
  } catch (e) {
    // In Firefox 4-22, defining length on an array throws an exception.
    return true;
  }
};

var hasPropertyDescriptors_1 = hasPropertyDescriptors$1;

var keys = objectKeys$1;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$1 = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction$1 = function (fn) {
  return typeof fn === 'function' && toStr$1.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = hasPropertyDescriptors_1();

var supportsDescriptors$2 = origDefineProperty && hasPropertyDescriptors;

var defineProperty$3 = function (object, name, value, predicate) {
  if (name in object) {
    if (predicate === true) {
      if (object[name] === value) {
        return;
      }
    } else if (!isFunction$1(predicate) || !predicate()) {
      return;
    }
  }
  if (supportsDescriptors$2) {
    origDefineProperty(object, name, {
      configurable: true,
      enumerable: false,
      value: value,
      writable: true,
    });
  } else {
    object[name] = value; // eslint-disable-line no-param-reassign
  }
};

var defineProperties = function (object, map) {
  var predicates = arguments.length > 2 ? arguments[2] : {};
  var props = keys(map);
  if (hasSymbols) {
    props = concat.call(props, Object.getOwnPropertySymbols(map));
  }
  for (var i = 0; i < props.length; i += 1) {
    defineProperty$3(object, props[i], map[props[i]], predicates[props[i]]);
  }
};

defineProperties.supportsDescriptors = !!supportsDescriptors$2;

var defineProperties_1 = defineProperties;

var numberIsNaN = function (value) {
  return value !== value;
};

var implementation$6 = function is(a, b) {
  if (a === 0 && b === 0) {
    return 1 / a === 1 / b;
  }
  if (a === b) {
    return true;
  }
  if (numberIsNaN(a) && numberIsNaN(b)) {
    return true;
  }
  return false;
};

var implementation$5 = implementation$6;

var polyfill$2 = function getPolyfill() {
  return typeof Object.is === 'function' ? Object.is : implementation$5;
};

var getPolyfill$3 = polyfill$2;
var define$2 = defineProperties_1;

var shim$3 = function shimObjectIs() {
  var polyfill = getPolyfill$3();
  define$2(
    Object,
    { is: polyfill },
    {
      is: function testObjectIs() {
        return Object.is !== polyfill;
      },
    },
  );
  return polyfill;
};

var define$1 = defineProperties_1;
var callBind$1 = callBindExports;

var implementation$4 = implementation$6;
var getPolyfill$2 = polyfill$2;
var shim$2 = shim$3;

var polyfill$1 = callBind$1(getPolyfill$2(), Object);

define$1(polyfill$1, {
  getPolyfill: getPolyfill$2,
  implementation: implementation$4,
  shim: shim$2,
});

var objectIs = polyfill$1;

var callBound = callBound$2;
var hasToStringTag$1 = shams();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$1) {
  has = callBound('Object.prototype.hasOwnProperty');
  $exec = callBound('RegExp.prototype.exec');
  isRegexMarker = {};

  var throwRegexMarker = function () {
    throw isRegexMarker;
  };
  badStringifier = {
    toString: throwRegexMarker,
    valueOf: throwRegexMarker,
  };

  if (typeof Symbol.toPrimitive === 'symbol') {
    badStringifier[Symbol.toPrimitive] = throwRegexMarker;
  }
}

var $toString = callBound('Object.prototype.toString');
var gOPD$2 = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

var isRegex$1 = hasToStringTag$1
  ? // eslint-disable-next-line consistent-return
    function isRegex(value) {
      if (!value || typeof value !== 'object') {
        return false;
      }

      var descriptor = gOPD$2(value, 'lastIndex');
      var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
      if (!hasLastIndexDataProperty) {
        return false;
      }

      try {
        $exec(value, badStringifier);
      } catch (e) {
        return e === isRegexMarker;
      }
    }
  : function isRegex(value) {
      // In older browsers, typeof regex incorrectly returns 'function'
      if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
        return false;
      }

      return $toString(value) === regexClass;
    };

var implementation$3 = { exports: {} };

var functionsHaveNames = function functionsHaveNames() {
  return typeof function f() {}.name === 'string';
};

var gOPD$1 = Object.getOwnPropertyDescriptor;
if (gOPD$1) {
  try {
    gOPD$1([], 'length');
  } catch (e) {
    // IE 8 has a broken gOPD
    gOPD$1 = null;
  }
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
  if (!functionsHaveNames() || !gOPD$1) {
    return false;
  }
  var desc = gOPD$1(function () {}, 'name');
  return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
  return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

var functionsHaveNames_1 = functionsHaveNames;

implementation$3.exports;

(function (module) {
  var functionsHaveConfigurableNames = functionsHaveNames_1.functionsHaveConfigurableNames();

  var $Object = Object;
  var $TypeError = TypeError;

  module.exports = function flags() {
    if (this != null && this !== $Object(this)) {
      throw new $TypeError('RegExp.prototype.flags getter called on non-object');
    }
    var result = '';
    if (this.hasIndices) {
      result += 'd';
    }
    if (this.global) {
      result += 'g';
    }
    if (this.ignoreCase) {
      result += 'i';
    }
    if (this.multiline) {
      result += 'm';
    }
    if (this.dotAll) {
      result += 's';
    }
    if (this.unicode) {
      result += 'u';
    }
    if (this.unicodeSets) {
      result += 'v';
    }
    if (this.sticky) {
      result += 'y';
    }
    return result;
  };

  if (functionsHaveConfigurableNames && Object.defineProperty) {
    Object.defineProperty(module.exports, 'name', { value: 'get flags' });
  }
})(implementation$3);

var implementationExports$1 = implementation$3.exports;

var implementation$2 = implementationExports$1;

var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;

var polyfill = function getPolyfill() {
  if (supportsDescriptors$1 && /a/gim.flags === 'gim') {
    var descriptor = $gOPD(RegExp.prototype, 'flags');
    if (
      descriptor &&
      typeof descriptor.get === 'function' &&
      typeof RegExp.prototype.dotAll === 'boolean' &&
      typeof RegExp.prototype.hasIndices === 'boolean'
    ) {
      /* eslint getter-return: 0 */
      var calls = '';
      var o = {};
      Object.defineProperty(o, 'hasIndices', {
        get: function () {
          calls += 'd';
        },
      });
      Object.defineProperty(o, 'sticky', {
        get: function () {
          calls += 'y';
        },
      });
      if (calls === 'dy') {
        return descriptor.get;
      }
    }
  }
  return implementation$2;
};

var supportsDescriptors = defineProperties_1.supportsDescriptors;
var getPolyfill$1 = polyfill;
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty$2 = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

var shim$1 = function shimFlags() {
  if (!supportsDescriptors || !getProto) {
    throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
  }
  var polyfill = getPolyfill$1();
  var proto = getProto(regex);
  var descriptor = gOPD(proto, 'flags');
  if (!descriptor || descriptor.get !== polyfill) {
    defineProperty$2(proto, 'flags', {
      configurable: true,
      enumerable: false,
      get: polyfill,
    });
  }
  return polyfill;
};

var define = defineProperties_1;
var callBind = callBindExports;

var implementation$1 = implementationExports$1;
var getPolyfill = polyfill;
var shim = shim$1;

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
  getPolyfill: getPolyfill,
  implementation: implementation$1,
  shim: shim,
});

var regexp_prototype_flags = flagsBound;

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
  try {
    getDay.call(value);
    return true;
  } catch (e) {
    return false;
  }
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = shams();

var isDateObject = function isDateObject(value) {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

var objectKeys = objectKeys$1;
var isArguments = isArguments$1;
var is = objectIs;
var isRegex = isRegex$1;
var flags = regexp_prototype_flags;
var isDate = isDateObject;

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) {
    return false;
  }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) {
    return false;
  }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) {
    return false;
  }

  if (isArguments(a) !== isArguments(b)) {
    return false;
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) {
    return false;
  }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) {
    return false;
  }
  if (aIsBuffer || bIsBuffer) {
    // && would work too, because both are true or both false here
    if (a.length !== b.length) {
      return false;
    }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) {
    // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) {
    return false;
  }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) {
      return false;
    }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) {
      return false;
    }
  }

  return true;
}

var deepEqual_1 = deepEqual;

var deepEqual$1 = /*@__PURE__*/ getDefaultExportFromCjs(deepEqual_1);

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = (function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
})();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
 * Create a debounced version of a method, that's asynchronously deferred
 * but called in the minimum time possible.
 *
 * @method
 * @memberof Popper.Utils
 * @argument {Function} fn
 * @returns {Function}
 */
var debounce$1 = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
    overflow = _getStyleComputedProp.overflow,
    overflowX = _getStyleComputedProp.overflowX,
    overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (
    ['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 &&
    getStyleComputedProperty(offsetParent, 'position') === 'static'
  ) {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if ((element1 !== commonAncestorContainer && element2 !== commonAncestorContainer) || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(
    body['offset' + axis],
    body['scroll' + axis],
    html['client' + axis],
    html['offset' + axis],
    html['scroll' + axis],
    isIE(10)
      ? parseInt(html['offset' + axis]) +
          parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) +
          parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')])
      : 0,
  );
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle),
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
};

var createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends =
  Object.assign ||
  function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height,
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top,
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height,
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (
    isIE10 && !fixedPosition
      ? parent.contains(scrollParent)
      : parent === scrollParent && scrollParent.nodeName !== 'BODY'
  ) {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height,
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition
    ? getFixedPositionOffsetParent(popper)
    : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
        height = _getWindowSizes.height,
        width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
    height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top,
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height,
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom,
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height,
    },
  };

  var sortedAreas = Object.keys(rects)
    .map(function (key) {
      return _extends(
        {
          key: key,
        },
        rects[key],
        {
          area: getArea(rects[key]),
        },
      );
    })
    .sort(function (a, b) {
      return b.area - a.area;
    });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
      height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition
    ? getFixedPositionOffsetParent(popper)
    : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x,
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height,
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] =
    referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {},
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(
    this.options.placement,
    data.offsets.reference,
    this.popper,
    this.reference,
    this.options.modifiers.flip.boundariesElement,
    this.options.modifiers.flip.padding,
  );

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
      enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(
    options.placement,
    referenceOffsets,
    popper,
    reference,
    options.modifiers.flip.boundariesElement,
    options.modifiers.flip.padding,
  );

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var round = Math.round,
    floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right),
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
    y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn(
      'WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!',
    );
  }
  var gpuAcceleration =
    legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position,
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
    top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement,
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired =
    !!requesting &&
    modifiers.some(function (modifier) {
      return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(
      requested +
        ' modifier is required by ' +
        _requesting +
        ' modifier in order to work, be sure to include it before ' +
        _requesting +
        '!',
    );
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow =
    ((_data$offsets$arrow = {}),
    defineProperty$1(_data$offsets$arrow, side, Math.round(sideValue)),
    defineProperty$1(_data$offsets$arrow, altSide, ''),
    _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = [
  'auto-start',
  'auto',
  'auto-end',
  'top-start',
  'top',
  'top-end',
  'right-start',
  'right',
  'right-end',
  'bottom-end',
  'bottom',
  'bottom-start',
  'left-end',
  'left',
  'left-start',
];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise',
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(
    data.instance.popper,
    data.instance.reference,
    options.padding,
    options.boundariesElement,
    data.positionFixed,
  );

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef =
      (placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left)) ||
      (placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right)) ||
      (placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top)) ||
      (placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom));

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries =
      (placement === 'left' && overflowsLeft) ||
      (placement === 'right' && overflowsRight) ||
      (placement === 'top' && overflowsTop) ||
      (placement === 'bottom' && overflowsBottom);

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef =
      !!options.flipVariations &&
      ((isVertical && variation === 'start' && overflowsLeft) ||
        (isVertical && variation === 'end' && overflowsRight) ||
        (!isVertical && variation === 'start' && overflowsTop) ||
        (!isVertical && variation === 'end' && overflowsBottom));

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent =
      !!options.flipVariationsByContent &&
      ((isVertical && variation === 'start' && overflowsRight) ||
        (isVertical && variation === 'end' && overflowsLeft) ||
        (!isVertical && variation === 'start' && overflowsBottom) ||
        (!isVertical && variation === 'end' && overflowsTop));

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends(
        {},
        data.offsets.popper,
        getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement),
      );

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return (rect[measurement] / 100) * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return (size / 100) * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(
    find(fragments, function (frag) {
      return frag.search(/,|\s/) !== -1;
    }),
  );

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops =
    divider !== -1
      ? [
          fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]),
          [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1)),
        ]
      : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return (
      op
        // This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function (a, b) {
          if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
            a[a.length - 1] = b;
            mergeWithPrevious = true;
            return a;
          } else if (mergeWithPrevious) {
            a[a.length - 1] += b;
            mergeWithPrevious = false;
            return a;
          } else {
            return a.concat(b);
          }
        }, [])
        // Here we convert the string values into number values (in px)
        .map(function (str) {
          return toValue(str, measurement, popperOffsets, referenceOffsets);
        })
    );
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
    _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
    left = popperStyles.left,
    transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(
    data.instance.popper,
    data.instance.reference,
    options.padding,
    boundariesElement,
    data.positionFixed,
  );

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty$1({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(
          popper[mainSide],
          boundaries[placement] - (placement === 'right' ? popper.width : popper.height),
        );
      }
      return defineProperty$1({}, mainSide, value);
    },
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
      reference = _data$offsets.reference,
      popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty$1({}, side, reference[side]),
      end: defineProperty$1({}, side, reference[side] + reference[measurement] - popper[measurement]),
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (
    refRect.bottom < bound.top ||
    refRect.left > bound.right ||
    refRect.top > bound.bottom ||
    refRect.right < bound.left
  ) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] =
    reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift,
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0,
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent',
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether,
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]',
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false,
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner,
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide,
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right',
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined,
  },
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers,
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper$1 = (function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce$1(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: [],
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends(
        {},
        Popper.Defaults.modifiers[name] || {},
        options.modifiers ? options.modifiers[name] : {},
      );
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers)
      .map(function (name) {
        return _extends(
          {
            name: name,
          },
          _this.options.modifiers[name],
        );
      })
      // sort the modifiers by order
      .sort(function (a, b) {
        return a.order - b.order;
      });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs

  createClass(Popper, [
    {
      key: 'update',
      value: function update$$1() {
        return update.call(this);
      },
    },
    {
      key: 'destroy',
      value: function destroy$$1() {
        return destroy.call(this);
      },
    },
    {
      key: 'enableEventListeners',
      value: function enableEventListeners$$1() {
        return enableEventListeners.call(this);
      },
    },
    {
      key: 'disableEventListeners',
      value: function disableEventListeners$$1() {
        return disableEventListeners.call(this);
      },

      /**
       * Schedules an update. It will run on the next UI update available.
       * @method scheduleUpdate
       * @memberof Popper
       */

      /**
       * Collection of utilities useful when writing custom modifiers.
       * Starting from version 1.7, this method is available only if you
       * include `popper-utils.js` before `popper.js`.
       *
       * **DEPRECATION**: This way to access PopperUtils is deprecated
       * and will be removed in v2! Use the PopperUtils module directly instead.
       * Due to the high instability of the methods contained in Utils, we can't
       * guarantee them to follow semver. Use them at your own risk!
       * @static
       * @private
       * @type {Object}
       * @deprecated since version 1.8
       * @member Utils
       * @memberof Popper
       */
    },
  ]);
  return Popper;
})();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */

Popper$1.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper$1.placements = placements;
Popper$1.Defaults = Defaults;

var lib = { exports: {} };

var implementation = { exports: {} };

var key = '__global_unique_id__';

var gud = function () {
  return (global[key] = (global[key] || 0) + 1);
};

implementation.exports;

(function (module, exports) {
  exports.__esModule = true;

  var _react = React__default['default'];

  _interopRequireDefault(_react);

  var _propTypes = PropTypes__default['default'];

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _gud = gud;

  var _gud2 = _interopRequireDefault(_gud);

  var _warning = warning_1;

  var _warning2 = _interopRequireDefault(_warning);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
      throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
    });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass);
  }

  var MAX_SIGNED_31_BIT_INT = 1073741823;

  // Inlined Object.is polyfill.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
  function objectIs(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }

  function createEventEmitter(value) {
    var handlers = [];
    return {
      on: function on(handler) {
        handlers.push(handler);
      },
      off: function off(handler) {
        handlers = handlers.filter(function (h) {
          return h !== handler;
        });
      },
      get: function get() {
        return value;
      },
      set: function set(newValue, changedBits) {
        value = newValue;
        handlers.forEach(function (handler) {
          return handler(value, changedBits);
        });
      },
    };
  }

  function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
  }

  function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;

    var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

    var Provider = (function (_Component) {
      _inherits(Provider, _Component);

      function Provider() {
        var _temp, _this, _ret;

        _classCallCheck(this, Provider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (
          (_ret =
            ((_temp =
              ((_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)))),
              _this)),
            (_this.emitter = createEventEmitter(_this.props.value)),
            _temp)),
          _possibleConstructorReturn(_this, _ret)
        );
      }

      Provider.prototype.getChildContext = function getChildContext() {
        var _ref;

        return (_ref = {}), (_ref[contextProp] = this.emitter), _ref;
      };

      Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
          var oldValue = this.props.value;
          var newValue = nextProps.value;
          var changedBits = void 0;

          if (objectIs(oldValue, newValue)) {
            changedBits = 0; // No change
          } else {
            changedBits =
              typeof calculateChangedBits === 'function'
                ? calculateChangedBits(oldValue, newValue)
                : MAX_SIGNED_31_BIT_INT;
            if (process.env.NODE_ENV !== 'production') {
              (0, _warning2.default)(
                (changedBits & MAX_SIGNED_31_BIT_INT) === changedBits,
                'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s',
                changedBits,
              );
            }

            changedBits |= 0;

            if (changedBits !== 0) {
              this.emitter.set(nextProps.value, changedBits);
            }
          }
        }
      };

      Provider.prototype.render = function render() {
        return this.props.children;
      };

      return Provider;
    })(_react.Component);

    Provider.childContextTypes =
      ((_Provider$childContex = {}),
      (_Provider$childContex[contextProp] = _propTypes2.default.object.isRequired),
      _Provider$childContex);

    var Consumer = (function (_Component2) {
      _inherits(Consumer, _Component2);

      function Consumer() {
        var _temp2, _this2, _ret2;

        _classCallCheck(this, Consumer);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return (
          (_ret2 =
            ((_temp2 =
              ((_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args)))),
              _this2)),
            (_this2.state = {
              value: _this2.getValue(),
            }),
            (_this2.onUpdate = function (newValue, changedBits) {
              var observedBits = _this2.observedBits | 0;
              if ((observedBits & changedBits) !== 0) {
                _this2.setState({ value: _this2.getValue() });
              }
            }),
            _temp2)),
          _possibleConstructorReturn(_this2, _ret2)
        );
      }

      Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var observedBits = nextProps.observedBits;

        this.observedBits =
          observedBits === undefined || observedBits === null
            ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
            : observedBits;
      };

      Consumer.prototype.componentDidMount = function componentDidMount() {
        if (this.context[contextProp]) {
          this.context[contextProp].on(this.onUpdate);
        }
        var observedBits = this.props.observedBits;

        this.observedBits =
          observedBits === undefined || observedBits === null
            ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
            : observedBits;
      };

      Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.context[contextProp]) {
          this.context[contextProp].off(this.onUpdate);
        }
      };

      Consumer.prototype.getValue = function getValue() {
        if (this.context[contextProp]) {
          return this.context[contextProp].get();
        } else {
          return defaultValue;
        }
      };

      Consumer.prototype.render = function render() {
        return onlyChild(this.props.children)(this.state.value);
      };

      return Consumer;
    })(_react.Component);

    Consumer.contextTypes =
      ((_Consumer$contextType = {}),
      (_Consumer$contextType[contextProp] = _propTypes2.default.object),
      _Consumer$contextType);

    return {
      Provider: Provider,
      Consumer: Consumer,
    };
  }

  exports.default = createReactContext;
  module.exports = exports['default'];
})(implementation, implementation.exports);

var implementationExports = implementation.exports;

lib.exports;

(function (module, exports) {
  exports.__esModule = true;

  var _react = React__default['default'];

  var _react2 = _interopRequireDefault(_react);

  var _implementation = implementationExports;

  var _implementation2 = _interopRequireDefault(_implementation);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  exports.default = _react2.default.createContext || _implementation2.default;
  module.exports = exports['default'];
})(lib, lib.exports);

var libExports = lib.exports;
var createContext = /*@__PURE__*/ getDefaultExportFromCjs(libExports);

var ManagerReferenceNodeContext = createContext();
var ManagerReferenceNodeSetterContext = createContext();

var Manager =
  /*#__PURE__*/
  (function (_React$Component) {
    _inheritsLoose(Manager, _React$Component);

    function Manager() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'referenceNode', void 0);

      _defineProperty$2(
        _assertThisInitialized(_assertThisInitialized(_this)),
        'setReferenceNode',
        function (newReferenceNode) {
          if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
            _this.referenceNode = newReferenceNode;

            _this.forceUpdate();
          }
        },
      );

      return _this;
    }

    var _proto = Manager.prototype;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.referenceNode = null;
    };

    _proto.render = function render() {
      return React__namespace.createElement(
        ManagerReferenceNodeContext.Provider,
        {
          value: this.referenceNode,
        },
        React__namespace.createElement(
          ManagerReferenceNodeSetterContext.Provider,
          {
            value: this.setReferenceNode,
          },
          this.props.children,
        ),
      );
    };

    return Manager;
  })(React__namespace.Component);

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
    ref.current = node;
  }
};

var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none',
};
var initialArrowStyle = {};
var InnerPopper =
  /*#__PURE__*/
  (function (_React$Component) {
    _inheritsLoose(InnerPopper, _React$Component);

    function InnerPopper() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'state', {
        data: undefined,
        placement: undefined,
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'popperInstance', void 0);

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'popperNode', null);

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'arrowNode', null);

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'setPopperNode', function (popperNode) {
        if (!popperNode || _this.popperNode === popperNode) return;
        setRef(_this.props.innerRef, popperNode);
        _this.popperNode = popperNode;

        _this.updatePopperInstance();
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'setArrowNode', function (arrowNode) {
        _this.arrowNode = arrowNode;
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'updateStateModifier', {
        enabled: true,
        order: 900,
        fn: function fn(data) {
          var placement = data.placement;

          _this.setState({
            data: data,
            placement: placement,
          });

          return data;
        },
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'getOptions', function () {
        return {
          placement: _this.props.placement,
          eventsEnabled: _this.props.eventsEnabled,
          positionFixed: _this.props.positionFixed,
          modifiers: _extends$1({}, _this.props.modifiers, {
            arrow: _extends$1({}, _this.props.modifiers && _this.props.modifiers.arrow, {
              enabled: !!_this.arrowNode,
              element: _this.arrowNode,
            }),
            applyStyle: {
              enabled: false,
            },
            updateStateModifier: _this.updateStateModifier,
          }),
        };
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'getPopperStyle', function () {
        return !_this.popperNode || !_this.state.data
          ? initialStyle
          : _extends$1(
              {
                position: _this.state.data.offsets.popper.position,
              },
              _this.state.data.styles,
            );
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'getPopperPlacement', function () {
        return !_this.state.data ? undefined : _this.state.placement;
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'getArrowStyle', function () {
        return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'getOutOfBoundariesState', function () {
        return _this.state.data ? _this.state.data.hide : undefined;
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'destroyPopperInstance', function () {
        if (!_this.popperInstance) return;

        _this.popperInstance.destroy();

        _this.popperInstance = null;
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'updatePopperInstance', function () {
        _this.destroyPopperInstance();

        var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          popperNode = _assertThisInitialize.popperNode;

        var referenceElement = _this.props.referenceElement;
        if (!referenceElement || !popperNode) return;
        _this.popperInstance = new Popper$1(referenceElement, popperNode, _this.getOptions());
      });

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'scheduleUpdate', function () {
        if (_this.popperInstance) {
          _this.popperInstance.scheduleUpdate();
        }
      });

      return _this;
    }

    var _proto = InnerPopper.prototype;

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      // If the Popper.js options have changed, update the instance (destroy + create)
      if (
        this.props.placement !== prevProps.placement ||
        this.props.referenceElement !== prevProps.referenceElement ||
        this.props.positionFixed !== prevProps.positionFixed ||
        !deepEqual$1(this.props.modifiers, prevProps.modifiers, {
          strict: true,
        })
      ) {
        // develop only check that modifiers isn't being updated needlessly
        if (process.env.NODE_ENV === 'development') {
          if (
            this.props.modifiers !== prevProps.modifiers &&
            this.props.modifiers != null &&
            prevProps.modifiers != null &&
            shallowEqual(this.props.modifiers, prevProps.modifiers)
          ) {
            console.warn(
              "'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.",
            );
          }
        }

        this.updatePopperInstance();
      } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
        this.props.eventsEnabled
          ? this.popperInstance.enableEventListeners()
          : this.popperInstance.disableEventListeners();
      } // A placement difference in state means popper determined a new placement
      // apart from the props value. By the time the popper element is rendered with
      // the new position Popper has already measured it, if the place change triggers
      // a size change it will result in a misaligned popper. So we schedule an update to be sure.

      if (prevState.placement !== this.state.placement) {
        this.scheduleUpdate();
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      setRef(this.props.innerRef, null);
      this.destroyPopperInstance();
    };

    _proto.render = function render() {
      return unwrapArray(this.props.children)({
        ref: this.setPopperNode,
        style: this.getPopperStyle(),
        placement: this.getPopperPlacement(),
        outOfBoundaries: this.getOutOfBoundariesState(),
        scheduleUpdate: this.scheduleUpdate,
        arrowProps: {
          ref: this.setArrowNode,
          style: this.getArrowStyle(),
        },
      });
    };

    return InnerPopper;
  })(React__namespace.Component);

_defineProperty$2(InnerPopper, 'defaultProps', {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false,
});

Popper$1.placements;
function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
    props = _objectWithoutPropertiesLoose$1(_ref, ['referenceElement']);

  return React__namespace.createElement(ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
    return React__namespace.createElement(
      InnerPopper,
      _extends$1(
        {
          referenceElement: referenceElement !== undefined ? referenceElement : referenceNode,
        },
        props,
      ),
    );
  });
}

var InnerReference =
  /*#__PURE__*/
  (function (_React$Component) {
    _inheritsLoose(InnerReference, _React$Component);

    function InnerReference() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

      _defineProperty$2(_assertThisInitialized(_assertThisInitialized(_this)), 'refHandler', function (node) {
        setRef(_this.props.innerRef, node);
        safeInvoke(_this.props.setReferenceNode, node);
      });

      return _this;
    }

    var _proto = InnerReference.prototype;

    _proto.componentWillUnmount = function componentWillUnmount() {
      setRef(this.props.innerRef, null);
    };

    _proto.render = function render() {
      warning$1(
        Boolean(this.props.setReferenceNode),
        '`Reference` should not be used outside of a `Manager` component.',
      );
      return unwrapArray(this.props.children)({
        ref: this.refHandler,
      });
    };

    return InnerReference;
  })(React__namespace.Component);

function Reference(props) {
  return React__namespace.createElement(ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
    return React__namespace.createElement(
      InnerReference,
      _extends$1(
        {
          setReferenceNode: setReferenceNode,
        },
        props,
      ),
    );
  });
}

function oe$2(e) {
  return (oe$2 =
    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
      ? function (e) {
          return typeof e;
        }
      : function (e) {
          return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
            ? 'symbol'
            : typeof e;
        })(e);
}
function ae$2(e, t) {
  if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
}
function se$2(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    (n.enumerable = n.enumerable || !1),
      (n.configurable = !0),
      'value' in n && (n.writable = !0),
      Object.defineProperty(e, n.key, n);
  }
}
function ie$2(e, t, r) {
  return t && se$2(e.prototype, t), r && se$2(e, r), e;
}
function pe$2(e, t, r) {
  return (
    t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = r), e
  );
}
function ce$2() {
  return (ce$2 =
    Object.assign ||
    function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }).apply(this, arguments);
}
function le$2(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t &&
      (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })),
      r.push.apply(r, n);
  }
  return r;
}
function de$2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2
      ? le$2(Object(r), !0).forEach(function (t) {
          pe$2(e, t, r[t]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
      : le$2(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
  }
  return e;
}
function ue$1(e, t) {
  if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function');
  (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
    t && me$1(e, t);
}
function he$2(e) {
  return (he$2 = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
}
function me$1(e, t) {
  return (me$1 =
    Object.setPrototypeOf ||
    function (e, t) {
      return (e.__proto__ = t), e;
    })(e, t);
}
function fe$2(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ye$2(e, t) {
  return !t || ('object' != typeof t && 'function' != typeof t) ? fe$2(e) : t;
}
function ve$2(e) {
  var t = (function () {
    if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ('function' == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  })();
  return function () {
    var r,
      n = he$2(e);
    if (t) {
      var o = he$2(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return ye$2(this, r);
  };
}
function De$2(e) {
  return (
    (function (e) {
      if (Array.isArray(e)) return we$2(e);
    })(e) ||
    (function (e) {
      if ('undefined' != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    })(e) ||
    (function (e, t) {
      if (!e) return;
      if ('string' == typeof e) return we$2(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      'Object' === r && e.constructor && (r = e.constructor.name);
      if ('Map' === r || 'Set' === r) return Array.from(e);
      if ('Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return we$2(e, t);
    })(e) ||
    (function () {
      throw new TypeError(
        'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
      );
    })()
  );
}
function we$2(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function ke$2(e, t) {
  switch (e) {
    case 'P':
      return t.date({ width: 'short' });
    case 'PP':
      return t.date({ width: 'medium' });
    case 'PPP':
      return t.date({ width: 'long' });
    case 'PPPP':
    default:
      return t.date({ width: 'full' });
  }
}
function ge$2(e, t) {
  switch (e) {
    case 'p':
      return t.time({ width: 'short' });
    case 'pp':
      return t.time({ width: 'medium' });
    case 'ppp':
      return t.time({ width: 'long' });
    case 'pppp':
    default:
      return t.time({ width: 'full' });
  }
}
var be$2 = {
    p: ge$2,
    P: function (e, t) {
      var r,
        n = e.match(/(P+)(p+)?/),
        o = n[1],
        a = n[2];
      if (!a) return ke$2(e, t);
      switch (o) {
        case 'P':
          r = t.dateTime({ width: 'short' });
          break;
        case 'PP':
          r = t.dateTime({ width: 'medium' });
          break;
        case 'PPP':
          r = t.dateTime({ width: 'long' });
          break;
        case 'PPPP':
        default:
          r = t.dateTime({ width: 'full' });
      }
      return r.replace('{{date}}', ke$2(o, t)).replace('{{time}}', ge$2(a, t));
    },
  },
  Ce$2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function _e$2(e) {
  var t = e ? ('string' == typeof e || e instanceof String ? parseISO(e) : toDate(e)) : new Date();
  return Me$2(t) ? t : null;
}
function Se$2(e, t, r, n) {
  var a = null,
    s = Ve$2(r) || Ve$2(Qe$1()),
    i = !0;
  return Array.isArray(t)
    ? (t.forEach(function (t) {
        var r = parse(e, t, new Date(), { locale: s });
        n && (i = Me$2(r) && e === format(r, t, { awareOfUnicodeTokens: !0 })), Me$2(r) && i && (a = r);
      }),
      a)
    : ((a = parse(e, t, new Date(), { locale: s })),
      n
        ? (i = Me$2(a) && e === format(a, t, { awareOfUnicodeTokens: !0 }))
        : Me$2(a) ||
          ((t = t
            .match(Ce$2)
            .map(function (e) {
              var t = e[0];
              return 'p' === t || 'P' === t ? (s ? (0, be$2[t])(e, s.formatLong) : t) : e;
            })
            .join('')),
          e.length > 0 && (a = parse(e, t.slice(0, e.length), new Date())),
          Me$2(a) || (a = new Date(e))),
      Me$2(a) && i ? a : null);
}
function Me$2(e) {
  return isValid(e) && isAfter(e, new Date('1/1/1000'));
}
function Pe$2(e, t, r) {
  if ('en' === r) return format(e, t, { awareOfUnicodeTokens: !0 });
  var n = Ve$2(r);
  return (
    r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')),
    !n && Qe$1() && Ve$2(Qe$1()) && (n = Ve$2(Qe$1())),
    format(e, t, { locale: n || null, awareOfUnicodeTokens: !0 })
  );
}
function Ee$2(e, t) {
  var r = t.hour,
    n = void 0 === r ? 0 : r,
    o = t.minute,
    a = void 0 === o ? 0 : o,
    s = t.second;
  return setHours(setMinutes(setSeconds(e, void 0 === s ? 0 : s), a), n);
}
function Ne$2(e, t) {
  var r = (t && Ve$2(t)) || (Qe$1() && Ve$2(Qe$1()));
  return getISOWeek(e, r ? { locale: r } : null);
}
function Oe$2(e, t) {
  return Pe$2(e, 'ddd', t);
}
function xe$2(e) {
  return startOfDay(e);
}
function Te$2(e, t) {
  var r = Ve$2(t || Qe$1());
  return startOfWeek(e, { locale: r });
}
function Ye$2(e) {
  return startOfMonth(e);
}
function Ie$2(e) {
  return startOfYear(e);
}
function Le$2(e) {
  return startOfQuarter(e);
}
function Fe$2(e, t) {
  return e && t ? isSameYear(e, t) : !e && !t;
}
function Re$2(e, t) {
  return e && t ? isSameMonth(e, t) : !e && !t;
}
function Ae$2(e, t) {
  return e && t ? isSameQuarter(e, t) : !e && !t;
}
function We$1(e, t) {
  return e && t ? isSameDay(e, t) : !e && !t;
}
function Be$2(e, t) {
  return e && t ? isEqual(e, t) : !e && !t;
}
function je$2(e, t, r) {
  var n,
    o = startOfDay(t),
    a = endOfDay(r);
  try {
    n = isWithinInterval(e, { start: o, end: a });
  } catch (e) {
    n = !1;
  }
  return n;
}
function Qe$1() {
  return ('undefined' != typeof window ? window : global).__localeId__;
}
function Ve$2(e) {
  if ('string' == typeof e) {
    var t = 'undefined' != typeof window ? window : global;
    return t.__localeData__ ? t.__localeData__[e] : null;
  }
  return e;
}
function qe$1(e, t) {
  return Pe$2(setMonth(_e$2(), e), 'LLLL', t);
}
function Ue$1(e, t) {
  return Pe$2(setMonth(_e$2(), e), 'LLL', t);
}
function $e$1(e, t) {
  return Pe$2(setQuarter(_e$2(), e), 'QQQ', t);
}
function ze$2(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.minDate,
    n = t.maxDate,
    o = t.excludeDates,
    a = t.includeDates,
    s = t.filterDate;
  return (
    rt(e, { minDate: r, maxDate: n }) ||
    (o &&
      o.some(function (t) {
        return We$1(e, t);
      })) ||
    (a &&
      !a.some(function (t) {
        return We$1(e, t);
      })) ||
    (s && !s(_e$2(e))) ||
    !1
  );
}
function Ge$1(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.excludeDates;
  return (
    (r &&
      r.some(function (t) {
        return We$1(e, t);
      })) ||
    !1
  );
}
function Je$1(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.minDate,
    n = t.maxDate,
    o = t.excludeDates,
    a = t.includeDates,
    s = t.filterDate;
  return (
    rt(e, { minDate: r, maxDate: n }) ||
    (o &&
      o.some(function (t) {
        return Re$2(e, t);
      })) ||
    (a &&
      !a.some(function (t) {
        return Re$2(e, t);
      })) ||
    (s && !s(_e$2(e))) ||
    !1
  );
}
function Xe(e, t, r, n) {
  var o = getYear(e),
    a = getMonth(e),
    s = getYear(t),
    i = getMonth(t),
    p = getYear(n);
  return o === s && o === p
    ? a <= r && r <= i
    : o < s
    ? (p === o && a <= r) || (p === s && i >= r) || (p < s && p > o)
    : void 0;
}
function Ze(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.minDate,
    n = t.maxDate,
    o = t.excludeDates,
    a = t.includeDates,
    s = t.filterDate;
  return (
    rt(e, { minDate: r, maxDate: n }) ||
    (o &&
      o.some(function (t) {
        return Ae$2(e, t);
      })) ||
    (a &&
      !a.some(function (t) {
        return Ae$2(e, t);
      })) ||
    (s && !s(_e$2(e))) ||
    !1
  );
}
function et(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.minDate,
    n = t.maxDate,
    o = new Date(e, 0, 1);
  return rt(o, { minDate: r, maxDate: n }) || !1;
}
function tt(e, t, r, n) {
  var o = getYear(e),
    a = getQuarter(e),
    s = getYear(t),
    i = getQuarter(t),
    p = getYear(n);
  return o === s && o === p
    ? a <= r && r <= i
    : o < s
    ? (p === o && a <= r) || (p === s && i >= r) || (p < s && p > o)
    : void 0;
}
function rt(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.minDate,
    n = t.maxDate;
  return (r && differenceInCalendarDays(e, r) < 0) || (n && differenceInCalendarDays(e, n) > 0);
}
function nt(e, t) {
  return t.some(function (t) {
    return getHours(t) === getHours(e) && getMinutes(t) === getMinutes(e);
  });
}
function ot(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.excludeTimes,
    n = t.includeTimes,
    o = t.filterTime;
  return (r && nt(e, r)) || (n && !nt(e, n)) || (o && !o(e)) || !1;
}
function at(e, t) {
  var r = t.minTime,
    n = t.maxTime;
  if (!r || !n) throw new Error('Both minTime and maxTime props required');
  var o,
    a = _e$2(),
    s = setHours(setMinutes(a, getMinutes(e)), getHours(e)),
    i = setHours(setMinutes(a, getMinutes(r)), getHours(r)),
    p = setHours(setMinutes(a, getMinutes(n)), getHours(n));
  try {
    o = !isWithinInterval(s, { start: i, end: p });
  } catch (e) {
    o = !1;
  }
  return o;
}
function st(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.minDate,
    n = t.includeDates,
    o = subMonths(e, 1);
  return (
    (r && differenceInCalendarMonths(r, o) > 0) ||
    (n &&
      n.every(function (e) {
        return differenceInCalendarMonths(e, o) > 0;
      })) ||
    !1
  );
}
function it(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.maxDate,
    n = t.includeDates,
    o = addMonths(e, 1);
  return (
    (r && differenceInCalendarMonths(o, r) > 0) ||
    (n &&
      n.every(function (e) {
        return differenceInCalendarMonths(o, e) > 0;
      })) ||
    !1
  );
}
function pt(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.minDate,
    n = t.includeDates,
    o = subYears(e, 1);
  return (
    (r && differenceInCalendarYears(r, o) > 0) ||
    (n &&
      n.every(function (e) {
        return differenceInCalendarYears(e, o) > 0;
      })) ||
    !1
  );
}
function ct(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.maxDate,
    n = t.includeDates,
    o = addYears(e, 1);
  return (
    (r && differenceInCalendarYears(o, r) > 0) ||
    (n &&
      n.every(function (e) {
        return differenceInCalendarYears(o, e) > 0;
      })) ||
    !1
  );
}
function lt(e) {
  var t = e.minDate,
    r = e.includeDates;
  if (r && t) {
    var n = r.filter(function (e) {
      return differenceInCalendarDays(e, t) >= 0;
    });
    return min(n);
  }
  return r ? min(r) : t;
}
function dt(e) {
  var t = e.maxDate,
    r = e.includeDates;
  if (r && t) {
    var n = r.filter(function (e) {
      return differenceInCalendarDays(e, t) <= 0;
    });
    return max$1(n);
  }
  return r ? max$1(r) : t;
}
function ut() {
  for (
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
      t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'react-datepicker__day--highlighted',
      n = new Map(),
      o = 0,
      a = e.length;
    o < a;
    o++
  ) {
    var s = e[o];
    if (isDate$1(s)) {
      var i = Pe$2(s, 'MM.dd.yyyy'),
        p = n.get(i) || [];
      p.includes(t) || (p.push(t), n.set(i, p));
    } else if ('object' === oe$2(s)) {
      var c = Object.keys(s),
        l = c[0],
        d = s[c[0]];
      if ('string' == typeof l && d.constructor === Array)
        for (var u = 0, h = d.length; u < h; u++) {
          var m = Pe$2(d[u], 'MM.dd.yyyy'),
            f = n.get(m) || [];
          f.includes(l) || (f.push(l), n.set(m, f));
        }
    }
  }
  return n;
}
function ht(e, t, r, n, o) {
  for (var i = o.length, p = [], c = 0; c < i; c++) {
    var l = addMinutes(addHours(e, getHours(o[c])), getMinutes(o[c])),
      d = addMinutes(e, (r + 1) * n);
    isAfter(l, t) && isBefore(l, d) && p.push(o[c]);
  }
  return p;
}
function mt(e) {
  return e < 10 ? '0'.concat(e) : ''.concat(e);
}
function ft(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 12,
    r = Math.ceil(getYear(e) / t) * t,
    n = r - (t - 1);
  return { startPeriod: n, endPeriod: r };
}
function yt(e, t, r, n) {
  for (var o = [], a = 0; a < 2 * t + 1; a++) {
    var s = e + t - a,
      i = !0;
    r && (i = getYear(r) <= s), n && i && (i = getYear(n) >= s), i && o.push(s);
  }
  return o;
}
var vt = onClickOutsideHOC(
    (function (r) {
      ue$1(o, React__default['default'].Component);
      var n = ve$2(o);
      function o(t) {
        var r;
        ae$2(this, o),
          pe$2(fe$2((r = n.call(this, t))), 'renderOptions', function () {
            var t = r.props.year,
              n = r.state.yearsList.map(function (n) {
                return React__default['default'].createElement(
                  'div',
                  {
                    className:
                      t === n
                        ? 'react-datepicker__year-option react-datepicker__year-option--selected_year'
                        : 'react-datepicker__year-option',
                    key: n,
                    onClick: r.onChange.bind(fe$2(r), n),
                  },
                  t === n
                    ? React__default['default'].createElement(
                        'span',
                        { className: 'react-datepicker__year-option--selected' },
                        '✓',
                      )
                    : '',
                  n,
                );
              }),
              o = r.props.minDate ? getYear(r.props.minDate) : null,
              a = r.props.maxDate ? getYear(r.props.maxDate) : null;
            return (
              (a &&
                r.state.yearsList.find(function (e) {
                  return e === a;
                })) ||
                n.unshift(
                  React__default['default'].createElement(
                    'div',
                    { className: 'react-datepicker__year-option', key: 'upcoming', onClick: r.incrementYears },
                    React__default['default'].createElement('a', {
                      className:
                        'react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming',
                    }),
                  ),
                ),
              (o &&
                r.state.yearsList.find(function (e) {
                  return e === o;
                })) ||
                n.push(
                  React__default['default'].createElement(
                    'div',
                    { className: 'react-datepicker__year-option', key: 'previous', onClick: r.decrementYears },
                    React__default['default'].createElement('a', {
                      className:
                        'react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous',
                    }),
                  ),
                ),
              n
            );
          }),
          pe$2(fe$2(r), 'onChange', function (e) {
            r.props.onChange(e);
          }),
          pe$2(fe$2(r), 'handleClickOutside', function () {
            r.props.onCancel();
          }),
          pe$2(fe$2(r), 'shiftYears', function (e) {
            var t = r.state.yearsList.map(function (t) {
              return t + e;
            });
            r.setState({ yearsList: t });
          }),
          pe$2(fe$2(r), 'incrementYears', function () {
            return r.shiftYears(1);
          }),
          pe$2(fe$2(r), 'decrementYears', function () {
            return r.shiftYears(-1);
          });
        var a = t.yearDropdownItemNumber,
          s = t.scrollableYearDropdown,
          i = a || (s ? 10 : 5);
        return (r.state = { yearsList: yt(r.props.year, i, r.props.minDate, r.props.maxDate) }), r;
      }
      return (
        ie$2(o, [
          {
            key: 'render',
            value: function () {
              var r = cx({
                'react-datepicker__year-dropdown': !0,
                'react-datepicker__year-dropdown--scrollable': this.props.scrollableYearDropdown,
              });
              return React__default['default'].createElement('div', { className: r }, this.renderOptions());
            },
          },
        ]),
        o
      );
    })(),
  ),
  Dt = (function (t) {
    ue$1(n, React__default['default'].Component);
    var r = ve$2(n);
    function n() {
      var t;
      ae$2(this, n);
      for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++) a[s] = arguments[s];
      return (
        pe$2(fe$2((t = r.call.apply(r, [this].concat(a)))), 'state', { dropdownVisible: !1 }),
        pe$2(fe$2(t), 'renderSelectOptions', function () {
          for (
            var r = t.props.minDate ? getYear(t.props.minDate) : 1900,
              n = t.props.maxDate ? getYear(t.props.maxDate) : 2100,
              o = [],
              a = r;
            a <= n;
            a++
          )
            o.push(React__default['default'].createElement('option', { key: a, value: a }, a));
          return o;
        }),
        pe$2(fe$2(t), 'onSelectChange', function (e) {
          t.onChange(e.target.value);
        }),
        pe$2(fe$2(t), 'renderSelectMode', function () {
          return React__default['default'].createElement(
            'select',
            { value: t.props.year, className: 'react-datepicker__year-select', onChange: t.onSelectChange },
            t.renderSelectOptions(),
          );
        }),
        pe$2(fe$2(t), 'renderReadView', function (r) {
          return React__default['default'].createElement(
            'div',
            {
              key: 'read',
              style: { visibility: r ? 'visible' : 'hidden' },
              className: 'react-datepicker__year-read-view',
              onClick: function (e) {
                return t.toggleDropdown(e);
              },
            },
            React__default['default'].createElement('span', {
              className: 'react-datepicker__year-read-view--down-arrow',
            }),
            React__default['default'].createElement(
              'span',
              { className: 'react-datepicker__year-read-view--selected-year' },
              t.props.year,
            ),
          );
        }),
        pe$2(fe$2(t), 'renderDropdown', function () {
          return React__default['default'].createElement(vt, {
            key: 'dropdown',
            year: t.props.year,
            onChange: t.onChange,
            onCancel: t.toggleDropdown,
            minDate: t.props.minDate,
            maxDate: t.props.maxDate,
            scrollableYearDropdown: t.props.scrollableYearDropdown,
            yearDropdownItemNumber: t.props.yearDropdownItemNumber,
          });
        }),
        pe$2(fe$2(t), 'renderScrollMode', function () {
          var e = t.state.dropdownVisible,
            r = [t.renderReadView(!e)];
          return e && r.unshift(t.renderDropdown()), r;
        }),
        pe$2(fe$2(t), 'onChange', function (e) {
          t.toggleDropdown(), e !== t.props.year && t.props.onChange(e);
        }),
        pe$2(fe$2(t), 'toggleDropdown', function (e) {
          t.setState({ dropdownVisible: !t.state.dropdownVisible }, function () {
            t.props.adjustDateOnChange && t.handleYearChange(t.props.date, e);
          });
        }),
        pe$2(fe$2(t), 'handleYearChange', function (e, r) {
          t.onSelect(e, r), t.setOpen();
        }),
        pe$2(fe$2(t), 'onSelect', function (e, r) {
          t.props.onSelect && t.props.onSelect(e, r);
        }),
        pe$2(fe$2(t), 'setOpen', function () {
          t.props.setOpen && t.props.setOpen(!0);
        }),
        t
      );
    }
    return (
      ie$2(n, [
        {
          key: 'render',
          value: function () {
            var t;
            switch (this.props.dropdownMode) {
              case 'scroll':
                t = this.renderScrollMode();
                break;
              case 'select':
                t = this.renderSelectMode();
            }
            return React__default['default'].createElement(
              'div',
              {
                className:
                  'react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--'.concat(
                    this.props.dropdownMode,
                  ),
              },
              t,
            );
          },
        },
      ]),
      n
    );
  })(),
  wt = onClickOutsideHOC(
    (function (t) {
      ue$1(n, React__default['default'].Component);
      var r = ve$2(n);
      function n() {
        var t;
        ae$2(this, n);
        for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++) a[s] = arguments[s];
        return (
          pe$2(fe$2((t = r.call.apply(r, [this].concat(a)))), 'renderOptions', function () {
            return t.props.monthNames.map(function (r, n) {
              return React__default['default'].createElement(
                'div',
                {
                  className:
                    t.props.month === n
                      ? 'react-datepicker__month-option react-datepicker__month-option--selected_month'
                      : 'react-datepicker__month-option',
                  key: r,
                  onClick: t.onChange.bind(fe$2(t), n),
                },
                t.props.month === n
                  ? React__default['default'].createElement(
                      'span',
                      { className: 'react-datepicker__month-option--selected' },
                      '✓',
                    )
                  : '',
                r,
              );
            });
          }),
          pe$2(fe$2(t), 'onChange', function (e) {
            return t.props.onChange(e);
          }),
          pe$2(fe$2(t), 'handleClickOutside', function () {
            return t.props.onCancel();
          }),
          t
        );
      }
      return (
        ie$2(n, [
          {
            key: 'render',
            value: function () {
              return React__default['default'].createElement(
                'div',
                { className: 'react-datepicker__month-dropdown' },
                this.renderOptions(),
              );
            },
          },
        ]),
        n
      );
    })(),
  ),
  kt = (function (t) {
    ue$1(n, React__default['default'].Component);
    var r = ve$2(n);
    function n() {
      var t;
      ae$2(this, n);
      for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++) a[s] = arguments[s];
      return (
        pe$2(fe$2((t = r.call.apply(r, [this].concat(a)))), 'state', { dropdownVisible: !1 }),
        pe$2(fe$2(t), 'renderSelectOptions', function (t) {
          return t.map(function (t, r) {
            return React__default['default'].createElement('option', { key: r, value: r }, t);
          });
        }),
        pe$2(fe$2(t), 'renderSelectMode', function (r) {
          return React__default['default'].createElement(
            'select',
            {
              value: t.props.month,
              className: 'react-datepicker__month-select',
              onChange: function (e) {
                return t.onChange(e.target.value);
              },
            },
            t.renderSelectOptions(r),
          );
        }),
        pe$2(fe$2(t), 'renderReadView', function (r, n) {
          return React__default['default'].createElement(
            'div',
            {
              key: 'read',
              style: { visibility: r ? 'visible' : 'hidden' },
              className: 'react-datepicker__month-read-view',
              onClick: t.toggleDropdown,
            },
            React__default['default'].createElement('span', {
              className: 'react-datepicker__month-read-view--down-arrow',
            }),
            React__default['default'].createElement(
              'span',
              { className: 'react-datepicker__month-read-view--selected-month' },
              n[t.props.month],
            ),
          );
        }),
        pe$2(fe$2(t), 'renderDropdown', function (r) {
          return React__default['default'].createElement(wt, {
            key: 'dropdown',
            month: t.props.month,
            monthNames: r,
            onChange: t.onChange,
            onCancel: t.toggleDropdown,
          });
        }),
        pe$2(fe$2(t), 'renderScrollMode', function (e) {
          var r = t.state.dropdownVisible,
            n = [t.renderReadView(!r, e)];
          return r && n.unshift(t.renderDropdown(e)), n;
        }),
        pe$2(fe$2(t), 'onChange', function (e) {
          t.toggleDropdown(), e !== t.props.month && t.props.onChange(e);
        }),
        pe$2(fe$2(t), 'toggleDropdown', function () {
          return t.setState({ dropdownVisible: !t.state.dropdownVisible });
        }),
        t
      );
    }
    return (
      ie$2(n, [
        {
          key: 'render',
          value: function () {
            var t,
              r = this,
              n = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(
                this.props.useShortMonthInDropdown
                  ? function (e) {
                      return Ue$1(e, r.props.locale);
                    }
                  : function (e) {
                      return qe$1(e, r.props.locale);
                    },
              );
            switch (this.props.dropdownMode) {
              case 'scroll':
                t = this.renderScrollMode(n);
                break;
              case 'select':
                t = this.renderSelectMode(n);
            }
            return React__default['default'].createElement(
              'div',
              {
                className:
                  'react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--'.concat(
                    this.props.dropdownMode,
                  ),
              },
              t,
            );
          },
        },
      ]),
      n
    );
  })();
function gt(e, t) {
  for (var r = [], n = Ye$2(e), o = Ye$2(t); !isAfter(n, o); ) r.push(_e$2(n)), (n = addMonths(n, 1));
  return r;
}
var bt = onClickOutsideHOC(
    (function (r) {
      ue$1(o, React__default['default'].Component);
      var n = ve$2(o);
      function o(t) {
        var r;
        return (
          ae$2(this, o),
          pe$2(fe$2((r = n.call(this, t))), 'renderOptions', function () {
            return r.state.monthYearsList.map(function (t) {
              var n = getTime$1(t),
                o = Fe$2(r.props.date, t) && Re$2(r.props.date, t);
              return React__default['default'].createElement(
                'div',
                {
                  className: o
                    ? 'react-datepicker__month-year-option --selected_month-year'
                    : 'react-datepicker__month-year-option',
                  key: n,
                  onClick: r.onChange.bind(fe$2(r), n),
                },
                o
                  ? React__default['default'].createElement(
                      'span',
                      { className: 'react-datepicker__month-year-option--selected' },
                      '✓',
                    )
                  : '',
                Pe$2(t, r.props.dateFormat, r.props.locale),
              );
            });
          }),
          pe$2(fe$2(r), 'onChange', function (e) {
            return r.props.onChange(e);
          }),
          pe$2(fe$2(r), 'handleClickOutside', function () {
            r.props.onCancel();
          }),
          (r.state = { monthYearsList: gt(r.props.minDate, r.props.maxDate) }),
          r
        );
      }
      return (
        ie$2(o, [
          {
            key: 'render',
            value: function () {
              var r = cx({
                'react-datepicker__month-year-dropdown': !0,
                'react-datepicker__month-year-dropdown--scrollable': this.props.scrollableMonthYearDropdown,
              });
              return React__default['default'].createElement('div', { className: r }, this.renderOptions());
            },
          },
        ]),
        o
      );
    })(),
  ),
  Ct = (function (t) {
    ue$1(n, React__default['default'].Component);
    var r = ve$2(n);
    function n() {
      var t;
      ae$2(this, n);
      for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++) a[s] = arguments[s];
      return (
        pe$2(fe$2((t = r.call.apply(r, [this].concat(a)))), 'state', { dropdownVisible: !1 }),
        pe$2(fe$2(t), 'renderSelectOptions', function () {
          for (var r = Ye$2(t.props.minDate), n = Ye$2(t.props.maxDate), o = []; !isAfter(r, n); ) {
            var a = getTime$1(r);
            o.push(
              React__default['default'].createElement(
                'option',
                { key: a, value: a },
                Pe$2(r, t.props.dateFormat, t.props.locale),
              ),
            ),
              (r = addMonths(r, 1));
          }
          return o;
        }),
        pe$2(fe$2(t), 'onSelectChange', function (e) {
          t.onChange(e.target.value);
        }),
        pe$2(fe$2(t), 'renderSelectMode', function () {
          return React__default['default'].createElement(
            'select',
            {
              value: getTime$1(Ye$2(t.props.date)),
              className: 'react-datepicker__month-year-select',
              onChange: t.onSelectChange,
            },
            t.renderSelectOptions(),
          );
        }),
        pe$2(fe$2(t), 'renderReadView', function (r) {
          var n = Pe$2(t.props.date, t.props.dateFormat, t.props.locale);
          return React__default['default'].createElement(
            'div',
            {
              key: 'read',
              style: { visibility: r ? 'visible' : 'hidden' },
              className: 'react-datepicker__month-year-read-view',
              onClick: function (e) {
                return t.toggleDropdown(e);
              },
            },
            React__default['default'].createElement('span', {
              className: 'react-datepicker__month-year-read-view--down-arrow',
            }),
            React__default['default'].createElement(
              'span',
              { className: 'react-datepicker__month-year-read-view--selected-month-year' },
              n,
            ),
          );
        }),
        pe$2(fe$2(t), 'renderDropdown', function () {
          return React__default['default'].createElement(bt, {
            key: 'dropdown',
            date: t.props.date,
            dateFormat: t.props.dateFormat,
            onChange: t.onChange,
            onCancel: t.toggleDropdown,
            minDate: t.props.minDate,
            maxDate: t.props.maxDate,
            scrollableMonthYearDropdown: t.props.scrollableMonthYearDropdown,
            locale: t.props.locale,
          });
        }),
        pe$2(fe$2(t), 'renderScrollMode', function () {
          var e = t.state.dropdownVisible,
            r = [t.renderReadView(!e)];
          return e && r.unshift(t.renderDropdown()), r;
        }),
        pe$2(fe$2(t), 'onChange', function (e) {
          t.toggleDropdown();
          var r = _e$2(parseInt(e));
          (Fe$2(t.props.date, r) && Re$2(t.props.date, r)) || t.props.onChange(r);
        }),
        pe$2(fe$2(t), 'toggleDropdown', function () {
          return t.setState({ dropdownVisible: !t.state.dropdownVisible });
        }),
        t
      );
    }
    return (
      ie$2(n, [
        {
          key: 'render',
          value: function () {
            var t;
            switch (this.props.dropdownMode) {
              case 'scroll':
                t = this.renderScrollMode();
                break;
              case 'select':
                t = this.renderSelectMode();
            }
            return React__default['default'].createElement(
              'div',
              {
                className:
                  'react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--'.concat(
                    this.props.dropdownMode,
                  ),
              },
              t,
            );
          },
        },
      ]),
      n
    );
  })(),
  _t = (function (r) {
    ue$1(o, React__default['default'].Component);
    var n = ve$2(o);
    function o() {
      var r;
      ae$2(this, o);
      for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++) s[i] = arguments[i];
      return (
        pe$2(fe$2((r = n.call.apply(n, [this].concat(s)))), 'dayEl', React__default['default'].createRef()),
        pe$2(fe$2(r), 'handleClick', function (e) {
          !r.isDisabled() && r.props.onClick && r.props.onClick(e);
        }),
        pe$2(fe$2(r), 'handleMouseEnter', function (e) {
          !r.isDisabled() && r.props.onMouseEnter && r.props.onMouseEnter(e);
        }),
        pe$2(fe$2(r), 'handleOnKeyDown', function (e) {
          ' ' === e.key && (e.preventDefault(), (e.key = 'Enter')), r.props.handleOnKeyDown(e);
        }),
        pe$2(fe$2(r), 'isSameDay', function (e) {
          return We$1(r.props.day, e);
        }),
        pe$2(fe$2(r), 'isKeyboardSelected', function () {
          return (
            !r.props.disabledKeyboardNavigation && !r.isSameDay(r.props.selected) && r.isSameDay(r.props.preSelection)
          );
        }),
        pe$2(fe$2(r), 'isDisabled', function () {
          return ze$2(r.props.day, r.props);
        }),
        pe$2(fe$2(r), 'isExcluded', function () {
          return Ge$1(r.props.day, r.props);
        }),
        pe$2(fe$2(r), 'getHighLightedClass', function (e) {
          var t = r.props,
            n = t.day,
            o = t.highlightDates;
          if (!o) return !1;
          var a = Pe$2(n, 'MM.dd.yyyy');
          return o.get(a);
        }),
        pe$2(fe$2(r), 'isInRange', function () {
          var e = r.props,
            t = e.day,
            n = e.startDate,
            o = e.endDate;
          return !(!n || !o) && je$2(t, n, o);
        }),
        pe$2(fe$2(r), 'isInSelectingRange', function () {
          var e = r.props,
            t = e.day,
            n = e.selectsStart,
            o = e.selectsEnd,
            a = e.selectsRange,
            s = e.selectingDate,
            i = e.startDate,
            p = e.endDate;
          return (
            !(!(n || o || a) || !s || r.isDisabled()) &&
            (n && p && (isBefore(s, p) || Be$2(s, p))
              ? je$2(t, s, p)
              : ((o && i && (isAfter(s, i) || Be$2(s, i))) || !(!a || !i || p || (!isAfter(s, i) && !Be$2(s, i)))) &&
                je$2(t, i, s))
          );
        }),
        pe$2(fe$2(r), 'isSelectingRangeStart', function () {
          if (!r.isInSelectingRange()) return !1;
          var e = r.props,
            t = e.day,
            n = e.selectingDate,
            o = e.startDate;
          return We$1(t, e.selectsStart ? n : o);
        }),
        pe$2(fe$2(r), 'isSelectingRangeEnd', function () {
          if (!r.isInSelectingRange()) return !1;
          var e = r.props,
            t = e.day,
            n = e.selectingDate,
            o = e.endDate;
          return We$1(t, e.selectsEnd ? n : o);
        }),
        pe$2(fe$2(r), 'isRangeStart', function () {
          var e = r.props,
            t = e.day,
            n = e.startDate,
            o = e.endDate;
          return !(!n || !o) && We$1(n, t);
        }),
        pe$2(fe$2(r), 'isRangeEnd', function () {
          var e = r.props,
            t = e.day,
            n = e.startDate,
            o = e.endDate;
          return !(!n || !o) && We$1(o, t);
        }),
        pe$2(fe$2(r), 'isWeekend', function () {
          var e = getDay$1(r.props.day);
          return 0 === e || 6 === e;
        }),
        pe$2(fe$2(r), 'isOutsideMonth', function () {
          return void 0 !== r.props.month && r.props.month !== getMonth(r.props.day);
        }),
        pe$2(fe$2(r), 'getClassNames', function (e) {
          var n = r.props.dayClassName ? r.props.dayClassName(e) : void 0;
          return cx(
            'react-datepicker__day',
            n,
            'react-datepicker__day--' + Oe$2(r.props.day),
            {
              'react-datepicker__day--disabled': r.isDisabled(),
              'react-datepicker__day--excluded': r.isExcluded(),
              'react-datepicker__day--selected': r.isSameDay(r.props.selected),
              'react-datepicker__day--keyboard-selected': r.isKeyboardSelected(),
              'react-datepicker__day--range-start': r.isRangeStart(),
              'react-datepicker__day--range-end': r.isRangeEnd(),
              'react-datepicker__day--in-range': r.isInRange(),
              'react-datepicker__day--in-selecting-range': r.isInSelectingRange(),
              'react-datepicker__day--selecting-range-start': r.isSelectingRangeStart(),
              'react-datepicker__day--selecting-range-end': r.isSelectingRangeEnd(),
              'react-datepicker__day--today': r.isSameDay(_e$2()),
              'react-datepicker__day--weekend': r.isWeekend(),
              'react-datepicker__day--outside-month': r.isOutsideMonth(),
            },
            r.getHighLightedClass('react-datepicker__day--highlighted'),
          );
        }),
        pe$2(fe$2(r), 'getAriaLabel', function () {
          var e = r.props,
            t = e.day,
            n = e.ariaLabelPrefixWhenEnabled,
            o = void 0 === n ? 'Choose' : n,
            a = e.ariaLabelPrefixWhenDisabled,
            s = void 0 === a ? 'Not available' : a,
            i = r.isDisabled() || r.isExcluded() ? s : o;
          return ''.concat(i, ' ').concat(Pe$2(t, 'PPPP'));
        }),
        pe$2(fe$2(r), 'getTabIndex', function (e, t) {
          var n = e || r.props.selected,
            o = t || r.props.preSelection;
          return r.isKeyboardSelected() || (r.isSameDay(n) && We$1(o, n)) ? 0 : -1;
        }),
        pe$2(fe$2(r), 'handleFocusDay', function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = !1;
          0 === r.getTabIndex() &&
            !e.isInputFocused &&
            r.isSameDay(r.props.preSelection) &&
            ((document.activeElement && document.activeElement !== document.body) || (t = !0),
            r.props.inline && !r.props.shouldFocusDayInline && (t = !1),
            r.props.containerRef &&
              r.props.containerRef.current &&
              r.props.containerRef.current.contains(document.activeElement) &&
              document.activeElement.classList.contains('react-datepicker__day') &&
              (t = !0)),
            t && r.dayEl.current.focus({ preventScroll: !0 });
        }),
        pe$2(fe$2(r), 'renderDayContents', function () {
          if (r.isOutsideMonth()) {
            if (r.props.monthShowsDuplicateDaysEnd && getDate(r.props.day) < 10) return null;
            if (r.props.monthShowsDuplicateDaysStart && getDate(r.props.day) > 20) return null;
          }
          return r.props.renderDayContents
            ? r.props.renderDayContents(getDate(r.props.day), r.props.day)
            : getDate(r.props.day);
        }),
        pe$2(fe$2(r), 'render', function () {
          return React__default['default'].createElement(
            'div',
            {
              ref: r.dayEl,
              className: r.getClassNames(r.props.day),
              onKeyDown: r.handleOnKeyDown,
              onClick: r.handleClick,
              onMouseEnter: r.handleMouseEnter,
              tabIndex: r.getTabIndex(),
              'aria-label': r.getAriaLabel(),
              role: 'button',
              'aria-disabled': r.isDisabled(),
            },
            r.renderDayContents(),
          );
        }),
        r
      );
    }
    return (
      ie$2(o, [
        {
          key: 'componentDidMount',
          value: function () {
            this.handleFocusDay();
          },
        },
        {
          key: 'componentDidUpdate',
          value: function (e) {
            this.handleFocusDay(e);
          },
        },
      ]),
      o
    );
  })(),
  St = (function (r) {
    ue$1(o, React__default['default'].Component);
    var n = ve$2(o);
    function o() {
      var e;
      ae$2(this, o);
      for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++) r[a] = arguments[a];
      return (
        pe$2(fe$2((e = n.call.apply(n, [this].concat(r)))), 'handleClick', function (t) {
          e.props.onClick && e.props.onClick(t);
        }),
        e
      );
    }
    return (
      ie$2(o, [
        {
          key: 'render',
          value: function () {
            var r = this.props,
              n = r.weekNumber,
              o = r.ariaLabelPrefix,
              a = void 0 === o ? 'week ' : o,
              s = { 'react-datepicker__week-number': !0, 'react-datepicker__week-number--clickable': !!r.onClick };
            return React__default['default'].createElement(
              'div',
              {
                className: cx(s),
                'aria-label': ''.concat(a, ' ').concat(this.props.weekNumber),
                onClick: this.handleClick,
              },
              n,
            );
          },
        },
      ]),
      o
    );
  })(),
  Mt = (function (t) {
    ue$1(n, React__default['default'].Component);
    var r = ve$2(n);
    function n() {
      var t;
      ae$2(this, n);
      for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++) a[s] = arguments[s];
      return (
        pe$2(fe$2((t = r.call.apply(r, [this].concat(a)))), 'handleDayClick', function (e, r) {
          t.props.onDayClick && t.props.onDayClick(e, r);
        }),
        pe$2(fe$2(t), 'handleDayMouseEnter', function (e) {
          t.props.onDayMouseEnter && t.props.onDayMouseEnter(e);
        }),
        pe$2(fe$2(t), 'handleWeekClick', function (e, r, n) {
          'function' == typeof t.props.onWeekSelect && t.props.onWeekSelect(e, r, n),
            t.props.shouldCloseOnSelect && t.props.setOpen(!1);
        }),
        pe$2(fe$2(t), 'formatWeekNumber', function (e) {
          return t.props.formatWeekNumber ? t.props.formatWeekNumber(e) : Ne$2(e);
        }),
        pe$2(fe$2(t), 'renderDays', function () {
          var r = Te$2(t.props.day, t.props.locale),
            n = [],
            o = t.formatWeekNumber(r);
          if (t.props.showWeekNumber) {
            var a = t.props.onWeekSelect ? t.handleWeekClick.bind(fe$2(t), r, o) : void 0;
            n.push(
              React__default['default'].createElement(St, {
                key: 'W',
                weekNumber: o,
                onClick: a,
                ariaLabelPrefix: t.props.ariaLabelPrefix,
              }),
            );
          }
          return n.concat(
            [0, 1, 2, 3, 4, 5, 6].map(function (n) {
              var o = addDays(r, n);
              return React__default['default'].createElement(_t, {
                ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix,
                ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix,
                key: o.valueOf(),
                day: o,
                month: t.props.month,
                onClick: t.handleDayClick.bind(fe$2(t), o),
                onMouseEnter: t.handleDayMouseEnter.bind(fe$2(t), o),
                minDate: t.props.minDate,
                maxDate: t.props.maxDate,
                excludeDates: t.props.excludeDates,
                includeDates: t.props.includeDates,
                highlightDates: t.props.highlightDates,
                selectingDate: t.props.selectingDate,
                filterDate: t.props.filterDate,
                preSelection: t.props.preSelection,
                selected: t.props.selected,
                selectsStart: t.props.selectsStart,
                selectsEnd: t.props.selectsEnd,
                selectsRange: t.props.selectsRange,
                startDate: t.props.startDate,
                endDate: t.props.endDate,
                dayClassName: t.props.dayClassName,
                renderDayContents: t.props.renderDayContents,
                disabledKeyboardNavigation: t.props.disabledKeyboardNavigation,
                handleOnKeyDown: t.props.handleOnKeyDown,
                isInputFocused: t.props.isInputFocused,
                containerRef: t.props.containerRef,
                inline: t.props.inline,
                shouldFocusDayInline: t.props.shouldFocusDayInline,
                monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd,
                monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart,
              });
            }),
          );
        }),
        t
      );
    }
    return (
      ie$2(
        n,
        [
          {
            key: 'render',
            value: function () {
              return React__default['default'].createElement(
                'div',
                { className: 'react-datepicker__week' },
                this.renderDays(),
              );
            },
          },
        ],
        [
          {
            key: 'defaultProps',
            get: function () {
              return { shouldCloseOnSelect: !0 };
            },
          },
        ],
      ),
      n
    );
  })(),
  Pt = (function (r) {
    ue$1(o, React__default['default'].Component);
    var n = ve$2(o);
    function o() {
      var r;
      ae$2(this, o);
      for (var a = arguments.length, s = new Array(a), l = 0; l < a; l++) s[l] = arguments[l];
      return (
        pe$2(
          fe$2((r = n.call.apply(n, [this].concat(s)))),
          'MONTH_REFS',
          De$2(Array(12)).map(function () {
            return React__default['default'].createRef();
          }),
        ),
        pe$2(fe$2(r), 'isDisabled', function (e) {
          return ze$2(e, r.props);
        }),
        pe$2(fe$2(r), 'isExcluded', function (e) {
          return Ge$1(e, r.props);
        }),
        pe$2(fe$2(r), 'handleDayClick', function (e, t) {
          r.props.onDayClick && r.props.onDayClick(e, t, r.props.orderInDisplay);
        }),
        pe$2(fe$2(r), 'handleDayMouseEnter', function (e) {
          r.props.onDayMouseEnter && r.props.onDayMouseEnter(e);
        }),
        pe$2(fe$2(r), 'handleMouseLeave', function () {
          r.props.onMouseLeave && r.props.onMouseLeave();
        }),
        pe$2(fe$2(r), 'isRangeStartMonth', function (e) {
          var t = r.props,
            n = t.day,
            o = t.startDate,
            a = t.endDate;
          return !(!o || !a) && Re$2(setMonth(n, e), o);
        }),
        pe$2(fe$2(r), 'isRangeStartQuarter', function (e) {
          var t = r.props,
            n = t.day,
            o = t.startDate,
            a = t.endDate;
          return !(!o || !a) && Ae$2(setQuarter(n, e), o);
        }),
        pe$2(fe$2(r), 'isRangeEndMonth', function (e) {
          var t = r.props,
            n = t.day,
            o = t.startDate,
            a = t.endDate;
          return !(!o || !a) && Re$2(setMonth(n, e), a);
        }),
        pe$2(fe$2(r), 'isRangeEndQuarter', function (e) {
          var t = r.props,
            n = t.day,
            o = t.startDate,
            a = t.endDate;
          return !(!o || !a) && Ae$2(setQuarter(n, e), a);
        }),
        pe$2(fe$2(r), 'isWeekInMonth', function (e) {
          var t = r.props.day,
            n = addDays(e, 6);
          return Re$2(e, t) || Re$2(n, t);
        }),
        pe$2(fe$2(r), 'renderWeeks', function () {
          for (
            var t = [], n = r.props.fixedHeight, o = Te$2(Ye$2(r.props.day), r.props.locale), a = 0, s = !1;
            t.push(
              React__default['default'].createElement(Mt, {
                ariaLabelPrefix: r.props.weekAriaLabelPrefix,
                chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
                disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
                key: a,
                day: o,
                month: getMonth(r.props.day),
                onDayClick: r.handleDayClick,
                onDayMouseEnter: r.handleDayMouseEnter,
                onWeekSelect: r.props.onWeekSelect,
                formatWeekNumber: r.props.formatWeekNumber,
                locale: r.props.locale,
                minDate: r.props.minDate,
                maxDate: r.props.maxDate,
                excludeDates: r.props.excludeDates,
                includeDates: r.props.includeDates,
                inline: r.props.inline,
                shouldFocusDayInline: r.props.shouldFocusDayInline,
                highlightDates: r.props.highlightDates,
                selectingDate: r.props.selectingDate,
                filterDate: r.props.filterDate,
                preSelection: r.props.preSelection,
                selected: r.props.selected,
                selectsStart: r.props.selectsStart,
                selectsEnd: r.props.selectsEnd,
                selectsRange: r.props.selectsRange,
                showWeekNumber: r.props.showWeekNumbers,
                startDate: r.props.startDate,
                endDate: r.props.endDate,
                dayClassName: r.props.dayClassName,
                setOpen: r.props.setOpen,
                shouldCloseOnSelect: r.props.shouldCloseOnSelect,
                disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
                renderDayContents: r.props.renderDayContents,
                handleOnKeyDown: r.props.handleOnKeyDown,
                isInputFocused: r.props.isInputFocused,
                containerRef: r.props.containerRef,
                monthShowsDuplicateDaysEnd: r.props.monthShowsDuplicateDaysEnd,
                monthShowsDuplicateDaysStart: r.props.monthShowsDuplicateDaysStart,
              }),
            ),
              !s;

          ) {
            a++, (o = addWeeks(o, 1));
            var i = n && a >= 6,
              c = !n && !r.isWeekInMonth(o);
            if (i || c) {
              if (!r.props.peekNextMonth) break;
              s = !0;
            }
          }
          return t;
        }),
        pe$2(fe$2(r), 'onMonthClick', function (e, t) {
          r.handleDayClick(Ye$2(setMonth(r.props.day, t)), e);
        }),
        pe$2(fe$2(r), 'handleMonthNavigation', function (e, t) {
          r.isDisabled(t) ||
            r.isExcluded(t) ||
            (r.props.setPreSelection(t), r.MONTH_REFS[e].current && r.MONTH_REFS[e].current.focus());
        }),
        pe$2(fe$2(r), 'onMonthKeyDown', function (e, t) {
          var n = e.key;
          if (!r.props.disabledKeyboardNavigation)
            switch (n) {
              case 'Enter':
                r.onMonthClick(e, t), r.props.setPreSelection(r.props.selected);
                break;
              case 'ArrowRight':
                r.handleMonthNavigation(11 === t ? 0 : t + 1, addMonths(r.props.preSelection, 1));
                break;
              case 'ArrowLeft':
                r.handleMonthNavigation(0 === t ? 11 : t - 1, subMonths(r.props.preSelection, 1));
            }
        }),
        pe$2(fe$2(r), 'onQuarterClick', function (e, t) {
          r.handleDayClick(Le$2(setQuarter(r.props.day, t)), e);
        }),
        pe$2(fe$2(r), 'getMonthClassNames', function (e) {
          var n = r.props,
            o = n.day,
            a = n.startDate,
            s = n.endDate,
            i = n.selected,
            p = n.minDate,
            c = n.maxDate,
            l = n.preSelection,
            d = n.monthClassName,
            u = d ? d(o) : void 0;
          return cx('react-datepicker__month-text', 'react-datepicker__month-'.concat(e), u, {
            'react-datepicker__month--disabled': (p || c) && Je$1(setMonth(o, e), r.props),
            'react-datepicker__month--selected': getMonth(o) === e && getYear(o) === getYear(i),
            'react-datepicker__month-text--keyboard-selected': getMonth(l) === e,
            'react-datepicker__month--in-range': Xe(a, s, e, o),
            'react-datepicker__month--range-start': r.isRangeStartMonth(e),
            'react-datepicker__month--range-end': r.isRangeEndMonth(e),
          });
        }),
        pe$2(fe$2(r), 'getTabIndex', function (e) {
          var t = getMonth(r.props.preSelection);
          return r.props.disabledKeyboardNavigation || e !== t ? '-1' : '0';
        }),
        pe$2(fe$2(r), 'getAriaLabel', function (e) {
          var t = r.props,
            n = t.ariaLabelPrefix,
            o = void 0 === n ? 'Choose' : n,
            a = t.disabledDayAriaLabelPrefix,
            s = void 0 === a ? 'Not available' : a,
            i = t.day,
            p = setMonth(i, e),
            c = r.isDisabled(p) || r.isExcluded(p) ? s : o;
          return ''.concat(c, ' ').concat(Pe$2(p, 'MMMM yyyy'));
        }),
        pe$2(fe$2(r), 'getQuarterClassNames', function (e) {
          var n = r.props,
            o = n.day,
            a = n.startDate,
            s = n.endDate,
            i = n.selected,
            p = n.minDate,
            c = n.maxDate;
          return cx('react-datepicker__quarter-text', 'react-datepicker__quarter-'.concat(e), {
            'react-datepicker__quarter--disabled': (p || c) && Ze(setQuarter(o, e), r.props),
            'react-datepicker__quarter--selected': getQuarter(o) === e && getYear(o) === getYear(i),
            'react-datepicker__quarter--in-range': tt(a, s, e, o),
            'react-datepicker__quarter--range-start': r.isRangeStartQuarter(e),
            'react-datepicker__quarter--range-end': r.isRangeEndQuarter(e),
          });
        }),
        pe$2(fe$2(r), 'renderMonths', function () {
          var t = r.props,
            n = t.showFullMonthYearPicker,
            o = t.showTwoColumnMonthYearPicker,
            a = t.showFourColumnMonthYearPicker,
            s = t.locale;
          return (
            a
              ? [
                  [0, 1, 2, 3],
                  [4, 5, 6, 7],
                  [8, 9, 10, 11],
                ]
              : o
              ? [
                  [0, 1],
                  [2, 3],
                  [4, 5],
                  [6, 7],
                  [8, 9],
                  [10, 11],
                ]
              : [
                  [0, 1, 2],
                  [3, 4, 5],
                  [6, 7, 8],
                  [9, 10, 11],
                ]
          ).map(function (t, o) {
            return React__default['default'].createElement(
              'div',
              { className: 'react-datepicker__month-wrapper', key: o },
              t.map(function (t, o) {
                return React__default['default'].createElement(
                  'div',
                  {
                    ref: r.MONTH_REFS[t],
                    key: o,
                    onClick: function (e) {
                      r.onMonthClick(e, t);
                    },
                    onKeyDown: function (e) {
                      r.onMonthKeyDown(e, t);
                    },
                    tabIndex: r.getTabIndex(t),
                    className: r.getMonthClassNames(t),
                    role: 'button',
                    'aria-label': r.getAriaLabel(t),
                  },
                  n ? qe$1(t, s) : Ue$1(t, s),
                );
              }),
            );
          });
        }),
        pe$2(fe$2(r), 'renderQuarters', function () {
          return React__default['default'].createElement(
            'div',
            { className: 'react-datepicker__quarter-wrapper' },
            [1, 2, 3, 4].map(function (t, n) {
              return React__default['default'].createElement(
                'div',
                {
                  key: n,
                  onClick: function (e) {
                    r.onQuarterClick(e, t);
                  },
                  className: r.getQuarterClassNames(t),
                },
                $e$1(t, r.props.locale),
              );
            }),
          );
        }),
        pe$2(fe$2(r), 'getClassNames', function () {
          var e = r.props;
          e.day;
          var n = e.selectingDate,
            o = e.selectsStart,
            a = e.selectsEnd,
            s = e.showMonthYearPicker,
            i = e.showQuarterYearPicker;
          return cx(
            'react-datepicker__month',
            { 'react-datepicker__month--selecting-range': n && (o || a) },
            { 'react-datepicker__monthPicker': s },
            { 'react-datepicker__quarterPicker': i },
          );
        }),
        r
      );
    }
    return (
      ie$2(o, [
        {
          key: 'render',
          value: function () {
            var t = this.props,
              r = t.showMonthYearPicker,
              n = t.showQuarterYearPicker,
              o = t.day,
              a = t.ariaLabelPrefix,
              s = void 0 === a ? 'month ' : a;
            return React__default['default'].createElement(
              'div',
              {
                className: this.getClassNames(),
                onMouseLeave: this.handleMouseLeave,
                'aria-label': ''.concat(s, ' ').concat(Pe$2(o, 'yyyy-MM')),
              },
              r ? this.renderMonths() : n ? this.renderQuarters() : this.renderWeeks(),
            );
          },
        },
      ]),
      o
    );
  })(),
  Et = (function (t) {
    ue$1(n, React__default['default'].Component);
    var r = ve$2(n);
    function n() {
      var t;
      ae$2(this, n);
      for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++) s[i] = arguments[i];
      return (
        pe$2(fe$2((t = r.call.apply(r, [this].concat(s)))), 'state', { height: null }),
        pe$2(fe$2(t), 'handleClick', function (e) {
          ((t.props.minTime || t.props.maxTime) && at(e, t.props)) ||
            ((t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && ot(e, t.props)) ||
            t.props.onChange(e);
        }),
        pe$2(fe$2(t), 'liClasses', function (e, r, n) {
          var o = ['react-datepicker__time-list-item', t.props.timeClassName ? t.props.timeClassName(e, r, n) : void 0];
          return (
            t.props.selected &&
              r === getHours(e) &&
              n === getMinutes(e) &&
              o.push('react-datepicker__time-list-item--selected'),
            (((t.props.minTime || t.props.maxTime) && at(e, t.props)) ||
              ((t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && ot(e, t.props))) &&
              o.push('react-datepicker__time-list-item--disabled'),
            t.props.injectTimes &&
              (60 * getHours(e) + getMinutes(e)) % t.props.intervals != 0 &&
              o.push('react-datepicker__time-list-item--injected'),
            o.join(' ')
          );
        }),
        pe$2(fe$2(t), 'renderTimes', function () {
          for (
            var r = [],
              n = t.props.format ? t.props.format : 'p',
              o = t.props.intervals,
              s = xe$2(_e$2(t.props.selected)),
              i = 1440 / o,
              p =
                t.props.injectTimes &&
                t.props.injectTimes.sort(function (e, t) {
                  return e - t;
                }),
              c = t.props.selected || t.props.openToDate || _e$2(),
              l = getHours(c),
              d = getMinutes(c),
              u = setHours(setMinutes(s, d), l),
              h = 0;
            h < i;
            h++
          ) {
            var m = addMinutes(s, h * o);
            if ((r.push(m), p)) {
              var f = ht(s, m, h, o, p);
              r = r.concat(f);
            }
          }
          return r.map(function (r, o) {
            return React__default['default'].createElement(
              'li',
              {
                key: o,
                onClick: t.handleClick.bind(fe$2(t), r),
                className: t.liClasses(r, l, d),
                ref: function (e) {
                  (isBefore(r, u) || Be$2(r, u)) && (t.centerLi = e);
                },
                tabIndex: '0',
              },
              Pe$2(r, n, t.props.locale),
            );
          });
        }),
        t
      );
    }
    return (
      ie$2(
        n,
        [
          {
            key: 'componentDidMount',
            value: function () {
              (this.list.scrollTop = n.calcCenterPosition(
                this.props.monthRef
                  ? this.props.monthRef.clientHeight - this.header.clientHeight
                  : this.list.clientHeight,
                this.centerLi,
              )),
                this.props.monthRef &&
                  this.header &&
                  this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
            },
          },
          {
            key: 'render',
            value: function () {
              var t = this,
                r = this.state.height;
              return React__default['default'].createElement(
                'div',
                {
                  className: 'react-datepicker__time-container '.concat(
                    this.props.todayButton ? 'react-datepicker__time-container--with-today-button' : '',
                  ),
                },
                React__default['default'].createElement(
                  'div',
                  {
                    className: 'react-datepicker__header react-datepicker__header--time '.concat(
                      this.props.showTimeSelectOnly ? 'react-datepicker__header--time--only' : '',
                    ),
                    ref: function (e) {
                      t.header = e;
                    },
                  },
                  React__default['default'].createElement(
                    'div',
                    { className: 'react-datepicker-time__header' },
                    this.props.timeCaption,
                  ),
                ),
                React__default['default'].createElement(
                  'div',
                  { className: 'react-datepicker__time' },
                  React__default['default'].createElement(
                    'div',
                    { className: 'react-datepicker__time-box' },
                    React__default['default'].createElement(
                      'ul',
                      {
                        className: 'react-datepicker__time-list',
                        ref: function (e) {
                          t.list = e;
                        },
                        style: r ? { height: r } : {},
                        tabIndex: '0',
                      },
                      this.renderTimes(),
                    ),
                  ),
                ),
              );
            },
          },
        ],
        [
          {
            key: 'defaultProps',
            get: function () {
              return { intervals: 30, onTimeChange: function () {}, todayButton: null, timeCaption: 'Time' };
            },
          },
        ],
      ),
      n
    );
  })();
pe$2(Et, 'calcCenterPosition', function (e, t) {
  return t.offsetTop - (e / 2 - t.clientHeight / 2);
});
var Nt = (function (r) {
    ue$1(o, React__default['default'].Component);
    var n = ve$2(o);
    function o(e) {
      var r;
      return (
        ae$2(this, o),
        pe$2(fe$2((r = n.call(this, e))), 'handleYearClick', function (e, t) {
          r.props.onDayClick && r.props.onDayClick(e, t);
        }),
        pe$2(fe$2(r), 'isSameDay', function (e, t) {
          return We$1(e, t);
        }),
        pe$2(fe$2(r), 'isKeyboardSelected', function (e) {
          var t = Ie$2(setYear(r.props.date, e));
          return (
            !r.props.disabledKeyboardNavigation &&
            !r.props.inline &&
            !We$1(t, Ie$2(r.props.selected)) &&
            We$1(t, Ie$2(r.props.preSelection))
          );
        }),
        pe$2(fe$2(r), 'onYearClick', function (e, t) {
          var n = r.props.date;
          r.handleYearClick(Ie$2(setYear(n, t)), e);
        }),
        pe$2(fe$2(r), 'getYearClassNames', function (e) {
          var n = r.props,
            o = n.minDate,
            a = n.maxDate,
            s = n.selected;
          return cx('react-datepicker__year-text', {
            'react-datepicker__year-text--selected': e === getYear(s),
            'react-datepicker__year-text--disabled': (o || a) && et(e, r.props),
            'react-datepicker__year-text--keyboard-selected': r.isKeyboardSelected(e),
            'react-datepicker__year-text--today': e === getYear(_e$2()),
          });
        }),
        r
      );
    }
    return (
      ie$2(o, [
        {
          key: 'render',
          value: function () {
            for (
              var t = this,
                r = [],
                n = this.props,
                o = ft(n.date, n.yearItemNumber),
                a = o.startPeriod,
                s = o.endPeriod,
                i = function (n) {
                  r.push(
                    React__default['default'].createElement(
                      'div',
                      {
                        onClick: function (e) {
                          t.onYearClick(e, n);
                        },
                        className: t.getYearClassNames(n),
                        key: n,
                      },
                      n,
                    ),
                  );
                },
                p = a;
              p <= s;
              p++
            )
              i(p);
            return React__default['default'].createElement(
              'div',
              { className: 'react-datepicker__year' },
              React__default['default'].createElement('div', { className: 'react-datepicker__year-wrapper' }, r),
            );
          },
        },
      ]),
      o
    );
  })(),
  Ot = (function (t) {
    ue$1(n, React__default['default'].Component);
    var r = ve$2(n);
    function n(t) {
      var o;
      return (
        ae$2(this, n),
        pe$2(fe$2((o = r.call(this, t))), 'onTimeChange', function (e) {
          o.setState({ time: e });
          var t = new Date();
          t.setHours(e.split(':')[0]), t.setMinutes(e.split(':')[1]), o.props.onChange(t);
        }),
        pe$2(fe$2(o), 'renderTimeInput', function () {
          var t = o.state.time,
            r = o.props,
            n = r.date,
            a = r.timeString,
            s = r.customTimeInput;
          return s
            ? React__default['default'].cloneElement(s, { date: n, value: t, onChange: o.onTimeChange })
            : React__default['default'].createElement('input', {
                type: 'time',
                className: 'react-datepicker-time__input',
                placeholder: 'Time',
                name: 'time-input',
                required: !0,
                value: t,
                onChange: function (e) {
                  o.onTimeChange(e.target.value || a);
                },
              });
        }),
        (o.state = { time: o.props.timeString }),
        o
      );
    }
    return (
      ie$2(
        n,
        [
          {
            key: 'render',
            value: function () {
              return React__default['default'].createElement(
                'div',
                { className: 'react-datepicker__input-time-container' },
                React__default['default'].createElement(
                  'div',
                  { className: 'react-datepicker-time__caption' },
                  this.props.timeInputLabel,
                ),
                React__default['default'].createElement(
                  'div',
                  { className: 'react-datepicker-time__input-container' },
                  React__default['default'].createElement(
                    'div',
                    { className: 'react-datepicker-time__input' },
                    this.renderTimeInput(),
                  ),
                ),
              );
            },
          },
        ],
        [
          {
            key: 'getDerivedStateFromProps',
            value: function (e, t) {
              return e.timeString !== t.time ? { time: e.timeString } : null;
            },
          },
        ],
      ),
      n
    );
  })();
function xt(t) {
  var r = t.className,
    n = t.children,
    o = t.showPopperArrow,
    a = t.arrowProps,
    s = void 0 === a ? {} : a;
  return React__default['default'].createElement(
    'div',
    { className: r },
    o && React__default['default'].createElement('div', ce$2({ className: 'react-datepicker__triangle' }, s)),
    n,
  );
}
var Tt = ['react-datepicker__year-select', 'react-datepicker__month-select', 'react-datepicker__month-year-select'],
  Yt = (function (r) {
    ue$1(o, React__default['default'].Component);
    var n = ve$2(o);
    function o(r) {
      var a;
      return (
        ae$2(this, o),
        pe$2(fe$2((a = n.call(this, r))), 'handleClickOutside', function (e) {
          a.props.onClickOutside(e);
        }),
        pe$2(fe$2(a), 'setClickOutsideRef', function () {
          return a.containerRef.current;
        }),
        pe$2(fe$2(a), 'handleDropdownFocus', function (e) {
          (function () {
            var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || '').split(
              /\s+/,
            );
            return Tt.some(function (t) {
              return e.indexOf(t) >= 0;
            });
          })(e.target) && a.props.onDropdownFocus();
        }),
        pe$2(fe$2(a), 'getDateInView', function () {
          var e = a.props,
            t = e.preSelection,
            r = e.selected,
            n = e.openToDate,
            o = lt(a.props),
            s = dt(a.props),
            i = _e$2(),
            p = n || r || t;
          return p || (o && isBefore(i, o) ? o : s && isAfter(i, s) ? s : i);
        }),
        pe$2(fe$2(a), 'increaseMonth', function () {
          a.setState(
            function (e) {
              var t = e.date;
              return { date: addMonths(t, 1) };
            },
            function () {
              return a.handleMonthChange(a.state.date);
            },
          );
        }),
        pe$2(fe$2(a), 'decreaseMonth', function () {
          a.setState(
            function (e) {
              var t = e.date;
              return { date: subMonths(t, 1) };
            },
            function () {
              return a.handleMonthChange(a.state.date);
            },
          );
        }),
        pe$2(fe$2(a), 'handleDayClick', function (e, t, r) {
          a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
        }),
        pe$2(fe$2(a), 'handleDayMouseEnter', function (e) {
          a.setState({ selectingDate: e }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
        }),
        pe$2(fe$2(a), 'handleMonthMouseLeave', function () {
          a.setState({ selectingDate: null }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
        }),
        pe$2(fe$2(a), 'handleYearChange', function (e) {
          a.props.onYearChange && a.props.onYearChange(e),
            a.props.adjustDateOnChange &&
              (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)),
            a.props.setPreSelection && a.props.setPreSelection(e);
        }),
        pe$2(fe$2(a), 'handleMonthChange', function (e) {
          a.props.onMonthChange && a.props.onMonthChange(e),
            a.props.adjustDateOnChange &&
              (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)),
            a.props.setPreSelection && a.props.setPreSelection(e);
        }),
        pe$2(fe$2(a), 'handleMonthYearChange', function (e) {
          a.handleYearChange(e), a.handleMonthChange(e);
        }),
        pe$2(fe$2(a), 'changeYear', function (e) {
          a.setState(
            function (t) {
              var r = t.date;
              return { date: setYear(r, e) };
            },
            function () {
              return a.handleYearChange(a.state.date);
            },
          );
        }),
        pe$2(fe$2(a), 'changeMonth', function (e) {
          a.setState(
            function (t) {
              var r = t.date;
              return { date: setMonth(r, e) };
            },
            function () {
              return a.handleMonthChange(a.state.date);
            },
          );
        }),
        pe$2(fe$2(a), 'changeMonthYear', function (e) {
          a.setState(
            function (t) {
              var r = t.date;
              return { date: setYear(setMonth(r, getMonth(e)), getYear(e)) };
            },
            function () {
              return a.handleMonthYearChange(a.state.date);
            },
          );
        }),
        pe$2(fe$2(a), 'header', function () {
          var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date,
            n = Te$2(r, a.props.locale),
            o = [];
          return (
            a.props.showWeekNumbers &&
              o.push(
                React__default['default'].createElement(
                  'div',
                  { key: 'W', className: 'react-datepicker__day-name' },
                  a.props.weekLabel || '#',
                ),
              ),
            o.concat(
              [0, 1, 2, 3, 4, 5, 6].map(function (r) {
                var o = addDays(n, r),
                  s = a.formatWeekday(o, a.props.locale),
                  p = a.props.weekDayClassName ? a.props.weekDayClassName(o) : void 0;
                return React__default['default'].createElement(
                  'div',
                  { key: r, className: cx('react-datepicker__day-name', p) },
                  s,
                );
              }),
            )
          );
        }),
        pe$2(fe$2(a), 'formatWeekday', function (e, t) {
          return a.props.formatWeekDay
            ? (function (e, t, r) {
                return t(Pe$2(e, 'EEEE', r));
              })(e, a.props.formatWeekDay, t)
            : a.props.useWeekdaysShort
            ? (function (e, t) {
                return Pe$2(e, 'EEE', t);
              })(e, t)
            : (function (e, t) {
                return Pe$2(e, 'EEEEEE', t);
              })(e, t);
        }),
        pe$2(fe$2(a), 'decreaseYear', function () {
          a.setState(
            function (e) {
              var t = e.date;
              return { date: subYears(t, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
            },
            function () {
              return a.handleYearChange(a.state.date);
            },
          );
        }),
        pe$2(fe$2(a), 'renderPreviousButton', function () {
          if (!a.props.renderCustomHeader) {
            var t;
            switch (!0) {
              case a.props.showMonthYearPicker:
                t = pt(a.state.date, a.props);
                break;
              case a.props.showYearPicker:
                t = (function (e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    r = t.minDate,
                    n = t.yearItemNumber,
                    o = void 0 === n ? 12 : n,
                    a = ft(Ie$2(subYears(e, o)), o).endPeriod,
                    s = r && getYear(r);
                  return (s && s > a) || !1;
                })(a.state.date, a.props);
                break;
              default:
                t = st(a.state.date, a.props);
            }
            if (
              (a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !t) &&
              !a.props.showTimeSelectOnly
            ) {
              var r = ['react-datepicker__navigation', 'react-datepicker__navigation--previous'],
                n = a.decreaseMonth;
              (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) &&
                (n = a.decreaseYear),
                t &&
                  a.props.showDisabledMonthNavigation &&
                  (r.push('react-datepicker__navigation--previous--disabled'), (n = null));
              var o = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker,
                s = a.props,
                i = s.previousMonthAriaLabel,
                p = void 0 === i ? 'Previous Month' : i,
                c = s.previousYearAriaLabel,
                l = void 0 === c ? 'Previous Year' : c;
              return React__default['default'].createElement(
                'button',
                { type: 'button', className: r.join(' '), onClick: n, 'aria-label': o ? l : p },
                o ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel,
              );
            }
          }
        }),
        pe$2(fe$2(a), 'increaseYear', function () {
          a.setState(
            function (e) {
              var t = e.date;
              return { date: addYears(t, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
            },
            function () {
              return a.handleYearChange(a.state.date);
            },
          );
        }),
        pe$2(fe$2(a), 'renderNextButton', function () {
          if (!a.props.renderCustomHeader) {
            var t;
            switch (!0) {
              case a.props.showMonthYearPicker:
                t = ct(a.state.date, a.props);
                break;
              case a.props.showYearPicker:
                t = (function (e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    r = t.maxDate,
                    n = t.yearItemNumber,
                    o = void 0 === n ? 12 : n,
                    a = ft(addYears(e, o), o).startPeriod,
                    s = r && getYear(r);
                  return (s && s < a) || !1;
                })(a.state.date, a.props);
                break;
              default:
                t = it(a.state.date, a.props);
            }
            if (
              (a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !t) &&
              !a.props.showTimeSelectOnly
            ) {
              var r = ['react-datepicker__navigation', 'react-datepicker__navigation--next'];
              a.props.showTimeSelect && r.push('react-datepicker__navigation--next--with-time'),
                a.props.todayButton && r.push('react-datepicker__navigation--next--with-today-button');
              var n = a.increaseMonth;
              (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) &&
                (n = a.increaseYear),
                t &&
                  a.props.showDisabledMonthNavigation &&
                  (r.push('react-datepicker__navigation--next--disabled'), (n = null));
              var o = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker,
                s = a.props,
                i = s.nextMonthAriaLabel,
                p = void 0 === i ? 'Next Month' : i,
                c = s.nextYearAriaLabel,
                d = void 0 === c ? 'Next Year' : c;
              return React__default['default'].createElement(
                'button',
                { type: 'button', className: r.join(' '), onClick: n, 'aria-label': o ? d : p },
                o ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel,
              );
            }
          }
        }),
        pe$2(fe$2(a), 'renderCurrentMonth', function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date,
            r = ['react-datepicker__current-month'];
          return (
            a.props.showYearDropdown && r.push('react-datepicker__current-month--hasYearDropdown'),
            a.props.showMonthDropdown && r.push('react-datepicker__current-month--hasMonthDropdown'),
            a.props.showMonthYearDropdown && r.push('react-datepicker__current-month--hasMonthYearDropdown'),
            React__default['default'].createElement(
              'div',
              { className: r.join(' ') },
              Pe$2(t, a.props.dateFormat, a.props.locale),
            )
          );
        }),
        pe$2(fe$2(a), 'renderYearDropdown', function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (a.props.showYearDropdown && !t)
            return React__default['default'].createElement(Dt, {
              adjustDateOnChange: a.props.adjustDateOnChange,
              date: a.state.date,
              onSelect: a.props.onSelect,
              setOpen: a.props.setOpen,
              dropdownMode: a.props.dropdownMode,
              onChange: a.changeYear,
              minDate: a.props.minDate,
              maxDate: a.props.maxDate,
              year: getYear(a.state.date),
              scrollableYearDropdown: a.props.scrollableYearDropdown,
              yearDropdownItemNumber: a.props.yearDropdownItemNumber,
            });
        }),
        pe$2(fe$2(a), 'renderMonthDropdown', function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (a.props.showMonthDropdown && !t)
            return React__default['default'].createElement(kt, {
              dropdownMode: a.props.dropdownMode,
              locale: a.props.locale,
              onChange: a.changeMonth,
              month: getMonth(a.state.date),
              useShortMonthInDropdown: a.props.useShortMonthInDropdown,
            });
        }),
        pe$2(fe$2(a), 'renderMonthYearDropdown', function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (a.props.showMonthYearDropdown && !t)
            return React__default['default'].createElement(Ct, {
              dropdownMode: a.props.dropdownMode,
              locale: a.props.locale,
              dateFormat: a.props.dateFormat,
              onChange: a.changeMonthYear,
              minDate: a.props.minDate,
              maxDate: a.props.maxDate,
              date: a.state.date,
              scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
            });
        }),
        pe$2(fe$2(a), 'renderTodayButton', function () {
          if (a.props.todayButton && !a.props.showTimeSelectOnly)
            return React__default['default'].createElement(
              'div',
              {
                className: 'react-datepicker__today-button',
                onClick: function (e) {
                  return a.props.onSelect(startOfDay(_e$2()), e);
                },
              },
              a.props.todayButton,
            );
        }),
        pe$2(fe$2(a), 'renderDefaultHeader', function (t) {
          var r = t.monthDate,
            n = t.i;
          return React__default['default'].createElement(
            'div',
            {
              className: 'react-datepicker__header '.concat(
                a.props.showTimeSelect ? 'react-datepicker__header--has-time-select' : '',
              ),
            },
            a.renderCurrentMonth(r),
            React__default['default'].createElement(
              'div',
              {
                className: 'react-datepicker__header__dropdown react-datepicker__header__dropdown--'.concat(
                  a.props.dropdownMode,
                ),
                onFocus: a.handleDropdownFocus,
              },
              a.renderMonthDropdown(0 !== n),
              a.renderMonthYearDropdown(0 !== n),
              a.renderYearDropdown(0 !== n),
            ),
            React__default['default'].createElement('div', { className: 'react-datepicker__day-names' }, a.header(r)),
          );
        }),
        pe$2(fe$2(a), 'renderCustomHeader', function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = t.monthDate,
            n = t.i;
          if ((a.props.showTimeSelect && !a.state.monthContainer) || a.props.showTimeSelectOnly) return null;
          var o = st(a.state.date, a.props),
            s = it(a.state.date, a.props),
            i = pt(a.state.date, a.props),
            p = ct(a.state.date, a.props),
            c = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
          return React__default['default'].createElement(
            'div',
            {
              className: 'react-datepicker__header react-datepicker__header--custom',
              onFocus: a.props.onDropdownFocus,
            },
            a.props.renderCustomHeader(
              de$2(
                de$2({}, a.state),
                {},
                {
                  customHeaderCount: n,
                  changeMonth: a.changeMonth,
                  changeYear: a.changeYear,
                  decreaseMonth: a.decreaseMonth,
                  increaseMonth: a.increaseMonth,
                  decreaseYear: a.decreaseYear,
                  increaseYear: a.increaseYear,
                  prevMonthButtonDisabled: o,
                  nextMonthButtonDisabled: s,
                  prevYearButtonDisabled: i,
                  nextYearButtonDisabled: p,
                },
              ),
            ),
            c &&
              React__default['default'].createElement('div', { className: 'react-datepicker__day-names' }, a.header(r)),
          );
        }),
        pe$2(fe$2(a), 'renderYearHeader', function () {
          var t = a.state.date,
            r = a.props,
            n = r.showYearPicker,
            o = ft(t, r.yearItemNumber),
            s = o.startPeriod,
            i = o.endPeriod;
          return React__default['default'].createElement(
            'div',
            { className: 'react-datepicker__header react-datepicker-year-header' },
            n ? ''.concat(s, ' - ').concat(i) : getYear(t),
          );
        }),
        pe$2(fe$2(a), 'renderHeader', function (e) {
          switch (!0) {
            case void 0 !== a.props.renderCustomHeader:
              return a.renderCustomHeader(e);
            case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
              return a.renderYearHeader(e);
            default:
              return a.renderDefaultHeader(e);
          }
        }),
        pe$2(fe$2(a), 'renderMonths', function () {
          if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
            for (
              var t = [],
                r = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0,
                n = subMonths(a.state.date, r),
                o = 0;
              o < a.props.monthsShown;
              ++o
            ) {
              var s = o - a.props.monthSelectedIn,
                i = addMonths(n, s),
                p = 'month-'.concat(o),
                l = o < a.props.monthsShown - 1,
                d = o > 0;
              t.push(
                React__default['default'].createElement(
                  'div',
                  {
                    key: p,
                    ref: function (e) {
                      a.monthContainer = e;
                    },
                    className: 'react-datepicker__month-container',
                  },
                  a.renderHeader({ monthDate: i, i: o }),
                  React__default['default'].createElement(Pt, {
                    chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                    onChange: a.changeMonthYear,
                    day: i,
                    dayClassName: a.props.dayClassName,
                    monthClassName: a.props.monthClassName,
                    onDayClick: a.handleDayClick,
                    handleOnKeyDown: a.props.handleOnKeyDown,
                    onDayMouseEnter: a.handleDayMouseEnter,
                    onMouseLeave: a.handleMonthMouseLeave,
                    onWeekSelect: a.props.onWeekSelect,
                    orderInDisplay: o,
                    formatWeekNumber: a.props.formatWeekNumber,
                    locale: a.props.locale,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    excludeDates: a.props.excludeDates,
                    highlightDates: a.props.highlightDates,
                    selectingDate: a.state.selectingDate,
                    includeDates: a.props.includeDates,
                    inline: a.props.inline,
                    shouldFocusDayInline: a.props.shouldFocusDayInline,
                    fixedHeight: a.props.fixedHeight,
                    filterDate: a.props.filterDate,
                    preSelection: a.props.preSelection,
                    setPreSelection: a.props.setPreSelection,
                    selected: a.props.selected,
                    selectsStart: a.props.selectsStart,
                    selectsEnd: a.props.selectsEnd,
                    selectsRange: a.props.selectsRange,
                    showWeekNumbers: a.props.showWeekNumbers,
                    startDate: a.props.startDate,
                    endDate: a.props.endDate,
                    peekNextMonth: a.props.peekNextMonth,
                    setOpen: a.props.setOpen,
                    shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                    renderDayContents: a.props.renderDayContents,
                    disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                    showMonthYearPicker: a.props.showMonthYearPicker,
                    showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                    showYearPicker: a.props.showYearPicker,
                    showQuarterYearPicker: a.props.showQuarterYearPicker,
                    isInputFocused: a.props.isInputFocused,
                    containerRef: a.containerRef,
                    monthShowsDuplicateDaysEnd: l,
                    monthShowsDuplicateDaysStart: d,
                  }),
                ),
              );
            }
            return t;
          }
        }),
        pe$2(fe$2(a), 'renderYears', function () {
          if (!a.props.showTimeSelectOnly)
            return a.props.showYearPicker
              ? React__default['default'].createElement(
                  'div',
                  { className: 'react-datepicker__year--container' },
                  a.renderHeader(),
                  React__default['default'].createElement(
                    Nt,
                    ce$2({ onDayClick: a.handleDayClick, date: a.state.date }, a.props),
                  ),
                )
              : void 0;
        }),
        pe$2(fe$2(a), 'renderTimeSection', function () {
          if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly))
            return React__default['default'].createElement(Et, {
              selected: a.props.selected,
              openToDate: a.props.openToDate,
              onChange: a.props.onTimeChange,
              timeClassName: a.props.timeClassName,
              format: a.props.timeFormat,
              includeTimes: a.props.includeTimes,
              intervals: a.props.timeIntervals,
              minTime: a.props.minTime,
              maxTime: a.props.maxTime,
              excludeTimes: a.props.excludeTimes,
              filterTime: a.props.filterTime,
              timeCaption: a.props.timeCaption,
              todayButton: a.props.todayButton,
              showMonthDropdown: a.props.showMonthDropdown,
              showMonthYearDropdown: a.props.showMonthYearDropdown,
              showYearDropdown: a.props.showYearDropdown,
              withPortal: a.props.withPortal,
              monthRef: a.state.monthContainer,
              injectTimes: a.props.injectTimes,
              locale: a.props.locale,
              showTimeSelectOnly: a.props.showTimeSelectOnly,
            });
        }),
        pe$2(fe$2(a), 'renderInputTimeSection', function () {
          var t = new Date(a.props.selected),
            r = Me$2(t) && Boolean(a.props.selected) ? ''.concat(mt(t.getHours()), ':').concat(mt(t.getMinutes())) : '';
          if (a.props.showTimeInput)
            return React__default['default'].createElement(Ot, {
              date: t,
              timeString: r,
              timeInputLabel: a.props.timeInputLabel,
              onChange: a.props.onTimeChange,
              customTimeInput: a.props.customTimeInput,
            });
        }),
        (a.containerRef = React__default['default'].createRef()),
        (a.state = { date: a.getDateInView(), selectingDate: null, monthContainer: null }),
        a
      );
    }
    return (
      ie$2(
        o,
        [
          {
            key: 'componentDidMount',
            value: function () {
              var e = this;
              this.props.showTimeSelect &&
                (this.assignMonthContainer = void e.setState({ monthContainer: e.monthContainer }));
            },
          },
          {
            key: 'componentDidUpdate',
            value: function (e) {
              this.props.preSelection && !We$1(this.props.preSelection, e.preSelection)
                ? this.setState({ date: this.props.preSelection })
                : this.props.openToDate &&
                  !We$1(this.props.openToDate, e.openToDate) &&
                  this.setState({ date: this.props.openToDate });
            },
          },
          {
            key: 'render',
            value: function () {
              var r = this.props.container || xt;
              return React__default['default'].createElement(
                'div',
                { ref: this.containerRef },
                React__default['default'].createElement(
                  r,
                  {
                    className: cx('react-datepicker', this.props.className, {
                      'react-datepicker--time-only': this.props.showTimeSelectOnly,
                    }),
                    showPopperArrow: this.props.showPopperArrow,
                    arrowProps: this.props.arrowProps,
                  },
                  this.renderPreviousButton(),
                  this.renderNextButton(),
                  this.renderMonths(),
                  this.renderYears(),
                  this.renderTodayButton(),
                  this.renderTimeSection(),
                  this.renderInputTimeSection(),
                  this.props.children,
                ),
              );
            },
          },
        ],
        [
          {
            key: 'defaultProps',
            get: function () {
              return {
                onDropdownFocus: function () {},
                monthsShown: 1,
                monthSelectedIn: 0,
                forceShowMonthNavigation: !1,
                timeCaption: 'Time',
                previousYearButtonLabel: 'Previous Year',
                nextYearButtonLabel: 'Next Year',
                previousMonthButtonLabel: 'Previous Month',
                nextMonthButtonLabel: 'Next Month',
                customTimeInput: null,
                yearItemNumber: 12,
              };
            },
          },
        ],
      ),
      o
    );
  })(),
  It = function (e) {
    return !e.disabled && -1 !== e.tabIndex;
  },
  Lt = (function (t) {
    ue$1(n, React__default['default'].Component);
    var r = ve$2(n);
    function n(t) {
      var o;
      return (
        ae$2(this, n),
        pe$2(fe$2((o = r.call(this, t))), 'getTabChildren', function () {
          return Array.prototype.slice
            .call(o.tabLoopRef.current.querySelectorAll('[tabindex], a, button, input, select, textarea'), 1, -1)
            .filter(It);
        }),
        pe$2(fe$2(o), 'handleFocusStart', function (e) {
          var t = o.getTabChildren();
          t && t.length > 1 && t[t.length - 1].focus();
        }),
        pe$2(fe$2(o), 'handleFocusEnd', function (e) {
          var t = o.getTabChildren();
          t && t.length > 1 && t[0].focus();
        }),
        (o.tabLoopRef = React__default['default'].createRef()),
        o
      );
    }
    return (
      ie$2(
        n,
        [
          {
            key: 'render',
            value: function () {
              return this.props.enableTabLoop
                ? React__default['default'].createElement(
                    'div',
                    { className: 'react-datepicker__tab-loop', ref: this.tabLoopRef },
                    React__default['default'].createElement('div', {
                      className: 'react-datepicker__tab-loop__start',
                      tabIndex: '0',
                      onFocus: this.handleFocusStart,
                    }),
                    this.props.children,
                    React__default['default'].createElement('div', {
                      className: 'react-datepicker__tab-loop__end',
                      tabIndex: '0',
                      onFocus: this.handleFocusEnd,
                    }),
                  )
                : this.props.children;
            },
          },
        ],
        [
          {
            key: 'defaultProps',
            get: function () {
              return { enableTabLoop: !0 };
            },
          },
        ],
      ),
      n
    );
  })(),
  Ft = (function (t) {
    ue$1(n, React__default['default'].Component);
    var r = ve$2(n);
    function n(e) {
      var t;
      return ae$2(this, n), ((t = r.call(this, e)).el = document.createElement('div')), t;
    }
    return (
      ie$2(n, [
        {
          key: 'componentDidMount',
          value: function () {
            (this.portalRoot = document.getElementById(this.props.portalId)),
              this.portalRoot ||
                ((this.portalRoot = document.createElement('div')),
                this.portalRoot.setAttribute('id', this.props.portalId),
                document.body.appendChild(this.portalRoot)),
              this.portalRoot.appendChild(this.el);
          },
        },
        {
          key: 'componentWillUnmount',
          value: function () {
            this.portalRoot.removeChild(this.el);
          },
        },
        {
          key: 'render',
          value: function () {
            return ReactDOM__default['default'].createPortal(this.props.children, this.el);
          },
        },
      ]),
      n
    );
  })(),
  Rt = (function (r) {
    ue$1(o, React__default['default'].Component);
    var n = ve$2(o);
    function o() {
      return ae$2(this, o), n.apply(this, arguments);
    }
    return (
      ie$2(
        o,
        [
          {
            key: 'render',
            value: function () {
              var r,
                n = this.props,
                o = n.className,
                a = n.wrapperClassName,
                s = n.hidePopper,
                i = n.popperComponent,
                p = n.popperModifiers,
                c = n.popperPlacement,
                l = n.popperProps,
                d = n.targetComponent,
                u = n.enableTabLoop,
                h = n.popperOnKeyDown,
                m = n.portalId;
              if (!s) {
                var f = cx('react-datepicker-popper', o);
                r = React__default['default'].createElement(
                  Popper,
                  ce$2({ modifiers: p, placement: c }, l),
                  function (t) {
                    var r = t.ref,
                      n = t.style,
                      o = t.placement,
                      a = t.arrowProps;
                    return React__default['default'].createElement(
                      Lt,
                      { enableTabLoop: u },
                      React__default['default'].createElement(
                        'div',
                        { ref: r, style: n, className: f, 'data-placement': o, onKeyDown: h },
                        React__default['default'].cloneElement(i, { arrowProps: a }),
                      ),
                    );
                  },
                );
              }
              this.props.popperContainer &&
                (r = React__default['default'].createElement(this.props.popperContainer, {}, r)),
                m && !s && (r = React__default['default'].createElement(Ft, { portalId: m }, r));
              var y = cx('react-datepicker-wrapper', a);
              return React__default['default'].createElement(
                Manager,
                { className: 'react-datepicker-manager' },
                React__default['default'].createElement(Reference, null, function (t) {
                  var r = t.ref;
                  return React__default['default'].createElement('div', { ref: r, className: y }, d);
                }),
                r,
              );
            },
          },
        ],
        [
          {
            key: 'defaultProps',
            get: function () {
              return {
                hidePopper: !0,
                popperModifiers: {
                  preventOverflow: { enabled: !0, escapeWithReference: !0, boundariesElement: 'viewport' },
                },
                popperProps: {},
                popperPlacement: 'bottom-start',
              };
            },
          },
        ],
      ),
      o
    );
  })(),
  At = onClickOutsideHOC(Yt);
var Wt = (function (n) {
    ue$1(a, React__default['default'].Component);
    var o = ve$2(a);
    function a(n) {
      var s;
      return (
        ae$2(this, a),
        pe$2(fe$2((s = o.call(this, n))), 'getPreSelection', function () {
          return s.props.openToDate
            ? s.props.openToDate
            : s.props.selectsEnd && s.props.startDate
            ? s.props.startDate
            : s.props.selectsStart && s.props.endDate
            ? s.props.endDate
            : _e$2();
        }),
        pe$2(fe$2(s), 'calcInitialState', function () {
          var e = s.getPreSelection(),
            t = lt(s.props),
            r = dt(s.props),
            n = t && isBefore(e, startOfDay(t)) ? t : r && isAfter(e, endOfDay(r)) ? r : e;
          return {
            open: s.props.startOpen || !1,
            preventFocus: !1,
            preSelection: s.props.selected ? s.props.selected : n,
            highlightDates: ut(s.props.highlightDates),
            focused: !1,
            shouldFocusDayInline: !1,
          };
        }),
        pe$2(fe$2(s), 'clearPreventFocusTimeout', function () {
          s.preventFocusTimeout && clearTimeout(s.preventFocusTimeout);
        }),
        pe$2(fe$2(s), 'setFocus', function () {
          s.input && s.input.focus && s.input.focus({ preventScroll: !0 });
        }),
        pe$2(fe$2(s), 'setBlur', function () {
          s.input && s.input.blur && s.input.blur(), s.cancelFocusInput();
        }),
        pe$2(fe$2(s), 'setOpen', function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          s.setState(
            {
              open: e,
              preSelection: e && s.state.open ? s.state.preSelection : s.calcInitialState().preSelection,
              lastPreSelectChange: jt,
            },
            function () {
              e ||
                s.setState(
                  function (e) {
                    return { focused: !!t && e.focused };
                  },
                  function () {
                    !t && s.setBlur(), s.setState({ inputValue: null });
                  },
                );
            },
          );
        }),
        pe$2(fe$2(s), 'inputOk', function () {
          return isDate$1(s.state.preSelection);
        }),
        pe$2(fe$2(s), 'isCalendarOpen', function () {
          return void 0 === s.props.open ? s.state.open && !s.props.disabled && !s.props.readOnly : s.props.open;
        }),
        pe$2(fe$2(s), 'handleFocus', function (e) {
          s.state.preventFocus || (s.props.onFocus(e), s.props.preventOpenOnFocus || s.props.readOnly || s.setOpen(!0)),
            s.setState({ focused: !0 });
        }),
        pe$2(fe$2(s), 'cancelFocusInput', function () {
          clearTimeout(s.inputFocusTimeout), (s.inputFocusTimeout = null);
        }),
        pe$2(fe$2(s), 'deferFocusInput', function () {
          s.cancelFocusInput(),
            (s.inputFocusTimeout = setTimeout(function () {
              return s.setFocus();
            }, 1));
        }),
        pe$2(fe$2(s), 'handleDropdownFocus', function () {
          s.cancelFocusInput();
        }),
        pe$2(fe$2(s), 'handleBlur', function (e) {
          (!s.state.open || s.props.withPortal || s.props.showTimeInput) && s.props.onBlur(e),
            s.setState({ focused: !1 });
        }),
        pe$2(fe$2(s), 'handleCalendarClickOutside', function (e) {
          s.props.inline || s.setOpen(!1), s.props.onClickOutside(e), s.props.withPortal && e.preventDefault();
        }),
        pe$2(fe$2(s), 'handleChange', function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          var n = t[0];
          if (
            !s.props.onChangeRaw ||
            (s.props.onChangeRaw.apply(fe$2(s), t),
            'function' == typeof n.isDefaultPrevented && !n.isDefaultPrevented())
          ) {
            s.setState({ inputValue: n.target.value, lastPreSelectChange: Bt });
            var o = Se$2(n.target.value, s.props.dateFormat, s.props.locale, s.props.strictParsing);
            (!o && n.target.value) || s.setSelected(o, n, !0);
          }
        }),
        pe$2(fe$2(s), 'handleSelect', function (e, t, r) {
          s.setState({ preventFocus: !0 }, function () {
            return (
              (s.preventFocusTimeout = setTimeout(function () {
                return s.setState({ preventFocus: !1 });
              }, 50)),
              s.preventFocusTimeout
            );
          }),
            s.props.onChangeRaw && s.props.onChangeRaw(t),
            s.setSelected(e, t, !1, r),
            !s.props.shouldCloseOnSelect || s.props.showTimeSelect
              ? s.setPreSelection(e)
              : s.props.inline || s.setOpen(!1);
        }),
        pe$2(fe$2(s), 'setSelected', function (e, t, r, n) {
          var o = e;
          if (null === o || !ze$2(o, s.props)) {
            var a = s.props,
              i = a.onChange,
              p = a.selectsRange,
              c = a.startDate,
              l = a.endDate;
            if (!Be$2(s.props.selected, o) || s.props.allowSameDay || p)
              if (
                (null !== o &&
                  (!s.props.selected ||
                    (r && (s.props.showTimeSelect || s.props.showTimeSelectOnly || s.props.showTimeInput)) ||
                    (o = Ee$2(o, {
                      hour: getHours(s.props.selected),
                      minute: getMinutes(s.props.selected),
                      second: getSeconds(s.props.selected),
                    })),
                  s.props.inline || s.setState({ preSelection: o }),
                  s.props.focusSelectedMonth || s.setState({ monthSelectedIn: n })),
                p)
              ) {
                var d = c && !l,
                  u = c && l;
                !c && !l ? i([o, null], t) : d && (isBefore(o, c) ? i([o, null], t) : i([c, o], t)),
                  u && i([o, null], t);
              } else i(o, t);
            r || (s.props.onSelect(o, t), s.setState({ inputValue: null }));
          }
        }),
        pe$2(fe$2(s), 'setPreSelection', function (e) {
          var t = void 0 !== s.props.minDate,
            r = void 0 !== s.props.maxDate,
            n = !0;
          if (e) {
            var o = startOfDay(e);
            if (t && r) n = je$2(e, s.props.minDate, s.props.maxDate);
            else if (t) {
              var a = startOfDay(s.props.minDate);
              n = isAfter(e, a) || Be$2(o, a);
            } else if (r) {
              var i = endOfDay(s.props.maxDate);
              n = isBefore(e, i) || Be$2(o, i);
            }
          }
          n && s.setState({ preSelection: e });
        }),
        pe$2(fe$2(s), 'handleTimeChange', function (e) {
          var t = Ee$2(s.props.selected ? s.props.selected : s.getPreSelection(), {
            hour: getHours(e),
            minute: getMinutes(e),
          });
          s.setState({ preSelection: t }),
            s.props.onChange(t),
            s.props.shouldCloseOnSelect && s.setOpen(!1),
            s.props.showTimeInput && s.setOpen(!0),
            s.setState({ inputValue: null });
        }),
        pe$2(fe$2(s), 'onInputClick', function () {
          s.props.disabled || s.props.readOnly || s.setOpen(!0), s.props.onInputClick();
        }),
        pe$2(fe$2(s), 'onInputKeyDown', function (e) {
          s.props.onKeyDown(e);
          var t = e.key;
          if (s.state.open || s.props.inline || s.props.preventOpenOnFocus) {
            if (s.state.open) {
              if ('ArrowDown' === t || 'ArrowUp' === t) {
                e.preventDefault();
                var r =
                  s.calendar.componentNode &&
                  s.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
                return void (r && r.focus({ preventScroll: !0 }));
              }
              var n = _e$2(s.state.preSelection);
              'Enter' === t
                ? (e.preventDefault(),
                  s.inputOk() && s.state.lastPreSelectChange === jt
                    ? (s.handleSelect(n, e), !s.props.shouldCloseOnSelect && s.setPreSelection(n))
                    : s.setOpen(!1))
                : 'Escape' === t && (e.preventDefault(), s.setOpen(!1)),
                s.inputOk() || s.props.onInputError({ code: 1, msg: 'Date input not valid.' });
            }
          } else ('ArrowDown' !== t && 'ArrowUp' !== t && 'Enter' !== t) || s.onInputClick();
        }),
        pe$2(fe$2(s), 'onDayKeyDown', function (e) {
          s.props.onKeyDown(e);
          var t = e.key,
            r = _e$2(s.state.preSelection);
          if ('Enter' === t)
            e.preventDefault(), s.handleSelect(r, e), !s.props.shouldCloseOnSelect && s.setPreSelection(r);
          else if ('Escape' === t)
            e.preventDefault(),
              s.setOpen(!1),
              s.inputOk() || s.props.onInputError({ code: 1, msg: 'Date input not valid.' });
          else if (!s.props.disabledKeyboardNavigation) {
            var n;
            switch (t) {
              case 'ArrowLeft':
                n = subDays(r, 1);
                break;
              case 'ArrowRight':
                n = addDays(r, 1);
                break;
              case 'ArrowUp':
                n = subWeeks(r, 1);
                break;
              case 'ArrowDown':
                n = addWeeks(r, 1);
                break;
              case 'PageUp':
                n = subMonths(r, 1);
                break;
              case 'PageDown':
                n = addMonths(r, 1);
                break;
              case 'Home':
                n = subYears(r, 1);
                break;
              case 'End':
                n = addYears(r, 1);
            }
            if (!n)
              return void (s.props.onInputError && s.props.onInputError({ code: 1, msg: 'Date input not valid.' }));
            if (
              (e.preventDefault(),
              s.setState({ lastPreSelectChange: jt }),
              s.props.adjustDateOnChange && s.setSelected(n),
              s.setPreSelection(n),
              s.props.inline)
            ) {
              var o = getMonth(r),
                a = getMonth(n),
                f = getYear(r),
                y = getYear(n);
              o !== a || f !== y ? s.setState({ shouldFocusDayInline: !0 }) : s.setState({ shouldFocusDayInline: !1 });
            }
          }
        }),
        pe$2(fe$2(s), 'onPopperKeyDown', function (e) {
          'Escape' === e.key &&
            (e.preventDefault(),
            s.setState({ preventFocus: !0 }, function () {
              s.setOpen(!1),
                setTimeout(function () {
                  s.setFocus(), s.setState({ preventFocus: !1 });
                });
            }));
        }),
        pe$2(fe$2(s), 'onClearClick', function (e) {
          e && e.preventDefault && e.preventDefault(), s.props.onChange(null, e), s.setState({ inputValue: null });
        }),
        pe$2(fe$2(s), 'clear', function () {
          s.onClearClick();
        }),
        pe$2(fe$2(s), 'onScroll', function (e) {
          'boolean' == typeof s.props.closeOnScroll && s.props.closeOnScroll
            ? (e.target !== document && e.target !== document.documentElement && e.target !== document.body) ||
              s.setOpen(!1)
            : 'function' == typeof s.props.closeOnScroll && s.props.closeOnScroll(e) && s.setOpen(!1);
        }),
        pe$2(fe$2(s), 'renderCalendar', function () {
          return s.props.inline || s.isCalendarOpen()
            ? React__default['default'].createElement(
                At,
                {
                  ref: function (e) {
                    s.calendar = e;
                  },
                  locale: s.props.locale,
                  chooseDayAriaLabelPrefix: s.props.chooseDayAriaLabelPrefix,
                  disabledDayAriaLabelPrefix: s.props.disabledDayAriaLabelPrefix,
                  weekAriaLabelPrefix: s.props.weekAriaLabelPrefix,
                  adjustDateOnChange: s.props.adjustDateOnChange,
                  setOpen: s.setOpen,
                  shouldCloseOnSelect: s.props.shouldCloseOnSelect,
                  dateFormat: s.props.dateFormatCalendar,
                  useWeekdaysShort: s.props.useWeekdaysShort,
                  formatWeekDay: s.props.formatWeekDay,
                  dropdownMode: s.props.dropdownMode,
                  selected: s.props.selected,
                  preSelection: s.state.preSelection,
                  onSelect: s.handleSelect,
                  onWeekSelect: s.props.onWeekSelect,
                  openToDate: s.props.openToDate,
                  minDate: s.props.minDate,
                  maxDate: s.props.maxDate,
                  selectsStart: s.props.selectsStart,
                  selectsEnd: s.props.selectsEnd,
                  selectsRange: s.props.selectsRange,
                  startDate: s.props.startDate,
                  endDate: s.props.endDate,
                  excludeDates: s.props.excludeDates,
                  filterDate: s.props.filterDate,
                  onClickOutside: s.handleCalendarClickOutside,
                  formatWeekNumber: s.props.formatWeekNumber,
                  highlightDates: s.state.highlightDates,
                  includeDates: s.props.includeDates,
                  includeTimes: s.props.includeTimes,
                  injectTimes: s.props.injectTimes,
                  inline: s.props.inline,
                  shouldFocusDayInline: s.state.shouldFocusDayInline,
                  peekNextMonth: s.props.peekNextMonth,
                  showMonthDropdown: s.props.showMonthDropdown,
                  showPreviousMonths: s.props.showPreviousMonths,
                  useShortMonthInDropdown: s.props.useShortMonthInDropdown,
                  showMonthYearDropdown: s.props.showMonthYearDropdown,
                  showWeekNumbers: s.props.showWeekNumbers,
                  showYearDropdown: s.props.showYearDropdown,
                  withPortal: s.props.withPortal,
                  forceShowMonthNavigation: s.props.forceShowMonthNavigation,
                  showDisabledMonthNavigation: s.props.showDisabledMonthNavigation,
                  scrollableYearDropdown: s.props.scrollableYearDropdown,
                  scrollableMonthYearDropdown: s.props.scrollableMonthYearDropdown,
                  todayButton: s.props.todayButton,
                  weekLabel: s.props.weekLabel,
                  outsideClickIgnoreClass: 'react-datepicker-ignore-onclickoutside',
                  fixedHeight: s.props.fixedHeight,
                  monthsShown: s.props.monthsShown,
                  monthSelectedIn: s.state.monthSelectedIn,
                  onDropdownFocus: s.handleDropdownFocus,
                  onMonthChange: s.props.onMonthChange,
                  onYearChange: s.props.onYearChange,
                  dayClassName: s.props.dayClassName,
                  weekDayClassName: s.props.weekDayClassName,
                  monthClassName: s.props.monthClassName,
                  timeClassName: s.props.timeClassName,
                  showTimeSelect: s.props.showTimeSelect,
                  showTimeSelectOnly: s.props.showTimeSelectOnly,
                  onTimeChange: s.handleTimeChange,
                  timeFormat: s.props.timeFormat,
                  timeIntervals: s.props.timeIntervals,
                  minTime: s.props.minTime,
                  maxTime: s.props.maxTime,
                  excludeTimes: s.props.excludeTimes,
                  filterTime: s.props.filterTime,
                  timeCaption: s.props.timeCaption,
                  className: s.props.calendarClassName,
                  container: s.props.calendarContainer,
                  yearItemNumber: s.props.yearItemNumber,
                  yearDropdownItemNumber: s.props.yearDropdownItemNumber,
                  previousMonthButtonLabel: s.props.previousMonthButtonLabel,
                  nextMonthButtonLabel: s.props.nextMonthButtonLabel,
                  previousYearButtonLabel: s.props.previousYearButtonLabel,
                  nextYearButtonLabel: s.props.nextYearButtonLabel,
                  timeInputLabel: s.props.timeInputLabel,
                  disabledKeyboardNavigation: s.props.disabledKeyboardNavigation,
                  renderCustomHeader: s.props.renderCustomHeader,
                  popperProps: s.props.popperProps,
                  renderDayContents: s.props.renderDayContents,
                  onDayMouseEnter: s.props.onDayMouseEnter,
                  onMonthMouseLeave: s.props.onMonthMouseLeave,
                  showTimeInput: s.props.showTimeInput,
                  showMonthYearPicker: s.props.showMonthYearPicker,
                  showFullMonthYearPicker: s.props.showFullMonthYearPicker,
                  showTwoColumnMonthYearPicker: s.props.showTwoColumnMonthYearPicker,
                  showFourColumnMonthYearPicker: s.props.showFourColumnMonthYearPicker,
                  showYearPicker: s.props.showYearPicker,
                  showQuarterYearPicker: s.props.showQuarterYearPicker,
                  showPopperArrow: s.props.showPopperArrow,
                  excludeScrollbar: s.props.excludeScrollbar,
                  handleOnKeyDown: s.onDayKeyDown,
                  isInputFocused: s.state.focused,
                  customTimeInput: s.props.customTimeInput,
                  setPreSelection: s.setPreSelection,
                },
                s.props.children,
              )
            : null;
        }),
        pe$2(fe$2(s), 'renderDateInput', function () {
          var r,
            n,
            o,
            a,
            i,
            p = cx(s.props.className, pe$2({}, 'react-datepicker-ignore-onclickoutside', s.state.open)),
            c = s.props.customInput || React__default['default'].createElement('input', { type: 'text' }),
            l = s.props.customInputRef || 'ref',
            d =
              'string' == typeof s.props.value
                ? s.props.value
                : 'string' == typeof s.state.inputValue
                ? s.state.inputValue
                : ((n = s.props.selected),
                  (o = s.props),
                  (a = o.dateFormat),
                  (i = o.locale),
                  (n && Pe$2(n, Array.isArray(a) ? a[0] : a, i)) || '');
          return React__default['default'].cloneElement(
            c,
            (pe$2((r = {}), l, function (e) {
              s.input = e;
            }),
            pe$2(r, 'value', d),
            pe$2(r, 'onBlur', s.handleBlur),
            pe$2(r, 'onChange', s.handleChange),
            pe$2(r, 'onClick', s.onInputClick),
            pe$2(r, 'onFocus', s.handleFocus),
            pe$2(r, 'onKeyDown', s.onInputKeyDown),
            pe$2(r, 'id', s.props.id),
            pe$2(r, 'name', s.props.name),
            pe$2(r, 'autoFocus', s.props.autoFocus),
            pe$2(r, 'placeholder', s.props.placeholderText),
            pe$2(r, 'disabled', s.props.disabled),
            pe$2(r, 'autoComplete', s.props.autoComplete),
            pe$2(r, 'className', cx(c.props.className, p)),
            pe$2(r, 'title', s.props.title),
            pe$2(r, 'readOnly', s.props.readOnly),
            pe$2(r, 'required', s.props.required),
            pe$2(r, 'tabIndex', s.props.tabIndex),
            pe$2(r, 'aria-describedby', s.props.ariaDescribedBy),
            pe$2(r, 'aria-invalid', s.props.ariaInvalid),
            pe$2(r, 'aria-labelledby', s.props.ariaLabelledBy),
            pe$2(r, 'aria-required', s.props.ariaRequired),
            r),
          );
        }),
        pe$2(fe$2(s), 'renderClearButton', function () {
          var t = s.props,
            r = t.isClearable,
            n = t.selected,
            o = t.clearButtonTitle,
            a = t.clearButtonClassName,
            i = t.ariaLabelClose,
            p = void 0 === i ? 'Close' : i;
          return r && null != n
            ? React__default['default'].createElement('button', {
                type: 'button',
                className: 'react-datepicker__close-icon '.concat(a),
                'aria-label': p,
                onClick: s.onClearClick,
                title: o,
                tabIndex: -1,
              })
            : null;
        }),
        (s.state = s.calcInitialState()),
        s
      );
    }
    return (
      ie$2(
        a,
        [
          {
            key: 'componentDidMount',
            value: function () {
              window.addEventListener('scroll', this.onScroll, !0);
            },
          },
          {
            key: 'componentDidUpdate',
            value: function (e, t) {
              var r, n;
              e.inline &&
                ((r = e.selected),
                (n = this.props.selected),
                r && n ? getMonth(r) !== getMonth(n) || getYear(r) !== getYear(n) : r !== n) &&
                this.setPreSelection(this.props.selected),
                void 0 !== this.state.monthSelectedIn &&
                  e.monthsShown !== this.props.monthsShown &&
                  this.setState({ monthSelectedIn: 0 }),
                e.highlightDates !== this.props.highlightDates &&
                  this.setState({ highlightDates: ut(this.props.highlightDates) }),
                t.focused || Be$2(e.selected, this.props.selected) || this.setState({ inputValue: null }),
                t.open !== this.state.open &&
                  (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(),
                  !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
            },
          },
          {
            key: 'componentWillUnmount',
            value: function () {
              this.clearPreventFocusTimeout(), window.removeEventListener('scroll', this.onScroll, !0);
            },
          },
          {
            key: 'render',
            value: function () {
              var t = this.renderCalendar();
              return this.props.inline && !this.props.withPortal
                ? t
                : this.props.withPortal
                ? React__default['default'].createElement(
                    'div',
                    null,
                    this.props.inline
                      ? null
                      : React__default['default'].createElement(
                          'div',
                          { className: 'react-datepicker__input-container' },
                          this.renderDateInput(),
                          this.renderClearButton(),
                        ),
                    this.state.open || this.props.inline
                      ? React__default['default'].createElement('div', { className: 'react-datepicker__portal' }, t)
                      : null,
                  )
                : React__default['default'].createElement(Rt, {
                    className: this.props.popperClassName,
                    wrapperClassName: this.props.wrapperClassName,
                    hidePopper: !this.isCalendarOpen(),
                    portalId: this.props.portalId,
                    popperModifiers: this.props.popperModifiers,
                    targetComponent: React__default['default'].createElement(
                      'div',
                      { className: 'react-datepicker__input-container' },
                      this.renderDateInput(),
                      this.renderClearButton(),
                    ),
                    popperContainer: this.props.popperContainer,
                    popperComponent: t,
                    popperPlacement: this.props.popperPlacement,
                    popperProps: this.props.popperProps,
                    popperOnKeyDown: this.onPopperKeyDown,
                    enableTabLoop: this.props.enableTabLoop,
                  });
            },
          },
        ],
        [
          {
            key: 'defaultProps',
            get: function () {
              return {
                allowSameDay: !1,
                dateFormat: 'MM/dd/yyyy',
                dateFormatCalendar: 'LLLL yyyy',
                onChange: function () {},
                disabled: !1,
                disabledKeyboardNavigation: !1,
                dropdownMode: 'scroll',
                onFocus: function () {},
                onBlur: function () {},
                onKeyDown: function () {},
                onInputClick: function () {},
                onSelect: function () {},
                onClickOutside: function () {},
                onMonthChange: function () {},
                onCalendarOpen: function () {},
                onCalendarClose: function () {},
                preventOpenOnFocus: !1,
                onYearChange: function () {},
                onInputError: function () {},
                monthsShown: 1,
                readOnly: !1,
                withPortal: !1,
                shouldCloseOnSelect: !0,
                showTimeSelect: !1,
                showTimeInput: !1,
                showPreviousMonths: !1,
                showMonthYearPicker: !1,
                showFullMonthYearPicker: !1,
                showTwoColumnMonthYearPicker: !1,
                showFourColumnMonthYearPicker: !1,
                showYearPicker: !1,
                showQuarterYearPicker: !1,
                strictParsing: !1,
                timeIntervals: 30,
                timeCaption: 'Time',
                previousMonthButtonLabel: 'Previous Month',
                nextMonthButtonLabel: 'Next Month',
                previousYearButtonLabel: 'Previous Year',
                nextYearButtonLabel: 'Next Year',
                timeInputLabel: 'Time',
                enableTabLoop: !0,
                yearItemNumber: 12,
                renderDayContents: function (e) {
                  return e;
                },
                focusSelectedMonth: !1,
                showPopperArrow: !0,
                excludeScrollbar: !0,
                customTimeInput: null,
              };
            },
          },
        ],
      ),
      a
    );
  })(),
  Bt = 'input',
  jt = 'navigate';

var style$k = {
  DatePicker: 'htco-DatePicker',
  DatePickerInput: 'htco-DatePickerInput',
  DatePickerCalendar: 'htco-DatePickerCalendar',
  DatePickerHelperText: 'htco-DatePickerHelperText',
  isWarning: 'htco-isWarning',
  isError: 'htco-isError',
  hasWarning: 'htco-hasWarning',
  hasError: 'htco-hasError',
  DatePickerOutlined: 'htco-DatePickerOutlined',
  hasValue: 'htco-hasValue',
  hasIcon: 'htco-hasIcon',
  hasErrorIcon: 'htco-hasErrorIcon',
  hasWarningIcon: 'htco-hasWarningIcon',
  DatePickerInputOutlined: 'htco-DatePickerInputOutlined',
  DatePickerLabelOutlined: 'htco-DatePickerLabelOutlined',
};

var DatePicker = function (_a) {
  var _b, _c, _d;
  var value = _a.value,
    className = _a.className,
    calendarClassName = _a.calendarClassName,
    inputClassName = _a.inputClassName,
    onChange = _a.onChange,
    error = _a.error,
    label = _a.label,
    name = _a.name,
    _e = _a.required,
    required = _e === void 0 ? false : _e,
    registerRequiredField = _a.registerRequiredField,
    unregisterRequiredField = _a.unregisterRequiredField,
    _f = _a.maxDate,
    maxDate = _f === void 0 ? addYears(new Date(), 1000) : _f,
    _g = _a.minDate,
    minDate = _g === void 0 ? subYears(new Date(), 1000) : _g,
    _h = _a.displayFormat,
    displayFormat = _h === void 0 ? 'MM/dd/yyyy' : _h,
    _j = _a.valueFormat,
    valueFormat = _j === void 0 ? 'yyyy-MM-dd' : _j,
    _k = _a.theme,
    theme = _k === void 0 ? '' : _k,
    _l = _a.helperText,
    helperText = _l === void 0 ? '' : _l,
    _m = _a.warning,
    warning = _m === void 0 ? '' : _m,
    _o = _a.showWarningIcon,
    showWarningIcon = _o === void 0 ? false : _o,
    _p = _a.showErrorIcon,
    showErrorIcon = _p === void 0 ? false : _p,
    props = __rest$1(_a, [
      'value',
      'className',
      'calendarClassName',
      'inputClassName',
      'onChange',
      'error',
      'label',
      'name',
      'required',
      'registerRequiredField',
      'unregisterRequiredField',
      'maxDate',
      'minDate',
      'displayFormat',
      'valueFormat',
      'theme',
      'helperText',
      'warning',
      'showWarningIcon',
      'showErrorIcon',
    ]);
  useRequiredValidation({
    name: name,
    required: required,
    registerRequiredField: registerRequiredField,
    unregisterRequiredField: unregisterRequiredField,
  });
  var _q = React.useState(value),
    lastValidDate = _q[0],
    setLastValidDate = _q[1];
  // when we need to control date value like clearing or changing the date
  React.useEffect(
    function () {
      handleChange(value);
    },
    [value],
  );
  var parseDate = function (date) {
    return parse(date, valueFormat, new Date());
  };
  var treatInputValue = function (input) {
    // oh no, is that a regular expression???
    var notANumber = new RegExp(/[^0-9]/g);
    if (notANumber.test(input)) {
      return parse(input, valueFormat, new Date());
    }
    var displayFormatWithoutSeparators = displayFormat.replace(/[^a-zA-Z]/g, '');
    return parse(input, displayFormatWithoutSeparators, new Date());
  };
  var handleChange = function (value) {
    var date = !!value && value instanceof Date ? value : parseDate(value);
    if (date && isValid(date)) {
      var formattedDate = format(date, valueFormat);
      setLastValidDate(date);
      onChange(formattedDate, name);
    }
    // to be able to clean the date
    if (value === null || value === undefined || value === '') {
      setLastValidDate(value);
      onChange(value, name);
    }
    return lastValidDate;
  };
  var parsedSelectedValue = !!value && isValid(parseDate(value)) ? parseDate(value) : lastValidDate;
  var themeName = theme && theme.charAt(0).toUpperCase() + theme.slice(1);
  var canShowErrorIcon = showErrorIcon && theme === 'outlined';
  var canShowWarningIcon = showWarningIcon && theme === 'outlined';
  return jsxRuntime.jsxs('div', {
    className: cx(
      style$k.DatePicker,
      className,
      ((_b = {}),
      (_b[style$k['DatePicker'.concat(themeName)]] = themeName),
      (_b[style$k.hasValue] = lastValidDate),
      (_b[style$k.hasWarning] = warning),
      (_b[style$k.hasWarningIcon] = canShowWarningIcon),
      (_b[style$k.hasError] = error),
      (_b[style$k.hasIcon] = canShowErrorIcon || canShowWarningIcon),
      _b),
    ),
    children: [
      jsxRuntime.jsx(Label$1, {
        error: !theme && error,
        className: cx(((_c = {}), (_c[style$k['DatePickerLabel'.concat(themeName)]] = themeName), _c)),
        children: label,
      }),
      jsxRuntime.jsx(
        Wt,
        __assign(
          {
            className: cx(
              style$k.DatePickerInput,
              inputClassName,
              ((_d = {}),
              (_d[style$k.hasWarning] = !!warning),
              (_d[style$k.hasError] = !!error),
              (_d[style$k['DatePickerInput'.concat(themeName)]] = themeName),
              _d),
            ),
            calendarClassName: cx(style$k.DatePickerCalendar, calendarClassName),
            selected: parsedSelectedValue,
            maxDate: maxDate,
            minDate: minDate,
            onChangeRaw: function (evt) {
              var parsedDate = treatInputValue(evt.target.value);
              if (isValid(parsedDate)) {
                var formattedDate = format(parsedDate, valueFormat);
                onChange(formattedDate, name);
              }
            },
            onChange: handleChange,
            dateFormat: displayFormat,
          },
          props,
        ),
      ),
      error &&
        themeName &&
        jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            jsxRuntime.jsx('p', { className: cx(style$k.DatePickerHelperText, style$k.isError), children: error }),
            canShowErrorIcon &&
              jsxRuntime.jsx(Icon, { name: 'icon-error', className: cx(style$k.hasIcon, style$k.hasErrorIcon) }),
          ],
        }),
      warning &&
        !error &&
        themeName &&
        jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            jsxRuntime.jsx('p', { className: cx(style$k.DatePickerHelperText, style$k.isWarning), children: warning }),
            canShowWarningIcon &&
              jsxRuntime.jsx(Icon, { name: 'icon-alert', className: cx(style$k.hasIcon, style$k.hasWarningIcon) }),
          ],
        }),
      helperText &&
        !error &&
        !warning &&
        themeName &&
        jsxRuntime.jsx('p', { className: style$k.DatePickerHelperText, children: helperText }),
    ],
  });
};
DatePicker.propTypes = {
  value: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].instanceOf(Date),
  ]),
  name: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  calendarClassName: PropTypes__default['default'].string,
  required: PropTypes__default['default'].bool,
  displayFormat: PropTypes__default['default'].string,
  valueFormat: PropTypes__default['default'].string,
  label: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].node,
  ]),
  error: PropTypes__default['default'].string,
  helperText: PropTypes__default['default'].string,
  maxDate: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].instanceOf(Date),
  ]),
  minDate: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].instanceOf(Date),
  ]),
  onChange: PropTypes__default['default'].func.isRequired,
  theme: PropTypes__default['default'].oneOf(['default', 'outlined']),
  width: PropTypes__default['default'].string,
  warning: PropTypes__default['default'].string,
  showWarningIcon: PropTypes__default['default'].bool,
};

var img$a =
  "data:image/svg+xml,%3csvg width='23' height='22' viewBox='0 0 23 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_4398_4164)'%3e%3cpath d='M22.9711 8.34046H14.1993L11.4898 0L8.77188 8.34046L0 8.332L7.10387 13.4919L4.38594 21.8239L11.4898 16.6725L18.5852 21.8239L15.8757 13.4919L22.9711 8.34046Z' fill='%2300B67A'/%3e%3cpath d='M16.4853 15.3783L15.8757 13.4919L11.4897 16.6725L16.4853 15.3783Z' fill='%23005128'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_4398_4164'%3e%3crect width='23' height='22' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$9 =
  'data:image/png;base64,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';

var style$j = {
  TestimonialCard: 'htco-TestimonialCard',
  TestimonialCardImage: 'htco-TestimonialCardImage',
  TestimonialCardContent: 'htco-TestimonialCardContent',
  TestimonialCardDivider: 'htco-TestimonialCardDivider',
  TestimonialCardAuthor: 'htco-TestimonialCardAuthor',
  TesimonialDividerAndAuthorContainer: 'htco-TesimonialDividerAndAuthorContainer',
};

var TestimonialCard = function (_a) {
  var author = _a.author,
    children = _a.children,
    className = _a.className,
    props = __rest$1(_a, ['author', 'children', 'className']);
  return jsxRuntime.jsxs('div', {
    className: cx(className, style$j.TestimonialCard),
    style: __assign({}, props.style),
    children: [
      jsxRuntime.jsxs('div', {
        children: [
          jsxRuntime.jsx('img', { className: style$j.TestimonialCardImage, src: img$9, alt: 'trustpilot' }),
          jsxRuntime.jsx('div', { className: style$j.TestimonialCardContent, children: children }),
        ],
      }),
      jsxRuntime.jsxs('div', {
        className: style$j.TesimonialDividerAndAuthorContainer,
        children: [
          jsxRuntime.jsx('hr', { className: style$j.TestimonialCardDivider, align: 'left' }),
          jsxRuntime.jsx('div', { className: style$j.TestimonialCardAuthor, children: author }),
        ],
      }),
    ],
  });
};
TestimonialCard.propTypes = {
  author: PropTypes__default['default'].string,
  children: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].element,
    PropTypes__default['default'].string,
  ]).isRequired,
};

var style$i = {
  TestimonialsCarousel: 'htco-TestimonialsCarousel',
  TestimonialsCarouselHeader: 'htco-TestimonialsCarouselHeader',
  TestimonialsCarouselRatingDesktop: 'htco-TestimonialsCarouselRatingDesktop',
  TestimonialsCarouselRatingMobile: 'htco-TestimonialsCarouselRatingMobile',
  TestimonialsCarouselItems: 'htco-TestimonialsCarouselItems',
  ScrollSnapTypeXMandatory: 'htco-ScrollSnapTypeXMandatory',
  TestimonialsCarouselItem: 'htco-TestimonialsCarouselItem',
  ScrollSnapAlignCenter: 'htco-ScrollSnapAlignCenter',
  TestimonialsCarouselItemCard: 'htco-TestimonialsCarouselItemCard',
  CustomScrollbarContainer: 'htco-CustomScrollbarContainer',
  CustomScrollbar: 'htco-CustomScrollbar',
  CustomScrollbarTrack: 'htco-CustomScrollbarTrack',
  CustomScrollbarThumb: 'htco-CustomScrollbarThumb',
  CursorGrabbing: 'htco-CursorGrabbing',
  HoverStyle: 'htco-HoverStyle',
  ArrowsContainer: 'htco-ArrowsContainer',
  Arrow: 'htco-Arrow',
  LeftArrow: 'htco-LeftArrow',
};

var DEFAULT_CARDS = [
  {
    author: 'Susan',
    content:
      'This was the perfect solution for us. Within hours, we had an Investment Manager who explained the whole process.',
  },
  {
    author: 'Robert',
    content: 'My experience was exceptional....three weeks from first contact to [Investment] approval.',
  },
  {
    author: 'Van',
    content: 'All terms were also spelled out very clearly — I appreciate the transparency the process provides.',
  },
  {
    author: 'Kenny',
    content: 'Hometap was amazing and seamless. It was so easy and crystal clear.',
  },
  {
    author: 'Monica',
    content: 'The process was so quick and easy. I almost thought it was too good to be true.',
  },
  {
    author: 'James',
    content: "I can't decide if this is a lifesaver or a game changer. To me, it's both.",
  },
  {
    author: 'Dena',
    content: 'The entire process was smooth and stress-free. So glad we found Hometap!',
  },
  {
    author: 'Linette',
    content: 'This is the second time we have worked with Hometap and it was even better the second time.',
  },
  {
    author: 'William',
    content: "Hometap provided me a way to help improve my home and help fund my daughter's college dreams.",
  },
  {
    author: 'Donna',
    content: 'The Hometap employees work with your needs in mind and make the process stress-free.',
  },
  {
    author: 'Sherri',
    content:
      'Lightning fast service, way quicker then traditional methods; my time frame from start to finish was about two weeks!',
  },
  {
    author: 'Michael',
    content:
      'The process took less than 10 days to complete. Our deal is done. The papers are signed. Buh-bye, high-interest debt.',
  },
  {
    author: 'Lora',
    content: 'I am forever grateful to have found this company when I did.',
  },
  {
    author: 'Steve',
    content: 'The process has been really straightforward and provided me capital to grow my business.',
  },
  {
    author: 'Matthew',
    content:
      'We saved over $2000+ a month in payments and can now get some additions and upgrades we wanted done on the home!',
  },
];
var ArrowSvg = function () {
  return jsxRuntime.jsx('svg', {
    width: '22',
    height: '26',
    viewBox: '0 0 24 28',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    children: jsxRuntime.jsx('path', {
      d: 'M8.00452 4L19 14.4978L8 25',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  });
};
var Arrow = function (_a) {
  var _b;
  var type = _a.type,
    onClick = _a.onClick,
    className = _a.className;
  return jsxRuntime.jsx('button', {
    className: cx(style$i.Arrow, className, ((_b = {}), (_b[style$i.LeftArrow] = type === 'prev'), _b)),
    'aria-label': ''.concat(type, ' arrow button'),
    onClick: onClick,
    children: jsxRuntime.jsx(ArrowSvg, {}),
  });
};
var CustomScrollbar = function (_a) {
  var _b;
  var _c, _d;
  var scrollPercentage = _a.scrollPercentage,
    _e = _a.pages,
    pages = _e === void 0 ? 2 : _e,
    onScroll = _a.onScroll,
    onDragStart = _a.onDragStart,
    onDragEnd = _a.onDragEnd;
  var trackRef = React.useRef(null);
  var thumbRef = React.useRef(null);
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  var thumbWidth = ((_c = thumbRef.current) === null || _c === void 0 ? void 0 : _c.offsetWidth) || 0;
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  var trackWidth = ((_d = trackRef.current) === null || _d === void 0 ? void 0 : _d.offsetWidth) || 0;
  var thumbPosition = scrollPercentage * (trackWidth - thumbWidth);
  var _f = React__namespace.useState(false),
    isDragging = _f[0],
    setIsDragging = _f[1];
  var lastTouchX = React.useRef(0);
  var moveThumb = function (newPosition, scrollBehavior) {
    var _a, _b;
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    var thumbWidth = ((_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    var trackWidth = ((_b = trackRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
    if (newPosition + thumbWidth > trackWidth) newPosition = trackWidth - thumbWidth;
    if (newPosition < 0) newPosition = 0;
    var newScrollPercentage = newPosition / (trackWidth - thumbWidth);
    if (onScroll) onScroll(newScrollPercentage, scrollBehavior);
  };
  // mouse events
  var onClickTrack = function (e) {
    moveThumb(e.nativeEvent.offsetX, 'smooth');
  };
  var onMouseDownThumb = function () {
    setIsDragging(true);
    if (onDragStart) onDragStart();
    // sometimes we end up dragging outside of the scrollbar so move up ins on the document
    document.addEventListener('mousemove', onMouseMoveDocument);
    document.addEventListener('mouseup', onMouseUpDocument);
    document.body.classList.add(style$i.CursorGrabbing);
  };
  var onMouseUpDocument = function () {
    setIsDragging(false);
    if (onDragEnd) onDragEnd();
    document.removeEventListener('mousemove', onMouseMoveDocument);
    document.removeEventListener('mouseup', onMouseUpDocument);
    document.body.classList.remove(style$i.CursorGrabbing);
  };
  var onMouseMoveDocument = function (e) {
    var _a;
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    var currentPosition = ((_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.offsetLeft) || 0;
    moveThumb(currentPosition + e.movementX);
  };
  var onClickPrev = function () {
    var _a;
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    var trackWidth =
      ((_a = trackRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0;
    var delta = trackWidth / pages;
    moveThumb(thumbPosition - delta, 'smooth');
  };
  var onClickNext = function () {
    var _a;
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    var trackWidth =
      ((_a = trackRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0;
    var delta = trackWidth / pages;
    moveThumb(thumbPosition + delta, 'smooth');
  };
  // touch events
  var onTouchStartThumb = function (e) {
    setIsDragging(true);
    if (onDragStart) onDragStart();
    lastTouchX.current = e.touches[0].clientX;
    document.addEventListener('touchmove', onTouchMoveDocument);
    document.addEventListener('touchend', onTouchEndDocument);
    document.body.classList.add(style$i.CursorGrabbing);
  };
  var onTouchMoveDocument = function (e) {
    var _a;
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    var currentPosition = ((_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.offsetLeft) || 0;
    moveThumb(currentPosition + e.touches[0].clientX - lastTouchX.current);
    lastTouchX.current = e.touches[0].clientX;
  };
  var onTouchEndDocument = function () {
    setIsDragging(false);
    if (onDragEnd) onDragEnd();
    document.removeEventListener('touchmove', onTouchMoveDocument);
    document.removeEventListener('touchend', onTouchEndDocument);
    document.body.classList.remove(style$i.CursorGrabbing);
  };
  return jsxRuntime.jsxs('div', {
    className: style$i.CustomScrollbarContainer,
    children: [
      jsxRuntime.jsxs('div', {
        className: style$i.CustomScrollbar,
        children: [
          jsxRuntime.jsx('button', { className: style$i.CustomScrollbarTrack, onClick: onClickTrack, ref: trackRef }),
          jsxRuntime.jsx('button', {
            className: cx(
              style$i.CustomScrollbarThumb,
              ((_b = {}), (_b[style$i.CursorGrabbing] = isDragging), (_b[style$i.HoverStyle] = isDragging), _b),
            ),
            style: { left: thumbPosition, width: ''.concat(100 / pages, '%') },
            ref: thumbRef,
            onMouseDown: onMouseDownThumb,
            onTouchStart: onTouchStartThumb,
          }),
        ],
      }),
      jsxRuntime.jsxs('div', {
        className: style$i.ArrowsContainer,
        children: [
          jsxRuntime.jsx(Arrow, { className: 'prev-arrow', type: 'prev', onClick: onClickPrev }),
          jsxRuntime.jsx(Arrow, { className: 'next-arrow', type: 'next', onClick: onClickNext }),
        ],
      }),
    ],
  });
};
var TestimonialsCarousel = function (_a) {
  var _b;
  var className = _a.className,
    _c = _a.cards,
    cards = _c === void 0 ? DEFAULT_CARDS : _c,
    _d = _a.heading,
    heading = _d === void 0 ? 'Join over 18,000 homeowners' : _d,
    _e = _a.rating,
    rating = _e === void 0 ? '4.9 / 5' : _e,
    _f = _a.ratingDescription,
    ratingDescription = _f === void 0 ? 'Rating on Trustpilot' : _f;
  var _g = React.useState(0),
    scrollPercentage = _g[0],
    setScrollPercentage = _g[1];
  var _h = React.useState(0),
    scrollWidth = _h[0],
    setScrollWidth = _h[1];
  var _j = React.useState(0),
    offsetWidth = _j[0],
    setOffsetWidth = _j[1];
  var _k = React.useState(),
    scrollTo = _k[0],
    setScrollTo = _k[1];
  var _l = React.useState(false),
    isDragging = _l[0],
    setIsDragging = _l[1];
  // useCallback here instead of useRef because useRef will be undefined on first render so can't calculate pages properly
  var callbackRef = React.useCallback(
    function (node) {
      if (node !== null) {
        setScrollWidth(node.scrollWidth);
        setOffsetWidth(node.offsetWidth);
        setScrollTo(function () {
          return function (options) {
            return node.scrollTo(options);
          };
        });
      }
    },
    [window.innerWidth],
  ); // recalculate on window resize
  var onCustomScrollbarScroll = function (newScrollPercentage, scrollBehavior) {
    if (scrollBehavior === void 0) {
      scrollBehavior = 'auto';
    }
    var scrollWidthMinusOffset = scrollWidth - offsetWidth;
    var newScrollPosition = scrollWidthMinusOffset > 0 ? scrollWidthMinusOffset * newScrollPercentage : 0;
    if (scrollTo) scrollTo({ left: newScrollPosition, behavior: scrollBehavior });
  };
  var onScroll = function (e) {
    var scrollWidthMinusOffset = scrollWidth - offsetWidth;
    var scrollPosition = e.currentTarget.scrollLeft;
    var newScrollPercentage = scrollWidthMinusOffset > 0 ? scrollPosition / scrollWidthMinusOffset : 0;
    setScrollPercentage(newScrollPercentage);
  };
  // we calculate the number of pages based on the actual size of the container so we can set item size with css
  var customScrollbarPages = Math.ceil(scrollWidth / offsetWidth);
  return jsxRuntime.jsxs(Paper, {
    theme: 'medium',
    pad: 2,
    className: cx(style$i.TestimonialsCarousel, className),
    children: [
      jsxRuntime.jsxs('div', {
        className: style$i.TestimonialsCarouselHeader,
        children: [
          jsxRuntime.jsx('h2', { children: heading }),
          jsxRuntime.jsxs('a', {
            className: style$i.TestimonialsCarouselRatingDesktop,
            href: 'https://www.trustpilot.com/review/hometap.com',
            target: 'blank',
            children: [
              jsxRuntime.jsx('h3', { children: rating }),
              jsxRuntime.jsx('img', { src: img$a, alt: 'TrustPilot star' }),
              jsxRuntime.jsx('p', { children: ratingDescription }),
            ],
          }),
        ],
      }),
      jsxRuntime.jsx('div', {
        className: cx(
          style$i.TestimonialsCarouselItems,
          ((_b = {}), (_b[style$i.ScrollSnapTypeXMandatory] = !isDragging), _b),
        ),
        onScroll: onScroll,
        ref: callbackRef,
        children: cards.map(function (card, i) {
          var _a;
          return jsxRuntime.jsx(
            'div',
            {
              className: cx(
                style$i.TestimonialsCarouselItem,
                ((_a = {}), (_a[style$i.ScrollSnapAlignCenter] = !isDragging), _a),
              ),
              children: jsxRuntime.jsxs(TestimonialCard, {
                className: style$i.TestimonialsCarouselItemCard,
                author: card === null || card === void 0 ? void 0 : card.author,
                children: ['"', card === null || card === void 0 ? void 0 : card.content, '"'],
              }),
            },
            (card === null || card === void 0 ? void 0 : card.author) + i,
          );
        }),
      }),
      jsxRuntime.jsx(CustomScrollbar, {
        scrollPercentage: scrollPercentage,
        onScroll: onCustomScrollbarScroll,
        pages: customScrollbarPages,
        onDragStart: function () {
          return setIsDragging(true);
        },
        onDragEnd: function () {
          return setIsDragging(false);
        },
      }),
      jsxRuntime.jsxs('a', {
        className: style$i.TestimonialsCarouselRatingMobile,
        href: 'https://www.trustpilot.com/review/hometap.com',
        target: 'blank',
        children: [
          jsxRuntime.jsx('h3', { children: rating }),
          jsxRuntime.jsx('img', { src: img$a, alt: 'TrustPilot star' }),
          jsxRuntime.jsx('p', { children: ratingDescription }),
        ],
      }),
    ],
  });
};

function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function areObjectsEqualShallow(objectA, objectB) {
  return (
    Object.keys(objectA).length === Object.keys(objectB).length &&
    Object.keys(objectA).every(function (objectKey) {
      if (!Object.prototype.hasOwnProperty.call(objectB, objectKey)) {
        return false;
      }

      return objectA[objectKey] === objectB[objectKey];
    })
  );
}
function sortAndMapPluginToOptions(plugins) {
  return plugins
    .concat()
    .sort(function (a, b) {
      return a.name > b.name ? 1 : -1;
    })
    .map(function (plugin) {
      return plugin.options;
    });
}
function arePluginsEqual(pluginsA, pluginsB) {
  if (pluginsA.length !== pluginsB.length) return false;
  var optionsA = sortAndMapPluginToOptions(pluginsA);
  var optionsB = sortAndMapPluginToOptions(pluginsB);
  return optionsA.every(function (optionA, index) {
    var optionB = optionsB[index];
    return areObjectsEqualShallow(optionA, optionB);
  });
}

function Alignment(align, viewSize) {
  var predefined = {
    start: start,
    center: center,
    end: end,
  };

  function start() {
    return 0;
  }

  function center(n) {
    return end(n) / 2;
  }

  function end(n) {
    return viewSize - n;
  }

  function percent() {
    return viewSize * Number(align);
  }

  function measure(n) {
    if (typeof align === 'number') return percent();
    return predefined[align](n);
  }

  var self = {
    measure: measure,
  };
  return self;
}

function Animation(callback) {
  var animationFrame = 0;

  function ifAnimating(active, cb) {
    return function () {
      if (active === !!animationFrame) cb();
    };
  }

  function start() {
    animationFrame = window.requestAnimationFrame(callback);
  }

  function stop() {
    window.cancelAnimationFrame(animationFrame);
    animationFrame = 0;
  }

  var self = {
    proceed: ifAnimating(true, start),
    start: ifAnimating(false, start),
    stop: ifAnimating(true, stop),
  };
  return self;
}

function Axis(axis, direction) {
  var scroll = axis === 'y' ? 'y' : 'x';
  var cross = axis === 'y' ? 'x' : 'y';
  var startEdge = getStartEdge();
  var endEdge = getEndEdge();

  function measureSize(rect) {
    var width = rect.width,
      height = rect.height;
    return scroll === 'x' ? width : height;
  }

  function getStartEdge() {
    if (scroll === 'y') return 'top';
    return direction === 'rtl' ? 'right' : 'left';
  }

  function getEndEdge() {
    if (scroll === 'y') return 'bottom';
    return direction === 'rtl' ? 'left' : 'right';
  }

  var self = {
    scroll: scroll,
    cross: cross,
    startEdge: startEdge,
    endEdge: endEdge,
    measureSize: measureSize,
  };
  return self;
}

function map(value, iStart, iStop, oStart, oStop) {
  return oStart + (oStop - oStart) * ((value - iStart) / (iStop - iStart));
}

function mathAbs(n) {
  return Math.abs(n);
}

function mathSign(n) {
  return !n ? 0 : n / mathAbs(n);
}

function deltaAbs(valueB, valueA) {
  return mathAbs(valueB - valueA);
}

function factorAbs(valueB, valueA) {
  if (valueB === 0 || valueA === 0) return 0;
  if (mathAbs(valueB) <= mathAbs(valueA)) return 0;
  var diff = deltaAbs(mathAbs(valueB), mathAbs(valueA));
  return mathAbs(diff / valueB);
}

function roundToDecimals(decimalPoints) {
  var pow = Math.pow(10, decimalPoints);
  return function (n) {
    return Math.round(n * pow) / pow;
  };
}

function debounce(callback, time) {
  var timeout = 0;
  return function () {
    window.clearTimeout(timeout);
    timeout = window.setTimeout(callback, time) || 0;
  };
}

function arrayGroup(array, size) {
  var groups = [];

  for (var i = 0; i < array.length; i += size) {
    groups.push(array.slice(i, i + size));
  }

  return groups;
}

function arrayKeys(array) {
  return Object.keys(array).map(Number);
}

function arrayLast(array) {
  return array[arrayLastIndex(array)];
}

function arrayLastIndex(array) {
  return Math.max(0, array.length - 1);
}

function Limit(min, max) {
  var length = mathAbs(min - max);

  function reachedMin(n) {
    return n < min;
  }

  function reachedMax(n) {
    return n > max;
  }

  function reachedAny(n) {
    return reachedMin(n) || reachedMax(n);
  }

  function constrain(n) {
    if (!reachedAny(n)) return n;
    return reachedMin(n) ? min : max;
  }

  function removeOffset(n) {
    if (!length) return n;
    return n - length * Math.ceil((n - max) / length);
  }

  var self = {
    length: length,
    max: max,
    min: min,
    constrain: constrain,
    reachedAny: reachedAny,
    reachedMax: reachedMax,
    reachedMin: reachedMin,
    removeOffset: removeOffset,
  };
  return self;
}

function Counter(max, start, loop) {
  var _a = Limit(0, max),
    min = _a.min,
    constrain = _a.constrain;

  var loopEnd = max + 1;
  var counter = withinLimit(start);

  function withinLimit(n) {
    return !loop ? constrain(n) : mathAbs((loopEnd + n) % loopEnd);
  }

  function get() {
    return counter;
  }

  function set(n) {
    counter = withinLimit(n);
    return self;
  }

  function add(n) {
    return set(get() + n);
  }

  function clone() {
    return Counter(max, get(), loop);
  }

  var self = {
    add: add,
    clone: clone,
    get: get,
    set: set,
    min: min,
    max: max,
  };
  return self;
}

function Direction(direction) {
  var sign = direction === 'rtl' ? -1 : 1;

  function apply(n) {
    return n * sign;
  }

  var self = {
    apply: apply,
  };
  return self;
}

function EventStore() {
  var listeners = [];

  function add(node, type, handler, options) {
    if (options === void 0) {
      options = false;
    }

    node.addEventListener(type, handler, options);
    listeners.push(function () {
      return node.removeEventListener(type, handler, options);
    });
    return self;
  }

  function removeAll() {
    listeners = listeners.filter(function (remove) {
      return remove();
    });
    return self;
  }

  var self = {
    add: add,
    removeAll: removeAll,
  };
  return self;
}

function Vector1D(value) {
  var vector = value;

  function get() {
    return vector;
  }

  function set(n) {
    vector = readNumber(n);
    return self;
  }

  function add(n) {
    vector += readNumber(n);
    return self;
  }

  function subtract(n) {
    vector -= readNumber(n);
    return self;
  }

  function multiply(n) {
    vector *= n;
    return self;
  }

  function divide(n) {
    vector /= n;
    return self;
  }

  function normalize() {
    if (vector !== 0) divide(vector);
    return self;
  }

  function readNumber(n) {
    return typeof n === 'number' ? n : n.get();
  }

  var self = {
    add: add,
    divide: divide,
    get: get,
    multiply: multiply,
    normalize: normalize,
    set: set,
    subtract: subtract,
  };
  return self;
}

function DragHandler(
  axis,
  direction,
  rootNode,
  target,
  dragFree,
  dragTracker,
  location,
  animation,
  scrollTo,
  scrollBody,
  scrollTarget,
  index,
  events,
  loop,
  skipSnaps,
) {
  var crossAxis = axis.cross;
  var focusNodes = ['INPUT', 'SELECT', 'TEXTAREA'];
  var dragStartPoint = Vector1D(0);
  var activationEvents = EventStore();
  var interactionEvents = EventStore();
  var snapForceBoost = {
    mouse: 300,
    touch: 400,
  };
  var freeForceBoost = {
    mouse: 500,
    touch: 600,
  };
  var baseSpeed = dragFree ? 5 : 16;
  var baseMass = 1;
  var dragThreshold = 20;
  var startScroll = 0;
  var startCross = 0;
  var pointerIsDown = false;
  var preventScroll = false;
  var preventClick = false;
  var isMouse = false;

  function addActivationEvents() {
    var node = rootNode;
    activationEvents
      .add(node, 'touchmove', function () {
        return undefined;
      })
      .add(node, 'touchend', function () {
        return undefined;
      })
      .add(node, 'touchstart', down)
      .add(node, 'mousedown', down)
      .add(node, 'touchcancel', up)
      .add(node, 'contextmenu', up)
      .add(node, 'click', click);
  }

  function addInteractionEvents() {
    var node = !isMouse ? rootNode : document;
    interactionEvents
      .add(node, 'touchmove', move)
      .add(node, 'touchend', up)
      .add(node, 'mousemove', move)
      .add(node, 'mouseup', up);
  }

  function removeAllEvents() {
    activationEvents.removeAll();
    interactionEvents.removeAll();
  }

  function isFocusNode(node) {
    var name = node.nodeName || '';
    return focusNodes.indexOf(name) > -1;
  }

  function forceBoost() {
    var boost = dragFree ? freeForceBoost : snapForceBoost;
    var type = isMouse ? 'mouse' : 'touch';
    return boost[type];
  }

  function allowedForce(force, targetChanged) {
    var next = index.clone().add(mathSign(force) * -1);
    var isEdge = next.get() === index.min || next.get() === index.max;
    var baseForce = scrollTarget.byDistance(force, !dragFree).distance;
    if (dragFree || mathAbs(force) < dragThreshold) return baseForce;
    if (!loop && isEdge) return baseForce * 0.4;
    if (skipSnaps && targetChanged) return baseForce * 0.5;
    return scrollTarget.byIndex(next.get(), 0).distance;
  }

  function down(evt) {
    isMouse = evt.type === 'mousedown';
    if (isMouse && evt.button !== 0) return;
    var isMoving = deltaAbs(target.get(), location.get()) >= 2;
    var clearPreventClick = isMouse || !isMoving;
    var isNotFocusNode = !isFocusNode(evt.target);
    var preventDefault = isMoving || (isMouse && isNotFocusNode);
    pointerIsDown = true;
    dragTracker.pointerDown(evt);
    dragStartPoint.set(target);
    target.set(location);
    scrollBody.useBaseMass().useSpeed(80);
    addInteractionEvents();
    startScroll = dragTracker.readPoint(evt);
    startCross = dragTracker.readPoint(evt, crossAxis);
    events.emit('pointerDown');
    if (clearPreventClick) preventClick = false;
    if (preventDefault) evt.preventDefault();
  }

  function move(evt) {
    if (!preventScroll && !isMouse) {
      if (!evt.cancelable) return up(evt);
      var lastScroll = dragTracker.readPoint(evt);
      var lastCross = dragTracker.readPoint(evt, crossAxis);
      var diffScroll = deltaAbs(lastScroll, startScroll);
      var diffCross = deltaAbs(lastCross, startCross);
      preventScroll = diffScroll > diffCross;
      if (!preventScroll && !preventClick) return up(evt);
    }

    var diff = dragTracker.pointerMove(evt);
    if (!preventClick && diff) preventClick = true;
    animation.start();
    target.add(direction.apply(diff));
    evt.preventDefault();
  }

  function up(evt) {
    var currentLocation = scrollTarget.byDistance(0, false);
    var targetChanged = currentLocation.index !== index.get();
    var rawForce = dragTracker.pointerUp(evt) * forceBoost();
    var force = allowedForce(direction.apply(rawForce), targetChanged);
    var forceFactor = factorAbs(rawForce, force);
    var isMoving = deltaAbs(target.get(), dragStartPoint.get()) >= 0.5;
    var isVigorous = targetChanged && forceFactor > 0.75;
    var isBelowThreshold = mathAbs(rawForce) < dragThreshold;
    var speed = isVigorous ? 10 : baseSpeed;
    var mass = isVigorous ? baseMass + 2.5 * forceFactor : baseMass;
    if (isMoving && !isMouse) preventClick = true;
    preventScroll = false;
    pointerIsDown = false;
    interactionEvents.removeAll();
    scrollBody.useSpeed(isBelowThreshold ? 9 : speed).useMass(mass);
    scrollTo.distance(force, !dragFree);
    isMouse = false;
    events.emit('pointerUp');
  }

  function click(evt) {
    if (preventClick) evt.preventDefault();
  }

  function clickAllowed() {
    return !preventClick;
  }

  function pointerDown() {
    return pointerIsDown;
  }

  var self = {
    addActivationEvents: addActivationEvents,
    clickAllowed: clickAllowed,
    pointerDown: pointerDown,
    removeAllEvents: removeAllEvents,
  };
  return self;
}

function DragTracker(axis, pxToPercent) {
  var logInterval = 170;
  var startEvent;
  var lastEvent;

  function isTouchEvent(evt) {
    return typeof TouchEvent !== 'undefined' && evt instanceof TouchEvent;
  }

  function readTime(evt) {
    return evt.timeStamp;
  }

  function readPoint(evt, evtAxis) {
    var property = evtAxis || axis.scroll;
    var coord = 'client' + (property === 'x' ? 'X' : 'Y');
    return (isTouchEvent(evt) ? evt.touches[0] : evt)[coord];
  }

  function pointerDown(evt) {
    startEvent = evt;
    lastEvent = evt;
    return pxToPercent.measure(readPoint(evt));
  }

  function pointerMove(evt) {
    var diff = readPoint(evt) - readPoint(lastEvent);
    var expired = readTime(evt) - readTime(startEvent) > logInterval;
    lastEvent = evt;
    if (expired) startEvent = evt;
    return pxToPercent.measure(diff);
  }

  function pointerUp(evt) {
    if (!startEvent || !lastEvent) return 0;
    var diffDrag = readPoint(lastEvent) - readPoint(startEvent);
    var diffTime = readTime(evt) - readTime(startEvent);
    var expired = readTime(evt) - readTime(lastEvent) > logInterval;
    var force = diffDrag / diffTime;
    var isFlick = diffTime && !expired && mathAbs(force) > 0.1;
    return isFlick ? pxToPercent.measure(force) : 0;
  }

  var self = {
    isTouchEvent: isTouchEvent,
    pointerDown: pointerDown,
    pointerMove: pointerMove,
    pointerUp: pointerUp,
    readPoint: readPoint,
  };
  return self;
}

function PxToPercent(viewInPx) {
  var totalPercent = 100;

  function measure(n) {
    if (viewInPx === 0) return 0;
    return (n / viewInPx) * totalPercent;
  }

  var self = {
    measure: measure,
    totalPercent: totalPercent,
  };
  return self;
}

function ScrollBody(location, baseSpeed, baseMass) {
  var roundToTwoDecimals = roundToDecimals(2);
  var velocity = Vector1D(0);
  var acceleration = Vector1D(0);
  var attraction = Vector1D(0);
  var attractionDirection = 0;
  var speed = baseSpeed;
  var mass = baseMass;

  function update() {
    velocity.add(acceleration);
    location.add(velocity);
    acceleration.multiply(0);
  }

  function applyForce(force) {
    force.divide(mass);
    acceleration.add(force);
  }

  function seek(target) {
    attraction.set(target).subtract(location);
    var magnitude = map(attraction.get(), 0, 100, 0, speed);
    attractionDirection = mathSign(attraction.get());
    attraction.normalize().multiply(magnitude).subtract(velocity);
    applyForce(attraction);
    return self;
  }

  function settle(target) {
    var diff = target.get() - location.get();
    var hasSettled = !roundToTwoDecimals(diff);
    if (hasSettled) location.set(target);
    return hasSettled;
  }

  function direction() {
    return attractionDirection;
  }

  function useBaseSpeed() {
    return useSpeed(baseSpeed);
  }

  function useBaseMass() {
    return useMass(baseMass);
  }

  function useSpeed(n) {
    speed = n;
    return self;
  }

  function useMass(n) {
    mass = n;
    return self;
  }

  var self = {
    direction: direction,
    seek: seek,
    settle: settle,
    update: update,
    useBaseMass: useBaseMass,
    useBaseSpeed: useBaseSpeed,
    useMass: useMass,
    useSpeed: useSpeed,
  };
  return self;
}

function ScrollBounds(limit, location, target, scrollBody) {
  var pullBackThreshold = 10;
  var edgeOffsetTolerance = 50;
  var maxFriction = 0.85;
  var disabled = false;

  function shouldConstrain() {
    if (disabled) return false;
    if (!limit.reachedAny(target.get())) return false;
    if (!limit.reachedAny(location.get())) return false;
    return true;
  }

  function constrain(pointerDown) {
    if (!shouldConstrain()) return;
    var edge = limit.reachedMin(location.get()) ? 'min' : 'max';
    var diffToEdge = mathAbs(limit[edge] - location.get());
    var diffToTarget = target.get() - location.get();
    var friction = Math.min(diffToEdge / edgeOffsetTolerance, maxFriction);
    target.subtract(diffToTarget * friction);

    if (!pointerDown && mathAbs(diffToTarget) < pullBackThreshold) {
      target.set(limit.constrain(target.get()));
      scrollBody.useSpeed(10).useMass(3);
    }
  }

  function toggleActive(active) {
    disabled = !active;
  }

  var self = {
    constrain: constrain,
    toggleActive: toggleActive,
  };
  return self;
}

function ScrollContain(viewSize, contentSize, snaps, snapsAligned, containScroll) {
  var scrollBounds = Limit(-contentSize + viewSize, snaps[0]);
  var snapsBounded = snapsAligned.map(scrollBounds.constrain);
  var snapsContained = measureContained();

  function findDuplicates() {
    var startSnap = snapsBounded[0];
    var endSnap = arrayLast(snapsBounded);
    var min = snapsBounded.lastIndexOf(startSnap);
    var max = snapsBounded.indexOf(endSnap) + 1;
    return Limit(min, max);
  }

  function measureContained() {
    if (contentSize <= viewSize) return [scrollBounds.max];
    if (containScroll === 'keepSnaps') return snapsBounded;

    var _a = findDuplicates(),
      min = _a.min,
      max = _a.max;

    return snapsBounded.slice(min, max);
  }

  var self = {
    snapsContained: snapsContained,
  };
  return self;
}

function ScrollLimit(contentSize, scrollSnaps, loop) {
  var limit = measureLimit();

  function measureLimit() {
    var startSnap = scrollSnaps[0];
    var endSnap = arrayLast(scrollSnaps);
    var min = loop ? startSnap - contentSize : endSnap;
    var max = startSnap;
    return Limit(min, max);
  }

  var self = {
    limit: limit,
  };
  return self;
}

function ScrollLooper(contentSize, pxToPercent, limit, location, vectors) {
  var min = limit.min + pxToPercent.measure(0.1);
  var max = limit.max + pxToPercent.measure(0.1);

  var _a = Limit(min, max),
    reachedMin = _a.reachedMin,
    reachedMax = _a.reachedMax;

  function shouldLoop(direction) {
    if (direction === 1) return reachedMax(location.get());
    if (direction === -1) return reachedMin(location.get());
    return false;
  }

  function loop(direction) {
    if (!shouldLoop(direction)) return;
    var loopDistance = contentSize * (direction * -1);
    vectors.forEach(function (v) {
      return v.add(loopDistance);
    });
  }

  var self = {
    loop: loop,
  };
  return self;
}

function ScrollProgress(limit) {
  var max = limit.max,
    scrollLength = limit.length;

  function get(n) {
    var currentLocation = n - max;
    return currentLocation / -scrollLength;
  }

  var self = {
    get: get,
  };
  return self;
}

function ScrollSnap(axis, alignment, pxToPercent, containerRect, slideRects, slidesToScroll) {
  var startEdge = axis.startEdge,
    endEdge = axis.endEdge;
  var snaps = measureUnaligned();
  var snapsAligned = measureAligned();

  function measureSizes() {
    return arrayGroup(slideRects, slidesToScroll)
      .map(function (rects) {
        return arrayLast(rects)[endEdge] - rects[0][startEdge];
      })
      .map(pxToPercent.measure)
      .map(mathAbs);
  }

  function measureUnaligned() {
    return slideRects
      .map(function (rect) {
        return containerRect[startEdge] - rect[startEdge];
      })
      .map(pxToPercent.measure)
      .map(function (snap) {
        return -mathAbs(snap);
      });
  }

  function measureAligned() {
    var groupedSnaps = arrayGroup(snaps, slidesToScroll).map(function (g) {
      return g[0];
    });
    var alignments = measureSizes().map(alignment.measure);
    return groupedSnaps.map(function (snap, index) {
      return snap + alignments[index];
    });
  }

  var self = {
    snaps: snaps,
    snapsAligned: snapsAligned,
  };
  return self;
}

function ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
  var reachedAny = limit.reachedAny,
    removeOffset = limit.removeOffset,
    constrain = limit.constrain;

  function minDistance(d1, d2) {
    return mathAbs(d1) < mathAbs(d2) ? d1 : d2;
  }

  function findTargetSnap(target) {
    var distance = loop ? removeOffset(target) : constrain(target);
    var ascDiffsToSnaps = scrollSnaps
      .map(function (scrollSnap) {
        return scrollSnap - distance;
      })
      .map(function (diffToSnap) {
        return shortcut(diffToSnap, 0);
      })
      .map(function (diff, i) {
        return {
          diff: diff,
          index: i,
        };
      })
      .sort(function (d1, d2) {
        return mathAbs(d1.diff) - mathAbs(d2.diff);
      });
    var index = ascDiffsToSnaps[0].index;
    return {
      index: index,
      distance: distance,
    };
  }

  function shortcut(target, direction) {
    var t1 = target;
    var t2 = target + contentSize;
    var t3 = target - contentSize;
    if (!loop) return t1;
    if (!direction) return minDistance(minDistance(t1, t2), t3);
    var shortest = minDistance(t1, direction === 1 ? t2 : t3);
    return mathAbs(shortest) * direction;
  }

  function byIndex(index, direction) {
    var diffToSnap = scrollSnaps[index] - targetVector.get();
    var distance = shortcut(diffToSnap, direction);
    return {
      index: index,
      distance: distance,
    };
  }

  function byDistance(distance, snap) {
    var target = targetVector.get() + distance;

    var _a = findTargetSnap(target),
      index = _a.index,
      targetSnapDistance = _a.distance;

    var reachedBound = !loop && reachedAny(target);
    if (!snap || reachedBound)
      return {
        index: index,
        distance: distance,
      };
    var diffToSnap = scrollSnaps[index] - targetSnapDistance;
    var snapDistance = distance + shortcut(diffToSnap, 0);
    return {
      index: index,
      distance: snapDistance,
    };
  }

  var self = {
    byDistance: byDistance,
    byIndex: byIndex,
    shortcut: shortcut,
  };
  return self;
}

function ScrollTo(animation, indexCurrent, indexPrevious, scrollTarget, targetVector, events) {
  function scrollTo(target) {
    var distanceDiff = target.distance;
    var indexDiff = target.index !== indexCurrent.get();

    if (distanceDiff) {
      animation.start();
      targetVector.add(distanceDiff);
    }

    if (indexDiff) {
      indexPrevious.set(indexCurrent.get());
      indexCurrent.set(target.index);
      events.emit('select');
    }
  }

  function distance(n, snap) {
    var target = scrollTarget.byDistance(n, snap);
    scrollTo(target);
  }

  function index(n, direction) {
    var targetIndex = indexCurrent.clone().set(n);
    var target = scrollTarget.byIndex(targetIndex.get(), direction);
    scrollTo(target);
  }

  var self = {
    distance: distance,
    index: index,
  };
  return self;
}

function SlideLooper(
  axis,
  viewSize,
  contentSize,
  slideSizesWithGaps,
  scrollSnaps,
  slidesInView,
  scrollLocation,
  slides,
) {
  var ascItems = arrayKeys(slideSizesWithGaps);
  var descItems = arrayKeys(slideSizesWithGaps).reverse();
  var loopPoints = startPoints().concat(endPoints());

  function removeSlideSizes(indexes, from) {
    return indexes.reduce(function (a, i) {
      return a - slideSizesWithGaps[i];
    }, from);
  }

  function slidesInGap(indexes, gap) {
    return indexes.reduce(function (a, i) {
      var remainingGap = removeSlideSizes(a, gap);
      return remainingGap > 0 ? a.concat([i]) : a;
    }, []);
  }

  function findLoopPoints(indexes, edge) {
    var isStartEdge = edge === 'start';
    var offset = isStartEdge ? -contentSize : contentSize;
    var slideBounds = slidesInView.findSlideBounds([offset]);
    return indexes.map(function (index) {
      var initial = isStartEdge ? 0 : -contentSize;
      var altered = isStartEdge ? contentSize : 0;
      var bounds = slideBounds.filter(function (b) {
        return b.index === index;
      })[0];
      var point = bounds[isStartEdge ? 'end' : 'start'];

      var getTarget = function () {
        return scrollLocation.get() > point ? initial : altered;
      };

      return {
        point: point,
        getTarget: getTarget,
        index: index,
        location: -1,
      };
    });
  }

  function startPoints() {
    var gap = scrollSnaps[0] - 1;
    var indexes = slidesInGap(descItems, gap);
    return findLoopPoints(indexes, 'end');
  }

  function endPoints() {
    var gap = viewSize - scrollSnaps[0] - 1;
    var indexes = slidesInGap(ascItems, gap);
    return findLoopPoints(indexes, 'start');
  }

  function canLoop() {
    return loopPoints.every(function (_a) {
      var index = _a.index;
      var otherIndexes = ascItems.filter(function (i) {
        return i !== index;
      });
      return removeSlideSizes(otherIndexes, viewSize) <= 0;
    });
  }

  function loop() {
    loopPoints.forEach(function (loopPoint) {
      var getTarget = loopPoint.getTarget,
        location = loopPoint.location,
        index = loopPoint.index;
      var target = getTarget();

      if (target !== location) {
        slides[index].style[axis.startEdge] = target + '%';
        loopPoint.location = target;
      }
    });
  }

  function clear() {
    loopPoints.forEach(function (_a) {
      var index = _a.index;
      slides[index].style[axis.startEdge] = '';
    });
  }

  var self = {
    canLoop: canLoop,
    clear: clear,
    loop: loop,
    loopPoints: loopPoints,
  };
  return self;
}

function SlidesInView(viewSize, contentSize, slideSizes, snaps, limit, loop, inViewThreshold) {
  var removeOffset = limit.removeOffset,
    constrain = limit.constrain;
  var cachedThreshold = Math.min(Math.max(inViewThreshold, 0.01), 0.99);
  var cachedOffsets = loop ? [0, contentSize, -contentSize] : [0];
  var cachedBounds = findSlideBounds(cachedOffsets, cachedThreshold);

  function findSlideBounds(offsets, threshold) {
    var slideOffsets = offsets || cachedOffsets;
    var slideThreshold = threshold || 0;
    var thresholds = slideSizes.map(function (s) {
      return s * slideThreshold;
    });
    return slideOffsets.reduce(function (list, offset) {
      var bounds = snaps.map(function (snap, index) {
        return {
          start: snap - slideSizes[index] + thresholds[index] + offset,
          end: snap + viewSize - thresholds[index] + offset,
          index: index,
        };
      });
      return list.concat(bounds);
    }, []);
  }

  function check(location, bounds) {
    var limitedLocation = loop ? removeOffset(location) : constrain(location);
    var slideBounds = bounds || cachedBounds;
    return slideBounds.reduce(function (list, slideBound) {
      var index = slideBound.index,
        start = slideBound.start,
        end = slideBound.end;
      var inList = list.indexOf(index) !== -1;
      var inView = start < limitedLocation && end > limitedLocation;
      return !inList && inView ? list.concat([index]) : list;
    }, []);
  }

  var self = {
    check: check,
    findSlideBounds: findSlideBounds,
  };
  return self;
}

function SlideSizes(axis, pxToPercent, slides, slideRects, loop) {
  var measureSize = axis.measureSize,
    startEdge = axis.startEdge,
    endEdge = axis.endEdge;
  var sizesInPx = slideRects.map(measureSize);
  var slideSizes = sizesInPx.map(pxToPercent.measure);
  var slideSizesWithGaps = measureWithGaps();

  function measureWithGaps() {
    return slideRects
      .map(function (rect, index, rects) {
        var isLast = index === arrayLastIndex(rects);
        var style = window.getComputedStyle(arrayLast(slides));
        var endGap = parseFloat(style.getPropertyValue('margin-' + endEdge));
        if (isLast) return sizesInPx[index] + (loop ? endGap : 0);
        return rects[index + 1][startEdge] - rect[startEdge];
      })
      .map(pxToPercent.measure)
      .map(mathAbs);
  }

  var self = {
    slideSizes: slideSizes,
    slideSizesWithGaps: slideSizesWithGaps,
  };
  return self;
}

function Translate(axis, direction, container) {
  var translate = axis.scroll === 'x' ? x : y;
  var containerStyle = container.style;
  var disabled = false;

  function x(n) {
    return 'translate3d(' + n + '%,0px,0px)';
  }

  function y(n) {
    return 'translate3d(0px,' + n + '%,0px)';
  }

  function to(target) {
    if (disabled) return;
    containerStyle.transform = translate(direction.apply(target.get()));
  }

  function toggleActive(active) {
    disabled = !active;
  }

  function clear() {
    containerStyle.transform = '';
  }

  var self = {
    clear: clear,
    to: to,
    toggleActive: toggleActive,
  };
  return self;
}

function Engine(root, container, slides, options, events) {
  // Options
  var align = options.align,
    scrollAxis = options.axis,
    contentDirection = options.direction,
    startIndex = options.startIndex,
    inViewThreshold = options.inViewThreshold,
    loop = options.loop,
    speed = options.speed,
    dragFree = options.dragFree,
    slidesToScroll = options.slidesToScroll,
    skipSnaps = options.skipSnaps,
    containScroll = options.containScroll; // Measurements

  var containerRect = container.getBoundingClientRect();
  var slideRects = slides.map(function (slide) {
    return slide.getBoundingClientRect();
  });
  var direction = Direction(contentDirection);
  var axis = Axis(scrollAxis, contentDirection);
  var pxToPercent = PxToPercent(axis.measureSize(containerRect));
  var viewSize = pxToPercent.totalPercent;
  var alignment = Alignment(align, viewSize);

  var _a = SlideSizes(axis, pxToPercent, slides, slideRects, loop),
    slideSizes = _a.slideSizes,
    slideSizesWithGaps = _a.slideSizesWithGaps;

  var _b = ScrollSnap(axis, alignment, pxToPercent, containerRect, slideRects, slidesToScroll),
    snaps = _b.snaps,
    snapsAligned = _b.snapsAligned;

  var contentSize = -arrayLast(snaps) + arrayLast(slideSizesWithGaps);
  var snapsContained = ScrollContain(viewSize, contentSize, snaps, snapsAligned, containScroll).snapsContained;
  var contain = !loop && containScroll !== '';
  var scrollSnaps = contain ? snapsContained : snapsAligned;
  var limit = ScrollLimit(contentSize, scrollSnaps, loop).limit; // Indexes

  var index = Counter(arrayLastIndex(scrollSnaps), startIndex, loop);
  var indexPrevious = index.clone();
  var slideIndexes = arrayKeys(slides); // Draw

  var update = function () {
    if (!loop) engine.scrollBounds.constrain(engine.dragHandler.pointerDown());
    engine.scrollBody.seek(target).update();
    var settled = engine.scrollBody.settle(target);

    if (settled && !engine.dragHandler.pointerDown()) {
      engine.animation.stop();
      events.emit('settle');
    }

    if (!settled) {
      events.emit('scroll');
    }

    if (loop) {
      engine.scrollLooper.loop(engine.scrollBody.direction());
      engine.slideLooper.loop();
    }

    engine.translate.to(location);
    engine.animation.proceed();
  }; // Shared

  var animation = Animation(update);
  var startLocation = scrollSnaps[index.get()];
  var location = Vector1D(startLocation);
  var target = Vector1D(startLocation);
  var scrollBody = ScrollBody(location, speed, 1);
  var scrollTarget = ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
  var scrollTo = ScrollTo(animation, index, indexPrevious, scrollTarget, target, events);
  var slidesInView = SlidesInView(viewSize, contentSize, slideSizes, snaps, limit, loop, inViewThreshold); // DragHandler

  var dragHandler = DragHandler(
    axis,
    direction,
    root,
    target,
    dragFree,
    DragTracker(axis, pxToPercent),
    location,
    animation,
    scrollTo,
    scrollBody,
    scrollTarget,
    index,
    events,
    loop,
    skipSnaps,
  ); // Slider

  var engine = {
    containerRect: containerRect,
    slideRects: slideRects,
    animation: animation,
    axis: axis,
    direction: direction,
    dragHandler: dragHandler,
    eventStore: EventStore(),
    pxToPercent: pxToPercent,
    index: index,
    indexPrevious: indexPrevious,
    limit: limit,
    location: location,
    options: options,
    scrollBody: scrollBody,
    scrollBounds: ScrollBounds(limit, location, target, scrollBody),
    scrollLooper: ScrollLooper(contentSize, pxToPercent, limit, location, [location, target]),
    scrollProgress: ScrollProgress(limit),
    scrollSnaps: scrollSnaps,
    scrollTarget: scrollTarget,
    scrollTo: scrollTo,
    slideLooper: SlideLooper(
      axis,
      viewSize,
      contentSize,
      slideSizesWithGaps,
      scrollSnaps,
      slidesInView,
      location,
      slides,
    ),
    slidesInView: slidesInView,
    slideIndexes: slideIndexes,
    target: target,
    translate: Translate(axis, direction, container),
  };
  return engine;
}

function EventEmitter() {
  var listeners = {};

  function getListeners(evt) {
    return listeners[evt] || [];
  }

  function emit(evt) {
    getListeners(evt).forEach(function (e) {
      return e(evt);
    });
    return self;
  }

  function on(evt, cb) {
    listeners[evt] = getListeners(evt).concat([cb]);
    return self;
  }

  function off(evt, cb) {
    listeners[evt] = getListeners(evt).filter(function (e) {
      return e !== cb;
    });
    return self;
  }

  var self = {
    emit: emit,
    off: off,
    on: on,
  };
  return self;
}

var defaultOptions = {
  align: 'center',
  axis: 'x',
  containScroll: '',
  direction: 'ltr',
  dragFree: false,
  draggable: true,
  inViewThreshold: 0,
  loop: false,
  skipSnaps: false,
  slidesToScroll: 1,
  speed: 10,
  startIndex: 0,
};

function OptionsPseudo(node) {
  var pseudoString = getComputedStyle(node, ':before').content;

  function get() {
    try {
      return JSON.parse(pseudoString.slice(1, -1).replace(/\\/g, ''));
    } catch (error) {} // eslint-disable-line no-empty

    return {};
  }

  var self = {
    get: get,
  };
  return self;
}

function EmblaCarousel(nodes, userOptions, userPlugins) {
  var events = EventEmitter();
  var debouncedResize = debounce(resize, 500);
  var reInit = reActivate;
  var on = events.on,
    off = events.off;
  var engine;
  var activated = false;
  var optionsBase = Object.assign({}, defaultOptions, EmblaCarousel.globalOptions);
  var options = Object.assign({}, optionsBase);
  var optionsPseudo;
  var plugins;
  var rootSize = 0;
  var root;
  var container;
  var slides;

  function setupElements() {
    var providedContainer = 'container' in nodes && nodes.container;
    var providedSlides = 'slides' in nodes && nodes.slides;
    root = 'root' in nodes ? nodes.root : nodes;
    container = providedContainer || root.children[0];
    slides = providedSlides || [].slice.call(container.children);
    optionsPseudo = OptionsPseudo(root);
  }

  function activate(withOptions, withPlugins) {
    setupElements();
    optionsBase = Object.assign({}, optionsBase, withOptions);
    options = Object.assign({}, optionsBase, optionsPseudo.get());
    plugins = Object.assign([], withPlugins);
    engine = Engine(root, container, slides, options, events);
    engine.eventStore.add(window, 'resize', debouncedResize);
    engine.translate.to(engine.location);
    rootSize = engine.axis.measureSize(root.getBoundingClientRect());
    plugins.forEach(function (plugin) {
      return plugin.init(self);
    });

    if (options.loop) {
      if (!engine.slideLooper.canLoop()) {
        deActivate();
        return activate(
          {
            loop: false,
          },
          withPlugins,
        );
      }

      engine.slideLooper.loop();
    }

    if (options.draggable && container.offsetParent && slides.length) {
      engine.dragHandler.addActivationEvents();
    }

    if (!activated) {
      setTimeout(function () {
        return events.emit('init');
      }, 0);
      activated = true;
    }
  }

  function reActivate(withOptions, withPlugins) {
    if (!activated) return;
    var startIndex = selectedScrollSnap();
    var newOptions = Object.assign(
      {
        startIndex: startIndex,
      },
      withOptions,
    );
    deActivate();
    activate(newOptions, withPlugins || plugins);
    events.emit('reInit');
  }

  function deActivate() {
    engine.dragHandler.removeAllEvents();
    engine.animation.stop();
    engine.eventStore.removeAll();
    engine.translate.clear();
    engine.slideLooper.clear();
    plugins.forEach(function (plugin) {
      return plugin.destroy();
    });
  }

  function destroy() {
    if (!activated) return;
    deActivate();
    activated = false;
    events.emit('destroy');
  }

  function resize() {
    if (!activated) return;
    var size = engine.axis.measureSize(root.getBoundingClientRect());
    if (rootSize !== size) reActivate();
    events.emit('resize');
  }

  function slidesInView(target) {
    var location = engine[target ? 'target' : 'location'].get();
    var type = options.loop ? 'removeOffset' : 'constrain';
    return engine.slidesInView.check(engine.limit[type](location));
  }

  function slidesNotInView(target) {
    var inView = slidesInView(target);
    return engine.slideIndexes.filter(function (index) {
      return inView.indexOf(index) === -1;
    });
  }

  function scrollTo(index, jump, direction) {
    engine.scrollBody.useBaseMass().useSpeed(jump ? 100 : options.speed);
    if (activated) engine.scrollTo.index(index, direction || 0);
  }

  function scrollNext(jump) {
    var next = engine.index.clone().add(1);
    scrollTo(next.get(), jump === true, -1);
  }

  function scrollPrev(jump) {
    var prev = engine.index.clone().add(-1);
    scrollTo(prev.get(), jump === true, 1);
  }

  function canScrollNext() {
    var next = engine.index.clone().add(1);
    return next.get() !== selectedScrollSnap();
  }

  function canScrollPrev() {
    var prev = engine.index.clone().add(-1);
    return prev.get() !== selectedScrollSnap();
  }

  function scrollSnapList() {
    return engine.scrollSnaps.map(engine.scrollProgress.get);
  }

  function scrollProgress() {
    return engine.scrollProgress.get(engine.location.get());
  }

  function selectedScrollSnap() {
    return engine.index.get();
  }

  function previousScrollSnap() {
    return engine.indexPrevious.get();
  }

  function clickAllowed() {
    return engine.dragHandler.clickAllowed();
  }

  function internalEngine() {
    return engine;
  }

  function rootNode() {
    return root;
  }

  function containerNode() {
    return container;
  }

  function slideNodes() {
    return slides;
  }

  var self = {
    canScrollNext: canScrollNext,
    canScrollPrev: canScrollPrev,
    clickAllowed: clickAllowed,
    containerNode: containerNode,
    internalEngine: internalEngine,
    destroy: destroy,
    off: off,
    on: on,
    previousScrollSnap: previousScrollSnap,
    reInit: reInit,
    rootNode: rootNode,
    scrollNext: scrollNext,
    scrollPrev: scrollPrev,
    scrollProgress: scrollProgress,
    scrollSnapList: scrollSnapList,
    scrollTo: scrollTo,
    selectedScrollSnap: selectedScrollSnap,
    slideNodes: slideNodes,
    slidesInView: slidesInView,
    slidesNotInView: slidesNotInView,
  };
  activate(userOptions, userPlugins);
  return self;
}

EmblaCarousel.globalOptions = undefined;

function useEmblaCarousel(options, plugins) {
  if (options === void 0) {
    options = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var _a = React.useState(),
    embla = _a[0],
    setEmbla = _a[1];

  var _b = React.useState(),
    viewport = _b[0],
    setViewport = _b[1];

  var storedOptions = React.useRef(options);
  var storedPlugins = React.useRef(plugins);
  var activeOptions = React.useMemo(
    function () {
      if (!areObjectsEqualShallow(storedOptions.current, options)) {
        storedOptions.current = options;
      }

      return storedOptions.current;
    },
    [storedOptions, options],
  );
  var activePlugins = React.useMemo(
    function () {
      if (!arePluginsEqual(storedPlugins.current, plugins)) {
        storedPlugins.current = plugins;
      }

      return storedPlugins.current;
    },
    [storedPlugins, plugins],
  );
  React.useEffect(
    function () {
      if (canUseDOM() && viewport) {
        EmblaCarousel.globalOptions = useEmblaCarousel.globalOptions;
        var newEmbla_1 = EmblaCarousel(viewport, activeOptions, activePlugins);
        setEmbla(newEmbla_1);
        return function () {
          return newEmbla_1.destroy();
        };
      } else {
        setEmbla(undefined);
      }
    },
    [viewport, activeOptions, activePlugins, setEmbla],
  );
  return [setViewport, embla];
}

useEmblaCarousel.globalOptions = undefined;

var style$h = {
  TestimonialsPanelCarousel: 'htco-TestimonialsPanelCarousel',
  embla: 'htco-embla',
  embla__container: 'htco-embla__container',
  embla__slide: 'htco-embla__slide',
  TestimonialsPanelCarouselTitle: 'htco-TestimonialsPanelCarouselTitle',
  TestimonialsPanelCarouselButtonDivider: 'htco-TestimonialsPanelCarouselButtonDivider',
  TestimonialsPanelCarouselControlsContainer: 'htco-TestimonialsPanelCarouselControlsContainer',
  TestimonialsPanelCarouselImageWrapper: 'htco-TestimonialsPanelCarouselImageWrapper',
  TestimonialsPanelCarouselImage: 'htco-TestimonialsPanelCarouselImage',
  TestimonialsPanelCarouselAuthor: 'htco-TestimonialsPanelCarouselAuthor',
  TestimonialsPanelCarouselQuote: 'htco-TestimonialsPanelCarouselQuote',
  TestimonialsPanelCarouselButton: 'htco-TestimonialsPanelCarouselButton',
  embla__prev: 'htco-embla__prev',
  TestimonialsPanelCarouselButtonIconLeft: 'htco-TestimonialsPanelCarouselButtonIconLeft',
  TestimonialsPanelCarouselButtonIconRight: 'htco-TestimonialsPanelCarouselButtonIconRight',
  TestimonialsPanelCarouselSlideNumberOne: 'htco-TestimonialsPanelCarouselSlideNumberOne',
  TestimonialsPanelCarouselSlideNumberTwo: 'htco-TestimonialsPanelCarouselSlideNumberTwo',
};

/*
  This Carousel was made with Embla Carousel. Docs are here: https://www.embla-carousel.com/guides/
*/
var SlideRatio = function (_a) {
  var num1 = _a.num1,
    num2 = _a.num2;
  return jsxRuntime.jsxs('div', {
    children: [
      jsxRuntime.jsx('span', {
        className: style$h.TestimonialsPanelCarouselSlideNumberOne,
        children: ''.concat(num1 <= 9 ? '0' : '').concat(num1),
      }),
      jsxRuntime.jsx('span', {
        className: style$h.TestimonialsPanelCarouselSlideNumberTwo,
        children: ''.concat(num2 <= 9 ? ' / 0' : ' / ').concat(num2),
      }),
    ],
  });
};
var TestimonialsPanelCard = function (_a) {
  var imageSrc = _a.imageSrc,
    _b = _a.imageAlt,
    imageAlt = _b === void 0 ? '' : _b,
    quote = _a.quote,
    author = _a.author;
  return jsxRuntime.jsxs(Container, {
    row: true,
    respondAt: 'md',
    children: [
      jsxRuntime.jsx('div', {
        className: style$h.TestimonialsPanelCarouselImageWrapper,
        children: jsxRuntime.jsx('img', {
          src: imageSrc,
          alt: imageAlt,
          className: style$h.TestimonialsPanelCarouselImage,
        }),
      }),
      jsxRuntime.jsx('h3', { className: style$h.TestimonialsPanelCarouselAuthor, children: author }),
      jsxRuntime.jsxs('div', {
        className: style$h.TestimonialsPanelCarouselQuote,
        children: ['\u201C', quote, '\u201D'],
      }),
    ],
  });
};
var TestimonialsPanelCarousel = function (_a) {
  var className = _a.className,
    _b = _a.title,
    title = _b === void 0 ? 'WHAT PEOPLE ARE SAYING' : _b,
    _c = _a.theme,
    theme = _c === void 0 ? 'elevated' : _c,
    _d = _a.infiniteLoop,
    infiniteLoop = _d === void 0 ? true : _d,
    _e = _a.cards,
    cards = _e === void 0 ? [] : _e;
  var cardsLength = cards.length;
  var containsSingleCard = cardsLength <= 1;
  var _f = React.useState(1),
    slideNumber = _f[0],
    setSlideNumber = _f[1];
  var _g = useEmblaCarousel({ loop: infiniteLoop }),
    emblaRef = _g[0],
    emblaApi = _g[1];
  var scrollPrev = React.useCallback(
    function () {
      if (emblaApi) {
        var curSlideIndex = emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.selectedScrollSnap();
        var prevIndexStep = void 0;
        if (curSlideIndex === 0) {
          prevIndexStep = cardsLength;
        } else {
          prevIndexStep = curSlideIndex;
        }
        setSlideNumber(prevIndexStep);
        emblaApi.scrollPrev();
      }
    },
    [emblaApi],
  );
  var scrollNext = React.useCallback(
    function () {
      if (emblaApi) {
        var curSlideIndex = emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.selectedScrollSnap();
        var nextIndexStep = ((curSlideIndex + 1) % cardsLength) + 1;
        setSlideNumber(nextIndexStep);
        emblaApi.scrollNext();
      }
    },
    [emblaApi],
  );
  return jsxRuntime.jsxs(Paper, {
    theme: theme,
    className: cx(style$h.TestimonialsPanelCarousel, className),
    children: [
      jsxRuntime.jsx('div', { className: style$h.TestimonialsPanelCarouselTitle, children: title }),
      jsxRuntime.jsxs('div', {
        className: style$h.embla,
        children: [
          jsxRuntime.jsx('div', {
            className: style$h.embla__viewport,
            ref: !containsSingleCard ? emblaRef : null,
            children: jsxRuntime.jsx('div', {
              className: style$h.embla__container,
              children: cards.map(function (card, i) {
                return jsxRuntime.jsx(
                  'div',
                  {
                    className: style$h.embla__slide,
                    children: jsxRuntime.jsx(TestimonialsPanelCard, {
                      imageSrc: card === null || card === void 0 ? void 0 : card.imageSrc,
                      imageAlt: card === null || card === void 0 ? void 0 : card.imageAlt,
                      quote: card === null || card === void 0 ? void 0 : card.quote,
                      author: card === null || card === void 0 ? void 0 : card.author,
                    }),
                  },
                  (card === null || card === void 0 ? void 0 : card.author) + i,
                );
              }),
            }),
          }),
          !containsSingleCard &&
            jsxRuntime.jsxs(jsxRuntime.Fragment, {
              children: [
                jsxRuntime.jsx('div', { className: style$h.TestimonialsPanelCarouselButtonDivider }),
                jsxRuntime.jsxs('div', {
                  className: style$h.TestimonialsPanelCarouselControlsContainer,
                  children: [
                    jsxRuntime.jsxs('div', {
                      children: [
                        jsxRuntime.jsx('button', {
                          className: cx(style$h.TestimonialsPanelCarouselButton, style$h.embla__prev),
                          onClick: scrollPrev,
                          children: jsxRuntime.jsx(Icon, {
                            className: style$h.TestimonialsPanelCarouselButtonIconLeft,
                            name: 'chevron2-left',
                            size: '2x',
                          }),
                        }),
                        jsxRuntime.jsx('button', {
                          className: cx(style$h.TestimonialsPanelCarouselButton, style$h.embla__next),
                          onClick: scrollNext,
                          children: jsxRuntime.jsx(Icon, {
                            className: style$h.TestimonialsPanelCarouselButtonIconRight,
                            name: 'chevron2-right',
                            size: '2x',
                          }),
                        }),
                      ],
                    }),
                    jsxRuntime.jsx('div', {
                      children: jsxRuntime.jsx(SlideRatio, { num1: slideNumber, num2: cardsLength }),
                    }),
                  ],
                }),
              ],
            }),
        ],
      }),
    ],
  });
};
TestimonialsPanelCarousel.propTypes = {
  className: PropTypes__default['default'].string,
  infiniteLoop: PropTypes__default['default'].bool,
  title: PropTypes__default['default'].string.isRequired,
  theme: PropTypes__default['default'].oneOf(['plain', 'elevated', 'medium', 'dark']),
  cards: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      imageSrc: PropTypes__default['default'].string.isRequired,
      imageAlt: PropTypes__default['default'].string.isRequired,
      quote: PropTypes__default['default'].string.isRequired,
      author: PropTypes__default['default'].string,
    }),
  ),
};

var style$g = {
  FeaturedContentCarousel: 'htco-FeaturedContentCarousel',
  embla: 'htco-embla',
  embla__container: 'htco-embla__container',
  embla__slide: 'htco-embla__slide',
  embla__dots: 'htco-embla__dots',
  embla__dot: 'htco-embla__dot',
  is_selected: 'htco-is_selected',
  hasSingleVisibleCard: 'htco-hasSingleVisibleCard',
  embla__viewport: 'htco-embla__viewport',
  FeaturedContentCarouselCard: 'htco-FeaturedContentCarouselCard',
  hasMultipleCards: 'htco-hasMultipleCards',
  isLight: 'htco-isLight',
  FeaturedContentCarouselCardOuterContainer: 'htco-FeaturedContentCarouselCardOuterContainer',
  hasImage: 'htco-hasImage',
  FeaturedContentCarouselCardTitle: 'htco-FeaturedContentCarouselCardTitle',
  FeaturedContentCarouselCardInnerContainer: 'htco-FeaturedContentCarouselCardInnerContainer',
  FeaturedContentCarouselDisclaimer: 'htco-FeaturedContentCarouselDisclaimer',
  FeaturedContentCarouselImageContainer: 'htco-FeaturedContentCarouselImageContainer',
  FeaturedContentCarouselCardText: 'htco-FeaturedContentCarouselCardText',
  FeaturedContentCarouselCardExtraText: 'htco-FeaturedContentCarouselCardExtraText',
  FeaturedContentCarouselNavContainer: 'htco-FeaturedContentCarouselNavContainer',
  FeaturedContentCarouselButton: 'htco-FeaturedContentCarouselButton',
};

/*
  This Carousel was made with Embla Carousel. Docs are here: https://www.embla-carousel.com/guides/
*/
var DotButton = function (_a) {
  var _b;
  var selected = _a.selected,
    onClick = _a.onClick;
  return jsxRuntime.jsx('button', {
    className: cx(style$g.embla__dot, ((_b = {}), (_b[style$g.is_selected] = !!selected), _b)),
    type: 'button',
    onClick: onClick,
  });
};
var themeMap = {
  dark: style$g.isDark,
  light: style$g.isLight,
};
// Each card theme has a corresponding button theme
var buttonThemeMap = {
  dark: 'alternative',
  light: 'primary',
};
var FeaturedCarouselCardWrapper = function (_a) {
  var _b, _c, _d;
  var theme = _a.theme,
    title = _a.title,
    header = _a.header,
    text = _a.text,
    extraText = _a.extraText,
    image = _a.image,
    disclaimer = _a.disclaimer,
    multipleCards = _a.multipleCards,
    children = _a.children,
    outerContainerClassName = _a.outerContainerClassName,
    innerContainerClassName = _a.innerContainerClassName;
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  var classes = cx(
    style$g.FeaturedContentCarouselCard,
    themeMap[theme],
    ((_b = {}), (_b[style$g.hasMultipleCards] = multipleCards), _b),
  );
  return jsxRuntime.jsx('div', {
    className: classes,
    children: jsxRuntime.jsxs('div', {
      className: cx(
        style$g.FeaturedContentCarouselCardOuterContainer,
        outerContainerClassName,
        ((_c = {}), (_c[style$g.hasImage] = image), _c),
      ),
      children: [
        jsxRuntime.jsxs('div', {
          className: cx(
            style$g.FeaturedContentCarouselCardInnerContainer,
            innerContainerClassName,
            ((_d = {}), (_d[style$g.hasImage] = image), _d),
          ),
          children: [
            jsxRuntime.jsx('span', { className: style$g.FeaturedContentCarouselCardTitle, children: title }),
            jsxRuntime.jsx('h2', { children: header }),
            jsxRuntime.jsxs('div', {
              className: style$g.FeaturedContentCarouselCardText,
              children: [
                text,
                ' ',
                extraText &&
                  jsxRuntime.jsx('span', {
                    className: style$g.FeaturedContentCarouselCardExtraText,
                    children: extraText,
                  }),
              ],
            }),
            children,
            disclaimer &&
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
              jsxRuntime.jsx('div', {
                className: cx(style$g.FeaturedContentCarouselDisclaimer, themeMap[theme]),
                children: disclaimer,
              }),
          ],
        }),
        image &&
          jsxRuntime.jsx('div', {
            className: style$g.FeaturedContentCarouselImageContainer,
            children: jsxRuntime.jsx('img', { src: image, alt: 'ad icon' }),
          }),
      ],
    }),
  });
};
var FeaturedContentCarouselCard = function (_a) {
  var _b;
  var theme = _a.theme,
    title = _a.title,
    header = _a.header,
    text = _a.text,
    extraText = _a.extraText,
    linkText = _a.linkText,
    href = _a.href,
    image = _a.image,
    disclaimer = _a.disclaimer,
    isLoading = _a.isLoading,
    loaderProps = _a.loaderProps,
    multipleCards = _a.multipleCards,
    outerContainerClassName = _a.outerContainerClassName,
    innerContainerClassName = _a.innerContainerClassName;
  return jsxRuntime.jsx(FeaturedCarouselCardWrapper, {
    theme: theme,
    title: title,
    header: header,
    text: text,
    extraText: extraText,
    image: image,
    disclaimer: disclaimer,
    multipleCards: multipleCards,
    outerContainerClassName: outerContainerClassName,
    innerContainerClassName: innerContainerClassName,
    children: isLoading
      ? jsxRuntime.jsx(Loader, __assign({}, loaderProps))
      : jsxRuntime.jsx(Button, {
          className: cx(
            style$g.FeaturedContentCarouselCardLink,
            style$g.FeaturedContentCarouselButtonActivity,
            ((_b = {}),
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            (_b[themeMap[theme]] = theme === 'light'),
            _b),
          ),
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          theme: buttonThemeMap[theme],
          size: 'small',
          href: href,
          target: '_blank',
          children: linkText,
        }),
  });
};
var FeaturedContentCarousel = function (_a) {
  var _b, _c;
  var className = _a.className,
    outerContainerClassName = _a.outerContainerClassName,
    innerContainerClassName = _a.innerContainerClassName,
    emblaClassName = _a.emblaClassName,
    _d = _a.infiniteLoop,
    infiniteLoop = _d === void 0 ? true : _d,
    _e = _a.cards,
    cards = _e === void 0 ? [] : _e;
  var multipleCards = cards.length > 1;
  var _f = useEmblaCarousel({ loop: infiniteLoop, draggable: multipleCards }),
    emblaRef = _f[0],
    emblaApi = _f[1];
  var _g = React.useState(0),
    selectedIndex = _g[0],
    setSelectedIndex = _g[1];
  var _h = React.useState([]),
    scrollSnaps = _h[0],
    setScrollSnaps = _h[1];
  var scrollPrev = React.useCallback(
    function () {
      if (emblaApi) emblaApi.scrollPrev();
    },
    [emblaApi],
  );
  var scrollNext = React.useCallback(
    function () {
      if (emblaApi) emblaApi.scrollNext();
    },
    [emblaApi],
  );
  var scrollTo = React.useCallback(
    function (index) {
      return emblaApi && emblaApi.scrollTo(index);
    },
    [emblaApi],
  );
  var onSelect = React.useCallback(
    function () {
      if (!emblaApi) return;
      setSelectedIndex(emblaApi.selectedScrollSnap());
    },
    [emblaApi, setSelectedIndex],
  );
  React.useEffect(
    function () {
      if (!emblaApi) return;
      onSelect();
      // @ts-expect-error TS(2345): Argument of type 'number[]' is not assignable to p... Remove this comment to see the full error message
      setScrollSnaps(emblaApi.scrollSnapList());
      emblaApi.on('select', onSelect);
    },
    [emblaApi, setScrollSnaps, onSelect],
  );
  var visibleCards = React.useMemo(
    function () {
      // @ts-expect-error TS(7006): Parameter 'card' implicitly has an 'any' type.
      return cards.filter(function (card) {
        return !card.shouldHide;
      });
    },
    [cards],
  );
  return jsxRuntime.jsx('div', {
    className: cx(
      style$g.FeaturedContentCarousel,
      className,
      ((_b = {}), (_b[style$g.hasSingleVisibleCard] = visibleCards.length === 1), _b),
    ),
    children: jsxRuntime.jsxs('div', {
      className: cx(style$g.embla, emblaClassName),
      children: [
        jsxRuntime.jsx('div', {
          className: style$g.embla__viewport,
          ref: emblaRef,
          children: jsxRuntime.jsx('div', {
            className: style$g.embla__container,
            children: visibleCards.map(function (card, i) {
              return jsxRuntime.jsx(
                'div',
                {
                  className: style$g.embla__slide,
                  children: jsxRuntime.jsx(FeaturedContentCarouselCard, {
                    theme: card === null || card === void 0 ? void 0 : card.theme,
                    title: card === null || card === void 0 ? void 0 : card.title,
                    header: card === null || card === void 0 ? void 0 : card.header,
                    text: card === null || card === void 0 ? void 0 : card.text,
                    extraText: card === null || card === void 0 ? void 0 : card.extraText,
                    linkText: card === null || card === void 0 ? void 0 : card.linkText,
                    href: card === null || card === void 0 ? void 0 : card.href,
                    image: card === null || card === void 0 ? void 0 : card.image,
                    disclaimer: card === null || card === void 0 ? void 0 : card.disclaimer,
                    isLoading: card === null || card === void 0 ? void 0 : card.isLoading,
                    loaderProps: card === null || card === void 0 ? void 0 : card.loaderProps,
                    multipleCards: multipleCards,
                    outerContainerClassName: outerContainerClassName,
                    innerContainerClassName: innerContainerClassName,
                  }),
                },
                (card === null || card === void 0 ? void 0 : card.href) + i,
              );
            }),
          }),
        }),
        visibleCards.length > 1 &&
          jsxRuntime.jsxs('div', {
            className: cx(
              style$g.FeaturedContentCarouselNavContainer,
              ((_c = {}), (_c[style$g.hasMultipleCards] = multipleCards), _c),
            ),
            children: [
              jsxRuntime.jsx('button', {
                className: cx(style$g.FeaturedContentCarouselButton, style$g.embla__prev),
                onClick: scrollPrev,
                children: jsxRuntime.jsx(Icon, { name: 'chevron2-left' }),
              }),
              jsxRuntime.jsx('div', {
                className: style$g.embla__dots,
                children: scrollSnaps.map(function (_, index) {
                  return jsxRuntime.jsx(
                    DotButton,
                    {
                      selected: index === selectedIndex,
                      onClick: function () {
                        return scrollTo(index);
                      },
                    },
                    index,
                  );
                }),
              }),
              jsxRuntime.jsx('button', {
                className: cx(style$g.FeaturedContentCarouselButton, style$g.embla__next),
                onClick: scrollNext,
                children: jsxRuntime.jsx(Icon, { name: 'chevron2-right' }),
              }),
            ],
          }),
      ],
    }),
  });
};
FeaturedContentCarousel.propTypes = {
  className: PropTypes__default['default'].string,
  outerContainerClassName: PropTypes__default['default'].string,
  innerContainerClassName: PropTypes__default['default'].string,
  emblaClassName: PropTypes__default['default'].string,
  infiniteLoop: PropTypes__default['default'].bool,
  cards: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      theme: PropTypes__default['default'].oneOf(['dark', 'light']),
      title: PropTypes__default['default'].string.isRequired,
      header: PropTypes__default['default'].string.isRequired,
      text: PropTypes__default['default'].string.isRequired,
      extraText: PropTypes__default['default'].string,
      linkText: PropTypes__default['default'].string.isRequired,
      href: PropTypes__default['default'].string.isRequired,
      image: PropTypes__default['default'].string,
      disclaimer: PropTypes__default['default'].string,
      shouldHide: PropTypes__default['default'].bool,
      isLoading: PropTypes__default['default'].bool,
      loaderProps: PropTypes__default['default'].object,
      multipleCards: PropTypes__default['default'].bool,
    }),
  ),
};

var ENVIRONMENTS = {
  local: { label: 'local', theme: 'purple' },
  sand: { label: 'sandbox', theme: 'primaryBlue15' },
  dev: { label: 'development', theme: 'green' },
  stage: { label: 'staging', theme: 'lightBlue' },
  test: { label: 'test', theme: 'teal' },
  prod: { label: 'production', theme: null },
};
var getEnvTheme = function (env) {
  var _a;
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return ((_a = ENVIRONMENTS[env]) === null || _a === void 0 ? void 0 : _a.theme) || null;
};
var isProd = function (env) {
  return env === 'prod';
};
var isStage = function (env) {
  return env === 'stage';
};
var getEnvLabel = function (env) {
  var _a;
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return ((_a = ENVIRONMENTS[env]) === null || _a === void 0 ? void 0 : _a.label) || env;
};
// Exposed in this way to allow us to stub this method in tests
var locationHelper = {
  getOrigin: function () {
    return window.location.origin;
  },
};
var EnvConfig = function () {
  /**
   * @returns {object} helper functions to configure global variables based on logic based on environment
   */
  var getEnv = function () {
    var origin = locationHelper.getOrigin();
    var hostname = origin.split('//').slice(-1)[0];
    var domain = hostname.split('.').slice(-2).join('.');
    if (/localhost/.exec(hostname) || /127.0.0.1/.exec(hostname)) {
      return 'local';
    }
    var domainToAccountMap = { 'htap.sh': 'sand', 'htap.im': 'dev', 'hometap.com': 'prod', 'htap.co': 'prod' };
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    var account = domainToAccountMap[domain];
    if (account !== 'prod') {
      return account;
    }
    return /^staging/.exec(hostname) ? 'stage' : 'prod';
  };
  var getBackendUrlForEnv = function (env) {
    var origin = locationHelper.getOrigin();
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    var hostname = origin.split('//').pop().split(':')[0];
    var protocol = origin.split('//').slice(0)[0];
    var fixedNameMap = {
      prod: 'https://portal.hometap.com/',
      stage: 'https://staging-portal.hometap.com/',
      local: 'http://'.concat(hostname, ':8000/'),
    };
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (fixedNameMap[env]) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      return fixedNameMap[env];
    }
    return ''.concat(protocol, '//').concat(hostname.replace(/^(client|staff)-/, ''), '/');
  };
  return {
    getEnv: getEnv,
    getBackendUrlForEnv: function () {
      return getBackendUrlForEnv(getEnv());
    },
    isProd: function () {
      return isProd(getEnv());
    },
    isStage: function () {
      return isStage(getEnv());
    },
    getEnvLabel: function () {
      return getEnvLabel(getEnv());
    },
    getEnvTheme: function () {
      return getEnvTheme(getEnv());
    },
  };
};

var img$8 =
  "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='140px' height='36px' viewBox='0 0 140 36' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 59.1 (86144) - https://sketch.com --%3e %3ctitle%3eLogos/logo-hometap%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Components/Header---Mobile' transform='translate(-15.000000%2c -12.000000)'%3e %3cg id='Logos/logo-hometap'%3e %3cg transform='translate(15.000000%2c 11.000000)'%3e %3cg id='hometap-logo-horizontal' transform='translate(0.000000%2c 1.296296)'%3e %3cpath d='M134.029851%2c27.3432836 C132.41791%2c27.3432836 130.925373%2c26.7462687 130.089552%2c25.641791 L130.089552%2c31.1940299 L127.61194%2c32.0597015 L127.61194%2c15.2835821 L130.089552%2c15.2835821 L130.089552%2c16.9253731 C131.044776%2c15.7313433 132.477612%2c15.0149254 134%2c15.0447761 C137.074627%2c15.0447761 139.850746%2c17.4029851 139.850746%2c21.1641791 C139.850746%2c24.9552239 136.985075%2c27.3432836 134.029851%2c27.3432836 L134.029851%2c27.3432836 Z M119.462687%2c25.0149254 C121.58209%2c25.0149254 123.164179%2c23.2835821 123.164179%2c21.1641791 C123.104478%2c19.1044776 121.373134%2c17.5223881 119.343284%2c17.5820896 C117.313433%2c17.641791 115.701493%2c19.3731343 115.761194%2c21.4029851 C115.820896%2c23.4328358 117.462687%2c25.0149254 119.462687%2c25.0149254 Z M133.791045%2c25.0149254 C135.910448%2c25.0149254 137.492537%2c23.2835821 137.492537%2c21.1641791 C137.432836%2c19.1044776 135.701493%2c17.5223881 133.671642%2c17.5820896 C131.641791%2c17.641791 130.029851%2c19.3731343 130.089552%2c21.4029851 C130.149254%2c23.4328358 131.791045%2c25.0149254 133.791045%2c25.0149254 Z M119.104478%2c27.3134328 C116.119403%2c27.3134328 113.283582%2c24.9253731 113.283582%2c21.1940299 C113.283582%2c17.4328358 116.059701%2c15.0746269 119.134328%2c15.0746269 C120.626866%2c15.0447761 122.059701%2c15.7014925 123.014925%2c16.8358209 L123.014925%2c15.3134328 L125.522388%2c15.3134328 L125.522388%2c27.0746269 L123.014925%2c27.0746269 L123.014925%2c25.4626866 C122.059701%2c26.6268657 120.626866%2c27.3134328 119.104478%2c27.3134328 L119.104478%2c27.3134328 Z' id='Shape' fill='%23434C5E' fill-rule='nonzero'%3e%3c/path%3e %3cpath d='M107.164179%2c10.8955224 L109.641791%2c10 L109.641791%2c15.0447761 L112.089552%2c15.0447761 L112.089552%2c17.3432836 L109.641791%2c17.3432836 L109.641791%2c22.0895522 C109.641791%2c24.238806 109.970149%2c24.5671642 112.089552%2c24.5671642 L112.089552%2c26.9850746 L111.731343%2c26.9850746 C108.238806%2c26.9850746 107.19403%2c25.8507463 107.19403%2c22.0895522 L107.19403%2c17.3134328 L105.253731%2c17.3134328 L105.253731%2c15.0149254 L107.19403%2c15.0149254 L107.164179%2c10.8955224 Z' id='Path' fill='%23434C5E' fill-rule='nonzero'%3e%3c/path%3e %3cpath d='M98.5373134%2c17.2835821 C96.8656716%2c17.2537313 95.4029851%2c18.3283582 94.9253731%2c19.9104478 L102.029851%2c19.9104478 C101.671642%2c18.238806 100.358209%2c17.2835821 98.5373134%2c17.2835821 Z M101.910448%2c23.3134328 L104.179104%2c24.119403 C103.134328%2c26.0597015 101.253731%2c27.3134328 98.6268657%2c27.3134328 C94.8955224%2c27.3134328 92.3880597%2c24.6567164 92.3880597%2c21.2537313 C92.3283582%2c17.9104478 95.0149254%2c15.1641791 98.358209%2c15.0746269 C98.4179104%2c15.0746269 98.4776119%2c15.0746269 98.5373134%2c15.0746269 C102.029851%2c15.0746269 104.626866%2c17.5820896 104.626866%2c21.0746269 L104.626866%2c22.0597015 L94.8358209%2c22.0597015 C95.1641791%2c23.880597 96.5970149%2c25.0746269 98.6567164%2c25.0746269 C99.9701493%2c25.1044776 101.223881%2c24.4477612 101.910448%2c23.3134328 L101.910448%2c23.3134328 Z' id='Shape' fill='%23434C5E' fill-rule='nonzero'%3e%3c/path%3e %3cpath d='M72.0895522%2c27.1641791 L72.0895522%2c15.4626866 L74.5970149%2c15.4626866 L74.5970149%2c16.8656716 C75.4029851%2c15.7910448 76.7164179%2c15.1641791 78.0895522%2c15.2238806 C79.9701493%2c15.2238806 81.3134328%2c16.0298507 82%2c17.3432836 C82.8656716%2c16 84.3880597%2c15.1940299 86%2c15.2238806 C89.2238806%2c15.2238806 90.8955224%2c17.1343284 90.8955224%2c20.1492537 L90.8955224%2c27.1641791 L88.3283582%2c27.1641791 L88.3283582%2c20.2985075 C88.3283582%2c18.5373134 87.3432836%2c17.4029851 85.5820896%2c17.4029851 C84%2c17.4029851 82.7761194%2c18.4776119 82.7761194%2c20.5671642 L82.7761194%2c27.1641791 L80.2089552%2c27.1641791 L80.2089552%2c20.1791045 C80.2089552%2c18.4776119 79.2238806%2c17.4029851 77.5223881%2c17.4029851 C75.8507463%2c17.4029851 74.6268657%2c18.5074627 74.6268657%2c20.6567164 L74.6268657%2c27.1641791 L72.0895522%2c27.1641791 Z' id='Path' fill='%23434C5E' fill-rule='nonzero'%3e%3c/path%3e %3cpath d='M64.2089552%2c24.9552239 C66.2985075%2c24.8656716 67.9104478%2c23.1044776 67.8208955%2c21.0447761 C67.7313433%2c19.0746269 66.1791045%2c17.5223881 64.2089552%2c17.4328358 C62.1791045%2c17.4328358 60.6268657%2c19.1343284 60.6268657%2c21.1940299 C60.5970149%2c23.2537313 62.1791045%2c24.9552239 64.2089552%2c24.9552239 L64.2089552%2c24.9552239 Z M64.2089552%2c27.3134328 C60.8358209%2c27.3134328 58.0895522%2c24.5970149 58.0597015%2c21.2238806 C58.0298507%2c17.8507463 60.7761194%2c15.1044776 64.1492537%2c15.0746269 C67.5223881%2c15.0746269 70.2686567%2c17.7910448 70.2985075%2c21.1641791 C70.2985075%2c21.1641791 70.2985075%2c21.1641791 70.2985075%2c21.1940299 C70.3283582%2c24.5373134 67.641791%2c27.2835821 64.2985075%2c27.3134328 C64.2686567%2c27.3134328 64.238806%2c27.3134328 64.2089552%2c27.3134328 L64.2089552%2c27.3134328 Z' id='Shape' fill='%23434C5E' fill-rule='nonzero'%3e%3c/path%3e %3cpath d='M45.2238806%2c27.0149254 L45.2238806%2c10.8955224 L47.761194%2c10 L47.761194%2c16.5671642 C48.6567164%2c15.4328358 50%2c14.8059701 51.4328358%2c14.8059701 C54.4477612%2c14.8059701 56.2686567%2c16.7761194 56.2686567%2c20.0298507 L56.2686567%2c27.0149254 L53.6716418%2c27.0149254 L53.6716418%2c20.2686567 C53.6716418%2c18.2686567 52.7164179%2c17.0447761 50.7761194%2c17.0447761 C49.0746269%2c17.0447761 47.761194%2c18.3283582 47.761194%2c20.4477612 L47.761194%2c27.0149254 L45.2238806%2c27.0149254 L45.2238806%2c27.0149254 Z' id='Path' fill='%23434C5E' fill-rule='nonzero'%3e%3c/path%3e %3cg id='Group' fill-rule='nonzero'%3e %3cpath d='M29.8507463%2c26.7164179 L29.7313433%2c26.7761194 L29.3432836%2c26.9253731 C25.641791%2c27.9104478 21.8507463%2c28.3880597 18.0298507%2c28.3880597 C13.9701493%2c28.4477612 9.94029851%2c27.880597 6.05970149%2c26.7462687 L6.05970149%2c26.7462687 L5.97014925%2c26.7164179 L1.1641791%2c23.8208955 C2.95522388%2c28.8656716 6.92537313%2c32.8358209 12%2c34.6567164 L12%2c34.6567164 L12%2c34.6567164 C15.8208955%2c36 20%2c36 23.8208955%2c34.6567164 L23.8208955%2c34.6567164 L23.8208955%2c34.6567164 C28.8656716%2c32.8656716 32.8656716%2c28.8955224 34.6567164%2c23.8208955 L29.8507463%2c26.7164179 Z' id='Path' fill='%239BEABB'%3e%3c/path%3e %3cpath d='M35.6716418%2c17.9104478 L33.3731343%2c21.1641791 L29.7313433%2c26.7761194 L23.7910448%2c34.6567164 C28.8358209%2c32.8656716 32.8358209%2c28.8955224 34.6268657%2c23.8208955 L34.6268657%2c23.8208955 L34.6268657%2c23.8208955 C35.3432836%2c21.9402985 35.6716418%2c19.9402985 35.6716418%2c17.9104478 L35.6716418%2c17.9104478 Z' id='Path' fill='%2340C089'%3e%3c/path%3e %3cpath d='M6.05970149%2c26.7761194 L2.44776119%2c21.1641791 L0.149253731%2c17.9104478 L0.149253731%2c17.9104478 C0.149253731%2c19.9402985 0.47761194%2c21.9402985 1.1641791%2c23.8208955 L1.1641791%2c23.8208955 L1.1641791%2c23.8208955 C2.95522388%2c28.8656716 6.92537313%2c32.8358209 12%2c34.6567164 L6.05970149%2c26.7761194 Z' id='Path' fill='%2339C564'%3e%3c/path%3e %3cpath d='M4.68656716%2c6.05970149 C1.76119403%2c9.31343284 0.149253731%2c13.5522388 0.149253731%2c17.9104478 L0.149253731%2c17.9104478 C0.149253731%2c19.9402985 0.47761194%2c21.9402985 1.1641791%2c23.8208955 L1.1641791%2c23.8208955 L1.1641791%2c23.8208955 C2.14925373%2c26.6268657 3.85074627%2c29.1343284 6.05970149%2c31.1343284 L6.05970149%2c4.68656716 C5.58208955%2c5.10447761 5.13432836%2c5.58208955 4.68656716%2c6.05970149 Z' id='Path' fill='%2300C5FF'%3e%3c/path%3e %3cpath d='M35.6716418%2c17.9104478 C35.6716418%2c12.8656716 33.5223881%2c8.05970149 29.761194%2c4.68656716 L29.761194%2c31.1343284 C31.9701493%2c29.1343284 33.6716418%2c26.6268657 34.6567164%2c23.8208955 L34.6567164%2c23.8208955 L34.6567164%2c23.8208955 C35.3432836%2c21.9402985 35.6716418%2c19.9402985 35.6716418%2c17.9104478 L35.6716418%2c17.9104478 Z' id='Path' fill='%23AEE4FF'%3e%3c/path%3e %3cpath d='M34.6567164%2c12 C32.8656716%2c6.95522388 28.8955224%2c2.95522388 23.8208955%2c1.1641791 L23.8208955%2c1.1641791 L23.8208955%2c1.1641791 C20%2c-0.179104478 15.8208955%2c-0.179104478 12%2c1.1641791 L17.9104478%2c5.34328358 L29.7313433%2c13.7313433 L35.641791%2c17.9104478 C35.6716418%2c15.880597 35.3134328%2c13.880597 34.6567164%2c12 Z' id='Path' fill='%23C7A2FB'%3e%3c/path%3e %3cpath d='M17.9104478%2c31.8507463 L12%2c34.6567164 C15.8208955%2c36 20%2c36 23.8208955%2c34.6567164 L17.9104478%2c31.8507463 Z' id='Path' fill='%2339C564'%3e%3c/path%3e %3cpath d='M17.9104478%2c0.149253731 C15.9104478%2c0.149253731 13.9104478%2c0.507462687 12%2c1.1641791 L12%2c1.1641791 L12%2c1.1641791 C4.89552239%2c3.67164179 0.149253731%2c10.3880597 0.149253731%2c17.9104478 L6.05970149%2c13.7313433 L17.9104478%2c5.34328358 L23.8208955%2c1.1641791 C21.9104478%2c0.507462687 19.9104478%2c0.149253731 17.9104478%2c0.149253731 Z' id='Path' fill='%233E4DE9'%3e%3c/path%3e %3cpath d='M6.05970149%2c4.68656716 L6.05970149%2c13.7313433 L12%2c1.1641791 C9.82089552%2c1.94029851 7.79104478%2c3.13432836 6.05970149%2c4.68656716 Z' id='Path' fill='%23366CED'%3e%3c/path%3e %3cpath d='M4.68656716%2c6.05970149 C1.76119403%2c9.31343284 0.149253731%2c13.5522388 0.149253731%2c17.9104478 L6.05970149%2c13.7313433 L6.05970149%2c4.68656716 C5.58208955%2c5.10447761 5.13432836%2c5.58208955 4.68656716%2c6.05970149 Z' id='Path' fill='%230054ED'%3e%3c/path%3e %3cpolygon id='Path' fill='%234F79ED' points='12 1.1641791 12 1.1641791 12 1.1641791 6.05970149 13.7313433 6.05970149 13.7313433 17.9104478 5.34328358 17.9104478 5.34328358'%3e%3c/polygon%3e %3cpath d='M0.149253731%2c17.9104478 L0.149253731%2c17.9104478 C0.149253731%2c19.9402985 0.47761194%2c21.9402985 1.1641791%2c23.8208955 L2.44776119%2c21.1343284 L0.149253731%2c17.9104478 Z' id='Path' fill='%2300A2BB'%3e%3c/path%3e %3cpath d='M6.05970149%2c26.7761194 L6.05970149%2c31.1641791 C7.79104478%2c32.7164179 9.79104478%2c33.9104478 12%2c34.6865672 L6.05970149%2c26.7761194 Z' id='Path' fill='%2339C564'%3e%3c/path%3e %3cpolygon id='Path' fill='%2300B5BB' points='2.44776119 21.1641791 1.1641791 23.8507463 1.1641791 23.8507463 1.1641791 23.8507463 6.05970149 26.7761194'%3e%3c/polygon%3e %3cpath d='M5.97014925%2c26.7164179 L1.1641791%2c23.8208955 C2.14925373%2c26.6268657 3.85074627%2c29.1343284 6.05970149%2c31.1343284 L6.05970149%2c26.7761194 L5.97014925%2c26.7164179 Z' id='Path' fill='%2300A689'%3e%3c/path%3e %3cpolygon id='Path' fill='%2300B0FF' points='0.149253731 17.9104478 0.149253731 17.9104478 2.44776119 21.1641791 6.05970149 13.7313433'%3e%3c/polygon%3e %3cpolygon id='Path' fill='%2300C5FF' points='6.05970149 13.7313433 2.44776119 21.1641791 6.05970149 26.7761194 6.05970149 26.7761194'%3e%3c/polygon%3e %3cpolygon id='Path' fill='%235ED789' points='6.05970149 26.7761194 12 34.6567164 12 34.6567164 12 34.6567164 17.9104478 31.8507463 17.9104478 31.8507463'%3e%3c/polygon%3e %3cpath d='M35.6716418%2c17.9104478 L35.6716418%2c17.9104478 C35.6716418%2c19.9402985 35.3432836%2c21.9402985 34.6567164%2c23.8208955 L33.3731343%2c21.1343284 L35.6716418%2c17.9104478 Z' id='Path' fill='%235385B8'%3e%3c/path%3e %3cpath d='M29.761194%2c4.68656716 L29.761194%2c13.7313433 L23.8208955%2c1.1641791 C26%2c1.94029851 28.0298507%2c3.13432836 29.761194%2c4.68656716 Z' id='Path' fill='%239B67F7'%3e%3c/path%3e %3cpath d='M29.761194%2c26.7761194 L29.761194%2c31.1641791 C28.0298507%2c32.7164179 26.0298507%2c33.9104478 23.8208955%2c34.6865672 L29.761194%2c26.7761194 Z' id='Path' fill='%2339C564'%3e%3c/path%3e %3cpath d='M31.1343284%2c6.05970149 C34.0597015%2c9.31343284 35.6716418%2c13.5223881 35.6716418%2c17.9104478 L29.761194%2c13.7313433 L29.761194%2c4.68656716 C30.238806%2c5.10447761 30.6865672%2c5.58208955 31.1343284%2c6.05970149 Z' id='Path' fill='%236A5CF7'%3e%3c/path%3e %3cpolygon id='Path' fill='%236AD1BB' points='33.3731343 21.1641791 34.6567164 23.8507463 34.6567164 23.8507463 34.6567164 23.8507463 29.761194 26.7761194'%3e%3c/polygon%3e %3cpath d='M29.8507463%2c26.7164179 L34.6567164%2c23.8507463 C33.6716418%2c26.6567164 31.9701493%2c29.1641791 29.761194%2c31.1641791 L29.761194%2c26.7761194 L29.8507463%2c26.7164179 Z' id='Path' fill='%2340C089'%3e%3c/path%3e %3cpolygon id='Path' fill='%238891FB' points='35.6716418 17.9104478 35.6716418 17.9104478 33.3731343 21.1641791 29.761194 13.7313433'%3e%3c/polygon%3e %3cpolygon id='Path' fill='%23AEE4FF' points='29.761194 13.7313433 33.3731343 21.1641791 29.761194 26.7761194 29.761194 26.7761194'%3e%3c/polygon%3e %3cpolygon id='Path' fill='%23C7A2FB' points='23.8208955 1.1641791 23.8208955 1.1641791 23.8208955 1.1641791 29.761194 13.7313433 29.761194 13.7313433 17.9104478 5.34328358 17.9104478 5.34328358'%3e%3c/polygon%3e %3cpolygon id='Path' fill='%235ED789' points='29.761194 26.7761194 23.8208955 34.6567164 23.8208955 34.6567164 23.8208955 34.6567164 17.9104478 31.8507463 17.9104478 31.8507463'%3e%3c/polygon%3e %3cpath d='M18.0597015%2c28.3880597 C14%2c28.4477612 9.97014925%2c27.880597 6.08955224%2c26.7462687 L6.08955224%2c26.7761194 L17.9402985%2c31.8507463 L29.5223881%2c26.8955224 C25.761194%2c27.880597 21.9104478%2c28.3880597 18.0597015%2c28.3880597 Z' id='Path' fill='%239BEABB'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var style$f = {
  Badge: 'htco-Badge',
  isLarge: 'htco-isLarge',
  isPrimaryPurple100: 'htco-isPrimaryPurple100',
  isPrimaryPurple15: 'htco-isPrimaryPurple15',
  isPrimaryPurpleOutlined: 'htco-isPrimaryPurpleOutlined',
  isPrimaryTeal100: 'htco-isPrimaryTeal100',
  isPrimaryTeal15: 'htco-isPrimaryTeal15',
  isPrimaryTealOutlined: 'htco-isPrimaryTealOutlined',
  isPrimaryBlue100: 'htco-isPrimaryBlue100',
  isPrimaryBlue15: 'htco-isPrimaryBlue15',
  isPrimaryBlueOutlined: 'htco-isPrimaryBlueOutlined',
  isPrimaryGreen100: 'htco-isPrimaryGreen100',
  isPrimaryGreen15: 'htco-isPrimaryGreen15',
  isPrimaryGreenOutlined: 'htco-isPrimaryGreenOutlined',
  isSecondaryRed100: 'htco-isSecondaryRed100',
  isSecondaryRed15: 'htco-isSecondaryRed15',
  isSecondaryRedOutlined: 'htco-isSecondaryRedOutlined',
  isSecondaryOrange100: 'htco-isSecondaryOrange100',
  isSecondaryOrange15: 'htco-isSecondaryOrange15',
  isSecondaryOrangeOutlined: 'htco-isSecondaryOrangeOutlined',
  isSecondaryYellow100: 'htco-isSecondaryYellow100',
  isSecondaryYellow15: 'htco-isSecondaryYellow15',
  isSecondaryYellowOutlined: 'htco-isSecondaryYellowOutlined',
  isSecondaryGrey100: 'htco-isSecondaryGrey100',
  isSecondaryGrey15: 'htco-isSecondaryGrey15',
  isSecondaryGreyOutlined: 'htco-isSecondaryGreyOutlined',
  isPrimaryLightBlue100: 'htco-isPrimaryLightBlue100',
};

var COLOR_THEMES = {
  PRIMARY_PURPLE_100: 'primaryPurple100',
  PRIMARY_PURPLE_15: 'primaryPurple15',
  PRIMARY_PURPLE_OUTLINED: 'primaryPurpleOutlined',
  PRIMARY_TEAL_100: 'primaryTeal100',
  PRIMARY_TEAL_15: 'primaryTeal15',
  PRIMARY_TEAL_OUTLINED: 'primaryTealOutlined',
  PRIMARY_GREEN_100: 'primaryGreen100',
  PRIMARY_GREEN_15: 'primaryGreen15',
  PRIMARY_GREEN_OUTLINED: 'primaryGreenOutlined',
  PRIMARY_BLUE_100: 'primaryBlue100',
  PRIMARY_BLUE_15: 'primaryBlue15',
  PRIMARY_BLUE_OUTLINED: 'primaryBlueOutlined',
  SECONDARY_RED_100: 'secondaryRed100',
  SECONDARY_RED_15: 'secondaryRed15',
  SECONDARY_RED_OUTLINED: 'secondaryRedOutlined',
  SECONDARY_ORANGE_100: 'secondaryOrange100',
  SECONDARY_ORANGE_15: 'secondaryOrange15',
  SECONDARY_ORANGE_OUTLINED: 'secondaryOrangeOutlined',
  SECONDARY_YELLOW_100: 'secondaryYellow100',
  SECONDARY_YELLOW_15: 'secondaryYellow15',
  SECONDARY_YELLOW_OUTLINED: 'secondaryYellowOutlined',
  SECONDARY_GREY_100: 'secondaryGrey100',
  SECONDARY_GREY_15: 'secondaryGrey15',
  SECONDARY_GREY_OUTLINED: 'secondaryGreyOutlined',
  // Legacy Naming
  DANGER: 'danger',
  NEUTRAL_LIGHT_50: 'neutralLight50',
  NEUTRAL_DARK_50: 'neutralDark50',
  PRIMARY_LIGHT_BLUE_100: 'primaryLightBlue100',
  LEGACY_COLOR_LIGHT_BLUE: 'lightBlue',
  LEGACY_COLOR_PURPLE: 'purple',
  LEGACY_COLOR_TEAL: 'teal',
  LEGACY_COLOR_GREEN: 'green',
  LEGACY_COLOR_GRAY: 'gray',
};
var Badge = function (_a) {
  var _b;
  var label = _a.label,
    theme = _a.theme,
    large = _a.large,
    className = _a.className,
    props = __rest$1(_a, ['label', 'theme', 'large', 'className']);
  var themeModifierClassNameConfig =
    ((_b = {}),
    (_b[style$f.isPrimaryLightBlue100] =
      theme === COLOR_THEMES.PRIMARY_LIGHT_BLUE_100 || theme === COLOR_THEMES.LEGACY_COLOR_LIGHT_BLUE),
    (_b[style$f.isPrimaryPurple100] =
      theme === COLOR_THEMES.PRIMARY_PURPLE_100 || theme === COLOR_THEMES.LEGACY_COLOR_PURPLE),
    (_b[style$f.isPrimaryPurple15] = theme === COLOR_THEMES.PRIMARY_PURPLE_15),
    (_b[style$f.isPrimaryPurpleOutlined] = theme === COLOR_THEMES.PRIMARY_PURPLE_OUTLINED),
    (_b[style$f.isPrimaryTeal100] =
      theme === COLOR_THEMES.PRIMARY_TEAL_100 || theme === COLOR_THEMES.LEGACY_COLOR_TEAL),
    (_b[style$f.isPrimaryTeal15] = theme === COLOR_THEMES.PRIMARY_TEAL_15),
    (_b[style$f.isPrimaryTealOutlined] = theme === COLOR_THEMES.PRIMARY_TEAL_OUTLINED),
    (_b[style$f.isPrimaryGreen100] =
      theme === COLOR_THEMES.PRIMARY_GREEN_100 || theme === COLOR_THEMES.LEGACY_COLOR_GREEN),
    (_b[style$f.isPrimaryGreen15] = theme === COLOR_THEMES.PRIMARY_GREEN_15),
    (_b[style$f.isPrimaryGreenOutlined] = theme === COLOR_THEMES.PRIMARY_GREEN_OUTLINED),
    (_b[style$f.isPrimaryBlue100] = theme === COLOR_THEMES.PRIMARY_BLUE_100),
    (_b[style$f.isPrimaryBlue15] = theme === COLOR_THEMES.PRIMARY_BLUE_15),
    (_b[style$f.isPrimaryBlueOutlined] = theme === COLOR_THEMES.PRIMARY_BLUE_OUTLINED),
    (_b[style$f.isSecondaryRed100] = theme === COLOR_THEMES.SECONDARY_RED_100 || theme === COLOR_THEMES.DANGER),
    (_b[style$f.isSecondaryRed15] = theme === COLOR_THEMES.SECONDARY_RED_15),
    (_b[style$f.isSecondaryRedOutlined] = theme === COLOR_THEMES.SECONDARY_RED_OUTLINED),
    (_b[style$f.isSecondaryOrange100] = theme === COLOR_THEMES.SECONDARY_ORANGE_100),
    (_b[style$f.isSecondaryOrange15] = theme === COLOR_THEMES.SECONDARY_ORANGE_15),
    (_b[style$f.isSecondaryOrangeOutlined] = theme === COLOR_THEMES.SECONDARY_ORANGE_OUTLINED),
    (_b[style$f.isSecondaryYellow100] = theme === COLOR_THEMES.SECONDARY_YELLOW_100),
    (_b[style$f.isSecondaryYellow15] = theme === COLOR_THEMES.SECONDARY_YELLOW_15),
    (_b[style$f.isSecondaryYellowOutlined] = theme === COLOR_THEMES.SECONDARY_YELLOW_OUTLINED),
    (_b[style$f.isSecondaryGrey100] =
      theme === COLOR_THEMES.SECONDARY_GREY_100 ||
      theme === COLOR_THEMES.NEUTRAL_DARK_50 ||
      theme === COLOR_THEMES.LEGACY_COLOR_GRAY),
    (_b[style$f.isSecondaryGrey15] =
      theme === COLOR_THEMES.SECONDARY_GREY_15 || theme === COLOR_THEMES.NEUTRAL_LIGHT_50),
    (_b[style$f.isSecondaryGreyOutlined] = theme === COLOR_THEMES.SECONDARY_GREY_OUTLINED),
    (_b[style$f.isLarge] = large),
    _b);
  return jsxRuntime.jsx(
    'div',
    __assign({ className: cx(style$f.Badge, className, themeModifierClassNameConfig) }, props, { children: label }),
  );
};
Badge.propTypes = {
  label: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].node,
  ]).isRequired,
  theme: PropTypes__default['default'].oneOf(Object.values(COLOR_THEMES)).isRequired,
  large: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].string,
};

var style$e = {
  Header: 'htco-Header',
  isGreen: 'htco-isGreen',
  isLightBlue: 'htco-isLightBlue',
  isPurple: 'htco-isPurple',
  isTeal: 'htco-isTeal',
  HeaderLogoContainer: 'htco-HeaderLogoContainer',
  HeaderContainer: 'htco-HeaderContainer',
  HeaderTabsContainer: 'htco-HeaderTabsContainer',
  TabsContainer: 'htco-TabsContainer',
};

var Header = function (_a) {
  var children = _a.children,
    _b = _a.logoLink,
    logoLink = _b === void 0 ? 'https://www.hometap.com' : _b,
    _c = _a.environment,
    environment = _c === void 0 ? 'prod' : _c,
    className = _a.className;
  var envTheme = getEnvTheme(environment);
  var envClass = envTheme ? 'is'.concat(envTheme.charAt(0).toUpperCase() + envTheme.slice(1)) : null;
  return (
    // @ts-expect-error TS(2538): Type 'null' cannot be used as an index type.
    jsxRuntime.jsx('header', {
      className: cx(style$e.Header, style$e[envClass], className),
      children: jsxRuntime.jsxs('div', {
        className: style$e.HeaderContainer,
        children: [
          jsxRuntime.jsxs('div', {
            className: style$e.HeaderLogoContainer,
            children: [
              jsxRuntime.jsx('a', {
                href: logoLink,
                children: jsxRuntime.jsx('img', { src: img$8, alt: 'hometap logo' }),
              }),
              !isProd(environment) && jsxRuntime.jsx(Badge, { label: getEnvLabel(environment), theme: envTheme }),
            ],
          }),
          children,
        ],
      }),
    })
  );
};
Header.propTypes = {
  children: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].arrayOf(PropTypes__default['default'].node),
    PropTypes__default['default'].node,
  ]),
  logoLink: PropTypes__default['default'].string,
  environment: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  tabProps: PropTypes__default['default'].shape({
    className: PropTypes__default['default'].string,
    theme: PropTypes__default['default'].oneOf(['normal', 'inverse']),
    maxWidth: PropTypes__default['default'].string,
    muiSelectWidth: PropTypes__default['default'].string,
    onChange: PropTypes__default['default'].func.isRequired,
    curTab: PropTypes__default['default'].string,
    mobileBreakpoint: PropTypes__default['default'].oneOf([
      'xs',
      'sm',
      'md',
      'lg',
      'mobile',
      'mobileLg',
      'tablet',
      'tabletLg',
      'smallDesktop',
      'largeDesktop',
    ]),
    showBorderLine: PropTypes__default['default'].bool,
    scrollable: PropTypes__default['default'].bool,
  }),
};

var validateSSN = function (val) {
  var re = /^\d{3}-?\d{2}-?\d{4}$/g;
  return re.test(val);
};
var SSNInput = function (_a) {
  var props = __rest$1(_a, []);
  var _b = React.useState(),
    internalError = _b[0],
    setInternalError = _b[1];
  var validator = function (val) {
    if (val || props.required) {
      if (!validateSSN(val)) {
        return 'Please enter a valid Social Security Number. ###-##-####';
      } else if (props.validator) {
        return props.validator();
      }
    }
  };
  var handleBlur = function (val, name, err) {
    var _a, _b;
    setInternalError(validator(val));
    (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, val, name, err);
    if (!err) {
      (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, val, name, err);
    }
  };
  var handleChange = function (val, name, err) {
    var _a;
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, val, name, err);
    if (internalError && !validator(val)) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      setInternalError();
    }
  };
  return jsxRuntime.jsx(
    TextInput,
    __assign({ placeholder: 'e.g ###-##-####' }, props, {
      'aria-hidden': true,
      mask: '000-00-0000',
      autoComplete: 'off',
      error: props.error || internalError,
      validator: validator,
      onBlur: handleBlur,
      onChange: handleChange,
    }),
  );
};
SSNInput.propTypes = {
  name: PropTypes__default['default'].string,
  label: PropTypes__default['default'].node,
  error: PropTypes__default['default'].node,
  value: PropTypes__default['default'].string,
  required: PropTypes__default['default'].bool,
  validator: PropTypes__default['default'].func,
  onChange: PropTypes__default['default'].func,
  registerRequiredField: PropTypes__default['default'].func,
};

var style$d = {
  MenuDropdown: 'htco-MenuDropdown',
  MenuDropdownTrigger: 'htco-MenuDropdownTrigger',
  MenuDropdownChevron: 'htco-MenuDropdownChevron',
  MenuDropdownDots: 'htco-MenuDropdownDots',
  isDark: 'htco-isDark',
  isDisabled: 'htco-isDisabled',
  MenuDropdownContent: 'htco-MenuDropdownContent',
  MenuDropdownItem: 'htco-MenuDropdownItem',
};

// used for testing
var DEFAULT_MENU_OFFSET = 10;
var MenuDropdown = function (_a) {
  var _b, _c, _d;
  var _e = _a.position,
    position = _e === void 0 ? 'bottom-start' : _e,
    modifiers = _a.modifiers,
    trigger = _a.trigger,
    children = _a.children,
    className = _a.className,
    _f = _a.openClassName,
    openClassName = _f === void 0 ? '' : _f,
    _g = _a.showCaret,
    showCaret = _g === void 0 ? true : _g,
    menuWidth = _a.menuWidth,
    _h = _a.size,
    size = _h === void 0 ? 'lg' : _h,
    _j = _a.theme,
    theme = _j === void 0 ? 'primary' : _j,
    disabled = _a.disabled,
    onMenuChange = _a.onMenuChange,
    isMenuOpen = _a.isMenuOpen,
    props = __rest$1(_a, [
      'position',
      'modifiers',
      'trigger',
      'children',
      'className',
      'openClassName',
      'showCaret',
      'menuWidth',
      'size',
      'theme',
      'disabled',
      'onMenuChange',
      'isMenuOpen',
    ]);
  var _k = React.useState(null),
    triggerComponent = _k[0],
    setTriggerComponent = _k[1];
  var _l = React.useState(null),
    menuDropdown = _l[0],
    setMenuDropdown = _l[1];
  var _m = React.useState(isMenuOpen || false),
    isOpen = _m[0],
    setIsOpen = _m[1];
  var _o = React.useState(),
    outsideClickRef = _o[0],
    setOutsideClickRef = _o[1];
  React.useEffect(
    function () {
      if (isMenuOpen !== undefined) {
        setIsOpen(isMenuOpen);
      }
    },
    [isMenuOpen],
  );
  var _p = usePopper(triggerComponent, menuDropdown, {
      placement: position,
      modifiers: modifiers || [
        {
          name: 'offset',
          options: {
            offset: [0, DEFAULT_MENU_OFFSET],
          },
        },
      ],
    }),
    styles = _p.styles,
    attributes = _p.attributes;
  var handleVisibility = function (e) {
    setIsOpen(!isOpen);
    if (onMenuChange) onMenuChange(!isOpen);
    e.stopPropagation();
  };
  useOutsideClick(outsideClickRef, function () {
    setIsOpen(false);
    if (onMenuChange && isMenuOpen) {
      onMenuChange(false);
    }
  });
  return jsxRuntime.jsxs(
    'div',
    __assign({ className: cx(style$d.MenuDropdown, className, ((_b = {}), (_b[openClassName] = isOpen), _b)) }, props, {
      children: [
        jsxRuntime.jsxs('div', {
          className: cx(style$d.MenuDropdownTrigger, ((_c = {}), (_c[style$d.isDisabled] = disabled), _c)),
          role: 'button',
          tabIndex: 0,
          // @ts-expect-error TS(2322): Type 'Dispatch<SetStateAction<null>>' is not assig... Remove this comment to see the full error message
          ref: setTriggerComponent,
          onClick: handleVisibility,
          onKeyDown: function (e) {
            if (!disabled) {
              handleKeyboardEnter(handleVisibility)(e);
            }
          },
          children: [
            typeof trigger === 'function'
              ? trigger({ isOpen: isOpen, disabled: disabled })
              : trigger ||
                jsxRuntime.jsx(Icon, {
                  className: cx(style$d.MenuDropdownDots, ((_d = {}), (_d[style$d.isDark] = theme === 'dark'), _d)),
                  name: 'icon-dots-horizontal',
                  size: size,
                }),
            trigger &&
              showCaret &&
              jsxRuntime.jsx(Icon, {
                className: style$d.MenuDropdownChevron,
                name: isOpen ? 'icon-chevron-up' : 'icon-chevron-down',
                size: size,
              }),
          ],
        }),
        isOpen &&
          jsxRuntime.jsx(
            'span',
            __assign(
              {
                ref: function (refInput) {
                  // @ts-expect-error TS(2345): Argument of type 'HTMLSpanElement | null' is not a... Remove this comment to see the full error message
                  setOutsideClickRef(refInput);
                  // @ts-expect-error TS(2345): Argument of type 'HTMLSpanElement | null' is not a... Remove this comment to see the full error message
                  setMenuDropdown(refInput);
                },
                style: __assign(__assign({}, styles.popper), { width: menuWidth }),
                // @ts-expect-error TS(2345): Argument of type '[CSSProperties, string]' is not ... Remove this comment to see the full error message
                className: cx(styles.popper, style$d.MenuDropdownContent),
              },
              attributes.popper,
              { children: children },
            ),
          ),
      ],
    }),
  );
};
MenuDropdown.propTypes = {
  trigger: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].node,
    PropTypes__default['default'].func,
  ]),
  children: PropTypes__default['default'].arrayOf(PropTypes__default['default'].element),
  className: PropTypes__default['default'].string,
  openClassName: PropTypes__default['default'].string,
  position: PropTypes__default['default'].string,
  theme: PropTypes__default['default'].oneOf(['primary', 'dark']),
  size: PropTypes__default['default'].oneOf(['sm', 'lg', '2x', '3x', '4x', '5x']),
  showCaret: PropTypes__default['default'].bool,
  modifiers: PropTypes__default['default'].arrayOf(PropTypes__default['default'].object),
  isMenuOpen: PropTypes__default['default'].bool,
  onMenuChange: PropTypes__default['default'].func,
  disabled: PropTypes__default['default'].bool,
};

var MenuDropdownItem = function (_a) {
  var _b;
  var children = _a.children,
    className = _a.className,
    icon = _a.icon,
    _c = _a.href,
    href = _c === void 0 ? '#' : _c,
    _d = _a.isDisabled,
    isDisabled = _d === void 0 ? false : _d,
    props = __rest$1(_a, ['children', 'className', 'icon', 'href', 'isDisabled']);
  return jsxRuntime.jsxs(
    'a',
    __assign(
      {
        className: cx(style$d.MenuDropdownItem, className, ((_b = {}), (_b[style$d.isDisabled] = isDisabled), _b)),
        href: href,
      },
      props,
      { children: [icon && jsxRuntime.jsx(Icon, { name: icon }), children] },
    ),
  );
};
MenuDropdownItem.propTypes = {
  children: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].node,
    PropTypes__default['default'].arrayOf(PropTypes__default['default'].node),
  ]),
  icon: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  href: PropTypes__default['default'].string,
  isDisabled: PropTypes__default['default'].bool,
};

var reactIs$2 = { exports: {} };

var reactIs_production_min$1 = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b = Symbol.for('react.element'),
    c = Symbol.for('react.portal'),
    d = Symbol.for('react.fragment'),
    e = Symbol.for('react.strict_mode'),
    f = Symbol.for('react.profiler'),
    g = Symbol.for('react.provider'),
    h = Symbol.for('react.context'),
    k = Symbol.for('react.server_context'),
    l = Symbol.for('react.forward_ref'),
    m = Symbol.for('react.suspense'),
    n = Symbol.for('react.suspense_list'),
    p = Symbol.for('react.memo'),
    q = Symbol.for('react.lazy'),
    t = Symbol.for('react.offscreen'),
    u;
  u = Symbol.for('react.module.reference');
  function v(a) {
    if ('object' === typeof a && null !== a) {
      var r = a.$$typeof;
      switch (r) {
        case b:
          switch (((a = a.type), a)) {
            case d:
            case f:
            case e:
            case m:
            case n:
              return a;
            default:
              switch (((a = a && a.$$typeof), a)) {
                case k:
                case h:
                case l:
                case q:
                case p:
                case g:
                  return a;
                default:
                  return r;
              }
          }
        case c:
          return r;
      }
    }
  }
  reactIs_production_min$1.ContextConsumer = h;
  reactIs_production_min$1.ContextProvider = g;
  reactIs_production_min$1.Element = b;
  reactIs_production_min$1.ForwardRef = l;
  reactIs_production_min$1.Fragment = d;
  reactIs_production_min$1.Lazy = q;
  reactIs_production_min$1.Memo = p;
  reactIs_production_min$1.Portal = c;
  reactIs_production_min$1.Profiler = f;
  reactIs_production_min$1.StrictMode = e;
  reactIs_production_min$1.Suspense = m;
  reactIs_production_min$1.SuspenseList = n;
  reactIs_production_min$1.isAsyncMode = function () {
    return !1;
  };
  reactIs_production_min$1.isConcurrentMode = function () {
    return !1;
  };
  reactIs_production_min$1.isContextConsumer = function (a) {
    return v(a) === h;
  };
  reactIs_production_min$1.isContextProvider = function (a) {
    return v(a) === g;
  };
  reactIs_production_min$1.isElement = function (a) {
    return 'object' === typeof a && null !== a && a.$$typeof === b;
  };
  reactIs_production_min$1.isForwardRef = function (a) {
    return v(a) === l;
  };
  reactIs_production_min$1.isFragment = function (a) {
    return v(a) === d;
  };
  reactIs_production_min$1.isLazy = function (a) {
    return v(a) === q;
  };
  reactIs_production_min$1.isMemo = function (a) {
    return v(a) === p;
  };
  reactIs_production_min$1.isPortal = function (a) {
    return v(a) === c;
  };
  reactIs_production_min$1.isProfiler = function (a) {
    return v(a) === f;
  };
  reactIs_production_min$1.isStrictMode = function (a) {
    return v(a) === e;
  };
  reactIs_production_min$1.isSuspense = function (a) {
    return v(a) === m;
  };
  reactIs_production_min$1.isSuspenseList = function (a) {
    return v(a) === n;
  };
  reactIs_production_min$1.isValidElementType = function (a) {
    return 'string' === typeof a ||
      'function' === typeof a ||
      a === d ||
      a === f ||
      a === e ||
      a === m ||
      a === n ||
      a === t ||
      ('object' === typeof a &&
        null !== a &&
        (a.$$typeof === q ||
          a.$$typeof === p ||
          a.$$typeof === g ||
          a.$$typeof === h ||
          a.$$typeof === l ||
          a.$$typeof === u ||
          void 0 !== a.getModuleId))
      ? !0
      : !1;
  };
  reactIs_production_min$1.typeOf = v;
  return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;

  if (process.env.NODE_ENV !== 'production') {
    (function () {
      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types.
      var REACT_ELEMENT_TYPE = Symbol.for('react.element');
      var REACT_PORTAL_TYPE = Symbol.for('react.portal');
      var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
      var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
      var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
      var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
      var REACT_CONTEXT_TYPE = Symbol.for('react.context');
      var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
      var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
      var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
      var REACT_MEMO_TYPE = Symbol.for('react.memo');
      var REACT_LAZY_TYPE = Symbol.for('react.lazy');
      var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

      // -----------------------------------------------------------------------------

      var enableScopeAPI = false; // Experimental Create Event Handle API.
      var enableCacheElement = false;
      var enableTransitionTracing = false; // No known bugs, but needs performance testing

      var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
      // stuff. Intended to enable React core members to more easily debug scheduling
      // issues in DEV builds.

      var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

      var REACT_MODULE_REFERENCE;

      {
        REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
      }

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

        if (
          type === REACT_FRAGMENT_TYPE ||
          type === REACT_PROFILER_TYPE ||
          enableDebugTracing ||
          type === REACT_STRICT_MODE_TYPE ||
          type === REACT_SUSPENSE_TYPE ||
          type === REACT_SUSPENSE_LIST_TYPE ||
          enableLegacyHidden ||
          type === REACT_OFFSCREEN_TYPE ||
          enableScopeAPI ||
          enableCacheElement ||
          enableTransitionTracing
        ) {
          return true;
        }

        if (typeof type === 'object' && type !== null) {
          if (
            type.$$typeof === REACT_LAZY_TYPE ||
            type.$$typeof === REACT_MEMO_TYPE ||
            type.$$typeof === REACT_PROVIDER_TYPE ||
            type.$$typeof === REACT_CONTEXT_TYPE ||
            type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE ||
            type.getModuleId !== undefined
          ) {
            return true;
          }
        }

        return false;
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_SERVER_CONTEXT_TYPE:
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }
              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn'](
              'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.',
            );
          }
        }

        return false;
      }
      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn'](
              'The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.',
            );
          }
        }

        return false;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
      }

      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.SuspenseList = SuspenseList;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isSuspenseList = isSuspenseList;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = requireReactIs_production_min$1();
} else {
  reactIs$2.exports = requireReactIs_development$1();
}

var reactIsExports$1 = reactIs$2.exports;

function stylis_min(W) {
  function M(d, c, e, h, a) {
    for (
      var m = 0,
        b = 0,
        v = 0,
        n = 0,
        q,
        g,
        x = 0,
        K = 0,
        k,
        u = (k = q = 0),
        l = 0,
        r = 0,
        I = 0,
        t = 0,
        B = e.length,
        J = B - 1,
        y,
        f = '',
        p = '',
        F = '',
        G = '',
        C;
      l < B;

    ) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), (n = v = m = 0), B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B; ) {
              switch ((g = e.charCodeAt(l))) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch ((g = e.charCodeAt(l + 1))) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }
                          }
                        }

                        l = u;
                      }
                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g; ) {}
              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A &&
                  ((r = X(O, f, I)),
                  (C = H(3, k, r, c, D, z, t, g, a, h)),
                  (f = r.join('')),
                  void 0 !== C && 0 === (t = (k = C.trim()).length) && ((g = 0), (k = '')));
                if (0 < t)
                  switch (g) {
                    case 115:
                      f = f.replace(da, ea);

                    case 100:
                    case 109:
                    case 45:
                      k = f + '{' + k + '}';
                      break;

                    case 107:
                      f = f.replace(fa, '$1 $2');
                      k = f + '{' + k + '}';
                      k = 1 === w || (2 === w && L('@' + k, 3)) ? '@-webkit-' + k + '@' + k : '@' + k;
                      break;

                    default:
                      (k = f + k), 112 === h && (k = ((p += k), ''));
                  }
                else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length))
              switch (
                (0 === u &&
                  ((q = f.charCodeAt(0)), 45 === q || (96 < q && 123 > q)) &&
                  (t = (f = f.replace(' ', ':')).length),
                0 < A &&
                  void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) &&
                  0 === (t = (f = C.trim()).length) &&
                  (f = '\x00\x00'),
                (q = f.charCodeAt(0)),
                (g = f.charCodeAt(1)),
                q)
              ) {
                case 0:
                  break;

                case 64:
                  if (105 === g || 99 === g) {
                    G += f + e.charAt(l);
                    break;
                  }

                default:
                  58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
              }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? (b = 0) : 0 === 1 + q && 107 !== h && 0 < f.length && ((r = 1), (f += '\x00'));
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b)
                switch (x) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y = '';
                    break;

                  default:
                    32 !== g && (y = ' ');
                }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && ((r = I = 1), (y = '\f' + y));
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u)
                switch (l - u) {
                  case 2:
                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                  case 8:
                    111 === K && (E = K);
                }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && ((r = 1), (y += '\r'));
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q)
                  switch (2 * x + 3 * K) {
                    case 533:
                      break;

                    default:
                      q = 1;
                  }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v))
                switch (b) {
                  case 0:
                    switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                      case 235:
                        b = 47;
                        break;

                      case 220:
                        (t = l), (b = 42);
                    }

                    break;

                  case 42:
                    47 === g &&
                      42 === x &&
                      t + 2 !== l &&
                      (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), (y = ''), (b = 0));
                }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && ((C = H(2, p, r, d, D, z, t, h, a, h)), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
      m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = (b = 0);

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }
    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
      m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || (2 === w && L(b, 1)) ? '-webkit-' + b + b : b;
    }

    if (0 === w || (2 === w && !L(a, 1))) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4))
          switch (a.charCodeAt(5)) {
            case 103:
              return (
                '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a
              );

            case 115:
              return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

            case 98:
              return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
          }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch ((m = b.charCodeAt(0) + (b.charCodeAt(7) | 0))) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a =
              a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') +
              ';' +
              a.replace(b, '-webkit-' + b) +
              ';' +
              a.replace(b, '-ms-' + b + 'box') +
              ';' +
              a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5))
          switch (a.charCodeAt(6)) {
            case 105:
              return (b = a.replace('-items', '')), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

            case 115:
              return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

            default:
              return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
          }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d))
          return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0)
            ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch')
            : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (
          ((a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a),
          211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10))
        )
          return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
      h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch ((w = S[g].call(B, d, x, e, h, a, m, b, v, n, q))) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;
        else if ('object' === typeof d)
          for (var c = 0, e = d.length; c < e; ++c) {
            T(d[c]);
          }
        else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && ((R = null), d ? ('function' !== typeof d ? (w = 1) : ((w = 2), (R = d))) : (w = 0));
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && ((h = H(-2, a, e, e, D, z, a.length, 0, 0, 0)), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
    N = /[\0\r\f]/g,
    aa = /: */g,
    ka = /zoo|gra/,
    ma = /([,: ])(transform)/g,
    ia = /,\r+?/g,
    F = /([\t\r\n ])*\f?&/g,
    fa = /@(k\w+)\s*(\S*)\s*/,
    Q = /::(place)/g,
    ha = /:(read-only)/g,
    G = /[svh]\w+-[tblr]{2}/,
    da = /\(\s*(.*)\s*\)/g,
    oa = /([\s\S]*?);/g,
    ba = /-self|flex-/g,
    na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    la = /stretch|:\s*\w+\-(?:conte|avail)/,
    ja = /([^-])(image-set\()/,
    z = 1,
    D = 1,
    E = 0,
    w = 1,
    O = [],
    S = [],
    A = 0,
    R = null,
    Y = 0,
    V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1,
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex =
  /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */ memoize(
  function (prop) {
    return (
      reactPropsRegex.test(prop) ||
      (prop.charCodeAt(0) === 111 &&
        /* o */
        prop.charCodeAt(1) === 110 &&
        /* n */
        prop.charCodeAt(2) < 91)
    );
  },
  /* Z+1 */
);

var reactIs$1 = { exports: {} };

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = 'function' === typeof Symbol && Symbol.for,
    c = b ? Symbol.for('react.element') : 60103,
    d = b ? Symbol.for('react.portal') : 60106,
    e = b ? Symbol.for('react.fragment') : 60107,
    f = b ? Symbol.for('react.strict_mode') : 60108,
    g = b ? Symbol.for('react.profiler') : 60114,
    h = b ? Symbol.for('react.provider') : 60109,
    k = b ? Symbol.for('react.context') : 60110,
    l = b ? Symbol.for('react.async_mode') : 60111,
    m = b ? Symbol.for('react.concurrent_mode') : 60111,
    n = b ? Symbol.for('react.forward_ref') : 60112,
    p = b ? Symbol.for('react.suspense') : 60113,
    q = b ? Symbol.for('react.suspense_list') : 60120,
    r = b ? Symbol.for('react.memo') : 60115,
    t = b ? Symbol.for('react.lazy') : 60116,
    v = b ? Symbol.for('react.block') : 60121,
    w = b ? Symbol.for('react.fundamental') : 60117,
    x = b ? Symbol.for('react.responder') : 60118,
    y = b ? Symbol.for('react.scope') : 60119;
  function z(a) {
    if ('object' === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (((a = a.type), a)) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (((a = a && a.$$typeof), a)) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return 'object' === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return (
      'string' === typeof a ||
      'function' === typeof a ||
      a === e ||
      a === m ||
      a === g ||
      a === f ||
      a === p ||
      a === q ||
      ('object' === typeof a &&
        null !== a &&
        (a.$$typeof === t ||
          a.$$typeof === r ||
          a.$$typeof === h ||
          a.$$typeof === k ||
          a.$$typeof === n ||
          a.$$typeof === w ||
          a.$$typeof === x ||
          a.$$typeof === y ||
          a.$$typeof === v))
    );
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;

  if (process.env.NODE_ENV !== 'production') {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return (
          typeof type === 'string' ||
          typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE ||
          type === REACT_CONCURRENT_MODE_TYPE ||
          type === REACT_PROFILER_TYPE ||
          type === REACT_STRICT_MODE_TYPE ||
          type === REACT_SUSPENSE_TYPE ||
          type === REACT_SUSPENSE_LIST_TYPE ||
          (typeof type === 'object' &&
            type !== null &&
            (type.$$typeof === REACT_LAZY_TYPE ||
              type.$$typeof === REACT_MEMO_TYPE ||
              type.$$typeof === REACT_PROVIDER_TYPE ||
              type.$$typeof === REACT_CONTEXT_TYPE ||
              type.$$typeof === REACT_FORWARD_REF_TYPE ||
              type.$$typeof === REACT_FUNDAMENTAL_TYPE ||
              type.$$typeof === REACT_RESPONDER_TYPE ||
              type.$$typeof === REACT_SCOPE_TYPE ||
              type.$$typeof === REACT_BLOCK_TYPE))
        );
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }
              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn'](
              'The ReactIs.isAsyncMode() alias has been deprecated, ' +
                'and will be removed in React 17+. Update your code to use ' +
                'ReactIs.isConcurrentMode() instead. It has the exact same API.',
            );
          }
        }

        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = requireReactIs_production_min();
} else {
  reactIs$1.exports = requireReactIs_development();
}

var reactIsExports = reactIs$1.exports;

var reactIs = reactIsExports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true,
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true,
};
var FORWARD_REF_STATICS = {
  $$typeof: true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
};
var MEMO_STATICS = {
  $$typeof: true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true,
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (
        !KNOWN_STATICS[key] &&
        !(blacklist && blacklist[key]) &&
        !(sourceStatics && sourceStatics[key]) &&
        !(targetStatics && targetStatics[key])
      ) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var m$1 = /*@__PURE__*/ getDefaultExportFromCjs(hoistNonReactStatics_cjs);

function v$1() {
  return (v$1 =
    Object.assign ||
    function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    }).apply(this, arguments);
}
var y$1 = function (e, t) {
    for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1) n.push(t[r], e[r + 1]);
    return n;
  },
  g$1 = function (t) {
    return (
      null !== t &&
      'object' == typeof t &&
      '[object Object]' === (t.toString ? t.toString() : Object.prototype.toString.call(t)) &&
      !reactIsExports$1.typeOf(t)
    );
  },
  S$1 = Object.freeze([]),
  w$1 = Object.freeze({});
function E$1(e) {
  return 'function' == typeof e;
}
function b$1(e) {
  return ('production' !== process.env.NODE_ENV && 'string' == typeof e && e) || e.displayName || e.name || 'Component';
}
function _$1(e) {
  return e && 'string' == typeof e.styledComponentId;
}
var N$1 =
    ('undefined' != typeof process &&
      void 0 !== process.env &&
      (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR)) ||
    'data-styled',
  C$1 = 'undefined' != typeof window && 'HTMLElement' in window,
  I$1 = Boolean(
    'boolean' == typeof SC_DISABLE_SPEEDY
      ? SC_DISABLE_SPEEDY
      : 'undefined' != typeof process &&
          void 0 !== process.env &&
          (void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && '' !== process.env.REACT_APP_SC_DISABLE_SPEEDY
            ? 'false' !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY
            : void 0 !== process.env.SC_DISABLE_SPEEDY && '' !== process.env.SC_DISABLE_SPEEDY
            ? 'false' !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY
            : 'production' !== process.env.NODE_ENV),
  ),
  O$1 =
    'production' !== process.env.NODE_ENV
      ? {
          1: 'Cannot create styled-component for component: %s.\n\n',
          2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
          3: 'Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n',
          4: 'The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n',
          5: 'The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n',
          6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
          7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
          8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
          9: 'Missing document `<head>`\n\n',
          10: 'Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n',
          11: '_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n',
          12: 'It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n',
          13: '%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n',
          14: 'ThemeProvider: "theme" prop is required.\n\n',
          15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
          16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
          17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n",
        }
      : {};
function R$1() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)
    t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
  return (
    t.forEach(function (t) {
      e = e.replace(/%[a-z]/, t);
    }),
    e
  );
}
function D$1(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  throw 'production' === process.env.NODE_ENV
    ? new Error(
        'An error occurred. See https://git.io/JUIaE#' +
          e +
          ' for more information.' +
          (n.length > 0 ? ' Args: ' + n.join(', ') : ''),
      )
    : new Error(R$1.apply(void 0, [O$1[e]].concat(n)).trim());
}
var j$1 = (function () {
    function e(e) {
      (this.groupSizes = new Uint32Array(512)), (this.length = 512), (this.tag = e);
    }
    var t = e.prototype;
    return (
      (t.indexOfGroup = function (e) {
        for (var t = 0, n = 0; n < e; n++) t += this.groupSizes[n];
        return t;
      }),
      (t.insertRules = function (e, t) {
        if (e >= this.groupSizes.length) {
          for (var n = this.groupSizes, r = n.length, o = r; e >= o; ) (o <<= 1) < 0 && D$1(16, '' + e);
          (this.groupSizes = new Uint32Array(o)), this.groupSizes.set(n), (this.length = o);
          for (var s = r; s < o; s++) this.groupSizes[s] = 0;
        }
        for (var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)
          this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
      }),
      (t.clearGroup = function (e) {
        if (e < this.length) {
          var t = this.groupSizes[e],
            n = this.indexOfGroup(e),
            r = n + t;
          this.groupSizes[e] = 0;
          for (var o = n; o < r; o++) this.tag.deleteRule(n);
        }
      }),
      (t.getGroup = function (e) {
        var t = '';
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for (var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)
          t += this.tag.getRule(s) + '/*!sc*/\n';
        return t;
      }),
      e
    );
  })(),
  T$1 = new Map(),
  x$1 = new Map(),
  k$1 = 1,
  V$1 = function (e) {
    if (T$1.has(e)) return T$1.get(e);
    for (; x$1.has(k$1); ) k$1++;
    var t = k$1++;
    return (
      'production' !== process.env.NODE_ENV && ((0 | t) < 0 || t > 1 << 30) && D$1(16, '' + t),
      T$1.set(e, t),
      x$1.set(t, e),
      t
    );
  },
  z$1 = function (e) {
    return x$1.get(e);
  },
  B$1 = function (e, t) {
    t >= k$1 && (k$1 = t + 1), T$1.set(e, t), x$1.set(t, e);
  },
  M$1 = 'style[' + N$1 + '][data-styled-version="5.3.10"]',
  G$1 = new RegExp('^' + N$1 + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
  L$1 = function (e, t, n) {
    for (var r, o = n.split(','), s = 0, i = o.length; s < i; s++) (r = o[s]) && e.registerName(t, r);
  },
  F$1 = function (e, t) {
    for (var n = (t.textContent || '').split('/*!sc*/\n'), r = [], o = 0, s = n.length; o < s; o++) {
      var i = n[o].trim();
      if (i) {
        var a = i.match(G$1);
        if (a) {
          var c = 0 | parseInt(a[1], 10),
            u = a[2];
          0 !== c && (B$1(u, c), L$1(e, u, a[3]), e.getTag().insertRules(c, r)), (r.length = 0);
        } else r.push(i);
      }
    }
  },
  Y$1 = function () {
    return 'undefined' != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
  },
  q$1 = function (e) {
    var t = document.head,
      n = e || t,
      r = document.createElement('style'),
      o = (function (e) {
        for (var t = e.childNodes, n = t.length; n >= 0; n--) {
          var r = t[n];
          if (r && 1 === r.nodeType && r.hasAttribute(N$1)) return r;
        }
      })(n),
      s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute(N$1, 'active'), r.setAttribute('data-styled-version', '5.3.10');
    var i = Y$1();
    return i && r.setAttribute('nonce', i), n.insertBefore(r, s), r;
  },
  H$1 = (function () {
    function e(e) {
      var t = (this.element = q$1(e));
      t.appendChild(document.createTextNode('')),
        (this.sheet = (function (e) {
          if (e.sheet) return e.sheet;
          for (var t = document.styleSheets, n = 0, r = t.length; n < r; n++) {
            var o = t[n];
            if (o.ownerNode === e) return o;
          }
          D$1(17);
        })(t)),
        (this.length = 0);
    }
    var t = e.prototype;
    return (
      (t.insertRule = function (e, t) {
        try {
          return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
          return !1;
        }
      }),
      (t.deleteRule = function (e) {
        this.sheet.deleteRule(e), this.length--;
      }),
      (t.getRule = function (e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && 'string' == typeof t.cssText ? t.cssText : '';
      }),
      e
    );
  })(),
  $$1 = (function () {
    function e(e) {
      var t = (this.element = q$1(e));
      (this.nodes = t.childNodes), (this.length = 0);
    }
    var t = e.prototype;
    return (
      (t.insertRule = function (e, t) {
        if (e <= this.length && e >= 0) {
          var n = document.createTextNode(t),
            r = this.nodes[e];
          return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
      }),
      (t.deleteRule = function (e) {
        this.element.removeChild(this.nodes[e]), this.length--;
      }),
      (t.getRule = function (e) {
        return e < this.length ? this.nodes[e].textContent : '';
      }),
      e
    );
  })(),
  W = (function () {
    function e(e) {
      (this.rules = []), (this.length = 0);
    }
    var t = e.prototype;
    return (
      (t.insertRule = function (e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
      }),
      (t.deleteRule = function (e) {
        this.rules.splice(e, 1), this.length--;
      }),
      (t.getRule = function (e) {
        return e < this.length ? this.rules[e] : '';
      }),
      e
    );
  })(),
  U$1 = C$1,
  J$1 = { isServer: !C$1, useCSSOMInjection: !I$1 },
  X$1 = (function () {
    function e(e, t, n) {
      void 0 === e && (e = w$1),
        void 0 === t && (t = {}),
        (this.options = v$1({}, J$1, {}, e)),
        (this.gs = t),
        (this.names = new Map(n)),
        (this.server = !!e.isServer),
        !this.server &&
          C$1 &&
          U$1 &&
          ((U$1 = !1),
          (function (e) {
            for (var t = document.querySelectorAll(M$1), n = 0, r = t.length; n < r; n++) {
              var o = t[n];
              o && 'active' !== o.getAttribute(N$1) && (F$1(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
          })(this));
    }
    e.registerId = function (e) {
      return V$1(e);
    };
    var t = e.prototype;
    return (
      (t.reconstructWithOptions = function (t, n) {
        return void 0 === n && (n = !0), new e(v$1({}, this.options, {}, t), this.gs, (n && this.names) || void 0);
      }),
      (t.allocateGSInstance = function (e) {
        return (this.gs[e] = (this.gs[e] || 0) + 1);
      }),
      (t.getTag = function () {
        return (
          this.tag ||
          (this.tag =
            ((n = (t = this.options).isServer),
            (r = t.useCSSOMInjection),
            (o = t.target),
            (e = n ? new W(o) : r ? new H$1(o) : new $$1(o)),
            new j$1(e)))
        );
        var e, t, n, r, o;
      }),
      (t.hasNameForId = function (e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
      }),
      (t.registerName = function (e, t) {
        if ((V$1(e), this.names.has(e))) this.names.get(e).add(t);
        else {
          var n = new Set();
          n.add(t), this.names.set(e, n);
        }
      }),
      (t.insertRules = function (e, t, n) {
        this.registerName(e, t), this.getTag().insertRules(V$1(e), n);
      }),
      (t.clearNames = function (e) {
        this.names.has(e) && this.names.get(e).clear();
      }),
      (t.clearRules = function (e) {
        this.getTag().clearGroup(V$1(e)), this.clearNames(e);
      }),
      (t.clearTag = function () {
        this.tag = void 0;
      }),
      (t.toString = function () {
        return (function (e) {
          for (var t = e.getTag(), n = t.length, r = '', o = 0; o < n; o++) {
            var s = z$1(o);
            if (void 0 !== s) {
              var i = e.names.get(s),
                a = t.getGroup(o);
              if (i && a && i.size) {
                var c = N$1 + '.g' + o + '[id="' + s + '"]',
                  u = '';
                void 0 !== i &&
                  i.forEach(function (e) {
                    e.length > 0 && (u += e + ',');
                  }),
                  (r += '' + a + c + '{content:"' + u + '"}/*!sc*/\n');
              }
            }
          }
          return r;
        })(this);
      }),
      e
    );
  })(),
  Z$1 = /(a)(d)/gi,
  K$1 = function (e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
  };
function Q$1(e) {
  var t,
    n = '';
  for (t = Math.abs(e); t > 52; t = (t / 52) | 0) n = K$1(t % 52) + n;
  return (K$1(t % 52) + n).replace(Z$1, '$1-$2');
}
var ee$1 = function (e, t) {
    for (var n = t.length; n; ) e = (33 * e) ^ t.charCodeAt(--n);
    return e;
  },
  te$1 = function (e) {
    return ee$1(5381, e);
  };
function ne$1(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (E$1(n) && !_$1(n)) return !1;
  }
  return !0;
}
var re$1 = te$1('5.3.10'),
  oe$1 = (function () {
    function e(e, t, n) {
      (this.rules = e),
        (this.staticRulesId = ''),
        (this.isStatic = 'production' === process.env.NODE_ENV && (void 0 === n || n.isStatic) && ne$1(e)),
        (this.componentId = t),
        (this.baseHash = ee$1(re$1, t)),
        (this.baseStyle = n),
        X$1.registerId(t);
    }
    return (
      (e.prototype.generateAndInjectStyles = function (e, t, n) {
        var r = this.componentId,
          o = [];
        if ((this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash))
          if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
          else {
            var s = _e$1(this.rules, e, t, n).join(''),
              i = Q$1(ee$1(this.baseHash, s) >>> 0);
            if (!t.hasNameForId(r, i)) {
              var a = n(s, '.' + i, void 0, r);
              t.insertRules(r, i, a);
            }
            o.push(i), (this.staticRulesId = i);
          }
        else {
          for (var c = this.rules.length, u = ee$1(this.baseHash, n.hash), l = '', d = 0; d < c; d++) {
            var h = this.rules[d];
            if ('string' == typeof h) (l += h), 'production' !== process.env.NODE_ENV && (u = ee$1(u, h + d));
            else if (h) {
              var p = _e$1(h, e, t, n),
                f = Array.isArray(p) ? p.join('') : p;
              (u = ee$1(u, f + d)), (l += f);
            }
          }
          if (l) {
            var m = Q$1(u >>> 0);
            if (!t.hasNameForId(r, m)) {
              var v = n(l, '.' + m, void 0, r);
              t.insertRules(r, m, v);
            }
            o.push(m);
          }
        }
        return o.join(' ');
      }),
      e
    );
  })(),
  se$1 = /^\s*\/\/.*$/gm,
  ie$1 = [':', '[', '.', '#'];
function ae$1(e) {
  var t,
    n,
    r,
    o,
    s = void 0 === e ? w$1 : e,
    i = s.options,
    a = void 0 === i ? w$1 : i,
    c = s.plugins,
    u = void 0 === c ? S$1 : c,
    l = new stylis_min(a),
    d = [],
    p = (function (e) {
      function t(t) {
        if (t)
          try {
            e(t + '}');
          } catch (e) {}
      }
      return function (n, r, o, s, i, a, c, u, l, d) {
        switch (n) {
          case 1:
            if (0 === l && 64 === r.charCodeAt(0)) return e(r + ';'), '';
            break;
          case 2:
            if (0 === u) return r + '/*|*/';
            break;
          case 3:
            switch (u) {
              case 102:
              case 112:
                return e(o[0] + r), '';
              default:
                return r + (0 === d ? '/*|*/' : '');
            }
          case -2:
            r.split('/*|*/}').forEach(t);
        }
      };
    })(function (e) {
      d.push(e);
    }),
    f = function (e, r, s) {
      return (0 === r && -1 !== ie$1.indexOf(s[n.length])) || s.match(o) ? e : '.' + t;
    };
  function m(e, s, i, a) {
    void 0 === a && (a = '&');
    var c = e.replace(se$1, ''),
      u = s && i ? i + ' ' + s + ' { ' + c + ' }' : c;
    return (
      (t = a),
      (n = s),
      (r = new RegExp('\\' + n + '\\b', 'g')),
      (o = new RegExp('(\\' + n + '\\b){2,}')),
      l(i || !s ? '' : s, u)
    );
  }
  return (
    l.use(
      [].concat(u, [
        function (e, t, o) {
          2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function (e) {
          if (-2 === e) {
            var t = d;
            return (d = []), t;
          }
        },
      ]),
    ),
    (m.hash = u.length
      ? u
          .reduce(function (e, t) {
            return t.name || D$1(15), ee$1(e, t.name);
          }, 5381)
          .toString()
      : ''),
    m
  );
}
var ce$1 = React__default['default'].createContext();
ce$1.Consumer;
var le$1 = React__default['default'].createContext(),
  de$1 = (le$1.Consumer, new X$1()),
  he$1 = ae$1();
function pe$1() {
  return React.useContext(ce$1) || de$1;
}
function fe$1() {
  return React.useContext(le$1) || he$1;
}
var ve$1 = (function () {
    function e(e, t) {
      var n = this;
      (this.inject = function (e, t) {
        void 0 === t && (t = he$1);
        var r = n.name + t.hash;
        e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, '@keyframes'));
      }),
        (this.toString = function () {
          return D$1(12, String(n.name));
        }),
        (this.name = e),
        (this.id = 'sc-keyframes-' + e),
        (this.rules = t);
    }
    return (
      (e.prototype.getName = function (e) {
        return void 0 === e && (e = he$1), this.name + e.hash;
      }),
      e
    );
  })(),
  ye$1 = /([A-Z])/,
  ge$1 = /([A-Z])/g,
  Se$1 = /^ms-/,
  we$1 = function (e) {
    return '-' + e.toLowerCase();
  };
function Ee$1(e) {
  return ye$1.test(e) ? e.replace(ge$1, we$1).replace(Se$1, '-ms-') : e;
}
var be$1 = function (e) {
  return null == e || !1 === e || '' === e;
};
function _e$1(e, n, r, o) {
  if (Array.isArray(e)) {
    for (var s, i = [], a = 0, c = e.length; a < c; a += 1)
      '' !== (s = _e$1(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
    return i;
  }
  if (be$1(e)) return '';
  if (_$1(e)) return '.' + e.styledComponentId;
  if (E$1(e)) {
    if ('function' != typeof (l = e) || (l.prototype && l.prototype.isReactComponent) || !n) return e;
    var u = e(n);
    return (
      'production' !== process.env.NODE_ENV &&
        reactIsExports$1.isElement(u) &&
        console.warn(
          b$1(e) +
            ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.',
        ),
      _e$1(u, n, r, o)
    );
  }
  var l;
  return e instanceof ve$1
    ? r
      ? (e.inject(r, o), e.getName(o))
      : e
    : g$1(e)
    ? (function e(t, n) {
        var r,
          o,
          s = [];
        for (var i in t)
          t.hasOwnProperty(i) &&
            !be$1(t[i]) &&
            ((Array.isArray(t[i]) && t[i].isCss) || E$1(t[i])
              ? s.push(Ee$1(i) + ':', t[i], ';')
              : g$1(t[i])
              ? s.push.apply(s, e(t[i], i))
              : s.push(
                  Ee$1(i) +
                    ': ' +
                    ((r = i),
                    null == (o = t[i]) || 'boolean' == typeof o || '' === o
                      ? ''
                      : 'number' != typeof o || 0 === o || r in unitlessKeys || r.startsWith('--')
                      ? String(o).trim()
                      : o + 'px') +
                    ';',
                ));
        return n ? [n + ' {'].concat(s, ['}']) : s;
      })(e)
    : e.toString();
}
var Ne$1 = function (e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function Ae$1(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return E$1(e) || g$1(e)
    ? Ne$1(_e$1(y$1(S$1, [e].concat(n))))
    : 0 === n.length && 1 === e.length && 'string' == typeof e[0]
    ? e
    : Ne$1(_e$1(y$1(e, n)));
}
var Ce$1 = /invalid hook call/i,
  Ie$1 = new Set(),
  Pe$1 = function (e, t) {
    if ('production' !== process.env.NODE_ENV) {
      var n =
          'The component ' +
          e +
          (t ? ' with the id of "' + t + '"' : '') +
          " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",
        r = console.error;
      try {
        var o = !0;
        (console.error = function (e) {
          if (Ce$1.test(e)) (o = !1), Ie$1.delete(n);
          else {
            for (var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) s[i - 1] = arguments[i];
            r.apply(void 0, [e].concat(s));
          }
        }),
          React.useRef(),
          o && !Ie$1.has(n) && (console.warn(n), Ie$1.add(n));
      } catch (e) {
        Ce$1.test(e.message) && Ie$1.delete(n);
      } finally {
        console.error = r;
      }
    }
  },
  Oe$1 = function (e, t, n) {
    return void 0 === n && (n = w$1), (e.theme !== n.theme && e.theme) || t || n.theme;
  },
  Re$1 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
  De$1 = /(^-|-$)/g;
function je$1(e) {
  return e.replace(Re$1, '-').replace(De$1, '');
}
var Te$1 = function (e) {
  return Q$1(te$1(e) >>> 0);
};
function xe$1(e) {
  return 'string' == typeof e && ('production' === process.env.NODE_ENV || e.charAt(0) === e.charAt(0).toLowerCase());
}
var ke$1 = function (e) {
    return 'function' == typeof e || ('object' == typeof e && null !== e && !Array.isArray(e));
  },
  Ve$1 = function (e) {
    return '__proto__' !== e && 'constructor' !== e && 'prototype' !== e;
  };
function ze$1(e, t, n) {
  var r = e[n];
  ke$1(t) && ke$1(r) ? Be$1(r, t) : (e[n] = t);
}
function Be$1(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  for (var o = 0, s = n; o < s.length; o++) {
    var i = s[o];
    if (ke$1(i)) for (var a in i) Ve$1(a) && ze$1(e, i[a], a);
  }
  return e;
}
var Me$1 = React__default['default'].createContext();
Me$1.Consumer;
function Le$1(e) {
  var t = React.useContext(Me$1),
    n = React.useMemo(
      function () {
        return (function (e, t) {
          if (!e) return D$1(14);
          if (E$1(e)) {
            var n = e(t);
            return 'production' === process.env.NODE_ENV || (null !== n && !Array.isArray(n) && 'object' == typeof n)
              ? n
              : D$1(7);
          }
          return Array.isArray(e) || 'object' != typeof e ? D$1(8) : t ? v$1({}, t, {}, e) : e;
        })(e.theme, t);
      },
      [e.theme, t],
    );
  return e.children ? React__default['default'].createElement(Me$1.Provider, { value: n }, e.children) : null;
}
var Fe$1 = {};
function Ye$1(e, t, n) {
  var o = _$1(e),
    i = !xe$1(e),
    a = t.attrs,
    c = void 0 === a ? S$1 : a,
    d = t.componentId,
    h =
      void 0 === d
        ? (function (e, t) {
            var n = 'string' != typeof e ? 'sc' : je$1(e);
            Fe$1[n] = (Fe$1[n] || 0) + 1;
            var r = n + '-' + Te$1('5.3.10' + n + Fe$1[n]);
            return t ? t + '-' + r : r;
          })(t.displayName, t.parentComponentId)
        : d,
    p = t.displayName,
    y =
      void 0 === p
        ? (function (e) {
            return xe$1(e) ? 'styled.' + e : 'Styled(' + b$1(e) + ')';
          })(e)
        : p,
    g = t.displayName && t.componentId ? je$1(t.displayName) + '-' + t.componentId : t.componentId || h,
    N = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c,
    A = t.shouldForwardProp;
  o &&
    e.shouldForwardProp &&
    (A = t.shouldForwardProp
      ? function (n, r, o) {
          return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
        }
      : e.shouldForwardProp);
  var C,
    I = new oe$1(n, g, o ? e.componentStyle : void 0),
    P = I.isStatic && 0 === c.length,
    O = function (e, t) {
      return (function (e, t, n, r) {
        var o = e.attrs,
          i = e.componentStyle,
          a = e.defaultProps,
          c = e.foldedComponentIds,
          d = e.shouldForwardProp,
          h = e.styledComponentId,
          p = e.target;
        'production' !== process.env.NODE_ENV && React.useDebugValue(h);
        var m = (function (e, t, n) {
            void 0 === e && (e = w$1);
            var r = v$1({}, t, { theme: e }),
              o = {};
            return (
              n.forEach(function (e) {
                var t,
                  n,
                  s,
                  i = e;
                for (t in (E$1(i) && (i = i(r)), i))
                  r[t] = o[t] = 'className' === t ? ((n = o[t]), (s = i[t]), n && s ? n + ' ' + s : n || s) : i[t];
              }),
              [r, o]
            );
          })(Oe$1(t, React.useContext(Me$1), a) || w$1, t, o),
          y = m[0],
          g = m[1],
          S = (function (e, t, n, r) {
            var o = pe$1(),
              s = fe$1(),
              i = t ? e.generateAndInjectStyles(w$1, o, s) : e.generateAndInjectStyles(n, o, s);
            return (
              'production' !== process.env.NODE_ENV && React.useDebugValue(i),
              'production' !== process.env.NODE_ENV && !t && r && r(i),
              i
            );
          })(i, r, y, 'production' !== process.env.NODE_ENV ? e.warnTooManyClasses : void 0),
          b = n,
          _ = g.$as || t.$as || g.as || t.as || p,
          N = xe$1(_),
          A = g !== t ? v$1({}, t, {}, g) : t,
          C = {};
        for (var I in A)
          '$' !== I[0] &&
            'as' !== I &&
            ('forwardedAs' === I ? (C.as = A[I]) : (d ? d(I, isPropValid, _) : !N || isPropValid(I)) && (C[I] = A[I]));
        return (
          t.style && g.style !== t.style && (C.style = v$1({}, t.style, {}, g.style)),
          (C.className = Array.prototype
            .concat(c, h, S !== h ? S : null, t.className, g.className)
            .filter(Boolean)
            .join(' ')),
          (C.ref = b),
          React.createElement(_, C)
        );
      })(C, e, t, P);
    };
  return (
    (O.displayName = y),
    ((C = React__default['default'].forwardRef(O)).attrs = N),
    (C.componentStyle = I),
    (C.displayName = y),
    (C.shouldForwardProp = A),
    (C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : S$1),
    (C.styledComponentId = g),
    (C.target = o ? e.target : e),
    (C.withComponent = function (e) {
      var r = t.componentId,
        o = (function (e, t) {
          if (null == e) return {};
          var n,
            r,
            o = {},
            s = Object.keys(e);
          for (r = 0; r < s.length; r++) (n = s[r]), t.indexOf(n) >= 0 || (o[n] = e[n]);
          return o;
        })(t, ['componentId']),
        s = r && r + '-' + (xe$1(e) ? e : je$1(b$1(e)));
      return Ye$1(e, v$1({}, o, { attrs: N, componentId: s }), n);
    }),
    Object.defineProperty(C, 'defaultProps', {
      get: function () {
        return this._foldedDefaultProps;
      },
      set: function (t) {
        this._foldedDefaultProps = o ? Be$1({}, e.defaultProps, t) : t;
      },
    }),
    'production' !== process.env.NODE_ENV &&
      (Pe$1(y, g),
      (C.warnTooManyClasses = (function (e, t) {
        var n = {},
          r = !1;
        return function (o) {
          if (!r && ((n[o] = !0), Object.keys(n).length >= 200)) {
            var s = t ? ' with the id of "' + t + '"' : '';
            console.warn(
              'Over 200 classes were generated for component ' +
                e +
                s +
                '.\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />',
            ),
              (r = !0),
              (n = {});
          }
        };
      })(y, g))),
    Object.defineProperty(C, 'toString', {
      value: function () {
        return '.' + C.styledComponentId;
      },
    }),
    i &&
      m$1(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0,
      }),
    C
  );
}
var qe = function (e) {
  return (function e(t, r, o) {
    if ((void 0 === o && (o = w$1), !reactIsExports$1.isValidElementType(r))) return D$1(1, String(r));
    var s = function () {
      return t(r, o, Ae$1.apply(void 0, arguments));
    };
    return (
      (s.withConfig = function (n) {
        return e(t, r, v$1({}, o, {}, n));
      }),
      (s.attrs = function (n) {
        return e(t, r, v$1({}, o, { attrs: Array.prototype.concat(o.attrs, n).filter(Boolean) }));
      }),
      s
    );
  })(Ye$1, e);
};
[
  'a',
  'abbr',
  'address',
  'area',
  'article',
  'aside',
  'audio',
  'b',
  'base',
  'bdi',
  'bdo',
  'big',
  'blockquote',
  'body',
  'br',
  'button',
  'canvas',
  'caption',
  'cite',
  'code',
  'col',
  'colgroup',
  'data',
  'datalist',
  'dd',
  'del',
  'details',
  'dfn',
  'dialog',
  'div',
  'dl',
  'dt',
  'em',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hgroup',
  'hr',
  'html',
  'i',
  'iframe',
  'img',
  'input',
  'ins',
  'kbd',
  'keygen',
  'label',
  'legend',
  'li',
  'link',
  'main',
  'map',
  'mark',
  'marquee',
  'menu',
  'menuitem',
  'meta',
  'meter',
  'nav',
  'noscript',
  'object',
  'ol',
  'optgroup',
  'option',
  'output',
  'p',
  'param',
  'picture',
  'pre',
  'progress',
  'q',
  'rp',
  'rt',
  'ruby',
  's',
  'samp',
  'script',
  'section',
  'select',
  'small',
  'source',
  'span',
  'strong',
  'style',
  'sub',
  'summary',
  'sup',
  'table',
  'tbody',
  'td',
  'textarea',
  'tfoot',
  'th',
  'thead',
  'time',
  'title',
  'tr',
  'track',
  'u',
  'ul',
  'var',
  'video',
  'wbr',
  'circle',
  'clipPath',
  'defs',
  'ellipse',
  'foreignObject',
  'g',
  'image',
  'line',
  'linearGradient',
  'marker',
  'mask',
  'path',
  'pattern',
  'polygon',
  'polyline',
  'radialGradient',
  'rect',
  'stop',
  'svg',
  'text',
  'textPath',
  'tspan',
].forEach(function (e) {
  qe[e] = qe(e);
});
'production' !== process.env.NODE_ENV &&
  'undefined' != typeof navigator &&
  'ReactNative' === navigator.product &&
  console.warn(
    "It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native",
  ),
  'production' !== process.env.NODE_ENV &&
    'test' !== process.env.NODE_ENV &&
    'undefined' != typeof window &&
    ((window['__styled-components-init__'] = window['__styled-components-init__'] || 0),
    1 === window['__styled-components-init__'] &&
      console.warn(
        "It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info.",
      ),
    (window['__styled-components-init__'] += 1));

var l;
function r(e, t) {
  return e[t];
}
function i(e, t) {
  return t.split('.').reduce((e, t) => {
    const n = t.match(/[^\]\\[.]+/g);
    if (n && n.length > 1) for (let t = 0; t < n.length; t++) return e[n[t]][n[t + 1]];
    return e[t];
  }, e);
}
function s(e = [], t, n = 0) {
  return [...e.slice(0, n), t, ...e.slice(n)];
}
function d(e = [], t, n = 'id') {
  const o = e.slice(),
    a = r(t, n);
  return (
    a
      ? o.splice(
          o.findIndex((e) => r(e, n) === a),
          1,
        )
      : o.splice(
          o.findIndex((e) => e === t),
          1,
        ),
    o
  );
}
function c(e) {
  return e.map((e, t) => {
    const n = Object.assign(Object.assign({}, e), { sortable: e.sortable || !!e.sortFunction || void 0 });
    return e.id || (n.id = t + 1), n;
  });
}
function g(e, t) {
  return Math.ceil(e / t);
}
function u(e, t) {
  return Math.min(e, t);
}
!(function (e) {
  (e.ASC = 'asc'), (e.DESC = 'desc');
})(l || (l = {}));
const p = () => null;
function b(e, t = [], n = []) {
  let o = {},
    a = [...n];
  return (
    t.length &&
      t.forEach((t) => {
        if (!t.when || 'function' != typeof t.when)
          throw new Error('"when" must be defined in the conditional style object and must be function');
        t.when(e) &&
          ((o = t.style || {}),
          t.classNames && (a = [...a, ...t.classNames]),
          'function' == typeof t.style && (o = t.style(e) || {}));
      }),
    { style: o, classNames: a.join(' ') }
  );
}
function m(e, t = [], n = 'id') {
  const o = r(e, n);
  return o ? t.some((e) => r(e, n) === o) : t.some((t) => t === e);
}
function h(e, t) {
  return t ? e.findIndex((e) => w(e.id, t)) : -1;
}
function w(e, t) {
  return e == t;
}
function f(e, t) {
  const n = !e.toggleOnSelectedRowsChange;
  switch (t.type) {
    case 'SELECT_ALL_ROWS': {
      const { keyField: n, rows: o, rowCount: a, mergeSelections: l } = t,
        r = !e.allSelected,
        i = !e.toggleOnSelectedRowsChange;
      if (l) {
        const t = r
          ? [...e.selectedRows, ...o.filter((t) => !m(t, e.selectedRows, n))]
          : e.selectedRows.filter((e) => !m(e, o, n));
        return Object.assign(Object.assign({}, e), {
          allSelected: r,
          selectedCount: t.length,
          selectedRows: t,
          toggleOnSelectedRowsChange: i,
        });
      }
      return Object.assign(Object.assign({}, e), {
        allSelected: r,
        selectedCount: r ? a : 0,
        selectedRows: r ? o : [],
        toggleOnSelectedRowsChange: i,
      });
    }
    case 'SELECT_SINGLE_ROW': {
      const { keyField: o, row: a, isSelected: l, rowCount: r, singleSelect: i } = t;
      return i
        ? l
          ? Object.assign(Object.assign({}, e), {
              selectedCount: 0,
              allSelected: !1,
              selectedRows: [],
              toggleOnSelectedRowsChange: n,
            })
          : Object.assign(Object.assign({}, e), {
              selectedCount: 1,
              allSelected: !1,
              selectedRows: [a],
              toggleOnSelectedRowsChange: n,
            })
        : l
        ? Object.assign(Object.assign({}, e), {
            selectedCount: e.selectedRows.length > 0 ? e.selectedRows.length - 1 : 0,
            allSelected: !1,
            selectedRows: d(e.selectedRows, a, o),
            toggleOnSelectedRowsChange: n,
          })
        : Object.assign(Object.assign({}, e), {
            selectedCount: e.selectedRows.length + 1,
            allSelected: e.selectedRows.length + 1 === r,
            selectedRows: s(e.selectedRows, a),
            toggleOnSelectedRowsChange: n,
          });
    }
    case 'SELECT_MULTIPLE_ROWS': {
      const { keyField: o, selectedRows: a, totalRows: l, mergeSelections: r } = t;
      if (r) {
        const t = [...e.selectedRows, ...a.filter((t) => !m(t, e.selectedRows, o))];
        return Object.assign(Object.assign({}, e), {
          selectedCount: t.length,
          allSelected: !1,
          selectedRows: t,
          toggleOnSelectedRowsChange: n,
        });
      }
      return Object.assign(Object.assign({}, e), {
        selectedCount: a.length,
        allSelected: a.length === l,
        selectedRows: a,
        toggleOnSelectedRowsChange: n,
      });
    }
    case 'CLEAR_SELECTED_ROWS': {
      const { selectedRowsFlag: n } = t;
      return Object.assign(Object.assign({}, e), {
        allSelected: !1,
        selectedCount: 0,
        selectedRows: [],
        selectedRowsFlag: n,
      });
    }
    case 'SORT_CHANGE': {
      const { sortDirection: o, selectedColumn: a, clearSelectedOnSort: l } = t;
      return Object.assign(
        Object.assign(Object.assign({}, e), { selectedColumn: a, sortDirection: o, currentPage: 1 }),
        l && { allSelected: !1, selectedCount: 0, selectedRows: [], toggleOnSelectedRowsChange: n },
      );
    }
    case 'CHANGE_PAGE': {
      const { page: o, paginationServer: a, visibleOnly: l, persistSelectedOnPageChange: r } = t,
        i = a && r,
        s = (a && !r) || l;
      return Object.assign(
        Object.assign(Object.assign(Object.assign({}, e), { currentPage: o }), i && { allSelected: !1 }),
        s && { allSelected: !1, selectedCount: 0, selectedRows: [], toggleOnSelectedRowsChange: n },
      );
    }
    case 'CHANGE_ROWS_PER_PAGE': {
      const { rowsPerPage: n, page: o } = t;
      return Object.assign(Object.assign({}, e), { currentPage: o, rowsPerPage: n });
    }
  }
}
const x = Ae$1`
	pointer-events: none;
	opacity: 0.4;
`,
  C = qe.div`
	position: relative;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	max-width: 100%;
	${({ disabled: e }) => e && x};
	${({ theme: e }) => e.table.style};
`,
  y = Ae$1`
	position: sticky;
	position: -webkit-sticky; /* Safari */
	top: 0;
	z-index: 1;
`,
  R = qe.div`
	display: flex;
	width: 100%;
	${({ fixedHeader: e }) => e && y};
	${({ theme: e }) => e.head.style};
`,
  v = qe.div`
	display: flex;
	align-items: stretch;
	width: 100%;
	${({ theme: e }) => e.headRow.style};
	${({ dense: e, theme: t }) => e && t.headRow.denseStyle};
`,
  S = (e, ...t) => Ae$1`
		@media screen and (max-width: ${599}px) {
			${Ae$1(e, ...t)}
		}
	`,
  E = (e, ...t) => Ae$1`
		@media screen and (max-width: ${959}px) {
			${Ae$1(e, ...t)}
		}
	`,
  O = (e, ...t) => Ae$1`
		@media screen and (max-width: ${1280}px) {
			${Ae$1(e, ...t)}
		}
	`,
  k =
    (e) =>
    (t, ...n) => Ae$1`
				@media screen and (max-width: ${e}px) {
					${Ae$1(t, ...n)}
				}
			`,
  P = qe.div`
	position: relative;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	line-height: normal;
	${({ theme: e, headCell: t }) => e[t ? 'headCells' : 'cells'].style};
	${({ noPadding: e }) => e && 'padding: 0'};
`,
  D = qe(P)`
	flex-grow: ${({ button: e, grow: t }) => (0 === t || e ? 0 : t || 1)};
	flex-shrink: 0;
	flex-basis: 0;
	max-width: ${({ maxWidth: e }) => e || '100%'};
	min-width: ${({ minWidth: e }) => e || '100px'};
	${({ width: e }) =>
    e &&
    Ae$1`
			min-width: ${e};
			max-width: ${e};
		`};
	${({ right: e }) => e && 'justify-content: flex-end'};
	${({ button: e, center: t }) => (t || e) && 'justify-content: center'};
	${({ compact: e, button: t }) => (e || t) && 'padding: 0'};

	/* handle hiding cells */
	${({ hide: e }) =>
    e &&
    'sm' === e &&
    S`
    display: none;
  `};
	${({ hide: e }) =>
    e &&
    'md' === e &&
    E`
    display: none;
  `};
	${({ hide: e }) =>
    e &&
    'lg' === e &&
    O`
    display: none;
  `};
	${({ hide: e }) =>
    e &&
    Number.isInteger(e) &&
    k(e)`
    display: none;
  `};
`,
  H = Ae$1`
	div:first-child {
		white-space: ${({ wrapCell: e }) => (e ? 'normal' : 'nowrap')};
		overflow: ${({ allowOverflow: e }) => (e ? 'visible' : 'hidden')};
		text-overflow: ellipsis;
	}
`,
  $ = qe(D).attrs((e) => ({ style: e.style }))`
	${({ renderAsCell: e }) => !e && H};
	${({ theme: e, isDragging: t }) => t && e.cells.draggingStyle};
	${({ cellStyle: e }) => e};
`;
var F = React__namespace.memo(function ({
  id: t,
  column: n,
  row: o,
  rowIndex: a,
  dataTag: l,
  isDragging: r,
  onDragStart: s,
  onDragOver: d,
  onDragEnd: c,
  onDragEnter: g,
  onDragLeave: u,
}) {
  const { style: p, classNames: m } = b(o, n.conditionalCellStyles, ['rdt_TableCell']);
  return React__namespace.createElement(
    $,
    {
      id: t,
      'data-column-id': n.id,
      role: 'cell',
      className: m,
      'data-tag': l,
      cellStyle: n.style,
      renderAsCell: !!n.cell,
      allowOverflow: n.allowOverflow,
      button: n.button,
      center: n.center,
      compact: n.compact,
      grow: n.grow,
      hide: n.hide,
      maxWidth: n.maxWidth,
      minWidth: n.minWidth,
      right: n.right,
      width: n.width,
      wrapCell: n.wrap,
      style: p,
      isDragging: r,
      onDragStart: s,
      onDragOver: d,
      onDragEnd: c,
      onDragEnter: g,
      onDragLeave: u,
    },
    !n.cell &&
      React__namespace.createElement(
        'div',
        { 'data-tag': l },
        (function (e, t, n, o) {
          if (!t) return null;
          if ('string' != typeof t && 'function' != typeof t)
            throw new Error(
              'selector must be a . delimited string eg (my.property) or function (e.g. row => row.field',
            );
          return n && 'function' == typeof n ? n(e, o) : t && 'function' == typeof t ? t(e, o) : i(e, t);
        })(o, n.selector, n.format, a),
      ),
    n.cell && n.cell(o, a, n, t),
  );
});
var j = React__namespace.memo(function ({
  name: t,
  component: n = 'input',
  componentOptions: o = { style: {} },
  indeterminate: a = !1,
  checked: l = !1,
  disabled: r = !1,
  onClick: i = p,
}) {
  const s = n,
    d =
      'input' !== s
        ? o.style
        : ((e) =>
            Object.assign(Object.assign({ fontSize: '18px' }, !e && { cursor: 'pointer' }), {
              padding: 0,
              marginTop: '1px',
              verticalAlign: 'middle',
              position: 'relative',
            }))(r),
    c = React__namespace.useMemo(
      () =>
        (function (e, ...t) {
          let n;
          return (
            Object.keys(e)
              .map((t) => e[t])
              .forEach((o, a) => {
                const l = e;
                'function' == typeof o && (n = Object.assign(Object.assign({}, l), { [Object.keys(e)[a]]: o(...t) }));
              }),
            n || e
          );
        })(o, a),
      [o, a],
    );
  return React__namespace.createElement(
    s,
    Object.assign(
      {
        type: 'checkbox',
        ref: (e) => {
          e && (e.indeterminate = a);
        },
        style: d,
        onClick: r ? p : i,
        name: t,
        'aria-label': t,
        checked: l,
        disabled: r,
      },
      c,
      { onChange: p },
    ),
  );
});
const I = qe(P)`
	flex: 0 0 48px;
	min-width: 48px;
	justify-content: center;
	align-items: center;
	user-select: none;
	white-space: nowrap;
`;
function T({
  name: t,
  keyField: n,
  row: o,
  rowCount: a,
  selected: l,
  selectableRowsComponent: r,
  selectableRowsComponentProps: i,
  selectableRowsSingle: s,
  selectableRowDisabled: d,
  onSelectedRow: c,
}) {
  const g = !(!d || !d(o));
  return React__namespace.createElement(
    I,
    { onClick: (e) => e.stopPropagation(), className: 'rdt_TableCell', noPadding: !0 },
    React__namespace.createElement(j, {
      name: t,
      component: r,
      componentOptions: i,
      checked: l,
      'aria-checked': l,
      onClick: () => {
        c({ type: 'SELECT_SINGLE_ROW', row: o, isSelected: l, keyField: n, rowCount: a, singleSelect: s });
      },
      disabled: g,
    }),
  );
}
const L = qe.button`
	display: inline-flex;
	align-items: center;
	user-select: none;
	white-space: nowrap;
	border: none;
	background-color: transparent;
	${({ theme: e }) => e.expanderButton.style};
`;
function M({ disabled: t = !1, expanded: n = !1, expandableIcon: o, id: a, row: l, onToggled: r }) {
  const i = n ? o.expanded : o.collapsed;
  return React__namespace.createElement(
    L,
    {
      'aria-disabled': t,
      onClick: () => r && r(l),
      'data-testid': `expander-button-${a}`,
      disabled: t,
      'aria-label': n ? 'Collapse Row' : 'Expand Row',
      role: 'button',
      type: 'button',
    },
    i,
  );
}
const A = qe(P)`
	white-space: nowrap;
	font-weight: 400;
	min-width: 48px;
	${({ theme: e }) => e.expanderCell.style};
`;
function _({ row: t, expanded: n = !1, expandableIcon: o, id: a, onToggled: l, disabled: r = !1 }) {
  return React__namespace.createElement(
    A,
    { onClick: (e) => e.stopPropagation(), noPadding: !0 },
    React__namespace.createElement(M, { id: a, row: t, expanded: n, expandableIcon: o, disabled: r, onToggled: l }),
  );
}
const N = qe.div`
	width: 100%;
	box-sizing: border-box;
	${({ theme: e }) => e.expanderRow.style};
	${({ extendedRowStyle: e }) => e};
`;
var z = React__namespace.memo(function ({
  data: t,
  ExpanderComponent: n,
  expanderComponentProps: o,
  extendedRowStyle: a,
  extendedClassNames: l,
}) {
  const r = ['rdt_ExpanderRow', ...l.split(' ').filter((e) => 'rdt_TableRow' !== e)].join(' ');
  return React__namespace.createElement(
    N,
    { className: r, extendedRowStyle: a },
    React__namespace.createElement(n, Object.assign({ data: t }, o)),
  );
});
var B, G, V;
!(function (e) {
  (e.LTR = 'ltr'), (e.RTL = 'rtl'), (e.AUTO = 'auto');
})(B || (B = {})),
  (function (e) {
    (e.LEFT = 'left'), (e.RIGHT = 'right'), (e.CENTER = 'center');
  })(G || (G = {})),
  (function (e) {
    (e.SM = 'sm'), (e.MD = 'md'), (e.LG = 'lg');
  })(V || (V = {}));
const U = Ae$1`
	&:hover {
		${({ highlightOnHover: e, theme: t }) => e && t.rows.highlightOnHoverStyle};
	}
`,
  Y = Ae$1`
	&:hover {
		cursor: pointer;
	}
`,
  K = qe.div.attrs((e) => ({ style: e.style }))`
	display: flex;
	align-items: stretch;
	align-content: stretch;
	width: 100%;
	box-sizing: border-box;
	${({ theme: e }) => e.rows.style};
	${({ dense: e, theme: t }) => e && t.rows.denseStyle};
	${({ striped: e, theme: t }) => e && t.rows.stripedStyle};
	${({ highlightOnHover: e }) => e && U};
	${({ pointerOnHover: e }) => e && Y};
	${({ selected: e, theme: t }) => e && t.rows.selectedHighlightStyle};
`;
function q({
  columns: t = [],
  conditionalRowStyles: n = [],
  defaultExpanded: o = !1,
  defaultExpanderDisabled: a = !1,
  dense: l = !1,
  expandableIcon: i,
  expandableRows: s = !1,
  expandableRowsComponent: d,
  expandableRowsComponentProps: c,
  expandableRowsHideExpander: g,
  expandOnRowClicked: u = !1,
  expandOnRowDoubleClicked: m = !1,
  highlightOnHover: h = !1,
  id: f,
  expandableInheritConditionalStyles: x,
  keyField: C,
  onRowClicked: y = p,
  onRowDoubleClicked: R = p,
  onRowMouseEnter: v = p,
  onRowMouseLeave: S = p,
  onRowExpandToggled: E = p,
  onSelectedRow: O = p,
  pointerOnHover: k = !1,
  row: P,
  rowCount: D,
  rowIndex: H,
  selectableRowDisabled: $ = null,
  selectableRows: j = !1,
  selectableRowsComponent: I,
  selectableRowsComponentProps: L,
  selectableRowsHighlight: M = !1,
  selectableRowsSingle: A = !1,
  selected: N,
  striped: W = !1,
  draggingColumnId: B,
  onDragStart: G,
  onDragOver: V,
  onDragEnd: U,
  onDragEnter: Y,
  onDragLeave: q,
}) {
  const [J, Q] = React__namespace.useState(o);
  React__namespace.useEffect(() => {
    Q(o);
  }, [o]);
  const X = React__namespace.useCallback(() => {
      Q(!J), E(!J, P);
    }, [J, E, P]),
    Z = k || (s && (u || m)),
    ee = React__namespace.useCallback(
      (e) => {
        e.target && 'allowRowEvents' === e.target.getAttribute('data-tag') && (y(P, e), !a && s && u && X());
      },
      [a, u, s, X, y, P],
    ),
    te = React__namespace.useCallback(
      (e) => {
        e.target && 'allowRowEvents' === e.target.getAttribute('data-tag') && (R(P, e), !a && s && m && X());
      },
      [a, m, s, X, R, P],
    ),
    ne = React__namespace.useCallback(
      (e) => {
        v(P, e);
      },
      [v, P],
    ),
    oe = React__namespace.useCallback(
      (e) => {
        S(P, e);
      },
      [S, P],
    ),
    ae = r(P, C),
    { style: le, classNames: re } = b(P, n, ['rdt_TableRow']),
    ie = M && N,
    se = x ? le : {},
    de = W && H % 2 == 0;
  return React__namespace.createElement(
    React__namespace.Fragment,
    null,
    React__namespace.createElement(
      K,
      {
        id: `row-${f}`,
        role: 'row',
        striped: de,
        highlightOnHover: h,
        pointerOnHover: !a && Z,
        dense: l,
        onClick: ee,
        onDoubleClick: te,
        onMouseEnter: ne,
        onMouseLeave: oe,
        className: re,
        selected: ie,
        style: le,
      },
      j &&
        React__namespace.createElement(T, {
          name: `select-row-${ae}`,
          keyField: C,
          row: P,
          rowCount: D,
          selected: N,
          selectableRowsComponent: I,
          selectableRowsComponentProps: L,
          selectableRowDisabled: $,
          selectableRowsSingle: A,
          onSelectedRow: O,
        }),
      s &&
        !g &&
        React__namespace.createElement(_, {
          id: ae,
          expandableIcon: i,
          expanded: J,
          row: P,
          onToggled: X,
          disabled: a,
        }),
      t.map((t) =>
        t.omit
          ? null
          : React__namespace.createElement(F, {
              id: `cell-${t.id}-${ae}`,
              key: `cell-${t.id}-${ae}`,
              dataTag: t.ignoreRowClick || t.button ? null : 'allowRowEvents',
              column: t,
              row: P,
              rowIndex: H,
              isDragging: w(B, t.id),
              onDragStart: G,
              onDragOver: V,
              onDragEnd: U,
              onDragEnter: Y,
              onDragLeave: q,
            }),
      ),
    ),
    s &&
      J &&
      React__namespace.createElement(z, {
        key: `expander-${ae}`,
        data: P,
        extendedRowStyle: se,
        extendedClassNames: re,
        ExpanderComponent: d,
        expanderComponentProps: c,
      }),
  );
}
const J = qe.span`
	padding: 2px;
	color: inherit;
	flex-grow: 0;
	flex-shrink: 0;
	${({ sortActive: e }) => (e ? 'opacity: 1' : 'opacity: 0')};
	${({ sortDirection: e }) => 'desc' === e && 'transform: rotate(180deg)'};
`,
  Q = ({ sortActive: e, sortDirection: n }) =>
    React__default['default'].createElement(J, { sortActive: e, sortDirection: n }, '▲'),
  X = qe(D)`
	${({ button: e }) => e && 'text-align: center'};
	${({ theme: e, isDragging: t }) => t && e.headCells.draggingStyle};
`,
  Z = Ae$1`
	cursor: pointer;
	span.__rdt_custom_sort_icon__ {
		i,
		svg {
			transform: 'translate3d(0, 0, 0)';
			${({ sortActive: e }) => (e ? 'opacity: 1' : 'opacity: 0')};
			color: inherit;
			font-size: 18px;
			height: 18px;
			width: 18px;
			backface-visibility: hidden;
			transform-style: preserve-3d;
			transition-duration: 95ms;
			transition-property: transform;
		}

		&.asc i,
		&.asc svg {
			transform: rotate(180deg);
		}
	}

	${({ sortActive: e }) =>
    !e &&
    Ae$1`
			&:hover,
			&:focus {
				opacity: 0.7;

				span,
				span.__rdt_custom_sort_icon__ * {
					opacity: 0.7;
				}
			}
		`};
`,
  ee = qe.div`
	display: inline-flex;
	align-items: center;
	justify-content: inherit;
	height: 100%;
	width: 100%;
	outline: none;
	user-select: none;
	overflow: hidden;
	${({ disabled: e }) => !e && Z};
`,
  te = qe.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
var ne = React__namespace.memo(function ({
  column: t,
  disabled: n,
  draggingColumnId: o,
  selectedColumn: a = {},
  sortDirection: r,
  sortIcon: i,
  sortServer: s,
  pagination: d,
  paginationServer: c,
  persistSelectedOnSort: g,
  selectableRowsVisibleOnly: u,
  onSort: p,
  onDragStart: b,
  onDragOver: m,
  onDragEnd: h,
  onDragEnter: f,
  onDragLeave: x,
}) {
  React__namespace.useEffect(() => {
    'string' == typeof t.selector &&
      console.error(
        `Warning: ${t.selector} is a string based column selector which has been deprecated as of v7 and will be removed in v8. Instead, use a selector function e.g. row => row[field]...`,
      );
  }, []);
  const [C, y] = React__namespace.useState(!1),
    R = React__namespace.useRef(null);
  if (
    (React__namespace.useEffect(() => {
      R.current && y(R.current.scrollWidth > R.current.clientWidth);
    }, [C]),
    t.omit)
  )
    return null;
  const v = () => {
      if (!t.sortable && !t.selector) return;
      let e = r;
      w(a.id, t.id) && (e = r === l.ASC ? l.DESC : l.ASC),
        p({ type: 'SORT_CHANGE', sortDirection: e, selectedColumn: t, clearSelectedOnSort: (d && c && !g) || s || u });
    },
    S = (t) => React__namespace.createElement(Q, { sortActive: t, sortDirection: r }),
    E = () => React__namespace.createElement('span', { className: [r, '__rdt_custom_sort_icon__'].join(' ') }, i),
    O = !(!t.sortable || !w(a.id, t.id)),
    k = !t.sortable || n,
    P = t.sortable && !i && !t.right,
    D = t.sortable && !i && t.right,
    H = t.sortable && i && !t.right,
    $ = t.sortable && i && t.right;
  return React__namespace.createElement(
    X,
    {
      'data-column-id': t.id,
      className: 'rdt_TableCol',
      headCell: !0,
      allowOverflow: t.allowOverflow,
      button: t.button,
      compact: t.compact,
      grow: t.grow,
      hide: t.hide,
      maxWidth: t.maxWidth,
      minWidth: t.minWidth,
      right: t.right,
      center: t.center,
      width: t.width,
      draggable: t.reorder,
      isDragging: w(t.id, o),
      onDragStart: b,
      onDragOver: m,
      onDragEnd: h,
      onDragEnter: f,
      onDragLeave: x,
    },
    t.name &&
      React__namespace.createElement(
        ee,
        {
          'data-column-id': t.id,
          'data-sort-id': t.id,
          role: 'columnheader',
          tabIndex: 0,
          className: 'rdt_TableCol_Sortable',
          onClick: k ? void 0 : v,
          onKeyPress: k
            ? void 0
            : (e) => {
                'Enter' === e.key && v();
              },
          sortActive: !k && O,
          disabled: k,
        },
        !k && $ && E(),
        !k && D && S(O),
        'string' == typeof t.name
          ? React__namespace.createElement(te, { title: C ? t.name : void 0, ref: R, 'data-column-id': t.id }, t.name)
          : t.name,
        !k && H && E(),
        !k && P && S(O),
      ),
  );
});
const oe = qe(P)`
	flex: 0 0 48px;
	justify-content: center;
	align-items: center;
	user-select: none;
	white-space: nowrap;
	font-size: unset;
`;
function ae({
  headCell: t = !0,
  rowData: n,
  keyField: o,
  allSelected: a,
  mergeSelections: l,
  selectedRows: r,
  selectableRowsComponent: i,
  selectableRowsComponentProps: s,
  selectableRowDisabled: d,
  onSelectAllRows: c,
}) {
  const g = r.length > 0 && !a,
    u = d ? n.filter((e) => !d(e)) : n,
    p = 0 === u.length,
    b = Math.min(n.length, u.length);
  return React__namespace.createElement(
    oe,
    { className: 'rdt_TableCol', headCell: t, noPadding: !0 },
    React__namespace.createElement(j, {
      name: 'select-all-rows',
      component: i,
      componentOptions: s,
      onClick: () => {
        c({ type: 'SELECT_ALL_ROWS', rows: u, rowCount: b, mergeSelections: l, keyField: o });
      },
      checked: a,
      indeterminate: g,
      disabled: p,
    }),
  );
}
function le(t = B.AUTO) {
  const n = 'object' == typeof window,
    [o, a] = React__namespace.useState(!1);
  return (
    React__namespace.useEffect(() => {
      if (n)
        if ('auto' !== t) a('rtl' === t);
        else {
          const e = !(!window.document || !window.document.createElement),
            t = document.getElementsByTagName('BODY')[0],
            n = document.getElementsByTagName('HTML')[0],
            o = 'rtl' === t.dir || 'rtl' === n.dir;
          a(e && o);
        }
    }, [t, n]),
    o
  );
}
const re = qe.div`
	display: flex;
	align-items: center;
	flex: 1 0 auto;
	height: 100%;
	color: ${({ theme: e }) => e.contextMenu.fontColor};
	font-size: ${({ theme: e }) => e.contextMenu.fontSize};
	font-weight: 400;
`,
  ie = qe.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-wrap: wrap;
`,
  se = qe.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	box-sizing: inherit;
	z-index: 1;
	align-items: center;
	justify-content: space-between;
	display: flex;
	${({ rtl: e }) => e && 'direction: rtl'};
	${({ theme: e }) => e.contextMenu.style};
	${({ theme: e, visible: t }) => t && e.contextMenu.activeStyle};
`;
function de({ contextMessage: t, contextActions: n, contextComponent: o, selectedCount: a, direction: l }) {
  const r = le(l),
    i = a > 0;
  return o
    ? React__namespace.createElement(se, { visible: i }, React__namespace.cloneElement(o, { selectedCount: a }))
    : React__namespace.createElement(
        se,
        { visible: i, rtl: r },
        React__namespace.createElement(
          re,
          null,
          ((e, t, n) => {
            if (0 === t) return null;
            const o = 1 === t ? e.singular : e.plural;
            return n ? `${t} ${e.message || ''} ${o}` : `${t} ${o} ${e.message || ''}`;
          })(t, a, r),
        ),
        React__namespace.createElement(ie, null, n),
      );
}
const ce = qe.div`
	position: relative;
	box-sizing: border-box;
	overflow: hidden;
	display: flex;
	flex: 1 1 auto;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	flex-wrap: wrap;
	${({ theme: e }) => e.header.style}
`,
  ge = qe.div`
	flex: 1 0 auto;
	color: ${({ theme: e }) => e.header.fontColor};
	font-size: ${({ theme: e }) => e.header.fontSize};
	font-weight: 400;
`,
  ue = qe.div`
	flex: 1 0 auto;
	display: flex;
	align-items: center;
	justify-content: flex-end;

	> * {
		margin-left: 5px;
	}
`,
  pe = ({
    title: t,
    actions: n = null,
    contextMessage: o,
    contextActions: a,
    contextComponent: l,
    selectedCount: r,
    direction: i,
    showMenu: s = !0,
  }) =>
    React__namespace.createElement(
      ce,
      { className: 'rdt_TableHeader', role: 'heading', 'aria-level': 1 },
      React__namespace.createElement(ge, null, t),
      n && React__namespace.createElement(ue, null, n),
      s &&
        React__namespace.createElement(de, {
          contextMessage: o,
          contextActions: a,
          contextComponent: l,
          direction: i,
          selectedCount: r,
        }),
    );
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function be(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (null != e && 'function' == typeof Object.getOwnPropertySymbols) {
    var a = 0;
    for (o = Object.getOwnPropertySymbols(e); a < o.length; a++)
      t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (n[o[a]] = e[o[a]]);
  }
  return n;
}
const me = { left: 'flex-start', right: 'flex-end', center: 'center' },
  he = qe.header`
	position: relative;
	display: flex;
	flex: 1 1 auto;
	box-sizing: border-box;
	align-items: center;
	padding: 4px 16px 4px 24px;
	width: 100%;
	justify-content: ${({ align: e }) => me[e]};
	flex-wrap: ${({ wrapContent: e }) => (e ? 'wrap' : 'nowrap')};
	${({ theme: e }) => e.subHeader.style}
`,
  we = (t) => {
    var { align: n = 'right', wrapContent: o = !0 } = t,
      a = be(t, ['align', 'wrapContent']);
    return React__namespace.createElement(he, Object.assign({ align: n, wrapContent: o }, a));
  },
  fe = qe.div`
	display: flex;
	flex-direction: column;
`,
  xe = qe.div`
	position: relative;
	width: 100%;
	border-radius: inherit;
	${({ responsive: e, fixedHeader: t }) =>
    e &&
    Ae$1`
			overflow-x: auto;

			// hidden prevents vertical scrolling in firefox when fixedHeader is disabled
			overflow-y: ${t ? 'auto' : 'hidden'};
			min-height: 0;
		`};

	${({ fixedHeader: e = !1, fixedHeaderScrollHeight: t = '100vh' }) =>
    e &&
    Ae$1`
			max-height: ${t};
			-webkit-overflow-scrolling: touch;
		`};

	${({ theme: e }) => e.responsiveWrapper.style};
`,
  Ce = qe.div`
	position: relative;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	${(e) => e.theme.progress.style};
`,
  ye = qe.div`
	position: relative;
	width: 100%;
	${({ theme: e }) => e.tableWrapper.style};
`,
  Re = qe(P)`
	white-space: nowrap;
	${({ theme: e }) => e.expanderCell.style};
`,
  ve = qe.div`
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	${({ theme: e }) => e.noData.style};
`,
  Se = () =>
    React__default['default'].createElement(
      'svg',
      { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
      React__default['default'].createElement('path', { d: 'M7 10l5 5 5-5z' }),
      React__default['default'].createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
    ),
  Ee = qe.select`
	cursor: pointer;
	height: 24px;
	max-width: 100%;
	user-select: none;
	padding-left: 8px;
	padding-right: 24px;
	box-sizing: content-box;
	font-size: inherit;
	color: inherit;
	border: none;
	background-color: transparent;
	appearance: none;
	direction: ltr;
	flex-shrink: 0;

	&::-ms-expand {
		display: none;
	}

	&:disabled::-ms-expand {
		background: #f60;
	}

	option {
		color: initial;
	}
`,
  Oe = qe.div`
	position: relative;
	flex-shrink: 0;
	font-size: inherit;
	color: inherit;
	margin-top: 1px;

	svg {
		top: 0;
		right: 0;
		color: inherit;
		position: absolute;
		fill: currentColor;
		width: 24px;
		height: 24px;
		display: inline-block;
		user-select: none;
		pointer-events: none;
	}
`,
  ke = (t) => {
    var { defaultValue: n, onChange: o } = t,
      a = be(t, ['defaultValue', 'onChange']);
    return React__namespace.createElement(
      Oe,
      null,
      React__namespace.createElement(Ee, Object.assign({ onChange: o, defaultValue: n }, a)),
      React__namespace.createElement(Se, null),
    );
  },
  Pe = {
    columns: [],
    data: [],
    title: '',
    keyField: 'id',
    selectableRows: !1,
    selectableRowsHighlight: !1,
    selectableRowsNoSelectAll: !1,
    selectableRowSelected: null,
    selectableRowDisabled: null,
    selectableRowsComponent: 'input',
    selectableRowsComponentProps: {},
    selectableRowsVisibleOnly: !1,
    selectableRowsSingle: !1,
    clearSelectedRows: !1,
    expandableRows: !1,
    expandableRowDisabled: null,
    expandableRowExpanded: null,
    expandOnRowClicked: !1,
    expandableRowsHideExpander: !1,
    expandOnRowDoubleClicked: !1,
    expandableInheritConditionalStyles: !1,
    expandableRowsComponent: function () {
      return React__default['default'].createElement(
        'div',
        null,
        'To add an expander pass in a component instance via ',
        React__default['default'].createElement('strong', null, 'expandableRowsComponent'),
        '. You can then access props.data from this component.',
      );
    },
    expandableIcon: {
      collapsed: React__default['default'].createElement(
        () =>
          React__default['default'].createElement(
            'svg',
            {
              fill: 'currentColor',
              height: '24',
              viewBox: '0 0 24 24',
              width: '24',
              xmlns: 'http://www.w3.org/2000/svg',
            },
            React__default['default'].createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' }),
            React__default['default'].createElement('path', { d: 'M0-.25h24v24H0z', fill: 'none' }),
          ),
        null,
      ),
      expanded: React__default['default'].createElement(
        () =>
          React__default['default'].createElement(
            'svg',
            {
              fill: 'currentColor',
              height: '24',
              viewBox: '0 0 24 24',
              width: '24',
              xmlns: 'http://www.w3.org/2000/svg',
            },
            React__default['default'].createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' }),
            React__default['default'].createElement('path', { d: 'M0-.75h24v24H0z', fill: 'none' }),
          ),
        null,
      ),
    },
    expandableRowsComponentProps: {},
    progressPending: !1,
    progressComponent: React__default['default'].createElement(
      'div',
      { style: { fontSize: '24px', fontWeight: 700, padding: '24px' } },
      'Loading...',
    ),
    persistTableHead: !1,
    sortIcon: null,
    sortFunction: null,
    sortServer: !1,
    striped: !1,
    highlightOnHover: !1,
    pointerOnHover: !1,
    noContextMenu: !1,
    contextMessage: { singular: 'item', plural: 'items', message: 'selected' },
    actions: null,
    contextActions: null,
    contextComponent: null,
    defaultSortFieldId: null,
    defaultSortAsc: !0,
    responsive: !0,
    noDataComponent: React__default['default'].createElement(
      'div',
      { style: { padding: '24px' } },
      'There are no records to display',
    ),
    disabled: !1,
    noTableHead: !1,
    noHeader: !1,
    subHeader: !1,
    subHeaderAlign: G.RIGHT,
    subHeaderWrap: !0,
    subHeaderComponent: null,
    fixedHeader: !1,
    fixedHeaderScrollHeight: '100vh',
    pagination: !1,
    paginationServer: !1,
    paginationServerOptions: { persistSelectedOnSort: !1, persistSelectedOnPageChange: !1 },
    paginationDefaultPage: 1,
    paginationResetDefaultPage: !1,
    paginationTotalRows: 0,
    paginationPerPage: 10,
    paginationRowsPerPageOptions: [10, 15, 20, 25, 30],
    paginationComponent: null,
    paginationComponentOptions: {},
    paginationIconFirstPage: React__default['default'].createElement(
      () =>
        React__default['default'].createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            'aria-hidden': 'true',
            role: 'presentation',
          },
          React__default['default'].createElement('path', {
            d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z',
          }),
          React__default['default'].createElement('path', { fill: 'none', d: 'M24 24H0V0h24v24z' }),
        ),
      null,
    ),
    paginationIconLastPage: React__default['default'].createElement(
      () =>
        React__default['default'].createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            'aria-hidden': 'true',
            role: 'presentation',
          },
          React__default['default'].createElement('path', {
            d: 'M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z',
          }),
          React__default['default'].createElement('path', { fill: 'none', d: 'M0 0h24v24H0V0z' }),
        ),
      null,
    ),
    paginationIconNext: React__default['default'].createElement(
      () =>
        React__default['default'].createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            'aria-hidden': 'true',
            role: 'presentation',
          },
          React__default['default'].createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' }),
          React__default['default'].createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
        ),
      null,
    ),
    paginationIconPrevious: React__default['default'].createElement(
      () =>
        React__default['default'].createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            'aria-hidden': 'true',
            role: 'presentation',
          },
          React__default['default'].createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' }),
          React__default['default'].createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
        ),
      null,
    ),
    dense: !1,
    conditionalRowStyles: [],
    theme: 'default',
    customStyles: {},
    direction: B.AUTO,
    onChangePage: p,
    onChangeRowsPerPage: p,
    onRowClicked: p,
    onRowDoubleClicked: p,
    onRowMouseEnter: p,
    onRowMouseLeave: p,
    onRowExpandToggled: p,
    onSelectedRowsChange: p,
    onSort: p,
    onColumnOrderChange: p,
  },
  De = {
    rowsPerPageText: 'Rows per page:',
    rangeSeparatorText: 'of',
    noRowsPerPage: !1,
    selectAllRowsItem: !1,
    selectAllRowsItemText: 'All',
  },
  He = qe.nav`
	display: flex;
	flex: 1 1 auto;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	padding-right: 8px;
	padding-left: 8px;
	width: 100%;
	${({ theme: e }) => e.pagination.style};
`,
  $e = qe.button`
	position: relative;
	display: block;
	user-select: none;
	border: none;
	${({ theme: e }) => e.pagination.pageButtonsStyle};
	${({ isRTL: e }) => e && 'transform: scale(-1, -1)'};
`,
  Fe = qe.div`
	display: flex;
	align-items: center;
	border-radius: 4px;
	white-space: nowrap;
	${S`
    width: 100%;
    justify-content: space-around;
  `};
`,
  je = qe.span`
	flex-shrink: 1;
	user-select: none;
`,
  Ie = qe(je)`
	margin: 0 24px;
`,
  Te = qe(je)`
	margin: 0 4px;
`;
var Le = React__namespace.memo(function ({
  rowsPerPage: t,
  rowCount: n,
  currentPage: o,
  direction: a = Pe.direction,
  paginationRowsPerPageOptions: l = Pe.paginationRowsPerPageOptions,
  paginationIconLastPage: r = Pe.paginationIconLastPage,
  paginationIconFirstPage: i = Pe.paginationIconFirstPage,
  paginationIconNext: s = Pe.paginationIconNext,
  paginationIconPrevious: d = Pe.paginationIconPrevious,
  paginationComponentOptions: c = Pe.paginationComponentOptions,
  onChangeRowsPerPage: u = Pe.onChangeRowsPerPage,
  onChangePage: p = Pe.onChangePage,
}) {
  const b = (() => {
      const t = 'object' == typeof window;
      function n() {
        return { width: t ? window.innerWidth : void 0, height: t ? window.innerHeight : void 0 };
      }
      const [o, a] = React__namespace.useState(n);
      return (
        React__namespace.useEffect(() => {
          if (!t) return () => null;
          function e() {
            a(n());
          }
          return window.addEventListener('resize', e), () => window.removeEventListener('resize', e);
        }, []),
        o
      );
    })(),
    m = le(a),
    h = b.width && b.width > 599,
    w = g(n, t),
    f = o * t,
    x = f - t + 1,
    C = 1 === o,
    y = o === w,
    R = Object.assign(Object.assign({}, De), c),
    v = o === w ? `${x}-${n} ${R.rangeSeparatorText} ${n}` : `${x}-${f} ${R.rangeSeparatorText} ${n}`,
    S = React__namespace.useCallback(() => p(o - 1), [o, p]),
    E = React__namespace.useCallback(() => p(o + 1), [o, p]),
    O = React__namespace.useCallback(() => p(1), [p]),
    k = React__namespace.useCallback(() => p(g(n, t)), [p, n, t]),
    P = React__namespace.useCallback((e) => u(Number(e.target.value), o), [o, u]),
    D = l.map((t) => React__namespace.createElement('option', { key: t, value: t }, t));
  R.selectAllRowsItem &&
    D.push(React__namespace.createElement('option', { key: -1, value: n }, R.selectAllRowsItemText));
  const H = React__namespace.createElement(ke, { onChange: P, defaultValue: t, 'aria-label': R.rowsPerPageText }, D);
  return React__namespace.createElement(
    He,
    { className: 'rdt_Pagination' },
    !R.noRowsPerPage &&
      h &&
      React__namespace.createElement(
        React__namespace.Fragment,
        null,
        React__namespace.createElement(Te, null, R.rowsPerPageText),
        H,
      ),
    h && React__namespace.createElement(Ie, null, v),
    React__namespace.createElement(
      Fe,
      null,
      React__namespace.createElement(
        $e,
        {
          id: 'pagination-first-page',
          type: 'button',
          'aria-label': 'First Page',
          'aria-disabled': C,
          onClick: O,
          disabled: C,
          isRTL: m,
        },
        i,
      ),
      React__namespace.createElement(
        $e,
        {
          id: 'pagination-previous-page',
          type: 'button',
          'aria-label': 'Previous Page',
          'aria-disabled': C,
          onClick: S,
          disabled: C,
          isRTL: m,
        },
        d,
      ),
      !h && H,
      React__namespace.createElement(
        $e,
        {
          id: 'pagination-next-page',
          type: 'button',
          'aria-label': 'Next Page',
          'aria-disabled': y,
          onClick: E,
          disabled: y,
          isRTL: m,
        },
        s,
      ),
      React__namespace.createElement(
        $e,
        {
          id: 'pagination-last-page',
          type: 'button',
          'aria-label': 'Last Page',
          'aria-disabled': y,
          onClick: k,
          disabled: y,
          isRTL: m,
        },
        r,
      ),
    ),
  );
});
const Me = (t, n) => {
  const o = React__namespace.useRef(!0);
  React__namespace.useEffect(() => {
    o.current ? (o.current = !1) : t();
  }, n);
};
var Ae = function (e) {
  return (
    (function (e) {
      return !!e && 'object' == typeof e;
    })(e) &&
    !(function (e) {
      var t = Object.prototype.toString.call(e);
      return (
        '[object RegExp]' === t ||
        '[object Date]' === t ||
        (function (e) {
          return e.$$typeof === _e;
        })(e)
      );
    })(e)
  );
};
var _e = 'function' == typeof Symbol && Symbol.for ? Symbol.for('react.element') : 60103;
function Ne(e, t) {
  return !1 !== t.clone && t.isMergeableObject(e) ? Ve(((n = e), Array.isArray(n) ? [] : {}), e, t) : e;
  var n;
}
function ze(e, t, n) {
  return e.concat(t).map(function (e) {
    return Ne(e, n);
  });
}
function We(e) {
  return Object.keys(e).concat(
    (function (e) {
      return Object.getOwnPropertySymbols
        ? Object.getOwnPropertySymbols(e).filter(function (t) {
            return e.propertyIsEnumerable(t);
          })
        : [];
    })(e),
  );
}
function Be(e, t) {
  try {
    return t in e;
  } catch (e) {
    return !1;
  }
}
function Ge(e, t, n) {
  var o = {};
  return (
    n.isMergeableObject(e) &&
      We(e).forEach(function (t) {
        o[t] = Ne(e[t], n);
      }),
    We(t).forEach(function (a) {
      (function (e, t) {
        return Be(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
      })(e, a) ||
        (Be(e, a) && n.isMergeableObject(t[a])
          ? (o[a] = (function (e, t) {
              if (!t.customMerge) return Ve;
              var n = t.customMerge(e);
              return 'function' == typeof n ? n : Ve;
            })(a, n)(e[a], t[a], n))
          : (o[a] = Ne(t[a], n)));
    }),
    o
  );
}
function Ve(e, t, n) {
  ((n = n || {}).arrayMerge = n.arrayMerge || ze),
    (n.isMergeableObject = n.isMergeableObject || Ae),
    (n.cloneUnlessOtherwiseSpecified = Ne);
  var o = Array.isArray(t);
  return o === Array.isArray(e) ? (o ? n.arrayMerge(e, t, n) : Ge(e, t, n)) : Ne(t, n);
}
Ve.all = function (e, t) {
  if (!Array.isArray(e)) throw new Error('first argument should be an array');
  return e.reduce(function (e, n) {
    return Ve(e, n, t);
  }, {});
};
var Ue = Ve;
const Ye = {
    text: { primary: 'rgba(0, 0, 0, 0.87)', secondary: 'rgba(0, 0, 0, 0.54)', disabled: 'rgba(0, 0, 0, 0.38)' },
    background: { default: '#FFFFFF' },
    context: { background: '#e3f2fd', text: 'rgba(0, 0, 0, 0.87)' },
    divider: { default: 'rgba(0,0,0,.12)' },
    button: {
      default: 'rgba(0,0,0,.54)',
      focus: 'rgba(0,0,0,.12)',
      hover: 'rgba(0,0,0,.12)',
      disabled: 'rgba(0, 0, 0, .18)',
    },
    selected: { default: '#e3f2fd', text: 'rgba(0, 0, 0, 0.87)' },
    highlightOnHover: { default: '#EEEEEE', text: 'rgba(0, 0, 0, 0.87)' },
    striped: { default: '#FAFAFA', text: 'rgba(0, 0, 0, 0.87)' },
  },
  Ke = {
    default: Ye,
    light: Ye,
    dark: {
      text: { primary: '#FFFFFF', secondary: 'rgba(255, 255, 255, 0.7)', disabled: 'rgba(0,0,0,.12)' },
      background: { default: '#424242' },
      context: { background: '#E91E63', text: '#FFFFFF' },
      divider: { default: 'rgba(81, 81, 81, 1)' },
      button: {
        default: '#FFFFFF',
        focus: 'rgba(255, 255, 255, .54)',
        hover: 'rgba(255, 255, 255, .12)',
        disabled: 'rgba(255, 255, 255, .18)',
      },
      selected: { default: 'rgba(0, 0, 0, .7)', text: '#FFFFFF' },
      highlightOnHover: { default: 'rgba(0, 0, 0, .7)', text: '#FFFFFF' },
      striped: { default: 'rgba(0, 0, 0, .87)', text: '#FFFFFF' },
    },
  };
function Je(t, n, o, a) {
  const [r, i] = React__namespace.useState(() => c(t)),
    [s, d] = React__namespace.useState(''),
    g = React__namespace.useRef('');
  Me(() => {
    i(c(t));
  }, [t]);
  const u = React__namespace.useCallback(
      (e) => {
        var t, n, o;
        const { attributes: a } = e.target,
          l = null === (t = a.getNamedItem('data-column-id')) || void 0 === t ? void 0 : t.value;
        l &&
          ((g.current =
            (null === (o = null === (n = r[h(r, l)]) || void 0 === n ? void 0 : n.id) || void 0 === o
              ? void 0
              : o.toString()) || ''),
          d(g.current));
      },
      [r],
    ),
    p = React__namespace.useCallback(
      (e) => {
        var t;
        const { attributes: o } = e.target,
          a = null === (t = o.getNamedItem('data-column-id')) || void 0 === t ? void 0 : t.value;
        if (a && g.current && a !== g.current) {
          const e = h(r, g.current),
            t = h(r, a),
            o = [...r];
          (o[e] = r[t]), (o[t] = r[e]), i(o), n(o);
        }
      },
      [n, r],
    ),
    b = React__namespace.useCallback((e) => {
      e.preventDefault();
    }, []),
    m = React__namespace.useCallback((e) => {
      e.preventDefault();
    }, []),
    w = React__namespace.useCallback((e) => {
      e.preventDefault(), (g.current = ''), d('');
    }, []),
    f = (function (e = !1) {
      return e ? l.ASC : l.DESC;
    })(a),
    x = React__namespace.useMemo(() => r[h(r, null == o ? void 0 : o.toString())] || {}, [o, r]);
  return {
    tableColumns: r,
    draggingColumnId: s,
    handleDragStart: u,
    handleDragEnter: p,
    handleDragOver: b,
    handleDragLeave: m,
    handleDragEnd: w,
    defaultSortDirection: f,
    defaultSortColumn: x,
  };
}
var Qe = React__namespace.memo(function (t) {
  const {
      data: n = Pe.data,
      columns: o = Pe.columns,
      title: s = Pe.title,
      actions: d = Pe.actions,
      keyField: c = Pe.keyField,
      striped: p = Pe.striped,
      highlightOnHover: b = Pe.highlightOnHover,
      pointerOnHover: h = Pe.pointerOnHover,
      dense: w = Pe.dense,
      selectableRows: x = Pe.selectableRows,
      selectableRowsSingle: y = Pe.selectableRowsSingle,
      selectableRowsHighlight: S = Pe.selectableRowsHighlight,
      selectableRowsNoSelectAll: E = Pe.selectableRowsNoSelectAll,
      selectableRowsVisibleOnly: O = Pe.selectableRowsVisibleOnly,
      selectableRowSelected: k = Pe.selectableRowSelected,
      selectableRowDisabled: D = Pe.selectableRowDisabled,
      selectableRowsComponent: H = Pe.selectableRowsComponent,
      selectableRowsComponentProps: $ = Pe.selectableRowsComponentProps,
      onRowExpandToggled: F = Pe.onRowExpandToggled,
      onSelectedRowsChange: j = Pe.onSelectedRowsChange,
      expandableIcon: I = Pe.expandableIcon,
      onChangeRowsPerPage: T = Pe.onChangeRowsPerPage,
      onChangePage: L = Pe.onChangePage,
      paginationServer: M = Pe.paginationServer,
      paginationServerOptions: A = Pe.paginationServerOptions,
      paginationTotalRows: _ = Pe.paginationTotalRows,
      paginationDefaultPage: N = Pe.paginationDefaultPage,
      paginationResetDefaultPage: z = Pe.paginationResetDefaultPage,
      paginationPerPage: W = Pe.paginationPerPage,
      paginationRowsPerPageOptions: B = Pe.paginationRowsPerPageOptions,
      paginationIconLastPage: G = Pe.paginationIconLastPage,
      paginationIconFirstPage: V = Pe.paginationIconFirstPage,
      paginationIconNext: U = Pe.paginationIconNext,
      paginationIconPrevious: Y = Pe.paginationIconPrevious,
      paginationComponent: K = Pe.paginationComponent,
      paginationComponentOptions: J = Pe.paginationComponentOptions,
      responsive: Q = Pe.responsive,
      progressPending: X = Pe.progressPending,
      progressComponent: Z = Pe.progressComponent,
      persistTableHead: ee = Pe.persistTableHead,
      noDataComponent: te = Pe.noDataComponent,
      disabled: oe = Pe.disabled,
      noTableHead: le = Pe.noTableHead,
      noHeader: re = Pe.noHeader,
      fixedHeader: ie = Pe.fixedHeader,
      fixedHeaderScrollHeight: se = Pe.fixedHeaderScrollHeight,
      pagination: de = Pe.pagination,
      subHeader: ce = Pe.subHeader,
      subHeaderAlign: ge = Pe.subHeaderAlign,
      subHeaderWrap: ue = Pe.subHeaderWrap,
      subHeaderComponent: be = Pe.subHeaderComponent,
      noContextMenu: me = Pe.noContextMenu,
      contextMessage: he = Pe.contextMessage,
      contextActions: Se = Pe.contextActions,
      contextComponent: Ee = Pe.contextComponent,
      expandableRows: Oe = Pe.expandableRows,
      onRowClicked: ke = Pe.onRowClicked,
      onRowDoubleClicked: De = Pe.onRowDoubleClicked,
      onRowMouseEnter: He = Pe.onRowMouseEnter,
      onRowMouseLeave: $e = Pe.onRowMouseLeave,
      sortIcon: Fe = Pe.sortIcon,
      onSort: je = Pe.onSort,
      sortFunction: Ie = Pe.sortFunction,
      sortServer: Te = Pe.sortServer,
      expandableRowsComponent: Ae = Pe.expandableRowsComponent,
      expandableRowsComponentProps: _e = Pe.expandableRowsComponentProps,
      expandableRowDisabled: Ne = Pe.expandableRowDisabled,
      expandableRowsHideExpander: ze = Pe.expandableRowsHideExpander,
      expandOnRowClicked: We = Pe.expandOnRowClicked,
      expandOnRowDoubleClicked: Be = Pe.expandOnRowDoubleClicked,
      expandableRowExpanded: Ge = Pe.expandableRowExpanded,
      expandableInheritConditionalStyles: Ve = Pe.expandableInheritConditionalStyles,
      defaultSortFieldId: Ye = Pe.defaultSortFieldId,
      defaultSortAsc: qe = Pe.defaultSortAsc,
      clearSelectedRows: Qe = Pe.clearSelectedRows,
      conditionalRowStyles: Xe = Pe.conditionalRowStyles,
      theme: Ze = Pe.theme,
      customStyles: et = Pe.customStyles,
      direction: tt = Pe.direction,
      onColumnOrderChange: nt = Pe.onColumnOrderChange,
      className: ot,
    } = t,
    {
      tableColumns: at,
      draggingColumnId: lt,
      handleDragStart: rt,
      handleDragEnter: it,
      handleDragOver: st,
      handleDragLeave: dt,
      handleDragEnd: ct,
      defaultSortDirection: gt,
      defaultSortColumn: ut,
    } = Je(o, nt, Ye, qe),
    [
      {
        rowsPerPage: pt,
        currentPage: bt,
        selectedRows: mt,
        allSelected: ht,
        selectedCount: wt,
        selectedColumn: ft,
        sortDirection: xt,
        toggleOnSelectedRowsChange: Ct,
      },
      yt,
    ] = React__namespace.useReducer(f, {
      allSelected: !1,
      selectedCount: 0,
      selectedRows: [],
      selectedColumn: ut,
      toggleOnSelectedRowsChange: !1,
      sortDirection: gt,
      currentPage: N,
      rowsPerPage: W,
      selectedRowsFlag: !1,
      contextMessage: Pe.contextMessage,
    }),
    { persistSelectedOnSort: Rt = !1, persistSelectedOnPageChange: vt = !1 } = A,
    St = !(!M || (!vt && !Rt)),
    Et = de && !X && n.length > 0,
    Ot = K || Le,
    kt = React__namespace.useMemo(
      () =>
        ((e = {}, t = 'default', n = 'default') => {
          const o = Ke[t] ? t : n;
          return Ue(
            {
              table: { style: { color: (a = Ke[o]).text.primary, backgroundColor: a.background.default } },
              tableWrapper: { style: { display: 'table' } },
              responsiveWrapper: { style: {} },
              header: {
                style: {
                  fontSize: '22px',
                  color: a.text.primary,
                  backgroundColor: a.background.default,
                  minHeight: '56px',
                  paddingLeft: '16px',
                  paddingRight: '8px',
                },
              },
              subHeader: { style: { backgroundColor: a.background.default, minHeight: '52px' } },
              head: { style: { color: a.text.primary, fontSize: '12px', fontWeight: 500 } },
              headRow: {
                style: {
                  backgroundColor: a.background.default,
                  minHeight: '52px',
                  borderBottomWidth: '1px',
                  borderBottomColor: a.divider.default,
                  borderBottomStyle: 'solid',
                },
                denseStyle: { minHeight: '32px' },
              },
              headCells: { style: { paddingLeft: '16px', paddingRight: '16px' }, draggingStyle: { cursor: 'move' } },
              contextMenu: {
                style: {
                  backgroundColor: a.context.background,
                  fontSize: '18px',
                  fontWeight: 400,
                  color: a.context.text,
                  paddingLeft: '16px',
                  paddingRight: '8px',
                  transform: 'translate3d(0, -100%, 0)',
                  transitionDuration: '125ms',
                  transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
                  willChange: 'transform',
                },
                activeStyle: { transform: 'translate3d(0, 0, 0)' },
              },
              cells: {
                style: { paddingLeft: '16px', paddingRight: '16px', wordBreak: 'break-word' },
                draggingStyle: {},
              },
              rows: {
                style: {
                  fontSize: '13px',
                  fontWeight: 400,
                  color: a.text.primary,
                  backgroundColor: a.background.default,
                  minHeight: '48px',
                  '&:not(:last-of-type)': {
                    borderBottomStyle: 'solid',
                    borderBottomWidth: '1px',
                    borderBottomColor: a.divider.default,
                  },
                },
                denseStyle: { minHeight: '32px' },
                selectedHighlightStyle: {
                  '&:nth-of-type(n)': {
                    color: a.selected.text,
                    backgroundColor: a.selected.default,
                    borderBottomColor: a.background.default,
                  },
                },
                highlightOnHoverStyle: {
                  color: a.highlightOnHover.text,
                  backgroundColor: a.highlightOnHover.default,
                  transitionDuration: '0.15s',
                  transitionProperty: 'background-color',
                  borderBottomColor: a.background.default,
                  outlineStyle: 'solid',
                  outlineWidth: '1px',
                  outlineColor: a.background.default,
                },
                stripedStyle: { color: a.striped.text, backgroundColor: a.striped.default },
              },
              expanderRow: { style: { color: a.text.primary, backgroundColor: a.background.default } },
              expanderCell: { style: { flex: '0 0 48px' } },
              expanderButton: {
                style: {
                  color: a.button.default,
                  fill: a.button.default,
                  backgroundColor: 'transparent',
                  borderRadius: '2px',
                  transition: '0.25s',
                  height: '100%',
                  width: '100%',
                  '&:hover:enabled': { cursor: 'pointer' },
                  '&:disabled': { color: a.button.disabled },
                  '&:hover:not(:disabled)': { cursor: 'pointer', backgroundColor: a.button.hover },
                  '&:focus': { outline: 'none', backgroundColor: a.button.focus },
                  svg: { margin: 'auto' },
                },
              },
              pagination: {
                style: {
                  color: a.text.secondary,
                  fontSize: '13px',
                  minHeight: '56px',
                  backgroundColor: a.background.default,
                  borderTopStyle: 'solid',
                  borderTopWidth: '1px',
                  borderTopColor: a.divider.default,
                },
                pageButtonsStyle: {
                  borderRadius: '50%',
                  height: '40px',
                  width: '40px',
                  padding: '8px',
                  margin: 'px',
                  cursor: 'pointer',
                  transition: '0.4s',
                  color: a.button.default,
                  fill: a.button.default,
                  backgroundColor: 'transparent',
                  '&:disabled': { cursor: 'unset', color: a.button.disabled, fill: a.button.disabled },
                  '&:hover:not(:disabled)': { backgroundColor: a.button.hover },
                  '&:focus': { outline: 'none', backgroundColor: a.button.focus },
                },
              },
              noData: {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: a.text.primary,
                  backgroundColor: a.background.default,
                },
              },
              progress: {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: a.text.primary,
                  backgroundColor: a.background.default,
                },
              },
            },
            e,
          );
          var a;
        })(et, Ze),
      [et, Ze],
    ),
    Pt = React__namespace.useMemo(() => Object.assign({}, 'auto' !== tt && { dir: tt }), [tt]),
    Dt = React__namespace.useMemo(() => {
      if (Te) return n;
      if ((null == ft ? void 0 : ft.sortFunction) && 'function' == typeof ft.sortFunction) {
        const e = ft.sortFunction,
          t = xt === l.ASC ? e : (t, n) => -1 * e(t, n);
        return [...n].sort(t);
      }
      return (function (e, t, n, o) {
        return t
          ? o && 'function' == typeof o
            ? o(e.slice(0), t, n)
            : e.slice(0).sort((e, o) => {
                let a, l;
                if (('string' == typeof t ? ((a = i(e, t)), (l = i(o, t))) : ((a = t(e)), (l = t(o))), 'asc' === n)) {
                  if (a < l) return -1;
                  if (a > l) return 1;
                }
                if ('desc' === n) {
                  if (a > l) return -1;
                  if (a < l) return 1;
                }
                return 0;
              })
          : e;
      })(n, null == ft ? void 0 : ft.selector, xt, Ie);
    }, [Te, ft, xt, n, Ie]),
    Ht = React__namespace.useMemo(() => {
      if (de && !M) {
        const e = bt * pt,
          t = e - pt;
        return Dt.slice(t, e);
      }
      return Dt;
    }, [bt, de, M, pt, Dt]),
    $t = React__namespace.useCallback((e) => {
      yt(e);
    }, []),
    Ft = React__namespace.useCallback((e) => {
      yt(e);
    }, []),
    jt = React__namespace.useCallback((e) => {
      yt(e);
    }, []),
    It = React__namespace.useCallback((e, t) => ke(e, t), [ke]),
    Tt = React__namespace.useCallback((e, t) => De(e, t), [De]),
    Lt = React__namespace.useCallback((e, t) => He(e, t), [He]),
    Mt = React__namespace.useCallback((e, t) => $e(e, t), [$e]),
    At = React__namespace.useCallback(
      (e) => yt({ type: 'CHANGE_PAGE', page: e, paginationServer: M, visibleOnly: O, persistSelectedOnPageChange: vt }),
      [M, vt, O],
    ),
    _t = React__namespace.useCallback(
      (e) => {
        const t = g(_ || Ht.length, e),
          n = u(bt, t);
        M || At(n), yt({ type: 'CHANGE_ROWS_PER_PAGE', page: n, rowsPerPage: e });
      },
      [bt, At, M, _, Ht.length],
    );
  if (de && !M && Dt.length > 0 && 0 === Ht.length) {
    const e = g(Dt.length, pt),
      t = u(bt, e);
    At(t);
  }
  Me(() => {
    j({ allSelected: ht, selectedCount: wt, selectedRows: mt.slice(0) });
  }, [Ct]),
    Me(() => {
      je(ft, xt, Dt.slice(0));
    }, [ft, xt]),
    Me(() => {
      L(bt, _ || Dt.length);
    }, [bt]),
    Me(() => {
      T(pt, bt);
    }, [pt]),
    Me(() => {
      At(N);
    }, [N, z]),
    Me(() => {
      if (de && M && _ > 0) {
        const e = g(_, pt),
          t = u(bt, e);
        bt !== t && At(t);
      }
    }, [_]),
    React__namespace.useEffect(() => {
      yt({ type: 'CLEAR_SELECTED_ROWS', selectedRowsFlag: Qe });
    }, [y, Qe]),
    React__namespace.useEffect(() => {
      if (!k) return;
      const e = Dt.filter((e) => k(e)),
        t = y ? e.slice(0, 1) : e;
      yt({ type: 'SELECT_MULTIPLE_ROWS', keyField: c, selectedRows: t, totalRows: Dt.length, mergeSelections: St });
    }, [n, k]);
  const Nt = O ? Ht : Dt,
    zt = vt || y || E;
  return React__namespace.createElement(
    Le$1,
    { theme: kt },
    !re &&
      (!!s || !!d) &&
      React__namespace.createElement(pe, {
        title: s,
        actions: d,
        showMenu: !me,
        selectedCount: wt,
        direction: tt,
        contextActions: Se,
        contextComponent: Ee,
        contextMessage: he,
      }),
    ce && React__namespace.createElement(we, { align: ge, wrapContent: ue }, be),
    React__namespace.createElement(
      xe,
      Object.assign({ responsive: Q, fixedHeader: ie, fixedHeaderScrollHeight: se, className: ot }, Pt),
      React__namespace.createElement(
        ye,
        null,
        X && !ee && React__namespace.createElement(Ce, null, Z),
        React__namespace.createElement(
          C,
          { disabled: oe, className: 'rdt_Table', role: 'table' },
          !le &&
            (!!ee || (Dt.length > 0 && !X)) &&
            React__namespace.createElement(
              R,
              { className: 'rdt_TableHead', role: 'rowgroup', fixedHeader: ie },
              React__namespace.createElement(
                v,
                { className: 'rdt_TableHeadRow', role: 'row', dense: w },
                x &&
                  (zt
                    ? React__namespace.createElement(P, { style: { flex: '0 0 48px' } })
                    : React__namespace.createElement(ae, {
                        allSelected: ht,
                        selectedRows: mt,
                        selectableRowsComponent: H,
                        selectableRowsComponentProps: $,
                        selectableRowDisabled: D,
                        rowData: Nt,
                        keyField: c,
                        mergeSelections: St,
                        onSelectAllRows: Ft,
                      })),
                Oe && !ze && React__namespace.createElement(Re, null),
                at.map((t) =>
                  React__namespace.createElement(ne, {
                    key: t.id,
                    column: t,
                    selectedColumn: ft,
                    disabled: X || 0 === Dt.length,
                    pagination: de,
                    paginationServer: M,
                    persistSelectedOnSort: Rt,
                    selectableRowsVisibleOnly: O,
                    sortDirection: xt,
                    sortIcon: Fe,
                    sortServer: Te,
                    onSort: $t,
                    onDragStart: rt,
                    onDragOver: st,
                    onDragEnd: ct,
                    onDragEnter: it,
                    onDragLeave: dt,
                    draggingColumnId: lt,
                  }),
                ),
              ),
            ),
          !Dt.length && !X && React__namespace.createElement(ve, null, te),
          X && ee && React__namespace.createElement(Ce, null, Z),
          !X &&
            Dt.length > 0 &&
            React__namespace.createElement(
              fe,
              { className: 'rdt_TableBody', role: 'rowgroup' },
              Ht.map((t, n) => {
                const o = r(t, c),
                  a = (function (e = '') {
                    return 'number' != typeof e && (!e || 0 === e.length);
                  })(o)
                    ? n
                    : o,
                  l = m(t, mt, c),
                  i = !!(Oe && Ge && Ge(t)),
                  s = !!(Oe && Ne && Ne(t));
                return React__namespace.createElement(q, {
                  id: a,
                  key: a,
                  keyField: c,
                  'data-row-id': a,
                  columns: at,
                  row: t,
                  rowCount: Dt.length,
                  rowIndex: n,
                  selectableRows: x,
                  expandableRows: Oe,
                  expandableIcon: I,
                  highlightOnHover: b,
                  pointerOnHover: h,
                  dense: w,
                  expandOnRowClicked: We,
                  expandOnRowDoubleClicked: Be,
                  expandableRowsComponent: Ae,
                  expandableRowsComponentProps: _e,
                  expandableRowsHideExpander: ze,
                  defaultExpanderDisabled: s,
                  defaultExpanded: i,
                  expandableInheritConditionalStyles: Ve,
                  conditionalRowStyles: Xe,
                  selected: l,
                  selectableRowsHighlight: S,
                  selectableRowsComponent: H,
                  selectableRowsComponentProps: $,
                  selectableRowDisabled: D,
                  selectableRowsSingle: y,
                  striped: p,
                  onRowExpandToggled: F,
                  onRowClicked: It,
                  onRowDoubleClicked: Tt,
                  onRowMouseEnter: Lt,
                  onRowMouseLeave: Mt,
                  onSelectedRow: jt,
                  draggingColumnId: lt,
                  onDragStart: rt,
                  onDragOver: st,
                  onDragEnd: ct,
                  onDragEnter: it,
                  onDragLeave: dt,
                });
              }),
            ),
        ),
      ),
    ),
    Et &&
      React__namespace.createElement(
        'div',
        null,
        React__namespace.createElement(Ot, {
          onChangePage: At,
          onChangeRowsPerPage: _t,
          rowCount: _ || Dt.length,
          currentPage: bt,
          rowsPerPage: pt,
          direction: tt,
          paginationRowsPerPageOptions: B,
          paginationIconLastPage: G,
          paginationIconFirstPage: V,
          paginationIconNext: U,
          paginationIconPrevious: Y,
          paginationComponentOptions: J,
        }),
      ),
  );
});

var style$c = {
  DataTable: 'htco-DataTable',
  DataTableSortIconContainer: 'htco-DataTableSortIconContainer',
  DataTableSortIcon: 'htco-DataTableSortIcon',
  hideDefaultPagination: 'htco-hideDefaultPagination',
  DataTableLoaderOverlay: 'htco-DataTableLoaderOverlay',
  isSelected: 'htco-isSelected',
  DataTableMobileExpandedBackground: 'htco-DataTableMobileExpandedBackground',
  DataTableMobileExpandedTableColName: 'htco-DataTableMobileExpandedTableColName',
  DataTableMobileExpandedTableRowContent: 'htco-DataTableMobileExpandedTableRowContent',
  DataTableMobileExpandedTableRow: 'htco-DataTableMobileExpandedTableRow',
};

var getFilteredDropdownColumns = function (columns, mobileColumns) {
  return columns.filter(function (col) {
    var found = mobileColumns.findIndex(function (mCol) {
      return mCol.name === col.name;
    });
    return found === -1;
  });
};
var getDropdownRowData = function (row, dropDownColumns, props) {
  /**
   * @param {object} row - data representing a row
   * @param {Array} - dropDownColumns array of objects representing mobile column data
   * @param {object} - props to configure all row data
   * @returns {object} - representing the row data filtered out from the desktop columns
   */
  var splitRow = Object.keys(row).map(function (key) {
    var _a;
    return (_a = {}), (_a[key] = row[key]), _a;
  });
  var filteredRowData = splitRow.reduce(function (rowData, configuredRow) {
    var found =
      dropDownColumns === null || dropDownColumns === void 0
        ? void 0
        : dropDownColumns.find(function (col) {
            return col.cell ? col.cell(configuredRow) : col.selector(configuredRow);
          });
    if (!!found || configuredRow.id) {
      var foundRowKeys = Object.keys(configuredRow);
      for (var _i = 0, foundRowKeys_1 = foundRowKeys; _i < foundRowKeys_1.length; _i++) {
        var key = foundRowKeys_1[_i];
        rowData[key] = configuredRow[key];
      }
    }
    return __assign(__assign({}, rowData), props);
  }, {});
  return filteredRowData;
};

var StyledTable = qe.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ["\n  [data-sort-id='", "'] {\n    .", '.', ' {\n      opacity: 1 !important;\n    }\n  }\n'],
      ["\n  [data-sort-id='", "'] {\n    .", '.', ' {\n      opacity: 1 !important;\n    }\n  }\n'],
    )),
  function (props) {
    return props.selectedSortColumn;
  },
  style$c.DataTableSortIcon,
  style$c.isSelected,
);
var SortIcon = function (_a) {
  var _b, _c;
  var sortDirection = _a.sortDirection;
  return jsxRuntime.jsxs('span', {
    style: { display: 'inline-flex', flexDirection: 'column' },
    className: style$c.DataTableSortIconContainer,
    children: [
      jsxRuntime.jsx(Icon, {
        name: 'caret-up',
        size: 'sm',
        className: cx(style$c.DataTableSortIcon, ((_b = {}), (_b[style$c.isSelected] = sortDirection === 'asc'), _b)),
      }),
      jsxRuntime.jsx(Icon, {
        name: 'caret-down',
        size: 'sm',
        className: cx(style$c.DataTableSortIcon, ((_c = {}), (_c[style$c.isSelected] = sortDirection === 'desc'), _c)),
      }),
    ],
  });
};
var DefaultExpandedTable = function (_a) {
  var row = _a.data,
    filteredDropdownColumns = _a.filteredDropdownColumns,
    expandableRowsComponentProps = _a.expandableRowsComponentProps;
  var filteredRowData = getDropdownRowData(row, filteredDropdownColumns, expandableRowsComponentProps);
  return filteredDropdownColumns
    ? jsxRuntime.jsx(Paper, {
        className: style$c.DataTableMobileExpandedBackground,
        theme: 'plain',
        pad: { left: 6.5, top: 1.5, bottom: 3 },
        children: filteredDropdownColumns.map(function (col, index) {
          var rowContent = col.cell ? col.cell(filteredRowData) : col.selector(filteredRowData);
          return (
            rowContent &&
            jsxRuntime.jsxs(
              'div',
              {
                className: style$c.DataTableMobileExpandedTableRow,
                children: [
                  jsxRuntime.jsx('p', { className: style$c.DataTableMobileExpandedTableColName, children: col.name }),
                  jsxRuntime.jsx('div', {
                    className: style$c.DataTableMobileExpandedTableRowContent,
                    children: rowContent,
                  }),
                ],
              },
              ''.concat(col.name, '-').concat(filteredRowData.id || index),
            )
          );
        }),
      })
    : null;
};
var DataTable = function (_a) {
  var _b;
  var data = _a.data,
    columns = _a.columns,
    className = _a.className,
    mobileColumns = _a.mobileColumns,
    loaderComponent = _a.loaderComponent,
    expandableRowsComponent = _a.expandableRowsComponent,
    expandableRowsComponentProps = _a.expandableRowsComponentProps,
    defaultSortFieldId = _a.defaultSortFieldId,
    _c = _a.defaultSortAsc,
    defaultSortAsc = _c === void 0 ? true : _c,
    _d = _a.loading,
    loading = _d === void 0 ? false : _d,
    _e = _a.respondAt,
    respondAt = _e === void 0 ? 'sm' : _e,
    _f = _a.customStyles,
    customStyles = _f === void 0 ? {} : _f,
    _g = _a.onSort,
    onSort =
      _g === void 0
        ? function () {
            return null;
          }
        : _g,
    _h = _a.expandableRows,
    expandableRows = _h === void 0 ? false : _h,
    _j = _a.hideDefaultPaginationStyles,
    hideDefaultPaginationStyles = _j === void 0 ? true : _j,
    _k = _a.noDataComponent,
    noDataComponent = _k === void 0 ? 'There are no records to display' : _k,
    primaryColumns = _a.primaryColumns,
    rest = __rest$1(_a, [
      'data',
      'columns',
      'className',
      'mobileColumns',
      'loaderComponent',
      'expandableRowsComponent',
      'expandableRowsComponentProps',
      'defaultSortFieldId',
      'defaultSortAsc',
      'loading',
      'respondAt',
      'customStyles',
      'onSort',
      'expandableRows',
      'hideDefaultPaginationStyles',
      'noDataComponent',
      'primaryColumns',
    ]);
  var _l = React.useState(defaultSortAsc ? 'asc' : 'desc'),
    sortDirection = _l[0],
    setSortDirection = _l[1];
  var _m = React.useState(typeof defaultSortFieldId === 'number' ? defaultSortFieldId : null),
    selectedSortIndex = _m[0],
    setSelectedSortIndex = _m[1];
  var isScreenSize = useWindowSize().isScreenSize;
  var columnsToFilter = (isScreenSize(respondAt) && mobileColumns) || primaryColumns;
  var filteredDropdownColumns = columnsToFilter && getFilteredDropdownColumns(columns, columnsToFilter);
  var dropdownConfiguredColumns = columnsToFilter ? columnsToFilter : columns;
  var configuredData =
    data === null || data === void 0
      ? void 0
      : data.map(function (row) {
          // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
          var dropdownRowData = getDropdownRowData(row, filteredDropdownColumns);
          var filteredKeys = Object.keys(dropdownRowData);
          var isEmpty = (filteredKeys.length === 1 && filteredKeys[0] === 'id') || !filteredKeys.length;
          return __assign(__assign({}, row), { expandedRowDisabled: isEmpty });
        });
  var expanderButtonStyles = {
    style: {
      borderRadius: 0,
      '&:hover:not(:disabled)': {
        backgroundColor: '#fbfbfa',
      },
      '&:focus': {
        backgroundColor: '#fbfbfa',
      },
      svg: {
        height: 18,
        width: 18,
      },
    },
  };
  return (
    // @ts-expect-error TS(2769): No overload matches this call.
    jsxRuntime.jsxs(StyledTable, {
      selectedSortColumn: defaultSortFieldId || selectedSortIndex,
      className: cx(
        style$c.DataTable,
        className,
        ((_b = {}), (_b[style$c.hideDefaultPagination] = hideDefaultPaginationStyles), _b),
      ),
      children: [
        loading &&
          (loaderComponent ||
            jsxRuntime.jsx(Loader, { className: style$c.DataTableLoaderOverlay, overlay: true, size: 'large' })),
        jsxRuntime.jsx(
          Qe,
          __assign(
            {
              data: configuredData,
              columns: dropdownConfiguredColumns,
              expandableRows: columnsToFilter || expandableRows,
              noDataComponent:
                !(data === null || data === void 0 ? void 0 : data.length) && !loading && noDataComponent,
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              expandableRowDisabled: function (row) {
                return row.expandedRowDisabled;
              },
              expandableRowsComponent: expandableRowsComponent || DefaultExpandedTable,
              expandableRowsComponentProps: {
                filteredDropdownColumns: filteredDropdownColumns,
                expandableRowsComponentProps: expandableRowsComponentProps,
              },
              defaultSortAsc: defaultSortAsc,
              defaultSortFieldId: defaultSortFieldId,
              sortIcon: jsxRuntime.jsx(SortIcon, { sortDirection: sortDirection }),
              onSort: function (selectedColumn, sortDir) {
                var foundIndex =
                  dropdownConfiguredColumns === null || dropdownConfiguredColumns === void 0
                    ? void 0
                    : dropdownConfiguredColumns.findIndex(function (col) {
                        return (
                          (col === null || col === void 0 ? void 0 : col.name) ===
                          (selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.name)
                        );
                      });
                setSelectedSortIndex(foundIndex + 1);
                setSortDirection(sortDir);
                onSort(selectedColumn, sortDir, foundIndex);
              },
              customStyles: __assign(__assign({}, customStyles), {
                expanderButton:
                  (customStyles === null || customStyles === void 0 ? void 0 : customStyles.expanderButton) ||
                  expanderButtonStyles,
              }),
            },
            rest,
          ),
        ),
      ],
    })
  );
};
var ArrayOfObjectsType = PropTypes__default['default'].arrayOf(PropTypes__default['default'].object);
DataTable.propTypes = {
  onSort: PropTypes__default['default'].func,
  loading: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].string,
  expandableRows: PropTypes__default['default'].bool,
  customStyles: PropTypes__default['default'].object,
  noDataComponent: PropTypes__default['default'].node,
  loaderComponent: PropTypes__default['default'].node,
  mobileColumns: ArrayOfObjectsType,
  data: ArrayOfObjectsType.isRequired,
  columns: ArrayOfObjectsType.isRequired,
  hideDefaultPaginationStyles: PropTypes__default['default'].bool,
  expandableRowsComponent: PropTypes__default['default'].elementType,
  expandableRowsComponentProps: PropTypes__default['default'].object,
  respondAt: PropTypes__default['default'].oneOf(['xs', 'sm', 'md', 'lg']),
  defaultSortAsc: PropTypes__default['default'].bool,
  defaultSortFieldId: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].number,
  ]),
  primaryColumns: ArrayOfObjectsType,
};
var templateObject_1;

var styles$6 = {
  MuiTextInputOutlined: 'htco-MuiTextInputOutlined',
  error: 'htco-error',
  withMask: 'htco-withMask',
  MuiTextInputBase: 'htco-MuiTextInputBase',
  MuiTextInputWithHeader: 'htco-MuiTextInputWithHeader',
  MuiTextInputFilled: 'htco-MuiTextInputFilled',
  withMinWidth: 'htco-withMinWidth',
  withPrefix: 'htco-withPrefix',
  withSuffix: 'htco-withSuffix',
  startAdornment: 'htco-startAdornment',
  endAdornment: 'htco-endAdornment',
  withoutLeftPadding: 'htco-withoutLeftPadding',
  disabled: 'htco-disabled',
  MuiTextInputOutline: 'htco-MuiTextInputOutline',
  withIcon: 'htco-withIcon',
  MuiTextInputIconButton: 'htco-MuiTextInputIconButton',
  isOutlined: 'htco-isOutlined',
  MuiTextInputErrorIcon: 'htco-MuiTextInputErrorIcon',
  isDisabled: 'htco-isDisabled',
  MuiTextInputFieldHeader: 'htco-MuiTextInputFieldHeader',
};

var hasMask = function (props) {
  return props.mask !== undefined && props.mask !== null;
};
var isMaskedRef = function (ref, props) {
  return hasMask(props) && !!ref && typeof ref !== 'function';
};
var isOtherRef = function (ref, props) {
  return !hasMask(props) && !!ref;
};
var MuiTextInputBase = React.forwardRef(function (_a, ref) {
  var _b, _c, _d, _e, _f;
  var _g, _h, _j;
  var _k = _a.type,
    type = _k === void 0 ? 'text' : _k,
    _l = _a.theme,
    theme = _l === void 0 ? 'filled' : _l,
    name = _a.name,
    error = _a.error,
    className = _a.className,
    inputClassName = _a.inputClassName,
    _m = _a.label,
    label = _m === void 0 ? '' : _m,
    _o = _a.disabled,
    disabled = _o === void 0 ? false : _o,
    onChange = _a.onChange,
    onBlur = _a.onBlur,
    required = _a.required,
    _p = _a.width,
    width = _p === void 0 ? 'auto' : _p,
    _q = _a.maxLength,
    maxLength = _q === void 0 ? 999 : _q,
    onIconClick = _a.onIconClick,
    helperText = _a.helperText,
    headerText = _a.headerText,
    startAdornment = _a.startAdornment,
    endAdornment = _a.endAdornment,
    _r = _a.unmask,
    unmask = _r === void 0 ? false : _r,
    iconName = _a.iconName,
    _s = _a.showIcon,
    showIcon = _s === void 0 ? true : _s,
    _t = _a.showRequiredAsterisk,
    showRequiredAsterisk = _t === void 0 ? true : _t,
    _u = _a.value,
    value = _u === void 0 ? '' : _u,
    props = __rest$1(_a, [
      'type',
      'theme',
      'name',
      'error',
      'className',
      'inputClassName',
      'label',
      'disabled',
      'onChange',
      'onBlur',
      'required',
      'width',
      'maxLength',
      'onIconClick',
      'helperText',
      'headerText',
      'startAdornment',
      'endAdornment',
      'unmask',
      'iconName',
      'showIcon',
      'showRequiredAsterisk',
      'value',
    ]);
  var valueParsed = value !== null && value !== void 0 ? value : '';
  var isOutlinedTheme = theme === 'outlined';
  var withIcon = iconName && showIcon;
  var classNames = cx(
    styles$6.MuiTextInputBase,
    ((_b = {}),
    (_b[styles$6.MuiTextInputWithHeader] = headerText),
    (_b[styles$6.MuiTextInputFilled] = theme === 'filled'),
    (_b[styles$6.MuiTextInputOutlined] = isOutlinedTheme),
    (_b[styles$6.disabled] = disabled),
    (_b[styles$6.error] = error),
    (_b[styles$6.withPrefix] = startAdornment),
    (_b[styles$6.withSuffix] = endAdornment),
    (_b[styles$6.withMask] = hasMask(props)),
    (_b[styles$6.withIcon] = withIcon),
    _b),
    className,
  );
  var inputStyle = { width: width };
  var shouldShowError = (error === null || error === void 0 ? void 0 : error.length) ? error.length >= 1 : false;
  var ariaLabel =
    (_g = props['aria-label']) !== null && _g !== void 0 ? _g : typeof label === 'string' ? label : undefined;
  var iMaskRef = React.useRef(undefined);
  if (isMaskedRef(ref, props)) {
    iMaskRef = ref;
  }
  var getIcon = function () {
    var _a;
    if (!withIcon) return null;
    return jsxRuntime.jsx(IconButton, {
      type: 'button',
      className: cx(styles$6.MuiTextInputIconButton, ((_a = {}), (_a[styles$6.isOutlined] = isOutlinedTheme), _a)),
      icon: iconName,
      onClick: onIconClick,
    });
  };
  return jsxRuntime.jsxs('div', {
    className: classNames,
    style: inputStyle,
    children: [
      headerText &&
        jsxRuntime.jsx('p', {
          className: cx(((_c = {}), (_c[styles$6.MuiTextInputFieldHeader] = true), _c)),
          children: headerText,
        }),
      shouldShowError &&
        !withIcon &&
        jsxRuntime.jsx(Icon, {
          name: 'icon-error',
          className: cx(
            styles$6.MuiTextInputErrorIcon,
            ((_d = {}), (_d[styles$6.isDisabled] = disabled), (_d[styles$6.isOutlined] = isOutlinedTheme), _d),
          ),
        }),
      hasMask(props)
        ? jsxRuntime.jsx(
            IMaskInput,
            __assign(
              {
                ref: iMaskRef,
                className: inputClassName,
                'aria-label': ariaLabel,
                onAccept: function (value, _, event) {
                  var _a, _b, _c;
                  if (!onChange) return;
                  var syntheticTarget =
                    (_a = event === null || event === void 0 ? void 0 : event.target) !== null && _a !== void 0
                      ? _a
                      : (_c =
                          (_b = iMaskRef === null || iMaskRef === void 0 ? void 0 : iMaskRef.current) === null ||
                          _b === void 0
                            ? void 0
                            : _b.maskRef) === null || _c === void 0
                      ? void 0
                      : _c.el;
                  var syntheticEvent = __assign(__assign({}, event), {
                    target: __assign(__assign({}, syntheticTarget), { value: value }),
                  });
                  onChange(syntheticEvent);
                },
                onBlur: function (event) {
                  var _a, _b, _c;
                  if (!onBlur) return;
                  var value =
                    (_c =
                      (_b = (_a = iMaskRef.current) === null || _a === void 0 ? void 0 : _a.maskRef) === null ||
                      _b === void 0
                        ? void 0
                        : _b.value) !== null && _c !== void 0
                      ? _c
                      : '';
                  var syntheticEvent = __assign(__assign({}, event), {
                    target: __assign(__assign({}, event.target), { value: value }),
                  });
                  onBlur(syntheticEvent);
                },
                placeholder: (_h = props.placeholder) !== null && _h !== void 0 ? _h : ' ',
                disabled: disabled,
                unmask: unmask,
                name: name,
                value: valueParsed,
                mask: props.mask,
              },
              props,
            ),
          )
        : jsxRuntime.jsx(
            'input',
            __assign(
              {
                ref: !isOtherRef(ref, props) ? null : ref,
                name: name,
                className: inputClassName,
                'aria-label': ariaLabel,
                type: type,
                maxLength: maxLength,
                placeholder: (_j = props.placeholder) !== null && _j !== void 0 ? _j : ' ',
                disabled: disabled,
                onChange: onChange,
                onBlur: onBlur,
                value: valueParsed,
              },
              props,
            ),
          ),
      theme === 'outlined'
        ? jsxRuntime.jsx('div', {
            className: cx(((_e = {}), (_e[styles$6.MuiTextInputOutline] = theme === 'outlined'), _e)),
          })
        : null,
      jsxRuntime.jsxs(Label$1, {
        className: cx(styles$6.Label, 'text'),
        children: [label, ' ', required && showRequiredAsterisk ? '*' : ''],
      }),
      showIcon && getIcon(),
      startAdornment && jsxRuntime.jsx('span', { className: styles$6.startAdornment, children: startAdornment }),
      endAdornment &&
        !shouldShowError &&
        jsxRuntime.jsx('span', { className: styles$6.endAdornment, children: endAdornment }),
      jsxRuntime.jsx('p', {
        className: cx(((_f = {}), (_f[styles$6.withoutLeftPadding] = shouldShowError && theme === 'filled'), _f)),
        children: shouldShowError ? error : helperText,
      }),
    ],
  });
});
MuiTextInputBase.displayName = 'MuiTextInputBase';

var useMuiTextInputField = function (_a) {
  var name = _a.name,
    required = _a.required,
    validator = _a.validator,
    registerRequiredField = _a.registerRequiredField,
    unregisterRequiredField = _a.unregisterRequiredField,
    onChange = _a.onChange,
    onBlur = _a.onBlur;
  useRequiredValidation({
    name: name,
    required: required,
    registerRequiredField: registerRequiredField,
    unregisterRequiredField: unregisterRequiredField,
  });
  var handleValidation = function (value) {
    if (value || required) {
      if (validator) {
        return validator(value);
      }
    }
    return undefined;
  };
  var handleValue = function (fn, v) {
    fn(v, name, handleValidation(v));
  };
  var handleChange = function (e) {
    if (onChange) {
      var originalValue = e.target.value;
      handleValue(onChange, originalValue);
    }
  };
  var handleBlur = function (e) {
    if (onBlur) {
      var originalValue = e.target.value;
      handleValue(onBlur, originalValue);
    }
  };
  return { handleChange: handleChange, handleBlur: handleBlur, handleValue: handleValue };
};
var MuiTextInput = function (_a, ref) {
  var _b;
  var name = _a.name,
    validator = _a.validator,
    _c = _a.onBlur,
    onBlur =
      _c === void 0
        ? function () {
            return null;
          }
        : _c,
    _d = _a.onChange,
    onChange =
      _d === void 0
        ? function () {
            return null;
          }
        : _d,
    required = _a.required,
    registerRequiredField = _a.registerRequiredField,
    unregisterRequiredField = _a.unregisterRequiredField,
    props = __rest$1(_a, [
      'name',
      'validator',
      'onBlur',
      'onChange',
      'required',
      'registerRequiredField',
      'unregisterRequiredField',
    ]);
  var _e = useMuiTextInputField({
      name: name,
      required: required,
      validator: validator,
      registerRequiredField: registerRequiredField,
      unregisterRequiredField: unregisterRequiredField,
      onChange: onChange,
      onBlur: onBlur,
    }),
    handleChange = _e.handleChange,
    handleBlur = _e.handleBlur,
    handleValue = _e.handleValue;
  var value = (_b = props.value) !== null && _b !== void 0 ? _b : '';
  React.useEffect(function () {
    if (value && value !== '' && onBlur) {
      handleValue(onBlur, value);
    }
  }, []);
  return jsxRuntime.jsx(
    MuiTextInputBase,
    __assign({}, props, {
      name: name,
      value: value,
      required: required,
      ref: ref,
      onChange: handleChange,
      onBlur: handleBlur,
    }),
  );
};
var MuiTextInput$1 = React.forwardRef(MuiTextInput);

/**
 * extend predefined mask with provided overrides
 * @param mask - Mask definition
 * @param overrides - Mask parameters to override
 * @returns - Mask definition
 */
var extend = function (mask, overrides) {
  if (overrides === void 0) {
    overrides = {};
  }
  return [__assign(__assign({}, Array.isArray(mask) ? mask[0] : mask), overrides)];
};
/**
 * combine several masks so input will accept either value
 * @param masks - List of mask definitions to combine
 * @returns - Combined mask definition
 */
var combine = function () {
  var masks = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    masks[_i] = arguments[_i];
  }
  return masks.reduce(function (result, mask) {
    if (Array.isArray(mask)) {
      result.push.apply(result, mask);
    } else {
      result.push(mask);
    }
    return result;
  }, []);
};
/**
 * default percent format (converted to decimal value)
 */
var PERCENT_MASK = [
  {
    mask: Number,
    scale: 3,
    max: 0.99999,
    normalizeZeros: false,
    radix: '.',
    parse: function (value) {
      return value && !Number.isNaN(value) && parseFloat((Number(value) / 100).toFixed(5));
    },
    format: function (value) {
      return (typeof value === 'number' ? value * 100 : value).toLocaleString('en-US', {
        useGrouping: false,
        maximumFractionDigits: 20,
      });
    },
  },
];
/**
 * default money in USD currency format
 */
var MONEY_USD_MASK = [
  {
    mask: Number,
    type: 'number',
    signed: false,
    scale: 2,
    min: 0,
    max: 999999999.99, // upper limit to 1 billion
    padFractionalZeros: false,
    radix: '.',
    thousandsSeparator: ',',
    normalizeZeros: false,
    mapToRadix: ['.'],
  },
];
var mapPatternToFormat = function (pattern) {
  return pattern.replace('m', 'MM').replace('d', 'dd').replace('Y', 'yyyy');
};
/**
 * default date format (m/d/Y)
 */
var DATE_MASK = [
  {
    mask: Date,
    pattern: 'm/d/Y',
    format: function (date, self) {
      if (!date) return '';
      if (!self._dateFormat) {
        self._dateFormat = mapPatternToFormat(self.mask);
      }
      return format(date, self._dateFormat);
    },
    parse: function (str, self) {
      if (!self._dateFormat) {
        self._dateFormat = mapPatternToFormat(self.mask);
      }
      return parse(str, self._dateFormat, new Date());
    },
  },
];
var SSN_MASK$1 = [
  {
    mask: 'XXX-XX-XXXX',
    definitions: {
      X: {
        mask: '0',
        displayChar: '*',
      },
    },
  },
];
var SSN_NO_OBFUSCATION_MASK = extend(SSN_MASK$1, { mask: '000-00-0000' });
var SSN_PARTIAL_OBFUSCATION_MASK = extend(SSN_MASK$1, { mask: 'XXX-XX-0000' });
var SSN_FULL_OBFUSCATION_MASK = extend(SSN_MASK$1);
var InputMask = {
  extend: extend,
  combine: combine,
  DATE_MASK: DATE_MASK,
  MONEY_USD_MASK: MONEY_USD_MASK,
  PERCENT_MASK: PERCENT_MASK,
  SSN_NO_OBFUSCATION_MASK: SSN_NO_OBFUSCATION_MASK,
  SSN_PARTIAL_OBFUSCATION_MASK: SSN_PARTIAL_OBFUSCATION_MASK,
  SSN_FULL_OBFUSCATION_MASK: SSN_FULL_OBFUSCATION_MASK,
};

var SSN_LENGTH = 9;
var SSN_MASK = {
  full: InputMask.SSN_FULL_OBFUSCATION_MASK,
  none: InputMask.SSN_NO_OBFUSCATION_MASK,
  partial: InputMask.SSN_PARTIAL_OBFUSCATION_MASK,
};
var MuiSSNInputBase = React.forwardRef(function (_a, ref) {
  var _b;
  var _c = _a.required,
    required = _c === void 0 ? false : _c,
    _d = _a.showRequiredAsterisk,
    showRequiredAsterisk = _d === void 0 ? true : _d,
    _e = _a.width,
    width = _e === void 0 ? 'auto' : _e,
    props = __rest$1(_a, ['required', 'showRequiredAsterisk', 'width']);
  var obfuscate = (_b = props.obfuscate) !== null && _b !== void 0 ? _b : 'full';
  var _f = React.useState(obfuscate === 'none'),
    isRevealed = _f[0],
    setIsRevealed = _f[1];
  var getSSNIconName = function () {
    return isRevealed ? 'icon-hide' : 'icon-show';
  };
  var mask = SSN_MASK[obfuscate] || SSN_MASK.full;
  if (isRevealed) {
    mask = SSN_MASK.none;
  }
  return jsxRuntime.jsx(
    MuiTextInputBase,
    __assign(
      {
        ref: ref,
        iconName: getSSNIconName(),
        onIconClick: function () {
          return setIsRevealed(function (revealed) {
            return !revealed;
          });
        },
        showIcon: obfuscate !== 'none',
      },
      props,
      {
        inputClassName: cx(styles$6.withMinWidth, props.inputClassName),
        'aria-hidden': true,
        required: required,
        autoComplete: 'off',
        width: width,
        maxLength: SSN_LENGTH + 2,
        showRequiredAsterisk: showRequiredAsterisk,
        mask: mask,
        unmask: true,
      },
    ),
  );
});
MuiSSNInputBase.displayName = 'MuiSSNInputBase';

var SSN_ERROR = 'Please enter a valid SSN.';
var SSN_NO_ERROR = '';
var isValidSSN = function (value) {
  var re = /^\d{3}-?\d{2}-?\d{4}$/g;
  return typeof value === 'string' && re.test(value);
};
var isValidValue = function (value, required) {
  return value ? isValidSSN(value) : !required;
};
var MuiSSNInput = React.forwardRef(function (_a, ref) {
  var name = _a.name,
    value = _a.value,
    onChange = _a.onChange,
    onBlur = _a.onBlur,
    onError = _a.onError,
    _b = _a.required,
    required = _b === void 0 ? false : _b,
    registerRequiredField = _a.registerRequiredField,
    unregisterRequiredField = _a.unregisterRequiredField,
    props = __rest$1(_a, [
      'name',
      'value',
      'onChange',
      'onBlur',
      'onError',
      'required',
      'registerRequiredField',
      'unregisterRequiredField',
    ]);
  var _c = useMuiTextInputField({
      name: name,
      required: required,
      validator: function (val) {
        return !isValidValue(val) && SSN_ERROR;
      },
      registerRequiredField: registerRequiredField,
      unregisterRequiredField: unregisterRequiredField,
      onChange: onChange,
      onBlur: onBlur,
    }),
    handleChange = _c.handleChange,
    handleFormBlur = _c.handleBlur;
  var _d = React.useState(function () {
      return !isValidValue(value, required);
    }),
    isError = _d[0],
    setIsError = _d[1];
  var _e = React.useState(!!value),
    shouldShowError = _e[0],
    setShouldShowError = _e[1];
  React.useEffect(
    function () {
      onError === null || onError === void 0 ? void 0 : onError(isError);
    },
    [isError],
  );
  React.useEffect(
    function () {
      return validate(value);
    },
    [value],
  );
  var validate = function (newValue) {
    var isValid = isValidValue(newValue, required);
    if (!required && isValid) {
      setShouldShowError(false);
    }
    setIsError(!isValid);
  };
  var handleBlur = function (e) {
    var val = e.target.value;
    validate(val);
    if (required && !val) {
      setIsError(true);
    }
    setShouldShowError(true);
    handleFormBlur(e);
  };
  var getError = function () {
    if (shouldShowError) {
      return isError ? SSN_ERROR : SSN_NO_ERROR;
    }
    return SSN_NO_ERROR;
  };
  return jsxRuntime.jsx(
    MuiSSNInputBase,
    __assign({}, props, {
      ref: ref,
      name: name,
      value: value,
      required: required,
      onChange: handleChange,
      onBlur: handleBlur,
      error: getError(),
    }),
  );
});
MuiSSNInput.displayName = 'MuiSSNInput';

var img$7 =
  "data:image/svg+xml,%3csvg width='16' height='12' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M14.0582 0.341937C14.5095 -0.121366 15.2331 -0.112779 15.6743 0.361116C16.0816 0.798558 16.106 1.47957 15.7524 1.94615L15.6561 2.05806L6.30419 11.6581C5.89422 12.0789 5.25805 12.1113 4.81328 11.7552L4.70632 11.6581L0.34392 7.17993C-0.107409 6.71663 -0.115587 5.95688 0.325654 5.48298C0.732953 5.04554 1.38082 5.00457 1.83306 5.36526L1.94179 5.4638L5.50514 9.1212L14.0582 0.341937Z' fill='%23366CED'/%3e%3c/svg%3e";

var styles$5 = {
  MuiSelectLabelOutlined: 'htco-MuiSelectLabelOutlined',
  hasValue: 'htco-hasValue',
  isFocused: 'htco-isFocused',
  MuiSelect: 'htco-MuiSelect',
  isDisabled: 'htco-isDisabled',
  isMultiple: 'htco-isMultiple',
  isError: 'htco-isError',
  MuiSelectLabel: 'htco-MuiSelectLabel',
  MuiSelectLabelFilled: 'htco-MuiSelectLabelFilled',
  MuiSelectWithHeader: 'htco-MuiSelectWithHeader',
  MuiSelectOutlined: 'htco-MuiSelectOutlined',
  hasError: 'htco-hasError',
  MuiSelectFieldHeader: 'htco-MuiSelectFieldHeader',
};

var baseDivStyles = {
  div: {
    height: '100%',
    width: '100%',
    padding: '0',
  },
};
var baseMenuStyles = {
  marginTop: 0,
  paddingTop: '12px',
  paddingBottom: '12px',
  '> div': {
    paddingTop: 0,
    paddingBottom: 0,
  },
};
var customThemesStyles = {
  filled: {
    valueContainerStyles: { paddingLeft: 2 },
    multipleIndicatorsContainerStyles: baseDivStyles,
    indicatorsContainerStyles: __assign({ paddingTop: '2px' }, baseDivStyles),
    errorStyles: {
      borderBottomColor: '#b41a1a !important;',
      ':after': {
        display: 'none',
      },
    },
    disabledStyles: {
      backgroundColor: '#f6f6f6',
      borderBottomColor: '#D8D8D8',
    },
    menuStyles: __assign(__assign({}, baseMenuStyles), {
      borderRadius: '0 0 6px 6px',
      boxShadow: '0 4px 20px rgba(32, 53, 104, 0.14)',
    }),
  },
  outlined: {
    valueContainerStyles: {
      paddingLeft: '15px',
    },
    multipleIndicatorsContainerStyles: __assign({ padding: '0 12px 0 0' }, baseDivStyles),
    indicatorsContainerStyles: __assign({ padding: '0 12px 0 0' }, baseDivStyles),
    errorStyles: {},
    disabledStyles: {
      backgroundColor: '#f6f6f6',
      outlineColor: '#d8d8d8',
    },
    menuStyles: __assign({}, baseMenuStyles),
  },
};
var MuiSelect = function (_a) {
  var _b, _c, _d, _e;
  var _f, _g, _h;
  var _j = _a.width,
    width = _j === void 0 ? '200px' : _j,
    helperText = _a.helperText,
    headerText = _a.headerText,
    _k = _a.showRequiredAsterisk,
    showRequiredAsterisk = _k === void 0 ? true : _k,
    label = _a.label,
    _l = _a.theme,
    muitheme = _l === void 0 ? 'filled' : _l,
    props = __rest$1(_a, ['width', 'helperText', 'headerText', 'showRequiredAsterisk', 'label', 'theme']);
  var focusState = useBoolState();
  var theme = ['filled', 'outlined'].includes(muitheme) ? muitheme : 'filled';
  var selectClassNames = cx(
    styles$5.MuiSelect,
    ((_b = {}),
    (_b[styles$5.MuiSelectOutlined] = theme === 'outlined'),
    (_b[styles$5.isDisabled] = props.disabled),
    (_b[styles$5.isMultiple] = props.multiple),
    _b),
  );
  var labelClassnames = cx(
    styles$5.MuiSelectLabel,
    ((_c = {}),
    (_c[styles$5.MuiSelectWithHeader] = headerText),
    (_c[styles$5.MuiSelectLabelFilled] = theme === 'filled'),
    (_c[styles$5.MuiSelectLabelOutlined] = theme === 'outlined'),
    (_c[styles$5.isDisabled] = props.disabled),
    (_c[styles$5.isFocused] = focusState.value),
    (_c[styles$5.hasValue] = !props.multiple ? !!props.value : Array.isArray(props.value) && !!props.value.length),
    (_c[styles$5.hasError] = props.error),
    (_c[styles$5.isMultiple] = props.multiple),
    _c),
  );
  var getSelectControlTheme = function (isFocused, hasValue) {
    var borderColor = '#919aac';
    if (isFocused && !props.error) {
      borderColor = '#366ced';
    } else if (props.disabled) {
      borderColor = '#d8d8d8';
    } else if (props.error) {
      borderColor = '#b41a1a';
    }
    var borderColorHover = '#152033';
    if (isFocused && !props.error) {
      borderColorHover = '#366ced';
    } else if (props.error) {
      borderColorHover = '#b41a1a';
    }
    return {
      filled: {
        height: props.multiple ? 'inherit' : '48px',
        minHeight: '48px',
        border: 'none',
        outline: 'none',
        backgroundColor: props.multiple && hasValue ? '#FBFBFA' : 'transparent',
        borderTop: props.multiple ? '' : 'solid 12px transparent',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: isFocused ? 'transparent' : '#919AAC',
        boxShadow: 'none',
        borderRadius: 0,
        position: 'relative',
        ':hover': {
          backgroundColor: '#FBFBFA',
          borderTopColor: 'transparent',
          borderBottomColor: props.error ? '#B41A1A' : '#919AAC',
        },
        ':after': {
          position: 'absolute',
          display: 'block',
          bottom: -1,
          content: '""',
          backgroundColor: '#366ced',
          height: 2,
          left: isFocused ? '0' : '45%',
          width: isFocused ? '100%' : '10px',
          visibility: isFocused ? 'visible' : 'hidden',
          transition: 'all 0.2s ease-in-out',
        },
      },
      outlined: {
        height: props.multiple ? 'auto' : '48px',
        minHeight: '48px',
        border: 'none',
        boxShadow: 'none',
        transition: 'all 0.15s ease-in-out',
        position: 'relative',
        '::before': {
          transition: 'all 0.15s ease-in-out',
          content: '""',
          position: 'absolute',
          border: '1px solid',
          borderWidth: isFocused && !props.error ? '2px' : '1px',
          borderColor: borderColor,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          borderRadius: '6px',
        },
        ':hover::before': {
          borderColor: borderColorHover,
        },
      },
    };
  };
  var customStyles = {
    option: function (styles, _a) {
      var isSelected = _a.isSelected;
      return __assign(__assign({}, styles), {
        color: '#152033',
        position: 'relative',
        ':hover': {
          cursor: 'pointer',
        },
        ':after': {
          position: 'absolute',
          backgroundColor: '#FBFBFA',
          content: 'url('.concat(img$7, ')'),
          top: '50%',
          right: '20px',
          transform: 'translateY(-50%)',
          visibility: isSelected ? 'visible' : 'hidden',
          zIndex: 999,
        },
      });
    },
    control: function (styles, _a) {
      var isFocused = _a.isFocused,
        isDisabled = _a.isDisabled,
        hasValue = _a.hasValue;
      var res = __assign(
        __assign(__assign({}, styles), getSelectControlTheme(isFocused, hasValue)[theme]),
        isDisabled && customThemesStyles[theme].disabledStyles,
      );
      return !props.error ? res : __assign(__assign({}, res), customThemesStyles[theme].errorStyles);
    },
    indicatorsContainer: function (styles) {
      return props.multiple
        ? __assign(__assign({}, styles), customThemesStyles[theme].multipleIndicatorsContainerStyles)
        : customThemesStyles[theme].indicatorsContainerStyles;
    },
    indicatorSeparator: function () {
      return {};
    },
    placeholder: function (styles) {
      return __assign(__assign({}, styles), { display: 'none' });
    },
    input: function (styles) {
      return theme === 'outlined' && !props.multiple ? __assign(__assign({}, styles), { margin: '0' }) : styles;
    },
    valueContainer: function (styles) {
      return __assign(__assign({}, styles), customThemesStyles[theme].valueContainerStyles);
    },
    singleValue: function (styles, _a) {
      var isDisabled = _a.isDisabled;
      return theme === 'filled'
        ? styles
        : __assign(__assign({}, styles), { margin: '0', color: isDisabled ? '#434c5e' : '#152033' });
    },
    multiValue: function (styles) {
      return __assign(__assign({}, styles), {
        boxSizing: 'border-box',
        border: '1px solid #D8D8D8',
        borderRadius: '4px',
        backgroundColor: '#ffffff',
        height: '36px',
        marginTop: '4px',
        padding: '6px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      });
    },
    multiValueLabel: function (styles) {
      return __assign(__assign({}, styles), {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '23px',
        color: '#152033',
        paddingLeft: 0,
        paddingRight: '8px',
      });
    },
    multiValueRemove: function (styles) {
      return __assign(__assign({}, styles), {
        color: '#687183',
        padding: 0,
        ':hover': {
          backgroundColor: 'transparent',
          color: '#366CED',
          cursor: 'pointer',
        },
        '>svg': {
          width: '18px',
          height: '18px',
        },
      });
    },
    menu: function (styles) {
      return __assign(__assign({}, styles), customThemesStyles[theme].menuStyles);
    },
  };
  var style = { width: width };
  var handleBlur = function () {
    var _a;
    (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, props.value);
    focusState.setFalse();
  };
  var ariaLabel = (_f = props['aria-label']) !== null && _f !== void 0 ? _f : typeof label === 'string' ? label : '';
  return jsxRuntime.jsxs('div', {
    className: selectClassNames,
    style: style,
    children: [
      headerText &&
        jsxRuntime.jsx('p', {
          className: cx(((_d = {}), (_d[styles$5.MuiSelectFieldHeader] = true), _d)),
          children: headerText,
        }),
      jsxRuntime.jsx(
        DropdownSelector,
        __assign({ isMuiSelect: true, isClearable: false, onFocus: focusState.setTrue, styles: customStyles }, props, {
          onBlur: handleBlur,
          'aria-label': ariaLabel,
        }),
      ),
      jsxRuntime.jsx('label', {
        className: labelClassnames,
        children: jsxRuntime.jsxs('span', {
          children: [label, ' ', props.required && showRequiredAsterisk ? '*' : ''],
        }),
      }),
      ((_g = props.error) !== null && _g !== void 0 ? _g : helperText) &&
        jsxRuntime.jsx('p', {
          className: cx(((_e = {}), (_e[styles$5.isError] = props.error), _e)),
          children: (_h = props.error) !== null && _h !== void 0 ? _h : helperText,
        }),
    ],
  });
};

var style$b = {
  MuiSliderContainer: 'htco-MuiSliderContainer',
  MuiSliderTitle: 'htco-MuiSliderTitle',
  MuiSliderTooltip: 'htco-MuiSliderTooltip',
  MuiSliderValueAndSubtitleContainer: 'htco-MuiSliderValueAndSubtitleContainer',
  MuiSliderValue: 'htco-MuiSliderValue',
  MuiSliderSubtitle: 'htco-MuiSliderSubtitle',
  MuiSliderSliderContainer: 'htco-MuiSliderSliderContainer',
  MuiSliderSliderTrack: 'htco-MuiSliderSliderTrack',
  MuiSliderSliderProgressBar: 'htco-MuiSliderSliderProgressBar',
  MuiSliderInput: 'htco-MuiSliderInput',
  MuiSliderSliderStepContainer: 'htco-MuiSliderSliderStepContainer',
  MuiSliderSliderStepMinMaxTickContainer: 'htco-MuiSliderSliderStepMinMaxTickContainer',
  MuiSliderSliderStepMin: 'htco-MuiSliderSliderStepMin',
  MuiSliderSliderStepMax: 'htco-MuiSliderSliderStepMax',
  MuiSliderSliderStepTickContainer: 'htco-MuiSliderSliderStepTickContainer',
  MuiSliderSliderStepTickPoint: 'htco-MuiSliderSliderStepTickPoint',
  MuiSliderSliderStepTick: 'htco-MuiSliderSliderStepTick',
  MuiSliderIsTickWithinSelectedRange: 'htco-MuiSliderIsTickWithinSelectedRange',
  MuiSliderSliderStepLabel: 'htco-MuiSliderSliderStepLabel',
};

var MuiSliderBase = React.forwardRef(function (_a, ref) {
  var title = _a.title,
    name = _a.name,
    value = _a.value,
    _b = _a.valueRenderer,
    valueRenderer =
      _b === void 0
        ? function (value) {
            return value;
          }
        : _b,
    subtitleRenderer = _a.subtitleRenderer,
    _c = _a.min,
    min = _c === void 0 ? 0 : _c,
    _d = _a.max,
    max = _d === void 0 ? 100 : _d,
    _e = _a.step,
    step = _e === void 0 ? 10 : _e,
    breakPoints = _a.breakPoints,
    tooltipContent = _a.tooltipContent,
    error = _a.error,
    onRelease = _a.onRelease,
    props = __rest$1(_a, [
      'title',
      'name',
      'value',
      'valueRenderer',
      'subtitleRenderer',
      'min',
      'max',
      'step',
      'breakPoints',
      'tooltipContent',
      'error',
      'onRelease',
    ]);
  var selectedValue = parseInt(typeof value === 'number' || typeof value === 'string' ? value : min);
  var getLabelByStepIndex = function (stepIndex) {
    var result = null;
    var stepValue = min + stepIndex * step;
    if (breakPoints) {
      breakPoints.forEach(function (item) {
        if (item.position === stepValue) {
          result = item.label;
        }
      });
    }
    return result;
  };
  return jsxRuntime.jsxs('div', {
    className: style$b.MuiSliderContainer,
    children: [
      jsxRuntime.jsxs(Label$1, {
        className: style$b.MuiSliderTitle,
        error: error,
        children: [
          title,
          tooltipContent &&
            jsxRuntime.jsx(Tooltip$1, {
              content: tooltipContent,
              className: style$b.MuiSliderTooltip,
              children: jsxRuntime.jsx(Icon, { name: 'icon-info', size: 'sm' }),
            }),
        ],
      }),
      jsxRuntime.jsxs('div', {
        className: style$b.MuiSliderValueAndSubtitleContainer,
        children: [
          jsxRuntime.jsx('h4', { className: style$b.MuiSliderValue, children: valueRenderer(selectedValue) }),
          typeof subtitleRenderer === 'function' &&
            jsxRuntime.jsx('h5', { className: style$b.MuiSliderSubtitle, children: subtitleRenderer(selectedValue) }),
        ],
      }),
      jsxRuntime.jsxs('div', {
        className: style$b.MuiSliderSliderContainer,
        children: [
          jsxRuntime.jsx('div', { className: style$b.MuiSliderSliderTrack }),
          jsxRuntime.jsx('div', {
            className: style$b.MuiSliderSliderProgressBar,
            style: { width: ''.concat(Math.min(((selectedValue - min) / (max - min)) * 100, 100), '%') },
          }),
          jsxRuntime.jsxs('div', {
            className: style$b.MuiSliderSliderStepContainer,
            children: [
              jsxRuntime.jsxs('div', {
                className: style$b.MuiSliderSliderStepMinMaxTickContainer,
                children: [
                  jsxRuntime.jsxs('div', {
                    children: [
                      jsxRuntime.jsx('div', { className: style$b.MuiSliderSliderStepMin }),
                      jsxRuntime.jsx('h4', {
                        className: style$b.MuiSliderSliderStepLabel,
                        children: getLabelByStepIndex(0),
                      }),
                    ],
                  }),
                  jsxRuntime.jsxs('div', {
                    children: [
                      jsxRuntime.jsx('div', { className: style$b.MuiSliderSliderStepMax }),
                      jsxRuntime.jsx('h4', {
                        className: style$b.MuiSliderSliderStepLabel,
                        style: { right: 0 },
                        children: getLabelByStepIndex(Math.floor((max - min) / step)),
                      }),
                    ],
                  }),
                ],
              }),
              breakPoints.map(function (item) {
                var _a;
                if (item.position === min || item.position === max) {
                  return null;
                }
                var tickLeftPosition = ''.concat(((item.position - min) / (max - min)) * 100, '%');
                return jsxRuntime.jsxs(
                  'div',
                  {
                    className: style$b.MuiSliderSliderStepTickPoint,
                    style: { left: tickLeftPosition },
                    children: [
                      jsxRuntime.jsx('div', {
                        className: cx(
                          style$b.MuiSliderSliderStepTick,
                          ((_a = {}),
                          (_a[style$b.MuiSliderIsTickWithinSelectedRange] = item.position <= selectedValue),
                          _a),
                        ),
                      }),
                      item.label &&
                        jsxRuntime.jsx('h4', { className: style$b.MuiSliderSliderStepLabel, children: item.label }),
                    ],
                  },
                  item.position,
                );
              }),
            ],
          }),
          jsxRuntime.jsx(
            'input',
            __assign(
              {
                className: style$b.MuiSliderInput,
                type: 'range',
                value: selectedValue,
                name: name,
                min: min,
                max: max,
                step: step,
                'aria-label': title,
                onMouseUp: onRelease,
                onTouchEnd: onRelease,
                onKeyUp: onRelease,
                ref: ref,
              },
              props,
            ),
          ),
        ],
      }),
    ],
  });
});
MuiSliderBase.displayName = 'MuiSliderBase';
MuiSliderBase.propTypes = {
  title: PropTypes__default['default'].node,
  valueRenderer: PropTypes__default['default'].func,
  subtitleRenderer: PropTypes__default['default'].func,
  name: PropTypes__default['default'].string,
  value: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].number,
    PropTypes__default['default'].string,
  ]),
  tooltipContent: PropTypes__default['default'].node,
  min: PropTypes__default['default'].number,
  max: PropTypes__default['default'].number,
  step: PropTypes__default['default'].number,
  breakPoints: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      position: PropTypes__default['default'].number,
      label: PropTypes__default['default'].string,
    }),
  ).isRequired,
  error: PropTypes__default['default'].string,
  onRelease: PropTypes__default['default'].func,
};

var MuiSlider = function (_a) {
  var title = _a.title,
    name = _a.name,
    value = _a.value,
    _b = _a.valueRenderer,
    valueRenderer =
      _b === void 0
        ? function (value) {
            return value;
          }
        : _b,
    subtitleRenderer = _a.subtitleRenderer,
    _c = _a.min,
    min = _c === void 0 ? 0 : _c,
    _d = _a.max,
    max = _d === void 0 ? 100 : _d,
    _e = _a.step,
    step = _e === void 0 ? 10 : _e,
    breakPoints = _a.breakPoints,
    tooltipContent = _a.tooltipContent,
    error = _a.error,
    onChange = _a.onChange,
    onRelease = _a.onRelease;
  var handleChange = function (e) {
    var newValue = withinRange(e.target.value, min, max);
    onChange === null || onChange === void 0 ? void 0 : onChange(newValue, name, error);
  };
  var handleRelease = function (e) {
    var newValue = withinRange(e.currentTarget.value, min, max);
    onRelease === null || onRelease === void 0 ? void 0 : onRelease(newValue, name, error);
  };
  return jsxRuntime.jsx(MuiSliderBase, {
    title: title,
    valueRenderer: valueRenderer,
    subtitleRenderer: subtitleRenderer,
    name: name,
    value: value,
    tooltipContent: tooltipContent,
    min: min,
    max: max,
    step: step,
    breakPoints: breakPoints,
    error: error,
    onChange: handleChange,
    onRelease: handleRelease,
  });
};
MuiSlider.propTypes = {
  title: PropTypes__default['default'].node,
  valueRenderer: PropTypes__default['default'].func,
  subtitleRenderer: PropTypes__default['default'].func,
  name: PropTypes__default['default'].string,
  value: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].number,
    PropTypes__default['default'].string,
  ]),
  tooltipContent: PropTypes__default['default'].node,
  min: PropTypes__default['default'].number,
  max: PropTypes__default['default'].number,
  step: PropTypes__default['default'].number,
  breakPoints: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      position: PropTypes__default['default'].number,
      label: PropTypes__default['default'].string,
    }),
  ).isRequired,
  error: PropTypes__default['default'].string,
  onChange: PropTypes__default['default'].func,
  onRelease: PropTypes__default['default'].func,
};

var img$6 =
  "data:image/svg+xml,%3csvg width='19' height='12' viewBox='0 0 19 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.15534 0.749976L6.25009 5.84473C6.54297 6.13751 7.01772 6.13751 7.31059 5.84473L9.81259 3.34273C10.1055 3.04994 10.5802 3.04994 10.8731 3.34273L18.0625 10.7197' stroke='%23152033' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M18.0625 7.71973V10.7197H15.0625' stroke='%23152033' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var img$5 =
  "data:image/svg+xml,%3csvg width='19' height='12' viewBox='0 0 19 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.15534 10.7198L6.25009 5.625C6.54297 5.33221 7.01772 5.33221 7.31059 5.625L9.81259 8.127C10.1055 8.41979 10.5802 8.41979 10.8731 8.127L18.0625 0.749998' stroke='%23152033' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M18.0625 3.75V0.75H15.0625' stroke='%23152033' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var style$a = {
  HomeValueShareHeaderSection: 'htco-HomeValueShareHeaderSection',
  HomeValueShareIcon: 'htco-HomeValueShareIcon',
  HomeValueShareHeader: 'htco-HomeValueShareHeader',
  HomeValueShareSectionsGap: 'htco-HomeValueShareSectionsGap',
  HomeValueSharePercentagesSection: 'htco-HomeValueSharePercentagesSection',
  HomeValueShareVerticalLine: 'htco-HomeValueShareVerticalLine',
  HomeValueShareValuesContainer: 'htco-HomeValueShareValuesContainer',
  HomeValueShareValueContainer: 'htco-HomeValueShareValueContainer',
  HomeValueShareValue: 'htco-HomeValueShareValue',
  HomeValueShareValueTextMargin: 'htco-HomeValueShareValueTextMargin',
  HomeValueShareValueHighlightPercentage: 'htco-HomeValueShareValueHighlightPercentage',
  HomeValueShareValueHighlightText: 'htco-HomeValueShareValueHighlightText',
};

var HomeValueShare = function (_a) {
  var _b;
  var upShareValues = _a.upShareValues,
    downShareValues = _a.downShareValues;
  var showPercentagesSection = function (values) {
    return jsxRuntime.jsxs('div', {
      className: style$a.HomeValueSharePercentagesSection,
      children: [
        jsxRuntime.jsx('div', { className: style$a.HomeValueShareVerticalLine }),
        jsxRuntime.jsx('div', {
          className: style$a.HomeValueShareValuesContainer,
          children: values.map(function (item, index) {
            var _a, _b, _c, _d;
            return jsxRuntime.jsxs(
              'div',
              {
                className: style$a.HomeValueShareValueContainer,
                children: [
                  jsxRuntime.jsx('h4', {
                    className: cx(
                      ((_a = {}), (_a[style$a.HomeValueShareValueHighlightPercentage] = item.isHighlighted), _a),
                      ((_b = {}), (_b[style$a.HomeValueShareValue] = !item.isHighlighted), _b),
                    ),
                    children: item.percentage,
                  }),
                  item.text &&
                    jsxRuntime.jsx('h4', {
                      className: cx(
                        style$a.HomeValueShareValueTextMargin,
                        ((_c = {}), (_c[style$a.HomeValueShareValueHighlightText] = item.isHighlighted), _c),
                        ((_d = {}), (_d[style$a.HomeValueShareValue] = !item.isHighlighted), _d),
                      ),
                      children: item.text,
                    }),
                ],
              },
              index,
            );
          }),
        }),
      ],
    });
  };
  return jsxRuntime.jsxs('div', {
    children: [
      upShareValues &&
        jsxRuntime.jsxs('div', {
          children: [
            jsxRuntime.jsxs('div', {
              className: style$a.HomeValueShareHeaderSection,
              children: [
                jsxRuntime.jsx('img', {
                  src: img$5,
                  className: style$a.HomeValueShareIcon,
                  alt: 'icon share increase',
                }),
                jsxRuntime.jsx('h4', {
                  className: style$a.HomeValueShareHeader,
                  children: 'If your home\u2019s value increases, Hometap receives:',
                }),
              ],
            }),
            showPercentagesSection(upShareValues),
          ],
        }),
      downShareValues &&
        jsxRuntime.jsxs('div', {
          className: cx(((_b = {}), (_b[style$a.HomeValueShareSectionsGap] = upShareValues), _b)),
          children: [
            jsxRuntime.jsxs('div', {
              className: style$a.HomeValueShareHeaderSection,
              children: [
                jsxRuntime.jsx('img', {
                  src: img$6,
                  className: style$a.HomeValueShareIcon,
                  alt: 'icon share decrease',
                }),
                jsxRuntime.jsx('h4', {
                  className: style$a.HomeValueShareHeader,
                  children: 'If your home\u2019s value decreases, Hometap receives:',
                }),
              ],
            }),
            showPercentagesSection(downShareValues),
          ],
        }),
    ],
  });
};
HomeValueShare.propTypes = {
  upShareValues: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].oneOfType([
      PropTypes__default['default'].shape({
        percentage: PropTypes__default['default'].string,
        text: PropTypes__default['default'].string,
      }),
      PropTypes__default['default'].shape({
        percentage: PropTypes__default['default'].string,
      }),
    ]),
  ),
  downShareValues: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].oneOfType([
      PropTypes__default['default'].shape({
        percentage: PropTypes__default['default'].string,
        text: PropTypes__default['default'].string,
      }),
      PropTypes__default['default'].shape({
        percentage: PropTypes__default['default'].string,
      }),
    ]),
  ),
};

var styles$4 = {
  SlideSide: 'htco-SlideSide',
  SlideSideChildren: 'htco-SlideSideChildren',
  SlideSideOverlay: 'htco-SlideSideOverlay',
  isRight: 'htco-isRight',
  isLeft: 'htco-isLeft',
  SlideSideBackdrop: 'htco-SlideSideBackdrop',
  hideBackdrop: 'htco-hideBackdrop',
  SlideSideRelativeOverlay: 'htco-SlideSideRelativeOverlay',
};

var SlideSide = function (_a) {
  var children = _a.children,
    maxWidth = _a.maxWidth,
    className = _a.className,
    childrenWrapperClassName = _a.childrenWrapperClassName,
    _b = _a.gap,
    gap = _b === void 0 ? 0 : _b,
    _c = _a.duration,
    duration = _c === void 0 ? 500 : _c,
    _d = _a.visible,
    visible = _d === void 0 ? false : _d,
    _e = _a.isOverlay,
    isOverlay = _e === void 0 ? false : _e,
    _f = _a.displayBackdrop,
    displayBackdrop = _f === void 0 ? false : _f,
    _g = _a.isRelativeOverlay,
    isRelativeOverlay = _g === void 0 ? false : _g,
    _h = _a.direction,
    direction = _h === void 0 ? 'left' : _h,
    minWidth = _a.minWidth,
    _j = _a.onBackdropClick,
    onBackdropClick =
      _j === void 0
        ? function () {
            return null;
          }
        : _j,
    style = _a.style,
    props = __rest$1(_a, [
      'children',
      'maxWidth',
      'className',
      'childrenWrapperClassName',
      'gap',
      'duration',
      'visible',
      'isOverlay',
      'displayBackdrop',
      'isRelativeOverlay',
      'direction',
      'minWidth',
      'onBackdropClick',
      'style',
    ]);
  var _k = React.useState(minWidth),
    calcWidth = _k[0],
    setCalcWidth = _k[1];
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  var childRef = React.useRef();
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  var transitionRef = React.useRef();
  var _l = React.useState(visible),
    isOpen = _l[0],
    setIsOpen = _l[1];
  var overlayOrDirection = isOverlay || direction === 'right';
  React.useEffect(
    function () {
      var timeout;
      if (visible !== null) {
        timeout = setTimeout(function () {
          setIsOpen(visible);
        }, duration);
      }
      return function () {
        return clearTimeout(timeout);
      };
    },
    [visible],
  );
  React.useLayoutEffect(
    function () {
      var content = childRef.current;
      if (content) {
        // @ts-expect-error TS(2339): Property 'getBoundingClientRect' does not exist on... Remove this comment to see the full error message
        setCalcWidth(content.getBoundingClientRect().width);
      }
    },
    [childRef.current, visible],
  );
  var transitionEnterStyles = { marginRight: gap, width: maxWidth || calcWidth };
  var transitionExitStyles = {
    marginRight: minWidth && gap ? gap : 0,
    width: minWidth !== null && minWidth !== void 0 ? minWidth : 0,
  };
  var transitionStates = {
    entering: transitionEnterStyles,
    entered: transitionEnterStyles,
    exiting: transitionExitStyles,
    exited: transitionExitStyles,
  };
  useOutsideClick(transitionRef.current, function () {
    if (isOpen && overlayOrDirection) {
      setIsOpen(false);
      onBackdropClick();
    }
  });
  var shouldDisplayBackdrop = displayBackdrop && visible && overlayOrDirection;
  var backDropEnterStyles = {
    opacity: shouldDisplayBackdrop ? 0.4 : 0,
    pointerEvents: shouldDisplayBackdrop ? 'all' : 'none',
  };
  var backdropTransitionStates = {
    entering: backDropEnterStyles,
    entered: backDropEnterStyles,
    exiting: { opacity: 0, pointerEvents: 'none' },
    exited: { opacity: 0, pointerEvents: 'none' },
  };
  React.useEffect(
    function () {
      if (isRelativeOverlay === false) {
        document.body.style.overflow = visible && overlayOrDirection ? 'hidden' : 'auto';
      }
    },
    [overlayOrDirection, visible],
  );
  return (
    // @ts-expect-error TS(2786): 'Transition' cannot be used as a JSX component.
    jsxRuntime.jsx(
      Transition$2,
      __assign(
        {
          in: visible,
          timeout: duration,
          appear: visible,
          nodeRef: transitionRef,
          mountOnEnter: !minWidth,
          unmountOnExit: !minWidth,
        },
        props,
        {
          children: function (state) {
            return jsxRuntime.jsxs(jsxRuntime.Fragment, {
              children: [
                jsxRuntime.jsx('div', {
                  className: cx(
                    styles$4.SlideSide,
                    className,
                    [direction === 'left' ? styles$4.isLeft : styles$4.isRight],
                    [overlayOrDirection && styles$4.SlideSideOverlay],
                    [isRelativeOverlay && styles$4.SlideSideRelativeOverlay],
                  ),
                  // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
                  ref: transitionRef,
                  style: __assign(
                    __assign(
                      {
                        transitionProperty: 'margin-right, width, translate, transform, transformX',
                        transitionDuration: ''.concat(duration / 1000, 's'),
                        boxSizing: 'border-box',
                        overflowX: 'hidden',
                      },
                      style,
                    ),
                    transitionStates[state],
                  ),
                  children: jsxRuntime.jsx('div', {
                    // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
                    ref: childRef,
                    className: cx(styles$4.SlideSideChildren, childrenWrapperClassName),
                    style: {
                      transitionProperty: 'width',
                      transitionDuration: ''.concat(duration / 1000, 's'),
                      boxSizing: 'border-box',
                      width: !visible && minWidth ? minWidth : maxWidth || 'max-content',
                    },
                    children: typeof children === 'function' ? children({ slideState: state }) : children,
                  }),
                }),
                jsxRuntime.jsx('div', {
                  className: cx(styles$4.SlideSideBackdrop, [!overlayOrDirection && styles$4.hideBackdrop]),
                  'data-test-id': 'slide-side-backdrop',
                  style: __assign(
                    { transitionProperty: 'opacity', transitionDuration: ''.concat(duration / 1000, 's') },
                    backdropTransitionStates[state],
                  ),
                }),
              ],
            });
          },
        },
      ),
    )
  );
};
SlideSide.propTypes = {
  gap: PropTypes__default['default'].number,
  visible: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].node,
  duration: PropTypes__default['default'].number,
  maxWidth: PropTypes__default['default'].number,
  childrenWrapperClassName: PropTypes__default['default'].node,
  isOverlay: PropTypes__default['default'].bool,
  displayBackdrop: PropTypes__default['default'].bool,
  onBackdropClick: PropTypes__default['default'].func,
  direction: PropTypes__default['default'].oneOf(['left', 'right']),
  minWidth: PropTypes__default['default'].number,
};

var COMMON_MIME_TYPES = new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ['aac', 'audio/aac'],
  ['abw', 'application/x-abiword'],
  ['arc', 'application/x-freearc'],
  ['avif', 'image/avif'],
  ['avi', 'video/x-msvideo'],
  ['azw', 'application/vnd.amazon.ebook'],
  ['bin', 'application/octet-stream'],
  ['bmp', 'image/bmp'],
  ['bz', 'application/x-bzip'],
  ['bz2', 'application/x-bzip2'],
  ['cda', 'application/x-cdf'],
  ['csh', 'application/x-csh'],
  ['css', 'text/css'],
  ['csv', 'text/csv'],
  ['doc', 'application/msword'],
  ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  ['eot', 'application/vnd.ms-fontobject'],
  ['epub', 'application/epub+zip'],
  ['gz', 'application/gzip'],
  ['gif', 'image/gif'],
  ['heic', 'image/heic'],
  ['heif', 'image/heif'],
  ['htm', 'text/html'],
  ['html', 'text/html'],
  ['ico', 'image/vnd.microsoft.icon'],
  ['ics', 'text/calendar'],
  ['jar', 'application/java-archive'],
  ['jpeg', 'image/jpeg'],
  ['jpg', 'image/jpeg'],
  ['js', 'text/javascript'],
  ['json', 'application/json'],
  ['jsonld', 'application/ld+json'],
  ['mid', 'audio/midi'],
  ['midi', 'audio/midi'],
  ['mjs', 'text/javascript'],
  ['mp3', 'audio/mpeg'],
  ['mp4', 'video/mp4'],
  ['mpeg', 'video/mpeg'],
  ['mpkg', 'application/vnd.apple.installer+xml'],
  ['odp', 'application/vnd.oasis.opendocument.presentation'],
  ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
  ['odt', 'application/vnd.oasis.opendocument.text'],
  ['oga', 'audio/ogg'],
  ['ogv', 'video/ogg'],
  ['ogx', 'application/ogg'],
  ['opus', 'audio/opus'],
  ['otf', 'font/otf'],
  ['png', 'image/png'],
  ['pdf', 'application/pdf'],
  ['php', 'application/x-httpd-php'],
  ['ppt', 'application/vnd.ms-powerpoint'],
  ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  ['rar', 'application/vnd.rar'],
  ['rtf', 'application/rtf'],
  ['sh', 'application/x-sh'],
  ['svg', 'image/svg+xml'],
  ['swf', 'application/x-shockwave-flash'],
  ['tar', 'application/x-tar'],
  ['tif', 'image/tiff'],
  ['tiff', 'image/tiff'],
  ['ts', 'video/mp2t'],
  ['ttf', 'font/ttf'],
  ['txt', 'text/plain'],
  ['vsd', 'application/vnd.visio'],
  ['wav', 'audio/wav'],
  ['weba', 'audio/webm'],
  ['webm', 'video/webm'],
  ['webp', 'image/webp'],
  ['woff', 'font/woff'],
  ['woff2', 'font/woff2'],
  ['xhtml', 'application/xhtml+xml'],
  ['xls', 'application/vnd.ms-excel'],
  ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  ['xml', 'application/xml'],
  ['xul', 'application/vnd.mozilla.xul+xml'],
  ['zip', 'application/zip'],
  ['7z', 'application/x-7z-compressed'],
  // Others
  ['mkv', 'video/x-matroska'],
  ['mov', 'video/quicktime'],
  ['msg', 'application/vnd.ms-outlook'],
]);
function toFileWithPath(file, path) {
  var f = withMimeType(file);
  if (typeof f.path !== 'string') {
    // on electron, path is already set to the absolute path
    var webkitRelativePath = file.webkitRelativePath;
    Object.defineProperty(f, 'path', {
      value:
        typeof path === 'string'
          ? path
          : // If <input webkitdirectory> is set,
          // the File will have a {webkitRelativePath} property
          // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
          typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
          ? webkitRelativePath
          : file.name,
      writable: false,
      configurable: false,
      enumerable: true,
    });
  }
  return f;
}
function withMimeType(file) {
  var name = file.name;
  var hasExtension = name && name.lastIndexOf('.') !== -1;
  if (hasExtension && !file.type) {
    var ext = name.split('.').pop().toLowerCase();
    var type = COMMON_MIME_TYPES.get(ext);
    if (type) {
      Object.defineProperty(file, 'type', {
        value: type,
        writable: false,
        configurable: false,
        enumerable: true,
      });
    }
  }
  return file;
}

var FILES_TO_IGNORE = [
  // Thumbnail cache files for macOS and Windows
  '.DS_Store',
  'Thumbs.db', // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
        return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
      } else if (isChangeEvt(evt)) {
        return [2 /*return*/, getInputFiles(evt)];
      } else if (
        Array.isArray(evt) &&
        evt.every(function (item) {
          return 'getFile' in item && typeof item.getFile === 'function';
        })
      ) {
        return [2 /*return*/, getFsHandleFiles(evt)];
      }
      return [2 /*return*/, []];
    });
  });
}
function isDataTransfer(value) {
  return isObject(value);
}
function isChangeEvt(value) {
  return isObject(value) && isObject(value.target);
}
function isObject(v) {
  return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
  return fromList(evt.target.files).map(function (file) {
    return toFileWithPath(file);
  });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
  return __awaiter(this, void 0, void 0, function () {
    var files;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [
            4 /*yield*/,
            Promise.all(
              handles.map(function (h) {
                return h.getFile();
              }),
            ),
          ];
        case 1:
          files = _a.sent();
          return [
            2 /*return*/,
            files.map(function (file) {
              return toFileWithPath(file);
            }),
          ];
      }
    });
  });
}
function getDataTransferFiles(dt, type) {
  return __awaiter(this, void 0, void 0, function () {
    var items, files;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!dt.items) return [3 /*break*/, 2];
          items = fromList(dt.items).filter(function (item) {
            return item.kind === 'file';
          });
          // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
          // only 'dragstart' and 'drop' has access to the data (source node)
          if (type !== 'drop') {
            return [2 /*return*/, items];
          }
          return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
        case 1:
          files = _a.sent();
          return [2 /*return*/, noIgnoredFiles(flatten(files))];
        case 2:
          return [
            2 /*return*/,
            noIgnoredFiles(
              fromList(dt.files).map(function (file) {
                return toFileWithPath(file);
              }),
            ),
          ];
      }
    });
  });
}
function noIgnoredFiles(files) {
  return files.filter(function (file) {
    return FILES_TO_IGNORE.indexOf(file.name) === -1;
  });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
  if (items === null) {
    return [];
  }
  var files = [];
  // tslint:disable: prefer-for-of
  for (var i = 0; i < items.length; i++) {
    var file = items[i];
    files.push(file);
  }
  return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== 'function') {
    return fromDataTransferItem(item);
  }
  var entry = item.webkitGetAsEntry();
  // Safari supports dropping an image node from a different window and can be retrieved using
  // the DataTransferItem.getAsFile() API
  // NOTE: FileSystemEntry.file() throws if trying to get the file
  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }
  return fromDataTransferItem(item);
}
function flatten(items) {
  return items.reduce(function (acc, files) {
    return __spreadArray(
      __spreadArray([], __read(acc), false),
      __read(Array.isArray(files) ? flatten(files) : [files]),
      false,
    );
  }, []);
}
function fromDataTransferItem(item) {
  var file = item.getAsFile();
  if (!file) {
    return Promise.reject(''.concat(item, ' is not a File'));
  }
  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
    });
  });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function (resolve, reject) {
    var entries = [];
    function readEntries() {
      var _this = this;
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
      reader.readEntries(
        function (batch) {
          return __awaiter(_this, void 0, void 0, function () {
            var files, err_1, items;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  if (!!batch.length) return [3 /*break*/, 5];
                  _a.label = 1;
                case 1:
                  _a.trys.push([1, 3, , 4]);
                  return [4 /*yield*/, Promise.all(entries)];
                case 2:
                  files = _a.sent();
                  resolve(files);
                  return [3 /*break*/, 4];
                case 3:
                  err_1 = _a.sent();
                  reject(err_1);
                  return [3 /*break*/, 4];
                case 4:
                  return [3 /*break*/, 6];
                case 5:
                  items = Promise.all(batch.map(fromEntry));
                  entries.push(items);
                  // Continue reading
                  readEntries();
                  _a.label = 6;
                case 6:
                  return [2 /*return*/];
              }
            });
          });
        },
        function (err) {
          reject(err);
        },
      );
    }
    readEntries();
  });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [
        2 /*return*/,
        new Promise(function (resolve, reject) {
          entry.file(
            function (file) {
              var fwp = toFileWithPath(file, entry.fullPath);
              resolve(fwp);
            },
            function (err) {
              reject(err);
            },
          );
        }),
      ];
    });
  });
}

var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _toConsumableArray$1(arr) {
  return (
    _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1()
  );
}

function _nonIterableSpread$1() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}

function _iterableToArray$1(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys$1(Object(source), !0).forEach(function (key) {
          _defineProperty$1(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _slicedToArray$1(arr, i) {
  return (
    _arrayWithHoles$1(arr) ||
    _iterableToArrayLimit$1(arr, i) ||
    _unsupportedIterableToArray$1(arr, i) ||
    _nonIterableRest$1()
  );
}

function _nonIterableRest$1() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : (typeof Symbol !== 'undefined' && arr[Symbol.iterator]) || arr['@@iterator'];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files';

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? 'one of '.concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: 'File type must be '.concat(messageSuffix),
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: 'File is larger than '.concat(maxSize, ' ').concat(maxSize === 1 ? 'byte' : 'bytes'),
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: 'File is smaller than '.concat(minSize, ' ').concat(minSize === 1 ? 'byte' : 'bytes'),
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files',
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */

function allFilesAccepted(_ref) {
  var files = _ref.files,
    accept = _ref.accept,
    minSize = _ref.minSize,
    maxSize = _ref.maxSize,
    multiple = _ref.multiple,
    maxFiles = _ref.maxFiles,
    validator = _ref.validator;

  if ((!multiple && files.length > 1) || (multiple && maxFiles >= 1 && files.length > maxFiles)) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
      _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
      accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
      _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
      sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file

  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return 'showOpenFilePicker' in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept)
      .filter(function (_ref2) {
        var _ref3 = _slicedToArray$1(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

        var ok = true;

        if (!isMIMEType(mimeType)) {
          console.warn(
            'Skipped "'.concat(
              mimeType,
              '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.',
            ),
          );
          ok = false;
        }

        if (!Array.isArray(ext) || !ext.every(isExt)) {
          console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
          ok = false;
        }

        return ok;
      })
      .reduce(function (agg, _ref4) {
        var _ref5 = _slicedToArray$1(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

        return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
      }, {});
    return [
      {
        accept: acceptForPicker,
      },
    ];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept)
      .reduce(function (a, _ref6) {
        var _ref7 = _slicedToArray$1(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

        return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
      }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
      .filter(function (v) {
        return isMIMEType(v) || isExt(v);
      })
      .join(',');
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === 'AbortError' || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === 'SecurityError' || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === 'audio/*' || v === 'video/*' || v === 'image/*' || v === 'text/*' || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */

var _excluded = ['children'],
  _excluded2 = ['open'],
  _excluded3 = [
    'refKey',
    'role',
    'onKeyDown',
    'onFocus',
    'onBlur',
    'onClick',
    'onDragEnter',
    'onDragOver',
    'onDragLeave',
    'onDrop',
  ],
  _excluded4 = ['refKey', 'onChange', 'onClick'];

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}

function _iterableToArray(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
  );
}

function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : (typeof Symbol !== 'undefined' && arr[Symbol.iterator]) || arr['@@iterator'];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys(Object(source), !0).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
      : ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/ React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
    open = _useDropzone.open,
    props = _objectWithoutProperties(_useDropzone, _excluded2);

  React.useImperativeHandle(
    ref,
    function () {
      return {
        open: open,
      };
    },
    [open],
  ); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/ React__default['default'].createElement(
    React.Fragment,
    null,
    children(
      _objectSpread(
        _objectSpread({}, props),
        {},
        {
          open: open,
        },
      ),
    ),
  );
});
Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false,
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes__default['default'].func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes__default['default'].objectOf(
    PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  ),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes__default['default'].bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes__default['default'].bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes__default['default'].bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes__default['default'].bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes__default['default'].bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes__default['default'].bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes__default['default'].number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes__default['default'].number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes__default['default'].number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes__default['default'].bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes__default['default'].func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes__default['default'].func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes__default['default'].func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes__default['default'].bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes__default['default'].bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes__default['default'].func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes__default['default'].func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes__default['default'].func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes__default['default'].func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes__default['default'].func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes__default['default'].func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes__default['default'].func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes__default['default'].func,
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: [],
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    accept = _defaultProps$props.accept,
    disabled = _defaultProps$props.disabled,
    getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
    maxSize = _defaultProps$props.maxSize,
    minSize = _defaultProps$props.minSize,
    multiple = _defaultProps$props.multiple,
    maxFiles = _defaultProps$props.maxFiles,
    onDragEnter = _defaultProps$props.onDragEnter,
    onDragLeave = _defaultProps$props.onDragLeave,
    onDragOver = _defaultProps$props.onDragOver,
    onDrop = _defaultProps$props.onDrop,
    onDropAccepted = _defaultProps$props.onDropAccepted,
    onDropRejected = _defaultProps$props.onDropRejected,
    onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
    onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
    useFsAccessApi = _defaultProps$props.useFsAccessApi,
    autoFocus = _defaultProps$props.autoFocus,
    preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
    noClick = _defaultProps$props.noClick,
    noKeyboard = _defaultProps$props.noKeyboard,
    noDrag = _defaultProps$props.noDrag,
    noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
    onError = _defaultProps$props.onError,
    validator = _defaultProps$props.validator;

  var acceptAttr = React.useMemo(
    function () {
      return acceptPropAsAcceptAttr(accept);
    },
    [accept],
  );
  var pickerTypes = React.useMemo(
    function () {
      return pickerOptionsFromAccept(accept);
    },
    [accept],
  );
  var onFileDialogOpenCb = React.useMemo(
    function () {
      return typeof onFileDialogOpen === 'function' ? onFileDialogOpen : noop;
    },
    [onFileDialogOpen],
  );
  var onFileDialogCancelCb = React.useMemo(
    function () {
      return typeof onFileDialogCancel === 'function' ? onFileDialogCancel : noop;
    },
    [onFileDialogCancel],
  );
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = React.useRef(null);
  var inputRef = React.useRef(null);

  var _useReducer = React.useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
    isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = React.useRef(
    typeof window !== 'undefined' && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI(),
  ); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog',
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  React.useEffect(
    function () {
      window.addEventListener('focus', onWindowFocus, false);
      return function () {
        window.removeEventListener('focus', onWindowFocus, false);
      };
    },
    [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef],
  );
  var dragTargetsRef = React.useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  React.useEffect(
    function () {
      if (preventDropOnDocument) {
        document.addEventListener('dragover', onDocumentDragOver, false);
        document.addEventListener('drop', onDocumentDrop, false);
      }

      return function () {
        if (preventDropOnDocument) {
          document.removeEventListener('dragover', onDocumentDragOver);
          document.removeEventListener('drop', onDocumentDrop);
        }
      };
    },
    [rootRef, preventDropOnDocument],
  ); // Auto focus the root when autoFocus is true

  React.useEffect(
    function () {
      if (!disabled && autoFocus && rootRef.current) {
        rootRef.current.focus();
      }

      return function () {};
    },
    [rootRef, autoFocus, disabled],
  );
  var onErrCb = React.useCallback(
    function (e) {
      if (onError) {
        onError(e);
      } else {
        // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
      }
    },
    [onError],
  );
  var onDragEnterCb = React.useCallback(
    function (event) {
      event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

      event.persist();
      stopPropagation(event);
      dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

      if (isEvtWithFiles(event)) {
        Promise.resolve(getFilesFromEvent(event))
          .then(function (files) {
            if (isPropagationStopped(event) && !noDragEventsBubbling) {
              return;
            }

            var fileCount = files.length;
            var isDragAccept =
              fileCount > 0 &&
              allFilesAccepted({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator,
              });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
              isDragAccept: isDragAccept,
              isDragReject: isDragReject,
              isDragActive: true,
              type: 'setDraggedFiles',
            });

            if (onDragEnter) {
              onDragEnter(event);
            }
          })
          .catch(function (e) {
            return onErrCb(e);
          });
      }
    },
    [
      getFilesFromEvent,
      onDragEnter,
      onErrCb,
      noDragEventsBubbling,
      acceptAttr,
      minSize,
      maxSize,
      multiple,
      maxFiles,
      validator,
    ],
  );
  var onDragOverCb = React.useCallback(
    function (event) {
      event.preventDefault();
      event.persist();
      stopPropagation(event);
      var hasFiles = isEvtWithFiles(event);

      if (hasFiles && event.dataTransfer) {
        try {
          event.dataTransfer.dropEffect = 'copy';
        } catch (_unused) {}
        /* eslint-disable-line no-empty */
      }

      if (hasFiles && onDragOver) {
        onDragOver(event);
      }

      return false;
    },
    [onDragOver, noDragEventsBubbling],
  );
  var onDragLeaveCb = React.useCallback(
    function (event) {
      event.preventDefault();
      event.persist();
      stopPropagation(event); // Only deactivate once the dropzone and all children have been left

      var targets = dragTargetsRef.current.filter(function (target) {
        return rootRef.current && rootRef.current.contains(target);
      }); // Make sure to remove a target present multiple times only once
      // (Firefox may fire dragenter/dragleave multiple times on the same element)

      var targetIdx = targets.indexOf(event.target);

      if (targetIdx !== -1) {
        targets.splice(targetIdx, 1);
      }

      dragTargetsRef.current = targets;

      if (targets.length > 0) {
        return;
      }

      dispatch({
        type: 'setDraggedFiles',
        isDragActive: false,
        isDragAccept: false,
        isDragReject: false,
      });

      if (isEvtWithFiles(event) && onDragLeave) {
        onDragLeave(event);
      }
    },
    [rootRef, onDragLeave, noDragEventsBubbling],
  );
  var setFiles = React.useCallback(
    function (files, event) {
      var acceptedFiles = [];
      var fileRejections = [];
      files.forEach(function (file) {
        var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

        var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

        var customErrors = validator ? validator(file) : null;

        if (accepted && sizeMatch && !customErrors) {
          acceptedFiles.push(file);
        } else {
          var errors = [acceptError, sizeError];

          if (customErrors) {
            errors = errors.concat(customErrors);
          }

          fileRejections.push({
            file: file,
            errors: errors.filter(function (e) {
              return e;
            }),
          });
        }
      });

      if ((!multiple && acceptedFiles.length > 1) || (multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles)) {
        // Reject everything and empty accepted files
        acceptedFiles.forEach(function (file) {
          fileRejections.push({
            file: file,
            errors: [TOO_MANY_FILES_REJECTION],
          });
        });
        acceptedFiles.splice(0);
      }

      dispatch({
        acceptedFiles: acceptedFiles,
        fileRejections: fileRejections,
        type: 'setFiles',
      });

      if (onDrop) {
        onDrop(acceptedFiles, fileRejections, event);
      }

      if (fileRejections.length > 0 && onDropRejected) {
        onDropRejected(fileRejections, event);
      }

      if (acceptedFiles.length > 0 && onDropAccepted) {
        onDropAccepted(acceptedFiles, event);
      }
    },
    [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator],
  );
  var onDropCb = React.useCallback(
    function (event) {
      event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

      event.persist();
      stopPropagation(event);
      dragTargetsRef.current = [];

      if (isEvtWithFiles(event)) {
        Promise.resolve(getFilesFromEvent(event))
          .then(function (files) {
            if (isPropagationStopped(event) && !noDragEventsBubbling) {
              return;
            }

            setFiles(files, event);
          })
          .catch(function (e) {
            return onErrCb(e);
          });
      }

      dispatch({
        type: 'reset',
      });
    },
    [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling],
  ); // Fn for opening the file dialog programmatically

  var openFileDialog = React.useCallback(
    function () {
      // No point to use FS access APIs if context is not secure
      // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
      if (fsAccessApiWorksRef.current) {
        dispatch({
          type: 'openDialog',
        });
        onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

        var opts = {
          multiple: multiple,
          types: pickerTypes,
        };
        window
          .showOpenFilePicker(opts)
          .then(function (handles) {
            return getFilesFromEvent(handles);
          })
          .then(function (files) {
            setFiles(files, null);
            dispatch({
              type: 'closeDialog',
            });
          })
          .catch(function (e) {
            // AbortError means the user canceled
            if (isAbort(e)) {
              onFileDialogCancelCb(e);
              dispatch({
                type: 'closeDialog',
              });
            } else if (isSecurityError(e)) {
              fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
              // Try using the input

              if (inputRef.current) {
                inputRef.current.value = null;
                inputRef.current.click();
              } else {
                onErrCb(
                  new Error(
                    'Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided.',
                  ),
                );
              }
            } else {
              onErrCb(e);
            }
          });
        return;
      }

      if (inputRef.current) {
        dispatch({
          type: 'openDialog',
        });
        onFileDialogOpenCb();
        inputRef.current.value = null;
        inputRef.current.click();
      }
    },
    [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple],
  ); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = React.useCallback(
    function (event) {
      // Ignore keyboard events bubbling up the DOM tree
      if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
        return;
      }

      if (event.key === ' ' || event.key === 'Enter' || event.keyCode === 32 || event.keyCode === 13) {
        event.preventDefault();
        openFileDialog();
      }
    },
    [rootRef, openFileDialog],
  ); // Update focus state for the dropzone

  var onFocusCb = React.useCallback(function () {
    dispatch({
      type: 'focus',
    });
  }, []);
  var onBlurCb = React.useCallback(function () {
    dispatch({
      type: 'blur',
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = React.useCallback(
    function () {
      if (noClick) {
        return;
      } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
      // to ensure React can handle state changes
      // See: https://github.com/react-dropzone/react-dropzone/issues/450

      if (isIeOrEdge()) {
        setTimeout(openFileDialog, 0);
      } else {
        openFileDialog();
      }
    },
    [noClick, openFileDialog],
  );

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = React.useMemo(
    function () {
      return function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

        return _objectSpread(
          _objectSpread(
            _defineProperty(
              {
                onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
                onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
                onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
                role: typeof role === 'string' && role !== '' ? role : 'presentation',
              },
              refKey,
              rootRef,
            ),
            !disabled && !noKeyboard
              ? {
                  tabIndex: 0,
                }
              : {},
          ),
          rest,
        );
      };
    },
    [
      rootRef,
      onKeyDownCb,
      onFocusCb,
      onBlurCb,
      onClickCb,
      onDragEnterCb,
      onDragOverCb,
      onDragLeaveCb,
      onDropCb,
      noKeyboard,
      noDrag,
      disabled,
    ],
  );
  var onInputElementClick = React.useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = React.useMemo(
    function () {
      return function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

        var inputProps = _defineProperty(
          {
            accept: acceptAttr,
            multiple: multiple,
            type: 'file',
            style: {
              display: 'none',
            },
            onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
            onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
            tabIndex: -1,
          },
          refKey,
          inputRef,
        );

        return _objectSpread(_objectSpread({}, inputProps), rest);
      };
    },
    [inputRef, accept, multiple, onDropCb, disabled],
  );
  return _objectSpread(
    _objectSpread({}, state),
    {},
    {
      isFocused: isFocused && !disabled,
      getRootProps: getRootProps,
      getInputProps: getInputProps,
      rootRef: rootRef,
      inputRef: inputRef,
      open: composeHandler(openFileDialog),
    },
  );
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread(
        _objectSpread({}, state),
        {},
        {
          isFocused: true,
        },
      );

    case 'blur':
      return _objectSpread(
        _objectSpread({}, state),
        {},
        {
          isFocused: false,
        },
      );

    case 'openDialog':
      return _objectSpread(
        _objectSpread({}, initialState),
        {},
        {
          isFileDialogActive: true,
        },
      );

    case 'closeDialog':
      return _objectSpread(
        _objectSpread({}, state),
        {},
        {
          isFileDialogActive: false,
        },
      );

    case 'setDraggedFiles':
      return _objectSpread(
        _objectSpread({}, state),
        {},
        {
          isDragActive: action.isDragActive,
          isDragAccept: action.isDragAccept,
          isDragReject: action.isDragReject,
        },
      );

    case 'setFiles':
      return _objectSpread(
        _objectSpread({}, state),
        {},
        {
          acceptedFiles: action.acceptedFiles,
          fileRejections: action.fileRejections,
        },
      );

    case 'reset':
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}

var bytesToSize = function (bytes, decimals) {
  if (decimals === void 0) {
    decimals = 2;
  }
  if (bytes === 0) return '0 Bytes';
  var k = 1000;
  var dm = decimals < 0 ? 0 : decimals;
  // sizes larger than GB not needed, included anyways to decrease likelihood out of bounds exception
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return ''.concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), ' ').concat(sizes[i]);
};

var style$9 = {
  FileUploader: 'htco-FileUploader',
  isDisabled: 'htco-isDisabled',
  FileUploaderIcon: 'htco-FileUploaderIcon',
  FileUploaderCTA: 'htco-FileUploaderCTA',
  FileUploaderAdditionalInfo: 'htco-FileUploaderAdditionalInfo',
  FileUploaderButton: 'htco-FileUploaderButton',
};

var MAX_UPLOAD_SIZE_BYTES = 1000 * 1000 * 50; // 50mb
var MAX_BULK_UPLOAD_FILE_COUNT = 20;
var ACCEPTED_FILE_TYPE_AND_EXTENSIONS = {
  'application/pdf': ['.pdf'],
  'image/jpg': ['.jpg'],
  'image/jpeg': ['.jpeg'],
  'image/png': ['.png'],
  'image/pjpeg': ['.pjpeg'],
  'image/heif': ['.heif'],
  'image/heic': ['.heic'],
};
var ERROR_CODE_MESSAGE_MAP = {
  'file-invalid-type': 'File extension is not allowed. Allowed extensions are: '.concat(
    Object.keys(ACCEPTED_FILE_TYPE_AND_EXTENSIONS).join(', '),
  ),
  'file-too-large': 'File size exceeds limit of '.concat(bytesToSize(MAX_UPLOAD_SIZE_BYTES), '.'),
};
var FileUploader = function (_a) {
  var _b, _c;
  var options = _a.options,
    uploadTrigger = _a.uploadTrigger,
    onUpload = _a.onUpload,
    _d = _a.maxUploadSizeBytes,
    maxUploadSizeBytes = _d === void 0 ? MAX_UPLOAD_SIZE_BYTES : _d,
    _e = _a.maxBulkFileCount,
    maxBulkFileCount = _e === void 0 ? MAX_BULK_UPLOAD_FILE_COUNT : _e,
    className = _a.className,
    _f = _a.disabled,
    disabled = _f === void 0 ? false : _f,
    _g = _a.errorCodes,
    errorCodes = _g === void 0 ? ERROR_CODE_MESSAGE_MAP : _g,
    _h = _a.acceptedFileTypes,
    acceptedFileTypes = _h === void 0 ? ACCEPTED_FILE_TYPE_AND_EXTENSIONS : _h;
  var _j = useDropzone(
      __assign(
        {
          accept: acceptedFileTypes,
          disabled: disabled,
          noClick: true,
          maxSize: maxUploadSizeBytes,
          maxFiles: maxBulkFileCount,
        },
        options,
      ),
    ),
    acceptedFiles = _j.acceptedFiles,
    fileRejections = _j.fileRejections,
    getRootProps = _j.getRootProps,
    getInputProps = _j.getInputProps,
    open = _j.open;
  React.useEffect(
    function () {
      if (uploadTrigger) {
        uploadTrigger.current = open;
      }
    },
    [uploadTrigger, open],
  );
  var onUploadCallback = React.useCallback(function (payload) {
    return onUpload(payload);
  }, []);
  React.useEffect(
    function () {
      if (
        (acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.length) ||
        (fileRejections === null || fileRejections === void 0 ? void 0 : fileRejections.length)
      ) {
        onUploadCallback({
          acceptedFiles: acceptedFiles,
          rejectedFiles: fileRejections.map(function (file) {
            var _a;
            return {
              file: file.file,
              errors:
                (_a = file.errors) === null || _a === void 0
                  ? void 0
                  : _a.map(function (err) {
                      return __assign(__assign({}, err), { message: errorCodes[err.code] || err.message });
                    }),
            };
          }),
        });
      }
      // Adding onUpload to the dependency array causes loops that are hard to work around if they need to
      // set state for the parent based on this data - leaving it out works as long as the onUpload method doesn't need to change
    },
    [acceptedFiles, fileRejections, onUploadCallback],
  );
  return jsxRuntime.jsxs(
    'div',
    __assign(
      {},
      getRootProps({
        className: cx(style$9.FileUploader, className, ((_b = {}), (_b[style$9.isDisabled] = disabled), _b)),
      }),
      {
        children: [
          jsxRuntime.jsx(Icon, { size: '3x', name: 'file-upload', className: cx(style$9.FileUploaderIcon) }),
          jsxRuntime.jsxs('span', {
            className: cx(style$9.FileUploaderCTA),
            children: [
              'Drag and drop here, or',
              ' ',
              jsxRuntime.jsx('button', {
                type: 'button',
                onClick: open,
                className: cx(style$9.FileUploaderButton, ((_c = {}), (_c[style$9.isDisabled] = disabled), _c)),
                children: 'pick from your files',
              }),
            ],
          }),
          jsxRuntime.jsxs('span', {
            className: cx(style$9.FileUploaderAdditionalInfo),
            children: ['Please note that you can upload up to ', maxBulkFileCount, ' files at once.'],
          }),
          maxUploadSizeBytes !== Infinity &&
            jsxRuntime.jsxs('span', {
              className: cx(style$9.FileUploaderAdditionalInfo),
              children: ['Max. file size: ', bytesToSize(maxUploadSizeBytes)],
            }),
          jsxRuntime.jsx('input', __assign({ 'data-test-id': 'uploadInput' }, getInputProps())),
        ],
      },
    ),
  );
};

var style$8 = {
  RadioButton: 'htco-RadioButton',
  isDisabled: 'htco-isDisabled',
  RadioButtonInput: 'htco-RadioButtonInput',
  RadioButtonCustom: 'htco-RadioButtonCustom',
  RadioButtonDisplayLabel: 'htco-RadioButtonDisplayLabel',
  RadioButtonSet: 'htco-RadioButtonSet',
  isInline: 'htco-isInline',
  withHelp: 'htco-withHelp',
  RadioButtonSetLabel: 'htco-RadioButtonSetLabel',
  RadioButtonSetItem: 'htco-RadioButtonSetItem',
  isChecked: 'htco-isChecked',
  RadioButtonSetLabelText: 'htco-RadioButtonSetLabelText',
};

var RadioButton = function (_a) {
  var _b;
  var label = _a.label,
    name = _a.name,
    value = _a.value,
    _c = _a.checked,
    checked = _c === void 0 ? false : _c,
    _d = _a.disabled,
    disabled = _d === void 0 ? false : _d,
    _e = _a.required,
    required = _e === void 0 ? false : _e,
    error = _a.error,
    className = _a.className,
    onChange = _a.onChange,
    props = __rest$1(_a, [
      'label',
      'name',
      'value',
      'checked',
      'disabled',
      'required',
      'error',
      'className',
      'onChange',
    ]);
  useRequiredValidation(__assign({ name: name, required: required }, props));
  var id = ''.concat(name, '-').concat(value);
  var handleChange = function () {
    onChange(!checked, name, value);
  };
  return jsxRuntime.jsx('div', {
    children: jsxRuntime.jsxs('label', {
      className: cx(
        style$8.RadioButton,
        className,
        ((_b = {}), (_b[style$8.isDisabled] = disabled), (_b[style$8.isChecked] = checked), _b),
      ),
      style: props.style,
      htmlFor: id,
      children: [
        jsxRuntime.jsx('input', {
          className: style$8.RadioButtonInput,
          type: 'radio',
          name: name,
          id: id,
          value: value,
          checked: checked,
          disabled: disabled,
          onChange: handleChange,
        }),
        jsxRuntime.jsx('span', {
          // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
          tabIndex: '0',
          role: 'radio',
          'data-testid': 'radio-button',
          'aria-checked': checked,
          'aria-label': label || value,
          className: style$8.RadioButtonCustom,
          onKeyDown: function (e) {
            if (!disabled) handleKeyboardEnter(handleChange)(e);
          },
        }),
        jsxRuntime.jsxs('span', {
          className: style$8.RadioButtonDisplayLabel,
          children: [label || value, jsxRuntime.jsx('div', { children: jsxRuntime.jsx(FormError, { error: error }) })],
        }),
      ],
    }),
  });
};
RadioButton.propTypes = {
  label: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].node,
  ]),
  name: PropTypes__default['default'].string,
  value: PropTypes__default['default'].string,
  checked: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  required: PropTypes__default['default'].bool,
  error: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].bool,
  ]),
  className: PropTypes__default['default'].string,
  onChange: PropTypes__default['default'].func.isRequired,
  registerRequiredField: PropTypes__default['default'].func,
  unregisterRequiredField: PropTypes__default['default'].func,
};

var RadioButtonSet = function (_a) {
  var _b = _a.value,
    value = _b === void 0 ? '' : _b,
    label = _a.label,
    _c = _a.inline,
    inline = _c === void 0 ? false : _c,
    _d = _a.required,
    required = _d === void 0 ? false : _d,
    _e = _a.disabled,
    disabled = _e === void 0 ? false : _e,
    name = _a.name,
    error = _a.error,
    _f = _a.options,
    options = _f === void 0 ? [] : _f,
    onChange = _a.onChange,
    className = _a.className,
    props = __rest$1(_a, [
      'value',
      'label',
      'inline',
      'required',
      'disabled',
      'name',
      'error',
      'options',
      'onChange',
      'className',
    ]);
  useRequiredValidation(__assign({ name: name, required: required }, props));
  // @ts-expect-error TS(7006): Parameter 'opt' implicitly has an 'any' type.
  var withHelp = !!options.find(function (opt) {
    return opt.helptip;
  });
  return jsxRuntime.jsxs('span', {
    className: cx(style$8.RadioButtonSet, inline && style$8.isInline, className),
    children: [
      jsxRuntime.jsx(Label$1, { error: error, className: style$8.RadioButtonSetLabel, children: label }),
      options.map(function (option) {
        var _a;
        var isChecked = option.value === value;
        return React.createElement(
          RadioButton,
          __assign({}, option, {
            key: option.value,
            name: name,
            className: cx(style$8.RadioButtonSetItem, ((_a = {}), (_a[style$8.withHelp] = withHelp), _a)),
            checked: isChecked,
            disabled: option.disabled || disabled,
            label: jsxRuntime.jsxs(jsxRuntime.Fragment, {
              children: [
                jsxRuntime.jsx('span', {
                  className: style$8.RadioButtonSetLabelText,
                  children: option.label || option.value,
                }),
                option.helptip &&
                  jsxRuntime.jsx('span', {
                    children: jsxRuntime.jsx(Helptip, __assign({}, option.helptip, { target: 'body' })),
                  }),
              ],
            }),
            onChange: function () {
              return onChange(option.value, name);
            },
          }),
        );
      }),
    ],
  });
};
RadioButtonSet.prototypes = {
  label: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].node,
  ]),
  name: PropTypes__default['default'].string,
  value: PropTypes__default['default'].string,
  options: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      label: PropTypes__default['default'].oneOfType([
        PropTypes__default['default'].string,
        PropTypes__default['default'].node,
      ]).isRequired,
      value: PropTypes__default['default'].string.isRequired,
      helptip: PropTypes__default['default'].object,
    }),
  ).isRequired,
  disabled: PropTypes__default['default'].bool,
  required: PropTypes__default['default'].bool,
  onChange: PropTypes__default['default'].func.isRequired,
  registerRequiredField: PropTypes__default['default'].func,
  unregisterRequiredField: PropTypes__default['default'].func,
};

var style$7 = {
  Toast: 'htco-Toast',
  Toast__success: 'htco-Toast__success',
  Toast__error: 'htco-Toast__error',
  Toast__warning: 'htco-Toast__warning',
  Toast__info: 'htco-Toast__info',
  isHideBorder: 'htco-isHideBorder',
  ToastWrapperIcon: 'htco-ToastWrapperIcon',
  ToastIcon: 'htco-ToastIcon',
  ToastIcon__success: 'htco-ToastIcon__success',
  ToastIcon__error: 'htco-ToastIcon__error',
  ToastIcon__warning: 'htco-ToastIcon__warning',
  ToastIcon__info: 'htco-ToastIcon__info',
  ToastBody: 'htco-ToastBody',
  ToastTitle: 'htco-ToastTitle',
  ToastDescription: 'htco-ToastDescription',
  ToastClose: 'htco-ToastClose',
  ToastCloseIcon: 'htco-ToastCloseIcon',
};

var Toast = function (_a) {
  var _b, _c;
  var type = _a.type,
    title = _a.title,
    description = _a.description,
    closeToast = _a.closeToast,
    _d = _a.toastProps,
    toastProps = _d === void 0 ? {} : _d,
    _e = _a.showCloseButton,
    showCloseButton = _e === void 0 ? true : _e,
    _f = _a.shouldShowTypeIcon,
    shouldShowTypeIcon = _f === void 0 ? true : _f,
    customIconName = _a.customIconName,
    className = _a.className,
    props = __rest$1(_a, [
      'type',
      'title',
      'description',
      'closeToast',
      'toastProps',
      'showCloseButton',
      'shouldShowTypeIcon',
      'customIconName',
      'className',
    ]);
  var hideProgressBar = toastProps.hideProgressBar;
  var showProgressBar = hideProgressBar !== undefined && !hideProgressBar;
  var iconsMap = {
    error: jsxRuntime.jsx(Icon, { name: 'icon-block' }),
    success: jsxRuntime.jsx(Icon, { name: 'icon-check-btl', size: 'sm' }),
    warning: jsxRuntime.jsx(Icon, { name: 'icon-alert' }),
    info: jsxRuntime.jsx(Icon, { name: 'icon-info' }),
  };
  var icon;
  if (customIconName) {
    icon = jsxRuntime.jsx(Icon, { name: customIconName });
  } else if (type) {
    icon = iconsMap[type];
  }
  return jsxRuntime.jsxs(
    'div',
    __assign(
      {
        className: cx(
          style$7.Toast,
          className,
          ((_b = {}), (_b[style$7['Toast__'.concat(type)]] = type), (_b[style$7.isHideBorder] = showProgressBar), _b),
        ),
      },
      props,
      {
        children: [
          icon &&
            shouldShowTypeIcon &&
            jsxRuntime.jsx('div', {
              className: style$7.ToastWrapperIcon,
              children: jsxRuntime.jsx('div', {
                className: cx(style$7.ToastIcon, ((_c = {}), (_c[style$7['ToastIcon__'.concat(type)]] = type), _c)),
                children: icon,
              }),
            }),
          jsxRuntime.jsxs('div', {
            className: style$7.ToastBody,
            children: [
              title && jsxRuntime.jsx('div', { className: style$7.ToastTitle, children: title }),
              description && jsxRuntime.jsx('div', { className: style$7.ToastDescription, children: description }),
            ],
          }),
          closeToast &&
            showCloseButton &&
            jsxRuntime.jsx('div', {
              role: 'button',
              tabIndex: 0,
              onClick: closeToast,
              onKeyDown: handleKeyboardClick,
              className: style$7.ToastClose,
              children: jsxRuntime.jsx('div', {
                className: style$7.ToastCloseIcon,
                children: jsxRuntime.jsx(Icon, { name: 'icon-close' }),
              }),
            }),
        ],
      },
    ),
  );
};

var img$4 =
  "data:image/svg+xml,%3csvg width='310' height='64' viewBox='0 0 310 64' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.16244 64C0.0626011 64 -0.231236 62.483 0.789055 62.0723L154.627 0.150299C154.866 0.0538588 155.134 0.0538597 155.373 0.1503L309.211 62.0723C310.231 62.483 309.937 64 308.838 64H1.16244Z' fill='%23C3D3FA'/%3e%3c/svg%3e";

var style$6 = {
  homeGraphHeight: '288px',
  HomeGraphContainer: 'htco-HomeGraphContainer',
  HomeGraphMobileView: 'htco-HomeGraphMobileView',
  HomeGraph: 'htco-HomeGraph',
  HomeGraphHouse: 'htco-HomeGraphHouse',
  HomeGraphHouseBody: 'htco-HomeGraphHouseBody',
  HomeGraphInfoAmount: 'htco-HomeGraphInfoAmount',
  HomeGraphInfoAmountBig: 'htco-HomeGraphInfoAmountBig',
  HomeGraphProjectedValueGraph: 'htco-HomeGraphProjectedValueGraph',
  HomeGraphHomeownerLayer: 'htco-HomeGraphHomeownerLayer',
  HomeGraphMortgageLayer: 'htco-HomeGraphMortgageLayer',
  HomeGraphMortgageTooltipAnchorPoint: 'htco-HomeGraphMortgageTooltipAnchorPoint',
  HomeGraphInfoPaneTooltip: 'htco-HomeGraphInfoPaneTooltip',
  HomeGraphInfoPaneTooltipArrow: 'htco-HomeGraphInfoPaneTooltipArrow',
  HomeGraphInfoPaneTooltipInfoAmount: 'htco-HomeGraphInfoPaneTooltipInfoAmount',
  HomeGraphHometapLayer: 'htco-HomeGraphHometapLayer',
  HomeGraphHometapShareTooltipAnchorPointContainer: 'htco-HomeGraphHometapShareTooltipAnchorPointContainer',
  HomeGraphHometapShareTooltipAnchorPoint: 'htco-HomeGraphHometapShareTooltipAnchorPoint',
  HomeGraphHometapRemainingLayer: 'htco-HomeGraphHometapRemainingLayer',
  hasSiblingMortgage: 'htco-hasSiblingMortgage',
  HomeGraphHometapInvestmentLayer: 'htco-HomeGraphHometapInvestmentLayer',
  isNotShowingInvestment: 'htco-isNotShowingInvestment',
  isNotShowingInvestmentAndHasSiblingMortgage: 'htco-isNotShowingInvestmentAndHasSiblingMortgage',
  HomeGraphHometapShareInvestmentText: 'htco-HomeGraphHometapShareInvestmentText',
  HomeGraphHometapSharePattern: 'htco-HomeGraphHometapSharePattern',
  HomeGraphInvestmentOutsideContainer: 'htco-HomeGraphInvestmentOutsideContainer',
  HomeGraphCapContainer: 'htco-HomeGraphCapContainer',
  HomeGraphCapHeader: 'htco-HomeGraphCapHeader',
  HomeGraphCapBody: 'htco-HomeGraphCapBody',
  HomeGraphCapLabel: 'htco-HomeGraphCapLabel',
  HomeGraphTooltip: 'htco-HomeGraphTooltip',
  HomeGraphCapInfoTooltipText: 'htco-HomeGraphCapInfoTooltipText',
};

var style$5 = {
  HomeGraphHomeTapShareHatch: 'htco-HomeGraphHomeTapShareHatch',
  HomeGraphHometapShare: 'htco-HomeGraphHometapShare',
  HomeGraphHometapShareLabel: 'htco-HomeGraphHometapShareLabel',
  HomeGraphHometapInvestment: 'htco-HomeGraphHometapInvestment',
  HomeGraphRoundTopBorder: 'htco-HomeGraphRoundTopBorder',
  HomeGraphHometapShareLayer: 'htco-HomeGraphHometapShareLayer',
  HomeGraphRoundBottomBorder: 'htco-HomeGraphRoundBottomBorder',
};

var HomeGraphHometapShareLayer = function (_a) {
  var _b, _c;
  var height = _a.height,
    _d = _a.width,
    width = _d === void 0 ? '100%' : _d,
    hometapShareHeight = _a.hometapShareHeight,
    investmentHeight = _a.investmentHeight,
    label = _a.label,
    className = _a.className,
    roundTopBorder = _a.roundTopBorder,
    roundBottomBorder = _a.roundBottomBorder;
  var adjustedHometapShareHeight = investmentHeight
    ? Math.max(hometapShareHeight - investmentHeight, 0)
    : hometapShareHeight;
  var showsInvestmentAmount = investmentHeight !== null;
  var hatchLayer = jsxRuntime.jsxs('svg', {
    className: style$5.HomeGraphHomeTapShareHatch,
    height: '100%',
    children: [
      jsxRuntime.jsx('defs', {
        children: jsxRuntime.jsx('pattern', {
          id: 'diagonalHatch',
          patternUnits: 'userSpaceOnUse',
          width: '5',
          height: '7',
          patternTransform: 'rotate(-45 3 5)',
          children: jsxRuntime.jsx('path', { d: 'M -1,3 l 7,0', stroke: '#fff', strokeWidth: '.3' }),
        }),
      }),
      jsxRuntime.jsx('rect', { height: '100%', width: '100%', fill: 'url(#diagonalHatch)' }),
    ],
  });
  var investmentAmountLayer = jsxRuntime.jsx('div', {
    className: cx(
      style$5.HomeGraphHometapInvestment,
      ((_b = {}), (_b[style$5.HomeGraphRoundBottomBorder] = roundBottomBorder), _b),
    ),
    style: { width: width, height: ''.concat(investmentHeight, 'px') },
    children:
      label &&
      jsxRuntime.jsx('div', {
        className: style$5.HomeGraphHometapShareLabel,
        'data-cy': 'investment-inside',
        children: label,
      }),
  });
  return jsxRuntime.jsxs('div', {
    className: cx(style$5.HomeGraphHometapShareLayer, className),
    style: { height: ''.concat(height, 'px') },
    children: [
      showsInvestmentAmount && hatchLayer,
      jsxRuntime.jsx('div', {
        className: cx(
          style$5.HomeGraphHometapShare,
          ((_c = {}),
          (_c[style$5.HomeGraphRoundTopBorder] = roundTopBorder),
          (_c[style$5.HomeGraphRoundBottomBorder] = !showsInvestmentAmount && roundBottomBorder),
          _c),
        ),
        style: { width: width, height: ''.concat(adjustedHometapShareHeight, 'px') },
      }),
      showsInvestmentAmount && investmentAmountLayer,
    ],
  });
};
HomeGraphHometapShareLayer.propTypes = {
  height: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].number,
  ]),
  width: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].number,
  ]),
  hometapShareHeight: PropTypes__default['default'].number.isRequired,
  investmentHeight: PropTypes__default['default'].number,
  label: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  roundTopBorder: PropTypes__default['default'].bool,
  roundBottomBorder: PropTypes__default['default'].bool,
};

var style$4 = {
  HomeGraphLegend: 'htco-HomeGraphLegend',
  HomeGraphLegendHeader: 'htco-HomeGraphLegendHeader',
  HomeGraphLegendHeaderTitle: 'htco-HomeGraphLegendHeaderTitle',
  HomeGraphLegendHeaderValue: 'htco-HomeGraphLegendHeaderValue',
  HomeGraphLegendKey: 'htco-HomeGraphLegendKey',
  HomeGraphLegendIcon: 'htco-HomeGraphLegendIcon',
  HomeGraphLegendDescription: 'htco-HomeGraphLegendDescription',
  HomeGraphLegendTitle: 'htco-HomeGraphLegendTitle',
  HomeGraphLegendValueContainer: 'htco-HomeGraphLegendValueContainer',
  HomeGraphLegendValue: 'htco-HomeGraphLegendValue',
  HomeGraphLegendBadgeShare: 'htco-HomeGraphLegendBadgeShare',
  HomeGraphLegendBadgeCapped: 'htco-HomeGraphLegendBadgeCapped',
  HomeGraphHomeownerLayer: 'htco-HomeGraphHomeownerLayer',
  HomeGraphMortgageLayer: 'htco-HomeGraphMortgageLayer',
  HomeGraph: 'htco-HomeGraph',
  HomeGraphInfoPaneTooltipTitle: 'htco-HomeGraphInfoPaneTooltipTitle',
};

var getFormattedDollars = function (amount) {
  return convertToMoneyString(amount, { stripDecimal: true });
};
var homeGraphPercentFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});
var getFormattedPercent = function (percent) {
  percent = percent / 100;
  return homeGraphPercentFormatter.format(percent);
};
var LEGEND_KEYS = {
  projectedHomeValue: 'Projected Home Value',
  homeownerShare: 'Your share',
  mortgageBalance: 'Mortgage balance',
  hometapShare: 'Hometap share',
};

var HomeGraphInfoBadge = function (_a) {
  var share = _a.share;
  var _b = share.isShareCapped,
    isShareCapped = _b === void 0 ? false : _b,
    percent = share.percent;
  if (isShareCapped) return jsxRuntime.jsx('h5', { className: style$4.HomeGraphLegendBadgeCapped, children: 'CAPPED' });
  return share
    ? jsxRuntime.jsx('h5', {
        className: style$4.HomeGraphLegendBadgeShare,
        'data-cy': 'info-share',
        children: getFormattedPercent(percent),
      })
    : null;
};
var HomeGraphLegendKey = function (_a) {
  var title = _a.title,
    share = _a.share,
    className = _a.className,
    IconOverride = _a.iconOverride,
    iconOverrideProps = _a.iconOverrideProps;
  return jsxRuntime.jsxs('div', {
    className: style$4.HomeGraphLegendKey,
    children: [
      IconOverride
        ? jsxRuntime.jsx('div', {
            className: style$4.HomeGraphLegendIcon,
            'data-cy': 'homeGraphLegendIcon',
            children: jsxRuntime.jsx(
              IconOverride,
              __assign(
                {
                  height: 16,
                  width: 16,
                  hometapShareHeight: 16,
                  investmentHeight: 8,
                  roundTopBorder: true,
                  roundBottomBorder: true,
                },
                iconOverrideProps,
              ),
            ),
          })
        : jsxRuntime.jsx('div', {
            className: cx(style$4.HomeGraphLegendIcon, className),
            'data-cy': 'homeGraphLegendIcon',
          }),
      jsxRuntime.jsxs('div', {
        className: style$4.HomeGraphLegendDescription,
        children: [
          jsxRuntime.jsx('h4', { className: style$4.HomeGraphLegendTitle, children: title }),
          jsxRuntime.jsxs('div', {
            className: style$4.HomeGraphLegendValueContainer,
            children: [
              jsxRuntime.jsx('h3', {
                className: style$4.HomeGraphLegendValue,
                children: getFormattedDollars(share.dollars),
              }),
              jsxRuntime.jsx(HomeGraphInfoBadge, { share: share }),
            ],
          }),
        ],
      }),
    ],
  });
};
var HomeGraphLegend = function (_a) {
  var homeownerShare = _a.homeownerShare,
    hometapShare = _a.hometapShare,
    mortgageBalance = _a.mortgageBalance,
    projectedHomeValue = _a.projectedHomeValue,
    _b = _a.showsInvestmentAmount,
    showsInvestmentAmount = _b === void 0 ? true : _b;
  return jsxRuntime.jsxs('div', {
    className: style$4.HomeGraphLegend,
    children: [
      jsxRuntime.jsxs('div', {
        className: style$4.HomeGraphLegendHeader,
        children: [
          jsxRuntime.jsx('h4', {
            className: style$4.HomeGraphLegendHeaderTitle,
            children: LEGEND_KEYS.projectedHomeValue,
          }),
          jsxRuntime.jsx('div', {
            className: style$4.HomeGraphLegendHeaderValue,
            children: getFormattedDollars(projectedHomeValue),
          }),
        ],
      }),
      jsxRuntime.jsx(HomeGraphLegendKey, {
        title: LEGEND_KEYS.homeownerShare,
        share: homeownerShare,
        className: style$4.HomeGraphHomeownerLayer,
      }),
      mortgageBalance &&
        jsxRuntime.jsx(HomeGraphLegendKey, {
          title: LEGEND_KEYS.mortgageBalance,
          share: mortgageBalance,
          className: style$4.HomeGraphMortgageLayer,
        }),
      jsxRuntime.jsx(HomeGraphLegendKey, {
        title: LEGEND_KEYS.hometapShare,
        share: hometapShare,
        iconOverride: HomeGraphHometapShareLayer,
        iconOverrideProps: { investmentHeight: showsInvestmentAmount ? 8 : null },
      }),
    ],
  });
};
HomeGraphLegend.propTypes = {
  homeownerShare: PropTypes__default['default'].shape({
    dollars: PropTypes__default['default'].number.isRequired,
    percent: PropTypes__default['default'].number.isRequired,
  }).isRequired,
  mortgageBalance: PropTypes__default['default'].shape({
    dollars: PropTypes__default['default'].number.isRequired,
    percent: PropTypes__default['default'].number.isRequired,
  }),
  hometapShare: PropTypes__default['default'].shape({
    dollars: PropTypes__default['default'].number.isRequired,
    percent: PropTypes__default['default'].number.isRequired,
    isShareCapped: PropTypes__default['default'].bool.isRequired,
    crrPercent: PropTypes__default['default'].number.isRequired,
  }).isRequired,
  projectedHomeValue: PropTypes__default['default'].number.isRequired,
};

// below 15px the hometap-investment text in home graph doesn't fit inside its container
var hometapInvestmentHidePixel = 15;
var HomeGraph = function (_a) {
  var homeownerShare = _a.homeownerShare,
    mortgageBalance = _a.mortgageBalance,
    hometapShare = _a.hometapShare,
    investmentAmount = _a.investmentAmount,
    projectedHomeValue = _a.projectedHomeValue;
  var homeGraphHeight = parseInt(style$6.homeGraphHeight.split('p')[0]);
  var hometapShareHeight = Math.round((hometapShare.percent / 100) * homeGraphHeight);
  var showsInvestmentAmount = investmentAmount !== null;
  var investmentPercent = Math.round((investmentAmount / hometapShare.dollars) * 100);
  var investmentHeight = Math.min(Math.round((investmentPercent / 100) * hometapShareHeight), hometapShareHeight);
  var labelFitInsideHomeGraph = investmentHeight >= hometapInvestmentHidePixel;
  var showsInvestmentLayer = showsInvestmentAmount && investmentAmount <= hometapShare.dollars;
  var showsInvestmentAmountInsideHome = showsInvestmentLayer && labelFitInsideHomeGraph;
  var investmentLabel = showsInvestmentAmount ? 'Investment - '.concat(getFormattedDollars(investmentAmount)) : null;
  return jsxRuntime.jsxs('div', {
    className: style$6.HomeGraphContainer,
    children: [
      jsxRuntime.jsxs('div', {
        className: style$6.HomeGraph,
        children: [
          jsxRuntime.jsxs('div', {
            className: style$6.HomeGraphHouse,
            'data-cy': 'homeGraph-house',
            children: [
              jsxRuntime.jsx('img', {
                className: style$6.HomeGraphProjectedValueGraph,
                src: img$4,
                alt: 'home graph roof',
              }),
              jsxRuntime.jsxs('div', {
                className: style$6.HomeGraphHouseBody,
                children: [
                  jsxRuntime.jsx('div', {
                    className: style$6.HomeGraphHomeownerLayer,
                    style: { height: ''.concat(homeownerShare.percent, '%') },
                  }),
                  mortgageBalance &&
                    jsxRuntime.jsx('div', {
                      className: style$6.HomeGraphMortgageLayer,
                      style: { height: ''.concat(mortgageBalance.percent, '%') },
                    }),
                  jsxRuntime.jsx(HomeGraphHometapShareLayer, {
                    height: hometapShareHeight,
                    hometapShareHeight: hometapShareHeight,
                    investmentHeight: showsInvestmentAmount ? investmentHeight : null,
                    label: showsInvestmentAmountInsideHome ? investmentLabel : null,
                    roundBottomBorder: true,
                  }),
                ],
              }),
              !showsInvestmentAmountInsideHome &&
                showsInvestmentAmount &&
                jsxRuntime.jsx('div', {
                  className: style$6.HomeGraphInvestmentOutsideContainer,
                  'data-cy': 'investment-outside',
                  children: investmentLabel,
                }),
            ],
          }),
          jsxRuntime.jsx(HomeGraphLegend, {
            mortgageBalance: mortgageBalance,
            homeownerShare: homeownerShare,
            hometapShare: hometapShare,
            projectedHomeValue: projectedHomeValue,
            showsInvestmentAmount: showsInvestmentAmount,
          }),
        ],
      }),
      hometapShare.isShareCapped &&
        jsxRuntime.jsxs('div', {
          className: style$6.HomeGraphCapContainer,
          children: [
            jsxRuntime.jsxs('div', {
              className: style$6.HomeGraphCapHeader,
              children: [
                jsxRuntime.jsx('h4', { className: style$6.HomeGraphCapLabel, children: 'CAPPED' }),
                jsxRuntime.jsx(Tooltip$1, {
                  className: style$6.HomeGraphTooltip,
                  position: 'bottom-start',
                  content: jsxRuntime.jsxs('p', {
                    className: style$6.HomeGraphCapInfoTooltipText,
                    children: [
                      'Because Hometap puts the homeowner first, we observe what we call a \u201CHometap Cap,\u201D which limits our annual rate of return to ',
                      jsxRuntime.jsxs('strong', { children: [hometapShare.crrPercent, '%'] }),
                      ' so that you \u2014 the homeowner \u2014 reap the benefits of your home\u2019s appreciation. This added protection becomes especially valuable during periods of rapid appreciation or in cases where you choose to settle the investment in a very short period of time.',
                    ],
                  }),
                  children: jsxRuntime.jsx(Icon, { name: 'icon-info', size: 'lg' }),
                }),
              ],
            }),
            jsxRuntime.jsxs('p', {
              className: style$6.HomeGraphCapBody,
              children: [
                'In this scenario, the \u201CHometap Cap\u201D would come into effect and limit the Hometap Share to a',
                jsxRuntime.jsxs('strong', { children: [' ', hometapShare.crrPercent, '%'] }),
                ' annualized rate of return on the original Investment amount.',
              ],
            }),
          ],
        }),
    ],
  });
};
HomeGraph.propTypes = {
  homeownerShare: PropTypes__default['default'].shape({
    dollars: PropTypes__default['default'].number.isRequired,
    percent: PropTypes__default['default'].number.isRequired,
  }).isRequired,
  mortgageBalance: PropTypes__default['default'].shape({
    dollars: PropTypes__default['default'].number.isRequired,
    percent: PropTypes__default['default'].number.isRequired,
  }),
  hometapShare: PropTypes__default['default'].shape({
    dollars: PropTypes__default['default'].number.isRequired,
    percent: PropTypes__default['default'].number.isRequired,
    isShareCapped: PropTypes__default['default'].bool.isRequired,
    crrPercent: PropTypes__default['default'].number.isRequired,
  }).isRequired,
  investmentAmount: PropTypes__default['default'].number,
  projectedHomeValue: PropTypes__default['default'].number.isRequired,
};

var style$3 = {
  ColorCard: 'htco-ColorCard',
  ColorCardTitle: 'htco-ColorCardTitle',
  ColorCardDescription: 'htco-ColorCardDescription',
  ColorCardIcon: 'htco-ColorCardIcon',
  isDarkTheme: 'htco-isDarkTheme',
  isPurpleTheme: 'htco-isPurpleTheme',
  isWhiteTheme: 'htco-isWhiteTheme',
};

var ColorCard = function (_a) {
  var _b;
  var title = _a.title,
    description = _a.description,
    icon = _a.icon,
    _c = _a.theme,
    theme = _c === void 0 ? 'blue' : _c,
    width = _a.width,
    className = _a.className;
  return jsxRuntime.jsxs('div', {
    className: cx(
      className,
      style$3.ColorCard,
      ((_b = {}),
      (_b[style$3.isWhiteTheme] = theme === 'white'),
      (_b[style$3.isDarkTheme] = theme === 'dark'),
      (_b[style$3.isPurpleTheme] = theme === 'purple'),
      _b),
    ),
    style: { width: width },
    children: [
      icon && jsxRuntime.jsx(Icon, { size: '4x', name: icon, className: style$3.ColorCardIcon }),
      jsxRuntime.jsx('h3', { className: cx(className, style$3.ColorCardTitle), children: title }),
      jsxRuntime.jsx('p', { className: cx(className, style$3.ColorCardDescription), children: description }),
    ],
  });
};
ColorCard.propTypes = {
  title: PropTypes__default['default'].string.isRequired,
  description: PropTypes__default['default'].string.isRequired,
  icon: PropTypes__default['default'].string,
  theme: PropTypes__default['default'].oneOf(['blue', 'purple', 'dark', 'white']),
  width: PropTypes__default['default'].string,
};

var img$3 =
  'data:image/png;base64,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';

var img$2 =
  'data:image/png;base64,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';

var img$1 =
  'data:image/png;base64,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';

var img =
  'data:image/png;base64,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';

var styles$3 = {
  PropertyDropdownContainer: 'htco-PropertyDropdownContainer',
  small: 'htco-small',
  PropertyDropdownSelectedProperty: 'htco-PropertyDropdownSelectedProperty',
  isActive: 'htco-isActive',
  PropertyDropdownSelectedPropertyInfo: 'htco-PropertyDropdownSelectedPropertyInfo',
  PropertyDropdownSelectedPropertyInfoText: 'htco-PropertyDropdownSelectedPropertyInfoText',
  PropertyDropdownSelectMenu: 'htco-PropertyDropdownSelectMenu',
  isOpen: 'htco-isOpen',
  PropertyDropdownSelect: 'htco-PropertyDropdownSelect',
  isSelected: 'htco-isSelected',
  PropertyDropdownSelectMenuNewOption: 'htco-PropertyDropdownSelectMenuNewOption',
};

var AddressDropdown = function (_a) {
  var _b, _c;
  var value = _a.value,
    options = _a.options,
    onChange = _a.onChange,
    onAdd = _a.onAdd,
    _d = _a.maxOptions,
    maxOptions = _d === void 0 ? 10 : _d,
    _e = _a.size,
    size = _e === void 0 ? 'normal' : _e;
  var _f = React.useState(false),
    showPropertyMenu = _f[0],
    setShowPropertyMenu = _f[1];
  // @ts-expect-error expected one argument, but got zero
  var ref = React.useRef();
  useOutsideClick(ref.current, function () {
    setShowPropertyMenu(false);
  });
  var imageSources = [img$3, img$2, img$1, img];
  var selectedOptionIndex = options.findIndex(function (option) {
    return option.value === value.value;
  });
  return jsxRuntime.jsxs('div', {
    className: cx(styles$3.PropertyDropdownContainer, ((_b = {}), (_b[styles$3.small] = size === 'small'), _b)),
    children: [
      jsxRuntime.jsxs('button', {
        'data-cy': 'btn-open',
        // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
        ref: ref,
        className: cx(styles$3.PropertyDropdownSelectedProperty, showPropertyMenu && styles$3.isActive),
        onClick: function () {
          return setShowPropertyMenu(!showPropertyMenu);
        },
        children: [
          jsxRuntime.jsxs('div', {
            className: styles$3.PropertyDropdownSelectedPropertyInfo,
            children: [
              jsxRuntime.jsx('img', {
                src: imageSources[selectedOptionIndex % imageSources.length],
                alt: 'selected property',
              }),
              jsxRuntime.jsxs('div', {
                className: cx(
                  styles$3.PropertyDropdownSelectedPropertyInfoText,
                  ((_c = {}), (_c[styles$3.small] = size === 'small'), _c),
                ),
                children: [
                  jsxRuntime.jsx('h4', { children: value.mainInfo }),
                  value.additionalInfo && jsxRuntime.jsx('p', { children: value.additionalInfo }),
                ],
              }),
            ],
          }),
          jsxRuntime.jsx('span', {
            children: jsxRuntime.jsx(Icon, { name: showPropertyMenu ? 'icon-chevron2-up' : 'icon-chevron2-down' }),
          }),
        ],
      }),
      jsxRuntime.jsxs('ul', {
        className: cx(styles$3.PropertyDropdownSelectMenu, [showPropertyMenu && styles$3.isOpen]),
        'data-cy': 'menu-open',
        children: [
          options.map(function (option, index) {
            return jsxRuntime.jsx(
              'li',
              {
                className: cx(styles$3.PropertyDropdownSelect, [value.value === option.value && styles$3.isSelected]),
                children: jsxRuntime.jsxs('button', {
                  onClick: function () {
                    onChange(option);
                    setShowPropertyMenu(false);
                  },
                  children: [
                    jsxRuntime.jsx('p', { children: option.mainInfo }),
                    jsxRuntime.jsx('span', {
                      children: jsxRuntime.jsx(Icon, { name: 'icon-check-mdc', color: '#366CED' }),
                    }),
                  ],
                }),
              },
              index,
            );
          }),
          (options === null || options === void 0 ? void 0 : options.length) < maxOptions &&
            jsxRuntime.jsx('li', {
              className: styles$3.PropertyDropdownSelectMenuNewOption,
              children: jsxRuntime.jsxs('button', {
                onClick: onAdd,
                'data-cy': 'menu-add',
                children: [
                  jsxRuntime.jsx('span', { children: jsxRuntime.jsx(Icon, { name: 'icon-plus', color: '#366CED' }) }),
                  jsxRuntime.jsx('p', { children: 'Add home to dashboard' }),
                ],
              }),
            }),
        ],
      }),
    ],
  });
};
AddressDropdown.propTypes = {
  value: PropTypes__default['default'].shape({
    value: PropTypes__default['default'].string.isRequired,
    mainInfo: PropTypes__default['default'].string.isRequired,
    additionalInfo: PropTypes__default['default'].string,
  }).isRequired,
  options: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      value: PropTypes__default['default'].string.isRequired,
      mainInfo: PropTypes__default['default'].string.isRequired,
      additionalInfo: PropTypes__default['default'].string,
    }),
  ).isRequired,
  onChange: PropTypes__default['default'].func.isRequired,
  onAdd: PropTypes__default['default'].func.isRequired,
  maxOptions: PropTypes__default['default'].number,
  size: PropTypes__default['default'].oneOf(['normal', 'small']),
};

var styles$2 = {
  PropertyCardContainer: 'htco-PropertyCardContainer',
  PropertyCardDetailsContainer: 'htco-PropertyCardDetailsContainer',
  PropertyCardImg: 'htco-PropertyCardImg',
  PropertyCardDetails: 'htco-PropertyCardDetails',
  PropertyCardDetail: 'htco-PropertyCardDetail',
  PropertyCardButtonContainer: 'htco-PropertyCardButtonContainer',
};

var _a;
var IMG_NAMES = {
  img1: 'property-1',
  img2: 'property-2',
  img3: 'property-3',
  img4: 'property-4',
};
var PROPERTY_IMAGES =
  ((_a = {}),
  (_a[IMG_NAMES.img1] = img$3),
  (_a[IMG_NAMES.img2] = img$2),
  (_a[IMG_NAMES.img3] = img$1),
  (_a[IMG_NAMES.img4] = img),
  _a);
var PropertyCard = function (_a) {
  var property = _a.property,
    _b = _a.propertyImg,
    propertyImg = _b === void 0 ? IMG_NAMES.img1 : _b,
    onDelete = _a.onDelete,
    shouldHideDeleteButton = _a.shouldHideDeleteButton;
  var showDeleteButton = onDelete && typeof onDelete === 'function' && !shouldHideDeleteButton;
  return jsxRuntime.jsxs('div', {
    className: styles$2.PropertyCardContainer,
    'data-cy': 'property-details',
    children: [
      jsxRuntime.jsx('img', {
        src: PROPERTY_IMAGES[propertyImg],
        className: styles$2.PropertyCardImg,
        alt: 'property',
      }),
      jsxRuntime.jsxs('div', {
        className: styles$2.PropertyCardDetailsContainer,
        children: [
          jsxRuntime.jsxs('div', {
            className: styles$2.PropertyCardDetails,
            children: [
              jsxRuntime.jsxs('div', {
                className: styles$2.PropertyCardDetail,
                children: [
                  jsxRuntime.jsx('span', { children: 'Street' }),
                  jsxRuntime.jsx('h4', { children: property.street }),
                ],
              }),
              jsxRuntime.jsxs('div', {
                className: styles$2.PropertyCardDetail,
                children: [
                  jsxRuntime.jsx('span', { children: 'City' }),
                  jsxRuntime.jsx('h4', { children: property.city }),
                ],
              }),
              jsxRuntime.jsxs('div', {
                className: styles$2.PropertyCardDetail,
                children: [
                  jsxRuntime.jsx('span', { children: 'State' }),
                  jsxRuntime.jsx('h4', { children: property.state }),
                ],
              }),
              jsxRuntime.jsxs('div', {
                className: styles$2.PropertyCardDetail,
                children: [
                  jsxRuntime.jsx('span', { children: 'Zip Code' }),
                  jsxRuntime.jsx('h4', { children: property.zipCode }),
                ],
              }),
              property.details &&
                jsxRuntime.jsxs('div', {
                  className: styles$2.PropertyCardDetail,
                  children: [
                    jsxRuntime.jsx('span', { children: 'Details' }),
                    jsxRuntime.jsx('h4', { children: property.details }),
                  ],
                }),
            ],
          }),
          showDeleteButton &&
            jsxRuntime.jsx('div', {
              className: styles$2.PropertyCardButtonContainer,
              children: jsxRuntime.jsx(Button, {
                icon: 'icon-bin',
                theme: 'link',
                onClick: onDelete,
                children: 'Delete',
              }),
            }),
        ],
      }),
    ],
  });
};
PropertyCard.propTypes = {
  property: PropTypes__default['default'].shape({
    street: PropTypes__default['default'].string.isRequired,
    city: PropTypes__default['default'].string.isRequired,
    state: PropTypes__default['default'].string.isRequired,
    zipCode: PropTypes__default['default'].string.isRequired,
    details: PropTypes__default['default'].string,
  }).isRequired,
  propertyImg: PropTypes__default['default'].oneOf([IMG_NAMES.img1, IMG_NAMES.img2, IMG_NAMES.img3, IMG_NAMES.img4])
    .isRequired,
  onDelete: PropTypes__default['default'].func,
  shouldHideDeleteButton: PropTypes__default['default'].bool,
};

var style$2 = {
  ProfileInfoCardContainer: 'htco-ProfileInfoCardContainer',
  ProfileInfoCardDetail: 'htco-ProfileInfoCardDetail',
};

var ProfileInfoCard = function (_a) {
  var profileInfo = _a.profileInfo,
    onChangePassword = _a.onChangePassword,
    onEditPhoneNumber = _a.onEditPhoneNumber;
  return jsxRuntime.jsxs('div', {
    className: style$2.ProfileInfoCardContainer,
    'data-cy': 'profile-card',
    children: [
      jsxRuntime.jsxs('div', {
        className: style$2.ProfileInfoCardDetail,
        children: [
          jsxRuntime.jsx('span', { children: 'First name' }),
          jsxRuntime.jsx('h4', { children: profileInfo.firstName }),
        ],
      }),
      jsxRuntime.jsxs('div', {
        className: style$2.ProfileInfoCardDetail,
        children: [
          jsxRuntime.jsx('span', { children: 'Last name' }),
          jsxRuntime.jsx('h4', { children: profileInfo.lastName }),
        ],
      }),
      jsxRuntime.jsxs('div', {
        className: style$2.ProfileInfoCardDetail,
        children: [
          jsxRuntime.jsx('span', { children: 'Email' }),
          jsxRuntime.jsx('h4', { children: profileInfo.email }),
        ],
      }),
      profileInfo.phoneNumber &&
        jsxRuntime.jsxs('div', {
          className: style$2.ProfileInfoCardDetail,
          children: [
            jsxRuntime.jsx('span', { children: 'Phone Number' }),
            jsxRuntime.jsx(Button, {
              icon: 'icon-edit',
              theme: 'link',
              onClick: onEditPhoneNumber,
              'data-cy': 'edit-number',
              children: profileInfo.phoneNumber,
            }),
          ],
        }),
      jsxRuntime.jsxs('div', {
        className: style$2.ProfileInfoCardDetail,
        children: [
          jsxRuntime.jsx('span', { children: 'Password' }),
          jsxRuntime.jsx(Button, {
            theme: 'link',
            onClick: onChangePassword,
            'data-cy': 'reset-password',
            children: 'Reset Password',
          }),
        ],
      }),
    ],
  });
};
ProfileInfoCard.propTypes = {
  profileInfo: PropTypes__default['default'].shape({
    firstName: PropTypes__default['default'].string.isRequired,
    lastName: PropTypes__default['default'].string.isRequired,
    email: PropTypes__default['default'].string.isRequired,
    phoneNumber: PropTypes__default['default'].string,
  }).isRequired,
  onEditPhoneNumber: PropTypes__default['default'].func.isRequired,
  onChangePassword: PropTypes__default['default'].func.isRequired,
};

var style$1 = {
  BreadCrumbsDisplay: 'htco-BreadCrumbsDisplay',
  BreadCrumbsDisplayCrumb: 'htco-BreadCrumbsDisplayCrumb',
  isLastCrumb: 'htco-isLastCrumb',
  BreadCrumbsDisplaySeparator: 'htco-BreadCrumbsDisplaySeparator',
};

/**
 * A simple bread crumb component that can be configured to render a list of crumbs.
 * Each crumb can have an `as` property that can be an arbitrary component or html tag
 */
var BreadCrumbsDisplay = function (_a) {
  var _b = _a.crumbs,
    crumbs = _b === void 0 ? [] : _b,
    _c = _a.separator,
    separator = _c === void 0 ? '/' : _c,
    className = _a.className;
  // @ts-expect-error TS(7006): Parameter 'crumb' implicitly has an 'any' type.
  var renderedCrumbs = crumbs.map(function (crumb, i) {
    var _a;
    var display = crumb.display,
      _b = crumb.as,
      Component = _b === void 0 ? 'a' : _b,
      rest = __rest$1(crumb, ['display', 'as']);
    var isLastCrumb = i === crumbs.length - 1;
    var key = ''.concat(display, '-').concat(i);
    return !isLastCrumb
      ? jsxRuntime.jsxs(
          React.Fragment,
          {
            children: [
              jsxRuntime.jsx(
                Component,
                __assign({}, rest, {
                  className: cx(
                    style$1.BreadCrumbsDisplayCrumb,
                    rest.className,
                    ((_a = {}), (_a[style$1.isLastCrumb] = isLastCrumb), _a),
                  ),
                  children: crumb.display,
                }),
              ),
              jsxRuntime.jsx('span', { className: style$1.BreadCrumbsDisplaySeparator, children: separator }),
            ],
          },
          key,
        )
      : jsxRuntime.jsx(
          'span',
          {
            className: cx(style$1.BreadCrumbsDisplayCrumb, rest.className, style$1.isLastCrumb),
            children: crumb.display,
          },
          key,
        );
  });
  return jsxRuntime.jsx('span', { className: cx(style$1.BreadCrumbsDisplay, className), children: renderedCrumbs });
};
BreadCrumbsDisplay.propTypes = {
  className: PropTypes__default['default'].string,
  crumbs: PropTypes__default['default'].arrayOf(
    PropTypes__default['default'].shape({
      display: PropTypes__default['default'].node,
      as: PropTypes__default['default'].oneOfType([
        PropTypes__default['default'].node,
        PropTypes__default['default'].elementType,
      ]),
    }).isRequired,
  ),
  separator: PropTypes__default['default'].string,
};

var styles$1 = {
  DropdownButton: 'htco-DropdownButton',
  DropdownSelected: 'htco-DropdownSelected',
  DropdownSelectedInfoValue: 'htco-DropdownSelectedInfoValue',
  isActive: 'htco-isActive',
  DropdownSelectedInfoLabel: 'htco-DropdownSelectedInfoLabel',
  DropdownSelectedInfo: 'htco-DropdownSelectedInfo',
  DropdownMenu: 'htco-DropdownMenu',
  isOpen: 'htco-isOpen',
  fullWidth: 'htco-fullWidth',
  DropdownMenuItem: 'htco-DropdownMenuItem',
  OptionLabel: 'htco-OptionLabel',
  OptionLabelTitle: 'htco-OptionLabelTitle',
  OptionLabelNoTitle: 'htco-OptionLabelNoTitle',
  isSelected: 'htco-isSelected',
};

function DropdownButton(_a) {
  var _b;
  var name = _a.name,
    value = _a.value,
    options = _a.options,
    label = _a.label,
    _c = _a.disabled,
    disabled = _c === void 0 ? false : _c,
    fullWidth = _a.fullWidth,
    onChange = _a.onChange;
  var _d = React.useState(false),
    showDropdownMenu = _d[0],
    setShowDropdownMenu = _d[1];
  var parentRef = React.useRef(null);
  var buttonRef = React.useRef(null);
  var optionsRef = React.useRef([]);
  var _e = React.useState(0),
    currentFocus = _e[0],
    setCurrentFocus = _e[1];
  var hasFocusRef = React.useRef(false);
  useOutsideClick(parentRef.current, function () {
    if (showDropdownMenu) setShowDropdownMenu(false);
  });
  var selectedOptionIndex = options.findIndex(function (option) {
    return option.value === value;
  });
  var selectedOption = options[selectedOptionIndex];
  var handleDropdownTrigger = React.useCallback(
    function (handleOptionFocus) {
      var _a;
      if (handleOptionFocus === void 0) {
        handleOptionFocus = false;
      }
      var shouldShowDropdown = !showDropdownMenu;
      var focusIndex = selectedOptionIndex !== -1 ? selectedOptionIndex : 0;
      setShowDropdownMenu(shouldShowDropdown);
      setCurrentFocus(focusIndex);
      (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      if (handleOptionFocus) {
        hasFocusRef.current = true;
        setTimeout(function () {
          focusOption(focusIndex);
        }, 10);
      }
    },
    [showDropdownMenu],
  );
  var handleButtonClick = function (e) {
    e.preventDefault();
    handleDropdownTrigger();
  };
  var handleOptionClick = function (newValue) {
    onChange(newValue, name);
    setShowDropdownMenu(false);
  };
  var focusOption = function (index) {
    var optionRef = optionsRef.current[index];
    optionRef === null || optionRef === void 0 ? void 0 : optionRef.setAttribute('tabindex', '0');
    optionRef === null || optionRef === void 0 ? void 0 : optionRef.focus();
    hasFocusRef.current = true;
  };
  var nextFocus = React.useCallback(
    function () {
      setCurrentFocus(function (current) {
        return current === options.length - 1 ? 0 : current + 1;
      });
    },
    [options.length],
  );
  var previousFocus = React.useCallback(
    function () {
      setCurrentFocus(function (current) {
        return current === 0 ? options.length - 1 : current - 1;
      });
    },
    [options.length],
  );
  var handleKeyDown = React.useCallback(
    function (e) {
      var _a, _b, _c, _d;
      if (showDropdownMenu) {
        switch (e.key) {
          case 'Tab':
            if (e.shiftKey && currentFocus === 0) {
              setShowDropdownMenu(false);
            } else if (!e.shiftKey && currentFocus === options.length - 1) {
              setShowDropdownMenu(false);
            } else {
              e.preventDefault();
              if (e.shiftKey) {
                previousFocus();
              } else {
                nextFocus();
              }
            }
            break;
          case 'ArrowUp':
            e.preventDefault();
            if (currentFocus === 0) {
              setShowDropdownMenu(false);
              (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            } else {
              previousFocus();
            }
            break;
          case 'ArrowDown':
            e.preventDefault();
            if (currentFocus === options.length - 1) {
              setShowDropdownMenu(false);
              (_b = buttonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            } else {
              nextFocus();
            }
            break;
          case 'Escape':
            e.preventDefault();
            setShowDropdownMenu(false);
            (_c = buttonRef.current) === null || _c === void 0 ? void 0 : _c.focus();
            break;
          case 'Enter':
            handleOptionClick((_d = options[currentFocus]) === null || _d === void 0 ? void 0 : _d.value);
            setTimeout(function () {
              var _a;
              (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 10);
            break;
        }
      } else if (e.key === 'Enter') {
        e.nativeEvent.stopImmediatePropagation();
        handleDropdownTrigger(true);
      }
    },
    [nextFocus, previousFocus, currentFocus, options.length, showDropdownMenu, handleDropdownTrigger],
  );
  React.useEffect(
    function () {
      optionsRef.current = optionsRef.current.slice(0, options.length);
    },
    [options],
  );
  // When user opens the DD with mouse click add global keydown event to allow user switch to keyboard interaction
  React.useEffect(
    function () {
      if (showDropdownMenu && !hasFocusRef.current) {
        var handleTabFocus_1 = function (e) {
          var _a;
          var handled = false;
          if (['Tab', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
            focusOption(currentFocus);
            handled = true;
          } else if (e.key === 'Escape') {
            setShowDropdownMenu(false);
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            handled = true;
          }
          if (handled) {
            e.preventDefault();
            e.stopPropagation();
            document.body.removeEventListener('keydown', handleTabFocus_1);
          }
        };
        document.body.addEventListener('keydown', handleTabFocus_1);
        return function () {
          document.body.removeEventListener('keydown', handleTabFocus_1);
        };
      }
    },
    [showDropdownMenu],
  );
  React.useEffect(
    function () {
      if (showDropdownMenu) {
        if (hasFocusRef.current) {
          focusOption(currentFocus);
        }
      } else {
        hasFocusRef.current = false;
      }
    },
    [currentFocus, showDropdownMenu],
  );
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    jsxRuntime.jsxs('div', {
      className: styles$1.DropdownButton,
      ref: parentRef,
      onKeyDown: handleKeyDown,
      children: [
        jsxRuntime.jsxs('button', {
          onClick: handleButtonClick,
          className: cx(styles$1.DropdownSelected, [showDropdownMenu && styles$1.isActive]),
          disabled: disabled,
          'aria-haspopup': 'true',
          'aria-expanded': showDropdownMenu,
          'data-cy': 'dropdown-button',
          ref: buttonRef,
          children: [
            jsxRuntime.jsxs('div', {
              className: styles$1.DropdownSelectedInfo,
              children: [
                jsxRuntime.jsx('span', { className: styles$1.DropdownSelectedInfoLabel, children: label }),
                jsxRuntime.jsx('h6', {
                  className: styles$1.DropdownSelectedInfoValue,
                  children:
                    (_b =
                      selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectedLabel) !==
                      null && _b !== void 0
                      ? _b
                      : selectedOption === null || selectedOption === void 0
                      ? void 0
                      : selectedOption.optionLabel,
                }),
              ],
            }),
            jsxRuntime.jsx('span', {
              children: jsxRuntime.jsx(Icon, { name: showDropdownMenu ? 'icon-chevron2-up' : 'icon-chevron2-down' }),
            }),
          ],
        }),
        jsxRuntime.jsx('ul', {
          className: cx(styles$1.DropdownMenu, [showDropdownMenu && styles$1.isOpen, fullWidth && styles$1.fullWidth]),
          role: 'menu',
          'aria-hidden': !showDropdownMenu,
          'data-cy': 'dropdown-menu',
          children: options.map(function (option, i) {
            return jsxRuntime.jsx(jsxRuntime.Fragment, {
              children: jsxRuntime.jsxs(
                'li',
                {
                  className: cx(styles$1.DropdownMenuItem, [value === option.value && styles$1.isSelected]),
                  onClick: function () {
                    return handleOptionClick(option.value);
                  },
                  role: 'menuitem',
                  'aria-hidden': !showDropdownMenu,
                  ref: function (option) {
                    optionsRef.current[i] = option;
                  },
                  children: [
                    jsxRuntime.jsxs('div', {
                      className: styles$1.OptionLabel,
                      children: [
                        option.optionTitle &&
                          jsxRuntime.jsx('div', { className: styles$1.OptionLabelTitle, children: option.optionTitle }),
                        jsxRuntime.jsx('div', {
                          className: cx(!option.optionTitle && styles$1.OptionLabelNoTitle),
                          children: option.optionLabel,
                        }),
                      ],
                    }),
                    jsxRuntime.jsx('span', {
                      children: jsxRuntime.jsx(Icon, { name: 'icon-check-mdc', color: '#366CED' }),
                    }),
                  ],
                },
                'option_'.concat(i),
              ),
            });
          }),
        }),
      ],
    })
  );
}

var styles = {
  DropdownMenuButton: 'htco-DropdownMenuButton',
  DropdownMenuButtonTrigger: 'htco-DropdownMenuButtonTrigger',
  isActive: 'htco-isActive',
  DropdownMenuButtonMenu: 'htco-DropdownMenuButtonMenu',
  isOpen: 'htco-isOpen',
  fullWidth: 'htco-fullWidth',
};

var DropdownMenuButton = function (_a) {
  var label = _a.label,
    disabled = _a.disabled,
    fullWidth = _a.fullWidth,
    children = _a.children;
  var _b = React.useState(false),
    showDropdownMenu = _b[0],
    setShowDropdownMenu = _b[1];
  var parentRef = React.useRef(null);
  var buttonRef = React.useRef(null);
  var menuRef = React.useRef(null);
  var closeTimeout = React.useRef(null);
  var handleButtonClick = React.useCallback(function () {
    var _a;
    setShowDropdownMenu(function (isShown) {
      return !isShown;
    });
    (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
  }, []);
  var handleMenuClick = React.useCallback(function () {
    setShowDropdownMenu(false);
  }, []);
  useOutsideClick(parentRef.current, handleMenuClick);
  var focusNext = React.useCallback(function () {
    var _a, _b;
    var menuItems = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.childNodes;
    if (!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length)) {
      return;
    }
    var activeItem = null;
    var firstFocusable = null;
    var nextFocusable = null;
    menuItems.forEach(function (item) {
      if (!firstFocusable && item.nodeType === Node.ELEMENT_NODE) {
        firstFocusable = item;
      }
      if (activeItem && !nextFocusable && item.nodeType === Node.ELEMENT_NODE && item.tabIndex > -1) {
        nextFocusable = item;
      }
      if (item === document.activeElement) {
        activeItem = item;
      }
    });
    if (activeItem && !nextFocusable) {
      setShowDropdownMenu(false);
      (_b = buttonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
    }
    var focusable = nextFocusable !== null && nextFocusable !== void 0 ? nextFocusable : firstFocusable;
    focusable === null || focusable === void 0 ? void 0 : focusable.focus();
  }, []);
  var focusPrev = React.useCallback(function () {
    var _a, _b;
    var menuItems = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.childNodes;
    if (!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length)) {
      return;
    }
    var activeItem = null;
    var prevFocusable = null;
    menuItems.forEach(function (item) {
      if (item === document.activeElement) {
        activeItem = item;
      }
      if (!activeItem && item.nodeType === Node.ELEMENT_NODE && item.tabIndex > -1) {
        prevFocusable = item;
      }
    });
    if (activeItem && !prevFocusable) {
      setShowDropdownMenu(false);
      (_b = buttonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
    }
    var focusable = activeItem && prevFocusable;
    focusable === null || focusable === void 0 ? void 0 : focusable.focus();
  }, []);
  var handleKeyDown = React.useCallback(
    function (e) {
      var _a;
      if (showDropdownMenu) {
        switch (e.key) {
          case 'Tab':
            e.preventDefault();
            if (e.shiftKey) {
              focusPrev();
            } else {
              focusNext();
            }
            break;
          case 'ArrowDown':
            e.preventDefault();
            focusNext();
            break;
          case 'ArrowUp':
            e.preventDefault();
            focusPrev();
            break;
          case 'Escape':
            e.preventDefault();
            setShowDropdownMenu(false);
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            break;
          case 'Enter':
            closeTimeout.current = setTimeout(function () {
              var _a;
              setShowDropdownMenu(false);
              (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
              closeTimeout.current = null;
            }, 10);
            break;
        }
      } else if (e.key === 'Enter') {
        e.nativeEvent.stopImmediatePropagation();
        handleButtonClick();
        setTimeout(focusNext, 10);
      }
    },
    [showDropdownMenu, focusNext, focusPrev],
  );
  React.useEffect(function () {
    return function () {
      if (closeTimeout.current) {
        clearTimeout(closeTimeout.current);
      }
    };
  }, []);
  return jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: jsxRuntime.jsxs('div', {
      className: styles.DropdownMenuButton,
      ref: parentRef,
      onKeyDown: handleKeyDown,
      children: [
        jsxRuntime.jsxs('button', {
          ref: buttonRef,
          onClick: handleButtonClick,
          className: cx(styles.DropdownMenuButtonTrigger, [showDropdownMenu && styles.isActive]),
          disabled: disabled,
          'aria-haspopup': 'true',
          'aria-expanded': showDropdownMenu,
          'data-cy': 'dropdown-button',
          children: [
            jsxRuntime.jsx('div', { children: label }),
            jsxRuntime.jsx('span', {
              children: jsxRuntime.jsx(Icon, { name: showDropdownMenu ? 'icon-chevron2-up' : 'icon-chevron2-down' }),
            }),
          ],
        }),
        jsxRuntime.jsx('div', {
          ref: menuRef,
          onClick: handleMenuClick,
          className: cx(
            styles.DropdownMenuButtonMenu,
            showDropdownMenu && styles.isOpen,
            fullWidth && styles.fullWidth,
          ),
          role: 'menu',
          'aria-hidden': !showDropdownMenu,
          'data-cy': 'dropdown-menu',
          children: children,
        }),
      ],
    }),
  });
};

var style = {
  MuiTextareaOutlined: 'htco-MuiTextareaOutlined',
  error: 'htco-error',
  MuiTextareaBase: 'htco-MuiTextareaBase',
  Label: 'htco-Label',
  MuiTextareaFilled: 'htco-MuiTextareaFilled',
  withMinWidth: 'htco-withMinWidth',
  startAdornment: 'htco-startAdornment',
  endAdornment: 'htco-endAdornment',
  withoutLeftPadding: 'htco-withoutLeftPadding',
  disabled: 'htco-disabled',
  MuiTextAreaOutline: 'htco-MuiTextAreaOutline',
  MuiTextareaErrorIcon: 'htco-MuiTextareaErrorIcon',
  isOutlined: 'htco-isOutlined',
  isDisabled: 'htco-isDisabled',
};

var MuiTextareaBase = React.forwardRef(function (_a, ref) {
  var _b, _c, _d, _e;
  var name = _a.name,
    label = _a.label,
    error = _a.error,
    required = _a.required,
    className = _a.className,
    helperText = _a.helperText,
    _f = _a.rows,
    rows = _f === void 0 ? 2 : _f,
    _g = _a.cols,
    cols = _g === void 0 ? 20 : _g,
    _h = _a.value,
    value = _h === void 0 ? '' : _h,
    _j = _a.width,
    width = _j === void 0 ? 'auto' : _j,
    _k = _a.maxLength,
    maxLength = _k === void 0 ? 999 : _k,
    _l = _a.theme,
    theme = _l === void 0 ? 'filled' : _l,
    _m = _a.disabled,
    disabled = _m === void 0 ? false : _m,
    _o = _a.showRequiredAsterisk,
    showRequiredAsterisk = _o === void 0 ? true : _o,
    props = __rest$1(_a, [
      'name',
      'label',
      'error',
      'required',
      'className',
      'helperText',
      'rows',
      'cols',
      'value',
      'width',
      'maxLength',
      'theme',
      'disabled',
      'showRequiredAsterisk',
    ]);
  var isOutlinedTheme = theme === 'outlined';
  var inputStyle = { width: width };
  var hasError = (error === null || error === void 0 ? void 0 : error.length) >= 1;
  return jsxRuntime.jsxs('div', {
    className: cx(
      style.MuiTextareaBase,
      ((_b = {}),
      (_b[style.MuiTextareaFilled] = theme === 'filled'),
      (_b[style.MuiTextareaOutlined] = isOutlinedTheme),
      (_b[style.disabled] = disabled),
      (_b[style.error] = hasError),
      _b),
      className,
    ),
    style: inputStyle,
    children: [
      hasError
        ? jsxRuntime.jsx(Icon, {
            name: 'icon-error',
            className: cx(
              style.MuiTextareaErrorIcon,
              ((_c = {}), (_c[style.isDisabled] = disabled), (_c[style.isOutlined] = isOutlinedTheme), _c),
            ),
          })
        : null,
      jsxRuntime.jsx(
        'textarea',
        __assign(
          {
            ref: ref,
            name: name,
            cols: cols,
            rows: rows,
            value: value,
            'aria-label': label,
            maxLength: maxLength,
            disabled: disabled,
            placeholder: ' ',
          },
          props,
        ),
      ),
      theme === 'outlined' &&
        jsxRuntime.jsx('div', {
          className: cx(((_d = {}), (_d[style.MuiTextAreaOutline] = theme === 'outlined'), _d)),
        }),
      jsxRuntime.jsx('label', {
        children: jsxRuntime.jsxs(Label$1, {
          className: cx(style.Label, 'text'),
          children: [label, ' ', required && showRequiredAsterisk ? '*' : ''],
        }),
      }),
      jsxRuntime.jsx('p', {
        className: cx(((_e = {}), (_e[style.withoutLeftPadding] = hasError && theme === 'filled'), _e)),
        children: hasError ? error : helperText,
      }),
    ],
  });
});
MuiTextareaBase.displayName = 'MuiTextareaBase';
MuiTextareaBase.propTypes = {
  name: PropTypes__default['default'].string,
  label: PropTypes__default['default'].node,
  disabled: PropTypes__default['default'].bool,
  cols: PropTypes__default['default'].number,
  rows: PropTypes__default['default'].number,
  error: PropTypes__default['default'].node,
  required: PropTypes__default['default'].bool,
  value: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].number,
  ]),
  onChange: PropTypes__default['default'].func,
  width: PropTypes__default['default'].string,
  maxLength: PropTypes__default['default'].number,
  helperText: PropTypes__default['default'].string,
  showRequiredAsterisk: PropTypes__default['default'].bool,
  theme: PropTypes__default['default'].oneOf(['filled', 'outlined']),
};

var MuiTextarea = React.forwardRef(function (_a, ref) {
  var name = _a.name,
    _b = _a.value,
    value = _b === void 0 ? '' : _b,
    validator = _a.validator,
    onBlur = _a.onBlur,
    _c = _a.onChange,
    onChange =
      _c === void 0
        ? function () {
            return null;
          }
        : _c,
    required = _a.required,
    registerRequiredField = _a.registerRequiredField,
    unregisterRequiredField = _a.unregisterRequiredField,
    props = __rest$1(_a, [
      'name',
      'value',
      'validator',
      'onBlur',
      'onChange',
      'required',
      'registerRequiredField',
      'unregisterRequiredField',
    ]);
  useRequiredValidation({
    name: name,
    required: required,
    registerRequiredField: registerRequiredField,
    unregisterRequiredField: unregisterRequiredField,
  });
  React.useEffect(function () {
    if (value && value !== '') {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(value, name, handleValidation(value));
    }
  }, []);
  var handleValue = function (v) {
    return onChange(v, name, handleValidation(v));
  };
  var handleChange = function (e) {
    handleValue(e.currentTarget.value);
  };
  var handleBlur = function (e) {
    var val = e.currentTarget.value;
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(val, name, handleValidation(val));
  };
  var handleValidation = function (val) {
    if (val || required) {
      if (validator) {
        return validator(val);
      }
    }
  };
  return jsxRuntime.jsx(
    MuiTextareaBase,
    __assign(
      { ref: ref, name: name, value: value, onBlur: handleBlur, required: required, onChange: handleChange },
      props,
    ),
  );
});
MuiTextarea.displayName = 'MuiTextarea';
MuiTextarea.propTypes = {
  name: PropTypes__default['default'].string,
  label: PropTypes__default['default'].node,
  required: PropTypes__default['default'].bool,
  validator: PropTypes__default['default'].func,
  value: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].string,
    PropTypes__default['default'].number,
  ]),
  onChange: PropTypes__default['default'].func,
  /** This is used with useForm hook to manage required fields */
  registerRequiredField: PropTypes__default['default'].func,
  unregisterRequiredField: PropTypes__default['default'].func,
};

var CurrencyInputBase = React.forwardRef(function (_a, ref) {
  var _b, _c, _d, _e, _f, _g;
  var label = _a.label,
    _h = _a.theme,
    theme = _h === void 0 ? 'outlined' : _h,
    _j = _a.required,
    required = _j === void 0 ? false : _j,
    disabled = _a.disabled,
    validator = _a.validator,
    _k = _a.mask,
    mask = _k === void 0 ? '' : _k,
    _l = _a.extendedMaskProps,
    extendedMaskProps = _l === void 0 ? {} : _l,
    _m = _a.unmask,
    unmask = _m === void 0 ? 'typed' : _m,
    _o = _a.startAdornment,
    startAdornment = _o === void 0 ? '$' : _o,
    _p = _a.width,
    width = _p === void 0 ? '100%' : _p,
    _q = _a.showRequiredAsterisk,
    showRequiredAsterisk = _q === void 0 ? false : _q,
    _r = _a.padFractionalZeros,
    padFractionalZeros = _r === void 0 ? false : _r,
    _s = _a.valuesToClearOnFocus,
    valuesToClearOnFocus = _s === void 0 ? ['0', '0.00'] : _s,
    _t = _a.isZeroDefaultOnBlur,
    isZeroDefaultOnBlur = _t === void 0 ? true : _t,
    onChange = _a.onChange,
    onBlur = _a.onBlur,
    props = __rest$1(_a, [
      'label',
      'theme',
      'required',
      'disabled',
      'validator',
      'mask',
      'extendedMaskProps',
      'unmask',
      'startAdornment',
      'width',
      'showRequiredAsterisk',
      'padFractionalZeros',
      'valuesToClearOnFocus',
      'isZeroDefaultOnBlur',
      'onChange',
      'onBlur',
    ]);
  var inputRef = React.useRef(null);
  if (ref) {
    // @ts-expect-error TS(2322): Type '((instance: unknown) => void) | MutableRefOb... Remove this comment to see the full error message
    inputRef = ref;
  }
  var _u = React.useState(),
    isEmptyMask = _u[0],
    setIsEmptyMask = _u[1];
  var defaultMoneyUsdMask = InputMask.extend(
    InputMask.MONEY_USD_MASK,
    __assign({ padFractionalZeros: padFractionalZeros }, extendedMaskProps),
  );
  React.useEffect(
    function () {
      var _a, _b;
      // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
      setIsEmptyMask(
        ((_b =
          (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0
            ? void 0
            : _a.maskRef) === null || _b === void 0
          ? void 0
          : _b.value) === '',
      );
      // @ts-expect-error TS(2339): Property 'maskRef' does not exist on type 'never'.
    },
    [
      (_c =
        (_b = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _b === void 0
          ? void 0
          : _b.maskRef) === null || _c === void 0
        ? void 0
        : _c.value,
    ],
  );
  var clearField = function (event) {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    inputRef.current.maskRef.value = '';
    var syntheticEvent = __assign(__assign({}, event), {
      target: __assign(__assign({}, (event === null || event === void 0 ? void 0 : event.target) || inputRef), {
        value: null,
      }),
    });
    onChange === null || onChange === void 0 ? void 0 : onChange(syntheticEvent);
  };
  // @ts-expect-error TS(2339): Property 'maskRef' does not exist on type 'never'.
  var typedValue =
    (_e =
      (_d = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _d === void 0
        ? void 0
        : _d.maskRef) === null || _e === void 0
      ? void 0
      : _e.typedValue;
  // @ts-expect-error TS(2339): Property 'maskRef' does not exist on type 'never'.
  var maskValue =
    (_g =
      (_f = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _f === void 0
        ? void 0
        : _f.maskRef) === null || _g === void 0
      ? void 0
      : _g.value;
  // to prevent the addition of zeros when all values are cleared
  React.useEffect(
    function () {
      if (typedValue === 0 && maskValue === '' && !isEmptyMask) {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        clearField();
        // @ts-expect-error TS(2345): Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
        setIsEmptyMask(true);
      }
    },
    [typedValue, maskValue, isEmptyMask, clearField],
  );
  var handleFocus = function (event) {
    var _a, _b;
    // @ts-expect-error TS(2339): Property 'maskRef' does not exist on type 'never'.
    var maskValue =
      (_b =
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0
          ? void 0
          : _a.maskRef) === null || _b === void 0
        ? void 0
        : _b.value;
    if (valuesToClearOnFocus.includes(maskValue)) {
      clearField(event);
    }
  };
  var handleBlur = function (event) {
    if (event.target.value === '' && isZeroDefaultOnBlur) {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      inputRef.current.maskRef.value = '0';
      if (onChange) {
        var syntheticEvent = __assign(__assign({}, event), {
          target: __assign(__assign({}, event === null || event === void 0 ? void 0 : event.target), { value: 0 }),
        });
        onChange(syntheticEvent);
      }
    } else {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    }
  };
  return jsxRuntime.jsx(
    MuiTextInputBase,
    __assign(
      {
        label: label,
        mask: mask || defaultMoneyUsdMask,
        theme: theme,
        onFocus: handleFocus,
        unmask: unmask,
        startAdornment: startAdornment,
        width: width,
        disabled: disabled,
        required: required,
        showRequiredAsterisk: showRequiredAsterisk,
        validator: validator,
        onChange: onChange,
        onBlur: handleBlur,
        ref: inputRef,
      },
      props,
    ),
  );
});
CurrencyInputBase.displayName = 'CurrencyInputBase';
CurrencyInputBase.propTypes = {
  label: PropTypes__default['default'].string,
  theme: PropTypes__default['default'].oneOf(['filled', 'outlined']),
  required: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  mask: PropTypes__default['default'].oneOf([
    PropTypes__default['default'].arrayOf(PropTypes__default['default'].object),
    PropTypes__default['default'].string,
  ]),
  extendedMaskProps: PropTypes__default['default'].object,
  unmask: PropTypes__default['default'].oneOf(['typed', true, false]),
  startAdornment: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].node,
    PropTypes__default['default'].string,
  ]),
  width: PropTypes__default['default'].string,
  showRequiredAsterisk: PropTypes__default['default'].bool,
  padFractionalZeros: PropTypes__default['default'].bool,
  isZeroDefaultOnBlur: PropTypes__default['default'].bool,
  valuesToClearOnFocus: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  onChange: PropTypes__default['default'].func,
  onBlur: PropTypes__default['default'].func,
};

var CurrencyInput = function (_a) {
  var validator = _a.validator,
    onChange = _a.onChange,
    onBlur = _a.onBlur,
    registerRequiredField = _a.registerRequiredField,
    unregisterRequiredField = _a.unregisterRequiredField,
    props = __rest$1(_a, ['validator', 'onChange', 'onBlur', 'registerRequiredField', 'unregisterRequiredField']);
  var _b = props || {},
    name = _b.name,
    required = _b.required;
  var _c = useMuiTextInputField({
      name: name,
      required: required,
      validator: validator,
      registerRequiredField: registerRequiredField,
      unregisterRequiredField: unregisterRequiredField,
      onChange: onChange,
      onBlur: onBlur,
    }),
    handleChange = _c.handleChange,
    handleBlur = _c.handleBlur;
  return jsxRuntime.jsx(CurrencyInputBase, __assign({}, props, { onChange: handleChange, onBlur: handleBlur }));
};
CurrencyInput.propTypes = {
  label: PropTypes__default['default'].string,
  theme: PropTypes__default['default'].oneOf(['filled', 'outlined']),
  required: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  validator: PropTypes__default['default'].func,
  mask: PropTypes__default['default'].oneOf([
    PropTypes__default['default'].arrayOf(PropTypes__default['default'].object),
    PropTypes__default['default'].string,
  ]),
  extendedMaskProps: PropTypes__default['default'].object,
  unmask: PropTypes__default['default'].oneOf(['typed', true, false]),
  startAdornment: PropTypes__default['default'].oneOfType([
    PropTypes__default['default'].node,
    PropTypes__default['default'].string,
  ]),
  width: PropTypes__default['default'].string,
  showRequiredAsterisk: PropTypes__default['default'].bool,
  padFractionalZeros: PropTypes__default['default'].bool,
  isZeroDefaultOnBlur: PropTypes__default['default'].bool,
  valuesToClearOnFocus: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  onChange: PropTypes__default['default'].func,
  onBlur: PropTypes__default['default'].func,
};

exports.ACCEPTED_FILE_TYPE_AND_EXTENSIONS = ACCEPTED_FILE_TYPE_AND_EXTENSIONS;
exports.Accordion = Accordion;
exports.AddressDropdown = AddressDropdown;
exports.Badge = Badge;
exports.Banner = Banner;
exports.BarChart = BarChart;
exports.BreadCrumbsDisplay = BreadCrumbsDisplay;
exports.Button = Button;
exports.COLOR_THEMES = COLOR_THEMES;
exports.CTABlock = CTABlock;
exports.CardGroup = CardGroup;
exports.Checkbox = Checkbox;
exports.CheckboxSet = CheckboxSet;
exports.ColorCard = ColorCard;
exports.Container = Container;
exports.ContentCard = ContentCard;
exports.ContentHero = ContentHero;
exports.CurrencyInput = CurrencyInput;
exports.CurrencyInputBase = CurrencyInputBase;
exports.DEFAULT_MENU_OFFSET = DEFAULT_MENU_OFFSET;
exports.DataTable = DataTable;
exports.DatePicker = DatePicker;
exports.DetailBox = DetailBox;
exports.Dropdown = DropdownButton;
exports.DropdownMenuButton = DropdownMenuButton;
exports.DropdownSelector = DropdownSelector;
exports.ENVIRONMENTS = ENVIRONMENTS;
exports.EmailInput = EmailInput;
exports.EnvConfig = EnvConfig;
exports.FadeIn = FadeIn;
exports.FeaturedContentCarousel = FeaturedContentCarousel;
exports.FileUploader = FileUploader;
exports.FixedBanner = FixedBanner;
exports.FormError = FormError;
exports.Grid = Grid;
exports.Header = Header;
exports.Helptip = Helptip;
exports.HomeGraph = HomeGraph;
exports.HomeValueShare = HomeValueShare;
exports.ICON_SCRIPT = fortAwesome;
exports.Icon = Icon;
exports.IconButton = IconButton;
exports.InfoCard = InfoCard;
exports.InputMask = InputMask;
exports.KPIBar = KPIBar;
exports.KPICard = KPICard;
exports.Label = Label$1;
exports.LabelWithAsterisk = LabelWithAsterisk;
exports.LabelWithAsteriskAndHelp = LabelWithAsteriskAndHelp;
exports.LabelWithHelp = LabelWithHelp;
exports.Loader = Loader;
exports.LoadingPlaceholder = LoadingPlaceholder;
exports.MenuDropdown = MenuDropdown;
exports.MenuDropdownItem = MenuDropdownItem;
exports.Modal = Modal;
exports.ModalButton = ModalButton;
exports.ModalConfirm = ModalConfirm;
exports.ModalTheme = ModalTheme;
exports.MuiSSNInput = MuiSSNInput;
exports.MuiSSNInputBase = MuiSSNInputBase;
exports.MuiSelect = MuiSelect;
exports.MuiSlider = MuiSlider;
exports.MuiSliderBase = MuiSliderBase;
exports.MuiTextInput = MuiTextInput$1;
exports.MuiTextInputBase = MuiTextInputBase;
exports.MuiTextarea = MuiTextarea;
exports.MuiTextareaBase = MuiTextareaBase;
exports.NotFoundBlock = NotFoundBlock;
exports.NumberInput = NumberInput;
exports.Paper = Paper;
exports.PhoneInput = PhoneInput;
exports.PointCard = PointCard;
exports.ProfileInfoCard = ProfileInfoCard;
exports.ProgressBar = ProgressBar;
exports.ProgressIndicator = ProgressIndicator;
exports.PropertyCard = PropertyCard;
exports.RadioButton = RadioButton;
exports.RadioButtonSet = RadioButtonSet;
exports.SSNInput = SSNInput;
exports.SSN_LENGTH = SSN_LENGTH;
exports.SelectionSet = SelectionSet;
exports.SelectionSetBase = SelectionSetBase;
exports.SlideDown = SlideDown;
exports.SlideSide = SlideSide;
exports.Slider = Slider;
exports.Table = Table;
exports.TestimonialCard = TestimonialCard;
exports.TestimonialsCarousel = TestimonialsCarousel;
exports.TestimonialsPanelCarousel = TestimonialsPanelCarousel;
exports.TextInput = TextInput;
exports.Toast = Toast;
exports.Toggle = Toggle;
exports.Tooltip = Tooltip$1;
exports.TooltipActionValues = TooltipActionValues;
exports.TooltipPositionValues = TooltipPositionValues;
exports.UseCaseCard = UseCaseCard;
exports.breakpoints = breakpoints;
exports.convertToMoneyString = convertToMoneyString;
exports.formatting = formatting;
exports.getEnvLabel = getEnvLabel;
exports.getEnvTheme = getEnvTheme;
exports.getValuesFromRange = getValuesFromRange;
exports.isProd = isProd;
exports.isStage = isStage;
exports.locationHelper = locationHelper;
exports.useAsync = useAsync;
exports.useBoolState = useBoolState;
exports.useErrorScroll = useErrorScroll;
exports.useEscape = useEscape;
exports.useFocusTrap = useFocusTrap;
exports.useForm = useForm;
exports.useKeyboardOnlyFocus = useKeyboardOnlyFocus;
exports.useMuiTextInputField = useMuiTextInputField;
exports.useOutsideClick = useOutsideClick;
exports.useRequiredValidation = useRequiredValidation;
exports.useScroll = useScroll;
exports.useSessionSecurityTimer = useSessionSecurityTimer;
exports.useWin = useWin;
exports.useWindowSize = useWindowSize;
exports.withinRange = withinRange;
